/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/quote_and_a_chart/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 242);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(249);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(294)();
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PRESENTATION_ATTRIBUTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EVENT_ATTRIBUTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SCALE_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LEGEND_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getDisplayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return findAllByType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return findChildByType; });
/* unused harmony export withoutType */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getPresentationAttributes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return filterEventAttributes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return filterEventsOfChild; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return validateWidthHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return isSsr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return filterSvgElements; });
/* unused harmony export isSingleChildEqual */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return isChildrenEqual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return renderByOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getReactEventByType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return parseChildIndex; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isString__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isString__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isObject__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isFunction__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isArray__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DataUtils__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PureRender__ = __webpack_require__(4);






function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }







var PRESENTATION_ATTRIBUTES = {
  alignmentBaseline: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  angle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  baselineShift: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  clip: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  clipPath: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  clipRule: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  colorInterpolation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  colorInterpolationFilters: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  colorProfile: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  colorRendering: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  cursor: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  direction: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['ltr', 'rtl', 'inherit']),
  display: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  dominantBaseline: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  enableBackground: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  fill: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  fillOpacity: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number]),
  fillRule: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['nonzero', 'evenodd', 'inherit']),
  filter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  floodColor: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  floodOpacity: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number]),
  font: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  fontFamily: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  fontSize: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  fontSizeAdjust: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  fontStretch: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['normal', 'wider', 'narrower', 'ultra-condensed', 'extra-condensed', 'condensed', 'semi-condensed', 'semi-expanded', 'expanded', 'extra-expanded', 'ultra-expanded', 'inherit']),
  fontStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['normal', 'italic', 'oblique', 'inherit']),
  fontVariant: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['normal', 'small-caps', 'inherit']),
  fontWeight: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['normal', 'bold', 'bolder', 'lighter', 100, 200, 300, 400, 500, 600, 700, 800, 900, 'inherit']),
  glyphOrientationHorizontal: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  glyphOrientationVertical: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  imageRendering: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['auto', 'optimizeSpeed', 'optimizeQuality', 'inherit']),
  kerning: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  letterSpacing: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  lightingColor: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  markerEnd: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  markerMid: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  markerStart: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  mask: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  opacity: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  overflow: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['visible', 'hidden', 'scroll', 'auto', 'inherit']),
  pointerEvents: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['visiblePainted', 'visibleFill', 'visibleStroke', 'visible', 'painted', 'fill', 'stroke', 'all', 'none', 'inherit']),
  shapeRendering: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['auto', 'optimizeSpeed', 'crispEdges', 'geometricPrecision', 'inherit']),
  stopColor: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  stopOpacity: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  stroke: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  strokeDasharray: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  strokeDashoffset: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  strokeLinecap: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['butt', 'round', 'square', 'inherit']),
  strokeLinejoin: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['miter', 'round', 'bevel', 'inherit']),
  strokeMiterlimit: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  strokeOpacity: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  strokeWidth: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  textAnchor: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['start', 'middle', 'end', 'inherit']),
  textDecoration: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['none', 'underline', 'overline', 'line-through', 'blink', 'inherit']),
  textRendering: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['auto', 'optimizeSpeed', 'optimizeLegibility', 'geometricPrecision', 'inherit']),
  unicodeBidi: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['normal', 'embed', 'bidi-override', 'inherit']),
  visibility: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['visible', 'hidden', 'collapse', 'inherit']),
  wordSpacing: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  writingMode: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['lr-tb', 'rl-tb', 'tb-rl', 'lr', 'rl', 'tb', 'inherit']),
  transform: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,

  width: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  dx: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  dy: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  x: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  y: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  r: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  // The radius of Rectangle
  radius: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array])
};

var EVENT_ATTRIBUTES = {
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseDown: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseUp: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseOver: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseMove: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseOut: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onTouchEnd: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onTouchMove: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onTouchStart: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onTouchCancel: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
};

var REACT_BROWSER_EVENT_MAP = {
  click: 'onClick',
  mousedown: 'onMouseDown',
  mouseup: 'onMouseUp',
  mouseover: 'onMouseOver',
  mousemove: 'onMouseMove',
  mouseout: 'onMouseOut',
  mouseenter: 'onMouseEnter',
  mouseleave: 'onMouseLeave',
  touchcancel: 'onTouchCancel',
  touchend: 'onTouchEnd',
  touchmove: 'onTouchMove',
  touchstart: 'onTouchStart'
};

var SCALE_TYPES = ['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utcTime', 'sequential', 'threshold'];

var LEGEND_TYPES = ['plainline', 'line', 'square', 'rect', 'circle', 'cross', 'diamond', 'star', 'triangle', 'wye', 'none'];

/**
 * Get the display name of a component
 * @param  {Object} Comp Specified Component
 * @return {String}      Display name of Component
 */
var getDisplayName = function getDisplayName(Comp) {
  if (!Comp) {
    return '';
  }
  if (typeof Comp === 'string') {
    return Comp;
  }
  return Comp.displayName || Comp.name || 'Component';
};

/*
 * Find and return all matched children by type. `type` can be a React element class or
 * string
 */
var findAllByType = function findAllByType(children, type) {
  var result = [];
  var types = [];

  if (__WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default()(type)) {
    types = type.map(function (t) {
      return getDisplayName(t);
    });
  } else {
    types = [getDisplayName(type)];
  }

  __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.forEach(children, function (child) {
    var childType = child && child.type && (child.type.displayName || child.type.name);
    if (types.indexOf(childType) !== -1) {
      result.push(child);
    }
  });

  return result;
};
/*
 * Return the first matched child by type, return null otherwise.
 * `type` can be a React element class or string.
 */
var findChildByType = function findChildByType(children, type) {
  var result = findAllByType(children, type);

  return result && result[0];
};

/*
 * Create a new array of children excluding the ones matched the type
 */
var withoutType = function withoutType(children, type) {
  var newChildren = [];
  var types = void 0;

  if (__WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default()(type)) {
    types = type.map(function (t) {
      return getDisplayName(t);
    });
  } else {
    types = [getDisplayName(type)];
  }

  __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.forEach(children, function (child) {
    if (child && child.type && child.type.displayName && types.indexOf(child.type.displayName) !== -1) {
      return;
    }
    newChildren.push(child);
  });

  return newChildren;
};

/**
 * get all the presentation attribute of svg element
 * @param  {Object} el A react element or the props of a react element
 * @return {Object}    attributes or null
 */
var getPresentationAttributes = function getPresentationAttributes(el) {
  if (!el || __WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default()(el)) {
    return null;
  }

  var props = __WEBPACK_IMPORTED_MODULE_5_react___default.a.isValidElement(el) ? el.props : el;

  if (!__WEBPACK_IMPORTED_MODULE_2_lodash_isObject___default()(props)) {
    return null;
  }

  var out = null;
  // eslint-disable-next-line no-restricted-syntax
  for (var i in props) {
    if ({}.hasOwnProperty.call(props, i) && PRESENTATION_ATTRIBUTES[i]) {
      if (!out) out = {};
      out[i] = props[i];
    }
  }
  return out;
};

var getEventHandlerOfElement = function getEventHandlerOfElement(originalHandler, props) {
  return function (e) {
    originalHandler(props, e);

    return null;
  };
};
/**
 * get all the event attribute of svg element
 * @param  {Object}   el           A react element or the props of a react element
 * @param  {Function} newHandler   New handler of event
 * @param  {Boolean}  wrapCallback Wrap callback and return more parameters or not
 * @return {Object}                attributes or null
 */
var filterEventAttributes = function filterEventAttributes(el, newHandler) {
  var wrapCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (!el || __WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default()(el)) {
    return null;
  }

  var props = __WEBPACK_IMPORTED_MODULE_5_react___default.a.isValidElement(el) ? el.props : el;

  if (!__WEBPACK_IMPORTED_MODULE_2_lodash_isObject___default()(props)) {
    return null;
  }

  var out = null;
  // eslint-disable-next-line no-restricted-syntax
  for (var i in props) {
    if ({}.hasOwnProperty.call(props, i) && EVENT_ATTRIBUTES[i]) {
      if (!out) out = {};
      out[i] = newHandler || (wrapCallback ? getEventHandlerOfElement(props[i], props) : props[i]);
    }
  }
  return out;
};

var getEventHandlerOfChild = function getEventHandlerOfChild(originalHandler, data, index) {
  return function (e) {
    originalHandler(data, index, e);

    return null;
  };
};

var filterEventsOfChild = function filterEventsOfChild(props, data, index) {
  if (!__WEBPACK_IMPORTED_MODULE_2_lodash_isObject___default()(props)) {
    return null;
  }

  var out = null;
  // eslint-disable-next-line no-restricted-syntax
  for (var i in props) {
    if ({}.hasOwnProperty.call(props, i) && EVENT_ATTRIBUTES[i] && __WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default()(props[i])) {
      if (!out) out = {};
      out[i] = getEventHandlerOfChild(props[i], data, index);
    }
  }
  return out;
};

/**
 * validate the width and height props of a chart element
 * @param  {Object} el A chart element
 * @return {Boolean}   true If the props width and height are number, and greater than 0
 */
var validateWidthHeight = function validateWidthHeight(el) {
  if (!el || !el.props) {
    return false;
  }
  var _el$props = el.props,
      width = _el$props.width,
      height = _el$props.height;


  if (!Object(__WEBPACK_IMPORTED_MODULE_7__DataUtils__["g" /* isNumber */])(width) || width <= 0 || !Object(__WEBPACK_IMPORTED_MODULE_7__DataUtils__["g" /* isNumber */])(height) || height <= 0) {
    return false;
  }

  return true;
};

var isSsr = function isSsr() {
  return !(typeof window !== 'undefined' && window.document && window.document.createElement && window.setTimeout);
};

var SVG_TAGS = ['a', 'altGlyph', 'altGlyphDef', 'altGlyphItem', 'animate', 'animateColor', 'animateMotion', 'animateTransform', 'circle', 'clipPath', 'color-profile', 'cursor', 'defs', 'desc', 'ellipse', 'feBlend', 'feColormatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence', 'filter', 'font', 'font-face', 'font-face-format', 'font-face-name', 'font-face-url', 'foreignObject', 'g', 'glyph', 'glyphRef', 'hkern', 'image', 'line', 'lineGradient', 'marker', 'mask', 'metadata', 'missing-glyph', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'script', 'set', 'stop', 'style', 'svg', 'switch', 'symbol', 'text', 'textPath', 'title', 'tref', 'tspan', 'use', 'view', 'vkern'];

var isSvgElement = function isSvgElement(child) {
  return child && child.type && __WEBPACK_IMPORTED_MODULE_1_lodash_isString___default()(child.type) && SVG_TAGS.indexOf(child.type) >= 0;
};

/**
 * Filter all the svg elements of children
 * @param  {Array} children The children of a react element
 * @return {Array}          All the svg elements
 */
var filterSvgElements = function filterSvgElements(children) {
  var svgElements = [];

  __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.forEach(children, function (entry) {
    if (entry && entry.type && __WEBPACK_IMPORTED_MODULE_1_lodash_isString___default()(entry.type) && SVG_TAGS.indexOf(entry.type) >= 0) {
      svgElements.push(entry);
    }
  });

  return svgElements;
};

var isSingleChildEqual = function isSingleChildEqual(nextChild, prevChild) {
  if (__WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(nextChild) && __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(prevChild)) {
    return true;
  } else if (!__WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(nextChild) && !__WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(prevChild)) {
    return Object(__WEBPACK_IMPORTED_MODULE_8__PureRender__["b" /* shallowEqual */])(nextChild.props, prevChild.props);
  }

  return false;
};
/**
 * Wether props of children changed
 * @param  {Object} nextChildren The latest children
 * @param  {Object} prevChildren The prev children
 * @return {Boolean}             equal or not
 */
var isChildrenEqual = function isChildrenEqual(nextChildren, prevChildren) {
  if (nextChildren === prevChildren) {
    return true;
  }

  if (__WEBPACK_IMPORTED_MODULE_5_react__["Children"].count(nextChildren) !== __WEBPACK_IMPORTED_MODULE_5_react__["Children"].count(prevChildren)) {
    return false;
  }
  var count = __WEBPACK_IMPORTED_MODULE_5_react__["Children"].count(nextChildren);

  if (count === 0) {
    return true;
  }
  if (count === 1) {
    return isSingleChildEqual(__WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default()(nextChildren) ? nextChildren[0] : nextChildren, __WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default()(prevChildren) ? prevChildren[0] : prevChildren);
  }

  for (var i = 0; i < count; i++) {
    var nextChild = nextChildren[i];
    var prevChild = prevChildren[i];

    if (__WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default()(nextChild) || __WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default()(prevChild)) {
      if (!isChildrenEqual(nextChild, prevChild)) {
        return false;
      }
    } else if (!isSingleChildEqual(nextChild, prevChild)) {
      return false;
    }
  }

  return true;
};

var renderByOrder = function renderByOrder(children, renderMap) {
  var elements = [];
  var record = {};

  __WEBPACK_IMPORTED_MODULE_5_react__["Children"].forEach(children, function (child, index) {
    if (child && isSvgElement(child)) {
      elements.push(child);
    } else if (child && renderMap[getDisplayName(child.type)]) {
      var displayName = getDisplayName(child.type);
      var _renderMap$displayNam = renderMap[displayName],
          handler = _renderMap$displayNam.handler,
          once = _renderMap$displayNam.once;


      if (once && !record[displayName] || !once) {
        var results = handler(child, displayName, index);

        if (__WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default()(results)) {
          elements = [elements].concat(_toConsumableArray(results));
        } else {
          elements.push(results);
        }

        record[displayName] = true;
      }
    }
  });

  return elements;
};

var getReactEventByType = function getReactEventByType(e) {
  var type = e && e.type;

  if (type && REACT_BROWSER_EVENT_MAP[type]) {
    return REACT_BROWSER_EVENT_MAP[type];
  }

  return null;
};

var parseChildIndex = function parseChildIndex(child, children) {
  var result = -1;
  __WEBPACK_IMPORTED_MODULE_5_react__["Children"].forEach(children, function (entry, index) {
    if (entry === child) {
      result = index;
    }
  });

  return result;
};

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = shallowEqual;
/* harmony export (immutable) */ __webpack_exports__["a"] = pureRenderDecorator;
function shallowEqual(a, b) {
  /* eslint-disable no-restricted-syntax */
  for (var key in a) {
    if ({}.hasOwnProperty.call(a, key) && (!{}.hasOwnProperty.call(b, key) || a[key] !== b[key])) {
      return false;
    }
  }
  for (var _key in b) {
    if ({}.hasOwnProperty.call(b, _key) && !{}.hasOwnProperty.call(a, _key)) {
      return false;
    }
  }
  return true;
}

function shouldComponentUpdate(props, state) {
  return !shallowEqual(props, this.props) || !shallowEqual(state, this.state);
}

function pureRenderDecorator(component) {
  // eslint-disable-next-line no-param-reassign
  component.prototype.shouldComponentUpdate = shouldComponentUpdate;
}

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(27),
    isObject = __webpack_require__(17);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return mathSign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isPercent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isNumOrStr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return uniqueId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getPercentValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAnyElementOfObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return hasDuplicate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return interpolateNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return findEntryInArray; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isArray__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNaN__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNaN___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isNaN__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isNumber__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isNumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isNumber__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isString__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isString__);







var mathSign = function mathSign(value) {
  if (value === 0) {
    return 0;
  }
  if (value > 0) {
    return 1;
  }

  return -1;
};

var isPercent = function isPercent(value) {
  return __WEBPACK_IMPORTED_MODULE_4_lodash_isString___default()(value) && value.indexOf('%') === value.length - 1;
};

var isNumber = function isNumber(value) {
  return __WEBPACK_IMPORTED_MODULE_3_lodash_isNumber___default()(value) && !__WEBPACK_IMPORTED_MODULE_2_lodash_isNaN___default()(value);
};

var isNumOrStr = function isNumOrStr(value) {
  return isNumber(value) || __WEBPACK_IMPORTED_MODULE_4_lodash_isString___default()(value);
};

var idCounter = 0;
var uniqueId = function uniqueId(prefix) {
  var id = ++idCounter;

  return '' + (prefix || '') + id;
};
/**
 * Get percent value of a total value
 * @param {Number|String} percent A percent
 * @param {Number} totalValue     Total value
 * @param {NUmber} defaultValue   The value returned when percent is undefined or invalid
 * @param {Boolean} validate      If set to be true, the result will be validated
 * @return {Number} value
 */
var getPercentValue = function getPercentValue(percent, totalValue) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var validate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (!isNumber(percent) && !__WEBPACK_IMPORTED_MODULE_4_lodash_isString___default()(percent)) {
    return defaultValue;
  }

  var value = void 0;

  if (isPercent(percent)) {
    var index = percent.indexOf('%');
    value = totalValue * parseFloat(percent.slice(0, index)) / 100;
  } else {
    value = +percent;
  }

  if (__WEBPACK_IMPORTED_MODULE_2_lodash_isNaN___default()(value)) {
    value = defaultValue;
  }

  if (validate && value > totalValue) {
    value = totalValue;
  }

  return value;
};

var getAnyElementOfObject = function getAnyElementOfObject(obj) {
  if (!obj) {
    return null;
  }

  var keys = Object.keys(obj);

  if (keys && keys.length) {
    return obj[keys[0]];
  }

  return null;
};

var hasDuplicate = function hasDuplicate(ary) {
  if (!__WEBPACK_IMPORTED_MODULE_1_lodash_isArray___default()(ary)) {
    return false;
  }

  var len = ary.length;
  var cache = {};

  for (var i = 0; i < len; i++) {
    if (!cache[ary[i]]) {
      cache[ary[i]] = true;
    } else {
      return true;
    }
  }

  return false;
};

var interpolateNumber = function interpolateNumber(numberA, numberB) {
  if (isNumber(numberA) && isNumber(numberB)) {
    return function (t) {
      return numberA + t * (numberB - numberA);
    };
  }

  return function () {
    return numberB;
  };
};

var findEntryInArray = function findEntryInArray(ary, specifiedKey, specifiedValue) {
  if (!ary || !ary.length) {
    return null;
  }

  return ary.find(function (entry) {
    return entry && __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(entry, specifiedKey) === specifiedValue;
  });
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var CONST_VAR = {
  SORT_DESC: 'desc',
  SORT_ASC: 'asc',
  AWAIT_BEFORE_CELL_EDIT: 1,
  SIZE_PER_PAGE: 10,
  NEXT_PAGE: '>',
  NEXT_PAGE_TITLE: 'next page',
  LAST_PAGE: '>>',
  LAST_PAGE_TITLE: 'last page',
  PRE_PAGE: '<',
  PRE_PAGE_TITLE: 'previous page',
  FIRST_PAGE: '<<',
  FIRST_PAGE_TITLE: 'first page',
  PAGE_START_INDEX: 1,
  ROW_SELECT_BG_COLOR: '',
  ROW_SELECT_NONE: 'none',
  ROW_SELECT_SINGLE: 'radio',
  ROW_SELECT_MULTI: 'checkbox',
  CELL_EDIT_NONE: 'none',
  CELL_EDIT_CLICK: 'click',
  CELL_EDIT_DBCLICK: 'dbclick',
  SIZE_PER_PAGE_LIST: [10, 25, 30, 50],
  PAGINATION_SIZE: 5,
  PAGINATION_POS_TOP: 'top',
  PAGINATION_POS_BOTTOM: 'bottom',
  PAGINATION_POS_BOTH: 'both',
  TOOLBAR_POS_TOP: 'top',
  TOOLBAR_POS_BOTTOM: 'bottom',
  TOOLBAR_POS_BOTH: 'both',
  NO_DATA_TEXT: 'There is no data to display',
  SHOW_ONLY_SELECT: 'Show Selected Only',
  SHOW_ALL: 'Show All',
  EXPORT_CSV_TEXT: 'Export to CSV',
  INSERT_BTN_TEXT: 'New',
  DELETE_BTN_TEXT: 'Delete',
  SAVE_BTN_TEXT: 'Save',
  CLOSE_BTN_TEXT: 'Close',
  FILTER_DELAY: 500,
  SCROLL_TOP: 'Top',
  SCROLL_BOTTOM: 'Bottom',
  FILTER_TYPE: {
    TEXT: 'TextFilter',
    REGEX: 'RegexFilter',
    SELECT: 'SelectFilter',
    NUMBER: 'NumberFilter',
    DATE: 'DateFilter',
    CUSTOM: 'CustomFilter',
    ARRAY: 'ArrayFilter'
  },
  FILTER_COND_EQ: 'eq',
  FILTER_COND_LIKE: 'like',
  EXPAND_BY_ROW: 'row',
  EXPAND_BY_COL: 'column',
  REMOTE_SORT: 'sort',
  REMOTE_PAGE: 'pagination',
  REMOTE_CELL_EDIT: 'cellEdit',
  REMOTE_INSERT_ROW: 'insertRow',
  REMOTE_DROP_ROW: 'dropRow',
  REMOTE_FILTER: 'filter',
  REMOTE_SEARCH: 'search',
  REMOTE_EXPORT_CSV: 'exportCSV',
  INSERT_FAIL_INDICATOR: 'Validation errors, please check!',
  DEFAULT_CSV_SEPARATOR: ',',
  CSV_STRING_TYPE: 'string',
  CSV_NUMBER_TYPE: 'number',
  AUTO_COLLAPSE_WHEN_SORT: false,
  AUTO_COLLAPSE_WHEN_SEARCH: false,
  AUTO_COLLAPSE_WHEN_FILTER: false
};

CONST_VAR.REMOTE = {};
CONST_VAR.REMOTE[CONST_VAR.REMOTE_SORT] = false;
CONST_VAR.REMOTE[CONST_VAR.REMOTE_PAGE] = false;
CONST_VAR.REMOTE[CONST_VAR.REMOTE_CELL_EDIT] = false;
CONST_VAR.REMOTE[CONST_VAR.REMOTE_INSERT_ROW] = false;
CONST_VAR.REMOTE[CONST_VAR.REMOTE_DROP_ROW] = false;
CONST_VAR.REMOTE[CONST_VAR.REMOTE_FILTER] = false;
CONST_VAR.REMOTE[CONST_VAR.REMOTE_SEARCH] = false;
CONST_VAR.REMOTE[CONST_VAR.REMOTE_EXPORT_CSV] = false;

var _default = CONST_VAR;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(CONST_VAR, 'CONST_VAR', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/Const.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/Const.js');
}();

;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * @fileOverview Layer
 */




var propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node])
};

function Layer(props) {
  var children = props.children,
      className = props.className,
      others = _objectWithoutProperties(props, ['children', 'className']);

  var layerClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('recharts-layer', className);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'g',
    _extends({ className: layerClass }, others),
    children
  );
}

Layer.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (Layer);

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(86);
var core = __webpack_require__(87);
var hide = __webpack_require__(131);
var redefine = __webpack_require__(272);
var ctx = __webpack_require__(275);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return getValueByDataKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getDomainOfDataByKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return calculateActiveTickIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getMainColorOfGraphicItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getLegendProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getBarSizeList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getBarPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return appendOffsetOfLegend; });
/* unused harmony export getDomainOfErrorBars */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return parseErrorBarsOfAxis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getDomainOfItemsWithSameAxis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return isCategorialAxis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getCoordinatesOfGrid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return getTicksOfAxis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return combineEventHandlers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return parseScale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return checkDomainOfScale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return findPositionOfBar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return truncateByDomain; });
/* unused harmony export offsetSign */
/* unused harmony export getStackedData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getStackGroupsByAxisId; });
/* unused harmony export calculateDomainOfTicks */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return getTicksOfScale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getCateCoordinateOfLine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getCateCoordinateOfBar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getBaseValueOfBar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return detectReferenceElementsDomain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return getStackedDataOfItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getDomainOfStackGroups; });
/* unused harmony export MIN_VALUE_REG */
/* unused harmony export MAX_VALUE_REG */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return parseSpecifiedDomain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return validateCoordinateInRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getBandSizeOfAxis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return parseDomainOfCategoryAxis; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_sortBy__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNaN__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNaN___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isNaN__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isString__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isString__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_max__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_max___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_max__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_min__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isArray__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isFunction__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_get__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isNil__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_recharts_scale__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_recharts_scale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_recharts_scale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_d3_scale__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_d3_shape__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__DataUtils__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__cartesian_ReferenceDot__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__cartesian_ReferenceLine__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__cartesian_ReferenceArea__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__cartesian_ErrorBar__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__component_Legend__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ReactUtils__ = __webpack_require__(3);











var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }












var getValueByDataKey = function getValueByDataKey(obj, dataKey, defaultValue) {
  if (__WEBPACK_IMPORTED_MODULE_9_lodash_isNil___default()(obj) || __WEBPACK_IMPORTED_MODULE_9_lodash_isNil___default()(dataKey)) {
    return defaultValue;
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_13__DataUtils__["f" /* isNumOrStr */])(dataKey)) {
    return __WEBPACK_IMPORTED_MODULE_8_lodash_get___default()(obj, dataKey, defaultValue);
  }

  if (__WEBPACK_IMPORTED_MODULE_7_lodash_isFunction___default()(dataKey)) {
    return dataKey(obj);
  }

  return defaultValue;
};
/**
 * Get domain of data by key
 * @param  {Array}   data      The data displayed in the chart
 * @param  {String}  key       The unique key of a group of data
 * @param  {String}  type      The type of axis
 * @param  {Boolean} filterNil Whether or not filter nil values
 * @return {Array} Domain of data
 */
var getDomainOfDataByKey = function getDomainOfDataByKey(data, key, type, filterNil) {
  var flattenData = data.reduce(function (result, entry) {
    var value = getValueByDataKey(entry, key);

    if (__WEBPACK_IMPORTED_MODULE_6_lodash_isArray___default()(value)) {
      return [].concat(_toConsumableArray(result), _toConsumableArray(value));
    }

    return [].concat(_toConsumableArray(result), [value]);
  }, []);

  if (type === 'number') {
    var domain = flattenData.filter(__WEBPACK_IMPORTED_MODULE_13__DataUtils__["g" /* isNumber */]);

    return [Math.min.apply(null, domain), Math.max.apply(null, domain)];
  }

  var validateData = filterNil ? flattenData.filter(function (entry) {
    return !__WEBPACK_IMPORTED_MODULE_9_lodash_isNil___default()(entry);
  }) : flattenData;

  return validateData.map(function (entry) {
    return Object(__WEBPACK_IMPORTED_MODULE_13__DataUtils__["f" /* isNumOrStr */])(entry) ? entry : '';
  });
};

var calculateActiveTickIndex = function calculateActiveTickIndex(coordinate, ticks, unsortedTicks, axis) {
  var index = -1;
  var len = ticks.length;

  if (len > 1) {
    if (axis && axis.axisType === 'angleAxis' && Math.abs(Math.abs(axis.range[1] - axis.range[0]) - 360) <= 1e-6) {
      var range = axis.range;
      // ticks are distributed in a circle

      for (var i = 0; i < len; i++) {
        var before = i > 0 ? unsortedTicks[i - 1].coordinate : unsortedTicks[len - 1].coordinate;
        var cur = unsortedTicks[i].coordinate;
        var after = i >= len - 1 ? unsortedTicks[0].coordinate : unsortedTicks[i + 1].coordinate;
        var sameDirectionCoord = void 0;

        if (Object(__WEBPACK_IMPORTED_MODULE_13__DataUtils__["i" /* mathSign */])(cur - before) !== Object(__WEBPACK_IMPORTED_MODULE_13__DataUtils__["i" /* mathSign */])(after - cur)) {
          var diffInterval = [];
          if (Object(__WEBPACK_IMPORTED_MODULE_13__DataUtils__["i" /* mathSign */])(after - cur) === Object(__WEBPACK_IMPORTED_MODULE_13__DataUtils__["i" /* mathSign */])(range[1] - range[0])) {
            sameDirectionCoord = after;

            var curInRange = cur + range[1] - range[0];
            diffInterval[0] = Math.min(curInRange, (curInRange + before) / 2);
            diffInterval[1] = Math.max(curInRange, (curInRange + before) / 2);
          } else {
            sameDirectionCoord = before;

            var afterInRange = after + range[1] - range[0];
            diffInterval[0] = Math.min(cur, (afterInRange + cur) / 2);
            diffInterval[1] = Math.max(cur, (afterInRange + cur) / 2);
          }
          var sameInterval = [Math.min(cur, (sameDirectionCoord + cur) / 2), Math.max(cur, (sameDirectionCoord + cur) / 2)];

          if (coordinate > sameInterval[0] && coordinate <= sameInterval[1] || coordinate >= diffInterval[0] && coordinate <= diffInterval[1]) {
            index = unsortedTicks[i].index;
            break;
          }
        } else {
          var min = Math.min(before, after);
          var max = Math.max(before, after);

          if (coordinate > (min + cur) / 2 && coordinate <= (max + cur) / 2) {
            index = unsortedTicks[i].index;
            break;
          }
        }
      }
    } else {
      // ticks are distributed in a single direction
      for (var _i = 0; _i < len; _i++) {
        if (_i === 0 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i > 0 && _i < len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i === len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2) {
          index = ticks[_i].index;
          break;
        }
      }
    }
  } else {
    index = 0;
  }

  return index;
};

/**
 * Get the main color of each graphic item
 * @param  {ReactElement} item A graphic item
 * @return {String}            Color
 */
var getMainColorOfGraphicItem = function getMainColorOfGraphicItem(item) {
  var displayName = item.type.displayName;
  var result = void 0;

  switch (displayName) {
    case 'Line':
    case 'Area':
    case 'Radar':
      result = item.props.stroke;
      break;
    default:
      result = item.props.fill;
      break;
  }

  return result;
};

var getLegendProps = function getLegendProps(_ref) {
  var children = _ref.children,
      formatedGraphicalItems = _ref.formatedGraphicalItems,
      legendWidth = _ref.legendWidth,
      legendContent = _ref.legendContent;

  var legendItem = Object(__WEBPACK_IMPORTED_MODULE_19__ReactUtils__["i" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_18__component_Legend__["a" /* default */]);
  if (!legendItem) {
    return null;
  }

  var legendData = void 0;
  if (legendItem.props && legendItem.props.payload) {
    legendData = legendItem.props && legendItem.props.payload;
  } else if (legendContent === 'children') {
    legendData = (formatedGraphicalItems || []).reduce(function (result, _ref2) {
      var item = _ref2.item,
          props = _ref2.props;

      var data = props.sectors || props.data || [];

      return result.concat(data.map(function (entry) {
        return {
          type: legendItem.props.iconType || item.props.legendType,
          value: entry.name,
          color: entry.fill,
          payload: entry
        };
      }));
    }, []);
  } else {
    legendData = (formatedGraphicalItems || []).map(function (_ref3) {
      var item = _ref3.item;
      var _item$props = item.props,
          dataKey = _item$props.dataKey,
          name = _item$props.name,
          legendType = _item$props.legendType,
          hide = _item$props.hide;


      return {
        inactive: hide,
        dataKey: dataKey,
        type: legendItem.props.iconType || legendType || 'square',
        color: getMainColorOfGraphicItem(item),
        value: name || dataKey,
        payload: item.props
      };
    });
  }

  return _extends({}, legendItem.props, __WEBPACK_IMPORTED_MODULE_18__component_Legend__["a" /* default */].getWithHeight(legendItem, legendWidth), {
    payload: legendData,
    item: legendItem
  });
};
/**
 * Calculate the size of all groups for stacked bar graph
 * @param  {Object} stackGroups The items grouped by axisId and stackId
 * @return {Object} The size of all groups
 */
var getBarSizeList = function getBarSizeList(_ref4) {
  var globalSize = _ref4.barSize,
      _ref4$stackGroups = _ref4.stackGroups,
      stackGroups = _ref4$stackGroups === undefined ? {} : _ref4$stackGroups;

  if (!stackGroups) {
    return {};
  }

  var result = {};
  var numericAxisIds = Object.keys(stackGroups);

  for (var i = 0, len = numericAxisIds.length; i < len; i++) {
    var sgs = stackGroups[numericAxisIds[i]].stackGroups;
    var stackIds = Object.keys(sgs);

    for (var j = 0, sLen = stackIds.length; j < sLen; j++) {
      var _sgs$stackIds$j = sgs[stackIds[j]],
          items = _sgs$stackIds$j.items,
          cateAxisId = _sgs$stackIds$j.cateAxisId;


      var barItems = items.filter(function (item) {
        return Object(__WEBPACK_IMPORTED_MODULE_19__ReactUtils__["j" /* getDisplayName */])(item.type).indexOf('Bar') >= 0;
      });

      if (barItems && barItems.length) {
        var selfSize = barItems[0].props.barSize;

        var cateId = barItems[0].props[cateAxisId];

        if (!result[cateId]) {
          result[cateId] = [];
        }

        result[cateId].push({
          item: barItems[0],
          stackList: barItems.slice(1),
          barSize: __WEBPACK_IMPORTED_MODULE_9_lodash_isNil___default()(selfSize) ? globalSize : selfSize
        });
      }
    }
  }

  return result;
};

/**
   * Calculate the size of each bar and the gap between two bars
   * @param  {Number} bandSize  The size of each category
   * @param  {sizeList} sizeList  The size of all groups
   * @param  {maxBarSize} maxBarSize The maximum size of bar
   * @return {Number} The size of each bar and the gap between two bars
   */
var getBarPosition = function getBarPosition(_ref5) {
  var barGap = _ref5.barGap,
      barCategoryGap = _ref5.barCategoryGap,
      bandSize = _ref5.bandSize,
      _ref5$sizeList = _ref5.sizeList,
      sizeList = _ref5$sizeList === undefined ? [] : _ref5$sizeList,
      maxBarSize = _ref5.maxBarSize;

  var len = sizeList.length;
  if (len < 1) return null;

  var realBarGap = Object(__WEBPACK_IMPORTED_MODULE_13__DataUtils__["c" /* getPercentValue */])(barGap, bandSize, 0, true);
  var result = void 0;

  // whether or not is barSize setted by user
  if (sizeList[0].barSize === +sizeList[0].barSize) {
    var useFull = false;
    var fullBarSize = bandSize / len;
    var sum = sizeList.reduce(function (res, entry) {
      return res + entry.barSize || 0;
    }, 0);
    sum += (len - 1) * realBarGap;

    if (sum >= bandSize) {
      sum -= (len - 1) * realBarGap;
      realBarGap = 0;
    }
    if (sum >= bandSize && fullBarSize > 0) {
      useFull = true;
      fullBarSize *= 0.9;
      sum = len * fullBarSize;
    }

    var offset = (bandSize - sum) / 2 >> 0;
    var prev = { offset: offset - realBarGap, size: 0 };

    result = sizeList.reduce(function (res, entry) {
      var newRes = [].concat(_toConsumableArray(res), [{
        item: entry.item,
        position: {
          offset: prev.offset + prev.size + realBarGap,
          size: useFull ? fullBarSize : entry.barSize
        }
      }]);

      prev = newRes[newRes.length - 1].position;

      if (entry.stackList && entry.stackList.length) {
        entry.stackList.forEach(function (item) {
          newRes.push({ item: item, position: prev });
        });
      }
      return newRes;
    }, []);
  } else {
    var _offset = Object(__WEBPACK_IMPORTED_MODULE_13__DataUtils__["c" /* getPercentValue */])(barCategoryGap, bandSize, 0, true);

    if (bandSize - 2 * _offset - (len - 1) * realBarGap <= 0) {
      realBarGap = 0;
    }

    var originalSize = (bandSize - 2 * _offset - (len - 1) * realBarGap) / len;
    if (originalSize > 1) {
      originalSize >>= 0;
    }
    var size = maxBarSize === +maxBarSize ? Math.min(originalSize, maxBarSize) : originalSize;

    result = sizeList.reduce(function (res, entry, i) {
      var newRes = [].concat(_toConsumableArray(res), [{
        item: entry.item,
        position: {
          offset: _offset + (originalSize + realBarGap) * i + (originalSize - size) / 2,
          size: size
        }
      }]);

      if (entry.stackList && entry.stackList.length) {
        entry.stackList.forEach(function (item) {
          newRes.push({ item: item, position: newRes[newRes.length - 1].position });
        });
      }
      return newRes;
    }, []);
  }

  return result;
};

var appendOffsetOfLegend = function appendOffsetOfLegend(offset, items, props, legendBox) {
  var children = props.children,
      width = props.width,
      height = props.height,
      margin = props.margin;

  var legendWidth = width - (margin.left || 0) - (margin.right || 0);
  var legendHeight = height - (margin.top || 0) - (margin.bottom || 0);
  var legendProps = getLegendProps({ children: children, items: items, legendWidth: legendWidth, legendHeight: legendHeight });
  var newOffset = offset;

  if (legendProps) {
    var box = legendBox || {};
    var align = legendProps.align,
        verticalAlign = legendProps.verticalAlign,
        layout = legendProps.layout;


    if ((layout === 'vertical' || layout === 'horizontal' && verticalAlign === 'center') && Object(__WEBPACK_IMPORTED_MODULE_13__DataUtils__["g" /* isNumber */])(offset[align])) {
      newOffset = _extends({}, offset, _defineProperty({}, align, newOffset[align] + (box.width || 0)));
    }

    if ((layout === 'horizontal' || layout === 'vertical' && align === 'center') && Object(__WEBPACK_IMPORTED_MODULE_13__DataUtils__["g" /* isNumber */])(offset[verticalAlign])) {
      newOffset = _extends({}, offset, _defineProperty({}, verticalAlign, newOffset[verticalAlign] + (box.height || 0)));
    }
  }

  return newOffset;
};

var getDomainOfErrorBars = function getDomainOfErrorBars(data, item, dataKey, axisType) {
  var children = item.props.children;

  var errorBars = Object(__WEBPACK_IMPORTED_MODULE_19__ReactUtils__["h" /* findAllByType */])(children, __WEBPACK_IMPORTED_MODULE_17__cartesian_ErrorBar__["a" /* default */]).filter(function (errorBarChild) {
    var direction = errorBarChild.props.direction;


    return __WEBPACK_IMPORTED_MODULE_9_lodash_isNil___default()(direction) || __WEBPACK_IMPORTED_MODULE_9_lodash_isNil___default()(axisType) ? true : axisType.indexOf(direction) >= 0;
  });

  if (errorBars && errorBars.length) {
    var keys = errorBars.map(function (errorBarChild) {
      return errorBarChild.props.dataKey;
    });

    return data.reduce(function (result, entry) {
      var entryValue = getValueByDataKey(entry, dataKey, 0);
      var mainValue = __WEBPACK_IMPORTED_MODULE_6_lodash_isArray___default()(entryValue) ? [__WEBPACK_IMPORTED_MODULE_5_lodash_min___default()(entryValue), __WEBPACK_IMPORTED_MODULE_4_lodash_max___default()(entryValue)] : [entryValue, entryValue];
      var errorDomain = keys.reduce(function (prevErrorArr, k) {
        var errorValue = getValueByDataKey(entry, k, 0);
        var lowerValue = mainValue[0] - Math.abs(__WEBPACK_IMPORTED_MODULE_6_lodash_isArray___default()(errorValue) ? errorValue[0] : errorValue);
        var upperValue = mainValue[1] + Math.abs(__WEBPACK_IMPORTED_MODULE_6_lodash_isArray___default()(errorValue) ? errorValue[1] : errorValue);

        return [Math.min(lowerValue, prevErrorArr[0]), Math.max(upperValue, prevErrorArr[1])];
      }, [Infinity, -Infinity]);

      return [Math.min(errorDomain[0], result[0]), Math.max(errorDomain[1], result[1])];
    }, [Infinity, -Infinity]);
  }

  return null;
};
var parseErrorBarsOfAxis = function parseErrorBarsOfAxis(data, items, dataKey, axisType) {
  var domains = items.map(function (item) {
    return getDomainOfErrorBars(data, item, dataKey, axisType);
  }).filter(function (entry) {
    return !__WEBPACK_IMPORTED_MODULE_9_lodash_isNil___default()(entry);
  });

  if (domains && domains.length) {
    return domains.reduce(function (result, entry) {
      return [Math.min(result[0], entry[0]), Math.max(result[1], entry[1])];
    }, [Infinity, -Infinity]);
  }

  return null;
};
/**
 * Get domain of data by the configuration of item element
 * @param  {Array}   data      The data displayed in the chart
 * @param  {Array}   items     The instances of item
 * @param  {String}  type      The type of axis, number - Number Axis, category - Category Axis
 * @param  {Boolean} filterNil Whether or not filter nil values
 * @return {Array}        Domain
 */
var getDomainOfItemsWithSameAxis = function getDomainOfItemsWithSameAxis(data, items, type, filterNil) {
  var domains = items.map(function (item) {
    var dataKey = item.props.dataKey;


    if (type === 'number' && dataKey) {
      return getDomainOfErrorBars(data, item, dataKey) || getDomainOfDataByKey(data, dataKey, type, filterNil);
    }
    return getDomainOfDataByKey(data, dataKey, type, filterNil);
  });

  if (type === 'number') {
    // Calculate the domain of number axis
    return domains.reduce(function (result, entry) {
      return [Math.min(result[0], entry[0]), Math.max(result[1], entry[1])];
    }, [Infinity, -Infinity]);
  }

  var tag = {};
  // Get the union set of category axis
  return domains.reduce(function (result, entry) {
    for (var i = 0, len = entry.length; i < len; i++) {
      if (!tag[entry[i]]) {
        tag[entry[i]] = true;

        result.push(entry[i]);
      }
    }
    return result;
  }, []);
};

var isCategorialAxis = function isCategorialAxis(layout, axisType) {
  return layout === 'horizontal' && axisType === 'xAxis' || layout === 'vertical' && axisType === 'yAxis' || layout === 'centric' && axisType === 'angleAxis' || layout === 'radial' && axisType === 'radiusAxis';
};

/**
 * Calculate the Coordinates of grid
 * @param  {Array} ticks The ticks in axis
 * @param {Number} min   The minimun value of axis
 * @param {Number} max   The maximun value of axis
 * @return {Array}       Coordinates
 */
var getCoordinatesOfGrid = function getCoordinatesOfGrid(ticks, min, max) {
  var hasMin = void 0,
      hasMax = void 0;

  var values = ticks.map(function (entry) {
    if (entry.coordinate === min) {
      hasMin = true;
    }
    if (entry.coordinate === max) {
      hasMax = true;
    }

    return entry.coordinate;
  });

  if (!hasMin) {
    values.push(min);
  }
  if (!hasMax) {
    values.push(max);
  }

  return values;
};

/**
 * Get the ticks of an axis
 * @param  {Object}  axis The configuration of an axis
 * @param {Boolean} isGrid Whether or not are the ticks in grid
 * @param {Boolean} isAll Return the ticks of all the points or not
 * @return {Array}  Ticks
 */
var getTicksOfAxis = function getTicksOfAxis(axis, isGrid, isAll) {
  if (!axis) return null;
  var scale = axis.scale;
  var duplicateDomain = axis.duplicateDomain,
      type = axis.type,
      range = axis.range;

  var offset = (isGrid || isAll) && type === 'category' && scale.bandwidth ? scale.bandwidth() / 2 : 0;
  offset = axis.axisType === 'angleAxis' ? Object(__WEBPACK_IMPORTED_MODULE_13__DataUtils__["i" /* mathSign */])(range[0] - range[1]) * 2 * offset : offset;

  // The ticks setted by user should only affect the ticks adjacent to axis line
  if (isGrid && (axis.ticks || axis.niceTicks)) {
    return (axis.ticks || axis.niceTicks).map(function (entry) {
      var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;

      return {
        coordinate: scale(scaleContent) + offset,
        value: entry,
        offset: offset
      };
    });
  }

  if (axis.isCategorial && axis.categoricalDomain) {
    return axis.categoricalDomain.map(function (entry, index) {
      return {
        coordinate: scale(entry),
        value: entry,
        index: index,
        offset: offset
      };
    });
  }

  if (scale.ticks && !isAll) {
    return scale.ticks(axis.tickCount).map(function (entry) {
      return { coordinate: scale(entry) + offset, value: entry, offset: offset };
    });
  }

  // When axis has duplicated text, serial numbers are used to generate scale
  return scale.domain().map(function (entry, index) {
    return {
      coordinate: scale(entry) + offset,
      value: duplicateDomain ? duplicateDomain[entry] : entry,
      index: index,
      offset: offset
    };
  });
};

/**
 * combine the handlers
 * @param  {Function} defaultHandler Internal private handler
 * @param  {Function} parentHandler  Handler function specified in parent component
 * @param  {Function} childHandler   Handler function specified in child component
 * @return {Function}                The combined handler
 */
var combineEventHandlers = function combineEventHandlers(defaultHandler, parentHandler, childHandler) {
  var customizedHandler = void 0;

  if (__WEBPACK_IMPORTED_MODULE_7_lodash_isFunction___default()(childHandler)) {
    customizedHandler = childHandler;
  } else if (__WEBPACK_IMPORTED_MODULE_7_lodash_isFunction___default()(parentHandler)) {
    customizedHandler = parentHandler;
  }

  if (__WEBPACK_IMPORTED_MODULE_7_lodash_isFunction___default()(defaultHandler) || customizedHandler) {
    return function (arg1, arg2, arg3, arg4) {
      if (__WEBPACK_IMPORTED_MODULE_7_lodash_isFunction___default()(defaultHandler)) {
        defaultHandler(arg1, arg2, arg3, arg4);
      }

      if (__WEBPACK_IMPORTED_MODULE_7_lodash_isFunction___default()(customizedHandler)) {
        customizedHandler(arg1, arg2, arg3, arg4);
      }
    };
  }

  return null;
};
/**
 * Parse the scale function of axis
 * @param  {Object}   axis          The option of axis
 * @param  {String}   chartType     The displayName of chart
 * @return {Function}               The scale funcion
 */
var parseScale = function parseScale(axis, chartType) {
  var scale = axis.scale,
      type = axis.type,
      layout = axis.layout,
      axisType = axis.axisType;

  if (scale === 'auto') {
    if (layout === 'radial' && axisType === 'radiusAxis') {
      return { scale: __WEBPACK_IMPORTED_MODULE_11_d3_scale__["scaleBand"](), realScaleType: 'band' };
    } else if (layout === 'radial' && axisType === 'angleAxis') {
      return { scale: __WEBPACK_IMPORTED_MODULE_11_d3_scale__["scaleLinear"](), realScaleType: 'linear' };
    }

    if (type === 'category' && chartType && (chartType.indexOf('LineChart') >= 0 || chartType.indexOf('AreaChart') >= 0)) {
      return { scale: __WEBPACK_IMPORTED_MODULE_11_d3_scale__["scalePoint"](), realScaleType: 'point' };
    } else if (type === 'category') {
      return { scale: __WEBPACK_IMPORTED_MODULE_11_d3_scale__["scaleBand"](), realScaleType: 'band' };
    }

    return { scale: __WEBPACK_IMPORTED_MODULE_11_d3_scale__["scaleLinear"](), realScaleType: 'linear' };
  } else if (__WEBPACK_IMPORTED_MODULE_3_lodash_isString___default()(scale)) {
    var name = 'scale' + scale.slice(0, 1).toUpperCase() + scale.slice(1);

    return {
      scale: (__WEBPACK_IMPORTED_MODULE_11_d3_scale__[name] || __WEBPACK_IMPORTED_MODULE_11_d3_scale__["scalePoint"])(),
      realScaleType: __WEBPACK_IMPORTED_MODULE_11_d3_scale__[name] ? name : 'point'
    };
  }

  return __WEBPACK_IMPORTED_MODULE_7_lodash_isFunction___default()(scale) ? { scale: scale } : { scale: __WEBPACK_IMPORTED_MODULE_11_d3_scale__["scalePoint"](), realScaleType: 'point' };
};
var EPS = 1e-4;
var checkDomainOfScale = function checkDomainOfScale(scale) {
  var domain = scale.domain();

  if (!domain || domain.length <= 2) {
    return;
  }

  var len = domain.length;
  var range = scale.range();
  var min = Math.min(range[0], range[1]) - EPS;
  var max = Math.max(range[0], range[1]) + EPS;
  var first = scale(domain[0]);
  var last = scale(domain[len - 1]);

  if (first < min || first > max || last < min || last > max) {
    scale.domain([domain[0], domain[len - 1]]);
  }
};

var findPositionOfBar = function findPositionOfBar(barPosition, child) {
  if (!barPosition) {
    return null;
  }

  for (var i = 0, len = barPosition.length; i < len; i++) {
    if (barPosition[i].item === child) {
      return barPosition[i].position;
    }
  }

  return null;
};

var truncateByDomain = function truncateByDomain(value, domain) {
  if (!domain || domain.length !== 2 || !Object(__WEBPACK_IMPORTED_MODULE_13__DataUtils__["g" /* isNumber */])(domain[0]) || !Object(__WEBPACK_IMPORTED_MODULE_13__DataUtils__["g" /* isNumber */])(domain[1])) {
    return value;
  }

  var min = Math.min(domain[0], domain[1]);
  var max = Math.max(domain[0], domain[1]);

  var result = [value[0], value[1]];
  if (!Object(__WEBPACK_IMPORTED_MODULE_13__DataUtils__["g" /* isNumber */])(value[0]) || value[0] < min) {
    result[0] = min;
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_13__DataUtils__["g" /* isNumber */])(value[1]) || value[1] > max) {
    result[1] = max;
  }

  if (result[0] > max) {
    result[0] = max;
  }

  if (result[1] < min) {
    result[1] = min;
  }

  return result;
};

/* eslint no-param-reassign: 0 */
var offsetSign = function offsetSign(series) {
  var n = series.length;
  if (n <= 0) {
    return;
  }

  for (var j = 0, m = series[0].length; j < m; ++j) {
    var positive = 0;
    var negative = 0;

    for (var i = 0; i < n; ++i) {
      var value = __WEBPACK_IMPORTED_MODULE_2_lodash_isNaN___default()(series[i][j][1]) ? series[i][j][0] : series[i][j][1];

      if (value >= 0) {
        series[i][j][0] = positive;
        series[i][j][1] = positive + value;
        positive = series[i][j][1];
      } else {
        series[i][j][0] = negative;
        series[i][j][1] = negative + value;
        negative = series[i][j][1];
      }
    }
  }
};

var STACK_OFFSET_MAP = {
  sign: offsetSign,
  expand: __WEBPACK_IMPORTED_MODULE_12_d3_shape__["o" /* stackOffsetExpand */],
  none: __WEBPACK_IMPORTED_MODULE_12_d3_shape__["p" /* stackOffsetNone */],
  silhouette: __WEBPACK_IMPORTED_MODULE_12_d3_shape__["q" /* stackOffsetSilhouette */],
  wiggle: __WEBPACK_IMPORTED_MODULE_12_d3_shape__["r" /* stackOffsetWiggle */]
};

var getStackedData = function getStackedData(data, stackItems, offsetType) {
  var dataKeys = stackItems.map(function (item) {
    return item.props.dataKey;
  });
  var stack = Object(__WEBPACK_IMPORTED_MODULE_12_d3_shape__["n" /* stack */])().keys(dataKeys).value(function (d, key) {
    return +getValueByDataKey(d, key, 0);
  }).order(__WEBPACK_IMPORTED_MODULE_12_d3_shape__["s" /* stackOrderNone */]).offset(STACK_OFFSET_MAP[offsetType]);

  return stack(data);
};

var getStackGroupsByAxisId = function getStackGroupsByAxisId(data, _items, numericAxisId, cateAxisId, offsetType, reverseStackOrder) {
  if (!data) {
    return null;
  }

  // reversing items to affect render order (for layering)
  var items = reverseStackOrder ? _items.reverse() : _items;

  var stackGroups = items.reduce(function (result, item) {
    var _item$props2 = item.props,
        stackId = _item$props2.stackId,
        hide = _item$props2.hide;


    if (hide) {
      return result;
    }

    var axisId = item.props[numericAxisId];
    var parentGroup = result[axisId] || { hasStack: false, stackGroups: {} };

    if (Object(__WEBPACK_IMPORTED_MODULE_13__DataUtils__["f" /* isNumOrStr */])(stackId)) {
      var childGroup = parentGroup.stackGroups[stackId] || {
        numericAxisId: numericAxisId, cateAxisId: cateAxisId, items: []
      };

      childGroup.items.push(item);

      parentGroup.hasStack = true;

      parentGroup.stackGroups[stackId] = childGroup;
    } else {
      parentGroup.stackGroups[Object(__WEBPACK_IMPORTED_MODULE_13__DataUtils__["j" /* uniqueId */])('_stackId_')] = {
        numericAxisId: numericAxisId, cateAxisId: cateAxisId, items: [item]
      };
    }

    return _extends({}, result, _defineProperty({}, axisId, parentGroup));
  }, {});

  return Object.keys(stackGroups).reduce(function (result, axisId) {
    var group = stackGroups[axisId];

    if (group.hasStack) {
      group.stackGroups = Object.keys(group.stackGroups).reduce(function (res, stackId) {
        var g = group.stackGroups[stackId];

        return _extends({}, res, _defineProperty({}, stackId, {
          numericAxisId: numericAxisId,
          cateAxisId: cateAxisId,
          items: g.items,
          stackedData: getStackedData(data, g.items, offsetType)
        }));
      }, {});
    }

    return _extends({}, result, _defineProperty({}, axisId, group));
  }, {});
};

/**
 * get domain of ticks
 * @param  {Array} ticks Ticks of axis
 * @param  {String} type  The type of axis
 * @return {Array} domain
 */
var calculateDomainOfTicks = function calculateDomainOfTicks(ticks, type) {
  if (type === 'number') {
    return [Math.min.apply(null, ticks), Math.max.apply(null, ticks)];
  }

  return ticks;
};

/**
 * Configure the scale function of axis
 * @param {Object} scale The scale function
 * @param {Object} opts  The configuration of axis
 * @return {Object}      null
 */
var getTicksOfScale = function getTicksOfScale(scale, opts) {
  var realScaleType = opts.realScaleType,
      type = opts.type,
      tickCount = opts.tickCount,
      originalDomain = opts.originalDomain,
      allowDecimals = opts.allowDecimals;

  var scaleType = realScaleType || opts.scale;

  if (scaleType !== 'auto' && scaleType !== 'linear') {
    return null;
  }

  if (tickCount && type === 'number' && originalDomain && (originalDomain[0] === 'auto' || originalDomain[1] === 'auto')) {
    // Calculate the ticks by the number of grid when the axis is a number axis
    var domain = scale.domain();
    var tickValues = Object(__WEBPACK_IMPORTED_MODULE_10_recharts_scale__["getNiceTickValues"])(domain, tickCount, allowDecimals);

    scale.domain(calculateDomainOfTicks(tickValues, type));

    return { niceTicks: tickValues };
  } else if (tickCount && type === 'number') {
    var _domain = scale.domain();
    var _tickValues = Object(__WEBPACK_IMPORTED_MODULE_10_recharts_scale__["getTickValuesFixedDomain"])(_domain, tickCount, allowDecimals);

    return { niceTicks: _tickValues };
  }

  return null;
};

var getCateCoordinateOfLine = function getCateCoordinateOfLine(_ref6) {
  var axis = _ref6.axis,
      ticks = _ref6.ticks,
      bandSize = _ref6.bandSize,
      entry = _ref6.entry,
      index = _ref6.index;

  if (axis.type === 'category') {
    // find coordinate of category axis by the value of category
    if (!axis.allowDuplicatedCategory && axis.dataKey && !__WEBPACK_IMPORTED_MODULE_9_lodash_isNil___default()(entry[axis.dataKey])) {
      var matchedTick = Object(__WEBPACK_IMPORTED_MODULE_13__DataUtils__["a" /* findEntryInArray */])(ticks, 'value', entry[axis.dataKey]);

      if (matchedTick) {
        return matchedTick.coordinate + bandSize / 2;
      }
    }

    return ticks[index] ? ticks[index].coordinate + bandSize / 2 : null;
  }

  var value = getValueByDataKey(entry, axis.dataKey);

  return !__WEBPACK_IMPORTED_MODULE_9_lodash_isNil___default()(value) ? axis.scale(value) : null;
};

var getCateCoordinateOfBar = function getCateCoordinateOfBar(_ref7) {
  var axis = _ref7.axis,
      ticks = _ref7.ticks,
      offset = _ref7.offset,
      bandSize = _ref7.bandSize,
      entry = _ref7.entry,
      index = _ref7.index;

  if (axis.type === 'category') {
    return ticks[index] ? ticks[index].coordinate + offset : null;
  }
  var value = getValueByDataKey(entry, axis.dataKey, axis.domain[index]);

  return !__WEBPACK_IMPORTED_MODULE_9_lodash_isNil___default()(value) ? axis.scale(value) - bandSize / 2 + offset : null;
};

var getBaseValueOfBar = function getBaseValueOfBar(_ref8) {
  var numericAxis = _ref8.numericAxis;

  var domain = numericAxis.scale.domain();

  if (numericAxis.type === 'number') {
    var min = Math.min(domain[0], domain[1]);
    var max = Math.max(domain[0], domain[1]);

    if (min <= 0 && max >= 0) {
      return 0;
    }
    if (max < 0) {
      return max;
    }

    return min;
  }

  return domain[0];
};

var detectReferenceElementsDomain = function detectReferenceElementsDomain(children, domain, axisId, axisType, specifiedTicks) {
  var lines = Object(__WEBPACK_IMPORTED_MODULE_19__ReactUtils__["h" /* findAllByType */])(children, __WEBPACK_IMPORTED_MODULE_15__cartesian_ReferenceLine__["a" /* default */]);
  var dots = Object(__WEBPACK_IMPORTED_MODULE_19__ReactUtils__["h" /* findAllByType */])(children, __WEBPACK_IMPORTED_MODULE_14__cartesian_ReferenceDot__["a" /* default */]);
  var elements = lines.concat(dots);
  var areas = Object(__WEBPACK_IMPORTED_MODULE_19__ReactUtils__["h" /* findAllByType */])(children, __WEBPACK_IMPORTED_MODULE_16__cartesian_ReferenceArea__["a" /* default */]);
  var idKey = axisType + 'Id';
  var valueKey = axisType[0];
  var finalDomain = domain;

  if (elements.length) {
    finalDomain = elements.reduce(function (result, el) {
      if (el.props[idKey] === axisId && el.props.alwaysShow && Object(__WEBPACK_IMPORTED_MODULE_13__DataUtils__["g" /* isNumber */])(el.props[valueKey])) {
        var value = el.props[valueKey];

        return [Math.min(result[0], value), Math.max(result[1], value)];
      }
      return result;
    }, finalDomain);
  }

  if (areas.length) {
    var key1 = valueKey + '1';
    var key2 = valueKey + '2';

    finalDomain = areas.reduce(function (result, el) {
      if (el.props[idKey] === axisId && el.props.alwaysShow && Object(__WEBPACK_IMPORTED_MODULE_13__DataUtils__["g" /* isNumber */])(el.props[key1]) && Object(__WEBPACK_IMPORTED_MODULE_13__DataUtils__["g" /* isNumber */])(el.props[key2])) {
        var value1 = el.props[key1];
        var value2 = el.props[key2];

        return [Math.min(result[0], value1, value2), Math.max(result[1], value1, value2)];
      }
      return result;
    }, finalDomain);
  }

  if (specifiedTicks && specifiedTicks.length) {
    finalDomain = specifiedTicks.reduce(function (result, tick) {
      if (Object(__WEBPACK_IMPORTED_MODULE_13__DataUtils__["g" /* isNumber */])(tick)) {
        return [Math.min(result[0], tick), Math.max(result[1], tick)];
      }

      return result;
    }, finalDomain);
  }

  return finalDomain;
};

var getStackedDataOfItem = function getStackedDataOfItem(item, stackGroups) {
  var stackId = item.props.stackId;


  if (Object(__WEBPACK_IMPORTED_MODULE_13__DataUtils__["f" /* isNumOrStr */])(stackId)) {
    var group = stackGroups[stackId];

    if (group && group.items.length) {
      var itemIndex = -1;

      for (var i = 0, len = group.items.length; i < len; i++) {
        if (group.items[i] === item) {
          itemIndex = i;
          break;
        }
      }
      return itemIndex >= 0 ? group.stackedData[itemIndex] : null;
    }
  }

  return null;
};

var getDomainOfSingle = function getDomainOfSingle(data) {
  return data.reduce(function (result, entry) {
    return [Math.min.apply(null, entry.concat([result[0]]).filter(__WEBPACK_IMPORTED_MODULE_13__DataUtils__["g" /* isNumber */])), Math.max.apply(null, entry.concat([result[1]]).filter(__WEBPACK_IMPORTED_MODULE_13__DataUtils__["g" /* isNumber */]))];
  }, [Infinity, -Infinity]);
};

var getDomainOfStackGroups = function getDomainOfStackGroups(stackGroups, startIndex, endIndex) {
  return Object.keys(stackGroups).reduce(function (result, stackId) {
    var group = stackGroups[stackId];
    var stackedData = group.stackedData;

    var domain = stackedData.reduce(function (res, entry) {
      var s = getDomainOfSingle(entry.slice(startIndex, endIndex + 1));

      return [Math.min(res[0], s[0]), Math.max(res[1], s[1])];
    }, [Infinity, -Infinity]);

    return [Math.min(domain[0], result[0]), Math.max(domain[1], result[1])];
  }, [Infinity, -Infinity]).map(function (result) {
    return result === Infinity || result === -Infinity ? 0 : result;
  });
};

var MIN_VALUE_REG = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var MAX_VALUE_REG = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;

var parseSpecifiedDomain = function parseSpecifiedDomain(specifiedDomain, dataDomain, allowDataOverflow) {
  if (!__WEBPACK_IMPORTED_MODULE_6_lodash_isArray___default()(specifiedDomain)) {
    return dataDomain;
  }

  var domain = [];

  if (Object(__WEBPACK_IMPORTED_MODULE_13__DataUtils__["g" /* isNumber */])(specifiedDomain[0])) {
    domain[0] = allowDataOverflow ? specifiedDomain[0] : Math.min(specifiedDomain[0], dataDomain[0]);
  } else if (MIN_VALUE_REG.test(specifiedDomain[0])) {
    var value = +MIN_VALUE_REG.exec(specifiedDomain[0])[1];

    domain[0] = dataDomain[0] - value;
  } else if (__WEBPACK_IMPORTED_MODULE_7_lodash_isFunction___default()(specifiedDomain[0])) {
    domain[0] = specifiedDomain[0](dataDomain[0]);
  } else {
    domain[0] = dataDomain[0];
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_13__DataUtils__["g" /* isNumber */])(specifiedDomain[1])) {
    domain[1] = allowDataOverflow ? specifiedDomain[1] : Math.max(specifiedDomain[1], dataDomain[1]);
  } else if (MAX_VALUE_REG.test(specifiedDomain[1])) {
    var _value = +MAX_VALUE_REG.exec(specifiedDomain[1])[1];

    domain[1] = dataDomain[1] + _value;
  } else if (__WEBPACK_IMPORTED_MODULE_7_lodash_isFunction___default()(specifiedDomain[1])) {
    domain[1] = specifiedDomain[1](dataDomain[1]);
  } else {
    domain[1] = dataDomain[1];
  }

  return domain;
};

var validateCoordinateInRange = function validateCoordinateInRange(coordinate, scale) {
  if (!scale) {
    return false;
  }

  var range = scale.range();
  var first = range[0];
  var last = range[range.length - 1];
  var isValidate = first <= last ? coordinate >= first && coordinate <= last : coordinate >= last && coordinate <= first;

  return isValidate;
};

/**
 * Calculate the size between two category
 * @param  {Object} axis  The options of axis
 * @param  {Array}  ticks The ticks of axis
 * @return {Number} Size
 */
var getBandSizeOfAxis = function getBandSizeOfAxis(axis, ticks) {
  if (axis && axis.scale && axis.scale.bandwidth) {
    return axis.scale.bandwidth();
  }

  if (axis && ticks && ticks.length >= 2) {
    var orderedTicks = __WEBPACK_IMPORTED_MODULE_1_lodash_sortBy___default()(ticks, function (o) {
      return o.coordinate;
    });
    var bandSize = Infinity;

    for (var i = 1, len = orderedTicks.length; i < len; i++) {
      var cur = orderedTicks[i];
      var prev = orderedTicks[i - 1];

      bandSize = Math.min((cur.coordinate || 0) - (prev.coordinate || 0), bandSize);
    }

    return bandSize === Infinity ? 0 : bandSize;
  }

  return 0;
};
/**
 * parse the domain of a category axis when a domain is specified
 * @param   {Array}        specifiedDomain  The domain specified by users
 * @param   {Array}        calculatedDomain The domain calculated by dateKey
 * @param   {ReactElement} axisChild        The axis element
 * @returns {Array}        domains
 */
var parseDomainOfCategoryAxis = function parseDomainOfCategoryAxis(specifiedDomain, calculatedDomain, axisChild) {
  if (!specifiedDomain || !specifiedDomain.length) {
    return calculatedDomain;
  }

  if (__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(specifiedDomain, __WEBPACK_IMPORTED_MODULE_8_lodash_get___default()(axisChild, 'type.defaultProps.domain'))) {
    return calculatedDomain;
  }

  return specifiedDomain;
};

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = newInterval;
var t0 = new Date,
    t1 = new Date;

function newInterval(floori, offseti, count, field) {

  function interval(date) {
    return floori(date = new Date(+date)), date;
  }

  interval.floor = interval;

  interval.ceil = function(date) {
    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
  };

  interval.round = function(date) {
    var d0 = interval(date),
        d1 = interval.ceil(date);
    return date - d0 < d1 - date ? d0 : d1;
  };

  interval.offset = function(date, step) {
    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
  };

  interval.range = function(start, stop, step) {
    var range = [], previous;
    start = interval.ceil(start);
    step = step == null ? 1 : Math.floor(step);
    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
    do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
    while (previous < start && start < stop);
    return range;
  };

  interval.filter = function(test) {
    return newInterval(function(date) {
      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
    }, function(date, step) {
      if (date >= date) {
        if (step < 0) while (++step <= 0) {
          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
        } else while (--step >= 0) {
          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
        }
      }
    });
  };

  if (count) {
    interval.count = function(start, end) {
      t0.setTime(+start), t1.setTime(+end);
      floori(t0), floori(t1);
      return Math.floor(count(t0, t1));
    };

    interval.every = function(step) {
      step = Math.floor(step);
      return !isFinite(step) || !(step > 0) ? null
          : !(step > 1) ? interval
          : interval.filter(field
              ? function(d) { return field(d) % step === 0; }
              : function(d) { return interval.count(0, d) % step === 0; });
    };
  }

  return interval;
}


/***/ }),
/* 13 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

module.exports = isNil;


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RADIAN; });
/* unused harmony export degreeToRadian */
/* unused harmony export radianToDegree */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return polarToCartesian; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getMaxRadius; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatAxisMap; });
/* unused harmony export distanceBetweenPoints */
/* unused harmony export getAngleOfPoint */
/* unused harmony export formatAngleOfSector */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return inRangeOfSector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DataUtils__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ChartUtils__ = __webpack_require__(11);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var RADIAN = Math.PI / 180;

var degreeToRadian = function degreeToRadian(angle) {
  return angle * Math.PI / 180;
};

var radianToDegree = function radianToDegree(angleInRadian) {
  return angleInRadian * 180 / Math.PI;
};

var polarToCartesian = function polarToCartesian(cx, cy, radius, angle) {
  return {
    x: cx + Math.cos(-RADIAN * angle) * radius,
    y: cy + Math.sin(-RADIAN * angle) * radius
  };
};

var getMaxRadius = function getMaxRadius(width, height) {
  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    top: 0, right: 0, bottom: 0, left: 0
  };
  return Math.min(Math.abs(width - (offset.left || 0) - (offset.right || 0)), Math.abs(height - (offset.top || 0) - (offset.bottom || 0))) / 2;
};

/**
 * Calculate the scale function, position, width, height of axes
 * @param  {Object} props     Latest props
 * @param  {Object} axisMap   The configuration of axes
 * @param  {Object} offset    The offset of main part in the svg element
 * @param  {Object} axisType  The type of axes, radius-axis or angle-axis
 * @param  {String} chartName The name of chart
 * @return {Object} Configuration
 */
var formatAxisMap = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
  var width = props.width,
      height = props.height;
  var startAngle = props.startAngle,
      endAngle = props.endAngle;

  var cx = Object(__WEBPACK_IMPORTED_MODULE_1__DataUtils__["c" /* getPercentValue */])(props.cx, width, width / 2);
  var cy = Object(__WEBPACK_IMPORTED_MODULE_1__DataUtils__["c" /* getPercentValue */])(props.cy, height, height / 2);
  var maxRadius = getMaxRadius(width, height, offset);
  var innerRadius = Object(__WEBPACK_IMPORTED_MODULE_1__DataUtils__["c" /* getPercentValue */])(props.innerRadius, maxRadius, 0);
  var outerRadius = Object(__WEBPACK_IMPORTED_MODULE_1__DataUtils__["c" /* getPercentValue */])(props.outerRadius, maxRadius, maxRadius * 0.8);
  var ids = Object.keys(axisMap);

  return ids.reduce(function (result, id) {
    var axis = axisMap[id];
    var domain = axis.domain,
        reversed = axis.reversed;

    var range = void 0;

    if (__WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(axis.range)) {
      if (axisType === 'angleAxis') {
        range = [startAngle, endAngle];
      } else if (axisType === 'radiusAxis') {
        range = [innerRadius, outerRadius];
      }

      if (reversed) {
        range = [range[1], range[0]];
      }
    } else {
      range = axis.range;
      startAngle = range[0];
      endAngle = range[1];
    }

    var _parseScale = Object(__WEBPACK_IMPORTED_MODULE_2__ChartUtils__["A" /* parseScale */])(axis, chartName),
        realScaleType = _parseScale.realScaleType,
        scale = _parseScale.scale;

    scale.domain(domain).range(range);
    Object(__WEBPACK_IMPORTED_MODULE_2__ChartUtils__["c" /* checkDomainOfScale */])(scale);
    var ticks = Object(__WEBPACK_IMPORTED_MODULE_2__ChartUtils__["v" /* getTicksOfScale */])(scale, _extends({}, axis, { realScaleType: realScaleType }));

    var finalAxis = _extends({}, axis, ticks, {
      range: range,
      radius: outerRadius,
      realScaleType: realScaleType, scale: scale, cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, startAngle: startAngle, endAngle: endAngle
    });

    return _extends({}, result, _defineProperty({}, id, finalAxis));
  }, {});
};

var distanceBetweenPoints = function distanceBetweenPoints(point, anotherPoint) {
  var x1 = point.x,
      y1 = point.y;
  var x2 = anotherPoint.x,
      y2 = anotherPoint.y;


  return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
};

var getAngleOfPoint = function getAngleOfPoint(_ref, _ref2) {
  var x = _ref.x,
      y = _ref.y;
  var cx = _ref2.cx,
      cy = _ref2.cy;

  var radius = distanceBetweenPoints({ x: x, y: y }, { x: cx, y: cy });

  if (radius <= 0) {
    return { radius: radius };
  }

  var cos = (x - cx) / radius;
  var angleInRadian = Math.acos(cos);

  if (y > cy) {
    angleInRadian = 2 * Math.PI - angleInRadian;
  }

  return { radius: radius, angle: radianToDegree(angleInRadian), angleInRadian: angleInRadian };
};

var formatAngleOfSector = function formatAngleOfSector(_ref3) {
  var startAngle = _ref3.startAngle,
      endAngle = _ref3.endAngle;

  var startCnt = Math.floor(startAngle / 360);
  var endCnt = Math.floor(endAngle / 360);
  var min = Math.min(startCnt, endCnt);

  return {
    startAngle: startAngle - min * 360,
    endAngle: endAngle - min * 360
  };
};

var reverseFormatAngleOfSetor = function reverseFormatAngleOfSetor(angle, _ref4) {
  var startAngle = _ref4.startAngle,
      endAngle = _ref4.endAngle;

  var startCnt = Math.floor(startAngle / 360);
  var endCnt = Math.floor(endAngle / 360);
  var min = Math.min(startCnt, endCnt);

  return angle + min * 360;
};

var inRangeOfSector = function inRangeOfSector(_ref5, sector) {
  var x = _ref5.x,
      y = _ref5.y;

  var _getAngleOfPoint = getAngleOfPoint({ x: x, y: y }, sector),
      radius = _getAngleOfPoint.radius,
      angle = _getAngleOfPoint.angle;

  var innerRadius = sector.innerRadius,
      outerRadius = sector.outerRadius;


  if (radius < innerRadius || radius > outerRadius) {
    return false;
  }

  if (radius === 0) {
    return true;
  }

  var _formatAngleOfSector = formatAngleOfSector(sector),
      startAngle = _formatAngleOfSector.startAngle,
      endAngle = _formatAngleOfSector.endAngle;

  var formatAngle = angle;
  var inRange = void 0;

  if (startAngle <= endAngle) {
    while (formatAngle > endAngle) {
      formatAngle -= 360;
    }
    while (formatAngle < startAngle) {
      formatAngle += 360;
    }
    inRange = formatAngle >= startAngle && formatAngle <= endAngle;
  } else {
    while (formatAngle > startAngle) {
      formatAngle -= 360;
    }
    while (formatAngle < endAngle) {
      formatAngle += 360;
    }
    inRange = formatAngle >= endAngle && formatAngle <= startAngle;
  }

  if (inRange) {
    return _extends({}, sector, { radius: radius, angle: reverseFormatAngleOfSetor(formatAngle, sector) });
  }

  return null;
};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Const = __webpack_require__(7);

var _Const2 = _interopRequireDefault(_Const);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = {
  renderReactSortCaret: function renderReactSortCaret(order, isBootstrap4) {
    var orderClass = void 0;
    if (isBootstrap4) {
      orderClass = (0, _classnames2.default)('fa', {
        'fa-sort-asc': order === _Const2.default.SORT_ASC,
        'fa-sort-desc': order === _Const2.default.SORT_DESC
      });
      return _react2.default.createElement('span', { className: orderClass, style: { margin: '10px 5px' } });
    } else {
      orderClass = (0, _classnames2.default)('order', {
        'dropup': order === _Const2.default.SORT_ASC
      });
      return _react2.default.createElement(
        'span',
        { className: orderClass },
        _react2.default.createElement('span', { className: 'caret', style: { margin: '10px 5px' } })
      );
    }
  },
  isFunction: function isFunction(obj) {
    return obj && typeof obj === 'function';
  },
  getScrollBarWidth: function getScrollBarWidth() {
    var inner = document.createElement('p');
    inner.style.width = '100%';
    inner.style.height = '200px';

    var outer = document.createElement('div');
    outer.style.position = 'absolute';
    outer.style.top = '0px';
    outer.style.left = '0px';
    outer.style.visibility = 'hidden';
    outer.style.width = '200px';
    outer.style.height = '150px';
    outer.style.overflow = 'hidden';
    outer.appendChild(inner);

    document.body.appendChild(outer);
    var w1 = inner.getBoundingClientRect().width;
    outer.style.overflow = 'scroll';
    var w2 = inner.getBoundingClientRect().width;

    if (w1 === w2) w2 = outer.clientWidth;

    document.body.removeChild(outer);

    return w1 - w2;
  },
  canUseDOM: function canUseDOM() {
    return typeof window !== 'undefined' && typeof window.document !== 'undefined';
  },


  // We calculate an offset here in order to properly fetch the indexed data,
  // despite the page start index not always being 1
  getNormalizedPage: function getNormalizedPage(pageStartIndex, page) {
    pageStartIndex = this.getFirstPage(pageStartIndex);
    if (page === undefined) page = pageStartIndex;
    var offset = Math.abs(_Const2.default.PAGE_START_INDEX - pageStartIndex);
    return page + offset;
  },
  getFirstPage: function getFirstPage(pageStartIndex) {
    return pageStartIndex !== undefined ? pageStartIndex : _Const2.default.PAGE_START_INDEX;
  },
  isBootstrap4: function isBootstrap4(version) {
    return version === '4';
  },
  isSelectRowDefined: function isSelectRowDefined(mode) {
    return mode === _Const2.default.ROW_SELECT_SINGLE || mode === _Const2.default.ROW_SELECT_MULTI;
  },
  renderColGroup: function renderColGroup(columns, selectRow) {
    var expandColumnOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var version = arguments[3];

    var selectRowHeader = null;
    var expandRowHeader = null;
    var isBootstrap4 = this.isBootstrap4(version);
    var isSelectRowDefined = this.isSelectRowDefined(selectRow.mode);
    var columnWidth = isBootstrap4 ? '38px' : '30px';
    if (isSelectRowDefined) {
      var style = {
        width: selectRow.columnWidth || columnWidth,
        minWidth: selectRow.columnWidth || columnWidth
      };
      if (!selectRow.hideSelectColumn) {
        selectRowHeader = _react2.default.createElement('col', { key: 'select-col', style: style });
      }
    }
    if (expandColumnOptions.expandColumnVisible) {
      var _style = {
        width: expandColumnOptions.columnWidth || columnWidth,
        minWidth: expandColumnOptions.columnWidth || columnWidth
      };
      expandRowHeader = _react2.default.createElement('col', { key: 'expand-col', style: _style });
    }
    var theader = columns.map(function (column, i) {
      var style = {
        display: column.hidden ? 'none' : null
      };
      if (column.width) {
        var width = !isNaN(column.width) ? column.width + 'px' : column.width;
        style.width = width;
        /** add min-wdth to fix user assign column width
        not eq offsetWidth in large column table **/
        style.minWidth = width;
      }
      return _react2.default.createElement('col', { style: style, key: i });
    });

    return _react2.default.createElement(
      'colgroup',
      null,
      expandColumnOptions.expandColumnVisible && expandColumnOptions.expandColumnBeforeSelectColumn && expandRowHeader,
      selectRowHeader,
      expandColumnOptions.expandColumnVisible && !expandColumnOptions.expandColumnBeforeSelectColumn && expandRowHeader,
      theader
    );
  }
}; /* eslint react/display-name: 0 */

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/util.js');
}();

;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(133);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 17 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translateStyle = exports.AnimateGroup = exports.configBezier = exports.configSpring = undefined;

var _Animate = __webpack_require__(151);

var _Animate2 = _interopRequireDefault(_Animate);

var _easing = __webpack_require__(164);

var _util = __webpack_require__(75);

var _AnimateGroup = __webpack_require__(423);

var _AnimateGroup2 = _interopRequireDefault(_AnimateGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.configSpring = _easing.configSpring;
exports.configBezier = _easing.configBezier;
exports.AnimateGroup = _AnimateGroup2.default;
exports.translateStyle = _util.translateStyle;
exports.default = _Animate2.default;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(105);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return dataFunction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return filterAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return separateDataByYears; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return averageDataByYear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return filterBySex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return turnStringsIntoFloats; });
/* unused harmony export deleteNaN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return filterTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return mapTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return initialReformat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return filterByAgeGroup; });
var dataFunction=function dataFunction(data,alcohol){var inputData=[];//go through the data
data.forEach(function(row,i){//check if data has specified type and set it to a variable
var tableTitle=row.GHO||null,country=row.COUNTRY||null,region=row.REGION||null,year=row.YEAR||null,value=row.Value||null,sex=row.SEX||null,alcoholType=row.ALCOHOLTYPE||null,socialCostType=row.SOCIALCOSTTYPE||null,ageGroup=row.AGEGROUP||null,advertisingType=row.ADVERTISINGTYPE||null,residenceAreaType=row.RESIDENCEAREATYPE||null,whoIncomeRegion=row.WHOINCOMEREGION||null;//set first object to all values it can possible have
inputData[i]={};inputData[i].title=tableTitle;inputData[i].value=value;if(country)inputData[i].country=country;if(region)inputData[i].region=region;if(year)inputData[i].year=year;if(sex)inputData[i].sex=sex;if(whoIncomeRegion)inputData[i].region=whoIncomeRegion;if(ageGroup)inputData[i].agegroup=ageGroup;//alcohol only has to do with certain datasets
if(alcohol){if(socialCostType)inputData[i].socialCostType=socialCostType;if(advertisingType)inputData[i].advertisingType=advertisingType;if(alcoholType)inputData[i].alcoholType=alcoholType;}if(residenceAreaType)inputData[i].residenceAreaType=residenceAreaType;return row;});//data filtered without extra parameters
return inputData;};//this is usesd to filter data by, first title, and then by year
var filterAll=function filterAll(data){var filtered=[];//go through the data and add to first filter
data.map(function(row){//if title exists already then add the row to correlate with the title
if(filtered[row.title])filtered[row.title].push(row);//create a new array for row and place first instance into it
else{filtered[row.title]=[];filtered[row.title].push(row);}});var secondFilter=[];for(var title in filtered){//go through each title key
filtered[title].forEach(function(row,i){//go through each row inside title array
if(!secondFilter[title]){//if there is no key associated with the title
//create a new object
secondFilter[title]={};//set a year to the title if it exists
secondFilter[title][row.year]=[];//add the row to the specified year
secondFilter[title][row.year].push(row);//check if the year exists with the title
}else if(!secondFilter[title][row.year]){//if it does not create the new year
secondFilter[title][row.year]=[];//push the row into the title/year
secondFilter[title][row.year].push(row);}else{//push the row into the title and year specified
secondFilter[title][row.year].push(row);}});}//should return an array that contains a title as a key, an array of objects specifying years arrays as the value. Each of these arrays contains all of the row related to the year.
return secondFilter;};var separateDataByYears=function separateDataByYears(data,title){data=data[title];var separatedData=[],i=0;//key is each year... 1990, 1991...
for(var key in data){//sets a new object solely with the key year and the corresponding year value
separatedData.push({year:key});//loop through all of the objects within each year, grab the objects region, set it as the key and set the corresponding data value to the region
data[key].forEach(function(obj){separatedData[i][obj.region]=+obj.value;});//increment i so that the next year is set to the next index in the array
i++;}return separatedData;};var averageDataByYear=function averageDataByYear(data){var averagedData={},k=0;//loop through each year in the dataset
data.forEach(function(obj){for(var key in obj){//if key is year, do nothing, otherwise go through each key/value
if(key!=='year'){//if the index is greater then 0, it means that you have already set each region to the first corresponding value(1990, if that is the first year), so grab the next value and add it to it (1991, 1992, ...)
if(k>0){averagedData[key]+=+obj[key];}else{//set first value, set region, and set value
averagedData[key]=+obj[key];}}}k++;});//k is the amount of years that were gone through, so divide by that number for the average
for(var key in averagedData){averagedData[key]=averagedData[key]/k;}return averagedData;};var filterBySex=function filterBySex(sex,data,key,year){//key is the title, year is the one desired
var filteredData=data[key][year].filter(function(obj){if(sex===obj.sex)return obj;});return filteredData;};var turnStringsIntoFloats=function turnStringsIntoFloats(data,key){data.map(function(obj){//sometimes a value is null which converts to NaN for the chart
if(obj[key]!==null){obj[key]=parseFloat(obj[key]);}else{obj[key]=0;}});return data;};var deleteNaN=function deleteNaN(data,key){data=data.filter(function(obj){if(!isNaN(obj[key])){return obj;}});return data;};//here the data that has No Value, other wierd things as a value is filtered out first,
var filterTable=function filterTable(data){return data.filter(function(row){var value=row.Value;if(!value||value==='No data'||value==='Not applicable'){return false;}else return true;});};//then when the numbers are odd with brackets, etc. It is turned into a float or an int that can easily be worked with.
var mapTable=function mapTable(data){return data.map(function(row){var value=row.Value;var charCode=value.charCodeAt(0);var bracketIndex=value.indexOf('[')>-1;if(charCode>64&&!bracketIndex)return row;else if(value[0]==='<'||value[0]==='>'){value=value.split(' ')[0].slice(1);row.Value=value;return row;}else if(value.indexOf(' ')>-1){if(bracketIndex){value=value.split('[')[0];row.Value=value;return row;}value=value.split(' ').join('');row.Value=value;return row;}else{return row;}});};var initialReformat=function initialReformat(data){var temp={};//initially the data has a fact property with all needed data within.
return data.fact.map(function(row){//data is then structured as so: {dims: {...stuff}, Value: some_value, ...}
temp=row.Value;row=row.dims;row.Value=temp;//now it is as so: {stuff1: something, stuff2: something_else, ..., Value: some_value}
return row;});};var filterByAgeGroup=function filterByAgeGroup(data,ageGroup){return data.filter(function(row){if(row.agegroup===ageGroup)return row;});};

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WikiquoteApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return error; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
var WikiquoteApi=function(){var wqa={};var API_URL="https://en.wikiquote.org/w/api.php";//query the title specified
wqa.queryTitles=function(titles,_success,_error){__WEBPACK_IMPORTED_MODULE_0_jquery__["ajax"]({url:API_URL,dataType:"jsonp",data:{format:"json",action:"query",redirects:"",titles:titles},success:function success(result,status){var pages=result.query.pages;var pageId=-1;for(var p in pages){var page=pages[p];// api can return invalid records, these are marked as "missing"
if(!("missing"in page)){pageId=page.pageid;break;}}if(pageId>0){_success(pageId);}else{_error("No results");}},error:function error(xhr,result,status){_error("Error processing your query");}});};/**
   * Get the sections for a given page.
   * This makes parsing for quotes more manageable.
   * Returns an array of all "1.x" sections as these usually contain the quotes.
   * If no 1.x sections exists, returns section 1. Returns the titles that were used
   * in case there is a redirect.
   */wqa.getSectionsForPage=function(pageId,_success2,_error2){__WEBPACK_IMPORTED_MODULE_0_jquery__["ajax"]({url:API_URL,dataType:"jsonp",data:{format:"json",action:"parse",prop:"sections",pageid:pageId},success:function success(result,status){var sectionArray=[];var sections=result.parse.sections;for(var s in sections){var splitNum=sections[s].number.split('.');if(splitNum.length>1&&splitNum[0]==="1"){sectionArray.push(sections[s].index);}}// Use section 1 if there are no "1.x" sections
if(sectionArray.length===0){sectionArray.push("1");}_success2({titles:result.parse.title,sections:sectionArray});},error:function error(xhr,result,status){_error2("Error getting sections");}});};/*
   * Get all quotes for a given section.  Most sections will be of the format:
   * <h3> title </h3>
   * <ul>
   *   <li>
   *     Quote text
   *     <ul>
   *       <li> additional info on the quote </li>
   *     </ul>
   *   </li>
   * <ul>
   * <ul> next quote etc... </ul>
   *
   * The quote may or may not contain sections inside <b /> tags.
   *
   * For quotes with bold sections, only the bold part is returned for brevity
   * (usually the bold part is more well known).
   * Otherwise the entire text is returned.  Returns the titles that were used
   * in case there is a redirect.
   */wqa.getQuotesForSection=function(pageId,sectionIndex,_success3,_error3){__WEBPACK_IMPORTED_MODULE_0_jquery__["ajax"]({url:API_URL,dataType:"jsonp",data:{format:"json",action:"parse",noimages:"",pageid:pageId,section:sectionIndex},success:function success(result,status){var quotes=result.parse.text["*"];var quoteArray=[];// Find top level <li> only
var $lis=__WEBPACK_IMPORTED_MODULE_0_jquery__(quotes).find('li:not(li li)');$lis.each(function(){// Remove all children that aren't <b>
__WEBPACK_IMPORTED_MODULE_0_jquery__(this).children().remove(':not(b)');var $bolds=__WEBPACK_IMPORTED_MODULE_0_jquery__(this).find('b');// If the section has bold text, use it.  Otherwise pull the plain text.
if($bolds.length>0){quoteArray.push($bolds.html());}else{quoteArray.push(__WEBPACK_IMPORTED_MODULE_0_jquery__(this).html());}});//grab valid quotes, not quotes that are very short or very long.
var filteredQuotes=[];filteredQuotes=quoteArray.filter(function(quote){if(quote.length<450){if(quote.length>50){return quote;}}});_success3({titles:result.parse.title,quotes:filteredQuotes});},error:function error(xhr,result,status){_error3("Error getting quotes");}});};/**
   * Get a random quote for the given title search.
   * This function searches for a page id for the given title, chooses a random
   * section from the list of sections for the page, and then chooses a random
   * quote from that section.  Returns the titles that were used in case there
   * is a redirect.
   */wqa.getRandomQuote=function(titles,success,error){var errorFunction=function errorFunction(msg){error(msg);};var chooseQuote=function chooseQuote(quotes){var randomNum=Math.floor(Math.random()*quotes.quotes.length);success({titles:quotes.titles,quote:quotes.quotes[randomNum]});};var getQuotes=function getQuotes(pageId,sections){var randomNum=Math.floor(Math.random()*sections.sections.length);wqa.getQuotesForSection(pageId,sections.sections[randomNum],chooseQuote,errorFunction);};var getSections=function getSections(pageId){wqa.getSectionsForPage(pageId,function(sections){getQuotes(pageId,sections);},errorFunction);};wqa.queryTitles(titles,getSections,errorFunction);};return wqa;}();var error=function error(err){console.error(err);};

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(250);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__polyfill__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__container_Surface__ = __webpack_require__(44);
/* unused harmony reexport Surface */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__container_Layer__ = __webpack_require__(9);
/* unused harmony reexport Layer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__component_Legend__ = __webpack_require__(98);
/* unused harmony reexport Legend */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__component_Tooltip__ = __webpack_require__(74);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_4__component_Tooltip__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__component_ResponsiveContainer__ = __webpack_require__(430);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_5__component_ResponsiveContainer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__component_Cell__ = __webpack_require__(52);
/* unused harmony reexport Cell */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__component_Text__ = __webpack_require__(34);
/* unused harmony reexport Text */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__component_Label__ = __webpack_require__(28);
/* unused harmony reexport Label */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__component_LabelList__ = __webpack_require__(30);
/* unused harmony reexport LabelList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shape_Sector__ = __webpack_require__(80);
/* unused harmony reexport Sector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shape_Curve__ = __webpack_require__(41);
/* unused harmony reexport Curve */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shape_Rectangle__ = __webpack_require__(40);
/* unused harmony reexport Rectangle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shape_Polygon__ = __webpack_require__(122);
/* unused harmony reexport Polygon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shape_Dot__ = __webpack_require__(36);
/* unused harmony reexport Dot */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__shape_Cross__ = __webpack_require__(214);
/* unused harmony reexport Cross */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__shape_Symbols__ = __webpack_require__(99);
/* unused harmony reexport Symbols */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__polar_PolarGrid__ = __webpack_require__(531);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_17__polar_PolarGrid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__polar_PolarRadiusAxis__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_18__polar_PolarRadiusAxis__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__polar_PolarAngleAxis__ = __webpack_require__(82);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_19__polar_PolarAngleAxis__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__polar_Pie__ = __webpack_require__(216);
/* unused harmony reexport Pie */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__polar_Radar__ = __webpack_require__(217);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_21__polar_Radar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__polar_RadialBar__ = __webpack_require__(218);
/* unused harmony reexport RadialBar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__cartesian_Brush__ = __webpack_require__(219);
/* unused harmony reexport Brush */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__cartesian_ReferenceLine__ = __webpack_require__(212);
/* unused harmony reexport ReferenceLine */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__cartesian_ReferenceDot__ = __webpack_require__(211);
/* unused harmony reexport ReferenceDot */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__cartesian_ReferenceArea__ = __webpack_require__(213);
/* unused harmony reexport ReferenceArea */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__cartesian_CartesianAxis__ = __webpack_require__(221);
/* unused harmony reexport CartesianAxis */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__cartesian_CartesianGrid__ = __webpack_require__(536);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_28__cartesian_CartesianGrid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__cartesian_Line__ = __webpack_require__(123);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_29__cartesian_Line__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__cartesian_Area__ = __webpack_require__(124);
/* unused harmony reexport Area */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__cartesian_Bar__ = __webpack_require__(125);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_31__cartesian_Bar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__cartesian_Scatter__ = __webpack_require__(126);
/* unused harmony reexport Scatter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__cartesian_XAxis__ = __webpack_require__(42);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_33__cartesian_XAxis__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__cartesian_YAxis__ = __webpack_require__(43);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_34__cartesian_YAxis__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__cartesian_ZAxis__ = __webpack_require__(83);
/* unused harmony reexport ZAxis */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__cartesian_ErrorBar__ = __webpack_require__(58);
/* unused harmony reexport ErrorBar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__chart_LineChart__ = __webpack_require__(537);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_37__chart_LineChart__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__chart_BarChart__ = __webpack_require__(540);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_38__chart_BarChart__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__chart_PieChart__ = __webpack_require__(541);
/* unused harmony reexport PieChart */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__chart_Treemap__ = __webpack_require__(542);
/* unused harmony reexport Treemap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__chart_Sankey__ = __webpack_require__(543);
/* unused harmony reexport Sankey */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__chart_RadarChart__ = __webpack_require__(546);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_42__chart_RadarChart__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__chart_ScatterChart__ = __webpack_require__(547);
/* unused harmony reexport ScatterChart */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__chart_AreaChart__ = __webpack_require__(548);
/* unused harmony reexport AreaChart */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__chart_RadialBarChart__ = __webpack_require__(549);
/* unused harmony reexport RadialBarChart */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__chart_ComposedChart__ = __webpack_require__(550);
/* unused harmony reexport ComposedChart */































































































/***/ }),
/* 24 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_bisect__ = __webpack_require__(179);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__src_bisect__["a"]; });
/* unused harmony reexport bisectRight */
/* unused harmony reexport bisectLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_ascending__ = __webpack_require__(39);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__src_ascending__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_bisector__ = __webpack_require__(180);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__src_bisector__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_cross__ = __webpack_require__(456);
/* unused harmony reexport cross */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_descending__ = __webpack_require__(457);
/* unused harmony reexport descending */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_deviation__ = __webpack_require__(182);
/* unused harmony reexport deviation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_extent__ = __webpack_require__(184);
/* unused harmony reexport extent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_histogram__ = __webpack_require__(458);
/* unused harmony reexport histogram */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_threshold_freedmanDiaconis__ = __webpack_require__(461);
/* unused harmony reexport thresholdFreedmanDiaconis */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_threshold_scott__ = __webpack_require__(462);
/* unused harmony reexport thresholdScott */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_threshold_sturges__ = __webpack_require__(188);
/* unused harmony reexport thresholdSturges */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_max__ = __webpack_require__(463);
/* unused harmony reexport max */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_mean__ = __webpack_require__(464);
/* unused harmony reexport mean */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_median__ = __webpack_require__(465);
/* unused harmony reexport median */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_merge__ = __webpack_require__(466);
/* unused harmony reexport merge */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_min__ = __webpack_require__(189);
/* unused harmony reexport min */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_pairs__ = __webpack_require__(181);
/* unused harmony reexport pairs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_permute__ = __webpack_require__(467);
/* unused harmony reexport permute */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_quantile__ = __webpack_require__(112);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_18__src_quantile__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__src_range__ = __webpack_require__(186);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_19__src_range__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__src_scan__ = __webpack_require__(468);
/* unused harmony reexport scan */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__src_shuffle__ = __webpack_require__(469);
/* unused harmony reexport shuffle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__src_sum__ = __webpack_require__(470);
/* unused harmony reexport sum */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__src_ticks__ = __webpack_require__(187);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_23__src_ticks__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_23__src_ticks__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_23__src_ticks__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__src_transpose__ = __webpack_require__(190);
/* unused harmony reexport transpose */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__src_variance__ = __webpack_require__(183);
/* unused harmony reexport variance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__src_zip__ = __webpack_require__(471);
/* unused harmony reexport zip */





























/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return durationSecond; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return durationMinute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return durationHour; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return durationDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return durationWeek; });
var durationSecond = 1e3;
var durationMinute = 6e4;
var durationHour = 36e5;
var durationDay = 864e5;
var durationWeek = 6048e5;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(45),
    getRawTag = __webpack_require__(297),
    objectToString = __webpack_require__(298);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isObject__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNil__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Text__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_DataUtils__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_PolarUtils__ = __webpack_require__(14);




var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }










var cartesianViewBoxShape = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
  x: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  y: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  width: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number
});
var polarViewBoxShape = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
  cx: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  cy: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  innerRadius: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  outerRadius: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  startAngle: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  endAngle: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number
});

var propTypes = {
  viewBox: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([cartesianViewBoxShape, polarViewBoxShape]),
  formatter: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  value: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string]),
  offset: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  position: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['top', 'left', 'right', 'bottom', 'inside', 'outside', 'insideLeft', 'insideRight', 'insideTop', 'insideBottom', 'insideTopLeft', 'insideBottomLeft', 'insideTopRight', 'insideBottomRight', 'insideStart', 'insideEnd', 'end', 'center']),
  children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node]),
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  content: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func])
};

var defaultProps = {
  offset: 5
};

var getLabel = function getLabel(props) {
  var value = props.value,
      formatter = props.formatter;

  var label = __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(props.children) ? value : props.children;

  if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(formatter)) {
    return formatter(label);
  }

  return label;
};

var getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
  var sign = Object(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["i" /* mathSign */])(endAngle - startAngle);
  var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);

  return sign * deltaAngle;
};

var renderRadialLabel = function renderRadialLabel(labelProps, label, attrs) {
  var position = labelProps.position,
      viewBox = labelProps.viewBox,
      offset = labelProps.offset,
      className = labelProps.className;
  var cx = viewBox.cx,
      cy = viewBox.cy,
      innerRadius = viewBox.innerRadius,
      outerRadius = viewBox.outerRadius,
      startAngle = viewBox.startAngle,
      endAngle = viewBox.endAngle,
      clockWise = viewBox.clockWise;

  var radius = (innerRadius + outerRadius) / 2;
  var deltaAngle = getDeltaAngle(startAngle, endAngle);
  var sign = deltaAngle >= 0 ? 1 : -1;
  var labelAngle = void 0,
      direction = void 0;

  if (position === 'insideStart') {
    labelAngle = startAngle + sign * offset;
    direction = clockWise;
  } else if (position === 'insideEnd') {
    labelAngle = endAngle - sign * offset;
    direction = !clockWise;
  } else if (position === 'end') {
    labelAngle = endAngle + sign * offset;
    direction = clockWise;
  }

  direction = deltaAngle <= 0 ? direction : !direction;

  var startPoint = Object(__WEBPACK_IMPORTED_MODULE_9__util_PolarUtils__["e" /* polarToCartesian */])(cx, cy, radius, labelAngle);
  var endPoint = Object(__WEBPACK_IMPORTED_MODULE_9__util_PolarUtils__["e" /* polarToCartesian */])(cx, cy, radius, labelAngle + (direction ? 1 : -1) * 359);
  var path = 'M' + startPoint.x + ',' + startPoint.y + '\n    A' + radius + ',' + radius + ',0,1,' + (direction ? 0 : 1) + ',\n    ' + endPoint.x + ',' + endPoint.y;
  var id = __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(labelProps.id) ? Object(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["j" /* uniqueId */])('recharts-radial-line-') : labelProps.id;

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    'text',
    _extends({}, attrs, {
      dominantBaseline: 'central',
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()('recharts-radial-bar-label', className)
    }),
    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'defs',
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('path', { id: id, d: path })
    ),
    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'textPath',
      { xlinkHref: '#' + id },
      label
    )
  );
};

var getAttrsOfPolarLabel = function getAttrsOfPolarLabel(props) {
  var viewBox = props.viewBox,
      offset = props.offset,
      position = props.position;
  var cx = viewBox.cx,
      cy = viewBox.cy,
      innerRadius = viewBox.innerRadius,
      outerRadius = viewBox.outerRadius,
      startAngle = viewBox.startAngle,
      endAngle = viewBox.endAngle;

  var midAngle = (startAngle + endAngle) / 2;

  if (position === 'outside') {
    var _polarToCartesian = Object(__WEBPACK_IMPORTED_MODULE_9__util_PolarUtils__["e" /* polarToCartesian */])(cx, cy, outerRadius + offset, midAngle),
        _x = _polarToCartesian.x,
        _y = _polarToCartesian.y;

    return {
      x: _x,
      y: _y,
      textAnchor: _x >= cx ? 'start' : 'end',
      verticalAnchor: 'middle'
    };
  }

  if (position === 'center') {
    return {
      x: cx,
      y: cy,
      textAnchor: 'middle',
      verticalAnchor: 'middle'
    };
  }

  var r = (innerRadius + outerRadius) / 2;

  var _polarToCartesian2 = Object(__WEBPACK_IMPORTED_MODULE_9__util_PolarUtils__["e" /* polarToCartesian */])(cx, cy, r, midAngle),
      x = _polarToCartesian2.x,
      y = _polarToCartesian2.y;

  return {
    x: x,
    y: y,
    textAnchor: 'middle',
    verticalAnchor: 'middle'
  };
};

var getAttrsOfCartesianLabel = function getAttrsOfCartesianLabel(props) {
  var viewBox = props.viewBox,
      offset = props.offset,
      position = props.position;
  var x = viewBox.x,
      y = viewBox.y,
      width = viewBox.width,
      height = viewBox.height;

  var sign = height >= 0 ? 1 : -1;

  if (position === 'top') {
    return {
      x: x + width / 2,
      y: y - sign * offset,
      textAnchor: 'middle',
      verticalAnchor: 'end'
    };
  }

  if (position === 'bottom') {
    return {
      x: x + width / 2,
      y: y + height + sign * offset,
      textAnchor: 'middle',
      verticalAnchor: 'start'
    };
  }

  if (position === 'left') {
    return {
      x: x - offset,
      y: y + height / 2,
      textAnchor: 'end',
      verticalAnchor: 'middle'
    };
  }

  if (position === 'right') {
    return {
      x: x + width + offset,
      y: y + height / 2,
      textAnchor: 'start',
      verticalAnchor: 'middle'
    };
  }

  if (position === 'insideLeft') {
    return {
      x: x + offset,
      y: y + height / 2,
      textAnchor: 'start',
      verticalAnchor: 'middle'
    };
  }

  if (position === 'insideRight') {
    return {
      x: x + width - offset,
      y: y + height / 2,
      textAnchor: 'end',
      verticalAnchor: 'middle'
    };
  }

  if (position === 'insideTop') {
    return {
      x: x + width / 2,
      y: y + sign * offset,
      textAnchor: 'middle',
      verticalAnchor: 'start'
    };
  }

  if (position === 'insideBottom') {
    return {
      x: x + width / 2,
      y: y + height - sign * offset,
      textAnchor: 'middle',
      verticalAnchor: 'end'
    };
  }

  if (position === 'insideTopLeft') {
    return {
      x: x + offset,
      y: y + sign * offset,
      textAnchor: 'start',
      verticalAnchor: 'start'
    };
  }

  if (position === 'insideTopRight') {
    return {
      x: x + width - offset,
      y: y + sign * offset,
      textAnchor: 'end',
      verticalAnchor: 'start'
    };
  }

  if (position === 'insideBottomLeft') {
    return {
      x: x + offset,
      y: y + height - sign * offset,
      textAnchor: 'start',
      verticalAnchor: 'end'
    };
  }

  if (position === 'insideBottomRight') {
    return {
      x: x + width - offset,
      y: y + height - sign * offset,
      textAnchor: 'end',
      verticalAnchor: 'end'
    };
  }

  if (__WEBPACK_IMPORTED_MODULE_0_lodash_isObject___default()(position) && (Object(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["g" /* isNumber */])(position.x) || Object(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["h" /* isPercent */])(position.x)) && (Object(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["g" /* isNumber */])(position.y) || Object(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["h" /* isPercent */])(position.y))) {
    return {
      x: x + Object(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["c" /* getPercentValue */])(position.x, width),
      y: y + Object(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["c" /* getPercentValue */])(position.y, height),
      textAnchor: 'end',
      verticalAnchor: 'end'
    };
  }

  return {
    x: x + width / 2,
    y: y + height / 2,
    textAnchor: 'middle',
    verticalAnchor: 'middle'
  };
};

var isPolar = function isPolar(viewBox) {
  return Object(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["g" /* isNumber */])(viewBox.cx);
};

function Label(props) {
  var viewBox = props.viewBox,
      position = props.position,
      value = props.value,
      children = props.children,
      content = props.content,
      _props$className = props.className,
      className = _props$className === undefined ? '' : _props$className;


  if (!viewBox || __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(value) && __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(children) && !Object(__WEBPACK_IMPORTED_MODULE_3_react__["isValidElement"])(content) && !__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(content)) {
    return null;
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_3_react__["isValidElement"])(content)) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_react__["cloneElement"])(content, props);
  }

  var label = void 0;
  if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(content)) {
    label = content(props);

    if (Object(__WEBPACK_IMPORTED_MODULE_3_react__["isValidElement"])(label)) {
      return label;
    }
  } else {
    label = getLabel(props);
  }

  var isPolarLabel = isPolar(viewBox);
  var attrs = Object(__WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["k" /* getPresentationAttributes */])(props);

  if (isPolarLabel && (position === 'insideStart' || position === 'insideEnd' || position === 'end')) {
    return renderRadialLabel(props, label, attrs);
  }

  var positionAttrs = isPolarLabel ? getAttrsOfPolarLabel(props) : getAttrsOfCartesianLabel(props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6__Text__["a" /* default */],
    _extends({
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()('recharts-label', className)
    }, attrs, positionAttrs),
    label
  );
}

Label.displayName = 'Label';
Label.defaultProps = defaultProps;
Label.propTypes = propTypes;

var parseViewBox = function parseViewBox(props) {
  var cx = props.cx,
      cy = props.cy,
      angle = props.angle,
      startAngle = props.startAngle,
      endAngle = props.endAngle,
      r = props.r,
      radius = props.radius,
      innerRadius = props.innerRadius,
      outerRadius = props.outerRadius,
      x = props.x,
      y = props.y,
      top = props.top,
      left = props.left,
      width = props.width,
      height = props.height,
      clockWise = props.clockWise;


  if (Object(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["g" /* isNumber */])(width) && Object(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["g" /* isNumber */])(height)) {
    if (Object(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["g" /* isNumber */])(x) && Object(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["g" /* isNumber */])(y)) {
      return { x: x, y: y, width: width, height: height };
    } else if (Object(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["g" /* isNumber */])(top) && Object(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["g" /* isNumber */])(left)) {
      return { x: top, y: left, width: width, height: height };
    }
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["g" /* isNumber */])(x) && Object(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["g" /* isNumber */])(y)) {
    return { x: x, y: y, width: 0, height: 0 };
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["g" /* isNumber */])(cx) && Object(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["g" /* isNumber */])(cy)) {
    return {
      cx: cx, cy: cy,
      startAngle: startAngle || angle || 0,
      endAngle: endAngle || angle || 0,
      innerRadius: innerRadius || 0,
      outerRadius: outerRadius || radius || r || 0,
      clockWise: clockWise
    };
  }

  if (props.viewBox) {
    return props.viewBox;
  }

  return {};
};

var parseLabel = function parseLabel(label, viewBox) {
  if (!label) {
    return null;
  }

  if (label === true) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Label, { key: 'label-implicit', viewBox: viewBox });
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["f" /* isNumOrStr */])(label)) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Label, { key: 'label-implicit', viewBox: viewBox, value: label });
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_3_react__["isValidElement"])(label) || __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(label)) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Label, { key: 'label-implicit', content: label, viewBox: viewBox });
  }

  if (__WEBPACK_IMPORTED_MODULE_0_lodash_isObject___default()(label)) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Label, _extends({ viewBox: viewBox }, label, { key: 'label-implicit' }));
  }

  return null;
};

var renderCallByParent = function renderCallByParent(parentProps, viewBox) {
  var ckeckPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (!parentProps || !parentProps.children && ckeckPropsLabel && !parentProps.label) {
    return null;
  }
  var children = parentProps.children;

  var parentViewBox = parseViewBox(parentProps);

  var explicitChilren = Object(__WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["h" /* findAllByType */])(children, Label).map(function (child, index) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_react__["cloneElement"])(child, {
      viewBox: viewBox || parentViewBox,
      key: 'label-' + index
    });
  });

  if (!ckeckPropsLabel) {
    return explicitChilren;
  }
  var implicitLabel = parseLabel(parentProps.label, viewBox || parentViewBox);

  return [implicitLabel].concat(_toConsumableArray(explicitChilren));
};

Label.parseViewBox = parseViewBox;
Label.renderCallByParent = renderCallByParent;

/* harmony default export */ __webpack_exports__["a"] = (Label);

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_color__ = __webpack_require__(115);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_color__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__src_color__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__src_color__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_lab__ = __webpack_require__(479);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__src_lab__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__src_lab__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_cubehelix__ = __webpack_require__(480);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__src_cubehelix__["a"]; });





/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isObject__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNil__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_last__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_last__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isArray__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Label__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__container_Layer__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_ChartUtils__ = __webpack_require__(11);






var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









var propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  data: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object),
  valueAccessor: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  clockWise: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  dataKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func])
};

var defaultProps = {
  valueAccessor: function valueAccessor(entry) {
    return __WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default()(entry.value) ? __WEBPACK_IMPORTED_MODULE_3_lodash_last___default()(entry.value) : entry.value;
  }
};

function LabelList(props) {
  var data = props.data,
      valueAccessor = props.valueAccessor,
      dataKey = props.dataKey,
      clockWise = props.clockWise,
      id = props.id,
      others = _objectWithoutProperties(props, ['data', 'valueAccessor', 'dataKey', 'clockWise', 'id']);

  if (!data || !data.length) {
    return null;
  }

  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */],
    { className: 'recharts-label-list' },
    data.map(function (entry, index) {
      var value = __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(dataKey) ? valueAccessor(entry, index) : Object(__WEBPACK_IMPORTED_MODULE_10__util_ChartUtils__["w" /* getValueByDataKey */])(entry && entry.payload, dataKey);
      var idProps = __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(id) ? {} : {
        id: id + '-' + index
      };

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Label__["a" /* default */], _extends({}, Object(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["k" /* getPresentationAttributes */])(entry), others, idProps, {
        index: index,
        value: value,
        viewBox: __WEBPACK_IMPORTED_MODULE_7__Label__["a" /* default */].parseViewBox(__WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(clockWise) ? entry : _extends({}, entry, { clockWise: clockWise })),
        key: 'label-' + index
      }));
    })
  );
}

LabelList.propTypes = propTypes;
LabelList.displayName = 'LabelList';

var parseLabelList = function parseLabelList(label, data) {
  if (!label) {
    return null;
  }

  if (label === true) {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(LabelList, { key: 'labelList-implicit', data: data });
  }

  if (__WEBPACK_IMPORTED_MODULE_5_react___default.a.isValidElement(label) || __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(label)) {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(LabelList, { key: 'labelList-implicit', data: data, content: label });
  }

  if (__WEBPACK_IMPORTED_MODULE_0_lodash_isObject___default()(label)) {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(LabelList, _extends({ data: data }, label, { key: 'labelList-implicit' }));
  }

  return null;
};

var renderCallByParent = function renderCallByParent(parentProps, data) {
  var ckeckPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (!parentProps || !parentProps.children && ckeckPropsLabel && !parentProps.label) {
    return null;
  }
  var children = parentProps.children;


  var explicitChilren = Object(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["h" /* findAllByType */])(children, LabelList).map(function (child, index) {
    return Object(__WEBPACK_IMPORTED_MODULE_5_react__["cloneElement"])(child, {
      data: data,
      key: 'labelList-' + index
    });
  });
  if (!ckeckPropsLabel) {
    return explicitChilren;
  }

  var implicitLabelList = parseLabelList(parentProps.label, data);

  return [implicitLabelList].concat(_toConsumableArray(explicitChilren));
};

LabelList.renderCallByParent = renderCallByParent;
LabelList.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (LabelList);

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_sortBy__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_range__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_throttle__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_throttle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isNil__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__container_Surface__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__container_Layer__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__component_Tooltip__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__component_Legend__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shape_Curve__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shape_Cross__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__shape_Sector__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__shape_Dot__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__shape_Rectangle__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__util_ReactUtils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__cartesian_CartesianAxis__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__cartesian_Brush__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__util_DOMUtils__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__util_DataUtils__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__util_ChartUtils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__util_PolarUtils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__util_PureRender__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__util_Events__ = __webpack_require__(539);







var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


























var ORIENT_MAP = {
  xAxis: ['bottom', 'top'],
  yAxis: ['left', 'right']
};

var originCoordinate = { x: 0, y: 0 };

var generateCategoricalChart = function generateCategoricalChart(_ref) {
  var _class, _temp, _initialiseProps;

  var chartName = _ref.chartName,
      GraphicalChild = _ref.GraphicalChild,
      _ref$eventType = _ref.eventType,
      eventType = _ref$eventType === undefined ? 'axis' : _ref$eventType,
      axisComponents = _ref.axisComponents,
      legendContent = _ref.legendContent,
      formatAxisMap = _ref.formatAxisMap,
      defaultProps = _ref.defaultProps,
      propTypes = _ref.propTypes;
  var CategoricalChartWrapper = (_temp = _class = function (_Component) {
    _inherits(CategoricalChartWrapper, _Component);

    function CategoricalChartWrapper(props) {
      _classCallCheck(this, CategoricalChartWrapper);

      var _this = _possibleConstructorReturn(this, (CategoricalChartWrapper.__proto__ || Object.getPrototypeOf(CategoricalChartWrapper)).call(this, props));

      _initialiseProps.call(_this);

      var defaultState = _this.constructor.createDefaultState(props);
      var updateId = 0;
      _this.state = _extends({}, defaultState, { updateId: 0
      }, _this.updateStateOfAxisMapsOffsetAndStackGroups(_extends({ props: props }, defaultState, { updateId: updateId })));

      _this.uniqueChartId = __WEBPACK_IMPORTED_MODULE_5_lodash_isNil___default()(props.id) ? Object(__WEBPACK_IMPORTED_MODULE_22__util_DataUtils__["j" /* uniqueId */])('recharts') : props.id;

      if (props.throttleDelay) {
        _this.triggeredAfterMouseMove = __WEBPACK_IMPORTED_MODULE_4_lodash_throttle___default()(_this.triggeredAfterMouseMove, props.throttleDelay);
      }
      return _this;
    }

    /* eslint-disable  react/no-did-mount-set-state */


    /**
     * Returns default, reset state for the categorical chart.
     * @param {Object} props Props object to use when creating the default state
     * @return {Object} Whole new state
     */


    _createClass(CategoricalChartWrapper, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (!__WEBPACK_IMPORTED_MODULE_5_lodash_isNil___default()(this.props.syncId)) {
          this.addListener();
        }
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var _props = this.props,
            data = _props.data,
            children = _props.children,
            width = _props.width,
            height = _props.height,
            layout = _props.layout,
            stackOffset = _props.stackOffset,
            margin = _props.margin;
        var updateId = this.state.updateId;


        if (nextProps.data !== data || nextProps.width !== width || nextProps.height !== height || nextProps.layout !== layout || nextProps.stackOffset !== stackOffset || !Object(__WEBPACK_IMPORTED_MODULE_25__util_PureRender__["b" /* shallowEqual */])(nextProps.margin, margin)) {
          var defaultState = this.constructor.createDefaultState(nextProps);
          this.setState(_extends({}, defaultState, { updateId: updateId + 1
          }, this.updateStateOfAxisMapsOffsetAndStackGroups(_extends({ props: nextProps }, defaultState, { updateId: updateId + 1 }))));
        } else if (!Object(__WEBPACK_IMPORTED_MODULE_18__util_ReactUtils__["m" /* isChildrenEqual */])(nextProps.children, children)) {
          var hasGlobalData = !__WEBPACK_IMPORTED_MODULE_5_lodash_isNil___default()(nextProps.data);
          var newUpdateId = hasGlobalData ? updateId : updateId + 1;
          var _state = this.state,
              dataStartIndex = _state.dataStartIndex,
              dataEndIndex = _state.dataEndIndex;
          // Don't update brush

          var _defaultState = _extends({}, this.constructor.createDefaultState(nextProps), { dataEndIndex: dataEndIndex, dataStartIndex: dataStartIndex
          });
          this.setState(_extends({}, _defaultState, {
            updateId: newUpdateId
          }, this.updateStateOfAxisMapsOffsetAndStackGroups(_extends({
            props: nextProps
          }, _defaultState, {
            updateId: newUpdateId
          }))));
        }
        // add syncId
        if (__WEBPACK_IMPORTED_MODULE_5_lodash_isNil___default()(this.props.syncId) && !__WEBPACK_IMPORTED_MODULE_5_lodash_isNil___default()(nextProps.syncId)) {
          this.addListener();
        }
        // remove syncId
        if (!__WEBPACK_IMPORTED_MODULE_5_lodash_isNil___default()(this.props.syncId) && __WEBPACK_IMPORTED_MODULE_5_lodash_isNil___default()(nextProps.syncId)) {
          this.removeListener();
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (!__WEBPACK_IMPORTED_MODULE_5_lodash_isNil___default()(this.props.syncId)) {
          this.removeListener();
        }
        if (typeof this.triggeredAfterMouseMove.cancel === 'function') {
          this.triggeredAfterMouseMove.cancel();
        }
      }
      /**
      * Get the configuration of all x-axis or y-axis
      * @param  {Object} props          Latest props
      * @param  {String} axisType       The type of axis
      * @param  {Array}  graphicalItems The instances of item
      * @param  {Object} stackGroups    The items grouped by axisId and stackId
      * @param {Number} dataStartIndex  The start index of the data series when a brush is applied
      * @param {Number} dataEndIndex    The end index of the data series when a brush is applied
      * @return {Object}          Configuration
      */

    }, {
      key: 'getAxisMap',
      value: function getAxisMap(props, _ref2) {
        var _ref2$axisType = _ref2.axisType,
            axisType = _ref2$axisType === undefined ? 'xAxis' : _ref2$axisType,
            AxisComp = _ref2.AxisComp,
            graphicalItems = _ref2.graphicalItems,
            stackGroups = _ref2.stackGroups,
            dataStartIndex = _ref2.dataStartIndex,
            dataEndIndex = _ref2.dataEndIndex;
        var children = props.children;

        var axisIdKey = axisType + 'Id';
        // Get all the instance of Axis
        var axes = Object(__WEBPACK_IMPORTED_MODULE_18__util_ReactUtils__["h" /* findAllByType */])(children, AxisComp);

        var axisMap = {};

        if (axes && axes.length) {
          axisMap = this.getAxisMapByAxes(props, { axes: axes, graphicalItems: graphicalItems, axisType: axisType, axisIdKey: axisIdKey,
            stackGroups: stackGroups, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex });
        } else if (graphicalItems && graphicalItems.length) {
          axisMap = this.getAxisMapByItems(props, {
            Axis: AxisComp,
            graphicalItems: graphicalItems, axisType: axisType, axisIdKey: axisIdKey, stackGroups: stackGroups, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex });
        }

        return axisMap;
      }
      /**
       * Get the configuration of axis by the options of axis instance
       * @param  {Object} props         Latest props
       * @param {Array}  axes           The instance of axes
       * @param  {Array} graphicalItems The instances of item
       * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
       * @param  {String} axisIdKey     The unique id of an axis
       * @param  {Object} stackGroups   The items grouped by axisId and stackId
       * @param {Number} dataStartIndex The start index of the data series when a brush is applied
       * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
       * @return {Object}      Configuration
       */

    }, {
      key: 'getAxisMapByAxes',
      value: function getAxisMapByAxes(props, _ref3) {
        var _this2 = this;

        var axes = _ref3.axes,
            graphicalItems = _ref3.graphicalItems,
            axisType = _ref3.axisType,
            axisIdKey = _ref3.axisIdKey,
            stackGroups = _ref3.stackGroups,
            dataStartIndex = _ref3.dataStartIndex,
            dataEndIndex = _ref3.dataEndIndex;
        var layout = props.layout,
            children = props.children,
            stackOffset = props.stackOffset;

        var isCategorial = Object(__WEBPACK_IMPORTED_MODULE_23__util_ChartUtils__["x" /* isCategorialAxis */])(layout, axisType);

        // Eliminate duplicated axes
        var axisMap = axes.reduce(function (result, child) {
          var _child$props = child.props,
              type = _child$props.type,
              dataKey = _child$props.dataKey,
              allowDataOverflow = _child$props.allowDataOverflow,
              allowDuplicatedCategory = _child$props.allowDuplicatedCategory,
              scale = _child$props.scale,
              ticks = _child$props.ticks;

          var axisId = child.props[axisIdKey];
          var displayedData = _this2.constructor.getDisplayedData(props, {
            graphicalItems: graphicalItems.filter(function (item) {
              return item.props[axisIdKey] === axisId;
            }),
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex
          });
          var len = displayedData.length;

          if (!result[axisId]) {
            var domain = void 0,
                duplicateDomain = void 0,
                categoricalDomain = void 0;

            if (dataKey) {
              domain = Object(__WEBPACK_IMPORTED_MODULE_23__util_ChartUtils__["n" /* getDomainOfDataByKey */])(displayedData, dataKey, type);

              if (type === 'category' && isCategorial) {
                var duplicate = Object(__WEBPACK_IMPORTED_MODULE_22__util_DataUtils__["d" /* hasDuplicate */])(domain);

                if (allowDuplicatedCategory && duplicate) {
                  duplicateDomain = domain;
                  // When category axis has duplicated text, serial numbers are used to generate scale
                  domain = __WEBPACK_IMPORTED_MODULE_3_lodash_range___default()(0, len);
                } else if (!allowDuplicatedCategory) {
                  // remove duplicated category
                  domain = Object(__WEBPACK_IMPORTED_MODULE_23__util_ChartUtils__["y" /* parseDomainOfCategoryAxis */])(child.props.domain, domain, child).reduce(function (finalDomain, entry) {
                    return finalDomain.indexOf(entry) >= 0 ? finalDomain : [].concat(_toConsumableArray(finalDomain), [entry]);
                  }, []);
                }
              } else if (type === 'category') {
                if (!allowDuplicatedCategory) {
                  domain = Object(__WEBPACK_IMPORTED_MODULE_23__util_ChartUtils__["y" /* parseDomainOfCategoryAxis */])(child.props.domain, domain, child).reduce(function (finalDomain, entry) {
                    return finalDomain.indexOf(entry) >= 0 || entry === '' || __WEBPACK_IMPORTED_MODULE_5_lodash_isNil___default()(entry) ? finalDomain : [].concat(_toConsumableArray(finalDomain), [entry]);
                  }, []);
                } else {
                  // eliminate undefined or null or empty string
                  domain = domain.filter(function (entry) {
                    return entry !== '' && !__WEBPACK_IMPORTED_MODULE_5_lodash_isNil___default()(entry);
                  });
                }
              } else if (type === 'number') {
                var errorBarsDomain = Object(__WEBPACK_IMPORTED_MODULE_23__util_ChartUtils__["z" /* parseErrorBarsOfAxis */])(displayedData, graphicalItems.filter(function (item) {
                  return item.props[axisIdKey] === axisId && !item.props.hide;
                }), dataKey, axisType);

                if (errorBarsDomain) {
                  domain = errorBarsDomain;
                }
              }

              if (isCategorial && (type === 'number' || scale !== 'auto')) {
                categoricalDomain = Object(__WEBPACK_IMPORTED_MODULE_23__util_ChartUtils__["n" /* getDomainOfDataByKey */])(displayedData, dataKey, 'category');
              }
            } else if (isCategorial) {
              domain = __WEBPACK_IMPORTED_MODULE_3_lodash_range___default()(0, len);
            } else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack && type === 'number') {
              // when stackOffset is 'expand', the domain may be calculated as [0, 1.000000000002]
              domain = stackOffset === 'expand' ? [0, 1] : Object(__WEBPACK_IMPORTED_MODULE_23__util_ChartUtils__["p" /* getDomainOfStackGroups */])(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
            } else {
              domain = Object(__WEBPACK_IMPORTED_MODULE_23__util_ChartUtils__["o" /* getDomainOfItemsWithSameAxis */])(displayedData, graphicalItems.filter(function (item) {
                return item.props[axisIdKey] === axisId && !item.props.hide;
              }), type, true);
            }
            if (type === 'number') {
              // To detect wether there is any reference lines whose props alwaysShow is true
              domain = Object(__WEBPACK_IMPORTED_MODULE_23__util_ChartUtils__["e" /* detectReferenceElementsDomain */])(children, domain, axisId, axisType, ticks);

              if (child.props.domain) {
                domain = Object(__WEBPACK_IMPORTED_MODULE_23__util_ChartUtils__["B" /* parseSpecifiedDomain */])(child.props.domain, domain, allowDataOverflow);
              }
            }

            return _extends({}, result, _defineProperty({}, axisId, _extends({}, child.props, {
              axisType: axisType,
              domain: domain,
              categoricalDomain: categoricalDomain,
              duplicateDomain: duplicateDomain,
              originalDomain: child.props.domain,
              isCategorial: isCategorial,
              layout: layout
            })));
          }

          return result;
        }, {});
        return axisMap;
      }
      /**
       * Get the configuration of axis by the options of item,
       * this kind of axis does not display in chart
       * @param  {Object} props         Latest props
       * @param  {Array} graphicalItems The instances of item
       * @param  {ReactElement} Axis    Axis Component
       * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
       * @param  {String} axisIdKey     The unique id of an axis
       * @param  {Object} stackGroups   The items grouped by axisId and stackId
       * @param {Number} dataStartIndex The start index of the data series when a brush is applied
       * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
       * @return {Object}               Configuration
       */

    }, {
      key: 'getAxisMapByItems',
      value: function getAxisMapByItems(props, _ref4) {
        var graphicalItems = _ref4.graphicalItems,
            Axis = _ref4.Axis,
            axisType = _ref4.axisType,
            axisIdKey = _ref4.axisIdKey,
            stackGroups = _ref4.stackGroups,
            dataStartIndex = _ref4.dataStartIndex,
            dataEndIndex = _ref4.dataEndIndex;
        var layout = props.layout,
            children = props.children;

        var displayedData = this.constructor.getDisplayedData(props, {
          graphicalItems: graphicalItems, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex
        });
        var len = displayedData.length;
        var isCategorial = Object(__WEBPACK_IMPORTED_MODULE_23__util_ChartUtils__["x" /* isCategorialAxis */])(layout, axisType);
        var index = -1;

        // The default type of x-axis is category axis,
        // The default contents of x-axis is the serial numbers of data
        // The default type of y-axis is number axis
        // The default contents of y-axis is the domain of data
        var axisMap = graphicalItems.reduce(function (result, child) {
          var axisId = child.props[axisIdKey];

          if (!result[axisId]) {
            index++;
            var domain = void 0;

            if (isCategorial) {
              domain = __WEBPACK_IMPORTED_MODULE_3_lodash_range___default()(0, len);
            } else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack) {
              domain = Object(__WEBPACK_IMPORTED_MODULE_23__util_ChartUtils__["p" /* getDomainOfStackGroups */])(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
              domain = Object(__WEBPACK_IMPORTED_MODULE_23__util_ChartUtils__["e" /* detectReferenceElementsDomain */])(children, domain, axisId, axisType);
            } else {
              domain = Object(__WEBPACK_IMPORTED_MODULE_23__util_ChartUtils__["B" /* parseSpecifiedDomain */])(Axis.defaultProps.domain, Object(__WEBPACK_IMPORTED_MODULE_23__util_ChartUtils__["o" /* getDomainOfItemsWithSameAxis */])(displayedData, graphicalItems.filter(function (item) {
                return item.props[axisIdKey] === axisId && !item.props.hide;
              }), 'number'), Axis.defaultProps.allowDataOverflow);
              domain = Object(__WEBPACK_IMPORTED_MODULE_23__util_ChartUtils__["e" /* detectReferenceElementsDomain */])(children, domain, axisId, axisType);
            }

            return _extends({}, result, _defineProperty({}, axisId, _extends({
              axisType: axisType
            }, Axis.defaultProps, {
              hide: true,
              orientation: ORIENT_MAP[axisType] && ORIENT_MAP[axisType][index % 2],
              domain: domain,
              originalDomain: Axis.defaultProps.domain,
              isCategorial: isCategorial,
              layout: layout
              // specify scale when no Axis
              // scale: isCategorial ? 'band' : 'linear',
            })));
          }

          return result;
        }, {});

        return axisMap;
      }
    }, {
      key: 'getActiveCoordinate',
      value: function getActiveCoordinate(tooltipTicks, activeIndex, rangeObj) {
        var layout = this.props.layout;

        var entry = __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(tooltipTicks.filter(function (tick) {
          return tick && tick.index === activeIndex;
        }), '[0]');

        if (entry) {
          if (layout === 'horizontal') {
            return { x: entry.coordinate, y: rangeObj.y };
          } else if (layout === 'vertical') {
            return { x: rangeObj.x, y: entry.coordinate };
          } else if (layout === 'centric') {
            var _angle = entry.coordinate;
            var _radius = rangeObj.radius;

            return _extends({}, rangeObj, Object(__WEBPACK_IMPORTED_MODULE_24__util_PolarUtils__["e" /* polarToCartesian */])(rangeObj.cx, rangeObj.cy, _radius, _angle), {
              angle: _angle, radius: _radius
            });
          }

          var radius = entry.coordinate;
          var angle = rangeObj.angle;

          return _extends({}, rangeObj, Object(__WEBPACK_IMPORTED_MODULE_24__util_PolarUtils__["e" /* polarToCartesian */])(rangeObj.cx, rangeObj.cy, radius, angle), {
            angle: angle, radius: radius
          });
        }

        return originCoordinate;
      }
      /**
       * Get the information of mouse in chart, return null when the mouse is not in the chart
       * @param  {Object} event    The event object
       * @return {Object}          Mouse data
       */

    }, {
      key: 'getMouseInfo',
      value: function getMouseInfo(event) {
        if (!this.container) {
          return null;
        }

        var containerOffset = Object(__WEBPACK_IMPORTED_MODULE_21__util_DOMUtils__["b" /* getOffset */])(this.container);
        var e = Object(__WEBPACK_IMPORTED_MODULE_21__util_DOMUtils__["a" /* calculateChartCoordinate */])(event, containerOffset);
        var rangeObj = this.inRange(e.chartX, e.chartY);
        if (!rangeObj) {
          return null;
        }

        var _state2 = this.state,
            xAxisMap = _state2.xAxisMap,
            yAxisMap = _state2.yAxisMap;


        if (eventType !== 'axis' && xAxisMap && yAxisMap) {
          var xScale = Object(__WEBPACK_IMPORTED_MODULE_22__util_DataUtils__["b" /* getAnyElementOfObject */])(xAxisMap).scale;
          var yScale = Object(__WEBPACK_IMPORTED_MODULE_22__util_DataUtils__["b" /* getAnyElementOfObject */])(yAxisMap).scale;
          var xValue = xScale && xScale.invert ? xScale.invert(e.chartX) : null;
          var yValue = yScale && yScale.invert ? yScale.invert(e.chartY) : null;

          return _extends({}, e, { xValue: xValue, yValue: yValue });
        }

        var _state3 = this.state,
            ticks = _state3.orderedTooltipTicks,
            axis = _state3.tooltipAxis,
            tooltipTicks = _state3.tooltipTicks;

        var pos = this.calculateTooltipPos(rangeObj);
        var activeIndex = Object(__WEBPACK_IMPORTED_MODULE_23__util_ChartUtils__["b" /* calculateActiveTickIndex */])(pos, ticks, tooltipTicks, axis);

        if (activeIndex >= 0 && tooltipTicks) {
          var activeLabel = tooltipTicks[activeIndex] && tooltipTicks[activeIndex].value;
          var activePayload = this.getTooltipContent(activeIndex, activeLabel);
          var activeCoordinate = this.getActiveCoordinate(ticks, activeIndex, rangeObj);

          return _extends({}, e, {
            activeTooltipIndex: activeIndex,
            activeLabel: activeLabel, activePayload: activePayload, activeCoordinate: activeCoordinate
          });
        }

        return null;
      }
      /**
       * Get the content to be displayed in the tooltip
       * @param  {Number} activeIndex    Active index of data
       * @param  {String} activeLabel    Active label of data
       * @return {Array}                 The content of tooltip
       */

    }, {
      key: 'getTooltipContent',
      value: function getTooltipContent(activeIndex, activeLabel) {
        var _state4 = this.state,
            graphicalItems = _state4.graphicalItems,
            tooltipAxis = _state4.tooltipAxis;

        var displayedData = this.constructor.getDisplayedData(this.props, this.state);

        if (activeIndex < 0 || !graphicalItems || !graphicalItems.length || activeIndex >= displayedData.length) {
          return null;
        }

        // get data by activeIndex when the axis don't allow duplicated category
        return graphicalItems.reduce(function (result, child) {
          var hide = child.props.hide;


          if (hide) {
            return result;
          }

          var _child$props2 = child.props,
              dataKey = _child$props2.dataKey,
              name = _child$props2.name,
              unit = _child$props2.unit,
              formatter = _child$props2.formatter,
              data = _child$props2.data;

          var payload = void 0;

          if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
            // graphic child has data props
            payload = Object(__WEBPACK_IMPORTED_MODULE_22__util_DataUtils__["a" /* findEntryInArray */])(data || displayedData, tooltipAxis.dataKey, activeLabel);
          } else {
            payload = displayedData[activeIndex];
          }

          if (!payload) {
            return result;
          }
          return [].concat(_toConsumableArray(result), [_extends({}, Object(__WEBPACK_IMPORTED_MODULE_18__util_ReactUtils__["k" /* getPresentationAttributes */])(child), {
            dataKey: dataKey, unit: unit, formatter: formatter,
            name: name || dataKey,
            color: Object(__WEBPACK_IMPORTED_MODULE_23__util_ChartUtils__["r" /* getMainColorOfGraphicItem */])(child),
            value: Object(__WEBPACK_IMPORTED_MODULE_23__util_ChartUtils__["w" /* getValueByDataKey */])(payload, dataKey),
            payload: payload
          })]);
        }, []);
      }
    }, {
      key: 'getFormatItems',
      value: function getFormatItems(props, currentState) {
        var _this3 = this;

        var graphicalItems = currentState.graphicalItems,
            stackGroups = currentState.stackGroups,
            offset = currentState.offset,
            updateId = currentState.updateId,
            dataStartIndex = currentState.dataStartIndex,
            dataEndIndex = currentState.dataEndIndex;
        var barSize = props.barSize,
            layout = props.layout,
            barGap = props.barGap,
            barCategoryGap = props.barCategoryGap,
            globalMaxBarSize = props.maxBarSize;

        var _getAxisNameByLayout = this.getAxisNameByLayout(layout),
            numericAxisName = _getAxisNameByLayout.numericAxisName,
            cateAxisName = _getAxisNameByLayout.cateAxisName;

        var hasBar = this.constructor.hasBar(graphicalItems);
        var sizeList = hasBar && Object(__WEBPACK_IMPORTED_MODULE_23__util_ChartUtils__["i" /* getBarSizeList */])({ barSize: barSize, stackGroups: stackGroups });
        var formatedItems = [];

        graphicalItems.forEach(function (item, index) {
          var displayedData = _this3.constructor.getDisplayedData(props, { dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex }, item);
          var _item$props = item.props,
              dataKey = _item$props.dataKey,
              childMaxBarSize = _item$props.maxBarSize;

          var numericAxisId = item.props[numericAxisName + 'Id'];
          var cateAxisId = item.props[cateAxisName + 'Id'];
          var axisObj = axisComponents.reduce(function (result, entry) {
            var _extends4;

            var axisMap = currentState[entry.axisType + 'Map'];
            var id = item.props[entry.axisType + 'Id'];
            var axis = axisMap && axisMap[id];

            return _extends({}, result, (_extends4 = {}, _defineProperty(_extends4, entry.axisType, axis), _defineProperty(_extends4, entry.axisType + 'Ticks', Object(__WEBPACK_IMPORTED_MODULE_23__util_ChartUtils__["u" /* getTicksOfAxis */])(axis)), _extends4));
          }, {});
          var cateAxis = axisObj[cateAxisName];
          var cateTicks = axisObj[cateAxisName + 'Ticks'];
          var stackedData = stackGroups && stackGroups[numericAxisId] && stackGroups[numericAxisId].hasStack && Object(__WEBPACK_IMPORTED_MODULE_23__util_ChartUtils__["t" /* getStackedDataOfItem */])(item, stackGroups[numericAxisId].stackGroups);
          var bandSize = Object(__WEBPACK_IMPORTED_MODULE_23__util_ChartUtils__["g" /* getBandSizeOfAxis */])(cateAxis, cateTicks);
          var maxBarSize = __WEBPACK_IMPORTED_MODULE_5_lodash_isNil___default()(childMaxBarSize) ? globalMaxBarSize : childMaxBarSize;
          var barPosition = hasBar && Object(__WEBPACK_IMPORTED_MODULE_23__util_ChartUtils__["h" /* getBarPosition */])({
            barGap: barGap, barCategoryGap: barCategoryGap, bandSize: bandSize, sizeList: sizeList[cateAxisId], maxBarSize: maxBarSize
          });
          var componsedFn = item && item.type && item.type.getComposedData;

          if (componsedFn) {
            var _extends5;

            formatedItems.push({
              props: _extends({}, componsedFn(_extends({}, axisObj, { displayedData: displayedData, props: props, dataKey: dataKey, item: item, bandSize: bandSize,
                barPosition: barPosition, offset: offset, stackedData: stackedData, layout: layout, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex,
                onItemMouseLeave: Object(__WEBPACK_IMPORTED_MODULE_23__util_ChartUtils__["d" /* combineEventHandlers */])(_this3.handleItemMouseLeave, null, item.props.onMouseLeave),
                onItemMouseEnter: Object(__WEBPACK_IMPORTED_MODULE_23__util_ChartUtils__["d" /* combineEventHandlers */])(_this3.handleItemMouseEnter, null, item.props.onMouseEnter)
              })), (_extends5 = {
                key: item.key || 'item-' + index
              }, _defineProperty(_extends5, numericAxisName, axisObj[numericAxisName]), _defineProperty(_extends5, cateAxisName, axisObj[cateAxisName]), _defineProperty(_extends5, 'animationId', updateId), _extends5)),
              childIndex: Object(__WEBPACK_IMPORTED_MODULE_18__util_ReactUtils__["o" /* parseChildIndex */])(item, props.children),
              item: item
            });
          }
        });

        return formatedItems;
      }
    }, {
      key: 'getCursorRectangle',
      value: function getCursorRectangle() {
        var layout = this.props.layout;
        var _state5 = this.state,
            activeCoordinate = _state5.activeCoordinate,
            offset = _state5.offset,
            tooltipAxisBandSize = _state5.tooltipAxisBandSize;

        var halfSize = tooltipAxisBandSize / 2;

        return {
          stroke: 'none',
          fill: '#ccc',
          x: layout === 'horizontal' ? activeCoordinate.x - halfSize : offset.left + 0.5,
          y: layout === 'horizontal' ? offset.top + 0.5 : activeCoordinate.y - halfSize,
          width: layout === 'horizontal' ? tooltipAxisBandSize : offset.width - 1,
          height: layout === 'horizontal' ? offset.height - 1 : tooltipAxisBandSize
        };
      }
    }, {
      key: 'getCursorPoints',
      value: function getCursorPoints() {
        var layout = this.props.layout;
        var _state6 = this.state,
            activeCoordinate = _state6.activeCoordinate,
            offset = _state6.offset;

        var x1 = void 0,
            y1 = void 0,
            x2 = void 0,
            y2 = void 0;

        if (layout === 'horizontal') {
          x1 = activeCoordinate.x;
          x2 = x1;
          y1 = offset.top;
          y2 = offset.top + offset.height;
        } else if (layout === 'vertical') {
          y1 = activeCoordinate.y;
          y2 = y1;
          x1 = offset.left;
          x2 = offset.left + offset.width;
        } else if (!__WEBPACK_IMPORTED_MODULE_5_lodash_isNil___default()(activeCoordinate.cx) || !__WEBPACK_IMPORTED_MODULE_5_lodash_isNil___default()(activeCoordinate.cy)) {
          if (layout === 'centric') {
            var cx = activeCoordinate.cx,
                cy = activeCoordinate.cy,
                innerRadius = activeCoordinate.innerRadius,
                outerRadius = activeCoordinate.outerRadius,
                angle = activeCoordinate.angle;

            var innerPoint = Object(__WEBPACK_IMPORTED_MODULE_24__util_PolarUtils__["e" /* polarToCartesian */])(cx, cy, innerRadius, angle);
            var outerPoint = Object(__WEBPACK_IMPORTED_MODULE_24__util_PolarUtils__["e" /* polarToCartesian */])(cx, cy, outerRadius, angle);
            x1 = innerPoint.x;
            y1 = innerPoint.y;
            x2 = outerPoint.x;
            y2 = outerPoint.y;
          } else {
            var _cx = activeCoordinate.cx,
                _cy = activeCoordinate.cy,
                radius = activeCoordinate.radius,
                startAngle = activeCoordinate.startAngle,
                endAngle = activeCoordinate.endAngle;

            var startPoint = Object(__WEBPACK_IMPORTED_MODULE_24__util_PolarUtils__["e" /* polarToCartesian */])(_cx, _cy, radius, startAngle);
            var endPoint = Object(__WEBPACK_IMPORTED_MODULE_24__util_PolarUtils__["e" /* polarToCartesian */])(_cx, _cy, radius, endAngle);

            return {
              points: [startPoint, endPoint],
              cx: _cx, cy: _cy, radius: radius, startAngle: startAngle, endAngle: endAngle
            };
          }
        }

        return [{ x: x1, y: y1 }, { x: x2, y: y2 }];
      }
    }, {
      key: 'getAxisNameByLayout',
      value: function getAxisNameByLayout(layout) {
        if (layout === 'horizontal') {
          return { numericAxisName: 'yAxis', cateAxisName: 'xAxis' };
        } else if (layout === 'vertical') {
          return { numericAxisName: 'xAxis', cateAxisName: 'yAxis' };
        } else if (layout === 'centric') {
          return { numericAxisName: 'radiusAxis', cateAxisName: 'angleAxis' };
        }

        return { numericAxisName: 'angleAxis', cateAxisName: 'radiusAxis' };
      }
    }, {
      key: 'calculateTooltipPos',
      value: function calculateTooltipPos(rangeObj) {
        var layout = this.props.layout;


        if (layout === 'horizontal') {
          return rangeObj.x;
        }
        if (layout === 'vertical') {
          return rangeObj.y;
        }
        if (layout === 'centric') {
          return rangeObj.angle;
        }

        return rangeObj.radius;
      }
    }, {
      key: 'inRange',
      value: function inRange(x, y) {
        var layout = this.props.layout;


        if (layout === 'horizontal' || layout === 'vertical') {
          var offset = this.state.offset;

          var isInRange = x >= offset.left && x <= offset.left + offset.width && y >= offset.top && y <= offset.top + offset.height;

          return isInRange ? { x: x, y: y } : null;
        }

        var _state7 = this.state,
            angleAxisMap = _state7.angleAxisMap,
            radiusAxisMap = _state7.radiusAxisMap;


        if (angleAxisMap && radiusAxisMap) {
          var angleAxis = Object(__WEBPACK_IMPORTED_MODULE_22__util_DataUtils__["b" /* getAnyElementOfObject */])(angleAxisMap);

          return Object(__WEBPACK_IMPORTED_MODULE_24__util_PolarUtils__["d" /* inRangeOfSector */])({ x: x, y: y }, angleAxis);
        }

        return null;
      }
    }, {
      key: 'parseEventsOfWrapper',
      value: function parseEventsOfWrapper() {
        var children = this.props.children;

        var tooltipItem = Object(__WEBPACK_IMPORTED_MODULE_18__util_ReactUtils__["i" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_11__component_Tooltip__["a" /* default */]);
        var tooltipEvents = tooltipItem && eventType === 'axis' ? {
          onMouseEnter: this.handleMouseEnter,
          onMouseMove: this.handleMouseMove,
          onMouseLeave: this.handleMouseLeave,
          onTouchMove: this.handleTouchMove
        } : {};
        var outerEvents = Object(__WEBPACK_IMPORTED_MODULE_18__util_ReactUtils__["e" /* filterEventAttributes */])(this.props, this.handleOuterEvent);

        return _extends({}, outerEvents, tooltipEvents);
      }
      /**
       * The AxisMaps are expensive to render on large data sets
       * so provide the ability to store them in state and only update them when necessary
       * they are dependent upon the start and end index of
       * the brush so it's important that this method is called _after_
       * the state is updated with any new start/end indices
       *
       * @param {Object} props          The props object to be used for updating the axismaps
       * @param {Number} dataStartIndex The start index of the data series when a brush is applied
       * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
       * @param {Number} updateId       The update id
       * @return {Object} state New state to set
       */

    }, {
      key: 'updateStateOfAxisMapsOffsetAndStackGroups',
      value: function updateStateOfAxisMapsOffsetAndStackGroups(_ref5) {
        var _this4 = this;

        var props = _ref5.props,
            dataStartIndex = _ref5.dataStartIndex,
            dataEndIndex = _ref5.dataEndIndex,
            updateId = _ref5.updateId;

        if (!Object(__WEBPACK_IMPORTED_MODULE_18__util_ReactUtils__["q" /* validateWidthHeight */])({ props: props })) {
          return null;
        }

        var children = props.children,
            layout = props.layout,
            stackOffset = props.stackOffset,
            data = props.data,
            reverseStackOrder = props.reverseStackOrder;

        var _getAxisNameByLayout2 = this.getAxisNameByLayout(layout),
            numericAxisName = _getAxisNameByLayout2.numericAxisName,
            cateAxisName = _getAxisNameByLayout2.cateAxisName;

        var graphicalItems = Object(__WEBPACK_IMPORTED_MODULE_18__util_ReactUtils__["h" /* findAllByType */])(children, GraphicalChild);
        var stackGroups = Object(__WEBPACK_IMPORTED_MODULE_23__util_ChartUtils__["s" /* getStackGroupsByAxisId */])(data, graphicalItems, numericAxisName + 'Id', cateAxisName + 'Id', stackOffset, reverseStackOrder);
        var axisObj = axisComponents.reduce(function (result, entry) {
          var name = entry.axisType + 'Map';

          return _extends({}, result, _defineProperty({}, name, _this4.getAxisMap(props, _extends({}, entry, {
            graphicalItems: graphicalItems,
            stackGroups: entry.axisType === numericAxisName && stackGroups,
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex
          }))));
        }, {});

        var offset = this.calculateOffset(_extends({}, axisObj, { props: props, graphicalItems: graphicalItems }));

        Object.keys(axisObj).forEach(function (key) {
          axisObj[key] = formatAxisMap(props, axisObj[key], offset, key.replace('Map', ''), chartName);
        });
        var cateAxisMap = axisObj[cateAxisName + 'Map'];
        var ticksObj = this.tooltipTicksGenerator(cateAxisMap);

        var formatedGraphicalItems = this.getFormatItems(props, _extends({}, axisObj, { dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex, updateId: updateId,
          graphicalItems: graphicalItems, stackGroups: stackGroups, offset: offset
        }));

        return _extends({
          formatedGraphicalItems: formatedGraphicalItems, graphicalItems: graphicalItems, offset: offset, stackGroups: stackGroups
        }, ticksObj, axisObj);
      }

      /* eslint-disable  no-underscore-dangle */

    }, {
      key: 'addListener',
      value: function addListener() {
        __WEBPACK_IMPORTED_MODULE_26__util_Events__["b" /* eventCenter */].on(__WEBPACK_IMPORTED_MODULE_26__util_Events__["a" /* SYNC_EVENT */], this.handleReceiveSyncEvent);

        if (__WEBPACK_IMPORTED_MODULE_26__util_Events__["b" /* eventCenter */].setMaxListeners && __WEBPACK_IMPORTED_MODULE_26__util_Events__["b" /* eventCenter */]._maxListeners) {
          __WEBPACK_IMPORTED_MODULE_26__util_Events__["b" /* eventCenter */].setMaxListeners(__WEBPACK_IMPORTED_MODULE_26__util_Events__["b" /* eventCenter */]._maxListeners + 1);
        }
      }
    }, {
      key: 'removeListener',
      value: function removeListener() {
        __WEBPACK_IMPORTED_MODULE_26__util_Events__["b" /* eventCenter */].removeListener(__WEBPACK_IMPORTED_MODULE_26__util_Events__["a" /* SYNC_EVENT */], this.handleReceiveSyncEvent);

        if (__WEBPACK_IMPORTED_MODULE_26__util_Events__["b" /* eventCenter */].setMaxListeners && __WEBPACK_IMPORTED_MODULE_26__util_Events__["b" /* eventCenter */]._maxListeners) {
          __WEBPACK_IMPORTED_MODULE_26__util_Events__["b" /* eventCenter */].setMaxListeners(__WEBPACK_IMPORTED_MODULE_26__util_Events__["b" /* eventCenter */]._maxListeners - 1);
        }
      }
      /**
       * Calculate the offset of main part in the svg element
       * @param  {Object} props          Latest props
       * @param  {Array}  graphicalItems The instances of item
       * @param  {Object} xAxisMap       The configuration of x-axis
       * @param  {Object} yAxisMap       The configuration of y-axis
       * @return {Object} The offset of main part in the svg element
       */

    }, {
      key: 'calculateOffset',
      value: function calculateOffset(_ref6) {
        var props = _ref6.props,
            graphicalItems = _ref6.graphicalItems,
            _ref6$xAxisMap = _ref6.xAxisMap,
            xAxisMap = _ref6$xAxisMap === undefined ? {} : _ref6$xAxisMap,
            _ref6$yAxisMap = _ref6.yAxisMap,
            yAxisMap = _ref6$yAxisMap === undefined ? {} : _ref6$yAxisMap;
        var width = props.width,
            height = props.height,
            children = props.children;

        var margin = props.margin || {};
        var brushItem = Object(__WEBPACK_IMPORTED_MODULE_18__util_ReactUtils__["i" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_20__cartesian_Brush__["a" /* default */]);
        var legendItem = Object(__WEBPACK_IMPORTED_MODULE_18__util_ReactUtils__["i" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_12__component_Legend__["a" /* default */]);

        var offsetH = Object.keys(yAxisMap).reduce(function (result, id) {
          var entry = yAxisMap[id];
          var orientation = entry.orientation;

          if (!entry.mirror && !entry.hide) {
            return _extends({}, result, _defineProperty({}, orientation, result[orientation] + entry.width));
          }

          return result;
        }, { left: margin.left || 0, right: margin.right || 0 });

        var offsetV = Object.keys(xAxisMap).reduce(function (result, id) {
          var entry = xAxisMap[id];
          var orientation = entry.orientation;

          if (!entry.mirror && !entry.hide) {
            return _extends({}, result, _defineProperty({}, orientation, result[orientation] + entry.height));
          }

          return result;
        }, { top: margin.top || 0, bottom: margin.bottom || 0 });

        var offset = _extends({}, offsetV, offsetH);

        var brushBottom = offset.bottom;

        if (brushItem) {
          offset.bottom += brushItem.props.height || __WEBPACK_IMPORTED_MODULE_20__cartesian_Brush__["a" /* default */].defaultProps.height;
        }

        if (legendItem && this.legendInstance) {
          var legendBox = this.legendInstance.getBBox();

          offset = Object(__WEBPACK_IMPORTED_MODULE_23__util_ChartUtils__["a" /* appendOffsetOfLegend */])(offset, graphicalItems, props, legendBox);
        }

        return _extends({
          brushBottom: brushBottom
        }, offset, {
          width: width - offset.left - offset.right,
          height: height - offset.top - offset.bottom
        });
      }
      /**
       * The handler of mouse entering chart
       * @param  {Object} e              Event object
       * @return {Null}                  null
       */

      /**
       * The handler of mouse entering a scatter
       * @param {Object} el     The active scatter
       * @return {Object} no return
       */

      /**
       * The handler of mouse leaving a scatter
       * @return {Object} no return
       */

      /**
       * The handler of mouse moving in chart
       * @param  {Object} e        Event object
       * @return {Null} no return
       */

      /**
       * The handler if mouse leaving chart
       * @param {Object} e Event object
       * @return {Null} no return
       */

    }, {
      key: 'triggerSyncEvent',
      value: function triggerSyncEvent(data) {
        var syncId = this.props.syncId;


        if (!__WEBPACK_IMPORTED_MODULE_5_lodash_isNil___default()(syncId)) {
          __WEBPACK_IMPORTED_MODULE_26__util_Events__["b" /* eventCenter */].emit(__WEBPACK_IMPORTED_MODULE_26__util_Events__["a" /* SYNC_EVENT */], syncId, this.uniqueChartId, data);
        }
      }
    }, {
      key: 'filterFormatItem',
      value: function filterFormatItem(item, displayName, childIndex) {
        var formatedGraphicalItems = this.state.formatedGraphicalItems;


        for (var i = 0, len = formatedGraphicalItems.length; i < len; i++) {
          var entry = formatedGraphicalItems[i];

          if (entry.item === item || entry.props.key === item.key || displayName === Object(__WEBPACK_IMPORTED_MODULE_18__util_ReactUtils__["j" /* getDisplayName */])(entry.item.type) && childIndex === entry.childIndex) {
            return entry;
          }
        }

        return null;
      }
    }, {
      key: 'renderAxis',

      /**
       * Draw axis
       * @param {Object} axisOptions The options of axis
       * @param {Object} element      The axis element
       * @param {String} displayName  The display name of axis
       * @param {Number} index        The index of element
       * @return {ReactElement}       The instance of x-axes
       */
      value: function renderAxis(axisOptions, element, displayName, index) {
        var _props2 = this.props,
            width = _props2.width,
            height = _props2.height;


        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__cartesian_CartesianAxis__["a" /* default */], _extends({}, axisOptions, {
          className: 'recharts-' + axisOptions.axisType + ' ' + axisOptions.axisType,
          key: element.key || displayName + '-' + index,
          viewBox: { x: 0, y: 0, width: width, height: height },
          ticksGenerator: this.axesTicksGenerator
        }));
      }
      /**
       * Draw grid
       * @param  {ReactElement} element the grid item
       * @return {ReactElement} The instance of grid
       */

    }, {
      key: 'renderLegend',

      /**
       * Draw legend
       * @return {ReactElement}            The instance of Legend
       */
      value: function renderLegend() {
        var _this5 = this;

        var formatedGraphicalItems = this.state.formatedGraphicalItems;
        var _props3 = this.props,
            children = _props3.children,
            width = _props3.width,
            height = _props3.height;

        var margin = this.props.margin || {};
        var legendWidth = width - (margin.left || 0) - (margin.right || 0);
        var legendHeight = height - (margin.top || 0) - (margin.bottom || 0);
        var props = Object(__WEBPACK_IMPORTED_MODULE_23__util_ChartUtils__["q" /* getLegendProps */])({
          children: children, formatedGraphicalItems: formatedGraphicalItems, legendWidth: legendWidth, legendHeight: legendHeight, legendContent: legendContent
        });

        if (!props) {
          return null;
        }

        var item = props.item,
            otherProps = _objectWithoutProperties(props, ['item']);

        return Object(__WEBPACK_IMPORTED_MODULE_6_react__["cloneElement"])(item, _extends({}, otherProps, {
          chartWidth: width,
          chartHeight: height,
          margin: margin,
          ref: function ref(legend) {
            _this5.legendInstance = legend;
          },
          onBBoxUpdate: this.handleLegendBBoxUpdate
        }));
      }
      /**
       * Draw Tooltip
       * @return {ReactElement}  The instance of Tooltip
       */

    }, {
      key: 'renderTooltip',
      value: function renderTooltip() {
        var children = this.props.children;

        var tooltipItem = Object(__WEBPACK_IMPORTED_MODULE_18__util_ReactUtils__["i" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_11__component_Tooltip__["a" /* default */]);

        if (!tooltipItem) {
          return null;
        }

        var _state8 = this.state,
            isTooltipActive = _state8.isTooltipActive,
            activeCoordinate = _state8.activeCoordinate,
            activePayload = _state8.activePayload,
            activeLabel = _state8.activeLabel,
            offset = _state8.offset;


        return Object(__WEBPACK_IMPORTED_MODULE_6_react__["cloneElement"])(tooltipItem, {
          viewBox: _extends({}, offset, { x: offset.left, y: offset.top }),
          active: isTooltipActive,
          label: activeLabel,
          payload: isTooltipActive ? activePayload : [],
          coordinate: activeCoordinate
        });
      }
    }, {
      key: 'renderActiveDot',
      value: function renderActiveDot(option, props) {
        var dot = void 0;

        if (Object(__WEBPACK_IMPORTED_MODULE_6_react__["isValidElement"])(option)) {
          dot = Object(__WEBPACK_IMPORTED_MODULE_6_react__["cloneElement"])(option, props);
        } else if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(option)) {
          dot = option(props);
        } else {
          dot = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__shape_Dot__["a" /* default */], props);
        }

        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10__container_Layer__["a" /* default */],
          { className: 'recharts-active-dot', key: props.key },
          dot
        );
      }
    }, {
      key: 'renderActivePoints',
      value: function renderActivePoints(_ref7) {
        var item = _ref7.item,
            activePoint = _ref7.activePoint,
            basePoint = _ref7.basePoint,
            childIndex = _ref7.childIndex,
            isRange = _ref7.isRange;

        var result = [];
        var key = item.props.key;
        var _item$item$props = item.item.props,
            activeDot = _item$item$props.activeDot,
            dataKey = _item$item$props.dataKey;

        var dotProps = _extends({
          index: childIndex,
          dataKey: dataKey,
          cx: activePoint.x,
          cy: activePoint.y,
          r: 4,
          fill: Object(__WEBPACK_IMPORTED_MODULE_23__util_ChartUtils__["r" /* getMainColorOfGraphicItem */])(item.item),
          strokeWidth: 2,
          stroke: '#fff',
          payload: activePoint.payload,
          value: activePoint.value,
          key: key + '-activePoint-' + childIndex
        }, Object(__WEBPACK_IMPORTED_MODULE_18__util_ReactUtils__["k" /* getPresentationAttributes */])(activeDot), Object(__WEBPACK_IMPORTED_MODULE_18__util_ReactUtils__["e" /* filterEventAttributes */])(activeDot));

        result.push(this.renderActiveDot(activeDot, dotProps, childIndex));

        if (basePoint) {
          result.push(this.renderActiveDot(activeDot, _extends({}, dotProps, {
            cx: basePoint.x,
            cy: basePoint.y,
            key: key + '-basePoint-' + childIndex
          }), childIndex));
        } else if (isRange) {
          result.push(null);
        }

        return result;
      }
    }, {
      key: 'render',
      value: function render() {
        var _this6 = this;

        if (!Object(__WEBPACK_IMPORTED_MODULE_18__util_ReactUtils__["q" /* validateWidthHeight */])(this)) {
          return null;
        }

        var _props4 = this.props,
            children = _props4.children,
            className = _props4.className,
            width = _props4.width,
            height = _props4.height,
            style = _props4.style,
            compact = _props4.compact,
            others = _objectWithoutProperties(_props4, ['children', 'className', 'width', 'height', 'style', 'compact']);

        var attrs = Object(__WEBPACK_IMPORTED_MODULE_18__util_ReactUtils__["k" /* getPresentationAttributes */])(others);
        var map = {
          CartesianGrid: { handler: this.renderGrid, once: true },
          ReferenceArea: { handler: this.renderReferenceElement },
          ReferenceLine: { handler: this.renderReferenceElement },
          ReferenceDot: { handler: this.renderReferenceElement },
          XAxis: { handler: this.renderXAxis },
          YAxis: { handler: this.renderYAxis },
          Brush: { handler: this.renderBrush, once: true },
          Bar: { handler: this.renderGraphicChild },
          Line: { handler: this.renderGraphicChild },
          Area: { handler: this.renderGraphicChild },
          Radar: { handler: this.renderGraphicChild },
          RadialBar: { handler: this.renderGraphicChild },
          Scatter: { handler: this.renderGraphicChild },
          Pie: { handler: this.renderGraphicChild },
          Tooltip: { handler: this.renderCursor, once: true },
          PolarGrid: { handler: this.renderPolarGrid, once: true },
          PolarAngleAxis: { handler: this.renderPolarAxis },
          PolarRadiusAxis: { handler: this.renderPolarAxis }
        };

        // The "compact" mode is mainly used as the panorama within Brush
        if (compact) {
          return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__container_Surface__["a" /* default */],
            _extends({}, attrs, { width: width, height: height }),
            Object(__WEBPACK_IMPORTED_MODULE_18__util_ReactUtils__["p" /* renderByOrder */])(children, map)
          );
        }

        var events = this.parseEventsOfWrapper();
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'div',
          _extends({
            className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()('recharts-wrapper', className),
            style: _extends({}, style, { position: 'relative', cursor: 'default', width: width, height: height })
          }, events, {
            ref: function ref(node) {
              _this6.container = node;
            }
          }),
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__container_Surface__["a" /* default */],
            _extends({}, attrs, { width: width, height: height }),
            Object(__WEBPACK_IMPORTED_MODULE_18__util_ReactUtils__["p" /* renderByOrder */])(children, map)
          ),
          this.renderLegend(),
          this.renderTooltip()
        );
      }
    }]);

    return CategoricalChartWrapper;
  }(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]), _class.displayName = chartName, _class.propTypes = _extends({
    syncId: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number]),
    compact: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    width: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
    height: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
    data: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object),
    layout: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['horizontal', 'vertical']),
    stackOffset: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['sign', 'expand', 'none', 'wiggle', 'silhouette']),
    throttleDelay: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
    margin: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
      top: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
      right: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
      bottom: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
      left: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number
    }),
    barCategoryGap: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string]),
    barGap: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string]),
    barSize: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string]),
    maxBarSize: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
    style: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
    className: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
    children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node]),
    onClick: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
    onMouseLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
    onMouseEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
    onMouseMove: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
    onMouseDown: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
    onMouseUp: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
    reverseStackOrder: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    id: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
  }, propTypes), _class.defaultProps = _extends({
    layout: 'horizontal',
    stackOffset: 'none',
    barCategoryGap: '10%',
    barGap: 4,
    margin: { top: 5, right: 5, bottom: 5, left: 5 },
    reverseStackOrder: false
  }, defaultProps), _class.createDefaultState = function (props) {
    var children = props.children;

    var brushItem = Object(__WEBPACK_IMPORTED_MODULE_18__util_ReactUtils__["i" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_20__cartesian_Brush__["a" /* default */]);
    var startIndex = brushItem && brushItem.props && brushItem.props.startIndex || 0;
    var endIndex = brushItem && brushItem.props && brushItem.props.endIndex || props.data && props.data.length - 1 || 0;
    return {
      chartX: 0,
      chartY: 0,
      dataStartIndex: startIndex,
      dataEndIndex: endIndex,
      activeTooltipIndex: -1,
      isTooltipActive: false
    };
  }, _class.hasBar = function (graphicalItems) {
    if (!graphicalItems || !graphicalItems.length) {
      return false;
    }

    return graphicalItems.some(function (item) {
      var name = Object(__WEBPACK_IMPORTED_MODULE_18__util_ReactUtils__["j" /* getDisplayName */])(item && item.type);

      return name && name.indexOf('Bar') >= 0;
    });
  }, _class.getDisplayedData = function (props, _ref8, item) {
    var graphicalItems = _ref8.graphicalItems,
        dataStartIndex = _ref8.dataStartIndex,
        dataEndIndex = _ref8.dataEndIndex;

    var itemsData = (graphicalItems || []).reduce(function (result, child) {
      var itemData = child.props.data;

      if (itemData && itemData.length) {
        return [].concat(_toConsumableArray(result), _toConsumableArray(itemData));
      }

      return result;
    }, []);
    if (itemsData && itemsData.length > 0) {
      return itemsData;
    }

    if (item && item.props && item.props.data && item.props.data.length > 0) {
      return item.props.data;
    }

    var data = props.data;


    if (data && data.length && Object(__WEBPACK_IMPORTED_MODULE_22__util_DataUtils__["g" /* isNumber */])(dataStartIndex) && Object(__WEBPACK_IMPORTED_MODULE_22__util_DataUtils__["g" /* isNumber */])(dataEndIndex)) {
      return data.slice(dataStartIndex, dataEndIndex + 1);
    }

    return [];
  }, _initialiseProps = function _initialiseProps() {
    var _this7 = this;

    this.handleLegendBBoxUpdate = function (box) {
      if (box && _this7.legendInstance) {
        var _state9 = _this7.state,
            dataStartIndex = _state9.dataStartIndex,
            dataEndIndex = _state9.dataEndIndex,
            updateId = _state9.updateId;


        _this7.setState(_this7.updateStateOfAxisMapsOffsetAndStackGroups({
          props: _this7.props, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex, updateId: updateId
        }));
      }
    };

    this.handleReceiveSyncEvent = function (cId, chartId, data) {
      var _props5 = _this7.props,
          syncId = _props5.syncId,
          layout = _props5.layout;
      var updateId = _this7.state.updateId;


      if (syncId === cId && chartId !== _this7.uniqueChartId) {
        var dataStartIndex = data.dataStartIndex,
            dataEndIndex = data.dataEndIndex;


        if (!__WEBPACK_IMPORTED_MODULE_5_lodash_isNil___default()(data.dataStartIndex) || !__WEBPACK_IMPORTED_MODULE_5_lodash_isNil___default()(data.dataEndIndex)) {
          _this7.setState(_extends({
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex
          }, _this7.updateStateOfAxisMapsOffsetAndStackGroups({ props: _this7.props, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex, updateId: updateId })));
        } else if (!__WEBPACK_IMPORTED_MODULE_5_lodash_isNil___default()(data.activeTooltipIndex)) {
          var chartX = data.chartX,
              chartY = data.chartY,
              activeTooltipIndex = data.activeTooltipIndex;
          var _state10 = _this7.state,
              offset = _state10.offset,
              tooltipTicks = _state10.tooltipTicks;

          if (!offset) {
            return;
          }
          var viewBox = _extends({}, offset, { x: offset.left, y: offset.top });
          // When a categotical chart is combined with another chart, the value of chartX
          // and chartY may beyond the boundaries.
          var validateChartX = Math.min(chartX, viewBox.x + viewBox.width);
          var validateChartY = Math.min(chartY, viewBox.y + viewBox.height);
          var activeLabel = tooltipTicks[activeTooltipIndex] && tooltipTicks[activeTooltipIndex].value;
          var activePayload = _this7.getTooltipContent(activeTooltipIndex);
          var activeCoordinate = tooltipTicks[activeTooltipIndex] ? {
            x: layout === 'horizontal' ? tooltipTicks[activeTooltipIndex].coordinate : validateChartX,
            y: layout === 'horizontal' ? validateChartY : tooltipTicks[activeTooltipIndex].coordinate
          } : originCoordinate;

          _this7.setState(_extends({}, data, { activeLabel: activeLabel, activeCoordinate: activeCoordinate, activePayload: activePayload }));
        } else {
          _this7.setState(data);
        }
      }
    };

    this.handleBrushChange = function (_ref9) {
      var startIndex = _ref9.startIndex,
          endIndex = _ref9.endIndex;

      // Only trigger changes if the extents of the brush have actually changed
      if (startIndex !== _this7.state.dataStartIndex || endIndex !== _this7.state.dataEndIndex) {
        var updateId = _this7.state.updateId;


        _this7.setState(_extends({
          dataStartIndex: startIndex,
          dataEndIndex: endIndex
        }, _this7.updateStateOfAxisMapsOffsetAndStackGroups({ props: _this7.props, dataStartIndex: startIndex, dataEndIndex: endIndex, updateId: updateId })));

        _this7.triggerSyncEvent({
          dataStartIndex: startIndex,
          dataEndIndex: endIndex
        });
      }
    };

    this.handleMouseEnter = function (e) {
      var onMouseEnter = _this7.props.onMouseEnter;

      var mouse = _this7.getMouseInfo(e);

      if (mouse) {
        var nextState = _extends({}, mouse, { isTooltipActive: true });
        _this7.setState(nextState);
        _this7.triggerSyncEvent(nextState);

        if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(onMouseEnter)) {
          onMouseEnter(nextState, e);
        }
      }
    };

    this.triggeredAfterMouseMove = function (e) {
      var onMouseMove = _this7.props.onMouseMove;

      var mouse = _this7.getMouseInfo(e);
      var nextState = mouse ? _extends({}, mouse, { isTooltipActive: true }) : { isTooltipActive: false };

      _this7.setState(nextState);
      _this7.triggerSyncEvent(nextState);

      if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(onMouseMove)) {
        onMouseMove(nextState, e);
      }
    };

    this.handleItemMouseEnter = function (el) {
      _this7.setState({
        isTooltipActive: true,
        activeItem: el,
        activePayload: el.tooltipPayload,
        activeCoordinate: el.tooltipPosition || { x: el.cx, y: el.cy }
      });
    };

    this.handleItemMouseLeave = function () {
      _this7.setState({
        isTooltipActive: false
      });
    };

    this.handleMouseMove = function (e) {
      if (e && __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(e.persist)) {
        e.persist();
      }
      _this7.triggeredAfterMouseMove(e);
    };

    this.handleMouseLeave = function (e) {
      var onMouseLeave = _this7.props.onMouseLeave;

      var nextState = { isTooltipActive: false };

      _this7.setState(nextState);
      _this7.triggerSyncEvent(nextState);

      if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(onMouseLeave)) {
        onMouseLeave(nextState, e);
      }
    };

    this.handleOuterEvent = function (e) {
      var eventName = Object(__WEBPACK_IMPORTED_MODULE_18__util_ReactUtils__["l" /* getReactEventByType */])(e);

      if (eventName && __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(_this7.props[eventName])) {
        var mouse = _this7.getMouseInfo(e);
        var handler = _this7.props[eventName];

        handler(mouse, e);
      }
    };

    this.handleClick = function (e) {
      var onClick = _this7.props.onClick;


      if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(onClick)) {
        var mouse = _this7.getMouseInfo(e);

        onClick(mouse, e);
      }
    };

    this.handleMouseDown = function (e) {
      var onMouseDown = _this7.props.onMouseDown;


      if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(onMouseDown)) {
        var mouse = _this7.getMouseInfo(e);

        onMouseDown(mouse, e);
      }
    };

    this.handleMouseUp = function (e) {
      var onMouseUp = _this7.props.onMouseUp;


      if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(onMouseUp)) {
        var mouse = _this7.getMouseInfo(e);

        onMouseUp(mouse, e);
      }
    };

    this.handleTouchMove = function (e) {
      if (e.changedTouches != null && e.changedTouches.length > 0) {
        _this7.handleMouseMove(e.changedTouches[0]);
      }
    };

    this.verticalCoordinatesGenerator = function (_ref10) {
      var xAxis = _ref10.xAxis,
          width = _ref10.width,
          height = _ref10.height,
          offset = _ref10.offset;
      return Object(__WEBPACK_IMPORTED_MODULE_23__util_ChartUtils__["m" /* getCoordinatesOfGrid */])(__WEBPACK_IMPORTED_MODULE_19__cartesian_CartesianAxis__["a" /* default */].getTicks(_extends({}, __WEBPACK_IMPORTED_MODULE_19__cartesian_CartesianAxis__["a" /* default */].defaultProps, xAxis, {
        ticks: Object(__WEBPACK_IMPORTED_MODULE_23__util_ChartUtils__["u" /* getTicksOfAxis */])(xAxis, true),
        viewBox: { x: 0, y: 0, width: width, height: height }
      })), offset.left, offset.left + offset.width);
    };

    this.horizontalCoordinatesGenerator = function (_ref11) {
      var yAxis = _ref11.yAxis,
          width = _ref11.width,
          height = _ref11.height,
          offset = _ref11.offset;
      return Object(__WEBPACK_IMPORTED_MODULE_23__util_ChartUtils__["m" /* getCoordinatesOfGrid */])(__WEBPACK_IMPORTED_MODULE_19__cartesian_CartesianAxis__["a" /* default */].getTicks(_extends({}, __WEBPACK_IMPORTED_MODULE_19__cartesian_CartesianAxis__["a" /* default */].defaultProps, yAxis, {
        ticks: Object(__WEBPACK_IMPORTED_MODULE_23__util_ChartUtils__["u" /* getTicksOfAxis */])(yAxis, true),
        viewBox: { x: 0, y: 0, width: width, height: height }
      })), offset.top, offset.top + offset.height);
    };

    this.axesTicksGenerator = function (axis) {
      return Object(__WEBPACK_IMPORTED_MODULE_23__util_ChartUtils__["u" /* getTicksOfAxis */])(axis, true);
    };

    this.tooltipTicksGenerator = function (axisMap) {
      var axis = Object(__WEBPACK_IMPORTED_MODULE_22__util_DataUtils__["b" /* getAnyElementOfObject */])(axisMap);
      var tooltipTicks = Object(__WEBPACK_IMPORTED_MODULE_23__util_ChartUtils__["u" /* getTicksOfAxis */])(axis, false, true);

      return {
        tooltipTicks: tooltipTicks,
        orderedTooltipTicks: __WEBPACK_IMPORTED_MODULE_0_lodash_sortBy___default()(tooltipTicks, function (o) {
          return o.coordinate;
        }),
        tooltipAxis: axis,
        tooltipAxisBandSize: Object(__WEBPACK_IMPORTED_MODULE_23__util_ChartUtils__["g" /* getBandSizeOfAxis */])(axis)
      };
    };

    this.renderCursor = function (element) {
      var _state11 = _this7.state,
          isTooltipActive = _state11.isTooltipActive,
          activeCoordinate = _state11.activeCoordinate,
          activePayload = _state11.activePayload,
          offset = _state11.offset;


      if (!element || !element.props.cursor || !isTooltipActive || !activeCoordinate) {
        return null;
      }
      var layout = _this7.props.layout;

      var restProps = void 0;
      var cursorComp = __WEBPACK_IMPORTED_MODULE_13__shape_Curve__["a" /* default */];

      if (chartName === 'ScatterChart') {
        restProps = activeCoordinate;
        cursorComp = __WEBPACK_IMPORTED_MODULE_14__shape_Cross__["a" /* default */];
      } else if (chartName === 'BarChart') {
        restProps = _this7.getCursorRectangle();
        cursorComp = __WEBPACK_IMPORTED_MODULE_17__shape_Rectangle__["a" /* default */];
      } else if (layout === 'radial') {
        var _getCursorPoints = _this7.getCursorPoints(),
            cx = _getCursorPoints.cx,
            cy = _getCursorPoints.cy,
            radius = _getCursorPoints.radius,
            startAngle = _getCursorPoints.startAngle,
            endAngle = _getCursorPoints.endAngle;

        restProps = {
          cx: cx, cy: cy, startAngle: startAngle, endAngle: endAngle, innerRadius: radius, outerRadius: radius
        };
        cursorComp = __WEBPACK_IMPORTED_MODULE_15__shape_Sector__["a" /* default */];
      } else {
        restProps = { points: _this7.getCursorPoints() };
        cursorComp = __WEBPACK_IMPORTED_MODULE_13__shape_Curve__["a" /* default */];
      }
      var key = element.key || '_recharts-cursor';
      var cursorProps = _extends({
        stroke: '#ccc'
      }, offset, restProps, Object(__WEBPACK_IMPORTED_MODULE_18__util_ReactUtils__["k" /* getPresentationAttributes */])(element.props.cursor), {
        payload: activePayload,
        key: key,
        className: 'recharts-tooltip-cursor'
      });

      return Object(__WEBPACK_IMPORTED_MODULE_6_react__["isValidElement"])(element.props.cursor) ? Object(__WEBPACK_IMPORTED_MODULE_6_react__["cloneElement"])(element.props.cursor, cursorProps) : Object(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"])(cursorComp, cursorProps);
    };

    this.renderPolarAxis = function (element, displayName, index) {
      var axisType = element.type.axisType;
      var axisMap = _this7.state[axisType + 'Map'];
      var axisOption = axisMap[element.props[axisType + 'Id']];

      return Object(__WEBPACK_IMPORTED_MODULE_6_react__["cloneElement"])(element, _extends({}, axisOption, {
        className: axisType,
        key: element.key || displayName + '-' + index,
        ticks: Object(__WEBPACK_IMPORTED_MODULE_23__util_ChartUtils__["u" /* getTicksOfAxis */])(axisOption, true)
      }));
    };

    this.renderXAxis = function (element, displayName, index) {
      var xAxisMap = _this7.state.xAxisMap;

      var axisObj = xAxisMap[element.props.xAxisId];

      return _this7.renderAxis(axisObj, element, displayName, index);
    };

    this.renderYAxis = function (element, displayName, index) {
      var yAxisMap = _this7.state.yAxisMap;

      var axisObj = yAxisMap[element.props.yAxisId];

      return _this7.renderAxis(axisObj, element, displayName, index);
    };

    this.renderGrid = function (element) {
      var _state12 = _this7.state,
          xAxisMap = _state12.xAxisMap,
          yAxisMap = _state12.yAxisMap,
          offset = _state12.offset;
      var _props6 = _this7.props,
          width = _props6.width,
          height = _props6.height;

      var xAxis = Object(__WEBPACK_IMPORTED_MODULE_22__util_DataUtils__["b" /* getAnyElementOfObject */])(xAxisMap);
      var yAxis = Object(__WEBPACK_IMPORTED_MODULE_22__util_DataUtils__["b" /* getAnyElementOfObject */])(yAxisMap);
      var props = element.props || {};

      return Object(__WEBPACK_IMPORTED_MODULE_6_react__["cloneElement"])(element, {
        key: element.key || 'grid',
        x: Object(__WEBPACK_IMPORTED_MODULE_22__util_DataUtils__["g" /* isNumber */])(props.x) ? props.x : offset.left,
        y: Object(__WEBPACK_IMPORTED_MODULE_22__util_DataUtils__["g" /* isNumber */])(props.y) ? props.y : offset.top,
        width: Object(__WEBPACK_IMPORTED_MODULE_22__util_DataUtils__["g" /* isNumber */])(props.width) ? props.width : offset.width,
        height: Object(__WEBPACK_IMPORTED_MODULE_22__util_DataUtils__["g" /* isNumber */])(props.height) ? props.height : offset.height,
        xAxis: xAxis,
        yAxis: yAxis,
        offset: offset,
        chartWidth: width,
        chartHeight: height,
        verticalCoordinatesGenerator: _this7.verticalCoordinatesGenerator,
        horizontalCoordinatesGenerator: _this7.horizontalCoordinatesGenerator
      });
    };

    this.renderPolarGrid = function (element) {
      var _state13 = _this7.state,
          radiusAxisMap = _state13.radiusAxisMap,
          angleAxisMap = _state13.angleAxisMap;

      var radiusAxis = Object(__WEBPACK_IMPORTED_MODULE_22__util_DataUtils__["b" /* getAnyElementOfObject */])(radiusAxisMap);
      var angleAxis = Object(__WEBPACK_IMPORTED_MODULE_22__util_DataUtils__["b" /* getAnyElementOfObject */])(angleAxisMap);
      var cx = angleAxis.cx,
          cy = angleAxis.cy,
          innerRadius = angleAxis.innerRadius,
          outerRadius = angleAxis.outerRadius;


      return Object(__WEBPACK_IMPORTED_MODULE_6_react__["cloneElement"])(element, {
        polarAngles: Object(__WEBPACK_IMPORTED_MODULE_23__util_ChartUtils__["u" /* getTicksOfAxis */])(angleAxis, true).map(function (entry) {
          return entry.coordinate;
        }),
        polarRadius: Object(__WEBPACK_IMPORTED_MODULE_23__util_ChartUtils__["u" /* getTicksOfAxis */])(radiusAxis, true).map(function (entry) {
          return entry.coordinate;
        }),
        cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius,
        key: element.key || 'polar-grid'
      });
    };

    this.renderBrush = function (element) {
      var _props7 = _this7.props,
          margin = _props7.margin,
          data = _props7.data;
      var _state14 = _this7.state,
          offset = _state14.offset,
          dataStartIndex = _state14.dataStartIndex,
          dataEndIndex = _state14.dataEndIndex,
          updateId = _state14.updateId;

      // TODO: update brush when children update

      return Object(__WEBPACK_IMPORTED_MODULE_6_react__["cloneElement"])(element, {
        key: element.key || '_recharts-brush',
        onChange: Object(__WEBPACK_IMPORTED_MODULE_23__util_ChartUtils__["d" /* combineEventHandlers */])(_this7.handleBrushChange, null, element.props.onChange),
        data: data,
        x: Object(__WEBPACK_IMPORTED_MODULE_22__util_DataUtils__["g" /* isNumber */])(element.props.x) ? element.props.x : offset.left,
        y: Object(__WEBPACK_IMPORTED_MODULE_22__util_DataUtils__["g" /* isNumber */])(element.props.y) ? element.props.y : offset.top + offset.height + offset.brushBottom - (margin.bottom || 0),
        width: Object(__WEBPACK_IMPORTED_MODULE_22__util_DataUtils__["g" /* isNumber */])(element.props.width) ? element.props.width : offset.width,
        startIndex: dataStartIndex,
        endIndex: dataEndIndex,
        updateId: 'brush-' + updateId
      });
    };

    this.renderReferenceElement = function (element, displayName, index) {
      if (!element) {
        return null;
      }
      var _state15 = _this7.state,
          xAxisMap = _state15.xAxisMap,
          yAxisMap = _state15.yAxisMap,
          offset = _state15.offset;
      var _element$props = element.props,
          xAxisId = _element$props.xAxisId,
          yAxisId = _element$props.yAxisId;


      return Object(__WEBPACK_IMPORTED_MODULE_6_react__["cloneElement"])(element, {
        key: element.key || displayName + '-' + index,
        xAxis: xAxisMap[xAxisId],
        yAxis: yAxisMap[yAxisId],
        viewBox: {
          x: offset.left,
          y: offset.top,
          width: offset.width,
          height: offset.height
        }
      });
    };

    this.renderGraphicChild = function (element, displayName, index) {
      var item = _this7.filterFormatItem(element, displayName, index);
      if (!item) {
        return null;
      }

      var graphicalItem = Object(__WEBPACK_IMPORTED_MODULE_6_react__["cloneElement"])(element, item.props);
      var _state16 = _this7.state,
          isTooltipActive = _state16.isTooltipActive,
          tooltipAxis = _state16.tooltipAxis,
          activeTooltipIndex = _state16.activeTooltipIndex,
          activeLabel = _state16.activeLabel;
      var children = _this7.props.children;

      var tooltipItem = Object(__WEBPACK_IMPORTED_MODULE_18__util_ReactUtils__["i" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_11__component_Tooltip__["a" /* default */]);
      var _item$props2 = item.props,
          points = _item$props2.points,
          isRange = _item$props2.isRange,
          baseLine = _item$props2.baseLine;
      var _item$item$props2 = item.item.props,
          activeDot = _item$item$props2.activeDot,
          hide = _item$item$props2.hide;

      var hasActive = !hide && isTooltipActive && tooltipItem && activeDot && activeTooltipIndex >= 0;

      if (hasActive) {
        var activePoint = void 0,
            basePoint = void 0;

        if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
          activePoint = Object(__WEBPACK_IMPORTED_MODULE_22__util_DataUtils__["a" /* findEntryInArray */])(points, 'payload.' + tooltipAxis.dataKey, activeLabel);
          basePoint = isRange && baseLine && Object(__WEBPACK_IMPORTED_MODULE_22__util_DataUtils__["a" /* findEntryInArray */])(baseLine, 'payload.' + tooltipAxis.dataKey, activeLabel);
        } else {
          activePoint = points[activeTooltipIndex];
          basePoint = isRange && baseLine && baseLine[activeTooltipIndex];
        }

        if (!__WEBPACK_IMPORTED_MODULE_5_lodash_isNil___default()(activePoint)) {
          return [graphicalItem].concat(_toConsumableArray(_this7.renderActivePoints({
            item: item, activePoint: activePoint, basePoint: basePoint, childIndex: activeTooltipIndex,
            isRange: isRange
          })));
        }
      }

      if (isRange) {
        return [graphicalItem, null, null];
      }

      return [graphicalItem, null];
    };
  }, _temp);


  return CategoricalChartWrapper;
};

/* harmony default export */ __webpack_exports__["a"] = (generateCategoricalChart);

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(305),
    getValue = __webpack_require__(308);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function constant() {
    return x;
  };
});


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reduce_css_calc__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reduce_css_calc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_reduce_css_calc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_DataUtils__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_DOMUtils__ = __webpack_require__(111);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var BREAKING_SPACES = /[ \f\n\r\t\v\u2028\u2029]+/;

var calculateWordWidths = function calculateWordWidths(props) {
  try {
    var words = !__WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(props.children) ? props.children.toString().split(BREAKING_SPACES) : [];
    var wordsWithComputedWidth = words.map(function (word) {
      return { word: word, width: Object(__WEBPACK_IMPORTED_MODULE_7__util_DOMUtils__["c" /* getStringSize */])(word, props.style).width };
    });

    var spaceWidth = Object(__WEBPACK_IMPORTED_MODULE_7__util_DOMUtils__["c" /* getStringSize */])('\xA0', props.style).width;

    return { wordsWithComputedWidth: wordsWithComputedWidth, spaceWidth: spaceWidth };
  } catch (e) {
    return null;
  }
};

var Text = (_temp2 = _class = function (_Component) {
  _inherits(Text, _Component);

  function Text() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Text);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Text.__proto__ || Object.getPrototypeOf(Text)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      wordsByLines: []
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Text, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.updateWordsByLines(this.props, true);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var needCalculate = this.props.children !== nextProps.children || this.props.style !== nextProps.style;
      this.updateWordsByLines(nextProps, needCalculate);
    }
  }, {
    key: 'updateWordsByLines',
    value: function updateWordsByLines(props, needCalculate) {
      // Only perform calculations if using features that require them (multiline, scaleToFit)
      if ((props.width || props.scaleToFit) && !Object(__WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["n" /* isSsr */])()) {
        if (needCalculate) {
          var wordWidths = calculateWordWidths(props);

          if (wordWidths) {
            var wordsWithComputedWidth = wordWidths.wordsWithComputedWidth,
                spaceWidth = wordWidths.spaceWidth;


            this.wordsWithComputedWidth = wordsWithComputedWidth;
            this.spaceWidth = spaceWidth;
          } else {
            this.updateWordsWithoutCalculate(props);

            return;
          }
        }

        var wordsByLines = this.calculateWordsByLines(this.wordsWithComputedWidth, this.spaceWidth, props.width);
        this.setState({ wordsByLines: wordsByLines });
      } else {
        this.updateWordsWithoutCalculate(props);
      }
    }
  }, {
    key: 'updateWordsWithoutCalculate',
    value: function updateWordsWithoutCalculate(props) {
      var words = !__WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(props.children) ? props.children.toString().split(BREAKING_SPACES) : [];
      this.setState({ wordsByLines: [{ words: words }] });
    }
  }, {
    key: 'calculateWordsByLines',
    value: function calculateWordsByLines(wordsWithComputedWidth, spaceWidth, lineWidth) {
      var scaleToFit = this.props.scaleToFit;

      return wordsWithComputedWidth.reduce(function (result, _ref2) {
        var word = _ref2.word,
            width = _ref2.width;

        var currentLine = result[result.length - 1];

        if (currentLine && (lineWidth == null || scaleToFit || currentLine.width + width + spaceWidth < lineWidth)) {
          // Word can be added to an existing line
          currentLine.words.push(word);
          currentLine.width += width + spaceWidth;
        } else {
          // Add first word to line or word is too long to scaleToFit on existing line
          var newLine = { words: [word], width: width };
          result.push(newLine);
        }

        return result;
      }, []);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          dx = _props.dx,
          dy = _props.dy,
          textAnchor = _props.textAnchor,
          verticalAnchor = _props.verticalAnchor,
          scaleToFit = _props.scaleToFit,
          angle = _props.angle,
          lineHeight = _props.lineHeight,
          capHeight = _props.capHeight,
          className = _props.className,
          textProps = _objectWithoutProperties(_props, ['dx', 'dy', 'textAnchor', 'verticalAnchor', 'scaleToFit', 'angle', 'lineHeight', 'capHeight', 'className']);

      var wordsByLines = this.state.wordsByLines;


      if (!Object(__WEBPACK_IMPORTED_MODULE_5__util_DataUtils__["f" /* isNumOrStr */])(textProps.x) || !Object(__WEBPACK_IMPORTED_MODULE_5__util_DataUtils__["f" /* isNumOrStr */])(textProps.y)) {
        return null;
      }
      var x = textProps.x + (Object(__WEBPACK_IMPORTED_MODULE_5__util_DataUtils__["g" /* isNumber */])(dx) ? dx : 0);
      var y = textProps.y + (Object(__WEBPACK_IMPORTED_MODULE_5__util_DataUtils__["g" /* isNumber */])(dy) ? dy : 0);

      var startDy = void 0;
      switch (verticalAnchor) {
        case 'start':
          startDy = __WEBPACK_IMPORTED_MODULE_3_reduce_css_calc___default()('calc(' + capHeight + ')');
          break;
        case 'middle':
          startDy = __WEBPACK_IMPORTED_MODULE_3_reduce_css_calc___default()('calc(' + (wordsByLines.length - 1) / 2 + ' * -' + lineHeight + ' + (' + capHeight + ' / 2))');
          break;
        default:
          startDy = __WEBPACK_IMPORTED_MODULE_3_reduce_css_calc___default()('calc(' + (wordsByLines.length - 1) + ' * -' + lineHeight + ')');
          break;
      }

      var transforms = [];
      if (scaleToFit) {
        var lineWidth = wordsByLines[0].width;
        transforms.push('scale(' + this.props.width / lineWidth + ')');
      }
      if (angle) {
        transforms.push('rotate(' + angle + ', ' + x + ', ' + y + ')');
      }
      if (transforms.length) {
        textProps.transform = transforms.join(' ');
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'text',
        _extends({}, Object(__WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["k" /* getPresentationAttributes */])(textProps), {
          x: x,
          y: y,
          className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('recharts-text', className),
          textAnchor: textAnchor
        }),
        wordsByLines.map(function (line, index) {
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'tspan',
            { x: x, dy: index === 0 ? startDy : lineHeight, key: index },
            line.words.join(' ')
          );
        })
      );
    }
  }]);

  return Text;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {
  scaleToFit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  angle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  textAnchor: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['start', 'middle', 'end', 'inherit']),
  verticalAnchor: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['start', 'middle', 'end']),
  style: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
}), _class.defaultProps = {
  x: 0,
  y: 0,
  lineHeight: '1em',
  capHeight: '0.71em', // Magic number from d3
  scaleToFit: false,
  textAnchor: 'start',
  verticalAnchor: 'end' // Maintain compat with existing charts / default SVG behavior
}, _temp2);


/* harmony default export */ __webpack_exports__["a"] = (Text);

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return map; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
var array = Array.prototype;

var map = array.map;
var slice = array.slice;


/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_PureRender__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Dot
 */






var Dot = Object(__WEBPACK_IMPORTED_MODULE_3__util_PureRender__["a" /* default */])(_class = (_temp = _class2 = function (_Component) {
  _inherits(Dot, _Component);

  function Dot() {
    _classCallCheck(this, Dot);

    return _possibleConstructorReturn(this, (Dot.__proto__ || Object.getPrototypeOf(Dot)).apply(this, arguments));
  }

  _createClass(Dot, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          cx = _props.cx,
          cy = _props.cy,
          r = _props.r,
          className = _props.className;

      var layerClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('recharts-dot', className);

      if (cx === +cx && cy === +cy && r === +r) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle', _extends({}, Object(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["k" /* getPresentationAttributes */])(this.props), Object(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["e" /* filterEventAttributes */])(this.props, null, true), {
          className: layerClass,
          cx: cx,
          cy: cy,
          r: r
        }));
      }

      return null;
    }
  }]);

  return Dot;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class2.displayName = 'Dot', _class2.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cx: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  cy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  r: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
}, _temp)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (Dot);

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(27),
    isObjectLike = __webpack_require__(24);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 38 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
});


/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_smooth__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_smooth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_smooth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_PureRender__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Rectangle
 */







var getRectangePath = function getRectangePath(x, y, width, height, radius) {
  var maxRadius = Math.min(Math.abs(width) / 2, Math.abs(height) / 2);
  var sign = height >= 0 ? 1 : -1;
  var clockWise = height >= 0 ? 1 : 0;
  var path = void 0;

  if (maxRadius > 0 && radius instanceof Array) {
    var newRadius = [];
    for (var i = 0, len = 4; i < len; i++) {
      newRadius[i] = radius[i] > maxRadius ? maxRadius : radius[i];
    }

    path = 'M' + x + ',' + (y + sign * newRadius[0]);

    if (newRadius[0] > 0) {
      path += 'A ' + newRadius[0] + ',' + newRadius[0] + ',0,0,' + clockWise + ',' + (x + newRadius[0]) + ',' + y;
    }

    path += 'L ' + (x + width - newRadius[1]) + ',' + y;

    if (newRadius[1] > 0) {
      path += 'A ' + newRadius[1] + ',' + newRadius[1] + ',0,0,' + clockWise + ',\n        ' + (x + width) + ',' + (y + sign * newRadius[1]);
    }
    path += 'L ' + (x + width) + ',' + (y + height - sign * newRadius[2]);

    if (newRadius[2] > 0) {
      path += 'A ' + newRadius[2] + ',' + newRadius[2] + ',0,0,' + clockWise + ',\n        ' + (x + width - newRadius[2]) + ',' + (y + height);
    }
    path += 'L ' + (x + newRadius[3]) + ',' + (y + height);

    if (newRadius[3] > 0) {
      path += 'A ' + newRadius[3] + ',' + newRadius[3] + ',0,0,' + clockWise + ',\n        ' + x + ',' + (y + height - sign * newRadius[3]);
    }
    path += 'Z';
  } else if (maxRadius > 0 && radius === +radius && radius > 0) {
    var _newRadius = Math.min(maxRadius, radius);

    path = 'M ' + x + ',' + (y + sign * _newRadius) + '\n            A ' + _newRadius + ',' + _newRadius + ',0,0,' + clockWise + ',' + (x + _newRadius) + ',' + y + '\n            L ' + (x + width - _newRadius) + ',' + y + '\n            A ' + _newRadius + ',' + _newRadius + ',0,0,' + clockWise + ',' + (x + width) + ',' + (y + sign * _newRadius) + '\n            L ' + (x + width) + ',' + (y + height - sign * _newRadius) + '\n            A ' + _newRadius + ',' + _newRadius + ',0,0,' + clockWise + ',' + (x + width - _newRadius) + ',' + (y + height) + '\n            L ' + (x + _newRadius) + ',' + (y + height) + '\n            A ' + _newRadius + ',' + _newRadius + ',0,0,' + clockWise + ',' + x + ',' + (y + height - sign * _newRadius) + ' Z';
  } else {
    path = 'M ' + x + ',' + y + ' h ' + width + ' v ' + height + ' h ' + -width + ' Z';
  }

  return path;
};

var Rectangle = Object(__WEBPACK_IMPORTED_MODULE_4__util_PureRender__["a" /* default */])(_class = (_temp2 = _class2 = function (_Component) {
  _inherits(Rectangle, _Component);

  function Rectangle() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Rectangle);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Rectangle.__proto__ || Object.getPrototypeOf(Rectangle)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      totalLength: -1
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Rectangle, [{
    key: 'componentDidMount',


    /* eslint-disable  react/no-did-mount-set-state */
    value: function componentDidMount() {
      if (this.node && this.node.getTotalLength) {
        var totalLength = this.node.getTotalLength();

        if (totalLength) {
          this.setState({
            totalLength: totalLength
          });
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          x = _props.x,
          y = _props.y,
          width = _props.width,
          height = _props.height,
          radius = _props.radius,
          className = _props.className;
      var totalLength = this.state.totalLength;
      var _props2 = this.props,
          animationEasing = _props2.animationEasing,
          animationDuration = _props2.animationDuration,
          animationBegin = _props2.animationBegin,
          isAnimationActive = _props2.isAnimationActive,
          isUpdateAnimationActive = _props2.isUpdateAnimationActive;


      if (x !== +x || y !== +y || width !== +width || height !== +height || width === 0 || height === 0) {
        return null;
      }

      var layerClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('recharts-rectangle', className);

      if (!isUpdateAnimationActive) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', _extends({}, Object(__WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__["k" /* getPresentationAttributes */])(this.props), Object(__WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__["e" /* filterEventAttributes */])(this.props), {
          className: layerClass,
          d: getRectangePath(x, y, width, height, radius)
        }));
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_smooth___default.a,
        {
          canBegin: totalLength > 0,
          from: { width: width, height: height, x: x, y: y },
          to: { width: width, height: height, x: x, y: y },
          duration: animationDuration,
          animationEasing: animationEasing,
          isActive: isUpdateAnimationActive
        },
        function (_ref2) {
          var currWidth = _ref2.width,
              currHeight = _ref2.height,
              currX = _ref2.x,
              currY = _ref2.y;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_smooth___default.a,
            {
              canBegin: totalLength > 0,
              from: '0px ' + (totalLength === -1 ? 1 : totalLength) + 'px',
              to: totalLength + 'px 0px',
              attributeName: 'strokeDasharray',
              begin: animationBegin,
              duration: animationDuration,
              isActive: isAnimationActive,
              easing: animationEasing
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', _extends({}, Object(__WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__["k" /* getPresentationAttributes */])(_this2.props), Object(__WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__["e" /* filterEventAttributes */])(_this2.props), {
              className: layerClass,
              d: getRectangePath(currX, currY, currWidth, currHeight, radius),
              ref: function ref(node) {
                _this2.node = node;
              }
            }))
          );
        }
      );
    }
  }]);

  return Rectangle;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class2.displayName = 'Rectangle', _class2.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], __WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__["a" /* EVENT_ATTRIBUTES */], {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  x: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  y: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  radius: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array]),
  isAnimationActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isUpdateAnimationActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  animationBegin: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  animationDuration: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  animationEasing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
}), _class2.defaultProps = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  // The radius of border
  // The radius of four corners when radius is a number
  // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
  radius: 0,
  isAnimationActive: false,
  isUpdateAnimationActive: false,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: 'ease'
}, _temp2)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (Rectangle);

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isArray__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_shape__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_PureRender__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_DataUtils__ = __webpack_require__(6);



var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Curve
 */









var CURVE_FACTORIES = {
  curveBasisClosed: __WEBPACK_IMPORTED_MODULE_4_d3_shape__["c" /* curveBasisClosed */], curveBasisOpen: __WEBPACK_IMPORTED_MODULE_4_d3_shape__["d" /* curveBasisOpen */], curveBasis: __WEBPACK_IMPORTED_MODULE_4_d3_shape__["b" /* curveBasis */], curveLinearClosed: __WEBPACK_IMPORTED_MODULE_4_d3_shape__["f" /* curveLinearClosed */], curveLinear: __WEBPACK_IMPORTED_MODULE_4_d3_shape__["e" /* curveLinear */],
  curveMonotoneX: __WEBPACK_IMPORTED_MODULE_4_d3_shape__["g" /* curveMonotoneX */], curveMonotoneY: __WEBPACK_IMPORTED_MODULE_4_d3_shape__["h" /* curveMonotoneY */], curveNatural: __WEBPACK_IMPORTED_MODULE_4_d3_shape__["i" /* curveNatural */], curveStep: __WEBPACK_IMPORTED_MODULE_4_d3_shape__["j" /* curveStep */], curveStepAfter: __WEBPACK_IMPORTED_MODULE_4_d3_shape__["k" /* curveStepAfter */],
  curveStepBefore: __WEBPACK_IMPORTED_MODULE_4_d3_shape__["l" /* curveStepBefore */]
};

var defined = function defined(p) {
  return p.x === +p.x && p.y === +p.y;
};
var getX = function getX(p) {
  return p.x;
};
var getY = function getY(p) {
  return p.y;
};

var getCurveFactory = function getCurveFactory(type, layout) {
  if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(type)) {
    return type;
  }

  var name = 'curve' + type.slice(0, 1).toUpperCase() + type.slice(1);

  if (name === 'curveMonotone' && layout) {
    return CURVE_FACTORIES['' + name + (layout === 'vertical' ? 'Y' : 'X')];
  }
  return CURVE_FACTORIES[name] || __WEBPACK_IMPORTED_MODULE_4_d3_shape__["e" /* curveLinear */];
};

var Curve = Object(__WEBPACK_IMPORTED_MODULE_6__util_PureRender__["a" /* default */])(_class = (_temp = _class2 = function (_Component) {
  _inherits(Curve, _Component);

  function Curve() {
    _classCallCheck(this, Curve);

    return _possibleConstructorReturn(this, (Curve.__proto__ || Object.getPrototypeOf(Curve)).apply(this, arguments));
  }

  _createClass(Curve, [{
    key: 'getPath',

    /**
     * Calculate the path of curve
     * @return {String} path
     */
    value: function getPath() {
      var _props = this.props,
          type = _props.type,
          points = _props.points,
          baseLine = _props.baseLine,
          layout = _props.layout,
          connectNulls = _props.connectNulls;

      var curveFactory = getCurveFactory(type, layout);
      var formatPoints = connectNulls ? points.filter(function (entry) {
        return defined(entry);
      }) : points;
      var lineFunction = void 0;

      if (__WEBPACK_IMPORTED_MODULE_0_lodash_isArray___default()(baseLine)) {
        var areaPoints = formatPoints.map(function (entry, index) {
          return _extends({}, entry, { base: baseLine[index] });
        });
        if (layout === 'vertical') {
          lineFunction = Object(__WEBPACK_IMPORTED_MODULE_4_d3_shape__["a" /* area */])().y(getY).x1(getX).x0(function (d) {
            return d.base.x;
          });
        } else {
          lineFunction = Object(__WEBPACK_IMPORTED_MODULE_4_d3_shape__["a" /* area */])().x(getX).y1(getY).y0(function (d) {
            return d.base.y;
          });
        }
        lineFunction.defined(defined).curve(curveFactory);

        return lineFunction(areaPoints);
      } else if (layout === 'vertical' && Object(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["g" /* isNumber */])(baseLine)) {
        lineFunction = Object(__WEBPACK_IMPORTED_MODULE_4_d3_shape__["a" /* area */])().y(getY).x1(getX).x0(baseLine);
      } else if (Object(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["g" /* isNumber */])(baseLine)) {
        lineFunction = Object(__WEBPACK_IMPORTED_MODULE_4_d3_shape__["a" /* area */])().x(getX).y1(getY).y0(baseLine);
      } else {
        lineFunction = Object(__WEBPACK_IMPORTED_MODULE_4_d3_shape__["m" /* line */])().x(getX).y(getY);
      }

      lineFunction.defined(defined).curve(curveFactory);

      return lineFunction(formatPoints);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          className = _props2.className,
          points = _props2.points,
          path = _props2.path,
          pathRef = _props2.pathRef;


      if ((!points || !points.length) && !path) {
        return null;
      }

      var realPath = points && points.length ? this.getPath() : path;

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('path', _extends({}, Object(__WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["k" /* getPresentationAttributes */])(this.props), Object(__WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["e" /* filterEventAttributes */])(this.props, null, true), {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()('recharts-curve', className),
        d: realPath,
        ref: pathRef
      }));
    }
  }]);

  return Curve;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]), _class2.displayName = 'Curve', _class2.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  type: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func]),
  layout: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['horizontal', 'vertical']),
  baseLine: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array]),
  points: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object),
  connectNulls: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  pathRef: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func
}), _class2.defaultProps = {
  type: 'linear',
  points: [],
  connectNulls: false
}, _temp)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (Curve);

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_PureRender__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview X Axis
 */





var XAxis = Object(__WEBPACK_IMPORTED_MODULE_2__util_PureRender__["a" /* default */])(_class = (_temp = _class2 = function (_Component) {
  _inherits(XAxis, _Component);

  function XAxis() {
    _classCallCheck(this, XAxis);

    return _possibleConstructorReturn(this, (XAxis.__proto__ || Object.getPrototypeOf(XAxis)).apply(this, arguments));
  }

  _createClass(XAxis, [{
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return XAxis;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class2.displayName = 'XAxis', _class2.propTypes = {
  allowDecimals: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  allowDuplicatedCategory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  // The name of data displayed in the axis
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  // The unit of data displayed in the axis
  unit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  // The unique id of x-axis
  xAxisId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  domain: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['auto', 'dataMin', 'dataMax'])])),
  // The key of data displayed in the axis
  dataKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  // The width of axis which is usually calculated internally
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  // The height of axis, which need to be setted by user
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  mirror: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  // The orientation of axis
  orientation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['top', 'bottom']),
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['number', 'category']),
  // Ticks can be any type when the axis is the type of category
  // Ticks must be numbers when the axis is the type of number
  ticks: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  // The count of ticks
  tickCount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  // The formatter function of tick
  tickFormatter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  padding: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    left: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    right: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  }),
  allowDataOverflow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  scale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__["d" /* SCALE_TYPES */]), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  tick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element]),
  axisLine: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]),
  tickLine: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]),
  minTickGap: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  tickSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  interval: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['preserveStart', 'preserveEnd', 'preserveStartEnd'])]),
  reversed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
}, _class2.defaultProps = {
  allowDecimals: true,
  hide: false,
  orientation: 'bottom',
  width: 0,
  height: 30,
  mirror: false,
  xAxisId: 0,
  tickCount: 5,
  type: 'category',
  domain: [0, 'auto'],
  padding: { left: 0, right: 0 },
  allowDataOverflow: false,
  scale: 'auto',
  reversed: false,
  allowDuplicatedCategory: true
}, _temp)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (XAxis);

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_PureRender__ = __webpack_require__(4);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Y Axis
 */




var YAxis = Object(__WEBPACK_IMPORTED_MODULE_2__util_PureRender__["a" /* default */])(_class = (_temp = _class2 = function (_Component) {
  _inherits(YAxis, _Component);

  function YAxis() {
    _classCallCheck(this, YAxis);

    return _possibleConstructorReturn(this, (YAxis.__proto__ || Object.getPrototypeOf(YAxis)).apply(this, arguments));
  }

  _createClass(YAxis, [{
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return YAxis;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class2.displayName = 'YAxis', _class2.propTypes = {
  allowDecimals: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  allowDuplicatedCategory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  // The name of data displayed in the axis
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  // The unit of data displayed in the axis
  unit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  // The unique id of y-axis
  yAxisId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  domain: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['auto', 'dataMin', 'dataMax'])])),
  // The key of data displayed in the axis
  dataKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  // Ticks can be any type when the axis is the type of category
  // Ticks must be numbers when the axis is the type of number
  ticks: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  // The count of ticks
  tickCount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  // The formatter function of tick
  tickFormatter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  // The width of axis, which need to be setted by user
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  // The height of axis which is usually calculated in Chart
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  mirror: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  // The orientation of axis
  orientation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['left', 'right']),
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['number', 'category']),
  padding: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    top: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    bottom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  }),
  allowDataOverflow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  scale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utcTime', 'sequential', 'threshold']), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  tick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element]),
  axisLine: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]),
  tickLine: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]),
  minTickGap: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  tickSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  interval: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['preserveStart', 'preserveEnd', 'preserveStartEnd'])]),
  reversed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
}, _class2.defaultProps = {
  allowDuplicatedCategory: true,
  allowDecimals: true,
  hide: false,
  orientation: 'left',
  width: 60,
  height: 0,
  mirror: false,
  yAxisId: 0,
  tickCount: 5,
  type: 'number',
  domain: [0, 'auto'],
  padding: { top: 0, bottom: 0 },
  allowDataOverflow: false,
  scale: 'auto',
  reversed: false
}, _temp)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (YAxis);

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * @fileOverview Surface
 */





var propTypes = {
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  viewBox: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    y: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  }),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node])
};
function Surface(props) {
  var children = props.children,
      width = props.width,
      height = props.height,
      viewBox = props.viewBox,
      className = props.className,
      style = props.style,
      others = _objectWithoutProperties(props, ['children', 'width', 'height', 'viewBox', 'className', 'style']);

  var svgView = viewBox || { width: width, height: height, x: 0, y: 0 };
  var layerClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('recharts-surface', className);
  var attrs = Object(__WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__["k" /* getPresentationAttributes */])(others);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'svg',
    _extends({}, attrs, {
      className: layerClass,
      width: width,
      height: height,
      style: style,
      viewBox: svgView.x + ' ' + svgView.y + ' ' + svgView.width + ' ' + svgView.height,
      version: '1.1'
    }),
    children
  );
}

Surface.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (Surface);

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(16);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_path__ = __webpack_require__(327);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_path__["a"]; });



/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return abs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return atan2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return cos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return max; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return min; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return sin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return sqrt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return epsilon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return pi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return halfPi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return tau; });
/* harmony export (immutable) */ __webpack_exports__["b"] = acos;
/* harmony export (immutable) */ __webpack_exports__["c"] = asin;
var abs = Math.abs;
var atan2 = Math.atan2;
var cos = Math.cos;
var max = Math.max;
var min = Math.min;
var sin = Math.sin;
var sqrt = Math.sqrt;

var epsilon = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var tau = 2 * pi;

function acos(x) {
  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}

function asin(x) {
  return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
}


/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 1)) return;
  for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
    s0 = s1, s1 = series[order[i]];
    for (j = 0; j < m; ++j) {
      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
  }
});


/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  var n = series.length, o = new Array(n);
  while (--n >= 0) o[n] = n;
  return o;
});


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(5),
    isLength = __webpack_require__(109);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(413),
    baseMatchesProperty = __webpack_require__(416),
    identity = __webpack_require__(38),
    isArray = __webpack_require__(8),
    property = __webpack_require__(420);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_ReactUtils__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * @fileOverview Cross
 */



function Cell() {
  return null;
}

Cell.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_1__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */]);
Cell.displayName = 'Cell';

/* harmony default export */ __webpack_exports__["a"] = (Cell);

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x === null ? NaN : +x;
});


/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = linearish;
/* harmony export (immutable) */ __webpack_exports__["a"] = linear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__continuous__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tickFormat__ = __webpack_require__(491);





function linearish(scale) {
  var domain = scale.domain;

  scale.ticks = function(count) {
    var d = domain();
    return Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["h" /* ticks */])(d[0], d[d.length - 1], count == null ? 10 : count);
  };

  scale.tickFormat = function(count, specifier) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__tickFormat__["a" /* default */])(domain(), count, specifier);
  };

  scale.nice = function(count) {
    if (count == null) count = 10;

    var d = domain(),
        i0 = 0,
        i1 = d.length - 1,
        start = d[i0],
        stop = d[i1],
        step;

    if (stop < start) {
      step = start, start = stop, stop = step;
      step = i0, i0 = i1, i1 = step;
    }

    step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["f" /* tickIncrement */])(start, stop, count);

    if (step > 0) {
      start = Math.floor(start / step) * step;
      stop = Math.ceil(stop / step) * step;
      step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["f" /* tickIncrement */])(start, stop, count);
    } else if (step < 0) {
      start = Math.ceil(start * step) / step;
      stop = Math.floor(stop * step) / step;
      step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["f" /* tickIncrement */])(start, stop, count);
    }

    if (step > 0) {
      d[i0] = Math.floor(start / step) * step;
      d[i1] = Math.ceil(stop / step) * step;
      domain(d);
    } else if (step < 0) {
      d[i0] = Math.ceil(start * step) / step;
      d[i1] = Math.floor(stop * step) / step;
      domain(d);
    }

    return scale;
  };

  return scale;
}

function linear() {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["b" /* default */])(__WEBPACK_IMPORTED_MODULE_2__continuous__["c" /* deinterpolateLinear */], __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["c" /* interpolateNumber */]);

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["a" /* copy */])(scale, linear());
  };

  return linearish(scale);
}


/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_value__ = __webpack_require__(114);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_value__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_array__ = __webpack_require__(196);
/* unused harmony reexport interpolateArray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_basis__ = __webpack_require__(117);
/* unused harmony reexport interpolateBasis */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_basisClosed__ = __webpack_require__(194);
/* unused harmony reexport interpolateBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_date__ = __webpack_require__(197);
/* unused harmony reexport interpolateDate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_number__ = __webpack_require__(77);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_5__src_number__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_object__ = __webpack_require__(198);
/* unused harmony reexport interpolateObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_round__ = __webpack_require__(481);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_7__src_round__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_string__ = __webpack_require__(199);
/* unused harmony reexport interpolateString */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_transform_index__ = __webpack_require__(482);
/* unused harmony reexport interpolateTransformCss */
/* unused harmony reexport interpolateTransformSvg */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_zoom__ = __webpack_require__(485);
/* unused harmony reexport interpolateZoom */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_rgb__ = __webpack_require__(193);
/* unused harmony reexport interpolateRgb */
/* unused harmony reexport interpolateRgbBasis */
/* unused harmony reexport interpolateRgbBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_hsl__ = __webpack_require__(486);
/* unused harmony reexport interpolateHsl */
/* unused harmony reexport interpolateHslLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_lab__ = __webpack_require__(487);
/* unused harmony reexport interpolateLab */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_hcl__ = __webpack_require__(488);
/* unused harmony reexport interpolateHcl */
/* unused harmony reexport interpolateHclLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__ = __webpack_require__(489);
/* unused harmony reexport interpolateCubehelix */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_quantize__ = __webpack_require__(490);
/* unused harmony reexport quantize */



















/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = hue;
/* harmony export (immutable) */ __webpack_exports__["b"] = gamma;
/* harmony export (immutable) */ __webpack_exports__["a"] = nogamma;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(195);


function linear(a, d) {
  return function(t) {
    return a + t * d;
  };
}

function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
    return Math.pow(a + t * b, y);
  };
}

function hue(a, b) {
  var d = b - a;
  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
}

function gamma(y) {
  return (y = +y) === 1 ? nogamma : function(a, b) {
    return b - a ? exponential(a, b, y) : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
  };
}

function nogamma(a, b) {
  var d = b - a;
  return d ? linear(a, d) : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
}


/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(s) {
  return s.match(/.{6}/g).map(function(x) {
    return "#" + x;
  });
});


/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__container_Layer__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Render a group of error bar
*/





var ErrorBar = (_temp = _class = function (_Component) {
  _inherits(ErrorBar, _Component);

  function ErrorBar() {
    _classCallCheck(this, ErrorBar);

    return _possibleConstructorReturn(this, (ErrorBar.__proto__ || Object.getPrototypeOf(ErrorBar)).apply(this, arguments));
  }

  _createClass(ErrorBar, [{
    key: 'renderErrorBars',
    value: function renderErrorBars() {
      var _props = this.props,
          offset = _props.offset,
          layout = _props.layout,
          width = _props.width,
          dataKey = _props.dataKey,
          data = _props.data,
          dataPointFormatter = _props.dataPointFormatter,
          xAxis = _props.xAxis,
          yAxis = _props.yAxis,
          others = _objectWithoutProperties(_props, ['offset', 'layout', 'width', 'dataKey', 'data', 'dataPointFormatter', 'xAxis', 'yAxis']);

      var props = Object(__WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__["k" /* getPresentationAttributes */])(others);

      return data.map(function (entry, i) {
        var _dataPointFormatter = dataPointFormatter(entry, dataKey),
            x = _dataPointFormatter.x,
            y = _dataPointFormatter.y,
            value = _dataPointFormatter.value,
            errorVal = _dataPointFormatter.errorVal;

        if (!errorVal) {
          return null;
        }

        var xMid = void 0,
            yMid = void 0,
            xMin = void 0,
            yMin = void 0,
            xMax = void 0,
            yMax = void 0,
            scale = void 0,
            coordsTop = void 0,
            coordsMid = void 0,
            coordsBot = void 0,
            lowBound = void 0,
            highBound = void 0;

        if (Array.isArray(errorVal)) {
          lowBound = errorVal[0];
          highBound = errorVal[1];
        } else {
          lowBound = errorVal;
          highBound = errorVal;
        }

        if (layout === 'vertical') {
          scale = xAxis.scale;
          xMid = value;
          yMid = y + offset;
          xMin = scale(xMid - lowBound);
          yMin = yMid + width;
          xMax = scale(xMid + highBound);
          yMax = yMid - width;
          coordsTop = { x1: xMax, y1: yMin, x2: xMax, y2: yMax };
          coordsMid = { x1: xMin, y1: yMid, x2: xMax, y2: yMid };
          coordsBot = { x1: xMin, y1: yMin, x2: xMin, y2: yMax };
        } else if (layout === 'horizontal') {
          scale = yAxis.scale;
          xMid = x + offset;
          yMid = value;
          xMin = xMid - width;
          xMax = xMid + width;
          yMin = scale(yMid - lowBound);
          yMax = scale(yMid + highBound);
          coordsTop = { x1: xMin, y1: yMax, x2: xMax, y2: yMax };
          coordsMid = { x1: xMid, y1: yMin, x2: xMid, y2: yMax };
          coordsBot = { x1: xMin, y1: yMin, x2: xMax, y2: yMin };
        }

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__container_Layer__["a" /* default */],
          _extends({ className: 'recharts-errorBar', key: i }, props),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line', coordsTop),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line', coordsMid),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line', coordsBot)
        );
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__container_Layer__["a" /* default */],
        { className: 'recharts-errorBars' },
        this.renderErrorBars()
      );
    }
  }]);

  return ErrorBar;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
  dataKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]).isRequired,
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  xAxis: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  yAxis: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  layout: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  dataPointFormatter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  stroke: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  strokeWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  offset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
}, _class.defaultProps = {
  stroke: 'black',
  strokeWidth: 1.5,
  width: 5,
  offset: 0,
  layout: 'horizontal'
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (ErrorBar);

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatAxisMap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ChartUtils__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/**
 * Calculate the scale function, position, width, height of axes
 * @param  {Object} props     Latest props
 * @param  {Object} axisMap   The configuration of axes
 * @param  {Object} offset    The offset of main part in the svg element
 * @param  {String} axisType  The type of axes, x-axis or y-axis
 * @param  {String} chartName The name of chart
 * @return {Object} Configuration
 */
var formatAxisMap = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
  var width = props.width,
      height = props.height,
      layout = props.layout;

  var ids = Object.keys(axisMap);
  var steps = {
    left: offset.left,
    leftMirror: offset.left,
    right: width - offset.right,
    rightMirror: width - offset.right,
    top: offset.top,
    topMirror: offset.top,
    bottom: height - offset.bottom,
    bottomMirror: height - offset.bottom
  };

  return ids.reduce(function (result, id) {
    var axis = axisMap[id];
    var orientation = axis.orientation,
        domain = axis.domain,
        _axis$padding = axis.padding,
        padding = _axis$padding === undefined ? {} : _axis$padding,
        mirror = axis.mirror,
        reversed = axis.reversed;

    var offsetKey = '' + orientation + (mirror ? 'Mirror' : '');

    var range = void 0,
        x = void 0,
        y = void 0,
        needSpace = void 0;

    if (axisType === 'xAxis') {
      range = [offset.left + (padding.left || 0), offset.left + offset.width - (padding.right || 0)];
    } else if (axisType === 'yAxis') {
      range = layout === 'horizontal' ? [offset.top + offset.height - (padding.bottom || 0), offset.top + (padding.top || 0)] : [offset.top + (padding.top || 0), offset.top + offset.height - (padding.bottom || 0)];
    } else {
      range = axis.range;
    }

    if (reversed) {
      range = [range[1], range[0]];
    }

    var _parseScale = Object(__WEBPACK_IMPORTED_MODULE_0__ChartUtils__["A" /* parseScale */])(axis, chartName),
        scale = _parseScale.scale,
        realScaleType = _parseScale.realScaleType;

    scale.domain(domain).range(range);
    Object(__WEBPACK_IMPORTED_MODULE_0__ChartUtils__["c" /* checkDomainOfScale */])(scale);
    var ticks = Object(__WEBPACK_IMPORTED_MODULE_0__ChartUtils__["v" /* getTicksOfScale */])(scale, _extends({}, axis, { realScaleType: realScaleType }));

    if (axisType === 'xAxis') {
      needSpace = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
      x = offset.left;
      y = steps[offsetKey] - needSpace * axis.height;
    } else if (axisType === 'yAxis') {
      needSpace = orientation === 'left' && !mirror || orientation === 'right' && mirror;
      x = steps[offsetKey] - needSpace * axis.width;
      y = offset.top;
    }

    var finalAxis = _extends({}, axis, ticks, {
      realScaleType: realScaleType, x: x, y: y, scale: scale,
      width: axisType === 'xAxis' ? offset.width : axis.width,
      height: axisType === 'yAxis' ? offset.height : axis.height
    });

    finalAxis.bandSize = Object(__WEBPACK_IMPORTED_MODULE_0__ChartUtils__["g" /* getBandSizeOfAxis */])(finalAxis, ticks);

    if (!axis.hide && axisType === 'xAxis') {
      steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.height;
    } else if (!axis.hide) {
      steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.width;
    }

    return _extends({}, result, _defineProperty({}, id, finalAxis));
  }, {});
};

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 61 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(134);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(32);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(313),
    listCacheDelete = __webpack_require__(314),
    listCacheGet = __webpack_require__(315),
    listCacheHas = __webpack_require__(316),
    listCacheSet = __webpack_require__(317);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(95);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(319);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 67 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(37);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var isNumber = __webpack_require__(97);

/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */
function isNaN(value) {
  // An `NaN` primitive is the only value that is not equal to itself.
  // Perform the `toStringTag` check first to avoid errors with some
  // ActiveX objects in IE.
  return isNumber(value) && value != +value;
}

module.exports = isNaN;


/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function Linear(context) {
  this._context = context;
}

Linear.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: this._context.lineTo(x, y); break;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new Linear(context);
});


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {});


/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = point;
/* harmony export (immutable) */ __webpack_exports__["a"] = Basis;
function point(that, x, y) {
  that._context.bezierCurveTo(
    (2 * that._x0 + that._x1) / 3,
    (2 * that._y0 + that._y1) / 3,
    (that._x0 + 2 * that._x1) / 3,
    (that._y0 + 2 * that._y1) / 3,
    (that._x0 + 4 * that._x1 + x) / 6,
    (that._y0 + 4 * that._y1 + y) / 6
  );
}

function Basis(context) {
  this._context = context;
}

Basis.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3: point(this, this._x1, this._y1); // proceed
      case 2: this._context.lineTo(this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
      default: point(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* harmony default export */ __webpack_exports__["b"] = (function(context) {
  return new Basis(context);
});


/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = point;
/* harmony export (immutable) */ __webpack_exports__["a"] = Cardinal;
function point(that, x, y) {
  that._context.bezierCurveTo(
    that._x1 + that._k * (that._x2 - that._x0),
    that._y1 + that._k * (that._y2 - that._y0),
    that._x2 + that._k * (that._x1 - x),
    that._y2 + that._k * (that._y1 - y),
    that._x2,
    that._y2
  );
}

function Cardinal(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

Cardinal.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: point(this, this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
      case 2: this._point = 3; // proceed
      default: point(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(tension) {

  function cardinal(context) {
    return new Cardinal(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_smooth__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_smooth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_smooth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DefaultTooltipContent__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_DataUtils__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_PureRender__ = __webpack_require__(4);



var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Tooltip
 */









var EPS = 1;

var propTypes = {
  content: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func]),
  viewBox: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    y: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    width: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    height: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number
  }),

  active: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  separator: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  formatter: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  offset: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,

  itemStyle: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  labelStyle: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  wrapperStyle: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  cursor: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object]),

  coordinate: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    y: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number
  }),
  position: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    y: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number
  }),

  label: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any,
  payload: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    name: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any,
    value: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array]),
    unit: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any
  })),

  isAnimationActive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  animationDuration: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  animationEasing: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']),
  itemSorter: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  filterNull: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
};

var defaultProps = {
  active: false,
  offset: 10,
  viewBox: { x1: 0, x2: 0, y1: 0, y2: 0 },
  coordinate: { x: 0, y: 0 },
  cursorStyle: {},
  separator: ' : ',
  wrapperStyle: {},
  itemStyle: {},
  labelStyle: {},
  cursor: true,
  isAnimationActive: !Object(__WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["n" /* isSsr */])(),
  animationEasing: 'ease',
  animationDuration: 400,
  itemSorter: function itemSorter() {
    return -1;
  },
  filterNull: true
};

var renderContent = function renderContent(content, props) {
  if (__WEBPACK_IMPORTED_MODULE_2_react___default.a.isValidElement(content)) {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(content, props);
  } else if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(content)) {
    return content(props);
  }

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__DefaultTooltipContent__["a" /* default */], props);
};

var Tooltip = Object(__WEBPACK_IMPORTED_MODULE_8__util_PureRender__["a" /* default */])(_class = (_temp2 = _class2 = function (_Component) {
  _inherits(Tooltip, _Component);

  function Tooltip() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Tooltip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      boxWidth: -1,
      boxHeight: -1
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Tooltip, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.updateBBox();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.updateBBox();
    }
  }, {
    key: 'updateBBox',
    value: function updateBBox() {
      var _state = this.state,
          boxWidth = _state.boxWidth,
          boxHeight = _state.boxHeight;


      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var box = this.wrapperNode.getBoundingClientRect();

        if (Math.abs(box.width - boxWidth) > EPS || Math.abs(box.height - boxHeight) > EPS) {
          this.setState({
            boxWidth: box.width,
            boxHeight: box.height
          });
        }
      } else if (boxWidth !== -1 || boxHeight !== -1) {
        this.setState({
          boxWidth: -1,
          boxHeight: -1
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          payload = _props.payload,
          isAnimationActive = _props.isAnimationActive,
          animationDuration = _props.animationDuration,
          animationEasing = _props.animationEasing,
          filterNull = _props.filterNull;

      var finalPayload = filterNull && payload && payload.length ? payload.filter(function (entry) {
        return !__WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(entry.value);
      }) : payload;
      var hasPayload = finalPayload && finalPayload.length;
      var _props2 = this.props,
          content = _props2.content,
          viewBox = _props2.viewBox,
          coordinate = _props2.coordinate,
          position = _props2.position,
          active = _props2.active,
          offset = _props2.offset,
          wrapperStyle = _props2.wrapperStyle;

      var outerStyle = _extends({
        pointerEvents: 'none',
        visibility: active && hasPayload ? 'visible' : 'hidden',
        position: 'absolute',
        top: 0
      }, wrapperStyle);
      var translateX = void 0,
          translateY = void 0;

      if (position && Object(__WEBPACK_IMPORTED_MODULE_7__util_DataUtils__["g" /* isNumber */])(position.x) && Object(__WEBPACK_IMPORTED_MODULE_7__util_DataUtils__["g" /* isNumber */])(position.y)) {
        translateX = position.x;
        translateY = position.y;
      } else {
        var _state2 = this.state,
            boxWidth = _state2.boxWidth,
            boxHeight = _state2.boxHeight;


        if (boxWidth > 0 && boxHeight > 0 && coordinate) {
          translateX = position && Object(__WEBPACK_IMPORTED_MODULE_7__util_DataUtils__["g" /* isNumber */])(position.x) ? position.x : Math.max(coordinate.x + boxWidth + offset > viewBox.x + viewBox.width ? coordinate.x - boxWidth - offset : coordinate.x + offset, viewBox.x);

          translateY = position && Object(__WEBPACK_IMPORTED_MODULE_7__util_DataUtils__["g" /* isNumber */])(position.y) ? position.y : Math.max(coordinate.y + boxHeight + offset > viewBox.y + viewBox.height ? coordinate.y - boxHeight - offset : coordinate.y + offset, viewBox.y);
        } else {
          outerStyle.visibility = 'hidden';
        }
      }

      outerStyle = _extends({}, outerStyle, Object(__WEBPACK_IMPORTED_MODULE_4_react_smooth__["translateStyle"])({
        transform: 'translate(' + translateX + 'px, ' + translateY + 'px)'
      }));

      if (isAnimationActive && active) {
        outerStyle = _extends({}, outerStyle, Object(__WEBPACK_IMPORTED_MODULE_4_react_smooth__["translateStyle"])({
          transition: 'transform ' + animationDuration + 'ms ' + animationEasing
        }));
      }

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        {
          className: 'recharts-tooltip-wrapper',
          style: outerStyle,
          ref: function ref(node) {
            _this2.wrapperNode = node;
          }
        },
        renderContent(content, _extends({}, this.props, { payload: finalPayload }))
      );
    }
  }]);

  return Tooltip;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]), _class2.displayName = 'Tooltip', _class2.propTypes = propTypes, _class2.defaultProps = defaultProps, _temp2)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (Tooltip);

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.warn = exports.getTransitionVal = exports.compose = exports.translateStyle = exports.mapObject = exports.debugf = exports.debug = exports.log = exports.generatePrefixStyle = exports.getDashCase = exports.identity = exports.getIntersectionKeys = undefined;

var _intersection2 = __webpack_require__(389);

var _intersection3 = _interopRequireDefault(_intersection2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint no-console: 0 */
var PREFIX_LIST = ['Webkit', 'Moz', 'O', 'ms'];
var IN_LINE_PREFIX_LIST = ['-webkit-', '-moz-', '-o-', '-ms-'];
var IN_COMPATIBLE_PROPERTY = ['transform', 'transformOrigin', 'transition'];

var getIntersectionKeys = exports.getIntersectionKeys = function getIntersectionKeys(preObj, nextObj) {
  return (0, _intersection3.default)(Object.keys(preObj), Object.keys(nextObj));
};

var identity = exports.identity = function identity(param) {
  return param;
};

/*
 * @description: convert camel case to dash case
 * string => string
 */
var getDashCase = exports.getDashCase = function getDashCase(name) {
  return name.replace(/([A-Z])/g, function (v) {
    return '-' + v.toLowerCase();
  });
};

/*
 * @description: add compatible style prefix
 * (string, string) => object
 */
var generatePrefixStyle = exports.generatePrefixStyle = function generatePrefixStyle(name, value) {
  if (IN_COMPATIBLE_PROPERTY.indexOf(name) === -1) {
    return _defineProperty({}, name, value);
  }

  var isTransition = name === 'transition';
  var camelName = name.replace(/(\w)/, function (v) {
    return v.toUpperCase();
  });
  var styleVal = value;

  return PREFIX_LIST.reduce(function (result, property, i) {
    if (isTransition) {
      styleVal = value.replace(/(transform|transform-origin)/gim, IN_LINE_PREFIX_LIST[i] + '$1');
    }

    return _extends({}, result, _defineProperty({}, property + camelName, styleVal));
  }, {});
};

var log = exports.log = function log() {
  var _console;

  (_console = console).log.apply(_console, arguments);
};

/*
 * @description: log the value of a varible
 * string => any => any
 */
var debug = exports.debug = function debug(name) {
  return function (item) {
    log(name, item);

    return item;
  };
};

/*
 * @description: log name, args, return value of a function
 * function => function
 */
var debugf = exports.debugf = function debugf(tag, f) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var res = f.apply(undefined, args);
    var name = tag || f.name || 'anonymous function';
    var argNames = '(' + args.map(JSON.stringify).join(', ') + ')';

    log(name + ': ' + argNames + ' => ' + JSON.stringify(res));

    return res;
  };
};

/*
 * @description: map object on every element in this object.
 * (function, object) => object
 */
var mapObject = exports.mapObject = function mapObject(fn, obj) {
  return Object.keys(obj).reduce(function (res, key) {
    return _extends({}, res, _defineProperty({}, key, fn(key, obj[key])));
  }, {});
};

/*
 * @description: add compatible prefix to style
 * object => object
 */
var translateStyle = exports.translateStyle = function translateStyle(style) {
  return Object.keys(style).reduce(function (res, key) {
    return _extends({}, res, generatePrefixStyle(key, res[key]));
  }, style);
};

var compose = exports.compose = function compose() {
  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (!args.length) {
    return identity;
  }

  var fns = args.reverse();
  // first function can receive multiply arguments
  var firstFn = fns[0];
  var tailsFn = fns.slice(1);

  return function () {
    return tailsFn.reduce(function (res, fn) {
      return fn(res);
    }, firstFn.apply(undefined, arguments));
  };
};

var getTransitionVal = exports.getTransitionVal = function getTransitionVal(props, duration, easing) {
  return props.map(function (prop) {
    return getDashCase(prop) + ' ' + duration + 'ms ' + easing;
  }).join(',');
};

var isDev = "production" !== 'production';

var warn = exports.warn = function warn(condition, format, a, b, c, d, e, f) {
  if (isDev && typeof console !== 'undefined' && console.warn) {
    if (format === undefined) {
      console.warn('LogUtils requires an error message argument');
    }

    if (!condition) {
      if (format === undefined) {
        console.warn('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
      } else {
        var args = [a, b, c, d, e, f];
        var argIndex = 0;

        console.warn(format.replace(/%s/g, function () {
          return args[argIndex++];
        }));
      }
    }
  }
};

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(37);

/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */
function baseExtremum(array, iteratee, comparator) {
  var index = -1,
      length = array.length;

  while (++index < length) {
    var value = array[index],
        current = iteratee(value);

    if (current != null && (computed === undefined
          ? (current === current && !isSymbol(current))
          : comparator(current, computed)
        )) {
      var computed = current,
          result = value;
    }
  }
  return result;
}

module.exports = baseExtremum;


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a = +a, b -= a, function(t) {
    return a + b * t;
  };
});


/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = deinterpolateLinear;
/* harmony export (immutable) */ __webpack_exports__["a"] = copy;
/* harmony export (immutable) */ __webpack_exports__["b"] = continuous;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constant__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__number__ = __webpack_require__(200);






var unit = [0, 1];

function deinterpolateLinear(a, b) {
  return (b -= (a = +a))
      ? function(x) { return (x - a) / b; }
      : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */])(b);
}

function deinterpolateClamp(deinterpolate) {
  return function(a, b) {
    var d = deinterpolate(a = +a, b = +b);
    return function(x) { return x <= a ? 0 : x >= b ? 1 : d(x); };
  };
}

function reinterpolateClamp(reinterpolate) {
  return function(a, b) {
    var r = reinterpolate(a = +a, b = +b);
    return function(t) { return t <= 0 ? a : t >= 1 ? b : r(t); };
  };
}

function bimap(domain, range, deinterpolate, reinterpolate) {
  var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
  if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
  else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
  return function(x) { return r0(d0(x)); };
}

function polymap(domain, range, deinterpolate, reinterpolate) {
  var j = Math.min(domain.length, range.length) - 1,
      d = new Array(j),
      r = new Array(j),
      i = -1;

  // Reverse descending domains.
  if (domain[j] < domain[0]) {
    domain = domain.slice().reverse();
    range = range.slice().reverse();
  }

  while (++i < j) {
    d[i] = deinterpolate(domain[i], domain[i + 1]);
    r[i] = reinterpolate(range[i], range[i + 1]);
  }

  return function(x) {
    var i = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* bisect */])(domain, x, 1, j) - 1;
    return r[i](d[i](x));
  };
}

function copy(source, target) {
  return target
      .domain(source.domain())
      .range(source.range())
      .interpolate(source.interpolate())
      .clamp(source.clamp());
}

// deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
function continuous(deinterpolate, reinterpolate) {
  var domain = unit,
      range = unit,
      interpolate = __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["a" /* interpolate */],
      clamp = false,
      piecewise,
      output,
      input;

  function rescale() {
    piecewise = Math.min(domain.length, range.length) > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }

  function scale(x) {
    return (output || (output = piecewise(domain, range, clamp ? deinterpolateClamp(deinterpolate) : deinterpolate, interpolate)))(+x);
  }

  scale.invert = function(y) {
    return (input || (input = piecewise(range, domain, deinterpolateLinear, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
  };

  scale.domain = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_2__array__["a" /* map */].call(_, __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */]), rescale()) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_2__array__["b" /* slice */].call(_), rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = __WEBPACK_IMPORTED_MODULE_2__array__["b" /* slice */].call(_), interpolate = __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["d" /* interpolateRound */], rescale();
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, rescale()) : clamp;
  };

  scale.interpolate = function(_) {
    return arguments.length ? (interpolate = _, rescale()) : interpolate;
  };

  return rescale();
}


/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__(119);


/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x = Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(Math.abs(x)), x ? x[1] : NaN;
});


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_PureRender__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_PolarUtils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_DataUtils__ = __webpack_require__(6);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Sector
 */








var getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
  var sign = Object(__WEBPACK_IMPORTED_MODULE_6__util_DataUtils__["i" /* mathSign */])(endAngle - startAngle);
  var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 359.999);

  return sign * deltaAngle;
};

var getTangentCircle = function getTangentCircle(_ref) {
  var cx = _ref.cx,
      cy = _ref.cy,
      radius = _ref.radius,
      angle = _ref.angle,
      sign = _ref.sign,
      isExternal = _ref.isExternal,
      cornerRadius = _ref.cornerRadius;

  var centerRadius = cornerRadius * (isExternal ? 1 : -1) + radius;
  var theta = Math.asin(cornerRadius / centerRadius) / __WEBPACK_IMPORTED_MODULE_5__util_PolarUtils__["a" /* RADIAN */];
  var centerAngle = angle + sign * theta;
  var center = Object(__WEBPACK_IMPORTED_MODULE_5__util_PolarUtils__["e" /* polarToCartesian */])(cx, cy, centerRadius, centerAngle);
  // The coordinate of point which is tangent to the circle
  var circleTangency = Object(__WEBPACK_IMPORTED_MODULE_5__util_PolarUtils__["e" /* polarToCartesian */])(cx, cy, radius, centerAngle);
  // The coordinate of point which is tangent to the radius line
  var lineTangency = Object(__WEBPACK_IMPORTED_MODULE_5__util_PolarUtils__["e" /* polarToCartesian */])(cx, cy, centerRadius * Math.cos(theta * __WEBPACK_IMPORTED_MODULE_5__util_PolarUtils__["a" /* RADIAN */]), angle);

  return { center: center, circleTangency: circleTangency, lineTangency: lineTangency, theta: theta };
};

var getSectorPath = function getSectorPath(_ref2) {
  var cx = _ref2.cx,
      cy = _ref2.cy,
      innerRadius = _ref2.innerRadius,
      outerRadius = _ref2.outerRadius,
      startAngle = _ref2.startAngle,
      endAngle = _ref2.endAngle;

  var angle = getDeltaAngle(startAngle, endAngle);

  // When the angle of sector equals to 360, star point and end point coincide
  var tempEndAngle = startAngle + angle;
  var outerStartPoint = Object(__WEBPACK_IMPORTED_MODULE_5__util_PolarUtils__["e" /* polarToCartesian */])(cx, cy, outerRadius, startAngle);
  var outerEndPoint = Object(__WEBPACK_IMPORTED_MODULE_5__util_PolarUtils__["e" /* polarToCartesian */])(cx, cy, outerRadius, tempEndAngle);

  var path = 'M ' + outerStartPoint.x + ',' + outerStartPoint.y + '\n    A ' + outerRadius + ',' + outerRadius + ',0,\n    ' + +(Math.abs(angle) > 180) + ',' + +(startAngle > tempEndAngle) + ',\n    ' + outerEndPoint.x + ',' + outerEndPoint.y + '\n  ';

  if (innerRadius > 0) {
    var innerStartPoint = Object(__WEBPACK_IMPORTED_MODULE_5__util_PolarUtils__["e" /* polarToCartesian */])(cx, cy, innerRadius, startAngle);
    var innerEndPoint = Object(__WEBPACK_IMPORTED_MODULE_5__util_PolarUtils__["e" /* polarToCartesian */])(cx, cy, innerRadius, tempEndAngle);
    path += 'L ' + innerEndPoint.x + ',' + innerEndPoint.y + '\n            A ' + innerRadius + ',' + innerRadius + ',0,\n            ' + +(Math.abs(angle) > 180) + ',' + +(startAngle <= tempEndAngle) + ',\n            ' + innerStartPoint.x + ',' + innerStartPoint.y + ' Z';
  } else {
    path += 'L ' + cx + ',' + cy + ' Z';
  }

  return path;
};

var getSectorWithCorner = function getSectorWithCorner(_ref3) {
  var cx = _ref3.cx,
      cy = _ref3.cy,
      innerRadius = _ref3.innerRadius,
      outerRadius = _ref3.outerRadius,
      cornerRadius = _ref3.cornerRadius,
      startAngle = _ref3.startAngle,
      endAngle = _ref3.endAngle;

  var sign = Object(__WEBPACK_IMPORTED_MODULE_6__util_DataUtils__["i" /* mathSign */])(endAngle - startAngle);

  var _getTangentCircle = getTangentCircle({
    cx: cx, cy: cy, radius: outerRadius, angle: startAngle, sign: sign, cornerRadius: cornerRadius
  }),
      soct = _getTangentCircle.circleTangency,
      solt = _getTangentCircle.lineTangency,
      sot = _getTangentCircle.theta;

  var _getTangentCircle2 = getTangentCircle({
    cx: cx, cy: cy, radius: outerRadius, angle: endAngle, sign: -sign, cornerRadius: cornerRadius
  }),
      eoct = _getTangentCircle2.circleTangency,
      eolt = _getTangentCircle2.lineTangency,
      eot = _getTangentCircle2.theta;

  var outerArcAngle = Math.abs(startAngle - endAngle) - sot - eot;

  if (outerArcAngle < 0) {
    return getSectorPath({
      cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, startAngle: startAngle, endAngle: endAngle
    });
  }

  var path = 'M ' + solt.x + ',' + solt.y + '\n    A' + cornerRadius + ',' + cornerRadius + ',0,0,' + +(sign < 0) + ',' + soct.x + ',' + soct.y + '\n    A' + outerRadius + ',' + outerRadius + ',0,' + +(outerArcAngle > 180) + ',' + +(sign < 0) + ',' + eoct.x + ',' + eoct.y + '\n    A' + cornerRadius + ',' + cornerRadius + ',0,0,' + +(sign < 0) + ',' + eolt.x + ',' + eolt.y + '\n  ';

  if (innerRadius > 0) {
    var _getTangentCircle3 = getTangentCircle({
      cx: cx, cy: cy, radius: innerRadius, angle: startAngle, sign: sign, isExternal: true, cornerRadius: cornerRadius
    }),
        sict = _getTangentCircle3.circleTangency,
        silt = _getTangentCircle3.lineTangency,
        sit = _getTangentCircle3.theta;

    var _getTangentCircle4 = getTangentCircle({
      cx: cx, cy: cy, radius: innerRadius, angle: endAngle, sign: -sign, isExternal: true, cornerRadius: cornerRadius
    }),
        eict = _getTangentCircle4.circleTangency,
        eilt = _getTangentCircle4.lineTangency,
        eit = _getTangentCircle4.theta;

    var innerArcAngle = Math.abs(startAngle - endAngle) - sit - eit;

    if (innerArcAngle < 0) {
      return path + 'L' + cx + ',' + cy + 'Z';
    }

    path += 'L' + eilt.x + ',' + eilt.y + '\n      A' + cornerRadius + ',' + cornerRadius + ',0,0,' + +(sign < 0) + ',' + eict.x + ',' + eict.y + '\n      A' + innerRadius + ',' + innerRadius + ',0,' + +(innerArcAngle > 180) + ',' + +(sign > 0) + ',' + sict.x + ',' + sict.y + '\n      A' + cornerRadius + ',' + cornerRadius + ',0,0,' + +(sign < 0) + ',' + silt.x + ',' + silt.y + 'Z';
  } else {
    path += 'L' + cx + ',' + cy + 'Z';
  }

  return path;
};

var Sector = Object(__WEBPACK_IMPORTED_MODULE_3__util_PureRender__["a" /* default */])(_class = (_temp = _class2 = function (_Component) {
  _inherits(Sector, _Component);

  function Sector() {
    _classCallCheck(this, Sector);

    return _possibleConstructorReturn(this, (Sector.__proto__ || Object.getPrototypeOf(Sector)).apply(this, arguments));
  }

  _createClass(Sector, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          cx = _props.cx,
          cy = _props.cy,
          innerRadius = _props.innerRadius,
          outerRadius = _props.outerRadius,
          cornerRadius = _props.cornerRadius,
          startAngle = _props.startAngle,
          endAngle = _props.endAngle,
          className = _props.className;


      if (outerRadius < innerRadius || startAngle === endAngle) {
        return null;
      }

      var layerClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('recharts-sector', className);
      var deltaRadius = outerRadius - innerRadius;
      var cr = Object(__WEBPACK_IMPORTED_MODULE_6__util_DataUtils__["c" /* getPercentValue */])(cornerRadius, deltaRadius, 0, true);
      var path = void 0;

      if (cr > 0 && Math.abs(startAngle - endAngle) < 360) {
        path = getSectorWithCorner({
          cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius,
          cornerRadius: Math.min(cr, deltaRadius / 2),
          startAngle: startAngle, endAngle: endAngle
        });
      } else {
        path = getSectorPath({ cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, startAngle: startAngle, endAngle: endAngle });
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', _extends({}, Object(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["k" /* getPresentationAttributes */])(this.props), Object(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["e" /* filterEventAttributes */])(this.props), {
        className: layerClass,
        d: path
      }));
    }
  }]);

  return Sector;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class2.displayName = 'Sector', _class2.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cx: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  cy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  innerRadius: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  outerRadius: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  startAngle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  endAngle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  cornerRadius: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
}), _class2.defaultProps = {
  cx: 0,
  cy: 0,
  innerRadius: 0,
  outerRadius: 0,
  startAngle: 0,
  endAngle: 0,
  cornerRadius: 0
}, _temp)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (Sector);

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_minBy__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_minBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_minBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_maxBy__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_maxBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_maxBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_PureRender__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__component_Text__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__component_Label__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__container_Layer__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_PolarUtils__ = __webpack_require__(14);




var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview The axis of polar coordinate system
 */










var PolarRadiusAxis = Object(__WEBPACK_IMPORTED_MODULE_5__util_PureRender__["a" /* default */])(_class = (_temp = _class2 = function (_Component) {
  _inherits(PolarRadiusAxis, _Component);

  function PolarRadiusAxis() {
    _classCallCheck(this, PolarRadiusAxis);

    return _possibleConstructorReturn(this, (PolarRadiusAxis.__proto__ || Object.getPrototypeOf(PolarRadiusAxis)).apply(this, arguments));
  }

  _createClass(PolarRadiusAxis, [{
    key: 'getTickValueCoord',


    /**
     * Calculate the coordinate of tick
     * @param  {Number} coordinate The radius of tick
     * @return {Object} (x, y)
     */
    value: function getTickValueCoord(_ref) {
      var coordinate = _ref.coordinate;
      var _props = this.props,
          angle = _props.angle,
          cx = _props.cx,
          cy = _props.cy;


      return Object(__WEBPACK_IMPORTED_MODULE_10__util_PolarUtils__["e" /* polarToCartesian */])(cx, cy, coordinate, angle);
    }
  }, {
    key: 'getTickTextAnchor',
    value: function getTickTextAnchor() {
      var orientation = this.props.orientation;

      var textAnchor = void 0;

      switch (orientation) {
        case 'left':
          textAnchor = 'end';
          break;
        case 'right':
          textAnchor = 'start';
          break;
        default:
          textAnchor = 'middle';
          break;
      }

      return textAnchor;
    }
  }, {
    key: 'getViewBox',
    value: function getViewBox() {
      var _props2 = this.props,
          cx = _props2.cx,
          cy = _props2.cy,
          angle = _props2.angle,
          ticks = _props2.ticks;

      var maxRadiusTick = __WEBPACK_IMPORTED_MODULE_2_lodash_maxBy___default()(ticks, function (entry) {
        return entry.coordinate || 0;
      });
      var minRadiusTick = __WEBPACK_IMPORTED_MODULE_1_lodash_minBy___default()(ticks, function (entry) {
        return entry.coordinate || 0;
      });

      return {
        cx: cx, cy: cy,
        startAngle: angle,
        endAngle: angle,
        innerRadius: minRadiusTick.coordinate || 0,
        outerRadius: maxRadiusTick.coordinate || 0
      };
    }
  }, {
    key: 'renderAxisLine',
    value: function renderAxisLine() {
      var _props3 = this.props,
          cx = _props3.cx,
          cy = _props3.cy,
          angle = _props3.angle,
          ticks = _props3.ticks,
          axisLine = _props3.axisLine,
          others = _objectWithoutProperties(_props3, ['cx', 'cy', 'angle', 'ticks', 'axisLine']);

      var extent = ticks.reduce(function (result, entry) {
        return [Math.min(result[0], entry.coordinate), Math.max(result[1], entry.coordinate)];
      }, [Infinity, -Infinity]);
      var point0 = Object(__WEBPACK_IMPORTED_MODULE_10__util_PolarUtils__["e" /* polarToCartesian */])(cx, cy, extent[0], angle);
      var point1 = Object(__WEBPACK_IMPORTED_MODULE_10__util_PolarUtils__["e" /* polarToCartesian */])(cx, cy, extent[1], angle);

      var props = _extends({}, Object(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["k" /* getPresentationAttributes */])(others), {
        fill: 'none'
      }, Object(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["k" /* getPresentationAttributes */])(axisLine), {
        x1: point0.x,
        y1: point0.y,
        x2: point1.x,
        y2: point1.y
      });

      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('line', _extends({ className: 'recharts-polar-radius-axis-line' }, props));
    }
  }, {
    key: 'renderTickItem',
    value: function renderTickItem(option, props, value) {
      var tickItem = void 0;

      if (__WEBPACK_IMPORTED_MODULE_3_react___default.a.isValidElement(option)) {
        tickItem = __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(option)) {
        tickItem = option(props);
      } else {
        tickItem = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__component_Text__["a" /* default */],
          _extends({}, props, {
            className: 'recharts-polar-radius-axis-tick-value'
          }),
          value
        );
      }

      return tickItem;
    }
  }, {
    key: 'renderTicks',
    value: function renderTicks() {
      var _this2 = this;

      var _props4 = this.props,
          ticks = _props4.ticks,
          tick = _props4.tick,
          angle = _props4.angle,
          tickFormatter = _props4.tickFormatter,
          stroke = _props4.stroke,
          others = _objectWithoutProperties(_props4, ['ticks', 'tick', 'angle', 'tickFormatter', 'stroke']);

      var textAnchor = this.getTickTextAnchor();
      var axisProps = Object(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["k" /* getPresentationAttributes */])(others);
      var customTickProps = Object(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["k" /* getPresentationAttributes */])(tick);

      var items = ticks.map(function (entry, i) {
        var coord = _this2.getTickValueCoord(entry);
        var tickProps = _extends({
          textAnchor: textAnchor,
          transform: 'rotate(' + (90 - angle) + ', ' + coord.x + ', ' + coord.y + ')'
        }, axisProps, {
          stroke: 'none', fill: stroke
        }, customTickProps, {
          index: i
        }, coord, {
          payload: entry
        });

        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */],
          _extends({
            className: 'recharts-polar-radius-axis-tick',
            key: 'tick-' + i
          }, Object(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["f" /* filterEventsOfChild */])(_this2.props, entry, i)),
          _this2.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value) : entry.value)
        );
      });

      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */],
        { className: 'recharts-polar-radius-axis-ticks' },
        items
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props5 = this.props,
          ticks = _props5.ticks,
          axisLine = _props5.axisLine,
          tick = _props5.tick;


      if (!ticks || !ticks.length) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */],
        { className: 'recharts-polar-radius-axis' },
        axisLine && this.renderAxisLine(),
        tick && this.renderTicks(),
        __WEBPACK_IMPORTED_MODULE_7__component_Label__["a" /* default */].renderCallByParent(this.props, this.getViewBox())
      );
    }
  }]);

  return PolarRadiusAxis;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]), _class2.displayName = 'PolarRadiusAxis', _class2.axisType = 'radiusAxis', _class2.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], __WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["a" /* EVENT_ATTRIBUTES */], {
  type: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['number', 'category']),
  cx: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  cy: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  hide: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  radiusAxisId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number]),

  angle: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  tickCount: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  ticks: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    value: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,
    coordinate: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number
  })),
  orientation: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['left', 'right', 'middle']),
  axisLine: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object]),
  tick: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func]),
  stroke: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  tickFormatter: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  domain: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['auto', 'dataMin', 'dataMax'])])),
  scale: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utcTime', 'sequential', 'threshold']), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func]),
  allowDataOverflow: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  allowDuplicatedCategory: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool
}), _class2.defaultProps = {
  type: 'number',
  radiusAxisId: 0,
  cx: 0,
  cy: 0,
  angle: 0,
  orientation: 'right',
  stroke: '#ccc',
  axisLine: true,
  tick: true,
  tickCount: 5,
  domain: [0, 'auto'],
  allowDataOverflow: false,
  scale: 'auto',
  allowDuplicatedCategory: true
}, _temp)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (PolarRadiusAxis);

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_PureRender__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__container_Layer__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shape_Dot__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shape_Polygon__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__component_Text__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_PolarUtils__ = __webpack_require__(14);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Axis of radial direction
 */











var RADIAN = Math.PI / 180;
var eps = 1e-5;

var PolarAngleAxis = Object(__WEBPACK_IMPORTED_MODULE_3__util_PureRender__["a" /* default */])(_class = (_temp = _class2 = function (_Component) {
  _inherits(PolarAngleAxis, _Component);

  function PolarAngleAxis() {
    _classCallCheck(this, PolarAngleAxis);

    return _possibleConstructorReturn(this, (PolarAngleAxis.__proto__ || Object.getPrototypeOf(PolarAngleAxis)).apply(this, arguments));
  }

  _createClass(PolarAngleAxis, [{
    key: 'getTickLineCoord',


    /**
     * Calculate the coordinate of line endpoint
     * @param  {Object} data The Data if ticks
     * @return {Object} (x0, y0): The start point of text,
     *                  (x1, y1): The end point close to text,
     *                  (x2, y2): The end point close to axis
     */
    value: function getTickLineCoord(data) {
      var _props = this.props,
          cx = _props.cx,
          cy = _props.cy,
          radius = _props.radius,
          orientation = _props.orientation,
          tickLine = _props.tickLine;

      var tickLineSize = tickLine && tickLine.size || 8;
      var p1 = Object(__WEBPACK_IMPORTED_MODULE_9__util_PolarUtils__["e" /* polarToCartesian */])(cx, cy, radius, data.coordinate);
      var p2 = Object(__WEBPACK_IMPORTED_MODULE_9__util_PolarUtils__["e" /* polarToCartesian */])(cx, cy, radius + (orientation === 'inner' ? -1 : 1) * tickLineSize, data.coordinate);

      return { x1: p1.x, y1: p1.y, x2: p2.x, y2: p2.y };
    }
    /**
     * Get the text-anchor of each tick
     * @param  {Object} data Data of ticks
     * @return {String} text-anchor
     */

  }, {
    key: 'getTickTextAnchor',
    value: function getTickTextAnchor(data) {
      var orientation = this.props.orientation;

      var cos = Math.cos(-data.coordinate * RADIAN);
      var textAnchor = void 0;

      if (cos > eps) {
        textAnchor = orientation === 'outer' ? 'start' : 'end';
      } else if (cos < -eps) {
        textAnchor = orientation === 'outer' ? 'end' : 'start';
      } else {
        textAnchor = 'middle';
      }

      return textAnchor;
    }
  }, {
    key: 'renderAxisLine',
    value: function renderAxisLine() {
      var _props2 = this.props,
          cx = _props2.cx,
          cy = _props2.cy,
          radius = _props2.radius,
          axisLine = _props2.axisLine,
          axisLineType = _props2.axisLineType;

      var props = _extends({}, Object(__WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__["k" /* getPresentationAttributes */])(this.props), {
        fill: 'none'
      }, Object(__WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__["k" /* getPresentationAttributes */])(axisLine));

      if (axisLineType === 'circle') {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shape_Dot__["a" /* default */], _extends({
          className: 'recharts-polar-angle-axis-line'
        }, props, {
          cx: cx,
          cy: cy,
          r: radius
        }));
      }
      var ticks = this.props.ticks;

      var points = ticks.map(function (entry) {
        return Object(__WEBPACK_IMPORTED_MODULE_9__util_PolarUtils__["e" /* polarToCartesian */])(cx, cy, radius, entry.coordinate);
      });

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shape_Polygon__["a" /* default */], _extends({ className: 'recharts-polar-angle-axis-line' }, props, { points: points }));
    }
  }, {
    key: 'renderTickItem',
    value: function renderTickItem(option, props, value) {
      var tickItem = void 0;

      if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(option)) {
        tickItem = __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(option)) {
        tickItem = option(props);
      } else {
        tickItem = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8__component_Text__["a" /* default */],
          _extends({}, props, {
            className: 'recharts-polar-angle-axis-tick-value'
          }),
          value
        );
      }

      return tickItem;
    }
  }, {
    key: 'renderTicks',
    value: function renderTicks() {
      var _this2 = this;

      var _props3 = this.props,
          ticks = _props3.ticks,
          tick = _props3.tick,
          tickLine = _props3.tickLine,
          tickFormatter = _props3.tickFormatter,
          stroke = _props3.stroke;

      var axisProps = Object(__WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__["k" /* getPresentationAttributes */])(this.props);
      var customTickProps = Object(__WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__["k" /* getPresentationAttributes */])(tick);
      var tickLineProps = _extends({}, axisProps, { fill: 'none' }, Object(__WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__["k" /* getPresentationAttributes */])(tickLine));

      var items = ticks.map(function (entry, i) {
        var lineCoord = _this2.getTickLineCoord(entry);
        var textAnchor = _this2.getTickTextAnchor(entry);
        var tickProps = _extends({
          textAnchor: textAnchor
        }, axisProps, {
          stroke: 'none', fill: stroke
        }, customTickProps, {
          index: i, payload: entry,
          x: lineCoord.x2, y: lineCoord.y2
        });

        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__container_Layer__["a" /* default */],
          _extends({
            className: 'recharts-polar-angle-axis-tick',
            key: 'tick-' + i
          }, Object(__WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__["f" /* filterEventsOfChild */])(_this2.props, entry, i)),
          tickLine && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('line', _extends({
            className: 'recharts-polar-angle-axis-tick-line'
          }, tickLineProps, lineCoord)),
          tick && _this2.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value) : entry.value)
        );
      });

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__container_Layer__["a" /* default */],
        { className: 'recharts-polar-angle-axis-ticks' },
        items
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          ticks = _props4.ticks,
          radius = _props4.radius,
          axisLine = _props4.axisLine;


      if (radius <= 0 || !ticks || !ticks.length) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__container_Layer__["a" /* default */],
        { className: 'recharts-polar-angle-axis' },
        axisLine && this.renderAxisLine(),
        this.renderTicks()
      );
    }
  }]);

  return PolarAngleAxis;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class2.displayName = 'PolarAngleAxis', _class2.axisType = 'angleAxis', _class2.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], __WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__["a" /* EVENT_ATTRIBUTES */], {
  type: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['number', 'category']),
  angleAxisId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
  dataKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func]),
  cx: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  cy: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  radius: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
  hide: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  scale: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__["d" /* SCALE_TYPES */]), __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func]),

  axisLine: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object]),
  axisLineType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['polygon', 'circle']),
  tickLine: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object]),
  tick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element]),

  ticks: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
    coordinate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number
  })),
  stroke: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  orientation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['inner', 'outer']),
  tickFormatter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  allowDuplicatedCategory: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
}), _class2.defaultProps = {
  type: 'category',
  angleAxisId: 0,
  scale: 'auto',
  cx: 0,
  cy: 0,
  domain: [0, 'auto'],
  orientation: 'outer',
  axisLine: true,
  tickLine: true,
  tick: true,
  hide: false,
  allowDuplicatedCategory: true
}, _temp)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (PolarAngleAxis);

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_PureRender__ = __webpack_require__(4);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Z Axis
 */




var ZAxis = Object(__WEBPACK_IMPORTED_MODULE_2__util_PureRender__["a" /* default */])(_class = (_temp = _class2 = function (_Component) {
  _inherits(ZAxis, _Component);

  function ZAxis() {
    _classCallCheck(this, ZAxis);

    return _possibleConstructorReturn(this, (ZAxis.__proto__ || Object.getPrototypeOf(ZAxis)).apply(this, arguments));
  }

  _createClass(ZAxis, [{
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return ZAxis;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class2.displayName = 'ZAxis', _class2.propTypes = {
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['number', 'category']),
  // The name of data displayed in the axis
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  // The unit of data displayed in the axis
  unit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  // The unique id of z-axis
  zAxisId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  // The key of data displayed in the axis
  dataKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  // The range of axis
  range: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number),
  scale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utcTime', 'sequential', 'threshold']), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
}, _class2.defaultProps = {
  zAxisId: 0,
  range: [64, 64],
  scale: 'auto',
  type: 'number'
}, _temp)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (ZAxis);

/***/ }),
/* 84 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 86 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 87 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.1' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 88 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(61)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 90 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 91 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(27),
    isArray = __webpack_require__(8),
    isObjectLike = __webpack_require__(24);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(8),
    isSymbol = __webpack_require__(37);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(302),
    mapCacheDelete = __webpack_require__(318),
    mapCacheGet = __webpack_require__(320),
    mapCacheHas = __webpack_require__(321),
    mapCacheSet = __webpack_require__(322);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 95 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(32),
    root = __webpack_require__(16);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(27),
    isObjectLike = __webpack_require__(24);

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' ||
    (isObjectLike(value) && baseGetTag(value) == numberTag);
}

module.exports = isNumber;


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_PureRender__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DefaultLegendContent__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_DataUtils__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__ = __webpack_require__(3);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Legend
 */








var renderContent = function renderContent(content, props) {
  if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(content)) {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(content, props);
  } else if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(content)) {
    return content(props);
  }

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__DefaultLegendContent__["a" /* default */], props);
};

var EPS = 1;
var ICON_TYPES = __WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["b" /* LEGEND_TYPES */].filter(function (type) {
  return type !== 'none';
});

var Legend = Object(__WEBPACK_IMPORTED_MODULE_3__util_PureRender__["a" /* default */])(_class = (_temp2 = _class2 = function (_Component) {
  _inherits(Legend, _Component);

  function Legend() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Legend);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Legend.__proto__ || Object.getPrototypeOf(Legend)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      boxWidth: -1,
      boxHeight: -1
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Legend, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.updateBBox();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.updateBBox();
    }
  }, {
    key: 'getBBox',
    value: function getBBox() {
      var _state = this.state,
          boxWidth = _state.boxWidth,
          boxHeight = _state.boxHeight;


      if (boxWidth >= 0 && boxHeight >= 0) {
        return { width: boxWidth, height: boxHeight };
      }

      return null;
    }
  }, {
    key: 'getDefaultPosition',
    value: function getDefaultPosition(style) {
      var _props = this.props,
          layout = _props.layout,
          align = _props.align,
          verticalAlign = _props.verticalAlign,
          margin = _props.margin,
          chartWidth = _props.chartWidth,
          chartHeight = _props.chartHeight;

      var hPos = void 0,
          vPos = void 0;

      if (!style || (style.left === undefined || style.left === null) && (style.right === undefined || style.right === null)) {
        if (align === 'center' && layout === 'vertical') {
          var box = this.getBBox() || { width: 0 };
          hPos = { left: ((chartWidth || 0) - box.width) / 2 };
        } else {
          hPos = align === 'right' ? { right: margin && margin.right || 0 } : { left: margin && margin.left || 0 };
        }
      }

      if (!style || (style.top === undefined || style.top === null) && (style.bottom === undefined || style.bottom === null)) {
        if (verticalAlign === 'middle') {
          var _box = this.getBBox() || { height: 0 };
          vPos = { top: ((chartHeight || 0) - _box.height) / 2 };
        } else {
          vPos = verticalAlign === 'bottom' ? { bottom: margin && margin.bottom || 0 } : { top: margin && margin.top || 0 };
        }
      }

      return _extends({}, hPos, vPos);
    }
  }, {
    key: 'updateBBox',
    value: function updateBBox() {
      var _state2 = this.state,
          boxWidth = _state2.boxWidth,
          boxHeight = _state2.boxHeight;
      var onBBoxUpdate = this.props.onBBoxUpdate;


      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var box = this.wrapperNode.getBoundingClientRect();

        if (Math.abs(box.width - boxWidth) > EPS || Math.abs(box.height - boxHeight) > EPS) {
          this.setState({
            boxWidth: box.width,
            boxHeight: box.height
          }, function () {
            if (onBBoxUpdate) {
              onBBoxUpdate(box);
            }
          });
        }
      } else if (boxWidth !== -1 || boxHeight !== -1) {
        this.setState({
          boxWidth: -1,
          boxHeight: -1
        }, function () {
          if (onBBoxUpdate) {
            onBBoxUpdate(null);
          }
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          content = _props2.content,
          width = _props2.width,
          height = _props2.height,
          wrapperStyle = _props2.wrapperStyle;

      var outerStyle = _extends({
        position: 'absolute',
        width: width || 'auto',
        height: height || 'auto'
      }, this.getDefaultPosition(wrapperStyle), wrapperStyle);

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        {
          className: 'recharts-legend-wrapper',
          style: outerStyle,
          ref: function ref(node) {
            _this2.wrapperNode = node;
          }
        },
        renderContent(content, this.props)
      );
    }
  }], [{
    key: 'getWithHeight',
    value: function getWithHeight(item, chartWidth) {
      var layout = item.props.layout;


      if (layout === 'vertical' && Object(__WEBPACK_IMPORTED_MODULE_5__util_DataUtils__["g" /* isNumber */])(item.props.height)) {
        return {
          height: item.props.height
        };
      } else if (layout === 'horizontal') {
        return {
          width: item.props.width || chartWidth
        };
      }

      return null;
    }
  }]);

  return Legend;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class2.displayName = 'Legend', _class2.propTypes = {
  content: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func]),
  wrapperStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  chartWidth: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  chartHeight: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  width: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  iconSize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  iconType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(ICON_TYPES),
  layout: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['horizontal', 'vertical']),
  align: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['center', 'left', 'right']),
  verticalAlign: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['top', 'bottom', 'middle']),
  margin: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    top: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    left: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    bottom: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    right: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number
  }),
  payload: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
    id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
    type: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["b" /* LEGEND_TYPES */])
  })),
  formatter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  onBBoxUpdate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
}, _class2.defaultProps = {
  iconSize: 14,
  layout: 'horizontal',
  align: 'center',
  verticalAlign: 'bottom'
}, _temp2)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (Legend);

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_shape__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_PureRender__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Curve
 */







var SYMBOL_FACTORIES = {
  symbolCircle: __WEBPACK_IMPORTED_MODULE_2_d3_shape__["u" /* symbolCircle */], symbolCross: __WEBPACK_IMPORTED_MODULE_2_d3_shape__["v" /* symbolCross */], symbolDiamond: __WEBPACK_IMPORTED_MODULE_2_d3_shape__["w" /* symbolDiamond */],
  symbolSquare: __WEBPACK_IMPORTED_MODULE_2_d3_shape__["x" /* symbolSquare */], symbolStar: __WEBPACK_IMPORTED_MODULE_2_d3_shape__["y" /* symbolStar */], symbolTriangle: __WEBPACK_IMPORTED_MODULE_2_d3_shape__["z" /* symbolTriangle */], symbolWye: __WEBPACK_IMPORTED_MODULE_2_d3_shape__["A" /* symbolWye */]
};
var RADIAN = Math.PI / 180;

var getSymbolFactory = function getSymbolFactory(type) {
  var name = 'symbol' + type.slice(0, 1).toUpperCase() + type.slice(1);

  return SYMBOL_FACTORIES[name] || __WEBPACK_IMPORTED_MODULE_2_d3_shape__["u" /* symbolCircle */];
};

var calculateAreaSize = function calculateAreaSize(size, sizeType, type) {
  if (sizeType === 'area') {
    return size;
  }

  switch (type) {
    case 'cross':
      return 5 * size * size / 9;
    case 'diamond':
      return 0.5 * size * size / Math.sqrt(3);
    case 'square':
      return size * size;
    case 'star':
      {
        var angle = 18 * RADIAN;

        return 1.25 * size * size * (Math.tan(angle) - Math.tan(angle * 2) * Math.pow(Math.tan(angle), 2));
      }
    case 'triangle':
      return Math.sqrt(3) * size * size / 4;
    case 'wye':
      return (21 - 10 * Math.sqrt(3)) * size * size / 8;
    default:
      return Math.PI * size * size / 4;
  }
};

var Symbols = Object(__WEBPACK_IMPORTED_MODULE_4__util_PureRender__["a" /* default */])(_class = (_temp = _class2 = function (_Component) {
  _inherits(Symbols, _Component);

  function Symbols() {
    _classCallCheck(this, Symbols);

    return _possibleConstructorReturn(this, (Symbols.__proto__ || Object.getPrototypeOf(Symbols)).apply(this, arguments));
  }

  _createClass(Symbols, [{
    key: 'getPath',


    /**
     * Calculate the path of curve
     * @return {String} path
     */
    value: function getPath() {
      var _props = this.props,
          size = _props.size,
          sizeType = _props.sizeType,
          type = _props.type;

      var symbolFactory = getSymbolFactory(type);
      var symbol = Object(__WEBPACK_IMPORTED_MODULE_2_d3_shape__["t" /* symbol */])().type(symbolFactory).size(calculateAreaSize(size, sizeType, type));

      return symbol();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          className = _props2.className,
          cx = _props2.cx,
          cy = _props2.cy,
          size = _props2.size;


      if (cx === +cx && cy === +cy && size === +size) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', _extends({}, Object(__WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__["k" /* getPresentationAttributes */])(this.props), Object(__WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__["e" /* filterEventAttributes */])(this.props), {
          className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('recharts-symbols', className),
          transform: 'translate(' + cx + ', ' + cy + ')',
          d: this.getPath()
        }));
      }

      return null;
    }
  }]);

  return Symbols;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class2.displayName = 'Symbols', _class2.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['circle', 'cross', 'diamond', 'square', 'star', 'triangle', 'wye']),
  cx: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  cy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  sizeType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['area', 'diameter'])
}), _class2.defaultProps = {
  type: 'circle',
  size: 64,
  sizeType: 'area'
}, _temp)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (Symbols);

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_arc__ = __webpack_require__(326);
/* unused harmony reexport arc */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_area__ = __webpack_require__(137);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__src_area__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_line__ = __webpack_require__(101);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_2__src_line__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_pie__ = __webpack_require__(328);
/* unused harmony reexport pie */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_areaRadial__ = __webpack_require__(331);
/* unused harmony reexport areaRadial */
/* unused harmony reexport radialArea */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_lineRadial__ = __webpack_require__(139);
/* unused harmony reexport lineRadial */
/* unused harmony reexport radialLine */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_pointRadial__ = __webpack_require__(140);
/* unused harmony reexport pointRadial */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_link_index__ = __webpack_require__(332);
/* unused harmony reexport linkHorizontal */
/* unused harmony reexport linkVertical */
/* unused harmony reexport linkRadial */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_symbol__ = __webpack_require__(333);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_8__src_symbol__["a"]; });
/* unused harmony reexport symbols */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_symbol_circle__ = __webpack_require__(142);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_9__src_symbol_circle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_symbol_cross__ = __webpack_require__(143);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_10__src_symbol_cross__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_symbol_diamond__ = __webpack_require__(144);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_11__src_symbol_diamond__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_symbol_square__ = __webpack_require__(146);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_12__src_symbol_square__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_symbol_star__ = __webpack_require__(145);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_13__src_symbol_star__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_symbol_triangle__ = __webpack_require__(147);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_14__src_symbol_triangle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_symbol_wye__ = __webpack_require__(148);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_15__src_symbol_wye__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_curve_basisClosed__ = __webpack_require__(334);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_16__src_curve_basisClosed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_curve_basisOpen__ = __webpack_require__(335);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_17__src_curve_basisOpen__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_curve_basis__ = __webpack_require__(72);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_18__src_curve_basis__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__src_curve_bundle__ = __webpack_require__(336);
/* unused harmony reexport curveBundle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__src_curve_cardinalClosed__ = __webpack_require__(149);
/* unused harmony reexport curveCardinalClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__src_curve_cardinalOpen__ = __webpack_require__(150);
/* unused harmony reexport curveCardinalOpen */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__src_curve_cardinal__ = __webpack_require__(73);
/* unused harmony reexport curveCardinal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__src_curve_catmullRomClosed__ = __webpack_require__(337);
/* unused harmony reexport curveCatmullRomClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__src_curve_catmullRomOpen__ = __webpack_require__(338);
/* unused harmony reexport curveCatmullRomOpen */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__src_curve_catmullRom__ = __webpack_require__(103);
/* unused harmony reexport curveCatmullRom */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__src_curve_linearClosed__ = __webpack_require__(339);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_26__src_curve_linearClosed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__src_curve_linear__ = __webpack_require__(70);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_27__src_curve_linear__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__src_curve_monotone__ = __webpack_require__(340);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_28__src_curve_monotone__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_28__src_curve_monotone__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__src_curve_natural__ = __webpack_require__(341);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_29__src_curve_natural__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__src_curve_step__ = __webpack_require__(342);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_30__src_curve_step__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_30__src_curve_step__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_30__src_curve_step__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__src_stack__ = __webpack_require__(343);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_31__src_stack__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__src_offset_expand__ = __webpack_require__(344);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_32__src_offset_expand__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__src_offset_diverging__ = __webpack_require__(345);
/* unused harmony reexport stackOffsetDiverging */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__src_offset_none__ = __webpack_require__(48);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_34__src_offset_none__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__src_offset_silhouette__ = __webpack_require__(346);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_35__src_offset_silhouette__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__src_offset_wiggle__ = __webpack_require__(347);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_36__src_offset_wiggle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__src_order_ascending__ = __webpack_require__(104);
/* unused harmony reexport stackOrderAscending */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__src_order_descending__ = __webpack_require__(348);
/* unused harmony reexport stackOrderDescending */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__src_order_insideOut__ = __webpack_require__(349);
/* unused harmony reexport stackOrderInsideOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__src_order_none__ = __webpack_require__(49);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_40__src_order_none__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__src_order_reverse__ = __webpack_require__(350);
/* unused harmony reexport stackOrderReverse */




 // Note: radialArea is deprecated!
 // Note: radialLine is deprecated!









































/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__curve_linear__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__point__ = __webpack_require__(102);





/* harmony default export */ __webpack_exports__["a"] = (function() {
  var x = __WEBPACK_IMPORTED_MODULE_3__point__["a" /* x */],
      y = __WEBPACK_IMPORTED_MODULE_3__point__["b" /* y */],
      defined = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(true),
      context = null,
      curve = __WEBPACK_IMPORTED_MODULE_2__curve_linear__["a" /* default */],
      output = null;

  function line(data) {
    var i,
        n = data.length,
        d,
        defined0 = false,
        buffer;

    if (context == null) output = curve(buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) output.lineStart();
        else output.lineEnd();
      }
      if (defined0) output.point(+x(d, i, data), +y(d, i, data));
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  line.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), line) : x;
  };

  line.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), line) : y;
  };

  line.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(!!_), line) : defined;
  };

  line.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
  };

  line.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
  };

  return line;
});


/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = x;
/* harmony export (immutable) */ __webpack_exports__["b"] = y;
function x(p) {
  return p[0];
}

function y(p) {
  return p[1];
}


/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = point;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cardinal__ = __webpack_require__(73);



function point(that, x, y) {
  var x1 = that._x1,
      y1 = that._y1,
      x2 = that._x2,
      y2 = that._y2;

  if (that._l01_a > __WEBPACK_IMPORTED_MODULE_0__math__["f" /* epsilon */]) {
    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
  }

  if (that._l23_a > __WEBPACK_IMPORTED_MODULE_0__math__["f" /* epsilon */]) {
    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
  }

  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}

function CatmullRom(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRom.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: this.point(this._x2, this._y2); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; // proceed
      default: point(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRom(context, alpha) : new __WEBPACK_IMPORTED_MODULE_1__cardinal__["a" /* Cardinal */](context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = sum;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(49);


/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  var sums = series.map(sum);
  return Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series).sort(function(a, b) { return sums[a] - sums[b]; });
});

function sum(series) {
  var s = 0, i = -1, n = series.length, v;
  while (++i < n) if (v = +series[i][1]) s += v;
  return s;
}


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(351),
    isObjectLike = __webpack_require__(24);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(369),
    baseKeys = __webpack_require__(375),
    isArrayLike = __webpack_require__(50);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(371),
    isObjectLike = __webpack_require__(24);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 108 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 109 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 110 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getStyleString */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getStringSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getOffset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return calculateChartCoordinate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ReactUtils__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



var stringCache = {
  widthCache: {},
  cacheCount: 0
};
var MAX_CACHE_NUM = 2000;
var SPAN_STYLE = {
  position: 'absolute',
  top: '-20000px',
  left: 0,
  padding: 0,
  margin: 0,
  border: 'none',
  whiteSpace: 'pre'
};
var STYLE_LIST = ['minWidth', 'maxWidth', 'width', 'minHeight', 'maxHeight', 'height', 'top', 'left', 'fontSize', 'lineHeight', 'padding', 'margin', 'paddingLeft', 'paddingRight', 'paddingTop', 'paddingBottom', 'marginLeft', 'marginRight', 'marginTop', 'marginBottom'];
var MEASUREMENT_SPAN_ID = 'recharts_measurement_span';

function autoCompleteStyle(name, value) {
  if (STYLE_LIST.indexOf(name) >= 0 && value === +value) {
    return value + 'px';
  }

  return value;
}

function camelToMiddleLine(text) {
  var strs = text.split('');

  var formatStrs = strs.reduce(function (result, entry) {
    if (entry === entry.toUpperCase()) {
      return [].concat(_toConsumableArray(result), ['-', entry.toLowerCase()]);
    }

    return [].concat(_toConsumableArray(result), [entry]);
  }, []);

  return formatStrs.join('');
}

var getStyleString = function getStyleString(style) {
  return Object.keys(style).reduce(function (result, s) {
    return '' + result + camelToMiddleLine(s) + ':' + autoCompleteStyle(s, style[s]) + ';';
  }, '');
};

var getStringSize = function getStringSize(text) {
  var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (text === undefined || text === null || Object(__WEBPACK_IMPORTED_MODULE_0__ReactUtils__["n" /* isSsr */])()) {
    return { width: 0, height: 0 };
  }

  var str = '' + text;
  var styleString = getStyleString(style);
  var cacheKey = str + '-' + styleString;

  if (stringCache.widthCache[cacheKey]) {
    return stringCache.widthCache[cacheKey];
  }

  try {
    var measurementSpan = document.getElementById(MEASUREMENT_SPAN_ID);
    if (!measurementSpan) {
      measurementSpan = document.createElement('span');
      measurementSpan.setAttribute('id', MEASUREMENT_SPAN_ID);
      document.body.appendChild(measurementSpan);
    }

    measurementSpan.setAttribute('style', getStyleString(_extends({}, SPAN_STYLE, style)));
    measurementSpan.textContent = str;

    var rect = measurementSpan.getBoundingClientRect();
    var result = { width: rect.width, height: rect.height };

    stringCache.widthCache[cacheKey] = result;

    if (++stringCache.cacheCount > MAX_CACHE_NUM) {
      stringCache.cacheCount = 0;
      stringCache.widthCache = {};
    }

    return result;
  } catch (e) {
    return { width: 0, height: 0 };
  }
};

var getOffset = function getOffset(el) {
  var html = el.ownerDocument.documentElement;
  var box = { top: 0, left: 0 };

  // If we don't have gBCR, just use 0,0 rather than error
  // BlackBerry 5, iOS 3 (original iPhone)
  if (typeof el.getBoundingClientRect !== 'undefined') {
    box = el.getBoundingClientRect();
  }

  return {
    top: box.top + window.pageYOffset - html.clientTop,
    left: box.left + window.pageXOffset - html.clientLeft
  };
};

/**
 * Calculate coordinate of cursor in chart
 * @param  {Object} event  Event object
 * @param  {Object} offset The offset of main part in the svg element
 * @return {Object}        {chartX, chartY}
 */
var calculateChartCoordinate = function calculateChartCoordinate(event, offset) {
  return {
    chartX: Math.round(event.pageX - offset.left),
    chartY: Math.round(event.pageY - offset.top)
  };
};

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(53);


/* harmony default export */ __webpack_exports__["a"] = (function(values, p, valueof) {
  if (valueof == null) valueof = __WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */];
  if (!(n = values.length)) return;
  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
  var n,
      i = (n - 1) * p,
      i0 = Math.floor(i),
      value0 = +valueof(values[i0], i0, values),
      value1 = +valueof(values[i0 + 1], i0 + 1, values);
  return value0 + (value1 - value0) * (i - i0);
});


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return prefix; });
var prefix = "$";

function Map() {}

Map.prototype = map.prototype = {
  constructor: Map,
  has: function(key) {
    return (prefix + key) in this;
  },
  get: function(key) {
    return this[prefix + key];
  },
  set: function(key, value) {
    this[prefix + key] = value;
    return this;
  },
  remove: function(key) {
    var property = prefix + key;
    return property in this && delete this[property];
  },
  clear: function() {
    for (var property in this) if (property[0] === prefix) delete this[property];
  },
  keys: function() {
    var keys = [];
    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
    return keys;
  },
  values: function() {
    var values = [];
    for (var property in this) if (property[0] === prefix) values.push(this[property]);
    return values;
  },
  entries: function() {
    var entries = [];
    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
    return entries;
  },
  size: function() {
    var size = 0;
    for (var property in this) if (property[0] === prefix) ++size;
    return size;
  },
  empty: function() {
    for (var property in this) if (property[0] === prefix) return false;
    return true;
  },
  each: function(f) {
    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
  }
};

function map(object, f) {
  var map = new Map;

  // Copy constructor.
  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });

  // Index array by numeric index or specified key function.
  else if (Array.isArray(object)) {
    var i = -1,
        n = object.length,
        o;

    if (f == null) while (++i < n) map.set(i, object[i]);
    else while (++i < n) map.set(f(o = object[i], i, object), o);
  }

  // Convert object to map.
  else if (object) for (var key in object) map.set(key, object[key]);

  return map;
}

/* harmony default export */ __webpack_exports__["a"] = (map);


/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rgb__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__date__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__number__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__object__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__string__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constant__ = __webpack_require__(195);









/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var t = typeof b, c;
  return b == null || t === "boolean" ? Object(__WEBPACK_IMPORTED_MODULE_7__constant__["a" /* default */])(b)
      : (t === "number" ? __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */]
      : t === "string" ? ((c = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* color */])(b)) ? (b = c, __WEBPACK_IMPORTED_MODULE_1__rgb__["a" /* default */]) : __WEBPACK_IMPORTED_MODULE_6__string__["a" /* default */])
      : b instanceof __WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* color */] ? __WEBPACK_IMPORTED_MODULE_1__rgb__["a" /* default */]
      : b instanceof Date ? __WEBPACK_IMPORTED_MODULE_3__date__["a" /* default */]
      : Array.isArray(b) ? __WEBPACK_IMPORTED_MODULE_2__array__["a" /* default */]
      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? __WEBPACK_IMPORTED_MODULE_5__object__["a" /* default */]
      : __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */])(a, b);
});


/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Color;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return darker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return brighter; });
/* harmony export (immutable) */ __webpack_exports__["e"] = color;
/* harmony export (immutable) */ __webpack_exports__["h"] = rgbConvert;
/* harmony export (immutable) */ __webpack_exports__["g"] = rgb;
/* harmony export (immutable) */ __webpack_exports__["b"] = Rgb;
/* unused harmony export hslConvert */
/* harmony export (immutable) */ __webpack_exports__["f"] = hsl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(116);


function Color() {}

var darker = 0.7;
var brighter = 1 / darker;

var reI = "\\s*([+-]?\\d+)\\s*",
    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
    reHex3 = /^#([0-9a-f]{3})$/,
    reHex6 = /^#([0-9a-f]{6})$/,
    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");

var named = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Color, color, {
  displayable: function() {
    return this.rgb().displayable();
  },
  toString: function() {
    return this.rgb() + "";
  }
});

function color(format) {
  var m;
  format = (format + "").trim().toLowerCase();
  return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1)) // #f00
      : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
      : named.hasOwnProperty(format) ? rgbn(named[format])
      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
      : null;
}

function rgbn(n) {
  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}

function rgba(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb(r, g, b, a);
}

function rgbConvert(o) {
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Rgb;
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}

function rgb(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}

function Rgb(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Rgb, rgb, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return (0 <= this.r && this.r <= 255)
        && (0 <= this.g && this.g <= 255)
        && (0 <= this.b && this.b <= 255)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  toString: function() {
    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(")
        + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
        + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
        + Math.max(0, Math.min(255, Math.round(this.b) || 0))
        + (a === 1 ? ")" : ", " + a + ")");
  }
}));

function hsla(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;
  else if (l <= 0 || l >= 1) h = s = NaN;
  else if (s <= 0) h = NaN;
  return new Hsl(h, s, l, a);
}

function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Hsl;
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      h = NaN,
      s = max - min,
      l = (max + min) / 2;
  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;
    else if (g === max) h = (b - r) / s + 2;
    else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s, l, o.opacity);
}

function hsl(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}

function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Hsl, hsl, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = this.h % 360 + (this.h < 0) * 360,
        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
        l = this.l,
        m2 = l + (l < 0.5 ? l : 1 - l) * s,
        m1 = 2 * l - m2;
    return new Rgb(
      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
      hsl2rgb(h, m1, m2),
      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
        && (0 <= this.l && this.l <= 1)
        && (0 <= this.opacity && this.opacity <= 1);
  }
}));

/* From FvD 13.37, CSS Color Module Level 3 */
function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60
      : h < 180 ? m2
      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
      : m1) * 255;
}


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = extend;
/* harmony default export */ __webpack_exports__["a"] = (function(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
});

function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}


/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = basis;
function basis(t1, v0, v1, v2, v3) {
  var t2 = t1 * t1, t3 = t2 * t1;
  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
      + (4 - 6 * t2 + 3 * t3) * v1
      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
      + t3 * v3) / 6;
}

/* harmony default export */ __webpack_exports__["b"] = (function(values) {
  var n = values.length - 1;
  return function(t) {
    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
        v1 = values[i],
        v2 = values[i + 1],
        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
    return basis((t - i / n) * n, v0, v1, v2, v3);
  };
});


/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimal(1.23) returns ["123", 0].
/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
  var i, coefficient = x.slice(0, i);

  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
  return [
    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
    +x.slice(i + 1)
  ];
});


/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_interval__ = __webpack_require__(12);
/* unused harmony reexport timeInterval */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_millisecond__ = __webpack_require__(506);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__src_millisecond__["a"]; });
/* unused harmony reexport timeMilliseconds */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_1__src_millisecond__["a"]; });
/* unused harmony reexport utcMilliseconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_second__ = __webpack_require__(507);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_2__src_second__["a"]; });
/* unused harmony reexport timeSeconds */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_2__src_second__["a"]; });
/* unused harmony reexport utcSeconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_minute__ = __webpack_require__(508);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__src_minute__["a"]; });
/* unused harmony reexport timeMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_hour__ = __webpack_require__(509);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__src_hour__["a"]; });
/* unused harmony reexport timeHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_day__ = __webpack_require__(510);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__src_day__["a"]; });
/* unused harmony reexport timeDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_week__ = __webpack_require__(511);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["b"]; });
/* unused harmony reexport timeWeeks */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["b"]; });
/* unused harmony reexport timeSundays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["a"]; });
/* unused harmony reexport timeMondays */
/* unused harmony reexport timeTuesday */
/* unused harmony reexport timeTuesdays */
/* unused harmony reexport timeWednesday */
/* unused harmony reexport timeWednesdays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["c"]; });
/* unused harmony reexport timeThursdays */
/* unused harmony reexport timeFriday */
/* unused harmony reexport timeFridays */
/* unused harmony reexport timeSaturday */
/* unused harmony reexport timeSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_month__ = __webpack_require__(512);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_7__src_month__["a"]; });
/* unused harmony reexport timeMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_year__ = __webpack_require__(513);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_8__src_year__["a"]; });
/* unused harmony reexport timeYears */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_utcMinute__ = __webpack_require__(514);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_9__src_utcMinute__["a"]; });
/* unused harmony reexport utcMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_utcHour__ = __webpack_require__(515);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_10__src_utcHour__["a"]; });
/* unused harmony reexport utcHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_utcDay__ = __webpack_require__(516);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_11__src_utcDay__["a"]; });
/* unused harmony reexport utcDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__ = __webpack_require__(517);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["b"]; });
/* unused harmony reexport utcWeeks */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["b"]; });
/* unused harmony reexport utcSundays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["a"]; });
/* unused harmony reexport utcMondays */
/* unused harmony reexport utcTuesday */
/* unused harmony reexport utcTuesdays */
/* unused harmony reexport utcWednesday */
/* unused harmony reexport utcWednesdays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["c"]; });
/* unused harmony reexport utcThursdays */
/* unused harmony reexport utcFriday */
/* unused harmony reexport utcFridays */
/* unused harmony reexport utcSaturday */
/* unused harmony reexport utcSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_utcMonth__ = __webpack_require__(518);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_13__src_utcMonth__["a"]; });
/* unused harmony reexport utcMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_utcYear__ = __webpack_require__(519);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_14__src_utcYear__["a"]; });
/* unused harmony reexport utcYears */































/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return timeFormat; });
/* unused harmony export timeParse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utcFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return utcParse; });
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__(209);


var locale;
var timeFormat;
var timeParse;
var utcFormat;
var utcParse;

defaultLocale({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});

function defaultLocale(definition) {
  locale = Object(__WEBPACK_IMPORTED_MODULE_0__locale__["a" /* default */])(definition);
  timeFormat = locale.format;
  timeParse = locale.parse;
  utcFormat = locale.utcFormat;
  utcParse = locale.utcParse;
  return locale;
}


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_PureRender__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Polygon
 */






var getPolygonPoints = function getPolygonPoints(points) {
  return points.reduce(function (result, entry) {
    if (entry.x === +entry.x && entry.y === +entry.y) {
      result.push([entry.x, entry.y]);
    }

    return result;
  }, []).join(' ');
};

var Polygon = Object(__WEBPACK_IMPORTED_MODULE_3__util_PureRender__["a" /* default */])(_class = (_temp = _class2 = function (_Component) {
  _inherits(Polygon, _Component);

  function Polygon() {
    _classCallCheck(this, Polygon);

    return _possibleConstructorReturn(this, (Polygon.__proto__ || Object.getPrototypeOf(Polygon)).apply(this, arguments));
  }

  _createClass(Polygon, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          points = _props.points,
          className = _props.className;


      if (!points || !points.length) {
        return null;
      }

      var layerClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('recharts-polygon', className);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon', _extends({}, Object(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["k" /* getPresentationAttributes */])(this.props), Object(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["e" /* filterEventAttributes */])(this.props), {
        className: layerClass,
        points: getPolygonPoints(points)
      }));
    }
  }]);

  return Polygon;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class2.displayName = 'Polygon', _class2.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  points: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    y: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  }))
}), _temp)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (Polygon);

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNil__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_smooth__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_smooth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_smooth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_PureRender__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shape_Curve__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shape_Dot__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__container_Layer__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__component_LabelList__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ErrorBar__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_DataUtils__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_ChartUtils__ = __webpack_require__(11);




var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp2;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Line
 */















var Line = Object(__WEBPACK_IMPORTED_MODULE_7__util_PureRender__["a" /* default */])(_class = (_temp2 = _class2 = function (_Component) {
  _inherits(Line, _Component);

  function Line() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Line);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Line.__proto__ || Object.getPrototypeOf(Line)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isAnimationFinished: true,
      totalLength: 0
    }, _this.id = Object(__WEBPACK_IMPORTED_MODULE_13__util_DataUtils__["j" /* uniqueId */])('recharts-line-'), _this.cachePrevData = function (points) {
      _this.setState({ prevPoints: points });
    }, _this.pathRef = function (node) {
      _this.mainCurve = node;
    }, _this.handleAnimationEnd = function () {
      _this.setState({ isAnimationFinished: true });
      _this.props.onAnimationEnd();
    }, _this.handleAnimationStart = function () {
      _this.setState({ isAnimationFinished: false });
      _this.props.onAnimationStart();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  /**
   * Compose the data of each group
   * @param {Object} props The props from the component
   * @param  {Object} xAxis   The configuration of x-axis
   * @param  {Object} yAxis   The configuration of y-axis
   * @param  {String} dataKey The unique key of a group
   * @return {Array}  Composed data
   */


  _createClass(Line, [{
    key: 'componentDidMount',


    /* eslint-disable  react/no-did-mount-set-state */
    value: function componentDidMount() {
      if (!this.props.isAnimationActive) {
        return;
      }

      var totalLength = this.getTotalLength();
      this.setState({ totalLength: totalLength });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props = this.props,
          animationId = _props.animationId,
          points = _props.points;


      if (nextProps.animationId !== animationId) {
        this.cachePrevData(points);
      }
    }
  }, {
    key: 'getTotalLength',
    value: function getTotalLength() {
      var curveDom = this.mainCurve;
      var totalLength = curveDom && curveDom.getTotalLength && curveDom.getTotalLength() || 0;

      return totalLength;
    }
  }, {
    key: 'getStrokeDasharray',
    value: function getStrokeDasharray(length, totalLength, lines) {
      var lineLength = lines.reduce(function (pre, next) {
        return pre + next;
      });

      var count = parseInt(length / lineLength, 10);
      var remainLength = length % lineLength;
      var restLength = totalLength - length;

      var remainLines = [];
      for (var i = 0, sum = 0;; sum += lines[i], ++i) {
        if (sum + lines[i] > remainLength) {
          remainLines = [].concat(_toConsumableArray(lines.slice(0, i)), [remainLength - sum]);
          break;
        }
      }

      var emptyLines = remainLines.length % 2 === 0 ? [0, restLength] : [restLength];

      return [].concat(_toConsumableArray(this.repeat(lines, count)), _toConsumableArray(remainLines), emptyLines).map(function (line) {
        return line + 'px';
      }).join(', ');
    }
  }, {
    key: 'repeat',
    value: function repeat(lines, count) {
      var linesUnit = lines.length % 2 !== 0 ? [].concat(_toConsumableArray(lines), [0]) : lines;
      var result = [];

      for (var i = 0; i < count; ++i) {
        result = [].concat(_toConsumableArray(result), _toConsumableArray(linesUnit));
      }

      return result;
    }
  }, {
    key: 'renderErrorBar',
    value: function renderErrorBar() {
      if (this.props.isAnimationActive && !this.state.isAnimationFinished) {
        return null;
      }

      var _props2 = this.props,
          points = _props2.points,
          xAxis = _props2.xAxis,
          yAxis = _props2.yAxis,
          layout = _props2.layout,
          children = _props2.children;

      var errorBarItems = Object(__WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["h" /* findAllByType */])(children, __WEBPACK_IMPORTED_MODULE_12__ErrorBar__["a" /* default */]);

      if (!errorBarItems) {
        return null;
      }

      function dataPointFormatter(dataPoint, dataKey) {
        return {
          x: dataPoint.x,
          y: dataPoint.y,
          value: dataPoint.value,
          errorVal: Object(__WEBPACK_IMPORTED_MODULE_15__util_ChartUtils__["w" /* getValueByDataKey */])(dataPoint.payload, dataKey)
        };
      }

      return errorBarItems.map(function (item, i) {
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(item, {
          key: i,
          data: points,
          xAxis: xAxis,
          yAxis: yAxis,
          layout: layout,
          dataPointFormatter: dataPointFormatter
        });
      });
    }
  }, {
    key: 'renderDotItem',
    value: function renderDotItem(option, props) {
      var dotItem = void 0;

      if (__WEBPACK_IMPORTED_MODULE_3_react___default.a.isValidElement(option)) {
        dotItem = __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(option)) {
        dotItem = option(props);
      } else {
        var className = __WEBPACK_IMPORTED_MODULE_6_classnames___default()('recharts-line-dot', option ? option.className : '');
        dotItem = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shape_Dot__["a" /* default */], _extends({}, props, { className: className }));
      }

      return dotItem;
    }
  }, {
    key: 'renderDots',
    value: function renderDots() {
      var _this2 = this;

      var isAnimationActive = this.props.isAnimationActive;


      if (isAnimationActive && !this.state.isAnimationFinished) {
        return null;
      }
      var _props3 = this.props,
          dot = _props3.dot,
          points = _props3.points,
          dataKey = _props3.dataKey;

      var lineProps = Object(__WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["k" /* getPresentationAttributes */])(this.props);
      var customDotProps = Object(__WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["k" /* getPresentationAttributes */])(dot);
      var dotEvents = Object(__WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["e" /* filterEventAttributes */])(dot);
      var dots = points.map(function (entry, i) {
        var dotProps = _extends({
          key: 'dot-' + i,
          r: 3
        }, lineProps, customDotProps, dotEvents, {
          value: entry.value,
          dataKey: dataKey,
          cx: entry.x, cy: entry.y, index: i, payload: entry.payload
        });

        return _this2.renderDotItem(dot, dotProps);
      });

      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10__container_Layer__["a" /* default */],
        { className: 'recharts-line-dots', key: 'dots' },
        dots
      );
    }
  }, {
    key: 'renderCurveStatically',
    value: function renderCurveStatically(points, needClip, props) {
      var _props4 = this.props,
          type = _props4.type,
          layout = _props4.layout,
          connectNulls = _props4.connectNulls,
          id = _props4.id;

      var clipPathId = __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(id) ? this.id : id;
      var curveProps = _extends({}, Object(__WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["k" /* getPresentationAttributes */])(this.props), Object(__WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["e" /* filterEventAttributes */])(this.props), {
        fill: 'none',
        className: 'recharts-line-curve',
        clipPath: needClip ? 'url(#clipPath-' + clipPathId + ')' : null,
        points: points
      }, props, {
        type: type, layout: layout, connectNulls: connectNulls
      });

      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shape_Curve__["a" /* default */], _extends({}, curveProps, { pathRef: this.pathRef }));
    }
  }, {
    key: 'renderCurveWithAnimation',
    value: function renderCurveWithAnimation(needClip) {
      var _this3 = this;

      var _props5 = this.props,
          points = _props5.points,
          strokeDasharray = _props5.strokeDasharray,
          isAnimationActive = _props5.isAnimationActive,
          animationBegin = _props5.animationBegin,
          animationDuration = _props5.animationDuration,
          animationEasing = _props5.animationEasing,
          animationId = _props5.animationId,
          width = _props5.width,
          height = _props5.height,
          other = _objectWithoutProperties(_props5, ['points', 'strokeDasharray', 'isAnimationActive', 'animationBegin', 'animationDuration', 'animationEasing', 'animationId', 'width', 'height']);

      var _state = this.state,
          prevPoints = _state.prevPoints,
          totalLength = _state.totalLength;


      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_smooth___default.a,
        {
          begin: animationBegin,
          duration: animationDuration,
          isActive: isAnimationActive,
          easing: animationEasing,
          from: { t: 0 },
          to: { t: 1 },
          key: 'line-' + animationId,
          onAnimationEnd: this.handleAnimationEnd,
          onAnimationStart: this.handleAnimationStart
        },
        function (_ref2) {
          var t = _ref2.t;

          if (prevPoints) {
            var stepData = points.map(function (entry, index) {
              if (prevPoints[index]) {
                var prev = prevPoints[index];
                var _interpolatorX = Object(__WEBPACK_IMPORTED_MODULE_13__util_DataUtils__["e" /* interpolateNumber */])(prev.x, entry.x);
                var _interpolatorY = Object(__WEBPACK_IMPORTED_MODULE_13__util_DataUtils__["e" /* interpolateNumber */])(prev.y, entry.y);

                return _extends({}, entry, { x: _interpolatorX(t), y: _interpolatorY(t) });
              }

              // magic number of faking previous x and y location
              var interpolatorX = Object(__WEBPACK_IMPORTED_MODULE_13__util_DataUtils__["e" /* interpolateNumber */])(width * 2, entry.x);
              var interpolatorY = Object(__WEBPACK_IMPORTED_MODULE_13__util_DataUtils__["e" /* interpolateNumber */])(height / 2, entry.y);
              return _extends({}, entry, { x: interpolatorX(t), y: interpolatorY(t) });
            });
            return _this3.renderCurveStatically(stepData, needClip);
          }
          var interpolator = Object(__WEBPACK_IMPORTED_MODULE_13__util_DataUtils__["e" /* interpolateNumber */])(0, totalLength);
          var curLength = interpolator(t);
          var currentStrokeDasharray = void 0;

          if (strokeDasharray) {
            var lines = strokeDasharray.split(/[,\s]+/gim).map(function (num) {
              return parseFloat(num);
            });
            currentStrokeDasharray = _this3.getStrokeDasharray(curLength, totalLength, lines);
          } else {
            currentStrokeDasharray = curLength + 'px ' + (totalLength - curLength) + 'px';
          }

          return _this3.renderCurveStatically(points, needClip, {
            strokeDasharray: currentStrokeDasharray
          });
        }
      );
    }
  }, {
    key: 'renderCurve',
    value: function renderCurve(needClip) {
      var _props6 = this.props,
          points = _props6.points,
          isAnimationActive = _props6.isAnimationActive;
      var _state2 = this.state,
          prevPoints = _state2.prevPoints,
          totalLength = _state2.totalLength;


      if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(prevPoints, points))) {
        return this.renderCurveWithAnimation(needClip);
      }

      return this.renderCurveStatically(points, needClip);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props7 = this.props,
          hide = _props7.hide,
          dot = _props7.dot,
          points = _props7.points,
          className = _props7.className,
          xAxis = _props7.xAxis,
          yAxis = _props7.yAxis,
          top = _props7.top,
          left = _props7.left,
          width = _props7.width,
          height = _props7.height,
          isAnimationActive = _props7.isAnimationActive,
          id = _props7.id;


      if (hide || !points || !points.length) {
        return null;
      }

      var isAnimationFinished = this.state.isAnimationFinished;

      var hasSinglePoint = points.length === 1;
      var layerClass = __WEBPACK_IMPORTED_MODULE_6_classnames___default()('recharts-line', className);
      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
      var clipPathId = __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(id) ? this.id : id;

      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10__container_Layer__["a" /* default */],
        { className: layerClass },
        needClip ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'defs',
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'clipPath',
            { id: 'clipPath-' + clipPathId },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('rect', { x: left, y: top, width: width, height: height })
          )
        ) : null,
        !hasSinglePoint && this.renderCurve(needClip),
        this.renderErrorBar(),
        (hasSinglePoint || dot) && this.renderDots(),
        (!isAnimationActive || isAnimationFinished) && __WEBPACK_IMPORTED_MODULE_11__component_LabelList__["a" /* default */].renderCallByParent(this.props, points)
      );
    }
  }]);

  return Line;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]), _class2.displayName = 'Line', _class2.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], __WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["a" /* EVENT_ATTRIBUTES */], {
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  type: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func]),
  unit: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number]),
  name: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number]),
  yAxisId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number]),
  xAxisId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number]),
  yAxis: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  xAxis: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  legendType: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["b" /* LEGEND_TYPES */]),
  layout: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['horizontal', 'vertical']),
  connectNulls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  hide: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,

  // whether have dot in line
  activeDot: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool]),
  dot: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool]),

  top: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  left: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  width: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  points: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    y: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    value: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.value
  })),
  onAnimationStart: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onAnimationEnd: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,

  isAnimationActive: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  animationBegin: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  animationDuration: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  animationEasing: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']),
  animationId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  id: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string
}), _class2.defaultProps = {
  xAxisId: 0,
  yAxisId: 0,
  connectNulls: false,
  activeDot: true,
  dot: true,
  legendType: 'line',
  stroke: '#3182bd',
  strokeWidth: 1,
  fill: '#fff',
  points: [],
  isAnimationActive: !Object(__WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["n" /* isSsr */])(),
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: 'ease',
  hide: false,

  onAnimationStart: function onAnimationStart() {},
  onAnimationEnd: function onAnimationEnd() {}
}, _class2.getComposedData = function (_ref3) {
  var props = _ref3.props,
      xAxis = _ref3.xAxis,
      yAxis = _ref3.yAxis,
      xAxisTicks = _ref3.xAxisTicks,
      yAxisTicks = _ref3.yAxisTicks,
      dataKey = _ref3.dataKey,
      bandSize = _ref3.bandSize,
      displayedData = _ref3.displayedData,
      offset = _ref3.offset;
  var layout = props.layout;


  var points = displayedData.map(function (entry, index) {
    var value = Object(__WEBPACK_IMPORTED_MODULE_15__util_ChartUtils__["w" /* getValueByDataKey */])(entry, dataKey);

    if (layout === 'horizontal') {
      return {
        x: Object(__WEBPACK_IMPORTED_MODULE_15__util_ChartUtils__["l" /* getCateCoordinateOfLine */])({ axis: xAxis, ticks: xAxisTicks, bandSize: bandSize, entry: entry, index: index }),
        y: __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(value) ? null : yAxis.scale(value),
        value: value,
        payload: entry
      };
    }

    return {
      x: __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(value) ? null : xAxis.scale(value),
      y: Object(__WEBPACK_IMPORTED_MODULE_15__util_ChartUtils__["l" /* getCateCoordinateOfLine */])({ axis: yAxis, ticks: yAxisTicks, bandSize: bandSize, entry: entry, index: index }),
      value: value,
      payload: entry
    };
  });

  return _extends({ points: points, layout: layout }, offset);
}, _temp2)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (Line);

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isNaN__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isNaN___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isNaN__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isFunction__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isNil__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isArray__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_smooth__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_smooth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_smooth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shape_Curve__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shape_Dot__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__container_Layer__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__component_LabelList__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_PureRender__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_DataUtils__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__util_ChartUtils__ = __webpack_require__(11);






var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Area
 */














var Area = Object(__WEBPACK_IMPORTED_MODULE_13__util_PureRender__["a" /* default */])(_class = (_temp2 = _class2 = function (_Component) {
  _inherits(Area, _Component);

  function Area() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Area);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Area.__proto__ || Object.getPrototypeOf(Area)).call.apply(_ref, [this].concat(args))), _this), _this.state = { isAnimationFinished: true }, _this.id = Object(__WEBPACK_IMPORTED_MODULE_15__util_DataUtils__["j" /* uniqueId */])('recharts-area-'), _this.cachePrevData = function (points, baseLine) {
      _this.setState({
        prevPoints: points,
        prevBaseLine: baseLine
      });
    }, _this.handleAnimationEnd = function () {
      var onAnimationEnd = _this.props.onAnimationEnd;


      _this.setState({ isAnimationFinished: true });

      if (__WEBPACK_IMPORTED_MODULE_2_lodash_isFunction___default()(onAnimationEnd)) {
        onAnimationEnd();
      }
    }, _this.handleAnimationStart = function () {
      var onAnimationStart = _this.props.onAnimationStart;

      _this.setState({ isAnimationFinished: false });

      if (__WEBPACK_IMPORTED_MODULE_2_lodash_isFunction___default()(onAnimationStart)) {
        onAnimationStart();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Area, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props = this.props,
          animationId = _props.animationId,
          points = _props.points,
          baseLine = _props.baseLine;


      if (nextProps.animationId !== animationId) {
        this.cachePrevData(points, baseLine);
      }
    }
  }, {
    key: 'renderDots',
    value: function renderDots() {
      var _this2 = this;

      var isAnimationActive = this.props.isAnimationActive;


      if (isAnimationActive && !this.state.isAnimationFinished) {
        return null;
      }

      var _props2 = this.props,
          dot = _props2.dot,
          points = _props2.points,
          dataKey = _props2.dataKey;

      var areaProps = Object(__WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["k" /* getPresentationAttributes */])(this.props);
      var customDotProps = Object(__WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["k" /* getPresentationAttributes */])(dot);
      var dotEvents = Object(__WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["e" /* filterEventAttributes */])(dot);

      var dots = points.map(function (entry, i) {
        var dotProps = _extends({
          key: 'dot-' + i,
          r: 3
        }, areaProps, customDotProps, dotEvents, {
          dataKey: dataKey,
          cx: entry.x,
          cy: entry.y,
          index: i,
          value: entry.value,
          payload: entry.payload
        });

        return _this2.constructor.renderDotItem(dot, dotProps);
      });

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11__container_Layer__["a" /* default */],
        { className: 'recharts-area-dots' },
        dots
      );
    }
  }, {
    key: 'renderHorizontalRect',
    value: function renderHorizontalRect(alpha) {
      var _props3 = this.props,
          baseLine = _props3.baseLine,
          points = _props3.points,
          strokeWidth = _props3.strokeWidth;

      var startX = points[0].x;
      var endX = points[points.length - 1].x;
      var width = alpha * Math.abs(startX - endX);
      var maxY = Math.max.apply(null, points.map(function (entry) {
        return entry.y || 0;
      }));

      if (Object(__WEBPACK_IMPORTED_MODULE_15__util_DataUtils__["g" /* isNumber */])(baseLine)) {
        maxY = Math.max(baseLine, maxY);
      } else if (baseLine && __WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default()(baseLine) && baseLine.length) {
        maxY = Math.max(Math.max.apply(null, baseLine.map(function (entry) {
          return entry.y || 0;
        })), maxY);
      }

      if (Object(__WEBPACK_IMPORTED_MODULE_15__util_DataUtils__["g" /* isNumber */])(maxY)) {
        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('rect', {
          x: startX < endX ? startX : startX - width,
          y: 0,
          width: width,
          height: maxY + (strokeWidth || 1)
        });
      }

      return null;
    }
  }, {
    key: 'renderVerticalRect',
    value: function renderVerticalRect(alpha) {
      var _props4 = this.props,
          baseLine = _props4.baseLine,
          points = _props4.points,
          strokeWidth = _props4.strokeWidth;

      var startY = points[0].y;
      var endY = points[points.length - 1].y;
      var height = alpha * Math.abs(startY - endY);
      var maxX = Math.max.apply(null, points.map(function (entry) {
        return entry.x || 0;
      }));

      if (Object(__WEBPACK_IMPORTED_MODULE_15__util_DataUtils__["g" /* isNumber */])(baseLine)) {
        maxX = Math.max(baseLine, maxX);
      } else if (baseLine && __WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default()(baseLine) && baseLine.length) {
        maxX = Math.max(Math.max.apply(null, baseLine.map(function (entry) {
          return entry.x || 0;
        })), maxX);
      }

      if (Object(__WEBPACK_IMPORTED_MODULE_15__util_DataUtils__["g" /* isNumber */])(maxX)) {
        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('rect', {
          x: 0,
          y: startY < endY ? startY : startY - height,
          width: maxX + (strokeWidth || 1),
          height: height
        });
      }

      return null;
    }
  }, {
    key: 'renderClipRect',
    value: function renderClipRect(alpha) {
      var layout = this.props.layout;


      if (layout === 'vertical') {
        return this.renderVerticalRect(alpha);
      }

      return this.renderHorizontalRect(alpha);
    }
  }, {
    key: 'renderAreaStatically',
    value: function renderAreaStatically(points, baseLine, needClip) {
      var _props5 = this.props,
          layout = _props5.layout,
          type = _props5.type,
          stroke = _props5.stroke,
          connectNulls = _props5.connectNulls,
          isRange = _props5.isRange;


      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11__container_Layer__["a" /* default */],
        { clipPath: needClip ? 'url(#clipPath-' + this.id + ')' : null },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shape_Curve__["a" /* default */], _extends({}, this.props, {
          points: points,
          baseLine: baseLine,
          stroke: 'none',
          className: 'recharts-area-area'
        })),
        stroke !== 'none' && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shape_Curve__["a" /* default */], _extends({}, Object(__WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["k" /* getPresentationAttributes */])(this.props), {
          className: 'recharts-area-curve',
          layout: layout,
          type: type,
          connectNulls: connectNulls,
          fill: 'none',
          points: points
        })),
        stroke !== 'none' && isRange && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shape_Curve__["a" /* default */], _extends({}, Object(__WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["k" /* getPresentationAttributes */])(this.props), {
          className: 'recharts-area-curve',
          layout: layout,
          type: type,
          connectNulls: connectNulls,
          fill: 'none',
          points: baseLine
        }))
      );
    }
  }, {
    key: 'renderAreaWithAnimation',
    value: function renderAreaWithAnimation(needClip) {
      var _this3 = this;

      var _props6 = this.props,
          points = _props6.points,
          baseLine = _props6.baseLine,
          isAnimationActive = _props6.isAnimationActive,
          animationBegin = _props6.animationBegin,
          animationDuration = _props6.animationDuration,
          animationEasing = _props6.animationEasing,
          animationId = _props6.animationId,
          id = _props6.id;
      var _state = this.state,
          prevPoints = _state.prevPoints,
          prevBaseLine = _state.prevBaseLine;

      var clipPathId = __WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default()(id) ? this.id : id;

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_smooth___default.a,
        {
          begin: animationBegin,
          duration: animationDuration,
          isActive: isAnimationActive,
          easing: animationEasing,
          from: { t: 0 },
          to: { t: 1 },
          key: 'area-' + animationId,
          onAnimationEnd: this.handleAnimationEnd,
          onAnimationStart: this.handleAnimationStart
        },
        function (_ref2) {
          var t = _ref2.t;

          if (prevPoints) {
            // update animtaion
            var stepPoints = points.map(function (entry, index) {
              if (prevPoints[index]) {
                var prev = prevPoints[index];
                var interpolatorX = Object(__WEBPACK_IMPORTED_MODULE_15__util_DataUtils__["e" /* interpolateNumber */])(prev.x, entry.x);
                var interpolatorY = Object(__WEBPACK_IMPORTED_MODULE_15__util_DataUtils__["e" /* interpolateNumber */])(prev.y, entry.y);

                return _extends({}, entry, { x: interpolatorX(t), y: interpolatorY(t) });
              }

              return entry;
            });
            var stepBaseLine = void 0;

            if (Object(__WEBPACK_IMPORTED_MODULE_15__util_DataUtils__["g" /* isNumber */])(baseLine)) {
              var interpolator = Object(__WEBPACK_IMPORTED_MODULE_15__util_DataUtils__["e" /* interpolateNumber */])(prevBaseLine, baseLine);
              stepBaseLine = interpolator(t);
            } else if (__WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default()(baseLine) || __WEBPACK_IMPORTED_MODULE_1_lodash_isNaN___default()(baseLine)) {
              var _interpolator = Object(__WEBPACK_IMPORTED_MODULE_15__util_DataUtils__["e" /* interpolateNumber */])(prevBaseLine, 0);
              stepBaseLine = _interpolator(t);
            } else {
              stepBaseLine = baseLine.map(function (entry, index) {
                if (prevBaseLine[index]) {
                  var prev = prevBaseLine[index];
                  var interpolatorX = Object(__WEBPACK_IMPORTED_MODULE_15__util_DataUtils__["e" /* interpolateNumber */])(prev.x, entry.x);
                  var interpolatorY = Object(__WEBPACK_IMPORTED_MODULE_15__util_DataUtils__["e" /* interpolateNumber */])(prev.y, entry.y);

                  return _extends({}, entry, { x: interpolatorX(t), y: interpolatorY(t) });
                }

                return entry;
              });
            }

            return _this3.renderAreaStatically(stepPoints, stepBaseLine, needClip);
          }

          return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_11__container_Layer__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              'defs',
              null,
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                'clipPath',
                { id: 'animationClipPath-' + clipPathId },
                _this3.renderClipRect(t)
              )
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11__container_Layer__["a" /* default */],
              { clipPath: 'url(#animationClipPath-' + clipPathId + ')' },
              _this3.renderAreaStatically(points, baseLine, needClip)
            )
          );
        }
      );
    }
  }, {
    key: 'renderArea',
    value: function renderArea(needClip) {
      var _props7 = this.props,
          points = _props7.points,
          baseLine = _props7.baseLine,
          isAnimationActive = _props7.isAnimationActive;
      var _state2 = this.state,
          prevPoints = _state2.prevPoints,
          prevBaseLine = _state2.prevBaseLine,
          totalLength = _state2.totalLength;


      if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(prevPoints, points) || !__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(prevBaseLine, baseLine))) {
        return this.renderAreaWithAnimation(needClip);
      }

      return this.renderAreaStatically(points, baseLine, needClip);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props8 = this.props,
          hide = _props8.hide,
          dot = _props8.dot,
          points = _props8.points,
          className = _props8.className,
          top = _props8.top,
          left = _props8.left,
          xAxis = _props8.xAxis,
          yAxis = _props8.yAxis,
          width = _props8.width,
          height = _props8.height,
          isAnimationActive = _props8.isAnimationActive,
          id = _props8.id;


      if (hide || !points || !points.length) {
        return null;
      }

      var isAnimationFinished = this.state.isAnimationFinished;

      var hasSinglePoint = points.length === 1;
      var layerClass = __WEBPACK_IMPORTED_MODULE_7_classnames___default()('recharts-area', className);
      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
      var clipPathId = __WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default()(id) ? this.id : id;

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11__container_Layer__["a" /* default */],
        { className: layerClass },
        needClip ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'defs',
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'clipPath',
            { id: 'clipPath-' + clipPathId },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('rect', { x: left, y: top, width: width, height: height })
          )
        ) : null,
        !hasSinglePoint ? this.renderArea(needClip) : null,
        (dot || hasSinglePoint) && this.renderDots(),
        (!isAnimationActive || isAnimationFinished) && __WEBPACK_IMPORTED_MODULE_12__component_LabelList__["a" /* default */].renderCallByParent(this.props, points)
      );
    }
  }]);

  return Area;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]), _class2.displayName = 'Area', _class2.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], __WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["a" /* EVENT_ATTRIBUTES */], {
  className: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  dataKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func]).isRequired,
  type: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func]),
  unit: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number]),
  name: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number]),
  yAxisId: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number]),
  xAxisId: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number]),
  yAxis: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  xAxis: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  stackId: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  legendType: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["b" /* LEGEND_TYPES */]),
  connectNulls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  activeDot: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool]),
  // dot configuration
  dot: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool]),
  label: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool]),
  hide: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  // have curve configuration
  layout: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['horizontal', 'vertical']),
  baseLine: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array]),
  isRange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  points: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
    y: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
    value: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array])
  })),

  onAnimationStart: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onAnimationEnd: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  animationId: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  isAnimationActive: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  animationBegin: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  animationDuration: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  animationEasing: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']),

  id: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
}), _class2.defaultProps = {
  stroke: '#3182bd',
  fill: '#3182bd',
  fillOpacity: 0.6,
  xAxisId: 0,
  yAxisId: 0,
  legendType: 'line',
  connectNulls: false,
  // points of area
  points: [],
  dot: false,
  activeDot: true,
  hide: false,

  isAnimationActive: !Object(__WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["n" /* isSsr */])(),
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: 'ease'
}, _class2.getBaseValue = function (props, xAxis, yAxis) {
  var layout = props.layout,
      baseValue = props.baseValue;


  if (Object(__WEBPACK_IMPORTED_MODULE_15__util_DataUtils__["g" /* isNumber */])(baseValue)) {
    return baseValue;
  }

  var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
  var domain = numericAxis.scale.domain();

  if (numericAxis.type === 'number') {
    var max = Math.max(domain[0], domain[1]);
    var min = Math.min(domain[0], domain[1]);

    if (baseValue === 'dataMin') {
      return min;
    }
    if (baseValue === 'dataMax') {
      return max;
    }

    return max < 0 ? max : Math.max(Math.min(domain[0], domain[1]), 0);
  }

  if (baseValue === 'dataMin') {
    return domain[0];
  }
  if (baseValue === 'dataMax') {
    return domain[1];
  }

  return domain[0];
}, _class2.getComposedData = function (_ref3) {
  var props = _ref3.props,
      xAxis = _ref3.xAxis,
      yAxis = _ref3.yAxis,
      xAxisTicks = _ref3.xAxisTicks,
      yAxisTicks = _ref3.yAxisTicks,
      bandSize = _ref3.bandSize,
      dataKey = _ref3.dataKey,
      stackedData = _ref3.stackedData,
      dataStartIndex = _ref3.dataStartIndex,
      displayedData = _ref3.displayedData,
      offset = _ref3.offset;
  var layout = props.layout;

  var hasStack = stackedData && stackedData.length;
  var baseValue = Area.getBaseValue(props, xAxis, yAxis);
  var isRange = false;

  var points = displayedData.map(function (entry, index) {
    var value = void 0;

    if (hasStack) {
      value = stackedData[dataStartIndex + index];
    } else {
      value = Object(__WEBPACK_IMPORTED_MODULE_16__util_ChartUtils__["w" /* getValueByDataKey */])(entry, dataKey);

      if (!__WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default()(value)) {
        value = [baseValue, value];
      } else {
        isRange = true;
      }
    }

    if (layout === 'horizontal') {
      return {
        x: Object(__WEBPACK_IMPORTED_MODULE_16__util_ChartUtils__["l" /* getCateCoordinateOfLine */])({ axis: xAxis, ticks: xAxisTicks, bandSize: bandSize, entry: entry, index: index }),
        y: __WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default()(value[1]) ? null : yAxis.scale(value[1]),
        value: value,
        payload: entry
      };
    }

    return {
      x: __WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default()(value[1]) ? null : xAxis.scale(value[1]),
      y: Object(__WEBPACK_IMPORTED_MODULE_16__util_ChartUtils__["l" /* getCateCoordinateOfLine */])({ axis: yAxis, ticks: yAxisTicks, bandSize: bandSize, entry: entry, index: index }),
      value: value,
      payload: entry
    };
  });

  var baseLine = void 0;
  if (hasStack || isRange) {
    baseLine = points.map(function (entry) {
      return {
        x: layout === 'horizontal' ? entry.x : xAxis.scale(entry && entry.value[0]),
        y: layout === 'horizontal' ? yAxis.scale(entry && entry.value[0]) : entry.y
      };
    });
  } else if (layout === 'horizontal') {
    baseLine = yAxis.scale(baseValue);
  } else {
    baseLine = xAxis.scale(baseValue);
  }

  return _extends({ points: points, baseLine: baseLine, layout: layout, isRange: isRange }, offset);
}, _class2.renderDotItem = function (option, props) {
  var dotItem = void 0;

  if (__WEBPACK_IMPORTED_MODULE_5_react___default.a.isValidElement(option)) {
    dotItem = __WEBPACK_IMPORTED_MODULE_5_react___default.a.cloneElement(option, props);
  } else if (__WEBPACK_IMPORTED_MODULE_2_lodash_isFunction___default()(option)) {
    dotItem = option(props);
  } else {
    dotItem = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shape_Dot__["a" /* default */], _extends({}, props, { className: 'recharts-area-dot' }));
  }

  return dotItem;
}, _temp2)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (Area);

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isEqual__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isFunction__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_smooth__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_smooth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_smooth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shape_Rectangle__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__container_Layer__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ErrorBar__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__component_Cell__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__component_LabelList__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_PureRender__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_DataUtils__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_ReactUtils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__util_ChartUtils__ = __webpack_require__(11);





var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp2;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Render a group of bar
 */















var Bar = Object(__WEBPACK_IMPORTED_MODULE_13__util_PureRender__["a" /* default */])(_class = (_temp2 = _class2 = function (_Component) {
  _inherits(Bar, _Component);

  function Bar() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Bar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Bar.__proto__ || Object.getPrototypeOf(Bar)).call.apply(_ref, [this].concat(args))), _this), _this.state = { isAnimationFinished: false }, _this.id = Object(__WEBPACK_IMPORTED_MODULE_14__util_DataUtils__["j" /* uniqueId */])('recharts-bar-'), _this.cachePrevData = function (data) {
      _this.setState({ prevData: data });
    }, _this.handleAnimationEnd = function () {
      _this.setState({ isAnimationFinished: true });
      _this.props.onAnimationEnd();
    }, _this.handleAnimationStart = function () {
      _this.setState({ isAnimationFinished: false });
      _this.props.onAnimationStart();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  /**
   * Compose the data of each group
   * @param {Object} props Props for the component
   * @param {Object} item        An instance of Bar
   * @param {Array} barPosition  The offset and size of each bar
   * @param {Object} xAxis       The configuration of x-axis
   * @param {Object} yAxis       The configuration of y-axis
   * @param {Array} stackedData  The stacked data of a bar item
   * @return{Array} Composed data
   */


  _createClass(Bar, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props = this.props,
          animationId = _props.animationId,
          data = _props.data;


      if (nextProps.animationId !== animationId) {
        this.cachePrevData(data);
      }
    }
  }, {
    key: 'renderRectangle',
    value: function renderRectangle(option, props) {
      var rectangle = void 0;

      if (__WEBPACK_IMPORTED_MODULE_4_react___default.a.isValidElement(option)) {
        rectangle = __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_2_lodash_isFunction___default()(option)) {
        rectangle = option(props);
      } else {
        rectangle = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shape_Rectangle__["a" /* default */], props);
      }

      return rectangle;
    }
  }, {
    key: 'renderRectanglesStatically',
    value: function renderRectanglesStatically(data) {
      var _this2 = this;

      var shape = this.props.shape;

      var baseProps = Object(__WEBPACK_IMPORTED_MODULE_15__util_ReactUtils__["k" /* getPresentationAttributes */])(this.props);

      return data && data.map(function (entry, i) {
        var props = _extends({}, baseProps, entry, { index: i });

        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__container_Layer__["a" /* default */],
          _extends({
            className: 'recharts-bar-rectangle'
          }, Object(__WEBPACK_IMPORTED_MODULE_15__util_ReactUtils__["f" /* filterEventsOfChild */])(_this2.props, entry, i), {
            key: 'rectangle-' + i
          }),
          _this2.renderRectangle(shape, props)
        );
      });
    }
  }, {
    key: 'renderRectanglesWithAnimation',
    value: function renderRectanglesWithAnimation() {
      var _this3 = this;

      var _props2 = this.props,
          data = _props2.data,
          layout = _props2.layout,
          isAnimationActive = _props2.isAnimationActive,
          animationBegin = _props2.animationBegin,
          animationDuration = _props2.animationDuration,
          animationEasing = _props2.animationEasing,
          animationId = _props2.animationId,
          width = _props2.width;
      var prevData = this.state.prevData;


      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_smooth___default.a,
        {
          begin: animationBegin,
          duration: animationDuration,
          isActive: isAnimationActive,
          easing: animationEasing,
          from: { t: 0 },
          to: { t: 1 },
          key: 'bar-' + animationId,
          onAnimationEnd: this.handleAnimationEnd,
          onAnimationStart: this.handleAnimationStart
        },
        function (_ref2) {
          var t = _ref2.t;

          var stepData = data.map(function (entry, index) {
            var prev = prevData && prevData[index];

            if (prev) {
              var interpolatorX = Object(__WEBPACK_IMPORTED_MODULE_14__util_DataUtils__["e" /* interpolateNumber */])(prev.x, entry.x);
              var interpolatorY = Object(__WEBPACK_IMPORTED_MODULE_14__util_DataUtils__["e" /* interpolateNumber */])(prev.y, entry.y);
              var interpolatorWidth = Object(__WEBPACK_IMPORTED_MODULE_14__util_DataUtils__["e" /* interpolateNumber */])(prev.width, entry.width);
              var interpolatorHeight = Object(__WEBPACK_IMPORTED_MODULE_14__util_DataUtils__["e" /* interpolateNumber */])(prev.height, entry.height);

              return _extends({}, entry, {
                x: interpolatorX(t),
                y: interpolatorY(t),
                width: interpolatorWidth(t),
                height: interpolatorHeight(t)
              });
            }

            if (layout === 'horizontal') {
              var _interpolatorHeight = Object(__WEBPACK_IMPORTED_MODULE_14__util_DataUtils__["e" /* interpolateNumber */])(0, entry.height);
              var h = _interpolatorHeight(t);

              return _extends({}, entry, {
                y: entry.y + entry.height - h,
                height: h
              });
            }

            var interpolator = Object(__WEBPACK_IMPORTED_MODULE_14__util_DataUtils__["e" /* interpolateNumber */])(0, entry.width);
            var w = interpolator(t);

            return _extends({}, entry, { width: w });
          });

          return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__container_Layer__["a" /* default */],
            null,
            _this3.renderRectanglesStatically(stepData)
          );
        }
      );
    }
  }, {
    key: 'renderRectangles',
    value: function renderRectangles() {
      var _props3 = this.props,
          data = _props3.data,
          isAnimationActive = _props3.isAnimationActive;
      var prevData = this.state.prevData;


      if (isAnimationActive && data && data.length && (!prevData || !__WEBPACK_IMPORTED_MODULE_1_lodash_isEqual___default()(prevData, data))) {
        return this.renderRectanglesWithAnimation();
      }

      return this.renderRectanglesStatically(data);
    }
  }, {
    key: 'renderBackground',
    value: function renderBackground(sectors) {
      var _this4 = this;

      var data = this.props.data;

      var backgroundProps = Object(__WEBPACK_IMPORTED_MODULE_15__util_ReactUtils__["k" /* getPresentationAttributes */])(this.props.background);

      return data.map(function (entry, i) {
        // eslint-disable-next-line no-unused-vars
        var value = entry.value,
            background = entry.background,
            rest = _objectWithoutProperties(entry, ['value', 'background']);

        if (!background) {
          return null;
        }

        var props = _extends({}, rest, {
          fill: '#eee'
        }, background, backgroundProps, Object(__WEBPACK_IMPORTED_MODULE_15__util_ReactUtils__["f" /* filterEventsOfChild */])(_this4.props, entry, i), {
          index: i,
          key: 'background-bar-' + i,
          className: 'recharts-bar-background-rectangle'
        });

        return _this4.renderRectangle(background, props);
      });
    }
  }, {
    key: 'renderErrorBar',
    value: function renderErrorBar() {
      if (this.props.isAnimationActive && !this.state.isAnimationFinished) {
        return null;
      }

      var _props4 = this.props,
          data = _props4.data,
          xAxis = _props4.xAxis,
          yAxis = _props4.yAxis,
          layout = _props4.layout,
          children = _props4.children;

      var errorBarItems = Object(__WEBPACK_IMPORTED_MODULE_15__util_ReactUtils__["h" /* findAllByType */])(children, __WEBPACK_IMPORTED_MODULE_10__ErrorBar__["a" /* default */]);

      if (!errorBarItems) {
        return null;
      }

      var offset = layout === 'vertical' ? data[0].height / 2 : data[0].width / 2;

      function dataPointFormatter(dataPoint, dataKey) {
        return {
          x: dataPoint.x,
          y: dataPoint.y,
          value: dataPoint.value,
          errorVal: Object(__WEBPACK_IMPORTED_MODULE_16__util_ChartUtils__["w" /* getValueByDataKey */])(dataPoint, dataKey)
        };
      }

      return errorBarItems.map(function (item, i) {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(item, {
          key: i,
          data: data,
          xAxis: xAxis,
          yAxis: yAxis,
          layout: layout,
          offset: offset,
          dataPointFormatter: dataPointFormatter
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props5 = this.props,
          hide = _props5.hide,
          data = _props5.data,
          className = _props5.className,
          xAxis = _props5.xAxis,
          yAxis = _props5.yAxis,
          left = _props5.left,
          top = _props5.top,
          width = _props5.width,
          height = _props5.height,
          isAnimationActive = _props5.isAnimationActive,
          background = _props5.background,
          id = _props5.id;

      if (hide || !data || !data.length) {
        return null;
      }

      var isAnimationFinished = this.state.isAnimationFinished;

      var layerClass = __WEBPACK_IMPORTED_MODULE_6_classnames___default()('recharts-bar', className);
      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
      var clipPathId = __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(id) ? this.id : id;

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__container_Layer__["a" /* default */],
        { className: layerClass },
        needClip ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          'defs',
          null,
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            'clipPath',
            { id: 'clipPath-' + clipPathId },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('rect', { x: left, y: top, width: width, height: height })
          )
        ) : null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__container_Layer__["a" /* default */],
          {
            className: 'recharts-bar-rectangles',
            clipPath: needClip ? 'url(#clipPath-' + clipPathId + ')' : null
          },
          background ? this.renderBackground() : null,
          this.renderRectangles()
        ),
        this.renderErrorBar(),
        (!isAnimationActive || isAnimationFinished) && __WEBPACK_IMPORTED_MODULE_12__component_LabelList__["a" /* default */].renderCallByParent(this.props, data)
      );
    }
  }]);

  return Bar;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]), _class2.displayName = 'Bar', _class2.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_15__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], __WEBPACK_IMPORTED_MODULE_15__util_ReactUtils__["a" /* EVENT_ATTRIBUTES */], {
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  layout: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['vertical', 'horizontal']),
  xAxisId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),
  yAxisId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),
  yAxis: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  xAxis: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  stackId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),
  barSize: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  unit: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number]),
  name: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number]),
  dataKey: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func]).isRequired,
  legendType: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_15__util_ReactUtils__["b" /* LEGEND_TYPES */]),
  minPointSize: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  maxBarSize: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  hide: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  shape: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.element]),
  data: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    y: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    width: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    height: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    radius: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.array]),
    value: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.array])
  })),
  onAnimationStart: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onAnimationEnd: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  animationId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  isAnimationActive: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  animationBegin: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  animationDuration: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  animationEasing: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']),
  id: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
}), _class2.defaultProps = {
  xAxisId: 0,
  yAxisId: 0,
  legendType: 'rect',
  minPointSize: 0,
  hide: false,
  // data of bar
  data: [],
  layout: 'vertical',
  isAnimationActive: !Object(__WEBPACK_IMPORTED_MODULE_15__util_ReactUtils__["n" /* isSsr */])(),
  animationBegin: 0,
  animationDuration: 400,
  animationEasing: 'ease',

  onAnimationStart: function onAnimationStart() {},
  onAnimationEnd: function onAnimationEnd() {}
}, _class2.getComposedData = function (_ref3) {
  var props = _ref3.props,
      item = _ref3.item,
      barPosition = _ref3.barPosition,
      bandSize = _ref3.bandSize,
      xAxis = _ref3.xAxis,
      yAxis = _ref3.yAxis,
      xAxisTicks = _ref3.xAxisTicks,
      yAxisTicks = _ref3.yAxisTicks,
      stackedData = _ref3.stackedData,
      dataStartIndex = _ref3.dataStartIndex,
      displayedData = _ref3.displayedData,
      offset = _ref3.offset;

  var pos = Object(__WEBPACK_IMPORTED_MODULE_16__util_ChartUtils__["f" /* findPositionOfBar */])(barPosition, item);
  if (!pos) {
    return [];
  }

  var layout = props.layout;
  var _item$props = item.props,
      dataKey = _item$props.dataKey,
      children = _item$props.children,
      minPointSize = _item$props.minPointSize;

  var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
  var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
  var baseValue = Object(__WEBPACK_IMPORTED_MODULE_16__util_ChartUtils__["j" /* getBaseValueOfBar */])({ props: props, numericAxis: numericAxis });
  var cells = Object(__WEBPACK_IMPORTED_MODULE_15__util_ReactUtils__["h" /* findAllByType */])(children, __WEBPACK_IMPORTED_MODULE_11__component_Cell__["a" /* default */]);

  var rects = displayedData.map(function (entry, index) {
    var value = void 0,
        x = void 0,
        y = void 0,
        width = void 0,
        height = void 0,
        background = void 0;

    if (stackedData) {
      value = Object(__WEBPACK_IMPORTED_MODULE_16__util_ChartUtils__["C" /* truncateByDomain */])(stackedData[dataStartIndex + index], stackedDomain);
    } else {
      value = Object(__WEBPACK_IMPORTED_MODULE_16__util_ChartUtils__["w" /* getValueByDataKey */])(entry, dataKey);

      if (!__WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default()(value)) {
        value = [baseValue, value];
      }
    }

    if (layout === 'horizontal') {
      x = Object(__WEBPACK_IMPORTED_MODULE_16__util_ChartUtils__["k" /* getCateCoordinateOfBar */])({
        axis: xAxis,
        ticks: xAxisTicks,
        bandSize: bandSize,
        offset: pos.offset,
        entry: entry,
        index: index
      });
      y = yAxis.scale(value[1]);
      width = pos.size;
      height = yAxis.scale(value[0]) - yAxis.scale(value[1]);
      background = { x: x, y: yAxis.y, width: width, height: yAxis.height };

      if (Math.abs(minPointSize) > 0 && Math.abs(height) < Math.abs(minPointSize)) {
        var delta = Object(__WEBPACK_IMPORTED_MODULE_14__util_DataUtils__["i" /* mathSign */])(height || minPointSize) * (Math.abs(minPointSize) - Math.abs(height));

        y -= delta;
        height += delta;
      }
    } else {
      x = xAxis.scale(value[0]);
      y = Object(__WEBPACK_IMPORTED_MODULE_16__util_ChartUtils__["k" /* getCateCoordinateOfBar */])({
        axis: yAxis,
        ticks: yAxisTicks,
        bandSize: bandSize,
        offset: pos.offset,
        entry: entry,
        index: index
      });
      width = xAxis.scale(value[1]) - xAxis.scale(value[0]);
      height = pos.size;
      background = { x: xAxis.x, y: y, width: xAxis.width, height: height };

      if (Math.abs(minPointSize) > 0 && Math.abs(width) < Math.abs(minPointSize)) {
        var _delta = Object(__WEBPACK_IMPORTED_MODULE_14__util_DataUtils__["i" /* mathSign */])(width || minPointSize) * (Math.abs(minPointSize) - Math.abs(width));
        width += _delta;
      }
    }

    return _extends({}, entry, {
      x: x, y: y, width: width, height: height, value: stackedData ? value : value[1],
      payload: entry,
      background: background
    }, cells && cells[index] && cells[index].props);
  });

  return _extends({ data: rects, layout: layout }, offset);
}, _temp2)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (Bar);

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNil__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_smooth__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_smooth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_smooth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_PureRender__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__container_Layer__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__component_LabelList__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_ReactUtils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ZAxis__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shape_Curve__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shape_Symbols__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ErrorBar__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__component_Cell__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__util_DataUtils__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__util_ChartUtils__ = __webpack_require__(11);




var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Render a group of scatters
 */

















var Scatter = Object(__WEBPACK_IMPORTED_MODULE_7__util_PureRender__["a" /* default */])(_class = (_temp2 = _class2 = function (_Component) {
  _inherits(Scatter, _Component);

  function Scatter() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Scatter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Scatter.__proto__ || Object.getPrototypeOf(Scatter)).call.apply(_ref, [this].concat(args))), _this), _this.state = { isAnimationFinished: false }, _this.cachePrevPoints = function (points) {
      _this.setState({ prevPoints: points });
    }, _this.handleAnimationEnd = function () {
      _this.setState({ isAnimationFinished: true });
    }, _this.handleAnimationStart = function () {
      _this.setState({ isAnimationFinished: false });
    }, _this.id = Object(__WEBPACK_IMPORTED_MODULE_16__util_DataUtils__["j" /* uniqueId */])('recharts-scatter-'), _temp), _possibleConstructorReturn(_this, _ret);
  }

  /**
   * Compose the data of each group
   * @param  {Object} xAxis   The configuration of x-axis
   * @param  {Object} yAxis   The configuration of y-axis
   * @param  {String} dataKey The unique key of a group
   * @return {Array}  Composed data
   */


  _createClass(Scatter, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props = this.props,
          animationId = _props.animationId,
          points = _props.points;


      if (nextProps.animationId !== animationId) {
        this.cachePrevPoints(points);
      }
    }
  }, {
    key: 'renderSymbolItem',
    value: function renderSymbolItem(option, props) {
      var symbol = void 0;

      if (__WEBPACK_IMPORTED_MODULE_3_react___default.a.isValidElement(option)) {
        symbol = __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(option)) {
        symbol = option(props);
      } else {
        symbol = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__shape_Symbols__["a" /* default */], _extends({}, props, { type: option }));
      }

      return symbol;
    }
  }, {
    key: 'renderSymbolsStatically',
    value: function renderSymbolsStatically(points) {
      var _this2 = this;

      var _props2 = this.props,
          shape = _props2.shape,
          activeShape = _props2.activeShape,
          activeIndex = _props2.activeIndex;

      var baseProps = Object(__WEBPACK_IMPORTED_MODULE_10__util_ReactUtils__["k" /* getPresentationAttributes */])(this.props);

      return points.map(function (entry, i) {
        var props = _extends({ key: 'symbol-' + i }, baseProps, entry);

        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */],
          _extends({
            className: 'recharts-scatter-symbol'
          }, Object(__WEBPACK_IMPORTED_MODULE_10__util_ReactUtils__["f" /* filterEventsOfChild */])(_this2.props, entry, i), {
            key: 'symbol-' + i
          }),
          _this2.renderSymbolItem(activeIndex === i ? activeShape : shape, props)
        );
      });
    }
  }, {
    key: 'renderSymbolsWithAnimation',
    value: function renderSymbolsWithAnimation() {
      var _this3 = this;

      var _props3 = this.props,
          points = _props3.points,
          isAnimationActive = _props3.isAnimationActive,
          animationBegin = _props3.animationBegin,
          animationDuration = _props3.animationDuration,
          animationEasing = _props3.animationEasing,
          animationId = _props3.animationId;
      var prevPoints = this.state.prevPoints;


      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_smooth___default.a,
        {
          begin: animationBegin,
          duration: animationDuration,
          isActive: isAnimationActive,
          easing: animationEasing,
          from: { t: 0 },
          to: { t: 1 },
          key: 'pie-' + animationId,
          onAnimationEnd: this.handleAnimationEnd,
          onAnimationStart: this.handleAnimationStart
        },
        function (_ref2) {
          var t = _ref2.t;

          var stepData = points.map(function (entry, index) {
            var prev = prevPoints && prevPoints[index];

            if (prev) {
              var interpolatorCx = Object(__WEBPACK_IMPORTED_MODULE_16__util_DataUtils__["e" /* interpolateNumber */])(prev.cx, entry.cx);
              var interpolatorCy = Object(__WEBPACK_IMPORTED_MODULE_16__util_DataUtils__["e" /* interpolateNumber */])(prev.cy, entry.cy);
              var interpolatorSize = Object(__WEBPACK_IMPORTED_MODULE_16__util_DataUtils__["e" /* interpolateNumber */])(prev.size, entry.size);

              return _extends({}, entry, {
                cx: interpolatorCx(t),
                cy: interpolatorCy(t),
                size: interpolatorSize(t)
              });
            }

            var interpolator = Object(__WEBPACK_IMPORTED_MODULE_16__util_DataUtils__["e" /* interpolateNumber */])(0, entry.size);

            return _extends({}, entry, { size: interpolator(t) });
          });

          return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */],
            null,
            _this3.renderSymbolsStatically(stepData)
          );
        }
      );
    }
  }, {
    key: 'renderSymbols',
    value: function renderSymbols() {
      var _props4 = this.props,
          points = _props4.points,
          isAnimationActive = _props4.isAnimationActive;
      var prevPoints = this.state.prevPoints;


      if (isAnimationActive && points && points.length && (!prevPoints || !__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(prevPoints, points))) {
        return this.renderSymbolsWithAnimation();
      }

      return this.renderSymbolsStatically(points);
    }
  }, {
    key: 'renderErrorBar',
    value: function renderErrorBar() {
      var isAnimationActive = this.props.isAnimationActive;

      if (isAnimationActive && !this.state.isAnimationFinished) {
        return null;
      }

      var _props5 = this.props,
          points = _props5.points,
          xAxis = _props5.xAxis,
          yAxis = _props5.yAxis,
          children = _props5.children;

      var errorBarItems = Object(__WEBPACK_IMPORTED_MODULE_10__util_ReactUtils__["h" /* findAllByType */])(children, __WEBPACK_IMPORTED_MODULE_14__ErrorBar__["a" /* default */]);

      if (!errorBarItems) {
        return null;
      }

      function dataPointFormatterY(dataPoint, dataKey) {
        return {
          x: dataPoint.cx,
          y: dataPoint.cy,
          value: dataPoint.y,
          errorVal: Object(__WEBPACK_IMPORTED_MODULE_17__util_ChartUtils__["w" /* getValueByDataKey */])(dataPoint, dataKey)
        };
      }

      function dataPointFormatterX(dataPoint, dataKey) {
        return {
          x: dataPoint.cx,
          y: dataPoint.cy,
          value: dataPoint.x,
          errorVal: Object(__WEBPACK_IMPORTED_MODULE_17__util_ChartUtils__["w" /* getValueByDataKey */])(dataPoint, dataKey)
        };
      }

      return errorBarItems.map(function (item, i) {
        var direction = item.props.direction;


        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(item, {
          key: i,
          data: points,
          xAxis: xAxis,
          yAxis: yAxis,
          layout: direction === 'x' ? 'vertical' : 'horizontal',
          dataPointFormatter: direction === 'x' ? dataPointFormatterX : dataPointFormatterY
        });
      });
    }
  }, {
    key: 'renderLine',
    value: function renderLine() {
      var _props6 = this.props,
          points = _props6.points,
          line = _props6.line,
          lineType = _props6.lineType,
          lineJointType = _props6.lineJointType;

      var scatterProps = Object(__WEBPACK_IMPORTED_MODULE_10__util_ReactUtils__["k" /* getPresentationAttributes */])(this.props);
      var customLineProps = Object(__WEBPACK_IMPORTED_MODULE_10__util_ReactUtils__["k" /* getPresentationAttributes */])(line);
      var linePoints = void 0,
          lineItem = void 0;

      if (lineType === 'joint') {
        linePoints = points.map(function (entry) {
          return { x: entry.cx, y: entry.cy };
        });
      }
      var lineProps = _extends({}, scatterProps, {
        fill: 'none',
        stroke: scatterProps && scatterProps.fill
      }, customLineProps, {
        points: linePoints
      });

      if (__WEBPACK_IMPORTED_MODULE_3_react___default.a.isValidElement(line)) {
        lineItem = __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(line, lineProps);
      } else if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(line)) {
        lineItem = line(lineProps);
      } else {
        lineItem = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__shape_Curve__["a" /* default */], _extends({}, lineProps, { type: lineJointType }));
      }

      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */],
        { className: 'recharts-scatter-line', key: 'recharts-scatter-line' },
        lineItem
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props7 = this.props,
          hide = _props7.hide,
          points = _props7.points,
          line = _props7.line,
          className = _props7.className,
          xAxis = _props7.xAxis,
          yAxis = _props7.yAxis,
          left = _props7.left,
          top = _props7.top,
          width = _props7.width,
          height = _props7.height,
          id = _props7.id;

      if (hide || !points || !points.length) {
        return null;
      }
      var _state = this.state,
          isAnimationActive = _state.isAnimationActive,
          isAnimationFinished = _state.isAnimationFinished;

      var layerClass = __WEBPACK_IMPORTED_MODULE_6_classnames___default()('recharts-scatter', className);
      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
      var clipPathId = __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(id) ? this.id : id;

      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */],
        {
          className: layerClass,
          clipPath: needClip ? 'url(#clipPath-' + clipPathId + ')' : null
        },
        needClip ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'defs',
          null,
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'clipPath',
            { id: 'clipPath-' + clipPathId },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('rect', { x: left, y: top, width: width, height: height })
          )
        ) : null,
        line && this.renderLine(),
        this.renderErrorBar(),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */],
          { key: 'recharts-scatter-symbols' },
          this.renderSymbols()
        ),
        (!isAnimationActive || isAnimationFinished) && __WEBPACK_IMPORTED_MODULE_9__component_LabelList__["a" /* default */].renderCallByParent(this.props, points)
      );
    }
  }]);

  return Scatter;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]), _class2.displayName = 'Scatter', _class2.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_10__util_ReactUtils__["a" /* EVENT_ATTRIBUTES */], __WEBPACK_IMPORTED_MODULE_10__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {

  xAxisId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number]),
  yAxisId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number]),
  zAxisId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number]),
  line: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.element]),
  lineType: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['fitting', 'joint']),
  lineJointType: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func]),
  legendType: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_10__util_ReactUtils__["b" /* LEGEND_TYPES */]),
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  name: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number]),

  activeIndex: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  activeShape: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.element]),
  shape: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['circle', 'cross', 'diamond', 'square', 'star', 'triangle', 'wye']), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func]),
  points: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    cx: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    cy: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    size: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    node: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
      x: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string]),
      y: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string]),
      z: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string])
    }),
    payload: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any
  })),
  hide: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,

  isAnimationActive: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  animationId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  animationBegin: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  animationDuration: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  animationEasing: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
}), _class2.defaultProps = {
  xAxisId: 0,
  yAxisId: 0,
  zAxisId: 0,
  legendType: 'circle',
  lineType: 'joint',
  lineJointType: 'linear',
  data: [],
  shape: 'circle',
  hide: false,

  isAnimationActive: !Object(__WEBPACK_IMPORTED_MODULE_10__util_ReactUtils__["n" /* isSsr */])(),
  animationBegin: 0,
  animationDuration: 400,
  animationEasing: 'linear'
}, _class2.getComposedData = function (_ref3) {
  var xAxis = _ref3.xAxis,
      yAxis = _ref3.yAxis,
      zAxis = _ref3.zAxis,
      item = _ref3.item,
      displayedData = _ref3.displayedData,
      onItemMouseLeave = _ref3.onItemMouseLeave,
      onItemMouseEnter = _ref3.onItemMouseEnter,
      offset = _ref3.offset,
      xAxisTicks = _ref3.xAxisTicks;

  var cells = Object(__WEBPACK_IMPORTED_MODULE_10__util_ReactUtils__["h" /* findAllByType */])(item.props.children, __WEBPACK_IMPORTED_MODULE_15__component_Cell__["a" /* default */]);
  var xAxisDataKey = __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(xAxis.dataKey) ? item.props.dataKey : xAxis.dataKey;
  var yAxisDataKey = __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(yAxis.dataKey) ? item.props.dataKey : yAxis.dataKey;
  var zAxisDataKey = zAxis && zAxis.dataKey;
  var defaultRangeZ = zAxis ? zAxis.range : __WEBPACK_IMPORTED_MODULE_11__ZAxis__["a" /* default */].defaultProps.range;
  var defaultZ = defaultRangeZ && defaultRangeZ[0];
  var xBandSize = xAxis.scale.bandwidth ? xAxis.scale.bandwidth() : 0;
  var yBandSize = yAxis.scale.bandwidth ? yAxis.scale.bandwidth() : 0;
  var points = displayedData.map(function (entry, index) {
    var x = entry[xAxisDataKey];
    var y = entry[yAxisDataKey];
    var z = !__WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(zAxisDataKey) && entry[zAxisDataKey] || '-';
    var tooltipPayload = [{ name: xAxis.name || xAxis.dataKey, unit: xAxis.unit || '', value: x, payload: entry }, { name: yAxis.name || yAxis.dataKey, unit: yAxis.unit || '', value: y, payload: entry }];

    if (z !== '-') {
      tooltipPayload.push({
        name: zAxis.name || zAxis.dataKey, unit: zAxis.unit || '', value: z, payload: entry
      });
    }
    var cx = Object(__WEBPACK_IMPORTED_MODULE_17__util_ChartUtils__["l" /* getCateCoordinateOfLine */])({
      axis: xAxis, ticks: xAxisTicks, bandSize: xBandSize, entry: entry, index: index
    });
    var cy = Object(__WEBPACK_IMPORTED_MODULE_17__util_ChartUtils__["l" /* getCateCoordinateOfLine */])({
      axis: yAxis, ticks: xAxisTicks, bandSize: yBandSize, entry: entry, index: index
    });
    var size = z !== '-' ? zAxis.scale(z) : defaultZ;
    var radius = Math.sqrt(Math.max(size, 0) / Math.PI);

    return _extends({}, entry, { cx: cx, cy: cy,
      x: cx - radius,
      y: cy - radius,
      xAxis: xAxis, yAxis: yAxis, zAxis: zAxis,
      width: 2 * radius,
      height: 2 * radius,
      size: size,
      node: { x: x, y: y, z: z },
      tooltipPayload: tooltipPayload,
      tooltipPosition: { x: cx, y: cy },
      payload: entry
    }, cells && cells[index] && cells[index].props);
  });

  return _extends({
    onMouseLeave: onItemMouseLeave,
    onMouseEnter: onItemMouseEnter,
    points: points
  }, offset);
}, _temp2)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (Scatter);

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports);
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports);
        global.sAlertTools = mod.exports;
    }
})(this, function (exports) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    var actualGlobalConfig = void 0;

    var sAlertTools = {
        randomId: function randomId() {
            return Math.random().toString(36).split('.')[1];
        },
        returnFirstDefined: function returnFirstDefined() {
            var value = void 0;
            var i = void 0;

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            for (i = 0; i < args.length; i++) {
                if (typeof args[i] !== 'undefined') {
                    value = args[i];
                    break;
                }
            }
            return value;
        },
        styleToObj: function styleToObj(input) {
            var result = {},
                i = void 0,
                entry = void 0,
                attributes = input && input.split(';').filter(Boolean);

            for (i = 0; i < attributes.length; i++) {
                entry = attributes[i].split(':');
                result[entry.splice(0, 1)[0].trim()] = entry.join(':').trim();
            }
            return result;
        },
        setGlobalConfig: function setGlobalConfig(config) {
            if ((typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object') {
                actualGlobalConfig = config;
            }
        },
        getGlobalConfig: function getGlobalConfig() {
            return actualGlobalConfig;
        }
    };

    exports.default = sAlertTools;
});

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports);
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports);
        global.sAlertStore = mod.exports;
    }
})(this, function (exports) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    function _toConsumableArray(arr) {
        if (Array.isArray(arr)) {
            for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
                arr2[i] = arr[i];
            }

            return arr2;
        } else {
            return Array.from(arr);
        }
    }

    // custom simple store based on a awesome Redux library https://github.com/rackt/redux

    var createSAlertStore = function createSAlertStore(reducer) {
        var state = void 0;
        var listeners = [];
        var getState = function getState() {
            return state;
        };
        var dispatch = function dispatch(action) {
            state = reducer(state, action);
            listeners.forEach(function (listener) {
                return listener();
            });
        };
        var subscribe = function subscribe(listener) {
            listeners.push(listener);
            return function () {
                listeners = listeners.filter(function (l) {
                    return l !== listener;
                });
            };
        };
        dispatch({});
        return {
            getState: getState, dispatch: dispatch, subscribe: subscribe
        };
    };

    var insert = function insert(state, action) {
        return [].concat(_toConsumableArray(state), [action.data]);
    };

    var remove = function remove(state, action) {
        var elemToRemoveArray = state.slice().filter(function (item) {
            return item.id === action.data.id;
        });
        if (Array.isArray(elemToRemoveArray)) {
            var elemToRemoveIndex = state.indexOf(elemToRemoveArray[0]);
            return [].concat(_toConsumableArray(state.slice(0, elemToRemoveIndex)), _toConsumableArray(state.slice(elemToRemoveIndex + 1)));
        }
        return state;
    };

    var alertsReducer = function alertsReducer() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var action = arguments[1];

        switch (action.type) {
            case 'INSERT':
                return insert(state, action);
            case 'REMOVE':
                return remove(state, action);
            case 'REMOVEALL':
                return [];
            default:
                return state;
        }
    };

    var sAlertStore = createSAlertStore(alertsReducer);

    exports.default = sAlertStore;
});

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(245);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(266);
var createDesc = __webpack_require__(271);
module.exports = __webpack_require__(89) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 132 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(84)))

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(135),
    toKey = __webpack_require__(68);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(8),
    isKey = __webpack_require__(93),
    stringToPath = __webpack_require__(299),
    toString = __webpack_require__(323);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 136 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__curve_linear__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__line__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__point__ = __webpack_require__(102);






/* harmony default export */ __webpack_exports__["a"] = (function() {
  var x0 = __WEBPACK_IMPORTED_MODULE_4__point__["a" /* x */],
      x1 = null,
      y0 = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(0),
      y1 = __WEBPACK_IMPORTED_MODULE_4__point__["b" /* y */],
      defined = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(true),
      context = null,
      curve = __WEBPACK_IMPORTED_MODULE_2__curve_linear__["a" /* default */],
      output = null;

  function area(data) {
    var i,
        j,
        k,
        n = data.length,
        d,
        defined0 = false,
        buffer,
        x0z = new Array(n),
        y0z = new Array(n);

    if (context == null) output = curve(buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) {
          j = i;
          output.areaStart();
          output.lineStart();
        } else {
          output.lineEnd();
          output.lineStart();
          for (k = i - 1; k >= j; --k) {
            output.point(x0z[k], y0z[k]);
          }
          output.lineEnd();
          output.areaEnd();
        }
      }
      if (defined0) {
        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
      }
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  function arealine() {
    return Object(__WEBPACK_IMPORTED_MODULE_3__line__["a" /* default */])().defined(defined).curve(curve).context(context);
  }

  area.x = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), x1 = null, area) : x0;
  };

  area.x0 = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : x0;
  };

  area.x1 = function(_) {
    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : x1;
  };

  area.y = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), y1 = null, area) : y0;
  };

  area.y0 = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : y0;
  };

  area.y1 = function(_) {
    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : y1;
  };

  area.lineX0 =
  area.lineY0 = function() {
    return arealine().x(x0).y(y0);
  };

  area.lineY1 = function() {
    return arealine().x(x0).y(y1);
  };

  area.lineX1 = function() {
    return arealine().x(x1).y(y0);
  };

  area.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(!!_), area) : defined;
  };

  area.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
  };

  area.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
  };

  return area;
});


/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return curveRadialLinear; });
/* harmony export (immutable) */ __webpack_exports__["b"] = curveRadial;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__linear__ = __webpack_require__(70);


var curveRadialLinear = curveRadial(__WEBPACK_IMPORTED_MODULE_0__linear__["a" /* default */]);

function Radial(curve) {
  this._curve = curve;
}

Radial.prototype = {
  areaStart: function() {
    this._curve.areaStart();
  },
  areaEnd: function() {
    this._curve.areaEnd();
  },
  lineStart: function() {
    this._curve.lineStart();
  },
  lineEnd: function() {
    this._curve.lineEnd();
  },
  point: function(a, r) {
    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
  }
};

function curveRadial(curve) {

  function radial(context) {
    return new Radial(curve(context));
  }

  radial._curve = curve;

  return radial;
}


/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lineRadial;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curve_radial__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__line__ = __webpack_require__(101);



function lineRadial(l) {
  var c = l.curve;

  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;

  l.curve = function(_) {
    return arguments.length ? c(Object(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["b" /* default */])(_)) : c()._curve;
  };

  return l;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return lineRadial(Object(__WEBPACK_IMPORTED_MODULE_1__line__["a" /* default */])().curve(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["a" /* curveRadialLinear */]));
});


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x, y) {
  return [(y = +y) * Math.cos(x -= Math.PI / 2), y * Math.sin(x)];
});


/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return slice; });
var slice = Array.prototype.slice;


/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(47);


/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / __WEBPACK_IMPORTED_MODULE_0__math__["j" /* pi */]);
    context.moveTo(r, 0);
    context.arc(0, 0, r, 0, __WEBPACK_IMPORTED_MODULE_0__math__["m" /* tau */]);
  }
});


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / 5) / 2;
    context.moveTo(-3 * r, -r);
    context.lineTo(-r, -r);
    context.lineTo(-r, -3 * r);
    context.lineTo(r, -3 * r);
    context.lineTo(r, -r);
    context.lineTo(3 * r, -r);
    context.lineTo(3 * r, r);
    context.lineTo(r, r);
    context.lineTo(r, 3 * r);
    context.lineTo(-r, 3 * r);
    context.lineTo(-r, r);
    context.lineTo(-3 * r, r);
    context.closePath();
  }
});


/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var tan30 = Math.sqrt(1 / 3),
    tan30_2 = tan30 * 2;

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var y = Math.sqrt(size / tan30_2),
        x = y * tan30;
    context.moveTo(0, -y);
    context.lineTo(x, 0);
    context.lineTo(0, y);
    context.lineTo(-x, 0);
    context.closePath();
  }
});


/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(47);


var ka = 0.89081309152928522810,
    kr = Math.sin(__WEBPACK_IMPORTED_MODULE_0__math__["j" /* pi */] / 10) / Math.sin(7 * __WEBPACK_IMPORTED_MODULE_0__math__["j" /* pi */] / 10),
    kx = Math.sin(__WEBPACK_IMPORTED_MODULE_0__math__["m" /* tau */] / 10) * kr,
    ky = -Math.cos(__WEBPACK_IMPORTED_MODULE_0__math__["m" /* tau */] / 10) * kr;

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size * ka),
        x = kx * r,
        y = ky * r;
    context.moveTo(0, -r);
    context.lineTo(x, y);
    for (var i = 1; i < 5; ++i) {
      var a = __WEBPACK_IMPORTED_MODULE_0__math__["m" /* tau */] * i / 5,
          c = Math.cos(a),
          s = Math.sin(a);
      context.lineTo(s * r, -c * r);
      context.lineTo(c * x - s * y, s * x + c * y);
    }
    context.closePath();
  }
});


/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var w = Math.sqrt(size),
        x = -w / 2;
    context.rect(x, x, w, w);
  }
});


/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var sqrt3 = Math.sqrt(3);

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var y = -Math.sqrt(size / (sqrt3 * 3));
    context.moveTo(0, y * 2);
    context.lineTo(-sqrt3 * y, -y);
    context.lineTo(sqrt3 * y, -y);
    context.closePath();
  }
});


/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var c = -0.5,
    s = Math.sqrt(3) / 2,
    k = 1 / Math.sqrt(12),
    a = (k / 2 + 1) * 3;

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / a),
        x0 = r / 2,
        y0 = r * k,
        x1 = x0,
        y1 = r * k + r,
        x2 = -x1,
        y2 = y1;
    context.moveTo(x0, y0);
    context.lineTo(x1, y1);
    context.lineTo(x2, y2);
    context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
    context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
    context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
    context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
    context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
    context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
    context.closePath();
  }
});


/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CardinalClosed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cardinal__ = __webpack_require__(73);



function CardinalClosed(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
      default: Object(__WEBPACK_IMPORTED_MODULE_1__cardinal__["b" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(tension) {

  function cardinal(context) {
    return new CardinalClosed(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));


/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CardinalOpen;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardinal__ = __webpack_require__(73);


function CardinalOpen(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
      case 3: this._point = 4; // proceed
      default: Object(__WEBPACK_IMPORTED_MODULE_0__cardinal__["b" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(tension) {

  function cardinal(context) {
    return new CardinalOpen(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isEqual2 = __webpack_require__(19);

var _isEqual3 = _interopRequireDefault(_isEqual2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _AnimateManager = __webpack_require__(383);

var _AnimateManager2 = _interopRequireDefault(_AnimateManager);

var _PureRender = __webpack_require__(387);

var _PureRender2 = _interopRequireDefault(_PureRender);

var _easing = __webpack_require__(164);

var _configUpdate = __webpack_require__(406);

var _configUpdate2 = _interopRequireDefault(_configUpdate);

var _util = __webpack_require__(75);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Animate = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
  _inherits(Animate, _Component);

  function Animate(props, context) {
    _classCallCheck(this, Animate);

    var _this = _possibleConstructorReturn(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props, context));

    var _this$props = _this.props,
        isActive = _this$props.isActive,
        attributeName = _this$props.attributeName,
        from = _this$props.from,
        to = _this$props.to,
        steps = _this$props.steps,
        children = _this$props.children;


    _this.handleStyleChange = _this.handleStyleChange.bind(_this);
    _this.changeStyle = _this.changeStyle.bind(_this);

    if (!isActive) {
      _this.state = { style: {} };

      // if children is a function and animation is not active, set style to 'to'
      if (typeof children === 'function') {
        _this.state = { style: to };
      }

      return _possibleConstructorReturn(_this);
    }

    if (steps && steps.length) {
      _this.state = { style: steps[0].style };
    } else if (from) {
      if (typeof children === 'function') {
        _this.state = {
          style: from
        };

        return _possibleConstructorReturn(_this);
      }
      _this.state = {
        style: attributeName ? _defineProperty({}, attributeName, from) : from
      };
    } else {
      _this.state = { style: {} };
    }
    return _this;
  }

  _createClass(Animate, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          isActive = _props.isActive,
          canBegin = _props.canBegin;


      this.mounted = true;

      if (!isActive || !canBegin) {
        return;
      }

      this.runAnimation(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var isActive = nextProps.isActive,
          canBegin = nextProps.canBegin,
          attributeName = nextProps.attributeName,
          shouldReAnimate = nextProps.shouldReAnimate;


      if (!canBegin) {
        return;
      }

      if (!isActive) {
        this.setState({
          style: attributeName ? _defineProperty({}, attributeName, nextProps.to) : nextProps.to
        });

        return;
      }

      var animateProps = ['to', 'canBegin', 'isActive'];

      if ((0, _isEqual3.default)(this.props.to, nextProps.to) && this.props.canBegin && this.props.isActive) {
        return;
      }

      var isTriggered = !this.props.canBegin || !this.props.isActive;

      if (this.manager) {
        this.manager.stop();
      }

      if (this.stopJSAnimation) {
        this.stopJSAnimation();
      }

      var from = isTriggered || shouldReAnimate ? nextProps.from : this.props.to;

      this.setState({
        style: attributeName ? _defineProperty({}, attributeName, from) : from
      });

      this.runAnimation(_extends({}, nextProps, {
        from: from,
        begin: 0
      }));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.mounted = false;

      if (this.unSubscribe) {
        this.unSubscribe();
      }

      if (this.manager) {
        this.manager.stop();
        this.manager = null;
      }

      if (this.stopJSAnimation) {
        this.stopJSAnimation();
      }
    }
  }, {
    key: 'runJSAnimation',
    value: function runJSAnimation(props) {
      var _this2 = this;

      var from = props.from,
          to = props.to,
          duration = props.duration,
          easing = props.easing,
          begin = props.begin,
          onAnimationEnd = props.onAnimationEnd,
          onAnimationStart = props.onAnimationStart;

      var startAnimation = (0, _configUpdate2.default)(from, to, (0, _easing.configEasing)(easing), duration, this.changeStyle);

      var finalStartAnimation = function finalStartAnimation() {
        _this2.stopJSAnimation = startAnimation();
      };

      this.manager.start([onAnimationStart, begin, finalStartAnimation, duration, onAnimationEnd]);
    }
  }, {
    key: 'runStepAnimation',
    value: function runStepAnimation(props) {
      var _this3 = this;

      var steps = props.steps,
          begin = props.begin,
          onAnimationStart = props.onAnimationStart;
      var _steps$ = steps[0],
          initialStyle = _steps$.style,
          _steps$$duration = _steps$.duration,
          initialTime = _steps$$duration === undefined ? 0 : _steps$$duration;


      var addStyle = function addStyle(sequence, nextItem, index) {
        if (index === 0) {
          return sequence;
        }

        var duration = nextItem.duration,
            _nextItem$easing = nextItem.easing,
            easing = _nextItem$easing === undefined ? 'ease' : _nextItem$easing,
            style = nextItem.style,
            nextProperties = nextItem.properties,
            onAnimationEnd = nextItem.onAnimationEnd;


        var preItem = index > 0 ? steps[index - 1] : nextItem;
        var properties = nextProperties || Object.keys(style);

        if (typeof easing === 'function' || easing === 'spring') {
          return [].concat(_toConsumableArray(sequence), [_this3.runJSAnimation.bind(_this3, {
            from: preItem.style,
            to: style,
            duration: duration,
            easing: easing
          }), duration]);
        }

        var transition = (0, _util.getTransitionVal)(properties, duration, easing);
        var newStyle = _extends({}, preItem.style, style, {
          transition: transition
        });

        return [].concat(_toConsumableArray(sequence), [newStyle, duration, onAnimationEnd]).filter(_util.identity);
      };

      return this.manager.start([onAnimationStart].concat(_toConsumableArray(steps.reduce(addStyle, [initialStyle, Math.max(initialTime, begin)])), [props.onAnimationEnd]));
    }
  }, {
    key: 'runAnimation',
    value: function runAnimation(props) {
      if (!this.manager) {
        this.manager = (0, _AnimateManager2.default)();
      }
      var begin = props.begin,
          duration = props.duration,
          attributeName = props.attributeName,
          propsFrom = props.from,
          propsTo = props.to,
          easing = props.easing,
          onAnimationStart = props.onAnimationStart,
          onAnimationEnd = props.onAnimationEnd,
          steps = props.steps,
          children = props.children;


      var manager = this.manager;

      this.unSubscribe = manager.subscribe(this.handleStyleChange);

      if (typeof easing === 'function' || typeof children === 'function' || easing === 'spring') {
        this.runJSAnimation(props);
        return;
      }

      if (steps.length > 1) {
        this.runStepAnimation(props);
        return;
      }

      var to = attributeName ? _defineProperty({}, attributeName, propsTo) : propsTo;
      var transition = (0, _util.getTransitionVal)(Object.keys(to), duration, easing);

      manager.start([onAnimationStart, begin, _extends({}, to, { transition: transition }), duration, onAnimationEnd]);
    }
  }, {
    key: 'handleStyleChange',
    value: function handleStyleChange(style) {
      this.changeStyle(style);
    }
  }, {
    key: 'changeStyle',
    value: function changeStyle(style) {
      if (this.mounted) {
        this.setState({
          style: style
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          children = _props2.children,
          begin = _props2.begin,
          duration = _props2.duration,
          attributeName = _props2.attributeName,
          easing = _props2.easing,
          isActive = _props2.isActive,
          steps = _props2.steps,
          from = _props2.from,
          to = _props2.to,
          canBegin = _props2.canBegin,
          onAnimationEnd = _props2.onAnimationEnd,
          shouldReAnimate = _props2.shouldReAnimate,
          onAnimationReStart = _props2.onAnimationReStart,
          others = _objectWithoutProperties(_props2, ['children', 'begin', 'duration', 'attributeName', 'easing', 'isActive', 'steps', 'from', 'to', 'canBegin', 'onAnimationEnd', 'shouldReAnimate', 'onAnimationReStart']);

      var count = _react.Children.count(children);
      var stateStyle = (0, _util.translateStyle)(this.state.style);

      if (typeof children === 'function') {
        return children(stateStyle);
      }

      if (!isActive || count === 0) {
        return children;
      }

      var cloneContainer = function cloneContainer(container) {
        var _container$props = container.props,
            _container$props$styl = _container$props.style,
            style = _container$props$styl === undefined ? {} : _container$props$styl,
            className = _container$props.className;


        var res = (0, _react.cloneElement)(container, _extends({}, others, {
          style: _extends({}, style, stateStyle),
          className: className
        }));
        return res;
      };

      if (count === 1) {
        var onlyChild = _react.Children.only(children);

        return cloneContainer(_react.Children.only(children));
      }

      return _react2.default.createElement(
        'div',
        null,
        _react.Children.map(children, function (child) {
          return cloneContainer(child);
        })
      );
    }
  }]);

  return Animate;
}(_react.Component), _class2.displayName = 'Animate', _class2.propTypes = {
  from: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
  to: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
  attributeName: _propTypes2.default.string,
  // animation duration
  duration: _propTypes2.default.number,
  begin: _propTypes2.default.number,
  easing: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  steps: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    duration: _propTypes2.default.number.isRequired,
    style: _propTypes2.default.object.isRequired,
    easing: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']), _propTypes2.default.func]),
    // transition css properties(dash case), optional
    properties: _propTypes2.default.arrayOf('string'),
    onAnimationEnd: _propTypes2.default.func
  })),
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
  isActive: _propTypes2.default.bool,
  canBegin: _propTypes2.default.bool,
  onAnimationEnd: _propTypes2.default.func,
  // decide if it should reanimate with initial from style when props change
  shouldReAnimate: _propTypes2.default.bool,
  onAnimationStart: _propTypes2.default.func,
  onAnimationReStart: _propTypes2.default.func
}, _class2.defaultProps = {
  begin: 0,
  duration: 1000,
  from: '',
  to: '',
  attributeName: '',
  easing: 'ease',
  isActive: true,
  canBegin: true,
  steps: [],
  onAnimationEnd: function onAnimationEnd() {},
  onAnimationStart: function onAnimationStart() {}
}, _temp)) || _class;

exports.default = Animate;

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(64),
    stackClear = __webpack_require__(352),
    stackDelete = __webpack_require__(353),
    stackGet = __webpack_require__(354),
    stackHas = __webpack_require__(355),
    stackSet = __webpack_require__(356);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(154),
    arraySome = __webpack_require__(359),
    cacheHas = __webpack_require__(155);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(94),
    setCacheAdd = __webpack_require__(357),
    setCacheHas = __webpack_require__(358);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 155 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 156 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 157 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(16),
    stubFalse = __webpack_require__(372);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(159)(module)))

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(373),
    baseUnary = __webpack_require__(110),
    nodeUtil = __webpack_require__(374);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 161 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(385)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(84)))

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(27),
    getPrototype = __webpack_require__(388),
    isObjectLike = __webpack_require__(24);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.configEasing = exports.configSpring = exports.configBezier = undefined;

var _util = __webpack_require__(75);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var ACCURACY = 1e-4;

var cubicBezierFactor = function cubicBezierFactor(c1, c2) {
  return [0, 3 * c1, 3 * c2 - 6 * c1, 3 * c1 - 3 * c2 + 1];
};

var multyTime = function multyTime(params, t) {
  return params.map(function (param, i) {
    return param * Math.pow(t, i);
  }).reduce(function (pre, curr) {
    return pre + curr;
  });
};

var cubicBezier = function cubicBezier(c1, c2) {
  return function (t) {
    var params = cubicBezierFactor(c1, c2);

    return multyTime(params, t);
  };
};

var derivativeCubicBezier = function derivativeCubicBezier(c1, c2) {
  return function (t) {
    var params = cubicBezierFactor(c1, c2);
    var newParams = [].concat(_toConsumableArray(params.map(function (param, i) {
      return param * i;
    }).slice(1)), [0]);

    return multyTime(newParams, t);
  };
};

// calculate cubic-bezier using Newton's method
var configBezier = exports.configBezier = function configBezier() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var x1 = args[0],
      y1 = args[1],
      x2 = args[2],
      y2 = args[3];


  if (args.length === 1) {
    switch (args[0]) {
      case 'linear':
        x1 = 0.0;
        y1 = 0.0;
        x2 = 1.0;
        y2 = 1.0;

        break;
      case 'ease':
        x1 = 0.25;
        y1 = 0.1;
        x2 = 0.25;
        y2 = 1.0;

        break;
      case 'ease-in':
        x1 = 0.42;
        y1 = 0.0;
        x2 = 1.0;
        y2 = 1.0;

        break;
      case 'ease-out':
        x1 = 0.42;
        y1 = 0.0;
        x2 = 0.58;
        y2 = 1.0;

        break;
      case 'ease-in-out':
        x1 = 0.0;
        y1 = 0.0;
        x2 = 0.58;
        y2 = 1.0;

        break;
      default:
        (0, _util.warn)(false, '[configBezier]: arguments should be one of ' + 'oneOf \'linear\', \'ease\', \'ease-in\', \'ease-out\', ' + '\'ease-in-out\', instead received %s', args);
    }
  }

  (0, _util.warn)([x1, x2, y1, y2].every(function (num) {
    return typeof num === 'number' && num >= 0 && num <= 1;
  }), '[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s', args);

  var curveX = cubicBezier(x1, x2);
  var curveY = cubicBezier(y1, y2);
  var derCurveX = derivativeCubicBezier(x1, x2);
  var rangeValue = function rangeValue(value) {
    if (value > 1) {
      return 1;
    } else if (value < 0) {
      return 0;
    }

    return value;
  };

  var bezier = function bezier(_t) {
    var t = _t > 1 ? 1 : _t;
    var x = t;

    for (var i = 0; i < 8; ++i) {
      var evalT = curveX(x) - t;
      var derVal = derCurveX(x);

      if (Math.abs(evalT - t) < ACCURACY || derVal < ACCURACY) {
        return curveY(x);
      }

      x = rangeValue(x - evalT / derVal);
    }

    return curveY(x);
  };

  bezier.isStepper = false;

  return bezier;
};

var configSpring = exports.configSpring = function configSpring() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _config$stiff = config.stiff,
      stiff = _config$stiff === undefined ? 100 : _config$stiff,
      _config$damping = config.damping,
      damping = _config$damping === undefined ? 8 : _config$damping,
      _config$dt = config.dt,
      dt = _config$dt === undefined ? 17 : _config$dt;

  var stepper = function stepper(currX, destX, currV) {
    var FSpring = -(currX - destX) * stiff;
    var FDamping = currV * damping;
    var newV = currV + (FSpring - FDamping) * dt / 1000;
    var newX = currV * dt / 1000 + currX;

    if (Math.abs(newX - destX) < ACCURACY && Math.abs(newV) < ACCURACY) {
      return [destX, 0];
    }
    return [newX, newV];
  };

  stepper.isStepper = true;
  stepper.dt = dt;

  return stepper;
};

var configEasing = exports.configEasing = function configEasing() {
  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  var easing = args[0];


  if (typeof easing === 'string') {
    switch (easing) {
      case 'ease':
      case 'ease-in-out':
      case 'ease-out':
      case 'ease-in':
      case 'linear':
        return configBezier(easing);
      case 'spring':
        return configSpring();
      default:
        (0, _util.warn)(false, '[configEasing]: first argument should be one of \'ease\', \'ease-in\', ' + '\'ease-out\', \'ease-in-out\', \'linear\' and \'spring\', instead  received %s', args);
    }
  }

  if (typeof easing === 'function') {
    return easing;
  }

  (0, _util.warn)(false, '[configEasing]: first argument type should be function or ' + 'string, instead received %s', args);

  return null;
};

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(38),
    overRest = __webpack_require__(397),
    setToString = __webpack_require__(399);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(409),
    createBaseEach = __webpack_require__(412);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(17);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 168 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(17),
    now = __webpack_require__(431),
    toNumber = __webpack_require__(170);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(17),
    isSymbol = __webpack_require__(37);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return warn; });
/* eslint no-console: 0 */
var isDev = "production" !== 'production';

var warn = function warn(condition, format, a, b, c, d, e, f) {
  if (isDev && typeof console !== 'undefined' && console.warn) {
    if (format === undefined) {
      console.warn('LogUtils requires an error message argument');
    }

    if (!condition) {
      if (format === undefined) {
        console.warn('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
      } else {
        var args = [a, b, c, d, e, f];
        var argIndex = 0;

        console.warn(format.replace(/%s/g, function () {
          return args[argIndex++];
        }));
      }
    }
  }
};

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(444),
    baseOrderBy = __webpack_require__(446),
    baseRest = __webpack_require__(165),
    isIterateeCall = __webpack_require__(173);

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
 */
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

module.exports = sortBy;


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(95),
    isArrayLike = __webpack_require__(50),
    isIndex = __webpack_require__(108),
    isObject = __webpack_require__(17);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 174 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */
function baseGt(value, other) {
  return value > other;
}

module.exports = baseGt;


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var baseExtremum = __webpack_require__(76),
    baseLt = __webpack_require__(176),
    identity = __webpack_require__(38);

/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */
function min(array) {
  return (array && array.length)
    ? baseExtremum(array, identity, baseLt)
    : undefined;
}

module.exports = min;


/***/ }),
/* 176 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */
function baseLt(value, other) {
  return value < other;
}

module.exports = baseLt;


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var identity = function identity(i) {
  return i;
};

var PLACE_HOLDER = exports.PLACE_HOLDER = {
  '@@functional/placeholder': true
};

var isPlaceHolder = function isPlaceHolder(val) {
  return val === PLACE_HOLDER;
};

var curry0 = function curry0(fn) {
  return function _curried() {
    if (arguments.length === 0 || arguments.length === 1 && isPlaceHolder(arguments.length <= 0 ? undefined : arguments[0])) {
      return _curried;
    }

    return fn.apply(undefined, arguments);
  };
};

var curryN = function curryN(n, fn) {
  if (n === 1) {
    return fn;
  }

  return curry0(function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var argsLength = args.filter(function (arg) {
      return arg !== PLACE_HOLDER;
    }).length;

    if (argsLength >= n) {
      return fn.apply(undefined, args);
    }

    return curryN(n - argsLength, curry0(function () {
      for (var _len2 = arguments.length, restArgs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        restArgs[_key2] = arguments[_key2];
      }

      var newArgs = args.map(function (arg) {
        return isPlaceHolder(arg) ? restArgs.shift() : arg;
      });

      return fn.apply(undefined, _toConsumableArray(newArgs).concat(restArgs));
    }));
  });
};

var curry = exports.curry = function curry(fn) {
  return curryN(fn.length, fn);
};

var range = exports.range = function range(begin, end) {
  var arr = [];

  for (var i = begin; i < end; ++i) {
    arr[i - begin] = i;
  }

  return arr;
};

var map = exports.map = curry(function (fn, arr) {
  if (Array.isArray(arr)) {
    return arr.map(fn);
  }

  return Object.keys(arr).map(function (key) {
    return arr[key];
  }).map(fn);
});

var compose = exports.compose = function compose() {
  for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  if (!args.length) {
    return identity;
  }

  var fns = args.reverse();
  // first function can receive multiply arguments
  var firstFn = fns[0];
  var tailsFn = fns.slice(1);

  return function () {
    return tailsFn.reduce(function (res, fn) {
      return fn(res);
    }, firstFn.apply(undefined, arguments));
  };
};

var reverse = exports.reverse = function reverse(arr) {
  if (Array.isArray(arr)) {
    return arr.reverse();
  }

  // can be string
  return arr.split('').reverse.join('');
};

var memoize = exports.memoize = function memoize(fn) {
  var lastArgs = null;
  var lastResult = null;

  return function () {
    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    if (lastArgs && args.every(function (val, i) {
      return val === lastArgs[i];
    })) {
      return lastResult;
    }

    lastArgs = args;
    lastResult = fn.apply(undefined, args);

    return lastResult;
  };
};

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_band__ = __webpack_require__(455);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleBand", function() { return __WEBPACK_IMPORTED_MODULE_0__src_band__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scalePoint", function() { return __WEBPACK_IMPORTED_MODULE_0__src_band__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_identity__ = __webpack_require__(478);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleIdentity", function() { return __WEBPACK_IMPORTED_MODULE_1__src_identity__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_linear__ = __webpack_require__(54);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleLinear", function() { return __WEBPACK_IMPORTED_MODULE_2__src_linear__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_log__ = __webpack_require__(501);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleLog", function() { return __WEBPACK_IMPORTED_MODULE_3__src_log__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_ordinal__ = __webpack_require__(191);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleOrdinal", function() { return __WEBPACK_IMPORTED_MODULE_4__src_ordinal__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleImplicit", function() { return __WEBPACK_IMPORTED_MODULE_4__src_ordinal__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_pow__ = __webpack_require__(502);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scalePow", function() { return __WEBPACK_IMPORTED_MODULE_5__src_pow__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleSqrt", function() { return __WEBPACK_IMPORTED_MODULE_5__src_pow__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_quantile__ = __webpack_require__(503);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleQuantile", function() { return __WEBPACK_IMPORTED_MODULE_6__src_quantile__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_quantize__ = __webpack_require__(504);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleQuantize", function() { return __WEBPACK_IMPORTED_MODULE_7__src_quantize__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_threshold__ = __webpack_require__(505);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleThreshold", function() { return __WEBPACK_IMPORTED_MODULE_8__src_threshold__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_time__ = __webpack_require__(207);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleTime", function() { return __WEBPACK_IMPORTED_MODULE_9__src_time__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_utcTime__ = __webpack_require__(521);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleUtc", function() { return __WEBPACK_IMPORTED_MODULE_10__src_utcTime__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_category10__ = __webpack_require__(522);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemeCategory10", function() { return __WEBPACK_IMPORTED_MODULE_11__src_category10__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_category20b__ = __webpack_require__(523);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemeCategory20b", function() { return __WEBPACK_IMPORTED_MODULE_12__src_category20b__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_category20c__ = __webpack_require__(524);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemeCategory20c", function() { return __WEBPACK_IMPORTED_MODULE_13__src_category20c__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_category20__ = __webpack_require__(525);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemeCategory20", function() { return __WEBPACK_IMPORTED_MODULE_14__src_category20__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__ = __webpack_require__(526);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateCubehelixDefault", function() { return __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_rainbow__ = __webpack_require__(527);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateRainbow", function() { return __WEBPACK_IMPORTED_MODULE_16__src_rainbow__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateWarm", function() { return __WEBPACK_IMPORTED_MODULE_16__src_rainbow__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateCool", function() { return __WEBPACK_IMPORTED_MODULE_16__src_rainbow__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_viridis__ = __webpack_require__(528);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateViridis", function() { return __WEBPACK_IMPORTED_MODULE_17__src_viridis__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateMagma", function() { return __WEBPACK_IMPORTED_MODULE_17__src_viridis__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateInferno", function() { return __WEBPACK_IMPORTED_MODULE_17__src_viridis__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolatePlasma", function() { return __WEBPACK_IMPORTED_MODULE_17__src_viridis__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_sequential__ = __webpack_require__(529);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleSequential", function() { return __WEBPACK_IMPORTED_MODULE_18__src_sequential__["a"]; });







































/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bisectRight */
/* unused harmony export bisectLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bisector__ = __webpack_require__(180);



var ascendingBisect = Object(__WEBPACK_IMPORTED_MODULE_1__bisector__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */]);
var bisectRight = ascendingBisect.right;
var bisectLeft = ascendingBisect.left;
/* harmony default export */ __webpack_exports__["a"] = (bisectRight);


/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(39);


/* harmony default export */ __webpack_exports__["a"] = (function(compare) {
  if (compare.length === 1) compare = ascendingComparator(compare);
  return {
    left: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) < 0) lo = mid + 1;
        else hi = mid;
      }
      return lo;
    },
    right: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) > 0) hi = mid;
        else lo = mid + 1;
      }
      return lo;
    }
  };
});

function ascendingComparator(f) {
  return function(d, x) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */])(f(d), x);
  };
}


/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pair;
/* unused harmony default export */ var _unused_webpack_default_export = (function(array, f) {
  if (f == null) f = pair;
  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
  while (i < n) pairs[i] = f(p, p = array[++i]);
  return pairs;
});

function pair(a, b) {
  return [a, b];
}


/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__variance__ = __webpack_require__(183);


/* harmony default export */ __webpack_exports__["a"] = (function(array, f) {
  var v = Object(__WEBPACK_IMPORTED_MODULE_0__variance__["a" /* default */])(array, f);
  return v ? Math.sqrt(v) : v;
});


/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(53);


/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      m = 0,
      i = -1,
      mean = 0,
      value,
      delta,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(values[i]))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(valueof(values[i], i, values)))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  if (m > 1) return sum / (m - 1);
});


/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  return [min, max];
});


/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return map; });
var array = Array.prototype;

var slice = array.slice;
var map = array.map;


/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(start, stop, step) {
  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;

  var i = -1,
      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
      range = new Array(n);

  while (++i < n) {
    range[i] = start + i * step;
  }

  return range;
});


/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = tickIncrement;
/* harmony export (immutable) */ __webpack_exports__["c"] = tickStep;
var e10 = Math.sqrt(50),
    e5 = Math.sqrt(10),
    e2 = Math.sqrt(2);

/* harmony default export */ __webpack_exports__["a"] = (function(start, stop, count) {
  var reverse,
      i = -1,
      n,
      ticks,
      step;

  stop = +stop, start = +start, count = +count;
  if (start === stop && count > 0) return [start];
  if (reverse = stop < start) n = start, start = stop, stop = n;
  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];

  if (step > 0) {
    start = Math.ceil(start / step);
    stop = Math.floor(stop / step);
    ticks = new Array(n = Math.ceil(stop - start + 1));
    while (++i < n) ticks[i] = (start + i) * step;
  } else {
    start = Math.floor(start * step);
    stop = Math.ceil(stop * step);
    ticks = new Array(n = Math.ceil(start - stop + 1));
    while (++i < n) ticks[i] = (start - i) / step;
  }

  if (reverse) ticks.reverse();

  return ticks;
});

function tickIncrement(start, stop, count) {
  var step = (stop - start) / Math.max(0, count),
      power = Math.floor(Math.log(step) / Math.LN10),
      error = step / Math.pow(10, power);
  return power >= 0
      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}

function tickStep(start, stop, count) {
  var step0 = Math.abs(stop - start) / Math.max(0, count),
      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
      error = step0 / step1;
  if (error >= e10) step1 *= 10;
  else if (error >= e5) step1 *= 5;
  else if (error >= e2) step1 *= 2;
  return stop < start ? -step1 : step1;
}


/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
});


/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  return min;
});


/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__min__ = __webpack_require__(189);


/* harmony default export */ __webpack_exports__["a"] = (function(matrix) {
  if (!(n = matrix.length)) return [];
  for (var i = -1, m = Object(__WEBPACK_IMPORTED_MODULE_0__min__["a" /* default */])(matrix, length), transpose = new Array(m); ++i < m;) {
    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
      row[j] = matrix[j][i];
    }
  }
  return transpose;
});

function length(d) {
  return d.length;
}


/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return implicit; });
/* harmony export (immutable) */ __webpack_exports__["a"] = ordinal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_collection__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(35);



var implicit = {name: "implicit"};

function ordinal(range) {
  var index = Object(__WEBPACK_IMPORTED_MODULE_0_d3_collection__["a" /* map */])(),
      domain = [],
      unknown = implicit;

  range = range == null ? [] : __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(range);

  function scale(d) {
    var key = d + "", i = index.get(key);
    if (!i) {
      if (unknown !== implicit) return unknown;
      index.set(key, i = domain.push(d));
    }
    return range[(i - 1) % range.length];
  }

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [], index = Object(__WEBPACK_IMPORTED_MODULE_0_d3_collection__["a" /* map */])();
    var i = -1, n = _.length, d, key;
    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
    return scale;
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), scale) : range.slice();
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function() {
    return ordinal()
        .domain(domain)
        .range(range)
        .unknown(unknown);
  };

  return scale;
}


/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deg2rad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return rad2deg; });
var deg2rad = Math.PI / 180;
var rad2deg = 180 / Math.PI;


/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export rgbBasis */
/* unused harmony export rgbBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basis__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__basisClosed__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__color__ = __webpack_require__(56);





/* harmony default export */ __webpack_exports__["a"] = ((function rgbGamma(y) {
  var color = Object(__WEBPACK_IMPORTED_MODULE_3__color__["b" /* gamma */])(y);

  function rgb(start, end) {
    var r = color((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* rgb */])(start)).r, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* rgb */])(end)).r),
        g = color(start.g, end.g),
        b = color(start.b, end.b),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_3__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }

  rgb.gamma = rgbGamma;

  return rgb;
})(1));

function rgbSpline(spline) {
  return function(colors) {
    var n = colors.length,
        r = new Array(n),
        g = new Array(n),
        b = new Array(n),
        i, color;
    for (i = 0; i < n; ++i) {
      color = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* rgb */])(colors[i]);
      r[i] = color.r || 0;
      g[i] = color.g || 0;
      b[i] = color.b || 0;
    }
    r = spline(r);
    g = spline(g);
    b = spline(b);
    color.opacity = 1;
    return function(t) {
      color.r = r(t);
      color.g = g(t);
      color.b = b(t);
      return color + "";
    };
  };
}

var rgbBasis = rgbSpline(__WEBPACK_IMPORTED_MODULE_1__basis__["b" /* default */]);
var rgbBasisClosed = rgbSpline(__WEBPACK_IMPORTED_MODULE_2__basisClosed__["a" /* default */]);


/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(117);


/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  var n = values.length;
  return function(t) {
    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
        v0 = values[(i + n - 1) % n],
        v1 = values[i % n],
        v2 = values[(i + 1) % n],
        v3 = values[(i + 2) % n];
    return Object(__WEBPACK_IMPORTED_MODULE_0__basis__["a" /* basis */])((t - i / n) * n, v0, v1, v2, v3);
  };
});


/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__(114);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var nb = b ? b.length : 0,
      na = a ? Math.min(nb, a.length) : 0,
      x = new Array(na),
      c = new Array(nb),
      i;

  for (i = 0; i < na; ++i) x[i] = Object(__WEBPACK_IMPORTED_MODULE_0__value__["a" /* default */])(a[i], b[i]);
  for (; i < nb; ++i) c[i] = b[i];

  return function(t) {
    for (i = 0; i < na; ++i) c[i] = x[i](t);
    return c;
  };
});


/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var d = new Date;
  return a = +a, b -= a, function(t) {
    return d.setTime(a + b * t), d;
  };
});


/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__(114);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var i = {},
      c = {},
      k;

  if (a === null || typeof a !== "object") a = {};
  if (b === null || typeof b !== "object") b = {};

  for (k in b) {
    if (k in a) {
      i[k] = Object(__WEBPACK_IMPORTED_MODULE_0__value__["a" /* default */])(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }

  return function(t) {
    for (k in i) c[k] = i[k](t);
    return c;
  };
});


/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(77);


var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
    reB = new RegExp(reA.source, "g");

function zero(b) {
  return function() {
    return b;
  };
}

function one(b) {
  return function(t) {
    return b(t) + "";
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
      am, // current match in a
      bm, // current match in b
      bs, // string preceding current number in b, if any
      i = -1, // index in s
      s = [], // string constants and placeholders
      q = []; // number interpolators

  // Coerce inputs to strings.
  a = a + "", b = b + "";

  // Interpolate pairs of numbers in a & b.
  while ((am = reA.exec(a))
      && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) { // a string precedes the next number in b
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
      if (s[i]) s[i] += bm; // coalesce with previous string
      else s[++i] = bm;
    } else { // interpolate non-matching numbers
      s[++i] = null;
      q.push({i: i, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(am, bm)});
    }
    bi = reB.lastIndex;
  }

  // Add remains of b.
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs; // coalesce with previous string
    else s[++i] = bs;
  }

  // Special optimization for only a single match.
  // Otherwise, interpolate each of the numbers and rejoin the string.
  return s.length < 2 ? (q[0]
      ? one(q[0].x)
      : zero(b))
      : (b = q.length, function(t) {
          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
          return s.join("");
        });
});


/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return +x;
});


/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__ = __webpack_require__(492);
/* unused harmony reexport formatDefaultLocale */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_locale__ = __webpack_require__(202);
/* unused harmony reexport formatLocale */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_formatSpecifier__ = __webpack_require__(203);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__src_formatSpecifier__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_precisionFixed__ = __webpack_require__(498);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__src_precisionFixed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_precisionPrefix__ = __webpack_require__(499);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__src_precisionPrefix__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_precisionRound__ = __webpack_require__(500);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__src_precisionRound__["a"]; });








/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formatGroup__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formatNumerals__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__formatSpecifier__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__formatTypes__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__formatPrefixAuto__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__identity__ = __webpack_require__(497);








var prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];

/* harmony default export */ __webpack_exports__["a"] = (function(locale) {
  var group = locale.grouping && locale.thousands ? Object(__WEBPACK_IMPORTED_MODULE_1__formatGroup__["a" /* default */])(locale.grouping, locale.thousands) : __WEBPACK_IMPORTED_MODULE_6__identity__["a" /* default */],
      currency = locale.currency,
      decimal = locale.decimal,
      numerals = locale.numerals ? Object(__WEBPACK_IMPORTED_MODULE_2__formatNumerals__["a" /* default */])(locale.numerals) : __WEBPACK_IMPORTED_MODULE_6__identity__["a" /* default */],
      percent = locale.percent || "%";

  function newFormat(specifier) {
    specifier = Object(__WEBPACK_IMPORTED_MODULE_3__formatSpecifier__["a" /* default */])(specifier);

    var fill = specifier.fill,
        align = specifier.align,
        sign = specifier.sign,
        symbol = specifier.symbol,
        zero = specifier.zero,
        width = specifier.width,
        comma = specifier.comma,
        precision = specifier.precision,
        type = specifier.type;

    // Compute the prefix and suffix.
    // For SI-prefix, the suffix is lazily computed.
    var prefix = symbol === "$" ? currency[0] : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
        suffix = symbol === "$" ? currency[1] : /[%p]/.test(type) ? percent : "";

    // What format function should we use?
    // Is this an integer type?
    // Can this type generate exponential notation?
    var formatType = __WEBPACK_IMPORTED_MODULE_4__formatTypes__["a" /* default */][type],
        maybeSuffix = !type || /[defgprs%]/.test(type);

    // Set the default precision if not specified,
    // or clamp the specified precision to the supported range.
    // For significant precision, it must be in [1, 21].
    // For fixed precision, it must be in [0, 20].
    precision = precision == null ? (type ? 6 : 12)
        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
        : Math.max(0, Math.min(20, precision));

    function format(value) {
      var valuePrefix = prefix,
          valueSuffix = suffix,
          i, n, c;

      if (type === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;

        // Perform the initial formatting.
        var valueNegative = value < 0;
        value = formatType(Math.abs(value), precision);

        // If a negative value rounds to zero during formatting, treat as positive.
        if (valueNegative && +value === 0) valueNegative = false;

        // Compute the prefix and suffix.
        valuePrefix = (valueNegative ? (sign === "(" ? sign : "-") : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
        valueSuffix = valueSuffix + (type === "s" ? prefixes[8 + __WEBPACK_IMPORTED_MODULE_5__formatPrefixAuto__["b" /* prefixExponent */] / 3] : "") + (valueNegative && sign === "(" ? ")" : "");

        // Break the formatted value into the integer “value” part that can be
        // grouped, and fractional or exponential “suffix” part that is not.
        if (maybeSuffix) {
          i = -1, n = value.length;
          while (++i < n) {
            if (c = value.charCodeAt(i), 48 > c || c > 57) {
              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }

      // If the fill character is not "0", grouping is applied before padding.
      if (comma && !zero) value = group(value, Infinity);

      // Compute the padding.
      var length = valuePrefix.length + value.length + valueSuffix.length,
          padding = length < width ? new Array(width - length + 1).join(fill) : "";

      // If the fill character is "0", grouping is applied after padding.
      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";

      // Reconstruct the final output based on the desired alignment.
      switch (align) {
        case "<": value = valuePrefix + value + valueSuffix + padding; break;
        case "=": value = valuePrefix + padding + value + valueSuffix; break;
        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
        default: value = padding + valuePrefix + value + valueSuffix; break;
      }

      return numerals(value);
    }

    format.toString = function() {
      return specifier + "";
    };

    return format;
  }

  function formatPrefix(specifier, value) {
    var f = newFormat((specifier = Object(__WEBPACK_IMPORTED_MODULE_3__formatSpecifier__["a" /* default */])(specifier), specifier.type = "f", specifier)),
        e = Math.max(-8, Math.min(8, Math.floor(Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(value) / 3))) * 3,
        k = Math.pow(10, -e),
        prefix = prefixes[8 + e / 3];
    return function(value) {
      return f(k * value) + prefix;
    };
  }

  return {
    format: newFormat,
    formatPrefix: formatPrefix
  };
});


/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatSpecifier;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatTypes__ = __webpack_require__(204);


// [[fill]align][sign][symbol][0][width][,][.precision][type]
var re = /^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?([a-z%])?$/i;

function formatSpecifier(specifier) {
  return new FormatSpecifier(specifier);
}

formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof

function FormatSpecifier(specifier) {
  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);

  var match,
      fill = match[1] || " ",
      align = match[2] || ">",
      sign = match[3] || "-",
      symbol = match[4] || "",
      zero = !!match[5],
      width = match[6] && +match[6],
      comma = !!match[7],
      precision = match[8] && +match[8].slice(1),
      type = match[9] || "";

  // The "n" type is an alias for ",g".
  if (type === "n") comma = true, type = "g";

  // Map invalid types to the default format.
  else if (!__WEBPACK_IMPORTED_MODULE_0__formatTypes__["a" /* default */][type]) type = "";

  // If zero fill is specified, padding goes after sign and before digits.
  if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";

  this.fill = fill;
  this.align = align;
  this.sign = sign;
  this.symbol = symbol;
  this.zero = zero;
  this.width = width;
  this.comma = comma;
  this.precision = precision;
  this.type = type;
}

FormatSpecifier.prototype.toString = function() {
  return this.fill
      + this.align
      + this.sign
      + this.symbol
      + (this.zero ? "0" : "")
      + (this.width == null ? "" : Math.max(1, this.width | 0))
      + (this.comma ? "," : "")
      + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0))
      + this.type;
};


/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDefault__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formatPrefixAuto__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formatRounded__ = __webpack_require__(496);




/* harmony default export */ __webpack_exports__["a"] = ({
  "": __WEBPACK_IMPORTED_MODULE_0__formatDefault__["a" /* default */],
  "%": function(x, p) { return (x * 100).toFixed(p); },
  "b": function(x) { return Math.round(x).toString(2); },
  "c": function(x) { return x + ""; },
  "d": function(x) { return Math.round(x).toString(10); },
  "e": function(x, p) { return x.toExponential(p); },
  "f": function(x, p) { return x.toFixed(p); },
  "g": function(x, p) { return x.toPrecision(p); },
  "o": function(x) { return Math.round(x).toString(8); },
  "p": function(x, p) { return Object(__WEBPACK_IMPORTED_MODULE_2__formatRounded__["a" /* default */])(x * 100, p); },
  "r": __WEBPACK_IMPORTED_MODULE_2__formatRounded__["a" /* default */],
  "s": __WEBPACK_IMPORTED_MODULE_1__formatPrefixAuto__["a" /* default */],
  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
  "x": function(x) { return Math.round(x).toString(16); }
});


/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return prefixExponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__(119);


var prefixExponent;

/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  var d = Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1],
      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
      n = coefficient.length;
  return i === n ? coefficient
      : i > n ? coefficient + new Array(i - n + 1).join("0")
      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
      : "0." + new Array(1 - i).join("0") + Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(x, Math.max(0, p + i - 1))[0]; // less than 1y!
});


/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(domain, interval) {
  domain = domain.slice();

  var i0 = 0,
      i1 = domain.length - 1,
      x0 = domain[i0],
      x1 = domain[i1],
      t;

  if (x1 < x0) {
    t = i0, i0 = i1, i1 = t;
    t = x0, x0 = x1, x1 = t;
  }

  domain[i0] = interval.floor(x0);
  domain[i1] = interval.ceil(x1);
  return domain;
});


/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = calendar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_time__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_time_format__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__array__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__continuous__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__nice__ = __webpack_require__(206);








var durationSecond = 1000,
    durationMinute = durationSecond * 60,
    durationHour = durationMinute * 60,
    durationDay = durationHour * 24,
    durationWeek = durationDay * 7,
    durationMonth = durationDay * 30,
    durationYear = durationDay * 365;

function date(t) {
  return new Date(t);
}

function number(t) {
  return t instanceof Date ? +t : +new Date(+t);
}

function calendar(year, month, week, day, hour, minute, second, millisecond, format) {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_5__continuous__["b" /* default */])(__WEBPACK_IMPORTED_MODULE_5__continuous__["c" /* deinterpolateLinear */], __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["c" /* interpolateNumber */]),
      invert = scale.invert,
      domain = scale.domain;

  var formatMillisecond = format(".%L"),
      formatSecond = format(":%S"),
      formatMinute = format("%I:%M"),
      formatHour = format("%I %p"),
      formatDay = format("%a %d"),
      formatWeek = format("%b %d"),
      formatMonth = format("%B"),
      formatYear = format("%Y");

  var tickIntervals = [
    [second,  1,      durationSecond],
    [second,  5,  5 * durationSecond],
    [second, 15, 15 * durationSecond],
    [second, 30, 30 * durationSecond],
    [minute,  1,      durationMinute],
    [minute,  5,  5 * durationMinute],
    [minute, 15, 15 * durationMinute],
    [minute, 30, 30 * durationMinute],
    [  hour,  1,      durationHour  ],
    [  hour,  3,  3 * durationHour  ],
    [  hour,  6,  6 * durationHour  ],
    [  hour, 12, 12 * durationHour  ],
    [   day,  1,      durationDay   ],
    [   day,  2,  2 * durationDay   ],
    [  week,  1,      durationWeek  ],
    [ month,  1,      durationMonth ],
    [ month,  3,  3 * durationMonth ],
    [  year,  1,      durationYear  ]
  ];

  function tickFormat(date) {
    return (second(date) < date ? formatMillisecond
        : minute(date) < date ? formatSecond
        : hour(date) < date ? formatMinute
        : day(date) < date ? formatHour
        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
        : year(date) < date ? formatMonth
        : formatYear)(date);
  }

  function tickInterval(interval, start, stop, step) {
    if (interval == null) interval = 10;

    // If a desired tick count is specified, pick a reasonable tick interval
    // based on the extent of the domain and a rough estimate of tick size.
    // Otherwise, assume interval is already a time interval and use it.
    if (typeof interval === "number") {
      var target = Math.abs(stop - start) / interval,
          i = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["c" /* bisector */])(function(i) { return i[2]; }).right(tickIntervals, target);
      if (i === tickIntervals.length) {
        step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["g" /* tickStep */])(start / durationYear, stop / durationYear, interval);
        interval = year;
      } else if (i) {
        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        step = i[1];
        interval = i[0];
      } else {
        step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["g" /* tickStep */])(start, stop, interval);
        interval = millisecond;
      }
    }

    return step == null ? interval : interval.every(step);
  }

  scale.invert = function(y) {
    return new Date(invert(y));
  };

  scale.domain = function(_) {
    return arguments.length ? domain(__WEBPACK_IMPORTED_MODULE_4__array__["a" /* map */].call(_, number)) : domain().map(date);
  };

  scale.ticks = function(interval, step) {
    var d = domain(),
        t0 = d[0],
        t1 = d[d.length - 1],
        r = t1 < t0,
        t;
    if (r) t = t0, t0 = t1, t1 = t;
    t = tickInterval(interval, t0, t1, step);
    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
    return r ? t.reverse() : t;
  };

  scale.tickFormat = function(count, specifier) {
    return specifier == null ? tickFormat : format(specifier);
  };

  scale.nice = function(interval, step) {
    var d = domain();
    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
        ? domain(Object(__WEBPACK_IMPORTED_MODULE_6__nice__["a" /* default */])(d, interval))
        : scale;
  };

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_5__continuous__["a" /* copy */])(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format));
  };

  return scale;
}

/* harmony default export */ __webpack_exports__["b"] = (function() {
  return calendar(__WEBPACK_IMPORTED_MODULE_2_d3_time__["k" /* timeYear */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["f" /* timeMonth */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["j" /* timeWeek */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["a" /* timeDay */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["b" /* timeHour */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["d" /* timeMinute */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["g" /* timeSecond */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["c" /* timeMillisecond */], __WEBPACK_IMPORTED_MODULE_3_d3_time_format__["a" /* timeFormat */]).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]);
});


/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__ = __webpack_require__(121);
/* unused harmony reexport timeFormatDefaultLocale */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["a"]; });
/* unused harmony reexport timeParse */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["b"]; });
/* unused harmony reexport utcParse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_locale__ = __webpack_require__(209);
/* unused harmony reexport timeFormatLocale */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_isoFormat__ = __webpack_require__(210);
/* unused harmony reexport isoFormat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_isoParse__ = __webpack_require__(520);
/* unused harmony reexport isoParse */






/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatLocale;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_time__ = __webpack_require__(120);


function localDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
    date.setFullYear(d.y);
    return date;
  }
  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}

function utcDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
    date.setUTCFullYear(d.y);
    return date;
  }
  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}

function newYear(y) {
  return {y: y, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0};
}

function formatLocale(locale) {
  var locale_dateTime = locale.dateTime,
      locale_date = locale.date,
      locale_time = locale.time,
      locale_periods = locale.periods,
      locale_weekdays = locale.days,
      locale_shortWeekdays = locale.shortDays,
      locale_months = locale.months,
      locale_shortMonths = locale.shortMonths;

  var periodRe = formatRe(locale_periods),
      periodLookup = formatLookup(locale_periods),
      weekdayRe = formatRe(locale_weekdays),
      weekdayLookup = formatLookup(locale_weekdays),
      shortWeekdayRe = formatRe(locale_shortWeekdays),
      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
      monthRe = formatRe(locale_months),
      monthLookup = formatLookup(locale_months),
      shortMonthRe = formatRe(locale_shortMonths),
      shortMonthLookup = formatLookup(locale_shortMonths);

  var formats = {
    "a": formatShortWeekday,
    "A": formatWeekday,
    "b": formatShortMonth,
    "B": formatMonth,
    "c": null,
    "d": formatDayOfMonth,
    "e": formatDayOfMonth,
    "f": formatMicroseconds,
    "H": formatHour24,
    "I": formatHour12,
    "j": formatDayOfYear,
    "L": formatMilliseconds,
    "m": formatMonthNumber,
    "M": formatMinutes,
    "p": formatPeriod,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatSeconds,
    "u": formatWeekdayNumberMonday,
    "U": formatWeekNumberSunday,
    "V": formatWeekNumberISO,
    "w": formatWeekdayNumberSunday,
    "W": formatWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatYear,
    "Y": formatFullYear,
    "Z": formatZone,
    "%": formatLiteralPercent
  };

  var utcFormats = {
    "a": formatUTCShortWeekday,
    "A": formatUTCWeekday,
    "b": formatUTCShortMonth,
    "B": formatUTCMonth,
    "c": null,
    "d": formatUTCDayOfMonth,
    "e": formatUTCDayOfMonth,
    "f": formatUTCMicroseconds,
    "H": formatUTCHour24,
    "I": formatUTCHour12,
    "j": formatUTCDayOfYear,
    "L": formatUTCMilliseconds,
    "m": formatUTCMonthNumber,
    "M": formatUTCMinutes,
    "p": formatUTCPeriod,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatUTCSeconds,
    "u": formatUTCWeekdayNumberMonday,
    "U": formatUTCWeekNumberSunday,
    "V": formatUTCWeekNumberISO,
    "w": formatUTCWeekdayNumberSunday,
    "W": formatUTCWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatUTCYear,
    "Y": formatUTCFullYear,
    "Z": formatUTCZone,
    "%": formatLiteralPercent
  };

  var parses = {
    "a": parseShortWeekday,
    "A": parseWeekday,
    "b": parseShortMonth,
    "B": parseMonth,
    "c": parseLocaleDateTime,
    "d": parseDayOfMonth,
    "e": parseDayOfMonth,
    "f": parseMicroseconds,
    "H": parseHour24,
    "I": parseHour24,
    "j": parseDayOfYear,
    "L": parseMilliseconds,
    "m": parseMonthNumber,
    "M": parseMinutes,
    "p": parsePeriod,
    "Q": parseUnixTimestamp,
    "s": parseUnixTimestampSeconds,
    "S": parseSeconds,
    "u": parseWeekdayNumberMonday,
    "U": parseWeekNumberSunday,
    "V": parseWeekNumberISO,
    "w": parseWeekdayNumberSunday,
    "W": parseWeekNumberMonday,
    "x": parseLocaleDate,
    "X": parseLocaleTime,
    "y": parseYear,
    "Y": parseFullYear,
    "Z": parseZone,
    "%": parseLiteralPercent
  };

  // These recursive directive definitions must be deferred.
  formats.x = newFormat(locale_date, formats);
  formats.X = newFormat(locale_time, formats);
  formats.c = newFormat(locale_dateTime, formats);
  utcFormats.x = newFormat(locale_date, utcFormats);
  utcFormats.X = newFormat(locale_time, utcFormats);
  utcFormats.c = newFormat(locale_dateTime, utcFormats);

  function newFormat(specifier, formats) {
    return function(date) {
      var string = [],
          i = -1,
          j = 0,
          n = specifier.length,
          c,
          pad,
          format;

      if (!(date instanceof Date)) date = new Date(+date);

      while (++i < n) {
        if (specifier.charCodeAt(i) === 37) {
          string.push(specifier.slice(j, i));
          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
          else pad = c === "e" ? " " : "0";
          if (format = formats[c]) c = format(date, pad);
          string.push(c);
          j = i + 1;
        }
      }

      string.push(specifier.slice(j, i));
      return string.join("");
    };
  }

  function newParse(specifier, newDate) {
    return function(string) {
      var d = newYear(1900),
          i = parseSpecifier(d, specifier, string += "", 0),
          week, day;
      if (i != string.length) return null;

      // If a UNIX timestamp is specified, return it.
      if ("Q" in d) return new Date(d.Q);

      // The am-pm flag is 0 for AM, and 1 for PM.
      if ("p" in d) d.H = d.H % 12 + d.p * 12;

      // Convert day-of-week and week-of-year to day-of-year.
      if ("V" in d) {
        if (d.V < 1 || d.V > 53) return null;
        if (!("w" in d)) d.w = 1;
        if ("Z" in d) {
          week = utcDate(newYear(d.y)), day = week.getUTCDay();
          week = day > 4 || day === 0 ? __WEBPACK_IMPORTED_MODULE_0_d3_time__["p" /* utcMonday */].ceil(week) : Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["p" /* utcMonday */])(week);
          week = __WEBPACK_IMPORTED_MODULE_0_d3_time__["l" /* utcDay */].offset(week, (d.V - 1) * 7);
          d.y = week.getUTCFullYear();
          d.m = week.getUTCMonth();
          d.d = week.getUTCDate() + (d.w + 6) % 7;
        } else {
          week = newDate(newYear(d.y)), day = week.getDay();
          week = day > 4 || day === 0 ? __WEBPACK_IMPORTED_MODULE_0_d3_time__["e" /* timeMonday */].ceil(week) : Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["e" /* timeMonday */])(week);
          week = __WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* timeDay */].offset(week, (d.V - 1) * 7);
          d.y = week.getFullYear();
          d.m = week.getMonth();
          d.d = week.getDate() + (d.w + 6) % 7;
        }
      } else if ("W" in d || "U" in d) {
        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
        day = "Z" in d ? utcDate(newYear(d.y)).getUTCDay() : newDate(newYear(d.y)).getDay();
        d.m = 0;
        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
      }

      // If a time zone is specified, all fields are interpreted as UTC and then
      // offset according to the specified time zone.
      if ("Z" in d) {
        d.H += d.Z / 100 | 0;
        d.M += d.Z % 100;
        return utcDate(d);
      }

      // Otherwise, all fields are in local time.
      return newDate(d);
    };
  }

  function parseSpecifier(d, specifier, string, j) {
    var i = 0,
        n = specifier.length,
        m = string.length,
        c,
        parse;

    while (i < n) {
      if (j >= m) return -1;
      c = specifier.charCodeAt(i++);
      if (c === 37) {
        c = specifier.charAt(i++);
        parse = parses[c in pads ? specifier.charAt(i++) : c];
        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
      } else if (c != string.charCodeAt(j++)) {
        return -1;
      }
    }

    return j;
  }

  function parsePeriod(d, string, i) {
    var n = periodRe.exec(string.slice(i));
    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortWeekday(d, string, i) {
    var n = shortWeekdayRe.exec(string.slice(i));
    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseWeekday(d, string, i) {
    var n = weekdayRe.exec(string.slice(i));
    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortMonth(d, string, i) {
    var n = shortMonthRe.exec(string.slice(i));
    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseMonth(d, string, i) {
    var n = monthRe.exec(string.slice(i));
    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseLocaleDateTime(d, string, i) {
    return parseSpecifier(d, locale_dateTime, string, i);
  }

  function parseLocaleDate(d, string, i) {
    return parseSpecifier(d, locale_date, string, i);
  }

  function parseLocaleTime(d, string, i) {
    return parseSpecifier(d, locale_time, string, i);
  }

  function formatShortWeekday(d) {
    return locale_shortWeekdays[d.getDay()];
  }

  function formatWeekday(d) {
    return locale_weekdays[d.getDay()];
  }

  function formatShortMonth(d) {
    return locale_shortMonths[d.getMonth()];
  }

  function formatMonth(d) {
    return locale_months[d.getMonth()];
  }

  function formatPeriod(d) {
    return locale_periods[+(d.getHours() >= 12)];
  }

  function formatUTCShortWeekday(d) {
    return locale_shortWeekdays[d.getUTCDay()];
  }

  function formatUTCWeekday(d) {
    return locale_weekdays[d.getUTCDay()];
  }

  function formatUTCShortMonth(d) {
    return locale_shortMonths[d.getUTCMonth()];
  }

  function formatUTCMonth(d) {
    return locale_months[d.getUTCMonth()];
  }

  function formatUTCPeriod(d) {
    return locale_periods[+(d.getUTCHours() >= 12)];
  }

  return {
    format: function(specifier) {
      var f = newFormat(specifier += "", formats);
      f.toString = function() { return specifier; };
      return f;
    },
    parse: function(specifier) {
      var p = newParse(specifier += "", localDate);
      p.toString = function() { return specifier; };
      return p;
    },
    utcFormat: function(specifier) {
      var f = newFormat(specifier += "", utcFormats);
      f.toString = function() { return specifier; };
      return f;
    },
    utcParse: function(specifier) {
      var p = newParse(specifier, utcDate);
      p.toString = function() { return specifier; };
      return p;
    }
  };
}

var pads = {"-": "", "_": " ", "0": "0"},
    numberRe = /^\s*\d+/, // note: ignores next directive
    percentRe = /^%/,
    requoteRe = /[\\^$*+?|[\]().{}]/g;

function pad(value, fill, width) {
  var sign = value < 0 ? "-" : "",
      string = (sign ? -value : value) + "",
      length = string.length;
  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}

function requote(s) {
  return s.replace(requoteRe, "\\$&");
}

function formatRe(names) {
  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}

function formatLookup(names) {
  var map = {}, i = -1, n = names.length;
  while (++i < n) map[names[i].toLowerCase()] = i;
  return map;
}

function parseWeekdayNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.w = +n[0], i + n[0].length) : -1;
}

function parseWeekdayNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.u = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.U = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberISO(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.V = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.W = +n[0], i + n[0].length) : -1;
}

function parseFullYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 4));
  return n ? (d.y = +n[0], i + n[0].length) : -1;
}

function parseYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}

function parseZone(d, string, i) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}

function parseMonthNumber(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}

function parseDayOfMonth(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.d = +n[0], i + n[0].length) : -1;
}

function parseDayOfYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}

function parseHour24(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.H = +n[0], i + n[0].length) : -1;
}

function parseMinutes(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.M = +n[0], i + n[0].length) : -1;
}

function parseSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.S = +n[0], i + n[0].length) : -1;
}

function parseMilliseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.L = +n[0], i + n[0].length) : -1;
}

function parseMicroseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 6));
  return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}

function parseLiteralPercent(d, string, i) {
  var n = percentRe.exec(string.slice(i, i + 1));
  return n ? i + n[0].length : -1;
}

function parseUnixTimestamp(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.Q = +n[0], i + n[0].length) : -1;
}

function parseUnixTimestampSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.Q = (+n[0]) * 1000, i + n[0].length) : -1;
}

function formatDayOfMonth(d, p) {
  return pad(d.getDate(), p, 2);
}

function formatHour24(d, p) {
  return pad(d.getHours(), p, 2);
}

function formatHour12(d, p) {
  return pad(d.getHours() % 12 || 12, p, 2);
}

function formatDayOfYear(d, p) {
  return pad(1 + __WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* timeDay */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["k" /* timeYear */])(d), d), p, 3);
}

function formatMilliseconds(d, p) {
  return pad(d.getMilliseconds(), p, 3);
}

function formatMicroseconds(d, p) {
  return formatMilliseconds(d, p) + "000";
}

function formatMonthNumber(d, p) {
  return pad(d.getMonth() + 1, p, 2);
}

function formatMinutes(d, p) {
  return pad(d.getMinutes(), p, 2);
}

function formatSeconds(d, p) {
  return pad(d.getSeconds(), p, 2);
}

function formatWeekdayNumberMonday(d) {
  var day = d.getDay();
  return day === 0 ? 7 : day;
}

function formatWeekNumberSunday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["h" /* timeSunday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["k" /* timeYear */])(d), d), p, 2);
}

function formatWeekNumberISO(d, p) {
  var day = d.getDay();
  d = (day >= 4 || day === 0) ? Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["i" /* timeThursday */])(d) : __WEBPACK_IMPORTED_MODULE_0_d3_time__["i" /* timeThursday */].ceil(d);
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["i" /* timeThursday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["k" /* timeYear */])(d), d) + (Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["k" /* timeYear */])(d).getDay() === 4), p, 2);
}

function formatWeekdayNumberSunday(d) {
  return d.getDay();
}

function formatWeekNumberMonday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["e" /* timeMonday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["k" /* timeYear */])(d), d), p, 2);
}

function formatYear(d, p) {
  return pad(d.getFullYear() % 100, p, 2);
}

function formatFullYear(d, p) {
  return pad(d.getFullYear() % 10000, p, 4);
}

function formatZone(d) {
  var z = d.getTimezoneOffset();
  return (z > 0 ? "-" : (z *= -1, "+"))
      + pad(z / 60 | 0, "0", 2)
      + pad(z % 60, "0", 2);
}

function formatUTCDayOfMonth(d, p) {
  return pad(d.getUTCDate(), p, 2);
}

function formatUTCHour24(d, p) {
  return pad(d.getUTCHours(), p, 2);
}

function formatUTCHour12(d, p) {
  return pad(d.getUTCHours() % 12 || 12, p, 2);
}

function formatUTCDayOfYear(d, p) {
  return pad(1 + __WEBPACK_IMPORTED_MODULE_0_d3_time__["l" /* utcDay */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["v" /* utcYear */])(d), d), p, 3);
}

function formatUTCMilliseconds(d, p) {
  return pad(d.getUTCMilliseconds(), p, 3);
}

function formatUTCMicroseconds(d, p) {
  return formatUTCMilliseconds(d, p) + "000";
}

function formatUTCMonthNumber(d, p) {
  return pad(d.getUTCMonth() + 1, p, 2);
}

function formatUTCMinutes(d, p) {
  return pad(d.getUTCMinutes(), p, 2);
}

function formatUTCSeconds(d, p) {
  return pad(d.getUTCSeconds(), p, 2);
}

function formatUTCWeekdayNumberMonday(d) {
  var dow = d.getUTCDay();
  return dow === 0 ? 7 : dow;
}

function formatUTCWeekNumberSunday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["s" /* utcSunday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["v" /* utcYear */])(d), d), p, 2);
}

function formatUTCWeekNumberISO(d, p) {
  var day = d.getUTCDay();
  d = (day >= 4 || day === 0) ? Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["t" /* utcThursday */])(d) : __WEBPACK_IMPORTED_MODULE_0_d3_time__["t" /* utcThursday */].ceil(d);
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["t" /* utcThursday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["v" /* utcYear */])(d), d) + (Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["v" /* utcYear */])(d).getUTCDay() === 4), p, 2);
}

function formatUTCWeekdayNumberSunday(d) {
  return d.getUTCDay();
}

function formatUTCWeekNumberMonday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["p" /* utcMonday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["v" /* utcYear */])(d), d), p, 2);
}

function formatUTCYear(d, p) {
  return pad(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCFullYear(d, p) {
  return pad(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCZone() {
  return "+0000";
}

function formatLiteralPercent() {
  return "%";
}

function formatUnixTimestamp(d) {
  return +d;
}

function formatUnixTimestampSeconds(d) {
  return Math.floor(+d / 1000);
}


/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isoSpecifier; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultLocale__ = __webpack_require__(121);


var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";

function formatIsoNative(date) {
  return date.toISOString();
}

var formatIso = Date.prototype.toISOString
    ? formatIsoNative
    : Object(__WEBPACK_IMPORTED_MODULE_0__defaultLocale__["b" /* utcFormat */])(isoSpecifier);

/* unused harmony default export */ var _unused_webpack_default_export = (formatIso);


/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_PureRender__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__container_Layer__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shape_Dot__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__component_Label__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_DataUtils__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_ChartUtils__ = __webpack_require__(11);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Reference Dot
 */












var ReferenceDot = Object(__WEBPACK_IMPORTED_MODULE_4__util_PureRender__["a" /* default */])(_class = (_temp = _class2 = function (_Component) {
  _inherits(ReferenceDot, _Component);

  function ReferenceDot() {
    _classCallCheck(this, ReferenceDot);

    return _possibleConstructorReturn(this, (ReferenceDot.__proto__ || Object.getPrototypeOf(ReferenceDot)).apply(this, arguments));
  }

  _createClass(ReferenceDot, [{
    key: 'getCoordinate',
    value: function getCoordinate() {
      var _props = this.props,
          x = _props.x,
          y = _props.y,
          xAxis = _props.xAxis,
          yAxis = _props.yAxis;

      var xScale = xAxis.scale;
      var yScale = yAxis.scale;
      var result = {
        cx: xScale(x) + (xScale.bandwidth ? xScale.bandwidth() / 2 : 0),
        cy: yScale(y) + (yScale.bandwidth ? yScale.bandwidth() / 2 : 0)
      };

      if (Object(__WEBPACK_IMPORTED_MODULE_10__util_ChartUtils__["D" /* validateCoordinateInRange */])(result.cx, xScale) && Object(__WEBPACK_IMPORTED_MODULE_10__util_ChartUtils__["D" /* validateCoordinateInRange */])(result.cy, yScale)) {
        return result;
      }

      return null;
    }
  }, {
    key: 'renderDot',
    value: function renderDot(option, props) {
      var dot = void 0;

      if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(option)) {
        dot = __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(option)) {
        dot = option(props);
      } else {
        dot = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shape_Dot__["a" /* default */], _extends({}, props, {
          cx: props.cx,
          cy: props.cy,
          className: 'recharts-reference-dot-dot'
        }));
      }

      return dot;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          x = _props2.x,
          y = _props2.y,
          r = _props2.r;

      var isX = Object(__WEBPACK_IMPORTED_MODULE_9__util_DataUtils__["f" /* isNumOrStr */])(x);
      var isY = Object(__WEBPACK_IMPORTED_MODULE_9__util_DataUtils__["f" /* isNumOrStr */])(y);

      if (!isX || !isY) {
        return null;
      }

      var coordinate = this.getCoordinate();

      if (!coordinate) {
        return null;
      }

      var _props3 = this.props,
          shape = _props3.shape,
          className = _props3.className;


      var dotProps = _extends({}, Object(__WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["k" /* getPresentationAttributes */])(this.props), Object(__WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["e" /* filterEventAttributes */])(this.props), coordinate);

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__container_Layer__["a" /* default */],
        { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('recharts-reference-dot', className) },
        this.renderDot(shape, dotProps),
        __WEBPACK_IMPORTED_MODULE_8__component_Label__["a" /* default */].renderCallByParent(this.props, {
          x: coordinate.cx - r,
          y: coordinate.cy - r,
          width: 2 * r,
          height: 2 * r
        })
      );
    }
  }]);

  return ReferenceDot;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class2.displayName = 'ReferenceDot', _class2.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], __WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["a" /* EVENT_ATTRIBUTES */], {
  r: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,

  xAxis: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({ scale: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func }),
  yAxis: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({ scale: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func }),

  isFront: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  alwaysShow: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  x: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
  y: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),

  className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
  yAxisId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
  xAxisId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
  shape: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element])
}), _class2.defaultProps = {
  isFront: false,
  alwaysShow: false,
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: '#fff',
  stroke: '#ccc',
  fillOpacity: 1,
  strokeWidth: 1
}, _temp)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (ReferenceDot);

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_PureRender__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__container_Layer__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__component_Label__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_DataUtils__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_ChartUtils__ = __webpack_require__(11);


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Reference Line
 */











var renderLine = function renderLine(option, props) {
  var line = void 0;

  if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(option)) {
    line = __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(option, props);
  } else if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(option)) {
    line = option(props);
  } else {
    line = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('line', _extends({}, props, {
      className: 'recharts-reference-line-line'
    }));
  }

  return line;
};

var ReferenceLine = Object(__WEBPACK_IMPORTED_MODULE_4__util_PureRender__["a" /* default */])(_class = (_temp = _class2 = function (_Component) {
  _inherits(ReferenceLine, _Component);

  function ReferenceLine() {
    _classCallCheck(this, ReferenceLine);

    return _possibleConstructorReturn(this, (ReferenceLine.__proto__ || Object.getPrototypeOf(ReferenceLine)).apply(this, arguments));
  }

  _createClass(ReferenceLine, [{
    key: 'getEndPoints',
    value: function getEndPoints(isX, isY) {
      var _props = this.props,
          xAxis = _props.xAxis,
          yAxis = _props.yAxis,
          viewBox = _props.viewBox;
      var x = viewBox.x,
          y = viewBox.y,
          width = viewBox.width,
          height = viewBox.height;


      if (isY) {
        var value = this.props.y;
        var scale = yAxis.scale;

        var offset = scale.bandwidth ? scale.bandwidth() / 2 : 0;
        var coord = scale(value) + offset;

        if (Object(__WEBPACK_IMPORTED_MODULE_9__util_ChartUtils__["D" /* validateCoordinateInRange */])(coord, scale)) {
          return yAxis.orientation === 'left' ? [{ x: x, y: coord }, { x: x + width, y: coord }] : [{ x: x + width, y: coord }, { x: x, y: coord }];
        }
      } else if (isX) {
        var _value = this.props.x;
        var _scale = xAxis.scale;

        var _offset = _scale.bandwidth ? _scale.bandwidth() / 2 : 0;
        var _coord = _scale(_value) + _offset;

        if (Object(__WEBPACK_IMPORTED_MODULE_9__util_ChartUtils__["D" /* validateCoordinateInRange */])(_coord, _scale)) {
          return xAxis.orientation === 'top' ? [{ x: _coord, y: y }, { x: _coord, y: y + height }] : [{ x: _coord, y: y + height }, { x: _coord, y: y }];
        }
      }

      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          x = _props2.x,
          y = _props2.y,
          shape = _props2.shape,
          className = _props2.className;

      var isX = Object(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["f" /* isNumOrStr */])(x);
      var isY = Object(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["f" /* isNumOrStr */])(y);

      if (!isX && !isY) {
        return null;
      }

      var endPoints = this.getEndPoints(isX, isY);

      if (!endPoints) {
        return null;
      }

      var _endPoints = _slicedToArray(endPoints, 2),
          start = _endPoints[0],
          end = _endPoints[1];

      var props = _extends({}, Object(__WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["k" /* getPresentationAttributes */])(this.props), Object(__WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["e" /* filterEventAttributes */])(this.props), {
        x1: start.x,
        y1: start.y,
        x2: end.x,
        y2: end.y
      });

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__container_Layer__["a" /* default */],
        { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('recharts-reference-line', className) },
        renderLine(shape, props),
        __WEBPACK_IMPORTED_MODULE_7__component_Label__["a" /* default */].renderCallByParent(this.props, {
          x: Math.min(props.x1, props.x2),
          y: Math.min(props.y1, props.y2),
          width: Math.abs(props.x2 - props.x1),
          height: Math.abs(props.y2 - props.y1)
        })
      );
    }
  }]);

  return ReferenceLine;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class2.displayName = 'ReferenceLine', _class2.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {
  viewBox: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    y: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    width: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    height: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number
  }),

  xAxis: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  yAxis: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,

  isFront: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  alwaysShow: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  x: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
  y: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),

  className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
  yAxisId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
  xAxisId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),

  shape: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
}), _class2.defaultProps = {
  isFront: false,
  alwaysShow: false,
  xAxisId: 0,
  yAxisId: 0,
  fill: 'none',
  stroke: '#ccc',
  fillOpacity: 1,
  strokeWidth: 1
}, _temp)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (ReferenceLine);

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_PureRender__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__container_Layer__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__component_Label__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_DataUtils__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_ChartUtils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shape_Rectangle__ = __webpack_require__(40);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Reference Line
 */












var ReferenceArea = Object(__WEBPACK_IMPORTED_MODULE_4__util_PureRender__["a" /* default */])(_class = (_temp = _class2 = function (_Component) {
  _inherits(ReferenceArea, _Component);

  function ReferenceArea() {
    _classCallCheck(this, ReferenceArea);

    return _possibleConstructorReturn(this, (ReferenceArea.__proto__ || Object.getPrototypeOf(ReferenceArea)).apply(this, arguments));
  }

  _createClass(ReferenceArea, [{
    key: 'getRect',
    value: function getRect(hasX1, hasX2, hasY1, hasY2) {
      var _props = this.props,
          xValue1 = _props.x1,
          xValue2 = _props.x2,
          yValue1 = _props.y1,
          yValue2 = _props.y2,
          xAxis = _props.xAxis,
          yAxis = _props.yAxis;

      var xScale = xAxis.scale;
      var yScale = yAxis.scale;
      var xOffset = xScale.bandwidth ? xScale.bandwidth() / 2 : 0;
      var yOffset = yScale.bandwidth ? yScale.bandwidth() / 2 : 0;
      var xRange = xScale.range();
      var yRange = yScale.range();
      var x1 = void 0,
          x2 = void 0,
          y1 = void 0,
          y2 = void 0;

      if (hasX1) {
        x1 = xScale(xValue1) + xOffset;
      } else {
        x1 = xRange[0];
      }

      if (hasX2) {
        x2 = xScale(xValue2) + xOffset;
      } else {
        x2 = xRange[1];
      }

      if (hasY1) {
        y1 = yScale(yValue1) + yOffset;
      } else {
        y1 = yRange[0];
      }

      if (hasY2) {
        y2 = yScale(yValue2) + yOffset;
      } else {
        y2 = yRange[1];
      }

      if (Object(__WEBPACK_IMPORTED_MODULE_9__util_ChartUtils__["D" /* validateCoordinateInRange */])(x1, xScale) && Object(__WEBPACK_IMPORTED_MODULE_9__util_ChartUtils__["D" /* validateCoordinateInRange */])(x2, xScale) && Object(__WEBPACK_IMPORTED_MODULE_9__util_ChartUtils__["D" /* validateCoordinateInRange */])(y1, yScale) && Object(__WEBPACK_IMPORTED_MODULE_9__util_ChartUtils__["D" /* validateCoordinateInRange */])(y2, yScale)) {
        return {
          x: Math.min(x1, x2),
          y: Math.min(y1, y2),
          width: Math.abs(x2 - x1),
          height: Math.abs(y2 - y1)
        };
      }

      return null;
    }
  }, {
    key: 'renderRect',
    value: function renderRect(option, props) {
      var rect = void 0;

      if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(option)) {
        rect = __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(option)) {
        rect = option(props);
      } else {
        rect = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shape_Rectangle__["a" /* default */], _extends({}, props, {
          className: 'recharts-reference-area-rect'
        }));
      }

      return rect;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          x1 = _props2.x1,
          x2 = _props2.x2,
          y1 = _props2.y1,
          y2 = _props2.y2,
          className = _props2.className;


      var hasX1 = Object(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["f" /* isNumOrStr */])(x1);
      var hasX2 = Object(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["f" /* isNumOrStr */])(x2);
      var hasY1 = Object(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["f" /* isNumOrStr */])(y1);
      var hasY2 = Object(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["f" /* isNumOrStr */])(y2);

      if (!hasX1 && !hasX2 && !hasY1 && !hasY2) {
        return null;
      }

      var rect = this.getRect(hasX1, hasX2, hasY1, hasY2);

      if (!rect) {
        return null;
      }

      var shape = this.props.shape;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__container_Layer__["a" /* default */],
        { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('recharts-reference-area', className) },
        this.renderRect(shape, _extends({}, this.props, rect)),
        __WEBPACK_IMPORTED_MODULE_6__component_Label__["a" /* default */].renderCallByParent(this.props, rect)
      );
    }
  }]);

  return ReferenceArea;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class2.displayName = 'ReferenceArea', _class2.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {
  viewBox: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    y: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    width: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    height: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number
  }),

  xAxis: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  yAxis: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,

  isFront: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  alwaysShow: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  x1: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
  x2: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
  y1: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
  y2: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),

  className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
  yAxisId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
  xAxisId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
  shape: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element])
}), _class2.defaultProps = {
  isFront: false,
  alwaysShow: false,
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: '#ccc',
  fillOpacity: 0.5,
  stroke: 'none',
  strokeWidth: 1
}, _temp)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (ReferenceArea);

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_PureRender__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_DataUtils__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Cross
 */







var Cross = Object(__WEBPACK_IMPORTED_MODULE_3__util_PureRender__["a" /* default */])(_class = (_temp = _class2 = function (_Component) {
  _inherits(Cross, _Component);

  function Cross() {
    _classCallCheck(this, Cross);

    return _possibleConstructorReturn(this, (Cross.__proto__ || Object.getPrototypeOf(Cross)).apply(this, arguments));
  }

  _createClass(Cross, [{
    key: 'getPath',
    value: function getPath(x, y, width, height, top, left) {
      return 'M' + x + ',' + top + 'v' + height + 'M' + left + ',' + y + 'h' + width;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          x = _props.x,
          y = _props.y,
          width = _props.width,
          height = _props.height,
          top = _props.top,
          left = _props.left,
          className = _props.className;


      if (!Object(__WEBPACK_IMPORTED_MODULE_4__util_DataUtils__["g" /* isNumber */])(x) || !Object(__WEBPACK_IMPORTED_MODULE_4__util_DataUtils__["g" /* isNumber */])(y) || !Object(__WEBPACK_IMPORTED_MODULE_4__util_DataUtils__["g" /* isNumber */])(width) || !Object(__WEBPACK_IMPORTED_MODULE_4__util_DataUtils__["g" /* isNumber */])(height) || !Object(__WEBPACK_IMPORTED_MODULE_4__util_DataUtils__["g" /* isNumber */])(top) || !Object(__WEBPACK_IMPORTED_MODULE_4__util_DataUtils__["g" /* isNumber */])(left)) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', _extends({}, Object(__WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__["k" /* getPresentationAttributes */])(this.props), {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('recharts-cross', className),
        d: this.getPath(x, y, width, height, top, left)
      }));
    }
  }]);

  return Cross;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class2.displayName = 'Cross', _class2.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {
  x: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  y: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  top: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  left: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
}), _class2.defaultProps = {
  x: 0,
  y: 0,
  top: 0,
  left: 0,
  width: 0,
  height: 0
}, _temp)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (Cross);

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

var baseExtremum = __webpack_require__(76),
    baseGt = __webpack_require__(174),
    baseIteratee = __webpack_require__(51);

/**
 * This method is like `_.max` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * the value is ranked. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * _.maxBy(objects, function(o) { return o.n; });
 * // => { 'n': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.maxBy(objects, 'n');
 * // => { 'n': 2 }
 */
function maxBy(array, iteratee) {
  return (array && array.length)
    ? baseExtremum(array, baseIteratee(iteratee, 2), baseGt)
    : undefined;
}

module.exports = maxBy;


/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isPlainObject__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isPlainObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isPlainObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isFunction__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isNil__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_smooth__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_smooth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_smooth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_PureRender__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__container_Layer__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shape_Sector__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shape_Curve__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__component_Text__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__component_Label__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__component_LabelList__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__component_Cell__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__util_ReactUtils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__util_PolarUtils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__util_DataUtils__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__util_ChartUtils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__util_LogUtils__ = __webpack_require__(171);





var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Render sectors of a pie
 */



















var Pie = Object(__WEBPACK_IMPORTED_MODULE_8__util_PureRender__["a" /* default */])(_class = (_temp2 = _class2 = function (_Component) {
  _inherits(Pie, _Component);

  function Pie() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Pie);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Pie.__proto__ || Object.getPrototypeOf(Pie)).call.apply(_ref, [this].concat(args))), _this), _this.state = { isAnimationFinished: false, isAnimationStarted: false }, _this.id = Object(__WEBPACK_IMPORTED_MODULE_18__util_DataUtils__["j" /* uniqueId */])('recharts-pie-'), _this.cachePrevData = function (sectors) {
      _this.setState({ prevSectors: sectors });
    }, _this.handleAnimationEnd = function () {
      _this.setState({
        isAnimationFinished: true
      });
    }, _this.handleAnimationStart = function () {
      _this.setState({
        isAnimationStarted: true
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Pie, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props = this.props,
          animationId = _props.animationId,
          sectors = _props.sectors;


      if (nextProps.isAnimationActive !== this.props.isAnimationActive) {
        this.cachePrevData([]);
      } else if (nextProps.animationId !== animationId) {
        this.cachePrevData(sectors);
      }
    }
  }, {
    key: 'getTextAnchor',
    value: function getTextAnchor(x, cx) {
      if (x > cx) {
        return 'start';
      } else if (x < cx) {
        return 'end';
      }

      return 'middle';
    }
  }, {
    key: 'isActiveIndex',
    value: function isActiveIndex(i) {
      var activeIndex = this.props.activeIndex;


      if (Array.isArray(activeIndex)) {
        return activeIndex.indexOf(i) !== -1;
      }

      return i === activeIndex;
    }
  }, {
    key: 'renderLabelLineItem',
    value: function renderLabelLineItem(option, props) {
      if (__WEBPACK_IMPORTED_MODULE_4_react___default.a.isValidElement(option)) {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_2_lodash_isFunction___default()(option)) {
        return option(props);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shape_Curve__["a" /* default */], _extends({}, props, { type: 'linear', className: 'recharts-pie-label-line' }));
    }
  }, {
    key: 'renderLabelItem',
    value: function renderLabelItem(option, props, value) {
      if (__WEBPACK_IMPORTED_MODULE_4_react___default.a.isValidElement(option)) {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(option, props);
      }
      var label = value;
      if (__WEBPACK_IMPORTED_MODULE_2_lodash_isFunction___default()(option)) {
        label = option(props);
        if (__WEBPACK_IMPORTED_MODULE_4_react___default.a.isValidElement(label)) {
          return label;
        }
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_12__component_Text__["a" /* default */],
        _extends({}, props, {
          alignmentBaseline: 'middle',
          className: 'recharts-pie-label-text'
        }),
        label
      );
    }
  }, {
    key: 'renderLabels',
    value: function renderLabels(sectors) {
      var _this2 = this;

      var isAnimationActive = this.props.isAnimationActive;


      if (isAnimationActive && !this.state.isAnimationFinished) {
        return null;
      }
      var _props2 = this.props,
          label = _props2.label,
          labelLine = _props2.labelLine,
          dataKey = _props2.dataKey,
          valueKey = _props2.valueKey;

      var pieProps = Object(__WEBPACK_IMPORTED_MODULE_16__util_ReactUtils__["k" /* getPresentationAttributes */])(this.props);
      var customLabelProps = Object(__WEBPACK_IMPORTED_MODULE_16__util_ReactUtils__["k" /* getPresentationAttributes */])(label);
      var customLabelLineProps = Object(__WEBPACK_IMPORTED_MODULE_16__util_ReactUtils__["k" /* getPresentationAttributes */])(labelLine);
      var offsetRadius = label && label.offsetRadius || 20;

      var labels = sectors.map(function (entry, i) {
        var midAngle = (entry.startAngle + entry.endAngle) / 2;
        var endPoint = Object(__WEBPACK_IMPORTED_MODULE_17__util_PolarUtils__["e" /* polarToCartesian */])(entry.cx, entry.cy, entry.outerRadius + offsetRadius, midAngle);
        var labelProps = _extends({}, pieProps, entry, {
          stroke: 'none'
        }, customLabelProps, {
          index: i,
          textAnchor: _this2.getTextAnchor(endPoint.x, entry.cx)
        }, endPoint);
        var lineProps = _extends({}, pieProps, entry, {
          fill: 'none',
          stroke: entry.fill
        }, customLabelLineProps, {
          index: i,
          points: [Object(__WEBPACK_IMPORTED_MODULE_17__util_PolarUtils__["e" /* polarToCartesian */])(entry.cx, entry.cy, entry.outerRadius, midAngle), endPoint]
        });
        var realDataKey = dataKey;
        // TODO: compatible to lower versions
        if (__WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default()(dataKey) && __WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default()(valueKey)) {
          realDataKey = 'value';
        } else if (__WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default()(dataKey)) {
          realDataKey = valueKey;
        }

        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__container_Layer__["a" /* default */],
          { key: 'label-' + i },
          labelLine && _this2.renderLabelLineItem(labelLine, lineProps),
          _this2.renderLabelItem(label, labelProps, Object(__WEBPACK_IMPORTED_MODULE_19__util_ChartUtils__["w" /* getValueByDataKey */])(entry, realDataKey))
        );
      });

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__container_Layer__["a" /* default */],
        { className: 'recharts-pie-labels' },
        labels
      );
    }
  }, {
    key: 'renderSectorItem',
    value: function renderSectorItem(option, props) {
      if (__WEBPACK_IMPORTED_MODULE_4_react___default.a.isValidElement(option)) {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_2_lodash_isFunction___default()(option)) {
        return option(props);
      } else if (__WEBPACK_IMPORTED_MODULE_1_lodash_isPlainObject___default()(option)) {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shape_Sector__["a" /* default */], _extends({}, props, option));
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shape_Sector__["a" /* default */], props);
    }
  }, {
    key: 'renderSectorsStatically',
    value: function renderSectorsStatically(sectors) {
      var _this3 = this;

      var activeShape = this.props.activeShape;


      return sectors.map(function (entry, i) {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__container_Layer__["a" /* default */],
          _extends({
            className: 'recharts-pie-sector'
          }, Object(__WEBPACK_IMPORTED_MODULE_16__util_ReactUtils__["f" /* filterEventsOfChild */])(_this3.props, entry, i), {
            key: 'sector-' + i
          }),
          _this3.renderSectorItem(_this3.isActiveIndex(i) ? activeShape : null, entry)
        );
      });
    }
  }, {
    key: 'renderSectorsWithAnimation',
    value: function renderSectorsWithAnimation() {
      var _this4 = this;

      var _props3 = this.props,
          sectors = _props3.sectors,
          isAnimationActive = _props3.isAnimationActive,
          animationBegin = _props3.animationBegin,
          animationDuration = _props3.animationDuration,
          animationEasing = _props3.animationEasing,
          animationId = _props3.animationId;
      var prevSectors = this.state.prevSectors;


      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_smooth___default.a,
        {
          begin: animationBegin,
          duration: animationDuration,
          isActive: isAnimationActive,
          easing: animationEasing,
          from: { t: 0 },
          to: { t: 1 },
          key: 'pie-' + animationId,
          onAnimationEnd: this.handleAnimationEnd
        },
        function (_ref2) {
          var t = _ref2.t;

          var stepData = [];
          var first = sectors && sectors[0];
          var curAngle = first.startAngle;

          sectors.forEach(function (entry, index) {
            var prev = prevSectors && prevSectors[index];
            var paddingAngle = index > 0 ? entry.paddingAngle : 0;

            if (prev) {
              var angleIp = Object(__WEBPACK_IMPORTED_MODULE_18__util_DataUtils__["e" /* interpolateNumber */])(prev.endAngle - prev.startAngle, entry.endAngle - entry.startAngle);
              var latest = _extends({}, entry, {
                startAngle: curAngle + paddingAngle,
                endAngle: curAngle + angleIp(t) + paddingAngle
              });

              stepData.push(latest);
              curAngle = latest.endAngle;
            } else {
              var endAngle = entry.endAngle,
                  startAngle = entry.startAngle;

              var interpolatorAngle = Object(__WEBPACK_IMPORTED_MODULE_18__util_DataUtils__["e" /* interpolateNumber */])(0, endAngle - startAngle);
              var deltaAngle = interpolatorAngle(t);
              var _latest = _extends({}, entry, {
                startAngle: curAngle + paddingAngle,
                endAngle: curAngle + deltaAngle + paddingAngle
              });

              stepData.push(_latest);
              curAngle = _latest.endAngle;
            }
          });

          return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__container_Layer__["a" /* default */],
            null,
            _this4.renderSectorsStatically(stepData)
          );
        }
      );
    }
  }, {
    key: 'renderSectors',
    value: function renderSectors() {
      var _props4 = this.props,
          sectors = _props4.sectors,
          isAnimationActive = _props4.isAnimationActive;
      var prevSectors = this.state.prevSectors;


      if (isAnimationActive && sectors && sectors.length && (!prevSectors || !__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(prevSectors, sectors))) {
        return this.renderSectorsWithAnimation();
      }
      return this.renderSectorsStatically(sectors);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props5 = this.props,
          hide = _props5.hide,
          sectors = _props5.sectors,
          className = _props5.className,
          label = _props5.label,
          cx = _props5.cx,
          cy = _props5.cy,
          innerRadius = _props5.innerRadius,
          outerRadius = _props5.outerRadius,
          isAnimationActive = _props5.isAnimationActive,
          id = _props5.id;


      if (hide || !sectors || !sectors.length || !Object(__WEBPACK_IMPORTED_MODULE_18__util_DataUtils__["g" /* isNumber */])(cx) || !Object(__WEBPACK_IMPORTED_MODULE_18__util_DataUtils__["g" /* isNumber */])(cy) || !Object(__WEBPACK_IMPORTED_MODULE_18__util_DataUtils__["g" /* isNumber */])(innerRadius) || !Object(__WEBPACK_IMPORTED_MODULE_18__util_DataUtils__["g" /* isNumber */])(outerRadius)) {
        return null;
      }

      var isAnimationFinished = this.state.isAnimationFinished;

      var layerClass = __WEBPACK_IMPORTED_MODULE_7_classnames___default()('recharts-pie', className);

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__container_Layer__["a" /* default */],
        { className: layerClass },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          'g',
          { clipPath: 'url(#' + (__WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default()(id) ? this.id : id) + ')' },
          this.renderSectors()
        ),
        label && this.renderLabels(sectors),
        __WEBPACK_IMPORTED_MODULE_13__component_Label__["a" /* default */].renderCallByParent(this.props, null, false),
        (!isAnimationActive || isAnimationFinished) && __WEBPACK_IMPORTED_MODULE_14__component_LabelList__["a" /* default */].renderCallByParent(this.props, sectors, false)
      );
    }
  }]);

  return Pie;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]), _class2.displayName = 'Pie', _class2.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_16__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], __WEBPACK_IMPORTED_MODULE_16__util_ReactUtils__["a" /* EVENT_ATTRIBUTES */], {
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  animationId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  cx: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),
  cy: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),
  startAngle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  endAngle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  paddingAngle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  innerRadius: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),
  outerRadius: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),
  cornerRadius: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),
  dataKey: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func]).isRequired,
  nameKey: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func]),
  valueKey: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func]),
  data: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object),
  minAngle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  legendType: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_16__util_ReactUtils__["b" /* LEGEND_TYPES */]),
  maxRadius: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  sectors: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object),
  hide: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  labelLine: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool]),
  label: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    offsetRadius: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number
  }), __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool]),
  activeShape: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.element]),
  activeIndex: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number)]),

  isAnimationActive: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  animationBegin: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  animationDuration: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  animationEasing: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'spring', 'linear']),
  id: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
}), _class2.defaultProps = {
  stroke: '#fff',
  fill: '#808080',
  legendType: 'rect',
  // The abscissa of pole
  cx: '50%',
  // The ordinate of pole
  cy: '50%',
  // The start angle of first sector
  startAngle: 0,
  // The direction of drawing sectors
  endAngle: 360,
  // The inner radius of sectors
  innerRadius: 0,
  // The outer radius of sectors
  outerRadius: '80%',
  paddingAngle: 0,
  labelLine: true,
  hide: false,
  minAngle: 0,
  isAnimationActive: !Object(__WEBPACK_IMPORTED_MODULE_16__util_ReactUtils__["n" /* isSsr */])(),
  animationBegin: 400,
  animationDuration: 1500,
  animationEasing: 'ease',
  nameKey: 'name'
}, _class2.parseDeltaAngle = function (_ref3) {
  var startAngle = _ref3.startAngle,
      endAngle = _ref3.endAngle;

  var sign = Object(__WEBPACK_IMPORTED_MODULE_18__util_DataUtils__["i" /* mathSign */])(endAngle - startAngle);
  var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);

  return sign * deltaAngle;
}, _class2.getRealPieData = function (item) {
  var _item$props = item.props,
      data = _item$props.data,
      children = _item$props.children;

  var presentationProps = Object(__WEBPACK_IMPORTED_MODULE_16__util_ReactUtils__["k" /* getPresentationAttributes */])(item.props);
  var cells = Object(__WEBPACK_IMPORTED_MODULE_16__util_ReactUtils__["h" /* findAllByType */])(children, __WEBPACK_IMPORTED_MODULE_15__component_Cell__["a" /* default */]);

  if (data && data.length) {
    return data.map(function (entry, index) {
      return _extends({
        payload: entry
      }, presentationProps, entry, cells && cells[index] && cells[index].props);
    });
  }

  if (cells && cells.length) {
    return cells.map(function (cell) {
      return _extends({}, presentationProps, cell.props);
    });
  }

  return [];
}, _class2.parseCoordinateOfPie = function (item, offset) {
  var top = offset.top,
      left = offset.left,
      width = offset.width,
      height = offset.height;

  var maxPieRadius = Object(__WEBPACK_IMPORTED_MODULE_17__util_PolarUtils__["c" /* getMaxRadius */])(width, height);
  var cx = left + Object(__WEBPACK_IMPORTED_MODULE_18__util_DataUtils__["c" /* getPercentValue */])(item.props.cx, width, width / 2);
  var cy = top + Object(__WEBPACK_IMPORTED_MODULE_18__util_DataUtils__["c" /* getPercentValue */])(item.props.cy, height, height / 2);
  var innerRadius = Object(__WEBPACK_IMPORTED_MODULE_18__util_DataUtils__["c" /* getPercentValue */])(item.props.innerRadius, maxPieRadius, 0);
  var outerRadius = Object(__WEBPACK_IMPORTED_MODULE_18__util_DataUtils__["c" /* getPercentValue */])(item.props.outerRadius, maxPieRadius, maxPieRadius * 0.8);
  var maxRadius = item.props.maxRadius || Math.sqrt(width * width + height * height) / 2;

  return { cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, maxRadius: maxRadius };
}, _class2.getComposedData = function (_ref4) {
  var item = _ref4.item,
      offset = _ref4.offset,
      onItemMouseLeave = _ref4.onItemMouseLeave,
      onItemMouseEnter = _ref4.onItemMouseEnter;

  var pieData = Pie.getRealPieData(item);
  if (!pieData || !pieData.length) {
    return [];
  }

  var _item$props2 = item.props,
      cornerRadius = _item$props2.cornerRadius,
      startAngle = _item$props2.startAngle,
      endAngle = _item$props2.endAngle,
      paddingAngle = _item$props2.paddingAngle,
      dataKey = _item$props2.dataKey,
      nameKey = _item$props2.nameKey,
      valueKey = _item$props2.valueKey;

  var minAngle = Math.abs(item.props.minAngle);
  var coordinate = Pie.parseCoordinateOfPie(item, offset);
  var len = pieData.length;
  var deltaAngle = Pie.parseDeltaAngle({ startAngle: startAngle, endAngle: endAngle });
  var absDeltaAngle = Math.abs(deltaAngle);
  var totalPadingAngle = (absDeltaAngle >= 360 ? len : len - 1) * paddingAngle;
  var realTotalAngle = absDeltaAngle - len * minAngle - totalPadingAngle;
  var realDataKey = dataKey;

  if (__WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default()(dataKey) && __WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default()(valueKey)) {
    Object(__WEBPACK_IMPORTED_MODULE_20__util_LogUtils__["a" /* warn */])(false, 'Use "dataKey" to specify the value of pie,\n      the props "valueKey" will be deprecated in 1.1.0');
    realDataKey = 'value';
  } else if (__WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default()(dataKey)) {
    Object(__WEBPACK_IMPORTED_MODULE_20__util_LogUtils__["a" /* warn */])(false, 'Use "dataKey" to specify the value of pie,\n      the props "valueKey" will be deprecated in 1.1.0');
    realDataKey = valueKey;
  }

  var sum = pieData.reduce(function (result, entry) {
    var val = Object(__WEBPACK_IMPORTED_MODULE_19__util_ChartUtils__["w" /* getValueByDataKey */])(entry, realDataKey, 0);
    return result + (Object(__WEBPACK_IMPORTED_MODULE_18__util_DataUtils__["g" /* isNumber */])(val) ? val : 0);
  }, 0);
  var sectors = void 0;

  if (sum > 0) {
    var prev = void 0;
    sectors = pieData.map(function (entry, i) {
      var val = Object(__WEBPACK_IMPORTED_MODULE_19__util_ChartUtils__["w" /* getValueByDataKey */])(entry, realDataKey, 0);
      var name = Object(__WEBPACK_IMPORTED_MODULE_19__util_ChartUtils__["w" /* getValueByDataKey */])(entry, nameKey, i);
      var percent = (Object(__WEBPACK_IMPORTED_MODULE_18__util_DataUtils__["g" /* isNumber */])(val) ? val : 0) / sum;
      var tempStartAngle = void 0;

      if (i) {
        tempStartAngle = prev.endAngle + Object(__WEBPACK_IMPORTED_MODULE_18__util_DataUtils__["i" /* mathSign */])(deltaAngle) * paddingAngle;
      } else {
        tempStartAngle = startAngle;
      }

      var tempEndAngle = tempStartAngle + Object(__WEBPACK_IMPORTED_MODULE_18__util_DataUtils__["i" /* mathSign */])(deltaAngle) * (minAngle + percent * realTotalAngle);
      var midAngle = (tempStartAngle + tempEndAngle) / 2;
      var middleRadius = (coordinate.innerRadius + coordinate.outerRadius) / 2;
      var tooltipPayload = [{ name: name, value: val, payload: entry }];
      var tooltipPosition = Object(__WEBPACK_IMPORTED_MODULE_17__util_PolarUtils__["e" /* polarToCartesian */])(coordinate.cx, coordinate.cy, middleRadius, midAngle);

      prev = _extends({
        percent: percent, cornerRadius: cornerRadius, name: name, tooltipPayload: tooltipPayload, midAngle: midAngle, middleRadius: middleRadius, tooltipPosition: tooltipPosition
      }, entry, coordinate, {
        value: Object(__WEBPACK_IMPORTED_MODULE_19__util_ChartUtils__["w" /* getValueByDataKey */])(entry, realDataKey),
        startAngle: tempStartAngle,
        endAngle: tempEndAngle,
        payload: entry,
        paddingAngle: Object(__WEBPACK_IMPORTED_MODULE_18__util_DataUtils__["i" /* mathSign */])(deltaAngle) * paddingAngle
      });

      return prev;
    });
  }

  return _extends({}, coordinate, {
    sectors: sectors,
    data: pieData,
    onMouseLeave: onItemMouseLeave,
    onMouseEnter: onItemMouseEnter
  });
}, _temp2)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (Pie);

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_smooth__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_smooth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_smooth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_DataUtils__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_PureRender__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_ReactUtils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_PolarUtils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_ChartUtils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shape_Polygon__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shape_Dot__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__container_Layer__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__component_LabelList__ = __webpack_require__(30);



var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Radar
 */















var Radar = Object(__WEBPACK_IMPORTED_MODULE_7__util_PureRender__["a" /* default */])(_class = (_temp2 = _class2 = function (_Component) {
  _inherits(Radar, _Component);

  function Radar() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Radar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Radar.__proto__ || Object.getPrototypeOf(Radar)).call.apply(_ref, [this].concat(args))), _this), _this.state = { isAnimationFinished: false }, _this.cachePrevData = function (points) {
      _this.setState({ prevPoints: points });
    }, _this.handleAnimationEnd = function () {
      _this.setState({ isAnimationFinished: true });
    }, _this.handleAnimationStart = function () {
      _this.setState({ isAnimationFinished: false });
    }, _this.handleMouseEnter = function (e) {
      var onMouseEnter = _this.props.onMouseEnter;


      if (onMouseEnter) {
        onMouseEnter(_this.props, e);
      }
    }, _this.handleMouseLeave = function (e) {
      var onMouseLeave = _this.props.onMouseLeave;


      if (onMouseLeave) {
        onMouseLeave(_this.props, e);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Radar, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props = this.props,
          animationId = _props.animationId,
          points = _props.points;


      if (nextProps.animationId !== animationId) {
        this.cachePrevData(points);
      }
    }
  }, {
    key: 'renderDotItem',
    value: function renderDotItem(option, props) {
      var dotItem = void 0;

      if (__WEBPACK_IMPORTED_MODULE_2_react___default.a.isValidElement(option)) {
        dotItem = __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(option)) {
        dotItem = option(props);
      } else {
        dotItem = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__shape_Dot__["a" /* default */], _extends({}, props, { className: 'recharts-radar-dot' }));
      }

      return dotItem;
    }
  }, {
    key: 'renderDots',
    value: function renderDots(points) {
      var _this2 = this;

      var _props2 = this.props,
          dot = _props2.dot,
          dataKey = _props2.dataKey;

      var baseProps = Object(__WEBPACK_IMPORTED_MODULE_8__util_ReactUtils__["k" /* getPresentationAttributes */])(this.props);
      var customDotProps = Object(__WEBPACK_IMPORTED_MODULE_8__util_ReactUtils__["k" /* getPresentationAttributes */])(dot);

      var dots = points.map(function (entry, i) {
        var dotProps = _extends({
          key: 'dot-' + i,
          r: 3
        }, baseProps, customDotProps, {
          dataKey: dataKey,
          cx: entry.x,
          cy: entry.y,
          index: i,
          playload: entry
        });

        return _this2.renderDotItem(dot, dotProps);
      });

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_13__container_Layer__["a" /* default */],
        { className: 'recharts-radar-dots' },
        dots
      );
    }
  }, {
    key: 'renderPolygonStatically',
    value: function renderPolygonStatically(points) {
      var _props3 = this.props,
          shape = _props3.shape,
          dot = _props3.dot;


      var radar = void 0;
      if (__WEBPACK_IMPORTED_MODULE_2_react___default.a.isValidElement(shape)) {
        radar = __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(shape, _extends({}, this.props, { points: points }));
      } else if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(shape)) {
        radar = shape(_extends({}, this.props, { points: points }));
      } else {
        radar = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shape_Polygon__["a" /* default */], _extends({}, Object(__WEBPACK_IMPORTED_MODULE_8__util_ReactUtils__["e" /* filterEventAttributes */])(this.props), {
          onMouseEnter: this.handleMouseEnter,
          onMouseLeave: this.handleMouseLeave
        }, Object(__WEBPACK_IMPORTED_MODULE_8__util_ReactUtils__["k" /* getPresentationAttributes */])(this.props), {
          points: points
        }));
      }

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_13__container_Layer__["a" /* default */],
        { className: 'recharts-radar-polygon' },
        radar,
        dot ? this.renderDots(points) : null
      );
    }
  }, {
    key: 'renderPolygonWithAnimation',
    value: function renderPolygonWithAnimation() {
      var _this3 = this;

      var _props4 = this.props,
          points = _props4.points,
          isAnimationActive = _props4.isAnimationActive,
          animationBegin = _props4.animationBegin,
          animationDuration = _props4.animationDuration,
          animationEasing = _props4.animationEasing,
          animationId = _props4.animationId;
      var prevPoints = this.state.prevPoints;


      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_smooth___default.a,
        {
          begin: animationBegin,
          duration: animationDuration,
          isActive: isAnimationActive,
          easing: animationEasing,
          from: { t: 0 },
          to: { t: 1 },
          key: 'radar-' + animationId,
          onAnimationEnd: this.handleAnimationEnd,
          onAnimationStart: this.handleAnimationStart
        },
        function (_ref2) {
          var t = _ref2.t;

          var stepData = points.map(function (entry, index) {
            var prev = prevPoints && prevPoints[index];

            if (prev) {
              var _interpolatorX = Object(__WEBPACK_IMPORTED_MODULE_6__util_DataUtils__["e" /* interpolateNumber */])(prev.x, entry.x);
              var _interpolatorY = Object(__WEBPACK_IMPORTED_MODULE_6__util_DataUtils__["e" /* interpolateNumber */])(prev.y, entry.y);

              return _extends({}, entry, {
                x: _interpolatorX(t),
                y: _interpolatorY(t)
              });
            }

            var interpolatorX = Object(__WEBPACK_IMPORTED_MODULE_6__util_DataUtils__["e" /* interpolateNumber */])(entry.cx, entry.x);
            var interpolatorY = Object(__WEBPACK_IMPORTED_MODULE_6__util_DataUtils__["e" /* interpolateNumber */])(entry.cy, entry.y);

            return _extends({}, entry, {
              x: interpolatorX(t),
              y: interpolatorY(t)
            });
          });

          return _this3.renderPolygonStatically(stepData);
        }
      );
    }
  }, {
    key: 'renderPolygon',
    value: function renderPolygon() {
      var _props5 = this.props,
          points = _props5.points,
          isAnimationActive = _props5.isAnimationActive;
      var prevPoints = this.state.prevPoints;


      if (isAnimationActive && points && points.length && (!prevPoints || !__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(prevPoints, points))) {
        return this.renderPolygonWithAnimation();
      }

      return this.renderPolygonStatically(points);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props6 = this.props,
          hide = _props6.hide,
          className = _props6.className,
          points = _props6.points,
          isAnimationActive = _props6.isAnimationActive;


      if (hide || !points || !points.length) {
        return null;
      }

      var isAnimationFinished = this.state.isAnimationFinished;

      var layerClass = __WEBPACK_IMPORTED_MODULE_5_classnames___default()('recharts-radar', className);

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_13__container_Layer__["a" /* default */],
        { className: layerClass },
        this.renderPolygon(),
        (!isAnimationActive || isAnimationFinished) && __WEBPACK_IMPORTED_MODULE_14__component_LabelList__["a" /* default */].renderCallByParent(this.props, points)
      );
    }
  }]);

  return Radar;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]), _class2.displayName = 'Radar', _class2.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_8__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  dataKey: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func]).isRequired,
  angleAxisId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number]),
  radiusAxisId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number]),

  points: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    y: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    cx: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    cy: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    angle: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    radius: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    value: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    payload: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })),
  shape: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func]),
  activeDot: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool]),
  // whether have dot in poly line
  dot: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool]),
  label: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool]),
  legendType: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_8__util_ReactUtils__["b" /* LEGEND_TYPES */]),
  hide: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,

  onMouseEnter: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  onClick: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  isAnimationActive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  animationId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  animationBegin: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  animationDuration: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  animationEasing: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
}), _class2.defaultProps = {
  angleAxisId: 0,
  radiusAxisId: 0,
  hide: false,
  activeDot: true,
  dot: false,
  legendType: 'rect',
  isAnimationActive: !Object(__WEBPACK_IMPORTED_MODULE_8__util_ReactUtils__["n" /* isSsr */])(),
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: 'ease'
}, _class2.getComposedData = function (_ref3) {
  var radiusAxis = _ref3.radiusAxis,
      angleAxis = _ref3.angleAxis,
      displayedData = _ref3.displayedData,
      dataKey = _ref3.dataKey,
      bandSize = _ref3.bandSize;
  var cx = angleAxis.cx,
      cy = angleAxis.cy;

  var points = displayedData.map(function (entry, i) {
    var name = Object(__WEBPACK_IMPORTED_MODULE_10__util_ChartUtils__["w" /* getValueByDataKey */])(entry, angleAxis.dataKey, i);
    var value = Object(__WEBPACK_IMPORTED_MODULE_10__util_ChartUtils__["w" /* getValueByDataKey */])(entry, dataKey, 0);
    var angle = angleAxis.scale(name) + (bandSize || 0);
    var radius = radiusAxis.scale(value);
    return _extends({}, Object(__WEBPACK_IMPORTED_MODULE_9__util_PolarUtils__["e" /* polarToCartesian */])(cx, cy, radius, angle), {
      name: name, value: value, cx: cx, cy: cy, radius: radius, angle: angle,
      payload: entry
    });
  });

  return { points: points };
}, _temp2)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (Radar);

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isArray__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_smooth__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_smooth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_smooth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shape_Sector__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__container_Layer__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_PureRender__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__component_LabelList__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__component_Cell__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_DataUtils__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_ChartUtils__ = __webpack_require__(11);




var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp2;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Render a group of radial bar
 */














var RadialBar = Object(__WEBPACK_IMPORTED_MODULE_10__util_PureRender__["a" /* default */])(_class = (_temp2 = _class2 = function (_Component) {
  _inherits(RadialBar, _Component);

  function RadialBar() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RadialBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RadialBar.__proto__ || Object.getPrototypeOf(RadialBar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isAnimationFinished: false
    }, _this.cachePrevData = function (data) {
      _this.setState({ prevData: data });
    }, _this.handleAnimationEnd = function () {
      _this.setState({ isAnimationFinished: true });
    }, _this.handleAnimationStart = function () {
      _this.setState({ isAnimationFinished: false });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RadialBar, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props = this.props,
          animationId = _props.animationId,
          data = _props.data;


      if (nextProps.animationId !== animationId) {
        this.cachePrevData(data);
      }
    }
  }, {
    key: 'getDeltaAngle',
    value: function getDeltaAngle() {
      var _props2 = this.props,
          startAngle = _props2.startAngle,
          endAngle = _props2.endAngle;

      var sign = Object(__WEBPACK_IMPORTED_MODULE_13__util_DataUtils__["i" /* mathSign */])(endAngle - startAngle);
      var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);

      return sign * deltaAngle;
    }
  }, {
    key: 'renderSectorShape',
    value: function renderSectorShape(shape, props) {
      var sectorShape = void 0;

      if (__WEBPACK_IMPORTED_MODULE_3_react___default.a.isValidElement(shape)) {
        sectorShape = __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(shape, props);
      } else if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(shape)) {
        sectorShape = shape(props);
      } else {
        sectorShape = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shape_Sector__["a" /* default */], props);
      }

      return sectorShape;
    }
  }, {
    key: 'renderSectorsStatically',
    value: function renderSectorsStatically(sectors) {
      var _this2 = this;

      var _props3 = this.props,
          shape = _props3.shape,
          activeShape = _props3.activeShape,
          activeIndex = _props3.activeIndex,
          cornerRadius = _props3.cornerRadius,
          others = _objectWithoutProperties(_props3, ['shape', 'activeShape', 'activeIndex', 'cornerRadius']);

      var baseProps = Object(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["k" /* getPresentationAttributes */])(others);

      return sectors.map(function (entry, i) {
        var props = _extends({}, baseProps, {
          cornerRadius: cornerRadius
        }, entry, Object(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["f" /* filterEventsOfChild */])(_this2.props, entry, i), {
          key: 'sector-' + i,
          className: 'recharts-radial-bar-sector'
        });

        return _this2.renderSectorShape(i === activeIndex ? activeShape : shape, props);
      });
    }
  }, {
    key: 'renderSectorsWithAnimation',
    value: function renderSectorsWithAnimation() {
      var _this3 = this;

      var _props4 = this.props,
          data = _props4.data,
          isAnimationActive = _props4.isAnimationActive,
          animationBegin = _props4.animationBegin,
          animationDuration = _props4.animationDuration,
          animationEasing = _props4.animationEasing,
          animationId = _props4.animationId;
      var prevData = this.state.prevData;


      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_smooth___default.a,
        {
          begin: animationBegin,
          duration: animationDuration,
          isActive: isAnimationActive,
          easing: animationEasing,
          from: { t: 0 },
          to: { t: 1 },
          key: 'radialBar-' + animationId,
          onAnimationStart: this.handleAnimationStart,
          onAnimationEnd: this.handleAnimationEnd
        },
        function (_ref2) {
          var t = _ref2.t;

          var stepData = data.map(function (entry, index) {
            var prev = prevData && prevData[index];

            if (prev) {
              var interpolatorStartAngle = Object(__WEBPACK_IMPORTED_MODULE_13__util_DataUtils__["e" /* interpolateNumber */])(prev.startAngle, entry.startAngle);
              var interpolatorEndAngle = Object(__WEBPACK_IMPORTED_MODULE_13__util_DataUtils__["e" /* interpolateNumber */])(prev.endAngle, entry.endAngle);

              return _extends({}, entry, {
                startAngle: interpolatorStartAngle(t),
                endAngle: interpolatorEndAngle(t)
              });
            }
            var endAngle = entry.endAngle,
                startAngle = entry.startAngle;

            var interpolator = Object(__WEBPACK_IMPORTED_MODULE_13__util_DataUtils__["e" /* interpolateNumber */])(startAngle, endAngle);

            return _extends({}, entry, { endAngle: interpolator(t) });
          });

          return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */],
            null,
            _this3.renderSectorsStatically(stepData)
          );
        }
      );
    }
  }, {
    key: 'renderSectors',
    value: function renderSectors() {
      var _props5 = this.props,
          data = _props5.data,
          isAnimationActive = _props5.isAnimationActive;
      var prevData = this.state.prevData;


      if (isAnimationActive && data && data.length && (!prevData || !__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(prevData, data))) {
        return this.renderSectorsWithAnimation();
      }

      return this.renderSectorsStatically(data);
    }
  }, {
    key: 'renderBackground',
    value: function renderBackground(sectors) {
      var _this4 = this;

      var cornerRadius = this.props.cornerRadius;

      var backgroundProps = Object(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["k" /* getPresentationAttributes */])(this.props.background);

      return sectors.map(function (entry, i) {
        // eslint-disable-next-line no-unused-vars
        var value = entry.value,
            background = entry.background,
            rest = _objectWithoutProperties(entry, ['value', 'background']);

        if (!background) {
          return null;
        }

        var props = _extends({
          cornerRadius: cornerRadius
        }, rest, {
          fill: '#eee'
        }, background, backgroundProps, Object(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["f" /* filterEventsOfChild */])(_this4.props, entry, i), {
          index: i,
          key: 'sector-' + i,
          className: 'recharts-radial-bar-background-sector'
        });

        return _this4.renderSectorShape(background, props);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props6 = this.props,
          hide = _props6.hide,
          data = _props6.data,
          className = _props6.className,
          background = _props6.background,
          isAnimationActive = _props6.isAnimationActive;


      if (hide || !data || !data.length) {
        return null;
      }

      var isAnimationFinished = this.state.isAnimationFinished;

      var layerClass = __WEBPACK_IMPORTED_MODULE_5_classnames___default()('recharts-area', className);

      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */],
        { className: layerClass },
        background && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */],
          { className: 'recharts-radial-bar-background' },
          this.renderBackground(data)
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */],
          { className: 'recharts-radial-bar-sectors' },
          this.renderSectors(data)
        ),
        (!isAnimationActive || isAnimationFinished) && __WEBPACK_IMPORTED_MODULE_11__component_LabelList__["a" /* default */].renderCallByParent(_extends({}, this.props, {
          clockWise: this.getDeltaAngle() < 0
        }), data)
      );
    }
  }]);

  return RadialBar;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]), _class2.displayName = 'RadialBar', _class2.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  angleAxisId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number]),
  radiusAxisId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number]),
  shape: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.element]),
  activeShape: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.element]),
  activeIndex: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  dataKey: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func]).isRequired,

  cornerRadius: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string]),
  minPointSize: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  maxBarSize: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  data: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    cx: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    cy: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    innerRadius: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    outerRadius: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    value: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.value
  })),
  legendType: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["b" /* LEGEND_TYPES */]),
  label: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object]),
  background: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.element]),
  hide: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,

  onMouseEnter: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onClick: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,

  isAnimationActive: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  animationBegin: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  animationDuration: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  animationEasing: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear', 'spring'])
}), _class2.defaultProps = {
  angleAxisId: 0,
  radiusAxisId: 0,
  minPointSize: 0,
  hide: false,
  legendType: 'rect',
  data: [],
  isAnimationActive: !Object(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["n" /* isSsr */])(),
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: 'ease'
}, _class2.getComposedData = function (_ref3) {
  var item = _ref3.item,
      props = _ref3.props,
      radiusAxis = _ref3.radiusAxis,
      radiusAxisTicks = _ref3.radiusAxisTicks,
      angleAxis = _ref3.angleAxis,
      angleAxisTicks = _ref3.angleAxisTicks,
      displayedData = _ref3.displayedData,
      dataKey = _ref3.dataKey,
      stackedData = _ref3.stackedData,
      barPosition = _ref3.barPosition,
      bandSize = _ref3.bandSize,
      dataStartIndex = _ref3.dataStartIndex;

  var pos = Object(__WEBPACK_IMPORTED_MODULE_14__util_ChartUtils__["f" /* findPositionOfBar */])(barPosition, item);
  if (!pos) {
    return [];
  }

  var cx = angleAxis.cx,
      cy = angleAxis.cy;
  var layout = props.layout;
  var _item$props = item.props,
      children = _item$props.children,
      minPointSize = _item$props.minPointSize;

  var numericAxis = layout === 'radial' ? angleAxis : radiusAxis;
  var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
  var baseValue = Object(__WEBPACK_IMPORTED_MODULE_14__util_ChartUtils__["j" /* getBaseValueOfBar */])({ props: props, numericAxis: numericAxis });
  var cells = Object(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["h" /* findAllByType */])(children, __WEBPACK_IMPORTED_MODULE_12__component_Cell__["a" /* default */]);
  var sectors = displayedData.map(function (entry, index) {
    var value = void 0,
        innerRadius = void 0,
        outerRadius = void 0,
        startAngle = void 0,
        endAngle = void 0,
        backgroundSector = void 0;

    if (stackedData) {
      value = Object(__WEBPACK_IMPORTED_MODULE_14__util_ChartUtils__["C" /* truncateByDomain */])(stackedData[dataStartIndex + index], stackedDomain);
    } else {
      value = Object(__WEBPACK_IMPORTED_MODULE_14__util_ChartUtils__["w" /* getValueByDataKey */])(entry, dataKey);
      if (!__WEBPACK_IMPORTED_MODULE_2_lodash_isArray___default()(value)) {
        value = [baseValue, value];
      }
    }

    if (layout === 'radial') {
      innerRadius = Object(__WEBPACK_IMPORTED_MODULE_14__util_ChartUtils__["k" /* getCateCoordinateOfBar */])({
        axis: radiusAxis,
        ticks: radiusAxisTicks,
        bandSize: bandSize,
        offset: pos.offset,
        entry: entry,
        index: index
      });
      endAngle = angleAxis.scale(value[1]);
      startAngle = angleAxis.scale(value[0]);
      outerRadius = innerRadius + pos.size;
      var deltaAngle = endAngle - startAngle;

      if (Math.abs(minPointSize) > 0 && Math.abs(deltaAngle) < Math.abs(minPointSize)) {
        var delta = Object(__WEBPACK_IMPORTED_MODULE_13__util_DataUtils__["i" /* mathSign */])(deltaAngle || minPointSize) * (Math.abs(minPointSize) - Math.abs(deltaAngle));

        endAngle += delta;
      }
      backgroundSector = {
        background: {
          cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, startAngle: props.startAngle,
          endAngle: props.endAngle
        }
      };
    } else {
      innerRadius = radiusAxis.scale(value[0]);
      outerRadius = radiusAxis.scale(value[1]);
      startAngle = Object(__WEBPACK_IMPORTED_MODULE_14__util_ChartUtils__["k" /* getCateCoordinateOfBar */])({
        axis: angleAxis,
        ticks: angleAxisTicks,
        bandSize: bandSize,
        offset: pos.offset,
        entry: entry,
        index: index
      });
      endAngle = startAngle + pos.size;
      var deltaRadius = outerRadius - innerRadius;

      if (Math.abs(minPointSize) > 0 && Math.abs(deltaRadius) < Math.abs(minPointSize)) {
        var _delta = Object(__WEBPACK_IMPORTED_MODULE_13__util_DataUtils__["i" /* mathSign */])(deltaRadius || minPointSize) * (Math.abs(minPointSize) - Math.abs(deltaRadius));
        outerRadius += _delta;
      }
    }

    return _extends({}, entry, backgroundSector, {
      payload: entry,
      value: stackedData ? value : value[1],
      cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, startAngle: startAngle, endAngle: endAngle
    }, cells && cells[index] && cells[index].props);
  });

  return { data: sectors, layout: layout };
}, _temp2)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (RadialBar);

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_range__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_d3_scale__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_ChartUtils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_PureRender__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__container_Layer__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__component_Text__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_DataUtils__ = __webpack_require__(6);



var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Brush
 */











var Brush = Object(__WEBPACK_IMPORTED_MODULE_7__util_PureRender__["a" /* default */])(_class = (_temp = _class2 = function (_Component) {
  _inherits(Brush, _Component);

  function Brush(props) {
    _classCallCheck(this, Brush);

    var _this = _possibleConstructorReturn(this, (Brush.__proto__ || Object.getPrototypeOf(Brush)).call(this, props));

    _this.handleDrag = function (e) {
      if (_this.leaveTimer) {
        clearTimeout(_this.leaveTimer);
        _this.leaveTimer = null;
      }

      if (_this.state.isTravellerMoving) {
        _this.handleTravellerMove(e);
      } else if (_this.state.isSlideMoving) {
        _this.handleSlideDrag(e);
      }
    };

    _this.handleTouchMove = function (e) {
      if (e.changedTouches != null && e.changedTouches.length > 0) {
        _this.handleDrag(e.changedTouches[0]);
      }
    };

    _this.handleDragEnd = function () {
      _this.setState({
        isTravellerMoving: false,
        isSlideMoving: false
      });
    };

    _this.handleLeaveWrapper = function () {
      if (_this.state.isTravellerMoving || _this.state.isSlideMoving) {
        _this.leaveTimer = setTimeout(_this.handleDragEnd, 1000);
      }
    };

    _this.handleEnterSlideOrTraveller = function () {
      _this.setState({
        isTextActive: true
      });
    };

    _this.handleLeaveSlideOrTraveller = function () {
      _this.setState({
        isTextActive: false
      });
    };

    _this.handleSlideDragStart = function (e) {
      var event = e.changedTouches && e.changedTouches.length ? e.changedTouches[0] : e;

      _this.setState({
        isTravellerMoving: false,
        isSlideMoving: true,
        slideMoveStartX: event.pageX
      });
    };

    _this.travellerDragStartHandlers = {
      startX: _this.handleTravellerDragStart.bind(_this, 'startX'),
      endX: _this.handleTravellerDragStart.bind(_this, 'endX')
    };

    _this.state = props.data && props.data.length ? _this.updateScale(props) : {};
    return _this;
  }

  _createClass(Brush, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var _props = this.props,
          data = _props.data,
          width = _props.width,
          x = _props.x,
          travellerWidth = _props.travellerWidth,
          updateId = _props.updateId;


      if ((nextProps.data !== data || nextProps.updateId !== updateId) && nextProps.data && nextProps.data.length) {
        this.setState(this.updateScale(nextProps));
      } else if (nextProps.width !== width || nextProps.x !== x || nextProps.travellerWidth !== travellerWidth) {
        this.scale.range([nextProps.x, nextProps.x + nextProps.width - nextProps.travellerWidth]);
        this.scaleValues = this.scale.domain().map(function (entry) {
          return _this2.scale(entry);
        });

        this.setState({
          startX: this.scale(nextProps.startIndex),
          endX: this.scale(nextProps.endIndex)
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.scale = null;
      this.scaleValues = null;

      if (this.leaveTimer) {
        clearTimeout(this.leaveTimer);
        this.leaveTimer = null;
      }
    }
  }, {
    key: 'getIndexInRange',
    value: function getIndexInRange(range, x) {
      var len = range.length;
      var start = 0;
      var end = len - 1;

      while (end - start > 1) {
        var middle = Math.floor((start + end) / 2);

        if (range[middle] > x) {
          end = middle;
        } else {
          start = middle;
        }
      }

      return x >= range[end] ? end : start;
    }
  }, {
    key: 'getIndex',
    value: function getIndex(_ref) {
      var startX = _ref.startX,
          endX = _ref.endX;

      var min = Math.min(startX, endX);
      var max = Math.max(startX, endX);
      var minIndex = this.getIndexInRange(this.scaleValues, min);
      var maxIndex = this.getIndexInRange(this.scaleValues, max);

      return {
        startIndex: minIndex,
        endIndex: maxIndex
      };
    }
  }, {
    key: 'getTextOfTick',
    value: function getTextOfTick(index) {
      var _props2 = this.props,
          data = _props2.data,
          tickFormatter = _props2.tickFormatter,
          dataKey = _props2.dataKey;

      var text = Object(__WEBPACK_IMPORTED_MODULE_6__util_ChartUtils__["w" /* getValueByDataKey */])(data[index], dataKey, index);

      return __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(tickFormatter) ? tickFormatter(text) : text;
    }
  }, {
    key: 'handleSlideDrag',
    value: function handleSlideDrag(e) {
      var _state = this.state,
          slideMoveStartX = _state.slideMoveStartX,
          startX = _state.startX,
          endX = _state.endX;
      var _props3 = this.props,
          x = _props3.x,
          width = _props3.width,
          travellerWidth = _props3.travellerWidth,
          startIndex = _props3.startIndex,
          endIndex = _props3.endIndex,
          onChange = _props3.onChange;

      var delta = e.pageX - slideMoveStartX;

      if (delta > 0) {
        delta = Math.min(delta, x + width - travellerWidth - endX, x + width - travellerWidth - startX);
      } else if (delta < 0) {
        delta = Math.max(delta, x - startX, x - endX);
      }
      var newIndex = this.getIndex({
        startX: startX + delta,
        endX: endX + delta
      });

      if ((newIndex.startIndex !== startIndex || newIndex.endIndex !== endIndex) && onChange) {
        onChange(newIndex);
      }

      this.setState({
        startX: startX + delta,
        endX: endX + delta,
        slideMoveStartX: e.pageX
      });
    }
  }, {
    key: 'handleTravellerDragStart',
    value: function handleTravellerDragStart(id, e) {
      var event = e.changedTouches && e.changedTouches.length ? e.changedTouches[0] : e;

      this.setState({
        isSlideMoving: false,
        isTravellerMoving: true,
        movingTravellerId: id,
        brushMoveStartX: event.pageX
      });
    }
  }, {
    key: 'handleTravellerMove',
    value: function handleTravellerMove(e) {
      var _setState;

      var _state2 = this.state,
          brushMoveStartX = _state2.brushMoveStartX,
          movingTravellerId = _state2.movingTravellerId;

      var prevValue = this.state[movingTravellerId];
      var _props4 = this.props,
          x = _props4.x,
          width = _props4.width,
          travellerWidth = _props4.travellerWidth,
          onChange = _props4.onChange;


      var params = { startX: this.state.startX, endX: this.state.endX };
      var delta = e.pageX - brushMoveStartX;

      if (delta > 0) {
        delta = Math.min(delta, x + width - travellerWidth - prevValue);
      } else if (delta < 0) {
        delta = Math.max(delta, x - prevValue);
      }

      params[movingTravellerId] = prevValue + delta;
      var newIndex = this.getIndex(params);

      this.setState((_setState = {}, _defineProperty(_setState, movingTravellerId, prevValue + delta), _defineProperty(_setState, 'brushMoveStartX', e.pageX), _setState), function () {
        if (onChange) {
          onChange(newIndex);
        }
      });
    }
  }, {
    key: 'updateScale',
    value: function updateScale(props) {
      var _this3 = this;

      var data = props.data,
          startIndex = props.startIndex,
          endIndex = props.endIndex,
          x = props.x,
          width = props.width,
          travellerWidth = props.travellerWidth;

      var len = data.length;
      this.scale = Object(__WEBPACK_IMPORTED_MODULE_5_d3_scale__["scalePoint"])().domain(__WEBPACK_IMPORTED_MODULE_0_lodash_range___default()(0, len)).range([x, x + width - travellerWidth]);
      this.scaleValues = this.scale.domain().map(function (entry) {
        return _this3.scale(entry);
      });
      return {
        isTextActive: false,
        isSlideMoving: false,
        isTravellerMoving: false,
        startX: this.scale(startIndex),
        endX: this.scale(endIndex)
      };
    }
  }, {
    key: 'renderBackground',
    value: function renderBackground() {
      var _props5 = this.props,
          x = _props5.x,
          y = _props5.y,
          width = _props5.width,
          height = _props5.height,
          fill = _props5.fill,
          stroke = _props5.stroke;


      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('rect', {
        stroke: stroke,
        fill: fill,
        x: x,
        y: y,
        width: width,
        height: height
      });
    }
  }, {
    key: 'renderPanorama',
    value: function renderPanorama() {
      var _props6 = this.props,
          x = _props6.x,
          y = _props6.y,
          width = _props6.width,
          height = _props6.height,
          data = _props6.data,
          children = _props6.children,
          padding = _props6.padding;

      var chartElement = __WEBPACK_IMPORTED_MODULE_2_react__["Children"].only(children);

      if (!chartElement) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(chartElement, {
        x: x,
        y: y,
        width: width,
        height: height,
        margin: padding,
        compact: true,
        data: data
      });
    }
  }, {
    key: 'renderTraveller',
    value: function renderTraveller(travellerX, id) {
      var _props7 = this.props,
          y = _props7.y,
          travellerWidth = _props7.travellerWidth,
          height = _props7.height,
          stroke = _props7.stroke;

      var lineY = Math.floor(y + height / 2) - 1;
      var x = Math.max(travellerX, this.props.x);

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */],
        {
          className: 'recharts-brush-traveller',
          onMouseEnter: this.handleEnterSlideOrTraveller,
          onMouseLeave: this.handleLeaveSlideOrTraveller,
          onMouseDown: this.travellerDragStartHandlers[id],
          onTouchStart: this.travellerDragStartHandlers[id],
          style: { cursor: 'col-resize' }
        },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('rect', {
          x: x,
          y: y,
          width: travellerWidth,
          height: height,
          fill: stroke,
          stroke: 'none'
        }),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('line', {
          x1: x + 1,
          y1: lineY,
          x2: x + travellerWidth - 1,
          y2: lineY,
          fill: 'none',
          stroke: '#fff'
        }),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('line', {
          x1: x + 1,
          y1: lineY + 2,
          x2: x + travellerWidth - 1,
          y2: lineY + 2,
          fill: 'none',
          stroke: '#fff'
        })
      );
    }
  }, {
    key: 'renderSlide',
    value: function renderSlide(startX, endX) {
      var _props8 = this.props,
          y = _props8.y,
          height = _props8.height,
          stroke = _props8.stroke;


      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('rect', {
        className: 'recharts-brush-slide',
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.handleSlideDragStart,
        onTouchStart: this.handleSlideDragStart,
        style: { cursor: 'move' },
        stroke: 'none',
        fill: stroke,
        fillOpacity: 0.2,
        x: Math.min(startX, endX),
        y: y,
        width: Math.abs(endX - startX),
        height: height
      });
    }
  }, {
    key: 'renderText',
    value: function renderText() {
      var _props9 = this.props,
          startIndex = _props9.startIndex,
          endIndex = _props9.endIndex,
          y = _props9.y,
          height = _props9.height,
          travellerWidth = _props9.travellerWidth,
          stroke = _props9.stroke;
      var _state3 = this.state,
          startX = _state3.startX,
          endX = _state3.endX;

      var offset = 5;
      var attrs = {
        pointerEvents: 'none',
        fill: stroke
      };

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */],
        { className: 'recharts-brush-texts' },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__component_Text__["a" /* default */],
          _extends({
            textAnchor: 'end',
            verticalAnchor: 'middle',
            x: Math.min(startX, endX) - offset,
            y: y + height / 2
          }, attrs),
          this.getTextOfTick(startIndex)
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__component_Text__["a" /* default */],
          _extends({
            textAnchor: 'start',
            verticalAnchor: 'middle',
            x: Math.max(startX, endX) + travellerWidth + offset,
            y: y + height / 2
          }, attrs),
          this.getTextOfTick(endIndex)
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props10 = this.props,
          data = _props10.data,
          className = _props10.className,
          children = _props10.children,
          x = _props10.x,
          y = _props10.y,
          width = _props10.width,
          height = _props10.height;
      var _state4 = this.state,
          startX = _state4.startX,
          endX = _state4.endX,
          isTextActive = _state4.isTextActive,
          isSlideMoving = _state4.isSlideMoving,
          isTravellerMoving = _state4.isTravellerMoving;


      if (!data || !data.length || !Object(__WEBPACK_IMPORTED_MODULE_10__util_DataUtils__["g" /* isNumber */])(x) || !Object(__WEBPACK_IMPORTED_MODULE_10__util_DataUtils__["g" /* isNumber */])(y) || !Object(__WEBPACK_IMPORTED_MODULE_10__util_DataUtils__["g" /* isNumber */])(width) || !Object(__WEBPACK_IMPORTED_MODULE_10__util_DataUtils__["g" /* isNumber */])(height) || width <= 0 || height <= 0) {
        return null;
      }

      var layerClass = __WEBPACK_IMPORTED_MODULE_4_classnames___default()('recharts-brush', className);
      var isPanoramic = __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1;

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */],
        {
          className: layerClass,
          onMouseMove: this.handleDrag,
          onMouseLeave: this.handleLeaveWrapper,
          onMouseUp: this.handleDragEnd,
          onTouchEnd: this.handleDragEnd,
          onTouchMove: this.handleTouchMove
        },
        this.renderBackground(),
        isPanoramic && this.renderPanorama(),
        this.renderSlide(startX, endX),
        this.renderTraveller(startX, 'startX'),
        this.renderTraveller(endX, 'endX'),
        (isTextActive || isSlideMoving || isTravellerMoving) && this.renderText()
      );
    }
  }]);

  return Brush;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]), _class2.displayName = 'Brush', _class2.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,

  fill: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  stroke: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  x: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  y: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  width: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,
  travellerWidth: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  padding: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    top: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    right: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    bottom: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    left: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number
  }),

  dataKey: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func]),
  data: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,
  startIndex: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  endIndex: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  tickFormatter: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,

  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,

  onChange: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  updateId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number])
}, _class2.defaultProps = {
  height: 40,
  travellerWidth: 5,
  fill: '#fff',
  stroke: '#666',
  padding: { top: 1, right: 1, bottom: 1, left: 1 }
}, _temp)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (Brush);

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

var createRange = __webpack_require__(533);

/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
var range = createRange();

module.exports = range;


/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_PureRender__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_DOMUtils__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__container_Layer__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__component_Text__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__component_Label__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_DataUtils__ = __webpack_require__(6);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Cartesian Axis
 */












var CartesianAxis = (_temp = _class = function (_Component) {
  _inherits(CartesianAxis, _Component);

  function CartesianAxis() {
    _classCallCheck(this, CartesianAxis);

    return _possibleConstructorReturn(this, (CartesianAxis.__proto__ || Object.getPrototypeOf(CartesianAxis)).apply(this, arguments));
  }

  _createClass(CartesianAxis, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(_ref, state) {
      var viewBox = _ref.viewBox,
          restProps = _objectWithoutProperties(_ref, ['viewBox']);

      // props.viewBox is sometimes generated every time -
      // check that specially as object equality is likely to fail
      var _props = this.props,
          viewBoxOld = _props.viewBox,
          restPropsOld = _objectWithoutProperties(_props, ['viewBox']);

      return !Object(__WEBPACK_IMPORTED_MODULE_4__util_PureRender__["b" /* shallowEqual */])(viewBox, viewBoxOld) || !Object(__WEBPACK_IMPORTED_MODULE_4__util_PureRender__["b" /* shallowEqual */])(restProps, restPropsOld) || !Object(__WEBPACK_IMPORTED_MODULE_4__util_PureRender__["b" /* shallowEqual */])(state, this.state);
    }

    /**
     * Calculate the coordinates of endpoints in ticks
     * @param  {Object} data The data of a simple tick
     * @return {Object} (x1, y1): The coordinate of endpoint close to tick text
     *  (x2, y2): The coordinate of endpoint close to axis
     */

  }, {
    key: 'getTickLineCoord',
    value: function getTickLineCoord(data) {
      var _props2 = this.props,
          x = _props2.x,
          y = _props2.y,
          width = _props2.width,
          height = _props2.height,
          orientation = _props2.orientation,
          tickSize = _props2.tickSize,
          mirror = _props2.mirror,
          tickMargin = _props2.tickMargin;

      var x1 = void 0,
          x2 = void 0,
          y1 = void 0,
          y2 = void 0,
          tx = void 0,
          ty = void 0;

      var sign = mirror ? -1 : 1;
      var finalTickSize = data.tickSize || tickSize;
      var tickCoord = Object(__WEBPACK_IMPORTED_MODULE_10__util_DataUtils__["g" /* isNumber */])(data.tickCoord) ? data.tickCoord : data.coordinate;

      switch (orientation) {
        case 'top':
          x1 = x2 = data.coordinate;
          y2 = y + !mirror * height;
          y1 = y2 - sign * finalTickSize;
          ty = y1 - sign * tickMargin;
          tx = tickCoord;
          break;
        case 'left':
          y1 = y2 = data.coordinate;
          x2 = x + !mirror * width;
          x1 = x2 - sign * finalTickSize;
          tx = x1 - sign * tickMargin;
          ty = tickCoord;
          break;
        case 'right':
          y1 = y2 = data.coordinate;
          x2 = x + mirror * width;
          x1 = x2 + sign * finalTickSize;
          tx = x1 + sign * tickMargin;
          ty = tickCoord;
          break;
        default:
          x1 = x2 = data.coordinate;
          y2 = y + mirror * height;
          y1 = y2 + sign * finalTickSize;
          ty = y1 + sign * tickMargin;
          tx = tickCoord;
          break;
      }

      return { line: { x1: x1, y1: y1, x2: x2, y2: y2 }, tick: { x: tx, y: ty } };
    }
  }, {
    key: 'getTickTextAnchor',
    value: function getTickTextAnchor() {
      var _props3 = this.props,
          orientation = _props3.orientation,
          mirror = _props3.mirror;

      var textAnchor = void 0;

      switch (orientation) {
        case 'left':
          textAnchor = mirror ? 'start' : 'end';
          break;
        case 'right':
          textAnchor = mirror ? 'end' : 'start';
          break;
        default:
          textAnchor = 'middle';
          break;
      }

      return textAnchor;
    }
  }, {
    key: 'getTickVerticalAnchor',
    value: function getTickVerticalAnchor() {
      var _props4 = this.props,
          orientation = _props4.orientation,
          mirror = _props4.mirror;

      var verticalAnchor = 'end';

      switch (orientation) {
        case 'left':
        case 'right':
          verticalAnchor = 'middle';
          break;
        case 'top':
          verticalAnchor = mirror ? 'start' : 'end';
          break;
        default:
          verticalAnchor = mirror ? 'end' : 'start';
          break;
      }

      return verticalAnchor;
    }
  }, {
    key: 'renderAxisLine',
    value: function renderAxisLine() {
      var _props5 = this.props,
          x = _props5.x,
          y = _props5.y,
          width = _props5.width,
          height = _props5.height,
          orientation = _props5.orientation,
          axisLine = _props5.axisLine,
          mirror = _props5.mirror;

      var props = _extends({}, Object(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["k" /* getPresentationAttributes */])(this.props), {
        fill: 'none'
      }, Object(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["k" /* getPresentationAttributes */])(axisLine));

      if (orientation === 'top' || orientation === 'bottom') {
        var needHeight = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
        props = _extends({}, props, {
          x1: x,
          y1: y + needHeight * height,
          x2: x + width,
          y2: y + needHeight * height
        });
      } else {
        var needWidth = orientation === 'left' && !mirror || orientation === 'right' && mirror;
        props = _extends({}, props, {
          x1: x + needWidth * width,
          y1: y,
          x2: x + needWidth * width,
          y2: y + height
        });
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('line', _extends({ className: 'recharts-cartesian-axis-line' }, props));
    }
  }, {
    key: 'renderTickItem',
    value: function renderTickItem(option, props, value) {
      var tickItem = void 0;

      if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(option)) {
        tickItem = __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(option)) {
        tickItem = option(props);
      } else {
        tickItem = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__component_Text__["a" /* default */],
          _extends({}, props, {
            className: 'recharts-cartesian-axis-tick-value'
          }),
          value
        );
      }

      return tickItem;
    }

    /**
     * render the ticks
     * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
     * @return {ReactComponent} renderedTicks
     */

  }, {
    key: 'renderTicks',
    value: function renderTicks(ticks) {
      var _this2 = this;

      var _props6 = this.props,
          tickLine = _props6.tickLine,
          stroke = _props6.stroke,
          tick = _props6.tick,
          tickFormatter = _props6.tickFormatter,
          unit = _props6.unit;

      var finalTicks = CartesianAxis.getTicks(_extends({}, this.props, { ticks: ticks }));
      var textAnchor = this.getTickTextAnchor();
      var verticalAnchor = this.getTickVerticalAnchor();
      var axisProps = Object(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["k" /* getPresentationAttributes */])(this.props);
      var customTickProps = Object(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["k" /* getPresentationAttributes */])(tick);
      var tickLineProps = _extends({}, axisProps, { fill: 'none' }, Object(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["k" /* getPresentationAttributes */])(tickLine));
      var items = finalTicks.map(function (entry, i) {
        var _getTickLineCoord = _this2.getTickLineCoord(entry),
            lineCoord = _getTickLineCoord.line,
            tickCoord = _getTickLineCoord.tick;

        var tickProps = _extends({
          textAnchor: textAnchor,
          verticalAnchor: verticalAnchor
        }, axisProps, {
          stroke: 'none', fill: stroke
        }, customTickProps, tickCoord, {
          index: i, payload: entry
        });

        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__container_Layer__["a" /* default */],
          _extends({
            className: 'recharts-cartesian-axis-tick',
            key: 'tick-' + i
          }, Object(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["f" /* filterEventsOfChild */])(_this2.props, entry, i)),
          tickLine && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('line', _extends({
            className: 'recharts-cartesian-axis-tick-line'
          }, tickLineProps, lineCoord)),
          tick && _this2.renderTickItem(tick, tickProps, '' + (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(tickFormatter) ? tickFormatter(entry.value) : entry.value) + (unit || ''))
        );
      });

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'g',
        { className: 'recharts-cartesian-axis-ticks' },
        items
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props7 = this.props,
          axisLine = _props7.axisLine,
          width = _props7.width,
          height = _props7.height,
          ticksGenerator = _props7.ticksGenerator,
          className = _props7.className,
          hide = _props7.hide;


      if (hide) {
        return null;
      }

      var _props8 = this.props,
          ticks = _props8.ticks,
          noTicksProps = _objectWithoutProperties(_props8, ['ticks']);

      var finalTicks = ticks;

      if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(ticksGenerator)) {
        finalTicks = ticks && ticks.length > 0 ? ticksGenerator(this.props) : ticksGenerator(noTicksProps);
      }

      if (width <= 0 || height <= 0 || !finalTicks || !finalTicks.length) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__container_Layer__["a" /* default */],
        { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('recharts-cartesian-axis', className) },
        axisLine && this.renderAxisLine(),
        this.renderTicks(finalTicks),
        __WEBPACK_IMPORTED_MODULE_8__component_Label__["a" /* default */].renderCallByParent(this.props)
      );
    }
  }], [{
    key: 'getTicks',
    value: function getTicks(props) {
      var tick = props.tick,
          ticks = props.ticks,
          viewBox = props.viewBox,
          minTickGap = props.minTickGap,
          orientation = props.orientation,
          interval = props.interval,
          tickFormatter = props.tickFormatter,
          unit = props.unit;


      if (!ticks || !ticks.length || !tick) {
        return [];
      }

      if (Object(__WEBPACK_IMPORTED_MODULE_10__util_DataUtils__["g" /* isNumber */])(interval) || Object(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["n" /* isSsr */])()) {
        return CartesianAxis.getNumberIntervalTicks(ticks, Object(__WEBPACK_IMPORTED_MODULE_10__util_DataUtils__["g" /* isNumber */])(interval) ? interval : 0);
      }

      if (interval === 'preserveStartEnd') {
        return CartesianAxis.getTicksStart({
          ticks: ticks, tickFormatter: tickFormatter, viewBox: viewBox, orientation: orientation, minTickGap: minTickGap, unit: unit
        }, true);
      } else if (interval === 'preserveStart') {
        return CartesianAxis.getTicksStart({
          ticks: ticks, tickFormatter: tickFormatter, viewBox: viewBox, orientation: orientation, minTickGap: minTickGap, unit: unit
        });
      }

      return CartesianAxis.getTicksEnd({
        ticks: ticks, tickFormatter: tickFormatter, viewBox: viewBox, orientation: orientation, minTickGap: minTickGap, unit: unit
      });
    }
  }, {
    key: 'getNumberIntervalTicks',
    value: function getNumberIntervalTicks(ticks, interval) {
      return ticks.filter(function (entry, i) {
        return i % (interval + 1) === 0;
      });
    }
  }, {
    key: 'getTicksStart',
    value: function getTicksStart(_ref2, preserveEnd) {
      var ticks = _ref2.ticks,
          tickFormatter = _ref2.tickFormatter,
          viewBox = _ref2.viewBox,
          orientation = _ref2.orientation,
          minTickGap = _ref2.minTickGap,
          unit = _ref2.unit;
      var x = viewBox.x,
          y = viewBox.y,
          width = viewBox.width,
          height = viewBox.height;

      var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height';
      var result = (ticks || []).slice();
      var unitSize = unit ? Object(__WEBPACK_IMPORTED_MODULE_5__util_DOMUtils__["c" /* getStringSize */])(unit)[sizeKey] : 0;
      var len = result.length;
      var sign = len >= 2 ? Object(__WEBPACK_IMPORTED_MODULE_10__util_DataUtils__["i" /* mathSign */])(result[1].coordinate - result[0].coordinate) : 1;

      var start = void 0,
          end = void 0;

      if (sign === 1) {
        start = sizeKey === 'width' ? x : y;
        end = sizeKey === 'width' ? x + width : y + height;
      } else {
        start = sizeKey === 'width' ? x + width : y + height;
        end = sizeKey === 'width' ? x : y;
      }

      if (preserveEnd) {
        // Try to guarantee the tail to be displayed
        var tail = ticks[len - 1];
        var tailContent = __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(tickFormatter) ? tickFormatter(tail.value) : tail.value;
        var tailSize = Object(__WEBPACK_IMPORTED_MODULE_5__util_DOMUtils__["c" /* getStringSize */])(tailContent)[sizeKey] + unitSize;
        var tailGap = sign * (tail.coordinate + sign * tailSize / 2 - end);
        result[len - 1] = tail = _extends({}, tail, {
          tickCoord: tailGap > 0 ? tail.coordinate - tailGap * sign : tail.coordinate
        });

        var isTailShow = sign * (tail.tickCoord - sign * tailSize / 2 - start) >= 0 && sign * (tail.tickCoord + sign * tailSize / 2 - end) <= 0;

        if (isTailShow) {
          end = tail.tickCoord - sign * (tailSize / 2 + minTickGap);
          result[len - 1] = _extends({}, tail, { isShow: true });
        }
      }

      var count = preserveEnd ? len - 1 : len;
      for (var i = 0; i < count; i++) {
        var entry = result[i];
        var content = __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(tickFormatter) ? tickFormatter(entry.value) : entry.value;
        var size = Object(__WEBPACK_IMPORTED_MODULE_5__util_DOMUtils__["c" /* getStringSize */])(content)[sizeKey] + unitSize;

        if (i === 0) {
          var gap = sign * (entry.coordinate - sign * size / 2 - start);
          result[i] = entry = _extends({}, entry, {
            tickCoord: gap < 0 ? entry.coordinate - gap * sign : entry.coordinate
          });
        } else {
          result[i] = entry = _extends({}, entry, { tickCoord: entry.coordinate });
        }

        var isShow = sign * (entry.tickCoord - sign * size / 2 - start) >= 0 && sign * (entry.tickCoord + sign * size / 2 - end) <= 0;

        if (isShow) {
          start = entry.tickCoord + sign * (size / 2 + minTickGap);
          result[i] = _extends({}, entry, { isShow: true });
        }
      }

      return result.filter(function (entry) {
        return entry.isShow;
      });
    }
  }, {
    key: 'getTicksEnd',
    value: function getTicksEnd(_ref3) {
      var ticks = _ref3.ticks,
          tickFormatter = _ref3.tickFormatter,
          viewBox = _ref3.viewBox,
          orientation = _ref3.orientation,
          minTickGap = _ref3.minTickGap,
          unit = _ref3.unit;
      var x = viewBox.x,
          y = viewBox.y,
          width = viewBox.width,
          height = viewBox.height;

      var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height';
      var unitSize = unit ? Object(__WEBPACK_IMPORTED_MODULE_5__util_DOMUtils__["c" /* getStringSize */])(unit)[sizeKey] : 0;
      var result = (ticks || []).slice();
      var len = result.length;
      var sign = len >= 2 ? Object(__WEBPACK_IMPORTED_MODULE_10__util_DataUtils__["i" /* mathSign */])(result[1].coordinate - result[0].coordinate) : 1;

      var start = void 0,
          end = void 0;

      if (sign === 1) {
        start = sizeKey === 'width' ? x : y;
        end = sizeKey === 'width' ? x + width : y + height;
      } else {
        start = sizeKey === 'width' ? x + width : y + height;
        end = sizeKey === 'width' ? x : y;
      }

      for (var i = len - 1; i >= 0; i--) {
        var entry = result[i];
        var content = __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(tickFormatter) ? tickFormatter(entry.value) : entry.value;
        var size = Object(__WEBPACK_IMPORTED_MODULE_5__util_DOMUtils__["c" /* getStringSize */])(content)[sizeKey] + unitSize;

        if (i === len - 1) {
          var gap = sign * (entry.coordinate + sign * size / 2 - end);
          result[i] = entry = _extends({}, entry, {
            tickCoord: gap > 0 ? entry.coordinate - gap * sign : entry.coordinate
          });
        } else {
          result[i] = entry = _extends({}, entry, { tickCoord: entry.coordinate });
        }

        var isShow = sign * (entry.tickCoord - sign * size / 2 - start) >= 0 && sign * (entry.tickCoord + sign * size / 2 - end) <= 0;

        if (isShow) {
          end = entry.tickCoord - sign * (size / 2 + minTickGap);
          result[i] = _extends({}, entry, { isShow: true });
        }
      }

      return result.filter(function (entry) {
        return entry.isShow;
      });
    }
  }]);

  return CartesianAxis;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class.displayName = 'CartesianAxis', _class.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], __WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["a" /* EVENT_ATTRIBUTES */], {
  className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  x: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  y: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  width: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  orientation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['top', 'bottom', 'left', 'right']),
  // The viewBox of svg
  viewBox: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    y: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    width: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    height: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number
  }),
  tick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element]),
  axisLine: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object]),
  tickLine: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object]),
  mirror: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  tickMargin: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,

  minTickGap: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  ticks: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  tickSize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  stroke: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  tickFormatter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  ticksGenerator: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  interval: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['preserveStart', 'preserveEnd', 'preserveStartEnd'])])
}), _class.defaultProps = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  viewBox: { x: 0, y: 0, width: 0, height: 0 },
  // The orientation of axis
  orientation: 'bottom',
  // The ticks
  ticks: [],

  stroke: '#666',
  tickLine: true,
  axisLine: true,
  tick: true,
  mirror: false,

  minTickGap: 5,
  // The width or height of tick
  tickSize: 6,
  tickMargin: 2,
  interval: 'preserveEnd'
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (CartesianAxis);

/***/ }),
/* 222 */
/***/ (function(module, exports) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function(n) {
  if (!isNumber(n) || n < 0 || isNaN(n))
    throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function(type) {
  var er, handler, len, args, i, listeners;

  if (!this._events)
    this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events.error ||
        (isObject(this._events.error) && !this._events.error.length)) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
    }
  }

  handler = this._events[type];

  if (isUndefined(handler))
    return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        args = Array.prototype.slice.call(arguments, 1);
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    args = Array.prototype.slice.call(arguments, 1);
    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++)
      listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter.prototype.addListener = function(type, listener) {
  var m;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events)
    this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener)
    this.emit('newListener', type,
              isFunction(listener.listener) ?
              listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
  else if (isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);
  else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (isObject(this._events[type]) && !this._events[type].warned) {
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' +
                    'leak detected. %d listeners added. ' +
                    'Use emitter.setMaxListeners() to increase limit.',
                    this._events[type].length);
      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function(type, listener) {
  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function(type, listener) {
  var list, position, length, i;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events || !this._events[type])
    return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener ||
      (isFunction(list.listener) && list.listener === listener)) {
    delete this._events[type];
    if (this._events.removeListener)
      this.emit('removeListener', type, listener);

  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener ||
          (list[i].listener && list[i].listener === listener)) {
        position = i;
        break;
      }
    }

    if (position < 0)
      return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener)
      this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function(type) {
  var key, listeners;

  if (!this._events)
    return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0)
      this._events = {};
    else if (this._events[type])
      delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    while (listeners.length)
      this.removeListener(type, listeners[listeners.length - 1]);
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function(type) {
  var ret;
  if (!this._events || !this._events[type])
    ret = [];
  else if (isFunction(this._events[type]))
    ret = [this._events[type]];
  else
    ret = this._events[type].slice();
  return ret;
};

EventEmitter.prototype.listenerCount = function(type) {
  if (this._events) {
    var evlistener = this._events[type];

    if (isFunction(evlistener))
      return 1;
    else if (evlistener)
      return evlistener.length;
  }
  return 0;
};

EventEmitter.listenerCount = function(emitter, type) {
  return emitter.listenerCount(type);
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(556);

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(22), __webpack_require__(1), __webpack_require__(127), __webpack_require__(128), __webpack_require__(557)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require('react'), require('react-dom'), require('prop-types'), require('./s-alert-parts/s-alert-tools'), require('./s-alert-parts/s-alert-store'), require('./SAlertContentTmpl'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.react, global.reactDom, global.propTypes, global.sAlertTools, global.sAlertStore, global.SAlertContentTmpl);
        global.SAlertContent = mod.exports;
    }
})(this, function (exports, _react, _reactDom, _propTypes, _sAlertTools, _sAlertStore, _SAlertContentTmpl) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _react2 = _interopRequireDefault(_react);

    var _reactDom2 = _interopRequireDefault(_reactDom);

    var _propTypes2 = _interopRequireDefault(_propTypes);

    var _sAlertTools2 = _interopRequireDefault(_sAlertTools);

    var _sAlertStore2 = _interopRequireDefault(_sAlertStore);

    var _SAlertContentTmpl2 = _interopRequireDefault(_SAlertContentTmpl);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    function _possibleConstructorReturn(self, call) {
        if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var SAlertContent = function (_React$Component) {
        _inherits(SAlertContent, _React$Component);

        function SAlertContent(props) {
            _classCallCheck(this, SAlertContent);

            return _possibleConstructorReturn(this, (SAlertContent.__proto__ || Object.getPrototypeOf(SAlertContent)).call(this, props));
        }

        _createClass(SAlertContent, [{
            key: 'handleCloseAlert',
            value: function handleCloseAlert() {
                var closingTimeout = void 0;
                var alertId = this.props.id;
                var currentAlertElem = _reactDom2.default.findDOMNode(this);
                var animationClose = function animationClose() {
                    currentAlertElem.style.display = 'none';
                    _sAlertStore2.default.dispatch({ type: 'REMOVE', data: { id: alertId } });
                    clearTimeout(closingTimeout);
                };
                if (document.hidden || document.webkitHidden || !currentAlertElem.classList.contains('s-alert-is-effect')) {
                    _sAlertStore2.default.dispatch({ type: 'REMOVE', data: { id: alertId } });
                } else {
                    currentAlertElem.classList.remove('s-alert-show');
                    closingTimeout = setTimeout(function () {
                        currentAlertElem.classList.add('s-alert-hide');
                    }, 100);
                    currentAlertElem.removeEventListener('webkitAnimationEnd', animationClose, false);
                    currentAlertElem.removeEventListener('animationend', animationClose, false);
                    currentAlertElem.addEventListener('webkitAnimationEnd', animationClose, false);
                    currentAlertElem.addEventListener('animationend', animationClose, false);
                }
                // stop audio when closing
                this.alertAudio && this.alertAudio.load();
            }
        }, {
            key: 'componentWillMount',
            value: function componentWillMount() {
                var beep = this.props.beep;
                var condition = this.props.condition;
                if (beep && typeof beep === 'string') {
                    this.alertAudio = new Audio(beep);
                    this.alertAudio.load();
                    this.alertAudio.play();
                }
                if (beep && (typeof beep === 'undefined' ? 'undefined' : _typeof(beep)) === 'object' && condition === 'info') {
                    this.alertAudio = new Audio(beep.info);
                    this.alertAudio.load();
                    this.alertAudio.play();
                }
                if (beep && (typeof beep === 'undefined' ? 'undefined' : _typeof(beep)) === 'object' && condition === 'error') {
                    this.alertAudio = new Audio(beep.error);
                    this.alertAudio.load();
                    this.alertAudio.play();
                }
                if (beep && (typeof beep === 'undefined' ? 'undefined' : _typeof(beep)) === 'object' && condition === 'success') {
                    this.alertAudio = new Audio(beep.success);
                    this.alertAudio.load();
                    this.alertAudio.play();
                }
                if (beep && (typeof beep === 'undefined' ? 'undefined' : _typeof(beep)) === 'object' && condition === 'warning') {
                    this.alertAudio = new Audio(beep.warning);
                    this.alertAudio.load();
                    this.alertAudio.play();
                }
            }
        }, {
            key: 'componentDidMount',
            value: function componentDidMount() {
                var _this2 = this;

                if (typeof this.props.timeout === 'number') {
                    this.closeTimer = setTimeout(function () {
                        _this2.handleCloseAlert();
                    }, this.props.timeout);
                }
                if (this.props.onShow) {
                    this.props.onShow();
                }
            }
        }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                if (this.closeTimer) {
                    clearTimeout(this.closeTimer);
                }
                if (this.props.onClose) {
                    this.props.onClose();
                }
            }
        }, {
            key: 'render',
            value: function render() {
                var classNames = 's-alert-box s-alert-' + this.props.condition + ' s-alert-' + this.props.position + ' ' + (this.props.effect ? 's-alert-is-effect s-alert-effect-' + this.props.effect : '') + ' s-alert-show';
                var message = this.props.html ? _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: this.props.message } }) : this.props.message;
                var styles = this.props.boxPosition ? _sAlertTools2.default.styleToObj(this.props.boxPosition) : {};
                var id = this.props.id;
                var handleClose = this.handleCloseAlert.bind(this);
                var contentTemplate = this.props.contentTemplate || _SAlertContentTmpl2.default;
                var customFields = this.props.customFields || {};

                return _react2.default.createElement(contentTemplate, { classNames: classNames, id: id, styles: styles, message: message, handleClose: handleClose, customFields: customFields });
            }
        }]);

        return SAlertContent;
    }(_react2.default.Component);

    SAlertContent.propTypes = {
        condition: _propTypes2.default.string.isRequired,
        message: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
        position: _propTypes2.default.string.isRequired,
        boxPosition: _propTypes2.default.string,
        id: _propTypes2.default.string.isRequired,
        effect: _propTypes2.default.string,
        beep: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.bool]),
        timeout: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['none']), _propTypes2.default.number]),
        html: _propTypes2.default.bool,
        onClose: _propTypes2.default.func,
        onShow: _propTypes2.default.func,
        customFields: _propTypes2.default.object,
        contentTemplate: _propTypes2.default.func
    };

    exports.default = SAlertContent;
});

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _Const = __webpack_require__(7);

var _Const2 = _interopRequireDefault(_Const);

var _util = __webpack_require__(15);

var _util2 = _interopRequireDefault(_util);

var _Date = __webpack_require__(559);

var _Date2 = _interopRequireDefault(_Date);

var _Text = __webpack_require__(560);

var _Text2 = _interopRequireDefault(_Text);

var _Regex = __webpack_require__(561);

var _Regex2 = _interopRequireDefault(_Regex);

var _Select = __webpack_require__(562);

var _Select2 = _interopRequireDefault(_Select);

var _Number = __webpack_require__(563);

var _Number2 = _interopRequireDefault(_Number);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint default-case: 0 */
/* eslint guard-for-in: 0 */


var TableHeaderColumn = function (_Component) {
  _inherits(TableHeaderColumn, _Component);

  function TableHeaderColumn(props) {
    _classCallCheck(this, TableHeaderColumn);

    var _this = _possibleConstructorReturn(this, (TableHeaderColumn.__proto__ || Object.getPrototypeOf(TableHeaderColumn)).call(this, props));

    _this.handleColumnClick = function () {
      return _this.__handleColumnClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleFilter = _this.handleFilter.bind(_this);
    return _this;
  }

  _createClass(TableHeaderColumn, [{
    key: '__handleColumnClick__REACT_HOT_LOADER__',
    value: function __handleColumnClick__REACT_HOT_LOADER__() {
      return this.__handleColumnClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.reset) {
        this.cleanFiltered();
      }

      // If column not displaying the same dataField, reset the filter accordingly
      if (nextProps.filter && nextProps.dataField !== this.props.dataField) {
        var emitter = nextProps.filter.emitter || {};
        var currentFilter = emitter.currentFilter || {};
        var filter = currentFilter[nextProps.dataField];
        var value = filter ? filter.value : '';

        var _ref = this.getFilters(nextProps) || {},
            ref = _ref.ref;

        if (this.refs[ref]) {
          this.refs[ref].setState({ value: value });
        }
      }
    }
  }, {
    key: '__handleColumnClick__REACT_HOT_LOADER__',
    value: function __handleColumnClick__REACT_HOT_LOADER__() {
      if (this.props.isOnlyHead || !this.props.dataSort) return;
      var order = this.props.sort;

      if (!order && this.props.defaultASC) order = _Const2.default.SORT_ASC;else order = this.props.sort === _Const2.default.SORT_DESC ? _Const2.default.SORT_ASC : _Const2.default.SORT_DESC;
      this.props.onSort(order, this.props.dataField);
    }
  }, {
    key: 'handleFilter',
    value: function handleFilter(value, type) {
      var filter = this.props.filter;

      filter.emitter.handleFilter(this.props.dataField, value, type, filter);
    }
  }, {
    key: 'getFilters',
    value: function getFilters() {
      var _this2 = this;

      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var headerText = props.headerText,
          children = props.children;

      switch (props.filter.type) {
        case _Const2.default.FILTER_TYPE.TEXT:
          {
            return _react2.default.createElement(_Text2.default, _extends({ ref: function ref(n) {
                return _this2.textFilter = n;
              } }, props.filter, {
              columnName: headerText || children, filterHandler: this.handleFilter }));
          }
        case _Const2.default.FILTER_TYPE.REGEX:
          {
            return _react2.default.createElement(_Regex2.default, _extends({ ref: function ref(n) {
                return _this2.regexFilter = n;
              } }, props.filter, {
              columnName: headerText || children, filterHandler: this.handleFilter }));
          }
        case _Const2.default.FILTER_TYPE.SELECT:
          {
            return _react2.default.createElement(_Select2.default, _extends({ ref: function ref(n) {
                return _this2.selectFilter = n;
              } }, props.filter, {
              columnName: headerText || children, filterHandler: this.handleFilter }));
          }
        case _Const2.default.FILTER_TYPE.NUMBER:
          {
            return _react2.default.createElement(_Number2.default, _extends({ ref: function ref(n) {
                return _this2.numberFilter = n;
              } }, props.filter, {
              columnName: headerText || children, filterHandler: this.handleFilter }));
          }
        case _Const2.default.FILTER_TYPE.DATE:
          {
            return _react2.default.createElement(_Date2.default, _extends({ ref: function ref(n) {
                return _this2.dateFilter = n;
              } }, props.filter, {
              columnName: headerText || children, filterHandler: this.handleFilter }));
          }
        case _Const2.default.FILTER_TYPE.CUSTOM:
          {
            var elm = props.filter.getElement(this.handleFilter, props.filter.customFilterParameters);

            return _react2.default.cloneElement(elm, { ref: function ref(n) {
                return _this2.customFilter = n;
              } });
          }
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.headerCol.setAttribute('data-field', this.props.dataField);
    }
  }, {
    key: 'renderDefaultCaret',
    value: function renderDefaultCaret(dataSort, isBootstrap4) {
      if (!dataSort) return null;
      if (isBootstrap4) {
        return _react2.default.createElement('span', { className: 'order fa fa-sort',
          style: { margin: '10px 0 10px 5px', color: '#ccc' } });
      } else {
        return _react2.default.createElement(
          'span',
          { className: 'order' },
          _react2.default.createElement(
            'span',
            { className: 'dropdown' },
            _react2.default.createElement('span', { className: 'caret', style: { margin: '10px 0 10px 5px', color: '#ccc' } })
          ),
          _react2.default.createElement(
            'span',
            { className: 'dropup' },
            _react2.default.createElement('span', { className: 'caret', style: { margin: '10px 0', color: '#ccc' } })
          )
        );
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var defaultCaret = void 0;
      var sortCaret = void 0;
      var sortClass = void 0;
      var _props = this.props,
          headerText = _props.headerText,
          dataAlign = _props.dataAlign,
          dataField = _props.dataField,
          headerAlign = _props.headerAlign,
          headerTitle = _props.headerTitle,
          hidden = _props.hidden,
          sort = _props.sort,
          dataSort = _props.dataSort,
          sortIndicator = _props.sortIndicator,
          children = _props.children,
          caretRender = _props.caretRender,
          className = _props.className,
          isOnlyHead = _props.isOnlyHead,
          version = _props.version,
          customSortClass = _props.sortHeaderColumnClassName,
          style = _props.thStyle;

      var thStyle = _extends({
        textAlign: headerAlign || dataAlign,
        display: hidden ? 'none' : null
      }, style);
      var isBootstrap4 = _util2.default.isBootstrap4(version);
      if (!isOnlyHead) {
        if (sortIndicator) {
          defaultCaret = this.renderDefaultCaret(dataSort, isBootstrap4);
        }
        sortCaret = sort ? _util2.default.renderReactSortCaret(sort, isBootstrap4) : defaultCaret;
        if (caretRender) {
          sortCaret = caretRender(sort, dataField);
        }
      }

      if (sort) {
        sortClass = _util2.default.isFunction(customSortClass) ? customSortClass(sort, dataField) : customSortClass;
      }
      var classes = (0, _classnames2.default)(_util2.default.isFunction(className) ? className() : className, !isOnlyHead && dataSort ? 'sort-column' : '', sortClass);

      var attr = {};
      if (headerTitle) {
        if (typeof children === 'string' && !headerText) {
          attr.title = children;
        } else {
          attr.title = headerText;
        }
      }
      return _react2.default.createElement(
        'th',
        _extends({ ref: function ref(node) {
            return _this3.headerCol = node;
          },
          className: classes,
          style: thStyle,
          onClick: this.handleColumnClick,
          rowSpan: this.props.rowSpan,
          colSpan: this.props.colSpan,
          'data-is-only-head': this.props.isOnlyHead
        }, attr),
        children,
        sortCaret,
        _react2.default.createElement(
          'div',
          { onClick: function onClick(e) {
              return e.stopPropagation();
            } },
          this.props.filter && !isOnlyHead ? this.getFilters() : null
        )
      );
    }
  }, {
    key: 'cleanFiltered',
    value: function cleanFiltered() {
      if (!this.props.filter) return;

      switch (this.props.filter.type) {
        case _Const2.default.FILTER_TYPE.TEXT:
          {
            this.textFilter.cleanFiltered();
            break;
          }
        case _Const2.default.FILTER_TYPE.REGEX:
          {
            this.regexFilter.cleanFiltered();
            break;
          }
        case _Const2.default.FILTER_TYPE.SELECT:
          {
            this.selectFilter.cleanFiltered();
            break;
          }
        case _Const2.default.FILTER_TYPE.NUMBER:
          {
            this.numberFilter.cleanFiltered();
            break;
          }
        case _Const2.default.FILTER_TYPE.DATE:
          {
            this.dateFilter.cleanFiltered();
            break;
          }
        case _Const2.default.FILTER_TYPE.CUSTOM:
          {
            this.customFilter.cleanFiltered();
            break;
          }
      }
    }
  }, {
    key: 'applyFilter',
    value: function applyFilter(val) {
      if (!this.props.filter) return;
      switch (this.props.filter.type) {
        case _Const2.default.FILTER_TYPE.TEXT:
          {
            this.textFilter.applyFilter(val);
            break;
          }
        case _Const2.default.FILTER_TYPE.REGEX:
          {
            this.regexFilter.applyFilter(val);
            break;
          }
        case _Const2.default.FILTER_TYPE.SELECT:
          {
            this.selectFilter.applyFilter(val);
            break;
          }
        case _Const2.default.FILTER_TYPE.NUMBER:
          {
            this.numberFilter.applyFilter(val);
            break;
          }
        case _Const2.default.FILTER_TYPE.DATE:
          {
            this.dateFilter.applyFilter(val);
            break;
          }
      }
    }
  }]);

  return TableHeaderColumn;
}(_react.Component);

var filterTypeArray = [];
for (var key in _Const2.default.FILTER_TYPE) {
  filterTypeArray.push(_Const2.default.FILTER_TYPE[key]);
}

TableHeaderColumn.propTypes = {
  dataField: _propTypes2.default.string,
  dataAlign: _propTypes2.default.string,
  headerAlign: _propTypes2.default.string,
  headerTitle: _propTypes2.default.bool,
  headerText: _propTypes2.default.string,
  dataSort: _propTypes2.default.bool,
  onSort: _propTypes2.default.func,
  dataFormat: _propTypes2.default.func,
  csvFormat: _propTypes2.default.func,
  csvHeader: _propTypes2.default.string,
  csvFieldType: _propTypes2.default.oneOf([_Const2.default.CSV_STRING_TYPE, _Const2.default.CSV_NUMBER_TYPE]),
  isKey: _propTypes2.default.bool,
  editable: _propTypes2.default.any,
  hidden: _propTypes2.default.bool,
  hiddenOnInsert: _propTypes2.default.bool,
  searchable: _propTypes2.default.bool,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  width: _propTypes2.default.string,
  sortFunc: _propTypes2.default.func,
  sortFuncExtraData: _propTypes2.default.any,
  sortHeaderColumnClassName: _propTypes2.default.any,
  columnClassName: _propTypes2.default.any,
  editColumnClassName: _propTypes2.default.any,
  invalidEditColumnClassName: _propTypes2.default.any,
  columnTitle: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func, _propTypes2.default.string]),
  filterFormatted: _propTypes2.default.bool,
  filterValue: _propTypes2.default.func,
  sort: _propTypes2.default.string,
  caretRender: _propTypes2.default.func,
  formatExtraData: _propTypes2.default.any,
  csvFormatExtraData: _propTypes2.default.any,
  filter: _propTypes2.default.shape({
    type: _propTypes2.default.oneOf(filterTypeArray),
    delay: _propTypes2.default.number,
    options: _propTypes2.default.oneOfType([_propTypes2.default.object, // for SelectFilter
    _propTypes2.default.arrayOf(_propTypes2.default.number) // for NumberFilter
    ]),
    numberComparators: _propTypes2.default.arrayOf(_propTypes2.default.string),
    emitter: _propTypes2.default.object,
    placeholder: _propTypes2.default.string,
    getElement: _propTypes2.default.func,
    customFilterParameters: _propTypes2.default.object,
    condition: _propTypes2.default.oneOf([_Const2.default.FILTER_COND_EQ, _Const2.default.FILTER_COND_LIKE])
  }),
  sortIndicator: _propTypes2.default.bool,
  export: _propTypes2.default.bool,
  expandable: _propTypes2.default.bool,
  tdAttr: _propTypes2.default.object,
  editTdAttr: _propTypes2.default.object,
  tdStyle: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object]),
  thStyle: _propTypes2.default.object,
  keyValidator: _propTypes2.default.bool,
  defaultASC: _propTypes2.default.bool
};

TableHeaderColumn.defaultProps = {
  dataAlign: 'left',
  headerAlign: undefined,
  headerTitle: true,
  dataSort: false,
  dataFormat: undefined,
  csvFormat: undefined,
  csvHeader: undefined,
  csvFieldType: _Const2.default.CSV_STRING_TYPE,
  isKey: false,
  editable: true,
  onSort: undefined,
  hidden: false,
  hiddenOnInsert: false,
  searchable: true,
  className: '',
  columnTitle: false,
  width: null,
  sortFunc: undefined,
  columnClassName: '',
  editColumnClassName: '',
  invalidEditColumnClassName: '',
  filterFormatted: false,
  filterValue: undefined,
  sort: undefined,
  formatExtraData: undefined,
  sortFuncExtraData: undefined,
  filter: undefined,
  sortIndicator: true,
  expandable: true,
  tdAttr: undefined,
  editTdAttr: undefined,
  tdStyle: undefined,
  thStyle: undefined,
  keyValidator: false,
  defaultASC: false
};

var _default = TableHeaderColumn;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TableHeaderColumn, 'TableHeaderColumn', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableHeaderColumn.js');

  __REACT_HOT_LOADER__.register(filterTypeArray, 'filterTypeArray', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableHeaderColumn.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableHeaderColumn.js');
}();

;

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _util = __webpack_require__(15);

var _util2 = _interopRequireDefault(_util);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var editor = function editor(editable, attr, format, editorClass, defaultValue, ignoreEditable, row) {
  if (editable === true || editable === false && ignoreEditable || typeof editable === 'string') {
    // simple declare
    var type = editable ? 'text' : editable;
    return _react2.default.createElement('input', _extends({}, attr, { type: type, defaultValue: defaultValue,
      className: (editorClass || '') + ' form-control editor edit-text' }));
  } else if (!editable) {
    var _type = editable ? 'text' : editable;
    return _react2.default.createElement('input', _extends({}, attr, { type: _type, defaultValue: defaultValue,
      disabled: 'disabled',
      className: (editorClass || '') + ' form-control editor edit-text' }));
  } else if (editable && (editable.type === undefined || editable.type === null || editable.type.trim() === '')) {
    var _type2 = editable ? 'text' : editable;
    return _react2.default.createElement('input', _extends({}, attr, { type: _type2, defaultValue: defaultValue,
      className: (editorClass || '') + ' form-control editor edit-text' }));
  } else if (editable.type) {
    // standard declare
    // put style if exist
    editable.style && (attr.style = editable.style);
    // put class if exist
    attr.className = (editorClass || '') + ' form-control editor edit-' + editable.type + (editable.className ? ' ' + editable.className : '');

    if (editable.type === 'select') {
      // process select input
      var options = [];
      var values = editable.options.values;
      var _editable$options = editable.options,
          textKey = _editable$options.textKey,
          valueKey = _editable$options.valueKey;

      if (_util2.default.isFunction(values)) {
        values = values(row);
      }
      if (Array.isArray(values)) {
        // only can use arrray data for options
        var text = void 0;
        var value = void 0;
        options = values.map(function (option, i) {
          if ((typeof option === 'undefined' ? 'undefined' : _typeof(option)) === 'object') {
            text = textKey ? option[textKey] : option.text;
            value = valueKey ? option[valueKey] : option.value;
          } else {
            text = format ? format(option) : option;
            value = option;
          }
          return _react2.default.createElement(
            'option',
            { key: 'option' + i, value: value },
            text
          );
        });
      }
      return _react2.default.createElement(
        'select',
        _extends({}, attr, { defaultValue: defaultValue }),
        options
      );
    } else if (editable.type === 'textarea') {
      // process textarea input
      // put other if exist
      editable.cols && (attr.cols = editable.cols);
      editable.rows && (attr.rows = editable.rows);
      var saveBtn = void 0;
      var keyUpHandler = attr.onKeyDown;
      if (keyUpHandler) {
        attr.onKeyDown = function (e) {
          if (e.keyCode !== 13) {
            // not Pressed ENTER
            keyUpHandler(e);
          }
        };
        saveBtn = _react2.default.createElement(
          'button',
          {
            className: 'btn btn-info btn-xs textarea-save-btn',
            onClick: keyUpHandler },
          'save'
        );
      }
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('textarea', _extends({}, attr, { defaultValue: defaultValue })),
        saveBtn
      );
    } else if (editable.type === 'checkbox') {
      var _values = 'true:false';
      if (editable.options && editable.options.values) {
        // values = editable.options.values.split(':');
        _values = editable.options.values;
      }
      attr.className = attr.className.replace('form-control', '');
      attr.className += ' checkbox pull-right';

      var checked = defaultValue && defaultValue.toString() === _values.split(':')[0] ? true : false;

      return _react2.default.createElement('input', _extends({}, attr, { type: 'checkbox',
        value: _values, defaultChecked: checked }));
    } else if (editable.type === 'datetime') {
      return _react2.default.createElement('input', _extends({}, attr, { type: 'datetime-local', defaultValue: defaultValue }));
    } else {
      // process other input type. as password,url,email...
      return _react2.default.createElement('input', _extends({}, attr, { type: editable.type, defaultValue: defaultValue }));
    }
  }
  // default return for other case of editable
  return _react2.default.createElement('input', _extends({}, attr, { type: 'text',
    className: (editorClass || '') + ' form-control editor edit-text' }));
};

var _default = editor;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(editor, 'editor', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/Editor.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/Editor.js');
}();

;

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.notice = undefined;

var _reactSAlert = __webpack_require__(223);

var _reactSAlert2 = _interopRequireDefault(_reactSAlert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var notice = function notice(type, msg, title) {
  var titleHTML = title ? '<h4><strong>' + title + '</strong></h4>' : '';

  var bodyHTML = '\n    ' + titleHTML + '\n    <div>\n      <span class=\'fa fa-exclamation-triangle glyphicon glyphicon-alert\'></span>&nbsp;\n      <span>' + msg + '</span>\n    </div>\n  ';

  _reactSAlert2.default.error(bodyHTML, {
    position: 'top-right',
    timeout: 3000,
    html: true,
    effect: 'scale'
  });
};

exports.notice = notice;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(notice, 'notice', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/Notification.js');
}();

;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sizePerPageDefaultClass = 'react-bs-table-sizePerPage-dropdown';

var SizePerPageDropDown = function (_Component) {
  _inherits(SizePerPageDropDown, _Component);

  function SizePerPageDropDown() {
    _classCallCheck(this, SizePerPageDropDown);

    return _possibleConstructorReturn(this, (SizePerPageDropDown.__proto__ || Object.getPrototypeOf(SizePerPageDropDown)).apply(this, arguments));
  }

  _createClass(SizePerPageDropDown, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          open = _props.open,
          hidden = _props.hidden,
          onClick = _props.onClick,
          onBlur = _props.onBlur,
          options = _props.options,
          className = _props.className,
          variation = _props.variation,
          btnContextual = _props.btnContextual,
          isBootstrap4 = _props.isBootstrap4,
          currSizePerPage = _props.currSizePerPage;


      if (hidden) return null;

      var openClass = open ? 'open show' : '';

      var renderOptions = function renderOptions() {
        var attrs = {
          className: 'dropdown-menu ' + openClass,
          role: 'menu',
          'aria-labelledby': 'pageDropDown'
        };
        var type = isBootstrap4 ? 'div' : 'ul';

        return _react2.default.createElement(type, attrs, options);
      };

      return _react2.default.createElement(
        'span',
        {
          className: variation + ' ' + openClass + ' ' + className + ' ' + sizePerPageDefaultClass },
        _react2.default.createElement(
          'button',
          { className: 'btn ' + btnContextual + ' dropdown-toggle',
            id: 'pageDropDown', 'data-toggle': 'dropdown',
            'aria-expanded': open,
            'aria-haspopup': !open,
            onClick: onClick,
            onBlur: onBlur },
          currSizePerPage,
          _react2.default.createElement(
            'span',
            null,
            ' ',
            _react2.default.createElement('span', { className: 'caret' })
          )
        ),
        renderOptions()
      );
    }
  }]);

  return SizePerPageDropDown;
}(_react.Component);

SizePerPageDropDown.propTypes = {
  open: _propTypes2.default.bool,
  hidden: _propTypes2.default.bool,
  btnContextual: _propTypes2.default.string,
  currSizePerPage: _propTypes2.default.string,
  options: _propTypes2.default.array,
  variation: _propTypes2.default.oneOf(['dropdown', 'dropup']),
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  onBlur: _propTypes2.default.func
};
SizePerPageDropDown.defaultProps = {
  open: false,
  hidden: false,
  btnContextual: 'btn-default btn-secondary',
  variation: 'dropdown',
  className: ''
};

var _default = SizePerPageDropDown;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(sizePerPageDefaultClass, 'sizePerPageDefaultClass', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/pagination/SizePerPageDropDown.js');

  __REACT_HOT_LOADER__.register(SizePerPageDropDown, 'SizePerPageDropDown', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/pagination/SizePerPageDropDown.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/pagination/SizePerPageDropDown.js');
}();

;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

var tabbableNode = /input|select|textarea|button|object/;

function hidesContents(element) {
  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;

  // If the node is empty, this is good enough
  if (zeroSize && !element.innerHTML) return true;

  // Otherwise we need to check some styles
  var style = window.getComputedStyle(element);
  return zeroSize ? style.getPropertyValue("overflow") !== "visible" : style.getPropertyValue("display") == "none";
}

function visible(element) {
  var parentElement = element;
  while (parentElement) {
    if (parentElement === document.body) break;
    if (hidesContents(parentElement)) return false;
    parentElement = parentElement.parentNode;
  }
  return true;
}

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}

function tabbable(element) {
  var tabIndex = element.getAttribute("tabindex");
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  return [].slice.call(element.querySelectorAll("*"), 0).filter(tabbable);
}
module.exports = exports["default"];

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assertNodeList = assertNodeList;
exports.setElement = setElement;
exports.validateElement = validateElement;
exports.hide = hide;
exports.show = show;
exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
exports.resetForTesting = resetForTesting;

var _warning = __webpack_require__(581);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var globalElement = null;

function assertNodeList(nodeList, selector) {
  if (!nodeList || !nodeList.length) {
    throw new Error("react-modal: No elements were found for selector " + selector + ".");
  }
}

function setElement(element) {
  var useElement = element;
  if (typeof useElement === "string") {
    var el = document.querySelectorAll(useElement);
    assertNodeList(el, useElement);
    useElement = "length" in el ? el[0] : el;
  }
  globalElement = useElement || globalElement;
  return globalElement;
}

function validateElement(appElement) {
  if (!appElement && !globalElement) {
    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));

    return false;
  }

  return true;
}

function hide(appElement) {
  if (validateElement(appElement)) {
    (appElement || globalElement).setAttribute("aria-hidden", "true");
  }
}

function show(appElement) {
  if (validateElement(appElement)) {
    (appElement || globalElement).removeAttribute("aria-hidden");
  }
}

function documentNotReadyOrSSRTesting() {
  globalElement = null;
}

function resetForTesting() {
  globalElement = null;
}

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.get = get;
exports.add = add;
exports.remove = remove;
exports.totalCount = totalCount;
var classListMap = {};

function get() {
  return classListMap;
}

function add(bodyClass) {
  // Set variable and default if none
  if (!classListMap[bodyClass]) {
    classListMap[bodyClass] = 0;
  }
  classListMap[bodyClass] += 1;
  return bodyClass;
}

function remove(bodyClass) {
  if (classListMap[bodyClass]) {
    classListMap[bodyClass] -= 1;
  }
  return bodyClass;
}

function totalCount() {
  return Object.keys(classListMap).reduce(function (acc, curr) {
    return acc + classListMap[curr];
  }, 0);
}

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canUseDOM = undefined;

var _exenv = __webpack_require__(583);

var _exenv2 = _interopRequireDefault(_exenv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EE = _exenv2.default;

var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};

var canUseDOM = exports.canUseDOM = EE.canUseDOM;

exports.default = SafeHTMLElement;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _util = __webpack_require__(15);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InsertModalHeader = function (_Component) {
  _inherits(InsertModalHeader, _Component);

  function InsertModalHeader() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, InsertModalHeader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InsertModalHeader.__proto__ || Object.getPrototypeOf(InsertModalHeader)).call.apply(_ref, [this].concat(args))), _this), _this.handleCloseBtnClick = function () {
      var _this2;

      return (_this2 = _this).__handleCloseBtnClick__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(InsertModalHeader, [{
    key: '__handleCloseBtnClick__REACT_HOT_LOADER__',
    value: function __handleCloseBtnClick__REACT_HOT_LOADER__() {
      return this.__handleCloseBtnClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleCloseBtnClick__REACT_HOT_LOADER__',
    value: function __handleCloseBtnClick__REACT_HOT_LOADER__(e) {
      var _props = this.props,
          onModalClose = _props.onModalClose,
          beforeClose = _props.beforeClose;

      beforeClose && beforeClose(e);
      onModalClose();
    }
  }, {
    key: 'renderContent',
    value: function renderContent(closeBtn) {
      var _props2 = this.props,
          version = _props2.version,
          titleText = _props2.title;

      var title = _react2.default.createElement(
        'h4',
        { key: 'title', className: 'modal-title' },
        titleText
      );
      if (_util2.default.isBootstrap4(version)) {
        return [title, closeBtn];
      } else {
        return _react2.default.createElement(
          'span',
          null,
          closeBtn,
          title
        );
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          hideClose = _props3.hideClose,
          className = _props3.className,
          children = _props3.children;


      var closeBtn = hideClose ? null : _react2.default.createElement(
        'button',
        { type: 'button',
          className: 'close', onClick: this.handleCloseBtnClick },
        _react2.default.createElement(
          'span',
          { 'aria-hidden': 'true' },
          '\xD7'
        ),
        _react2.default.createElement(
          'span',
          { className: 'sr-only' },
          'Close'
        )
      );

      var content = children || this.renderContent(closeBtn);

      return _react2.default.createElement(
        'div',
        { className: 'modal-header ' + className },
        content
      );
    }
  }]);

  return InsertModalHeader;
}(_react.Component);

InsertModalHeader.propTypes = {
  version: _propTypes2.default.string,
  className: _propTypes2.default.string,
  title: _propTypes2.default.string,
  onModalClose: _propTypes2.default.func,
  hideClose: _propTypes2.default.bool,
  beforeClose: _propTypes2.default.func
};
InsertModalHeader.defaultProps = {
  version: '3',
  className: '',
  title: 'Add Row',
  onModalClose: undefined,
  hideClose: false,
  beforeClose: undefined
};

var _default = InsertModalHeader;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(InsertModalHeader, 'InsertModalHeader', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertModalHeader.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertModalHeader.js');
}();

;

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Const = __webpack_require__(7);

var _Const2 = _interopRequireDefault(_Const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InsertModalFooter = function (_Component) {
  _inherits(InsertModalFooter, _Component);

  function InsertModalFooter() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, InsertModalFooter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InsertModalFooter.__proto__ || Object.getPrototypeOf(InsertModalFooter)).call.apply(_ref, [this].concat(args))), _this), _this.handleCloseBtnClick = function () {
      var _this2;

      return (_this2 = _this).__handleCloseBtnClick__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.handleSaveBtnClick = function () {
      var _this3;

      return (_this3 = _this).__handleSaveBtnClick__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(InsertModalFooter, [{
    key: '__handleSaveBtnClick__REACT_HOT_LOADER__',
    value: function __handleSaveBtnClick__REACT_HOT_LOADER__() {
      return this.__handleSaveBtnClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleCloseBtnClick__REACT_HOT_LOADER__',
    value: function __handleCloseBtnClick__REACT_HOT_LOADER__() {
      return this.__handleCloseBtnClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleCloseBtnClick__REACT_HOT_LOADER__',
    value: function __handleCloseBtnClick__REACT_HOT_LOADER__(e) {
      var _props = this.props,
          beforeClose = _props.beforeClose,
          onModalClose = _props.onModalClose;

      beforeClose && beforeClose(e);
      onModalClose();
    }
  }, {
    key: '__handleSaveBtnClick__REACT_HOT_LOADER__',
    value: function __handleSaveBtnClick__REACT_HOT_LOADER__(e) {
      var _props2 = this.props,
          beforeSave = _props2.beforeSave,
          onSave = _props2.onSave;

      beforeSave && beforeSave(e);
      onSave();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          className = _props3.className,
          saveBtnText = _props3.saveBtnText,
          closeBtnText = _props3.closeBtnText,
          closeBtnContextual = _props3.closeBtnContextual,
          saveBtnContextual = _props3.saveBtnContextual,
          closeBtnClass = _props3.closeBtnClass,
          saveBtnClass = _props3.saveBtnClass,
          children = _props3.children;


      var content = children || [_react2.default.createElement(
        'button',
        {
          key: 'closeBtn',
          type: 'button',
          className: 'btn ' + closeBtnContextual + ' ' + closeBtnClass,
          onClick: this.handleCloseBtnClick },
        closeBtnText
      ), _react2.default.createElement(
        'button',
        {
          key: 'saveBtn',
          type: 'button',
          className: 'btn ' + saveBtnContextual + ' ' + saveBtnClass,
          onClick: this.handleSaveBtnClick },
        saveBtnText
      )];

      return _react2.default.createElement(
        'div',
        { className: 'modal-footer ' + className },
        content
      );
    }
  }]);

  return InsertModalFooter;
}(_react.Component);

InsertModalFooter.propTypes = {
  className: _propTypes2.default.string,
  saveBtnText: _propTypes2.default.string,
  closeBtnText: _propTypes2.default.string,
  closeBtnContextual: _propTypes2.default.string,
  saveBtnContextual: _propTypes2.default.string,
  closeBtnClass: _propTypes2.default.string,
  saveBtnClass: _propTypes2.default.string,
  beforeClose: _propTypes2.default.func,
  beforeSave: _propTypes2.default.func,
  onSave: _propTypes2.default.func,
  onModalClose: _propTypes2.default.func
};
InsertModalFooter.defaultProps = {
  className: '',
  saveBtnText: _Const2.default.SAVE_BTN_TEXT,
  closeBtnText: _Const2.default.CLOSE_BTN_TEXT,
  closeBtnContextual: 'btn-default btn-secondary',
  saveBtnContextual: 'btn-primary',
  closeBtnClass: '',
  saveBtnClass: '',
  beforeClose: undefined,
  beforeSave: undefined
};

var _default = InsertModalFooter;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(InsertModalFooter, 'InsertModalFooter', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertModalFooter.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertModalFooter.js');
}();

;

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Editor = __webpack_require__(226);

var _Editor2 = _interopRequireDefault(_Editor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/display-name: 0 */


var InsertModalBody = function (_Component) {
  _inherits(InsertModalBody, _Component);

  function InsertModalBody() {
    _classCallCheck(this, InsertModalBody);

    return _possibleConstructorReturn(this, (InsertModalBody.__proto__ || Object.getPrototypeOf(InsertModalBody)).apply(this, arguments));
  }

  _createClass(InsertModalBody, [{
    key: 'getFieldValue',
    value: function getFieldValue() {
      var _this2 = this;

      var newRow = {};
      this.props.columns.forEach(function (column, i) {
        var inputVal = void 0;
        if (column.autoValue) {
          // when you want same auto generate value and not allow edit, example ID field
          var time = new Date().getTime();
          inputVal = typeof column.autoValue === 'function' ? column.autoValue() : 'autovalue-' + time;
        } else if (column.hiddenOnInsert || !column.field) {
          inputVal = '';
        } else {
          var dom = _this2.refs[column.field + i];
          inputVal = dom.value;

          if (column.editable && column.editable.type === 'checkbox') {
            var values = inputVal.split(':');
            inputVal = dom.checked ? values[0] : values[1];
          } else if (column.customInsertEditor) {
            inputVal = inputVal || dom.getFieldValue();
          }
        }
        newRow[column.field] = inputVal;
      }, this);
      return newRow;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          columns = _props.columns,
          validateState = _props.validateState,
          ignoreEditable = _props.ignoreEditable;

      return _react2.default.createElement(
        'div',
        { className: 'modal-body' },
        columns.map(function (column, i) {
          var editable = column.editable,
              format = column.format,
              field = column.field,
              name = column.name,
              autoValue = column.autoValue,
              hiddenOnInsert = column.hiddenOnInsert,
              customInsertEditor = column.customInsertEditor;

          var attr = {
            ref: field + i,
            placeholder: editable.placeholder ? editable.placeholder : name
          };
          var fieldElement = void 0;
          var defaultValue = editable.defaultValue || undefined;
          if (customInsertEditor) {
            var getElement = customInsertEditor.getElement;

            fieldElement = getElement(column, attr, 'form-control', ignoreEditable, defaultValue);
          }

          // fieldElement = false, means to use default editor when enable custom editor
          // Becasuse some users want to have default editor based on some condition.
          if (!customInsertEditor || fieldElement === false) {
            fieldElement = (0, _Editor2.default)(editable, attr, format, '', defaultValue, ignoreEditable);
          }

          if (autoValue || hiddenOnInsert || !column.field) {
            // when you want same auto generate value
            // and not allow edit, for example ID field
            return null;
          }
          var error = validateState[field] ? _react2.default.createElement(
            'span',
            { className: 'help-block bg-danger' },
            validateState[field]
          ) : null;
          return _react2.default.createElement(
            'div',
            { className: 'form-group', key: field },
            _react2.default.createElement(
              'label',
              null,
              name
            ),
            fieldElement,
            error
          );
        })
      );
    }
  }]);

  return InsertModalBody;
}(_react.Component);

InsertModalBody.propTypes = {
  columns: _propTypes2.default.array,
  validateState: _propTypes2.default.object,
  ignoreEditable: _propTypes2.default.bool
};

InsertModalBody.defaultProps = {
  validateState: {},
  ignoreEditable: false
};

var _default = InsertModalBody;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(InsertModalBody, 'InsertModalBody', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertModalBody.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertModalBody.js');
}();

;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Const = __webpack_require__(7);

var _Const2 = _interopRequireDefault(_Const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var insertBtnDefaultClass = 'react-bs-table-add-btn';

var InsertButton = function (_Component) {
  _inherits(InsertButton, _Component);

  function InsertButton() {
    _classCallCheck(this, InsertButton);

    return _possibleConstructorReturn(this, (InsertButton.__proto__ || Object.getPrototypeOf(InsertButton)).apply(this, arguments));
  }

  _createClass(InsertButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          btnContextual = _props.btnContextual,
          className = _props.className,
          onClick = _props.onClick,
          btnGlyphicon = _props.btnGlyphicon,
          btnText = _props.btnText,
          children = _props.children,
          rest = _objectWithoutProperties(_props, ['btnContextual', 'className', 'onClick', 'btnGlyphicon', 'btnText', 'children']);

      var content = children || _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement('i', { className: 'fa glyphicon ' + btnGlyphicon }),
        ' ',
        btnText
      );
      return _react2.default.createElement(
        'button',
        _extends({ type: 'button',
          className: 'btn ' + btnContextual + ' ' + insertBtnDefaultClass + ' ' + className,
          onClick: onClick
        }, rest),
        content
      );
    }
  }]);

  return InsertButton;
}(_react.Component);

InsertButton.propTypes = {
  btnText: _propTypes2.default.string,
  btnContextual: _propTypes2.default.string,
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  btnGlyphicon: _propTypes2.default.string
};
InsertButton.defaultProps = {
  btnText: _Const2.default.INSERT_BTN_TEXT,
  btnContextual: 'btn-info',
  className: '',
  onClick: undefined,
  btnGlyphicon: 'glyphicon-plus fa-plus'
};

var _default = InsertButton;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(insertBtnDefaultClass, 'insertBtnDefaultClass', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertButton.js');

  __REACT_HOT_LOADER__.register(InsertButton, 'InsertButton', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertButton.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertButton.js');
}();

;

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Const = __webpack_require__(7);

var _Const2 = _interopRequireDefault(_Const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var deleteBtnDefaultClass = 'react-bs-table-del-btn';

var DeleteButton = function (_Component) {
  _inherits(DeleteButton, _Component);

  function DeleteButton() {
    _classCallCheck(this, DeleteButton);

    return _possibleConstructorReturn(this, (DeleteButton.__proto__ || Object.getPrototypeOf(DeleteButton)).apply(this, arguments));
  }

  _createClass(DeleteButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          btnContextual = _props.btnContextual,
          className = _props.className,
          onClick = _props.onClick,
          btnGlyphicon = _props.btnGlyphicon,
          btnText = _props.btnText,
          children = _props.children,
          rest = _objectWithoutProperties(_props, ['btnContextual', 'className', 'onClick', 'btnGlyphicon', 'btnText', 'children']);

      var content = children || _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement('i', { className: 'fa glyphicon ' + btnGlyphicon }),
        ' ',
        btnText
      );
      return _react2.default.createElement(
        'button',
        _extends({ type: 'button',
          className: 'btn ' + btnContextual + ' ' + deleteBtnDefaultClass + ' ' + className,
          onClick: onClick
        }, rest),
        content
      );
    }
  }]);

  return DeleteButton;
}(_react.Component);

DeleteButton.propTypes = {
  btnText: _propTypes2.default.string,
  btnContextual: _propTypes2.default.string,
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  btnGlyphicon: _propTypes2.default.string
};
DeleteButton.defaultProps = {
  btnText: _Const2.default.DELETE_BTN_TEXT,
  btnContextual: 'btn-warning',
  className: '',
  onClick: undefined,
  btnGlyphicon: 'glyphicon-trash fa-trash'
};

var _default = DeleteButton;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(deleteBtnDefaultClass, 'deleteBtnDefaultClass', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/DeleteButton.js');

  __REACT_HOT_LOADER__.register(DeleteButton, 'DeleteButton', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/DeleteButton.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/DeleteButton.js');
}();

;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Const = __webpack_require__(7);

var _Const2 = _interopRequireDefault(_Const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var exportCsvBtnDefaultClass = 'react-bs-table-csv-btn';

var ExportCSVButton = function (_Component) {
  _inherits(ExportCSVButton, _Component);

  function ExportCSVButton() {
    _classCallCheck(this, ExportCSVButton);

    return _possibleConstructorReturn(this, (ExportCSVButton.__proto__ || Object.getPrototypeOf(ExportCSVButton)).apply(this, arguments));
  }

  _createClass(ExportCSVButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          btnContextual = _props.btnContextual,
          className = _props.className,
          onClick = _props.onClick,
          btnGlyphicon = _props.btnGlyphicon,
          btnText = _props.btnText,
          children = _props.children,
          rest = _objectWithoutProperties(_props, ['btnContextual', 'className', 'onClick', 'btnGlyphicon', 'btnText', 'children']);

      var content = children || _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement('i', { className: 'fa glyphicon ' + btnGlyphicon }),
        ' ',
        btnText
      );
      return _react2.default.createElement(
        'button',
        _extends({ type: 'button',
          className: 'btn ' + btnContextual + ' ' + exportCsvBtnDefaultClass + ' ' + className + ' hidden-print',
          onClick: onClick
        }, rest),
        content
      );
    }
  }]);

  return ExportCSVButton;
}(_react.Component);

ExportCSVButton.propTypes = {
  btnText: _propTypes2.default.string,
  btnContextual: _propTypes2.default.string,
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  btnGlyphicon: _propTypes2.default.string
};
ExportCSVButton.defaultProps = {
  btnText: _Const2.default.EXPORT_CSV_TEXT,
  btnContextual: 'btn-success',
  className: '',
  onClick: undefined,
  btnGlyphicon: 'glyphicon-export fa-download'
};

var _default = ExportCSVButton;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(exportCsvBtnDefaultClass, 'exportCsvBtnDefaultClass', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ExportCSVButton.js');

  __REACT_HOT_LOADER__.register(ExportCSVButton, 'ExportCSVButton', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ExportCSVButton.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ExportCSVButton.js');
}();

;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Const = __webpack_require__(7);

var _Const2 = _interopRequireDefault(_Const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var showSelectedOnlyBtnDefaultClass = 'react-bs-table-show-sel-only-btn';

var ShowSelectedOnlyButton = function (_Component) {
  _inherits(ShowSelectedOnlyButton, _Component);

  function ShowSelectedOnlyButton() {
    _classCallCheck(this, ShowSelectedOnlyButton);

    return _possibleConstructorReturn(this, (ShowSelectedOnlyButton.__proto__ || Object.getPrototypeOf(ShowSelectedOnlyButton)).apply(this, arguments));
  }

  _createClass(ShowSelectedOnlyButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          btnContextual = _props.btnContextual,
          className = _props.className,
          onClick = _props.onClick,
          toggle = _props.toggle,
          showAllText = _props.showAllText,
          showOnlySelectText = _props.showOnlySelectText,
          children = _props.children,
          rest = _objectWithoutProperties(_props, ['btnContextual', 'className', 'onClick', 'toggle', 'showAllText', 'showOnlySelectText', 'children']);

      var content = children || _react2.default.createElement(
        'span',
        null,
        toggle ? showAllText : showOnlySelectText
      );
      return _react2.default.createElement(
        'button',
        _extends({ type: 'button',
          'aria-pressed': 'false',
          'data-toggle': 'button',
          className: 'btn ' + btnContextual + ' ' + showSelectedOnlyBtnDefaultClass + ' ' + className,
          onClick: onClick
        }, rest),
        content
      );
    }
  }]);

  return ShowSelectedOnlyButton;
}(_react.Component);

ShowSelectedOnlyButton.propTypes = {
  showAllText: _propTypes2.default.string,
  showOnlySelectText: _propTypes2.default.string,
  toggle: _propTypes2.default.bool,
  btnContextual: _propTypes2.default.string,
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func
};
ShowSelectedOnlyButton.defaultProps = {
  showAllText: _Const2.default.SHOW_ALL,
  showOnlySelectText: _Const2.default.SHOW_ONLY_SELECT,
  toggle: false,
  btnContextual: 'btn-primary',
  className: '',
  onClick: undefined
};

var _default = ShowSelectedOnlyButton;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(showSelectedOnlyBtnDefaultClass, 'showSelectedOnlyBtnDefaultClass', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ShowSelectedOnlyButton.js');

  __REACT_HOT_LOADER__.register(ShowSelectedOnlyButton, 'ShowSelectedOnlyButton', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ShowSelectedOnlyButton.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ShowSelectedOnlyButton.js');
}();

;

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(22);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchField = function (_Component) {
  _inherits(SearchField, _Component);

  function SearchField() {
    _classCallCheck(this, SearchField);

    return _possibleConstructorReturn(this, (SearchField.__proto__ || Object.getPrototypeOf(SearchField)).apply(this, arguments));
  }

  _createClass(SearchField, [{
    key: 'getValue',
    value: function getValue() {
      return _reactDom2.default.findDOMNode(this).value;
    }
  }, {
    key: 'setValue',
    value: function setValue(value) {
      _reactDom2.default.findDOMNode(this).value = value;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          defaultValue = _props.defaultValue,
          placeholder = _props.placeholder,
          onKeyUp = _props.onKeyUp,
          rest = _objectWithoutProperties(_props, ['className', 'defaultValue', 'placeholder', 'onKeyUp']);

      return _react2.default.createElement('input', _extends({
        className: 'form-control ' + className,
        type: 'text',
        defaultValue: defaultValue,
        placeholder: placeholder || SearchField.defaultProps.placeholder,
        onKeyUp: onKeyUp,
        style: { zIndex: 0 }
      }, rest));
    }
  }]);

  return SearchField;
}(_react.Component);

SearchField.propTypes = {
  className: _propTypes2.default.string,
  defaultValue: _propTypes2.default.string,
  placeholder: _propTypes2.default.string,
  onKeyUp: _propTypes2.default.func
};
SearchField.defaultProps = {
  className: '',
  defaultValue: '',
  placeholder: 'Search',
  onKeyUp: undefined
};

var _default = SearchField;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SearchField, 'SearchField', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/SearchField.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/SearchField.js');
}();

;

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var clearBtnDefaultClass = 'react-bs-table-search-clear-btn';

var ClearSearchButton = function (_Component) {
  _inherits(ClearSearchButton, _Component);

  function ClearSearchButton() {
    _classCallCheck(this, ClearSearchButton);

    return _possibleConstructorReturn(this, (ClearSearchButton.__proto__ || Object.getPrototypeOf(ClearSearchButton)).apply(this, arguments));
  }

  _createClass(ClearSearchButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          btnContextual = _props.btnContextual,
          className = _props.className,
          onClick = _props.onClick,
          btnText = _props.btnText,
          children = _props.children,
          rest = _objectWithoutProperties(_props, ['btnContextual', 'className', 'onClick', 'btnText', 'children']);

      var content = children || _react2.default.createElement(
        'span',
        null,
        btnText
      );
      return _react2.default.createElement(
        'button',
        _extends({
          className: 'btn ' + btnContextual + ' ' + className + ' ' + clearBtnDefaultClass,
          type: 'button',
          onClick: onClick
        }, rest),
        content
      );
    }
  }]);

  return ClearSearchButton;
}(_react.Component);

ClearSearchButton.propTypes = {
  btnContextual: _propTypes2.default.string,
  className: _propTypes2.default.string,
  btnText: _propTypes2.default.string,
  onClick: _propTypes2.default.func
};
ClearSearchButton.defaultProps = {
  btnContextual: 'btn-default btn-secondary',
  className: '',
  btnText: 'Clear',
  onClick: undefined
};

var _default = ClearSearchButton;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(clearBtnDefaultClass, 'clearBtnDefaultClass', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ClearSearchButton.js');

  __REACT_HOT_LOADER__.register(ClearSearchButton, 'ClearSearchButton', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ClearSearchButton.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ClearSearchButton.js');
}();

;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(243);
module.exports = __webpack_require__(248);


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(244).enable();
  window.Promise = __webpack_require__(246);
}

// fetch() polyfill for making API calls.
__webpack_require__(247);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(85);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(129);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(84)))

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(129);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 247 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__registerServiceWorker__ = __webpack_require__(611);
__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */],null),document.getElementById('root'));Object(__WEBPACK_IMPORTED_MODULE_4__registerServiceWorker__["a" /* default */])();

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.2.0
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var m=__webpack_require__(85),n=__webpack_require__(130),p=__webpack_require__(60),q="function"===typeof Symbol&&Symbol["for"],r=q?Symbol["for"]("react.element"):60103,t=q?Symbol["for"]("react.call"):60104,u=q?Symbol["for"]("react.return"):60105,v=q?Symbol["for"]("react.portal"):60106,w=q?Symbol["for"]("react.fragment"):60107,x="function"===typeof Symbol&&Symbol.iterator;
function y(a){for(var b=arguments.length-1,e="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,c=0;c<b;c++)e+="\x26args[]\x3d"+encodeURIComponent(arguments[c+1]);b=Error(e+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}
var z={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function A(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}A.prototype.isReactComponent={};A.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?y("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};A.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function B(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}function C(){}C.prototype=A.prototype;var D=B.prototype=new C;D.constructor=B;m(D,A.prototype);D.isPureReactComponent=!0;function E(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}var F=E.prototype=new C;F.constructor=E;m(F,A.prototype);F.unstable_isAsyncReactComponent=!0;F.render=function(){return this.props.children};var G={current:null},H=Object.prototype.hasOwnProperty,I={key:!0,ref:!0,__self:!0,__source:!0};
function J(a,b,e){var c,d={},g=null,k=null;if(null!=b)for(c in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)H.call(b,c)&&!I.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var h=Array(f),l=0;l<f;l++)h[l]=arguments[l+2];d.children=h}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:r,type:a,key:g,ref:k,props:d,_owner:G.current}}function K(a){return"object"===typeof a&&null!==a&&a.$$typeof===r}
function escape(a){var b={"\x3d":"\x3d0",":":"\x3d2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var L=/\/+/g,M=[];function N(a,b,e,c){if(M.length){var d=M.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function O(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>M.length&&M.push(a)}
function P(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case r:case t:case u:case v:g=!0}}if(g)return e(c,a,""===b?"."+Q(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+Q(d,k);g+=P(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=x&&a[x]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=
f.call(a),k=0;!(d=a.next()).done;)d=d.value,f=b+Q(d,k++),g+=P(d,f,e,c);else"object"===d&&(e=""+a,y("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function Q(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function R(a,b){a.func.call(a.context,b,a.count++)}
function S(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?T(a,c,e,p.thatReturnsArgument):null!=a&&(K(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(L,"$\x26/")+"/")+e,a={$$typeof:r,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function T(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(L,"$\x26/")+"/");b=N(b,g,c,d);null==a||P(a,"",S,b);O(b)}
var U={Children:{map:function(a,b,e){if(null==a)return a;var c=[];T(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=N(null,null,b,e);null==a||P(a,"",R,b);O(b)},count:function(a){return null==a?0:P(a,"",p.thatReturnsNull,null)},toArray:function(a){var b=[];T(a,b,null,p.thatReturnsArgument);return b},only:function(a){K(a)?void 0:y("143");return a}},Component:A,PureComponent:B,unstable_AsyncComponent:E,Fragment:w,createElement:J,cloneElement:function(a,b,e){var c=m({},a.props),
d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=G.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)H.call(b,h)&&!I.hasOwnProperty(h)&&(c[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)c.children=e;else if(1<h){f=Array(h);for(var l=0;l<h;l++)f[l]=arguments[l+2];c.children=f}return{$$typeof:r,type:a.type,key:d,ref:g,props:c,_owner:k}},createFactory:function(a){var b=J.bind(null,a);b.type=a;return b},
isValidElement:K,version:"16.2.0",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:G,assign:m}},V=Object.freeze({default:U}),W=V&&U||V;module.exports=W["default"]?W["default"]:W;


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.2.0
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),l=__webpack_require__(251),B=__webpack_require__(85),C=__webpack_require__(60),ba=__webpack_require__(252),da=__webpack_require__(253),ea=__webpack_require__(254),fa=__webpack_require__(255),ia=__webpack_require__(258),D=__webpack_require__(130);
function E(a){for(var b=arguments.length-1,c="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,d=0;d<b;d++)c+="\x26args[]\x3d"+encodeURIComponent(arguments[d+1]);b=Error(c+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}aa?void 0:E("227");
var oa={children:!0,dangerouslySetInnerHTML:!0,defaultValue:!0,defaultChecked:!0,innerHTML:!0,suppressContentEditableWarning:!0,suppressHydrationWarning:!0,style:!0};function pa(a,b){return(a&b)===b}
var ta={MUST_USE_PROPERTY:1,HAS_BOOLEAN_VALUE:4,HAS_NUMERIC_VALUE:8,HAS_POSITIVE_NUMERIC_VALUE:24,HAS_OVERLOADED_BOOLEAN_VALUE:32,HAS_STRING_BOOLEAN_VALUE:64,injectDOMPropertyConfig:function(a){var b=ta,c=a.Properties||{},d=a.DOMAttributeNamespaces||{},e=a.DOMAttributeNames||{};a=a.DOMMutationMethods||{};for(var f in c){ua.hasOwnProperty(f)?E("48",f):void 0;var g=f.toLowerCase(),h=c[f];g={attributeName:g,attributeNamespace:null,propertyName:f,mutationMethod:null,mustUseProperty:pa(h,b.MUST_USE_PROPERTY),
hasBooleanValue:pa(h,b.HAS_BOOLEAN_VALUE),hasNumericValue:pa(h,b.HAS_NUMERIC_VALUE),hasPositiveNumericValue:pa(h,b.HAS_POSITIVE_NUMERIC_VALUE),hasOverloadedBooleanValue:pa(h,b.HAS_OVERLOADED_BOOLEAN_VALUE),hasStringBooleanValue:pa(h,b.HAS_STRING_BOOLEAN_VALUE)};1>=g.hasBooleanValue+g.hasNumericValue+g.hasOverloadedBooleanValue?void 0:E("50",f);e.hasOwnProperty(f)&&(g.attributeName=e[f]);d.hasOwnProperty(f)&&(g.attributeNamespace=d[f]);a.hasOwnProperty(f)&&(g.mutationMethod=a[f]);ua[f]=g}}},ua={};
function va(a,b){if(oa.hasOwnProperty(a)||2<a.length&&("o"===a[0]||"O"===a[0])&&("n"===a[1]||"N"===a[1]))return!1;if(null===b)return!0;switch(typeof b){case "boolean":return oa.hasOwnProperty(a)?a=!0:(b=wa(a))?a=b.hasBooleanValue||b.hasStringBooleanValue||b.hasOverloadedBooleanValue:(a=a.toLowerCase().slice(0,5),a="data-"===a||"aria-"===a),a;case "undefined":case "number":case "string":case "object":return!0;default:return!1}}function wa(a){return ua.hasOwnProperty(a)?ua[a]:null}
var xa=ta,ya=xa.MUST_USE_PROPERTY,K=xa.HAS_BOOLEAN_VALUE,za=xa.HAS_NUMERIC_VALUE,Aa=xa.HAS_POSITIVE_NUMERIC_VALUE,Ba=xa.HAS_OVERLOADED_BOOLEAN_VALUE,Ca=xa.HAS_STRING_BOOLEAN_VALUE,Da={Properties:{allowFullScreen:K,async:K,autoFocus:K,autoPlay:K,capture:Ba,checked:ya|K,cols:Aa,contentEditable:Ca,controls:K,"default":K,defer:K,disabled:K,download:Ba,draggable:Ca,formNoValidate:K,hidden:K,loop:K,multiple:ya|K,muted:ya|K,noValidate:K,open:K,playsInline:K,readOnly:K,required:K,reversed:K,rows:Aa,rowSpan:za,
scoped:K,seamless:K,selected:ya|K,size:Aa,start:za,span:Aa,spellCheck:Ca,style:0,tabIndex:0,itemScope:K,acceptCharset:0,className:0,htmlFor:0,httpEquiv:0,value:Ca},DOMAttributeNames:{acceptCharset:"accept-charset",className:"class",htmlFor:"for",httpEquiv:"http-equiv"},DOMMutationMethods:{value:function(a,b){if(null==b)return a.removeAttribute("value");"number"!==a.type||!1===a.hasAttribute("value")?a.setAttribute("value",""+b):a.validity&&!a.validity.badInput&&a.ownerDocument.activeElement!==a&&
a.setAttribute("value",""+b)}}},Ea=xa.HAS_STRING_BOOLEAN_VALUE,M={xlink:"http://www.w3.org/1999/xlink",xml:"http://www.w3.org/XML/1998/namespace"},Ga={Properties:{autoReverse:Ea,externalResourcesRequired:Ea,preserveAlpha:Ea},DOMAttributeNames:{autoReverse:"autoReverse",externalResourcesRequired:"externalResourcesRequired",preserveAlpha:"preserveAlpha"},DOMAttributeNamespaces:{xlinkActuate:M.xlink,xlinkArcrole:M.xlink,xlinkHref:M.xlink,xlinkRole:M.xlink,xlinkShow:M.xlink,xlinkTitle:M.xlink,xlinkType:M.xlink,
xmlBase:M.xml,xmlLang:M.xml,xmlSpace:M.xml}},Ha=/[\-\:]([a-z])/g;function Ia(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode x-height xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type xml:base xmlns:xlink xml:lang xml:space".split(" ").forEach(function(a){var b=a.replace(Ha,
Ia);Ga.Properties[b]=0;Ga.DOMAttributeNames[b]=a});xa.injectDOMPropertyConfig(Da);xa.injectDOMPropertyConfig(Ga);
var P={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,injection:{injectErrorUtils:function(a){"function"!==typeof a.invokeGuardedCallback?E("197"):void 0;Ja=a.invokeGuardedCallback}},invokeGuardedCallback:function(a,b,c,d,e,f,g,h,k){Ja.apply(P,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,g,h,k){P.invokeGuardedCallback.apply(this,arguments);if(P.hasCaughtError()){var q=P.clearCaughtError();P._hasRethrowError||(P._hasRethrowError=!0,P._rethrowError=
q)}},rethrowCaughtError:function(){return Ka.apply(P,arguments)},hasCaughtError:function(){return P._hasCaughtError},clearCaughtError:function(){if(P._hasCaughtError){var a=P._caughtError;P._caughtError=null;P._hasCaughtError=!1;return a}E("198")}};function Ja(a,b,c,d,e,f,g,h,k){P._hasCaughtError=!1;P._caughtError=null;var q=Array.prototype.slice.call(arguments,3);try{b.apply(c,q)}catch(v){P._caughtError=v,P._hasCaughtError=!0}}
function Ka(){if(P._hasRethrowError){var a=P._rethrowError;P._rethrowError=null;P._hasRethrowError=!1;throw a;}}var La=null,Ma={};
function Na(){if(La)for(var a in Ma){var b=Ma[a],c=La.indexOf(a);-1<c?void 0:E("96",a);if(!Oa[c]){b.extractEvents?void 0:E("97",a);Oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;Pa.hasOwnProperty(h)?E("99",h):void 0;Pa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&Qa(k[e],g,h);e=!0}else f.registrationName?(Qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:E("98",d,a)}}}}
function Qa(a,b,c){Ra[a]?E("100",a):void 0;Ra[a]=b;Sa[a]=b.eventTypes[c].dependencies}var Oa=[],Pa={},Ra={},Sa={};function Ta(a){La?E("101"):void 0;La=Array.prototype.slice.call(a);Na()}function Ua(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];Ma.hasOwnProperty(c)&&Ma[c]===d||(Ma[c]?E("102",c):void 0,Ma[c]=d,b=!0)}b&&Na()}
var Va=Object.freeze({plugins:Oa,eventNameDispatchConfigs:Pa,registrationNameModules:Ra,registrationNameDependencies:Sa,possibleRegistrationNames:null,injectEventPluginOrder:Ta,injectEventPluginsByName:Ua}),Wa=null,Xa=null,Ya=null;function Za(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=Ya(d);P.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
function $a(a,b){null==b?E("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function ab(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var bb=null;
function cb(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)Za(a,b,c[e],d[e]);else c&&Za(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function db(a){return cb(a,!0)}function gb(a){return cb(a,!1)}var hb={injectEventPluginOrder:Ta,injectEventPluginsByName:Ua};
function ib(a,b){var c=a.stateNode;if(!c)return null;var d=Wa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?E("231",b,typeof c):void 0;
return c}function jb(a,b,c,d){for(var e,f=0;f<Oa.length;f++){var g=Oa[f];g&&(g=g.extractEvents(a,b,c,d))&&(e=$a(e,g))}return e}function kb(a){a&&(bb=$a(bb,a))}function lb(a){var b=bb;bb=null;b&&(a?ab(b,db):ab(b,gb),bb?E("95"):void 0,P.rethrowCaughtError())}var mb=Object.freeze({injection:hb,getListener:ib,extractEvents:jb,enqueueEvents:kb,processEventQueue:lb}),nb=Math.random().toString(36).slice(2),Q="__reactInternalInstance$"+nb,ob="__reactEventHandlers$"+nb;
function pb(a){if(a[Q])return a[Q];for(var b=[];!a[Q];)if(b.push(a),a.parentNode)a=a.parentNode;else return null;var c=void 0,d=a[Q];if(5===d.tag||6===d.tag)return d;for(;a&&(d=a[Q]);a=b.pop())c=d;return c}function qb(a){if(5===a.tag||6===a.tag)return a.stateNode;E("33")}function rb(a){return a[ob]||null}
var sb=Object.freeze({precacheFiberNode:function(a,b){b[Q]=a},getClosestInstanceFromNode:pb,getInstanceFromNode:function(a){a=a[Q];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:qb,getFiberCurrentPropsFromNode:rb,updateFiberProps:function(a,b){a[ob]=b}});function tb(a){do a=a["return"];while(a&&5!==a.tag);return a?a:null}function ub(a,b,c){for(var d=[];a;)d.push(a),a=tb(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}
function vb(a,b,c){if(b=ib(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=$a(c._dispatchListeners,b),c._dispatchInstances=$a(c._dispatchInstances,a)}function wb(a){a&&a.dispatchConfig.phasedRegistrationNames&&ub(a._targetInst,vb,a)}function xb(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?tb(b):null;ub(b,vb,a)}}
function yb(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=ib(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=$a(c._dispatchListeners,b),c._dispatchInstances=$a(c._dispatchInstances,a))}function zb(a){a&&a.dispatchConfig.registrationName&&yb(a._targetInst,null,a)}function Ab(a){ab(a,wb)}
function Bb(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,g=0,h=e;h;h=tb(h))g++;h=0;for(var k=f;k;k=tb(k))h++;for(;0<g-h;)e=tb(e),g--;for(;0<h-g;)f=tb(f),h--;for(;g--;){if(e===f||e===f.alternate)break a;e=tb(e);f=tb(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){g=c.alternate;if(null!==g&&g===f)break;e.push(c);c=tb(c)}for(c=[];d&&d!==f;){g=d.alternate;if(null!==g&&g===f)break;c.push(d);d=tb(d)}for(d=0;d<e.length;d++)yb(e[d],"bubbled",a);for(a=c.length;0<a--;)yb(c[a],"captured",b)}
var Cb=Object.freeze({accumulateTwoPhaseDispatches:Ab,accumulateTwoPhaseDispatchesSkipTarget:function(a){ab(a,xb)},accumulateEnterLeaveDispatches:Bb,accumulateDirectDispatches:function(a){ab(a,zb)}}),Db=null;function Eb(){!Db&&l.canUseDOM&&(Db="textContent"in document.documentElement?"textContent":"innerText");return Db}var S={_root:null,_startText:null,_fallbackText:null};
function Fb(){if(S._fallbackText)return S._fallbackText;var a,b=S._startText,c=b.length,d,e=Gb(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);S._fallbackText=e.slice(a,1<d?1-d:void 0);return S._fallbackText}function Gb(){return"value"in S._root?S._root.value:S._root[Eb()]}
var Hb="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),Ib={type:null,target:null,currentTarget:C.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function T(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?C.thatReturnsTrue:C.thatReturnsFalse;this.isPropagationStopped=C.thatReturnsFalse;return this}
B(T.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=C.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=C.thatReturnsTrue)},persist:function(){this.isPersistent=C.thatReturnsTrue},isPersistent:C.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<Hb.length;a++)this[Hb[a]]=null}});T.Interface=Ib;T.augmentClass=function(a,b){function c(){}c.prototype=this.prototype;var d=new c;B(d,a.prototype);a.prototype=d;a.prototype.constructor=a;a.Interface=B({},this.Interface,b);a.augmentClass=this.augmentClass;Jb(a)};Jb(T);function Kb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function Lb(a){a instanceof this?void 0:E("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function Jb(a){a.eventPool=[];a.getPooled=Kb;a.release=Lb}function Mb(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Mb,{data:null});function Nb(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Nb,{data:null});var Pb=[9,13,27,32],Vb=l.canUseDOM&&"CompositionEvent"in window,Wb=null;l.canUseDOM&&"documentMode"in document&&(Wb=document.documentMode);var Xb;
if(Xb=l.canUseDOM&&"TextEvent"in window&&!Wb){var Yb=window.opera;Xb=!("object"===typeof Yb&&"function"===typeof Yb.version&&12>=parseInt(Yb.version(),10))}
var Zb=Xb,$b=l.canUseDOM&&(!Vb||Wb&&8<Wb&&11>=Wb),ac=String.fromCharCode(32),bc={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["topCompositionEnd","topKeyPress","topTextInput","topPaste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"topBlur topCompositionEnd topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"topBlur topCompositionStart topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"topBlur topCompositionUpdate topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")}},cc=!1;
function dc(a,b){switch(a){case "topKeyUp":return-1!==Pb.indexOf(b.keyCode);case "topKeyDown":return 229!==b.keyCode;case "topKeyPress":case "topMouseDown":case "topBlur":return!0;default:return!1}}function ec(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var fc=!1;function gc(a,b){switch(a){case "topCompositionEnd":return ec(b);case "topKeyPress":if(32!==b.which)return null;cc=!0;return ac;case "topTextInput":return a=b.data,a===ac&&cc?null:a;default:return null}}
function hc(a,b){if(fc)return"topCompositionEnd"===a||!Vb&&dc(a,b)?(a=Fb(),S._root=null,S._startText=null,S._fallbackText=null,fc=!1,a):null;switch(a){case "topPaste":return null;case "topKeyPress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "topCompositionEnd":return $b?null:b.data;default:return null}}
var ic={eventTypes:bc,extractEvents:function(a,b,c,d){var e;if(Vb)b:{switch(a){case "topCompositionStart":var f=bc.compositionStart;break b;case "topCompositionEnd":f=bc.compositionEnd;break b;case "topCompositionUpdate":f=bc.compositionUpdate;break b}f=void 0}else fc?dc(a,c)&&(f=bc.compositionEnd):"topKeyDown"===a&&229===c.keyCode&&(f=bc.compositionStart);f?($b&&(fc||f!==bc.compositionStart?f===bc.compositionEnd&&fc&&(e=Fb()):(S._root=d,S._startText=Gb(),fc=!0)),f=Mb.getPooled(f,b,c,d),e?f.data=
e:(e=ec(c),null!==e&&(f.data=e)),Ab(f),e=f):e=null;(a=Zb?gc(a,c):hc(a,c))?(b=Nb.getPooled(bc.beforeInput,b,c,d),b.data=a,Ab(b)):b=null;return[e,b]}},jc=null,kc=null,lc=null;function mc(a){if(a=Xa(a)){jc&&"function"===typeof jc.restoreControlledState?void 0:E("194");var b=Wa(a.stateNode);jc.restoreControlledState(a.stateNode,a.type,b)}}var nc={injectFiberControlledHostComponent:function(a){jc=a}};function oc(a){kc?lc?lc.push(a):lc=[a]:kc=a}
function pc(){if(kc){var a=kc,b=lc;lc=kc=null;mc(a);if(b)for(a=0;a<b.length;a++)mc(b[a])}}var qc=Object.freeze({injection:nc,enqueueStateRestore:oc,restoreStateIfNeeded:pc});function rc(a,b){return a(b)}var sc=!1;function tc(a,b){if(sc)return rc(a,b);sc=!0;try{return rc(a,b)}finally{sc=!1,pc()}}var uc={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};
function vc(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!uc[a.type]:"textarea"===b?!0:!1}function wc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}var xc;l.canUseDOM&&(xc=document.implementation&&document.implementation.hasFeature&&!0!==document.implementation.hasFeature("",""));
function yc(a,b){if(!l.canUseDOM||b&&!("addEventListener"in document))return!1;b="on"+a;var c=b in document;c||(c=document.createElement("div"),c.setAttribute(b,"return;"),c="function"===typeof c[b]);!c&&xc&&"wheel"===a&&(c=document.implementation.hasFeature("Events.wheel","3.0"));return c}function zc(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Ac(a){var b=zc(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"function"===typeof c.get&&"function"===typeof c.set)return Object.defineProperty(a,b,{enumerable:c.enumerable,configurable:!0,get:function(){return c.get.call(this)},set:function(a){d=""+a;c.set.call(this,a)}}),{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=null;delete a[b]}}}
function Bc(a){a._valueTracker||(a._valueTracker=Ac(a))}function Cc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=zc(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}var Dc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"topBlur topChange topClick topFocus topInput topKeyDown topKeyUp topSelectionChange".split(" ")}};
function Ec(a,b,c){a=T.getPooled(Dc.change,a,b,c);a.type="change";oc(c);Ab(a);return a}var Fc=null,Gc=null;function Hc(a){kb(a);lb(!1)}function Ic(a){var b=qb(a);if(Cc(b))return a}function Jc(a,b){if("topChange"===a)return b}var Kc=!1;l.canUseDOM&&(Kc=yc("input")&&(!document.documentMode||9<document.documentMode));function Lc(){Fc&&(Fc.detachEvent("onpropertychange",Mc),Gc=Fc=null)}function Mc(a){"value"===a.propertyName&&Ic(Gc)&&(a=Ec(Gc,a,wc(a)),tc(Hc,a))}
function Nc(a,b,c){"topFocus"===a?(Lc(),Fc=b,Gc=c,Fc.attachEvent("onpropertychange",Mc)):"topBlur"===a&&Lc()}function Oc(a){if("topSelectionChange"===a||"topKeyUp"===a||"topKeyDown"===a)return Ic(Gc)}function Pc(a,b){if("topClick"===a)return Ic(b)}function $c(a,b){if("topInput"===a||"topChange"===a)return Ic(b)}
var ad={eventTypes:Dc,_isInputEventSupported:Kc,extractEvents:function(a,b,c,d){var e=b?qb(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Jc;else if(vc(e))if(Kc)g=$c;else{g=Oc;var h=Nc}else f=e.nodeName,!f||"input"!==f.toLowerCase()||"checkbox"!==e.type&&"radio"!==e.type||(g=Pc);if(g&&(g=g(a,b)))return Ec(g,c,d);h&&h(a,e,b);"topBlur"===a&&null!=b&&(a=b._wrapperState||e._wrapperState)&&a.controlled&&"number"===e.type&&(a=""+e.value,e.getAttribute("value")!==
a&&e.setAttribute("value",a))}};function bd(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(bd,{view:null,detail:null});var cd={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function dd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=cd[a])?!!b[a]:!1}function ed(){return dd}function fd(a,b,c,d){return T.call(this,a,b,c,d)}
bd.augmentClass(fd,{screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:ed,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}});
var gd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["topMouseOut","topMouseOver"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["topMouseOut","topMouseOver"]}},hd={eventTypes:gd,extractEvents:function(a,b,c,d){if("topMouseOver"===a&&(c.relatedTarget||c.fromElement)||"topMouseOut"!==a&&"topMouseOver"!==a)return null;var e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;"topMouseOut"===a?(a=b,b=(b=c.relatedTarget||c.toElement)?pb(b):null):a=null;if(a===
b)return null;var f=null==a?e:qb(a);e=null==b?e:qb(b);var g=fd.getPooled(gd.mouseLeave,a,c,d);g.type="mouseleave";g.target=f;g.relatedTarget=e;c=fd.getPooled(gd.mouseEnter,b,c,d);c.type="mouseenter";c.target=e;c.relatedTarget=f;Bb(g,c,a,b);return[g,c]}},id=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner;function jd(a){a=a.type;return"string"===typeof a?a:"function"===typeof a?a.displayName||a.name:null}
function kd(a){var b=a;if(a.alternate)for(;b["return"];)b=b["return"];else{if(0!==(b.effectTag&2))return 1;for(;b["return"];)if(b=b["return"],0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function ld(a){return(a=a._reactInternalFiber)?2===kd(a):!1}function md(a){2!==kd(a)?E("188"):void 0}
function nd(a){var b=a.alternate;if(!b)return b=kd(a),3===b?E("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c["return"],f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return md(e),a;if(g===d)return md(e),b;g=g.sibling}E("188")}if(c["return"]!==d["return"])c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:E("189")}}c.alternate!==d?E("190"):void 0}3!==c.tag?E("188"):void 0;return c.stateNode.current===c?a:b}function od(a){a=nd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}
function pd(a){a=nd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}var qd=[];
function rd(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c["return"];)c=c["return"];c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=pb(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],sd(a.topLevelType,b,a.nativeEvent,wc(a.nativeEvent))}var td=!0,sd=void 0;function ud(a){td=!!a}function U(a,b,c){return c?ba.listen(c,b,vd.bind(null,a)):null}function wd(a,b,c){return c?ba.capture(c,b,vd.bind(null,a)):null}
function vd(a,b){if(td){var c=wc(b);c=pb(c);null===c||"number"!==typeof c.tag||2===kd(c)||(c=null);if(qd.length){var d=qd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{tc(rd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>qd.length&&qd.push(a)}}}
var xd=Object.freeze({get _enabled(){return td},get _handleTopLevel(){return sd},setHandleTopLevel:function(a){sd=a},setEnabled:ud,isEnabled:function(){return td},trapBubbledEvent:U,trapCapturedEvent:wd,dispatchEvent:vd});function yd(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
var zd={animationend:yd("Animation","AnimationEnd"),animationiteration:yd("Animation","AnimationIteration"),animationstart:yd("Animation","AnimationStart"),transitionend:yd("Transition","TransitionEnd")},Ad={},Bd={};l.canUseDOM&&(Bd=document.createElement("div").style,"AnimationEvent"in window||(delete zd.animationend.animation,delete zd.animationiteration.animation,delete zd.animationstart.animation),"TransitionEvent"in window||delete zd.transitionend.transition);
function Cd(a){if(Ad[a])return Ad[a];if(!zd[a])return a;var b=zd[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Bd)return Ad[a]=b[c];return""}
var Dd={topAbort:"abort",topAnimationEnd:Cd("animationend")||"animationend",topAnimationIteration:Cd("animationiteration")||"animationiteration",topAnimationStart:Cd("animationstart")||"animationstart",topBlur:"blur",topCancel:"cancel",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topChange:"change",topClick:"click",topClose:"close",topCompositionEnd:"compositionend",topCompositionStart:"compositionstart",topCompositionUpdate:"compositionupdate",topContextMenu:"contextmenu",topCopy:"copy",
topCut:"cut",topDoubleClick:"dblclick",topDrag:"drag",topDragEnd:"dragend",topDragEnter:"dragenter",topDragExit:"dragexit",topDragLeave:"dragleave",topDragOver:"dragover",topDragStart:"dragstart",topDrop:"drop",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topFocus:"focus",topInput:"input",topKeyDown:"keydown",topKeyPress:"keypress",topKeyUp:"keyup",topLoadedData:"loadeddata",topLoad:"load",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",
topMouseDown:"mousedown",topMouseMove:"mousemove",topMouseOut:"mouseout",topMouseOver:"mouseover",topMouseUp:"mouseup",topPaste:"paste",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topScroll:"scroll",topSeeked:"seeked",topSeeking:"seeking",topSelectionChange:"selectionchange",topStalled:"stalled",topSuspend:"suspend",topTextInput:"textInput",topTimeUpdate:"timeupdate",topToggle:"toggle",topTouchCancel:"touchcancel",topTouchEnd:"touchend",topTouchMove:"touchmove",
topTouchStart:"touchstart",topTransitionEnd:Cd("transitionend")||"transitionend",topVolumeChange:"volumechange",topWaiting:"waiting",topWheel:"wheel"},Ed={},Fd=0,Gd="_reactListenersID"+(""+Math.random()).slice(2);function Hd(a){Object.prototype.hasOwnProperty.call(a,Gd)||(a[Gd]=Fd++,Ed[a[Gd]]={});return Ed[a[Gd]]}function Id(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Jd(a,b){var c=Id(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Id(c)}}function Kd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&"text"===a.type||"textarea"===b||"true"===a.contentEditable)}
var Ld=l.canUseDOM&&"documentMode"in document&&11>=document.documentMode,Md={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"topBlur topContextMenu topFocus topKeyDown topKeyUp topMouseDown topMouseUp topSelectionChange".split(" ")}},Nd=null,Od=null,Pd=null,Qd=!1;
function Rd(a,b){if(Qd||null==Nd||Nd!==da())return null;var c=Nd;"selectionStart"in c&&Kd(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return Pd&&ea(Pd,c)?null:(Pd=c,a=T.getPooled(Md.select,Od,a,b),a.type="select",a.target=Nd,Ab(a),a)}
var Sd={eventTypes:Md,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Hd(e);f=Sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?qb(b):window;switch(a){case "topFocus":if(vc(e)||"true"===e.contentEditable)Nd=e,Od=b,Pd=null;break;case "topBlur":Pd=Od=Nd=null;break;case "topMouseDown":Qd=!0;break;case "topContextMenu":case "topMouseUp":return Qd=!1,Rd(c,d);case "topSelectionChange":if(Ld)break;
case "topKeyDown":case "topKeyUp":return Rd(c,d)}return null}};function Td(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Td,{animationName:null,elapsedTime:null,pseudoElement:null});function Ud(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Ud,{clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}});function Vd(a,b,c,d){return T.call(this,a,b,c,d)}bd.augmentClass(Vd,{relatedTarget:null});
function Wd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;return 32<=a||13===a?a:0}
var Xd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Yd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"};function Zd(a,b,c,d){return T.call(this,a,b,c,d)}
bd.augmentClass(Zd,{key:function(a){if(a.key){var b=Xd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=Wd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?Yd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:ed,charCode:function(a){return"keypress"===a.type?Wd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
a.type?Wd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}});function $d(a,b,c,d){return T.call(this,a,b,c,d)}fd.augmentClass($d,{dataTransfer:null});function ae(a,b,c,d){return T.call(this,a,b,c,d)}bd.augmentClass(ae,{touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:ed});function be(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(be,{propertyName:null,elapsedTime:null,pseudoElement:null});
function ce(a,b,c,d){return T.call(this,a,b,c,d)}fd.augmentClass(ce,{deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null});var de={},ee={};
"abort animationEnd animationIteration animationStart blur cancel canPlay canPlayThrough click close contextMenu copy cut doubleClick drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error focus input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing progress rateChange reset scroll seeked seeking stalled submit suspend timeUpdate toggle touchCancel touchEnd touchMove touchStart transitionEnd volumeChange waiting wheel".split(" ").forEach(function(a){var b=a[0].toUpperCase()+
a.slice(1),c="on"+b;b="top"+b;c={phasedRegistrationNames:{bubbled:c,captured:c+"Capture"},dependencies:[b]};de[a]=c;ee[b]=c});
var fe={eventTypes:de,extractEvents:function(a,b,c,d){var e=ee[a];if(!e)return null;switch(a){case "topKeyPress":if(0===Wd(c))return null;case "topKeyDown":case "topKeyUp":a=Zd;break;case "topBlur":case "topFocus":a=Vd;break;case "topClick":if(2===c.button)return null;case "topDoubleClick":case "topMouseDown":case "topMouseMove":case "topMouseUp":case "topMouseOut":case "topMouseOver":case "topContextMenu":a=fd;break;case "topDrag":case "topDragEnd":case "topDragEnter":case "topDragExit":case "topDragLeave":case "topDragOver":case "topDragStart":case "topDrop":a=
$d;break;case "topTouchCancel":case "topTouchEnd":case "topTouchMove":case "topTouchStart":a=ae;break;case "topAnimationEnd":case "topAnimationIteration":case "topAnimationStart":a=Td;break;case "topTransitionEnd":a=be;break;case "topScroll":a=bd;break;case "topWheel":a=ce;break;case "topCopy":case "topCut":case "topPaste":a=Ud;break;default:a=T}b=a.getPooled(e,b,c,d);Ab(b);return b}};sd=function(a,b,c,d){a=jb(a,b,c,d);kb(a);lb(!1)};hb.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
Wa=sb.getFiberCurrentPropsFromNode;Xa=sb.getInstanceFromNode;Ya=sb.getNodeFromInstance;hb.injectEventPluginsByName({SimpleEventPlugin:fe,EnterLeaveEventPlugin:hd,ChangeEventPlugin:ad,SelectEventPlugin:Sd,BeforeInputEventPlugin:ic});var ge=[],he=-1;function V(a){0>he||(a.current=ge[he],ge[he]=null,he--)}function W(a,b){he++;ge[he]=a.current;a.current=b}new Set;var ie={current:D},X={current:!1},je=D;function ke(a){return le(a)?je:ie.current}
function me(a,b){var c=a.type.contextTypes;if(!c)return D;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function le(a){return 2===a.tag&&null!=a.type.childContextTypes}function ne(a){le(a)&&(V(X,a),V(ie,a))}
function oe(a,b,c){null!=ie.cursor?E("168"):void 0;W(ie,b,a);W(X,c,a)}function pe(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:E("108",jd(a)||"Unknown",e);return B({},b,c)}function qe(a){if(!le(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||D;je=ie.current;W(ie,b,a);W(X,X.current,a);return!0}
function re(a,b){var c=a.stateNode;c?void 0:E("169");if(b){var d=pe(a,je);c.__reactInternalMemoizedMergedChildContext=d;V(X,a);V(ie,a);W(ie,d,a)}else V(X,a);W(X,b,a)}
function Y(a,b,c){this.tag=a;this.key=b;this.stateNode=this.type=null;this.sibling=this.child=this["return"]=null;this.index=0;this.memoizedState=this.updateQueue=this.memoizedProps=this.pendingProps=this.ref=null;this.internalContextTag=c;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
function se(a,b,c){var d=a.alternate;null===d?(d=new Y(a.tag,a.key,a.internalContextTag),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.pendingProps=b;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
function te(a,b,c){var d=void 0,e=a.type,f=a.key;"function"===typeof e?(d=e.prototype&&e.prototype.isReactComponent?new Y(2,f,b):new Y(0,f,b),d.type=e,d.pendingProps=a.props):"string"===typeof e?(d=new Y(5,f,b),d.type=e,d.pendingProps=a.props):"object"===typeof e&&null!==e&&"number"===typeof e.tag?(d=e,d.pendingProps=a.props):E("130",null==e?e:typeof e,"");d.expirationTime=c;return d}function ue(a,b,c,d){b=new Y(10,d,b);b.pendingProps=a;b.expirationTime=c;return b}
function ve(a,b,c){b=new Y(6,null,b);b.pendingProps=a;b.expirationTime=c;return b}function we(a,b,c){b=new Y(7,a.key,b);b.type=a.handler;b.pendingProps=a;b.expirationTime=c;return b}function xe(a,b,c){a=new Y(9,null,b);a.expirationTime=c;return a}function ye(a,b,c){b=new Y(4,a.key,b);b.pendingProps=a.children||[];b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}var ze=null,Ae=null;
function Be(a){return function(b){try{return a(b)}catch(c){}}}function Ce(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);ze=Be(function(a){return b.onCommitFiberRoot(c,a)});Ae=Be(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function De(a){"function"===typeof ze&&ze(a)}function Ee(a){"function"===typeof Ae&&Ae(a)}
function Fe(a){return{baseState:a,expirationTime:0,first:null,last:null,callbackList:null,hasForceUpdate:!1,isInitialized:!1}}function Ge(a,b){null===a.last?a.first=a.last=b:(a.last.next=b,a.last=b);if(0===a.expirationTime||a.expirationTime>b.expirationTime)a.expirationTime=b.expirationTime}
function He(a,b){var c=a.alternate,d=a.updateQueue;null===d&&(d=a.updateQueue=Fe(null));null!==c?(a=c.updateQueue,null===a&&(a=c.updateQueue=Fe(null))):a=null;a=a!==d?a:null;null===a?Ge(d,b):null===d.last||null===a.last?(Ge(d,b),Ge(a,b)):(Ge(d,b),a.last=b)}function Ie(a,b,c,d){a=a.partialState;return"function"===typeof a?a.call(b,c,d):a}
function Je(a,b,c,d,e,f){null!==a&&a.updateQueue===c&&(c=b.updateQueue={baseState:c.baseState,expirationTime:c.expirationTime,first:c.first,last:c.last,isInitialized:c.isInitialized,callbackList:null,hasForceUpdate:!1});c.expirationTime=0;c.isInitialized?a=c.baseState:(a=c.baseState=b.memoizedState,c.isInitialized=!0);for(var g=!0,h=c.first,k=!1;null!==h;){var q=h.expirationTime;if(q>f){var v=c.expirationTime;if(0===v||v>q)c.expirationTime=q;k||(k=!0,c.baseState=a)}else{k||(c.first=h.next,null===
c.first&&(c.last=null));if(h.isReplace)a=Ie(h,d,a,e),g=!0;else if(q=Ie(h,d,a,e))a=g?B({},a,q):B(a,q),g=!1;h.isForced&&(c.hasForceUpdate=!0);null!==h.callback&&(q=c.callbackList,null===q&&(q=c.callbackList=[]),q.push(h))}h=h.next}null!==c.callbackList?b.effectTag|=32:null!==c.first||c.hasForceUpdate||(b.updateQueue=null);k||(c.baseState=a);return a}
function Ke(a,b){var c=a.callbackList;if(null!==c)for(a.callbackList=null,a=0;a<c.length;a++){var d=c[a],e=d.callback;d.callback=null;"function"!==typeof e?E("191",e):void 0;e.call(b)}}
function Le(a,b,c,d){function e(a,b){b.updater=f;a.stateNode=b;b._reactInternalFiber=a}var f={isMounted:ld,enqueueSetState:function(c,d,e){c=c._reactInternalFiber;e=void 0===e?null:e;var g=b(c);He(c,{expirationTime:g,partialState:d,callback:e,isReplace:!1,isForced:!1,nextCallback:null,next:null});a(c,g)},enqueueReplaceState:function(c,d,e){c=c._reactInternalFiber;e=void 0===e?null:e;var g=b(c);He(c,{expirationTime:g,partialState:d,callback:e,isReplace:!0,isForced:!1,nextCallback:null,next:null});
a(c,g)},enqueueForceUpdate:function(c,d){c=c._reactInternalFiber;d=void 0===d?null:d;var e=b(c);He(c,{expirationTime:e,partialState:null,callback:d,isReplace:!1,isForced:!0,nextCallback:null,next:null});a(c,e)}};return{adoptClassInstance:e,constructClassInstance:function(a,b){var c=a.type,d=ke(a),f=2===a.tag&&null!=a.type.contextTypes,g=f?me(a,d):D;b=new c(b,g);e(a,b);f&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=d,a.__reactInternalMemoizedMaskedChildContext=g);return b},mountClassInstance:function(a,
b){var c=a.alternate,d=a.stateNode,e=d.state||null,g=a.pendingProps;g?void 0:E("158");var h=ke(a);d.props=g;d.state=a.memoizedState=e;d.refs=D;d.context=me(a,h);null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent&&(a.internalContextTag|=1);"function"===typeof d.componentWillMount&&(e=d.state,d.componentWillMount(),e!==d.state&&f.enqueueReplaceState(d,d.state,null),e=a.updateQueue,null!==e&&(d.state=Je(c,a,e,d,g,b)));"function"===typeof d.componentDidMount&&(a.effectTag|=
4)},updateClassInstance:function(a,b,e){var g=b.stateNode;g.props=b.memoizedProps;g.state=b.memoizedState;var h=b.memoizedProps,k=b.pendingProps;k||(k=h,null==k?E("159"):void 0);var u=g.context,z=ke(b);z=me(b,z);"function"!==typeof g.componentWillReceiveProps||h===k&&u===z||(u=g.state,g.componentWillReceiveProps(k,z),g.state!==u&&f.enqueueReplaceState(g,g.state,null));u=b.memoizedState;e=null!==b.updateQueue?Je(a,b,b.updateQueue,g,k,e):u;if(!(h!==k||u!==e||X.current||null!==b.updateQueue&&b.updateQueue.hasForceUpdate))return"function"!==
typeof g.componentDidUpdate||h===a.memoizedProps&&u===a.memoizedState||(b.effectTag|=4),!1;var G=k;if(null===h||null!==b.updateQueue&&b.updateQueue.hasForceUpdate)G=!0;else{var I=b.stateNode,L=b.type;G="function"===typeof I.shouldComponentUpdate?I.shouldComponentUpdate(G,e,z):L.prototype&&L.prototype.isPureReactComponent?!ea(h,G)||!ea(u,e):!0}G?("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(k,e,z),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4)):("function"!==typeof g.componentDidUpdate||
h===a.memoizedProps&&u===a.memoizedState||(b.effectTag|=4),c(b,k),d(b,e));g.props=k;g.state=e;g.context=z;return G}}}var Qe="function"===typeof Symbol&&Symbol["for"],Re=Qe?Symbol["for"]("react.element"):60103,Se=Qe?Symbol["for"]("react.call"):60104,Te=Qe?Symbol["for"]("react.return"):60105,Ue=Qe?Symbol["for"]("react.portal"):60106,Ve=Qe?Symbol["for"]("react.fragment"):60107,We="function"===typeof Symbol&&Symbol.iterator;
function Xe(a){if(null===a||"undefined"===typeof a)return null;a=We&&a[We]||a["@@iterator"];return"function"===typeof a?a:null}var Ye=Array.isArray;
function Ze(a,b){var c=b.ref;if(null!==c&&"function"!==typeof c){if(b._owner){b=b._owner;var d=void 0;b&&(2!==b.tag?E("110"):void 0,d=b.stateNode);d?void 0:E("147",c);var e=""+c;if(null!==a&&null!==a.ref&&a.ref._stringRef===e)return a.ref;a=function(a){var b=d.refs===D?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};a._stringRef=e;return a}"string"!==typeof c?E("148"):void 0;b._owner?void 0:E("149",c)}return c}
function $e(a,b){"textarea"!==a.type&&E("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function af(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=se(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=ve(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=Ze(b,c),d["return"]=a,d;d=te(c,a.internalContextTag,d);d.ref=Ze(b,c);d["return"]=a;return d}function q(a,b,c,d){if(null===b||7!==b.tag)return b=we(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c,d);
b["return"]=a;return b}function v(a,b,c,d){if(null===b||9!==b.tag)return b=xe(c,a.internalContextTag,d),b.type=c.value,b["return"]=a,b;b=e(b,null,d);b.type=c.value;b["return"]=a;return b}function y(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=ye(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c.children||[],d);b["return"]=a;return b}function u(a,b,c,d,f){if(null===b||10!==b.tag)return b=ue(c,a.internalContextTag,
d,f),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function z(a,b,c){if("string"===typeof b||"number"===typeof b)return b=ve(""+b,a.internalContextTag,c),b["return"]=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Re:if(b.type===Ve)return b=ue(b.props.children,a.internalContextTag,c,b.key),b["return"]=a,b;c=te(b,a.internalContextTag,c);c.ref=Ze(null,b);c["return"]=a;return c;case Se:return b=we(b,a.internalContextTag,c),b["return"]=a,b;case Te:return c=xe(b,a.internalContextTag,
c),c.type=b.value,c["return"]=a,c;case Ue:return b=ye(b,a.internalContextTag,c),b["return"]=a,b}if(Ye(b)||Xe(b))return b=ue(b,a.internalContextTag,c,null),b["return"]=a,b;$e(a,b)}return null}function G(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Re:return c.key===e?c.type===Ve?u(a,b,c.props.children,d,e):k(a,b,c,d):null;case Se:return c.key===e?q(a,b,c,d):null;case Te:return null===
e?v(a,b,c,d):null;case Ue:return c.key===e?y(a,b,c,d):null}if(Ye(c)||Xe(c))return null!==e?null:u(a,b,c,d,null);$e(a,c)}return null}function I(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Re:return a=a.get(null===d.key?c:d.key)||null,d.type===Ve?u(b,a,d.props.children,e,d.key):k(b,a,d,e);case Se:return a=a.get(null===d.key?c:d.key)||null,q(b,a,d,e);case Te:return a=a.get(c)||null,v(b,a,d,e);case Ue:return a=
a.get(null===d.key?c:d.key)||null,y(b,a,d,e)}if(Ye(d)||Xe(d))return a=a.get(c)||null,u(b,a,d,e,null);$e(b,d)}return null}function L(e,g,m,A){for(var h=null,r=null,n=g,w=g=0,k=null;null!==n&&w<m.length;w++){n.index>w?(k=n,n=null):k=n.sibling;var x=G(e,n,m[w],A);if(null===x){null===n&&(n=k);break}a&&n&&null===x.alternate&&b(e,n);g=f(x,g,w);null===r?h=x:r.sibling=x;r=x;n=k}if(w===m.length)return c(e,n),h;if(null===n){for(;w<m.length;w++)if(n=z(e,m[w],A))g=f(n,g,w),null===r?h=n:r.sibling=n,r=n;return h}for(n=
d(e,n);w<m.length;w++)if(k=I(n,e,w,m[w],A)){if(a&&null!==k.alternate)n["delete"](null===k.key?w:k.key);g=f(k,g,w);null===r?h=k:r.sibling=k;r=k}a&&n.forEach(function(a){return b(e,a)});return h}function N(e,g,m,A){var h=Xe(m);"function"!==typeof h?E("150"):void 0;m=h.call(m);null==m?E("151"):void 0;for(var r=h=null,n=g,w=g=0,k=null,x=m.next();null!==n&&!x.done;w++,x=m.next()){n.index>w?(k=n,n=null):k=n.sibling;var J=G(e,n,x.value,A);if(null===J){n||(n=k);break}a&&n&&null===J.alternate&&b(e,n);g=f(J,
g,w);null===r?h=J:r.sibling=J;r=J;n=k}if(x.done)return c(e,n),h;if(null===n){for(;!x.done;w++,x=m.next())x=z(e,x.value,A),null!==x&&(g=f(x,g,w),null===r?h=x:r.sibling=x,r=x);return h}for(n=d(e,n);!x.done;w++,x=m.next())if(x=I(n,e,w,x.value,A),null!==x){if(a&&null!==x.alternate)n["delete"](null===x.key?w:x.key);g=f(x,g,w);null===r?h=x:r.sibling=x;r=x}a&&n.forEach(function(a){return b(e,a)});return h}return function(a,d,f,h){"object"===typeof f&&null!==f&&f.type===Ve&&null===f.key&&(f=f.props.children);
var m="object"===typeof f&&null!==f;if(m)switch(f.$$typeof){case Re:a:{var r=f.key;for(m=d;null!==m;){if(m.key===r)if(10===m.tag?f.type===Ve:m.type===f.type){c(a,m.sibling);d=e(m,f.type===Ve?f.props.children:f.props,h);d.ref=Ze(m,f);d["return"]=a;a=d;break a}else{c(a,m);break}else b(a,m);m=m.sibling}f.type===Ve?(d=ue(f.props.children,a.internalContextTag,h,f.key),d["return"]=a,a=d):(h=te(f,a.internalContextTag,h),h.ref=Ze(d,f),h["return"]=a,a=h)}return g(a);case Se:a:{for(m=f.key;null!==d;){if(d.key===
m)if(7===d.tag){c(a,d.sibling);d=e(d,f,h);d["return"]=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=we(f,a.internalContextTag,h);d["return"]=a;a=d}return g(a);case Te:a:{if(null!==d)if(9===d.tag){c(a,d.sibling);d=e(d,null,h);d.type=f.value;d["return"]=a;a=d;break a}else c(a,d);d=xe(f,a.internalContextTag,h);d.type=f.value;d["return"]=a;a=d}return g(a);case Ue:a:{for(m=f.key;null!==d;){if(d.key===m)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===
f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d["return"]=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=ye(f,a.internalContextTag,h);d["return"]=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h)):(c(a,d),d=ve(f,a.internalContextTag,h)),d["return"]=a,a=d,g(a);if(Ye(f))return L(a,d,f,h);if(Xe(f))return N(a,d,f,h);m&&$e(a,f);if("undefined"===typeof f)switch(a.tag){case 2:case 1:h=a.type,E("152",h.displayName||
h.name||"Component")}return c(a,d)}}var bf=af(!0),cf=af(!1);
function df(a,b,c,d,e){function f(a,b,c){var d=b.expirationTime;b.child=null===a?cf(b,null,c,d):bf(b,a.child,c,d)}function g(a,b){var c=b.ref;null===c||a&&a.ref===c||(b.effectTag|=128)}function h(a,b,c,d){g(a,b);if(!c)return d&&re(b,!1),q(a,b);c=b.stateNode;id.current=b;var e=c.render();b.effectTag|=1;f(a,b,e);b.memoizedState=c.state;b.memoizedProps=c.props;d&&re(b,!0);return b.child}function k(a){var b=a.stateNode;b.pendingContext?oe(a,b.pendingContext,b.pendingContext!==b.context):b.context&&oe(a,
b.context,!1);I(a,b.containerInfo)}function q(a,b){null!==a&&b.child!==a.child?E("153"):void 0;if(null!==b.child){a=b.child;var c=se(a,a.pendingProps,a.expirationTime);b.child=c;for(c["return"]=b;null!==a.sibling;)a=a.sibling,c=c.sibling=se(a,a.pendingProps,a.expirationTime),c["return"]=b;c.sibling=null}return b.child}function v(a,b){switch(b.tag){case 3:k(b);break;case 2:qe(b);break;case 4:I(b,b.stateNode.containerInfo)}return null}var y=a.shouldSetTextContent,u=a.useSyncScheduling,z=a.shouldDeprioritizeSubtree,
G=b.pushHostContext,I=b.pushHostContainer,L=c.enterHydrationState,N=c.resetHydrationState,J=c.tryToClaimNextHydratableInstance;a=Le(d,e,function(a,b){a.memoizedProps=b},function(a,b){a.memoizedState=b});var w=a.adoptClassInstance,m=a.constructClassInstance,A=a.mountClassInstance,Ob=a.updateClassInstance;return{beginWork:function(a,b,c){if(0===b.expirationTime||b.expirationTime>c)return v(a,b);switch(b.tag){case 0:null!==a?E("155"):void 0;var d=b.type,e=b.pendingProps,r=ke(b);r=me(b,r);d=d(e,r);b.effectTag|=
1;"object"===typeof d&&null!==d&&"function"===typeof d.render?(b.tag=2,e=qe(b),w(b,d),A(b,c),b=h(a,b,!0,e)):(b.tag=1,f(a,b,d),b.memoizedProps=e,b=b.child);return b;case 1:a:{e=b.type;c=b.pendingProps;d=b.memoizedProps;if(X.current)null===c&&(c=d);else if(null===c||d===c){b=q(a,b);break a}d=ke(b);d=me(b,d);e=e(c,d);b.effectTag|=1;f(a,b,e);b.memoizedProps=c;b=b.child}return b;case 2:return e=qe(b),d=void 0,null===a?b.stateNode?E("153"):(m(b,b.pendingProps),A(b,c),d=!0):d=Ob(a,b,c),h(a,b,d,e);case 3:return k(b),
e=b.updateQueue,null!==e?(d=b.memoizedState,e=Je(a,b,e,null,null,c),d===e?(N(),b=q(a,b)):(d=e.element,r=b.stateNode,(null===a||null===a.child)&&r.hydrate&&L(b)?(b.effectTag|=2,b.child=cf(b,null,d,c)):(N(),f(a,b,d)),b.memoizedState=e,b=b.child)):(N(),b=q(a,b)),b;case 5:G(b);null===a&&J(b);e=b.type;var n=b.memoizedProps;d=b.pendingProps;null===d&&(d=n,null===d?E("154"):void 0);r=null!==a?a.memoizedProps:null;X.current||null!==d&&n!==d?(n=d.children,y(e,d)?n=null:r&&y(e,r)&&(b.effectTag|=16),g(a,b),
2147483647!==c&&!u&&z(e,d)?(b.expirationTime=2147483647,b=null):(f(a,b,n),b.memoizedProps=d,b=b.child)):b=q(a,b);return b;case 6:return null===a&&J(b),a=b.pendingProps,null===a&&(a=b.memoizedProps),b.memoizedProps=a,null;case 8:b.tag=7;case 7:e=b.pendingProps;if(X.current)null===e&&(e=a&&a.memoizedProps,null===e?E("154"):void 0);else if(null===e||b.memoizedProps===e)e=b.memoizedProps;d=e.children;b.stateNode=null===a?cf(b,b.stateNode,d,c):bf(b,b.stateNode,d,c);b.memoizedProps=e;return b.stateNode;
case 9:return null;case 4:a:{I(b,b.stateNode.containerInfo);e=b.pendingProps;if(X.current)null===e&&(e=a&&a.memoizedProps,null==e?E("154"):void 0);else if(null===e||b.memoizedProps===e){b=q(a,b);break a}null===a?b.child=bf(b,null,e,c):f(a,b,e);b.memoizedProps=e;b=b.child}return b;case 10:a:{c=b.pendingProps;if(X.current)null===c&&(c=b.memoizedProps);else if(null===c||b.memoizedProps===c){b=q(a,b);break a}f(a,b,c);b.memoizedProps=c;b=b.child}return b;default:E("156")}},beginFailedWork:function(a,b,
c){switch(b.tag){case 2:qe(b);break;case 3:k(b);break;default:E("157")}b.effectTag|=64;null===a?b.child=null:b.child!==a.child&&(b.child=a.child);if(0===b.expirationTime||b.expirationTime>c)return v(a,b);b.firstEffect=null;b.lastEffect=null;b.child=null===a?cf(b,null,null,c):bf(b,a.child,null,c);2===b.tag&&(a=b.stateNode,b.memoizedProps=a.props,b.memoizedState=a.state);return b.child}}}
function ef(a,b,c){function d(a){a.effectTag|=4}var e=a.createInstance,f=a.createTextInstance,g=a.appendInitialChild,h=a.finalizeInitialChildren,k=a.prepareUpdate,q=a.persistence,v=b.getRootHostContainer,y=b.popHostContext,u=b.getHostContext,z=b.popHostContainer,G=c.prepareToHydrateHostInstance,I=c.prepareToHydrateHostTextInstance,L=c.popHydrationState,N=void 0,J=void 0,w=void 0;a.mutation?(N=function(){},J=function(a,b,c){(b.updateQueue=c)&&d(b)},w=function(a,b,c,e){c!==e&&d(b)}):q?E("235"):E("236");
return{completeWork:function(a,b,c){var m=b.pendingProps;if(null===m)m=b.memoizedProps;else if(2147483647!==b.expirationTime||2147483647===c)b.pendingProps=null;switch(b.tag){case 1:return null;case 2:return ne(b),null;case 3:z(b);V(X,b);V(ie,b);m=b.stateNode;m.pendingContext&&(m.context=m.pendingContext,m.pendingContext=null);if(null===a||null===a.child)L(b),b.effectTag&=-3;N(b);return null;case 5:y(b);c=v();var A=b.type;if(null!==a&&null!=b.stateNode){var p=a.memoizedProps,q=b.stateNode,x=u();q=
k(q,A,p,m,c,x);J(a,b,q,A,p,m,c);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!m)return null===b.stateNode?E("166"):void 0,null;a=u();if(L(b))G(b,c,a)&&d(b);else{a=e(A,m,c,a,b);a:for(p=b.child;null!==p;){if(5===p.tag||6===p.tag)g(a,p.stateNode);else if(4!==p.tag&&null!==p.child){p.child["return"]=p;p=p.child;continue}if(p===b)break;for(;null===p.sibling;){if(null===p["return"]||p["return"]===b)break a;p=p["return"]}p.sibling["return"]=p["return"];p=p.sibling}h(a,A,m,c)&&d(b);b.stateNode=a}null!==b.ref&&
(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)w(a,b,a.memoizedProps,m);else{if("string"!==typeof m)return null===b.stateNode?E("166"):void 0,null;a=v();c=u();L(b)?I(b)&&d(b):b.stateNode=f(m,a,c,b)}return null;case 7:(m=b.memoizedProps)?void 0:E("165");b.tag=8;A=[];a:for((p=b.stateNode)&&(p["return"]=b);null!==p;){if(5===p.tag||6===p.tag||4===p.tag)E("247");else if(9===p.tag)A.push(p.type);else if(null!==p.child){p.child["return"]=p;p=p.child;continue}for(;null===p.sibling;){if(null===
p["return"]||p["return"]===b)break a;p=p["return"]}p.sibling["return"]=p["return"];p=p.sibling}p=m.handler;m=p(m.props,A);b.child=bf(b,null!==a?a.child:null,m,c);return b.child;case 8:return b.tag=7,null;case 9:return null;case 10:return null;case 4:return z(b),N(b),null;case 0:E("167");default:E("156")}}}}
function ff(a,b){function c(a){var c=a.ref;if(null!==c)try{c(null)}catch(A){b(a,A)}}function d(a){"function"===typeof Ee&&Ee(a);switch(a.tag){case 2:c(a);var d=a.stateNode;if("function"===typeof d.componentWillUnmount)try{d.props=a.memoizedProps,d.state=a.memoizedState,d.componentWillUnmount()}catch(A){b(a,A)}break;case 5:c(a);break;case 7:e(a.stateNode);break;case 4:k&&g(a)}}function e(a){for(var b=a;;)if(d(b),null===b.child||k&&4===b.tag){if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||
b["return"]===a)return;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}else b.child["return"]=b,b=b.child}function f(a){return 5===a.tag||3===a.tag||4===a.tag}function g(a){for(var b=a,c=!1,f=void 0,g=void 0;;){if(!c){c=b["return"];a:for(;;){null===c?E("160"):void 0;switch(c.tag){case 5:f=c.stateNode;g=!1;break a;case 3:f=c.stateNode.containerInfo;g=!0;break a;case 4:f=c.stateNode.containerInfo;g=!0;break a}c=c["return"]}c=!0}if(5===b.tag||6===b.tag)e(b),g?J(f,b.stateNode):N(f,b.stateNode);
else if(4===b.tag?f=b.stateNode.containerInfo:d(b),null!==b.child){b.child["return"]=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"];4===b.tag&&(c=!1)}b.sibling["return"]=b["return"];b=b.sibling}}var h=a.getPublicInstance,k=a.mutation;a=a.persistence;k||(a?E("235"):E("236"));var q=k.commitMount,v=k.commitUpdate,y=k.resetTextContent,u=k.commitTextUpdate,z=k.appendChild,G=k.appendChildToContainer,I=k.insertBefore,L=k.insertInContainerBefore,
N=k.removeChild,J=k.removeChildFromContainer;return{commitResetTextContent:function(a){y(a.stateNode)},commitPlacement:function(a){a:{for(var b=a["return"];null!==b;){if(f(b)){var c=b;break a}b=b["return"]}E("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:E("161")}c.effectTag&16&&(y(b),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c["return"]||f(c["return"])){c=
null;break a}c=c["return"]}c.sibling["return"]=c["return"];for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;if(null===c.child||4===c.tag)continue b;else c.child["return"]=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)c?d?L(b,e.stateNode,c):I(b,e.stateNode,c):d?G(b,e.stateNode):z(b,e.stateNode);else if(4!==e.tag&&null!==e.child){e.child["return"]=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e["return"]||e["return"]===
a)return;e=e["return"]}e.sibling["return"]=e["return"];e=e.sibling}},commitDeletion:function(a){g(a);a["return"]=null;a.child=null;a.alternate&&(a.alternate.child=null,a.alternate["return"]=null)},commitWork:function(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&v(c,f,e,a,d,b)}break;case 6:null===b.stateNode?E("162"):void 0;c=b.memoizedProps;u(b.stateNode,null!==a?a.memoizedProps:
c,c);break;case 3:break;default:E("163")}},commitLifeCycles:function(a,b){switch(b.tag){case 2:var c=b.stateNode;if(b.effectTag&4)if(null===a)c.props=b.memoizedProps,c.state=b.memoizedState,c.componentDidMount();else{var d=a.memoizedProps;a=a.memoizedState;c.props=b.memoizedProps;c.state=b.memoizedState;c.componentDidUpdate(d,a)}b=b.updateQueue;null!==b&&Ke(b,c);break;case 3:c=b.updateQueue;null!==c&&Ke(c,null!==b.child?b.child.stateNode:null);break;case 5:c=b.stateNode;null===a&&b.effectTag&4&&q(c,
b.type,b.memoizedProps,b);break;case 6:break;case 4:break;default:E("163")}},commitAttachRef:function(a){var b=a.ref;if(null!==b){var c=a.stateNode;switch(a.tag){case 5:b(h(c));break;default:b(c)}}},commitDetachRef:function(a){a=a.ref;null!==a&&a(null)}}}var gf={};
function hf(a){function b(a){a===gf?E("174"):void 0;return a}var c=a.getChildHostContext,d=a.getRootHostContext,e={current:gf},f={current:gf},g={current:gf};return{getHostContext:function(){return b(e.current)},getRootHostContainer:function(){return b(g.current)},popHostContainer:function(a){V(e,a);V(f,a);V(g,a)},popHostContext:function(a){f.current===a&&(V(e,a),V(f,a))},pushHostContainer:function(a,b){W(g,b,a);b=d(b);W(f,a,a);W(e,b,a)},pushHostContext:function(a){var d=b(g.current),h=b(e.current);
d=c(h,a.type,d);h!==d&&(W(f,a,a),W(e,d,a))},resetHostContainer:function(){e.current=gf;g.current=gf}}}
function jf(a){function b(a,b){var c=new Y(5,null,0);c.type="DELETED";c.stateNode=b;c["return"]=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function c(a,b){switch(a.tag){case 5:return b=f(b,a.type,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;case 6:return b=g(b,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;default:return!1}}function d(a){for(a=a["return"];null!==a&&5!==a.tag&&3!==a.tag;)a=a["return"];y=a}var e=a.shouldSetTextContent;
a=a.hydration;if(!a)return{enterHydrationState:function(){return!1},resetHydrationState:function(){},tryToClaimNextHydratableInstance:function(){},prepareToHydrateHostInstance:function(){E("175")},prepareToHydrateHostTextInstance:function(){E("176")},popHydrationState:function(){return!1}};var f=a.canHydrateInstance,g=a.canHydrateTextInstance,h=a.getNextHydratableSibling,k=a.getFirstHydratableChild,q=a.hydrateInstance,v=a.hydrateTextInstance,y=null,u=null,z=!1;return{enterHydrationState:function(a){u=
k(a.stateNode.containerInfo);y=a;return z=!0},resetHydrationState:function(){u=y=null;z=!1},tryToClaimNextHydratableInstance:function(a){if(z){var d=u;if(d){if(!c(a,d)){d=h(d);if(!d||!c(a,d)){a.effectTag|=2;z=!1;y=a;return}b(y,u)}y=a;u=k(d)}else a.effectTag|=2,z=!1,y=a}},prepareToHydrateHostInstance:function(a,b,c){b=q(a.stateNode,a.type,a.memoizedProps,b,c,a);a.updateQueue=b;return null!==b?!0:!1},prepareToHydrateHostTextInstance:function(a){return v(a.stateNode,a.memoizedProps,a)},popHydrationState:function(a){if(a!==
y)return!1;if(!z)return d(a),z=!0,!1;var c=a.type;if(5!==a.tag||"head"!==c&&"body"!==c&&!e(c,a.memoizedProps))for(c=u;c;)b(a,c),c=h(c);d(a);u=y?h(a.stateNode):null;return!0}}}
function kf(a){function b(a){Qb=ja=!0;var b=a.stateNode;b.current===a?E("177"):void 0;b.isReadyForCommit=!1;id.current=null;if(1<a.effectTag)if(null!==a.lastEffect){a.lastEffect.nextEffect=a;var c=a.firstEffect}else c=a;else c=a.firstEffect;yg();for(t=c;null!==t;){var d=!1,e=void 0;try{for(;null!==t;){var f=t.effectTag;f&16&&zg(t);if(f&128){var g=t.alternate;null!==g&&Ag(g)}switch(f&-242){case 2:Ne(t);t.effectTag&=-3;break;case 6:Ne(t);t.effectTag&=-3;Oe(t.alternate,t);break;case 4:Oe(t.alternate,
t);break;case 8:Sc=!0,Bg(t),Sc=!1}t=t.nextEffect}}catch(Tc){d=!0,e=Tc}d&&(null===t?E("178"):void 0,h(t,e),null!==t&&(t=t.nextEffect))}Cg();b.current=a;for(t=c;null!==t;){c=!1;d=void 0;try{for(;null!==t;){var k=t.effectTag;k&36&&Dg(t.alternate,t);k&128&&Eg(t);if(k&64)switch(e=t,f=void 0,null!==R&&(f=R.get(e),R["delete"](e),null==f&&null!==e.alternate&&(e=e.alternate,f=R.get(e),R["delete"](e))),null==f?E("184"):void 0,e.tag){case 2:e.stateNode.componentDidCatch(f.error,{componentStack:f.componentStack});
break;case 3:null===ca&&(ca=f.error);break;default:E("157")}var Qc=t.nextEffect;t.nextEffect=null;t=Qc}}catch(Tc){c=!0,d=Tc}c&&(null===t?E("178"):void 0,h(t,d),null!==t&&(t=t.nextEffect))}ja=Qb=!1;"function"===typeof De&&De(a.stateNode);ha&&(ha.forEach(G),ha=null);null!==ca&&(a=ca,ca=null,Ob(a));b=b.current.expirationTime;0===b&&(qa=R=null);return b}function c(a){for(;;){var b=Fg(a.alternate,a,H),c=a["return"],d=a.sibling;var e=a;if(2147483647===H||2147483647!==e.expirationTime){if(2!==e.tag&&3!==
e.tag)var f=0;else f=e.updateQueue,f=null===f?0:f.expirationTime;for(var g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;
if(null!==c)a=c;else{a.stateNode.isReadyForCommit=!0;break}}return null}function d(a){var b=rg(a.alternate,a,H);null===b&&(b=c(a));id.current=null;return b}function e(a){var b=Gg(a.alternate,a,H);null===b&&(b=c(a));id.current=null;return b}function f(a){if(null!==R){if(!(0===H||H>a))if(H<=Uc)for(;null!==F;)F=k(F)?e(F):d(F);else for(;null!==F&&!A();)F=k(F)?e(F):d(F)}else if(!(0===H||H>a))if(H<=Uc)for(;null!==F;)F=d(F);else for(;null!==F&&!A();)F=d(F)}function g(a,b){ja?E("243"):void 0;ja=!0;a.isReadyForCommit=
!1;if(a!==ra||b!==H||null===F){for(;-1<he;)ge[he]=null,he--;je=D;ie.current=D;X.current=!1;x();ra=a;H=b;F=se(ra.current,null,b)}var c=!1,d=null;try{f(b)}catch(Rc){c=!0,d=Rc}for(;c;){if(eb){ca=d;break}var g=F;if(null===g)eb=!0;else{var k=h(g,d);null===k?E("183"):void 0;if(!eb){try{c=k;d=b;for(k=c;null!==g;){switch(g.tag){case 2:ne(g);break;case 5:qg(g);break;case 3:p(g);break;case 4:p(g)}if(g===k||g.alternate===k)break;g=g["return"]}F=e(c);f(d)}catch(Rc){c=!0;d=Rc;continue}break}}}b=ca;eb=ja=!1;ca=
null;null!==b&&Ob(b);return a.isReadyForCommit?a.current.alternate:null}function h(a,b){var c=id.current=null,d=!1,e=!1,f=null;if(3===a.tag)c=a,q(a)&&(eb=!0);else for(var g=a["return"];null!==g&&null===c;){2===g.tag?"function"===typeof g.stateNode.componentDidCatch&&(d=!0,f=jd(g),c=g,e=!0):3===g.tag&&(c=g);if(q(g)){if(Sc||null!==ha&&(ha.has(g)||null!==g.alternate&&ha.has(g.alternate)))return null;c=null;e=!1}g=g["return"]}if(null!==c){null===qa&&(qa=new Set);qa.add(c);var h="";g=a;do{a:switch(g.tag){case 0:case 1:case 2:case 5:var k=
g._debugOwner,Qc=g._debugSource;var m=jd(g);var n=null;k&&(n=jd(k));k=Qc;m="\n    in "+(m||"Unknown")+(k?" (at "+k.fileName.replace(/^.*[\\\/]/,"")+":"+k.lineNumber+")":n?" (created by "+n+")":"");break a;default:m=""}h+=m;g=g["return"]}while(g);g=h;a=jd(a);null===R&&(R=new Map);b={componentName:a,componentStack:g,error:b,errorBoundary:d?c.stateNode:null,errorBoundaryFound:d,errorBoundaryName:f,willRetry:e};R.set(c,b);try{var p=b.error;p&&p.suppressReactErrorLogging||console.error(p)}catch(Vc){Vc&&
Vc.suppressReactErrorLogging||console.error(Vc)}Qb?(null===ha&&(ha=new Set),ha.add(c)):G(c);return c}null===ca&&(ca=b);return null}function k(a){return null!==R&&(R.has(a)||null!==a.alternate&&R.has(a.alternate))}function q(a){return null!==qa&&(qa.has(a)||null!==a.alternate&&qa.has(a.alternate))}function v(){return 20*(((I()+100)/20|0)+1)}function y(a){return 0!==ka?ka:ja?Qb?1:H:!Hg||a.internalContextTag&1?v():1}function u(a,b){return z(a,b,!1)}function z(a,b){for(;null!==a;){if(0===a.expirationTime||
a.expirationTime>b)a.expirationTime=b;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>b)&&(a.alternate.expirationTime=b);if(null===a["return"])if(3===a.tag){var c=a.stateNode;!ja&&c===ra&&b<H&&(F=ra=null,H=0);var d=c,e=b;Rb>Ig&&E("185");if(null===d.nextScheduledRoot)d.remainingExpirationTime=e,null===O?(sa=O=d,d.nextScheduledRoot=d):(O=O.nextScheduledRoot=d,O.nextScheduledRoot=sa);else{var f=d.remainingExpirationTime;if(0===f||e<f)d.remainingExpirationTime=e}Fa||(la?
Sb&&(ma=d,na=1,m(ma,na)):1===e?w(1,null):L(e));!ja&&c===ra&&b<H&&(F=ra=null,H=0)}else break;a=a["return"]}}function G(a){z(a,1,!0)}function I(){return Uc=((Wc()-Pe)/10|0)+2}function L(a){if(0!==Tb){if(a>Tb)return;Jg(Xc)}var b=Wc()-Pe;Tb=a;Xc=Kg(J,{timeout:10*(a-2)-b})}function N(){var a=0,b=null;if(null!==O)for(var c=O,d=sa;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===O?E("244"):void 0;if(d===d.nextScheduledRoot){sa=O=d.nextScheduledRoot=null;break}else if(d===sa)sa=e=d.nextScheduledRoot,
O.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===O){O=c;O.nextScheduledRoot=sa;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===O)break;c=d;d=d.nextScheduledRoot}}c=ma;null!==c&&c===b?Rb++:Rb=0;ma=b;na=a}function J(a){w(0,a)}function w(a,b){fb=b;for(N();null!==ma&&0!==na&&(0===a||na<=a)&&!Yc;)m(ma,na),N();null!==fb&&(Tb=0,Xc=-1);0!==na&&L(na);fb=null;Yc=!1;Rb=0;if(Ub)throw a=Zc,Zc=
null,Ub=!1,a;}function m(a,c){Fa?E("245"):void 0;Fa=!0;if(c<=I()){var d=a.finishedWork;null!==d?(a.finishedWork=null,a.remainingExpirationTime=b(d)):(a.finishedWork=null,d=g(a,c),null!==d&&(a.remainingExpirationTime=b(d)))}else d=a.finishedWork,null!==d?(a.finishedWork=null,a.remainingExpirationTime=b(d)):(a.finishedWork=null,d=g(a,c),null!==d&&(A()?a.finishedWork=d:a.remainingExpirationTime=b(d)));Fa=!1}function A(){return null===fb||fb.timeRemaining()>Lg?!1:Yc=!0}function Ob(a){null===ma?E("246"):
void 0;ma.remainingExpirationTime=0;Ub||(Ub=!0,Zc=a)}var r=hf(a),n=jf(a),p=r.popHostContainer,qg=r.popHostContext,x=r.resetHostContainer,Me=df(a,r,n,u,y),rg=Me.beginWork,Gg=Me.beginFailedWork,Fg=ef(a,r,n).completeWork;r=ff(a,h);var zg=r.commitResetTextContent,Ne=r.commitPlacement,Bg=r.commitDeletion,Oe=r.commitWork,Dg=r.commitLifeCycles,Eg=r.commitAttachRef,Ag=r.commitDetachRef,Wc=a.now,Kg=a.scheduleDeferredCallback,Jg=a.cancelDeferredCallback,Hg=a.useSyncScheduling,yg=a.prepareForCommit,Cg=a.resetAfterCommit,
Pe=Wc(),Uc=2,ka=0,ja=!1,F=null,ra=null,H=0,t=null,R=null,qa=null,ha=null,ca=null,eb=!1,Qb=!1,Sc=!1,sa=null,O=null,Tb=0,Xc=-1,Fa=!1,ma=null,na=0,Yc=!1,Ub=!1,Zc=null,fb=null,la=!1,Sb=!1,Ig=1E3,Rb=0,Lg=1;return{computeAsyncExpiration:v,computeExpirationForFiber:y,scheduleWork:u,batchedUpdates:function(a,b){var c=la;la=!0;try{return a(b)}finally{(la=c)||Fa||w(1,null)}},unbatchedUpdates:function(a){if(la&&!Sb){Sb=!0;try{return a()}finally{Sb=!1}}return a()},flushSync:function(a){var b=la;la=!0;try{a:{var c=
ka;ka=1;try{var d=a();break a}finally{ka=c}d=void 0}return d}finally{la=b,Fa?E("187"):void 0,w(1,null)}},deferredUpdates:function(a){var b=ka;ka=v();try{return a()}finally{ka=b}}}}
function lf(a){function b(a){a=od(a);return null===a?null:a.stateNode}var c=a.getPublicInstance;a=kf(a);var d=a.computeAsyncExpiration,e=a.computeExpirationForFiber,f=a.scheduleWork;return{createContainer:function(a,b){var c=new Y(3,null,0);a={current:c,containerInfo:a,pendingChildren:null,remainingExpirationTime:0,isReadyForCommit:!1,finishedWork:null,context:null,pendingContext:null,hydrate:b,nextScheduledRoot:null};return c.stateNode=a},updateContainer:function(a,b,c,q){var g=b.current;if(c){c=
c._reactInternalFiber;var h;b:{2===kd(c)&&2===c.tag?void 0:E("170");for(h=c;3!==h.tag;){if(le(h)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}(h=h["return"])?void 0:E("171")}h=h.stateNode.context}c=le(c)?pe(c,h):h}else c=D;null===b.context?b.context=c:b.pendingContext=c;b=q;b=void 0===b?null:b;q=null!=a&&null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent?d():e(g);He(g,{expirationTime:q,partialState:{element:a},callback:b,isReplace:!1,isForced:!1,
nextCallback:null,next:null});f(g,q)},batchedUpdates:a.batchedUpdates,unbatchedUpdates:a.unbatchedUpdates,deferredUpdates:a.deferredUpdates,flushSync:a.flushSync,getPublicRootInstance:function(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return c(a.child.stateNode);default:return a.child.stateNode}},findHostInstance:b,findHostInstanceWithNoPortals:function(a){a=pd(a);return null===a?null:a.stateNode},injectIntoDevTools:function(a){var c=a.findFiberByHostInstance;return Ce(B({},
a,{findHostInstanceByFiber:function(a){return b(a)},findFiberByHostInstance:function(a){return c?c(a):null}}))}}}var mf=Object.freeze({default:lf}),nf=mf&&lf||mf,of=nf["default"]?nf["default"]:nf;function pf(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Ue,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}var qf="object"===typeof performance&&"function"===typeof performance.now,rf=void 0;rf=qf?function(){return performance.now()}:function(){return Date.now()};
var sf=void 0,tf=void 0;
if(l.canUseDOM)if("function"!==typeof requestIdleCallback||"function"!==typeof cancelIdleCallback){var uf=null,vf=!1,wf=-1,xf=!1,yf=0,zf=33,Af=33,Bf;Bf=qf?{didTimeout:!1,timeRemaining:function(){var a=yf-performance.now();return 0<a?a:0}}:{didTimeout:!1,timeRemaining:function(){var a=yf-Date.now();return 0<a?a:0}};var Cf="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===Cf){vf=!1;a=rf();if(0>=yf-a)if(-1!==wf&&wf<=
a)Bf.didTimeout=!0;else{xf||(xf=!0,requestAnimationFrame(Df));return}else Bf.didTimeout=!1;wf=-1;a=uf;uf=null;null!==a&&a(Bf)}},!1);var Df=function(a){xf=!1;var b=a-yf+Af;b<Af&&zf<Af?(8>b&&(b=8),Af=b<zf?zf:b):zf=b;yf=a+Af;vf||(vf=!0,window.postMessage(Cf,"*"))};sf=function(a,b){uf=a;null!=b&&"number"===typeof b.timeout&&(wf=rf()+b.timeout);xf||(xf=!0,requestAnimationFrame(Df));return 0};tf=function(){uf=null;vf=!1;wf=-1}}else sf=window.requestIdleCallback,tf=window.cancelIdleCallback;else sf=function(a){return setTimeout(function(){a({timeRemaining:function(){return Infinity}})})},
tf=function(a){clearTimeout(a)};var Ef=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Ff={},Gf={};
function Hf(a){if(Gf.hasOwnProperty(a))return!0;if(Ff.hasOwnProperty(a))return!1;if(Ef.test(a))return Gf[a]=!0;Ff[a]=!0;return!1}
function If(a,b,c){var d=wa(b);if(d&&va(b,c)){var e=d.mutationMethod;e?e(a,c):null==c||d.hasBooleanValue&&!c||d.hasNumericValue&&isNaN(c)||d.hasPositiveNumericValue&&1>c||d.hasOverloadedBooleanValue&&!1===c?Jf(a,b):d.mustUseProperty?a[d.propertyName]=c:(b=d.attributeName,(e=d.attributeNamespace)?a.setAttributeNS(e,b,""+c):d.hasBooleanValue||d.hasOverloadedBooleanValue&&!0===c?a.setAttribute(b,""):a.setAttribute(b,""+c))}else Kf(a,b,va(b,c)?c:null)}
function Kf(a,b,c){Hf(b)&&(null==c?a.removeAttribute(b):a.setAttribute(b,""+c))}function Jf(a,b){var c=wa(b);c?(b=c.mutationMethod)?b(a,void 0):c.mustUseProperty?a[c.propertyName]=c.hasBooleanValue?!1:"":a.removeAttribute(c.attributeName):a.removeAttribute(b)}
function Lf(a,b){var c=b.value,d=b.checked;return B({type:void 0,step:void 0,min:void 0,max:void 0},b,{defaultChecked:void 0,defaultValue:void 0,value:null!=c?c:a._wrapperState.initialValue,checked:null!=d?d:a._wrapperState.initialChecked})}function Mf(a,b){var c=b.defaultValue;a._wrapperState={initialChecked:null!=b.checked?b.checked:b.defaultChecked,initialValue:null!=b.value?b.value:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}
function Nf(a,b){b=b.checked;null!=b&&If(a,"checked",b)}function Of(a,b){Nf(a,b);var c=b.value;if(null!=c)if(0===c&&""===a.value)a.value="0";else if("number"===b.type){if(b=parseFloat(a.value)||0,c!=b||c==b&&a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else null==b.value&&null!=b.defaultValue&&a.defaultValue!==""+b.defaultValue&&(a.defaultValue=""+b.defaultValue),null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Pf(a,b){switch(b.type){case "submit":case "reset":break;case "color":case "date":case "datetime":case "datetime-local":case "month":case "time":case "week":a.value="";a.value=a.defaultValue;break;default:a.value=a.value}b=a.name;""!==b&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==b&&(a.name=b)}function Qf(a){var b="";aa.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}
function Rf(a,b){a=B({children:void 0},b);if(b=Qf(b.children))a.children=b;return a}function Sf(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Tf(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function Uf(a,b){null!=b.dangerouslySetInnerHTML?E("91"):void 0;return B({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Vf(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?E("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:E("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
function Wf(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Xf(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Yf={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Zf(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function $f(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Zf(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var ag=void 0,bg=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Yf.svg||"innerHTML"in a)a.innerHTML=b;else{ag=ag||document.createElement("div");ag.innerHTML="\x3csvg\x3e"+b+"\x3c/svg\x3e";for(b=ag.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function cg(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var dg={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},eg=["Webkit","ms","Moz","O"];Object.keys(dg).forEach(function(a){eg.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);dg[b]=dg[a]})});
function fg(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||dg.hasOwnProperty(e)&&dg[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var gg=B({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function hg(a,b,c){b&&(gg[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?E("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?E("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:E("61")),null!=b.style&&"object"!==typeof b.style?E("62",c()):void 0)}
function ig(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var jg=Yf.html,kg=C.thatReturns("");
function lg(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Hd(a);b=Sa[b];for(var d=0;d<b.length;d++){var e=b[d];c.hasOwnProperty(e)&&c[e]||("topScroll"===e?wd("topScroll","scroll",a):"topFocus"===e||"topBlur"===e?(wd("topFocus","focus",a),wd("topBlur","blur",a),c.topBlur=!0,c.topFocus=!0):"topCancel"===e?(yc("cancel",!0)&&wd("topCancel","cancel",a),c.topCancel=!0):"topClose"===e?(yc("close",!0)&&wd("topClose","close",a),c.topClose=!0):Dd.hasOwnProperty(e)&&U(e,Dd[e],a),c[e]=!0)}}
var mg={topAbort:"abort",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topLoadedData:"loadeddata",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topSeeked:"seeked",topSeeking:"seeking",topStalled:"stalled",topSuspend:"suspend",topTimeUpdate:"timeupdate",topVolumeChange:"volumechange",
topWaiting:"waiting"};function ng(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===jg&&(d=Zf(a));d===jg?"script"===a?(a=c.createElement("div"),a.innerHTML="\x3cscript\x3e\x3c/script\x3e",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function og(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
function pg(a,b,c,d){var e=ig(b,c);switch(b){case "iframe":case "object":U("topLoad","load",a);var f=c;break;case "video":case "audio":for(f in mg)mg.hasOwnProperty(f)&&U(f,mg[f],a);f=c;break;case "source":U("topError","error",a);f=c;break;case "img":case "image":U("topError","error",a);U("topLoad","load",a);f=c;break;case "form":U("topReset","reset",a);U("topSubmit","submit",a);f=c;break;case "details":U("topToggle","toggle",a);f=c;break;case "input":Mf(a,c);f=Lf(a,c);U("topInvalid","invalid",a);
lg(d,"onChange");break;case "option":f=Rf(a,c);break;case "select":Tf(a,c);f=B({},c,{value:void 0});U("topInvalid","invalid",a);lg(d,"onChange");break;case "textarea":Vf(a,c);f=Uf(a,c);U("topInvalid","invalid",a);lg(d,"onChange");break;default:f=c}hg(b,f,kg);var g=f,h;for(h in g)if(g.hasOwnProperty(h)){var k=g[h];"style"===h?fg(a,k,kg):"dangerouslySetInnerHTML"===h?(k=k?k.__html:void 0,null!=k&&bg(a,k)):"children"===h?"string"===typeof k?("textarea"!==b||""!==k)&&cg(a,k):"number"===typeof k&&cg(a,
""+k):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(Ra.hasOwnProperty(h)?null!=k&&lg(d,h):e?Kf(a,h,k):null!=k&&If(a,h,k))}switch(b){case "input":Bc(a);Pf(a,c);break;case "textarea":Bc(a);Xf(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?Sf(a,!!c.multiple,b,!1):null!=c.defaultValue&&Sf(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=
C)}}
function sg(a,b,c,d,e){var f=null;switch(b){case "input":c=Lf(a,c);d=Lf(a,d);f=[];break;case "option":c=Rf(a,c);d=Rf(a,d);f=[];break;case "select":c=B({},c,{value:void 0});d=B({},d,{value:void 0});f=[];break;case "textarea":c=Uf(a,c);d=Uf(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=C)}hg(b,d,kg);var g,h;a=null;for(g in c)if(!d.hasOwnProperty(g)&&c.hasOwnProperty(g)&&null!=c[g])if("style"===g)for(h in b=c[g],b)b.hasOwnProperty(h)&&(a||(a={}),a[h]=
"");else"dangerouslySetInnerHTML"!==g&&"children"!==g&&"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&"autoFocus"!==g&&(Ra.hasOwnProperty(g)?f||(f=[]):(f=f||[]).push(g,null));for(g in d){var k=d[g];b=null!=c?c[g]:void 0;if(d.hasOwnProperty(g)&&k!==b&&(null!=k||null!=b))if("style"===g)if(b){for(h in b)!b.hasOwnProperty(h)||k&&k.hasOwnProperty(h)||(a||(a={}),a[h]="");for(h in k)k.hasOwnProperty(h)&&b[h]!==k[h]&&(a||(a={}),a[h]=k[h])}else a||(f||(f=[]),f.push(g,a)),a=k;else"dangerouslySetInnerHTML"===
g?(k=k?k.__html:void 0,b=b?b.__html:void 0,null!=k&&b!==k&&(f=f||[]).push(g,""+k)):"children"===g?b===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(g,""+k):"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&(Ra.hasOwnProperty(g)?(null!=k&&lg(e,g),f||b===k||(f=[])):(f=f||[]).push(g,k))}a&&(f=f||[]).push("style",a);return f}
function tg(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Nf(a,e);ig(c,d);d=ig(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?fg(a,h,kg):"dangerouslySetInnerHTML"===g?bg(a,h):"children"===g?cg(a,h):d?null!=h?Kf(a,g,h):a.removeAttribute(g):null!=h?If(a,g,h):Jf(a,g)}switch(c){case "input":Of(a,e);break;case "textarea":Wf(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?Sf(a,
!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?Sf(a,!!e.multiple,e.defaultValue,!0):Sf(a,!!e.multiple,e.multiple?[]:"",!1))}}
function ug(a,b,c,d,e){switch(b){case "iframe":case "object":U("topLoad","load",a);break;case "video":case "audio":for(var f in mg)mg.hasOwnProperty(f)&&U(f,mg[f],a);break;case "source":U("topError","error",a);break;case "img":case "image":U("topError","error",a);U("topLoad","load",a);break;case "form":U("topReset","reset",a);U("topSubmit","submit",a);break;case "details":U("topToggle","toggle",a);break;case "input":Mf(a,c);U("topInvalid","invalid",a);lg(e,"onChange");break;case "select":Tf(a,c);
U("topInvalid","invalid",a);lg(e,"onChange");break;case "textarea":Vf(a,c),U("topInvalid","invalid",a),lg(e,"onChange")}hg(b,c,kg);d=null;for(var g in c)c.hasOwnProperty(g)&&(f=c[g],"children"===g?"string"===typeof f?a.textContent!==f&&(d=["children",f]):"number"===typeof f&&a.textContent!==""+f&&(d=["children",""+f]):Ra.hasOwnProperty(g)&&null!=f&&lg(e,g));switch(b){case "input":Bc(a);Pf(a,c);break;case "textarea":Bc(a);Xf(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&
(a.onclick=C)}return d}function vg(a,b){return a.nodeValue!==b}
var wg=Object.freeze({createElement:ng,createTextNode:og,setInitialProperties:pg,diffProperties:sg,updateProperties:tg,diffHydratedProperties:ug,diffHydratedText:vg,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Of(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=
c.parentNode;c=c.querySelectorAll("input[name\x3d"+JSON.stringify(""+b)+'][type\x3d"radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=rb(d);e?void 0:E("90");Cc(d);Of(d,e)}}}break;case "textarea":Wf(a,c);break;case "select":b=c.value,null!=b&&Sf(a,!!c.multiple,b,!1)}}});nc.injectFiberControlledHostComponent(wg);var xg=null,Mg=null;function Ng(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}
function Og(a){a=a?9===a.nodeType?a.documentElement:a.firstChild:null;return!(!a||1!==a.nodeType||!a.hasAttribute("data-reactroot"))}
var Z=of({getRootHostContext:function(a){var b=a.nodeType;switch(b){case 9:case 11:a=(a=a.documentElement)?a.namespaceURI:$f(null,"");break;default:b=8===b?a.parentNode:a,a=b.namespaceURI||null,b=b.tagName,a=$f(a,b)}return a},getChildHostContext:function(a,b){return $f(a,b)},getPublicInstance:function(a){return a},prepareForCommit:function(){xg=td;var a=da();if(Kd(a)){if("selectionStart"in a)var b={start:a.selectionStart,end:a.selectionEnd};else a:{var c=window.getSelection&&window.getSelection();
if(c&&0!==c.rangeCount){b=c.anchorNode;var d=c.anchorOffset,e=c.focusNode;c=c.focusOffset;try{b.nodeType,e.nodeType}catch(z){b=null;break a}var f=0,g=-1,h=-1,k=0,q=0,v=a,y=null;b:for(;;){for(var u;;){v!==b||0!==d&&3!==v.nodeType||(g=f+d);v!==e||0!==c&&3!==v.nodeType||(h=f+c);3===v.nodeType&&(f+=v.nodeValue.length);if(null===(u=v.firstChild))break;y=v;v=u}for(;;){if(v===a)break b;y===b&&++k===d&&(g=f);y===e&&++q===c&&(h=f);if(null!==(u=v.nextSibling))break;v=y;y=v.parentNode}v=u}b=-1===g||-1===h?null:
{start:g,end:h}}else b=null}b=b||{start:0,end:0}}else b=null;Mg={focusedElem:a,selectionRange:b};ud(!1)},resetAfterCommit:function(){var a=Mg,b=da(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&fa(document.documentElement,c)){if(Kd(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(window.getSelection){b=window.getSelection();var e=c[Eb()].length;a=Math.min(d.start,e);d=void 0===d.end?a:Math.min(d.end,e);!b.extend&&a>
d&&(e=d,d=a,a=e);e=Jd(c,a);var f=Jd(c,d);if(e&&f&&(1!==b.rangeCount||b.anchorNode!==e.node||b.anchorOffset!==e.offset||b.focusNode!==f.node||b.focusOffset!==f.offset)){var g=document.createRange();g.setStart(e.node,e.offset);b.removeAllRanges();a>d?(b.addRange(g),b.extend(f.node,f.offset)):(g.setEnd(f.node,f.offset),b.addRange(g))}}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});ia(c);for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,a.element.scrollTop=
a.top}Mg=null;ud(xg);xg=null},createInstance:function(a,b,c,d,e){a=ng(a,b,c,d);a[Q]=e;a[ob]=b;return a},appendInitialChild:function(a,b){a.appendChild(b)},finalizeInitialChildren:function(a,b,c,d){pg(a,b,c,d);a:{switch(b){case "button":case "input":case "select":case "textarea":a=!!c.autoFocus;break a}a=!1}return a},prepareUpdate:function(a,b,c,d,e){return sg(a,b,c,d,e)},shouldSetTextContent:function(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===
typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===typeof b.dangerouslySetInnerHTML.__html},shouldDeprioritizeSubtree:function(a,b){return!!b.hidden},createTextInstance:function(a,b,c,d){a=og(a,b);a[Q]=d;return a},now:rf,mutation:{commitMount:function(a){a.focus()},commitUpdate:function(a,b,c,d,e){a[ob]=e;tg(a,b,c,d,e)},resetTextContent:function(a){a.textContent=""},commitTextUpdate:function(a,b,c){a.nodeValue=c},appendChild:function(a,b){a.appendChild(b)},appendChildToContainer:function(a,
b){8===a.nodeType?a.parentNode.insertBefore(b,a):a.appendChild(b)},insertBefore:function(a,b,c){a.insertBefore(b,c)},insertInContainerBefore:function(a,b,c){8===a.nodeType?a.parentNode.insertBefore(b,c):a.insertBefore(b,c)},removeChild:function(a,b){a.removeChild(b)},removeChildFromContainer:function(a,b){8===a.nodeType?a.parentNode.removeChild(b):a.removeChild(b)}},hydration:{canHydrateInstance:function(a,b){return 1!==a.nodeType||b.toLowerCase()!==a.nodeName.toLowerCase()?null:a},canHydrateTextInstance:function(a,
b){return""===b||3!==a.nodeType?null:a},getNextHydratableSibling:function(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},getFirstHydratableChild:function(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},hydrateInstance:function(a,b,c,d,e,f){a[Q]=f;a[ob]=c;return ug(a,b,c,e,d)},hydrateTextInstance:function(a,b,c){a[Q]=c;return vg(a,b)},didNotMatchHydratedContainerTextInstance:function(){},didNotMatchHydratedTextInstance:function(){},
didNotHydrateContainerInstance:function(){},didNotHydrateInstance:function(){},didNotFindHydratableContainerInstance:function(){},didNotFindHydratableContainerTextInstance:function(){},didNotFindHydratableInstance:function(){},didNotFindHydratableTextInstance:function(){}},scheduleDeferredCallback:sf,cancelDeferredCallback:tf,useSyncScheduling:!0});rc=Z.batchedUpdates;
function Pg(a,b,c,d,e){Ng(c)?void 0:E("200");var f=c._reactRootContainer;if(f)Z.updateContainer(b,f,a,e);else{d=d||Og(c);if(!d)for(f=void 0;f=c.lastChild;)c.removeChild(f);var g=Z.createContainer(c,d);f=c._reactRootContainer=g;Z.unbatchedUpdates(function(){Z.updateContainer(b,g,a,e)})}return Z.getPublicRootInstance(f)}function Qg(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;Ng(b)?void 0:E("200");return pf(a,b,null,c)}
function Rg(a,b){this._reactRootContainer=Z.createContainer(a,b)}Rg.prototype.render=function(a,b){Z.updateContainer(a,this._reactRootContainer,null,b)};Rg.prototype.unmount=function(a){Z.updateContainer(null,this._reactRootContainer,null,a)};
var Sg={createPortal:Qg,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(b)return Z.findHostInstance(b);"function"===typeof a.render?E("188"):E("213",Object.keys(a))},hydrate:function(a,b,c){return Pg(null,a,b,!0,c)},render:function(a,b,c){return Pg(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?E("38"):void 0;return Pg(a,b,c,!1,d)},unmountComponentAtNode:function(a){Ng(a)?void 0:
E("40");return a._reactRootContainer?(Z.unbatchedUpdates(function(){Pg(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:Qg,unstable_batchedUpdates:tc,unstable_deferredUpdates:Z.deferredUpdates,flushSync:Z.flushSync,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:mb,EventPluginRegistry:Va,EventPropagators:Cb,ReactControlledComponent:qc,ReactDOMComponentTree:sb,ReactDOMEventListener:xd}};
Z.injectIntoDevTools({findFiberByHostInstance:pb,bundleType:0,version:"16.2.0",rendererPackageName:"react-dom"});var Tg=Object.freeze({default:Sg}),Ug=Tg&&Sg||Tg;module.exports=Ug["default"]?Ug["default"]:Ug;


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(60);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(256);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(257);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 259 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_css__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__poem_1_data_AdultMortalityProbability__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__poem_1_data_AlcoholDeaths__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__poem_1_data_Before5Chart__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__poem_1_data_HIVKnowledge__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__poem_1_data_IntimatePartnerViolence__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__poem_1_data_LifeExpectancy__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__poem_1_data_OpenDefChart__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__poem_1_data_PopulationBelowPovertyLine__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__poem_1_data_SexualViolence__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__poem_1_data_SexWorkersSyphilis__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Buttons__ = __webpack_require__(610);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//all the charts and data
//the two buttons at bottom of every page
var App=function(_Component){_inherits(App,_Component);function App(props){_classCallCheck(this,App);var _this=_possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).call(this,props));_this.state={currentPage:0};_this.onPageChange=_this.onPageChange.bind(_this);_this.renderPage=_this.renderPage.bind(_this);return _this;}//every time a button is pressed to go to next, previous page, this runs
_createClass(App,[{key:'onPageChange',value:function onPageChange(value){var currentPage=this.state.currentPage+value;this.setState({currentPage:currentPage});}//each page is a specific case, as in a numerical page that it is located
},{key:'renderPage',value:function renderPage(curPage){switch(curPage){case 0:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__poem_1_data_AdultMortalityProbability__["a" /* default */],null);case 1:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__poem_1_data_AlcoholDeaths__["a" /* default */],null);case 2:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__poem_1_data_Before5Chart__["a" /* default */],null);case 3:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__poem_1_data_HIVKnowledge__["a" /* default */],null);case 4:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__poem_1_data_IntimatePartnerViolence__["a" /* default */],null);case 5:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__poem_1_data_LifeExpectancy__["a" /* default */],null);case 6:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__poem_1_data_OpenDefChart__["a" /* default */],null);case 7:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__poem_1_data_PopulationBelowPovertyLine__["a" /* default */],null);case 8:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__poem_1_data_SexualViolence__["a" /* default */],null);case 9:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__poem_1_data_SexWorkersSyphilis__["a" /* default */],null);default:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__poem_1_data_HIVKnowledge__["a" /* default */],null);}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'App'},this.renderPage(this.state.currentPage),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Buttons__["a" /* default */],{currentPage:this.state.currentPage,onPageChange:this.onPageChange}));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 261 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_recharts__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WikiQuote_js__ = __webpack_require__(21);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AdultMortalityProbabilityData=__webpack_require__(552);var AdultMortalityProbability=function(_Component){_inherits(AdultMortalityProbability,_Component);function AdultMortalityProbability(props){_classCallCheck(this,AdultMortalityProbability);var _this=_possibleConstructorReturn(this,(AdultMortalityProbability.__proto__||Object.getPrototypeOf(AdultMortalityProbability)).call(this,props));_this.state={data:[],quote:""};return _this;}//use success function so as to immidiately access the final data for set state
_createClass(AdultMortalityProbability,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var quote="",data=[];var success=function success(wikiData){quote='"'+wikiData.quote+'"';};__WEBPACK_IMPORTED_MODULE_3__WikiQuote_js__["a" /* WikiquoteApi */].getRandomQuote("Mortality",success,__WEBPACK_IMPORTED_MODULE_3__WikiQuote_js__["b" /* error */]);data=Object(__WEBPACK_IMPORTED_MODULE_2__utils_js__["h" /* mapTable */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_js__["f" /* filterTable */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_js__["g" /* initialReformat */])(AdultMortalityProbabilityData)));var checkQuoteLength=function checkQuoteLength(){if(quote.length>0){_this2.setState({quote:quote,data:data});}else{setTimeout(checkQuoteLength,100);}};checkQuoteLength();}},{key:'render',value:function render(){var data=[],dataFilter=[],formatData=[],j=0;if(this.state.data.length>0){//separates data based upon year.. as so: [some_title: {some_year: [objs_of_data],...},...]
data=Object(__WEBPACK_IMPORTED_MODULE_2__utils_js__["c" /* filterAll */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_js__["b" /* dataFunction */])(this.state.data));//averages data from all years based upon region, {region1: data1, ...}
dataFilter=Object(__WEBPACK_IMPORTED_MODULE_2__utils_js__["e" /* filterBySex */])('Both sexes',data,'Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)',2015);//format data to be read by recharts)
dataFilter.forEach(function(row){formatData[j]={};formatData[j].region=row.region;formatData[j].value=parseInt(row.value,10);j++;});}//ResponsiveContainer is used so the charts repond to decrease/increase in screen size
return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'chart a-mortality'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,this.state.quote),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h6',{className:'title'},'Adult mortality rate (probability of dying between 15 and 60 years per 1000 population) - 2015'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["k" /* ResponsiveContainer */],{width:'100%',height:300},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["j" /* RadarChart */],{cx:'50%',cy:'50%',outerRadius:'80%',data:formatData},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["g" /* PolarGrid */],{gridType:'circle'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["f" /* PolarAngleAxis */],{dataKey:'region'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["h" /* PolarRadiusAxis */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["l" /* Tooltip */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["i" /* Radar */],{name:'Probability',dataKey:'value',stroke:'#4286f4',fill:'#4e5d75',fillOpacity:0.7}))));}}]);return AdultMortalityProbability;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AdultMortalityProbability);

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_es6_math__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_es6_math___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_es6_math__);

/* eslint no-proto: 0 */
var testObject = {};

if (!(Object.setPrototypeOf || testObject.__proto__)) {
  var nativeGetPrototypeOf = Object.getPrototypeOf;

  Object.getPrototypeOf = function (object) {
    if (object.__proto__) {
      return object.__proto__;
    }

    return nativeGetPrototypeOf.call(Object, object);
  };
}

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(265);
__webpack_require__(277);
__webpack_require__(278);
__webpack_require__(279);
__webpack_require__(280);
__webpack_require__(281);
__webpack_require__(282);
__webpack_require__(283);
__webpack_require__(285);
__webpack_require__(286);
__webpack_require__(287);
__webpack_require__(288);
__webpack_require__(289);
__webpack_require__(290);
__webpack_require__(291);
__webpack_require__(292);
__webpack_require__(293);
module.exports = __webpack_require__(87).Math;


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(10);
var log1p = __webpack_require__(132);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(267);
var IE8_DOM_DEFINE = __webpack_require__(268);
var toPrimitive = __webpack_require__(270);
var dP = Object.defineProperty;

exports.f = __webpack_require__(89) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(88);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(89) && !__webpack_require__(61)(function () {
  return Object.defineProperty(__webpack_require__(269)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(88);
var document = __webpack_require__(86).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(88);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 271 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(86);
var hide = __webpack_require__(131);
var has = __webpack_require__(273);
var SRC = __webpack_require__(274)('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(87).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 273 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 274 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(276);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 276 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(10);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(10);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(10);
var sign = __webpack_require__(90);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(10);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(10);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(10);
var $expm1 = __webpack_require__(91);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(10);

$export($export.S, 'Math', { fround: __webpack_require__(284) });


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(90);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(10);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(10);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(61)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(10);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(10);

$export($export.S, 'Math', { log1p: __webpack_require__(132) });


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(10);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(10);

$export($export.S, 'Math', { sign: __webpack_require__(90) });


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(10);
var expm1 = __webpack_require__(91);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(61)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(10);
var expm1 = __webpack_require__(91);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(10);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(60);
var invariant = __webpack_require__(295);
var ReactPropTypesSecret = __webpack_require__(296);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(45);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 298 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(300);

/** Used to match property names within property paths. */
var reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(301);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(94);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(303),
    ListCache = __webpack_require__(64),
    Map = __webpack_require__(96);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(304),
    hashDelete = __webpack_require__(309),
    hashGet = __webpack_require__(310),
    hashHas = __webpack_require__(311),
    hashSet = __webpack_require__(312);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(63);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(5),
    isMasked = __webpack_require__(306),
    isObject = __webpack_require__(17),
    toSource = __webpack_require__(136);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(307);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(16);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 308 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 309 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(63);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(63);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(63);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 313 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(65);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(65);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(65);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(65);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(66);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 319 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(66);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(66);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(66);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(324);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(45),
    arrayMap = __webpack_require__(67),
    isArray = __webpack_require__(8),
    isSymbol = __webpack_require__(37);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_PureRender__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__container_Surface__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shape_Symbols__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Default Legend Content
 */








var SIZE = 32;
var ICON_TYPES = __WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["b" /* LEGEND_TYPES */].filter(function (type) {
  return type !== 'none';
});

var DefaultLegendContent = Object(__WEBPACK_IMPORTED_MODULE_3__util_PureRender__["a" /* default */])(_class = (_temp = _class2 = function (_Component) {
  _inherits(DefaultLegendContent, _Component);

  function DefaultLegendContent() {
    _classCallCheck(this, DefaultLegendContent);

    return _possibleConstructorReturn(this, (DefaultLegendContent.__proto__ || Object.getPrototypeOf(DefaultLegendContent)).apply(this, arguments));
  }

  _createClass(DefaultLegendContent, [{
    key: 'renderIcon',


    /**
     * Render the path of icon
     * @param {Object} data Data of each legend item
     * @return {String} Path element
     */
    value: function renderIcon(data) {
      var inactiveColor = this.props.inactiveColor;

      var halfSize = SIZE / 2;
      var sixthSize = SIZE / 6;
      var thirdSize = SIZE / 3;
      var color = data.inactive ? inactiveColor : data.color;

      if (data.type === 'plainline') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line', {
          strokeWidth: 4,
          fill: 'none',
          stroke: color,
          strokeDasharray: data.payload.strokeDasharray,
          x1: 0,
          y1: halfSize,
          x2: SIZE,
          y2: halfSize,
          className: 'recharts-legend-icon'
        });
      } else if (data.type === 'line') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
          strokeWidth: 4,
          fill: 'none',
          stroke: color,
          d: 'M0,' + halfSize + 'h' + thirdSize + '\n            A' + sixthSize + ',' + sixthSize + ',0,1,1,' + 2 * thirdSize + ',' + halfSize + '\n            H' + SIZE + 'M' + 2 * thirdSize + ',' + halfSize + '\n            A' + sixthSize + ',' + sixthSize + ',0,1,1,' + thirdSize + ',' + halfSize,
          className: 'recharts-legend-icon'
        });
      } else if (data.type === 'rect') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
          stroke: 'none',
          fill: color,
          d: 'M0,' + SIZE / 8 + 'h' + SIZE + 'v' + SIZE * 3 / 4 + 'h' + -SIZE + 'z',
          className: 'recharts-legend-icon'
        });
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shape_Symbols__["a" /* default */], {
        fill: color,
        cx: halfSize,
        cy: halfSize,
        size: SIZE,
        sizeType: 'diameter',
        type: data.type
      });
    }

    /**
     * Draw items of legend
     * @return {ReactElement} Items
     */

  }, {
    key: 'renderItems',
    value: function renderItems() {
      var _this2 = this;

      var _props = this.props,
          payload = _props.payload,
          iconSize = _props.iconSize,
          layout = _props.layout,
          formatter = _props.formatter;

      var viewBox = { x: 0, y: 0, width: SIZE, height: SIZE };
      var itemStyle = {
        display: layout === 'horizontal' ? 'inline-block' : 'block',
        marginRight: 10
      };
      var svgStyle = { display: 'inline-block', verticalAlign: 'middle', marginRight: 4 };

      return payload.map(function (entry, i) {
        var _classNames;

        var finalFormatter = entry.formatter || formatter;
        var className = __WEBPACK_IMPORTED_MODULE_2_classnames___default()((_classNames = {
          'recharts-legend-item': true
        }, _defineProperty(_classNames, 'legend-item-' + i, true), _defineProperty(_classNames, 'inactive', entry.inactive), _classNames));

        if (entry.type === 'none') {
          return null;
        }

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'li',
          _extends({
            className: className,
            style: itemStyle,
            key: 'legend-item-' + i
          }, Object(__WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["f" /* filterEventsOfChild */])(_this2.props, entry, i)),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4__container_Surface__["a" /* default */],
            { width: iconSize, height: iconSize, viewBox: viewBox, style: svgStyle },
            _this2.renderIcon(entry)
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'recharts-legend-item-text' },
            finalFormatter ? finalFormatter(entry.value, entry, i) : entry.value
          )
        );
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          payload = _props2.payload,
          layout = _props2.layout,
          align = _props2.align;


      if (!payload || !payload.length) {
        return null;
      }

      var finalStyle = {
        padding: 0,
        margin: 0,
        textAlign: layout === 'horizontal' ? align : 'left'
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'ul',
        { className: 'recharts-default-legend', style: finalStyle },
        this.renderItems()
      );
    }
  }]);

  return DefaultLegendContent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class2.displayName = 'Legend', _class2.propTypes = {
  content: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,
  iconSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  iconType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(ICON_TYPES),
  layout: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['horizontal', 'vertical']),
  align: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['center', 'left', 'right']),
  verticalAlign: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['top', 'bottom', 'middle']),
  payload: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
    type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["b" /* LEGEND_TYPES */])
  })),
  inactiveColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  formatter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
}, _class2.defaultProps = {
  iconSize: 14,
  layout: 'horizontal',
  align: 'center',
  verticalAlign: 'middle',
  inactiveColor: '#ccc'
}, _temp)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (DefaultLegendContent);

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(47);




function arcInnerRadius(d) {
  return d.innerRadius;
}

function arcOuterRadius(d) {
  return d.outerRadius;
}

function arcStartAngle(d) {
  return d.startAngle;
}

function arcEndAngle(d) {
  return d.endAngle;
}

function arcPadAngle(d) {
  return d && d.padAngle; // Note: optional!
}

function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
  var x10 = x1 - x0, y10 = y1 - y0,
      x32 = x3 - x2, y32 = y3 - y2,
      t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / (y32 * x10 - x32 * y10);
  return [x0 + t * x10, y0 + t * y10];
}

// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
  var x01 = x0 - x1,
      y01 = y0 - y1,
      lo = (cw ? rc : -rc) / Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(x01 * x01 + y01 * y01),
      ox = lo * y01,
      oy = -lo * x01,
      x11 = x0 + ox,
      y11 = y0 + oy,
      x10 = x1 + ox,
      y10 = y1 + oy,
      x00 = (x11 + x10) / 2,
      y00 = (y11 + y10) / 2,
      dx = x10 - x11,
      dy = y10 - y11,
      d2 = dx * dx + dy * dy,
      r = r1 - rc,
      D = x11 * y10 - x10 * y11,
      d = (dy < 0 ? -1 : 1) * Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(Object(__WEBPACK_IMPORTED_MODULE_2__math__["h" /* max */])(0, r * r * d2 - D * D)),
      cx0 = (D * dy - dx * d) / d2,
      cy0 = (-D * dx - dy * d) / d2,
      cx1 = (D * dy + dx * d) / d2,
      cy1 = (-D * dx + dy * d) / d2,
      dx0 = cx0 - x00,
      dy0 = cy0 - y00,
      dx1 = cx1 - x00,
      dy1 = cy1 - y00;

  // Pick the closer of the two intersection points.
  // TODO Is there a faster way to determine which intersection to use?
  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;

  return {
    cx: cx0,
    cy: cy0,
    x01: -ox,
    y01: -oy,
    x11: cx0 * (r1 / r - 1),
    y11: cy0 * (r1 / r - 1)
  };
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var innerRadius = arcInnerRadius,
      outerRadius = arcOuterRadius,
      cornerRadius = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(0),
      padRadius = null,
      startAngle = arcStartAngle,
      endAngle = arcEndAngle,
      padAngle = arcPadAngle,
      context = null;

  function arc() {
    var buffer,
        r,
        r0 = +innerRadius.apply(this, arguments),
        r1 = +outerRadius.apply(this, arguments),
        a0 = startAngle.apply(this, arguments) - __WEBPACK_IMPORTED_MODULE_2__math__["g" /* halfPi */],
        a1 = endAngle.apply(this, arguments) - __WEBPACK_IMPORTED_MODULE_2__math__["g" /* halfPi */],
        da = Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* abs */])(a1 - a0),
        cw = a1 > a0;

    if (!context) context = buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])();

    // Ensure that the outer radius is always larger than the inner radius.
    if (r1 < r0) r = r1, r1 = r0, r0 = r;

    // Is it a point?
    if (!(r1 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */])) context.moveTo(0, 0);

    // Or is it a circle or annulus?
    else if (da > __WEBPACK_IMPORTED_MODULE_2__math__["m" /* tau */] - __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
      context.moveTo(r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a0), r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a0));
      context.arc(0, 0, r1, a0, a1, !cw);
      if (r0 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
        context.moveTo(r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a1), r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a1));
        context.arc(0, 0, r0, a1, a0, cw);
      }
    }

    // Or is it a circular or annular sector?
    else {
      var a01 = a0,
          a11 = a1,
          a00 = a0,
          a10 = a1,
          da0 = da,
          da1 = da,
          ap = padAngle.apply(this, arguments) / 2,
          rp = (ap > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) && (padRadius ? +padRadius.apply(this, arguments) : Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(r0 * r0 + r1 * r1)),
          rc = Object(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* min */])(Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* abs */])(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
          rc0 = rc,
          rc1 = rc,
          t0,
          t1;

      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
      if (rp > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
        var p0 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["c" /* asin */])(rp / r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(ap)),
            p1 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["c" /* asin */])(rp / r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(ap));
        if ((da0 -= p0 * 2) > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
        if ((da1 -= p1 * 2) > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
      }

      var x01 = r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a01),
          y01 = r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a01),
          x10 = r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a10),
          y10 = r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a10);

      // Apply rounded corners?
      if (rc > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
        var x11 = r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a11),
            y11 = r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a11),
            x00 = r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a00),
            y00 = r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a00);

        // Restrict the corner radius according to the sector angle.
        if (da < __WEBPACK_IMPORTED_MODULE_2__math__["j" /* pi */]) {
          var oc = da0 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */] ? intersect(x01, y01, x00, y00, x11, y11, x10, y10) : [x10, y10],
              ax = x01 - oc[0],
              ay = y01 - oc[1],
              bx = x11 - oc[0],
              by = y11 - oc[1],
              kc = 1 / Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(Object(__WEBPACK_IMPORTED_MODULE_2__math__["b" /* acos */])((ax * bx + ay * by) / (Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(ax * ax + ay * ay) * Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(bx * bx + by * by))) / 2),
              lc = Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(oc[0] * oc[0] + oc[1] * oc[1]);
          rc0 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* min */])(rc, (r0 - lc) / (kc - 1));
          rc1 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* min */])(rc, (r1 - lc) / (kc + 1));
        }
      }

      // Is the sector collapsed to a line?
      if (!(da1 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */])) context.moveTo(x01, y01);

      // Does the sector’s outer ring have rounded corners?
      else if (rc1 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);

        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y01, t0.x01), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc1, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y01, t0.x01), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r1, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.cy + t0.y11, t0.cx + t0.x11), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
          context.arc(t1.cx, t1.cy, rc1, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y11, t1.x11), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the outer ring just a circular arc?
      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);

      // Is there no inner ring, and it’s a circular sector?
      // Or perhaps it’s an annular sector collapsed due to padding?
      if (!(r0 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) || !(da0 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */])) context.lineTo(x10, y10);

      // Does the sector’s inner ring (or point) have rounded corners?
      else if (rc0 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);

        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y01, t0.x01), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc0, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y01, t0.x01), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r0, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.cy + t0.y11, t0.cx + t0.x11), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.cy + t1.y11, t1.cx + t1.x11), cw);
          context.arc(t1.cx, t1.cy, rc0, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y11, t1.x11), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the inner ring just a circular arc?
      else context.arc(0, 0, r0, a10, a00, cw);
    }

    context.closePath();

    if (buffer) return context = null, buffer + "" || null;
  }

  arc.centroid = function() {
    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - __WEBPACK_IMPORTED_MODULE_2__math__["j" /* pi */] / 2;
    return [Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a) * r, Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a) * r];
  };

  arc.innerRadius = function(_) {
    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : innerRadius;
  };

  arc.outerRadius = function(_) {
    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : outerRadius;
  };

  arc.cornerRadius = function(_) {
    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : cornerRadius;
  };

  arc.padRadius = function(_) {
    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : padRadius;
  };

  arc.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : startAngle;
  };

  arc.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : endAngle;
  };

  arc.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : padAngle;
  };

  arc.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
  };

  return arc;
});


/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var pi = Math.PI,
    tau = 2 * pi,
    epsilon = 1e-6,
    tauEpsilon = tau - epsilon;

function Path() {
  this._x0 = this._y0 = // start of current subpath
  this._x1 = this._y1 = null; // end of current subpath
  this._ = "";
}

function path() {
  return new Path;
}

Path.prototype = path.prototype = {
  constructor: Path,
  moveTo: function(x, y) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
  },
  closePath: function() {
    if (this._x1 !== null) {
      this._x1 = this._x0, this._y1 = this._y0;
      this._ += "Z";
    }
  },
  lineTo: function(x, y) {
    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  quadraticCurveTo: function(x1, y1, x, y) {
    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  arcTo: function(x1, y1, x2, y2, r) {
    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
    var x0 = this._x1,
        y0 = this._y1,
        x21 = x2 - x1,
        y21 = y2 - y1,
        x01 = x0 - x1,
        y01 = y0 - y1,
        l01_2 = x01 * x01 + y01 * y01;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x1,y1).
    if (this._x1 === null) {
      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
    else if (!(l01_2 > epsilon)) {}

    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
    // Equivalently, is (x1,y1) coincident with (x2,y2)?
    // Or, is the radius zero? Line to (x1,y1).
    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Otherwise, draw an arc!
    else {
      var x20 = x2 - x0,
          y20 = y2 - y0,
          l21_2 = x21 * x21 + y21 * y21,
          l20_2 = x20 * x20 + y20 * y20,
          l21 = Math.sqrt(l21_2),
          l01 = Math.sqrt(l01_2),
          l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
          t01 = l / l01,
          t21 = l / l21;

      // If the start tangent is not coincident with (x0,y0), line to.
      if (Math.abs(t01 - 1) > epsilon) {
        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
      }

      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
    }
  },
  arc: function(x, y, r, a0, a1, ccw) {
    x = +x, y = +y, r = +r;
    var dx = r * Math.cos(a0),
        dy = r * Math.sin(a0),
        x0 = x + dx,
        y0 = y + dy,
        cw = 1 ^ ccw,
        da = ccw ? a0 - a1 : a1 - a0;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x0,y0).
    if (this._x1 === null) {
      this._ += "M" + x0 + "," + y0;
    }

    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
    else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
      this._ += "L" + x0 + "," + y0;
    }

    // Is this arc empty? We’re done.
    if (!r) return;

    // Does the angle go the wrong way? Flip the direction.
    if (da < 0) da = da % tau + tau;

    // Is this a complete circle? Draw two arcs to complete the circle.
    if (da > tauEpsilon) {
      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
    }

    // Is this arc non-empty? Draw an arc!
    else if (da > epsilon) {
      this._ += "A" + r + "," + r + ",0," + (+(da >= pi)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    }
  },
  rect: function(x, y, w, h) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
  },
  toString: function() {
    return this._;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (path);


/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__descending__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__math__ = __webpack_require__(47);





/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var value = __WEBPACK_IMPORTED_MODULE_2__identity__["a" /* default */],
      sortValues = __WEBPACK_IMPORTED_MODULE_1__descending__["a" /* default */],
      sort = null,
      startAngle = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(0),
      endAngle = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__math__["m" /* tau */]),
      padAngle = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(0);

  function pie(data) {
    var i,
        n = data.length,
        j,
        k,
        sum = 0,
        index = new Array(n),
        arcs = new Array(n),
        a0 = +startAngle.apply(this, arguments),
        da = Math.min(__WEBPACK_IMPORTED_MODULE_3__math__["m" /* tau */], Math.max(-__WEBPACK_IMPORTED_MODULE_3__math__["m" /* tau */], endAngle.apply(this, arguments) - a0)),
        a1,
        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
        pa = p * (da < 0 ? -1 : 1),
        v;

    for (i = 0; i < n; ++i) {
      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
        sum += v;
      }
    }

    // Optionally sort the arcs by previously-computed values or by data.
    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });

    // Compute the arcs! They are stored in the original data's order.
    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
        data: data[j],
        index: i,
        value: v,
        startAngle: a0,
        endAngle: a1,
        padAngle: p
      };
    }

    return arcs;
  }

  pie.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : value;
  };

  pie.sortValues = function(_) {
    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
  };

  pie.sort = function(_) {
    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
  };

  pie.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : startAngle;
  };

  pie.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : endAngle;
  };

  pie.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : padAngle;
  };

  return pie;
});


/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
});


/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(d) {
  return d;
});


/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curve_radial__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__area__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lineRadial__ = __webpack_require__(139);




/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var a = Object(__WEBPACK_IMPORTED_MODULE_1__area__["a" /* default */])().curve(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["a" /* curveRadialLinear */]),
      c = a.curve,
      x0 = a.lineX0,
      x1 = a.lineX1,
      y0 = a.lineY0,
      y1 = a.lineY1;

  a.angle = a.x, delete a.x;
  a.startAngle = a.x0, delete a.x0;
  a.endAngle = a.x1, delete a.x1;
  a.radius = a.y, delete a.y;
  a.innerRadius = a.y0, delete a.y0;
  a.outerRadius = a.y1, delete a.y1;
  a.lineStartAngle = function() { return Object(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["a" /* lineRadial */])(x0()); }, delete a.lineX0;
  a.lineEndAngle = function() { return Object(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["a" /* lineRadial */])(x1()); }, delete a.lineX1;
  a.lineInnerRadius = function() { return Object(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["a" /* lineRadial */])(y0()); }, delete a.lineY0;
  a.lineOuterRadius = function() { return Object(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["a" /* lineRadial */])(y1()); }, delete a.lineY1;

  a.curve = function(_) {
    return arguments.length ? c(Object(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["b" /* default */])(_)) : c()._curve;
  };

  return a;
});


/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export linkHorizontal */
/* unused harmony export linkVertical */
/* unused harmony export linkRadial */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__point__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pointRadial__ = __webpack_require__(140);






function linkSource(d) {
  return d.source;
}

function linkTarget(d) {
  return d.target;
}

function link(curve) {
  var source = linkSource,
      target = linkTarget,
      x = __WEBPACK_IMPORTED_MODULE_3__point__["a" /* x */],
      y = __WEBPACK_IMPORTED_MODULE_3__point__["b" /* y */],
      context = null;

  function link() {
    var buffer, argv = __WEBPACK_IMPORTED_MODULE_1__array__["a" /* slice */].call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
    if (!context) context = buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])();
    curve(context, +x.apply(this, (argv[0] = s, argv)), +y.apply(this, argv), +x.apply(this, (argv[0] = t, argv)), +y.apply(this, argv));
    if (buffer) return context = null, buffer + "" || null;
  }

  link.source = function(_) {
    return arguments.length ? (source = _, link) : source;
  };

  link.target = function(_) {
    return arguments.length ? (target = _, link) : target;
  };

  link.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(+_), link) : x;
  };

  link.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(+_), link) : y;
  };

  link.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), link) : context;
  };

  return link;
}

function curveHorizontal(context, x0, y0, x1, y1) {
  context.moveTo(x0, y0);
  context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
}

function curveVertical(context, x0, y0, x1, y1) {
  context.moveTo(x0, y0);
  context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
}

function curveRadial(context, x0, y0, x1, y1) {
  var p0 = Object(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" /* default */])(x0, y0),
      p1 = Object(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" /* default */])(x0, y0 = (y0 + y1) / 2),
      p2 = Object(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" /* default */])(x1, y0),
      p3 = Object(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" /* default */])(x1, y1);
  context.moveTo(p0[0], p0[1]);
  context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
}

function linkHorizontal() {
  return link(curveHorizontal);
}

function linkVertical() {
  return link(curveVertical);
}

function linkRadial() {
  var l = link(curveRadial);
  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;
  return l;
}


/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export symbols */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__symbol_circle__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__symbol_cross__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__symbol_diamond__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__symbol_star__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__symbol_square__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__symbol_triangle__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__symbol_wye__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constant__ = __webpack_require__(33);










var symbols = [
  __WEBPACK_IMPORTED_MODULE_1__symbol_circle__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_2__symbol_cross__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_3__symbol_diamond__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_5__symbol_square__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_4__symbol_star__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_6__symbol_triangle__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_7__symbol_wye__["a" /* default */]
];

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var type = Object(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__symbol_circle__["a" /* default */]),
      size = Object(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(64),
      context = null;

  function symbol() {
    var buffer;
    if (!context) context = buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])();
    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
    if (buffer) return context = null, buffer + "" || null;
  }

  symbol.type = function(_) {
    return arguments.length ? (type = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(_), symbol) : type;
  };

  symbol.size = function(_) {
    return arguments.length ? (size = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(+_), symbol) : size;
  };

  symbol.context = function(_) {
    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
  };

  return symbol;
});


/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basis__ = __webpack_require__(72);



function BasisClosed(context) {
  this._context = context;
}

BasisClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2);
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
      default: Object(__WEBPACK_IMPORTED_MODULE_1__basis__["c" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new BasisClosed(context);
});


/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(72);


function BasisOpen(context) {
  this._context = context;
}

BasisOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
      case 3: this._point = 4; // proceed
      default: Object(__WEBPACK_IMPORTED_MODULE_0__basis__["c" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new BasisOpen(context);
});


/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(72);


function Bundle(context, beta) {
  this._basis = new __WEBPACK_IMPORTED_MODULE_0__basis__["a" /* Basis */](context);
  this._beta = beta;
}

Bundle.prototype = {
  lineStart: function() {
    this._x = [];
    this._y = [];
    this._basis.lineStart();
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        j = x.length - 1;

    if (j > 0) {
      var x0 = x[0],
          y0 = y[0],
          dx = x[j] - x0,
          dy = y[j] - y0,
          i = -1,
          t;

      while (++i <= j) {
        t = i / j;
        this._basis.point(
          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
        );
      }
    }

    this._x = this._y = null;
    this._basis.lineEnd();
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(beta) {

  function bundle(context) {
    return beta === 1 ? new __WEBPACK_IMPORTED_MODULE_0__basis__["a" /* Basis */](context) : new Bundle(context, beta);
  }

  bundle.beta = function(beta) {
    return custom(+beta);
  };

  return bundle;
})(0.85));


/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardinalClosed__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__noop__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__catmullRom__ = __webpack_require__(103);




function CatmullRomClosed(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_1__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_1__noop__["a" /* default */],
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
      default: Object(__WEBPACK_IMPORTED_MODULE_2__catmullRom__["a" /* point */])(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRomClosed(context, alpha) : new __WEBPACK_IMPORTED_MODULE_0__cardinalClosed__["a" /* CardinalClosed */](context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));


/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardinalOpen__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__catmullRom__ = __webpack_require__(103);



function CatmullRomOpen(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
      case 3: this._point = 4; // proceed
      default: Object(__WEBPACK_IMPORTED_MODULE_1__catmullRom__["a" /* point */])(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRomOpen(context, alpha) : new __WEBPACK_IMPORTED_MODULE_0__cardinalOpen__["a" /* CardinalOpen */](context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));


/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(71);


function LinearClosed(context) {
  this._context = context;
}

LinearClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._point) this._context.closePath();
  },
  point: function(x, y) {
    x = +x, y = +y;
    if (this._point) this._context.lineTo(x, y);
    else this._point = 1, this._context.moveTo(x, y);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new LinearClosed(context);
});


/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = monotoneX;
/* harmony export (immutable) */ __webpack_exports__["b"] = monotoneY;
function sign(x) {
  return x < 0 ? -1 : 1;
}

// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function slope3(that, x2, y2) {
  var h0 = that._x1 - that._x0,
      h1 = x2 - that._x1,
      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
      p = (s0 * h1 + s1 * h0) / (h0 + h1);
  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}

// Calculate a one-sided slope.
function slope2(that, t) {
  var h = that._x1 - that._x0;
  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}

// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function point(that, t0, t1) {
  var x0 = that._x0,
      y0 = that._y0,
      x1 = that._x1,
      y1 = that._y1,
      dx = (x1 - x0) / 3;
  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}

function MonotoneX(context) {
  this._context = context;
}

MonotoneX.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 =
    this._t0 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x1, this._y1); break;
      case 3: point(this, this._t0, slope2(this, this._t0)); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    var t1 = NaN;

    x = +x, y = +y;
    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; point(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
      default: point(this, this._t0, t1 = slope3(this, x, y)); break;
    }

    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
    this._t0 = t1;
  }
}

function MonotoneY(context) {
  this._context = new ReflectContext(context);
}

(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
  MonotoneX.prototype.point.call(this, y, x);
};

function ReflectContext(context) {
  this._context = context;
}

ReflectContext.prototype = {
  moveTo: function(x, y) { this._context.moveTo(y, x); },
  closePath: function() { this._context.closePath(); },
  lineTo: function(x, y) { this._context.lineTo(y, x); },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
};

function monotoneX(context) {
  return new MonotoneX(context);
}

function monotoneY(context) {
  return new MonotoneY(context);
}


/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function Natural(context) {
  this._context = context;
}

Natural.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [];
    this._y = [];
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        n = x.length;

    if (n) {
      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
      if (n === 2) {
        this._context.lineTo(x[1], y[1]);
      } else {
        var px = controlPoints(x),
            py = controlPoints(y);
        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
        }
      }
    }

    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
    this._line = 1 - this._line;
    this._x = this._y = null;
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function controlPoints(x) {
  var i,
      n = x.length - 1,
      m,
      a = new Array(n),
      b = new Array(n),
      r = new Array(n);
  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
  a[n - 1] = r[n - 1] / b[n - 1];
  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
  b[n - 1] = (x[n] + a[n - 1]) / 2;
  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
  return [a, b];
}

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new Natural(context);
});


/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = stepBefore;
/* harmony export (immutable) */ __webpack_exports__["b"] = stepAfter;
function Step(context, t) {
  this._context = context;
  this._t = t;
}

Step.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: {
        if (this._t <= 0) {
          this._context.lineTo(this._x, y);
          this._context.lineTo(x, y);
        } else {
          var x1 = this._x * (1 - this._t) + x * this._t;
          this._context.lineTo(x1, this._y);
          this._context.lineTo(x1, y);
        }
        break;
      }
    }
    this._x = x, this._y = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new Step(context, 0.5);
});

function stepBefore(context) {
  return new Step(context, 0);
}

function stepAfter(context) {
  return new Step(context, 1);
}


/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__offset_none__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__order_none__ = __webpack_require__(49);





function stackValue(d, key) {
  return d[key];
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var keys = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])([]),
      order = __WEBPACK_IMPORTED_MODULE_3__order_none__["a" /* default */],
      offset = __WEBPACK_IMPORTED_MODULE_2__offset_none__["a" /* default */],
      value = stackValue;

  function stack(data) {
    var kz = keys.apply(this, arguments),
        i,
        m = data.length,
        n = kz.length,
        sz = new Array(n),
        oz;

    for (i = 0; i < n; ++i) {
      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
        si[j] = sij = [0, +value(data[j], ki, j, data)];
        sij.data = data[j];
      }
      si.key = ki;
    }

    for (i = 0, oz = order(sz); i < n; ++i) {
      sz[oz[i]].index = i;
    }

    offset(sz, oz);
    return sz;
  }

  stack.keys = function(_) {
    return arguments.length ? (keys = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(_)), stack) : keys;
  };

  stack.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), stack) : value;
  };

  stack.order = function(_) {
    return arguments.length ? (order = _ == null ? __WEBPACK_IMPORTED_MODULE_3__order_none__["a" /* default */] : typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(_)), stack) : order;
  };

  stack.offset = function(_) {
    return arguments.length ? (offset = _ == null ? __WEBPACK_IMPORTED_MODULE_2__offset_none__["a" /* default */] : _, stack) : offset;
  };

  return stack;
});


/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(48);


/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series, order);
});


/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(series, order) {
  if (!((n = series.length) > 1)) return;
  for (var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j) {
    for (yp = yn = 0, i = 0; i < n; ++i) {
      if ((dy = (d = series[order[i]][j])[1] - d[0]) >= 0) {
        d[0] = yp, d[1] = yp += dy;
      } else if (dy < 0) {
        d[1] = yn, d[0] = yn += dy;
      } else {
        d[0] = yp;
      }
    }
  }
});


/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(48);


/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
    s0[j][1] += s0[j][0] = -y / 2;
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series, order);
});


/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(48);


/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
      var si = series[order[i]],
          sij0 = si[j][1] || 0,
          sij1 = si[j - 1][1] || 0,
          s3 = (sij0 - sij1) / 2;
      for (var k = 0; k < i; ++k) {
        var sk = series[order[k]],
            skj0 = sk[j][1] || 0,
            skj1 = sk[j - 1][1] || 0;
        s3 += skj0 - skj1;
      }
      s1 += sij0, s2 += s3 * sij0;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    if (s1) y -= s2 / s1;
  }
  s0[j - 1][1] += s0[j - 1][0] = y;
  Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series, order);
});


/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(104);


/* unused harmony default export */ var _unused_webpack_default_export = (function(series) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */])(series).reverse();
});


/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ascending__ = __webpack_require__(104);



/* unused harmony default export */ var _unused_webpack_default_export = (function(series) {
  var n = series.length,
      i,
      j,
      sums = series.map(__WEBPACK_IMPORTED_MODULE_1__ascending__["b" /* sum */]),
      order = Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series).sort(function(a, b) { return sums[b] - sums[a]; }),
      top = 0,
      bottom = 0,
      tops = [],
      bottoms = [];

  for (i = 0; i < n; ++i) {
    j = order[i];
    if (top < bottom) {
      top += sums[j];
      tops.push(j);
    } else {
      bottom += sums[j];
      bottoms.push(j);
    }
  }

  return bottoms.reverse().concat(tops);
});


/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(49);


/* unused harmony default export */ var _unused_webpack_default_export = (function(series) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series).reverse();
});


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(152),
    equalArrays = __webpack_require__(153),
    equalByTag = __webpack_require__(360),
    equalObjects = __webpack_require__(364),
    getTag = __webpack_require__(378),
    isArray = __webpack_require__(8),
    isBuffer = __webpack_require__(158),
    isTypedArray = __webpack_require__(160);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(64);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 353 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 354 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 355 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(64),
    Map = __webpack_require__(96),
    MapCache = __webpack_require__(94);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 357 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 358 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 359 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(45),
    Uint8Array = __webpack_require__(361),
    eq = __webpack_require__(95),
    equalArrays = __webpack_require__(153),
    mapToArray = __webpack_require__(362),
    setToArray = __webpack_require__(363);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(16);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 362 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 363 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(365);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(366),
    getSymbols = __webpack_require__(367),
    keys = __webpack_require__(106);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(156),
    isArray = __webpack_require__(8);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(157),
    stubArray = __webpack_require__(368);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 368 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(370),
    isArguments = __webpack_require__(107),
    isArray = __webpack_require__(8),
    isBuffer = __webpack_require__(158),
    isIndex = __webpack_require__(108),
    isTypedArray = __webpack_require__(160);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 370 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(27),
    isObjectLike = __webpack_require__(24);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 372 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(27),
    isLength = __webpack_require__(109),
    isObjectLike = __webpack_require__(24);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(133);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(159)(module)))

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(376),
    nativeKeys = __webpack_require__(377);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 376 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(161);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(379),
    Map = __webpack_require__(96),
    Promise = __webpack_require__(380),
    Set = __webpack_require__(381),
    WeakMap = __webpack_require__(382),
    baseGetTag = __webpack_require__(27),
    toSource = __webpack_require__(136);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(32),
    root = __webpack_require__(16);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(32),
    root = __webpack_require__(16);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(32),
    root = __webpack_require__(16);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(32),
    root = __webpack_require__(16);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = createAnimateManager;

var _setRafTimeout = __webpack_require__(384);

var _setRafTimeout2 = _interopRequireDefault(_setRafTimeout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

function createAnimateManager() {
  var currStyle = {};
  var handleChange = function handleChange() {
    return null;
  };
  var shouldStop = false;

  var setStyle = function setStyle(_style) {
    if (shouldStop) {
      return;
    }

    if (Array.isArray(_style)) {
      if (!_style.length) {
        return;
      }

      var styles = _style;

      var _styles = _toArray(styles),
          curr = _styles[0],
          restStyles = _styles.slice(1);

      if (typeof curr === 'number') {
        (0, _setRafTimeout2.default)(setStyle.bind(null, restStyles), curr);

        return;
      }

      setStyle(curr);
      (0, _setRafTimeout2.default)(setStyle.bind(null, restStyles));
      return;
    }

    if ((typeof _style === 'undefined' ? 'undefined' : _typeof(_style)) === 'object') {
      currStyle = _style;
      handleChange(currStyle);
    }

    if (typeof _style === 'function') {
      _style();
    }
  };

  return {
    stop: function stop() {
      shouldStop = true;
    },
    start: function start(style) {
      shouldStop = false;
      setStyle(style);
    },
    subscribe: function subscribe(_handleChange) {
      handleChange = _handleChange;

      return function () {
        handleChange = function handleChange() {
          return null;
        };
      };
    }
  };
}

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = setRafTimeout;

var _raf = __webpack_require__(162);

var _raf2 = _interopRequireDefault(_raf);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function setRafTimeout(callback) {
  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var currTime = -1;

  var shouldUpdate = function shouldUpdate(now) {
    if (currTime < 0) {
      currTime = now;
    }

    if (now - currTime > timeout) {
      callback(now);
      currTime = -1;
    } else {
      (0, _raf2.default)(shouldUpdate);
    }
  };

  (0, _raf2.default)(shouldUpdate);
}

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(386)))

/***/ }),
/* 386 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shallowEqual = undefined;

var _isPlainObject2 = __webpack_require__(163);

var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);

var _isEqual2 = __webpack_require__(19);

var _isEqual3 = _interopRequireDefault(_isEqual2);

var _isArray2 = __webpack_require__(8);

var _isArray3 = _interopRequireDefault(_isArray2);

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function shallowEqual(objA, objB) {
  if (objA === objB) {
    return true;
  }

  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = hasOwnProperty.bind(objB);
  for (var i = 0; i < keysA.length; i++) {
    var keyA = keysA[i];

    if (objA[keyA] === objB[keyA]) {
      continue;
    }

    // special diff with Array or Object
    if ((0, _isArray3.default)(objA[keyA])) {
      if (!(0, _isArray3.default)(objB[keyA]) || objA[keyA].length !== objB[keyA].length) {
        return false;
      } else if (!(0, _isEqual3.default)(objA[keyA], objB[keyA])) {
        return false;
      }
    } else if ((0, _isPlainObject3.default)(objA[keyA])) {
      if (!(0, _isPlainObject3.default)(objB[keyA]) || !(0, _isEqual3.default)(objA[keyA], objB[keyA])) {
        return false;
      }
    } else if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
      return false;
    }
  }

  return true;
}

function shallowCompare(instance, nextProps, nextState) {
  return !shallowEqual(instance.props, nextProps) || !shallowEqual(instance.state, nextState);
}

function shouldComponentUpdate(nextProps, nextState) {
  return shallowCompare(this, nextProps, nextState);
}
/* eslint-disable no-param-reassign */
function pureRenderDecorator(component) {
  component.prototype.shouldComponentUpdate = shouldComponentUpdate;
}
exports.shallowEqual = shallowEqual;
exports.default = pureRenderDecorator;

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(161);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(67),
    baseIntersection = __webpack_require__(390),
    baseRest = __webpack_require__(165),
    castArrayLikeObject = __webpack_require__(404);

/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */
var intersection = baseRest(function(arrays) {
  var mapped = arrayMap(arrays, castArrayLikeObject);
  return (mapped.length && mapped[0] === arrays[0])
    ? baseIntersection(mapped)
    : [];
});

module.exports = intersection;


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(154),
    arrayIncludes = __webpack_require__(391),
    arrayIncludesWith = __webpack_require__(396),
    arrayMap = __webpack_require__(67),
    baseUnary = __webpack_require__(110),
    cacheHas = __webpack_require__(155);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */
function baseIntersection(arrays, iteratee, comparator) {
  var includes = comparator ? arrayIncludesWith : arrayIncludes,
      length = arrays[0].length,
      othLength = arrays.length,
      othIndex = othLength,
      caches = Array(othLength),
      maxLength = Infinity,
      result = [];

  while (othIndex--) {
    var array = arrays[othIndex];
    if (othIndex && iteratee) {
      array = arrayMap(array, baseUnary(iteratee));
    }
    maxLength = nativeMin(array.length, maxLength);
    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
      ? new SetCache(othIndex && array)
      : undefined;
  }
  array = arrays[0];

  var index = -1,
      seen = caches[0];

  outer:
  while (++index < length && result.length < maxLength) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (!(seen
          ? cacheHas(seen, computed)
          : includes(result, computed, comparator)
        )) {
      othIndex = othLength;
      while (--othIndex) {
        var cache = caches[othIndex];
        if (!(cache
              ? cacheHas(cache, computed)
              : includes(arrays[othIndex], computed, comparator))
            ) {
          continue outer;
        }
      }
      if (seen) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseIntersection;


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(392);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(393),
    baseIsNaN = __webpack_require__(394),
    strictIndexOf = __webpack_require__(395);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 393 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 394 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 395 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 396 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(398);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 398 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(400),
    shortOut = __webpack_require__(403);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(401),
    defineProperty = __webpack_require__(402),
    identity = __webpack_require__(38);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 401 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(32);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 403 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLikeObject = __webpack_require__(405);

/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */
function castArrayLikeObject(value) {
  return isArrayLikeObject(value) ? value : [];
}

module.exports = castArrayLikeObject;


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(50),
    isObjectLike = __webpack_require__(24);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _filter2 = __webpack_require__(407);

var _filter3 = _interopRequireDefault(_filter2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _raf = __webpack_require__(162);

var _raf2 = _interopRequireDefault(_raf);

var _util = __webpack_require__(75);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var alpha = function alpha(begin, end, k) {
  return begin + (end - begin) * k;
};
var needContinue = function needContinue(_ref) {
  var from = _ref.from,
      to = _ref.to;
  return from !== to;
};

/*
 * @description: cal new from value and velocity in each stepper
 * @return: { [styleProperty]: { from, to, velocity } }
 */
var calStepperVals = function calStepperVals(easing, preVals, steps) {
  var nextStepVals = (0, _util.mapObject)(function (key, val) {
    if (needContinue(val)) {
      var _easing = easing(val.from, val.to, val.velocity),
          _easing2 = _slicedToArray(_easing, 2),
          newX = _easing2[0],
          newV = _easing2[1];

      return _extends({}, val, {
        from: newX,
        velocity: newV
      });
    }

    return val;
  }, preVals);

  if (steps < 1) {
    return (0, _util.mapObject)(function (key, val) {
      if (needContinue(val)) {
        return _extends({}, val, {
          velocity: alpha(val.velocity, nextStepVals[key].velocity, steps),
          from: alpha(val.from, nextStepVals[key].from, steps)
        });
      }

      return val;
    }, preVals);
  }

  return calStepperVals(easing, nextStepVals, steps - 1);
};

// configure update function

exports.default = function (from, to, easing, duration, render) {
  var interKeys = (0, _util.getIntersectionKeys)(from, to);
  var timingStyle = interKeys.reduce(function (res, key) {
    return _extends({}, res, _defineProperty({}, key, [from[key], to[key]]));
  }, {});

  var stepperStyle = interKeys.reduce(function (res, key) {
    return _extends({}, res, _defineProperty({}, key, {
      from: from[key],
      velocity: 0,
      to: to[key]
    }));
  }, {});
  var cafId = -1;
  var preTime = void 0;
  var beginTime = void 0;
  var update = function update() {
    return null;
  };

  var getCurrStyle = function getCurrStyle() {
    return (0, _util.mapObject)(function (key, val) {
      return val.from;
    }, stepperStyle);
  };
  var shouldStopAnimation = function shouldStopAnimation() {
    return !(0, _filter3.default)(stepperStyle, needContinue).length;
  };

  // stepper timing function like spring
  var stepperUpdate = function stepperUpdate(now) {
    if (!preTime) {
      preTime = now;
    }
    var deltaTime = now - preTime;
    var steps = deltaTime / easing.dt;

    stepperStyle = calStepperVals(easing, stepperStyle, steps);
    // get union set and add compatible prefix
    render(_extends({}, from, to, getCurrStyle(stepperStyle)));

    preTime = now;

    if (!shouldStopAnimation()) {
      cafId = (0, _raf2.default)(update);
    }
  };

  // t => val timing function like cubic-bezier
  var timingUpdate = function timingUpdate(now) {
    if (!beginTime) {
      beginTime = now;
    }

    var t = (now - beginTime) / duration;
    var currStyle = (0, _util.mapObject)(function (key, val) {
      return alpha.apply(undefined, _toConsumableArray(val).concat([easing(t)]));
    }, timingStyle);

    // get union set and add compatible prefix
    render(_extends({}, from, to, currStyle));

    if (t < 1) {
      cafId = (0, _raf2.default)(update);
    } else {
      var finalStyle = (0, _util.mapObject)(function (key, val) {
        return alpha.apply(undefined, _toConsumableArray(val).concat([easing(1)]));
      }, timingStyle);

      render(_extends({}, from, to, finalStyle));
    }
  };

  update = easing.isStepper ? stepperUpdate : timingUpdate;

  // return start animation method
  return function () {
    (0, _raf2.default)(update);

    // return stop animation method
    return function () {
      (0, _raf.cancel)(cafId);
    };
  };
};

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(157),
    baseFilter = __webpack_require__(408),
    baseIteratee = __webpack_require__(51),
    isArray = __webpack_require__(8);

/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 */
function filter(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = filter;


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(166);

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter(collection, predicate) {
  var result = [];
  baseEach(collection, function(value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

module.exports = baseFilter;


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(410),
    keys = __webpack_require__(106);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(411);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 411 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(50);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(414),
    getMatchData = __webpack_require__(415),
    matchesStrictComparable = __webpack_require__(168);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(152),
    baseIsEqual = __webpack_require__(105);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(167),
    keys = __webpack_require__(106);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(105),
    get = __webpack_require__(62),
    hasIn = __webpack_require__(417),
    isKey = __webpack_require__(93),
    isStrictComparable = __webpack_require__(167),
    matchesStrictComparable = __webpack_require__(168),
    toKey = __webpack_require__(68);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(418),
    hasPath = __webpack_require__(419);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 418 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(135),
    isArguments = __webpack_require__(107),
    isArray = __webpack_require__(8),
    isIndex = __webpack_require__(108),
    isLength = __webpack_require__(109),
    toKey = __webpack_require__(68);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(421),
    basePropertyDeep = __webpack_require__(422),
    isKey = __webpack_require__(93),
    toKey = __webpack_require__(68);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 421 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(134);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _TransitionGroup = __webpack_require__(424);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _AnimateGroupChild = __webpack_require__(426);

var _AnimateGroupChild2 = _interopRequireDefault(_AnimateGroupChild);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AnimateGroup = (_temp = _class = function (_Component) {
  _inherits(AnimateGroup, _Component);

  function AnimateGroup() {
    _classCallCheck(this, AnimateGroup);

    return _possibleConstructorReturn(this, (AnimateGroup.__proto__ || Object.getPrototypeOf(AnimateGroup)).apply(this, arguments));
  }

  _createClass(AnimateGroup, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          component = _props.component,
          children = _props.children,
          appear = _props.appear,
          enter = _props.enter,
          leave = _props.leave;


      return _react2.default.createElement(
        _TransitionGroup2.default,
        { component: component },
        _react.Children.map(children, function (child, index) {
          return _react2.default.createElement(
            _AnimateGroupChild2.default,
            {
              appearOptions: appear,
              enterOptions: enter,
              leaveOptions: leave,
              key: 'child-' + index
            },
            child
          );
        })
      );
    }
  }]);

  return AnimateGroup;
}(_react.Component), _class.propTypes = {
  appear: _propTypes2.default.object,
  enter: _propTypes2.default.object,
  leave: _propTypes2.default.object,

  children: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.element]),
  component: _propTypes2.default.any
}, _class.defaultProps = {
  component: 'span'
}, _temp);
exports.default = AnimateGroup;

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ChildMapping = __webpack_require__(425);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var propTypes = {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   */
  component: _propTypes2.default.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   */
  children: _propTypes2.default.node,

  /**
   * A convenience prop that enables or disabled appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes2.default.bool,
  /**
   * A convenience prop that enables or disabled enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes2.default.bool,
  /**
    * A convenience prop that enables or disabled exit animations
    * for all children. Note that specifying this will override any defaults set
    * on individual children Transitions.
    */
  exit: _propTypes2.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes2.default.func
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
};

/**
 * The `<TransitionGroup>` component manages a set of `<Transition>` components
 * in a list. Like with the `<Transition>` component, `<TransitionGroup>`, is a
 * state machine for managing the mounting and unmounting of components over
 * time.
 *
 * Consider the example below using the `Fade` CSS transition from before.
 * As items are removed or added to the TodoList the `in` prop is toggled
 * automatically by the `<TransitionGroup>`. You can use _any_ `<Transition>`
 * component in a `<TransitionGroup>`, not just css.
 *
 * ```jsx
 * import TransitionGroup from 'react-transition-group/TransitionGroup';
 *
 * class TodoList extends React.Component {
 *   constructor(props) {
 *     super(props)
 *     this.state = {items: ['hello', 'world', 'click', 'me']}
 *   }
 *   handleAdd() {
 *     const newItems = this.state.items.concat([
 *       prompt('Enter some text')
 *     ]);
 *     this.setState({ items: newItems });
 *   }
 *   handleRemove(i) {
 *     let newItems = this.state.items.slice();
 *     newItems.splice(i, 1);
 *     this.setState({items: newItems});
 *   }
 *   render() {
 *     return (
 *       <div>
 *         <button onClick={() => this.handleAdd()}>Add Item</button>
 *         <TransitionGroup>
 *           {this.state.items.map((item, i) => (
 *             <FadeTransition key={item}>
 *               <div>
 *                 {item}{' '}
 *                 <button onClick={() => this.handleRemove(i)}>
 *                   remove
 *                 </button>
 *               </div>
 *             </FadeTransition>
 *           ))}
 *         </TransitionGroup>
 *       </div>
 *     );
 *   }
 * }
 * ```
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual `<Transition>`
 * components. This means you can mix and match animations across different
 * list items.
 */

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    // Initial children should all be entering, dependent on appear
    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.handleExited = function (key, node, originalHandler) {
      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (key in currentChildMapping) return;

      if (originalHandler) originalHandler(node);

      _this.setState(function (state) {
        var children = _extends({}, state.children);

        delete children[key];
        return { children: children };
      });
    };

    _this.state = {
      children: (0, _ChildMapping.getChildMapping)(props.children, function (child) {
        var onExited = function onExited(node) {
          _this.handleExited(child.key, node, child.props.onExited);
        };

        return (0, _react.cloneElement)(child, {
          onExited: onExited,
          in: true,
          appear: _this.getProp(child, 'appear'),
          enter: _this.getProp(child, 'enter'),
          exit: _this.getProp(child, 'exit')
        });
      })
    };
    return _this;
  }

  TransitionGroup.prototype.getChildContext = function getChildContext() {
    return {
      transitionGroup: { isMounting: !this.appeared }
    };
  };
  // use child config unless explictly set by the Group


  TransitionGroup.prototype.getProp = function getProp(child, prop) {
    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.props;

    return props[prop] != null ? props[prop] : child.props[prop];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    this.appeared = true;
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this2 = this;

    var prevChildMapping = this.state.children;
    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);

    var children = (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping);

    Object.keys(children).forEach(function (key) {
      var child = children[key];

      if (!(0, _react.isValidElement)(child)) return;

      var onExited = function onExited(node) {
        _this2.handleExited(child.key, node, child.props.onExited);
      };

      var hasPrev = key in prevChildMapping;
      var hasNext = key in nextChildMapping;

      var prevChild = prevChildMapping[key];
      var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in;

      // item is new (entering)
      if (hasNext && (!hasPrev || isLeaving)) {
        // console.log('entering', key)
        children[key] = (0, _react.cloneElement)(child, {
          onExited: onExited,
          in: true,
          exit: _this2.getProp(child, 'exit', nextProps),
          enter: _this2.getProp(child, 'enter', nextProps)
        });
      }
      // item is old (exiting)
      else if (!hasNext && hasPrev && !isLeaving) {
          // console.log('leaving', key)
          children[key] = (0, _react.cloneElement)(child, { in: false });
        }
        // item hasn't changed transition states
        // copy over the last transition props;
        else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
            // console.log('unchanged', key)
            children[key] = (0, _react.cloneElement)(child, {
              onExited: onExited,
              in: prevChild.props.in,
              exit: _this2.getProp(child, 'exit', nextProps),
              enter: _this2.getProp(child, 'enter', nextProps)
            });
          }
    });

    this.setState({ children: children });
  };

  TransitionGroup.prototype.render = function render() {
    var _props = this.props,
        Component = _props.component,
        childFactory = _props.childFactory,
        props = _objectWithoutProperties(_props, ['component', 'childFactory']);

    var children = this.state.children;


    delete props.appear;
    delete props.enter;
    delete props.exit;

    return _react2.default.createElement(
      Component,
      props,
      values(children).map(childFactory)
    );
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes2.default.object.isRequired
};


TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = TransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = Object.create(null);

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isNumber2 = __webpack_require__(97);

var _isNumber3 = _interopRequireDefault(_isNumber2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Transition = __webpack_require__(427);

var _Transition2 = _interopRequireDefault(_Transition);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Animate = __webpack_require__(151);

var _Animate2 = _interopRequireDefault(_Animate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var parseDurationOfSingleTransition = function parseDurationOfSingleTransition() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var steps = options.steps,
      duration = options.duration;


  if (steps && steps.length) {
    return steps.reduce(function (result, entry) {
      return result + ((0, _isNumber3.default)(entry.duration) && entry.duration > 0 ? entry.duration : 0);
    }, 0);
  }

  if ((0, _isNumber3.default)(duration)) {
    return duration;
  }

  return 0;
};

var AnimateGroupChild = (_temp2 = _class = function (_Component) {
  _inherits(AnimateGroupChild, _Component);

  function AnimateGroupChild() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AnimateGroupChild);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AnimateGroupChild.__proto__ || Object.getPrototypeOf(AnimateGroupChild)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isActive: false
    }, _this.handleEnter = function (node, isAppearing) {
      var _this$props = _this.props,
          appearOptions = _this$props.appearOptions,
          enterOptions = _this$props.enterOptions;


      _this.handleStyleActive(isAppearing ? appearOptions : enterOptions);
    }, _this.handleExit = function () {
      _this.handleStyleActive(_this.props.leaveOptions);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AnimateGroupChild, [{
    key: 'handleStyleActive',
    value: function handleStyleActive(style) {
      if (style) {
        var onAnimationEnd = style.onAnimationEnd ? function () {
          style.onAnimationEnd();
        } : null;

        this.setState(_extends({}, style, {
          onAnimationEnd: onAnimationEnd,
          isActive: true
        }));
      }
    }
  }, {
    key: 'parseTimeout',
    value: function parseTimeout() {
      var _props = this.props,
          appearOptions = _props.appearOptions,
          enterOptions = _props.enterOptions,
          leaveOptions = _props.leaveOptions;


      return parseDurationOfSingleTransition(appearOptions) + parseDurationOfSingleTransition(enterOptions) + parseDurationOfSingleTransition(leaveOptions);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          children = _props2.children,
          appearOptions = _props2.appearOptions,
          enterOptions = _props2.enterOptions,
          leaveOptions = _props2.leaveOptions,
          props = _objectWithoutProperties(_props2, ['children', 'appearOptions', 'enterOptions', 'leaveOptions']);

      return _react2.default.createElement(
        _Transition2.default,
        _extends({}, props, {
          onEnter: this.handleEnter,
          onExit: this.handleExit,
          timeout: this.parseTimeout()
        }),
        function (transitionState) {
          return _react2.default.createElement(
            _Animate2.default,
            _this2.state,
            _react.Children.only(children)
          );
        }
      );
    }
  }]);

  return AnimateGroupChild;
}(_react.Component), _class.propTypes = {
  appearOptions: _propTypes2.default.object,
  enterOptions: _propTypes2.default.object,
  leaveOptions: _propTypes2.default.object,
  children: _propTypes2.default.element
}, _temp2);
exports.default = AnimateGroupChild;

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;

var _propTypes = __webpack_require__(1);

var PropTypes = _interopRequireWildcard(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(22);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _PropTypes = __webpack_require__(428);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UNMOUNTED = exports.UNMOUNTED = 'unmounted';
var EXITED = exports.EXITED = 'exited';
var ENTERING = exports.ENTERING = 'entering';
var ENTERED = exports.ENTERED = 'entered';
var EXITING = exports.EXITING = 'exiting';

/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the components.
 * It's up to you to give meaning and effect to those states. For example we can
 * add styles to a component when it enters or exits:
 *
 * ```jsx
 * import Transition from 'react-transition-group/Transition';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {(state) => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm A fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
 * What it does do is track transition states over time so you can update the
 * component (such as by adding styles or classes) when it changes states.
 *
 * There are 4 main states a Transition can be in:
 *  - `ENTERING`
 *  - `ENTERED`
 *  - `EXITING`
 *  - `EXITED`
 *
 * Transition state is toggled via the `in` prop. When `true` the component begins the
 * "Enter" stage. During this stage, the component will shift from its current transition state,
 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
 * it's complete. Let's take the following example:
 *
 * ```jsx
 * state= { in: false };
 *
 * toggleEnterState = () => {
 *   this.setState({ in: true });
 * }
 *
 * render() {
 *   return (
 *     <div>
 *       <Transition in={this.state.in} timeout={500} />
 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state and
 * stay there for 500ms (the value of `timeout`) when finally switches to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
 */

var Transition = function (_React$Component) {
  _inherits(Transition, _React$Component);

  function Transition(props, context) {
    _classCallCheck(this, Transition);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    var parentGroup = context.transitionGroup;
    // In the context of a TransitionGroup all enters are really appears
    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;

    var initialStatus = void 0;
    _this.nextStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.nextStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = { status: initialStatus };

    _this.nextCallback = null;
    return _this;
  }

  Transition.prototype.getChildContext = function getChildContext() {
    return { transitionGroup: null }; // allows for nested Transitions
  };

  Transition.prototype.componentDidMount = function componentDidMount() {
    this.updateStatus(true);
  };

  Transition.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _ref = this.pendingState || this.state,
        status = _ref.status;

    if (nextProps.in) {
      if (status === UNMOUNTED) {
        this.setState({ status: EXITED });
      }
      if (status !== ENTERING && status !== ENTERED) {
        this.nextStatus = ENTERING;
      }
    } else {
      if (status === ENTERING || status === ENTERED) {
        this.nextStatus = EXITING;
      }
    }
  };

  Transition.prototype.componentDidUpdate = function componentDidUpdate() {
    this.updateStatus();
  };

  Transition.prototype.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  Transition.prototype.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;

    var exit = void 0,
        enter = void 0,
        appear = void 0;

    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter;
      appear = timeout.appear;
    }
    return { exit: exit, enter: enter, appear: appear };
  };

  Transition.prototype.updateStatus = function updateStatus() {
    var mounting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var nextStatus = this.nextStatus;

    if (nextStatus !== null) {
      this.nextStatus = null;
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();
      var node = _reactDom2.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({ status: UNMOUNTED });
    }
  };

  Transition.prototype.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;

    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;

    var timeouts = this.getTimeouts();

    // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set
    if (!mounting && !enter) {
      this.safeSetState({ status: ENTERED }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);

    this.safeSetState({ status: ENTERING }, function () {
      _this2.props.onEntering(node, appearing);

      // FIXME: appear timeout?
      _this2.onTransitionEnd(node, timeouts.enter, function () {
        _this2.safeSetState({ status: ENTERED }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  Transition.prototype.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;

    var timeouts = this.getTimeouts();

    // no exit animation skip right to EXITED
    if (!exit) {
      this.safeSetState({ status: EXITED }, function () {
        _this3.props.onExited(node);
      });
      return;
    }
    this.props.onExit(node);

    this.safeSetState({ status: EXITING }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({ status: EXITED }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  Transition.prototype.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  Transition.prototype.safeSetState = function safeSetState(nextState, callback) {
    var _this4 = this;

    // We need to track pending updates for instances where a cWRP fires quickly
    // after cDM and before the state flushes, which would double trigger a
    // transition
    this.pendingState = nextState;

    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, function () {
      _this4.pendingState = null;
      callback();
    });
  };

  Transition.prototype.setNextCallback = function setNextCallback(callback) {
    var _this5 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this5.nextCallback = null;

        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  Transition.prototype.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);

    if (node) {
      if (this.props.addEndListener) {
        this.props.addEndListener(node, this.nextCallback);
      }
      if (timeout != null) {
        setTimeout(this.nextCallback, timeout);
      }
    } else {
      setTimeout(this.nextCallback, 0);
    }
  };

  Transition.prototype.render = function render() {
    var status = this.state.status;
    if (status === UNMOUNTED) {
      return null;
    }

    var _props = this.props,
        children = _props.children,
        childProps = _objectWithoutProperties(_props, ['children']);
    // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react2.default.Children.only(children);
    return _react2.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react2.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};


Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element.
   * This function is called with the current transition status
   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can used
   * to apply context specific props to a component.
   *
   * ```jsx
   * <Transition timeout={150}>
   *   {(status) => (
   *     <MyComponent className={`fade fade-${status}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEventListener` is provided
   *
   * You may specify a single timeout for all transitions like: `timeout={500}`,
   * or individually like:
   *
   * ```jsx
   * timeout={{
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * @type {number | { enter?: number, exit?: number }}
   */
  timeout: function timeout(props) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;
    return pt.apply(undefined, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {};

// Name the function so it is clearer in the documentation
function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,

  onEnter: noop,
  onEntering: noop,
  onEntered: noop,

  onExit: noop,
  onExiting: noop,
  onExited: noop
};

Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

exports.default = Transition;

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var timeoutsShape = exports.timeoutsShape = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
  enter: _propTypes2.default.number,
  exit: _propTypes2.default.number
}).isRequired]);

var classNamesShape = exports.classNamesShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  exit: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  exit: _propTypes2.default.string,
  exitActive: _propTypes2.default.string
})]);

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isArray__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_PureRender__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_DataUtils__ = __webpack_require__(6);
 /**
                                        * @fileOverview Default Tooltip Content
                                        */

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var defaultFormatter = function defaultFormatter(value) {
  return __WEBPACK_IMPORTED_MODULE_0_lodash_isArray___default()(value) && Object(__WEBPACK_IMPORTED_MODULE_4__util_DataUtils__["f" /* isNumOrStr */])(value[0]) && Object(__WEBPACK_IMPORTED_MODULE_4__util_DataUtils__["f" /* isNumOrStr */])(value[1]) ? value.join(' ~ ') : value;
};

var DefaultTooltipContent = Object(__WEBPACK_IMPORTED_MODULE_3__util_PureRender__["a" /* default */])(_class = (_temp = _class2 = function (_Component) {
  _inherits(DefaultTooltipContent, _Component);

  function DefaultTooltipContent() {
    _classCallCheck(this, DefaultTooltipContent);

    return _possibleConstructorReturn(this, (DefaultTooltipContent.__proto__ || Object.getPrototypeOf(DefaultTooltipContent)).apply(this, arguments));
  }

  _createClass(DefaultTooltipContent, [{
    key: 'renderContent',
    value: function renderContent() {
      var _props = this.props,
          payload = _props.payload,
          separator = _props.separator,
          formatter = _props.formatter,
          itemStyle = _props.itemStyle,
          itemSorter = _props.itemSorter;


      if (payload && payload.length) {
        var listStyle = { padding: 0, margin: 0 };

        var items = payload.sort(itemSorter).map(function (entry, i) {
          var finalItemStyle = _extends({
            display: 'block',
            paddingTop: 4,
            paddingBottom: 4,
            color: entry.color || '#000'
          }, itemStyle);
          var hasName = Object(__WEBPACK_IMPORTED_MODULE_4__util_DataUtils__["f" /* isNumOrStr */])(entry.name);
          var finalFormatter = entry.formatter || formatter || defaultFormatter;

          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'li',
            { className: 'recharts-tooltip-item', key: 'tooltip-item-' + i, style: finalItemStyle },
            hasName ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              { className: 'recharts-tooltip-item-name' },
              entry.name
            ) : null,
            hasName ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              { className: 'recharts-tooltip-item-separator' },
              separator
            ) : null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              { className: 'recharts-tooltip-item-value' },
              finalFormatter ? finalFormatter(entry.value, entry.name, entry, i) : entry.value
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              { className: 'recharts-tooltip-item-unit' },
              entry.unit || ''
            )
          );
        });

        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'ul',
          { className: 'recharts-tooltip-item-list', style: listStyle },
          items
        );
      }

      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          labelStyle = _props2.labelStyle,
          label = _props2.label,
          labelFormatter = _props2.labelFormatter,
          wrapperStyle = _props2.wrapperStyle;

      var finalStyle = _extends({
        margin: 0,
        padding: 10,
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        whiteSpace: 'nowrap'
      }, wrapperStyle);
      var finalLabelStyle = _extends({
        margin: 0
      }, labelStyle);
      var hasLabel = Object(__WEBPACK_IMPORTED_MODULE_4__util_DataUtils__["f" /* isNumOrStr */])(label);
      var finalLabel = hasLabel ? label : '';

      if (hasLabel && labelFormatter) {
        finalLabel = labelFormatter(label);
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'recharts-default-tooltip', style: finalStyle },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          { className: 'recharts-tooltip-label', style: finalLabelStyle },
          finalLabel
        ),
        this.renderContent()
      );
    }
  }]);

  return DefaultTooltipContent;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class2.displayName = 'DefaultTooltipContent', _class2.propTypes = {
  separator: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  formatter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  wrapperStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  itemStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  labelStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  labelFormatter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  label: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
  payload: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    name: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
    value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array]),
    unit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any
  })),
  itemSorter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
}, _class2.defaultProps = {
  separator: ' : ',
  itemStyle: {},
  labelStyle: {}
}, _temp)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (DefaultTooltipContent);

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_resize_detector__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_resize_detector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_resize_detector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_DataUtils__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_LogUtils__ = __webpack_require__(171);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Wrapper component to make charts adapt to the size of parent * DOM
 */








var ResponsiveContainer = (_temp = _class = function (_Component) {
  _inherits(ResponsiveContainer, _Component);

  function ResponsiveContainer(props) {
    _classCallCheck(this, ResponsiveContainer);

    var _this = _possibleConstructorReturn(this, (ResponsiveContainer.__proto__ || Object.getPrototypeOf(ResponsiveContainer)).call(this, props));

    _this.updateDimensionsImmediate = function () {
      if (!_this.mounted) {
        return;
      }

      var newSize = _this.getContainerSize();

      if (newSize) {
        var _this$state = _this.state,
            oldWidth = _this$state.containerWidth,
            oldHeight = _this$state.containerHeight;
        var containerWidth = newSize.containerWidth,
            containerHeight = newSize.containerHeight;


        if (containerWidth !== oldWidth || containerHeight !== oldHeight) {
          _this.setState({ containerWidth: containerWidth, containerHeight: containerHeight });
        }
      }
    };

    _this.state = {
      containerWidth: -1,
      containerHeight: -1
    };

    _this.handleResize = props.debounce > 0 ? __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(_this.updateDimensionsImmediate, props.debounce) : _this.updateDimensionsImmediate;
    return _this;
  }

  /* eslint-disable  react/no-did-mount-set-state */


  _createClass(ResponsiveContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.mounted = true;

      var size = this.getContainerSize();

      if (size) {
        this.setState(size);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: 'getContainerSize',
    value: function getContainerSize() {
      if (!this.container) {
        return null;
      }

      return {
        containerWidth: this.container.clientWidth,
        containerHeight: this.container.clientHeight
      };
    }
  }, {
    key: 'renderChart',
    value: function renderChart() {
      var _state = this.state,
          containerWidth = _state.containerWidth,
          containerHeight = _state.containerHeight;


      if (containerWidth < 0 || containerHeight < 0) {
        return null;
      }

      var _props = this.props,
          aspect = _props.aspect,
          width = _props.width,
          height = _props.height,
          minWidth = _props.minWidth,
          minHeight = _props.minHeight,
          maxHeight = _props.maxHeight,
          children = _props.children;


      Object(__WEBPACK_IMPORTED_MODULE_6__util_LogUtils__["a" /* warn */])(Object(__WEBPACK_IMPORTED_MODULE_5__util_DataUtils__["h" /* isPercent */])(width) || Object(__WEBPACK_IMPORTED_MODULE_5__util_DataUtils__["h" /* isPercent */])(height), 'The width(%s) and height(%s) are both fixed numbers,\n       maybe you don\'t need to use a ResponsiveContainer.', width, height);

      Object(__WEBPACK_IMPORTED_MODULE_6__util_LogUtils__["a" /* warn */])(!aspect || aspect > 0, 'The aspect(%s) must be greater than zero.', aspect);

      var calculatedWidth = Object(__WEBPACK_IMPORTED_MODULE_5__util_DataUtils__["h" /* isPercent */])(width) ? containerWidth : width;
      var calculatedHeight = Object(__WEBPACK_IMPORTED_MODULE_5__util_DataUtils__["h" /* isPercent */])(height) ? containerHeight : height;

      if (aspect && aspect > 0) {
        // Preserve the desired aspect ratio
        calculatedHeight = calculatedWidth / aspect;
        // if maxHeight is set, overwrite if calculatedHeight is greater than maxHeight
        if (maxHeight && calculatedHeight > maxHeight) {
          calculatedHeight = maxHeight;
        }
      }

      Object(__WEBPACK_IMPORTED_MODULE_6__util_LogUtils__["a" /* warn */])(calculatedWidth > 0 || calculatedHeight > 0, 'The width(%s) and height(%s) of chart should be greater than 0,\n       please check the style of container, or the props width(%s) and height(%s),\n       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the\n       height and width.', calculatedWidth, calculatedHeight, width, height, minWidth, minHeight, aspect);

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(children, {
        width: calculatedWidth,
        height: calculatedHeight
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          minWidth = _props2.minWidth,
          minHeight = _props2.minHeight,
          width = _props2.width,
          height = _props2.height,
          maxHeight = _props2.maxHeight,
          id = _props2.id,
          className = _props2.className;

      var style = { width: width, height: height, minWidth: minWidth, minHeight: minHeight, maxHeight: maxHeight };

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        {
          id: id,
          className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('recharts-responsive-container', className),
          style: style,
          ref: function ref(node) {
            _this2.container = node;
          }
        },
        this.renderChart(),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_resize_detector___default.a, { handleWidth: true, handleHeight: true, onResize: this.handleResize })
      );
    }
  }]);

  return ResponsiveContainer;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class.displayName = 'ResponsiveContainer', _class.propTypes = {
  aspect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  width: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
  height: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
  minHeight: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
  minWidth: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
  maxHeight: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node.isRequired,
  debounce: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
  className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number])
}, _class.defaultProps = {
  width: '100%',
  height: '100%',
  debounce: 0
}, _temp);


/* harmony default export */ __webpack_exports__["a"] = (ResponsiveContainer);

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(16);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ResizeDetector = __webpack_require__(433);

var _ResizeDetector2 = _interopRequireDefault(_ResizeDetector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ResizeDetector2.default;

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _resizeDetectorStyles = __webpack_require__(434);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ResizeDetector = function (_Component) {
  _inherits(ResizeDetector, _Component);

  function ResizeDetector() {
    _classCallCheck(this, ResizeDetector);

    var _this = _possibleConstructorReturn(this, (ResizeDetector.__proto__ || Object.getPrototypeOf(ResizeDetector)).call(this));

    _this.state = {
      expandChildHeight: 0,
      expandChildWidth: 0,
      expandScrollLeft: 0,
      expandScrollTop: 0,
      shrinkScrollTop: 0,
      shrinkScrollLeft: 0,
      lastWidth: 0,
      lastHeight: 0
    };

    _this.reset = _this.reset.bind(_this);
    _this.handleScroll = _this.handleScroll.bind(_this);
    return _this;
  }

  _createClass(ResizeDetector, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.forceUpdate();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _containerSize = this.containerSize(),
          _containerSize2 = _slicedToArray(_containerSize, 2),
          width = _containerSize2[0],
          height = _containerSize2[1];

      this.reset(width, height);
      this.props.onResize(width, height);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return this.props !== nextProps || this.state !== nextState;
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.expand.scrollLeft = this.expand.scrollWidth;
      this.expand.scrollTop = this.expand.scrollHeight;

      this.shrink.scrollLeft = this.shrink.scrollWidth;
      this.shrink.scrollTop = this.shrink.scrollHeight;
    }
  }, {
    key: 'containerSize',
    value: function containerSize() {
      return [this.props.handleWidth && this.container.parentElement.offsetWidth, this.props.handleHeight && this.container.parentElement.offsetHeight];
    }
  }, {
    key: 'reset',
    value: function reset(containerWidth, containerHeight) {
      if (typeof window === 'undefined') {
        return;
      }

      var parent = this.container.parentElement;

      var position = 'static';
      if (parent.currentStyle) {
        position = parent.currentStyle.position;
      } else if (window.getComputedStyle) {
        position = window.getComputedStyle(parent).position;
      }
      if (position === 'static') {
        parent.style.position = 'relative';
      }

      this.setState({
        expandChildHeight: this.expand.offsetHeight + 10,
        expandChildWidth: this.expand.offsetWidth + 10,
        lastWidth: containerWidth,
        lastHeight: containerHeight
      });
    }
  }, {
    key: 'handleScroll',
    value: function handleScroll(e) {
      if (typeof window === 'undefined') {
        return;
      }

      e.preventDefault();
      e.stopPropagation();

      var state = this.state;

      var _containerSize3 = this.containerSize(),
          _containerSize4 = _slicedToArray(_containerSize3, 2),
          width = _containerSize4[0],
          height = _containerSize4[1];

      if (width !== state.lastWidth || height !== state.lastHeight) {
        this.props.onResize(width, height);
      }

      this.reset(width, height);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var state = this.state;


      var expandStyle = _extends({}, _resizeDetectorStyles.expandChildStyle, {
        width: state.expandChildWidth,
        height: state.expandChildHeight
      });

      return _react2.default.createElement(
        'div',
        { style: _resizeDetectorStyles.parentStyle, ref: function ref(e) {
            _this2.container = e;
          } },
        _react2.default.createElement(
          'div',
          { style: _resizeDetectorStyles.parentStyle, onScroll: this.handleScroll, ref: function ref(e) {
              _this2.expand = e;
            } },
          _react2.default.createElement('div', { style: expandStyle })
        ),
        _react2.default.createElement(
          'div',
          { style: _resizeDetectorStyles.parentStyle, onScroll: this.handleScroll, ref: function ref(e) {
              _this2.shrink = e;
            } },
          _react2.default.createElement('div', { style: _resizeDetectorStyles.shrinkChildStyle })
        )
      );
    }
  }]);

  return ResizeDetector;
}(_react.Component);

exports.default = ResizeDetector;


ResizeDetector.propTypes = {
  handleWidth: _propTypes2.default.bool,
  handleHeight: _propTypes2.default.bool,
  onResize: _propTypes2.default.func
};

ResizeDetector.defaultProps = {
  handleWidth: false,
  handleHeight: false,
  onResize: function onResize(e) {
    return e;
  }
};

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var parentStyle = exports.parentStyle = {
  position: 'absolute',
  left: 0,
  top: 0,
  right: 0,
  bottom: 0,
  overflow: 'hidden',
  zIndex: -1,
  visibility: 'hidden'
};

var shrinkChildStyle = exports.shrinkChildStyle = {
  position: 'absolute',
  left: 0,
  top: 0,
  width: '200%',
  height: '200%'
};

var expandChildStyle = exports.expandChildStyle = {
  position: 'absolute',
  left: 0,
  top: 0,
  width: '100%',
  height: '100%'
};

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies
 */
var balanced = __webpack_require__(436)
var reduceFunctionCall = __webpack_require__(437)
var mexp = __webpack_require__(439)

/**
 * Constantes
 */
var MAX_STACK = 100 // should be enough for a single calc()...
var NESTED_CALC_RE = /(\+|\-|\*|\\|[^a-z]|)(\s*)(\()/g

/**
 * Global variables
 */
var stack

/**
 * Expose reduceCSSCalc plugin
 *
 * @type {Function}
 */
module.exports = reduceCSSCalc

/**
 * Reduce CSS calc() in a string, whenever it's possible
 *
 * @param {String} value css input
 */
function reduceCSSCalc(value, decimalPrecision) {
  stack = 0
  decimalPrecision = Math.pow(10, decimalPrecision === undefined ? 5 : decimalPrecision)

  // Allow calc() on multiple lines
  value = value.replace(/\n+/g, " ")

  /**
   * Evaluates an expression
   *
   * @param {String} expression
   * @returns {String}
   */
  function evaluateExpression (expression, functionIdentifier, call) {
    if (stack++ > MAX_STACK) {
      stack = 0
      throw new Error("Call stack overflow for " + call)
    }

    if (expression === "") {
      throw new Error(functionIdentifier + "(): '" + call + "' must contain a non-whitespace string")
    }

    expression = evaluateNestedExpression(expression, call)

    var units = getUnitsInExpression(expression)

    // If the expression contains multiple units or CSS variables,
    // then let the expression be (i.e. browser calc())
    if (units.length > 1 || expression.indexOf("var(") > -1) {
      return functionIdentifier + "(" + expression + ")"
    }

    var unit = units[0] || ""

    if (unit === "%") {
      // Convert percentages to numbers, to handle expressions like: 50% * 50% (will become: 25%):
      // console.log(expression)
      expression = expression.replace(/\b[0-9\.]+%/g, function(percent) {
        return parseFloat(percent.slice(0, -1)) * 0.01
      })
    }

    // Remove units in expression:
    var toEvaluate = expression.replace(new RegExp(unit, "gi"), "")
    var result

    try {
      result = mexp.eval(toEvaluate)
    }
    catch (e) {
      return functionIdentifier + "(" + expression + ")"
    }

    // Transform back to a percentage result:
    if (unit === "%") {
      result *= 100
    }

    // adjust rounding shit
    // (0.1 * 0.2 === 0.020000000000000004)
    if (functionIdentifier.length || unit === "%") {
      result = Math.round(result * decimalPrecision) / decimalPrecision
    }

    // Add unit
    result += unit

    return result
  }

  /**
   * Evaluates nested expressions
   *
   * @param {String} expression
   * @returns {String}
   */
  function evaluateNestedExpression(expression, call) {
    // Remove the calc part from nested expressions to ensure
    // better browser compatibility
    expression = expression.replace(/((?:\-[a-z]+\-)?calc)/g, "")
    var evaluatedPart = ""
    var nonEvaluatedPart = expression
    var matches
    while ((matches = NESTED_CALC_RE.exec(nonEvaluatedPart))) {
      if (matches[0].index > 0) {
        evaluatedPart += nonEvaluatedPart.substring(0, matches[0].index)
      }

      var balancedExpr = balanced("(", ")", nonEvaluatedPart.substring([0].index))
      if (balancedExpr.body === "") {
        throw new Error("'" + expression + "' must contain a non-whitespace string")
      }

      var evaluated = evaluateExpression(balancedExpr.body, "", call)

      evaluatedPart += balancedExpr.pre + evaluated
      nonEvaluatedPart = balancedExpr.post
    }

    return evaluatedPart + nonEvaluatedPart
  }

  return reduceFunctionCall(value, /((?:\-[a-z]+\-)?calc)\(/, evaluateExpression)
}

/**
 * Checks what units are used in an expression
 *
 * @param {String} expression
 * @returns {Array}
 */

function getUnitsInExpression(expression) {
  var uniqueUnits = []
  var uniqueLowerCaseUnits = []
  var unitRegEx = /[\.0-9]([%a-z]+)/gi
  var matches = unitRegEx.exec(expression)

  while (matches) {
    if (!matches || !matches[1]) {
      continue
    }

    if (uniqueLowerCaseUnits.indexOf(matches[1].toLowerCase()) === -1) {
      uniqueUnits.push(matches[1])
      uniqueLowerCaseUnits.push(matches[1].toLowerCase())
    }

    matches = unitRegEx.exec(expression)
  }

  return uniqueUnits
}


/***/ }),
/* 436 */
/***/ (function(module, exports) {

module.exports = balanced;
function balanced(a, b, str) {
  if (a instanceof RegExp) a = maybeMatch(a, str);
  if (b instanceof RegExp) b = maybeMatch(b, str);

  var r = range(a, b, str);

  return r && {
    start: r[0],
    end: r[1],
    pre: str.slice(0, r[0]),
    body: str.slice(r[0] + a.length, r[1]),
    post: str.slice(r[1] + b.length)
  };
}

function maybeMatch(reg, str) {
  var m = str.match(reg);
  return m ? m[0] : null;
}

balanced.range = range;
function range(a, b, str) {
  var begs, beg, left, right, result;
  var ai = str.indexOf(a);
  var bi = str.indexOf(b, ai + 1);
  var i = ai;

  if (ai >= 0 && bi > 0) {
    begs = [];
    left = str.length;

    while (i >= 0 && !result) {
      if (i == ai) {
        begs.push(i);
        ai = str.indexOf(a, i + 1);
      } else if (begs.length == 1) {
        result = [ begs.pop(), bi ];
      } else {
        beg = begs.pop();
        if (beg < left) {
          left = beg;
          right = bi;
        }

        bi = str.indexOf(b, i + 1);
      }

      i = ai < bi && ai >= 0 ? ai : bi;
    }

    if (begs.length) {
      result = [ left, right ];
    }
  }

  return result;
}


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * Module dependencies
 */
var balanced = __webpack_require__(438)

/**
 * Expose `reduceFunctionCall`
 *
 * @type {Function}
 */
module.exports = reduceFunctionCall

/**
 * Walkthrough all expressions, evaluate them and insert them into the declaration
 *
 * @param {Array} expressions
 * @param {Object} declaration
 */

function reduceFunctionCall(string, functionRE, callback) {
  var call = string
  return getFunctionCalls(string, functionRE).reduce(function(string, obj) {
    return string.replace(obj.functionIdentifier + "(" + obj.matches.body + ")", evalFunctionCall(obj.matches.body, obj.functionIdentifier, callback, call, functionRE))
  }, string)
}

/**
 * Parses expressions in a value
 *
 * @param {String} value
 * @returns {Array}
 * @api private
 */

function getFunctionCalls(call, functionRE) {
  var expressions = []

  var fnRE = typeof functionRE === "string" ? new RegExp("\\b(" + functionRE + ")\\(") : functionRE
  do {
    var searchMatch = fnRE.exec(call)
    if (!searchMatch) {
      return expressions
    }
    if (searchMatch[1] === undefined) {
      throw new Error("Missing the first couple of parenthesis to get the function identifier in " + functionRE)
    }
    var fn = searchMatch[1]
    var startIndex = searchMatch.index
    var matches = balanced("(", ")", call.substring(startIndex))

    if (!matches || matches.start !== searchMatch[0].length - 1) {
      throw new SyntaxError(fn + "(): missing closing ')' in the value '" + call + "'")
    }

    expressions.push({matches: matches, functionIdentifier: fn})
    call = matches.post
  }
  while (fnRE.test(call))

  return expressions
}

/**
 * Evaluates an expression
 *
 * @param {String} expression
 * @returns {String}
 * @api private
 */

function evalFunctionCall (string, functionIdentifier, callback, call, functionRE) {
  // allow recursivity
  return callback(reduceFunctionCall(string, functionRE, callback), functionIdentifier, call)
}


/***/ }),
/* 438 */
/***/ (function(module, exports) {

module.exports = balanced;
function balanced(a, b, str) {
  if (a instanceof RegExp) a = maybeMatch(a, str);
  if (b instanceof RegExp) b = maybeMatch(b, str);

  var r = range(a, b, str);

  return r && {
    start: r[0],
    end: r[1],
    pre: str.slice(0, r[0]),
    body: str.slice(r[0] + a.length, r[1]),
    post: str.slice(r[1] + b.length)
  };
}

function maybeMatch(reg, str) {
  var m = str.match(reg);
  return m ? m[0] : null;
}

balanced.range = range;
function range(a, b, str) {
  var begs, beg, left, right, result;
  var ai = str.indexOf(a);
  var bi = str.indexOf(b, ai + 1);
  var i = ai;

  if (ai >= 0 && bi > 0) {
    begs = [];
    left = str.length;

    while (i >= 0 && !result) {
      if (i == ai) {
        begs.push(i);
        ai = str.indexOf(a, i + 1);
      } else if (begs.length == 1) {
        result = [ begs.pop(), bi ];
      } else {
        beg = begs.pop();
        if (beg < left) {
          left = beg;
          right = bi;
        }

        bi = str.indexOf(b, i + 1);
      }

      i = ai < bi && ai >= 0 ? ai : bi;
    }

    if (begs.length) {
      result = [ left, right ];
    }
  }

  return result;
}


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

var Mexp=__webpack_require__(440);
Mexp.prototype.formulaEval = function () {
	"use strict";
	var stack=[],pop1,pop2,pop3;
	var disp=[];
	var temp='';
	var arr=this.value;
	for(var i=0;i<arr.length;i++){
		if(arr[i].type===1||arr[i].type===3){
			disp.push({value:arr[i].type===3?arr[i].show:arr[i].value,type:1});
		}
		else if(arr[i].type===13){
			disp.push({value:arr[i].show,type:1});
		}
		else if(arr[i].type===0){
			disp[disp.length-1]={value:arr[i].show+(arr[i].show!="-"?"(":"")+disp[disp.length-1].value+(arr[i].show!="-"?")":""),type:0};
		}
		else if(arr[i].type===7){
			disp[disp.length-1]={value:(disp[disp.length-1].type!=1?"(":"")+disp[disp.length-1].value+(disp[disp.length-1].type!=1?")":"")+arr[i].show,type:7};
		}
		else if(arr[i].type===10){
			pop1=disp.pop();
			pop2=disp.pop();
			if(arr[i].show==='P'||arr[i].show==='C')disp.push({value:"<sup>"+pop2.value+"</sup>"+arr[i].show+"<sub>"+pop1.value+"</sub>",type:10});
			else disp.push({value:(pop2.type!=1?"(":"")+pop2.value+(pop2.type!=1?")":"")+"<sup>"+pop1.value+"</sup>",type:1});
		}
		else if(arr[i].type===2||arr[i].type===9){
			pop1=disp.pop();
			pop2=disp.pop();
			disp.push({value:(pop2.type!=1?"(":"")+pop2.value+(pop2.type!=1?")":"")+arr[i].show+(pop1.type!=1?"(":"")+pop1.value+(pop1.type!=1?")":""),type:arr[i].type});
		}
		else if(arr[i].type===12){
			pop1=disp.pop();
			pop2=disp.pop();
			pop3=disp.pop();
			disp.push({value:arr[i].show+"("+pop3.value+","+pop2.value+","+pop1.value+")",type:12});
		}
	}
	return disp[0].value;
};
module.exports=Mexp;

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

var Mexp=__webpack_require__(441);
Mexp.prototype.postfixEval = function (UserDefined) {
	'use strict';
	UserDefined=UserDefined||{};
	UserDefined.PI=Math.PI;
	UserDefined.E=Math.E;
	var stack=[],pop1,pop2,pop3;
	var disp=[];
	var temp='';
	var arr=this.value;
	var bool=(typeof UserDefined.n!=="undefined");
	for(var i=0;i<arr.length;i++){
		if(arr[i].type===1){
			stack.push({value:arr[i].value,type:1});
		}
		else if(arr[i].type===3){
			stack.push({value:UserDefined[arr[i].value],type:1});
		}
		else if(arr[i].type===0){
			if(typeof stack[stack.length-1].type==="undefined"){
				stack[stack.length-1].value.push(arr[i]);
			}
			else stack[stack.length-1].value=arr[i].value(stack[stack.length-1].value);
		}
		else if(arr[i].type===7){
			if(typeof stack[stack.length-1].type==="undefined"){
				stack[stack.length-1].value.push(arr[i]);
			}
			else stack[stack.length-1].value=arr[i].value(stack[stack.length-1].value);
		}
		else if(arr[i].type===8){
			pop1=stack.pop();
			pop2=stack.pop();
			stack.push({type:1,value:arr[i].value(pop2.value,pop1.value)});
		}
		else if(arr[i].type===10){
			pop1=stack.pop();
			pop2=stack.pop();
			if(typeof pop2.type==="undefined"){
				pop2.value=pop2.concat(pop1);
				pop2.value.push(arr[i]);
				stack.push(pop2);
			}
			else if (typeof pop1.type==="undefined") {
				pop1.unshift(pop2);
				pop1.push(arr[i]);
				stack.push(pop1);
			}
			else{
				stack.push({type:1,value:arr[i].value(pop2.value,pop1.value)});
            }
		}
		else if(arr[i].type===2||arr[i].type===9){
			pop1=stack.pop();
			pop2=stack.pop();
			if(typeof pop2.type==="undefined"){
                console.log(pop2);
				pop2=pop2.concat(pop1);
				pop2.push(arr[i]);
				stack.push(pop2);
			}
			else if (typeof pop1.type==="undefined") {
				pop1.unshift(pop2);
				pop1.push(arr[i]);
				stack.push(pop1);
			}
			else{
				stack.push({type:1,value:arr[i].value(pop2.value,pop1.value)});
			}
		}
		else if(arr[i].type===12){
			pop1=stack.pop();
			if (typeof pop1.type!=="undefined") {
				pop1=[pop1];
			}
			pop2=stack.pop();
			pop3=stack.pop();
			stack.push({type:1,value:arr[i].value(pop3.value,pop2.value,new Mexp(pop1))});
		}
		else if(arr[i].type===13){
			if(bool){
				stack.push({value:UserDefined[arr[i].value],type:3});
			}
			else stack.push([arr[i]]);
		}
	}
	if (stack.length>1) {
		throw(new Mexp.exception("Uncaught Syntax error"));
	}
	return stack[0].value>1000000000000000?"Infinity":parseFloat(stack[0].value.toFixed(15));
};
Mexp.eval=function(str,tokens,obj){
	if (typeof tokens==="undefined") {
		return this.lex(str).toPostfix().postfixEval();
	}
	else if (typeof obj==="undefined") {
		if (typeof tokens.length!=="undefined") 
			return this.lex(str,tokens).toPostfix().postfixEval();
		else
			return this.lex(str).toPostfix().postfixEval(tokens);
	}
	else
		return this.lex(str,tokens).toPostfix().postfixEval(obj);
};
module.exports=Mexp;

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {


    var Mexp=__webpack_require__(442);

	Mexp.prototype.toPostfix = function () {
		'use strict';
		var post=[],elem,popped,prep,pre,ele;
    	var stack=[{value:"(",type:4,pre:0}];
		var arr=this.value;
		for (var i=1; i < arr.length; i++) {
			if(arr[i].type===1||arr[i].type===3||arr[i].type===13){	//if token is number,constant,or n(which is also a special constant in our case)
				if(arr[i].type===1)
					arr[i].value=Number(arr[i].value);
				post.push(arr[i]);
			}
			else if(arr[i].type===4){
				stack.push(arr[i]);
			}
			else if(arr[i].type===5){
				while((popped=stack.pop()).type!==4){
					post.push(popped);
				}
			}
			else if(arr[i].type===11){
				while((popped=stack.pop()).type!==4){
					post.push(popped);
				}
				stack.push(popped);
			}
			else {
				elem=arr[i];
				pre=elem.pre;
				ele=stack[stack.length-1];
				prep=ele.pre;
				var flag=ele.value=='Math.pow'&&elem.value=='Math.pow';
				if(pre>prep)stack.push(elem);
				else {
					while(prep>=pre&&!flag||flag&&pre<prep){
						popped=stack.pop();
						ele=stack[stack.length-1];
						post.push(popped);
						prep=ele.pre;
						flag=elem.value=='Math.pow'&&ele.value=='Math.pow';
					}
					stack.push(elem);
				}
			}
		}
		return new Mexp(post);
	};
    module.exports=Mexp;

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

var Mexp=__webpack_require__(443);
	function inc(arr,val){
		for(var i=0;i<arr.length;i++)
			arr[i]+=val;
		return arr;
	}
	var token=['sin','cos','tan','pi','(',')','P','C',
		  'asin','acos','atan','7','8','9','int',
		  'cosh','acosh','ln','^','root','4','5','6','/','!',
		  'tanh','atanh','Mod','1','2','3','*',
		  'sinh','asinh','e','log','0','.','+','-',',','Sigma','n','Pi','pow'];
	var show=['sin','cos','tan','&pi;','(',')','P','C',
		'asin','acos','atan','7','8','9','Int',
		'cosh','acosh',' ln','^','root','4','5','6','&divide;','!',
		'tanh','atanh',' Mod ','1','2','3','&times;',
		'sinh','asinh','e',' log','0','.','+','-',',','&Sigma;','n','&Pi;','pow'];
	var eva=[Mexp.math.sin,Mexp.math.cos,Mexp.math.tan,'PI','(',')',Mexp.math.P,Mexp.math.C,
		Mexp.math.asin,Mexp.math.acos,Mexp.math.atan,'7','8','9',Math.floor,
		Mexp.math.cosh,Mexp.math.acosh,Math.log,Math.pow,Math.sqrt,'4','5','6',Mexp.math.div,Mexp.math.fact,
		Mexp.math.tanh,Mexp.math.atanh,Mexp.math.mod,'1','2','3',Mexp.math.mul,
		Mexp.math.sinh,Mexp.math.asinh,'E',Mexp.math.log,'0','.',Mexp.math.add,Mexp.math.sub,',',Mexp.math.sigma,'n',Mexp.math.Pi,Math.pow];
	var preced={0:11,1:0,2:3,3:0,4:0,5:0,6:0,7:11,8:11,9:1,10:10,11:0,12:11,13:0};
	var type=[0,0,0,3,4,5,10,10,
		0,0,0,1,1,1,0,
		0,0,0,10,0,1,1,1,2,7,
		0,0,2,1,1,1,2,
		0,0,3,0,1,6,9,9,11,12,13,12,8];
	 /*
	0 : function with syntax function_name(Maths_exp)
	1 : numbers
	2 : binary operators like * / Mod left associate and same precedence
	3 : Math constant values like e,pi,Cruncher ans
	4 : opening bracket
	5 : closing bracket
	6 : decimal
	7 : function with syntax (Math_exp)function_name
	8: function with syntax function_name(Math_exp1,Math_exp2)
	9 : binary operator like +,-
	10: binary operator like P C or ^
	11: ,
	12: function with , seperated three parameters
	13: variable of Sigma function
	 */
	var type0={0:true,1:true,3:true,4:true,6:true,8:true,9:true,12:true,13:true},//type2:true,type4:true,type9:true,type11:true,type21:true,type22
	type1={0:true,1:true,2:true,3:true,4:true,5:true,6:true,7:true,8:true,9:true,10:true,11:true,12:true,13:true},//type3:true,type5:true,type7:true,type23
	type_1={0:true,3:true,4:true,8:true,12:true,13:true},
	empty={},
	type_3={0:true,1:true,3:true,4:true,6:true,8:true,12:true,13:true},//type_5:true,type_7:true,type_23
	type6={1:true},
	newAr=[[],
			["1","2","3","7","8","9","4","5","6","+","-","*","/","(",")","^","!","P","C","e","0",".",",","n"],
			["pi","ln","Pi"],
			["sin","cos","tan","Del","int","Mod","log","pow"],
			["asin","acos","atan","cosh","root","tanh","sinh"],
			["acosh","atanh","asinh","Sigma"]];
	function match(str1,str2,i,x){
		for(var f=0;f<x;f++){
			if (str1[i+f]!==str2[f])
				return false;
		}
		return true;
	}
	Mexp.addToken=function(tokens){
		for(i=0;i<tokens.length;i++){
			x=tokens[i].token.length;
			var temp=-1;

			//newAr is a specially designed data structure in which 1D array at location one of 2d array has all string with length 1 2 with 2 and so on

			if (x<newAr.length)	//match to check if token is really huge and not existing
								//if not checked it will break in next line as undefined index
				for(y=0;y<newAr[x].length;y++){
					if (tokens[i].token===newAr[x][y]){
						temp=token.indexOf(newAr[x][y]);
						break;
					}
				}
			if (temp===-1) {
				token.push(tokens[i].token);
				type.push(tokens[i].type);
				if(newAr.length<=tokens[i].token.length)
					newAr[tokens[i].token.length]=[];
				newAr[tokens[i].token.length].push(tokens[i].token);
				eva.push(tokens[i].value);
				show.push(tokens[i].show);
			}
			else {
				token[temp]=tokens[i].token;
				type[temp]=tokens[i].type;
				eva[temp]=tokens[i].value;
				show[temp]=tokens[i].show;
			}
		}
	};
	Mexp.lex=function(inp,tokens){
		'use strict';
		var str=[{type:4,value:"(",show:"(",pre:0}];
		var ptc=[];	//Parenthesis to close at the beginning is after one token
		var inpStr=inp;
		var key;
        var pcounter=0;
		var allowed=type0;
		var bracToClose=0;
		var asterick=empty;
		var prevKey='';
		var i,x,y;
		if(typeof tokens!=="undefined")
			Mexp.addToken(tokens);
		var obj={};
		for(i=0;i<inpStr.length;i++){
			if (inpStr[i]==' ') {
				continue;
			}
			key='';
			sec:for(x=(inpStr.length-i>(newAr.length-2)?newAr.length-1:inpStr.length-i);x>0;x--){
				for(y=0;y<newAr[x].length;y++){
					if (match(inpStr,newAr[x][y],i,x)){
						key=newAr[x][y];
						break sec;
					}
				}
			}
			i+=key.length-1;
			if(key===''){
				throw(new Mexp.exception("Can't understand after "+inpStr.slice(i)));
			}
			var index=token.indexOf(key);
			var cToken=key;
			var cType=type[index];
			var cEv=eva[index];
			var cPre=preced[cType];
			var	cShow=show[index];
			var pre=str[str.length-1];
			for(j=ptc.length;j--;){	//loop over ptc
				if(ptc[j]===0){
					if([0,2,3,5,9,11,12,13].indexOf(cType)!==-1){
						if(allowed[cType]!==true){
							throw(new Mexp.exception(key+" is not allowed after "+prevKey));
						}
						str.push({value:")",type:5,pre:0,show:")"});
						allowed=type1;
						asterick=type_3;
						inc(ptc,-1).pop();
					}
				}
			}
			if(allowed[cType]!==true){
				throw(new Mexp.exception(key+" is not allowed after "+prevKey));
			}
			if(asterick[cType]===true){
				cType=2;
				cEv=Mexp.math.mul;
				cShow="&times;";
				cPre=3;
				i=i-key.length;
		 	}
			obj={value:cEv,type:cType,pre:cPre,show:cShow};
			if(cType===0){
				allowed=type0;
				asterick=empty;
				inc(ptc,2).push(2);
				str.push(obj);
				str.push({value:"(",type:4,pre:0,show:"("});
			}
			else if(cType===1){
				if(pre.type===1){
					pre.value+=cEv;
					inc(ptc,1);
				}
				else {
					str.push(obj);
				}
				allowed=type1;
				asterick=type_1;
			}
			else if(cType===2){
				allowed=type0;
				asterick=empty;
				inc(ptc,2);
				str.push(obj);
			}
			else if(cType===3){//constant
				str.push(obj);
				allowed=type1;
				asterick=type_3;
			}
			else if(cType===4){
                pcounter+=ptc.length;
                ptc=[];
				bracToClose++;
				allowed=type0;
				asterick=empty;
				str.push(obj);
			}
			else if(cType===5){
				if(!bracToClose){
					throw(new Mexp.exception("Closing parenthesis are more than opening one, wait What!!!"));
				}
                while(pcounter--){	//loop over ptc
    						str.push({value:")",type:5,pre:0,show:")"});
    			}
                pcounter=0;
				bracToClose--;
				allowed=type1;
				asterick=type_3;
				str.push(obj);
			}
			else if(cType===6){
				if(pre.hasDec){
					throw(new Mexp.exception("Two decimals are not allowed in one number"));
				}
				if(pre.type!==1){
					pre={value:0,type:1,pre:0};	//pre needs to be changed as it will the last value now to be safe in later code
					str.push(pre);
					inc(ptc,-1);
				}
				allowed=type6;
				inc(ptc,1);
				asterick=empty;
				pre.value+=cEv;
				pre.hasDec=true;
			}
			else if(cType===7){
				allowed=type1;
				asterick=type_3;
				inc(ptc,1);
				str.push(obj);
			}
			if(cType===8){
				allowed=type0;
				asterick=empty;
				inc(ptc,4).push(4);
				str.push(obj);
				str.push({value:"(",type:4,pre:0,show:"("});
			}
			else if(cType===9){
				if(pre.type===9){
					if(pre.value===Mexp.math.add){
						pre.value=cEv;
						pre.show=cShow;
						inc(ptc,1);
					}
					else if(pre.value===Mexp.math.sub&&cShow==='-'){
						pre.value=Mexp.math.add;
						pre.show='+';
						inc(ptc,1);
					}
				}
				else if(pre.type!==5&&pre.type!==7&&pre.type!==1&&pre.type!==3&&pre.type!==13){//changesign only when negative is found
					if(cToken==='-'){//do nothing for + token
									//don't add with the above if statement as that will run the else statement of parent if on Ctoken +
						allowed=type0;
						asterick=empty;
						inc(ptc,2).push(2);
						str.push({value:Mexp.math.changeSign,type:0,pre:21,show:"-"});
						str.push({value:"(",type:4,pre:0,show:"("});
					}
				}
				else{
					str.push(obj);
					inc(ptc,2);
				}
				allowed=type0;
				asterick=empty;
			}
			else if(cType===10){
				allowed=type0;
				asterick=empty;
				inc(ptc,2);
				str.push(obj);
			}
			else if(cType===11){
				allowed=type0;
				asterick=empty;
				str.push(obj);
			}
			else if(cType===12){
				allowed=type0;
				asterick=empty;
				inc(ptc,6).push(6);
				str.push(obj);
				str.push({value:"(",type:4,pre:0});
			}
			else if(cType===13){
				allowed=type1;
				asterick=type_3;
				str.push(obj);
			}
			inc(ptc,-1);
			prevKey=key;
		}
		for(var j=ptc.length;j--;){	//loop over ptc
			if(ptc[j]===0){

				str.push({value:")",show:")",type:5,pre:3});
				inc(ptc,-1).pop();
			}
		}
		if (allowed[5]!==true) {
			throw(new Mexp.exception("complete the expression"));
		}
		while(bracToClose--)
			str.push({value:")",show:")",type:5,pre:3});

		str.push({type:5,value:")",show:")",pre:0});
//        console.log(str);
		return new Mexp(str);
	};
    module.exports=Mexp;


/***/ }),
/* 443 */
/***/ (function(module, exports) {

	var Mexp=function(parsed){
		this.value=parsed;

	};

	Mexp.math={
		isDegree:true, //mode of calculator
		acos:function(x){
			return (Mexp.math.isDegree?180/Math.PI*Math.acos(x):Math.acos(x));
		},
		add:function(a,b){
			return a+b;
		},
		asin:function(x){
			return (Mexp.math.isDegree?180/Math.PI*Math.asin(x):Math.asin(x));
		},
		atan:function(x){
			return (Mexp.math.isDegree?180/Math.PI*Math.atan(x):Math.atan(x));
		},
		acosh:function(x){
			return Math.log(x+Math.sqrt(x*x-1));
		},
		asinh:function(x){
			return Math.log(x+Math.sqrt(x*x+1));
		},
		atanh:function(x){
			return Math.log((1+x)/(1-x));
		},
		C:function(n,r){
			var pro=1,other=n-r,choice=r;
			if(choice<other){
			choice=other;
			other=r;
			}
			for(var i=choice+1;i<=n;i++)
				pro*=i;
			return pro/Mexp.math.fact(other);
		},
		changeSign:function(x){
			return -x;
		},
		cos:function(x){
			if(Mexp.math.isDegree)x=Mexp.math.toRadian(x);
			return Math.cos(x);
		},
		cosh:function(x){
			return (Math.pow(Math.E,x)+Math.pow(Math.E,-1*x))/2;
		},
		div:function(a,b){
		return a/b;
		},
		fact:function(n) {
		if(n%1!==0)return "NAN";
			var pro=1;
			for(var i=2;i<=n;i++)
				pro*=i;
			return pro;
		},
		inverse:function(x){
			return 1/x;
		},
		log:function(i){
			return Math.log(i)/Math.log(10);
		},
		mod:function(a,b){
		return a%b;
		},
		mul:function(a,b){
		return a*b;
		},
		P:function(n,r){var pro=1;
			 for(var i=Math.floor(n)-Math.floor(r)+1;i<=Math.floor(n);i++)
					pro*=i;
					return pro;

		},
		Pi:function(low,high,ex){
			var pro=1;
			for(var i=low;i<=high;i++){
				pro*=Number(ex.postfixEval({n:i}));
			}
			return pro;
		},
		pow10x:function(e){
			var x=1;
			while(e--){x*=10;}
			return x;
		},
		sigma:function(low,high,ex){
			var sum=0;
			for(var i=low;i<=high;i++){
				sum+=Number(ex.postfixEval({n:i}));
			}
			return sum;
		},
		sin:function(x){
			if(Mexp.math.isDegree)x=Mexp.math.toRadian(x);
			return Math.sin(x);
		},
		sinh:function(x){
			return (Math.pow(Math.E,x)-Math.pow(Math.E,-1*x))/2;
		},
		sub:function(a,b){
		return a-b;
		},
		tan:function(x){
			if(Mexp.math.isDegree)x=Mexp.math.toRadian(x);
			return Math.tan(x);
		},
		tanh:function(x){
			return Mexp.sinha(x)/Mexp.cosha(x);
		},
		toRadian:function(x){
			return x*Math.PI/180;
		}
	};
	Mexp.exception=function(message){
		this.message=message;
	};
    module.exports=Mexp;

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(156),
    isFlattenable = __webpack_require__(445);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(45),
    isArguments = __webpack_require__(107),
    isArray = __webpack_require__(8);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(67),
    baseIteratee = __webpack_require__(51),
    baseMap = __webpack_require__(447),
    baseSortBy = __webpack_require__(448),
    baseUnary = __webpack_require__(110),
    compareMultiple = __webpack_require__(449),
    identity = __webpack_require__(38);

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  var index = -1;
  iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

module.exports = baseOrderBy;


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(166),
    isArrayLike = __webpack_require__(50);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),
/* 448 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

module.exports = baseSortBy;


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

var compareAscending = __webpack_require__(450);

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

module.exports = compareMultiple;


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(37);

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

module.exports = compareAscending;


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

var baseExtremum = __webpack_require__(76),
    baseGt = __webpack_require__(174),
    identity = __webpack_require__(38);

/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */
function max(array) {
  return (array && array.length)
    ? baseExtremum(array, identity, baseGt)
    : undefined;
}

module.exports = max;


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getNiceTickValues = __webpack_require__(453);

Object.defineProperty(exports, 'getTickValues', {
  enumerable: true,
  get: function get() {
    return _getNiceTickValues.getTickValues;
  }
});
Object.defineProperty(exports, 'getNiceTickValues', {
  enumerable: true,
  get: function get() {
    return _getNiceTickValues.getNiceTickValues;
  }
});
Object.defineProperty(exports, 'getTickValuesFixedDomain', {
  enumerable: true,
  get: function get() {
    return _getNiceTickValues.getTickValuesFixedDomain;
  }
});

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTickValuesFixedDomain = exports.getTickValues = exports.getNiceTickValues = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * @fileOverview calculate tick values of scale
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * @author xile611, arcthur
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * @date 2015-09-17
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          */

var _utils = __webpack_require__(177);

var _arithmetic = __webpack_require__(454);

var _arithmetic2 = _interopRequireDefault(_arithmetic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Calculate a interval of a minimum value and a maximum value
 *
 * @param  {Number} min       The minimum value
 * @param  {Number} max       The maximum value
 * @return {Array} An interval
 */
function getValidInterval(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      min = _ref2[0],
      max = _ref2[1];

  var validMin = min,
      validMax = max;

  // exchange

  if (min > max) {
    validMin = max;
    validMax = min;
  }

  return [validMin, validMax];
}

/**
 * Calculate the step which is easy to understand between ticks, like 10, 20, 25
 *
 * @param  {Number}  roughStep        The rough step calculated by deviding the
 * difference by the tickCount
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Integer} correctionFactor A correction factor
 * @return {Number}  The step which is easy to understand between two ticks
 */
function getFormatStep(roughStep, allowDecimals, correctionFactor) {
  if (roughStep <= 0) {
    return 0;
  }

  var digitCount = _arithmetic2.default.getDigitCount(roughStep);
  // The ratio between the rough step and the smallest number which has a bigger
  // order of magnitudes than the rough step
  var stepRatio = roughStep / Math.pow(10, digitCount);
  // When an integer and a float multiplied, the accuracy of result may be wrong
  var amendStepRatio = digitCount !== 1 ? _arithmetic2.default.multiply(Math.ceil(stepRatio / 0.05) + correctionFactor, 0.05) : _arithmetic2.default.multiply(Math.ceil(stepRatio / 0.1) + correctionFactor, 0.1);

  var formatStep = _arithmetic2.default.multiply(amendStepRatio, Math.pow(10, digitCount));

  return allowDecimals ? formatStep : Math.ceil(formatStep);
}

/**
 * calculate the ticks when the minimum value equals to the maximum value
 *
 * @param  {Number}  value         The minimum valuue which is also the maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}                 ticks
 */
function getTickOfSingleValue(value, tickCount, allowDecimals) {
  var isFlt = _arithmetic2.default.isFloat(value);
  var step = 1;
  // calculate the middle value of ticks
  var middle = value;

  if (isFlt && allowDecimals) {
    var absVal = Math.abs(value);

    if (absVal < 1) {
      // The step should be a float number when the difference is smaller than 1
      step = Math.pow(10, _arithmetic2.default.getDigitCount(value) - 1);

      middle = _arithmetic2.default.multiply(Math.floor(value / step), step);
    } else if (absVal > 1) {
      // Return the maximum integer which is smaller than 'value' when 'value' is greater than 1
      middle = Math.floor(value);
    }
  } else if (value === 0) {
    middle = Math.floor((tickCount - 1) / 2);
  } else if (!allowDecimals) {
    middle = Math.floor(value);
  }

  var middleIndex = Math.floor((tickCount - 1) / 2);

  var fn = (0, _utils.compose)((0, _utils.map)(function (n) {
    return _arithmetic2.default.sum(middle, _arithmetic2.default.multiply(n - middleIndex, step));
  }), _utils.range);

  return fn(0, tickCount);
}

/**
 * Calculate the step
 *
 * @param  {Number}  min              The minimum value of an interval
 * @param  {Number}  max              The maximum value of an interval
 * @param  {Integer} tickCount        The count of ticks
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Number}  correctionFactor A correction factor
 * @return {Object}  The step, minimum value of ticks, maximum value of ticks
 */
function calculateStep(min, max, tickCount, allowDecimals) {
  var correctionFactor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;

  // The step which is easy to understand between two ticks
  var step = getFormatStep((max - min) / (tickCount - 1), allowDecimals, correctionFactor);

  // A medial value of ticks
  var middle = void 0;

  // When 0 is inside the interval, 0 should be a tick
  if (min <= 0 && max >= 0) {
    middle = 0;
  } else {
    // calculate the middle value
    middle = _arithmetic2.default.divide(_arithmetic2.default.sum(min, max), 2);
    // minus modulo value
    middle = _arithmetic2.default.minus(middle, _arithmetic2.default.modulo(middle, step));
    // strip
    middle = _arithmetic2.default.strip(middle, 16);
  }

  var belowCount = Math.ceil((middle - min) / step);
  var upCount = Math.ceil((max - middle) / step);
  var scaleCount = belowCount + upCount + 1;

  if (scaleCount > tickCount) {
    // When more ticks need to cover the interval, step should be bigger.
    return calculateStep(min, max, tickCount, allowDecimals, correctionFactor + 1);
  } else if (scaleCount < tickCount) {
    // When less ticks can cover the interval, we should add some additional ticks
    upCount = max > 0 ? upCount + (tickCount - scaleCount) : upCount;
    belowCount = max > 0 ? belowCount : belowCount + (tickCount - scaleCount);
  }

  return {
    step: step,
    tickMin: _arithmetic2.default.minus(middle, _arithmetic2.default.multiply(belowCount, step)),
    tickMax: _arithmetic2.default.sum(middle, _arithmetic2.default.multiply(upCount, step))
  };
}
/**
 * Calculate the ticks of an interval
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */
function getNiceTickValuesFn(_ref3) {
  var _ref4 = _slicedToArray(_ref3, 2),
      min = _ref4[0],
      max = _ref4[1];

  var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
  var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  // More than two ticks should be return
  var count = Math.max(tickCount, 2);

  var _getValidInterval = getValidInterval([min, max]),
      _getValidInterval2 = _slicedToArray(_getValidInterval, 2),
      cormin = _getValidInterval2[0],
      cormax = _getValidInterval2[1];

  if (cormin === cormax) {
    return getTickOfSingleValue(cormin, tickCount, allowDecimals);
  }

  // Get the step between two ticks

  var _calculateStep = calculateStep(cormin, cormax, count, allowDecimals),
      step = _calculateStep.step,
      tickMin = _calculateStep.tickMin,
      tickMax = _calculateStep.tickMax;

  var values = _arithmetic2.default.rangeStep(tickMin, tickMax + 0.1 * step, step);

  return min > max ? (0, _utils.reverse)(values) : values;
}

function getTickValuesFn(_ref5) {
  var _ref6 = _slicedToArray(_ref5, 2),
      min = _ref6[0],
      max = _ref6[1];

  var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
  var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  // More than two ticks should be return
  var count = Math.max(tickCount, 2);

  var _getValidInterval3 = getValidInterval([min, max]),
      _getValidInterval4 = _slicedToArray(_getValidInterval3, 2),
      cormin = _getValidInterval4[0],
      cormax = _getValidInterval4[1];

  if (cormin === cormax) {
    return getTickOfSingleValue(cormin, tickCount, allowDecimals);
  }

  var step = getFormatStep((cormax - cormin) / (count - 1), allowDecimals, 0);

  var fn = (0, _utils.compose)((0, _utils.map)(function (n) {
    return cormin + n * step;
  }), _utils.range);

  var values = fn(0, count).filter(function (entry) {
    return entry >= cormin && entry <= cormax;
  });

  return min > max ? (0, _utils.reverse)(values) : values;
}

function getTickValuesFixedDomainFn(_ref7, tickCount) {
  var _ref8 = _slicedToArray(_ref7, 2),
      min = _ref8[0],
      max = _ref8[1];

  var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  // More than two ticks should be return
  var _getValidInterval5 = getValidInterval([min, max]),
      _getValidInterval6 = _slicedToArray(_getValidInterval5, 2),
      cormin = _getValidInterval6[0],
      cormax = _getValidInterval6[1];

  if (cormin === cormax) {
    return [cormin];
  }

  var count = Math.max(tickCount, 2);
  var step = getFormatStep((cormax - cormin) / (count - 1), allowDecimals, 0);
  var values = [].concat(_toConsumableArray(_arithmetic2.default.rangeStep(cormin, cormax - 0.99 * step, step)), [cormax]);

  return min > max ? (0, _utils.reverse)(values) : values;
}

var getNiceTickValues = exports.getNiceTickValues = (0, _utils.memoize)(getNiceTickValuesFn);
var getTickValues = exports.getTickValues = (0, _utils.memoize)(getTickValuesFn);
var getTickValuesFixedDomain = exports.getTickValuesFixedDomain = (0, _utils.memoize)(getTickValuesFixedDomainFn);

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(177);

/**
 * 把错误的数据转正
 * strip(0.09999999999999998)=0.1
 * @param {Number} num       输入值
 * @param {Number} precision 精度
 * @return {Number} 数值
 */
function strip(num) {
  var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 12;

  return +parseFloat(num.toPrecision(precision));
}

/**
 * 判断数据是否为浮点类型
 *
 * @param {Number} num 输入值
 * @return {Boolean} 是否是浮点类型
 */
/**
 * @fileOverview 一些公用的运算方法
 * @author xile611
 * @date 2015-09-17
 */
function isFloat(num) {
  return (/^([+-]?)\d*\.\d+$/.test(num)
  );
}

/**
 * 获取数值的位数
 * 其中绝对值属于区间[0.1, 1)， 得到的值为0
 * 绝对值属于区间[0.01, 0.1)，得到的位数为 -1
 * 绝对值属于区间[0.001, 0.01)，得到的位数为 -2
 *
 * @param  {Number} value 数值
 * @return {Integer} 位数
 */
function getDigitCount(value) {
  var abs = Math.abs(value);
  var result = void 0;

  if (value === 0) {
    result = 1;
  } else {
    result = Math.floor(Math.log(abs) / Math.log(10)) + 1;
  }

  return result;
}
/**
 * 计算数值的小数点后的位数
 * @param  {Number} a 数值，可能为整数，也可能为浮点数
 * @return {Integer}   位数
 */
function getDecimalDigitCount(a) {
  var str = a ? '' + a : '';

  // scientific notation
  if (str.indexOf('e') >= 0) {
    return Math.abs(parseInt(str.slice(str.indexOf('e') + 1), 10));
  }
  var ary = str.split('.');

  return ary.length > 1 ? ary[1].length : 0;
}
/**
 * 乘法运算，解决了js运算的精度问题
 * @param  {Number} a 被乘数
 * @param  {Number} b 乘数
 * @return {Number}   积
 */
function multiply(a, b) {
  var intA = parseInt(('' + a).replace('.', ''), 10);
  var intB = parseInt(('' + b).replace('.', ''), 10);
  var count = getDecimalDigitCount(a) + getDecimalDigitCount(b);

  return intA * intB / Math.pow(10, count);
}
/**
 * 加法运算，解决了js运算的精度问题
 * @param  {Number} a 被加数
 * @param  {Number} b 加数
 * @return {Number}   和
 */
function sum(a, b) {
  var count = Math.max(getDecimalDigitCount(a), getDecimalDigitCount(b));

  count = Math.pow(10, count);
  return (multiply(a, count) + multiply(b, count)) / count;
}
/**
 * 减法运算，解决了js运算的精度问题
 * @param  {Number} a 被减数
 * @param  {Number} b 减数
 * @return {Number}   差
 */
function minus(a, b) {
  return sum(a, -b);
}
/**
 * 除法运算，解决了js运算的精度问题
 * @param  {Number} a 被除数
 * @param  {Number} b 除数
 * @return {Number}   结果
 */
function divide(a, b) {
  var ca = getDecimalDigitCount(a);
  var cb = getDecimalDigitCount(b);
  var intA = parseInt(('' + a).replace('.', ''), 10);
  var intB = parseInt(('' + b).replace('.', ''), 10);

  return intA / intB * Math.pow(10, cb - ca);
}

function modulo(a, b) {
  var mod = Math.abs(b);

  if (b <= 0) {
    return a;
  }

  var cnt = Math.floor(a / mod);

  return minus(a, multiply(mod, cnt));
}

/**
 * 按照固定的步长获取[start, end)这个区间的数据
 * 并且需要处理js计算精度的问题
 *
 * @param  {Number} start 起点
 * @param  {Number} end   终点，不包含该值
 * @param  {Number} step  步长
 * @return {Array}        若干数值
 */
function rangeStep(start, end, step) {
  var num = start;
  var result = [];

  while (num < end) {
    result.push(num);

    num = sum(num, step);
  }

  return result;
}
/**
 * 对数值进行线性插值
 *
 * @param  {Number} a  定义域的极点
 * @param  {Number} b  定义域的极点
 * @param  {Number} t  [0, 1]内的某个值
 * @return {Number}    定义域内的某个值
 */
var interpolateNumber = (0, _utils.curry)(function (a, b, t) {
  var newA = +a;
  var newB = +b;

  return newA + t * (newB - newA);
});
/**
 * 线性插值的逆运算
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个范围内时，返回值属于[0, 1]
 */
var uninterpolateNumber = (0, _utils.curry)(function (a, b, x) {
  var diff = b - +a;

  diff = diff || Infinity;

  return (x - a) / diff;
});
/**
 * 线性插值的逆运算，并且有截断的操作
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个区间内时，返回值属于[0, 1]，
 * 当x不在 a ~ b这个区间时，会截断到 a ~ b 这个区间
 */
var uninterpolateTruncation = (0, _utils.curry)(function (a, b, x) {
  var diff = b - +a;

  diff = diff || Infinity;

  return Math.max(0, Math.min(1, (x - a) / diff));
});

exports.default = {
  rangeStep: rangeStep,
  isFloat: isFloat,
  getDigitCount: getDigitCount,
  getDecimalDigitCount: getDecimalDigitCount,

  sum: sum,
  minus: minus,
  multiply: multiply,
  divide: divide,
  modulo: modulo,
  strip: strip,

  interpolateNumber: interpolateNumber,
  uninterpolateNumber: uninterpolateNumber,
  uninterpolateTruncation: uninterpolateTruncation
};

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = band;
/* harmony export (immutable) */ __webpack_exports__["b"] = point;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ordinal__ = __webpack_require__(191);



function band() {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_1__ordinal__["a" /* default */])().unknown(undefined),
      domain = scale.domain,
      ordinalRange = scale.range,
      range = [0, 1],
      step,
      bandwidth,
      round = false,
      paddingInner = 0,
      paddingOuter = 0,
      align = 0.5;

  delete scale.unknown;

  function rescale() {
    var n = domain().length,
        reverse = range[1] < range[0],
        start = range[reverse - 0],
        stop = range[1 - reverse];
    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
    if (round) step = Math.floor(step);
    start += (stop - start - step * (n - paddingInner)) * align;
    bandwidth = step * (1 - paddingInner);
    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
    var values = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["e" /* range */])(n).map(function(i) { return start + step * i; });
    return ordinalRange(reverse ? values.reverse() : values);
  }

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.range = function(_) {
    return arguments.length ? (range = [+_[0], +_[1]], rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = [+_[0], +_[1]], round = true, rescale();
  };

  scale.bandwidth = function() {
    return bandwidth;
  };

  scale.step = function() {
    return step;
  };

  scale.round = function(_) {
    return arguments.length ? (round = !!_, rescale()) : round;
  };

  scale.padding = function(_) {
    return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
  };

  scale.paddingInner = function(_) {
    return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
  };

  scale.paddingOuter = function(_) {
    return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
  };

  scale.align = function(_) {
    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
  };

  scale.copy = function() {
    return band()
        .domain(domain())
        .range(range)
        .round(round)
        .paddingInner(paddingInner)
        .paddingOuter(paddingOuter)
        .align(align);
  };

  return rescale();
}

function pointish(scale) {
  var copy = scale.copy;

  scale.padding = scale.paddingOuter;
  delete scale.paddingInner;
  delete scale.paddingOuter;

  scale.copy = function() {
    return pointish(copy());
  };

  return scale;
}

function point() {
  return pointish(band().paddingInner(1));
}


/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pairs__ = __webpack_require__(181);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values0, values1, reduce) {
  var n0 = values0.length,
      n1 = values1.length,
      values = new Array(n0 * n1),
      i0,
      i1,
      i,
      value0;

  if (reduce == null) reduce = __WEBPACK_IMPORTED_MODULE_0__pairs__["a" /* pair */];

  for (i0 = i = 0; i0 < n0; ++i0) {
    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
      values[i] = reduce(value0, values1[i1]);
    }
  }

  return values;
});


/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
});


/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bisect__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__extent__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__identity__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__range__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ticks__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__threshold_sturges__ = __webpack_require__(188);









/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var value = __WEBPACK_IMPORTED_MODULE_4__identity__["a" /* default */],
      domain = __WEBPACK_IMPORTED_MODULE_3__extent__["a" /* default */],
      threshold = __WEBPACK_IMPORTED_MODULE_7__threshold_sturges__["a" /* default */];

  function histogram(data) {
    var i,
        n = data.length,
        x,
        values = new Array(n);

    for (i = 0; i < n; ++i) {
      values[i] = value(data[i], i, data);
    }

    var xz = domain(values),
        x0 = xz[0],
        x1 = xz[1],
        tz = threshold(values, x0, x1);

    // Convert number of thresholds into uniform thresholds.
    if (!Array.isArray(tz)) {
      tz = Object(__WEBPACK_IMPORTED_MODULE_6__ticks__["c" /* tickStep */])(x0, x1, tz);
      tz = Object(__WEBPACK_IMPORTED_MODULE_5__range__["a" /* default */])(Math.ceil(x0 / tz) * tz, Math.floor(x1 / tz) * tz, tz); // exclusive
    }

    // Remove any thresholds outside the domain.
    var m = tz.length;
    while (tz[0] <= x0) tz.shift(), --m;
    while (tz[m - 1] > x1) tz.pop(), --m;

    var bins = new Array(m + 1),
        bin;

    // Initialize bins.
    for (i = 0; i <= m; ++i) {
      bin = bins[i] = [];
      bin.x0 = i > 0 ? tz[i - 1] : x0;
      bin.x1 = i < m ? tz[i] : x1;
    }

    // Assign data to bins by value, ignoring any outside the domain.
    for (i = 0; i < n; ++i) {
      x = values[i];
      if (x0 <= x && x <= x1) {
        bins[Object(__WEBPACK_IMPORTED_MODULE_1__bisect__["a" /* default */])(tz, x, 0, m)].push(data[i]);
      }
    }

    return bins;
  }

  histogram.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(_), histogram) : value;
  };

  histogram.domain = function(_) {
    return arguments.length ? (domain = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])([_[0], _[1]]), histogram) : domain;
  };

  histogram.thresholds = function(_) {
    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array__["b" /* slice */].call(_)) : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(_), histogram) : threshold;
  };

  return histogram;
});


/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ascending__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__quantile__ = __webpack_require__(112);





/* unused harmony default export */ var _unused_webpack_default_export = (function(values, min, max) {
  values = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* map */].call(values, __WEBPACK_IMPORTED_MODULE_2__number__["a" /* default */]).sort(__WEBPACK_IMPORTED_MODULE_1__ascending__["a" /* default */]);
  return Math.ceil((max - min) / (2 * (Object(__WEBPACK_IMPORTED_MODULE_3__quantile__["a" /* default */])(values, 0.75) - Object(__WEBPACK_IMPORTED_MODULE_3__quantile__["a" /* default */])(values, 0.25)) * Math.pow(values.length, -1 / 3)));
});


/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__deviation__ = __webpack_require__(182);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values, min, max) {
  return Math.ceil((max - min) / (3.5 * Object(__WEBPACK_IMPORTED_MODULE_0__deviation__["a" /* default */])(values) * Math.pow(values.length, -1 / 3)));
});


/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  return max;
});


/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(53);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values, valueof) {
  var n = values.length,
      m = n,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(values[i]))) sum += value;
      else --m;
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(valueof(values[i], i, values)))) sum += value;
      else --m;
    }
  }

  if (m) return sum / m;
});


/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__number__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__quantile__ = __webpack_require__(112);




/* unused harmony default export */ var _unused_webpack_default_export = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      numbers = [];

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_1__number__["a" /* default */])(values[i]))) {
        numbers.push(value);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_1__number__["a" /* default */])(valueof(values[i], i, values)))) {
        numbers.push(value);
      }
    }
  }

  return Object(__WEBPACK_IMPORTED_MODULE_2__quantile__["a" /* default */])(numbers.sort(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */]), 0.5);
});


/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(arrays) {
  var n = arrays.length,
      m,
      i = -1,
      j = 0,
      merged,
      array;

  while (++i < n) j += arrays[i].length;
  merged = new Array(j);

  while (--n >= 0) {
    array = arrays[n];
    m = array.length;
    while (--m >= 0) {
      merged[--j] = array[m];
    }
  }

  return merged;
});


/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(array, indexes) {
  var i = indexes.length, permutes = new Array(i);
  while (i--) permutes[i] = array[indexes[i]];
  return permutes;
});


/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(39);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values, compare) {
  if (!(n = values.length)) return;
  var n,
      i = 0,
      j = 0,
      xi,
      xj = values[j];

  if (compare == null) compare = __WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */];

  while (++i < n) {
    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
      xj = xi, j = i;
    }
  }

  if (compare(xj, xj) === 0) return j;
});


/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(array, i0, i1) {
  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
      t,
      i;

  while (m) {
    i = Math.random() * m-- | 0;
    t = array[m + i0];
    array[m + i0] = array[i + i0];
    array[i + i0] = t;
  }

  return array;
});


/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
    }
  }

  else {
    while (++i < n) {
      if (value = +valueof(values[i], i, values)) sum += value;
    }
  }

  return sum;
});


/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transpose__ = __webpack_require__(190);


/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__transpose__["a" /* default */])(arguments);
});


/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_nest__ = __webpack_require__(473);
/* unused harmony reexport nest */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_set__ = __webpack_require__(474);
/* unused harmony reexport set */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_map__ = __webpack_require__(113);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__src_map__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_keys__ = __webpack_require__(475);
/* unused harmony reexport keys */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_values__ = __webpack_require__(476);
/* unused harmony reexport values */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_entries__ = __webpack_require__(477);
/* unused harmony reexport entries */








/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map__ = __webpack_require__(113);


/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var keys = [],
      sortKeys = [],
      sortValues,
      rollup,
      nest;

  function apply(array, depth, createResult, setResult) {
    if (depth >= keys.length) {
      if (sortValues != null) array.sort(sortValues);
      return rollup != null ? rollup(array) : array;
    }

    var i = -1,
        n = array.length,
        key = keys[depth++],
        keyValue,
        value,
        valuesByKey = Object(__WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */])(),
        values,
        result = createResult();

    while (++i < n) {
      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
        values.push(value);
      } else {
        valuesByKey.set(keyValue, [value]);
      }
    }

    valuesByKey.each(function(values, key) {
      setResult(result, key, apply(values, depth, createResult, setResult));
    });

    return result;
  }

  function entries(map, depth) {
    if (++depth > keys.length) return map;
    var array, sortKey = sortKeys[depth - 1];
    if (rollup != null && depth >= keys.length) array = map.entries();
    else array = [], map.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
  }

  return nest = {
    object: function(array) { return apply(array, 0, createObject, setObject); },
    map: function(array) { return apply(array, 0, createMap, setMap); },
    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
    key: function(d) { keys.push(d); return nest; },
    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
    sortValues: function(order) { sortValues = order; return nest; },
    rollup: function(f) { rollup = f; return nest; }
  };
});

function createObject() {
  return {};
}

function setObject(object, key, value) {
  object[key] = value;
}

function createMap() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */])();
}

function setMap(map, key, value) {
  map.set(key, value);
}


/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map__ = __webpack_require__(113);


function Set() {}

var proto = __WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */].prototype;

Set.prototype = set.prototype = {
  constructor: Set,
  has: proto.has,
  add: function(value) {
    value += "";
    this[__WEBPACK_IMPORTED_MODULE_0__map__["b" /* prefix */] + value] = value;
    return this;
  },
  remove: proto.remove,
  clear: proto.clear,
  values: proto.keys,
  size: proto.size,
  empty: proto.empty,
  each: proto.each
};

function set(object, f) {
  var set = new Set;

  // Copy constructor.
  if (object instanceof Set) object.each(function(value) { set.add(value); });

  // Otherwise, assume it’s an array.
  else if (object) {
    var i = -1, n = object.length;
    if (f == null) while (++i < n) set.add(object[i]);
    else while (++i < n) set.add(f(object[i], i, object));
  }

  return set;
}

/* unused harmony default export */ var _unused_webpack_default_export = (set);


/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(map) {
  var keys = [];
  for (var key in map) keys.push(key);
  return keys;
});


/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(map) {
  var values = [];
  for (var key in map) values.push(map[key]);
  return values;
});


/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(map) {
  var entries = [];
  for (var key in map) entries.push({key: key, value: map[key]});
  return entries;
});


/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = identity;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linear__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number__ = __webpack_require__(200);




function identity() {
  var domain = [0, 1];

  function scale(x) {
    return +x;
  }

  scale.invert = scale;

  scale.domain = scale.range = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* map */].call(_, __WEBPACK_IMPORTED_MODULE_2__number__["a" /* default */]), scale) : domain.slice();
  };

  scale.copy = function() {
    return identity().domain(domain);
  };

  return Object(__WEBPACK_IMPORTED_MODULE_1__linear__["b" /* linearish */])(scale);
}


/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lab;
/* unused harmony export Lab */
/* harmony export (immutable) */ __webpack_exports__["b"] = hcl;
/* unused harmony export Hcl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(192);




var Kn = 18,
    Xn = 0.950470, // D65 standard referent
    Yn = 1,
    Zn = 1.088830,
    t0 = 4 / 29,
    t1 = 6 / 29,
    t2 = 3 * t1 * t1,
    t3 = t1 * t1 * t1;

function labConvert(o) {
  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
  if (o instanceof Hcl) {
    var h = o.h * __WEBPACK_IMPORTED_MODULE_2__math__["a" /* deg2rad */];
    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
  }
  if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */])) o = Object(__WEBPACK_IMPORTED_MODULE_1__color__["h" /* rgbConvert */])(o);
  var b = rgb2xyz(o.r),
      a = rgb2xyz(o.g),
      l = rgb2xyz(o.b),
      x = xyz2lab((0.4124564 * b + 0.3575761 * a + 0.1804375 * l) / Xn),
      y = xyz2lab((0.2126729 * b + 0.7151522 * a + 0.0721750 * l) / Yn),
      z = xyz2lab((0.0193339 * b + 0.1191920 * a + 0.9503041 * l) / Zn);
  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}

function lab(l, a, b, opacity) {
  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
}

function Lab(l, a, b, opacity) {
  this.l = +l;
  this.a = +a;
  this.b = +b;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Lab, lab, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* Color */], {
  brighter: function(k) {
    return new Lab(this.l + Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  darker: function(k) {
    return new Lab(this.l - Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  rgb: function() {
    var y = (this.l + 16) / 116,
        x = isNaN(this.a) ? y : y + this.a / 500,
        z = isNaN(this.b) ? y : y - this.b / 200;
    y = Yn * lab2xyz(y);
    x = Xn * lab2xyz(x);
    z = Zn * lab2xyz(z);
    return new __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */](
      xyz2rgb( 3.2404542 * x - 1.5371385 * y - 0.4985314 * z), // D65 -> sRGB
      xyz2rgb(-0.9692660 * x + 1.8760108 * y + 0.0415560 * z),
      xyz2rgb( 0.0556434 * x - 0.2040259 * y + 1.0572252 * z),
      this.opacity
    );
  }
}));

function xyz2lab(t) {
  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
}

function lab2xyz(t) {
  return t > t1 ? t * t * t : t2 * (t - t0);
}

function xyz2rgb(x) {
  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}

function rgb2xyz(x) {
  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}

function hclConvert(o) {
  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
  if (!(o instanceof Lab)) o = labConvert(o);
  var h = Math.atan2(o.b, o.a) * __WEBPACK_IMPORTED_MODULE_2__math__["b" /* rad2deg */];
  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}

function hcl(h, c, l, opacity) {
  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}

function Hcl(h, c, l, opacity) {
  this.h = +h;
  this.c = +c;
  this.l = +l;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Hcl, hcl, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* Color */], {
  brighter: function(k) {
    return new Hcl(this.h, this.c, this.l + Kn * (k == null ? 1 : k), this.opacity);
  },
  darker: function(k) {
    return new Hcl(this.h, this.c, this.l - Kn * (k == null ? 1 : k), this.opacity);
  },
  rgb: function() {
    return labConvert(this).rgb();
  }
}));


/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cubehelix;
/* unused harmony export Cubehelix */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(192);




var A = -0.14861,
    B = +1.78277,
    C = -0.29227,
    D = -0.90649,
    E = +1.97294,
    ED = E * D,
    EB = E * B,
    BC_DA = B * C - D * A;

function cubehelixConvert(o) {
  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */])) o = Object(__WEBPACK_IMPORTED_MODULE_1__color__["h" /* rgbConvert */])(o);
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
      bl = b - l,
      k = (E * (g - l) - C * bl) / D,
      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
      h = s ? Math.atan2(k, bl) * __WEBPACK_IMPORTED_MODULE_2__math__["b" /* rad2deg */] - 120 : NaN;
  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}

function cubehelix(h, s, l, opacity) {
  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}

function Cubehelix(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Cubehelix, cubehelix, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* Color */], {
  brighter: function(k) {
    k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color__["c" /* brighter */] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* brighter */], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color__["d" /* darker */] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color__["d" /* darker */], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = isNaN(this.h) ? 0 : (this.h + 120) * __WEBPACK_IMPORTED_MODULE_2__math__["a" /* deg2rad */],
        l = +this.l,
        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
        cosh = Math.cos(h),
        sinh = Math.sin(h);
    return new __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */](
      255 * (l + a * (A * cosh + B * sinh)),
      255 * (l + a * (C * cosh + D * sinh)),
      255 * (l + a * (E * cosh)),
      this.opacity
    );
  }
}));


/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a = +a, b -= a, function(t) {
    return Math.round(a + b * t);
  };
});


/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export interpolateTransformCss */
/* unused harmony export interpolateTransformSvg */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parse__ = __webpack_require__(483);



function interpolateTransform(parse, pxComma, pxParen, degParen) {

  function pop(s) {
    return s.length ? s.pop() + " " : "";
  }

  function translate(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push("translate(", null, pxComma, null, pxParen);
      q.push({i: i - 4, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(xa, xb)}, {i: i - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(ya, yb)});
    } else if (xb || yb) {
      s.push("translate(" + xb + pxComma + yb + pxParen);
    }
  }

  function rotate(a, b, s, q) {
    if (a !== b) {
      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(a, b)});
    } else if (b) {
      s.push(pop(s) + "rotate(" + b + degParen);
    }
  }

  function skewX(a, b, s, q) {
    if (a !== b) {
      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(a, b)});
    } else if (b) {
      s.push(pop(s) + "skewX(" + b + degParen);
    }
  }

  function scale(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
      q.push({i: i - 4, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(xa, xb)}, {i: i - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(ya, yb)});
    } else if (xb !== 1 || yb !== 1) {
      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
  }

  return function(a, b) {
    var s = [], // string constants and placeholders
        q = []; // number interpolators
    a = parse(a), b = parse(b);
    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
    rotate(a.rotate, b.rotate, s, q);
    skewX(a.skewX, b.skewX, s, q);
    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
    a = b = null; // gc
    return function(t) {
      var i = -1, n = q.length, o;
      while (++i < n) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    };
  };
}

var interpolateTransformCss = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__["a" /* parseCss */], "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__["b" /* parseSvg */], ", ", ")", ")");


/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseCss;
/* harmony export (immutable) */ __webpack_exports__["b"] = parseSvg;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__decompose__ = __webpack_require__(484);


var cssNode,
    cssRoot,
    cssView,
    svgNode;

function parseCss(value) {
  if (value === "none") return __WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* identity */];
  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
  cssNode.style.transform = value;
  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
  cssRoot.removeChild(cssNode);
  value = value.slice(7, -1).split(",");
  return Object(__WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* default */])(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
}

function parseSvg(value) {
  if (value == null) return __WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* identity */];
  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
  svgNode.setAttribute("transform", value);
  if (!(value = svgNode.transform.baseVal.consolidate())) return __WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* identity */];
  value = value.matrix;
  return Object(__WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* default */])(value.a, value.b, value.c, value.d, value.e, value.f);
}


/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return identity; });
var degrees = 180 / Math.PI;

var identity = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};

/* harmony default export */ __webpack_exports__["a"] = (function(a, b, c, d, e, f) {
  var scaleX, scaleY, skewX;
  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
  return {
    translateX: e,
    translateY: f,
    rotate: Math.atan2(b, a) * degrees,
    skewX: Math.atan(skewX) * degrees,
    scaleX: scaleX,
    scaleY: scaleY
  };
});


/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var rho = Math.SQRT2,
    rho2 = 2,
    rho4 = 4,
    epsilon2 = 1e-12;

function cosh(x) {
  return ((x = Math.exp(x)) + 1 / x) / 2;
}

function sinh(x) {
  return ((x = Math.exp(x)) - 1 / x) / 2;
}

function tanh(x) {
  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}

// p0 = [ux0, uy0, w0]
// p1 = [ux1, uy1, w1]
/* unused harmony default export */ var _unused_webpack_default_export = (function(p0, p1) {
  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
      dx = ux1 - ux0,
      dy = uy1 - uy0,
      d2 = dx * dx + dy * dy,
      i,
      S;

  // Special case for u0 ≅ u1.
  if (d2 < epsilon2) {
    S = Math.log(w1 / w0) / rho;
    i = function(t) {
      return [
        ux0 + t * dx,
        uy0 + t * dy,
        w0 * Math.exp(rho * t * S)
      ];
    }
  }

  // General case.
  else {
    var d1 = Math.sqrt(d2),
        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
    S = (r1 - r0) / rho;
    i = function(t) {
      var s = t * S,
          coshr0 = cosh(r0),
          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
      return [
        ux0 + u * dx,
        uy0 + u * dy,
        w0 * coshr0 / cosh(rho * s + r0)
      ];
    }
  }

  i.duration = S * 1000;

  return i;
});


/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hslLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(56);



function hsl(hue) {
  return function(start, end) {
    var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["d" /* hsl */])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["d" /* hsl */])(end)).h),
        s = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.s, end.s),
        l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.s = s(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (hsl(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* hue */]));
var hslLong = hsl(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(56);



function lab(start, end) {
  var l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e" /* lab */])(start)).l, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e" /* lab */])(end)).l),
      a = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.a, end.a),
      b = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.b, end.b),
      opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
  return function(t) {
    start.l = l(t);
    start.a = a(t);
    start.b = b(t);
    start.opacity = opacity(t);
    return start + "";
  };
}


/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hclLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(56);



function hcl(hue) {
  return function(start, end) {
    var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["c" /* hcl */])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["c" /* hcl */])(end)).h),
        c = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.c, end.c),
        l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.c = c(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (hcl(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* hue */]));
var hclLong = hcl(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cubehelixLong; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(56);



function cubehelix(hue) {
  return (function cubehelixGamma(y) {
    y = +y;

    function cubehelix(start, end) {
      var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(end)).h),
          s = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.s, end.s),
          l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
          opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
      return function(t) {
        start.h = h(t);
        start.s = s(t);
        start.l = l(Math.pow(t, y));
        start.opacity = opacity(t);
        return start + "";
      };
    }

    cubehelix.gamma = cubehelixGamma;

    return cubehelix;
  })(1);
}

/* unused harmony default export */ var _unused_webpack_default_export = (cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* hue */]));
var cubehelixLong = cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(interpolator, n) {
  var samples = new Array(n);
  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
  return samples;
});


/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_format__ = __webpack_require__(201);



/* harmony default export */ __webpack_exports__["a"] = (function(domain, count, specifier) {
  var start = domain[0],
      stop = domain[domain.length - 1],
      step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["g" /* tickStep */])(start, stop, count == null ? 10 : count),
      precision;
  specifier = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["c" /* formatSpecifier */])(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s": {
      var value = Math.max(Math.abs(start), Math.abs(stop));
      if (specifier.precision == null && !isNaN(precision = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["e" /* precisionPrefix */])(step, value))) specifier.precision = precision;
      return Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["b" /* formatPrefix */])(specifier, value);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      if (specifier.precision == null && !isNaN(precision = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["f" /* precisionRound */])(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
      break;
    }
    case "f":
    case "%": {
      if (specifier.precision == null && !isNaN(precision = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["d" /* precisionFixed */])(step))) specifier.precision = precision - (specifier.type === "%") * 2;
      break;
    }
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["a" /* format */])(specifier);
});


/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return format; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatPrefix; });
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__(202);


var locale;
var format;
var formatPrefix;

defaultLocale({
  decimal: ".",
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});

function defaultLocale(definition) {
  locale = Object(__WEBPACK_IMPORTED_MODULE_0__locale__["a" /* default */])(definition);
  format = locale.format;
  formatPrefix = locale.formatPrefix;
  return locale;
}


/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(grouping, thousands) {
  return function(value, width) {
    var i = value.length,
        t = [],
        j = 0,
        g = grouping[0],
        length = 0;

    while (i > 0 && g > 0) {
      if (length + g + 1 > width) g = Math.max(1, width - length);
      t.push(value.substring(i -= g, i + g));
      if ((length += g + 1) > width) break;
      g = grouping[j = (j + 1) % grouping.length];
    }

    return t.reverse().join(thousands);
  };
});


/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
});


/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  x = x.toPrecision(p);

  out: for (var n = x.length, i = 1, i0 = -1, i1; i < n; ++i) {
    switch (x[i]) {
      case ".": i0 = i1 = i; break;
      case "0": if (i0 === 0) i0 = i; i1 = i; break;
      case "e": break out;
      default: if (i0 > 0) i0 = 0; break;
    }
  }

  return i0 > 0 ? x.slice(0, i0) + x.slice(i1 + 1) : x;
});


/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__(119);


/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  var d = Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1];
  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
});


/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(79);


/* harmony default export */ __webpack_exports__["a"] = (function(step) {
  return Math.max(0, -Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(Math.abs(step)));
});


/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(79);


/* harmony default export */ __webpack_exports__["a"] = (function(step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(value) / 3))) * 3 - Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(Math.abs(step)));
});


/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(79);


/* harmony default export */ __webpack_exports__["a"] = (function(step, max) {
  step = Math.abs(step), max = Math.abs(max) - step;
  return Math.max(0, Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(max) - Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(step)) + 1;
});


/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = log;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_format__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nice__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__continuous__ = __webpack_require__(78);






function deinterpolate(a, b) {
  return (b = Math.log(b / a))
      ? function(x) { return Math.log(x / a) / b; }
      : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(b);
}

function reinterpolate(a, b) {
  return a < 0
      ? function(t) { return -Math.pow(-b, t) * Math.pow(-a, 1 - t); }
      : function(t) { return Math.pow(b, t) * Math.pow(a, 1 - t); };
}

function pow10(x) {
  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}

function powp(base) {
  return base === 10 ? pow10
      : base === Math.E ? Math.exp
      : function(x) { return Math.pow(base, x); };
}

function logp(base) {
  return base === Math.E ? Math.log
      : base === 10 && Math.log10
      || base === 2 && Math.log2
      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
}

function reflect(f) {
  return function(x) {
    return -f(-x);
  };
}

function log() {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_4__continuous__["b" /* default */])(deinterpolate, reinterpolate).domain([1, 10]),
      domain = scale.domain,
      base = 10,
      logs = logp(10),
      pows = powp(10);

  function rescale() {
    logs = logp(base), pows = powp(base);
    if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
    return scale;
  }

  scale.base = function(_) {
    return arguments.length ? (base = +_, rescale()) : base;
  };

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.ticks = function(count) {
    var d = domain(),
        u = d[0],
        v = d[d.length - 1],
        r;

    if (r = v < u) i = u, u = v, v = i;

    var i = logs(u),
        j = logs(v),
        p,
        k,
        t,
        n = count == null ? 10 : +count,
        z = [];

    if (!(base % 1) && j - i < n) {
      i = Math.round(i) - 1, j = Math.round(j) + 1;
      if (u > 0) for (; i < j; ++i) {
        for (k = 1, p = pows(i); k < base; ++k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      } else for (; i < j; ++i) {
        for (k = base - 1, p = pows(i); k >= 1; --k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      }
    } else {
      z = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["h" /* ticks */])(i, j, Math.min(j - i, n)).map(pows);
    }

    return r ? z.reverse() : z;
  };

  scale.tickFormat = function(count, specifier) {
    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
    if (typeof specifier !== "function") specifier = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["a" /* format */])(specifier);
    if (count === Infinity) return specifier;
    if (count == null) count = 10;
    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
    return function(d) {
      var i = d / pows(Math.round(logs(d)));
      if (i * base < base - 0.5) i *= base;
      return i <= k ? specifier(d) : "";
    };
  };

  scale.nice = function() {
    return domain(Object(__WEBPACK_IMPORTED_MODULE_3__nice__["a" /* default */])(domain(), {
      floor: function(x) { return pows(Math.floor(logs(x))); },
      ceil: function(x) { return pows(Math.ceil(logs(x))); }
    }));
  };

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_4__continuous__["a" /* copy */])(scale, log().base(base));
  };

  return scale;
}


/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pow;
/* harmony export (immutable) */ __webpack_exports__["b"] = sqrt;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linear__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__continuous__ = __webpack_require__(78);




function raise(x, exponent) {
  return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
}

function pow() {
  var exponent = 1,
      scale = Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["b" /* default */])(deinterpolate, reinterpolate),
      domain = scale.domain;

  function deinterpolate(a, b) {
    return (b = raise(b, exponent) - (a = raise(a, exponent)))
        ? function(x) { return (raise(x, exponent) - a) / b; }
        : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(b);
  }

  function reinterpolate(a, b) {
    b = raise(b, exponent) - (a = raise(a, exponent));
    return function(t) { return raise(a + b * t, 1 / exponent); };
  }

  scale.exponent = function(_) {
    return arguments.length ? (exponent = +_, domain(domain())) : exponent;
  };

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["a" /* copy */])(scale, pow().exponent(exponent));
  };

  return Object(__WEBPACK_IMPORTED_MODULE_1__linear__["b" /* linearish */])(scale);
}

function sqrt() {
  return pow().exponent(0.5);
}


/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = quantile;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(35);



function quantile() {
  var domain = [],
      range = [],
      thresholds = [];

  function rescale() {
    var i = 0, n = Math.max(1, range.length);
    thresholds = new Array(n - 1);
    while (++i < n) thresholds[i - 1] = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["d" /* quantile */])(domain, i / n);
    return scale;
  }

  function scale(x) {
    if (!isNaN(x = +x)) return range[Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* bisect */])(thresholds, x)];
  }

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN] : [
      i > 0 ? thresholds[i - 1] : domain[0],
      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
    ];
  };

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [];
    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
    domain.sort(__WEBPACK_IMPORTED_MODULE_0_d3_array__["a" /* ascending */]);
    return rescale();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), rescale()) : range.slice();
  };

  scale.quantiles = function() {
    return thresholds.slice();
  };

  scale.copy = function() {
    return quantile()
        .domain(domain)
        .range(range);
  };

  return scale;
}


/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = quantize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__linear__ = __webpack_require__(54);




function quantize() {
  var x0 = 0,
      x1 = 1,
      n = 1,
      domain = [0.5],
      range = [0, 1];

  function scale(x) {
    if (x <= x) return range[Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* bisect */])(domain, x, 0, n)];
  }

  function rescale() {
    var i = -1;
    domain = new Array(n);
    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
    return scale;
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
  };

  scale.range = function(_) {
    return arguments.length ? (n = (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_)).length - 1, rescale()) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN]
        : i < 1 ? [x0, domain[0]]
        : i >= n ? [domain[n - 1], x1]
        : [domain[i - 1], domain[i]];
  };

  scale.copy = function() {
    return quantize()
        .domain([x0, x1])
        .range(range);
  };

  return Object(__WEBPACK_IMPORTED_MODULE_2__linear__["b" /* linearish */])(scale);
}


/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = threshold;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(35);



function threshold() {
  var domain = [0.5],
      range = [0, 1],
      n = 1;

  function scale(x) {
    if (x <= x) return range[Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* bisect */])(domain, x, 0, n)];
  }

  scale.domain = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return [domain[i - 1], domain[i]];
  };

  scale.copy = function() {
    return threshold()
        .domain(domain)
        .range(range);
  };

  return scale;
}


/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export milliseconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(12);


var millisecond = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function() {
  // noop
}, function(date, step) {
  date.setTime(+date + step);
}, function(start, end) {
  return end - start;
});

// An optimized implementation for this simple case.
millisecond.every = function(k) {
  k = Math.floor(k);
  if (!isFinite(k) || !(k > 0)) return null;
  if (!(k > 1)) return millisecond;
  return Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setTime(Math.floor(date / k) * k);
  }, function(date, step) {
    date.setTime(+date + step * k);
  }, function(start, end) {
    return (end - start) / k;
  });
};

/* harmony default export */ __webpack_exports__["a"] = (millisecond);
var milliseconds = millisecond.range;


/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export seconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(26);



var second = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setTime(Math.floor(date / __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationSecond */]) * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationSecond */]);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationSecond */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationSecond */];
}, function(date) {
  return date.getUTCSeconds();
});

/* harmony default export */ __webpack_exports__["a"] = (second);
var seconds = second.range;


/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export minutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(26);



var minute = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setTime(Math.floor(date / __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]) * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */];
}, function(date) {
  return date.getMinutes();
});

/* harmony default export */ __webpack_exports__["a"] = (minute);
var minutes = minute.range;


/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(26);



var hour = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  var offset = date.getTimezoneOffset() * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */] % __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */];
  if (offset < 0) offset += __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */];
  date.setTime(Math.floor((+date - offset) / __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */]) * __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */] + offset);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */];
}, function(date) {
  return date.getHours();
});

/* harmony default export */ __webpack_exports__["a"] = (hour);
var hours = hour.range;


/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export days */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(26);



var day = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setDate(date.getDate() + step);
}, function(start, end) {
  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]) / __WEBPACK_IMPORTED_MODULE_1__duration__["a" /* durationDay */];
}, function(date) {
  return date.getDate() - 1;
});

/* harmony default export */ __webpack_exports__["a"] = (day);
var days = day.range;


/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sunday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return monday; });
/* unused harmony export tuesday */
/* unused harmony export wednesday */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return thursday; });
/* unused harmony export friday */
/* unused harmony export saturday */
/* unused harmony export sundays */
/* unused harmony export mondays */
/* unused harmony export tuesdays */
/* unused harmony export wednesdays */
/* unused harmony export thursdays */
/* unused harmony export fridays */
/* unused harmony export saturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(26);



function weekday(i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setDate(date.getDate() + step * 7);
  }, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]) / __WEBPACK_IMPORTED_MODULE_1__duration__["e" /* durationWeek */];
  });
}

var sunday = weekday(0);
var monday = weekday(1);
var tuesday = weekday(2);
var wednesday = weekday(3);
var thursday = weekday(4);
var friday = weekday(5);
var saturday = weekday(6);

var sundays = sunday.range;
var mondays = monday.range;
var tuesdays = tuesday.range;
var wednesdays = wednesday.range;
var thursdays = thursday.range;
var fridays = friday.range;
var saturdays = saturday.range;


/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export months */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(12);


var month = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setMonth(date.getMonth() + step);
}, function(start, end) {
  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
  return date.getMonth();
});

/* harmony default export */ __webpack_exports__["a"] = (month);
var months = month.range;


/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export years */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(12);


var year = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setMonth(0, 1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
  return end.getFullYear() - start.getFullYear();
}, function(date) {
  return date.getFullYear();
});

// An optimized implementation for this simple case.
year.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setFullYear(date.getFullYear() + step * k);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (year);
var years = year.range;


/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(26);



var utcMinute = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCSeconds(0, 0);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */];
}, function(date) {
  return date.getUTCMinutes();
});

/* harmony default export */ __webpack_exports__["a"] = (utcMinute);
var utcMinutes = utcMinute.range;


/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(26);



var utcHour = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */];
}, function(date) {
  return date.getUTCHours();
});

/* harmony default export */ __webpack_exports__["a"] = (utcHour);
var utcHours = utcHour.range;


/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(26);



var utcDay = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["a" /* durationDay */];
}, function(date) {
  return date.getUTCDate() - 1;
});

/* harmony default export */ __webpack_exports__["a"] = (utcDay);
var utcDays = utcDay.range;


/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utcSunday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return utcMonday; });
/* unused harmony export utcTuesday */
/* unused harmony export utcWednesday */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return utcThursday; });
/* unused harmony export utcFriday */
/* unused harmony export utcSaturday */
/* unused harmony export utcSundays */
/* unused harmony export utcMondays */
/* unused harmony export utcTuesdays */
/* unused harmony export utcWednesdays */
/* unused harmony export utcThursdays */
/* unused harmony export utcFridays */
/* unused harmony export utcSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(26);



function utcWeekday(i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step * 7);
  }, function(start, end) {
    return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["e" /* durationWeek */];
  });
}

var utcSunday = utcWeekday(0);
var utcMonday = utcWeekday(1);
var utcTuesday = utcWeekday(2);
var utcWednesday = utcWeekday(3);
var utcThursday = utcWeekday(4);
var utcFriday = utcWeekday(5);
var utcSaturday = utcWeekday(6);

var utcSundays = utcSunday.range;
var utcMondays = utcMonday.range;
var utcTuesdays = utcTuesday.range;
var utcWednesdays = utcWednesday.range;
var utcThursdays = utcThursday.range;
var utcFridays = utcFriday.range;
var utcSaturdays = utcSaturday.range;


/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(12);


var utcMonth = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCDate(1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
  return date.getUTCMonth();
});

/* harmony default export */ __webpack_exports__["a"] = (utcMonth);
var utcMonths = utcMonth.range;


/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcYears */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(12);


var utcYear = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
  return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
  return date.getUTCFullYear();
});

// An optimized implementation for this simple case.
utcYear.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step * k);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (utcYear);
var utcYears = utcYear.range;


/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isoFormat__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaultLocale__ = __webpack_require__(121);



function parseIsoNative(string) {
  var date = new Date(string);
  return isNaN(date) ? null : date;
}

var parseIso = +new Date("2000-01-01T00:00:00.000Z")
    ? parseIsoNative
    : Object(__WEBPACK_IMPORTED_MODULE_1__defaultLocale__["c" /* utcParse */])(__WEBPACK_IMPORTED_MODULE_0__isoFormat__["a" /* isoSpecifier */]);

/* unused harmony default export */ var _unused_webpack_default_export = (parseIso);


/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__time__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_time_format__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_time__ = __webpack_require__(120);




/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__time__["a" /* calendar */])(__WEBPACK_IMPORTED_MODULE_2_d3_time__["v" /* utcYear */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["q" /* utcMonth */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["u" /* utcWeek */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["l" /* utcDay */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["m" /* utcHour */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["o" /* utcMinute */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["r" /* utcSecond */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["n" /* utcMillisecond */], __WEBPACK_IMPORTED_MODULE_1_d3_time_format__["b" /* utcFormat */]).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]);
});


/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(57);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf"));


/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(57);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6"));


/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(57);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9"));


/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(57);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5"));


/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(55);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["b" /* interpolateCubehelixLong */])(Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(300, 0.5, 0.0), Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(-240, 0.5, 1.0)));


/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return warm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cool; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(55);



var warm = Object(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["b" /* interpolateCubehelixLong */])(Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(-100, 0.75, 0.35), Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(80, 1.50, 0.8));

var cool = Object(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["b" /* interpolateCubehelixLong */])(Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(260, 0.75, 0.35), Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(80, 1.50, 0.8));

var rainbow = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])();

/* harmony default export */ __webpack_exports__["b"] = (function(t) {
  if (t < 0 || t > 1) t -= Math.floor(t);
  var ts = Math.abs(t - 0.5);
  rainbow.h = 360 * t - 100;
  rainbow.s = 1.5 - 1.5 * ts;
  rainbow.l = 0.8 - 0.9 * ts;
  return rainbow + "";
});


/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return magma; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return inferno; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return plasma; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(57);


function ramp(range) {
  var n = range.length;
  return function(t) {
    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (ramp(Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725")));

var magma = ramp(Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));

var inferno = ramp(Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));

var plasma = ramp(Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));


/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sequential;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__linear__ = __webpack_require__(54);


function sequential(interpolator) {
  var x0 = 0,
      x1 = 1,
      clamp = false;

  function scale(x) {
    var t = (x - x0) / (x1 - x0);
    return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [x0, x1];
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, scale) : clamp;
  };

  scale.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };

  scale.copy = function() {
    return sequential(interpolator).domain([x0, x1]).clamp(clamp);
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__linear__["b" /* linearish */])(scale);
}


/***/ }),
/* 530 */
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_PureRender__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_PolarUtils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Polar Grid
 */






var PolarGrid = Object(__WEBPACK_IMPORTED_MODULE_2__util_PureRender__["a" /* default */])(_class = (_temp = _class2 = function (_Component) {
  _inherits(PolarGrid, _Component);

  function PolarGrid() {
    _classCallCheck(this, PolarGrid);

    return _possibleConstructorReturn(this, (PolarGrid.__proto__ || Object.getPrototypeOf(PolarGrid)).apply(this, arguments));
  }

  _createClass(PolarGrid, [{
    key: 'getPolygonPath',
    value: function getPolygonPath(radius) {
      var _props = this.props,
          cx = _props.cx,
          cy = _props.cy,
          polarAngles = _props.polarAngles;


      var path = '';

      polarAngles.forEach(function (angle, i) {
        var point = Object(__WEBPACK_IMPORTED_MODULE_3__util_PolarUtils__["e" /* polarToCartesian */])(cx, cy, radius, angle);

        if (i) {
          path += 'L ' + point.x + ',' + point.y;
        } else {
          path += 'M ' + point.x + ',' + point.y;
        }
      });
      path += 'Z';

      return path;
    }
    /**
     * Draw axis of radial line
     * @return {[type]} The lines
     */

  }, {
    key: 'renderPolarAngles',
    value: function renderPolarAngles() {
      var _props2 = this.props,
          cx = _props2.cx,
          cy = _props2.cy,
          innerRadius = _props2.innerRadius,
          outerRadius = _props2.outerRadius,
          polarAngles = _props2.polarAngles;


      if (!polarAngles || !polarAngles.length) {
        return null;
      }
      var props = _extends({
        stroke: '#ccc'
      }, Object(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["k" /* getPresentationAttributes */])(this.props));

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'g',
        { className: 'recharts-polar-grid-angle' },
        polarAngles.map(function (entry, i) {
          var start = Object(__WEBPACK_IMPORTED_MODULE_3__util_PolarUtils__["e" /* polarToCartesian */])(cx, cy, innerRadius, entry);
          var end = Object(__WEBPACK_IMPORTED_MODULE_3__util_PolarUtils__["e" /* polarToCartesian */])(cx, cy, outerRadius, entry);

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line', _extends({}, props, {
            key: 'line-' + i,
            x1: start.x,
            y1: start.y,
            x2: end.x,
            y2: end.y
          }));
        })
      );
    }
    /**
     * Draw concentric circles
     * @param {Number} radius The radius of circle
     * @param {Number} index  The index of circle
     * @param {Object} extraProps Extra props
     * @return {ReactElement} circle
     */

  }, {
    key: 'renderConcentricCircle',
    value: function renderConcentricCircle(radius, index, extraProps) {
      var _props3 = this.props,
          cx = _props3.cx,
          cy = _props3.cy;

      var props = _extends({
        stroke: '#ccc'
      }, Object(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["k" /* getPresentationAttributes */])(this.props), {
        fill: 'none'
      }, extraProps);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle', _extends({}, props, {
        className: 'recharts-polar-grid-concentric-circle',
        key: 'circle-' + index,
        cx: cx,
        cy: cy,
        r: radius
      }));
    }
    /**
     * Draw concentric polygons
     * @param {Number} radius     The radius of polygon
     * @param {Number} index      The index of polygon
     * @param {Object} extraProps Extra props
     * @return {ReactElement} polygon
     */

  }, {
    key: 'renderConcentricPolygon',
    value: function renderConcentricPolygon(radius, index, extraProps) {
      var props = _extends({
        stroke: '#ccc'
      }, Object(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["k" /* getPresentationAttributes */])(this.props), {
        fill: 'none'
      }, extraProps);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', _extends({}, props, {
        className: 'recharts-polar-grid-concentric-polygon',
        key: 'path-' + index,
        d: this.getPolygonPath(radius)
      }));
    }

    /**
     * Draw concentric axis
     * @return {ReactElement} Concentric axis
     * @todo Optimize the name
     */

  }, {
    key: 'renderConcentricPath',
    value: function renderConcentricPath() {
      var _this2 = this;

      var _props4 = this.props,
          polarRadius = _props4.polarRadius,
          gridType = _props4.gridType;


      if (!polarRadius || !polarRadius.length) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'g',
        { className: 'recharts-polar-grid-concentric' },
        polarRadius.map(function (entry, i) {
          return gridType === 'circle' ? _this2.renderConcentricCircle(entry, i) : _this2.renderConcentricPolygon(entry, i);
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var outerRadius = this.props.outerRadius;


      if (outerRadius <= 0) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'g',
        { className: 'recharts-polar-grid' },
        this.renderPolarAngles(),
        this.renderConcentricPath()
      );
    }
  }]);

  return PolarGrid;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class2.displayName = 'PolarGrid', _class2.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {
  cx: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  cy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  innerRadius: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  outerRadius: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  polarAngles: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number),
  polarRadius: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number),
  gridType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['polygon', 'circle'])
}), _class2.defaultProps = {
  cx: 0,
  cy: 0,
  innerRadius: 0,
  outerRadius: 0,
  gridType: 'polygon'
}, _temp)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (PolarGrid);

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

var baseExtremum = __webpack_require__(76),
    baseIteratee = __webpack_require__(51),
    baseLt = __webpack_require__(176);

/**
 * This method is like `_.min` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * the value is ranked. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * _.minBy(objects, function(o) { return o.n; });
 * // => { 'n': 1 }
 *
 * // The `_.property` iteratee shorthand.
 * _.minBy(objects, 'n');
 * // => { 'n': 1 }
 */
function minBy(array, iteratee) {
  return (array && array.length)
    ? baseExtremum(array, baseIteratee(iteratee, 2), baseLt)
    : undefined;
}

module.exports = minBy;


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

var baseRange = __webpack_require__(534),
    isIterateeCall = __webpack_require__(173),
    toFinite = __webpack_require__(535);

/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */
function createRange(fromRight) {
  return function(start, end, step) {
    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
      end = step = undefined;
    }
    // Ensure the sign of `-0` is preserved.
    start = toFinite(start);
    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = toFinite(end);
    }
    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
    return baseRange(start, end, step, fromRight);
  };
}

module.exports = createRange;


/***/ }),
/* 534 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

module.exports = baseRange;


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(170);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_PureRender__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_DataUtils__ = __webpack_require__(6);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview Cartesian Grid
 */







var CartesianGrid = Object(__WEBPACK_IMPORTED_MODULE_3__util_PureRender__["a" /* default */])(_class = (_temp = _class2 = function (_Component) {
  _inherits(CartesianGrid, _Component);

  function CartesianGrid() {
    _classCallCheck(this, CartesianGrid);

    return _possibleConstructorReturn(this, (CartesianGrid.__proto__ || Object.getPrototypeOf(CartesianGrid)).apply(this, arguments));
  }

  _createClass(CartesianGrid, [{
    key: 'renderLineItem',
    value: function renderLineItem(option, props) {
      var lineItem = void 0;

      if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(option)) {
        lineItem = __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(option)) {
        lineItem = option(props);
      } else {
        var x1 = props.x1,
            y1 = props.y1,
            x2 = props.x2,
            y2 = props.y2,
            key = props.key,
            others = _objectWithoutProperties(props, ['x1', 'y1', 'x2', 'y2', 'key']);

        lineItem = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('line', _extends({}, Object(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["k" /* getPresentationAttributes */])(others), {
          x1: x1,
          y1: y1,
          x2: x2,
          y2: y2,
          fill: 'none',
          key: key
        }));
      }

      return lineItem;
    }

    /**
     * Draw the horizontal grid lines
     * @param {Array} horizontalPoints either passed in as props or generated from function
     * @return {Group} Horizontal lines
     */

  }, {
    key: 'renderHorizontal',
    value: function renderHorizontal(horizontalPoints) {
      var _this2 = this;

      var _props = this.props,
          x = _props.x,
          width = _props.width,
          horizontal = _props.horizontal;


      if (!horizontalPoints || !horizontalPoints.length) {
        return null;
      }

      var items = horizontalPoints.map(function (entry, i) {
        var props = _extends({}, _this2.props, {
          x1: x,
          y1: entry,
          x2: x + width,
          y2: entry,
          key: 'line-' + i,
          index: i
        });

        return _this2.renderLineItem(horizontal, props);
      });

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'g',
        { className: 'recharts-cartesian-grid-horizontal' },
        items
      );
    }

    /**
     * Draw vertical grid lines
     * @param {Array} verticalPoints either passed in as props or generated from function
     * @return {Group} Vertical lines
     */

  }, {
    key: 'renderVertical',
    value: function renderVertical(verticalPoints) {
      var _this3 = this;

      var _props2 = this.props,
          y = _props2.y,
          height = _props2.height,
          vertical = _props2.vertical;


      if (!verticalPoints || !verticalPoints.length) {
        return null;
      }

      var items = verticalPoints.map(function (entry, i) {
        var props = _extends({}, _this3.props, {
          x1: entry,
          y1: y,
          x2: entry,
          y2: y + height,
          key: 'line-' + i,
          index: i
        });

        return _this3.renderLineItem(vertical, props);
      });

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'g',
        { className: 'recharts-cartesian-grid-vertical' },
        items
      );
    }
  }, {
    key: 'renderBackground',
    value: function renderBackground() {
      var fill = this.props.fill;


      if (!fill || fill === 'none') {
        return null;
      }

      var _props3 = this.props,
          fillOpacity = _props3.fillOpacity,
          x = _props3.x,
          y = _props3.y,
          width = _props3.width,
          height = _props3.height;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('rect', {
        x: x,
        y: y,
        width: width,
        height: height,
        stroke: 'none',
        fill: fill,
        fillOpacity: fillOpacity,
        className: 'recharts-cartesian-grid-bg'
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          x = _props4.x,
          y = _props4.y,
          width = _props4.width,
          height = _props4.height,
          horizontal = _props4.horizontal,
          vertical = _props4.vertical,
          horizontalCoordinatesGenerator = _props4.horizontalCoordinatesGenerator,
          verticalCoordinatesGenerator = _props4.verticalCoordinatesGenerator,
          xAxis = _props4.xAxis,
          yAxis = _props4.yAxis,
          offset = _props4.offset,
          chartWidth = _props4.chartWidth,
          chartHeight = _props4.chartHeight;


      if (!Object(__WEBPACK_IMPORTED_MODULE_5__util_DataUtils__["g" /* isNumber */])(width) || width <= 0 || !Object(__WEBPACK_IMPORTED_MODULE_5__util_DataUtils__["g" /* isNumber */])(height) || height <= 0 || !Object(__WEBPACK_IMPORTED_MODULE_5__util_DataUtils__["g" /* isNumber */])(x) || x !== +x || !Object(__WEBPACK_IMPORTED_MODULE_5__util_DataUtils__["g" /* isNumber */])(y) || y !== +y) {
        return null;
      }

      var _props5 = this.props,
          horizontalPoints = _props5.horizontalPoints,
          verticalPoints = _props5.verticalPoints;

      // No horizontal points are specified

      if ((!horizontalPoints || !horizontalPoints.length) && __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(horizontalCoordinatesGenerator)) {
        horizontalPoints = horizontalCoordinatesGenerator({ yAxis: yAxis, width: chartWidth,
          height: chartHeight, offset: offset });
      }

      // No vertical points are specified
      if ((!verticalPoints || !verticalPoints.length) && __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(verticalCoordinatesGenerator)) {
        verticalPoints = verticalCoordinatesGenerator({ xAxis: xAxis, width: chartWidth,
          height: chartHeight, offset: offset });
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'g',
        { className: 'recharts-cartesian-grid' },
        this.renderBackground(),
        horizontal && this.renderHorizontal(horizontalPoints),
        vertical && this.renderVertical(verticalPoints)
      );
    }
  }]);

  return CartesianGrid;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class2.displayName = 'CartesianGrid', _class2.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {
  x: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  y: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  width: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  horizontal: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool]),
  vertical: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool]),
  horizontalPoints: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number),
  verticalPoints: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number),
  horizontalCoordinatesGenerator: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  verticalCoordinatesGenerator: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  xAxis: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  yAxis: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  offset: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  chartWidth: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  chartHeight: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number
}), _class2.defaultProps = {
  horizontal: true,
  vertical: true,
  // The ordinates of horizontal grid lines
  horizontalPoints: [],
  // The abscissas of vertical grid lines
  verticalPoints: [],

  stroke: '#ccc',
  fill: 'none'
}, _temp)) || _class;

/* harmony default export */ __webpack_exports__["a"] = (CartesianGrid);

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__generateCategoricalChart__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cartesian_Line__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cartesian_XAxis__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cartesian_YAxis__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_CartesianUtils__ = __webpack_require__(59);
/**
 * @fileOverview Line Chart
 */






/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__generateCategoricalChart__["a" /* default */])({
  chartName: 'LineChart',
  GraphicalChild: __WEBPACK_IMPORTED_MODULE_1__cartesian_Line__["a" /* default */],
  axisComponents: [{ axisType: 'xAxis', AxisComp: __WEBPACK_IMPORTED_MODULE_2__cartesian_XAxis__["a" /* default */] }, { axisType: 'yAxis', AxisComp: __WEBPACK_IMPORTED_MODULE_3__cartesian_YAxis__["a" /* default */] }],
  formatAxisMap: __WEBPACK_IMPORTED_MODULE_4__util_CartesianUtils__["a" /* formatAxisMap */]
}));

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

var debounce = __webpack_require__(169),
    isObject = __webpack_require__(17);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return eventCenter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SYNC_EVENT; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_events__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_events__);


var eventCenter = new __WEBPACK_IMPORTED_MODULE_0_events___default.a();

if (eventCenter.setMaxListeners) {
  eventCenter.setMaxListeners(10);
}


var SYNC_EVENT = 'recharts.syncMouseEvents';

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__generateCategoricalChart__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cartesian_Bar__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cartesian_XAxis__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cartesian_YAxis__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_CartesianUtils__ = __webpack_require__(59);
/**
 * @fileOverview Bar Chart
 */






/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__generateCategoricalChart__["a" /* default */])({
  chartName: 'BarChart',
  GraphicalChild: __WEBPACK_IMPORTED_MODULE_1__cartesian_Bar__["a" /* default */],
  axisComponents: [{ axisType: 'xAxis', AxisComp: __WEBPACK_IMPORTED_MODULE_2__cartesian_XAxis__["a" /* default */] }, { axisType: 'yAxis', AxisComp: __WEBPACK_IMPORTED_MODULE_3__cartesian_YAxis__["a" /* default */] }],
  formatAxisMap: __WEBPACK_IMPORTED_MODULE_4__util_CartesianUtils__["a" /* formatAxisMap */]
}));

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__generateCategoricalChart__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__polar_PolarAngleAxis__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__polar_PolarRadiusAxis__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_PolarUtils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__polar_Pie__ = __webpack_require__(216);
/**
 * @fileOverview Pie Chart
 */







/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__generateCategoricalChart__["a" /* default */])({
  chartName: 'PieChart',
  GraphicalChild: __WEBPACK_IMPORTED_MODULE_5__polar_Pie__["a" /* default */],
  eventType: 'item',
  legendContent: 'children',
  axisComponents: [{ axisType: 'angleAxis', AxisComp: __WEBPACK_IMPORTED_MODULE_2__polar_PolarAngleAxis__["a" /* default */] }, { axisType: 'radiusAxis', AxisComp: __WEBPACK_IMPORTED_MODULE_3__polar_PolarRadiusAxis__["a" /* default */] }],
  formatAxisMap: __WEBPACK_IMPORTED_MODULE_4__util_PolarUtils__["b" /* formatAxisMap */],
  defaultProps: {
    layout: 'centric',
    startAngle: 0,
    endAngle: 360,
    cx: '50%',
    cy: '50%',
    innerRadius: 0,
    outerRadius: '80%'
  },
  propTypes: {
    layout: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['centric']),
    startAngle: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
    endAngle: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
    cx: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string]),
    cy: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string]),
    innerRadius: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string]),
    outerRadius: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string])
  }
}));

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isNaN__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isNaN___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isNaN__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_smooth__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_smooth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_smooth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__container_Surface__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__container_Layer__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shape_Rectangle__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__component_Tooltip__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_PureRender__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_ChartUtils__ = __webpack_require__(11);



var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp2;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @fileOverview TreemapChart
 */













var computeNode = function computeNode(_ref) {
  var depth = _ref.depth,
      node = _ref.node,
      index = _ref.index,
      valueKey = _ref.valueKey;
  var children = node.children;

  var childDepth = depth + 1;
  var computedChildren = children && children.length ? children.map(function (child, i) {
    return computeNode({ depth: childDepth, node: child, index: i, valueKey: valueKey });
  }) : null;
  var value = void 0;

  if (children && children.length) {
    value = computedChildren.reduce(function (result, child) {
      return result + child.value;
    }, 0);
  } else {
    value = __WEBPACK_IMPORTED_MODULE_1_lodash_isNaN___default()(node[valueKey]) || node[valueKey] <= 0 ? 0 : node[valueKey];
  }

  return _extends({}, node, {
    children: computedChildren,
    value: value, depth: depth, index: index
  });
};

var filterRect = function filterRect(node) {
  return { x: node.x, y: node.y, width: node.width, height: node.height };
};

// Compute the area for each child based on value & scale.
var getAreaOfChildren = function getAreaOfChildren(children, areaValueRatio) {
  var ratio = areaValueRatio < 0 ? 0 : areaValueRatio;

  return children.map(function (child) {
    var area = child.value * ratio;

    return _extends({}, child, {
      area: __WEBPACK_IMPORTED_MODULE_1_lodash_isNaN___default()(area) || area <= 0 ? 0 : area
    });
  });
};

// Computes the score for the specified row, as the worst aspect ratio.
var getWorstScore = function getWorstScore(row, parentSize, aspectRatio) {
  var parentArea = parentSize * parentSize;
  var rowArea = row.area * row.area;

  var _row$reduce = row.reduce(function (result, child) {
    return {
      min: Math.min(result.min, child.area),
      max: Math.max(result.max, child.area)
    };
  }, { min: Infinity, max: 0 }),
      min = _row$reduce.min,
      max = _row$reduce.max;

  return rowArea ? Math.max(parentArea * max * aspectRatio / rowArea, rowArea / (parentArea * min * aspectRatio)) : Infinity;
};

var horizontalPosition = function horizontalPosition(row, parentSize, parentRect, isFlush) {
  var rowHeight = parentSize ? Math.round(row.area / parentSize) : 0;

  if (isFlush || rowHeight > parentRect.height) {
    rowHeight = parentRect.height;
  }

  var curX = parentRect.x;
  var child = void 0;
  for (var i = 0, len = row.length; i < len; i++) {
    child = row[i];
    child.x = curX;
    child.y = parentRect.y;
    child.height = rowHeight;
    child.width = Math.min(rowHeight ? Math.round(child.area / rowHeight) : 0, parentRect.x + parentRect.width - curX);
    curX += child.width;
  }
  // what's z
  child.z = true;
  // add the remain x to the last one of row
  child.width += parentRect.x + parentRect.width - curX;

  return _extends({}, parentRect, {
    y: parentRect.y + rowHeight,
    height: parentRect.height - rowHeight
  });
};

var verticalPosition = function verticalPosition(row, parentSize, parentRect, isFlush) {
  var rowWidth = parentSize ? Math.round(row.area / parentSize) : 0;

  if (isFlush || rowWidth > parentRect.width) {
    rowWidth = parentRect.width;
  }

  var curY = parentRect.y;
  var child = void 0;
  for (var i = 0, len = row.length; i < len; i++) {
    child = row[i];
    child.x = parentRect.x;
    child.y = curY;
    child.width = rowWidth;
    child.height = Math.min(rowWidth ? Math.round(child.area / rowWidth) : 0, parentRect.y + parentRect.height - curY);
    curY += child.height;
  }
  child.z = false;
  child.height += parentRect.y + parentRect.height - curY;

  return _extends({}, parentRect, {
    x: parentRect.x + rowWidth,
    width: parentRect.width - rowWidth
  });
};

var position = function position(row, parentSize, parentRect, isFlush) {
  if (parentSize === parentRect.width) {
    return horizontalPosition(row, parentSize, parentRect, isFlush);
  }

  return verticalPosition(row, parentSize, parentRect, isFlush);
};

// Recursively arranges the specified node's children into squarified rows.
var squarify = function squarify(node, aspectRatio) {
  var children = node.children;

  if (children && children.length) {
    var rect = filterRect(node);
    var row = [];
    var best = Infinity; // the best row score so far
    var child = void 0,
        score = void 0; // the current row score
    var size = Math.min(rect.width, rect.height); // initial orientation
    var scaleChildren = getAreaOfChildren(children, rect.width * rect.height / node.value);
    var tempChildren = scaleChildren.slice();

    row.area = 0;

    while (tempChildren.length > 0) {
      // row first
      row.push(child = tempChildren[0]);
      row.area += child.area;

      score = getWorstScore(row, size, aspectRatio);
      if (score <= best) {
        // continue with this orientation
        tempChildren.shift();
        best = score;
      } else {
        // abort, and try a different orientation
        row.area -= row.pop().area;
        rect = position(row, size, rect, false);
        size = Math.min(rect.width, rect.height);
        row.length = row.area = 0;
        best = Infinity;
      }
    }

    if (row.length) {
      rect = position(row, size, rect, true);
      row.length = row.area = 0;
    }

    return _extends({}, node, { children: scaleChildren.map(function (c) {
        return squarify(c, aspectRatio);
      }) });
  }

  return node;
};

var Treemap = Object(__WEBPACK_IMPORTED_MODULE_11__util_PureRender__["a" /* default */])(_class = (_temp2 = _class2 = function (_Component) {
  _inherits(Treemap, _Component);

  function Treemap() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, Treemap);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Treemap.__proto__ || Object.getPrototypeOf(Treemap)).call.apply(_ref2, [this].concat(args))), _this), _this.state = _this.createDefaultState(), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Treemap, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.data !== this.props.data) {
        this.setState(this.createDefaultState());
      }
    }
    /**
     * Returns default, reset state for the treemap chart.
     * @return {Object} Whole new state
     */

  }, {
    key: 'createDefaultState',
    value: function createDefaultState() {
      return {
        isTooltipActive: false,
        activeNode: null
      };
    }
  }, {
    key: 'handleMouseEnter',
    value: function handleMouseEnter(node, e) {
      var _props = this.props,
          onMouseEnter = _props.onMouseEnter,
          children = _props.children;

      var tooltipItem = Object(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["i" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_10__component_Tooltip__["a" /* default */]);

      if (tooltipItem) {
        this.setState({
          isTooltipActive: true,
          activeNode: node
        }, function () {
          if (onMouseEnter) {
            onMouseEnter(node, e);
          }
        });
      } else if (onMouseEnter) {
        onMouseEnter(node, e);
      }
    }
  }, {
    key: 'handleMouseLeave',
    value: function handleMouseLeave(node, e) {
      var _props2 = this.props,
          onMouseLeave = _props2.onMouseLeave,
          children = _props2.children;

      var tooltipItem = Object(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["i" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_10__component_Tooltip__["a" /* default */]);

      if (tooltipItem) {
        this.setState({
          isTooltipActive: false,
          activeNode: null
        }, function () {
          if (onMouseLeave) {
            onMouseLeave(node, e);
          }
        });
      } else if (onMouseLeave) {
        onMouseLeave(node, e);
      }
    }
  }, {
    key: 'handleClick',
    value: function handleClick(node) {
      var onClick = this.props.onClick;


      if (onClick) {
        onClick(node);
      }
    }
  }, {
    key: 'renderAnimatedItem',
    value: function renderAnimatedItem(content, nodeProps, isLeaf) {
      var _this2 = this;

      var _props3 = this.props,
          isAnimationActive = _props3.isAnimationActive,
          animationBegin = _props3.animationBegin,
          animationDuration = _props3.animationDuration,
          animationEasing = _props3.animationEasing,
          isUpdateAnimationActive = _props3.isUpdateAnimationActive;
      var width = nodeProps.width,
          height = nodeProps.height,
          x = nodeProps.x,
          y = nodeProps.y;

      var translateX = parseInt((Math.random() * 2 - 1) * width, 10);
      var event = {};

      if (isLeaf) {
        event = {
          onMouseEnter: this.handleMouseEnter.bind(this, nodeProps),
          onMouseLeave: this.handleMouseLeave.bind(this, nodeProps),
          onClick: this.handleClick.bind(this, nodeProps)
        };
      }

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_smooth___default.a,
        {
          from: { x: x, y: y, width: width, height: height },
          to: { x: x, y: y, width: width, height: height },
          duration: animationDuration,
          easing: animationEasing,
          isActive: isUpdateAnimationActive
        },
        function (_ref3) {
          var currX = _ref3.x,
              currY = _ref3.y,
              currWidth = _ref3.width,
              currHeight = _ref3.height;
          return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_smooth___default.a,
            {
              from: 'translate(' + translateX + 'px, ' + translateX + 'px)',
              to: 'translate(0, 0)',
              attributeName: 'transform',
              begin: animationBegin,
              easing: animationEasing,
              isActive: isAnimationActive,
              duration: animationDuration
            },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7__container_Layer__["a" /* default */],
              event,
              _this2.renderContentItem(content, _extends({}, nodeProps, {
                isAnimationActive: isAnimationActive,
                isUpdateAnimationActive: !isUpdateAnimationActive,
                width: currWidth,
                height: currHeight,
                x: currX,
                y: currY
              }))
            )
          );
        }
      );
    }
  }, {
    key: 'renderContentItem',
    value: function renderContentItem(content, nodeProps) {
      if (__WEBPACK_IMPORTED_MODULE_2_react___default.a.isValidElement(content)) {
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(content, nodeProps);
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(content)) {
        return content(nodeProps);
      }

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shape_Rectangle__["a" /* default */], _extends({
        fill: '#fff',
        stroke: '#000'
      }, nodeProps));
    }
  }, {
    key: 'renderNode',
    value: function renderNode(root, node, i) {
      var _this3 = this;

      var content = this.props.content;

      var nodeProps = _extends({}, Object(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["k" /* getPresentationAttributes */])(this.props), node, { root: root });
      var isLeaf = !node.children || !node.children.length;

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__container_Layer__["a" /* default */],
        { key: 'recharts-treemap-node-' + i, className: 'recharts-treemap-depth-' + node.depth },
        this.renderAnimatedItem(content, nodeProps, isLeaf),
        node.children && node.children.length ? node.children.map(function (child, index) {
          return _this3.renderNode(node, child, index);
        }) : null
      );
    }
  }, {
    key: 'renderAllNodes',
    value: function renderAllNodes() {
      var _props4 = this.props,
          width = _props4.width,
          height = _props4.height,
          data = _props4.data,
          dataKey = _props4.dataKey,
          aspectRatio = _props4.aspectRatio;


      var root = computeNode({
        depth: 0,
        node: { children: data, x: 0, y: 0, width: width, height: height },
        index: 0,
        valueKey: dataKey
      });

      var formatRoot = squarify(root, aspectRatio);

      return this.renderNode(formatRoot, formatRoot, 0);
    }
  }, {
    key: 'renderTooltip',
    value: function renderTooltip() {
      var _props5 = this.props,
          children = _props5.children,
          nameKey = _props5.nameKey;

      var tooltipItem = Object(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["i" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_10__component_Tooltip__["a" /* default */]);

      if (!tooltipItem) {
        return null;
      }

      var _props6 = this.props,
          width = _props6.width,
          height = _props6.height,
          dataKey = _props6.dataKey;
      var _state = this.state,
          isTooltipActive = _state.isTooltipActive,
          activeNode = _state.activeNode;

      var viewBox = { x: 0, y: 0, width: width, height: height };
      var coordinate = activeNode ? {
        x: activeNode.x + activeNode.width / 2,
        y: activeNode.y + activeNode.height / 2
      } : null;
      var payload = isTooltipActive && activeNode ? [{
        payload: activeNode,
        name: Object(__WEBPACK_IMPORTED_MODULE_12__util_ChartUtils__["w" /* getValueByDataKey */])(activeNode, nameKey, ''),
        value: Object(__WEBPACK_IMPORTED_MODULE_12__util_ChartUtils__["w" /* getValueByDataKey */])(activeNode, dataKey)
      }] : [];

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(tooltipItem, {
        viewBox: viewBox,
        active: isTooltipActive,
        coordinate: coordinate,
        label: '',
        payload: payload
      });
    }
  }, {
    key: 'render',
    value: function render() {
      if (!Object(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["q" /* validateWidthHeight */])(this)) {
        return null;
      }

      var _props7 = this.props,
          width = _props7.width,
          height = _props7.height,
          className = _props7.className,
          style = _props7.style,
          children = _props7.children,
          others = _objectWithoutProperties(_props7, ['width', 'height', 'className', 'style', 'children']);

      var attrs = Object(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["k" /* getPresentationAttributes */])(others);

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        {
          className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()('recharts-wrapper', className),
          style: _extends({}, style, { position: 'relative', cursor: 'default', width: width, height: height })
        },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__container_Surface__["a" /* default */],
          _extends({}, attrs, { width: width, height: height }),
          this.renderAllNodes(),
          Object(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["g" /* filterSvgElements */])(children)
        ),
        this.renderTooltip()
      );
    }
  }]);

  return Treemap;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]), _class2.displayName = 'Treemap', _class2.propTypes = {
  width: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  data: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,
  style: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  aspectRatio: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  content: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func]),
  fill: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  stroke: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  nameKey: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func]),
  dataKey: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func]),
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),

  onMouseEnter: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  onClick: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,

  isAnimationActive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  isUpdateAnimationActive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  animationBegin: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  animationDuration: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  animationEasing: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
}, _class2.defaultProps = {
  dataKey: 'value',
  aspectRatio: 0.5 * (1 + Math.sqrt(5)),
  isAnimationActive: !Object(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["n" /* isSsr */])(),
  isUpdateAnimationActive: !Object(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["n" /* isSsr */])(),
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: 'linear'
}, _temp2)) || _class;

/* unused harmony default export */ var _unused_webpack_default_export = (Treemap);

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_sumBy__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_sumBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_sumBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_min__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_maxBy__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_maxBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_maxBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__container_Surface__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__container_Layer__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__component_Tooltip__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shape_Rectangle__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_PureRender__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_ChartUtils__ = __webpack_require__(11);





var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file TreemapChart
 */












var defaultCoordinateOfTooltip = { x: 0, y: 0 };

var interpolationGenerator = function interpolationGenerator(a, b) {
  var ka = +a;
  var kb = b - ka;
  return function (t) {
    return ka + kb * t;
  };
};
var centerY = function centerY(node) {
  return node.y + node.dy / 2;
};
var getValue = function getValue(entry) {
  return entry && entry.value || 0;
};
var getSumOfIds = function getSumOfIds(links, ids) {
  return ids.reduce(function (result, id) {
    return result + getValue(links[id]);
  }, 0);
};
var getSumWithWeightedSource = function getSumWithWeightedSource(tree, links, ids) {
  return ids.reduce(function (result, id) {
    var link = links[id];
    var sourceNode = tree[link.source];

    return result + centerY(sourceNode) * getValue(links[id]);
  }, 0);
};
var getSumWithWeightedTarget = function getSumWithWeightedTarget(tree, links, ids) {
  return ids.reduce(function (result, id) {
    var link = links[id];
    var targetNode = tree[link.target];

    return result + centerY(targetNode) * getValue(links[id]);
  }, 0);
};
var ascendingY = function ascendingY(a, b) {
  return a.y - b.y;
};

var searchTargetsAndSources = function searchTargetsAndSources(links, id) {
  var sourceNodes = [];
  var sourceLinks = [];
  var targetNodes = [];
  var targetLinks = [];

  for (var i = 0, len = links.length; i < len; i++) {
    var link = links[i];

    if (link.source === id) {
      targetNodes.push(link.target);
      targetLinks.push(i);
    }

    if (link.target === id) {
      sourceNodes.push(link.source);
      sourceLinks.push(i);
    }
  }

  return { sourceNodes: sourceNodes, sourceLinks: sourceLinks, targetLinks: targetLinks, targetNodes: targetNodes };
};

var updateDepthOfTargets = function updateDepthOfTargets(tree, curNode) {
  var targetNodes = curNode.targetNodes;

  for (var i = 0, len = targetNodes.length; i < len; i++) {
    var target = tree[targetNodes[i]];

    if (target) {
      target.depth = Math.max(curNode.depth + 1, target.depth);

      updateDepthOfTargets(tree, target);
    }
  }
};

var getNodesTree = function getNodesTree(_ref, width, nodeWidth) {
  var nodes = _ref.nodes,
      links = _ref.links;

  var tree = nodes.map(function (entry, index) {
    var result = searchTargetsAndSources(links, index);

    return _extends({}, entry, result, {
      value: Math.max(getSumOfIds(links, result.sourceLinks), getSumOfIds(links, result.targetLinks)),
      depth: 0
    });
  });

  for (var i = 0, len = tree.length; i < len; i++) {
    var node = tree[i];

    if (!node.sourceNodes.length) {
      updateDepthOfTargets(tree, node);
    }
  }
  var maxDepth = __WEBPACK_IMPORTED_MODULE_3_lodash_maxBy___default()(tree, function (entry) {
    return entry.depth;
  }).depth;

  if (maxDepth >= 1) {
    var childWidth = (width - nodeWidth) / maxDepth;
    for (var _i = 0, _len = tree.length; _i < _len; _i++) {
      var _node = tree[_i];

      if (!_node.targetNodes.length) {
        _node.depth = maxDepth;
      }
      _node.x = _node.depth * childWidth;
      _node.dx = nodeWidth;
    }
  }

  return { tree: tree, maxDepth: maxDepth };
};

var getDepthTree = function getDepthTree(tree) {
  var result = [];

  for (var i = 0, len = tree.length; i < len; i++) {
    var node = tree[i];

    if (!result[node.depth]) {
      result[node.depth] = [];
    }

    result[node.depth].push(node);
  }

  return result;
};

var updateYOfTree = function updateYOfTree(depthTree, height, nodePadding, links) {
  var yRatio = __WEBPACK_IMPORTED_MODULE_2_lodash_min___default()(depthTree.map(function (nodes) {
    return (height - (nodes.length - 1) * nodePadding) / __WEBPACK_IMPORTED_MODULE_1_lodash_sumBy___default()(nodes, getValue);
  }));

  for (var d = 0, maxDepth = depthTree.length; d < maxDepth; d++) {
    for (var i = 0, len = depthTree[d].length; i < len; i++) {
      var node = depthTree[d][i];

      node.y = i;
      node.dy = node.value * yRatio;
    }
  }

  return links.map(function (link) {
    return _extends({}, link, { dy: getValue(link) * yRatio });
  });
};

var resolveCollisions = function resolveCollisions(depthTree, height, nodePadding) {
  for (var i = 0, len = depthTree.length; i < len; i++) {
    var nodes = depthTree[i];
    var n = nodes.length;

    // Sort by the value of y
    nodes.sort(ascendingY);

    var y0 = 0;
    for (var j = 0; j < n; j++) {
      var node = nodes[j];
      var dy = y0 - node.y;

      if (dy > 0) {
        node.y += dy;
      }

      y0 = node.y + node.dy + nodePadding;
    }

    y0 = height + nodePadding;
    for (var _j = n - 1; _j >= 0; _j--) {
      var _node2 = nodes[_j];
      var _dy = _node2.y + _node2.dy + nodePadding - y0;

      if (_dy > 0) {
        _node2.y -= _dy;
        y0 = _node2.y;
      } else {
        break;
      }
    }
  }
};

var relaxLeftToRight = function relaxLeftToRight(tree, depthTree, links, alpha) {
  for (var i = 0, maxDepth = depthTree.length; i < maxDepth; i++) {
    var nodes = depthTree[i];

    for (var j = 0, len = nodes.length; j < len; j++) {
      var node = nodes[j];

      if (node.sourceLinks.length) {
        var sourceSum = getSumOfIds(links, node.sourceLinks);
        var weightedSum = getSumWithWeightedSource(tree, links, node.sourceLinks);
        var y = weightedSum / sourceSum;

        node.y += (y - centerY(node)) * alpha;
      }
    }
  }
};
var relaxRightToLeft = function relaxRightToLeft(tree, depthTree, links, alpha) {
  for (var i = depthTree.length - 1; i >= 0; i--) {
    var nodes = depthTree[i];

    for (var j = 0, len = nodes.length; j < len; j++) {
      var node = nodes[j];

      if (node.targetLinks.length) {
        var targetSum = getSumOfIds(links, node.targetLinks);
        var weightedSum = getSumWithWeightedTarget(tree, links, node.targetLinks);
        var y = weightedSum / targetSum;

        node.y += (y - centerY(node)) * alpha;
      }
    }
  }
};
var updateYOfLinks = function updateYOfLinks(tree, links) {
  for (var i = 0, len = tree.length; i < len; i++) {
    var node = tree[i];
    var sy = 0;
    var ty = 0;

    node.targetLinks.sort(function (a, b) {
      return tree[links[a].target].y - tree[links[b].target].y;
    });
    node.sourceLinks.sort(function (a, b) {
      return tree[links[a].source].y - tree[links[b].source].y;
    });

    for (var j = 0, tLen = node.targetLinks.length; j < tLen; j++) {
      var link = links[node.targetLinks[j]];

      if (link) {
        link.sy = sy;
        sy += link.dy;
      }
    }

    for (var _j2 = 0, sLen = node.sourceLinks.length; _j2 < sLen; _j2++) {
      var _link = links[node.sourceLinks[_j2]];

      if (_link) {
        _link.ty = ty;
        ty += _link.dy;
      }
    }
  }
};

var computeData = function computeData(_ref2) {
  var data = _ref2.data,
      width = _ref2.width,
      height = _ref2.height,
      iterations = _ref2.iterations,
      nodeWidth = _ref2.nodeWidth,
      nodePadding = _ref2.nodePadding;
  var links = data.links;

  var _getNodesTree = getNodesTree(data, width, nodeWidth),
      tree = _getNodesTree.tree;

  var depthTree = getDepthTree(tree);
  var newLinks = updateYOfTree(depthTree, height, nodePadding, links);

  resolveCollisions(depthTree, height, nodePadding);

  var alpha = 1;
  for (var i = 1; i <= iterations; i++) {
    relaxRightToLeft(tree, depthTree, newLinks, alpha *= 0.99);

    resolveCollisions(depthTree, height, nodePadding);

    relaxLeftToRight(tree, depthTree, newLinks, alpha);

    resolveCollisions(depthTree, height, nodePadding);
  }

  updateYOfLinks(tree, newLinks);

  return { nodes: tree, links: newLinks };
};

var getCoordinateOfTooltip = function getCoordinateOfTooltip(el, type) {
  if (type === 'node') {
    return { x: el.x + el.width / 2, y: el.y + el.height / 2 };
  }

  return {
    x: (el.sourceX + el.targetX) / 2,
    y: (el.sourceY + el.targetY) / 2
  };
};

var getPayloadOfTooltip = function getPayloadOfTooltip(el, type, nameKey) {
  var payload = el.payload;

  if (type === 'node') {
    return [{
      payload: el,
      name: Object(__WEBPACK_IMPORTED_MODULE_13__util_ChartUtils__["w" /* getValueByDataKey */])(payload, nameKey, ''),
      value: Object(__WEBPACK_IMPORTED_MODULE_13__util_ChartUtils__["w" /* getValueByDataKey */])(payload, 'value')
    }];
  }
  if (payload.source && payload.target) {
    var sourceName = Object(__WEBPACK_IMPORTED_MODULE_13__util_ChartUtils__["w" /* getValueByDataKey */])(payload.source, nameKey, '');
    var targetName = Object(__WEBPACK_IMPORTED_MODULE_13__util_ChartUtils__["w" /* getValueByDataKey */])(payload.target, nameKey, '');

    return [{
      payload: el,
      name: sourceName + ' - ' + targetName,
      value: Object(__WEBPACK_IMPORTED_MODULE_13__util_ChartUtils__["w" /* getValueByDataKey */])(payload, 'value')
    }];
  }

  return [];
};

var Sankey = Object(__WEBPACK_IMPORTED_MODULE_11__util_PureRender__["a" /* default */])(_class = (_temp = _class2 = function (_Component) {
  _inherits(Sankey, _Component);

  function Sankey(props) {
    _classCallCheck(this, Sankey);

    var _this = _possibleConstructorReturn(this, (Sankey.__proto__ || Object.getPrototypeOf(Sankey)).call(this, props));

    _this.state = _this.createDefaultState(props);
    return _this;
  }

  _createClass(Sankey, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props = this.props,
          data = _props.data,
          width = _props.width,
          height = _props.height,
          margin = _props.margin,
          iterations = _props.iterations,
          nodeWidth = _props.nodeWidth,
          nodePadding = _props.nodePadding,
          nameKey = _props.nameKey;

      if (nextProps.data !== data || nextProps.width !== width || nextProps.height !== height || !Object(__WEBPACK_IMPORTED_MODULE_11__util_PureRender__["b" /* shallowEqual */])(nextProps.margin, margin) || nextProps.iterations !== iterations || nextProps.nodeWidth !== nodeWidth || nextProps.nodePadding !== nodePadding || nextProps.nameKey !== nameKey) {
        this.setState(this.createDefaultState(nextProps));
      }
    }
    /**
     * Returns default, reset state for the sankey chart.
     * @param  {Object} props The latest props
     * @return {Object} Whole new state
     */

  }, {
    key: 'createDefaultState',
    value: function createDefaultState(props) {
      var data = props.data,
          width = props.width,
          height = props.height,
          margin = props.margin,
          iterations = props.iterations,
          nodeWidth = props.nodeWidth,
          nodePadding = props.nodePadding;

      var contentWidth = width - (margin && margin.left || 0) - (margin && margin.right || 0);
      var contentHeight = height - (margin && margin.top || 0) - (margin && margin.bottom || 0);

      var _computeData = computeData({
        data: data,
        width: contentWidth,
        height: contentHeight,
        iterations: iterations, nodeWidth: nodeWidth, nodePadding: nodePadding
      }),
          links = _computeData.links,
          nodes = _computeData.nodes;

      return {
        activeElement: null,
        activeElementType: null,
        isTooltipActive: false,
        nodes: nodes, links: links
      };
    }
  }, {
    key: 'handleMouseEnter',
    value: function handleMouseEnter(el, type, e) {
      var _props2 = this.props,
          onMouseEnter = _props2.onMouseEnter,
          children = _props2.children;

      var tooltipItem = Object(__WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__["i" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_9__component_Tooltip__["a" /* default */]);

      if (tooltipItem) {
        this.setState({
          activeElement: el,
          activeElementType: type,
          isTooltipActive: true
        }, function () {
          if (onMouseEnter) {
            onMouseEnter(el, type, e);
          }
        });
      } else if (onMouseEnter) {
        onMouseEnter(el, type, e);
      }
    }
  }, {
    key: 'handleMouseLeave',
    value: function handleMouseLeave(el, type, e) {
      var _props3 = this.props,
          onMouseLeave = _props3.onMouseLeave,
          children = _props3.children;

      var tooltipItem = Object(__WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__["i" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_9__component_Tooltip__["a" /* default */]);

      if (tooltipItem) {
        this.setState({
          isTooltipActive: false
        }, function () {
          if (onMouseLeave) {
            onMouseLeave(el, type, e);
          }
        });
      } else if (onMouseLeave) {
        onMouseLeave(el, type, e);
      }
    }
  }, {
    key: 'renderLinkItem',
    value: function renderLinkItem(option, props) {
      if (__WEBPACK_IMPORTED_MODULE_4_react___default.a.isValidElement(option)) {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(option)) {
        return option(props);
      }

      var sourceX = props.sourceX,
          sourceY = props.sourceY,
          sourceControlX = props.sourceControlX,
          targetX = props.targetX,
          targetY = props.targetY,
          targetControlX = props.targetControlX,
          linkWidth = props.linkWidth,
          others = _objectWithoutProperties(props, ['sourceX', 'sourceY', 'sourceControlX', 'targetX', 'targetY', 'targetControlX', 'linkWidth']);

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('path', _extends({
        className: 'recharts-sankey-link',
        d: '\n          M' + sourceX + ',' + sourceY + '\n          C' + sourceControlX + ',' + sourceY + ' ' + targetControlX + ',' + targetY + ' ' + targetX + ',' + targetY + '\n        ',
        fill: 'none',
        stroke: '#333',
        strokeWidth: linkWidth,
        strokeOpacity: '0.2'
      }, Object(__WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__["k" /* getPresentationAttributes */])(others)));
    }
  }, {
    key: 'renderLinks',
    value: function renderLinks(links, nodes) {
      var _this2 = this;

      var _props4 = this.props,
          linkCurvature = _props4.linkCurvature,
          linkContent = _props4.link,
          margin = _props4.margin;

      var top = margin.top || 0;
      var left = margin.left || 0;

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */],
        { className: 'recharts-sankey-links', key: 'recharts-sankey-links' },
        links.map(function (link, i) {
          var sourceRelativeY = link.sy,
              targetRelativeY = link.ty,
              linkWidth = link.dy;

          var source = nodes[link.source];
          var target = nodes[link.target];
          var sourceX = source.x + source.dx + left;
          var targetX = target.x + left;
          var interpolationFunc = interpolationGenerator(sourceX, targetX);
          var sourceControlX = interpolationFunc(linkCurvature);
          var targetControlX = interpolationFunc(1 - linkCurvature);
          var sourceY = source.y + sourceRelativeY + linkWidth / 2 + top;
          var targetY = target.y + targetRelativeY + linkWidth / 2 + top;

          var linkProps = _extends({
            sourceX: sourceX, targetX: targetX,
            sourceY: sourceY, targetY: targetY,
            sourceControlX: sourceControlX, targetControlX: targetControlX,
            sourceRelativeY: sourceRelativeY, targetRelativeY: targetRelativeY,
            linkWidth: linkWidth,
            index: i,
            payload: _extends({}, link, { source: source, target: target })
          }, Object(__WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__["k" /* getPresentationAttributes */])(linkContent));
          var events = {
            onMouseEnter: _this2.handleMouseEnter.bind(_this2, linkProps, 'link'),
            onMouseLeave: _this2.handleMouseLeave.bind(_this2, linkProps, 'link')
          };

          return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */],
            _extends({ key: 'link' + i }, events),
            _this2.renderLinkItem(linkContent, linkProps)
          );
        })
      );
    }
  }, {
    key: 'renderNodeItem',
    value: function renderNodeItem(option, props) {
      if (__WEBPACK_IMPORTED_MODULE_4_react___default.a.isValidElement(option)) {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(option)) {
        return option(props);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shape_Rectangle__["a" /* default */], _extends({
        className: 'recharts-sankey-node',
        fill: '#0088fe',
        fillOpacity: '0.8'
      }, props));
    }
  }, {
    key: 'renderNodes',
    value: function renderNodes(nodes) {
      var _this3 = this;

      var _props5 = this.props,
          nodeContent = _props5.node,
          margin = _props5.margin;

      var top = margin.top || 0;
      var left = margin.left || 0;

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */],
        { className: 'recharts-sankey-nodes', key: 'recharts-sankey-nodes' },
        nodes.map(function (node, i) {
          var x = node.x,
              y = node.y,
              dx = node.dx,
              dy = node.dy;

          var nodeProps = _extends({}, Object(__WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__["k" /* getPresentationAttributes */])(nodeContent), {
            x: x + left,
            y: y + top,
            width: dx,
            height: dy,
            index: i,
            payload: node
          });
          var events = {
            onMouseEnter: _this3.handleMouseEnter.bind(_this3, nodeProps, 'node'),
            onMouseLeave: _this3.handleMouseLeave.bind(_this3, nodeProps, 'node')
          };

          return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */],
            _extends({ key: 'node' + i }, events),
            _this3.renderNodeItem(nodeContent, nodeProps)
          );
        })
      );
    }
  }, {
    key: 'renderTooltip',
    value: function renderTooltip() {
      var _props6 = this.props,
          children = _props6.children,
          width = _props6.width,
          height = _props6.height,
          nameKey = _props6.nameKey;

      var tooltipItem = Object(__WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__["i" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_9__component_Tooltip__["a" /* default */]);

      if (!tooltipItem) {
        return null;
      }

      var _state = this.state,
          isTooltipActive = _state.isTooltipActive,
          activeElement = _state.activeElement,
          activeElementType = _state.activeElementType;

      var viewBox = { x: 0, y: 0, width: width, height: height };
      var coordinate = activeElement ? getCoordinateOfTooltip(activeElement, activeElementType) : defaultCoordinateOfTooltip;
      var payload = activeElement ? getPayloadOfTooltip(activeElement, activeElementType, nameKey) : [];

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(tooltipItem, {
        viewBox: viewBox,
        active: isTooltipActive,
        coordinate: coordinate,
        label: '',
        payload: payload
      });
    }
  }, {
    key: 'render',
    value: function render() {
      if (!Object(__WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__["q" /* validateWidthHeight */])(this)) {
        return null;
      }

      var _props7 = this.props,
          width = _props7.width,
          height = _props7.height,
          className = _props7.className,
          style = _props7.style,
          children = _props7.children,
          others = _objectWithoutProperties(_props7, ['width', 'height', 'className', 'style', 'children']);

      var _state2 = this.state,
          links = _state2.links,
          nodes = _state2.nodes;

      var attrs = Object(__WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__["k" /* getPresentationAttributes */])(others);

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        'div',
        {
          className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()('recharts-wrapper', className),
          style: _extends({}, style, { position: 'relative', cursor: 'default', width: width, height: height })
        },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__container_Surface__["a" /* default */],
          _extends({}, attrs, { width: width, height: height }),
          Object(__WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__["g" /* filterSvgElements */])(children),
          this.renderLinks(links, nodes),
          this.renderNodes(nodes)
        ),
        this.renderTooltip()
      );
    }
  }]);

  return Sankey;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]), _class2.displayName = 'Sankey', _class2.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], __WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__["a" /* EVENT_ATTRIBUTES */], {

  nameKey: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func]),
  dataKey: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func]),
  width: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  data: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    nodes: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.array,
    links: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
      target: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
      source: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
      value: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number
    }))
  }),

  nodePadding: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  nodeWidth: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  linkCurvature: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  iterations: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  node: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func]),
  link: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func]),

  style: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node]),
  margin: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    top: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    right: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    bottom: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    left: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number
  })
}), _class2.defaultProps = {
  nodePadding: 10,
  nodeWidth: 10,
  nameKey: 'name',
  dataKey: 'value',
  linkCurvature: 0.5,
  iterations: 32,
  margin: { top: 5, right: 5, bottom: 5, left: 5 }
}, _temp)) || _class;

/* unused harmony default export */ var _unused_webpack_default_export = (Sankey);

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(51),
    baseSum = __webpack_require__(545);

/**
 * This method is like `_.sum` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the value to be summed.
 * The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the sum.
 * @example
 *
 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
 *
 * _.sumBy(objects, function(o) { return o.n; });
 * // => 20
 *
 * // The `_.property` iteratee shorthand.
 * _.sumBy(objects, 'n');
 * // => 20
 */
function sumBy(array, iteratee) {
  return (array && array.length)
    ? baseSum(array, baseIteratee(iteratee, 2))
    : 0;
}

module.exports = sumBy;


/***/ }),
/* 545 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.sum` and `_.sumBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the sum.
 */
function baseSum(array, iteratee) {
  var result,
      index = -1,
      length = array.length;

  while (++index < length) {
    var current = iteratee(array[index]);
    if (current !== undefined) {
      result = result === undefined ? current : (result + current);
    }
  }
  return result;
}

module.exports = baseSum;


/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__generateCategoricalChart__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__polar_Radar__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__polar_PolarAngleAxis__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__polar_PolarRadiusAxis__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_PolarUtils__ = __webpack_require__(14);
/**
 * @fileOverview Radar Chart
 */







/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__generateCategoricalChart__["a" /* default */])({
  chartName: 'RadarChart',
  GraphicalChild: __WEBPACK_IMPORTED_MODULE_2__polar_Radar__["a" /* default */],
  axisComponents: [{ axisType: 'angleAxis', AxisComp: __WEBPACK_IMPORTED_MODULE_3__polar_PolarAngleAxis__["a" /* default */] }, { axisType: 'radiusAxis', AxisComp: __WEBPACK_IMPORTED_MODULE_4__polar_PolarRadiusAxis__["a" /* default */] }],
  formatAxisMap: __WEBPACK_IMPORTED_MODULE_5__util_PolarUtils__["b" /* formatAxisMap */],
  defaultProps: {
    layout: 'centric',
    startAngle: 90,
    endAngle: -270,
    cx: '50%',
    cy: '50%',
    innerRadius: 0,
    outerRadius: '80%'
  },
  propTypes: {
    layout: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['centric']),
    startAngle: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
    endAngle: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
    cx: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string]),
    cy: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string]),
    innerRadius: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string]),
    outerRadius: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string])
  }
}));

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__generateCategoricalChart__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cartesian_Scatter__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cartesian_XAxis__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cartesian_YAxis__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cartesian_ZAxis__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_CartesianUtils__ = __webpack_require__(59);
/**
 * @fileOverview Scatter Chart
 */







/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__generateCategoricalChart__["a" /* default */])({
  chartName: 'ScatterChart',
  GraphicalChild: __WEBPACK_IMPORTED_MODULE_1__cartesian_Scatter__["a" /* default */],
  eventType: 'single',
  axisComponents: [{ axisType: 'xAxis', AxisComp: __WEBPACK_IMPORTED_MODULE_2__cartesian_XAxis__["a" /* default */] }, { axisType: 'yAxis', AxisComp: __WEBPACK_IMPORTED_MODULE_3__cartesian_YAxis__["a" /* default */] }, { axisType: 'zAxis', AxisComp: __WEBPACK_IMPORTED_MODULE_4__cartesian_ZAxis__["a" /* default */] }],
  formatAxisMap: __WEBPACK_IMPORTED_MODULE_5__util_CartesianUtils__["a" /* formatAxisMap */]
}));

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__generateCategoricalChart__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cartesian_Area__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cartesian_XAxis__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cartesian_YAxis__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_CartesianUtils__ = __webpack_require__(59);
/**
 * @fileOverview Area Chart
 */






/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__generateCategoricalChart__["a" /* default */])({
  chartName: 'AreaChart',
  GraphicalChild: __WEBPACK_IMPORTED_MODULE_1__cartesian_Area__["a" /* default */],
  axisComponents: [{ axisType: 'xAxis', AxisComp: __WEBPACK_IMPORTED_MODULE_2__cartesian_XAxis__["a" /* default */] }, { axisType: 'yAxis', AxisComp: __WEBPACK_IMPORTED_MODULE_3__cartesian_YAxis__["a" /* default */] }],
  formatAxisMap: __WEBPACK_IMPORTED_MODULE_4__util_CartesianUtils__["a" /* formatAxisMap */]
}));

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__generateCategoricalChart__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__polar_PolarAngleAxis__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__polar_PolarRadiusAxis__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_PolarUtils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__polar_RadialBar__ = __webpack_require__(218);
/**
 * @fileOverview Radar Bar Chart
 */







/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__generateCategoricalChart__["a" /* default */])({
  chartName: 'RadialBarChart',
  GraphicalChild: __WEBPACK_IMPORTED_MODULE_5__polar_RadialBar__["a" /* default */],
  legendContent: 'children',
  axisComponents: [{ axisType: 'angleAxis', AxisComp: __WEBPACK_IMPORTED_MODULE_2__polar_PolarAngleAxis__["a" /* default */] }, { axisType: 'radiusAxis', AxisComp: __WEBPACK_IMPORTED_MODULE_3__polar_PolarRadiusAxis__["a" /* default */] }],
  formatAxisMap: __WEBPACK_IMPORTED_MODULE_4__util_PolarUtils__["b" /* formatAxisMap */],
  defaultProps: {
    layout: 'radial',
    startAngle: 0,
    endAngle: 360,
    cx: '50%',
    cy: '50%',
    innerRadius: 0,
    outerRadius: '80%'
  },
  propTypes: {
    layout: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['radial']),
    startAngle: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
    endAngle: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
    cx: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string]),
    cy: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string]),
    innerRadius: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string]),
    outerRadius: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string])
  }
}));

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__generateCategoricalChart__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cartesian_Area__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cartesian_Bar__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cartesian_Line__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cartesian_Scatter__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cartesian_XAxis__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cartesian_YAxis__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cartesian_ZAxis__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_CartesianUtils__ = __webpack_require__(59);
/**
 * @fileOverview Composed Chart
 */










/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__generateCategoricalChart__["a" /* default */])({
  chartName: 'ComposedChart',
  GraphicalChild: [__WEBPACK_IMPORTED_MODULE_3__cartesian_Line__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__cartesian_Area__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__cartesian_Bar__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__cartesian_Scatter__["a" /* default */]],
  axisComponents: [{ axisType: 'xAxis', AxisComp: __WEBPACK_IMPORTED_MODULE_5__cartesian_XAxis__["a" /* default */] }, { axisType: 'yAxis', AxisComp: __WEBPACK_IMPORTED_MODULE_6__cartesian_YAxis__["a" /* default */] }, { axisType: 'zAxis', AxisComp: __WEBPACK_IMPORTED_MODULE_7__cartesian_ZAxis__["a" /* default */] }],
  formatAxisMap: __WEBPACK_IMPORTED_MODULE_8__util_CartesianUtils__["a" /* formatAxisMap */]
}));

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.2.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2017-03-20T18:59Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var document = window.document;

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};



	function DOMEval( code, doc ) {
		doc = doc || document;

		var script = doc.createElement( "script" );

		script.text = code;
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.2.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,

	// Matches dashed string for camelizing
	rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g,

	// Used by jQuery.camelCase as callback to replace()
	fcamelCase = function( all, letter ) {
		return letter.toUpperCase();
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {

					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && Array.isArray( src ) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject( src ) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isFunction: function( obj ) {
		return jQuery.type( obj ) === "function";
	},

	isWindow: function( obj ) {
		return obj != null && obj === obj.window;
	},

	isNumeric: function( obj ) {

		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&

			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {

		/* eslint-disable no-unused-vars */
		// See https://github.com/eslint/eslint/issues/6125
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	type: function( obj ) {
		if ( obj == null ) {
			return obj + "";
		}

		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	},

	// Evaluates a script in a global context
	globalEval: function( code ) {
		DOMEval( code );
	},

	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 13
	// Microsoft forgot to hump their vendor prefix (#9572)
	camelCase: function( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android <=4.0 only
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// Bind a function to a context, optionally partially applying any
	// arguments.
	proxy: function( fn, context ) {
		var tmp, args, proxy;

		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}

		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !jQuery.isFunction( fn ) ) {
			return undefined;
		}

		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};

		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;

		return proxy;
	},

	now: Date.now,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = jQuery.type( obj );

	if ( type === "function" || jQuery.isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.3
 * https://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2016-08-08
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	disabledAncestor = addCombinator(
		function( elem ) {
			return elem.disabled === true && ("form" in elem || "label" in elem);
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!compilerCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {

				if ( nodeType !== 1 ) {
					newContext = context;
					newSelector = selector;

				// qSA looks outside Element context, which is not what we want
				// Thanks to Andrew Dupont for this workaround technique
				// Support: IE <=8
				// Exclude object elements
				} else if ( context.nodeName.toLowerCase() !== "object" ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rcssescape, fcssescape );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[i] = "#" + nid + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement("fieldset");

	try {
		return !!fn( el );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}
		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
						disabledAncestor( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( preferredDoc !== document &&
		(subWindow = document.defaultView) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( el ) {
		el.className = "i";
		return !el.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( el ) {
		el.appendChild( document.createComment("") );
		return !el.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID filter and find
	if ( support.getById ) {
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode("id");
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( (elem = elems[i++]) ) {
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( el ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll(":enabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll(":disabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( el ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		!compilerCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return (sel + "").replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( (oldCache = uniqueCache[ key ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( el ) {
	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( el ) {
	return el.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

};
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



var risSimple = /^.[^:#\[\.,]*$/;

// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( jQuery.isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Simple selector that can be filtered directly, removing non-Elements
	if ( risSimple.test( qualifier ) ) {
		return jQuery.filter( qualifier, elements, not );
	}

	// Complex selector, compare the two sets, removing non-Elements
	qualifier = jQuery.filter( qualifier, elements );
	return jQuery.grep( elements, function( elem ) {
		return ( indexOf.call( qualifier, elem ) > -1 ) !== not && elem.nodeType === 1;
	} );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( jQuery.isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( jQuery.isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
        if ( nodeName( elem, "iframe" ) ) {
            return elem.contentDocument;
        }

        // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
        // Treat the template element as a regular one in browsers that
        // don't support it.
        if ( nodeName( elem, "template" ) ) {
            elem = elem.content || elem;
        }

        return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( jQuery.isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && jQuery.isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && jQuery.isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = jQuery.isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && jQuery.isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( jQuery.isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								jQuery.isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								jQuery.isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								jQuery.isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the master Deferred
			master = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						master.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( master.state() === "pending" ||
				jQuery.isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return master.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		}

		return master.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( jQuery.type( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !jQuery.isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ jQuery.camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ jQuery.camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ jQuery.camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( jQuery.camelCase );
			} else {
				key = jQuery.camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = jQuery.camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			jQuery.contains( elem.ownerDocument, elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};




function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted,
		scale = 1,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		do {

			// If previous iteration zeroed out, double until we get *something*.
			// Use string for doubling so we don't accidentally see scale as unchanged below
			scale = scale || ".5";

			// Adjust and apply
			initialInUnit = initialInUnit / scale;
			jQuery.style( elem, prop, initialInUnit + unit );

		// Update scale, tolerating zero or NaN from tween.cur()
		// Break the loop if scale is unchanged or perfect, or if we've just had enough.
		} while (
			scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
		);
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );

var rscriptType = ( /^$|\/(?:java|ecma)script/i );



// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE <=9 only
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE <=9 only
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, contains, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( jQuery.type( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		contains = jQuery.contains( elem.ownerDocument, elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( contains ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();
var documentElement = document.documentElement;



var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 only
// See #13393 for more info
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		// Make a writable jQuery.Event from the native event object
		var event = jQuery.event.fix( nativeEvent );

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or 2) have namespace(s)
				// a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: jQuery.isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
							return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
							return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {

			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					this.focus();
					return false;
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {

			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( this.type === "checkbox" && this.click && nodeName( this, "input" ) ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || jQuery.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,

	which: function( event ) {
		var button = event.button;

		// Add which for key events
		if ( event.which == null && rkeyEvent.test( event.type ) ) {
			return event.charCode != null ? event.charCode : event.keyCode;
		}

		// Add which for click: 1 === left; 2 === middle; 3 === right
		if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			if ( button & 1 ) {
				return 1;
			}

			if ( button & 2 ) {
				return 3;
			}

			if ( button & 4 ) {
				return 2;
			}

			return 0;
		}

		return event.which;
	}
}, jQuery.event.addProp );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	/* eslint-disable max-len */

	// See https://github.com/eslint/eslint/issues/3229
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,

	/* eslint-enable */

	// Support: IE <=10 - 11, Edge 12 - 13
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rscriptTypeMasked = /^true\/(.*)/,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( ">tbody", elem )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	var match = rscriptTypeMasked.exec( elem.type );

	if ( match ) {
		elem.type = match[ 1 ];
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		isFunction = jQuery.isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( isFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( isFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl ) {
								jQuery._evalUrl( node.src );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = jQuery.contains( elem.ownerDocument, elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rmargin = ( /^margin/ );

var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		div.style.cssText =
			"box-sizing:border-box;" +
			"position:relative;display:block;" +
			"margin:auto;border:1px;padding:1px;" +
			"top:1%;width:50%";
		div.innerHTML = "";
		documentElement.appendChild( container );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = divStyle.marginLeft === "2px";
		boxSizingReliableVal = divStyle.width === "4px";

		// Support: Android 4.0 - 4.3 only
		// Some styles come back with percentage values, even though they shouldn't
		div.style.marginRight = "50%";
		pixelMarginRightVal = divStyle.marginRight === "4px";

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	var pixelPositionVal, boxSizingReliableVal, pixelMarginRightVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
		"padding:0;margin-top:1px;position:absolute";
	container.appendChild( div );

	jQuery.extend( support, {
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelMarginRight: function() {
			computeStyleTests();
			return pixelMarginRightVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style;

// Return a css property mapped to a potentially vendor prefixed property
function vendorPropName( name ) {

	// Shortcut for names that are not vendor prefixed
	if ( name in emptyStyle ) {
		return name;
	}

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a property mapped along what jQuery.cssProps suggests or to
// a vendor prefixed property.
function finalPropName( name ) {
	var ret = jQuery.cssProps[ name ];
	if ( !ret ) {
		ret = jQuery.cssProps[ name ] = vendorPropName( name ) || name;
	}
	return ret;
}

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
	var i,
		val = 0;

	// If we already have the right measurement, avoid augmentation
	if ( extra === ( isBorderBox ? "border" : "content" ) ) {
		i = 4;

	// Otherwise initialize for horizontal or vertical properties
	} else {
		i = name === "width" ? 1 : 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin, so add it if we want it
		if ( extra === "margin" ) {
			val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
		}

		if ( isBorderBox ) {

			// border-box includes padding, so remove it if we want content
			if ( extra === "content" ) {
				val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// At this point, extra isn't border nor margin, so remove border
			if ( extra !== "margin" ) {
				val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		} else {

			// At this point, extra isn't content, so add padding
			val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// At this point, extra isn't content nor padding, so add border
			if ( extra !== "padding" ) {
				val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	return val;
}

function getWidthOrHeight( elem, name, extra ) {

	// Start with computed style
	var valueIsBorderBox,
		styles = getStyles( elem ),
		val = curCSS( elem, name, styles ),
		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

	// Computed unit is not pixels. Stop here and return.
	if ( rnumnonpx.test( val ) ) {
		return val;
	}

	// Check for style in case a browser which returns unreliable values
	// for getComputedStyle silently falls back to the reliable elem.style
	valueIsBorderBox = isBorderBox &&
		( support.boxSizingReliable() || val === elem.style[ name ] );

	// Fall back to offsetWidth/Height when value is "auto"
	// This happens for inline elements with no explicit setting (gh-3571)
	if ( val === "auto" ) {
		val = elem[ "offset" + name[ 0 ].toUpperCase() + name.slice( 1 ) ];
	}

	// Normalize "", auto, and prepare for extra
	val = parseFloat( val ) || 0;

	// Use the active box-sizing model to add/subtract irrelevant styles
	return ( val +
		augmentWidthOrHeight(
			elem,
			name,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {
		"float": "cssFloat"
	},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = jQuery.camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			if ( type === "number" ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = jQuery.camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, name ) {
	jQuery.cssHooks[ name ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, name, extra );
						} ) :
						getWidthOrHeight( elem, name, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = extra && getStyles( elem ),
				subtract = extra && augmentWidthOrHeight(
					elem,
					name,
					extra,
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					styles
				);

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ name ] = value;
				value = jQuery.css( elem, name );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( !rmargin.test( prefix ) ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 &&
				( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
					jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = jQuery.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 13
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

			/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = jQuery.camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( jQuery.isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					jQuery.proxy( result.stop, result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( jQuery.isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( jQuery.isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			jQuery.isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( jQuery.isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = jQuery.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://html.spec.whatwg.org/multipage/infrastructure.html#strip-and-collapse-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnothtmlwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnothtmlwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value;

		if ( typeof stateVal === "boolean" && type === "string" ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( type === "string" ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = value.match( rnothtmlwhite ) || [];

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, isFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		isFunction = jQuery.isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( isFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {

			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;
					elem[ type ]();
					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );




support.focusin = "onfocusin" in window;


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = jQuery.now();

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && jQuery.type( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = jQuery.isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( jQuery.isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 13
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available, append data to url
			if ( s.data ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( jQuery.isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,
		"throws": true
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( jQuery.isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( jQuery.isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var isFunction = jQuery.isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" ).prop( {
					charset: s.scriptCharset,
					src: s.url
				} ).on(
					"load error",
					callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					}
				);

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && jQuery.isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( jQuery.isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( jQuery.isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var doc, docElem, rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		rect = elem.getBoundingClientRect();

		doc = elem.ownerDocument;
		docElem = doc.documentElement;
		win = doc.defaultView;

		return {
			top: rect.top + win.pageYOffset - docElem.clientTop,
			left: rect.left + win.pageXOffset - docElem.clientLeft
		};
	},

	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
		// because it is its only offset parent
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume getBoundingClientRect is there when computed position is fixed
			offset = elem.getBoundingClientRect();

		} else {

			// Get *real* offsetParent
			offsetParent = this.offsetParent();

			// Get correct offsets
			offset = this.offset();
			if ( !nodeName( offsetParent[ 0 ], "html" ) ) {
				parentOffset = offsetParent.offset();
			}

			// Add offsetParent borders
			parentOffset = {
				top: parentOffset.top + jQuery.css( offsetParent[ 0 ], "borderTopWidth", true ),
				left: parentOffset.left + jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true )
			};
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( jQuery.isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( jQuery.isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	}
} );

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
		return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),
/* 552 */
/***/ (function(module, exports) {

module.exports = {"dimension":[{"label":"GHO","display":"Indicator"},{"label":"PUBLISHSTATE","display":"PUBLISH STATES"},{"label":"YEAR","display":"Year"},{"label":"REGION","display":"WHO region"},{"label":"SEX","display":"Sex"}],"fact":[{"dims":{"REGION":"Africa","YEAR":"2015","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"300"},{"dims":{"REGION":"Africa","YEAR":"2015","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"318"},{"dims":{"REGION":"Africa","YEAR":"2015","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"269"},{"dims":{"REGION":"Africa","YEAR":"2014","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"308"},{"dims":{"REGION":"Africa","YEAR":"2014","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"331"},{"dims":{"REGION":"Africa","YEAR":"2014","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"278"},{"dims":{"REGION":"Africa","YEAR":"2013","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"317"},{"dims":{"REGION":"Africa","YEAR":"2013","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"337"},{"dims":{"REGION":"Africa","YEAR":"2013","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"291"},{"dims":{"REGION":"Africa","YEAR":"2012","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"323"},{"dims":{"REGION":"Africa","YEAR":"2012","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"343"},{"dims":{"REGION":"Africa","YEAR":"2012","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"299"},{"dims":{"REGION":"Africa","YEAR":"2011","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"330"},{"dims":{"REGION":"Africa","YEAR":"2011","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"347"},{"dims":{"REGION":"Africa","YEAR":"2011","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"308"},{"dims":{"REGION":"Africa","YEAR":"2010","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"341"},{"dims":{"REGION":"Africa","YEAR":"2010","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"353"},{"dims":{"REGION":"Africa","YEAR":"2010","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"320"},{"dims":{"REGION":"Africa","YEAR":"2009","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"354"},{"dims":{"REGION":"Africa","YEAR":"2009","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"363"},{"dims":{"REGION":"Africa","YEAR":"2009","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"334"},{"dims":{"REGION":"Africa","YEAR":"2008","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"367"},{"dims":{"REGION":"Africa","YEAR":"2008","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"375"},{"dims":{"REGION":"Africa","YEAR":"2008","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"348"},{"dims":{"REGION":"Africa","YEAR":"2007","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"380"},{"dims":{"REGION":"Africa","YEAR":"2007","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"386"},{"dims":{"REGION":"Africa","YEAR":"2007","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"363"},{"dims":{"REGION":"Africa","YEAR":"2006","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"390"},{"dims":{"REGION":"Africa","YEAR":"2006","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"398"},{"dims":{"REGION":"Africa","YEAR":"2006","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"374"},{"dims":{"REGION":"Africa","YEAR":"2005","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"399"},{"dims":{"REGION":"Africa","YEAR":"2005","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"408"},{"dims":{"REGION":"Africa","YEAR":"2005","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"383"},{"dims":{"REGION":"Africa","YEAR":"2004","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"403"},{"dims":{"REGION":"Africa","YEAR":"2004","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"417"},{"dims":{"REGION":"Africa","YEAR":"2004","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"385"},{"dims":{"REGION":"Africa","YEAR":"2003","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"403"},{"dims":{"REGION":"Africa","YEAR":"2003","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"422"},{"dims":{"REGION":"Africa","YEAR":"2003","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"383"},{"dims":{"REGION":"Africa","YEAR":"2002","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"400"},{"dims":{"REGION":"Africa","YEAR":"2002","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"423"},{"dims":{"REGION":"Africa","YEAR":"2002","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"379"},{"dims":{"REGION":"Africa","YEAR":"2001","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"399"},{"dims":{"REGION":"Africa","YEAR":"2001","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"421"},{"dims":{"REGION":"Africa","YEAR":"2001","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"375"},{"dims":{"REGION":"Africa","YEAR":"2000","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"287"},{"dims":{"REGION":"Africa","YEAR":"2000","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"423"},{"dims":{"REGION":"Africa","YEAR":"2000","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"257"},{"dims":{"REGION":"Americas","YEAR":"2015","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"124"},{"dims":{"REGION":"Americas","YEAR":"2015","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"158"},{"dims":{"REGION":"Americas","YEAR":"2015","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"87"},{"dims":{"REGION":"Americas","YEAR":"2014","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"125"},{"dims":{"REGION":"Americas","YEAR":"2014","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"160"},{"dims":{"REGION":"Americas","YEAR":"2014","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"88"},{"dims":{"REGION":"Americas","YEAR":"2013","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"126"},{"dims":{"REGION":"Americas","YEAR":"2013","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"161"},{"dims":{"REGION":"Americas","YEAR":"2013","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"89"},{"dims":{"REGION":"Americas","YEAR":"2012","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"127"},{"dims":{"REGION":"Americas","YEAR":"2012","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"162"},{"dims":{"REGION":"Americas","YEAR":"2012","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"89"},{"dims":{"REGION":"Americas","YEAR":"2011","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"135"},{"dims":{"REGION":"Americas","YEAR":"2011","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"164"},{"dims":{"REGION":"Americas","YEAR":"2011","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"95"},{"dims":{"REGION":"Americas","YEAR":"2010","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"130"},{"dims":{"REGION":"Americas","YEAR":"2010","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"174"},{"dims":{"REGION":"Americas","YEAR":"2010","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"92"},{"dims":{"REGION":"Americas","YEAR":"2009","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"130"},{"dims":{"REGION":"Americas","YEAR":"2009","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"168"},{"dims":{"REGION":"Americas","YEAR":"2009","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"91"},{"dims":{"REGION":"Americas","YEAR":"2008","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"130"},{"dims":{"REGION":"Americas","YEAR":"2008","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"169"},{"dims":{"REGION":"Americas","YEAR":"2008","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"92"},{"dims":{"REGION":"Americas","YEAR":"2007","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"133"},{"dims":{"REGION":"Americas","YEAR":"2007","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"169"},{"dims":{"REGION":"Americas","YEAR":"2007","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"93"},{"dims":{"REGION":"Americas","YEAR":"2006","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"134"},{"dims":{"REGION":"Americas","YEAR":"2006","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"171"},{"dims":{"REGION":"Americas","YEAR":"2006","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"95"},{"dims":{"REGION":"Americas","YEAR":"2005","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"136"},{"dims":{"REGION":"Americas","YEAR":"2005","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"172"},{"dims":{"REGION":"Americas","YEAR":"2005","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"96"},{"dims":{"REGION":"Americas","YEAR":"2004","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"138"},{"dims":{"REGION":"Americas","YEAR":"2004","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"174"},{"dims":{"REGION":"Americas","YEAR":"2004","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"98"},{"dims":{"REGION":"Americas","YEAR":"2003","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"139"},{"dims":{"REGION":"Americas","YEAR":"2003","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"177"},{"dims":{"REGION":"Americas","YEAR":"2003","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"98"},{"dims":{"REGION":"Americas","YEAR":"2002","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"140"},{"dims":{"REGION":"Americas","YEAR":"2002","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"179"},{"dims":{"REGION":"Americas","YEAR":"2002","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"99"},{"dims":{"REGION":"Americas","YEAR":"2001","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"142"},{"dims":{"REGION":"Americas","YEAR":"2001","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"180"},{"dims":{"REGION":"Americas","YEAR":"2001","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"100"},{"dims":{"REGION":"Americas","YEAR":"2000","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"122"},{"dims":{"REGION":"Americas","YEAR":"2000","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"182"},{"dims":{"REGION":"Americas","YEAR":"2000","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"86"},{"dims":{"REGION":"South-East Asia","YEAR":"2015","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"177"},{"dims":{"REGION":"South-East Asia","YEAR":"2015","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"208"},{"dims":{"REGION":"South-East Asia","YEAR":"2015","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"140"},{"dims":{"REGION":"South-East Asia","YEAR":"2014","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"180"},{"dims":{"REGION":"South-East Asia","YEAR":"2014","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"211"},{"dims":{"REGION":"South-East Asia","YEAR":"2014","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"143"},{"dims":{"REGION":"South-East Asia","YEAR":"2013","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"182"},{"dims":{"REGION":"South-East Asia","YEAR":"2013","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"214"},{"dims":{"REGION":"South-East Asia","YEAR":"2013","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"146"},{"dims":{"REGION":"South-East Asia","YEAR":"2012","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"185"},{"dims":{"REGION":"South-East Asia","YEAR":"2012","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"216"},{"dims":{"REGION":"South-East Asia","YEAR":"2012","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"150"},{"dims":{"REGION":"South-East Asia","YEAR":"2011","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"188"},{"dims":{"REGION":"South-East Asia","YEAR":"2011","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"218"},{"dims":{"REGION":"South-East Asia","YEAR":"2011","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"154"},{"dims":{"REGION":"South-East Asia","YEAR":"2010","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"192"},{"dims":{"REGION":"South-East Asia","YEAR":"2010","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"219"},{"dims":{"REGION":"South-East Asia","YEAR":"2010","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"159"},{"dims":{"REGION":"South-East Asia","YEAR":"2009","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"197"},{"dims":{"REGION":"South-East Asia","YEAR":"2009","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"222"},{"dims":{"REGION":"South-East Asia","YEAR":"2009","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"165"},{"dims":{"REGION":"South-East Asia","YEAR":"2008","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"196"},{"dims":{"REGION":"South-East Asia","YEAR":"2008","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"227"},{"dims":{"REGION":"South-East Asia","YEAR":"2008","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"166"},{"dims":{"REGION":"South-East Asia","YEAR":"2007","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"199"},{"dims":{"REGION":"South-East Asia","YEAR":"2007","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"225"},{"dims":{"REGION":"South-East Asia","YEAR":"2007","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"168"},{"dims":{"REGION":"South-East Asia","YEAR":"2006","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"201"},{"dims":{"REGION":"South-East Asia","YEAR":"2006","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"227"},{"dims":{"REGION":"South-East Asia","YEAR":"2006","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"171"},{"dims":{"REGION":"South-East Asia","YEAR":"2005","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"208"},{"dims":{"REGION":"South-East Asia","YEAR":"2005","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"229"},{"dims":{"REGION":"South-East Asia","YEAR":"2005","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"177"},{"dims":{"REGION":"South-East Asia","YEAR":"2004","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"206"},{"dims":{"REGION":"South-East Asia","YEAR":"2004","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"237"},{"dims":{"REGION":"South-East Asia","YEAR":"2004","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"176"},{"dims":{"REGION":"South-East Asia","YEAR":"2003","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"208"},{"dims":{"REGION":"South-East Asia","YEAR":"2003","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"234"},{"dims":{"REGION":"South-East Asia","YEAR":"2003","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"179"},{"dims":{"REGION":"South-East Asia","YEAR":"2002","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"211"},{"dims":{"REGION":"South-East Asia","YEAR":"2002","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"236"},{"dims":{"REGION":"South-East Asia","YEAR":"2002","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"182"},{"dims":{"REGION":"South-East Asia","YEAR":"2001","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"213"},{"dims":{"REGION":"South-East Asia","YEAR":"2001","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"239"},{"dims":{"REGION":"South-East Asia","YEAR":"2001","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"184"},{"dims":{"REGION":"South-East Asia","YEAR":"2000","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"174"},{"dims":{"REGION":"South-East Asia","YEAR":"2000","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"241"},{"dims":{"REGION":"South-East Asia","YEAR":"2000","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"138"},{"dims":{"REGION":"Europe","YEAR":"2015","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"124"},{"dims":{"REGION":"Europe","YEAR":"2015","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"168"},{"dims":{"REGION":"Europe","YEAR":"2015","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"76"},{"dims":{"REGION":"Europe","YEAR":"2014","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"126"},{"dims":{"REGION":"Europe","YEAR":"2014","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"172"},{"dims":{"REGION":"Europe","YEAR":"2014","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"77"},{"dims":{"REGION":"Europe","YEAR":"2013","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"130"},{"dims":{"REGION":"Europe","YEAR":"2013","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"175"},{"dims":{"REGION":"Europe","YEAR":"2013","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"79"},{"dims":{"REGION":"Europe","YEAR":"2012","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"133"},{"dims":{"REGION":"Europe","YEAR":"2012","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"180"},{"dims":{"REGION":"Europe","YEAR":"2012","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"80"},{"dims":{"REGION":"Europe","YEAR":"2011","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"138"},{"dims":{"REGION":"Europe","YEAR":"2011","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"185"},{"dims":{"REGION":"Europe","YEAR":"2011","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"83"},{"dims":{"REGION":"Europe","YEAR":"2010","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"142"},{"dims":{"REGION":"Europe","YEAR":"2010","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"192"},{"dims":{"REGION":"Europe","YEAR":"2010","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"85"},{"dims":{"REGION":"Europe","YEAR":"2009","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"150"},{"dims":{"REGION":"Europe","YEAR":"2009","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"198"},{"dims":{"REGION":"Europe","YEAR":"2009","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"89"},{"dims":{"REGION":"Europe","YEAR":"2008","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"153"},{"dims":{"REGION":"Europe","YEAR":"2008","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"210"},{"dims":{"REGION":"Europe","YEAR":"2008","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"90"},{"dims":{"REGION":"Europe","YEAR":"2007","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"157"},{"dims":{"REGION":"Europe","YEAR":"2007","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"214"},{"dims":{"REGION":"Europe","YEAR":"2007","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"92"},{"dims":{"REGION":"Europe","YEAR":"2006","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"165"},{"dims":{"REGION":"Europe","YEAR":"2006","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"221"},{"dims":{"REGION":"Europe","YEAR":"2006","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"97"},{"dims":{"REGION":"Europe","YEAR":"2005","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"163"},{"dims":{"REGION":"Europe","YEAR":"2005","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"231"},{"dims":{"REGION":"Europe","YEAR":"2005","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"96"},{"dims":{"REGION":"Europe","YEAR":"2004","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"164"},{"dims":{"REGION":"Europe","YEAR":"2004","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"228"},{"dims":{"REGION":"Europe","YEAR":"2004","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"97"},{"dims":{"REGION":"Europe","YEAR":"2003","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"163"},{"dims":{"REGION":"Europe","YEAR":"2003","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"229"},{"dims":{"REGION":"Europe","YEAR":"2003","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"96"},{"dims":{"REGION":"Europe","YEAR":"2002","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"162"},{"dims":{"REGION":"Europe","YEAR":"2002","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"228"},{"dims":{"REGION":"Europe","YEAR":"2002","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"95"},{"dims":{"REGION":"Europe","YEAR":"2001","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"163"},{"dims":{"REGION":"Europe","YEAR":"2001","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"227"},{"dims":{"REGION":"Europe","YEAR":"2001","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"96"},{"dims":{"REGION":"Europe","YEAR":"2000","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"122"},{"dims":{"REGION":"Europe","YEAR":"2000","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"229"},{"dims":{"REGION":"Europe","YEAR":"2000","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"75"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2015","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"155"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2015","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"174"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2015","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"130"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2014","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"154"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2014","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"178"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2014","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"130"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2013","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"157"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2013","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"176"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2013","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"133"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2012","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"155"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2012","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"179"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2012","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"131"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2011","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"158"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2011","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"176"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2011","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"135"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2010","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"163"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2010","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"180"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2010","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"138"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2009","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"167"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2009","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"186"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2009","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"141"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2008","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"173"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2008","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"191"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2008","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"145"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2007","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"176"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2007","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"197"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2007","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"149"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2006","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"181"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2006","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"201"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2006","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"154"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2005","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"178"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2005","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"206"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2005","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"152"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2004","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"183"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2004","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"202"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2004","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"157"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2003","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"179"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2003","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"207"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2003","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"155"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2002","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"182"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2002","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"201"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2002","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"158"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2001","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"183"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2001","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"204"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2001","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"159"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2000","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"152"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2000","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"205"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2000","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"128"},{"dims":{"REGION":"Western Pacific","YEAR":"2015","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"93"},{"dims":{"REGION":"Western Pacific","YEAR":"2015","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"110"},{"dims":{"REGION":"Western Pacific","YEAR":"2015","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"73"},{"dims":{"REGION":"Western Pacific","YEAR":"2014","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"94"},{"dims":{"REGION":"Western Pacific","YEAR":"2014","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"112"},{"dims":{"REGION":"Western Pacific","YEAR":"2014","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"74"},{"dims":{"REGION":"Western Pacific","YEAR":"2013","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"95"},{"dims":{"REGION":"Western Pacific","YEAR":"2013","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"114"},{"dims":{"REGION":"Western Pacific","YEAR":"2013","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"75"},{"dims":{"REGION":"Western Pacific","YEAR":"2012","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"97"},{"dims":{"REGION":"Western Pacific","YEAR":"2012","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"115"},{"dims":{"REGION":"Western Pacific","YEAR":"2012","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"77"},{"dims":{"REGION":"Western Pacific","YEAR":"2011","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"98"},{"dims":{"REGION":"Western Pacific","YEAR":"2011","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"116"},{"dims":{"REGION":"Western Pacific","YEAR":"2011","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"78"},{"dims":{"REGION":"Western Pacific","YEAR":"2010","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"99"},{"dims":{"REGION":"Western Pacific","YEAR":"2010","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"118"},{"dims":{"REGION":"Western Pacific","YEAR":"2010","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"79"},{"dims":{"REGION":"Western Pacific","YEAR":"2009","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"102"},{"dims":{"REGION":"Western Pacific","YEAR":"2009","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"119"},{"dims":{"REGION":"Western Pacific","YEAR":"2009","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"81"},{"dims":{"REGION":"Western Pacific","YEAR":"2008","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"101"},{"dims":{"REGION":"Western Pacific","YEAR":"2008","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"122"},{"dims":{"REGION":"Western Pacific","YEAR":"2008","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"81"},{"dims":{"REGION":"Western Pacific","YEAR":"2007","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"103"},{"dims":{"REGION":"Western Pacific","YEAR":"2007","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"121"},{"dims":{"REGION":"Western Pacific","YEAR":"2007","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"82"},{"dims":{"REGION":"Western Pacific","YEAR":"2006","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"104"},{"dims":{"REGION":"Western Pacific","YEAR":"2006","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"122"},{"dims":{"REGION":"Western Pacific","YEAR":"2006","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"84"},{"dims":{"REGION":"Western Pacific","YEAR":"2005","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"105"},{"dims":{"REGION":"Western Pacific","YEAR":"2005","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"124"},{"dims":{"REGION":"Western Pacific","YEAR":"2005","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"85"},{"dims":{"REGION":"Western Pacific","YEAR":"2004","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"107"},{"dims":{"REGION":"Western Pacific","YEAR":"2004","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"125"},{"dims":{"REGION":"Western Pacific","YEAR":"2004","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"87"},{"dims":{"REGION":"Western Pacific","YEAR":"2003","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"109"},{"dims":{"REGION":"Western Pacific","YEAR":"2003","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"126"},{"dims":{"REGION":"Western Pacific","YEAR":"2003","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"89"},{"dims":{"REGION":"Western Pacific","YEAR":"2002","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"113"},{"dims":{"REGION":"Western Pacific","YEAR":"2002","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"129"},{"dims":{"REGION":"Western Pacific","YEAR":"2002","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"92"},{"dims":{"REGION":"Western Pacific","YEAR":"2001","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"118"},{"dims":{"REGION":"Western Pacific","YEAR":"2001","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"133"},{"dims":{"REGION":"Western Pacific","YEAR":"2001","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"94"},{"dims":{"REGION":"Western Pacific","YEAR":"2000","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"92"},{"dims":{"REGION":"Western Pacific","YEAR":"2000","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"140"},{"dims":{"REGION":"Western Pacific","YEAR":"2000","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"72"},{"dims":{"REGION":"Global","YEAR":"2015","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"149"},{"dims":{"REGION":"Global","YEAR":"2015","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"176"},{"dims":{"REGION":"Global","YEAR":"2015","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"117"},{"dims":{"REGION":"Global","YEAR":"2014","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"151"},{"dims":{"REGION":"Global","YEAR":"2014","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"179"},{"dims":{"REGION":"Global","YEAR":"2014","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"119"},{"dims":{"REGION":"Global","YEAR":"2013","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"153"},{"dims":{"REGION":"Global","YEAR":"2013","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"181"},{"dims":{"REGION":"Global","YEAR":"2013","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"121"},{"dims":{"REGION":"Global","YEAR":"2012","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"155"},{"dims":{"REGION":"Global","YEAR":"2012","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"183"},{"dims":{"REGION":"Global","YEAR":"2012","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"123"},{"dims":{"REGION":"Global","YEAR":"2011","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"158"},{"dims":{"REGION":"Global","YEAR":"2011","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"185"},{"dims":{"REGION":"Global","YEAR":"2011","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"127"},{"dims":{"REGION":"Global","YEAR":"2010","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"161"},{"dims":{"REGION":"Global","YEAR":"2010","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"189"},{"dims":{"REGION":"Global","YEAR":"2010","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"129"},{"dims":{"REGION":"Global","YEAR":"2009","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"165"},{"dims":{"REGION":"Global","YEAR":"2009","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"191"},{"dims":{"REGION":"Global","YEAR":"2009","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"133"},{"dims":{"REGION":"Global","YEAR":"2008","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"167"},{"dims":{"REGION":"Global","YEAR":"2008","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"196"},{"dims":{"REGION":"Global","YEAR":"2008","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"135"},{"dims":{"REGION":"Global","YEAR":"2007","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"170"},{"dims":{"REGION":"Global","YEAR":"2007","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"197"},{"dims":{"REGION":"Global","YEAR":"2007","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"138"},{"dims":{"REGION":"Global","YEAR":"2006","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"174"},{"dims":{"REGION":"Global","YEAR":"2006","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"201"},{"dims":{"REGION":"Global","YEAR":"2006","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"141"},{"dims":{"REGION":"Global","YEAR":"2005","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"176"},{"dims":{"REGION":"Global","YEAR":"2005","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"205"},{"dims":{"REGION":"Global","YEAR":"2005","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"144"},{"dims":{"REGION":"Global","YEAR":"2004","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"178"},{"dims":{"REGION":"Global","YEAR":"2004","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"208"},{"dims":{"REGION":"Global","YEAR":"2004","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"145"},{"dims":{"REGION":"Global","YEAR":"2003","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"178"},{"dims":{"REGION":"Global","YEAR":"2003","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"209"},{"dims":{"REGION":"Global","YEAR":"2003","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"146"},{"dims":{"REGION":"Global","YEAR":"2002","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"180"},{"dims":{"REGION":"Global","YEAR":"2002","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"210"},{"dims":{"REGION":"Global","YEAR":"2002","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"147"},{"dims":{"REGION":"Global","YEAR":"2001","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"182"},{"dims":{"REGION":"Global","YEAR":"2001","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"212"},{"dims":{"REGION":"Global","YEAR":"2001","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"148"},{"dims":{"REGION":"Global","YEAR":"2000","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Both sexes"},"Value":"146"},{"dims":{"REGION":"Global","YEAR":"2000","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Male"},"Value":"215"},{"dims":{"REGION":"Global","YEAR":"2000","GHO":"Adult mortality rate (probability of dying between 15 and 60 years per 1000 population)","SEX":"Female"},"Value":"115"}]}

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap_table__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WikiQuote_js__ = __webpack_require__(21);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AlcoholConumptionDeaths=__webpack_require__(593);var AlcoholDeaths=function(_Component){_inherits(AlcoholDeaths,_Component);function AlcoholDeaths(props){_classCallCheck(this,AlcoholDeaths);var _this=_possibleConstructorReturn(this,(AlcoholDeaths.__proto__||Object.getPrototypeOf(AlcoholDeaths)).call(this,props));_this.state={data:[],quote:""};return _this;}_createClass(AlcoholDeaths,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var quote="",data=[];var success=function success(wikiData){quote='"'+wikiData.quote+'"';};__WEBPACK_IMPORTED_MODULE_3__WikiQuote_js__["a" /* WikiquoteApi */].getRandomQuote("Drunkenness",success,__WEBPACK_IMPORTED_MODULE_3__WikiQuote_js__["b" /* error */]);data=Object(__WEBPACK_IMPORTED_MODULE_1__utils_js__["h" /* mapTable */])(Object(__WEBPACK_IMPORTED_MODULE_1__utils_js__["f" /* filterTable */])(Object(__WEBPACK_IMPORTED_MODULE_1__utils_js__["g" /* initialReformat */])(AlcoholConumptionDeaths)));var checkQuoteLength=function checkQuoteLength(){if(quote.length>0){_this2.setState({quote:quote,data:data});}else{setTimeout(checkQuoteLength,100);}};checkQuoteLength();}},{key:'render',value:function render(){var data=[],finalData=[];if(this.state.data.length>0){data=Object(__WEBPACK_IMPORTED_MODULE_1__utils_js__["c" /* filterAll */])(Object(__WEBPACK_IMPORTED_MODULE_1__utils_js__["b" /* dataFunction */])(this.state.data,'alcohol'));data=Object(__WEBPACK_IMPORTED_MODULE_1__utils_js__["e" /* filterBySex */])('Both sexes',data,'Alcohol-attributable fractions, all-cause deaths (%)','2012');finalData=Object(__WEBPACK_IMPORTED_MODULE_1__utils_js__["j" /* turnStringsIntoFloats */])(data,'value');var selectRowProp={bgColor:'rgb(238, 193, 213)'};}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chart alcohol'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.state.quote),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap_table__["BootstrapTable"],{selectRow:selectRowProp,striped:true,condensed:true,search:true,multiColumnSearch:true,pagination:true,height:'30vh',data:finalData},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap_table__["TableHeaderColumn"],{row:'0',colSpan:'2',dataAlign:'center'},'Alcohol-attributable fractions, all-cause deaths (%) Both Sexes 2012'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap_table__["TableHeaderColumn"],{row:'1',dataField:'country',isKey:true,width:'30%'},'Country'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap_table__["TableHeaderColumn"],{row:'1',dataAlign:'center',dataField:'value',dataSort:true,width:'20%'},'Value')));}}]);return AlcoholDeaths;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AlcoholDeaths);

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SizePerPageDropDown = exports.ButtonGroup = exports.SearchField = exports.ClearSearchButton = exports.ExportCSVButton = exports.ShowSelectedOnlyButton = exports.DeleteButton = exports.InsertButton = exports.InsertModalFooter = exports.InsertModalBody = exports.InsertModalHeader = exports.TableHeaderColumn = exports.BootstrapTable = undefined;

var _BootstrapTable = __webpack_require__(555);

var _BootstrapTable2 = _interopRequireDefault(_BootstrapTable);

var _TableHeaderColumn = __webpack_require__(225);

var _TableHeaderColumn2 = _interopRequireDefault(_TableHeaderColumn);

var _InsertModalHeader = __webpack_require__(233);

var _InsertModalHeader2 = _interopRequireDefault(_InsertModalHeader);

var _InsertModalBody = __webpack_require__(235);

var _InsertModalBody2 = _interopRequireDefault(_InsertModalBody);

var _InsertModalFooter = __webpack_require__(234);

var _InsertModalFooter2 = _interopRequireDefault(_InsertModalFooter);

var _InsertButton = __webpack_require__(236);

var _InsertButton2 = _interopRequireDefault(_InsertButton);

var _DeleteButton = __webpack_require__(237);

var _DeleteButton2 = _interopRequireDefault(_DeleteButton);

var _ExportCSVButton = __webpack_require__(238);

var _ExportCSVButton2 = _interopRequireDefault(_ExportCSVButton);

var _ShowSelectedOnlyButton = __webpack_require__(239);

var _ShowSelectedOnlyButton2 = _interopRequireDefault(_ShowSelectedOnlyButton);

var _ClearSearchButton = __webpack_require__(241);

var _ClearSearchButton2 = _interopRequireDefault(_ClearSearchButton);

var _SearchField = __webpack_require__(240);

var _SearchField2 = _interopRequireDefault(_SearchField);

var _ButtonGroup = __webpack_require__(592);

var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);

var _SizePerPageDropDown = __webpack_require__(228);

var _SizePerPageDropDown2 = _interopRequireDefault(_SizePerPageDropDown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (typeof window !== 'undefined') {
  window.BootstrapTable = _BootstrapTable2.default;
  window.TableHeaderColumn = _TableHeaderColumn2.default;
  window.InsertModalHeader = _InsertModalHeader2.default;
  window.InsertModalBody = _InsertModalBody2.default;
  window.InsertModalFooter = _InsertModalFooter2.default;
  window.InsertButton = _InsertButton2.default;
  window.DeleteButton = _DeleteButton2.default;
  window.ShowSelectedOnlyButton = _ShowSelectedOnlyButton2.default;
  window.ExportCSVButton = _ExportCSVButton2.default;
  window.ClearSearchButton = _ClearSearchButton2.default;
  window.SearchField = _SearchField2.default;
  window.ButtonGroup = _ButtonGroup2.default;
  window.SizePerPageDropDown = _SizePerPageDropDown2.default;
}
exports.BootstrapTable = _BootstrapTable2.default;
exports.TableHeaderColumn = _TableHeaderColumn2.default;
exports.InsertModalHeader = _InsertModalHeader2.default;
exports.InsertModalBody = _InsertModalBody2.default;
exports.InsertModalFooter = _InsertModalFooter2.default;
exports.InsertButton = _InsertButton2.default;
exports.DeleteButton = _DeleteButton2.default;
exports.ShowSelectedOnlyButton = _ShowSelectedOnlyButton2.default;
exports.ExportCSVButton = _ExportCSVButton2.default;
exports.ClearSearchButton = _ClearSearchButton2.default;
exports.SearchField = _SearchField2.default;
exports.ButtonGroup = _ButtonGroup2.default;
exports.SizePerPageDropDown = _SizePerPageDropDown2.default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactSAlert = __webpack_require__(223);

var _reactSAlert2 = _interopRequireDefault(_reactSAlert);

var _Const = __webpack_require__(7);

var _Const2 = _interopRequireDefault(_Const);

var _TableHeaderColumn = __webpack_require__(225);

var _TableHeaderColumn2 = _interopRequireDefault(_TableHeaderColumn);

var _TableHeader = __webpack_require__(564);

var _TableHeader2 = _interopRequireDefault(_TableHeader);

var _TableFooter = __webpack_require__(567);

var _TableFooter2 = _interopRequireDefault(_TableFooter);

var _TableBody = __webpack_require__(568);

var _TableBody2 = _interopRequireDefault(_TableBody);

var _PaginationList = __webpack_require__(573);

var _PaginationList2 = _interopRequireDefault(_PaginationList);

var _ToolBar = __webpack_require__(575);

var _ToolBar2 = _interopRequireDefault(_ToolBar);

var _TableFilter = __webpack_require__(585);

var _TableFilter2 = _interopRequireDefault(_TableFilter);

var _TableDataStore = __webpack_require__(586);

var _util = __webpack_require__(15);

var _util2 = _interopRequireDefault(_util);

var _csv_export_util = __webpack_require__(587);

var _csv_export_util2 = _interopRequireDefault(_csv_export_util);

var _Filter = __webpack_require__(591);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-alert: 0 */
/* eslint max-len: 0 */


var BootstrapTable = function (_Component) {
  _inherits(BootstrapTable, _Component);

  function BootstrapTable(props) {
    _classCallCheck(this, BootstrapTable);

    var _this = _possibleConstructorReturn(this, (BootstrapTable.__proto__ || Object.getPrototypeOf(BootstrapTable)).call(this, props));

    _this.handleSort = function () {
      return _this.__handleSort__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleExpandRow = function () {
      return _this.__handleExpandRow__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handlePaginationData = function () {
      return _this.__handlePaginationData__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleMouseLeave = function () {
      return _this.__handleMouseLeave__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleMouseEnter = function () {
      return _this.__handleMouseEnter__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleRowMouseOut = function () {
      return _this.__handleRowMouseOut__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleRowMouseOver = function () {
      return _this.__handleRowMouseOver__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleNavigateCell = function () {
      return _this.__handleNavigateCell__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleRowClick = function () {
      return _this.__handleRowClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleRowDoubleClick = function () {
      return _this.__handleRowDoubleClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleSelectAllRow = function () {
      return _this.__handleSelectAllRow__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleShowOnlySelected = function () {
      return _this.__handleShowOnlySelected__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleSelectRow = function () {
      return _this.__handleSelectRow__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleEditCell = function () {
      return _this.__handleEditCell__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleAddRow = function () {
      return _this.__handleAddRow__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.getPageByRowKey = function () {
      return _this.__getPageByRowKey__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleDropRow = function () {
      return _this.__handleDropRow__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleFilterData = function () {
      return _this.__handleFilterData__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleExportCSV = function () {
      return _this.__handleExportCSV__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleSearch = function () {
      return _this.__handleSearch__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this._scrollTop = function () {
      return _this.___scrollTop__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this._scrollHeader = function () {
      return _this.___scrollHeader__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this._scrollFooter = function () {
      return _this.___scrollFooter__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.isIE = false;
    if (_util2.default.canUseDOM()) {
      _this.isIE = document.documentMode;
    }
    _this.store = new _TableDataStore.TableDataStore(_this.props.data ? _this.props.data.slice() : []);
    _this.isVerticalScroll = false;
    _this.initTable(_this.props);

    if (_this.props.selectRow && _this.props.selectRow.selected) {
      var copy = _this.props.selectRow.selected.slice();
      _this.store.setSelectedRowKey(copy);
    }
    var currPage = _Const2.default.PAGE_START_INDEX;
    if (typeof _this.props.options.page !== 'undefined') {
      currPage = _this.props.options.page;
    } else if (typeof _this.props.options.pageStartIndex !== 'undefined') {
      currPage = _this.props.options.pageStartIndex;
    }

    _this._adjustHeaderWidth = _this._adjustHeaderWidth.bind(_this);
    _this._adjustHeight = _this._adjustHeight.bind(_this);
    _this._adjustTable = _this._adjustTable.bind(_this);
    _this.toggleExpandAllChilds = _this.toggleExpandAllChilds.bind(_this);

    var expandedKeys = [];
    if (_this.props.options.expandAllChilds !== null && _this.props.options.expandAllChilds !== undefined && _this.props.options.expandAllChilds) {
      expandedKeys = _this.store.getAllRowkey();
    } else if (_this.props.options.expanding !== undefined && _this.props.options.expanding !== null) {
      expandedKeys = _this.props.options.expanding;
    }

    _this.state = {
      data: _this.getTableData(),
      currPage: currPage,
      expanding: expandedKeys,
      sizePerPage: _this.props.options.sizePerPage || _Const2.default.SIZE_PER_PAGE_LIST[0],
      selectedRowKeys: _this.store.getSelectedRowKeys(),
      reset: false,
      x: _this.props.keyBoardNav ? 0 : -1,
      y: _this.props.keyBoardNav ? 0 : -1
    };
    return _this;
  }

  _createClass(BootstrapTable, [{
    key: '___scrollFooter__REACT_HOT_LOADER__',
    value: function ___scrollFooter__REACT_HOT_LOADER__() {
      return this.___scrollFooter__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '___scrollHeader__REACT_HOT_LOADER__',
    value: function ___scrollHeader__REACT_HOT_LOADER__() {
      return this.___scrollHeader__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '___scrollTop__REACT_HOT_LOADER__',
    value: function ___scrollTop__REACT_HOT_LOADER__() {
      return this.___scrollTop__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleSearch__REACT_HOT_LOADER__',
    value: function __handleSearch__REACT_HOT_LOADER__() {
      return this.__handleSearch__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleExportCSV__REACT_HOT_LOADER__',
    value: function __handleExportCSV__REACT_HOT_LOADER__() {
      return this.__handleExportCSV__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleFilterData__REACT_HOT_LOADER__',
    value: function __handleFilterData__REACT_HOT_LOADER__() {
      return this.__handleFilterData__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleDropRow__REACT_HOT_LOADER__',
    value: function __handleDropRow__REACT_HOT_LOADER__() {
      return this.__handleDropRow__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__getPageByRowKey__REACT_HOT_LOADER__',
    value: function __getPageByRowKey__REACT_HOT_LOADER__() {
      return this.__getPageByRowKey__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleAddRow__REACT_HOT_LOADER__',
    value: function __handleAddRow__REACT_HOT_LOADER__() {
      return this.__handleAddRow__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleEditCell__REACT_HOT_LOADER__',
    value: function __handleEditCell__REACT_HOT_LOADER__() {
      return this.__handleEditCell__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleSelectRow__REACT_HOT_LOADER__',
    value: function __handleSelectRow__REACT_HOT_LOADER__() {
      return this.__handleSelectRow__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleShowOnlySelected__REACT_HOT_LOADER__',
    value: function __handleShowOnlySelected__REACT_HOT_LOADER__() {
      return this.__handleShowOnlySelected__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleSelectAllRow__REACT_HOT_LOADER__',
    value: function __handleSelectAllRow__REACT_HOT_LOADER__() {
      return this.__handleSelectAllRow__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleRowDoubleClick__REACT_HOT_LOADER__',
    value: function __handleRowDoubleClick__REACT_HOT_LOADER__() {
      return this.__handleRowDoubleClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleRowClick__REACT_HOT_LOADER__',
    value: function __handleRowClick__REACT_HOT_LOADER__() {
      return this.__handleRowClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleNavigateCell__REACT_HOT_LOADER__',
    value: function __handleNavigateCell__REACT_HOT_LOADER__() {
      return this.__handleNavigateCell__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleRowMouseOver__REACT_HOT_LOADER__',
    value: function __handleRowMouseOver__REACT_HOT_LOADER__() {
      return this.__handleRowMouseOver__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleRowMouseOut__REACT_HOT_LOADER__',
    value: function __handleRowMouseOut__REACT_HOT_LOADER__() {
      return this.__handleRowMouseOut__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleMouseEnter__REACT_HOT_LOADER__',
    value: function __handleMouseEnter__REACT_HOT_LOADER__() {
      return this.__handleMouseEnter__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleMouseLeave__REACT_HOT_LOADER__',
    value: function __handleMouseLeave__REACT_HOT_LOADER__() {
      return this.__handleMouseLeave__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handlePaginationData__REACT_HOT_LOADER__',
    value: function __handlePaginationData__REACT_HOT_LOADER__() {
      return this.__handlePaginationData__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleExpandRow__REACT_HOT_LOADER__',
    value: function __handleExpandRow__REACT_HOT_LOADER__() {
      return this.__handleExpandRow__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleSort__REACT_HOT_LOADER__',
    value: function __handleSort__REACT_HOT_LOADER__() {
      return this.__handleSort__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'initTable',
    value: function initTable(props) {
      var _this2 = this;

      // If columns changed, clean removed columns that had filters
      if (props.children !== this.props.children && this.filter) {
        var nextDataFields = _react2.default.Children.map(props.children, function (column) {
          return column.props.dataField;
        });
        _react2.default.Children.forEach(this.props.children, function (column) {
          var _column$props = column.props,
              dataField = _column$props.dataField,
              filter = _column$props.filter;

          if (filter && !nextDataFields.includes(dataField)) {
            // Clear filter
            _this2.filter.handleFilter(dataField, '', filter.type, filter);
          }
        });
      }

      var keyField = props.keyField;


      var isKeyFieldDefined = typeof keyField === 'string' && keyField.length;
      _react2.default.Children.forEach(props.children, function (column) {
        if (column === null || column === undefined) {
          // Skip null and undefined value
          return;
        }
        if (column.props.isKey) {
          if (keyField) {
            throw new Error('Error. Multiple key column detected in TableHeaderColumn.');
          }
          keyField = column.props.dataField;
        }
        if (column.props.filter) {
          // a column contains a filter
          if (!_this2.filter) {
            // first time create the filter on the BootstrapTable
            _this2.filter = new _Filter.Filter();
          }
          // pass the filter to column with filter
          column.props.filter.emitter = _this2.filter;
        }
      });

      // if a column filter was created, add 'onFilterChange' listener
      if (this.filter) {
        this.filter.removeAllListeners('onFilterChange');
        this.filter.on('onFilterChange', function (currentFilter) {
          _this2.handleFilterData(currentFilter);
        });
      }

      this.colInfos = this.getColumnsDescription(props).reduce(function (prev, curr) {
        prev[curr.name] = curr;
        return prev;
      }, {});

      if (!isKeyFieldDefined && !keyField) {
        throw new Error('Error. No any key column defined in TableHeaderColumn.\n            Use \'isKey={true}\' to specify a unique column after version 0.5.4.');
      }

      this.store.setProps({
        isPagination: props.pagination,
        keyField: keyField,
        colInfos: this.colInfos,
        multiColumnSearch: props.multiColumnSearch,
        strictSearch: props.strictSearch,
        multiColumnSort: props.multiColumnSort,
        remote: this.props.remote
      });
    }
  }, {
    key: 'getTableData',
    value: function getTableData() {
      var result = [];
      var _props = this.props,
          options = _props.options,
          pagination = _props.pagination;

      var sortName = options.defaultSortName || options.sortName;
      var sortOrder = options.defaultSortOrder || options.sortOrder;
      var searchText = options.defaultSearch;

      if (sortName && sortOrder) {
        this.store.setSortInfo(sortOrder, sortName);
        if (!this.allowRemote(_Const2.default.REMOTE_SORT)) {
          this.store.sort();
        }
      }

      if (searchText) {
        this.store.search(searchText);
      }

      if (pagination) {
        var page = void 0;
        var sizePerPage = void 0;
        if (this.store.isChangedPage()) {
          sizePerPage = this.state.sizePerPage;
          page = this.state.currPage;
        } else {
          sizePerPage = options.sizePerPage || _Const2.default.SIZE_PER_PAGE_LIST[0];
          page = options.page || 1;
        }
        result = this.store.page(page, sizePerPage).get();
      } else {
        result = this.store.get();
      }
      return result;
    }
  }, {
    key: 'getColumnsDescription',
    value: function getColumnsDescription(_ref) {
      var _this3 = this;

      var children = _ref.children;

      var rowCount = 0;
      _react2.default.Children.forEach(children, function (column) {
        if (column === null || column === undefined) {
          // Skip null and undefined value
          return;
        }

        if (Number(column.props.row) > rowCount) {
          rowCount = Number(column.props.row);
        }
      });
      return _react2.default.Children.map(children, function (column, i) {
        if (column === null || column === undefined) {
          // Return null for empty objects
          return null;
        }

        var rowIndex = column.props.row ? Number(column.props.row) : 0;
        var rowSpan = column.props.rowSpan ? Number(column.props.rowSpan) : 1;
        if (rowSpan + rowIndex === rowCount + 1) {
          var columnDescription = _this3.getColumnDescription(column);

          columnDescription.index = i;
          return columnDescription;
        }
      });
    }
  }, {
    key: 'getColumnDescription',
    value: function getColumnDescription(column) {
      var columnDescription = {
        name: column.props.dataField,
        align: column.props.dataAlign,
        sort: column.props.dataSort,
        format: column.props.dataFormat,
        formatExtraData: column.props.formatExtraData,
        filterFormatted: column.props.filterFormatted,
        filterValue: column.props.filterValue,
        editable: column.props.editable,
        customEditor: column.props.customEditor,
        hidden: column.props.hidden,
        hiddenOnInsert: column.props.hiddenOnInsert,
        searchable: column.props.searchable,
        className: column.props.columnClassName,
        editClassName: column.props.editColumnClassName,
        invalidEditColumnClassName: column.props.invalidEditColumnClassName,
        columnTitle: column.props.columnTitle,
        width: column.props.width,
        text: column.props.headerText || column.props.children,
        sortFunc: column.props.sortFunc,
        sortFuncExtraData: column.props.sortFuncExtraData,
        export: column.props.export,
        expandable: column.props.expandable,
        attrs: column.props.tdAttr,
        editAttrs: column.props.editTdAttr,
        style: column.props.tdStyle
      };

      if (column.type.name !== _TableHeaderColumn2.default.name && _react2.default.isValidElement(column.props.children)) {
        columnDescription = _extends({}, columnDescription, this.getColumnDescription(_react2.default.Children.only(column.props.children)));
      }

      return columnDescription;
    }
  }, {
    key: 'reset',
    value: function reset() {
      var _this4 = this;

      var pageStartIndex = this.props.options.pageStartIndex;

      this.store.clean();
      this.body.setState({ currEditCell: null });
      this.setState(function () {
        return {
          data: _this4.getTableData(),
          currPage: _util2.default.getFirstPage(pageStartIndex),
          expanding: [],
          sizePerPage: _Const2.default.SIZE_PER_PAGE_LIST[0],
          selectedRowKeys: [],
          reset: true
        };
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.initTable(nextProps);
      var options = nextProps.options,
          selectRow = nextProps.selectRow;
      var replace = nextProps.replace;

      replace = replace || this.props.replace;

      if (!nextProps.data) {
        return;
      }
      this.store.setData(nextProps.data.slice());

      if (!replace) {
        // from #481
        var page = this.state.currPage;
        if (this.props.options.page !== options.page) {
          page = options.page;
        }
        // from #481
        var sizePerPage = this.state.sizePerPage;
        if (this.props.options.sizePerPage !== options.sizePerPage) {
          sizePerPage = options.sizePerPage;
        }

        if (this.isRemoteDataSource()) {
          var newState = { sizePerPage: sizePerPage, reset: false, currPage: page };
          var data = nextProps.data.slice();
          if (nextProps.pagination && !this.allowRemote(_Const2.default.REMOTE_PAGE)) {
            data = this.store.page(page, sizePerPage).get();
          }

          if (this.store.isOnFilter) {
            if (this.store.searchText) this.handleSearch(this.store.searchText);
            if (this.store.filterObj) this.handleFilterData(this.store.filterObj);
            newState.currPage = _util2.default.getFirstPage(nextProps.options.pageStartIndex);
          } else {
            if (!this.allowRemote(_Const2.default.REMOTE_SORT)) {
              data = this.store.sort().get();
            } else {
              var currentOptions = this.props.options;

              var sortName = options.sortName;
              var sortOrder = options.sortOrder;
              if (currentOptions.sortName !== sortName || currentOptions.sortOrder !== sortOrder) {
                this.store.setSortInfo(sortOrder, options.sortName);
              }
            }
            newState.data = data;
          }
          this.setState(function () {
            return newState;
          });
        } else {
          // #125
          // remove !options.page for #709
          if (page > Math.ceil(nextProps.data.length / sizePerPage)) {
            page = 1;
          }
          var sortList = this.store.getSortInfo();
          var sortField = options.sortName;
          var _sortOrder = options.sortOrder;
          if (sortField && _sortOrder) {
            this.store.setSortInfo(_sortOrder, sortField);
            this.store.sort();
          } else if (sortList.length > 0) {
            this.store.sort();
          }
          var _data = this.store.page(page, sizePerPage).get();
          this.setState(function () {
            return {
              data: _data,
              currPage: page,
              sizePerPage: sizePerPage,
              reset: false
            };
          });

          if (this.store.isSearching && options.afterSearch) {
            options.afterSearch(this.store.searchText, this.store.getDataIgnoringPagination());
          }

          if (this.store.isFiltering && options.afterColumnFilter) {
            options.afterColumnFilter(this.store.filterObj, this.store.getDataIgnoringPagination());
          }
        }

        // If setting the expanded rows is being handled externally
        // then overwrite the current expanded rows.
        if (this.props.options.expanding !== options.expanding) {
          this.setState(function () {
            return {
              expanding: options.expanding || []
            };
          });
        }

        if (selectRow && selectRow.selected) {
          // set default select rows to store.
          var copy = selectRow.selected.slice();
          this.store.setSelectedRowKey(copy);
          this.setState(function () {
            return {
              selectedRowKeys: copy,
              reset: false
            };
          });
        }
      } else {
        this.reset();
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._adjustTable();
      window.addEventListener('resize', this._adjustTable);
      this.body.container.addEventListener('scroll', this._scrollHeader);
      if (this.props.footer) {
        this.body.container.addEventListener('scroll', this._scrollFooter);
      }
      if (this.props.scrollTop) {
        this._scrollTop();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this._adjustTable);
      if (this.body && this.body.container) {
        this.body.container.removeEventListener('scroll', this._scrollHeader);
        if (this.props.footer) {
          this.body.container.removeEventListener('scroll', this._scrollFooter);
        }
      }
      if (this.filter) {
        this.filter.removeAllListeners('onFilterChange');
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this._adjustTable();
      if (this.props.options.afterTableComplete) {
        this.props.options.afterTableComplete();
      }
    }

    /**
     * Returns true if in the current configuration,
     * the datagrid should load its data remotely.
     *
     * @param  {Object}  [props] Optional. If not given, this.props will be used
     * @return {Boolean}
     */

  }, {
    key: 'isRemoteDataSource',
    value: function isRemoteDataSource(props) {
      var _ref2 = props || this.props,
          remote = _ref2.remote;

      return remote === true || _util2.default.isFunction(remote);
    }

    /**
     * Returns true if this action can be handled remote store
     * From #990, Sometimes, we need some actions as remote, some actions are handled by default
     * so function will tell you the target action is can be handled as remote or not.
     * @param  {String}  [action] Required.
     * @param  {Object}  [props] Optional. If not given, this.props will be used
     * @return {Boolean}
     */

  }, {
    key: 'allowRemote',
    value: function allowRemote(action, props) {
      var _ref3 = props || this.props,
          remote = _ref3.remote;

      if (typeof remote === 'function') {
        var remoteObj = remote(_Const2.default.REMOTE);
        return remoteObj[action];
      } else {
        return remote;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var style = {
        height: this.props.height,
        maxHeight: this.props.maxHeight
      };

      var columns = this.getColumnsDescription(this.props);
      var sortList = this.store.getSortInfo();
      var pagination = this.renderPagination();
      var toolBar = this.renderToolBar();
      var tableFilter = this.renderTableFilter(columns);
      var isSelectAll = this.isSelectAll();
      var expandColumnOptions = this.props.expandColumnOptions;
      if (typeof expandColumnOptions.expandColumnBeforeSelectColumn === 'undefined') {
        expandColumnOptions.expandColumnBeforeSelectColumn = true;
      }
      var colGroups = _util2.default.renderColGroup(columns, this.props.selectRow, expandColumnOptions, this.props.version);
      var tableFooter = this.renderTableFooter(this.props.footerData, this.state.data, columns, colGroups);
      var sortIndicator = this.props.options.sortIndicator;
      if (typeof this.props.options.sortIndicator === 'undefined') sortIndicator = true;

      var _props$options$pagina = this.props.options.paginationPosition,
          paginationPosition = _props$options$pagina === undefined ? _Const2.default.PAGINATION_POS_BOTTOM : _props$options$pagina;

      var showPaginationOnTop = paginationPosition !== _Const2.default.PAGINATION_POS_BOTTOM;
      var showPaginationOnBottom = paginationPosition !== _Const2.default.PAGINATION_POS_TOP;
      var selectRow = _extends({}, this.props.selectRow);
      if (this.props.cellEdit && this.props.cellEdit.mode !== _Const2.default.CELL_EDIT_NONE) {
        selectRow.clickToSelect = false;
      }

      var _props$options$toolba = this.props.options.toolbarPosition,
          toolbarPosition = _props$options$toolba === undefined ? _Const2.default.TOOLBAR_POS_TOP : _props$options$toolba;

      var showToolbarOnTop = toolbarPosition !== _Const2.default.TOOLBAR_POS_BOTTOM;
      var showToolbarOnBottom = toolbarPosition !== _Const2.default.TOOLBAR_POS_TOP;
      var _props$options$hideRo = this.props.options.hideRowOnExpand,
          hideRowOnExpand = _props$options$hideRo === undefined ? false : _props$options$hideRo;

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('react-bs-table-container', this.props.className, this.props.containerClass),
          style: this.props.containerStyle },
        showToolbarOnTop ? toolBar : null,
        showPaginationOnTop ? pagination : null,
        _react2.default.createElement(
          'div',
          { ref: function ref(node) {
              return _this5.table = node;
            },
            className: (0, _classnames2.default)('react-bs-table', { 'react-bs-table-bordered': this.props.bordered }, this.props.tableContainerClass),
            style: _extends({}, style, this.props.tableStyle),
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: this.handleMouseLeave },
          _react2.default.createElement(
            _TableHeader2.default,
            {
              ref: function ref(node) {
                return _this5.header = node;
              },
              version: this.props.version,
              colGroups: colGroups,
              headerContainerClass: this.props.headerContainerClass,
              tableHeaderClass: this.props.tableHeaderClass,
              style: this.props.headerStyle,
              rowSelectType: this.props.selectRow.mode,
              customComponent: this.props.selectRow.customComponent,
              hideSelectColumn: this.props.selectRow.hideSelectColumn,
              sortList: sortList,
              sortIndicator: sortIndicator,
              onSort: this.handleSort,
              onSelectAllRow: this.handleSelectAllRow,
              bordered: this.props.bordered,
              condensed: this.props.condensed,
              isFiltered: this.filter ? true : false,
              isSelectAll: isSelectAll,
              reset: this.state.reset,
              expandColumnVisible: expandColumnOptions.expandColumnVisible,
              expandColumnComponent: expandColumnOptions.expandColumnComponent,
              expandedColumnHeaderComponent: expandColumnOptions.expandedColumnHeaderComponent,
              noAnyExpand: this.state.expanding.length === 0,
              expandAll: this.props.options.expandAll,
              toggleExpandAllChilds: this.toggleExpandAllChilds,
              expandColumnBeforeSelectColumn: expandColumnOptions.expandColumnBeforeSelectColumn },
            this.props.children
          ),
          _react2.default.createElement(_TableBody2.default, {
            ref: function ref(node) {
              return _this5.body = node;
            },
            bodyContainerClass: this.props.bodyContainerClass,
            tableBodyClass: this.props.tableBodyClass,
            style: _extends({}, style, this.props.bodyStyle),
            data: this.state.data,
            version: this.props.version,
            expandComponent: this.props.expandComponent,
            expandableRow: this.props.expandableRow,
            expandRowBgColor: this.props.options.expandRowBgColor,
            expandBy: this.props.options.expandBy || _Const2.default.EXPAND_BY_ROW,
            expandBodyClass: this.props.options.expandBodyClass,
            expandParentClass: this.props.options.expandParentClass,
            columns: columns,
            trClassName: this.props.trClassName,
            trStyle: this.props.trStyle,
            striped: this.props.striped,
            bordered: this.props.bordered,
            hover: this.props.hover,
            keyField: this.store.getKeyField(),
            condensed: this.props.condensed,
            selectRow: selectRow,
            expandColumnOptions: this.props.expandColumnOptions,
            cellEdit: this.props.cellEdit,
            selectedRowKeys: this.state.selectedRowKeys,
            onRowClick: this.handleRowClick,
            onRowDoubleClick: this.handleRowDoubleClick,
            onRowMouseOver: this.handleRowMouseOver,
            onRowMouseOut: this.handleRowMouseOut,
            onSelectRow: this.handleSelectRow,
            noDataText: this.props.options.noDataText,
            withoutNoDataText: this.props.options.withoutNoDataText,
            expanding: this.state.expanding,
            onExpand: this.handleExpandRow,
            onlyOneExpanding: this.props.options.onlyOneExpanding,
            beforeShowError: this.props.options.beforeShowError,
            keyBoardNav: this.props.keyBoardNav,
            onNavigateCell: this.handleNavigateCell,
            x: this.state.x,
            y: this.state.y,
            withoutTabIndex: this.props.withoutTabIndex,
            hideRowOnExpand: hideRowOnExpand,
            onEditCell: this.handleEditCell }),
          tableFooter
        ),
        tableFilter,
        showPaginationOnBottom ? pagination : null,
        showToolbarOnBottom ? toolBar : null,
        this.props.renderAlert ? _react2.default.createElement(_reactSAlert2.default, { stack: { limit: 3 } }) : null
      );
    }
  }, {
    key: 'isSelectAll',
    value: function isSelectAll() {
      if (this.store.isEmpty()) return false;
      var _props$selectRow = this.props.selectRow,
          unselectable = _props$selectRow.unselectable,
          onlyUnselectVisible = _props$selectRow.onlyUnselectVisible;

      var keyField = this.store.getKeyField();
      var allRowKeys = onlyUnselectVisible ? this.store.get().map(function (r) {
        return r[keyField];
      }) : this.store.getAllRowkey();
      var defaultSelectRowKeys = this.store.getSelectedRowKeys();

      if (onlyUnselectVisible) {
        defaultSelectRowKeys = defaultSelectRowKeys.filter(function (x) {
          return x !== allRowKeys;
        });
      }

      if (defaultSelectRowKeys.length === 0) return false;
      var match = 0;
      var noFound = 0;
      var unSelectableCnt = 0;
      defaultSelectRowKeys.forEach(function (selected) {
        if (allRowKeys.indexOf(selected) !== -1) match++;else noFound++;
        if (unselectable && unselectable.indexOf(selected) !== -1) unSelectableCnt++;
      });

      if (noFound === defaultSelectRowKeys.length) return false;
      if (match === allRowKeys.length) {
        return true;
      } else {
        if (unselectable && match <= unSelectableCnt && unSelectableCnt === unselectable.length) return false;else return 'indeterminate';
      }
      // return (match === allRowKeys.length) ? true : 'indeterminate';
    }
  }, {
    key: 'cleanSelected',
    value: function cleanSelected() {
      this.store.setSelectedRowKey([]);
      this.setState(function () {
        return {
          selectedRowKeys: [],
          reset: false
        };
      });
    }
  }, {
    key: 'cleanSort',
    value: function cleanSort() {
      this.store.cleanSortInfo();
      this.setState(function () {
        return {
          reset: false
        };
      });
    }
  }, {
    key: '__handleSort__REACT_HOT_LOADER__',
    value: function __handleSort__REACT_HOT_LOADER__(order, sortField) {
      var _props2 = this.props,
          sort = _props2.autoCollapse.sort,
          options = _props2.options;

      if (options.onSortChange) {
        options.onSortChange(sortField, order, this.props);
      }
      this.store.setSortInfo(order, sortField);
      if (this.allowRemote(_Const2.default.REMOTE_SORT)) {
        if (sort) {
          this.setState(function () {
            return {
              expanding: []
            };
          });
        }
        return;
      }

      var result = this.store.sort().get();
      this.setState(function () {
        var newState = {
          data: result,
          reset: false
        };
        if (sort) newState.expanding = [];
        return newState;
      });
    }
  }, {
    key: '__handleExpandRow__REACT_HOT_LOADER__',
    value: function __handleExpandRow__REACT_HOT_LOADER__(expanding, rowKey, isRowExpanding, event) {
      var _this6 = this;

      var onExpand = this.props.options.onExpand;

      if (onExpand) {
        onExpand(rowKey, !isRowExpanding, event);
      }
      this.setState(function () {
        return { expanding: expanding, reset: false };
      }, function () {
        _this6._adjustHeaderWidth();
      });
    }
  }, {
    key: 'toggleExpandAllChilds',
    value: function toggleExpandAllChilds() {
      var _this7 = this;

      var expanding = this.state.expanding;

      if (expanding.length > 0) {
        this.setState(function () {
          return {
            expanding: [],
            reset: false
          };
        });
      } else {
        this.setState(function () {
          return {
            expanding: _this7.store.getAllRowkey(),
            reset: false
          };
        });
      }
    }
  }, {
    key: '__handlePaginationData__REACT_HOT_LOADER__',
    value: function __handlePaginationData__REACT_HOT_LOADER__(page, sizePerPage) {
      var _props$options = this.props.options,
          onPageChange = _props$options.onPageChange,
          pageStartIndex = _props$options.pageStartIndex;

      var emptyTable = this.store.isEmpty();
      if (onPageChange) {
        onPageChange(page, sizePerPage);
      }

      var state = {
        sizePerPage: sizePerPage,
        reset: false
      };
      if (!emptyTable) state.currPage = page;
      this.setState(function () {
        return state;
      });

      if (this.allowRemote(_Const2.default.REMOTE_PAGE) || emptyTable) {
        return;
      }

      var result = this.store.page(_util2.default.getNormalizedPage(pageStartIndex, page), sizePerPage).get();
      this.setState(function () {
        return { data: result, reset: false };
      });
    }
  }, {
    key: '__handleMouseLeave__REACT_HOT_LOADER__',
    value: function __handleMouseLeave__REACT_HOT_LOADER__() {
      if (this.props.options.onMouseLeave) {
        this.props.options.onMouseLeave();
      }
    }
  }, {
    key: '__handleMouseEnter__REACT_HOT_LOADER__',
    value: function __handleMouseEnter__REACT_HOT_LOADER__() {
      if (this.props.options.onMouseEnter) {
        this.props.options.onMouseEnter();
      }
    }
  }, {
    key: '__handleRowMouseOut__REACT_HOT_LOADER__',
    value: function __handleRowMouseOut__REACT_HOT_LOADER__(row, event) {
      if (this.props.options.onRowMouseOut) {
        this.props.options.onRowMouseOut(row, event);
      }
    }
  }, {
    key: '__handleRowMouseOver__REACT_HOT_LOADER__',
    value: function __handleRowMouseOver__REACT_HOT_LOADER__(row, event) {
      if (this.props.options.onRowMouseOver) {
        this.props.options.onRowMouseOver(row, event);
      }
    }
  }, {
    key: '__handleNavigateCell__REACT_HOT_LOADER__',
    value: function __handleNavigateCell__REACT_HOT_LOADER__(_ref4) {
      var offSetX = _ref4.x,
          offSetY = _ref4.y,
          lastEditCell = _ref4.lastEditCell;
      var pagination = this.props.pagination;
      var _state = this.state,
          x = _state.x,
          y = _state.y,
          currPage = _state.currPage;

      x += offSetX;
      y += offSetY;

      var columns = this.store.getColInfos();
      var visibleRowSize = this.state.data.length;
      var visibleColumnSize = Object.keys(columns).filter(function (k) {
        return !columns[k].hidden;
      }).length;

      if (y >= visibleRowSize) {
        currPage++;
        var lastPage = pagination ? this.pagination.getLastPage() : -1;
        if (currPage <= lastPage) {
          this.handlePaginationData(currPage, this.state.sizePerPage);
        } else {
          return;
        }
        y = 0;
      } else if (y < 0) {
        currPage--;
        if (currPage > 0) {
          this.handlePaginationData(currPage, this.state.sizePerPage);
        } else {
          return;
        }
        y = visibleRowSize - 1;
      } else if (x >= visibleColumnSize) {
        if (y + 1 === visibleRowSize) {
          currPage++;
          var _lastPage = pagination ? this.pagination.getLastPage() : -1;
          if (currPage <= _lastPage) {
            this.handlePaginationData(currPage, this.state.sizePerPage);
          } else {
            return;
          }
          y = 0;
        } else {
          y++;
        }
        x = lastEditCell ? 1 : 0;
      } else if (x < 0) {
        x = visibleColumnSize - 1;
        if (y === 0) {
          currPage--;
          if (currPage > 0) {
            this.handlePaginationData(currPage, this.state.sizePerPage);
          } else {
            return;
          }
          y = this.state.sizePerPage - 1;
        } else {
          y--;
        }
      }
      this.setState(function () {
        return {
          x: x, y: y, currPage: currPage, reset: false
        };
      });
    }
  }, {
    key: '__handleRowClick__REACT_HOT_LOADER__',
    value: function __handleRowClick__REACT_HOT_LOADER__(row, rowIndex, columnIndex, event) {
      var _props3 = this.props,
          options = _props3.options,
          keyBoardNav = _props3.keyBoardNav;

      if (options.onRowClick) {
        options.onRowClick(row, columnIndex, rowIndex, event);
      }
      if (keyBoardNav) {
        var _ref5 = (typeof keyBoardNav === 'undefined' ? 'undefined' : _typeof(keyBoardNav)) === 'object' ? keyBoardNav : {},
            clickToNav = _ref5.clickToNav;

        clickToNav = clickToNav === false ? clickToNav : true;
        if (clickToNav) {
          this.setState(function () {
            return {
              x: columnIndex,
              y: rowIndex,
              reset: false
            };
          });
        }
      }
    }
  }, {
    key: '__handleRowDoubleClick__REACT_HOT_LOADER__',
    value: function __handleRowDoubleClick__REACT_HOT_LOADER__(row, event) {
      if (this.props.options.onRowDoubleClick) {
        this.props.options.onRowDoubleClick(row, event);
      }
    }
  }, {
    key: '__handleSelectAllRow__REACT_HOT_LOADER__',
    value: function __handleSelectAllRow__REACT_HOT_LOADER__(e) {
      var isSelected = e.currentTarget.checked;
      var keyField = this.store.getKeyField();
      var _props$selectRow2 = this.props.selectRow,
          onSelectAll = _props$selectRow2.onSelectAll,
          unselectable = _props$selectRow2.unselectable,
          selected = _props$selectRow2.selected,
          onlyUnselectVisible = _props$selectRow2.onlyUnselectVisible;

      var selectedRowKeys = onlyUnselectVisible ? this.state.selectedRowKeys : [];
      var result = true;
      var rows = this.store.get();

      // onlyUnselectVisible default is false, #1276
      if (!isSelected && !onlyUnselectVisible) {
        rows = this.store.getRowByKey(this.state.selectedRowKeys);
      }

      if (unselectable && unselectable.length > 0) {
        if (isSelected) {
          rows = rows.filter(function (r) {
            return unselectable.indexOf(r[keyField]) === -1 || selected && selected.indexOf(r[keyField]) !== -1;
          });
        } else {
          rows = rows.filter(function (r) {
            return unselectable.indexOf(r[keyField]) === -1;
          });
        }
      }

      if (onSelectAll) {
        result = this.props.selectRow.onSelectAll(isSelected, rows);
      }

      if (typeof result == 'undefined' || result !== false) {
        if (isSelected) {
          if (Array.isArray(result)) {
            selectedRowKeys = result;
          } else {
            var currentRowKeys = rows.map(function (r) {
              return r[keyField];
            });
            // onlyUnselectVisible default is false, #1276
            if (onlyUnselectVisible) {
              selectedRowKeys = selectedRowKeys.concat(currentRowKeys);
            } else {
              selectedRowKeys = currentRowKeys;
            }
          }
        } else {
          if (unselectable && selected) {
            selectedRowKeys = selected.filter(function (r) {
              return unselectable.indexOf(r) > -1;
            });
          } else if (onlyUnselectVisible) {
            var _currentRowKeys = rows.map(function (r) {
              return r[keyField];
            });
            selectedRowKeys = selectedRowKeys.filter(function (k) {
              return _currentRowKeys.indexOf(k) === -1;
            });
          }
        }

        this.store.setSelectedRowKey(selectedRowKeys);
        this.setState(function () {
          return { selectedRowKeys: selectedRowKeys, reset: false };
        });
      }
    }
  }, {
    key: '__handleShowOnlySelected__REACT_HOT_LOADER__',
    value: function __handleShowOnlySelected__REACT_HOT_LOADER__() {
      this.store.ignoreNonSelected();
      var pageStartIndex = this.props.options.pageStartIndex;

      var result = void 0;
      if (this.props.pagination) {
        result = this.store.page(_util2.default.getNormalizedPage(pageStartIndex), this.state.sizePerPage).get();
      } else {
        result = this.store.get();
      }
      this.setState(function () {
        return {
          data: result,
          reset: false,
          currPage: _util2.default.getFirstPage(pageStartIndex)
        };
      });
    }
  }, {
    key: '__handleSelectRow__REACT_HOT_LOADER__',
    value: function __handleSelectRow__REACT_HOT_LOADER__(row, isSelected, e, rowIndex) {
      var result = true;
      var currSelected = this.store.getSelectedRowKeys();
      var rowKey = row[this.store.getKeyField()];
      var selectRow = this.props.selectRow;

      if (selectRow.onSelect) {
        result = selectRow.onSelect(row, isSelected, e, rowIndex);
      }

      if (typeof result === 'undefined' || result !== false) {
        if (selectRow.mode === _Const2.default.ROW_SELECT_SINGLE) {
          currSelected = isSelected ? [rowKey] : [];
        } else {
          if (isSelected) {
            currSelected.push(rowKey);
          } else {
            currSelected = currSelected.filter(function (key) {
              return rowKey !== key;
            });
          }
        }

        this.store.setSelectedRowKey(currSelected);
        this.setState(function () {
          return {
            selectedRowKeys: currSelected,
            reset: false
          };
        });
      }
    }
  }, {
    key: '__handleEditCell__REACT_HOT_LOADER__',
    value: function __handleEditCell__REACT_HOT_LOADER__(newVal, rowIndex, colIndex) {
      var _this8 = this;

      var beforeSaveCell = this.props.cellEdit.beforeSaveCell;

      var columns = this.getColumnsDescription(this.props);
      var fieldName = columns[colIndex].name;

      var invalid = function invalid() {
        _this8.setState(function () {
          return {
            data: _this8.store.get(),
            reset: false
          };
        });
        return;
      };

      if (beforeSaveCell) {
        var beforeSaveCellCB = function beforeSaveCellCB(result) {
          _this8.body.cancelEditCell();
          if (result || result === undefined) {
            _this8.editCell(newVal, rowIndex, colIndex);
          } else {
            invalid();
          }
        };
        var props = { rowIndex: rowIndex, colIndex: colIndex };
        var isValid = beforeSaveCell(this.state.data[rowIndex], fieldName, newVal, beforeSaveCellCB, props);
        if (isValid === false && typeof isValid !== 'undefined') {
          return invalid();
        } else if (isValid === _Const2.default.AWAIT_BEFORE_CELL_EDIT) {
          /* eslint consistent-return: 0 */
          return isValid;
        }
      }
      this.editCell(newVal, rowIndex, colIndex);
    }
  }, {
    key: 'editCell',
    value: function editCell(newVal, rowIndex, colIndex) {
      var onCellEdit = this.props.options.onCellEdit;
      var afterSaveCell = this.props.cellEdit.afterSaveCell;

      var columns = this.getColumnsDescription(this.props);
      var fieldName = columns[colIndex].name;
      var props = { rowIndex: rowIndex, colIndex: colIndex };
      if (onCellEdit) {
        newVal = onCellEdit(this.state.data[rowIndex], fieldName, newVal);
      }

      if (this.allowRemote(_Const2.default.REMOTE_CELL_EDIT)) {
        if (afterSaveCell) {
          afterSaveCell(this.state.data[rowIndex], fieldName, newVal, props);
        }
        return;
      }

      var result = this.store.edit(newVal, rowIndex, fieldName).get();
      this.setState(function () {
        return {
          data: result,
          reset: false
        };
      });

      if (afterSaveCell) {
        afterSaveCell(this.state.data[rowIndex], fieldName, newVal, props);
      }
    }
  }, {
    key: 'handleAddRowAtBegin',
    value: function handleAddRowAtBegin(newObj) {
      try {
        this.store.addAtBegin(newObj);
      } catch (e) {
        return e;
      }
      this._handleAfterAddingRow(newObj, true);
    }
  }, {
    key: '__handleAddRow__REACT_HOT_LOADER__',
    value: function __handleAddRow__REACT_HOT_LOADER__(newObj) {
      var _this9 = this;

      var isAsync = false;
      var onAddRow = this.props.options.onAddRow;


      var afterHandleAddRow = function afterHandleAddRow(errMsg) {
        if (isAsync) {
          _this9.toolbar.afterHandleSaveBtnClick(errMsg);
        } else {
          return errMsg;
        }
      };

      var afterAddRowCB = function afterAddRowCB(errMsg) {
        if (typeof errMsg !== 'undefined' && errMsg !== '') return afterHandleAddRow(errMsg);
        if (_this9.allowRemote(_Const2.default.REMOTE_INSERT_ROW)) {
          if (_this9.props.options.afterInsertRow) {
            _this9.props.options.afterInsertRow(newObj);
          }
          return afterHandleAddRow();
        }

        try {
          _this9.store.add(newObj);
        } catch (e) {
          return afterHandleAddRow(e.message);
        }
        _this9._handleAfterAddingRow(newObj, false);
        return afterHandleAddRow();
      };

      if (onAddRow) {
        var colInfos = this.store.getColInfos();
        var errMsg = onAddRow(newObj, colInfos, afterAddRowCB);

        if (errMsg !== '' && errMsg !== false) {
          return errMsg;
        } else if (typeof errMsg === 'undefined') {
          return afterAddRowCB();
        } else {
          isAsync = true;
          return !isAsync;
        }
      } else {
        return afterAddRowCB();
      }
    }
  }, {
    key: 'getSizePerPage',
    value: function getSizePerPage() {
      return this.state.sizePerPage;
    }
  }, {
    key: 'getCurrentPage',
    value: function getCurrentPage() {
      return this.state.currPage;
    }
  }, {
    key: 'getTableDataIgnorePaging',
    value: function getTableDataIgnorePaging() {
      return this.store.getCurrentDisplayData();
    }
  }, {
    key: '__getPageByRowKey__REACT_HOT_LOADER__',
    value: function __getPageByRowKey__REACT_HOT_LOADER__(rowKey) {
      var sizePerPage = this.state.sizePerPage;

      var currentData = this.store.getCurrentDisplayData();
      var keyField = this.store.getKeyField();
      var result = currentData.findIndex(function (x) {
        return x[keyField] === rowKey;
      });
      if (result > -1) {
        return parseInt(result / sizePerPage, 10) + 1;
      } else {
        return result;
      }
    }
  }, {
    key: '__handleDropRow__REACT_HOT_LOADER__',
    value: function __handleDropRow__REACT_HOT_LOADER__(rowKeys) {
      var _this10 = this;

      var dropRowKeys = rowKeys ? rowKeys : this.store.getSelectedRowKeys();
      // add confirm before the delete action if that option is set.
      if (dropRowKeys && dropRowKeys.length > 0) {
        if (this.props.options.handleConfirmDeleteRow) {
          this.props.options.handleConfirmDeleteRow(function () {
            _this10.deleteRow(dropRowKeys);
          }, dropRowKeys);
        } else if (confirm('Are you sure you want to delete?')) {
          this.deleteRow(dropRowKeys);
        }
      }
    }
  }, {
    key: 'deleteRow',
    value: function deleteRow(dropRowKeys) {
      var _this11 = this;

      var dropRow = this.store.getRowByKey(dropRowKeys);
      var _props$options2 = this.props.options,
          onDeleteRow = _props$options2.onDeleteRow,
          afterDeleteRow = _props$options2.afterDeleteRow,
          pageStartIndex = _props$options2.pageStartIndex;


      if (onDeleteRow) {
        onDeleteRow(dropRowKeys, dropRow);
      }

      this.store.setSelectedRowKey([]); // clear selected row key

      if (this.allowRemote(_Const2.default.REMOTE_DROP_ROW)) {
        if (afterDeleteRow) {
          afterDeleteRow(dropRowKeys, dropRow);
        }
        return;
      }

      this.store.remove(dropRowKeys); // remove selected Row
      var result = void 0;
      if (this.props.pagination) {
        // debugger;
        var sizePerPage = this.state.sizePerPage;

        var currLastPage = Math.ceil(this.store.getDataNum() / sizePerPage);
        var currPage = this.state.currPage;

        if (currPage > currLastPage) currPage = currLastPage;
        // console.log(Util.getNormalizedPage(currPage));
        result = this.store.page(_util2.default.getNormalizedPage(pageStartIndex, currPage), sizePerPage).get();
        this.setState(function () {
          return {
            data: result,
            selectedRowKeys: _this11.store.getSelectedRowKeys(),
            currPage: currPage,
            reset: false
          };
        });
      } else {
        result = this.store.get();
        this.setState(function () {
          return {
            data: result,
            reset: false,
            selectedRowKeys: _this11.store.getSelectedRowKeys()
          };
        });
      }
      if (afterDeleteRow) {
        afterDeleteRow(dropRowKeys, dropRow);
      }
    }
  }, {
    key: '__handleFilterData__REACT_HOT_LOADER__',
    value: function __handleFilterData__REACT_HOT_LOADER__(filterObj) {
      var _props4 = this.props,
          filter = _props4.autoCollapse.filter,
          options = _props4.options;
      var onFilterChange = options.onFilterChange,
          pageStartIndex = options.pageStartIndex;

      if (onFilterChange) {
        var colInfos = this.store.getColInfos();
        onFilterChange(filterObj, colInfos);
      }

      this.setState(function () {
        var newState = {
          currPage: _util2.default.getFirstPage(pageStartIndex),
          reset: false
        };
        if (filter) newState.expanding = [];
        return newState;
      });

      if (this.allowRemote(_Const2.default.REMOTE_FILTER)) {
        if (this.props.options.afterColumnFilter) {
          this.props.options.afterColumnFilter(filterObj, this.store.getDataIgnoringPagination());
        }
        return;
      }

      this.store.filter(filterObj);

      var sortList = this.store.getSortInfo();

      if (sortList.length > 0) {
        this.store.sort();
      }

      var result = void 0;

      if (this.props.pagination) {
        var sizePerPage = this.state.sizePerPage;

        result = this.store.page(_util2.default.getNormalizedPage(pageStartIndex), sizePerPage).get();
      } else {
        result = this.store.get();
      }
      if (this.props.options.afterColumnFilter) {
        this.props.options.afterColumnFilter(filterObj, this.store.getDataIgnoringPagination());
      }
      this.setState(function () {
        return {
          data: result,
          reset: false
        };
      });
    }
  }, {
    key: '__handleExportCSV__REACT_HOT_LOADER__',
    value: function __handleExportCSV__REACT_HOT_LOADER__() {
      var result = {};

      var csvFileName = this.props.csvFileName;
      var _props$options3 = this.props.options,
          onExportToCSV = _props$options3.onExportToCSV,
          exportCSVSeparator = _props$options3.exportCSVSeparator,
          noAutoBOM = _props$options3.noAutoBOM,
          excludeCSVHeader = _props$options3.excludeCSVHeader;

      if (onExportToCSV) {
        result = onExportToCSV();
      } else {
        result = this.store.getDataIgnoringPagination();
      }
      var separator = exportCSVSeparator || _Const2.default.DEFAULT_CSV_SEPARATOR;
      var keys = [];
      this.props.children.filter(function (_) {
        return _ != null;
      }).map(function (column) {
        if (column.props.export === true || typeof column.props.export === 'undefined' && column.props.hidden === false) {
          keys.push({
            field: column.props.dataField,
            type: column.props.csvFieldType,
            format: column.props.csvFormat,
            extraData: column.props.csvFormatExtraData,
            header: column.props.csvHeader || column.props.dataField,
            row: Number(column.props.row) || 0,
            rowSpan: Number(column.props.rowSpan) || 1,
            colSpan: Number(column.props.colSpan) || 1
          });
        }
      });

      if (_util2.default.isFunction(csvFileName)) {
        csvFileName = csvFileName();
      }

      (0, _csv_export_util2.default)(result, keys, csvFileName, separator, noAutoBOM, excludeCSVHeader);
    }
  }, {
    key: '__handleSearch__REACT_HOT_LOADER__',
    value: function __handleSearch__REACT_HOT_LOADER__(searchText) {
      // Set search field if this function being called outside
      // but it's not necessary if calling fron inside.
      if (this.toolbar) {
        this.toolbar.setSearchInput(searchText);
      }
      var search = this.props.autoCollapse.search;
      var _props$options4 = this.props.options,
          onSearchChange = _props$options4.onSearchChange,
          pageStartIndex = _props$options4.pageStartIndex;

      if (onSearchChange) {
        var colInfos = this.store.getColInfos();
        onSearchChange(searchText, colInfos, this.props.multiColumnSearch);
      }

      this.setState(function () {
        var newState = {
          currPage: _util2.default.getFirstPage(pageStartIndex),
          reset: false
        };
        if (search) newState.expanding = [];
        return newState;
      });

      if (this.allowRemote(_Const2.default.REMOTE_SEARCH)) {
        if (this.props.options.afterSearch) {
          this.props.options.afterSearch(searchText, this.store.getDataIgnoringPagination());
        }
        return;
      }

      this.store.search(searchText);

      var sortList = this.store.getSortInfo();

      if (sortList.length > 0) {
        this.store.sort();
      }

      var result = void 0;
      if (this.props.pagination) {
        var sizePerPage = this.state.sizePerPage;

        result = this.store.page(_util2.default.getNormalizedPage(pageStartIndex), sizePerPage).get();
      } else {
        result = this.store.get();
      }
      if (this.props.options.afterSearch) {
        this.props.options.afterSearch(searchText, this.store.getDataIgnoringPagination());
      }
      this.setState(function () {
        return {
          data: result,
          reset: false
        };
      });
    }
  }, {
    key: 'renderPagination',
    value: function renderPagination() {
      var _this12 = this;

      if (this.props.pagination) {
        var dataSize = void 0;
        if (this.allowRemote(_Const2.default.REMOTE_PAGE)) {
          dataSize = this.props.fetchInfo.dataTotalSize;
        } else {
          dataSize = this.store.getDataNum();
        }
        var options = this.props.options;

        var withFirstAndLast = options.withFirstAndLast === undefined ? true : options.withFirstAndLast;
        if (Math.ceil(dataSize / this.state.sizePerPage) <= 1 && this.props.ignoreSinglePage) return null;
        return _react2.default.createElement(
          'div',
          { className: 'react-bs-table-pagination' },
          _react2.default.createElement(_PaginationList2.default, {
            ref: function ref(node) {
              return _this12.pagination = node;
            },
            version: this.props.version,
            withFirstAndLast: withFirstAndLast,
            alwaysShowAllBtns: options.alwaysShowAllBtns,
            currPage: this.state.currPage,
            changePage: this.handlePaginationData,
            sizePerPage: this.state.sizePerPage,
            sizePerPageList: options.sizePerPageList || _Const2.default.SIZE_PER_PAGE_LIST,
            pageStartIndex: options.pageStartIndex,
            paginationShowsTotal: options.paginationShowsTotal,
            paginationSize: options.paginationSize || _Const2.default.PAGINATION_SIZE,
            dataSize: dataSize,
            onSizePerPageList: options.onSizePerPageList,
            prePage: options.prePage || _Const2.default.PRE_PAGE,
            nextPage: options.nextPage || _Const2.default.NEXT_PAGE,
            firstPage: options.firstPage || _Const2.default.FIRST_PAGE,
            lastPage: options.lastPage || _Const2.default.LAST_PAGE,
            prePageTitle: options.prePageTitle || _Const2.default.PRE_PAGE_TITLE,
            nextPageTitle: options.nextPageTitle || _Const2.default.NEXT_PAGE_TITLE,
            firstPageTitle: options.firstPageTitle || _Const2.default.FIRST_PAGE_TITLE,
            lastPageTitle: options.lastPageTitle || _Const2.default.LAST_PAGE_TITLE,
            hideSizePerPage: options.hideSizePerPage,
            sizePerPageDropDown: options.sizePerPageDropDown,
            hidePageListOnlyOnePage: options.hidePageListOnlyOnePage,
            paginationPanel: options.paginationPanel,
            keepSizePerPageState: options.keepSizePerPageState,
            open: false })
        );
      }
      return null;
    }
  }, {
    key: 'renderToolBar',
    value: function renderToolBar() {
      var _this13 = this;

      var _props5 = this.props,
          exportCSV = _props5.exportCSV,
          selectRow = _props5.selectRow,
          insertRow = _props5.insertRow,
          deleteRow = _props5.deleteRow,
          search = _props5.search,
          children = _props5.children,
          keyField = _props5.keyField;

      var enableShowOnlySelected = selectRow && selectRow.showOnlySelected;
      var print = typeof this.props.options.printToolBar === 'undefined' ? true : this.props.options.printToolBar;
      if (enableShowOnlySelected || insertRow || deleteRow || search || exportCSV || this.props.options.searchPanel || this.props.options.btnGroup || this.props.options.toolBar) {
        var columns = void 0;
        if (Array.isArray(children)) {
          columns = children.filter(function (_) {
            return _ != null;
          }).map(function (column, r) {
            if (!column) return;
            var props = column.props;

            var isKey = props.isKey || keyField === props.dataField;
            return {
              isKey: isKey,
              name: props.headerText || props.children,
              field: props.dataField,
              hiddenOnInsert: props.hiddenOnInsert,
              keyValidator: props.keyValidator,
              customInsertEditor: props.customInsertEditor,
              // when you want same auto generate value and not allow edit, example ID field
              autoValue: props.autoValue || false,
              // for create editor, no params for column.editable() indicate that editor for new row
              editable: props.editable && _util2.default.isFunction(props.editable === 'function') ? props.editable() : props.editable,
              format: props.dataFormat ? function (value) {
                return props.dataFormat(value, null, props.formatExtraData, r).replace(/<.*?>/g, '');
              } : false
            };
          });
        } else {
          columns = [{
            name: children.props.headerText || children.props.children,
            field: children.props.dataField,
            editable: children.props.editable,
            customInsertEditor: children.props.customInsertEditor,
            hiddenOnInsert: children.props.hiddenOnInsert,
            keyValidator: children.props.keyValidator
          }];
        }
        return _react2.default.createElement(
          'div',
          { className: 'react-bs-table-tool-bar ' + (print ? '' : 'hidden-print') },
          _react2.default.createElement(_ToolBar2.default, {
            ref: function ref(node) {
              return _this13.toolbar = node;
            },
            version: this.props.version,
            defaultSearch: this.props.options.defaultSearch,
            clearSearch: this.props.options.clearSearch,
            searchPosition: this.props.options.searchPosition,
            searchDelayTime: this.props.options.searchDelayTime,
            enableInsert: insertRow,
            enableDelete: deleteRow,
            enableSearch: search,
            enableExportCSV: exportCSV,
            enableShowOnlySelected: enableShowOnlySelected,
            columns: columns,
            searchPlaceholder: this.props.searchPlaceholder,
            exportCSVText: this.props.options.exportCSVText,
            insertText: this.props.options.insertText,
            deleteText: this.props.options.deleteText,
            saveText: this.props.options.saveText,
            closeText: this.props.options.closeText,
            ignoreEditable: this.props.options.ignoreEditable,
            onAddRow: this.handleAddRow,
            onDropRow: this.handleDropRow,
            onSearch: this.handleSearch,
            onExportCSV: this.handleExportCSV,
            onShowOnlySelected: this.handleShowOnlySelected,
            insertModalHeader: this.props.options.insertModalHeader,
            insertModalFooter: this.props.options.insertModalFooter,
            insertModalBody: this.props.options.insertModalBody,
            insertModal: this.props.options.insertModal,
            insertBtn: this.props.options.insertBtn,
            deleteBtn: this.props.options.deleteBtn,
            showSelectedOnlyBtn: this.props.options.showSelectedOnlyBtn,
            exportCSVBtn: this.props.options.exportCSVBtn,
            clearSearchBtn: this.props.options.clearSearchBtn,
            searchField: this.props.options.searchField,
            searchPanel: this.props.options.searchPanel,
            btnGroup: this.props.options.btnGroup,
            toolBar: this.props.options.toolBar,
            reset: this.state.reset,
            isValidKey: this.store.isValidKey,
            insertFailIndicator: this.props.options.insertFailIndicator || _Const2.default.INSERT_FAIL_INDICATOR })
        );
      } else {
        return null;
      }
    }
  }, {
    key: 'renderTableFilter',
    value: function renderTableFilter(columns) {
      if (this.props.columnFilter) {
        return _react2.default.createElement(_TableFilter2.default, { columns: columns,
          rowSelectType: this.props.selectRow.mode,
          onFilter: this.handleFilterData });
      } else {
        return null;
      }
    }
  }, {
    key: 'renderTableFooter',
    value: function renderTableFooter(footerData, footerFormatterReturnData, columns, colGroups) {
      var _this14 = this;

      if (this.props.footer) {
        var hideSelectColumn = true;
        var mode = this.props.selectRow.mode;

        var isSelectRowDefined = _util2.default.isSelectRowDefined(mode);
        if (isSelectRowDefined) {
          hideSelectColumn = this.props.selectRow.hideSelectColumn;
        }
        return _react2.default.createElement(
          _TableFooter2.default,
          {
            ref: function ref(node) {
              return _this14.footer = node;
            },
            columns: columns,
            colGroups: colGroups,
            footerFormatterReturnData: footerFormatterReturnData,
            tableFooterClass: this.props.tableFooterClass,
            style: this.props.headerStyle,
            hideSelectColumn: hideSelectColumn,
            expandColumnVisible: this.props.expandColumnOptions.expandColumnVisible,
            bordered: this.props.bordered,
            condensed: this.props.condensed,
            isFiltered: this.filter ? true : false,
            showStickyColumn: this.props.showStickyColumn },
          footerData
        );
      }
      return null;
    }
  }, {
    key: '___scrollTop__REACT_HOT_LOADER__',
    value: function ___scrollTop__REACT_HOT_LOADER__() {
      var scrollTop = this.props.scrollTop;

      if (scrollTop === _Const2.default.SCROLL_TOP) {
        this.body.container.scrollTop = 0;
      } else if (scrollTop === _Const2.default.SCROLL_BOTTOM) {
        this.body.container.scrollTop = this.body.container.scrollHeight;
      } else if (typeof scrollTop === 'number' && !isNaN(scrollTop)) {
        this.body.container.scrollTop = scrollTop;
      }
    }
  }, {
    key: '___scrollHeader__REACT_HOT_LOADER__',
    value: function ___scrollHeader__REACT_HOT_LOADER__(e) {
      this.header.container.scrollLeft = e.currentTarget.scrollLeft;
    }
  }, {
    key: '___scrollFooter__REACT_HOT_LOADER__',
    value: function ___scrollFooter__REACT_HOT_LOADER__(e) {
      if (this.props.footer) {
        this.footer.container.scrollLeft = e.currentTarget.scrollLeft;
      }
    }
  }, {
    key: '_adjustTable',
    value: function _adjustTable() {
      this._adjustHeight();
      if (!this.props.printable) {
        this._adjustHeaderWidth();
      }
    }
  }, {
    key: '_adjustHeaderWidth',
    value: function _adjustHeaderWidth() {
      var header = this.header.getHeaderColGrouop();
      var tbody = this.body.tbody;
      var bodyHeader = this.body.getHeaderColGrouop();
      var firstRow = tbody.childNodes[0];
      var isScroll = tbody.parentNode.getBoundingClientRect().height > tbody.parentNode.parentNode.getBoundingClientRect().height;

      var scrollBarWidth = isScroll ? _util2.default.getScrollBarWidth() : 0;
      if (firstRow && this.store.getDataNum()) {
        if (isScroll || this.isVerticalScroll !== isScroll) {
          var cells = firstRow.childNodes;
          for (var i = 0; i < cells.length; i++) {
            var cell = cells[i];
            var computedStyle = window.getComputedStyle(cell);
            var width = parseFloat(computedStyle.width.replace('px', ''));
            if (this.isIE) {
              var paddingLeftWidth = parseFloat(computedStyle.paddingLeft.replace('px', ''));
              var paddingRightWidth = parseFloat(computedStyle.paddingRight.replace('px', ''));
              var borderRightWidth = parseFloat(computedStyle.borderRightWidth.replace('px', ''));
              var borderLeftWidth = parseFloat(computedStyle.borderLeftWidth.replace('px', ''));
              width = width + paddingLeftWidth + paddingRightWidth + borderRightWidth + borderLeftWidth;
            }
            var lastPadding = cells.length - 1 === i ? scrollBarWidth : 0;
            if (width <= 0) {
              width = 120;
              cell.width = width + lastPadding + 'px';
            }
            var result = width + lastPadding + 'px';
            header[i].style.width = result;
            header[i].style.minWidth = result;
            if (cells.length - 1 === i) {
              bodyHeader[i].style.width = width + 'px';
              bodyHeader[i].style.minWidth = width + 'px';
            } else {
              bodyHeader[i].style.width = result;
              bodyHeader[i].style.minWidth = result;
            }
          }
        }
      } else {
        for (var _i in bodyHeader) {
          if (bodyHeader.hasOwnProperty(_i)) {
            var child = bodyHeader[_i];
            if (child.style) {
              if (child.style.width) {
                header[_i].style.width = child.style.width;
              }
              if (child.style.minWidth) {
                header[_i].style.minWidth = child.style.minWidth;
              }
            }
          }
        }
      }
      this.isVerticalScroll = isScroll;
    }
  }, {
    key: '_adjustHeight',
    value: function _adjustHeight() {
      var height = this.props.height;
      var maxHeight = this.props.maxHeight;

      if (typeof height === 'number' && !isNaN(height) || height.indexOf('%') === -1) {
        this.body.container.style.height = parseFloat(height, 10) - this.header.container.offsetHeight + 'px';
      }
      if (maxHeight) {
        maxHeight = typeof maxHeight === 'number' ? maxHeight : parseInt(maxHeight.replace('px', ''), 10);

        this.body.container.style.maxHeight = maxHeight - this.header.container.offsetHeight + 'px';
      }
    }
  }, {
    key: '_handleAfterAddingRow',
    value: function _handleAfterAddingRow(newObj, atTheBeginning) {
      var result = void 0;
      if (this.props.pagination) {
        // if pagination is enabled and inserting row at the end,
        // change page to the last page
        // otherwise, change it to the first page
        var sizePerPage = this.state.sizePerPage;


        if (atTheBeginning) {
          var pageStartIndex = this.props.options.pageStartIndex;

          result = this.store.page(_util2.default.getNormalizedPage(pageStartIndex), sizePerPage).get();
          this.setState(function () {
            return {
              data: result,
              currPage: _util2.default.getFirstPage(pageStartIndex),
              reset: false
            };
          });
        } else {
          var currLastPage = Math.ceil(this.store.getDataNum() / sizePerPage);
          result = this.store.page(currLastPage, sizePerPage).get();
          this.setState(function () {
            return {
              data: result,
              currPage: currLastPage,
              reset: false
            };
          });
        }
      } else {
        result = this.store.get();
        this.setState(function () {
          return {
            data: result,
            reset: false
          };
        });
      }

      if (this.props.options.afterInsertRow) {
        this.props.options.afterInsertRow(newObj);
      }
    }
  }]);

  return BootstrapTable;
}(_react.Component);

BootstrapTable.propTypes = {
  keyField: _propTypes2.default.string,
  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  maxHeight: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  data: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
  version: _propTypes2.default.string, // bootstrap version
  remote: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]), // remote data, default is false
  replace: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]),
  scrollTop: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  striped: _propTypes2.default.bool,
  bordered: _propTypes2.default.bool,
  hover: _propTypes2.default.bool,
  condensed: _propTypes2.default.bool,
  pagination: _propTypes2.default.bool,
  printable: _propTypes2.default.bool,
  withoutTabIndex: _propTypes2.default.bool,
  keyBoardNav: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
  searchPlaceholder: _propTypes2.default.string,
  selectRow: _propTypes2.default.shape({
    mode: _propTypes2.default.oneOf([_Const2.default.ROW_SELECT_NONE, _Const2.default.ROW_SELECT_SINGLE, _Const2.default.ROW_SELECT_MULTI]),
    customComponent: _propTypes2.default.func,
    bgColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
    selected: _propTypes2.default.array,
    onSelect: _propTypes2.default.func,
    onSelectAll: _propTypes2.default.func,
    clickToSelect: _propTypes2.default.bool,
    hideSelectColumn: _propTypes2.default.bool,
    clickToSelectAndEditCell: _propTypes2.default.bool,
    clickToExpand: _propTypes2.default.bool,
    showOnlySelected: _propTypes2.default.bool,
    unselectable: _propTypes2.default.array,
    columnWidth: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    onlyUnselectVisible: _propTypes2.default.bool
  }),
  cellEdit: _propTypes2.default.shape({
    mode: _propTypes2.default.string,
    blurToSave: _propTypes2.default.bool,
    blurToEscape: _propTypes2.default.bool,
    beforeSaveCell: _propTypes2.default.func,
    afterSaveCell: _propTypes2.default.func,
    nonEditableRows: _propTypes2.default.func
  }),
  insertRow: _propTypes2.default.bool,
  deleteRow: _propTypes2.default.bool,
  search: _propTypes2.default.bool,
  multiColumnSearch: _propTypes2.default.bool,
  strictSearch: _propTypes2.default.bool,
  columnFilter: _propTypes2.default.bool,
  trClassName: _propTypes2.default.any,
  trStyle: _propTypes2.default.any,
  tableStyle: _propTypes2.default.object,
  containerStyle: _propTypes2.default.object,
  headerStyle: _propTypes2.default.object,
  bodyStyle: _propTypes2.default.object,
  containerClass: _propTypes2.default.string,
  tableContainerClass: _propTypes2.default.string,
  headerContainerClass: _propTypes2.default.string,
  bodyContainerClass: _propTypes2.default.string,
  tableHeaderClass: _propTypes2.default.string,
  tableBodyClass: _propTypes2.default.string,
  tableFooterClass: _propTypes2.default.string,
  options: _propTypes2.default.shape({
    clearSearch: _propTypes2.default.bool,
    sortName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),
    sortOrder: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),
    defaultSortName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),
    defaultSortOrder: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),
    sortIndicator: _propTypes2.default.bool,
    afterTableComplete: _propTypes2.default.func,
    afterDeleteRow: _propTypes2.default.func,
    afterInsertRow: _propTypes2.default.func,
    afterSearch: _propTypes2.default.func,
    afterColumnFilter: _propTypes2.default.func,
    onRowClick: _propTypes2.default.func,
    onRowDoubleClick: _propTypes2.default.func,
    page: _propTypes2.default.number,
    pageStartIndex: _propTypes2.default.number,
    paginationShowsTotal: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]),
    sizePerPageList: _propTypes2.default.array,
    sizePerPage: _propTypes2.default.number,
    paginationSize: _propTypes2.default.number,
    paginationPosition: _propTypes2.default.oneOf([_Const2.default.PAGINATION_POS_TOP, _Const2.default.PAGINATION_POS_BOTTOM, _Const2.default.PAGINATION_POS_BOTH]),
    toolbarPosition: _propTypes2.default.oneOf([_Const2.default.TOOLBAR_POS_TOP, _Const2.default.TOOLBAR_POS_BOTTOM, _Const2.default.TOOLBAR_POS_BOTH]),
    hideSizePerPage: _propTypes2.default.bool,
    hidePageListOnlyOnePage: _propTypes2.default.bool,
    alwaysShowAllBtns: _propTypes2.default.bool,
    withFirstAndLast: _propTypes2.default.bool,
    keepSizePerPageState: _propTypes2.default.bool,
    onSortChange: _propTypes2.default.func,
    onPageChange: _propTypes2.default.func,
    onSizePerPageList: _propTypes2.default.func,
    onFilterChange: _propTypes2.default.func,
    onSearchChange: _propTypes2.default.func,
    onAddRow: _propTypes2.default.func,
    onExportToCSV: _propTypes2.default.func,
    onCellEdit: _propTypes2.default.func,
    noDataText: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
    withoutNoDataText: _propTypes2.default.bool,
    handleConfirmDeleteRow: _propTypes2.default.func,
    prePage: _propTypes2.default.any,
    nextPage: _propTypes2.default.any,
    firstPage: _propTypes2.default.any,
    lastPage: _propTypes2.default.any,
    prePageTitle: _propTypes2.default.string,
    nextPageTitle: _propTypes2.default.string,
    firstPageTitle: _propTypes2.default.string,
    lastPageTitle: _propTypes2.default.string,
    searchDelayTime: _propTypes2.default.number,
    excludeCSVHeader: _propTypes2.default.bool,
    exportCSVText: _propTypes2.default.string,
    exportCSVSeparator: _propTypes2.default.string,
    insertText: _propTypes2.default.string,
    deleteText: _propTypes2.default.string,
    saveText: _propTypes2.default.string,
    closeText: _propTypes2.default.string,
    ignoreEditable: _propTypes2.default.bool,
    defaultSearch: _propTypes2.default.string,
    insertModalHeader: _propTypes2.default.func,
    insertModalBody: _propTypes2.default.func,
    insertModalFooter: _propTypes2.default.func,
    insertModal: _propTypes2.default.func,
    insertBtn: _propTypes2.default.func,
    deleteBtn: _propTypes2.default.func,
    showSelectedOnlyBtn: _propTypes2.default.func,
    exportCSVBtn: _propTypes2.default.func,
    clearSearchBtn: _propTypes2.default.func,
    searchField: _propTypes2.default.func,
    searchPanel: _propTypes2.default.func,
    btnGroup: _propTypes2.default.func,
    toolBar: _propTypes2.default.func,
    sizePerPageDropDown: _propTypes2.default.func,
    paginationPanel: _propTypes2.default.func,
    searchPosition: _propTypes2.default.string,
    expandRowBgColor: _propTypes2.default.string,
    expandBy: _propTypes2.default.string,
    expanding: _propTypes2.default.array,
    onExpand: _propTypes2.default.func,
    onlyOneExpanding: _propTypes2.default.bool,
    expandBodyClass: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
    expandParentClass: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
    beforeShowError: _propTypes2.default.func,
    printToolBar: _propTypes2.default.bool,
    insertFailIndicator: _propTypes2.default.string,
    noAutoBOM: _propTypes2.default.bool,
    expandAll: _propTypes2.default.bool,
    hideRowOnExpand: _propTypes2.default.bool
  }),
  fetchInfo: _propTypes2.default.shape({
    dataTotalSize: _propTypes2.default.number
  }),
  renderAlert: _propTypes2.default.bool,
  exportCSV: _propTypes2.default.bool,
  csvFileName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  ignoreSinglePage: _propTypes2.default.bool,
  expandableRow: _propTypes2.default.func,
  expandComponent: _propTypes2.default.func,
  autoCollapse: _propTypes2.default.shape({
    sort: _propTypes2.default.bool,
    filter: _propTypes2.default.bool,
    search: _propTypes2.default.bool
  }),
  expandColumnOptions: _propTypes2.default.shape({
    columnWidth: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    expandColumnVisible: _propTypes2.default.bool,
    expandColumnComponent: _propTypes2.default.func,
    expandedColumnHeaderComponent: _propTypes2.default.func,
    expandColumnBeforeSelectColumn: _propTypes2.default.bool
  }),
  footer: _propTypes2.default.bool
};
BootstrapTable.defaultProps = {
  version: '3',
  replace: false,
  scrollTop: undefined,
  expandComponent: undefined,
  expandableRow: undefined,
  expandColumnOptions: {
    expandColumnVisible: false,
    expandColumnComponent: undefined,
    expandedColumnHeaderComponent: undefined,
    expandColumnBeforeSelectColumn: true
  },
  height: '100%',
  maxHeight: undefined,
  striped: false,
  bordered: true,
  hover: false,
  condensed: false,
  pagination: false,
  printable: false,
  withoutTabIndex: false,
  keyBoardNav: false,
  searchPlaceholder: undefined,
  selectRow: {
    mode: _Const2.default.ROW_SELECT_NONE,
    bgColor: _Const2.default.ROW_SELECT_BG_COLOR,
    selected: [],
    onSelect: undefined,
    onSelectAll: undefined,
    clickToSelect: false,
    hideSelectColumn: false,
    clickToSelectAndEditCell: false,
    clickToExpand: false,
    showOnlySelected: false,
    unselectable: [],
    customComponent: undefined,
    onlyUnselectVisible: false
  },
  cellEdit: {
    mode: _Const2.default.CELL_EDIT_NONE,
    blurToSave: false,
    blurToEscape: false,
    beforeSaveCell: undefined,
    afterSaveCell: undefined,
    nonEditableRows: undefined
  },
  insertRow: false,
  deleteRow: false,
  search: false,
  multiColumnSearch: false,
  strictSearch: undefined,
  multiColumnSort: 1,
  columnFilter: false,
  trClassName: '',
  trStyle: undefined,
  tableStyle: undefined,
  containerStyle: undefined,
  headerStyle: undefined,
  bodyStyle: undefined,
  containerClass: null,
  tableContainerClass: null,
  headerContainerClass: null,
  bodyContainerClass: null,
  tableHeaderClass: null,
  tableBodyClass: null,
  tableFooterClass: null,
  options: {
    clearSearch: false,
    sortName: undefined,
    sortOrder: undefined,
    defaultSortName: undefined,
    defaultSortOrder: undefined,
    sortIndicator: true,
    afterTableComplete: undefined,
    afterDeleteRow: undefined,
    afterInsertRow: undefined,
    afterSearch: undefined,
    afterColumnFilter: undefined,
    onRowClick: undefined,
    onRowDoubleClick: undefined,
    onMouseLeave: undefined,
    onMouseEnter: undefined,
    onRowMouseOut: undefined,
    onRowMouseOver: undefined,
    page: undefined,
    paginationShowsTotal: false,
    sizePerPageList: _Const2.default.SIZE_PER_PAGE_LIST,
    sizePerPage: undefined,
    paginationSize: _Const2.default.PAGINATION_SIZE,
    paginationPosition: _Const2.default.PAGINATION_POS_BOTTOM,
    toolbarPosition: _Const2.default.TOOLBAR_POS_TOP,
    hideSizePerPage: false,
    hidePageListOnlyOnePage: false,
    alwaysShowAllBtns: false,
    withFirstAndLast: true,
    keepSizePerPageState: false,
    onSizePerPageList: undefined,
    noDataText: undefined,
    withoutNoDataText: false,
    handleConfirmDeleteRow: undefined,
    prePage: _Const2.default.PRE_PAGE,
    nextPage: _Const2.default.NEXT_PAGE,
    firstPage: _Const2.default.FIRST_PAGE,
    lastPage: _Const2.default.LAST_PAGE,
    prePageTitle: _Const2.default.PRE_PAGE_TITLE,
    nextPageTitle: _Const2.default.NEXT_PAGE_TITLE,
    firstPageTitle: _Const2.default.FIRST_PAGE_TITLE,
    lastPageTitle: _Const2.default.LAST_PAGE_TITLE,
    pageStartIndex: 1,
    searchDelayTime: undefined,
    excludeCSVHeader: false,
    exportCSVText: _Const2.default.EXPORT_CSV_TEXT,
    exportCSVSeparator: _Const2.default.DEFAULT_CSV_SEPARATOR,
    insertText: _Const2.default.INSERT_BTN_TEXT,
    deleteText: _Const2.default.DELETE_BTN_TEXT,
    saveText: _Const2.default.SAVE_BTN_TEXT,
    closeText: _Const2.default.CLOSE_BTN_TEXT,
    ignoreEditable: false,
    defaultSearch: '',
    insertModalHeader: undefined,
    insertModalBody: undefined,
    insertModalFooter: undefined,
    insertModal: undefined,
    insertBtn: undefined,
    deleteBtn: undefined,
    showSelectedOnlyBtn: undefined,
    exportCSVBtn: undefined,
    clearSearchBtn: undefined,
    searchField: undefined,
    searchPanel: undefined,
    btnGroup: undefined,
    toolBar: undefined,
    sizePerPageDropDown: undefined,
    paginationPanel: undefined,
    searchPosition: 'right',
    expandRowBgColor: undefined,
    expandBy: _Const2.default.EXPAND_BY_ROW,
    expanding: [],
    onExpand: undefined,
    onlyOneExpanding: false,
    expandBodyClass: null,
    expandParentClass: null,
    beforeShowError: undefined,
    printToolBar: true,
    insertFailIndicator: _Const2.default.INSERT_FAIL_INDICATOR,
    noAutoBOM: true,
    expandAll: false,
    hideRowOnExpand: false
  },
  fetchInfo: {
    dataTotalSize: 0
  },
  renderAlert: true,
  exportCSV: false,
  csvFileName: 'spreadsheet.csv',
  ignoreSinglePage: false,
  autoCollapse: {
    sort: _Const2.default.AUTO_COLLAPSE_WHEN_SORT,
    filter: _Const2.default.AUTO_COLLAPSE_WHEN_FILTER,
    search: _Const2.default.AUTO_COLLAPSE_WHEN_SEARCH
  },
  footer: false
};

var _default = BootstrapTable;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(BootstrapTable, 'BootstrapTable', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/BootstrapTable.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/BootstrapTable.js');
}();

;

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(224), __webpack_require__(1), __webpack_require__(128), __webpack_require__(127), __webpack_require__(558)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require('react'), require('./SAlertContent'), require('prop-types'), require('./s-alert-parts/s-alert-store'), require('./s-alert-parts/s-alert-tools'), require('./s-alert-parts/s-alert-data-prep'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.react, global.SAlertContent, global.propTypes, global.sAlertStore, global.sAlertTools, global.sAlertDataPrep);
        global.SAlert = mod.exports;
    }
})(this, function (exports, _react, _SAlertContent, _propTypes, _sAlertStore, _sAlertTools, _sAlertDataPrep) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _react2 = _interopRequireDefault(_react);

    var _SAlertContent2 = _interopRequireDefault(_SAlertContent);

    var _propTypes2 = _interopRequireDefault(_propTypes);

    var _sAlertStore2 = _interopRequireDefault(_sAlertStore);

    var _sAlertTools2 = _interopRequireDefault(_sAlertTools);

    var _sAlertDataPrep2 = _interopRequireDefault(_sAlertDataPrep);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    function _possibleConstructorReturn(self, call) {
        if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }

        return target;
    };

    var insertFunc = function insertFunc(msg, data, condition) {
        var id = _sAlertTools2.default.randomId();
        _sAlertStore2.default.dispatch({
            type: 'INSERT',
            data: _extends({}, data, {
                id: id,
                condition: condition,
                message: msg
            })
        });
        return id;
    };

    var SAlert = function (_React$Component) {
        _inherits(SAlert, _React$Component);

        function SAlert(props) {
            _classCallCheck(this, SAlert);

            var _this = _possibleConstructorReturn(this, (SAlert.__proto__ || Object.getPrototypeOf(SAlert)).call(this, props));

            _this.state = {
                dataRight: [],
                dataLeft: [],
                dataTop: [],
                dataBottom: []
            };
            return _this;
        }

        _createClass(SAlert, [{
            key: 'componentDidMount',
            value: function componentDidMount() {
                var _this2 = this;

                var storeStateLeft = void 0;
                var storeStateRight = void 0;
                var storeStateTop = void 0;
                var storeStateBottom = void 0;

                var addToStoreRight = function addToStoreRight() {
                    requestAnimationFrame(function () {
                        return requestAnimationFrame(function () {
                            var length = void 0;
                            storeStateRight = (0, _sAlertDataPrep2.default)('right') || [];
                            length = storeStateRight.length;
                            if (_this2.props.stack && _this2.props.stack.limit && length > _this2.props.stack.limit) {
                                var id = storeStateRight[0].id;
                                _sAlertStore2.default.dispatch({ type: 'REMOVE', data: { id: id } });
                                storeStateRight = (0, _sAlertDataPrep2.default)('right') || [];
                            }
                            _this2.setState({ dataRight: storeStateRight });
                        });
                    });
                };
                this.unsubStoreRight = _sAlertStore2.default.subscribe(addToStoreRight);

                var addToStoreLeft = function addToStoreLeft() {
                    requestAnimationFrame(function () {
                        return requestAnimationFrame(function () {
                            var length = void 0;
                            storeStateLeft = (0, _sAlertDataPrep2.default)('left') || [];
                            length = storeStateLeft.length;
                            if (_this2.props.stack && _this2.props.stack.limit && length > _this2.props.stack.limit) {
                                var id = storeStateLeft[0].id;
                                _sAlertStore2.default.dispatch({ type: 'REMOVE', data: { id: id } });
                                storeStateLeft = (0, _sAlertDataPrep2.default)('left') || [];
                            }
                            _this2.setState({ dataLeft: storeStateLeft });
                        });
                    });
                };
                this.unsubStoreLeft = _sAlertStore2.default.subscribe(addToStoreLeft);

                var addToStoreTop = function addToStoreTop() {
                    requestAnimationFrame(function () {
                        return requestAnimationFrame(function () {
                            var length = void 0;
                            storeStateTop = (0, _sAlertDataPrep2.default)('full-top') || [];
                            length = storeStateTop.length;
                            if (_this2.props.stack && _this2.props.stack.limit && length > _this2.props.stack.limit) {
                                var id = storeStateTop[0].id;
                                _sAlertStore2.default.dispatch({ type: 'REMOVE', data: { id: id } });
                                storeStateTop = (0, _sAlertDataPrep2.default)('full-top') || [];
                            }
                            _this2.setState({ dataTop: storeStateTop });
                        });
                    });
                };
                this.unsubStoreTop = _sAlertStore2.default.subscribe(addToStoreTop);

                var addToStoreBottom = function addToStoreBottom() {
                    requestAnimationFrame(function () {
                        return requestAnimationFrame(function () {
                            var length = void 0;
                            storeStateBottom = (0, _sAlertDataPrep2.default)('full-bottom') || [];
                            length = storeStateBottom.length;
                            if (_this2.props.stack && _this2.props.stack.limit && length > _this2.props.stack.limit) {
                                var id = storeStateBottom[0].id;
                                _sAlertStore2.default.dispatch({ type: 'REMOVE', data: { id: id } });
                                storeStateBottom = (0, _sAlertDataPrep2.default)('full-bottom') || [];
                            }
                            _this2.setState({ dataBottom: storeStateBottom });
                        });
                    });
                };
                this.unsubStoreBottom = _sAlertStore2.default.subscribe(addToStoreBottom);

                // set up global config from global SAlert props
                // only stuff needed for getAlertData
                var globalConfig = {
                    contentTemplate: this.props.contentTemplate,
                    offset: this.props.offset,
                    message: this.props.message,
                    stack: this.props.stack,
                    html: this.props.html,
                    customFields: this.props.customFields,
                    position: this.props.position || 'top-right'
                };
                _sAlertTools2.default.setGlobalConfig(globalConfig);
            }
        }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unsubStoreTop();
                this.unsubStoreBottom();
                this.unsubStoreLeft();
                this.unsubStoreRight();
            }
        }, {
            key: 'render',
            value: function render() {
                var _this3 = this;

                var mapFunc = function mapFunc(alert, index) {
                    var customKey = 'alert-key-' + alert.id + '-' + alert.position;
                    var id = alert.id;
                    var condition = _sAlertTools2.default.returnFirstDefined(alert.condition, 'info');
                    var message = _sAlertTools2.default.returnFirstDefined(alert.message, _this3.props.message, '');
                    var position = _sAlertTools2.default.returnFirstDefined(alert.position, _this3.props.position, 'top-right');
                    var offset = _sAlertTools2.default.returnFirstDefined(alert.offset, _this3.props.offset, 0);
                    var effect = _sAlertTools2.default.returnFirstDefined(alert.effect, _this3.props.effect);
                    var boxPosition = alert.boxPosition;
                    var beep = _sAlertTools2.default.returnFirstDefined(alert.beep, _this3.props.beep, false);
                    var timeout = _sAlertTools2.default.returnFirstDefined(alert.timeout, _this3.props.timeout, 5000);
                    var html = _sAlertTools2.default.returnFirstDefined(alert.html, _this3.props.html);
                    var onClose = _sAlertTools2.default.returnFirstDefined(alert.onClose, _this3.props.onClose);
                    var onShow = _sAlertTools2.default.returnFirstDefined(alert.onShow, _this3.props.onShow);
                    var customFields = _sAlertTools2.default.returnFirstDefined(alert.customFields, _this3.props.customFields);
                    var contentTemplate = _this3.props.contentTemplate;
                    return _react2.default.createElement(_SAlertContent2.default, {
                        key: customKey,
                        id: id,
                        customFields: customFields,
                        condition: condition,
                        message: message,
                        position: position,
                        effect: effect,
                        boxPosition: boxPosition,
                        beep: beep,
                        timeout: timeout,
                        html: html,
                        onClose: onClose,
                        onShow: onShow,
                        contentTemplate: contentTemplate });
                };
                var sAlertElemsRight = this.state.dataRight.map(mapFunc);
                var sAlertElemsLeft = this.state.dataLeft.map(mapFunc);
                var sAlertElemsTop = this.state.dataTop.map(mapFunc);
                var sAlertElemsBottom = this.state.dataBottom.map(mapFunc);
                return _react2.default.createElement(
                    'div',
                    { className: 's-alert-wrapper' },
                    sAlertElemsRight,
                    sAlertElemsLeft,
                    sAlertElemsTop,
                    sAlertElemsBottom
                );
            }
        }], [{
            key: 'info',
            value: function info(msg, data) {
                return insertFunc(msg, data, 'info');
            }
        }, {
            key: 'error',
            value: function error(msg, data) {
                return insertFunc(msg, data, 'error');
            }
        }, {
            key: 'warning',
            value: function warning(msg, data) {
                return insertFunc(msg, data, 'warning');
            }
        }, {
            key: 'success',
            value: function success(msg, data) {
                return insertFunc(msg, data, 'success');
            }
        }, {
            key: 'close',
            value: function close(id) {
                _sAlertStore2.default.dispatch({ type: 'REMOVE', data: { id: id } });
            }
        }, {
            key: 'closeAll',
            value: function closeAll() {
                _sAlertStore2.default.dispatch({ type: 'REMOVEALL' });
            }
        }]);

        return SAlert;
    }(_react2.default.Component);

    SAlert.propTypes = {
        message: _propTypes2.default.string,
        position: _propTypes2.default.string,
        offset: _propTypes2.default.number,
        stack: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
        effect: _propTypes2.default.string,
        beep: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.bool]),
        timeout: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['none']), _propTypes2.default.number]),
        html: _propTypes2.default.bool,
        onClose: _propTypes2.default.func,
        onShow: _propTypes2.default.func,
        customFields: _propTypes2.default.object,
        contentTemplate: _propTypes2.default.func
    };

    exports.default = SAlert;
});

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require('react'), require('prop-types'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.react, global.propTypes);
        global.SAlertContentTmpl = mod.exports;
    }
})(this, function (exports, _react, _propTypes) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _react2 = _interopRequireDefault(_react);

    var _propTypes2 = _interopRequireDefault(_propTypes);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    function _possibleConstructorReturn(self, call) {
        if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var SAlertContentTmpl = function (_React$Component) {
        _inherits(SAlertContentTmpl, _React$Component);

        function SAlertContentTmpl(props) {
            _classCallCheck(this, SAlertContentTmpl);

            return _possibleConstructorReturn(this, (SAlertContentTmpl.__proto__ || Object.getPrototypeOf(SAlertContentTmpl)).call(this, props));
        }

        _createClass(SAlertContentTmpl, [{
            key: 'render',
            value: function render() {
                return _react2.default.createElement(
                    'div',
                    { className: this.props.classNames, id: this.props.id, style: this.props.styles },
                    _react2.default.createElement(
                        'div',
                        { className: 's-alert-box-inner' },
                        this.props.message
                    ),
                    _react2.default.createElement('span', { className: 's-alert-close', onClick: this.props.handleClose })
                );
            }
        }]);

        return SAlertContentTmpl;
    }(_react2.default.Component);

    SAlertContentTmpl.propTypes = {
        id: _propTypes2.default.string.isRequired,
        classNames: _propTypes2.default.string.isRequired,
        styles: _propTypes2.default.object.isRequired,
        message: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired,
        handleClose: _propTypes2.default.func.isRequired,
        customFields: _propTypes2.default.object
    };

    exports.default = SAlertContentTmpl;
});

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(22), __webpack_require__(224), __webpack_require__(128), __webpack_require__(127)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require('react'), require('react-dom'), require('../SAlertContent'), require('./s-alert-store'), require('./s-alert-tools'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.react, global.reactDom, global.SAlertContent, global.sAlertStore, global.sAlertTools);
        global.sAlertDataPrep = mod.exports;
    }
})(this, function (exports, _react, _reactDom, _SAlertContent, _sAlertStore, _sAlertTools) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _react2 = _interopRequireDefault(_react);

    var _reactDom2 = _interopRequireDefault(_reactDom);

    var _SAlertContent2 = _interopRequireDefault(_SAlertContent);

    var _sAlertStore2 = _interopRequireDefault(_sAlertStore);

    var _sAlertTools2 = _interopRequireDefault(_sAlertTools);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }

        return target;
    };

    var getAlertData = function getAlertData(sAlertPosition) {
        var positionTop = 0;
        var positionBottom = 0;
        var padding = 0;
        var alerts = {};
        var style = void 0;
        var docElement = void 0;
        var sAlertBoxHeight = void 0;
        var positionTypeTop = void 0;
        var positionTypeBottom = void 0;
        var checkFirst = function checkFirst(type, objId) {
            var collectionOfType = sAlertCollection.filter(function (obj) {
                return obj.position === type || sAlertGlobalConfig.position === type;
            });
            return collectionOfType && collectionOfType[0].id === objId;
        };
        var positionFunc = function positionFunc(position, positionType, alert, docElement, sAlertBoxHeight, reactComponent) {
            padding = aStack.spacing || parseInt(getComputedStyle(_reactDom2.default.findDOMNode(reactComponent))[positionType]);
            if (checkFirst(aPosition, alert.id) && aOffset) {
                position = 0;
                position = position + parseInt(aOffset);
            }
            if (checkFirst(aPosition, alert.id) && aStack.spacing) {
                position = position;
            } else {
                position = position + parseInt(padding);
            }
            style = positionType + ': ' + position + 'px;';
            position = position + sAlertBoxHeight;
            return position;
        };

        var sAlertGlobalConfig = _sAlertTools2.default.getGlobalConfig();
        var aStack = void 0;
        var aContentTemplate = void 0;
        var aOffset = void 0;
        var aMessage = void 0;
        var aHtml = void 0;
        var aCustomFields = void 0;
        var aPosition = void 0;

        var query = {};
        if (sAlertPosition === 'left') {
            query = function query(item) {
                return item.position === 'top-left' || item.position === 'bottom-left' || !item.position && (sAlertGlobalConfig.position === 'top-left' || sAlertGlobalConfig.position === 'bottom-left');
            };
        }
        if (sAlertPosition === 'right') {
            query = function query(item) {
                return item.position === 'top-right' || item.position === 'bottom-right' || !item.position && (sAlertGlobalConfig.position === 'top-right' || sAlertGlobalConfig.position === 'bottom-right');
            };
        }
        if (sAlertPosition === 'full-top') {
            query = function query(item) {
                return item.position === 'top' || !item.position && sAlertGlobalConfig.position === 'top';
            };
        }
        if (sAlertPosition === 'full-bottom') {
            query = function query(item) {
                return item.position === 'bottom' || !item.position && sAlertGlobalConfig.position === 'bottom';
            };
        }

        var currentState = _sAlertStore2.default.getState();
        var sAlertCollection = currentState.slice().filter(query);

        return sAlertCollection.map(function (alert) {
            aStack = sAlertGlobalConfig.stack;
            aContentTemplate = sAlertGlobalConfig.contentTemplate;
            aOffset = _sAlertTools2.default.returnFirstDefined(alert.offset, sAlertGlobalConfig.offset);
            aMessage = _sAlertTools2.default.returnFirstDefined(alert.message, sAlertGlobalConfig.message);
            aHtml = _sAlertTools2.default.returnFirstDefined(alert.html, sAlertGlobalConfig.html);
            aCustomFields = _sAlertTools2.default.returnFirstDefined(alert.customFields, sAlertGlobalConfig.customFields);
            aPosition = _sAlertTools2.default.returnFirstDefined(alert.position, sAlertGlobalConfig.position);
            positionTypeTop = aPosition && /top/g.test(aPosition);
            positionTypeBottom = aPosition && /bottom/g.test(aPosition);
            if (aStack) {
                // checking alert box height - needed to calculate position
                docElement = document.createElement('div');
                docElement.classList.add('s-alert-box-height');

                // mock element, needed for positions calculations
                var reactElement = _react2.default.createElement(_SAlertContent2.default, {
                    key: _sAlertTools2.default.randomId(),
                    id: _sAlertTools2.default.randomId(),
                    condition: alert.condition,
                    message: aMessage,
                    position: aPosition,
                    effect: alert.effect,
                    boxPosition: alert.boxPosition,
                    beep: false,
                    timeout: 'none',
                    html: aHtml,
                    contentTemplate: aContentTemplate,
                    customFields: aCustomFields
                });
                var reactComponent = _reactDom2.default.render(reactElement, docElement);

                document.body.appendChild(docElement);
                sAlertBoxHeight = parseInt(getComputedStyle(_reactDom2.default.findDOMNode(reactComponent))['height']);
                if (positionTypeTop) {
                    positionTop = positionFunc(positionTop, 'top', alert, docElement, sAlertBoxHeight, reactComponent);
                }
                if (positionTypeBottom) {
                    positionBottom = positionFunc(positionBottom, 'bottom', alert, docElement, sAlertBoxHeight, reactComponent);
                }
                var sAlertComputedStyle = getComputedStyle(_reactDom2.default.findDOMNode(reactComponent));
                if (sAlertPosition === 'left') {
                    style = style + 'left: ' + (aStack.spacing || parseInt(sAlertComputedStyle.left)) + 'px;';
                }
                if (sAlertPosition === 'right') {
                    style = style + 'right: ' + (aStack.spacing || parseInt(sAlertComputedStyle.right)) + 'px;';
                }
                alerts = _extends({}, alert, { boxPosition: style });
                _reactDom2.default.unmountComponentAtNode(docElement);
                docElement.parentNode.removeChild(docElement);
            } else if (aOffset && positionTypeTop) {
                alerts = _extends({}, alert, { boxPosition: 'top: ' + parseInt(aOffset) + 'px;' });
            } else if (aOffset && positionTypeBottom) {
                alerts = _extends({}, alert, { boxPosition: 'bottom: ' + parseInt(aOffset) + 'px;' });
            } else {
                alerts = alert;
            }
            return alerts;
        });
    };

    exports.default = getAlertData;
});

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Const = __webpack_require__(7);

var _Const2 = _interopRequireDefault(_Const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint quotes: 0 */
/* eslint max-len: 0 */


var legalComparators = ['=', '>', '>=', '<', '<=', '!='];

function dateParser(d) {
  return d.getFullYear() + '-' + ("0" + (d.getMonth() + 1)).slice(-2) + '-' + ("0" + d.getDate()).slice(-2);
}

var DateFilter = function (_Component) {
  _inherits(DateFilter, _Component);

  function DateFilter(props) {
    _classCallCheck(this, DateFilter);

    var _this = _possibleConstructorReturn(this, (DateFilter.__proto__ || Object.getPrototypeOf(DateFilter)).call(this, props));

    _this.dateComparators = _this.props.dateComparators || legalComparators;
    _this.filter = _this.filter.bind(_this);
    _this.onChangeComparator = _this.onChangeComparator.bind(_this);
    return _this;
  }

  _createClass(DateFilter, [{
    key: 'setDefaultDate',
    value: function setDefaultDate() {
      var defaultDate = '';
      var defaultValue = this.props.defaultValue;

      if (defaultValue && defaultValue.date) {
        // Set the appropriate format for the input type=date, i.e. "YYYY-MM-DD"
        defaultDate = dateParser(new Date(defaultValue.date));
      }
      return defaultDate;
    }
  }, {
    key: 'onChangeComparator',
    value: function onChangeComparator(event) {
      var date = this.inputDate.value;
      var comparator = event.target.value;
      if (date === '') {
        return;
      }
      date = new Date(date);
      this.props.filterHandler({ date: date, comparator: comparator }, _Const2.default.FILTER_TYPE.DATE);
    }
  }, {
    key: 'getComparatorOptions',
    value: function getComparatorOptions() {
      var optionTags = [];
      optionTags.push(_react2.default.createElement('option', { key: '-1' }));
      for (var i = 0; i < this.dateComparators.length; i++) {
        optionTags.push(_react2.default.createElement(
          'option',
          { key: i, value: this.dateComparators[i] },
          this.dateComparators[i]
        ));
      }
      return optionTags;
    }
  }, {
    key: 'filter',
    value: function filter(event) {
      var comparator = this.dateFilterComparator.value;
      var dateValue = event.target.value;
      if (dateValue) {
        this.props.filterHandler({ date: new Date(dateValue), comparator: comparator }, _Const2.default.FILTER_TYPE.DATE);
      } else {
        this.props.filterHandler(null, _Const2.default.FILTER_TYPE.DATE);
      }
    }
  }, {
    key: 'cleanFiltered',
    value: function cleanFiltered() {
      var value = this.setDefaultDate();
      var comparator = this.props.defaultValue ? this.props.defaultValue.comparator : '';
      this.setState(function () {
        return { isPlaceholderSelected: value === '' };
      });
      this.dateFilterComparator.value = comparator;
      this.inputDate.value = value;
      this.props.filterHandler({ date: new Date(value), comparator: comparator }, _Const2.default.FILTER_TYPE.DATE);
    }
  }, {
    key: 'applyFilter',
    value: function applyFilter(filterDateObj) {
      var date = filterDateObj.date,
          comparator = filterDateObj.comparator;

      this.setState(function () {
        return { isPlaceholderSelected: date === '' };
      });
      this.dateFilterComparator.value = comparator;
      this.inputDate.value = dateParser(date);
      this.props.filterHandler({ date: date, comparator: comparator }, _Const2.default.FILTER_TYPE.DATE);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var comparator = this.dateFilterComparator.value;
      var dateValue = this.inputDate.value;
      if (comparator && dateValue) {
        this.props.filterHandler({ date: new Date(dateValue), comparator: comparator }, _Const2.default.FILTER_TYPE.DATE);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          defaultValue = _props.defaultValue,
          _props$style = _props.style,
          date = _props$style.date,
          comparator = _props$style.comparator;

      return _react2.default.createElement(
        'div',
        { className: 'filter date-filter' },
        _react2.default.createElement(
          'select',
          { ref: function ref(n) {
              return _this2.dateFilterComparator = n;
            },
            style: comparator,
            className: 'date-filter-comparator form-control',
            onChange: this.onChangeComparator,
            defaultValue: defaultValue ? defaultValue.comparator : '' },
          this.getComparatorOptions()
        ),
        _react2.default.createElement('input', { ref: function ref(n) {
            return _this2.inputDate = n;
          },
          className: 'filter date-filter-input form-control',
          style: date,
          type: 'date',
          onChange: this.filter,
          defaultValue: this.setDefaultDate() })
      );
    }
  }]);

  return DateFilter;
}(_react.Component);

DateFilter.propTypes = {
  filterHandler: _propTypes2.default.func.isRequired,
  defaultValue: _propTypes2.default.shape({
    date: _propTypes2.default.object,
    comparator: _propTypes2.default.oneOf(legalComparators)
  }),
  style: _propTypes2.default.shape({
    date: _propTypes2.default.oneOfType([_propTypes2.default.object]),
    comparator: _propTypes2.default.oneOfType([_propTypes2.default.object])
  }),
  /* eslint consistent-return: 0 */
  dateComparators: function dateComparators(props, propName) {
    if (!props[propName]) {
      return;
    }
    for (var i = 0; i < props[propName].length; i++) {
      var comparatorIsValid = false;
      for (var j = 0; j < legalComparators.length; j++) {
        if (legalComparators[j] === props[propName][i]) {
          comparatorIsValid = true;
          break;
        }
      }
      if (!comparatorIsValid) {
        return new Error('Date comparator provided is not supported.\n          Use only ' + legalComparators);
      }
    }
  },
  columnName: _propTypes2.default.any
};

DateFilter.defaultProps = {
  style: {
    date: null,
    comparator: null
  }
};

var _default = DateFilter;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(legalComparators, 'legalComparators', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Date.js');

  __REACT_HOT_LOADER__.register(dateParser, 'dateParser', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Date.js');

  __REACT_HOT_LOADER__.register(DateFilter, 'DateFilter', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Date.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Date.js');
}();

;

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Const = __webpack_require__(7);

var _Const2 = _interopRequireDefault(_Const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextFilter = function (_Component) {
  _inherits(TextFilter, _Component);

  function TextFilter(props) {
    _classCallCheck(this, TextFilter);

    var _this = _possibleConstructorReturn(this, (TextFilter.__proto__ || Object.getPrototypeOf(TextFilter)).call(this, props));

    _this.filter = _this.filter.bind(_this);
    _this.timeout = null;
    _this.state = {
      value: _this.props.defaultValue || ''
    };
    return _this;
  }

  _createClass(TextFilter, [{
    key: 'filter',
    value: function filter(event) {
      var _this2 = this;

      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      var filterValue = event.target.value;
      this.setState(function () {
        return { value: filterValue };
      });
      this.timeout = setTimeout(function () {
        _this2.props.filterHandler(filterValue, _Const2.default.FILTER_TYPE.TEXT);
      }, this.props.delay);
    }
  }, {
    key: 'cleanFiltered',
    value: function cleanFiltered() {
      var value = this.props.defaultValue ? this.props.defaultValue : '';
      this.setState(function () {
        return { value: value };
      });
      this.props.filterHandler(value, _Const2.default.FILTER_TYPE.TEXT);
    }
  }, {
    key: 'applyFilter',
    value: function applyFilter(filterText) {
      this.setState(function () {
        return { value: filterText };
      });
      this.props.filterHandler(filterText, _Const2.default.FILTER_TYPE.TEXT);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var defaultValue = this.inputText.value;
      if (defaultValue) {
        this.props.filterHandler(defaultValue, _Const2.default.FILTER_TYPE.TEXT);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.defaultValue !== this.props.defaultValue) {
        this.applyFilter(nextProps.defaultValue || '');
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          placeholder = _props.placeholder,
          columnName = _props.columnName,
          style = _props.style;

      return _react2.default.createElement('input', { ref: function ref(n) {
          return _this3.inputText = n;
        },
        className: 'filter text-filter form-control',
        type: 'text',
        style: style,
        onChange: this.filter,
        placeholder: placeholder || 'Enter ' + columnName + '...',
        value: this.state.value });
    }
  }]);

  return TextFilter;
}(_react.Component);

TextFilter.propTypes = {
  filterHandler: _propTypes2.default.func.isRequired,
  defaultValue: _propTypes2.default.string,
  delay: _propTypes2.default.number,
  placeholder: _propTypes2.default.string,
  columnName: _propTypes2.default.any,
  style: _propTypes2.default.oneOfType([_propTypes2.default.object])
};

TextFilter.defaultProps = {
  delay: _Const2.default.FILTER_DELAY
};

var _default = TextFilter;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TextFilter, 'TextFilter', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Text.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Text.js');
}();

;

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Const = __webpack_require__(7);

var _Const2 = _interopRequireDefault(_Const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RegexFilter = function (_Component) {
  _inherits(RegexFilter, _Component);

  function RegexFilter(props) {
    _classCallCheck(this, RegexFilter);

    var _this = _possibleConstructorReturn(this, (RegexFilter.__proto__ || Object.getPrototypeOf(RegexFilter)).call(this, props));

    _this.filter = _this.filter.bind(_this);
    _this.timeout = null;
    return _this;
  }

  _createClass(RegexFilter, [{
    key: 'filter',
    value: function filter(event) {
      var _this2 = this;

      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      var filterValue = event.target.value;
      this.timeout = setTimeout(function () {
        _this2.props.filterHandler(filterValue, _Const2.default.FILTER_TYPE.REGEX);
      }, this.props.delay);
    }
  }, {
    key: 'cleanFiltered',
    value: function cleanFiltered() {
      var value = this.props.defaultValue ? this.props.defaultValue : '';
      this.inputText.value = value;
      this.props.filterHandler(value, _Const2.default.FILTER_TYPE.TEXT);
    }
  }, {
    key: 'applyFilter',
    value: function applyFilter(filterRegx) {
      this.inputText.value = filterRegx;
      this.props.filterHandler(filterRegx, _Const2.default.FILTER_TYPE.REGEX);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var value = this.inputText.value;
      if (value) {
        this.props.filterHandler(value, _Const2.default.FILTER_TYPE.REGEX);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          defaultValue = _props.defaultValue,
          placeholder = _props.placeholder,
          columnName = _props.columnName,
          style = _props.style;

      return _react2.default.createElement('input', { ref: function ref(n) {
          return _this3.inputText = n;
        },
        className: 'filter text-filter form-control',
        type: 'text',
        style: style,
        onChange: this.filter,
        placeholder: placeholder || 'Enter Regex for ' + columnName + '...',
        defaultValue: defaultValue ? defaultValue : '' });
    }
  }]);

  return RegexFilter;
}(_react.Component);

RegexFilter.propTypes = {
  filterHandler: _propTypes2.default.func.isRequired,
  defaultValue: _propTypes2.default.string,
  delay: _propTypes2.default.number,
  placeholder: _propTypes2.default.string,
  columnName: _propTypes2.default.any,
  style: _propTypes2.default.oneOfType([_propTypes2.default.object])
};

RegexFilter.defaultProps = {
  delay: _Const2.default.FILTER_DELAY
};

var _default = RegexFilter;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(RegexFilter, 'RegexFilter', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Regex.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Regex.js');
}();

;

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _Const = __webpack_require__(7);

var _Const2 = _interopRequireDefault(_Const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function optionsEquals(options1, options2) {
  var keys = Object.keys(options1);
  for (var k in keys) {
    if (options1[k] !== options2[k]) {
      return false;
    }
  }
  return Object.keys(options1).length === Object.keys(options2).length;
}

var SelectFilter = function (_Component) {
  _inherits(SelectFilter, _Component);

  function SelectFilter(props) {
    _classCallCheck(this, SelectFilter);

    var _this = _possibleConstructorReturn(this, (SelectFilter.__proto__ || Object.getPrototypeOf(SelectFilter)).call(this, props));

    _this.filter = _this.filter.bind(_this);
    _this.state = {
      isPlaceholderSelected: _this.props.defaultValue === undefined || !_this.props.options.hasOwnProperty(_this.props.defaultValue)
    };
    return _this;
  }

  _createClass(SelectFilter, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      var currentSelectValue = this.selectInput.value;
      var isPlaceholderSelected = !currentSelectValue || currentSelectValue === '';
      this.setState(function () {
        return {
          isPlaceholderSelected: isPlaceholderSelected
        };
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var needFilter = false;
      if (this.props.defaultValue !== prevProps.defaultValue) {
        needFilter = true;
      } else if (!optionsEquals(this.props.options, prevProps.options)) {
        needFilter = true;
      }
      if (needFilter) {
        var value = this.selectInput.value;
        if (value) {
          this.props.filterHandler(value, _Const2.default.FILTER_TYPE.SELECT);
        }
      }
    }
  }, {
    key: 'filter',
    value: function filter(event) {
      var value = event.target.value;

      this.setState(function () {
        return { isPlaceholderSelected: value === '' };
      });
      this.props.filterHandler(value, _Const2.default.FILTER_TYPE.SELECT);
    }
  }, {
    key: 'cleanFiltered',
    value: function cleanFiltered() {
      var value = this.props.defaultValue !== undefined ? this.props.defaultValue : '';
      this.setState(function () {
        return { isPlaceholderSelected: value === '' };
      });
      this.selectInput.value = value;
      this.props.filterHandler(value, _Const2.default.FILTER_TYPE.SELECT);
    }
  }, {
    key: 'applyFilter',
    value: function applyFilter(filterOption) {
      filterOption = filterOption + '';
      this.setState(function () {
        return { isPlaceholderSelected: filterOption === '' };
      });
      this.selectInput.value = filterOption;
      this.props.filterHandler(filterOption, _Const2.default.FILTER_TYPE.SELECT);
    }
  }, {
    key: 'getOptions',
    value: function getOptions() {
      var optionTags = [];
      var _props = this.props,
          options = _props.options,
          placeholder = _props.placeholder,
          columnName = _props.columnName,
          selectText = _props.selectText,
          withoutEmptyOption = _props.withoutEmptyOption;

      var selectTextValue = selectText !== undefined ? selectText : 'Select';
      if (!withoutEmptyOption) {
        optionTags.push(_react2.default.createElement(
          'option',
          { key: '-1', value: '' },
          placeholder || selectTextValue + ' ' + columnName + '...'
        ));
      }
      Object.keys(options).map(function (key) {
        optionTags.push(_react2.default.createElement(
          'option',
          { key: key, value: key },
          options[key] + ''
        ));
      });
      return optionTags;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var value = this.selectInput.value;
      if (value) {
        this.props.filterHandler(value, _Const2.default.FILTER_TYPE.SELECT);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var selectClass = (0, _classnames2.default)('filter', 'select-filter', 'form-control', { 'placeholder-selected': this.state.isPlaceholderSelected });

      return _react2.default.createElement(
        'select',
        { ref: function ref(n) {
            return _this2.selectInput = n;
          },
          style: this.props.style,
          className: selectClass,
          onChange: this.filter,
          defaultValue: this.props.defaultValue !== undefined ? this.props.defaultValue : '' },
        this.getOptions()
      );
    }
  }]);

  return SelectFilter;
}(_react.Component);

SelectFilter.propTypes = {
  filterHandler: _propTypes2.default.func.isRequired,
  options: _propTypes2.default.object.isRequired,
  placeholder: _propTypes2.default.string,
  columnName: _propTypes2.default.any,
  style: _propTypes2.default.oneOfType([_propTypes2.default.object])
};

var _default = SelectFilter;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(optionsEquals, 'optionsEquals', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Select.js');

  __REACT_HOT_LOADER__.register(SelectFilter, 'SelectFilter', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Select.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Select.js');
}();

;

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _Const = __webpack_require__(7);

var _Const2 = _interopRequireDefault(_Const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var legalComparators = ['=', '>', '>=', '<', '<=', '!='];

var NumberFilter = function (_Component) {
  _inherits(NumberFilter, _Component);

  function NumberFilter(props) {
    _classCallCheck(this, NumberFilter);

    var _this = _possibleConstructorReturn(this, (NumberFilter.__proto__ || Object.getPrototypeOf(NumberFilter)).call(this, props));

    _this.numberComparators = _this.props.numberComparators || legalComparators;
    _this.timeout = null;
    _this.state = {
      isPlaceholderSelected: _this.props.defaultValue === undefined || _this.props.defaultValue.number === undefined || _this.props.options && _this.props.options.indexOf(_this.props.defaultValue.number) === -1
    };
    _this.onChangeNumber = _this.onChangeNumber.bind(_this);
    _this.onChangeNumberSet = _this.onChangeNumberSet.bind(_this);
    _this.onChangeComparator = _this.onChangeComparator.bind(_this);
    return _this;
  }

  _createClass(NumberFilter, [{
    key: 'onChangeNumber',
    value: function onChangeNumber(event) {
      var _this2 = this;

      var comparator = this.numberFilterComparator.value;
      if (comparator === '') {
        return;
      }
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      var filterValue = event.target.value;
      this.timeout = setTimeout(function () {
        _this2.props.filterHandler({ number: filterValue, comparator: comparator }, _Const2.default.FILTER_TYPE.NUMBER);
      }, this.props.delay);
    }
  }, {
    key: 'onChangeNumberSet',
    value: function onChangeNumberSet(event) {
      var comparator = this.numberFilterComparator.value;
      var value = event.target.value;

      this.setState(function () {
        return { isPlaceholderSelected: value === '' };
      });
      if (comparator === '') {
        return;
      }
      this.props.filterHandler({ number: value, comparator: comparator }, _Const2.default.FILTER_TYPE.NUMBER);
    }
  }, {
    key: 'onChangeComparator',
    value: function onChangeComparator(event) {
      var value = this.numberFilter.value;
      var comparator = event.target.value;
      if (value === '') {
        return;
      }
      this.props.filterHandler({ number: value, comparator: comparator }, _Const2.default.FILTER_TYPE.NUMBER);
    }
  }, {
    key: 'cleanFiltered',
    value: function cleanFiltered() {
      var value = this.props.defaultValue ? this.props.defaultValue.number : '';
      var comparator = this.props.defaultValue ? this.props.defaultValue.comparator : '';
      this.setState(function () {
        return { isPlaceholderSelected: value === '' };
      });
      this.numberFilterComparator.value = comparator;
      this.numberFilter.value = value;
      this.props.filterHandler({ number: value, comparator: comparator }, _Const2.default.FILTER_TYPE.NUMBER);
    }
  }, {
    key: 'applyFilter',
    value: function applyFilter(filterObj) {
      var number = filterObj.number,
          comparator = filterObj.comparator;

      this.setState(function () {
        return { isPlaceholderSelected: number === '' };
      });
      this.numberFilterComparator.value = comparator;
      this.numberFilter.value = number;
      this.props.filterHandler({ number: number, comparator: comparator }, _Const2.default.FILTER_TYPE.NUMBER);
    }
  }, {
    key: 'getComparatorOptions',
    value: function getComparatorOptions() {
      var optionTags = [];
      var withoutEmptyComparatorOption = this.props.withoutEmptyComparatorOption;

      if (!withoutEmptyComparatorOption) {
        optionTags.push(_react2.default.createElement('option', { key: '-1' }));
      }
      for (var i = 0; i < this.numberComparators.length; i++) {
        optionTags.push(_react2.default.createElement(
          'option',
          { key: i, value: this.numberComparators[i] },
          this.numberComparators[i]
        ));
      }
      return optionTags;
    }
  }, {
    key: 'getNumberOptions',
    value: function getNumberOptions() {
      var optionTags = [];
      var _props = this.props,
          options = _props.options,
          withoutEmptyNumberOption = _props.withoutEmptyNumberOption;

      if (!withoutEmptyNumberOption) {
        optionTags.push(_react2.default.createElement(
          'option',
          { key: '-1', value: '' },
          this.props.placeholder || 'Select ' + this.props.columnName + '...'
        ));
      }
      for (var i = 0; i < options.length; i++) {
        optionTags.push(_react2.default.createElement(
          'option',
          { key: i, value: options[i] },
          options[i]
        ));
      }
      return optionTags;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var comparator = this.numberFilterComparator.value;
      var number = this.numberFilter.value;
      if (comparator && number) {
        this.props.filterHandler({ number: number, comparator: comparator }, _Const2.default.FILTER_TYPE.NUMBER);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var selectClass = (0, _classnames2.default)('select-filter', 'number-filter-input', 'form-control', { 'placeholder-selected': this.state.isPlaceholderSelected });

      return _react2.default.createElement(
        'div',
        { className: 'filter number-filter' },
        _react2.default.createElement(
          'select',
          { ref: function ref(n) {
              return _this3.numberFilterComparator = n;
            },
            style: this.props.style.comparator,
            className: 'number-filter-comparator form-control',
            onChange: this.onChangeComparator,
            defaultValue: this.props.defaultValue ? this.props.defaultValue.comparator : '' },
          this.getComparatorOptions()
        ),
        this.props.options ? _react2.default.createElement(
          'select',
          { ref: function ref(n) {
              return _this3.numberFilter = n;
            },
            className: selectClass,
            onChange: this.onChangeNumberSet,
            defaultValue: this.props.defaultValue ? this.props.defaultValue.number : '' },
          this.getNumberOptions()
        ) : _react2.default.createElement('input', { ref: function ref(n) {
            return _this3.numberFilter = n;
          },
          type: 'number',
          style: this.props.style.number,
          className: 'number-filter-input form-control',
          placeholder: this.props.placeholder || 'Enter ' + this.props.columnName + '...',
          onChange: this.onChangeNumber,
          defaultValue: this.props.defaultValue ? this.props.defaultValue.number : '' })
      );
    }
  }]);

  return NumberFilter;
}(_react.Component);

NumberFilter.propTypes = {
  filterHandler: _propTypes2.default.func.isRequired,
  options: _propTypes2.default.arrayOf(_propTypes2.default.number),
  defaultValue: _propTypes2.default.shape({
    number: _propTypes2.default.number,
    comparator: _propTypes2.default.oneOf(legalComparators)
  }),
  style: _propTypes2.default.shape({
    number: _propTypes2.default.oneOfType([_propTypes2.default.object]),
    comparator: _propTypes2.default.oneOfType([_propTypes2.default.object])
  }),
  delay: _propTypes2.default.number,
  /* eslint consistent-return: 0 */
  numberComparators: function numberComparators(props, propName) {
    if (!props[propName]) {
      return;
    }
    for (var i = 0; i < props[propName].length; i++) {
      var comparatorIsValid = false;
      for (var j = 0; j < legalComparators.length; j++) {
        if (legalComparators[j] === props[propName][i]) {
          comparatorIsValid = true;
          break;
        }
      }
      if (!comparatorIsValid) {
        return new Error('Number comparator provided is not supported.\n          Use only ' + legalComparators);
      }
    }
  },
  placeholder: _propTypes2.default.string,
  columnName: _propTypes2.default.any,
  withoutEmptyComparatorOption: _propTypes2.default.bool,
  withoutEmptyNumberOption: _propTypes2.default.bool
};

NumberFilter.defaultProps = {
  delay: _Const2.default.FILTER_DELAY,
  withoutEmptyComparatorOption: false,
  withoutEmptyNumberOption: false,
  style: {
    number: null,
    comparator: null
  }
};

var _default = NumberFilter;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(legalComparators, 'legalComparators', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Number.js');

  __REACT_HOT_LOADER__.register(NumberFilter, 'NumberFilter', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Number.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Number.js');
}();

;

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(22);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Const = __webpack_require__(7);

var _Const2 = _interopRequireDefault(_Const);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _SelectRowHeaderColumn = __webpack_require__(565);

var _SelectRowHeaderColumn2 = _interopRequireDefault(_SelectRowHeaderColumn);

var _ExpandRowHeaderColumn = __webpack_require__(566);

var _ExpandRowHeaderColumn2 = _interopRequireDefault(_ExpandRowHeaderColumn);

var _util = __webpack_require__(15);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Checkbox = function (_Component) {
  _inherits(Checkbox, _Component);

  function Checkbox() {
    _classCallCheck(this, Checkbox);

    return _possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).apply(this, arguments));
  }

  _createClass(Checkbox, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.update(this.props.checked);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this.update(props.checked);
    }
  }, {
    key: 'update',
    value: function update(checked) {
      _reactDom2.default.findDOMNode(this).indeterminate = checked === 'indeterminate';
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement('input', { className: 'react-bs-select-all',
        type: 'checkbox',
        checked: this.props.checked,
        onChange: this.props.onChange });
    }
  }]);

  return Checkbox;
}(_react.Component);

function getSortOrder(sortList, field, enableSort) {
  if (!enableSort) return undefined;
  var result = sortList.filter(function (sortObj) {
    return sortObj.sortField === field;
  });
  if (result.length > 0) {
    return result[0].order;
  } else {
    return undefined;
  }
}

var TableHeader = function (_Component2) {
  _inherits(TableHeader, _Component2);

  function TableHeader() {
    var _ref;

    var _temp, _this2, _ret;

    _classCallCheck(this, TableHeader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = TableHeader.__proto__ || Object.getPrototypeOf(TableHeader)).call.apply(_ref, [this].concat(args))), _this2), _this2.getHeaderColGrouop = function () {
      var _this3;

      return (_this3 = _this2).__getHeaderColGrouop__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _temp), _possibleConstructorReturn(_this2, _ret);
  }

  _createClass(TableHeader, [{
    key: '__getHeaderColGrouop__REACT_HOT_LOADER__',
    value: function __getHeaderColGrouop__REACT_HOT_LOADER__() {
      return this.__getHeaderColGrouop__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          sortIndicator = _props.sortIndicator,
          sortList = _props.sortList,
          onSort = _props.onSort,
          reset = _props.reset,
          version = _props.version,
          condensed = _props.condensed,
          bordered = _props.bordered,
          expandedColumnHeaderComponent = _props.expandedColumnHeaderComponent,
          noAnyExpand = _props.noAnyExpand,
          toggleExpandAllChilds = _props.toggleExpandAllChilds,
          expandAll = _props.expandAll;

      var containerClasses = (0, _classnames2.default)('react-bs-container-header', 'table-header-wrapper', this.props.headerContainerClass);
      var customTableClasses = {
        'table-bordered': bordered
      };
      if (condensed) {
        if (_util2.default.isBootstrap4(version)) customTableClasses['table-sm'] = true;else customTableClasses['table-condensed'] = true;
      }
      var tableClasses = (0, _classnames2.default)('table', 'table-hover', customTableClasses, this.props.tableHeaderClass);

      var rowCount = Math.max.apply(Math, _toConsumableArray(_react2.default.Children.map(this.props.children, function (elm) {
        return elm && elm.props.row ? Number(elm.props.row) : 0;
      })));

      var rows = [];
      var rowKey = 0;

      rows[0] = [];
      rows[0].push([this.props.expandColumnVisible && this.props.expandColumnBeforeSelectColumn && _react2.default.createElement(_ExpandRowHeaderColumn2.default, { key: 'expandCol', rowCount: rowCount + 1,
        expandedColumnHeaderComponent: expandedColumnHeaderComponent,
        noAnyExpand: noAnyExpand,
        expandAll: expandAll,
        toggleExpandAllChilds: toggleExpandAllChilds })], [this.renderSelectRowHeader(rowCount + 1, rowKey++)], [this.props.expandColumnVisible && !this.props.expandColumnBeforeSelectColumn && _react2.default.createElement(_ExpandRowHeaderColumn2.default, { key: 'expandCol', rowCount: rowCount + 1,
        expandedColumnHeaderComponent: expandedColumnHeaderComponent,
        noAnyExpand: noAnyExpand,
        expandAll: expandAll,
        toggleExpandAllChilds: toggleExpandAllChilds })]);

      _react2.default.Children.forEach(this.props.children, function (elm) {
        if (elm === null || elm === undefined) {
          // Skip null or undefined elements.
          return;
        }
        var _elm$props = elm.props,
            dataField = _elm$props.dataField,
            dataSort = _elm$props.dataSort;

        var sort = getSortOrder(sortList, dataField, dataSort);
        var rowIndex = elm.props.row ? Number(elm.props.row) : 0;
        var rowSpan = elm.props.rowSpan ? Number(elm.props.rowSpan) : 1;
        if (rows[rowIndex] === undefined) {
          rows[rowIndex] = [];
        }
        if (rowSpan + rowIndex === rowCount + 1) {
          rows[rowIndex].push(_react2.default.cloneElement(elm, { reset: reset, key: rowKey++, onSort: onSort, sort: sort, sortIndicator: sortIndicator, isOnlyHead: false, version: version }));
        } else {
          rows[rowIndex].push(_react2.default.cloneElement(elm, { key: rowKey++, isOnlyHead: true, version: version }));
        }
      });

      var trs = rows.map(function (row, indexRow) {
        return _react2.default.createElement(
          'tr',
          { key: indexRow },
          row
        );
      });

      return _react2.default.createElement(
        'div',
        {
          ref: function ref(node) {
            return _this4.container = node;
          },
          className: containerClasses,
          style: this.props.style },
        _react2.default.createElement(
          'table',
          { className: tableClasses },
          _react2.default.cloneElement(this.props.colGroups, { ref: function ref(node) {
              return _this4.headerGrp = node;
            } }),
          _react2.default.createElement(
            'thead',
            { ref: function ref(node) {
                return _this4.header = node;
              } },
            trs
          )
        )
      );
    }
  }, {
    key: '__getHeaderColGrouop__REACT_HOT_LOADER__',
    value: function __getHeaderColGrouop__REACT_HOT_LOADER__() {
      return this.headerGrp.childNodes;
    }
  }, {
    key: 'renderSelectRowHeader',
    value: function renderSelectRowHeader(rowCount, rowKey) {
      if (this.props.hideSelectColumn) {
        return null;
      } else if (this.props.customComponent) {
        var CustomComponent = this.props.customComponent;
        return _react2.default.createElement(
          _SelectRowHeaderColumn2.default,
          { key: rowKey, rowCount: rowCount },
          _react2.default.createElement(CustomComponent, { type: 'checkbox', checked: this.props.isSelectAll,
            indeterminate: this.props.isSelectAll === 'indeterminate', disabled: false,
            onChange: this.props.onSelectAllRow, rowIndex: 'Header' })
        );
      } else if (this.props.rowSelectType === _Const2.default.ROW_SELECT_SINGLE) {
        return _react2.default.createElement(_SelectRowHeaderColumn2.default, { key: rowKey, rowCount: rowCount });
      } else if (this.props.rowSelectType === _Const2.default.ROW_SELECT_MULTI) {
        return _react2.default.createElement(
          _SelectRowHeaderColumn2.default,
          { key: rowKey, rowCount: rowCount },
          _react2.default.createElement(Checkbox, {
            onChange: this.props.onSelectAllRow,
            checked: this.props.isSelectAll })
        );
      } else {
        return null;
      }
    }
  }]);

  return TableHeader;
}(_react.Component);

TableHeader.propTypes = {
  headerContainerClass: _propTypes2.default.string,
  tableHeaderClass: _propTypes2.default.string,
  style: _propTypes2.default.object,
  rowSelectType: _propTypes2.default.string,
  onSort: _propTypes2.default.func,
  onSelectAllRow: _propTypes2.default.func,
  sortList: _propTypes2.default.array,
  hideSelectColumn: _propTypes2.default.bool,
  bordered: _propTypes2.default.bool,
  condensed: _propTypes2.default.bool,
  isFiltered: _propTypes2.default.bool,
  isSelectAll: _propTypes2.default.oneOf([true, 'indeterminate', false]),
  sortIndicator: _propTypes2.default.bool,
  customComponent: _propTypes2.default.func,
  colGroups: _propTypes2.default.element,
  reset: _propTypes2.default.bool,
  expandColumnVisible: _propTypes2.default.bool,
  expandColumnComponent: _propTypes2.default.func,
  expandedColumnHeaderComponent: _propTypes2.default.func,
  expandColumnBeforeSelectColumn: _propTypes2.default.bool,
  version: _propTypes2.default.string,
  noAnyExpand: _propTypes2.default.bool,
  expandAll: _propTypes2.default.bool,
  toggleExpandAllChilds: _propTypes2.default.func
};

var _default = TableHeader;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Checkbox, 'Checkbox', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableHeader.js');

  __REACT_HOT_LOADER__.register(getSortOrder, 'getSortOrder', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableHeader.js');

  __REACT_HOT_LOADER__.register(TableHeader, 'TableHeader', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableHeader.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableHeader.js');
}();

;

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SelectRowHeaderColumn = function (_Component) {
  _inherits(SelectRowHeaderColumn, _Component);

  function SelectRowHeaderColumn() {
    _classCallCheck(this, SelectRowHeaderColumn);

    return _possibleConstructorReturn(this, (SelectRowHeaderColumn.__proto__ || Object.getPrototypeOf(SelectRowHeaderColumn)).apply(this, arguments));
  }

  _createClass(SelectRowHeaderColumn, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'th',
        { rowSpan: this.props.rowCount, style: { textAlign: 'center' },
          'data-is-only-head': false },
        this.props.children
      );
    }
  }]);

  return SelectRowHeaderColumn;
}(_react.Component);

SelectRowHeaderColumn.propTypes = {
  children: _propTypes2.default.node,
  rowCount: _propTypes2.default.number
};
var _default = SelectRowHeaderColumn;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SelectRowHeaderColumn, 'SelectRowHeaderColumn', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/SelectRowHeaderColumn.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/SelectRowHeaderColumn.js');
}();

;

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ExpandRowHeaderColumn = function (_Component) {
  _inherits(ExpandRowHeaderColumn, _Component);

  function ExpandRowHeaderColumn(props) {
    _classCallCheck(this, ExpandRowHeaderColumn);

    var _this = _possibleConstructorReturn(this, (ExpandRowHeaderColumn.__proto__ || Object.getPrototypeOf(ExpandRowHeaderColumn)).call(this, props));

    _this.toggleExpandAllChilds = _this.toggleExpandAllChilds.bind(_this);
    return _this;
  }

  _createClass(ExpandRowHeaderColumn, [{
    key: 'toggleExpandAllChilds',
    value: function toggleExpandAllChilds() {
      this.props.toggleExpandAllChilds();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          expandedColumnHeaderComponent = _props.expandedColumnHeaderComponent,
          noAnyExpand = _props.noAnyExpand,
          expandAll = _props.expandAll;

      var expandedHeaderComponent = noAnyExpand ? _react2.default.createElement('span', { className: 'fa fa-plus glyphicon glyphicon-plus' }) : _react2.default.createElement('span', { className: 'fa fa-minus glyphicon glyphicon-minus' });
      var ExpandedColumnHeaderComponent = expandedColumnHeaderComponent;

      return _react2.default.createElement(
        'th',
        { rowSpan: this.props.rowCount, style: { textAlign: 'center' },
          className: 'react-bs-table-expand-cell',
          'data-is-only-head': false },
        expandAll ? _react2.default.createElement(
          'div',
          { onClick: this.toggleExpandAllChilds },
          expandedColumnHeaderComponent ? _react2.default.createElement(ExpandedColumnHeaderComponent, {
            anyExpand: !noAnyExpand }) : expandedHeaderComponent
        ) : null
      );
    }
  }]);

  return ExpandRowHeaderColumn;
}(_react.Component);

ExpandRowHeaderColumn.propTypes = {
  expandedColumnHeaderComponent: _propTypes2.default.func,
  rowCount: _propTypes2.default.number,
  noAnyExpand: _propTypes2.default.bool,
  expandAll: _propTypes2.default.bool,
  toggleExpandAllChilds: _propTypes2.default.func
};
var _default = ExpandRowHeaderColumn;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ExpandRowHeaderColumn, 'ExpandRowHeaderColumn', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/ExpandRowHeaderColumn.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/ExpandRowHeaderColumn.js');
}();

;

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TableFooter = function (_Component) {
  _inherits(TableFooter, _Component);

  function TableFooter() {
    _classCallCheck(this, TableFooter);

    return _possibleConstructorReturn(this, (TableFooter.__proto__ || Object.getPrototypeOf(TableFooter)).apply(this, arguments));
  }

  _createClass(TableFooter, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          hideSelectColumn = _props.hideSelectColumn,
          expandColumnVisible = _props.expandColumnVisible;

      var containerClasses = (0, _classnames2.default)('react-bs-container-footer', 'table-footer-wrapper');
      var tableClasses = (0, _classnames2.default)('table', 'table-hover', {
        'table-bordered': this.props.bordered,
        'table-condensed': this.props.condensed
      }, this.props.tableFooterClass);
      return _react2.default.createElement(
        'div',
        {
          ref: function ref(node) {
            return _this2.container = node;
          },
          className: containerClasses,
          style: this.props.style },
        this.props.children.map(function (footerItem, footerItemIndex) {
          return _react2.default.createElement(
            'span',
            { key: footerItemIndex },
            _react2.default.createElement(
              'table',
              { className: tableClasses },
              _react2.default.cloneElement(_this2.props.colGroups),
              _react2.default.createElement(
                'tfoot',
                null,
                _react2.default.createElement(
                  'tr',
                  { ref: function ref(node) {
                      return _this2.footer = node;
                    } },
                  hideSelectColumn ? null : _this2.renderSelectionOrExpandCol(),
                  !expandColumnVisible ? null : _this2.renderSelectionOrExpandCol(),
                  _this2.props.columns.map(function (columnItem, colIndex) {
                    if (!columnItem.hidden) {
                      var footerObj = footerItem.filter(function (item) {
                        return item.columnIndex === colIndex;
                      });
                      var footerData = void 0;
                      var thAlignment = 'left';
                      if (footerObj.length) {
                        thAlignment = footerObj[0].align;
                        if (footerObj[0].formatter) {
                          footerData = footerObj[0].formatter(_this2.props.footerFormatterReturnData);
                        } else {
                          footerData = footerObj[0].label;
                        }
                      } else {
                        footerData = '';
                      }
                      return _react2.default.createElement(
                        'th',
                        {
                          key: colIndex,
                          style: {
                            minWidth: _this2.props.columns[colIndex].width + 'px',
                            textAlign: thAlignment
                          } },
                        footerData
                      );
                    }
                  })
                )
              )
            )
          );
        })
      );
    }
  }, {
    key: 'renderSelectionOrExpandCol',
    value: function renderSelectionOrExpandCol() {
      return _react2.default.createElement('th', null);
    }
  }]);

  return TableFooter;
}(_react.Component);

TableFooter.propTypes = {
  tableHeaderClass: _propTypes2.default.string,
  style: _propTypes2.default.object,
  hideSelectColumn: _propTypes2.default.bool,
  expandColumnVisible: _propTypes2.default.bool,
  bordered: _propTypes2.default.bool,
  condensed: _propTypes2.default.bool,
  isFiltered: _propTypes2.default.bool,
  sortIndicator: _propTypes2.default.bool
};

var _default = TableFooter;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TableFooter, 'TableFooter', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableFooter.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableFooter.js');
}();

;

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _util = __webpack_require__(15);

var _util2 = _interopRequireDefault(_util);

var _Const = __webpack_require__(7);

var _Const2 = _interopRequireDefault(_Const);

var _TableRow = __webpack_require__(569);

var _TableRow2 = _interopRequireDefault(_TableRow);

var _TableColumn = __webpack_require__(570);

var _TableColumn2 = _interopRequireDefault(_TableColumn);

var _TableEditColumn = __webpack_require__(571);

var _TableEditColumn2 = _interopRequireDefault(_TableEditColumn);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _ExpandComponent = __webpack_require__(572);

var _ExpandComponent2 = _interopRequireDefault(_ExpandComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TableBody = function (_Component) {
  _inherits(TableBody, _Component);

  function TableBody(props) {
    _classCallCheck(this, TableBody);

    var _this = _possibleConstructorReturn(this, (TableBody.__proto__ || Object.getPrototypeOf(TableBody)).call(this, props));

    _this.handleCellKeyDown = function () {
      return _this.__handleCellKeyDown__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleRowMouseOut = function () {
      return _this.__handleRowMouseOut__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleRowMouseOver = function () {
      return _this.__handleRowMouseOver__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleRowClick = function () {
      return _this.__handleRowClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleRowDoubleClick = function () {
      return _this.__handleRowDoubleClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleSelectRow = function () {
      return _this.__handleSelectRow__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleSelectRowColumChange = function () {
      return _this.__handleSelectRowColumChange__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleClickCell = function () {
      return _this.__handleClickCell__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleEditCell = function () {
      return _this.__handleEditCell__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.nextEditableCell = function () {
      return _this.__nextEditableCell__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleCompleteEditCell = function () {
      return _this.__handleCompleteEditCell__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.cancelEditCell = function () {
      return _this.__cancelEditCell__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleClickonSelectColumn = function () {
      return _this.__handleClickonSelectColumn__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.getHeaderColGrouop = function () {
      return _this.__getHeaderColGrouop__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.state = {
      currEditCell: null
    };
    return _this;
  }

  _createClass(TableBody, [{
    key: '__getHeaderColGrouop__REACT_HOT_LOADER__',
    value: function __getHeaderColGrouop__REACT_HOT_LOADER__() {
      return this.__getHeaderColGrouop__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleClickonSelectColumn__REACT_HOT_LOADER__',
    value: function __handleClickonSelectColumn__REACT_HOT_LOADER__() {
      return this.__handleClickonSelectColumn__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__cancelEditCell__REACT_HOT_LOADER__',
    value: function __cancelEditCell__REACT_HOT_LOADER__() {
      return this.__cancelEditCell__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleCompleteEditCell__REACT_HOT_LOADER__',
    value: function __handleCompleteEditCell__REACT_HOT_LOADER__() {
      return this.__handleCompleteEditCell__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__nextEditableCell__REACT_HOT_LOADER__',
    value: function __nextEditableCell__REACT_HOT_LOADER__() {
      return this.__nextEditableCell__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleEditCell__REACT_HOT_LOADER__',
    value: function __handleEditCell__REACT_HOT_LOADER__() {
      return this.__handleEditCell__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleClickCell__REACT_HOT_LOADER__',
    value: function __handleClickCell__REACT_HOT_LOADER__() {
      return this.__handleClickCell__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleSelectRowColumChange__REACT_HOT_LOADER__',
    value: function __handleSelectRowColumChange__REACT_HOT_LOADER__() {
      return this.__handleSelectRowColumChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleSelectRow__REACT_HOT_LOADER__',
    value: function __handleSelectRow__REACT_HOT_LOADER__() {
      return this.__handleSelectRow__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleRowDoubleClick__REACT_HOT_LOADER__',
    value: function __handleRowDoubleClick__REACT_HOT_LOADER__() {
      return this.__handleRowDoubleClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleRowClick__REACT_HOT_LOADER__',
    value: function __handleRowClick__REACT_HOT_LOADER__() {
      return this.__handleRowClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleRowMouseOver__REACT_HOT_LOADER__',
    value: function __handleRowMouseOver__REACT_HOT_LOADER__() {
      return this.__handleRowMouseOver__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleRowMouseOut__REACT_HOT_LOADER__',
    value: function __handleRowMouseOut__REACT_HOT_LOADER__() {
      return this.__handleRowMouseOut__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleCellKeyDown__REACT_HOT_LOADER__',
    value: function __handleCellKeyDown__REACT_HOT_LOADER__() {
      return this.__handleCellKeyDown__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          cellEdit = _props.cellEdit,
          beforeShowError = _props.beforeShowError,
          x = _props.x,
          y = _props.y,
          keyBoardNav = _props.keyBoardNav,
          trStyle = _props.trStyle,
          version = _props.version;

      var customTableClasses = {
        'table-striped': this.props.striped,
        'table-bordered': this.props.bordered,
        'table-hover': this.props.hover
      };
      if (this.props.condensed) {
        if (_util2.default.isBootstrap4(version)) customTableClasses['table-sm'] = true;else customTableClasses['table-condensed'] = true;
      }
      var tableClasses = (0, _classnames2.default)('table', customTableClasses, this.props.tableBodyClass);

      var noneditableRows = cellEdit.nonEditableRows && cellEdit.nonEditableRows() || [];
      var unselectable = this.props.selectRow.unselectable || [];
      var isSelectRowDefined = _util2.default.isSelectRowDefined(this.props.selectRow.mode);
      var tableHeader = _util2.default.renderColGroup(this.props.columns, this.props.selectRow, this.props.expandColumnOptions, version);
      var inputType = this.props.selectRow.mode === _Const2.default.ROW_SELECT_SINGLE ? 'radio' : 'checkbox';
      var CustomComponent = this.props.selectRow.customComponent;
      var enableKeyBoardNav = keyBoardNav === true || (typeof keyBoardNav === 'undefined' ? 'undefined' : _typeof(keyBoardNav)) === 'object';
      var customEditAndNavStyle = (typeof keyBoardNav === 'undefined' ? 'undefined' : _typeof(keyBoardNav)) === 'object' ? keyBoardNav.customStyleOnEditCell : null;
      var customNavStyle = (typeof keyBoardNav === 'undefined' ? 'undefined' : _typeof(keyBoardNav)) === 'object' ? keyBoardNav.customStyle : null;
      var ExpandColumnCustomComponent = this.props.expandColumnOptions.expandColumnComponent;
      var expandColSpan = this.props.columns.filter(function (col) {
        return col && !col.hidden;
      }).length;
      if (isSelectRowDefined && !this.props.selectRow.hideSelectColumn) {
        expandColSpan += 1;
      }
      var tabIndex = 1;
      if (this.props.expandColumnOptions.expandColumnVisible) {
        expandColSpan += 1;
      }

      var tableRows = this.props.data.map(function (data, r) {
        var tableColumns = this.props.columns.filter(function (_) {
          return _ != null;
        }).map(function (column, i) {
          var fieldValue = data[column.name];
          var isFocusCell = r === y && i === x;
          if (column.name !== this.props.keyField && // Key field can't be edit
          column.editable && // column is editable? default is true, user can set it false
          column.editable.readOnly !== true && this.state.currEditCell !== null && this.state.currEditCell.rid === r && this.state.currEditCell.cid === i && noneditableRows.indexOf(data[this.props.keyField]) === -1) {
            var editable = column.editable;
            var format = column.format ? function (value) {
              return column.format(value, data, column.formatExtraData, r).replace(/<.*?>/g, '');
            } : false;
            if (_util2.default.isFunction(column.editable)) {
              editable = column.editable(fieldValue, data, r, i);
            }

            return _react2.default.createElement(_TableEditColumn2.default, {
              completeEdit: this.handleCompleteEditCell
              // add by bluespring for column editor customize
              , editable: editable,
              attrs: column.editAttrs,
              customEditor: column.customEditor,
              format: column.format ? format : false,
              key: i,
              blurToSave: cellEdit.blurToSave,
              blurToEscape: cellEdit.blurToEscape,
              onTab: this.handleEditCell,
              rowIndex: r,
              colIndex: i,
              row: data,
              fieldValue: fieldValue,
              className: column.editClassName,
              invalidColumnClassName: column.invalidEditColumnClassName,
              beforeShowError: beforeShowError,
              isFocus: isFocusCell,
              customStyleWithNav: customEditAndNavStyle });
          } else {
            // add by bluespring for className customize
            var formattedValue = void 0;
            var columnChild = fieldValue && fieldValue.toString();
            var columnTitle = null;
            var tdClassName = column.className;
            var tdStyles = column.style;
            if (_util2.default.isFunction(column.className)) {
              tdClassName = column.className(fieldValue, data, r, i);
            }

            if (_util2.default.isFunction(column.style)) {
              tdStyles = column.style(fieldValue, data, r, i);
            }

            if (typeof column.format !== 'undefined') {
              formattedValue = column.format(fieldValue, data, column.formatExtraData, r);
              if (!_react2.default.isValidElement(formattedValue)) {
                columnChild = _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: formattedValue } });
              } else {
                columnChild = formattedValue;
              }
            }
            if (_util2.default.isFunction(column.columnTitle)) {
              columnTitle = column.columnTitle(fieldValue, data, r, i);
            } else if (typeof column.columnTitle === 'string') {
              columnTitle = column.columnTitle;
            } else if (column.columnTitle) {
              if (formattedValue) columnTitle = formattedValue.toString();else if (fieldValue) columnTitle = fieldValue.toString();
            }
            return _react2.default.createElement(
              _TableColumn2.default,
              { key: i,
                cIndex: i,
                rIndex: r,
                dataAlign: column.align,
                className: tdClassName,
                columnTitle: columnTitle,
                cellEdit: cellEdit,
                hidden: column.hidden,
                onEdit: this.handleEditCell,
                width: column.width,
                onClick: this.handleClickCell,
                attrs: column.attrs,
                style: tdStyles,
                tabIndex: tabIndex++ + '',
                isFocus: isFocusCell,
                keyBoardNav: enableKeyBoardNav,
                onKeyDown: this.handleCellKeyDown,
                customNavStyle: customNavStyle,
                row: data,
                withoutTabIndex: this.props.withoutTabIndex },
              columnChild
            );
          }
        }, this);
        var key = data[this.props.keyField];
        var disable = unselectable.indexOf(key) !== -1;
        var selected = this.props.selectedRowKeys.indexOf(key) !== -1;
        var selectRowColumn = isSelectRowDefined && !this.props.selectRow.hideSelectColumn ? this.renderSelectRowColumn(selected, inputType, disable, CustomComponent, r, data) : null;
        var expandedRowColumn = this.renderExpandRowColumn(this.props.expandableRow && this.props.expandableRow(data), this.props.expanding.indexOf(key) > -1, ExpandColumnCustomComponent, r);
        var haveExpandContent = this.props.expandableRow && this.props.expandableRow(data);
        var isExpanding = haveExpandContent && this.props.expanding.indexOf(key) > -1;
        var hideRowOnExpand = this.props.hideRowOnExpand;
        // add by bluespring for className customize

        var trClassName = this.props.trClassName;
        if (_util2.default.isFunction(this.props.trClassName)) {
          trClassName = this.props.trClassName(data, r);
        }
        if (isExpanding && this.props.expandParentClass) {
          trClassName += _util2.default.isFunction(this.props.expandParentClass) ? ' ' + this.props.expandParentClass(data, r) : ' ' + this.props.expandParentClass;
        }
        var result = [_react2.default.createElement(
          _TableRow2.default,
          { isSelected: selected, key: key, className: trClassName,
            index: r,
            row: data,
            selectRow: isSelectRowDefined ? this.props.selectRow : undefined,
            enableCellEdit: cellEdit.mode !== _Const2.default.CELL_EDIT_NONE,
            onRowClick: this.handleRowClick,
            onRowDoubleClick: this.handleRowDoubleClick,
            onRowMouseOver: this.handleRowMouseOver,
            onRowMouseOut: this.handleRowMouseOut,
            onSelectRow: this.handleSelectRow,
            onExpandRow: this.handleClickCell,
            unselectableRow: disable,
            style: trStyle,
            hidden: isExpanding && hideRowOnExpand,
            dbClickToEdit: cellEdit.mode === _Const2.default.CELL_EDIT_DBCLICK },
          this.props.expandColumnOptions.expandColumnVisible && this.props.expandColumnOptions.expandColumnBeforeSelectColumn && expandedRowColumn,
          selectRowColumn,
          this.props.expandColumnOptions.expandColumnVisible && !this.props.expandColumnOptions.expandColumnBeforeSelectColumn && expandedRowColumn,
          tableColumns
        )];

        if (haveExpandContent) {
          var expandBodyClass = _util2.default.isFunction(this.props.expandBodyClass) ? this.props.expandBodyClass(data, r, isExpanding) : this.props.expandBodyClass;
          result.push(_react2.default.createElement(
            _ExpandComponent2.default,
            {
              key: key + '-expand',
              row: data,
              className: expandBodyClass,
              bgColor: this.props.expandRowBgColor || this.props.selectRow.bgColor || undefined,
              hidden: !isExpanding,
              colSpan: expandColSpan,
              width: "100%" },
            this.props.expandComponent(data)
          ));
        }
        return result;
      }, this);

      if (tableRows.length === 0 && !this.props.withoutNoDataText) {
        var colSpan = this.props.columns.filter(function (c) {
          return !c.hidden;
        }).length + (isSelectRowDefined && !this.props.selectRow.hideSelectColumn ? 1 : 0) + (this.props.expandColumnOptions.expandColumnVisible ? 1 : 0);
        tableRows = [_react2.default.createElement(
          _TableRow2.default,
          { key: '##table-empty##', style: trStyle },
          _react2.default.createElement(
            'td',
            { 'data-toggle': 'collapse',
              colSpan: colSpan,
              className: 'react-bs-table-no-data' },
            this.props.noDataText || _Const2.default.NO_DATA_TEXT
          )
        )];
      }

      return _react2.default.createElement(
        'div',
        {
          ref: function ref(node) {
            return _this2.container = node;
          },
          className: (0, _classnames2.default)('react-bs-container-body', this.props.bodyContainerClass),
          style: this.props.style },
        _react2.default.createElement(
          'table',
          { className: tableClasses },
          _react2.default.cloneElement(tableHeader, { ref: function ref(node) {
              return _this2.header = node;
            } }),
          _react2.default.createElement(
            'tbody',
            { ref: function ref(node) {
                return _this2.tbody = node;
              } },
            tableRows
          )
        )
      );
    }
  }, {
    key: '__handleCellKeyDown__REACT_HOT_LOADER__',
    value: function __handleCellKeyDown__REACT_HOT_LOADER__(e, lastEditCell) {
      e.preventDefault();
      var _props2 = this.props,
          keyBoardNav = _props2.keyBoardNav,
          onNavigateCell = _props2.onNavigateCell,
          cellEdit = _props2.cellEdit,
          selectedRowKeys = _props2.selectedRowKeys;

      var offset = void 0;
      if (e.keyCode === 37) {
        offset = { x: -1, y: 0 };
      } else if (e.keyCode === 38) {
        offset = { x: 0, y: -1 };
      } else if (e.keyCode === 39 || e.keyCode === 9) {
        offset = { x: 1, y: 0 };
        if (e.keyCode === 9 && lastEditCell) {
          offset = _extends({}, offset, {
            lastEditCell: lastEditCell
          });
        }
      } else if (e.keyCode === 40) {
        offset = { x: 0, y: 1 };
      } else if (e.keyCode === 13) {
        var rowIndex = e.target.parentElement.rowIndex + 1;
        var enterToEdit = (typeof keyBoardNav === 'undefined' ? 'undefined' : _typeof(keyBoardNav)) === 'object' ? keyBoardNav.enterToEdit : false;
        var enterToExpand = (typeof keyBoardNav === 'undefined' ? 'undefined' : _typeof(keyBoardNav)) === 'object' ? keyBoardNav.enterToExpand : false;
        var enterToSelect = (typeof keyBoardNav === 'undefined' ? 'undefined' : _typeof(keyBoardNav)) === 'object' ? keyBoardNav.enterToSelect : false;

        if (cellEdit && enterToEdit) {
          this.handleEditCell(rowIndex, e.currentTarget.cellIndex, '', e);
        }

        if (enterToExpand) {
          this.handleClickCell(e, this.props.y + 1, this.props.x);
        }

        if (enterToSelect) {
          var isSelected = selectedRowKeys.indexOf(this.props.data[rowIndex - 1][this.props.keyField]) !== -1;
          this.handleSelectRow(rowIndex, !isSelected, e);
        }
      }
      if (offset && keyBoardNav) {
        onNavigateCell(offset);
      }
    }
  }, {
    key: '__handleRowMouseOut__REACT_HOT_LOADER__',
    value: function __handleRowMouseOut__REACT_HOT_LOADER__(rowIndex, event) {
      var targetRow = this.props.data[rowIndex];
      this.props.onRowMouseOut(targetRow, event);
    }
  }, {
    key: '__handleRowMouseOver__REACT_HOT_LOADER__',
    value: function __handleRowMouseOver__REACT_HOT_LOADER__(rowIndex, event) {
      var targetRow = this.props.data[rowIndex];
      this.props.onRowMouseOver(targetRow, event);
    }
  }, {
    key: '__handleRowClick__REACT_HOT_LOADER__',
    value: function __handleRowClick__REACT_HOT_LOADER__(rowIndex, cellIndex, event) {
      var _props3 = this.props,
          onRowClick = _props3.onRowClick,
          selectRow = _props3.selectRow;

      if (_util2.default.isSelectRowDefined(selectRow.mode)) cellIndex--;
      if (this._isExpandColumnVisible()) cellIndex--;
      onRowClick(this.props.data[rowIndex - 1], rowIndex - 1, cellIndex, event);
    }
  }, {
    key: '__handleRowDoubleClick__REACT_HOT_LOADER__',
    value: function __handleRowDoubleClick__REACT_HOT_LOADER__(rowIndex, event) {
      var onRowDoubleClick = this.props.onRowDoubleClick;

      var targetRow = this.props.data[rowIndex];
      onRowDoubleClick(targetRow, event);
    }
  }, {
    key: '__handleSelectRow__REACT_HOT_LOADER__',
    value: function __handleSelectRow__REACT_HOT_LOADER__(rowIndex, isSelected, e) {
      var selectedRow = void 0;
      var _props4 = this.props,
          data = _props4.data,
          onSelectRow = _props4.onSelectRow;

      data.forEach(function (row, i) {
        if (i === rowIndex - 1) {
          selectedRow = row;
          return false;
        }
      });
      onSelectRow(selectedRow, isSelected, e, rowIndex - 1);
    }
  }, {
    key: '__handleSelectRowColumChange__REACT_HOT_LOADER__',
    value: function __handleSelectRowColumChange__REACT_HOT_LOADER__(e, rowIndex) {
      if (!this.props.selectRow.clickToSelect || !this.props.selectRow.clickToSelectAndEditCell) {
        this.handleSelectRow(rowIndex + 1, e.currentTarget.checked, e);
      }
    }
  }, {
    key: '__handleClickCell__REACT_HOT_LOADER__',
    value: function __handleClickCell__REACT_HOT_LOADER__(event, rowIndex) {
      var columnIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
      var _props5 = this.props,
          columns = _props5.columns,
          keyField = _props5.keyField,
          expandBy = _props5.expandBy,
          expandableRow = _props5.expandableRow,
          _props5$selectRow = _props5.selectRow,
          mode = _props5$selectRow.mode,
          clickToExpand = _props5$selectRow.clickToExpand,
          hideSelectColumn = _props5$selectRow.hideSelectColumn,
          onlyOneExpanding = _props5.onlyOneExpanding;

      var isSelectRowDefined = _util2.default.isSelectRowDefined(mode);
      var selectRowAndExpand = isSelectRowDefined && !clickToExpand ? false : true;
      columnIndex = isSelectRowDefined && !hideSelectColumn ? columnIndex - 1 : columnIndex;
      columnIndex = this._isExpandColumnVisible() ? columnIndex - 1 : columnIndex;
      if (expandableRow && selectRowAndExpand && (expandBy === _Const2.default.EXPAND_BY_ROW ||
      /* Below will allow expanding trigger by clicking on selection column
      if configure as expanding by column */
      expandBy === _Const2.default.EXPAND_BY_COL && columnIndex < 0 || expandBy === _Const2.default.EXPAND_BY_COL && columns[columnIndex].expandable)) {
        var expanding = this.props.expanding;
        var rowKey = this.props.data[rowIndex - 1][keyField];
        var isRowExpanding = expanding.indexOf(rowKey) > -1;

        if (isRowExpanding) {
          // collapse
          expanding = expanding.filter(function (k) {
            return k !== rowKey;
          });
        } else {
          // expand
          if (onlyOneExpanding) expanding = [rowKey];else expanding.push(rowKey);
        }
        this.props.onExpand(expanding, rowKey, isRowExpanding, event);
      }
    }
  }, {
    key: '__handleEditCell__REACT_HOT_LOADER__',
    value: function __handleEditCell__REACT_HOT_LOADER__(rowIndex, columnIndex, action, e) {
      var selectRow = this.props.selectRow;

      var defineSelectRow = _util2.default.isSelectRowDefined(selectRow.mode);
      var expandColumnVisible = this._isExpandColumnVisible();
      if (defineSelectRow) {
        columnIndex--;
        if (selectRow.hideSelectColumn) columnIndex++;
      }
      if (expandColumnVisible) {
        columnIndex--;
      }
      rowIndex--;

      if (action === 'tab') {
        if (defineSelectRow && !selectRow.hideSelectColumn) columnIndex++;
        if (expandColumnVisible) columnIndex++;
        this.handleCompleteEditCell(e.target.value, rowIndex, columnIndex - 1);
        if (columnIndex >= this.props.columns.length) {
          this.handleCellKeyDown(e, true);
        } else {
          this.handleCellKeyDown(e);
        }

        var _nextEditableCell = this.nextEditableCell(rowIndex, columnIndex),
            nextRIndex = _nextEditableCell.nextRIndex,
            nextCIndex = _nextEditableCell.nextCIndex;

        rowIndex = nextRIndex;
        columnIndex = nextCIndex;
      }

      var stateObj = {
        currEditCell: {
          rid: rowIndex,
          cid: columnIndex
        }
      };

      if (this.props.selectRow.clickToSelectAndEditCell && this.props.cellEdit.mode !== _Const2.default.CELL_EDIT_DBCLICK) {
        var selected = this.props.selectedRowKeys.indexOf(this.props.data[rowIndex][this.props.keyField]) !== -1;
        this.handleSelectRow(rowIndex + 1, !selected, e);
      }
      this.setState(function () {
        return stateObj;
      });
    }
  }, {
    key: '__nextEditableCell__REACT_HOT_LOADER__',
    value: function __nextEditableCell__REACT_HOT_LOADER__(rIndex, cIndex) {
      var keyField = this.props.keyField;

      var nextRIndex = rIndex;
      var nextCIndex = cIndex;
      var row = void 0;
      var column = void 0;
      do {
        if (nextCIndex >= this.props.columns.length) {
          nextRIndex++;
          nextCIndex = 0;
        }
        row = this.props.data[nextRIndex];
        column = this.props.columns[nextCIndex];
        if (!row) break;
        var editable = column.editable;
        if (_util2.default.isFunction(column.editable)) {
          editable = column.editable(column, row, nextRIndex, nextCIndex);
        }
        if (editable && editable.readOnly !== true && !column.hidden && keyField !== column.name) {
          break;
        } else {
          nextCIndex++;
        }
      } while (row);
      return { nextRIndex: nextRIndex, nextCIndex: nextCIndex };
    }
  }, {
    key: '__handleCompleteEditCell__REACT_HOT_LOADER__',
    value: function __handleCompleteEditCell__REACT_HOT_LOADER__(newVal, rowIndex, columnIndex) {
      if (newVal !== null) {
        var result = this.props.onEditCell(newVal, rowIndex, columnIndex);
        if (result !== _Const2.default.AWAIT_BEFORE_CELL_EDIT) {
          this.setState(function () {
            return { currEditCell: null };
          });
        }
      } else {
        this.setState(function () {
          return { currEditCell: null };
        });
      }
    }
  }, {
    key: '__cancelEditCell__REACT_HOT_LOADER__',
    value: function __cancelEditCell__REACT_HOT_LOADER__() {
      this.setState(function () {
        return { currEditCell: null };
      });
    }
  }, {
    key: '__handleClickonSelectColumn__REACT_HOT_LOADER__',
    value: function __handleClickonSelectColumn__REACT_HOT_LOADER__(e, isSelect, rowIndex, row) {
      e.stopPropagation();
      if (e.target.tagName === 'TD' && (this.props.selectRow.clickToSelect || this.props.selectRow.clickToSelectAndEditCell)) {
        var unselectable = this.props.selectRow.unselectable || [];
        if (unselectable.indexOf(row[this.props.keyField]) === -1) {
          this.handleSelectRow(rowIndex + 1, isSelect, e);
          this.handleClickCell(e, rowIndex + 1);
        }
      }
    }
  }, {
    key: 'renderSelectRowColumn',
    value: function renderSelectRowColumn(selected, inputType, disabled) {
      var CustomComponent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      var _this3 = this;

      var rowIndex = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      var row = arguments[5];

      return _react2.default.createElement(
        'td',
        { onClick: function onClick(e) {
            _this3.handleClickonSelectColumn(e, !selected, rowIndex, row);
          }, style: { textAlign: 'center' } },
        CustomComponent ? _react2.default.createElement(CustomComponent, { type: inputType, checked: selected, disabled: disabled,
          rowIndex: rowIndex,
          onChange: function onChange(e) {
            return _this3.handleSelectRowColumChange(e, rowIndex);
          } }) : _react2.default.createElement('input', { type: inputType, checked: selected, disabled: disabled,
          onChange: function onChange(e) {
            return _this3.handleSelectRowColumChange(e, rowIndex);
          } })
      );
    }
  }, {
    key: 'renderExpandRowColumn',
    value: function renderExpandRowColumn(isExpandableRow, isExpanded, CustomComponent) {
      var _this4 = this;

      var rowIndex = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      var content = null;
      if (CustomComponent) {
        content = _react2.default.createElement(CustomComponent, { isExpandableRow: isExpandableRow, isExpanded: isExpanded });
      } else if (isExpandableRow) {
        content = isExpanded ? _react2.default.createElement('span', { className: 'fa fa-minus glyphicon glyphicon-minus' }) : _react2.default.createElement('span', { className: 'fa fa-plus glyphicon glyphicon-plus' });
      } else {
        content = ' ';
      }

      return _react2.default.createElement(
        'td',
        {
          className: 'react-bs-table-expand-cell',
          onClick: function onClick(e) {
            return _this4.handleClickCell(e, rowIndex + 1);
          } },
        content
      );
    }
  }, {
    key: '_isExpandColumnVisible',
    value: function _isExpandColumnVisible() {
      return this.props.expandColumnOptions.expandColumnVisible;
    }
  }, {
    key: '__getHeaderColGrouop__REACT_HOT_LOADER__',
    value: function __getHeaderColGrouop__REACT_HOT_LOADER__() {
      return this.header.childNodes;
    }
  }]);

  return TableBody;
}(_react.Component);

TableBody.propTypes = {
  version: _propTypes2.default.string,
  data: _propTypes2.default.array,
  columns: _propTypes2.default.array,
  striped: _propTypes2.default.bool,
  bordered: _propTypes2.default.bool,
  hover: _propTypes2.default.bool,
  condensed: _propTypes2.default.bool,
  keyField: _propTypes2.default.string,
  selectedRowKeys: _propTypes2.default.array,
  onRowClick: _propTypes2.default.func,
  onRowDoubleClick: _propTypes2.default.func,
  onSelectRow: _propTypes2.default.func,
  noDataText: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  withoutNoDataText: _propTypes2.default.bool,
  style: _propTypes2.default.object,
  tableBodyClass: _propTypes2.default.string,
  bodyContainerClass: _propTypes2.default.string,
  expandableRow: _propTypes2.default.func,
  expandComponent: _propTypes2.default.func,
  expandRowBgColor: _propTypes2.default.string,
  expandBy: _propTypes2.default.string,
  expanding: _propTypes2.default.array,
  onExpand: _propTypes2.default.func,
  expandBodyClass: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  expandParentClass: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  onlyOneExpanding: _propTypes2.default.bool,
  beforeShowError: _propTypes2.default.func,
  keyBoardNav: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
  x: _propTypes2.default.number,
  y: _propTypes2.default.number,
  onNavigateCell: _propTypes2.default.func,
  withoutTabIndex: _propTypes2.default.bool,
  hideRowOnExpand: _propTypes2.default.bool
};
var _default = TableBody;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TableBody, 'TableBody', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableBody.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableBody.js');
}();

;

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _util = __webpack_require__(15);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-nested-ternary: 0 */


var TableRow = function (_Component) {
  _inherits(TableRow, _Component);

  function TableRow(props) {
    _classCallCheck(this, TableRow);

    var _this = _possibleConstructorReturn(this, (TableRow.__proto__ || Object.getPrototypeOf(TableRow)).call(this, props));

    _this.rowClick = function () {
      return _this.__rowClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.expandRow = function () {
      return _this.__expandRow__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.rowDoubleClick = function () {
      return _this.__rowDoubleClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.rowMouseOut = function () {
      return _this.__rowMouseOut__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.rowMouseOver = function () {
      return _this.__rowMouseOver__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.clickNum = 0;
    return _this;
  }

  _createClass(TableRow, [{
    key: '__rowMouseOver__REACT_HOT_LOADER__',
    value: function __rowMouseOver__REACT_HOT_LOADER__() {
      return this.__rowMouseOver__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__rowMouseOut__REACT_HOT_LOADER__',
    value: function __rowMouseOut__REACT_HOT_LOADER__() {
      return this.__rowMouseOut__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__rowDoubleClick__REACT_HOT_LOADER__',
    value: function __rowDoubleClick__REACT_HOT_LOADER__() {
      return this.__rowDoubleClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__expandRow__REACT_HOT_LOADER__',
    value: function __expandRow__REACT_HOT_LOADER__() {
      return this.__expandRow__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__rowClick__REACT_HOT_LOADER__',
    value: function __rowClick__REACT_HOT_LOADER__() {
      return this.__rowClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__rowClick__REACT_HOT_LOADER__',
    value: function __rowClick__REACT_HOT_LOADER__(e) {
      var _this2 = this;

      var rowIndex = this.props.index + 1;
      var cellIndex = e.target.cellIndex;
      if (this.props.onRowClick) this.props.onRowClick(rowIndex, cellIndex, e);
      var _props = this.props,
          selectRow = _props.selectRow,
          unselectableRow = _props.unselectableRow,
          isSelected = _props.isSelected,
          onSelectRow = _props.onSelectRow,
          onExpandRow = _props.onExpandRow,
          dbClickToEdit = _props.dbClickToEdit;

      if (selectRow) {
        if (selectRow.clickToSelect && !unselectableRow) {
          onSelectRow(rowIndex, !isSelected, e);
        } else if (selectRow.clickToSelectAndEditCell && !unselectableRow) {
          this.clickNum++;
          /** if clickToSelectAndEditCell is enabled,
           *  there should be a delay to prevent a selection changed when
           *  user dblick to edit cell on same row but different cell
          **/
          setTimeout(function () {
            if (_this2.clickNum === 1) {
              onSelectRow(rowIndex, !isSelected, e);
              onExpandRow(e, rowIndex, cellIndex);
            }
            _this2.clickNum = 0;
          }, 200);
        } else {
          if (dbClickToEdit) {
            this.expandRow(e, rowIndex, cellIndex);
          }
        }
      }
    }
  }, {
    key: '__expandRow__REACT_HOT_LOADER__',
    value: function __expandRow__REACT_HOT_LOADER__(event, rowIndex, cellIndex) {
      var _this3 = this;

      this.clickNum++;
      setTimeout(function () {
        if (_this3.clickNum === 1) {
          _this3.props.onExpandRow(event, rowIndex, cellIndex);
        }
        _this3.clickNum = 0;
      }, 200);
    }
  }, {
    key: '__rowDoubleClick__REACT_HOT_LOADER__',
    value: function __rowDoubleClick__REACT_HOT_LOADER__(e) {
      if (e.target.tagName !== 'INPUT' && e.target.tagName !== 'SELECT' && e.target.tagName !== 'TEXTAREA') {
        if (this.props.onRowDoubleClick) {
          this.props.onRowDoubleClick(this.props.index, e);
        }
      }
    }
  }, {
    key: '__rowMouseOut__REACT_HOT_LOADER__',
    value: function __rowMouseOut__REACT_HOT_LOADER__(e) {
      var rowIndex = this.props.index;
      if (this.props.onRowMouseOut) {
        this.props.onRowMouseOut(rowIndex, e);
      }
    }
  }, {
    key: '__rowMouseOver__REACT_HOT_LOADER__',
    value: function __rowMouseOver__REACT_HOT_LOADER__(e) {
      var rowIndex = this.props.index;
      if (this.props.onRowMouseOver) {
        this.props.onRowMouseOver(rowIndex, e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      this.clickNum = 0;
      var _props2 = this.props,
          selectRow = _props2.selectRow,
          row = _props2.row,
          isSelected = _props2.isSelected,
          className = _props2.className,
          index = _props2.index,
          hidden = _props2.hidden;
      var style = this.props.style;

      var backgroundColor = null;
      var selectRowClass = null;

      if (selectRow) {
        backgroundColor = _util2.default.isFunction(selectRow.bgColor) ? selectRow.bgColor(row, isSelected) : isSelected ? selectRow.bgColor : null;

        selectRowClass = _util2.default.isFunction(selectRow.className) ? selectRow.className(row, isSelected) : isSelected ? selectRow.className : null;
      }

      if (_util2.default.isFunction(style)) {
        style = style(row, index);
      } else {
        style = _extends({}, style) || {};
      }
      // the bgcolor of row selection always overwrite the bgcolor defined by global.
      if (style && backgroundColor && isSelected) {
        style.backgroundColor = backgroundColor;
      }
      var trCss = {
        style: _extends({}, style),
        className: (0, _classnames2.default)(selectRowClass, className)
      };

      return _react2.default.createElement(
        'tr',
        _extends({}, trCss, {
          onMouseOver: this.rowMouseOver,
          onMouseOut: this.rowMouseOut,
          onClick: this.rowClick,
          hidden: hidden,
          onDoubleClick: this.rowDoubleClick }),
        this.props.children
      );
    }
  }]);

  return TableRow;
}(_react.Component);

TableRow.propTypes = {
  index: _propTypes2.default.number,
  row: _propTypes2.default.any,
  style: _propTypes2.default.any,
  isSelected: _propTypes2.default.bool,
  enableCellEdit: _propTypes2.default.bool,
  onRowClick: _propTypes2.default.func,
  onRowDoubleClick: _propTypes2.default.func,
  onSelectRow: _propTypes2.default.func,
  onExpandRow: _propTypes2.default.func,
  onRowMouseOut: _propTypes2.default.func,
  onRowMouseOver: _propTypes2.default.func,
  unselectableRow: _propTypes2.default.bool,
  hidden: _propTypes2.default.bool
};
TableRow.defaultProps = {
  onRowClick: undefined,
  onRowDoubleClick: undefined,
  hidden: false
};
var _default = TableRow;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TableRow, 'TableRow', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableRow.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableRow.js');
}();

;

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(22);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Const = __webpack_require__(7);

var _Const2 = _interopRequireDefault(_Const);

var _util = __webpack_require__(15);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TableColumn = function (_Component) {
  _inherits(TableColumn, _Component);

  function TableColumn(props) {
    _classCallCheck(this, TableColumn);

    var _this = _possibleConstructorReturn(this, (TableColumn.__proto__ || Object.getPrototypeOf(TableColumn)).call(this, props));

    _this.handleCellEdit = function () {
      return _this.__handleCellEdit__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleCellClick = function () {
      return _this.__handleCellClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleKeyDown = function () {
      return _this.__handleKeyDown__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    return _this;
  }
  /* eslint no-unused-vars: [0, { "args": "after-used" }] */


  _createClass(TableColumn, [{
    key: '__handleKeyDown__REACT_HOT_LOADER__',
    value: function __handleKeyDown__REACT_HOT_LOADER__() {
      return this.__handleKeyDown__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleCellClick__REACT_HOT_LOADER__',
    value: function __handleCellClick__REACT_HOT_LOADER__() {
      return this.__handleCellClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleCellEdit__REACT_HOT_LOADER__',
    value: function __handleCellEdit__REACT_HOT_LOADER__() {
      return this.__handleCellEdit__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var children = this.props.children;

      var shouldUpdated = this.props.width !== nextProps.width || this.props.className !== nextProps.className || this.props.hidden !== nextProps.hidden || this.props.dataAlign !== nextProps.dataAlign || this.props.isFocus !== nextProps.isFocus || (typeof children === 'undefined' ? 'undefined' : _typeof(children)) !== _typeof(nextProps.children) || ('' + this.props.onEdit).toString() !== ('' + nextProps.onEdit).toString();

      if (shouldUpdated) {
        return shouldUpdated;
      }

      if ((typeof children === 'undefined' ? 'undefined' : _typeof(children)) === 'object' && children !== null && children.props !== null) {
        if (children.props.type === 'checkbox' || children.props.type === 'radio') {
          shouldUpdated = shouldUpdated || children.props.type !== nextProps.children.props.type || children.props.checked !== nextProps.children.props.checked || children.props.disabled !== nextProps.children.props.disabled;
        } else {
          shouldUpdated = true;
        }
      } else {
        shouldUpdated = shouldUpdated || children !== nextProps.children;
      }

      if (shouldUpdated) {
        return shouldUpdated;
      }

      if (!(this.props.cellEdit && nextProps.cellEdit)) {
        return false;
      } else {
        return shouldUpdated || this.props.cellEdit.mode !== nextProps.cellEdit.mode;
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var dom = _reactDom2.default.findDOMNode(this);
      if (this.props.isFocus) {
        dom.focus();
      } else {
        dom.blur();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var dom = _reactDom2.default.findDOMNode(this);
      if (this.props.isFocus) {
        dom.focus();
      } else {
        dom.blur();
      }
    }
  }, {
    key: '__handleCellEdit__REACT_HOT_LOADER__',
    value: function __handleCellEdit__REACT_HOT_LOADER__(e) {
      try {
        if (this.props.cellEdit.mode === _Const2.default.CELL_EDIT_DBCLICK) {
          if (document.selection && document.selection.empty) {
            document.selection.empty();
          } else if (window.getSelection) {
            var sel = window.getSelection();
            sel.removeAllRanges();
          }
        }
      } catch (err) {} /* eslint no-empty: 0 */
      this.props.onEdit(this.props.rIndex + 1, e.currentTarget.cellIndex, e);
      if (this.props.cellEdit.mode !== _Const2.default.CELL_EDIT_DBCLICK) {
        this.props.onClick(e, this.props.rIndex + 1, e.currentTarget.cellIndex);
      }
    }
  }, {
    key: '__handleCellClick__REACT_HOT_LOADER__',
    value: function __handleCellClick__REACT_HOT_LOADER__(e) {
      var _props = this.props,
          onClick = _props.onClick,
          rIndex = _props.rIndex;

      if (onClick) {
        onClick(e, rIndex + 1, e.currentTarget.cellIndex);
      }
    }
  }, {
    key: '__handleKeyDown__REACT_HOT_LOADER__',
    value: function __handleKeyDown__REACT_HOT_LOADER__(e) {
      if (this.props.keyBoardNav) {
        this.props.onKeyDown(e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          children = _props2.children,
          columnTitle = _props2.columnTitle,
          dataAlign = _props2.dataAlign,
          hidden = _props2.hidden,
          cellEdit = _props2.cellEdit,
          attrs = _props2.attrs,
          style = _props2.style,
          isFocus = _props2.isFocus,
          keyBoardNav = _props2.keyBoardNav,
          tabIndex = _props2.tabIndex,
          customNavStyle = _props2.customNavStyle,
          withoutTabIndex = _props2.withoutTabIndex,
          row = _props2.row;
      var className = this.props.className;


      var tdStyle = _extends({
        textAlign: dataAlign,
        display: hidden ? 'none' : null
      }, style);

      var opts = {};

      if (cellEdit) {
        if (cellEdit.mode === _Const2.default.CELL_EDIT_CLICK) {
          opts.onClick = this.handleCellEdit;
        } else if (cellEdit.mode === _Const2.default.CELL_EDIT_DBCLICK) {
          opts.onDoubleClick = this.handleCellEdit;
        } else {
          opts.onClick = this.handleCellClick;
        }
      }

      if (keyBoardNav && isFocus) {
        opts.onKeyDown = this.handleKeyDown;
      }

      if (isFocus) {
        if (customNavStyle) {
          var cusmtStyle = _util2.default.isFunction(customNavStyle) ? customNavStyle(children, row) : customNavStyle;
          tdStyle = _extends({}, tdStyle, cusmtStyle);
        } else {
          className = className + ' default-focus-cell';
        }
      }

      var attr = {};
      if (!withoutTabIndex) attr.tabIndex = tabIndex;
      return _react2.default.createElement(
        'td',
        _extends({}, attr, { style: tdStyle,
          title: columnTitle,
          className: className
        }, opts, attrs),
        typeof children === 'boolean' ? children.toString() : children
      );
    }
  }]);

  return TableColumn;
}(_react.Component);

TableColumn.propTypes = {
  rIndex: _propTypes2.default.number,
  dataAlign: _propTypes2.default.string,
  hidden: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  columnTitle: _propTypes2.default.string,
  children: _propTypes2.default.node,
  onClick: _propTypes2.default.func,
  attrs: _propTypes2.default.object,
  style: _propTypes2.default.object,
  isFocus: _propTypes2.default.bool,
  onKeyDown: _propTypes2.default.func,
  tabIndex: _propTypes2.default.string,
  withoutTabIndex: _propTypes2.default.bool,
  keyBoardNav: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
  customNavStyle: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object]),
  row: _propTypes2.default.any /* only used on custom styling for navigation */
};

TableColumn.defaultProps = {
  dataAlign: 'left',
  withoutTabIndex: false,
  hidden: false,
  className: '',
  isFocus: false,
  keyBoardNav: false
};
var _default = TableColumn;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TableColumn, 'TableColumn', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableColumn.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableColumn.js');
}();

;

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(22);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Editor = __webpack_require__(226);

var _Editor2 = _interopRequireDefault(_Editor);

var _Notification = __webpack_require__(227);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _util = __webpack_require__(15);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TableEditColumn = function (_Component) {
  _inherits(TableEditColumn, _Component);

  function TableEditColumn(props) {
    _classCallCheck(this, TableEditColumn);

    var _this = _possibleConstructorReturn(this, (TableEditColumn.__proto__ || Object.getPrototypeOf(TableEditColumn)).call(this, props));

    _this.handleKeyPress = function () {
      return _this.__handleKeyPress__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleBlur = function () {
      return _this.__handleBlur__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleCustomUpdate = function () {
      return _this.__handleCustomUpdate__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.notifyToastr = function () {
      return _this.__notifyToastr__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleClick = function () {
      return _this.__handleClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.getInputRef = function () {
      return _this.__getInputRef__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.getHandleKeyPress = function () {
      return _this.__getHandleKeyPress__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.getHandleBlur = function () {
      return _this.__getHandleBlur__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.timeouteClear = 0;
    var _this$props = _this.props,
        fieldValue = _this$props.fieldValue,
        row = _this$props.row,
        className = _this$props.className;

    _this.focusInEditor = _this.focusInEditor.bind(_this);
    _this.state = {
      shakeEditor: false,
      className: _util2.default.isFunction(className) ? className(fieldValue, row) : className
    };
    return _this;
  }

  _createClass(TableEditColumn, [{
    key: '__getHandleBlur__REACT_HOT_LOADER__',
    value: function __getHandleBlur__REACT_HOT_LOADER__() {
      return this.__getHandleBlur__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__getHandleKeyPress__REACT_HOT_LOADER__',
    value: function __getHandleKeyPress__REACT_HOT_LOADER__() {
      return this.__getHandleKeyPress__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__getInputRef__REACT_HOT_LOADER__',
    value: function __getInputRef__REACT_HOT_LOADER__() {
      return this.__getInputRef__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleClick__REACT_HOT_LOADER__',
    value: function __handleClick__REACT_HOT_LOADER__() {
      return this.__handleClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__notifyToastr__REACT_HOT_LOADER__',
    value: function __notifyToastr__REACT_HOT_LOADER__() {
      return this.__notifyToastr__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleCustomUpdate__REACT_HOT_LOADER__',
    value: function __handleCustomUpdate__REACT_HOT_LOADER__() {
      return this.__handleCustomUpdate__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleBlur__REACT_HOT_LOADER__',
    value: function __handleBlur__REACT_HOT_LOADER__() {
      return this.__handleBlur__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleKeyPress__REACT_HOT_LOADER__',
    value: function __handleKeyPress__REACT_HOT_LOADER__() {
      return this.__handleKeyPress__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'valueShortCircuit',
    value: function valueShortCircuit(value) {
      return value === null || typeof value === 'undefined' ? '' : value;
    }
  }, {
    key: '__handleKeyPress__REACT_HOT_LOADER__',
    value: function __handleKeyPress__REACT_HOT_LOADER__(e) {
      if (e.keyCode === 13 || e.keyCode === 9) {
        // Pressed ENTER or TAB
        var value = e.currentTarget.type === 'checkbox' ? this._getCheckBoxValue(e) : e.currentTarget.value;

        if (e.keyCode === 9 && this.props.blurToSave || !this.validator(value)) {
          return;
        }

        if (e.keyCode === 13) {
          this.props.completeEdit(value, this.props.rowIndex, this.props.colIndex);
        } else {
          this.props.onTab(this.props.rowIndex + 1, this.props.colIndex + 1, 'tab', e);
          e.preventDefault();
        }
      } else if (e.keyCode === 27) {
        this.props.completeEdit(null, this.props.rowIndex, this.props.colIndex);
      } else if (e.type === 'click' && !this.props.blurToSave) {
        // textarea click save button
        var _value = e.target.parentElement.firstChild.value;
        if (!this.validator(_value)) {
          return;
        }
        this.props.completeEdit(_value, this.props.rowIndex, this.props.colIndex);
      }
    }
  }, {
    key: '__handleBlur__REACT_HOT_LOADER__',
    value: function __handleBlur__REACT_HOT_LOADER__(e) {
      e.stopPropagation();
      if (this.props.blurToSave) {
        var value = e.currentTarget.type === 'checkbox' ? this._getCheckBoxValue(e) : e.currentTarget.value;
        if (!this.validator(value)) {
          return false;
        }
        this.props.completeEdit(value, this.props.rowIndex, this.props.colIndex);
      } else if (this.props.blurToEscape) {
        this.props.completeEdit(null, this.props.rowIndex, this.props.colIndex);
      }
    }
  }, {
    key: '__handleCustomUpdate__REACT_HOT_LOADER__',


    // modified by iuculanop
    // BEGIN
    value: function __handleCustomUpdate__REACT_HOT_LOADER__(value) {
      if (!this.validator(value)) {
        return;
      }
      this.props.completeEdit(value, this.props.rowIndex, this.props.colIndex);
    }
  }, {
    key: 'validator',
    value: function validator(value) {
      var ts = this;
      var valid = true;
      if (ts.props.editable.validator) {
        var checkVal = ts.props.editable.validator(value, this.props.row);
        var responseType = typeof checkVal === 'undefined' ? 'undefined' : _typeof(checkVal);
        if (responseType !== 'object' && checkVal !== true) {
          valid = false;
          this.notifyToastr('error', checkVal, '');
        } else if (responseType === 'object' && checkVal.isValid !== true) {
          valid = false;
          this.notifyToastr(checkVal.notification.type, checkVal.notification.msg, checkVal.notification.title);
        }
        if (!valid) {
          // animate input
          ts.clearTimeout();
          var _props = this.props,
              invalidColumnClassName = _props.invalidColumnClassName,
              row = _props.row;

          var className = _util2.default.isFunction(invalidColumnClassName) ? invalidColumnClassName(value, row) : invalidColumnClassName;
          ts.setState({ shakeEditor: true, className: className });
          ts.timeouteClear = setTimeout(function () {
            ts.setState({ shakeEditor: false });
          }, 300);
          this.focusInEditor();
          return valid;
        }
      }
      return valid;
    }
    // END

  }, {
    key: '__notifyToastr__REACT_HOT_LOADER__',
    value: function __notifyToastr__REACT_HOT_LOADER__(type, message, title) {
      var toastr = true;
      var beforeShowError = this.props.beforeShowError;

      if (beforeShowError) {
        toastr = beforeShowError(type, message, title);
      }
      if (toastr) {
        (0, _Notification.notice)(type, message, title);
      }
    }
  }, {
    key: 'clearTimeout',
    value: function (_clearTimeout) {
      function clearTimeout() {
        return _clearTimeout.apply(this, arguments);
      }

      clearTimeout.toString = function () {
        return _clearTimeout.toString();
      };

      return clearTimeout;
    }(function () {
      if (this.timeouteClear !== 0) {
        clearTimeout(this.timeouteClear);
        this.timeouteClear = 0;
      }
    })
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.focusInEditor();
      var dom = _reactDom2.default.findDOMNode(this);
      if (this.props.isFocus) {
        dom.focus();
      } else {
        dom.blur();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var dom = _reactDom2.default.findDOMNode(this);
      if (this.props.isFocus) {
        dom.focus();
      } else {
        dom.blur();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clearTimeout();
    }
  }, {
    key: 'focusInEditor',
    value: function focusInEditor() {
      if (this.inputRef && _util2.default.isFunction(this.inputRef.focus)) {
        this.inputRef.focus();
      }
    }
  }, {
    key: '__handleClick__REACT_HOT_LOADER__',
    value: function __handleClick__REACT_HOT_LOADER__(e) {
      if (e.target.tagName !== 'TD') {
        e.stopPropagation();
      }
    }
  }, {
    key: '__getInputRef__REACT_HOT_LOADER__',
    value: function __getInputRef__REACT_HOT_LOADER__(userRef) {
      var _this2 = this;

      return function (ref) {
        _this2.inputRef = ref;
        if (_util2.default.isFunction(userRef)) {
          userRef(ref);
        } else if (typeof userRef === 'string') {
          throw new Error('Ref must be a function');
        }
      };
    }
  }, {
    key: '__getHandleKeyPress__REACT_HOT_LOADER__',
    value: function __getHandleKeyPress__REACT_HOT_LOADER__(customHandler) {
      var _this3 = this;

      return function (e) {
        _this3.handleKeyPress(e);
        if (_util2.default.isFunction(customHandler)) {
          customHandler(e);
        }
      };
    }
  }, {
    key: '__getHandleBlur__REACT_HOT_LOADER__',
    value: function __getHandleBlur__REACT_HOT_LOADER__(customHandler) {
      var _this4 = this;

      return function (e) {
        _this4.handleBlur(e);
        if (_util2.default.isFunction(customHandler)) {
          customHandler(e);
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          editable = _props2.editable,
          format = _props2.format,
          customEditor = _props2.customEditor,
          isFocus = _props2.isFocus,
          customStyleWithNav = _props2.customStyleWithNav,
          row = _props2.row,
          attrs = _props2.attrs;
      var shakeEditor = this.state.shakeEditor;

      var attr = _extends({}, editable.attrs, {
        ref: this.getInputRef(editable.attrs && editable.attrs.ref),
        onKeyDown: this.getHandleKeyPress(editable.attrs && editable.attrs.onKeyDown),
        onBlur: this.getHandleBlur(editable.attrs && editable.attrs.onBlur)
      });
      var style = { position: 'relative' };
      var fieldValue = this.props.fieldValue;
      var className = this.state.className;


      if (editable.placeholder) {
        attr.placeholder = editable.placeholder;
        /* eslint-disable no-console */
        console.warn('Setting editable.placeholder is deprecated. Use editable.attrs to set input attributes');
        /* eslint-enable no-console */
      }

      var editorClass = (0, _classnames2.default)({ 'animated': shakeEditor, 'shake': shakeEditor });
      fieldValue = fieldValue === 0 ? '0' : fieldValue;
      var cellEditor = void 0;
      if (customEditor) {
        var customEditorProps = _extends({
          row: row
        }, attr, {
          defaultValue: this.valueShortCircuit(fieldValue)
        }, customEditor.customEditorParameters);
        cellEditor = customEditor.getElement(this.handleCustomUpdate, customEditorProps);
      } else {
        cellEditor = (0, _Editor2.default)(editable, attr, format, editorClass, this.valueShortCircuit(fieldValue), null, row);
      }

      if (isFocus) {
        if (customStyleWithNav) {
          var customStyle = _util2.default.isFunction(customStyleWithNav) ? customStyleWithNav(fieldValue, row) : customStyleWithNav;
          style = _extends({}, style, customStyle);
        } else {
          className = className + ' default-focus-cell';
        }
      }

      return _react2.default.createElement(
        'td',
        _extends({}, attrs, {
          style: style,
          className: className,
          onClick: this.handleClick }),
        cellEditor
      );
    }
  }, {
    key: '_getCheckBoxValue',
    value: function _getCheckBoxValue(e) {
      var value = '';
      var values = e.currentTarget.value.split(':');
      value = e.currentTarget.checked ? values[0] : values[1];
      return value;
    }
  }]);

  return TableEditColumn;
}(_react.Component);

TableEditColumn.propTypes = {
  completeEdit: _propTypes2.default.func,
  rowIndex: _propTypes2.default.number,
  colIndex: _propTypes2.default.number,
  blurToSave: _propTypes2.default.bool,
  blurToEscape: _propTypes2.default.bool,
  editable: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
  format: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]),
  row: _propTypes2.default.any,
  fieldValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool, _propTypes2.default.number, _propTypes2.default.array, _propTypes2.default.object]),
  className: _propTypes2.default.any,
  beforeShowError: _propTypes2.default.func,
  isFocus: _propTypes2.default.bool,
  attrs: _propTypes2.default.object,
  customStyleWithNav: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object])
};

var _default = TableEditColumn;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TableEditColumn, 'TableEditColumn', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableEditColumn.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableEditColumn.js');
}();

;

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint max-len: 0 */
/* eslint no-nested-ternary: 0 */


var ExpandComponent = function (_Component) {
  _inherits(ExpandComponent, _Component);

  function ExpandComponent() {
    _classCallCheck(this, ExpandComponent);

    return _possibleConstructorReturn(this, (ExpandComponent.__proto__ || Object.getPrototypeOf(ExpandComponent)).apply(this, arguments));
  }

  _createClass(ExpandComponent, [{
    key: 'render',
    value: function render() {
      var className = this.props.className;

      var trCss = {
        style: {
          backgroundColor: this.props.bgColor
        },
        className: (0, _classnames2.default)(className)
      };
      return _react2.default.createElement(
        'tr',
        _extends({ hidden: this.props.hidden, width: this.props.width }, trCss),
        _react2.default.createElement(
          'td',
          { colSpan: this.props.colSpan },
          this.props.children
        )
      );
    }
  }]);

  return ExpandComponent;
}(_react.Component);

var _default = ExpandComponent;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ExpandComponent, 'ExpandComponent', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/ExpandComponent.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/ExpandComponent.js');
}();

;

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _PageButton = __webpack_require__(574);

var _PageButton2 = _interopRequireDefault(_PageButton);

var _SizePerPageDropDown = __webpack_require__(228);

var _SizePerPageDropDown2 = _interopRequireDefault(_SizePerPageDropDown);

var _Const = __webpack_require__(7);

var _Const2 = _interopRequireDefault(_Const);

var _util = __webpack_require__(15);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PaginationList = function (_Component) {
  _inherits(PaginationList, _Component);

  function PaginationList(props) {
    _classCallCheck(this, PaginationList);

    var _this = _possibleConstructorReturn(this, (PaginationList.__proto__ || Object.getPrototypeOf(PaginationList)).call(this, props));

    _this.changePage = function () {
      return _this.__changePage__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.changeSizePerPage = function () {
      return _this.__changeSizePerPage__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.toggleDropDown = function () {
      return _this.__toggleDropDown__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.closeDropDown = function () {
      return _this.__closeDropDown__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.state = {
      open: _this.props.open
    };
    return _this;
  }

  _createClass(PaginationList, [{
    key: '__closeDropDown__REACT_HOT_LOADER__',
    value: function __closeDropDown__REACT_HOT_LOADER__() {
      return this.__closeDropDown__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__toggleDropDown__REACT_HOT_LOADER__',
    value: function __toggleDropDown__REACT_HOT_LOADER__() {
      return this.__toggleDropDown__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__changeSizePerPage__REACT_HOT_LOADER__',
    value: function __changeSizePerPage__REACT_HOT_LOADER__() {
      return this.__changeSizePerPage__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__changePage__REACT_HOT_LOADER__',
    value: function __changePage__REACT_HOT_LOADER__() {
      return this.__changePage__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      var keepSizePerPageState = this.props.keepSizePerPageState;

      if (!keepSizePerPageState) {
        this.closeDropDown();
      }
    }
  }, {
    key: '__changePage__REACT_HOT_LOADER__',
    value: function __changePage__REACT_HOT_LOADER__(page) {
      var _props = this.props,
          pageStartIndex = _props.pageStartIndex,
          prePage = _props.prePage,
          currPage = _props.currPage,
          nextPage = _props.nextPage,
          lastPage = _props.lastPage,
          firstPage = _props.firstPage,
          sizePerPage = _props.sizePerPage,
          keepSizePerPageState = _props.keepSizePerPageState;


      if (page === prePage) {
        page = currPage - 1 < pageStartIndex ? pageStartIndex : currPage - 1;
      } else if (page === nextPage) {
        page = currPage + 1 > this.lastPage ? this.lastPage : currPage + 1;
      } else if (page === lastPage) {
        page = this.lastPage;
      } else if (page === firstPage) {
        page = pageStartIndex;
      } else {
        page = parseInt(page, 10);
      }

      if (keepSizePerPageState) {
        this.closeDropDown();
      }

      if (page !== currPage) {
        this.props.changePage(page, sizePerPage);
      }
    }
  }, {
    key: '__changeSizePerPage__REACT_HOT_LOADER__',
    value: function __changeSizePerPage__REACT_HOT_LOADER__(pageNum) {
      var selectSize = typeof pageNum === 'string' ? parseInt(pageNum, 10) : pageNum;
      var currPage = this.props.currPage;

      if (selectSize !== this.props.sizePerPage) {
        this.totalPages = Math.ceil(this.props.dataSize / selectSize);
        this.lastPage = this.props.pageStartIndex + this.totalPages - 1;
        if (currPage > this.lastPage) currPage = this.lastPage;
        this.props.changePage(currPage, selectSize);
        if (this.props.onSizePerPageList) {
          this.props.onSizePerPageList(selectSize);
        }
      }

      this.closeDropDown();
    }
  }, {
    key: '__toggleDropDown__REACT_HOT_LOADER__',
    value: function __toggleDropDown__REACT_HOT_LOADER__() {
      var _this2 = this;

      this.setState(function () {
        return {
          open: !_this2.state.open
        };
      });
    }
  }, {
    key: '__closeDropDown__REACT_HOT_LOADER__',
    value: function __closeDropDown__REACT_HOT_LOADER__() {
      this.setState(function () {
        return {
          open: false
        };
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          currPage = _props2.currPage,
          dataSize = _props2.dataSize,
          sizePerPage = _props2.sizePerPage,
          sizePerPageList = _props2.sizePerPageList,
          paginationShowsTotal = _props2.paginationShowsTotal,
          pageStartIndex = _props2.pageStartIndex,
          paginationPanel = _props2.paginationPanel,
          hidePageListOnlyOnePage = _props2.hidePageListOnlyOnePage;

      this.totalPages = Math.ceil(dataSize / sizePerPage);
      this.lastPage = this.props.pageStartIndex + this.totalPages - 1;
      var pageBtns = this.makePage(_util2.default.isFunction(paginationPanel));
      var dropdown = this.makeDropDown();

      var offset = Math.abs(_Const2.default.PAGE_START_INDEX - pageStartIndex);
      var start = (currPage - pageStartIndex) * sizePerPage;
      start = dataSize === 0 ? 0 : start + 1;
      var to = Math.min(sizePerPage * (currPage + offset) - 1, dataSize);
      if (to >= dataSize) to--;
      var total = paginationShowsTotal ? _react2.default.createElement(
        'span',
        null,
        'Showing rows ',
        start,
        ' to\xA0',
        to + 1,
        ' of\xA0',
        dataSize
      ) : null;

      if (_util2.default.isFunction(paginationShowsTotal)) {
        total = paginationShowsTotal(start, to + 1, dataSize);
      }

      var content = paginationPanel && paginationPanel({
        currPage: currPage,
        sizePerPage: sizePerPage,
        sizePerPageList: sizePerPageList,
        pageStartIndex: pageStartIndex,
        totalPages: this.totalPages,
        changePage: this.changePage,
        toggleDropDown: this.toggleDropDown,
        changeSizePerPage: this.changeSizePerPage,
        components: {
          totalText: total,
          sizePerPageDropdown: dropdown,
          pageList: pageBtns
        }
      });

      var hidePageList = hidePageListOnlyOnePage && this.totalPages === 1 ? 'none' : 'block';
      return _react2.default.createElement(
        'div',
        { className: 'row', style: { marginTop: 15 } },
        content || [_react2.default.createElement(
          'div',
          { key: 'paging-left', className: 'col-md-6 col-xs-6 col-sm-6 col-lg-6' },
          total,
          sizePerPageList.length > 1 ? dropdown : null
        ), _react2.default.createElement(
          'div',
          { key: 'paging-right', style: { display: hidePageList },
            className: 'col-md-6 col-xs-6 col-sm-6 col-lg-6' },
          pageBtns
        )]
      );
    }
  }, {
    key: 'makeDropDown',
    value: function makeDropDown() {
      var _this3 = this;

      var dropdown = void 0;
      var dropdownProps = void 0;
      var sizePerPageText = '';
      var _props3 = this.props,
          sizePerPageDropDown = _props3.sizePerPageDropDown,
          hideSizePerPage = _props3.hideSizePerPage,
          sizePerPage = _props3.sizePerPage,
          sizePerPageList = _props3.sizePerPageList;

      if (sizePerPageDropDown) {
        dropdown = sizePerPageDropDown({
          open: this.state.open,
          hideSizePerPage: hideSizePerPage,
          currSizePerPage: String(sizePerPage),
          sizePerPageList: sizePerPageList,
          toggleDropDown: this.toggleDropDown,
          changeSizePerPage: this.changeSizePerPage,
          onBlur: this.closeDropDown
        });
        if (dropdown.type.name === _SizePerPageDropDown2.default.name) {
          dropdownProps = dropdown.props;
        } else {
          return dropdown;
        }
      }

      if (dropdownProps || !dropdown) {
        var isBootstrap4 = _util2.default.isBootstrap4(this.props.version);
        var sizePerPageOptions = sizePerPageList.map(function (_sizePerPage) {
          var pageText = _sizePerPage.text || _sizePerPage;
          var pageNum = _sizePerPage.value || _sizePerPage;
          if (sizePerPage === pageNum) sizePerPageText = pageText;
          if (isBootstrap4) {
            return _react2.default.createElement(
              'a',
              {
                href: '#',
                tabIndex: '-1',
                key: pageText,
                className: 'dropdown-item',
                onMouseDown: function onMouseDown(e) {
                  e.preventDefault();
                  _this3.changeSizePerPage(pageNum);
                } },
              pageText
            );
          } else {
            return _react2.default.createElement(
              'li',
              { key: pageText, role: 'presentation', className: 'dropdown-item' },
              _react2.default.createElement(
                'a',
                { role: 'menuitem',
                  tabIndex: '-1', href: '#',
                  'data-page': pageNum,
                  onMouseDown: function onMouseDown(e) {
                    e.preventDefault();
                    _this3.changeSizePerPage(pageNum);
                  } },
                pageText
              )
            );
          }
        });
        dropdown = _react2.default.createElement(_SizePerPageDropDown2.default, _extends({
          open: this.state.open,
          hidden: hideSizePerPage,
          currSizePerPage: String(sizePerPageText),
          options: sizePerPageOptions,
          onClick: this.toggleDropDown,
          onBlur: this.closeDropDown,
          isBootstrap4: isBootstrap4
        }, dropdownProps));
      }
      return dropdown;
    }
  }, {
    key: 'makePage',
    value: function makePage() {
      var _this4 = this;

      var isCustomPagingPanel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var pages = this.getPages();
      var isStart = function isStart(page, _ref) {
        var currPage = _ref.currPage,
            pageStartIndex = _ref.pageStartIndex,
            firstPage = _ref.firstPage,
            prePage = _ref.prePage;
        return currPage === pageStartIndex && (page === firstPage || page === prePage);
      };
      var isEnd = function isEnd(page, _ref2) {
        var currPage = _ref2.currPage,
            nextPage = _ref2.nextPage,
            lastPage = _ref2.lastPage;
        return currPage === _this4.lastPage && (page === nextPage || page === lastPage);
      };
      var pageBtns = pages.filter(function (page) {
        if (this.props.alwaysShowAllBtns) {
          return true;
        }
        return isStart(page, this.props) || isEnd(page, this.props) ? false : true;
      }, this).map(function (page, index) {
        var isActive = page === this.props.currPage;
        var isDisabled = isStart(page, this.props) || isEnd(page, this.props) ? true : false;
        var title = page + '';
        var pageNumber = page;

        if (page === this.props.nextPage) {
          title = this.props.nextPageTitle;
          pageNumber = this.props.currPage + 1;
        } else if (page === this.props.prePage) {
          title = this.props.prePageTitle;
          pageNumber = this.props.currPage - 1;
        } else if (page === this.props.firstPage) {
          title = this.props.firstPageTitle;
          pageNumber = this.props.pageStartIndex;
        } else if (page === this.props.lastPage) {
          title = this.props.lastPageTitle;
          pageNumber = this.getLastPage();
        }

        return _react2.default.createElement(
          _PageButton2.default,
          { key: index,
            title: title,
            changePage: this.changePage,
            active: isActive,
            disable: isDisabled,
            pageNumber: pageNumber },
          page
        );
      }, this);
      var classname = (0, _classnames2.default)(isCustomPagingPanel ? null : 'react-bootstrap-table-page-btns-ul', 'pagination');
      return _react2.default.createElement(
        'ul',
        { className: classname },
        pageBtns
      );
    }
  }, {
    key: 'getLastPage',
    value: function getLastPage() {
      return this.lastPage;
    }
  }, {
    key: 'getPages',
    value: function getPages() {
      var pages = void 0;
      var endPage = this.totalPages;
      if (endPage <= 0) return [];
      var startPage = Math.max(this.props.currPage - Math.floor(this.props.paginationSize / 2), this.props.pageStartIndex);
      endPage = startPage + this.props.paginationSize - 1;

      if (endPage > this.lastPage) {
        endPage = this.lastPage;
        startPage = endPage - this.props.paginationSize + 1;
      }

      if (startPage !== this.props.pageStartIndex && this.totalPages > this.props.paginationSize && this.props.withFirstAndLast) {
        pages = [this.props.firstPage, this.props.prePage];
      } else if (this.totalPages > 1 || this.props.alwaysShowAllBtns) {
        pages = [this.props.prePage];
      } else {
        pages = [];
      }

      for (var i = startPage; i <= endPage; i++) {
        if (i >= this.props.pageStartIndex) pages.push(i);
      }

      if (endPage <= this.lastPage && pages.length > 1) {
        pages.push(this.props.nextPage);
      }
      if (endPage !== this.lastPage && this.props.withFirstAndLast) {
        pages.push(this.props.lastPage);
      }

      return pages;
    }
  }]);

  return PaginationList;
}(_react.Component);

PaginationList.propTypes = {
  currPage: _propTypes2.default.number,
  sizePerPage: _propTypes2.default.number,
  dataSize: _propTypes2.default.number,
  changePage: _propTypes2.default.func,
  sizePerPageList: _propTypes2.default.array,
  paginationShowsTotal: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]),
  paginationSize: _propTypes2.default.number,
  onSizePerPageList: _propTypes2.default.func,
  prePage: _propTypes2.default.any,
  nextPage: _propTypes2.default.any,
  firstPage: _propTypes2.default.any,
  lastPage: _propTypes2.default.any,
  pageStartIndex: _propTypes2.default.number,
  hideSizePerPage: _propTypes2.default.bool,
  alwaysShowAllBtns: _propTypes2.default.bool,
  withFirstAndLast: _propTypes2.default.bool,
  sizePerPageDropDown: _propTypes2.default.func,
  paginationPanel: _propTypes2.default.func,
  prePageTitle: _propTypes2.default.string,
  nextPageTitle: _propTypes2.default.string,
  firstPageTitle: _propTypes2.default.string,
  lastPageTitle: _propTypes2.default.string,
  hidePageListOnlyOnePage: _propTypes2.default.bool,
  keepSizePerPageState: _propTypes2.default.bool
};

PaginationList.defaultProps = {
  sizePerPage: _Const2.default.SIZE_PER_PAGE,
  pageStartIndex: _Const2.default.PAGE_START_INDEX
};

var _default = PaginationList;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(PaginationList, 'PaginationList', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/pagination/PaginationList.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/pagination/PaginationList.js');
}();

;

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PageButton = function (_Component) {
  _inherits(PageButton, _Component);

  function PageButton(props) {
    _classCallCheck(this, PageButton);

    var _this = _possibleConstructorReturn(this, (PageButton.__proto__ || Object.getPrototypeOf(PageButton)).call(this, props));

    _this.pageBtnClick = function () {
      return _this.__pageBtnClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    return _this;
  }

  _createClass(PageButton, [{
    key: '__pageBtnClick__REACT_HOT_LOADER__',
    value: function __pageBtnClick__REACT_HOT_LOADER__() {
      return this.__pageBtnClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__pageBtnClick__REACT_HOT_LOADER__',
    value: function __pageBtnClick__REACT_HOT_LOADER__(e) {
      e.preventDefault();
      this.props.changePage(this.props.pageNumber);
    }
  }, {
    key: 'render',
    value: function render() {
      var classes = (0, _classnames2.default)({
        'active': this.props.active,
        'disabled': this.props.disable,
        'hidden': this.props.hidden,
        'page-item': true
      });
      return _react2.default.createElement(
        'li',
        { className: classes, title: this.props.title },
        _react2.default.createElement(
          'a',
          { href: '#', onClick: this.pageBtnClick, className: 'page-link' },
          this.props.children
        )
      );
    }
  }]);

  return PageButton;
}(_react.Component);

PageButton.propTypes = {
  title: _propTypes2.default.string,
  changePage: _propTypes2.default.func,
  active: _propTypes2.default.bool,
  disable: _propTypes2.default.bool,
  hidden: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  pageNumber: _propTypes2.default.number
};

var _default = PageButton;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(PageButton, 'PageButton', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/pagination/PageButton.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/pagination/PageButton.js');
}();

;

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactModal = __webpack_require__(576);

var _reactModal2 = _interopRequireDefault(_reactModal);

var _Const = __webpack_require__(7);

var _Const2 = _interopRequireDefault(_Const);

var _Notification = __webpack_require__(227);

var _InsertModal = __webpack_require__(584);

var _InsertModal2 = _interopRequireDefault(_InsertModal);

var _InsertButton = __webpack_require__(236);

var _InsertButton2 = _interopRequireDefault(_InsertButton);

var _DeleteButton = __webpack_require__(237);

var _DeleteButton2 = _interopRequireDefault(_DeleteButton);

var _ExportCSVButton = __webpack_require__(238);

var _ExportCSVButton2 = _interopRequireDefault(_ExportCSVButton);

var _ShowSelectedOnlyButton = __webpack_require__(239);

var _ShowSelectedOnlyButton2 = _interopRequireDefault(_ShowSelectedOnlyButton);

var _SearchField = __webpack_require__(240);

var _SearchField2 = _interopRequireDefault(_SearchField);

var _ClearSearchButton = __webpack_require__(241);

var _ClearSearchButton2 = _interopRequireDefault(_ClearSearchButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-console: 0 */

// import classSet from 'classnames';

// import editor from '../Editor';


var ToolBar = function (_Component) {
  _inherits(ToolBar, _Component);

  function ToolBar(props) {
    _classCallCheck(this, ToolBar);

    var _this = _possibleConstructorReturn(this, (ToolBar.__proto__ || Object.getPrototypeOf(ToolBar)).call(this, props));

    _this.displayCommonMessage = function () {
      return _this.__displayCommonMessage__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleSaveBtnClick = function () {
      return _this.__handleSaveBtnClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.afterHandleSaveBtnClick = function () {
      return _this.__afterHandleSaveBtnClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleModalClose = function () {
      return _this.__handleModalClose__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleModalOpen = function () {
      return _this.__handleModalOpen__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleShowOnlyToggle = function () {
      return _this.__handleShowOnlyToggle__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleDropRowBtnClick = function () {
      return _this.__handleDropRowBtnClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleDebounce = function () {
      return _this.__handleDebounce__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleKeyUp = function () {
      return _this.__handleKeyUp__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleExportCSV = function () {
      return _this.__handleExportCSV__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleClearBtnClick = function () {
      return _this.__handleClearBtnClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.timeouteClear = 0;
    _this.modalClassName;
    _this.state = {
      isInsertModalOpen: false,
      validateState: null,
      shakeEditor: false,
      showSelected: false
    };
    return _this;
  }

  _createClass(ToolBar, [{
    key: '__handleClearBtnClick__REACT_HOT_LOADER__',
    value: function __handleClearBtnClick__REACT_HOT_LOADER__() {
      return this.__handleClearBtnClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleExportCSV__REACT_HOT_LOADER__',
    value: function __handleExportCSV__REACT_HOT_LOADER__() {
      return this.__handleExportCSV__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleKeyUp__REACT_HOT_LOADER__',
    value: function __handleKeyUp__REACT_HOT_LOADER__() {
      return this.__handleKeyUp__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleDebounce__REACT_HOT_LOADER__',
    value: function __handleDebounce__REACT_HOT_LOADER__(func, wait, immediate) {
      var _this2 = this,
          _arguments = arguments;

      var timeout = void 0;

      return function () {
        var later = function later() {
          timeout = null;

          if (!immediate) {
            func.apply(_this2, _arguments);
          }
        };

        var callNow = immediate && !timeout;

        clearTimeout(timeout);

        timeout = setTimeout(later, wait || 0);

        if (callNow) {
          func.appy(_this2, _arguments);
        }
      };
    }
  }, {
    key: '__handleDropRowBtnClick__REACT_HOT_LOADER__',
    value: function __handleDropRowBtnClick__REACT_HOT_LOADER__() {
      return this.__handleDropRowBtnClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleShowOnlyToggle__REACT_HOT_LOADER__',
    value: function __handleShowOnlyToggle__REACT_HOT_LOADER__() {
      return this.__handleShowOnlyToggle__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleModalOpen__REACT_HOT_LOADER__',
    value: function __handleModalOpen__REACT_HOT_LOADER__() {
      return this.__handleModalOpen__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleModalClose__REACT_HOT_LOADER__',
    value: function __handleModalClose__REACT_HOT_LOADER__() {
      return this.__handleModalClose__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__afterHandleSaveBtnClick__REACT_HOT_LOADER__',
    value: function __afterHandleSaveBtnClick__REACT_HOT_LOADER__() {
      return this.__afterHandleSaveBtnClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleSaveBtnClick__REACT_HOT_LOADER__',
    value: function __handleSaveBtnClick__REACT_HOT_LOADER__() {
      return this.__handleSaveBtnClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__displayCommonMessage__REACT_HOT_LOADER__',
    value: function __displayCommonMessage__REACT_HOT_LOADER__() {
      return this.__displayCommonMessage__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this3 = this;

      var delay = this.props.searchDelayTime ? this.props.searchDelayTime : 0;
      this.debounceCallback = this.handleDebounce(function () {
        _this3.seachInput && _this3.props.onSearch(_this3.seachInput.getValue());
      }, delay);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.reset) {
        this.setSearchInput('');
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clearTimeout();
    }
  }, {
    key: 'setSearchInput',
    value: function setSearchInput(text) {
      if (this.seachInput && this.seachInput.value !== text) {
        this.seachInput.value = text;
      }
    }
  }, {
    key: 'clearTimeout',
    value: function (_clearTimeout) {
      function clearTimeout() {
        return _clearTimeout.apply(this, arguments);
      }

      clearTimeout.toString = function () {
        return _clearTimeout.toString();
      };

      return clearTimeout;
    }(function () {
      if (this.timeouteClear) {
        clearTimeout(this.timeouteClear);
        this.timeouteClear = 0;
      }
    })
  }, {
    key: '__displayCommonMessage__REACT_HOT_LOADER__',
    value: function __displayCommonMessage__REACT_HOT_LOADER__() {
      (0, _Notification.notice)('error', this.props.insertFailIndicator, '');
    }
  }, {
    key: 'validateNewRow',
    value: function validateNewRow(newRow) {
      var _this4 = this;

      var validateState = {};
      var isValid = true;
      var tempMsg = void 0;
      var responseType = void 0;

      this.props.columns.forEach(function (column) {
        if (column.isKey && column.keyValidator) {
          // key validator for checking exist key
          tempMsg = _this4.props.isValidKey(newRow[column.field]);
          if (tempMsg) {
            _this4.displayCommonMessage();
            isValid = false;
            validateState[column.field] = tempMsg;
          }
        } else if (column.editable && column.editable.validator) {
          // process validate
          tempMsg = column.editable.validator(newRow[column.field], newRow);
          responseType = typeof tempMsg === 'undefined' ? 'undefined' : _typeof(tempMsg);
          if (responseType !== 'object' && tempMsg !== true) {
            _this4.displayCommonMessage();
            isValid = false;
            validateState[column.field] = tempMsg;
          } else if (responseType === 'object' && tempMsg.isValid !== true) {
            (0, _Notification.notice)(tempMsg.notification.type, tempMsg.notification.msg, tempMsg.notification.title);
            isValid = false;
            validateState[column.field] = tempMsg.notification.msg;
          }
        }
      });

      if (isValid) {
        return true;
      } else {
        this.clearTimeout();
        // show error in form and shake it
        this.setState(function () {
          return { validateState: validateState, shakeEditor: true };
        });
        this.timeouteClear = setTimeout(function () {
          _this4.setState(function () {
            return { shakeEditor: false };
          });
        }, 300);
        return null;
      }
    }
  }, {
    key: '__handleSaveBtnClick__REACT_HOT_LOADER__',
    value: function __handleSaveBtnClick__REACT_HOT_LOADER__(newRow) {
      if (!this.validateNewRow(newRow)) {
        // validation fail
        return;
      }
      var msg = this.props.onAddRow(newRow);
      if (msg !== false) {
        this.afterHandleSaveBtnClick(msg);
      }
    }
  }, {
    key: '__afterHandleSaveBtnClick__REACT_HOT_LOADER__',
    value: function __afterHandleSaveBtnClick__REACT_HOT_LOADER__(msg) {
      var _this5 = this;

      if (msg) {
        (0, _Notification.notice)('error', msg, '');
        this.clearTimeout();
        // shake form and hack prevent modal hide
        this.setState(function () {
          return {
            shakeEditor: true,
            validateState: 'this is hack for prevent bootstrap modal hide'
          };
        });
        // clear animate class
        this.timeouteClear = setTimeout(function () {
          _this5.setState(function () {
            return { shakeEditor: false };
          });
        }, 300);
      } else {
        // reset state and hide modal hide
        this.setState(function () {
          return {
            validateState: null,
            shakeEditor: false,
            isInsertModalOpen: false
          };
        });
      }
    }
  }, {
    key: '__handleModalClose__REACT_HOT_LOADER__',
    value: function __handleModalClose__REACT_HOT_LOADER__() {
      this.setState(function () {
        return { isInsertModalOpen: false };
      });
    }
  }, {
    key: '__handleModalOpen__REACT_HOT_LOADER__',
    value: function __handleModalOpen__REACT_HOT_LOADER__() {
      this.setState(function () {
        return { isInsertModalOpen: true };
      });
    }
  }, {
    key: '__handleShowOnlyToggle__REACT_HOT_LOADER__',
    value: function __handleShowOnlyToggle__REACT_HOT_LOADER__() {
      var _this6 = this;

      this.setState(function () {
        return {
          showSelected: !_this6.state.showSelected
        };
      });
      this.props.onShowOnlySelected();
    }
  }, {
    key: '__handleDropRowBtnClick__REACT_HOT_LOADER__',
    value: function __handleDropRowBtnClick__REACT_HOT_LOADER__() {
      this.props.onDropRow();
    }
  }, {
    key: '__handleKeyUp__REACT_HOT_LOADER__',
    value: function __handleKeyUp__REACT_HOT_LOADER__(event) {
      event.persist();
      this.debounceCallback(event);
    }
  }, {
    key: '__handleExportCSV__REACT_HOT_LOADER__',
    value: function __handleExportCSV__REACT_HOT_LOADER__() {
      this.props.onExportCSV();
    }
  }, {
    key: '__handleClearBtnClick__REACT_HOT_LOADER__',
    value: function __handleClearBtnClick__REACT_HOT_LOADER__() {
      this.seachInput && this.seachInput.setValue('');
      this.props.onSearch('');
    }
  }, {
    key: 'render',
    value: function render() {
      this.modalClassName = 'bs-table-modal-sm' + ToolBar.modalSeq++;
      var toolbar = null;
      var btnGroup = null;
      var insertBtn = null;
      var deleteBtn = null;
      var exportCSVBtn = null;
      var showSelectedOnlyBtn = null;

      if (this.props.enableInsert) {
        if (this.props.insertBtn) {
          insertBtn = this.renderCustomBtn(this.props.insertBtn, [this.handleModalOpen], _InsertButton2.default.name, 'onClick', this.handleModalOpen);
        } else {
          insertBtn = _react2.default.createElement(_InsertButton2.default, { btnText: this.props.insertText,
            onClick: this.handleModalOpen });
        }
      }

      if (this.props.enableDelete) {
        if (this.props.deleteBtn) {
          deleteBtn = this.renderCustomBtn(this.props.deleteBtn, [this.handleDropRowBtnClick], _DeleteButton2.default.name, 'onClick', this.handleDropRowBtnClick);
        } else {
          deleteBtn = _react2.default.createElement(_DeleteButton2.default, { btnText: this.props.deleteText,
            onClick: this.handleDropRowBtnClick });
        }
      }

      if (this.props.enableShowOnlySelected) {
        if (this.props.showSelectedOnlyBtn) {
          showSelectedOnlyBtn = this.renderCustomBtn(this.props.showSelectedOnlyBtn, [this.handleShowOnlyToggle, this.state.showSelected], _ShowSelectedOnlyButton2.default.name, 'onClick', this.handleShowOnlyToggle);
        } else {
          showSelectedOnlyBtn = _react2.default.createElement(_ShowSelectedOnlyButton2.default, { toggle: this.state.showSelected,
            onClick: this.handleShowOnlyToggle });
        }
      }

      if (this.props.enableExportCSV) {
        if (this.props.exportCSVBtn) {
          exportCSVBtn = this.renderCustomBtn(this.props.exportCSVBtn, [this.handleExportCSV], _ExportCSVButton2.default.name, 'onClick', this.handleExportCSV);
        } else {
          exportCSVBtn = _react2.default.createElement(_ExportCSVButton2.default, { btnText: this.props.exportCSVText,
            onClick: this.handleExportCSV });
        }
      }

      if (this.props.btnGroup) {
        btnGroup = this.props.btnGroup({
          exportCSVBtn: exportCSVBtn,
          insertBtn: insertBtn,
          deleteBtn: deleteBtn,
          showSelectedOnlyBtn: showSelectedOnlyBtn
        });
      } else {
        btnGroup = _react2.default.createElement(
          'div',
          { className: 'btn-group btn-group-sm', role: 'group' },
          exportCSVBtn,
          insertBtn,
          deleteBtn,
          showSelectedOnlyBtn
        );
      }

      var _renderSearchPanel = this.renderSearchPanel(),
          _renderSearchPanel2 = _slicedToArray(_renderSearchPanel, 3),
          searchPanel = _renderSearchPanel2[0],
          searchField = _renderSearchPanel2[1],
          clearBtn = _renderSearchPanel2[2];

      var modal = this.props.enableInsert ? this.renderInsertRowModal() : null;

      if (this.props.toolBar) {
        toolbar = this.props.toolBar({
          components: {
            exportCSVBtn: exportCSVBtn,
            insertBtn: insertBtn,
            deleteBtn: deleteBtn,
            showSelectedOnlyBtn: showSelectedOnlyBtn,
            searchPanel: searchPanel,
            btnGroup: btnGroup,
            searchField: searchField,
            clearBtn: clearBtn
          },
          event: {
            openInsertModal: this.handleModalOpen,
            closeInsertModal: this.handleModalClose,
            dropRow: this.handleDropRowBtnClick,
            showOnlyToogle: this.handleShowOnlyToggle,
            exportCSV: this.handleExportCSV,
            search: this.props.onSearch
          }
        });
      } else {
        toolbar = [_react2.default.createElement(
          'div',
          { key: 'toolbar-left', className: 'col-xs-6 col-sm-6 col-md-6 col-lg-8' },
          this.props.searchPosition === 'left' ? searchPanel : btnGroup
        ), _react2.default.createElement(
          'div',
          { key: 'toolbar-right', className: 'col-xs-6 col-sm-6 col-md-6 col-lg-4' },
          this.props.searchPosition === 'left' ? btnGroup : searchPanel
        )];
      }

      return _react2.default.createElement(
        'div',
        { className: 'row' },
        toolbar,
        modal
      );
    }
  }, {
    key: 'renderSearchPanel',
    value: function renderSearchPanel() {
      var _this7 = this;

      if (this.props.enableSearch) {
        var classNames = 'form-group form-group-sm react-bs-table-search-form';
        var clearBtn = null;
        var searchField = null;
        var searchPanel = null;
        if (this.props.clearSearch) {
          if (this.props.clearSearchBtn) {
            clearBtn = this.renderCustomBtn(this.props.clearSearchBtn, [this.handleClearBtnClick], _ClearSearchButton2.default.name, 'onClick', this.handleClearBtnClick); /* eslint max-len: 0*/
          } else {
            clearBtn = _react2.default.createElement(_ClearSearchButton2.default, { onClick: this.handleClearBtnClick });
          }
          classNames += ' input-group input-group-sm';
        }

        if (this.props.searchField) {
          searchField = this.props.searchField({
            search: this.handleKeyUp,
            defaultValue: this.props.defaultSearch,
            placeholder: this.props.searchPlaceholder
          });
          if (searchField.type.name === _SearchField2.default.name) {
            searchField = _react2.default.cloneElement(searchField, {
              ref: function ref(node) {
                return _this7.seachInput = node;
              },
              onKeyUp: this.handleKeyUp
            });
          } else {
            searchField = _react2.default.cloneElement(searchField, {
              ref: function ref(node) {
                return _this7.seachInput = node;
              }
            });
          }
        } else {
          searchField = _react2.default.createElement(_SearchField2.default, { ref: function ref(node) {
              return _this7.seachInput = node;
            },
            defaultValue: this.props.defaultSearch,
            placeholder: this.props.searchPlaceholder,
            onKeyUp: this.handleKeyUp });
        }
        if (this.props.searchPanel) {
          searchPanel = this.props.searchPanel({
            searchField: searchField, clearBtn: clearBtn,
            search: this.props.onSearch,
            defaultValue: this.props.defaultSearch,
            placeholder: this.props.searchPlaceholder,
            clearBtnClick: this.handleClearBtnClick
          });
        } else {
          searchPanel = _react2.default.createElement(
            'div',
            { className: classNames },
            searchField,
            _react2.default.createElement(
              'span',
              { className: 'input-group-btn' },
              clearBtn
            )
          );
        }
        return [searchPanel, searchField, clearBtn];
      } else {
        return [];
      }
    }
  }, {
    key: 'renderInsertRowModal',
    value: function renderInsertRowModal() {
      var validateState = this.state.validateState || {};
      var _props = this.props,
          version = _props.version,
          columns = _props.columns,
          ignoreEditable = _props.ignoreEditable,
          insertModalHeader = _props.insertModalHeader,
          insertModalBody = _props.insertModalBody,
          insertModalFooter = _props.insertModalFooter,
          insertModal = _props.insertModal;


      var modal = void 0;
      modal = insertModal && insertModal(this.handleModalClose, this.handleSaveBtnClick, columns, validateState, ignoreEditable);

      if (!modal) {
        modal = _react2.default.createElement(_InsertModal2.default, {
          version: version,
          columns: columns,
          validateState: validateState,
          ignoreEditable: ignoreEditable,
          onModalClose: this.handleModalClose,
          onSave: this.handleSaveBtnClick,
          headerComponent: insertModalHeader,
          bodyComponent: insertModalBody,
          footerComponent: insertModalFooter });
      }

      return _react2.default.createElement(
        _reactModal2.default,
        { className: 'react-bs-insert-modal modal-dialog',
          isOpen: this.state.isInsertModalOpen,
          ariaHideApp: false,
          onRequestClose: this.handleModalClose,
          contentLabel: 'Modal' },
        modal
      );
    }
  }, {
    key: 'renderCustomBtn',
    value: function renderCustomBtn(cb, params, componentName, eventName, event) {
      var element = cb.apply(null, params);
      if (element.type.name === componentName && !element.props[eventName]) {
        var props = {};
        props[eventName] = event;
        element = _react2.default.cloneElement(element, props);
      }
      return element;
    }
  }]);

  return ToolBar;
}(_react.Component);

ToolBar.modalSeq = 0;


ToolBar.propTypes = {
  version: _propTypes2.default.string,
  onAddRow: _propTypes2.default.func,
  onDropRow: _propTypes2.default.func,
  onShowOnlySelected: _propTypes2.default.func,
  enableInsert: _propTypes2.default.bool,
  enableDelete: _propTypes2.default.bool,
  enableSearch: _propTypes2.default.bool,
  enableShowOnlySelected: _propTypes2.default.bool,
  columns: _propTypes2.default.array,
  searchPlaceholder: _propTypes2.default.string,
  exportCSVText: _propTypes2.default.string,
  insertText: _propTypes2.default.string,
  deleteText: _propTypes2.default.string,
  saveText: _propTypes2.default.string,
  closeText: _propTypes2.default.string,
  clearSearch: _propTypes2.default.bool,
  ignoreEditable: _propTypes2.default.bool,
  defaultSearch: _propTypes2.default.string,
  insertModalHeader: _propTypes2.default.func,
  insertModalBody: _propTypes2.default.func,
  insertModalFooter: _propTypes2.default.func,
  insertModal: _propTypes2.default.func,
  insertBtn: _propTypes2.default.func,
  deleteBtn: _propTypes2.default.func,
  showSelectedOnlyBtn: _propTypes2.default.func,
  exportCSVBtn: _propTypes2.default.func,
  clearSearchBtn: _propTypes2.default.func,
  searchField: _propTypes2.default.func,
  searchPanel: _propTypes2.default.func,
  btnGroup: _propTypes2.default.func,
  toolBar: _propTypes2.default.func,
  searchPosition: _propTypes2.default.string,
  reset: _propTypes2.default.bool,
  isValidKey: _propTypes2.default.func,
  insertFailIndicator: _propTypes2.default.string
};

ToolBar.defaultProps = {
  reset: false,
  enableInsert: false,
  enableDelete: false,
  enableSearch: false,
  enableShowOnlySelected: false,
  clearSearch: false,
  ignoreEditable: false,
  exportCSVText: _Const2.default.EXPORT_CSV_TEXT,
  insertText: _Const2.default.INSERT_BTN_TEXT,
  deleteText: _Const2.default.DELETE_BTN_TEXT,
  saveText: _Const2.default.SAVE_BTN_TEXT,
  closeText: _Const2.default.CLOSE_BTN_TEXT
};

var _default = ToolBar;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ToolBar, 'ToolBar', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ToolBar.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ToolBar.js');
}();

;

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Modal = __webpack_require__(577);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Modal2.default;
module.exports = exports["default"];

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bodyOpenClassName = exports.portalClassName = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(22);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalPortal = __webpack_require__(578);

var _ModalPortal2 = _interopRequireDefault(_ModalPortal);

var _ariaAppHider = __webpack_require__(230);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _safeHTMLElement = __webpack_require__(232);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var portalClassName = exports.portalClassName = "ReactModalPortal";
var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";

var isReact16 = _reactDom2.default.createPortal !== undefined;
var createPortal = isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
      var parent = getParentElement(_this.props.parentSelector);
      parent.removeChild(_this.node);
    }, _this.portalRef = function (ref) {
      _this.portal = ref;
    }, _this.renderPortal = function (props) {
      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
      _this.portalRef(portal);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_safeHTMLElement.canUseDOM) return;

      if (!isReact16) {
        this.node = document.createElement("div");
      }
      this.node.className = this.props.portalClassName;

      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      if (!_safeHTMLElement.canUseDOM) return;
      var isOpen = newProps.isOpen;
      // Stop unnecessary renders if modal is remaining closed

      if (!this.props.isOpen && !isOpen) return;

      var currentParent = getParentElement(this.props.parentSelector);
      var newParent = getParentElement(newProps.parentSelector);

      if (newParent !== currentParent) {
        currentParent.removeChild(this.node);
        newParent.appendChild(this.node);
      }

      !isReact16 && this.renderPortal(newProps);
    }
  }, {
    key: "componentWillUpdate",
    value: function componentWillUpdate(newProps) {
      if (!_safeHTMLElement.canUseDOM) return;
      if (newProps.portalClassName !== this.props.portalClassName) {
        this.node.className = newProps.portalClassName;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;

      var state = this.portal.state;
      var now = Date.now();
      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);

      if (closesAt) {
        if (!state.beforeClose) {
          this.portal.closeWithTimeout();
        }

        setTimeout(this.removePortal, closesAt - now);
      } else {
        this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!_safeHTMLElement.canUseDOM || !isReact16) {
        return null;
      }

      if (!this.node && isReact16) {
        this.node = document.createElement("div");
      }

      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
        ref: this.portalRef,
        defaultStyles: Modal.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function setAppElement(element) {
      ariaAppHider.setElement(element);
    }

    /* eslint-disable react/no-unused-prop-types */

    /* eslint-enable react/no-unused-prop-types */

  }]);

  return Modal;
}(_react.Component);

Modal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  portalClassName: _propTypes2.default.string,
  bodyOpenClassName: _propTypes2.default.string,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  ariaHideApp: _propTypes2.default.bool,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  parentSelector: _propTypes2.default.func,
  aria: _propTypes2.default.object,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  shouldCloseOnEsc: _propTypes2.default.bool
};
Modal.defaultProps = {
  isOpen: false,
  portalClassName: portalClassName,
  bodyOpenClassName: bodyOpenClassName,
  ariaHideApp: true,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: true,
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: true,
  shouldReturnFocusAfterClose: true,
  parentSelector: function parentSelector() {
    return document.body;
  }
};
Modal.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};
exports.default = Modal;

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _focusManager = __webpack_require__(579);

var focusManager = _interopRequireWildcard(_focusManager);

var _scopeTab = __webpack_require__(580);

var _scopeTab2 = _interopRequireDefault(_scopeTab);

var _ariaAppHider = __webpack_require__(230);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _refCount = __webpack_require__(231);

var refCount = _interopRequireWildcard(_refCount);

var _bodyClassList = __webpack_require__(582);

var bodyClassList = _interopRequireWildcard(_bodyClassList);

var _safeHTMLElement = __webpack_require__(232);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: "ReactModal__Overlay",
  content: "ReactModal__Content"
};

var TAB_KEY = 9;
var ESC_KEY = 27;

var ModalPortal = function (_Component) {
  _inherits(ModalPortal, _Component);

  function ModalPortal(props) {
    _classCallCheck(this, ModalPortal);

    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));

    _this.setFocusAfterRender = function (focus) {
      _this.focusAfterRender = _this.props.shouldFocusAfterRender && focus;
    };

    _this.setOverlayRef = function (overlay) {
      _this.overlay = overlay;
    };

    _this.setContentRef = function (content) {
      _this.content = content;
    };

    _this.afterClose = function () {
      var _this$props = _this.props,
          appElement = _this$props.appElement,
          ariaHideApp = _this$props.ariaHideApp;

      // Remove body class

      bodyClassList.remove(_this.props.bodyOpenClassName);

      // Reset aria-hidden attribute if all modals have been removed
      if (ariaHideApp && refCount.totalCount() < 1) {
        ariaAppHider.show(appElement);
      }

      if (_this.props.shouldFocusAfterRender) {
        if (_this.props.shouldReturnFocusAfterClose) {
          focusManager.returnFocus();
          focusManager.teardownScopedFocus();
        } else {
          focusManager.popWithoutFocus();
        }
      }
    };

    _this.open = function () {
      _this.beforeOpen();
      if (_this.state.afterOpen && _this.state.beforeClose) {
        clearTimeout(_this.closeTimer);
        _this.setState({ beforeClose: false });
      } else {
        if (_this.props.shouldFocusAfterRender) {
          focusManager.setupScopedFocus(_this.node);
          focusManager.markForFocusLater();
        }

        _this.setState({ isOpen: true }, function () {
          _this.setState({ afterOpen: true });

          if (_this.props.isOpen && _this.props.onAfterOpen) {
            _this.props.onAfterOpen();
          }
        });
      }
    };

    _this.close = function () {
      if (_this.props.closeTimeoutMS > 0) {
        _this.closeWithTimeout();
      } else {
        _this.closeWithoutTimeout();
      }
    };

    _this.focusContent = function () {
      return _this.content && !_this.contentHasFocus() && _this.content.focus();
    };

    _this.closeWithTimeout = function () {
      var closesAt = Date.now() + _this.props.closeTimeoutMS;
      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
      });
    };

    _this.closeWithoutTimeout = function () {
      _this.setState({
        beforeClose: false,
        isOpen: false,
        afterOpen: false,
        closesAt: null
      }, _this.afterClose);
    };

    _this.handleKeyDown = function (event) {
      if (event.keyCode === TAB_KEY) {
        (0, _scopeTab2.default)(_this.content, event);
      }

      if (_this.props.shouldCloseOnEsc && event.keyCode === ESC_KEY) {
        event.stopPropagation();
        _this.requestClose(event);
      }
    };

    _this.handleOverlayOnClick = function (event) {
      if (_this.shouldClose === null) {
        _this.shouldClose = true;
      }

      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
        if (_this.ownerHandlesClose()) {
          _this.requestClose(event);
        } else {
          _this.focusContent();
        }
      }
      _this.shouldClose = null;
      _this.moveFromContentToOverlay = null;
    };

    _this.handleOverlayOnMouseUp = function () {
      if (_this.moveFromContentToOverlay === null) {
        _this.shouldClose = false;
      }
    };

    _this.handleContentOnMouseUp = function () {
      _this.shouldClose = false;
    };

    _this.handleOverlayOnMouseDown = function (event) {
      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
        event.preventDefault();
      }
      _this.moveFromContentToOverlay = false;
    };

    _this.handleContentOnClick = function () {
      _this.shouldClose = false;
    };

    _this.handleContentOnMouseDown = function () {
      _this.shouldClose = false;
      _this.moveFromContentToOverlay = false;
    };

    _this.requestClose = function (event) {
      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
    };

    _this.ownerHandlesClose = function () {
      return _this.props.onRequestClose;
    };

    _this.shouldBeClosed = function () {
      return !_this.state.isOpen && !_this.state.beforeClose;
    };

    _this.contentHasFocus = function () {
      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
    };

    _this.buildClassName = function (which, additional) {
      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
        base: CLASS_NAMES[which],
        afterOpen: CLASS_NAMES[which] + "--after-open",
        beforeClose: CLASS_NAMES[which] + "--before-close"
      };
      var className = classNames.base;
      if (_this.state.afterOpen) {
        className = className + " " + classNames.afterOpen;
      }
      if (_this.state.beforeClose) {
        className = className + " " + classNames.beforeClose;
      }
      return typeof additional === "string" && additional ? className + " " + additional : className;
    };

    _this.ariaAttributes = function (items) {
      return Object.keys(items).reduce(function (acc, name) {
        acc["aria-" + name] = items[name];
        return acc;
      }, {});
    };

    _this.state = {
      afterOpen: false,
      beforeClose: false
    };

    _this.shouldClose = null;
    _this.moveFromContentToOverlay = null;
    return _this;
  }

  _createClass(ModalPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Focus needs to be set when mounting and already open
      if (this.props.isOpen) {
        this.setFocusAfterRender(true);
        this.open();
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      if (false) {
        if (newProps.bodyOpenClassName !== this.props.bodyOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "bodyOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
      }
      // Focus only needs to be set once when the modal is being opened
      if (!this.props.isOpen && newProps.isOpen) {
        this.setFocusAfterRender(true);
        this.open();
      } else if (this.props.isOpen && !newProps.isOpen) {
        this.close();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.focusAfterRender) {
        this.focusContent();
        this.setFocusAfterRender(false);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.afterClose();
      clearTimeout(this.closeTimer);
    }
  }, {
    key: "beforeOpen",
    value: function beforeOpen() {
      var _props = this.props,
          appElement = _props.appElement,
          ariaHideApp = _props.ariaHideApp,
          bodyOpenClassName = _props.bodyOpenClassName;
      // Add body class

      bodyClassList.add(bodyOpenClassName);
      // Add aria-hidden to appElement
      if (ariaHideApp) {
        ariaAppHider.hide(appElement);
      }
    }

    // Don't steal focus from inner elements

  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          className = _props2.className,
          overlayClassName = _props2.overlayClassName,
          defaultStyles = _props2.defaultStyles;

      var contentStyles = className ? {} : defaultStyles.content;
      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;

      return this.shouldBeClosed() ? null : _react2.default.createElement(
        "div",
        {
          ref: this.setOverlayRef,
          className: this.buildClassName("overlay", overlayClassName),
          style: _extends({}, overlayStyles, this.props.style.overlay),
          onClick: this.handleOverlayOnClick,
          onMouseDown: this.handleOverlayOnMouseDown,
          onMouseUp: this.handleOverlayOnMouseUp,
          "aria-modal": "true"
        },
        _react2.default.createElement(
          "div",
          _extends({
            ref: this.setContentRef,
            style: _extends({}, contentStyles, this.props.style.content),
            className: this.buildClassName("content", className),
            tabIndex: "-1",
            onKeyDown: this.handleKeyDown,
            onMouseDown: this.handleContentOnMouseDown,
            onMouseUp: this.handleContentOnMouseUp,
            onClick: this.handleContentOnClick,
            role: this.props.role,
            "aria-label": this.props.contentLabel
          }, this.ariaAttributes(this.props.aria || {})),
          this.props.children
        )
      );
    }
  }]);

  return ModalPortal;
}(_react.Component);

ModalPortal.defaultProps = {
  style: {
    overlay: {},
    content: {}
  }
};
ModalPortal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  defaultStyles: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  bodyOpenClassName: _propTypes2.default.string,
  ariaHideApp: _propTypes2.default.bool,
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  aria: _propTypes2.default.object,
  children: _propTypes2.default.node,
  shouldCloseOnEsc: _propTypes2.default.bool
};
exports.default = ModalPortal;
module.exports = exports["default"];

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleBlur = handleBlur;
exports.handleFocus = handleFocus;
exports.markForFocusLater = markForFocusLater;
exports.returnFocus = returnFocus;
exports.popWithoutFocus = popWithoutFocus;
exports.setupScopedFocus = setupScopedFocus;
exports.teardownScopedFocus = teardownScopedFocus;

var _tabbable = __webpack_require__(229);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;

function handleBlur() {
  needToFocus = true;
}

function handleFocus() {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.
    setTimeout(function () {
      if (modalElement.contains(document.activeElement)) {
        return;
      }
      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}

function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}

/* eslint-disable no-console */
function returnFocus() {
  var toFocus = null;
  try {
    if (focusLaterElements.length !== 0) {
      toFocus = focusLaterElements.pop();
      toFocus.focus();
    }
    return;
  } catch (e) {
    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
  }
}
/* eslint-enable no-console */

function popWithoutFocus() {
  focusLaterElements.length > 0 && focusLaterElements.pop();
}

function setupScopedFocus(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener("blur", handleBlur, false);
    document.addEventListener("focus", handleFocus, true);
  } else {
    window.attachEvent("onBlur", handleBlur);
    document.attachEvent("onFocus", handleFocus);
  }
}

function teardownScopedFocus() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener("blur", handleBlur);
    document.removeEventListener("focus", handleFocus);
  } else {
    window.detachEvent("onBlur", handleBlur);
    document.detachEvent("onFocus", handleFocus);
  }
}

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scopeTab;

var _tabbable = __webpack_require__(229);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scopeTab(node, event) {
  var tabbable = (0, _tabbable2.default)(node);

  if (!tabbable.length) {
    // Do nothing, since there are no elements that can receive focus.
    event.preventDefault();
    return;
  }

  var shiftKey = event.shiftKey;
  var head = tabbable[0];
  var tail = tabbable[tabbable.length - 1];

  // proceed with default browser behavior
  if (node === document.activeElement) {
    return;
  }

  var target;
  if (tail === document.activeElement && !shiftKey) {
    target = head;
  }

  if (head === document.activeElement && shiftKey) {
    target = tail;
  }

  if (target) {
    event.preventDefault();
    target.focus();
    return;
  }

  // Safari radio issue.
  //
  // Safari does not move the focus to the radio button,
  // so we need to force it to really walk through all elements.
  //
  // This is very error prune, since we are trying to guess
  // if it is a safari browser from the first occurence between
  // chrome or safari.
  //
  // The chrome user agent contains the first ocurrence
  // as the 'chrome/version' and later the 'safari/version'.
  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;

  // If we are not in safari desktop, let the browser control
  // the focus
  if (!isSafariDesktop) return;

  var x = tabbable.indexOf(document.activeElement);

  if (x > -1) {
    x += shiftKey ? -1 : 1;
  }

  event.preventDefault();

  tabbable[x].focus();
}
module.exports = exports["default"];

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.add = add;
exports.remove = remove;

var _refCount = __webpack_require__(231);

var refCount = _interopRequireWildcard(_refCount);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function add(bodyClass) {
  // Increment class(es) on refCount tracker and add class(es) to body
  bodyClass.split(" ").map(refCount.add).forEach(function (className) {
    return document.body.classList.add(className);
  });
}

function remove(bodyClass) {
  var classListMap = refCount.get();
  // Decrement class(es) from the refCount tracker
  // and remove unused class(es) from body
  bodyClass.split(" ").map(refCount.remove).filter(function (className) {
    return classListMap[className] === 0;
  }).forEach(function (className) {
    return document.body.classList.remove(className);
  });
}

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return ExecutionEnvironment;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _InsertModalHeader = __webpack_require__(233);

var _InsertModalHeader2 = _interopRequireDefault(_InsertModalHeader);

var _InsertModalFooter = __webpack_require__(234);

var _InsertModalFooter2 = _interopRequireDefault(_InsertModalFooter);

var _InsertModalBody = __webpack_require__(235);

var _InsertModalBody2 = _interopRequireDefault(_InsertModalBody);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-console: 0 */

var defaultModalClassName = 'react-bs-table-insert-modal';

var InsertModal = function (_Component) {
  _inherits(InsertModal, _Component);

  function InsertModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, InsertModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InsertModal.__proto__ || Object.getPrototypeOf(InsertModal)).call.apply(_ref, [this].concat(args))), _this), _this.handleSave = function () {
      var _this2;

      return (_this2 = _this).__handleSave__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(InsertModal, [{
    key: '__handleSave__REACT_HOT_LOADER__',
    value: function __handleSave__REACT_HOT_LOADER__() {
      return this.__handleSave__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleSave__REACT_HOT_LOADER__',
    value: function __handleSave__REACT_HOT_LOADER__() {
      if (this.body.getFieldValue) {
        this.props.onSave(this.body.getFieldValue());
      } else {
        console.error('Custom InsertModalBody should implement getFieldValue function\n        and should return an object presented as the new row that user input.');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          headerComponent = _props.headerComponent,
          footerComponent = _props.footerComponent,
          bodyComponent = _props.bodyComponent;
      var _props2 = this.props,
          columns = _props2.columns,
          validateState = _props2.validateState,
          ignoreEditable = _props2.ignoreEditable,
          onModalClose = _props2.onModalClose;

      var bodyAttr = { columns: columns, validateState: validateState, ignoreEditable: ignoreEditable };

      bodyComponent = bodyComponent && bodyComponent(columns, validateState, ignoreEditable);

      headerComponent = headerComponent && headerComponent(onModalClose, this.handleSave);

      footerComponent = footerComponent && footerComponent(onModalClose, this.handleSave);

      if (bodyComponent) {
        bodyComponent = _react2.default.cloneElement(bodyComponent, { ref: function ref(node) {
            return _this3.body = node;
          } });
      }

      if (headerComponent && headerComponent.type.name === _InsertModalHeader2.default.name) {
        var eventProps = {};
        if (!headerComponent.props.onModalClose) eventProps.onModalClose = onModalClose;
        if (!headerComponent.props.onSave) eventProps.onSave = this.handleSave;
        if (Object.keys(eventProps).length > 0) {
          headerComponent = _react2.default.cloneElement(headerComponent, eventProps);
        }
      } else if (headerComponent && headerComponent.type.name !== _InsertModalHeader2.default.name) {
        var className = headerComponent.props.className;

        if (typeof className === 'undefined' || className.indexOf('modal-header') === -1) {
          headerComponent = _react2.default.createElement(
            'div',
            { className: 'modal-header' },
            headerComponent
          );
        }
      }

      if (footerComponent && footerComponent.type.name === _InsertModalFooter2.default.name) {
        var _eventProps = {};
        if (!footerComponent.props.onModalClose) _eventProps.onModalClose = onModalClose;
        if (!footerComponent.props.onSave) _eventProps.onSave = this.handleSave;
        if (Object.keys(_eventProps).length > 0) {
          footerComponent = _react2.default.cloneElement(footerComponent, _eventProps);
        }
      } else if (footerComponent && footerComponent.type.name !== _InsertModalFooter2.default.name) {
        var _className = footerComponent.props.className;

        if (typeof _className === 'undefined' || _className.indexOf('modal-footer') === -1) {
          footerComponent = _react2.default.createElement(
            'div',
            { className: 'modal-footer' },
            footerComponent
          );
        }
      }

      return _react2.default.createElement(
        'div',
        { className: 'modal-content ' + defaultModalClassName },
        headerComponent || _react2.default.createElement(_InsertModalHeader2.default, {
          version: this.props.version,
          className: 'react-bs-table-inser-modal-header',
          onModalClose: onModalClose }),
        bodyComponent || _react2.default.createElement(_InsertModalBody2.default, _extends({ ref: function ref(node) {
            return _this3.body = node;
          } }, bodyAttr)),
        footerComponent || _react2.default.createElement(_InsertModalFooter2.default, {
          className: 'react-bs-table-inser-modal-footer',
          onModalClose: onModalClose,
          onSave: this.handleSave })
      );
    }
  }]);

  return InsertModal;
}(_react.Component);

var _default = InsertModal;
exports.default = _default;

InsertModal.propTypes = {
  version: _propTypes2.default.string.isRequired,
  columns: _propTypes2.default.array.isRequired,
  validateState: _propTypes2.default.object.isRequired,
  ignoreEditable: _propTypes2.default.bool,
  headerComponent: _propTypes2.default.func,
  bodyComponent: _propTypes2.default.func,
  footerComponent: _propTypes2.default.func,
  onModalClose: _propTypes2.default.func,
  onSave: _propTypes2.default.func
};

InsertModal.defaultProps = {};
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(defaultModalClassName, 'defaultModalClassName', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertModal.js');

  __REACT_HOT_LOADER__.register(InsertModal, 'InsertModal', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertModal.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertModal.js');
}();

;

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Const = __webpack_require__(7);

var _Const2 = _interopRequireDefault(_Const);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TableFilter = function (_Component) {
  _inherits(TableFilter, _Component);

  function TableFilter(props) {
    _classCallCheck(this, TableFilter);

    var _this = _possibleConstructorReturn(this, (TableFilter.__proto__ || Object.getPrototypeOf(TableFilter)).call(this, props));

    _this.handleKeyUp = function () {
      return _this.__handleKeyUp__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.filterObj = {};
    return _this;
  }

  _createClass(TableFilter, [{
    key: '__handleKeyUp__REACT_HOT_LOADER__',
    value: function __handleKeyUp__REACT_HOT_LOADER__() {
      return this.__handleKeyUp__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleKeyUp__REACT_HOT_LOADER__',
    value: function __handleKeyUp__REACT_HOT_LOADER__(e) {
      var _e$currentTarget = e.currentTarget,
          value = _e$currentTarget.value,
          name = _e$currentTarget.name;

      if (value.trim() === '') {
        delete this.filterObj[name];
      } else {
        this.filterObj[name] = value;
      }
      this.props.onFilter(this.filterObj);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          striped = _props.striped,
          condensed = _props.condensed,
          rowSelectType = _props.rowSelectType,
          columns = _props.columns;

      var tableClasses = (0, _classnames2.default)('table', {
        'table-striped': striped,
        'table-condensed': condensed
      });
      var selectRowHeader = null;

      if (rowSelectType === _Const2.default.ROW_SELECT_SINGLE || rowSelectType === _Const2.default.ROW_SELECT_MULTI) {
        var style = {
          width: 35,
          paddingLeft: 0,
          paddingRight: 0
        };
        selectRowHeader = _react2.default.createElement(
          'th',
          { style: style, key: -1 },
          'Filter'
        );
      }

      var filterField = columns.map(function (column) {
        var hidden = column.hidden,
            width = column.width,
            name = column.name;

        var thStyle = {
          display: hidden ? 'none' : null,
          width: width
        };
        return _react2.default.createElement(
          'th',
          { key: name, style: thStyle },
          _react2.default.createElement(
            'div',
            { className: 'th-inner table-header-column' },
            _react2.default.createElement('input', { size: '10', type: 'text',
              placeholder: name, name: name, onKeyUp: this.handleKeyUp })
          )
        );
      }, this);

      return _react2.default.createElement(
        'table',
        { className: tableClasses, style: { marginTop: 5 } },
        _react2.default.createElement(
          'thead',
          null,
          _react2.default.createElement(
            'tr',
            { style: { borderBottomStyle: 'hidden' } },
            selectRowHeader,
            filterField
          )
        )
      );
    }
  }]);

  return TableFilter;
}(_react.Component);

TableFilter.propTypes = {
  columns: _propTypes2.default.array,
  rowSelectType: _propTypes2.default.string,
  onFilter: _propTypes2.default.func
};
var _default = TableFilter;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TableFilter, 'TableFilter', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableFilter.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableFilter.js');
}();

;

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableDataStore = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint no-nested-ternary: 0 */
/* eslint guard-for-in: 0 */
/* eslint no-console: 0 */
/* eslint eqeqeq: 0 */
/* eslint one-var: 0 */


var _Const = __webpack_require__(7);

var _Const2 = _interopRequireDefault(_Const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TableDataStore = function () {
  function TableDataStore(data) {
    var _this = this;

    _classCallCheck(this, TableDataStore);

    this.isValidKey = function () {
      return _this.__isValidKey__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    this.data = data;
    this.filteredData = null;
    this.isOnFilter = false;
    this.filterObj = null;
    this.searchText = null;
    this.sortList = [];
    this.pageObj = {};
    this.selected = [];
    this.showOnlySelected = false;
  }

  _createClass(TableDataStore, [{
    key: '__isValidKey__REACT_HOT_LOADER__',
    value: function __isValidKey__REACT_HOT_LOADER__() {
      return this.__isValidKey__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'setProps',
    value: function setProps(props) {
      this.keyField = props.keyField;
      this.enablePagination = props.isPagination;
      this.colInfos = props.colInfos;
      this.remote = props.remote;
      this.multiColumnSearch = props.multiColumnSearch;
      // default behaviour if strictSearch prop is not provided: !multiColumnSearch
      this.strictSearch = typeof props.strictSearch === 'undefined' ? !props.multiColumnSearch : props.strictSearch;
      this.multiColumnSort = props.multiColumnSort;
    }
  }, {
    key: 'clean',
    value: function clean() {
      this.filteredData = null;
      this.isOnFilter = false;
      this.filterObj = null;
      this.searchText = null;
      this.sortList = [];
      this.pageObj = {};
      this.selected = [];
    }
  }, {
    key: 'isSearching',
    value: function isSearching() {
      return this.searchText !== null;
    }
  }, {
    key: 'isFiltering',
    value: function isFiltering() {
      return this.filterObj !== null;
    }
  }, {
    key: 'setData',
    value: function setData(data) {
      this.data = data;
      if (this.remote) {
        return;
      }

      this._refresh(true);
    }
  }, {
    key: 'getColInfos',
    value: function getColInfos() {
      return this.colInfos;
    }
  }, {
    key: 'getSortInfo',
    value: function getSortInfo() {
      return this.sortList;
    }
  }, {
    key: 'setSortInfo',
    value: function setSortInfo(order, sortField) {
      if ((typeof order === 'undefined' ? 'undefined' : _typeof(order)) !== (typeof sortField === 'undefined' ? 'undefined' : _typeof(sortField))) {
        throw new Error('The type of sort field and order should be both with String or Array');
      }
      if (Array.isArray(order) && Array.isArray(sortField)) {
        if (order.length !== sortField.length) {
          throw new Error('The length of sort fields and orders should be equivalent');
        }
        order = order.slice().reverse();
        this.sortList = sortField.slice().reverse().map(function (field, i) {
          return {
            order: order[i],
            sortField: field
          };
        });
        this.sortList = this.sortList.slice(0, this.multiColumnSort);
      } else {
        var sortObj = {
          order: order,
          sortField: sortField
        };

        if (this.multiColumnSort > 1) {
          var i = this.sortList.length - 1;
          var sortFieldInHistory = false;

          for (; i >= 0; i--) {
            if (this.sortList[i].sortField === sortField) {
              sortFieldInHistory = true;
              break;
            }
          }

          if (sortFieldInHistory) {
            if (i > 0) {
              this.sortList = this.sortList.slice(0, i);
            } else {
              this.sortList = this.sortList.slice(1);
            }
          }

          this.sortList.unshift(sortObj);
          this.sortList = this.sortList.slice(0, this.multiColumnSort);
        } else {
          this.sortList = [sortObj];
        }
      }
    }
  }, {
    key: 'cleanSortInfo',
    value: function cleanSortInfo() {
      this.sortList = [];
    }
  }, {
    key: 'setSelectedRowKey',
    value: function setSelectedRowKey(selectedRowKeys) {
      this.selected = selectedRowKeys;
    }
  }, {
    key: 'getRowByKey',
    value: function getRowByKey(keys) {
      var _this2 = this;

      // Bad Performance #1164
      // return keys.map(key => {
      //   const result = this.data.filter(d => d[this.keyField] === key);
      //   if (result.length !== 0) return result[0];
      // });
      var result = [];
      if (!keys || keys.length === 0) {
        return result;
      }

      var _loop = function _loop(i) {
        var d = _this2.data[i];
        if (keys.indexOf(d[_this2.keyField]) > -1) {
          keys = keys.filter(function (k) {
            return k !== d[_this2.keyField];
          });
          result.push(d);
        }
      };

      for (var i = 0; i < this.data.length; i++) {
        _loop(i);
      }
      return result;
    }
  }, {
    key: 'getSelectedRowKeys',
    value: function getSelectedRowKeys() {
      return this.selected;
    }
  }, {
    key: 'getCurrentDisplayData',
    value: function getCurrentDisplayData() {
      if (this.isOnFilter) return this.filteredData;else return this.data;
    }
  }, {
    key: '_refresh',
    value: function _refresh(skipSorting) {
      if (this.isOnFilter) {
        if (this.filterObj !== null) this.filter(this.filterObj);
        if (this.searchText !== null) this.search(this.searchText);
      }
      if (!skipSorting && this.sortList.length > 0) {
        this.sort();
      }
    }
  }, {
    key: 'ignoreNonSelected',
    value: function ignoreNonSelected() {
      var _this3 = this;

      this.showOnlySelected = !this.showOnlySelected;
      if (this.showOnlySelected) {
        this.isOnFilter = true;
        this.filteredData = this.data.filter(function (row) {
          var result = _this3.selected.find(function (x) {
            return row[_this3.keyField] === x;
          });
          return typeof result !== 'undefined' ? true : false;
        });
      } else {
        this.isOnFilter = false;
      }
    }
  }, {
    key: 'sort',
    value: function sort() {
      var currentDisplayData = this.getCurrentDisplayData();

      currentDisplayData = this._sort(currentDisplayData);

      return this;
    }
  }, {
    key: 'page',
    value: function page(_page, sizePerPage) {
      this.pageObj.end = _page * sizePerPage - 1;
      this.pageObj.start = this.pageObj.end - (sizePerPage - 1);
      return this;
    }
  }, {
    key: 'edit',
    value: function edit(newVal, rowIndex, fieldName) {
      var currentDisplayData = this.getCurrentDisplayData();
      var rowKeyCache = void 0;
      if (!this.enablePagination) {
        currentDisplayData[rowIndex][fieldName] = newVal;
        rowKeyCache = currentDisplayData[rowIndex][this.keyField];
      } else {
        currentDisplayData[this.pageObj.start + rowIndex][fieldName] = newVal;
        rowKeyCache = currentDisplayData[this.pageObj.start + rowIndex][this.keyField];
      }
      if (this.isOnFilter) {
        this.data.forEach(function (row) {
          if (row[this.keyField] === rowKeyCache) {
            row[fieldName] = newVal;
          }
        }, this);
        if (this.filterObj !== null) this.filter(this.filterObj);
        if (this.searchText !== null) this.search(this.searchText);
      }
      return this;
    }
  }, {
    key: 'addAtBegin',
    value: function addAtBegin(newObj) {
      if (!newObj[this.keyField] || newObj[this.keyField].toString() === '') {
        throw new Error(this.keyField + ' can\'t be empty value.');
      }
      var currentDisplayData = this.getCurrentDisplayData();
      currentDisplayData.forEach(function (row) {
        if (row[this.keyField].toString() === newObj[this.keyField].toString()) {
          throw new Error(this.keyField + ' ' + newObj[this.keyField] + ' already exists');
        }
      }, this);
      currentDisplayData.unshift(newObj);
      if (this.isOnFilter) {
        this.data.unshift(newObj);
      }
      this._refresh(false);
    }
  }, {
    key: 'add',
    value: function add(newObj) {
      var e = this.isValidKey(newObj[this.keyField]);
      if (e) throw new Error(e);

      var currentDisplayData = this.getCurrentDisplayData();
      currentDisplayData.push(newObj);
      if (this.isOnFilter) {
        this.data.push(newObj);
      }
      this._refresh(false);
    }
  }, {
    key: '__isValidKey__REACT_HOT_LOADER__',
    value: function __isValidKey__REACT_HOT_LOADER__(key) {
      var _this4 = this;

      if (key === null || key === undefined || key.toString() === '') {
        return this.keyField + ' can\'t be empty value.';
      }
      var currentDisplayData = this.getCurrentDisplayData();
      var exist = currentDisplayData.find(function (row) {
        return row[_this4.keyField].toString() === key.toString();
      });
      if (exist) return this.keyField + ' ' + key + ' already exists';
    }
  }, {
    key: 'remove',
    value: function remove(rowKey) {
      var _this5 = this;

      var currentDisplayData = this.getCurrentDisplayData();
      var result = currentDisplayData.filter(function (row) {
        return rowKey.indexOf(row[_this5.keyField]) === -1;
      });

      if (this.isOnFilter) {
        this.data = this.data.filter(function (row) {
          return rowKey.indexOf(row[_this5.keyField]) === -1;
        });
        this.filteredData = result;
      } else {
        this.data = result;
      }
    }
  }, {
    key: 'filter',
    value: function filter(filterObj) {
      if (Object.keys(filterObj).length === 0) {
        this.filteredData = null;
        this.isOnFilter = false;
        this.filterObj = null;
        if (this.searchText) this._search(this.data);
      } else {
        var source = this.data;
        this.filterObj = filterObj;
        if (this.searchText) {
          this._search(source);
          source = this.filteredData;
        }
        this._filter(source);
      }
    }
  }, {
    key: 'filterNumber',
    value: function filterNumber(targetVal, filterVal, comparator) {
      var valid = true;
      switch (comparator) {
        case '=':
          {
            if (targetVal != filterVal) {
              valid = false;
            }
            break;
          }
        case '>':
          {
            if (targetVal <= filterVal) {
              valid = false;
            }
            break;
          }
        case '>=':
          {
            if (targetVal < filterVal) {
              valid = false;
            }
            break;
          }
        case '<':
          {
            if (targetVal >= filterVal) {
              valid = false;
            }
            break;
          }
        case '<=':
          {
            if (targetVal > filterVal) {
              valid = false;
            }
            break;
          }
        case '!=':
          {
            if (targetVal == filterVal) {
              valid = false;
            }
            break;
          }
        default:
          {
            console.error('Number comparator provided is not supported');
            break;
          }
      }
      return valid;
    }
  }, {
    key: 'filterDate',
    value: function filterDate(targetVal, filterVal, comparator) {
      if (!targetVal) return false;

      var filterDate = filterVal.getDate();
      var filterMonth = filterVal.getMonth();
      var filterYear = filterVal.getFullYear();

      if ((typeof targetVal === 'undefined' ? 'undefined' : _typeof(targetVal)) !== 'object') {
        targetVal = new Date(targetVal);
      }

      var targetDate = targetVal.getDate();
      var targetMonth = targetVal.getMonth();
      var targetYear = targetVal.getFullYear();

      var valid = true;
      switch (comparator) {
        case '=':
          {
            if (filterDate !== targetDate || filterMonth !== targetMonth || filterYear !== targetYear) {
              valid = false;
            }
            break;
          }
        case '>':
          {
            if (targetVal <= filterVal) {
              valid = false;
            }
            break;
          }
        case '>=':
          {
            if (targetYear < filterYear) {
              valid = false;
            } else if (targetYear === filterYear && targetMonth < filterMonth) {
              valid = false;
            } else if (targetYear === filterYear && targetMonth === filterMonth && targetDate < filterDate) {
              valid = false;
            }
            break;
          }
        case '<':
          {
            if (targetVal >= filterVal) {
              valid = false;
            }
            break;
          }
        case '<=':
          {
            if (targetYear > filterYear) {
              valid = false;
            } else if (targetYear === filterYear && targetMonth > filterMonth) {
              valid = false;
            } else if (targetYear === filterYear && targetMonth === filterMonth && targetDate > filterDate) {
              valid = false;
            }
            break;
          }
        case '!=':
          {
            if (filterDate === targetDate && filterMonth === targetMonth && filterYear === targetYear) {
              valid = false;
            }
            break;
          }
        default:
          {
            console.error('Date comparator provided is not supported');
            break;
          }
      }
      return valid;
    }
  }, {
    key: 'filterRegex',
    value: function filterRegex(targetVal, filterVal) {
      try {
        return new RegExp(filterVal, 'i').test(targetVal);
      } catch (e) {
        return true;
      }
    }
  }, {
    key: 'filterCustom',
    value: function filterCustom(targetVal, filterVal, callbackInfo, cond) {
      if (callbackInfo !== null && (typeof callbackInfo === 'undefined' ? 'undefined' : _typeof(callbackInfo)) === 'object') {
        return callbackInfo.callback(targetVal, callbackInfo.callbackParameters);
      }

      return this.filterText(targetVal, filterVal, cond);
    }
  }, {
    key: 'filterText',
    value: function filterText() {
      var targetVal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var filterVal = arguments[1];
      var cond = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _Const2.default.FILTER_COND_LIKE;

      targetVal = targetVal === null ? '' : targetVal.toString();
      filterVal = filterVal.toString();
      if (cond === _Const2.default.FILTER_COND_EQ) {
        return targetVal === filterVal;
      } else {
        targetVal = targetVal.toLowerCase();
        filterVal = filterVal.toLowerCase();
        return !(targetVal.indexOf(filterVal) === -1);
      }
    }

    /**
     * Filter if targetVal is contained in filterVal.
     */

  }, {
    key: 'filterArray',
    value: function filterArray(targetVal, filterVal) {
      // case insensitive
      return filterVal.indexOf(targetVal) > -1;
    }

    /* General search function
     * It will search for the text if the input includes that text;
     */

  }, {
    key: 'search',
    value: function search(searchText) {
      if (searchText.trim() === '') {
        this.filteredData = null;
        this.isOnFilter = false;
        this.searchText = null;
        if (this.filterObj) this._filter(this.data);
      } else {
        var source = this.data;
        this.searchText = searchText;
        if (this.filterObj) {
          this._filter(source);
          source = this.filteredData;
        }
        this._search(source);
      }
    }
  }, {
    key: '_filter',
    value: function _filter(source) {
      var _this6 = this;

      var filterObj = this.filterObj;
      this.filteredData = source.filter(function (row, r) {
        var valid = true;
        var filterVal = void 0;
        for (var key in filterObj) {
          var targetVal = row[key];
          if (targetVal === null || targetVal === undefined) {
            targetVal = '';
          }

          switch (filterObj[key].type) {
            case _Const2.default.FILTER_TYPE.NUMBER:
              {
                filterVal = filterObj[key].value.number;
                break;
              }
            case _Const2.default.FILTER_TYPE.CUSTOM:
              {
                filterVal = _typeof(filterObj[key].value) === 'object' ? undefined : typeof filterObj[key].value === 'string' ? filterObj[key].value.toLowerCase() : filterObj[key].value;
                break;
              }
            case _Const2.default.FILTER_TYPE.DATE:
              {
                filterVal = filterObj[key].value.date;
                break;
              }
            case _Const2.default.FILTER_TYPE.REGEX:
              {
                filterVal = filterObj[key].value;
                break;
              }
            case _Const2.default.FILTER_TYPE.ARRAY:
              {
                filterVal = filterObj[key].value;
                if (!Array.isArray(filterVal)) {
                  throw new Error('Value must be an Array');
                }
                break;
              }
            default:
              {
                filterVal = filterObj[key].value;
                if (filterVal === undefined) {
                  // Support old filter
                  filterVal = filterObj[key];
                }
                break;
              }
          }
          var format = void 0,
              filterFormatted = void 0,
              formatExtraData = void 0,
              filterValue = void 0;
          if (_this6.colInfos[key]) {
            format = _this6.colInfos[key].format;
            filterFormatted = _this6.colInfos[key].filterFormatted;
            formatExtraData = _this6.colInfos[key].formatExtraData;
            filterValue = _this6.colInfos[key].filterValue;
            if (filterFormatted && format) {
              targetVal = format(row[key], row, formatExtraData, r);
            } else if (filterValue) {
              targetVal = filterValue(row[key], row);
            }
          }

          switch (filterObj[key].type) {
            case _Const2.default.FILTER_TYPE.NUMBER:
              {
                valid = _this6.filterNumber(targetVal, filterVal, filterObj[key].value.comparator);
                break;
              }
            case _Const2.default.FILTER_TYPE.DATE:
              {
                valid = _this6.filterDate(targetVal, filterVal, filterObj[key].value.comparator);
                break;
              }
            case _Const2.default.FILTER_TYPE.REGEX:
              {
                valid = _this6.filterRegex(targetVal, filterVal);
                break;
              }
            case _Const2.default.FILTER_TYPE.CUSTOM:
              {
                var cond = filterObj[key].props ? filterObj[key].props.cond : _Const2.default.FILTER_COND_LIKE;
                valid = _this6.filterCustom(targetVal, filterVal, filterObj[key].value, cond);
                break;
              }
            case _Const2.default.FILTER_TYPE.ARRAY:
              {
                valid = _this6.filterArray(targetVal, filterVal);
                break;
              }
            default:
              {
                if (filterObj[key].type === _Const2.default.FILTER_TYPE.SELECT && filterFormatted && filterFormatted && format) {
                  filterVal = format(filterVal, row, formatExtraData, r);
                }
                var _cond = filterObj[key].props ? filterObj[key].props.cond : _Const2.default.FILTER_COND_LIKE;
                valid = _this6.filterText(targetVal, filterVal, _cond);
                break;
              }
          }
          if (!valid) {
            break;
          }
        }
        return valid;
      });
      this.isOnFilter = true;
    }

    /*
     * Four different sort modes, all case insensitive:
     * (1) strictSearch && !multiColumnSearch
     *     search text must be contained as provided in a single column
     * (2) strictSearch && multiColumnSearch
     *     conjunction (AND combination) of whitespace separated terms over multiple columns
     * (3) !strictSearch && !multiColumnSearch
     *     conjunction (AND combination) of whitespace separated terms in a single column
     * (4) !strictSearch && multiColumnSearch
     *     any of the whitespace separated terms must be contained in any column
     */

  }, {
    key: '_search',
    value: function _search(source) {
      var _this7 = this;

      var searchTextArray = void 0;
      if (this.multiColumnSearch || !this.strictSearch) {
        // ignore leading and trailing whitespaces
        searchTextArray = this.searchText.trim().toLowerCase().split(/\s+/);
      } else {
        searchTextArray = [this.searchText.toLowerCase()];
      }
      var searchTermCount = searchTextArray.length;
      var multipleTerms = searchTermCount > 1;
      var nonStrictMultiCol = multipleTerms && !this.strictSearch && this.multiColumnSearch;
      var nonStrictSingleCol = multipleTerms && !this.strictSearch && !this.multiColumnSearch;
      this.filteredData = source.filter(function (row, r) {
        var keys = Object.keys(row);
        // only clone array if necessary
        var searchTerms = multipleTerms ? searchTextArray.slice() : searchTextArray;
        // for loops are ugly, but performance matters here.
        // And you cant break from a forEach.
        // http://jsperf.com/for-vs-foreach/66
        for (var i = 0, keysLength = keys.length; i < keysLength; i++) {
          var key = keys[i];
          var colInfo = _this7.colInfos[key];
          if (colInfo && colInfo.searchable) {
            var format = colInfo.format,
                filterFormatted = colInfo.filterFormatted,
                filterValue = colInfo.filterValue,
                formatExtraData = colInfo.formatExtraData;

            var targetVal = void 0;
            if (filterFormatted && format) {
              targetVal = format(row[key], row, formatExtraData, r);
            } else if (filterValue) {
              targetVal = filterValue(row[key], row);
            } else {
              targetVal = row[key];
            }
            if (targetVal !== null && typeof targetVal !== 'undefined') {
              targetVal = targetVal.toString().toLowerCase();
              if (nonStrictSingleCol && searchTermCount > searchTerms.length) {
                // reset search terms for single column search
                searchTerms = searchTextArray.slice();
              }
              for (var j = searchTerms.length - 1; j > -1; j--) {
                if (targetVal.indexOf(searchTerms[j]) !== -1) {
                  if (nonStrictMultiCol || searchTerms.length === 1) {
                    // match found: the last or only one
                    return true;
                  }
                  // match found: but there are more search terms to check for
                  searchTerms.splice(j, 1);
                } else if (!_this7.multiColumnSearch) {
                  // one of the search terms was not found in this column
                  break;
                }
              }
            }
          }
        }
        return false;
      });
      this.isOnFilter = true;
    }
  }, {
    key: '_sort',
    value: function _sort(arr) {
      var _this8 = this;

      if (this.sortList.length === 0 || typeof this.sortList[0] === 'undefined') {
        return arr;
      }

      arr.sort(function (a, b) {
        var result = 0;

        for (var i = 0; i < _this8.sortList.length; i++) {
          var sortDetails = _this8.sortList[i];
          var isDesc = sortDetails.order.toLowerCase() === _Const2.default.SORT_DESC;

          var _colInfos$sortDetails = _this8.colInfos[sortDetails.sortField],
              sortFunc = _colInfos$sortDetails.sortFunc,
              sortFuncExtraData = _colInfos$sortDetails.sortFuncExtraData;


          if (sortFunc) {
            result = sortFunc(a, b, sortDetails.order, sortDetails.sortField, sortFuncExtraData);
          } else {
            var valueA = a[sortDetails.sortField] == null ? '' : a[sortDetails.sortField];
            var valueB = b[sortDetails.sortField] == null ? '' : b[sortDetails.sortField];

            if (isDesc) {
              if (typeof valueB === 'string') {
                result = valueB.localeCompare(valueA);
              } else {
                result = valueA > valueB ? -1 : valueA < valueB ? 1 : 0;
              }
            } else {
              if (typeof valueA === 'string') {
                result = valueA.localeCompare(valueB);
              } else {
                result = valueA < valueB ? -1 : valueA > valueB ? 1 : 0;
              }
            }
          }

          if (result !== 0) {
            return result;
          }
        }

        return result;
      });

      return arr;
    }
  }, {
    key: 'getDataIgnoringPagination',
    value: function getDataIgnoringPagination() {
      return this.getCurrentDisplayData();
    }
  }, {
    key: 'get',
    value: function get() {
      var _data = this.getCurrentDisplayData();

      if (_data.length === 0) return _data;

      var remote = typeof this.remote === 'function' ? this.remote(_Const2.default.REMOTE)[_Const2.default.REMOTE_PAGE] : this.remote;

      if (remote || !this.enablePagination) {
        return _data;
      } else {
        var result = [];
        for (var i = this.pageObj.start; i <= this.pageObj.end; i++) {
          result.push(_data[i]);
          if (i + 1 === _data.length) break;
        }
        return result;
      }
    }
  }, {
    key: 'getKeyField',
    value: function getKeyField() {
      return this.keyField;
    }
  }, {
    key: 'getDataNum',
    value: function getDataNum() {
      return this.getCurrentDisplayData().length;
    }
  }, {
    key: 'isChangedPage',
    value: function isChangedPage() {
      return this.pageObj.start && this.pageObj.end ? true : false;
    }
  }, {
    key: 'isEmpty',
    value: function isEmpty() {
      return this.data.length === 0 || this.data === null || this.data === undefined;
    }
  }, {
    key: 'getAllRowkey',
    value: function getAllRowkey() {
      var _this9 = this;

      return this.data.map(function (row) {
        return row[_this9.keyField];
      });
    }
  }]);

  return TableDataStore;
}();

exports.TableDataStore = TableDataStore;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TableDataStore, 'TableDataStore', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/store/TableDataStore.js');
}();

;

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__(15);

var _util2 = _interopRequireDefault(_util);

var _Const = __webpack_require__(7);

var _Const2 = _interopRequireDefault(_Const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint block-scoped-var: 0 */
/* eslint vars-on-top: 0 */
/* eslint no-var: 0 */
/* eslint no-unused-vars: 0 */
if (_util2.default.canUseDOM()) {
  var filesaver = __webpack_require__(588);
  var saveAs = filesaver.saveAs;
}

function toString(data, keys, separator, excludeCSVHeader) {
  var dataString = '';
  if (data.length === 0) return dataString;

  var headCells = [];
  var rowCount = 0;
  keys.forEach(function (key) {
    if (key.row > rowCount) {
      rowCount = key.row;
    }
    // rowCount += (key.rowSpan + key.colSpan - 1);
    for (var index = 0; index < key.colSpan; index++) {
      headCells.push(key);
    }
  });

  var firstRow = excludeCSVHeader ? 1 : 0;

  var _loop = function _loop(i) {
    dataString += headCells.map(function (x) {
      if (x.row + (x.rowSpan - 1) === i) {
        return '"' + x.header + '"';
      }
      if (x.row === i && x.rowSpan > 1) {
        return '';
      }
    }).filter(function (key) {
      return typeof key !== 'undefined';
    }).join(separator) + '\n';
  };

  for (var i = firstRow; i <= rowCount; i++) {
    _loop(i);
  }

  keys = keys.filter(function (key) {
    return key.field !== undefined;
  });

  data.map(function (row) {
    keys.map(function (col, i) {
      var field = col.field,
          format = col.format,
          extraData = col.extraData,
          type = col.type;

      var value = typeof format !== 'undefined' ? format(row[field], row, extraData) : row[field];
      value = type === _Const2.default.CSV_NUMBER_TYPE ? Number(value) : '"' + value + '"';
      var cell = typeof value !== 'undefined' ? value : '';
      dataString += cell;
      if (i + 1 < keys.length) dataString += separator;
    });

    dataString += '\n';
  });

  return dataString;
}

var exportCSV = function exportCSV(data, keys, filename, separator, noAutoBOM, excludeCSVHeader) {
  var dataString = toString(data, keys, separator, excludeCSVHeader);
  if (typeof window !== 'undefined') {
    noAutoBOM = noAutoBOM === undefined ? true : noAutoBOM;
    saveAs(new Blob(['\uFEFF', dataString], { type: 'text/plain;charset=utf-8' }), filename, noAutoBOM);
  }
};

var _default = exportCSV;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(saveAs, 'saveAs', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/csv_export_util.js');

  __REACT_HOT_LOADER__.register(toString, 'toString', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/csv_export_util.js');

  __REACT_HOT_LOADER__.register(exportCSV, 'exportCSV', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/csv_export_util.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/csv_export_util.js');
}();

;

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

/* FileSaver.js
 * A saveAs() FileSaver implementation.
 * 1.3.2
 * 2016-06-16 18:25:19
 *
 * By Eli Grey, http://eligrey.com
 * License: MIT
 *   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
 */

/*global self */
/*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */

/*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */

var saveAs = saveAs || function (view) {
	"use strict";
	// IE <10 is explicitly unsupported

	if (typeof view === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) {
		return;
	}
	var doc = view.document
	// only get URL when necessary in case Blob.js hasn't overridden it yet
	,
	    get_URL = function get_URL() {
		return view.URL || view.webkitURL || view;
	},
	    save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a"),
	    can_use_save_link = "download" in save_link,
	    click = function click(node) {
		var event = new MouseEvent("click");
		node.dispatchEvent(event);
	},
	    is_safari = /constructor/i.test(view.HTMLElement) || view.safari,
	    is_chrome_ios = /CriOS\/[\d]+/.test(navigator.userAgent),
	    throw_outside = function throw_outside(ex) {
		(view.setImmediate || view.setTimeout)(function () {
			throw ex;
		}, 0);
	},
	    force_saveable_type = "application/octet-stream"
	// the Blob API is fundamentally broken as there is no "downloadfinished" event to subscribe to
	,
	    arbitrary_revoke_timeout = 1000 * 40 // in ms
	,
	    revoke = function revoke(file) {
		var revoker = function revoker() {
			if (typeof file === "string") {
				// file is an object URL
				get_URL().revokeObjectURL(file);
			} else {
				// file is a File
				file.remove();
			}
		};
		setTimeout(revoker, arbitrary_revoke_timeout);
	},
	    dispatch = function dispatch(filesaver, event_types, event) {
		event_types = [].concat(event_types);
		var i = event_types.length;
		while (i--) {
			var listener = filesaver["on" + event_types[i]];
			if (typeof listener === "function") {
				try {
					listener.call(filesaver, event || filesaver);
				} catch (ex) {
					throw_outside(ex);
				}
			}
		}
	},
	    auto_bom = function auto_bom(blob) {
		// prepend BOM for UTF-8 XML and text/* types (including HTML)
		// note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
		if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
			return new Blob([String.fromCharCode(0xFEFF), blob], { type: blob.type });
		}
		return blob;
	},
	    FileSaver = function FileSaver(blob, name, no_auto_bom) {
		if (!no_auto_bom) {
			blob = auto_bom(blob);
		}
		// First try a.download, then web filesystem, then object URLs
		var filesaver = this,
		    type = blob.type,
		    force = type === force_saveable_type,
		    object_url,
		    dispatch_all = function dispatch_all() {
			dispatch(filesaver, "writestart progress write writeend".split(" "));
		}
		// on any filesys errors revert to saving with object URLs
		,
		    fs_error = function fs_error() {
			if ((is_chrome_ios || force && is_safari) && view.FileReader) {
				// Safari doesn't allow downloading of blob urls
				var reader = new FileReader();
				reader.onloadend = function () {
					var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
					var popup = view.open(url, '_blank');
					if (!popup) view.location.href = url;
					url = undefined; // release reference before dispatching
					filesaver.readyState = filesaver.DONE;
					dispatch_all();
				};
				reader.readAsDataURL(blob);
				filesaver.readyState = filesaver.INIT;
				return;
			}
			// don't create more object URLs than needed
			if (!object_url) {
				object_url = get_URL().createObjectURL(blob);
			}
			if (force) {
				view.location.href = object_url;
			} else {
				var opened = view.open(object_url, "_blank");
				if (!opened) {
					// Apple does not allow window.open, see https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
					view.location.href = object_url;
				}
			}
			filesaver.readyState = filesaver.DONE;
			dispatch_all();
			revoke(object_url);
		};
		filesaver.readyState = filesaver.INIT;

		if (can_use_save_link) {
			object_url = get_URL().createObjectURL(blob);
			setTimeout(function () {
				save_link.href = object_url;
				save_link.download = name;
				click(save_link);
				dispatch_all();
				revoke(object_url);
				filesaver.readyState = filesaver.DONE;
			});
			return;
		}

		fs_error();
	},
	    FS_proto = FileSaver.prototype,
	    saveAs = function saveAs(blob, name, no_auto_bom) {
		return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
	};
	// IE 10+ (native saveAs)
	if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
		return function (blob, name, no_auto_bom) {
			name = name || blob.name || "download";

			if (!no_auto_bom) {
				blob = auto_bom(blob);
			}
			return navigator.msSaveOrOpenBlob(blob, name);
		};
	}

	FS_proto.abort = function () {};
	FS_proto.readyState = FS_proto.INIT = 0;
	FS_proto.WRITING = 1;
	FS_proto.DONE = 2;

	FS_proto.error = FS_proto.onwritestart = FS_proto.onprogress = FS_proto.onwrite = FS_proto.onabort = FS_proto.onerror = FS_proto.onwriteend = null;

	return saveAs;
}(typeof self !== "undefined" && self || typeof window !== "undefined" && window || undefined.content);
// `self` is undefined in Firefox for Android content script context
// while `this` is nsIContentFrameMessageManager
// with an attribute `content` that corresponds to the window

if (typeof module !== "undefined" && module.exports) {
	module.exports.saveAs = saveAs;
} else if ("function" !== "undefined" && __webpack_require__(589) !== null && __webpack_require__(590) !== null) {
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
		return saveAs;
	}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(saveAs, "saveAs", "/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filesaver.js");
}();

;

/***/ }),
/* 589 */
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),
/* 590 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Filter = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Const = __webpack_require__(7);

var _Const2 = _interopRequireDefault(_Const);

var _events = __webpack_require__(222);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Filter = exports.Filter = function (_EventEmitter) {
  _inherits(Filter, _EventEmitter);

  function Filter(data) {
    _classCallCheck(this, Filter);

    var _this = _possibleConstructorReturn(this, (Filter.__proto__ || Object.getPrototypeOf(Filter)).call(this, data));

    _this.currentFilter = {};
    return _this;
  }

  _createClass(Filter, [{
    key: 'handleFilter',
    value: function handleFilter(dataField, value, type, filterObj) {
      var filterType = type || _Const2.default.FILTER_TYPE.CUSTOM;

      var props = {
        cond: filterObj.condition // Only for select and text filter
      };

      if (value !== null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
        // value of the filter is an object
        var hasValue = true;
        for (var prop in value) {
          if (!value[prop] || value[prop] === '') {
            hasValue = false;
            break;
          }
        }
        // if one of the object properties is undefined or empty, we remove the filter
        if (hasValue) {
          this.currentFilter[dataField] = { value: value, type: filterType, props: props };
        } else {
          delete this.currentFilter[dataField];
        }
      } else if (!value || value.trim() === '') {
        delete this.currentFilter[dataField];
      } else {
        this.currentFilter[dataField] = { value: value.trim(), type: filterType, props: props };
      }
      this.emit('onFilterChange', this.currentFilter);
    }
  }]);

  return Filter;
}(_events.EventEmitter);

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Filter, 'Filter', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/Filter.js');
}();

;

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ButtonGroup = function (_Component) {
  _inherits(ButtonGroup, _Component);

  function ButtonGroup() {
    _classCallCheck(this, ButtonGroup);

    return _possibleConstructorReturn(this, (ButtonGroup.__proto__ || Object.getPrototypeOf(ButtonGroup)).apply(this, arguments));
  }

  _createClass(ButtonGroup, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          sizeClass = _props.sizeClass,
          children = _props.children,
          rest = _objectWithoutProperties(_props, ['className', 'sizeClass', 'children']);

      return _react2.default.createElement(
        'div',
        _extends({ className: 'btn-group ' + sizeClass + ' ' + className, role: 'group' }, rest),
        children
      );
    }
  }]);

  return ButtonGroup;
}(_react.Component);

ButtonGroup.propTypes = {
  sizeClass: _propTypes2.default.string,
  className: _propTypes2.default.string
};
ButtonGroup.defaultProps = {
  sizeClass: 'btn-group-sm',
  className: ''
};

var _default = ButtonGroup;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ButtonGroup, 'ButtonGroup', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ButtonGroup.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ButtonGroup.js');
}();

;

/***/ }),
/* 593 */
/***/ (function(module, exports) {

module.exports = {"dimension":[{"label":"GHO","display":"Indicator"},{"label":"PUBLISHSTATE","display":"PUBLISH STATES"},{"label":"YEAR","display":"Year"},{"label":"REGION","display":"WHO region"},{"label":"COUNTRY","display":"Country"},{"label":"SEX","display":"Sex"}],"fact":[{"dims":{"COUNTRY":"Afghanistan","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"0.7"},{"dims":{"COUNTRY":"Afghanistan","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"1.1"},{"dims":{"COUNTRY":"Afghanistan","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"0.4"},{"dims":{"COUNTRY":"Albania","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"2.8"},{"dims":{"COUNTRY":"Albania","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"3.8"},{"dims":{"COUNTRY":"Albania","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.7"},{"dims":{"COUNTRY":"Algeria","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"0.9"},{"dims":{"COUNTRY":"Algeria","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"1.2"},{"dims":{"COUNTRY":"Algeria","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"0.7"},{"dims":{"COUNTRY":"Andorra","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"3.9"},{"dims":{"COUNTRY":"Andorra","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"5.3"},{"dims":{"COUNTRY":"Andorra","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"2.4"},{"dims":{"COUNTRY":"Angola","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"3.2"},{"dims":{"COUNTRY":"Angola","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"4.9"},{"dims":{"COUNTRY":"Angola","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.4"},{"dims":{"COUNTRY":"Antigua and Barbuda","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"2.2"},{"dims":{"COUNTRY":"Antigua and Barbuda","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"3.5"},{"dims":{"COUNTRY":"Antigua and Barbuda","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"0.7"},{"dims":{"COUNTRY":"Argentina","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"5.0"},{"dims":{"COUNTRY":"Argentina","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"6.9"},{"dims":{"COUNTRY":"Argentina","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"2.9"},{"dims":{"COUNTRY":"Armenia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"2.5"},{"dims":{"COUNTRY":"Armenia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"3.4"},{"dims":{"COUNTRY":"Armenia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.5"},{"dims":{"COUNTRY":"Australia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"3.2"},{"dims":{"COUNTRY":"Australia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"5.1"},{"dims":{"COUNTRY":"Australia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.2"},{"dims":{"COUNTRY":"Austria","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"3.8"},{"dims":{"COUNTRY":"Austria","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"6.6"},{"dims":{"COUNTRY":"Austria","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.3"},{"dims":{"COUNTRY":"Azerbaijan","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"2.4"},{"dims":{"COUNTRY":"Azerbaijan","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"2.5"},{"dims":{"COUNTRY":"Azerbaijan","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"2.3"},{"dims":{"COUNTRY":"Bahamas","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"3.1"},{"dims":{"COUNTRY":"Bahamas","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"4.6"},{"dims":{"COUNTRY":"Bahamas","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.3"},{"dims":{"COUNTRY":"Bahrain","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"0.8"},{"dims":{"COUNTRY":"Bahrain","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"1.0"},{"dims":{"COUNTRY":"Bahrain","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"0.4"},{"dims":{"COUNTRY":"Bangladesh","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"0.6"},{"dims":{"COUNTRY":"Bangladesh","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"1.0"},{"dims":{"COUNTRY":"Bangladesh","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"0.0"},{"dims":{"COUNTRY":"Barbados","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"3.3"},{"dims":{"COUNTRY":"Barbados","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"5.2"},{"dims":{"COUNTRY":"Barbados","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.1"},{"dims":{"COUNTRY":"Belarus","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"34.7"},{"dims":{"COUNTRY":"Belarus","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"28.1"},{"dims":{"COUNTRY":"Belarus","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"41.8"},{"dims":{"COUNTRY":"Belgium","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"4.5"},{"dims":{"COUNTRY":"Belgium","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"6.5"},{"dims":{"COUNTRY":"Belgium","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"2.6"},{"dims":{"COUNTRY":"Belize","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"6.8"},{"dims":{"COUNTRY":"Belize","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"10.9"},{"dims":{"COUNTRY":"Belize","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.1"},{"dims":{"COUNTRY":"Benin","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"1.8"},{"dims":{"COUNTRY":"Benin","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"2.4"},{"dims":{"COUNTRY":"Benin","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.3"},{"dims":{"COUNTRY":"Bhutan","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"1.2"},{"dims":{"COUNTRY":"Bhutan","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"1.2"},{"dims":{"COUNTRY":"Bhutan","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.3"},{"dims":{"COUNTRY":"Bolivia (Plurinational State of)","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"4.6"},{"dims":{"COUNTRY":"Bolivia (Plurinational State of)","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"6.3"},{"dims":{"COUNTRY":"Bolivia (Plurinational State of)","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"2.6"},{"dims":{"COUNTRY":"Bosnia and Herzegovina","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"4.1"},{"dims":{"COUNTRY":"Bosnia and Herzegovina","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"6.4"},{"dims":{"COUNTRY":"Bosnia and Herzegovina","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.7"},{"dims":{"COUNTRY":"Botswana","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"3.9"},{"dims":{"COUNTRY":"Botswana","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"7.0"},{"dims":{"COUNTRY":"Botswana","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.0"},{"dims":{"COUNTRY":"Brazil","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"6.4"},{"dims":{"COUNTRY":"Brazil","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"9.7"},{"dims":{"COUNTRY":"Brazil","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"2.1"},{"dims":{"COUNTRY":"Brunei Darussalam","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"1.3"},{"dims":{"COUNTRY":"Brunei Darussalam","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"1.6"},{"dims":{"COUNTRY":"Brunei Darussalam","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"0.9"},{"dims":{"COUNTRY":"Bulgaria","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"5.0"},{"dims":{"COUNTRY":"Bulgaria","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"8.1"},{"dims":{"COUNTRY":"Bulgaria","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.7"},{"dims":{"COUNTRY":"Burkina Faso","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"3.4"},{"dims":{"COUNTRY":"Burkina Faso","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"4.9"},{"dims":{"COUNTRY":"Burkina Faso","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"2.0"},{"dims":{"COUNTRY":"Burundi","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"4.4"},{"dims":{"COUNTRY":"Burundi","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"6.2"},{"dims":{"COUNTRY":"Burundi","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"2.4"},{"dims":{"COUNTRY":"Côte d'Ivoire","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"3.6"},{"dims":{"COUNTRY":"Côte d'Ivoire","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"5.2"},{"dims":{"COUNTRY":"Côte d'Ivoire","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.7"},{"dims":{"COUNTRY":"Cabo Verde","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"3.6"},{"dims":{"COUNTRY":"Cabo Verde","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"5.5"},{"dims":{"COUNTRY":"Cabo Verde","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.3"},{"dims":{"COUNTRY":"Cambodia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"5.0"},{"dims":{"COUNTRY":"Cambodia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"7.8"},{"dims":{"COUNTRY":"Cambodia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"2.0"},{"dims":{"COUNTRY":"Cameroon","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"4.3"},{"dims":{"COUNTRY":"Cameroon","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"6.3"},{"dims":{"COUNTRY":"Cameroon","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"2.1"},{"dims":{"COUNTRY":"Canada","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"3.4"},{"dims":{"COUNTRY":"Canada","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"5.1"},{"dims":{"COUNTRY":"Canada","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.6"},{"dims":{"COUNTRY":"Central African Republic","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"1.8"},{"dims":{"COUNTRY":"Central African Republic","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"2.4"},{"dims":{"COUNTRY":"Central African Republic","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.1"},{"dims":{"COUNTRY":"Chad","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"2.3"},{"dims":{"COUNTRY":"Chad","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"3.2"},{"dims":{"COUNTRY":"Chad","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.3"},{"dims":{"COUNTRY":"Chile","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"6.3"},{"dims":{"COUNTRY":"Chile","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"9.2"},{"dims":{"COUNTRY":"Chile","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"3.0"},{"dims":{"COUNTRY":"China","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"6.3"},{"dims":{"COUNTRY":"China","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"9.0"},{"dims":{"COUNTRY":"China","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"3.1"},{"dims":{"COUNTRY":"Colombia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"4.4"},{"dims":{"COUNTRY":"Colombia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"6.5"},{"dims":{"COUNTRY":"Colombia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.6"},{"dims":{"COUNTRY":"Comoros","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"0.7"},{"dims":{"COUNTRY":"Comoros","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"0.7"},{"dims":{"COUNTRY":"Comoros","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"0.8"},{"dims":{"COUNTRY":"Congo","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"2.2"},{"dims":{"COUNTRY":"Congo","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"3.0"},{"dims":{"COUNTRY":"Congo","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.4"},{"dims":{"COUNTRY":"Cook Islands","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"6.1"},{"dims":{"COUNTRY":"Cook Islands","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"9.2"},{"dims":{"COUNTRY":"Cook Islands","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"2.2"},{"dims":{"COUNTRY":"Costa Rica","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"3.6"},{"dims":{"COUNTRY":"Costa Rica","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"5.5"},{"dims":{"COUNTRY":"Costa Rica","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.2"},{"dims":{"COUNTRY":"Croatia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"5.6"},{"dims":{"COUNTRY":"Croatia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"9.2"},{"dims":{"COUNTRY":"Croatia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.9"},{"dims":{"COUNTRY":"Cuba","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"2.9"},{"dims":{"COUNTRY":"Cuba","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"4.5"},{"dims":{"COUNTRY":"Cuba","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.0"},{"dims":{"COUNTRY":"Cyprus","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"2.1"},{"dims":{"COUNTRY":"Cyprus","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"3.4"},{"dims":{"COUNTRY":"Cyprus","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"0.7"},{"dims":{"COUNTRY":"Czechia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"5.8"},{"dims":{"COUNTRY":"Czechia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"9.4"},{"dims":{"COUNTRY":"Czechia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"2.0"},{"dims":{"COUNTRY":"Democratic People's Republic of Korea","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"4.6"},{"dims":{"COUNTRY":"Democratic People's Republic of Korea","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"7.3"},{"dims":{"COUNTRY":"Democratic People's Republic of Korea","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.7"},{"dims":{"COUNTRY":"Democratic Republic of the Congo","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"2.0"},{"dims":{"COUNTRY":"Democratic Republic of the Congo","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"2.8"},{"dims":{"COUNTRY":"Democratic Republic of the Congo","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.1"},{"dims":{"COUNTRY":"Denmark","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"4.8"},{"dims":{"COUNTRY":"Denmark","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"7.2"},{"dims":{"COUNTRY":"Denmark","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"2.5"},{"dims":{"COUNTRY":"Djibouti","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"2.0"},{"dims":{"COUNTRY":"Djibouti","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"2.6"},{"dims":{"COUNTRY":"Djibouti","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.4"},{"dims":{"COUNTRY":"Dominica","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"3.7"},{"dims":{"COUNTRY":"Dominica","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"5.8"},{"dims":{"COUNTRY":"Dominica","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.3"},{"dims":{"COUNTRY":"Dominican Republic","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"4.1"},{"dims":{"COUNTRY":"Dominican Republic","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"5.8"},{"dims":{"COUNTRY":"Dominican Republic","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"2.3"},{"dims":{"COUNTRY":"Ecuador","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"5.0"},{"dims":{"COUNTRY":"Ecuador","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"6.6"},{"dims":{"COUNTRY":"Ecuador","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"2.9"},{"dims":{"COUNTRY":"Egypt","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"0.8"},{"dims":{"COUNTRY":"Egypt","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"0.9"},{"dims":{"COUNTRY":"Egypt","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"0.7"},{"dims":{"COUNTRY":"El Salvador","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"5.8"},{"dims":{"COUNTRY":"El Salvador","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"8.6"},{"dims":{"COUNTRY":"El Salvador","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"2.1"},{"dims":{"COUNTRY":"Equatorial Guinea","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"2.4"},{"dims":{"COUNTRY":"Equatorial Guinea","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"3.5"},{"dims":{"COUNTRY":"Equatorial Guinea","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.1"},{"dims":{"COUNTRY":"Eritrea","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"0.6"},{"dims":{"COUNTRY":"Eritrea","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"0.8"},{"dims":{"COUNTRY":"Eritrea","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"0.5"},{"dims":{"COUNTRY":"Estonia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"21.4"},{"dims":{"COUNTRY":"Estonia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"19.2"},{"dims":{"COUNTRY":"Estonia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"23.5"},{"dims":{"COUNTRY":"Ethiopia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"3.2"},{"dims":{"COUNTRY":"Ethiopia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"4.1"},{"dims":{"COUNTRY":"Ethiopia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"2.2"},{"dims":{"COUNTRY":"Fiji","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"1.4"},{"dims":{"COUNTRY":"Fiji","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"2.2"},{"dims":{"COUNTRY":"Fiji","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"0.2"},{"dims":{"COUNTRY":"Finland","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"6.4"},{"dims":{"COUNTRY":"Finland","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"9.3"},{"dims":{"COUNTRY":"Finland","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"3.5"},{"dims":{"COUNTRY":"France","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"5.3"},{"dims":{"COUNTRY":"France","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"8.4"},{"dims":{"COUNTRY":"France","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"2.3"},{"dims":{"COUNTRY":"Gabon","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"5.5"},{"dims":{"COUNTRY":"Gabon","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"8.3"},{"dims":{"COUNTRY":"Gabon","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"2.6"},{"dims":{"COUNTRY":"Gambia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"2.5"},{"dims":{"COUNTRY":"Gambia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"3.8"},{"dims":{"COUNTRY":"Gambia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.1"},{"dims":{"COUNTRY":"Georgia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"4.6"},{"dims":{"COUNTRY":"Georgia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"6.5"},{"dims":{"COUNTRY":"Georgia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"2.6"},{"dims":{"COUNTRY":"Germany","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"4.4"},{"dims":{"COUNTRY":"Germany","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"6.7"},{"dims":{"COUNTRY":"Germany","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"2.3"},{"dims":{"COUNTRY":"Ghana","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"3.4"},{"dims":{"COUNTRY":"Ghana","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"4.3"},{"dims":{"COUNTRY":"Ghana","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"2.4"},{"dims":{"COUNTRY":"Greece","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"3.9"},{"dims":{"COUNTRY":"Greece","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"5.3"},{"dims":{"COUNTRY":"Greece","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"2.4"},{"dims":{"COUNTRY":"Grenada","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"4.8"},{"dims":{"COUNTRY":"Grenada","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"6.9"},{"dims":{"COUNTRY":"Grenada","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"2.1"},{"dims":{"COUNTRY":"Guatemala","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"5.3"},{"dims":{"COUNTRY":"Guatemala","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"7.8"},{"dims":{"COUNTRY":"Guatemala","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.9"},{"dims":{"COUNTRY":"Guinea","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"1.0"},{"dims":{"COUNTRY":"Guinea","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"1.3"},{"dims":{"COUNTRY":"Guinea","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"0.7"},{"dims":{"COUNTRY":"Guinea-Bissau","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"1.8"},{"dims":{"COUNTRY":"Guinea-Bissau","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"2.5"},{"dims":{"COUNTRY":"Guinea-Bissau","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.1"},{"dims":{"COUNTRY":"Guyana","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"6.0"},{"dims":{"COUNTRY":"Guyana","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"9.5"},{"dims":{"COUNTRY":"Guyana","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.7"},{"dims":{"COUNTRY":"Haiti","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"2.9"},{"dims":{"COUNTRY":"Haiti","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"4.6"},{"dims":{"COUNTRY":"Haiti","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.1"},{"dims":{"COUNTRY":"Honduras","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"3.2"},{"dims":{"COUNTRY":"Honduras","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"4.5"},{"dims":{"COUNTRY":"Honduras","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.7"},{"dims":{"COUNTRY":"Hungary","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"6.7"},{"dims":{"COUNTRY":"Hungary","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"11.3"},{"dims":{"COUNTRY":"Hungary","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"2.1"},{"dims":{"COUNTRY":"Iceland","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"2.1"},{"dims":{"COUNTRY":"Iceland","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"3.1"},{"dims":{"COUNTRY":"Iceland","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.2"},{"dims":{"COUNTRY":"India","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"5.4"},{"dims":{"COUNTRY":"India","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"8.7"},{"dims":{"COUNTRY":"India","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.3"},{"dims":{"COUNTRY":"Indonesia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"2.1"},{"dims":{"COUNTRY":"Indonesia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"2.5"},{"dims":{"COUNTRY":"Indonesia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.5"},{"dims":{"COUNTRY":"Iran (Islamic Republic of)","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"0.8"},{"dims":{"COUNTRY":"Iran (Islamic Republic of)","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"1.2"},{"dims":{"COUNTRY":"Iran (Islamic Republic of)","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"0.3"},{"dims":{"COUNTRY":"Iraq","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"0.4"},{"dims":{"COUNTRY":"Iraq","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"0.6"},{"dims":{"COUNTRY":"Iraq","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"0.1"},{"dims":{"COUNTRY":"Ireland","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"4.8"},{"dims":{"COUNTRY":"Ireland","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"6.3"},{"dims":{"COUNTRY":"Ireland","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"3.3"},{"dims":{"COUNTRY":"Israel","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"1.1"},{"dims":{"COUNTRY":"Israel","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"1.2"},{"dims":{"COUNTRY":"Israel","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.0"},{"dims":{"COUNTRY":"Italy","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"1.6"},{"dims":{"COUNTRY":"Italy","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"2.2"},{"dims":{"COUNTRY":"Italy","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.0"},{"dims":{"COUNTRY":"Jamaica","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"2.1"},{"dims":{"COUNTRY":"Jamaica","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"3.1"},{"dims":{"COUNTRY":"Jamaica","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"0.9"},{"dims":{"COUNTRY":"Japan","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"3.2"},{"dims":{"COUNTRY":"Japan","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"4.5"},{"dims":{"COUNTRY":"Japan","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.8"},{"dims":{"COUNTRY":"Jordan","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"0.4"},{"dims":{"COUNTRY":"Jordan","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"0.4"},{"dims":{"COUNTRY":"Jordan","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"0.4"},{"dims":{"COUNTRY":"Kazakhstan","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"9.2"},{"dims":{"COUNTRY":"Kazakhstan","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"12.3"},{"dims":{"COUNTRY":"Kazakhstan","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"5.8"},{"dims":{"COUNTRY":"Kenya","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"2.6"},{"dims":{"COUNTRY":"Kenya","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"3.8"},{"dims":{"COUNTRY":"Kenya","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.2"},{"dims":{"COUNTRY":"Kiribati","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"2.0"},{"dims":{"COUNTRY":"Kiribati","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"2.9"},{"dims":{"COUNTRY":"Kiribati","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"0.8"},{"dims":{"COUNTRY":"Kuwait","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"1.1"},{"dims":{"COUNTRY":"Kuwait","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"1.2"},{"dims":{"COUNTRY":"Kuwait","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"0.8"},{"dims":{"COUNTRY":"Kyrgyzstan","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"5.8"},{"dims":{"COUNTRY":"Kyrgyzstan","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"7.4"},{"dims":{"COUNTRY":"Kyrgyzstan","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"3.7"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"4.9"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"7.8"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.7"},{"dims":{"COUNTRY":"Latvia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"24.4"},{"dims":{"COUNTRY":"Latvia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"19.6"},{"dims":{"COUNTRY":"Latvia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"28.9"},{"dims":{"COUNTRY":"Lebanon","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"1.5"},{"dims":{"COUNTRY":"Lebanon","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"2.0"},{"dims":{"COUNTRY":"Lebanon","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"0.8"},{"dims":{"COUNTRY":"Lesotho","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"3.0"},{"dims":{"COUNTRY":"Lesotho","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"5.0"},{"dims":{"COUNTRY":"Lesotho","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.1"},{"dims":{"COUNTRY":"Liberia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"3.0"},{"dims":{"COUNTRY":"Liberia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"4.3"},{"dims":{"COUNTRY":"Liberia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.7"},{"dims":{"COUNTRY":"Libya","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"0.3"},{"dims":{"COUNTRY":"Libya","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"0.4"},{"dims":{"COUNTRY":"Libya","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"0.1"},{"dims":{"COUNTRY":"Lithuania","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"30.9"},{"dims":{"COUNTRY":"Lithuania","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"25.6"},{"dims":{"COUNTRY":"Lithuania","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"36.1"},{"dims":{"COUNTRY":"Luxembourg","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"4.9"},{"dims":{"COUNTRY":"Luxembourg","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"7.2"},{"dims":{"COUNTRY":"Luxembourg","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"2.7"},{"dims":{"COUNTRY":"Madagascar","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"2.4"},{"dims":{"COUNTRY":"Madagascar","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"3.1"},{"dims":{"COUNTRY":"Madagascar","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.6"},{"dims":{"COUNTRY":"Malawi","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"1.7"},{"dims":{"COUNTRY":"Malawi","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"2.6"},{"dims":{"COUNTRY":"Malawi","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"0.8"},{"dims":{"COUNTRY":"Malaysia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"1.7"},{"dims":{"COUNTRY":"Malaysia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"2.0"},{"dims":{"COUNTRY":"Malaysia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.2"},{"dims":{"COUNTRY":"Maldives","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"1.9"},{"dims":{"COUNTRY":"Maldives","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"2.4"},{"dims":{"COUNTRY":"Maldives","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.3"},{"dims":{"COUNTRY":"Mali","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"0.9"},{"dims":{"COUNTRY":"Mali","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"1.4"},{"dims":{"COUNTRY":"Mali","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"0.4"},{"dims":{"COUNTRY":"Malta","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"3.0"},{"dims":{"COUNTRY":"Malta","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"3.8"},{"dims":{"COUNTRY":"Malta","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"2.0"},{"dims":{"COUNTRY":"Marshall Islands","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Comments":"missing data","Value":""},{"dims":{"COUNTRY":"Marshall Islands","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Comments":"missing data","Value":""},{"dims":{"COUNTRY":"Marshall Islands","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Comments":"missing data","Value":""},{"dims":{"COUNTRY":"Mauritania","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"0.6"},{"dims":{"COUNTRY":"Mauritania","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"0.6"},{"dims":{"COUNTRY":"Mauritania","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"0.6"},{"dims":{"COUNTRY":"Mauritius","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"3.9"},{"dims":{"COUNTRY":"Mauritius","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"5.6"},{"dims":{"COUNTRY":"Mauritius","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.5"},{"dims":{"COUNTRY":"Mexico","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"6.8"},{"dims":{"COUNTRY":"Mexico","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"11.8"},{"dims":{"COUNTRY":"Mexico","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"0.7"},{"dims":{"COUNTRY":"Micronesia (Federated States of)","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"2.1"},{"dims":{"COUNTRY":"Micronesia (Federated States of)","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"3.5"},{"dims":{"COUNTRY":"Micronesia (Federated States of)","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"0.5"},{"dims":{"COUNTRY":"Monaco","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Comments":"missing data","Value":""},{"dims":{"COUNTRY":"Monaco","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Comments":"missing data","Value":""},{"dims":{"COUNTRY":"Monaco","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Comments":"missing data","Value":""},{"dims":{"COUNTRY":"Mongolia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"10.5"},{"dims":{"COUNTRY":"Mongolia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"14.0"},{"dims":{"COUNTRY":"Mongolia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"5.3"},{"dims":{"COUNTRY":"Montenegro","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Comments":"missing data","Value":""},{"dims":{"COUNTRY":"Montenegro","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Comments":"missing data","Value":""},{"dims":{"COUNTRY":"Montenegro","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Comments":"missing data","Value":""},{"dims":{"COUNTRY":"Morocco","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"1.1"},{"dims":{"COUNTRY":"Morocco","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"1.6"},{"dims":{"COUNTRY":"Morocco","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"0.6"},{"dims":{"COUNTRY":"Mozambique","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"1.3"},{"dims":{"COUNTRY":"Mozambique","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"1.6"},{"dims":{"COUNTRY":"Mozambique","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"0.9"},{"dims":{"COUNTRY":"Myanmar","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"2.0"},{"dims":{"COUNTRY":"Myanmar","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"2.8"},{"dims":{"COUNTRY":"Myanmar","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.2"},{"dims":{"COUNTRY":"Namibia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"6.9"},{"dims":{"COUNTRY":"Namibia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"10.1"},{"dims":{"COUNTRY":"Namibia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"3.6"},{"dims":{"COUNTRY":"Nauru","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"3.4"},{"dims":{"COUNTRY":"Nauru","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"4.5"},{"dims":{"COUNTRY":"Nauru","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.5"},{"dims":{"COUNTRY":"Nepal","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"2.9"},{"dims":{"COUNTRY":"Nepal","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"4.5"},{"dims":{"COUNTRY":"Nepal","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.1"},{"dims":{"COUNTRY":"Netherlands","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"2.7"},{"dims":{"COUNTRY":"Netherlands","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"3.9"},{"dims":{"COUNTRY":"Netherlands","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.5"},{"dims":{"COUNTRY":"New Zealand","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"2.8"},{"dims":{"COUNTRY":"New Zealand","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"4.3"},{"dims":{"COUNTRY":"New Zealand","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.3"},{"dims":{"COUNTRY":"Nicaragua","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"6.4"},{"dims":{"COUNTRY":"Nicaragua","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"10.1"},{"dims":{"COUNTRY":"Nicaragua","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.6"},{"dims":{"COUNTRY":"Niger","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"0.3"},{"dims":{"COUNTRY":"Niger","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"0.3"},{"dims":{"COUNTRY":"Niger","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"0.4"},{"dims":{"COUNTRY":"Nigeria","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"4.2"},{"dims":{"COUNTRY":"Nigeria","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"5.7"},{"dims":{"COUNTRY":"Nigeria","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"2.5"},{"dims":{"COUNTRY":"Niue","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"5.4"},{"dims":{"COUNTRY":"Niue","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"8.0"},{"dims":{"COUNTRY":"Niue","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"2.0"},{"dims":{"COUNTRY":"Norway","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"2.0"},{"dims":{"COUNTRY":"Norway","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"2.9"},{"dims":{"COUNTRY":"Norway","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.2"},{"dims":{"COUNTRY":"Oman","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"0.8"},{"dims":{"COUNTRY":"Oman","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"1.0"},{"dims":{"COUNTRY":"Oman","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"0.5"},{"dims":{"COUNTRY":"Pakistan","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"0.5"},{"dims":{"COUNTRY":"Pakistan","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"0.4"},{"dims":{"COUNTRY":"Pakistan","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"0.5"},{"dims":{"COUNTRY":"Palau","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"4.6"},{"dims":{"COUNTRY":"Palau","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"7.1"},{"dims":{"COUNTRY":"Palau","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.6"},{"dims":{"COUNTRY":"Panama","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"5.6"},{"dims":{"COUNTRY":"Panama","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"7.9"},{"dims":{"COUNTRY":"Panama","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"2.3"},{"dims":{"COUNTRY":"Papua New Guinea","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"3.1"},{"dims":{"COUNTRY":"Papua New Guinea","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"4.2"},{"dims":{"COUNTRY":"Papua New Guinea","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.7"},{"dims":{"COUNTRY":"Paraguay","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"6.3"},{"dims":{"COUNTRY":"Paraguay","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"8.9"},{"dims":{"COUNTRY":"Paraguay","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"2.5"},{"dims":{"COUNTRY":"Peru","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"6.6"},{"dims":{"COUNTRY":"Peru","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"9.0"},{"dims":{"COUNTRY":"Peru","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"4.0"},{"dims":{"COUNTRY":"Philippines","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"5.2"},{"dims":{"COUNTRY":"Philippines","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"7.6"},{"dims":{"COUNTRY":"Philippines","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.9"},{"dims":{"COUNTRY":"Poland","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"7.0"},{"dims":{"COUNTRY":"Poland","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"10.7"},{"dims":{"COUNTRY":"Poland","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"2.7"},{"dims":{"COUNTRY":"Portugal","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"5.8"},{"dims":{"COUNTRY":"Portugal","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"8.0"},{"dims":{"COUNTRY":"Portugal","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"3.2"},{"dims":{"COUNTRY":"Qatar","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"3.1"},{"dims":{"COUNTRY":"Qatar","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"3.9"},{"dims":{"COUNTRY":"Qatar","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"0.5"},{"dims":{"COUNTRY":"Republic of Korea","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"7.5"},{"dims":{"COUNTRY":"Republic of Korea","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"12.0"},{"dims":{"COUNTRY":"Republic of Korea","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.9"},{"dims":{"COUNTRY":"Republic of Moldova","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"33.1"},{"dims":{"COUNTRY":"Republic of Moldova","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"25.2"},{"dims":{"COUNTRY":"Republic of Moldova","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"41.5"},{"dims":{"COUNTRY":"Romania","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"8.9"},{"dims":{"COUNTRY":"Romania","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"13.6"},{"dims":{"COUNTRY":"Romania","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"3.6"},{"dims":{"COUNTRY":"Russian Federation","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"30.5"},{"dims":{"COUNTRY":"Russian Federation","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"24.6"},{"dims":{"COUNTRY":"Russian Federation","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"37.0"},{"dims":{"COUNTRY":"Rwanda","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"5.6"},{"dims":{"COUNTRY":"Rwanda","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"7.9"},{"dims":{"COUNTRY":"Rwanda","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"3.2"},{"dims":{"COUNTRY":"Saint Kitts and Nevis","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"3.7"},{"dims":{"COUNTRY":"Saint Kitts and Nevis","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"5.0"},{"dims":{"COUNTRY":"Saint Kitts and Nevis","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.9"},{"dims":{"COUNTRY":"Saint Lucia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"4.3"},{"dims":{"COUNTRY":"Saint Lucia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"6.3"},{"dims":{"COUNTRY":"Saint Lucia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.6"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"3.5"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"5.2"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.5"},{"dims":{"COUNTRY":"Samoa","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"2.0"},{"dims":{"COUNTRY":"Samoa","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"3.2"},{"dims":{"COUNTRY":"Samoa","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"0.4"},{"dims":{"COUNTRY":"San Marino","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Comments":"missing data","Value":""},{"dims":{"COUNTRY":"San Marino","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Comments":"missing data","Value":""},{"dims":{"COUNTRY":"San Marino","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Comments":"missing data","Value":""},{"dims":{"COUNTRY":"Sao Tome and Principe","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"3.5"},{"dims":{"COUNTRY":"Sao Tome and Principe","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"4.9"},{"dims":{"COUNTRY":"Sao Tome and Principe","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.8"},{"dims":{"COUNTRY":"Saudi Arabia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"0.5"},{"dims":{"COUNTRY":"Saudi Arabia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"0.6"},{"dims":{"COUNTRY":"Saudi Arabia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"0.2"},{"dims":{"COUNTRY":"Senegal","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"1.0"},{"dims":{"COUNTRY":"Senegal","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"1.0"},{"dims":{"COUNTRY":"Senegal","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"0.9"},{"dims":{"COUNTRY":"Serbia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"4.4"},{"dims":{"COUNTRY":"Serbia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"7.6"},{"dims":{"COUNTRY":"Serbia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.3"},{"dims":{"COUNTRY":"Seychelles","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"4.7"},{"dims":{"COUNTRY":"Seychelles","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"6.8"},{"dims":{"COUNTRY":"Seychelles","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.9"},{"dims":{"COUNTRY":"Sierra Leone","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"4.5"},{"dims":{"COUNTRY":"Sierra Leone","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"6.8"},{"dims":{"COUNTRY":"Sierra Leone","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"2.2"},{"dims":{"COUNTRY":"Singapore","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"2.2"},{"dims":{"COUNTRY":"Singapore","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"2.6"},{"dims":{"COUNTRY":"Singapore","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.7"},{"dims":{"COUNTRY":"Slovakia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"7.7"},{"dims":{"COUNTRY":"Slovakia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"12.0"},{"dims":{"COUNTRY":"Slovakia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"2.9"},{"dims":{"COUNTRY":"Slovenia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"7.9"},{"dims":{"COUNTRY":"Slovenia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"12.6"},{"dims":{"COUNTRY":"Slovenia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"3.1"},{"dims":{"COUNTRY":"Solomon Islands","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"2.1"},{"dims":{"COUNTRY":"Solomon Islands","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"2.9"},{"dims":{"COUNTRY":"Solomon Islands","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.0"},{"dims":{"COUNTRY":"Somalia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"0.3"},{"dims":{"COUNTRY":"Somalia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"0.4"},{"dims":{"COUNTRY":"Somalia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"0.3"},{"dims":{"COUNTRY":"South Africa","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"6.4"},{"dims":{"COUNTRY":"South Africa","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"10.1"},{"dims":{"COUNTRY":"South Africa","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"2.2"},{"dims":{"COUNTRY":"South Sudan","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"2.2"},{"dims":{"COUNTRY":"South Sudan","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"3.3"},{"dims":{"COUNTRY":"South Sudan","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.0"},{"dims":{"COUNTRY":"Spain","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"3.6"},{"dims":{"COUNTRY":"Spain","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"5.1"},{"dims":{"COUNTRY":"Spain","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"2.1"},{"dims":{"COUNTRY":"Sri Lanka","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"5.8"},{"dims":{"COUNTRY":"Sri Lanka","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"8.6"},{"dims":{"COUNTRY":"Sri Lanka","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.6"},{"dims":{"COUNTRY":"Sudan","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"2.9"},{"dims":{"COUNTRY":"Sudan","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"4.2"},{"dims":{"COUNTRY":"Sudan","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.4"},{"dims":{"COUNTRY":"Suriname","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"4.2"},{"dims":{"COUNTRY":"Suriname","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"6.1"},{"dims":{"COUNTRY":"Suriname","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.7"},{"dims":{"COUNTRY":"Swaziland","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"3.3"},{"dims":{"COUNTRY":"Swaziland","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"5.4"},{"dims":{"COUNTRY":"Swaziland","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.1"},{"dims":{"COUNTRY":"Sweden","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"3.3"},{"dims":{"COUNTRY":"Sweden","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"4.8"},{"dims":{"COUNTRY":"Sweden","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.9"},{"dims":{"COUNTRY":"Switzerland","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"3.6"},{"dims":{"COUNTRY":"Switzerland","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"5.5"},{"dims":{"COUNTRY":"Switzerland","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.8"},{"dims":{"COUNTRY":"Syrian Arab Republic","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"0.7"},{"dims":{"COUNTRY":"Syrian Arab Republic","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"0.7"},{"dims":{"COUNTRY":"Syrian Arab Republic","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"0.5"},{"dims":{"COUNTRY":"Tajikistan","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"3.3"},{"dims":{"COUNTRY":"Tajikistan","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"3.3"},{"dims":{"COUNTRY":"Tajikistan","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"3.3"},{"dims":{"COUNTRY":"Thailand","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"6.8"},{"dims":{"COUNTRY":"Thailand","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"10.1"},{"dims":{"COUNTRY":"Thailand","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"2.0"},{"dims":{"COUNTRY":"The former Yugoslav republic of Macedonia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"2.8"},{"dims":{"COUNTRY":"The former Yugoslav republic of Macedonia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"4.4"},{"dims":{"COUNTRY":"The former Yugoslav republic of Macedonia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.2"},{"dims":{"COUNTRY":"Timor-Leste","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"1.2"},{"dims":{"COUNTRY":"Timor-Leste","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"1.4"},{"dims":{"COUNTRY":"Timor-Leste","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.0"},{"dims":{"COUNTRY":"Togo","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"1.5"},{"dims":{"COUNTRY":"Togo","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"2.0"},{"dims":{"COUNTRY":"Togo","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.0"},{"dims":{"COUNTRY":"Tonga","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"1.1"},{"dims":{"COUNTRY":"Tonga","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"1.5"},{"dims":{"COUNTRY":"Tonga","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"0.9"},{"dims":{"COUNTRY":"Trinidad and Tobago","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"3.4"},{"dims":{"COUNTRY":"Trinidad and Tobago","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"5.1"},{"dims":{"COUNTRY":"Trinidad and Tobago","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.2"},{"dims":{"COUNTRY":"Tunisia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"1.7"},{"dims":{"COUNTRY":"Tunisia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"2.7"},{"dims":{"COUNTRY":"Tunisia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"0.5"},{"dims":{"COUNTRY":"Turkey","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"1.3"},{"dims":{"COUNTRY":"Turkey","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"2.0"},{"dims":{"COUNTRY":"Turkey","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"0.3"},{"dims":{"COUNTRY":"Turkmenistan","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"4.9"},{"dims":{"COUNTRY":"Turkmenistan","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"5.8"},{"dims":{"COUNTRY":"Turkmenistan","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"3.8"},{"dims":{"COUNTRY":"Tuvalu","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"2.2"},{"dims":{"COUNTRY":"Tuvalu","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"2.7"},{"dims":{"COUNTRY":"Tuvalu","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.5"},{"dims":{"COUNTRY":"Uganda","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"5.0"},{"dims":{"COUNTRY":"Uganda","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"6.7"},{"dims":{"COUNTRY":"Uganda","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"3.2"},{"dims":{"COUNTRY":"Ukraine","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"34.4"},{"dims":{"COUNTRY":"Ukraine","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"24.6"},{"dims":{"COUNTRY":"Ukraine","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"43.9"},{"dims":{"COUNTRY":"United Arab Emirates","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"6.8"},{"dims":{"COUNTRY":"United Arab Emirates","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"8.7"},{"dims":{"COUNTRY":"United Arab Emirates","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"0.7"},{"dims":{"COUNTRY":"United Kingdom of Great Britain and Northern Ireland","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"3.4"},{"dims":{"COUNTRY":"United Kingdom of Great Britain and Northern Ireland","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"5.1"},{"dims":{"COUNTRY":"United Kingdom of Great Britain and Northern Ireland","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.8"},{"dims":{"COUNTRY":"United Republic of Tanzania","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"4.1"},{"dims":{"COUNTRY":"United Republic of Tanzania","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"5.6"},{"dims":{"COUNTRY":"United Republic of Tanzania","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"2.4"},{"dims":{"COUNTRY":"United States of America","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"3.2"},{"dims":{"COUNTRY":"United States of America","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"4.8"},{"dims":{"COUNTRY":"United States of America","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.6"},{"dims":{"COUNTRY":"Uruguay","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"2.9"},{"dims":{"COUNTRY":"Uruguay","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"4.1"},{"dims":{"COUNTRY":"Uruguay","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.6"},{"dims":{"COUNTRY":"Uzbekistan","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"4.9"},{"dims":{"COUNTRY":"Uzbekistan","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"5.7"},{"dims":{"COUNTRY":"Uzbekistan","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"3.9"},{"dims":{"COUNTRY":"Vanuatu","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"1.6"},{"dims":{"COUNTRY":"Vanuatu","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"1.9"},{"dims":{"COUNTRY":"Vanuatu","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.1"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"10.8"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"16.5"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.7"},{"dims":{"COUNTRY":"Viet Nam","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"8.3"},{"dims":{"COUNTRY":"Viet Nam","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"13.6"},{"dims":{"COUNTRY":"Viet Nam","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.6"},{"dims":{"COUNTRY":"Yemen","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"0.5"},{"dims":{"COUNTRY":"Yemen","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"0.6"},{"dims":{"COUNTRY":"Yemen","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"0.4"},{"dims":{"COUNTRY":"Zambia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"2.1"},{"dims":{"COUNTRY":"Zambia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"3.0"},{"dims":{"COUNTRY":"Zambia","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"1.0"},{"dims":{"COUNTRY":"Zimbabwe","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Both sexes","YEAR":"2012"},"Value":"2.9"},{"dims":{"COUNTRY":"Zimbabwe","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Male","YEAR":"2012"},"Value":"4.8"},{"dims":{"COUNTRY":"Zimbabwe","GHO":"Alcohol-attributable fractions, all-cause deaths (%)","SEX":"Female","YEAR":"2012"},"Value":"0.9"}]}

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_recharts__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WikiQuote_js__ = __webpack_require__(21);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BeforeFiveMortality=__webpack_require__(595);var MortalityBeforeFiveChart=function(_Component){_inherits(MortalityBeforeFiveChart,_Component);function MortalityBeforeFiveChart(props){_classCallCheck(this,MortalityBeforeFiveChart);var _this=_possibleConstructorReturn(this,(MortalityBeforeFiveChart.__proto__||Object.getPrototypeOf(MortalityBeforeFiveChart)).call(this,props));_this.state={data:[],quote:""};return _this;}_createClass(MortalityBeforeFiveChart,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var quote="",data=[];var success=function success(wikiData){quote='"'+wikiData.quote+'"';};__WEBPACK_IMPORTED_MODULE_3__WikiQuote_js__["a" /* WikiquoteApi */].getRandomQuote("Childhood",success,__WEBPACK_IMPORTED_MODULE_3__WikiQuote_js__["b" /* error */]);data=Object(__WEBPACK_IMPORTED_MODULE_2__utils_js__["h" /* mapTable */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_js__["f" /* filterTable */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_js__["g" /* initialReformat */])(BeforeFiveMortality)));var checkQuoteLength=function checkQuoteLength(){if(quote.length>0){_this2.setState({quote:quote,data:data});}else{setTimeout(checkQuoteLength,100);}};checkQuoteLength();}},{key:'render',value:function render(){var data=[],dataFilter=[],formatData=[],j=0;if(this.state.data.length>0){//separates data based upon year.. as so: [some_title: {some_year: [objs_of_data],...},...]
data=Object(__WEBPACK_IMPORTED_MODULE_2__utils_js__["c" /* filterAll */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_js__["b" /* dataFunction */])(this.state.data));//averages data from all years based upon region, {region1: data1, ...}
dataFilter=Object(__WEBPACK_IMPORTED_MODULE_2__utils_js__["a" /* averageDataByYear */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_js__["i" /* separateDataByYears */])(data,'Under-five mortality rate (probability of dying by age 5 per 1000 live births)'));//format data to be read by recharts
for(var key in dataFilter){formatData[j]={};formatData[j].region=key;formatData[j].value=parseInt(dataFilter[key],10);j++;}}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'chart under-five'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,this.state.quote),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h6',{className:'title'},'Under-five mortality rate (probability of dying by age 5 per 1000 live births)'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["k" /* ResponsiveContainer */],{width:'100%',height:300},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["j" /* RadarChart */],{cx:'50%',cy:'50%',outerRadius:'80%',data:formatData},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["g" /* PolarGrid */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["f" /* PolarAngleAxis */],{dataKey:'region'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["h" /* PolarRadiusAxis */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["l" /* Tooltip */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["i" /* Radar */],{name:'probability',dataKey:'value',stroke:'#8884d8',fill:'#160e68',fillOpacity:0.6}))));}}]);return MortalityBeforeFiveChart;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (MortalityBeforeFiveChart);

/***/ }),
/* 595 */
/***/ (function(module, exports) {

module.exports = {"dimension":[{"label":"GHO","display":"Indicator"},{"label":"PUBLISHSTATE","display":"PUBLISH STATES"},{"label":"YEAR","display":"Year"},{"label":"REGION","display":"WHO region"}],"fact":[{"dims":{"REGION":"Africa","YEAR":"2016","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"52.3"},{"dims":{"REGION":"Africa","YEAR":"2016","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"27.2"},{"dims":{"REGION":"Africa","YEAR":"2016","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"76.5"},{"dims":{"REGION":"Africa","YEAR":"2015","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"53.9"},{"dims":{"REGION":"Africa","YEAR":"2015","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"27.7"},{"dims":{"REGION":"Africa","YEAR":"2015","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"79.5"},{"dims":{"REGION":"Africa","YEAR":"2014","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"55.6"},{"dims":{"REGION":"Africa","YEAR":"2014","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"28.4"},{"dims":{"REGION":"Africa","YEAR":"2014","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"82.6"},{"dims":{"REGION":"Africa","YEAR":"2013","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"57.5"},{"dims":{"REGION":"Africa","YEAR":"2013","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"29.1"},{"dims":{"REGION":"Africa","YEAR":"2013","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"86.1"},{"dims":{"REGION":"Africa","YEAR":"2012","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"59.5"},{"dims":{"REGION":"Africa","YEAR":"2012","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"29.9"},{"dims":{"REGION":"Africa","YEAR":"2012","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"89.9"},{"dims":{"REGION":"Africa","YEAR":"2011","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"61.7"},{"dims":{"REGION":"Africa","YEAR":"2011","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"30.7"},{"dims":{"REGION":"Africa","YEAR":"2011","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"94.1"},{"dims":{"REGION":"Africa","YEAR":"2010","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"64.0"},{"dims":{"REGION":"Africa","YEAR":"2010","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"31.5"},{"dims":{"REGION":"Africa","YEAR":"2010","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"98.6"},{"dims":{"REGION":"Africa","YEAR":"2009","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"66.5"},{"dims":{"REGION":"Africa","YEAR":"2009","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"32.3"},{"dims":{"REGION":"Africa","YEAR":"2009","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"103.4"},{"dims":{"REGION":"Africa","YEAR":"2008","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"69.2"},{"dims":{"REGION":"Africa","YEAR":"2008","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"33.2"},{"dims":{"REGION":"Africa","YEAR":"2008","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"108.4"},{"dims":{"REGION":"Africa","YEAR":"2007","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"72.0"},{"dims":{"REGION":"Africa","YEAR":"2007","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"34.1"},{"dims":{"REGION":"Africa","YEAR":"2007","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"113.8"},{"dims":{"REGION":"Africa","YEAR":"2006","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"75.0"},{"dims":{"REGION":"Africa","YEAR":"2006","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"35.0"},{"dims":{"REGION":"Africa","YEAR":"2006","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"119.4"},{"dims":{"REGION":"Africa","YEAR":"2005","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"78.0"},{"dims":{"REGION":"Africa","YEAR":"2005","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"36.0"},{"dims":{"REGION":"Africa","YEAR":"2005","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"125.1"},{"dims":{"REGION":"Africa","YEAR":"2004","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"81.2"},{"dims":{"REGION":"Africa","YEAR":"2004","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"37.0"},{"dims":{"REGION":"Africa","YEAR":"2004","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"131.1"},{"dims":{"REGION":"Africa","YEAR":"2003","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"84.5"},{"dims":{"REGION":"Africa","YEAR":"2003","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"38.0"},{"dims":{"REGION":"Africa","YEAR":"2003","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"137.1"},{"dims":{"REGION":"Africa","YEAR":"2002","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"87.6"},{"dims":{"REGION":"Africa","YEAR":"2002","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"39.0"},{"dims":{"REGION":"Africa","YEAR":"2002","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"143.0"},{"dims":{"REGION":"Africa","YEAR":"2001","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"90.7"},{"dims":{"REGION":"Africa","YEAR":"2001","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"40.0"},{"dims":{"REGION":"Africa","YEAR":"2001","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"148.7"},{"dims":{"REGION":"Africa","YEAR":"2000","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"93.5"},{"dims":{"REGION":"Africa","YEAR":"2000","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"40.9"},{"dims":{"REGION":"Africa","YEAR":"2000","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"154.0"},{"dims":{"REGION":"Africa","YEAR":"1999","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"96.0"},{"dims":{"REGION":"Africa","YEAR":"1999","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"41.8"},{"dims":{"REGION":"Africa","YEAR":"1999","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"158.7"},{"dims":{"REGION":"Africa","YEAR":"1998","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"98.2"},{"dims":{"REGION":"Africa","YEAR":"1998","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"42.5"},{"dims":{"REGION":"Africa","YEAR":"1998","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"162.9"},{"dims":{"REGION":"Africa","YEAR":"1997","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"100.0"},{"dims":{"REGION":"Africa","YEAR":"1997","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"43.1"},{"dims":{"REGION":"Africa","YEAR":"1997","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"165.9"},{"dims":{"REGION":"Africa","YEAR":"1996","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"101.4"},{"dims":{"REGION":"Africa","YEAR":"1996","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"43.6"},{"dims":{"REGION":"Africa","YEAR":"1996","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"168.3"},{"dims":{"REGION":"Africa","YEAR":"1995","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"102.6"},{"dims":{"REGION":"Africa","YEAR":"1995","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"44.0"},{"dims":{"REGION":"Africa","YEAR":"1995","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"171.2"},{"dims":{"REGION":"Africa","YEAR":"1994","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"103.7"},{"dims":{"REGION":"Africa","YEAR":"1994","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"44.3"},{"dims":{"REGION":"Africa","YEAR":"1994","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"173.5"},{"dims":{"REGION":"Africa","YEAR":"1993","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"104.4"},{"dims":{"REGION":"Africa","YEAR":"1993","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"44.6"},{"dims":{"REGION":"Africa","YEAR":"1993","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"173.8"},{"dims":{"REGION":"Africa","YEAR":"1992","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"105.0"},{"dims":{"REGION":"Africa","YEAR":"1992","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"44.9"},{"dims":{"REGION":"Africa","YEAR":"1992","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"175.0"},{"dims":{"REGION":"Africa","YEAR":"1991","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"105.8"},{"dims":{"REGION":"Africa","YEAR":"1991","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"45.2"},{"dims":{"REGION":"Africa","YEAR":"1991","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"176.3"},{"dims":{"REGION":"Africa","YEAR":"1990","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"106.5"},{"dims":{"REGION":"Africa","YEAR":"1990","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"45.5"},{"dims":{"REGION":"Africa","YEAR":"1990","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"177.7"},{"dims":{"REGION":"Americas","YEAR":"2016","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"12.1"},{"dims":{"REGION":"Americas","YEAR":"2016","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"7.5"},{"dims":{"REGION":"Americas","YEAR":"2016","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"14.2"},{"dims":{"REGION":"Americas","YEAR":"2015","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"12.5"},{"dims":{"REGION":"Americas","YEAR":"2015","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"7.8"},{"dims":{"REGION":"Americas","YEAR":"2015","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"14.7"},{"dims":{"REGION":"Americas","YEAR":"2014","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"12.9"},{"dims":{"REGION":"Americas","YEAR":"2014","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"8.0"},{"dims":{"REGION":"Americas","YEAR":"2014","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"15.2"},{"dims":{"REGION":"Americas","YEAR":"2013","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"13.3"},{"dims":{"REGION":"Americas","YEAR":"2013","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"8.3"},{"dims":{"REGION":"Americas","YEAR":"2013","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"15.7"},{"dims":{"REGION":"Americas","YEAR":"2012","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"13.8"},{"dims":{"REGION":"Americas","YEAR":"2012","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"8.5"},{"dims":{"REGION":"Americas","YEAR":"2012","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"16.2"},{"dims":{"REGION":"Americas","YEAR":"2011","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"14.2"},{"dims":{"REGION":"Americas","YEAR":"2011","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"8.7"},{"dims":{"REGION":"Americas","YEAR":"2011","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"16.8"},{"dims":{"REGION":"Americas","YEAR":"2010","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"15.1"},{"dims":{"REGION":"Americas","YEAR":"2010","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"8.9"},{"dims":{"REGION":"Americas","YEAR":"2010","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"19.7"},{"dims":{"REGION":"Americas","YEAR":"2009","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"15.2"},{"dims":{"REGION":"Americas","YEAR":"2009","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"9.1"},{"dims":{"REGION":"Americas","YEAR":"2009","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"17.9"},{"dims":{"REGION":"Americas","YEAR":"2008","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"15.7"},{"dims":{"REGION":"Americas","YEAR":"2008","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"9.3"},{"dims":{"REGION":"Americas","YEAR":"2008","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"18.6"},{"dims":{"REGION":"Americas","YEAR":"2007","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"16.3"},{"dims":{"REGION":"Americas","YEAR":"2007","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"9.6"},{"dims":{"REGION":"Americas","YEAR":"2007","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"19.3"},{"dims":{"REGION":"Americas","YEAR":"2006","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"16.9"},{"dims":{"REGION":"Americas","YEAR":"2006","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"9.9"},{"dims":{"REGION":"Americas","YEAR":"2006","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"20.1"},{"dims":{"REGION":"Americas","YEAR":"2005","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"17.6"},{"dims":{"REGION":"Americas","YEAR":"2005","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"10.3"},{"dims":{"REGION":"Americas","YEAR":"2005","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"20.9"},{"dims":{"REGION":"Americas","YEAR":"2004","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"18.4"},{"dims":{"REGION":"Americas","YEAR":"2004","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"10.7"},{"dims":{"REGION":"Americas","YEAR":"2004","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"21.9"},{"dims":{"REGION":"Americas","YEAR":"2003","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"19.2"},{"dims":{"REGION":"Americas","YEAR":"2003","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"11.1"},{"dims":{"REGION":"Americas","YEAR":"2003","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"22.9"},{"dims":{"REGION":"Americas","YEAR":"2002","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"20.1"},{"dims":{"REGION":"Americas","YEAR":"2002","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"11.6"},{"dims":{"REGION":"Americas","YEAR":"2002","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"24.1"},{"dims":{"REGION":"Americas","YEAR":"2001","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"21.1"},{"dims":{"REGION":"Americas","YEAR":"2001","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"12.1"},{"dims":{"REGION":"Americas","YEAR":"2001","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"25.3"},{"dims":{"REGION":"Americas","YEAR":"2000","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"22.1"},{"dims":{"REGION":"Americas","YEAR":"2000","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"12.6"},{"dims":{"REGION":"Americas","YEAR":"2000","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"26.6"},{"dims":{"REGION":"Americas","YEAR":"1999","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"23.2"},{"dims":{"REGION":"Americas","YEAR":"1999","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"13.1"},{"dims":{"REGION":"Americas","YEAR":"1999","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"28.2"},{"dims":{"REGION":"Americas","YEAR":"1998","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"24.4"},{"dims":{"REGION":"Americas","YEAR":"1998","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"13.7"},{"dims":{"REGION":"Americas","YEAR":"1998","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"29.8"},{"dims":{"REGION":"Americas","YEAR":"1997","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"25.5"},{"dims":{"REGION":"Americas","YEAR":"1997","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"14.2"},{"dims":{"REGION":"Americas","YEAR":"1997","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"31.1"},{"dims":{"REGION":"Americas","YEAR":"1996","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"26.7"},{"dims":{"REGION":"Americas","YEAR":"1996","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"14.8"},{"dims":{"REGION":"Americas","YEAR":"1996","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"32.7"},{"dims":{"REGION":"Americas","YEAR":"1995","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"28.0"},{"dims":{"REGION":"Americas","YEAR":"1995","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"15.4"},{"dims":{"REGION":"Americas","YEAR":"1995","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"34.4"},{"dims":{"REGION":"Americas","YEAR":"1994","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"29.3"},{"dims":{"REGION":"Americas","YEAR":"1994","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"15.9"},{"dims":{"REGION":"Americas","YEAR":"1994","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"36.2"},{"dims":{"REGION":"Americas","YEAR":"1993","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"30.6"},{"dims":{"REGION":"Americas","YEAR":"1993","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"16.5"},{"dims":{"REGION":"Americas","YEAR":"1993","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"37.9"},{"dims":{"REGION":"Americas","YEAR":"1992","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"31.9"},{"dims":{"REGION":"Americas","YEAR":"1992","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"17.0"},{"dims":{"REGION":"Americas","YEAR":"1992","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"39.7"},{"dims":{"REGION":"Americas","YEAR":"1991","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"33.2"},{"dims":{"REGION":"Americas","YEAR":"1991","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"17.6"},{"dims":{"REGION":"Americas","YEAR":"1991","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"41.6"},{"dims":{"REGION":"Americas","YEAR":"1990","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"34.5"},{"dims":{"REGION":"Americas","YEAR":"1990","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"18.2"},{"dims":{"REGION":"Americas","YEAR":"1990","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"43.5"},{"dims":{"REGION":"South-East Asia","YEAR":"2016","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"31.5"},{"dims":{"REGION":"South-East Asia","YEAR":"2016","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"22.6"},{"dims":{"REGION":"South-East Asia","YEAR":"2016","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"38.9"},{"dims":{"REGION":"South-East Asia","YEAR":"2015","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"32.9"},{"dims":{"REGION":"South-East Asia","YEAR":"2015","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"23.4"},{"dims":{"REGION":"South-East Asia","YEAR":"2015","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"40.8"},{"dims":{"REGION":"South-East Asia","YEAR":"2014","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"34.4"},{"dims":{"REGION":"South-East Asia","YEAR":"2014","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"24.4"},{"dims":{"REGION":"South-East Asia","YEAR":"2014","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"43.0"},{"dims":{"REGION":"South-East Asia","YEAR":"2013","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"36.0"},{"dims":{"REGION":"South-East Asia","YEAR":"2013","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"25.3"},{"dims":{"REGION":"South-East Asia","YEAR":"2013","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"45.3"},{"dims":{"REGION":"South-East Asia","YEAR":"2012","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"37.7"},{"dims":{"REGION":"South-East Asia","YEAR":"2012","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"26.4"},{"dims":{"REGION":"South-East Asia","YEAR":"2012","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"47.7"},{"dims":{"REGION":"South-East Asia","YEAR":"2011","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"39.4"},{"dims":{"REGION":"South-East Asia","YEAR":"2011","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"27.4"},{"dims":{"REGION":"South-East Asia","YEAR":"2011","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"50.3"},{"dims":{"REGION":"South-East Asia","YEAR":"2010","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"41.3"},{"dims":{"REGION":"South-East Asia","YEAR":"2010","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"28.5"},{"dims":{"REGION":"South-East Asia","YEAR":"2010","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"52.9"},{"dims":{"REGION":"South-East Asia","YEAR":"2009","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"43.2"},{"dims":{"REGION":"South-East Asia","YEAR":"2009","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"29.7"},{"dims":{"REGION":"South-East Asia","YEAR":"2009","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"55.7"},{"dims":{"REGION":"South-East Asia","YEAR":"2008","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"45.2"},{"dims":{"REGION":"South-East Asia","YEAR":"2008","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"30.8"},{"dims":{"REGION":"South-East Asia","YEAR":"2008","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"59.1"},{"dims":{"REGION":"South-East Asia","YEAR":"2007","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"47.0"},{"dims":{"REGION":"South-East Asia","YEAR":"2007","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"31.9"},{"dims":{"REGION":"South-East Asia","YEAR":"2007","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"61.4"},{"dims":{"REGION":"South-East Asia","YEAR":"2006","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"49.0"},{"dims":{"REGION":"South-East Asia","YEAR":"2006","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"33.1"},{"dims":{"REGION":"South-East Asia","YEAR":"2006","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"64.3"},{"dims":{"REGION":"South-East Asia","YEAR":"2005","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"50.9"},{"dims":{"REGION":"South-East Asia","YEAR":"2005","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"34.2"},{"dims":{"REGION":"South-East Asia","YEAR":"2005","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"67.3"},{"dims":{"REGION":"South-East Asia","YEAR":"2004","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"53.0"},{"dims":{"REGION":"South-East Asia","YEAR":"2004","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"35.4"},{"dims":{"REGION":"South-East Asia","YEAR":"2004","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"71.3"},{"dims":{"REGION":"South-East Asia","YEAR":"2003","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"54.9"},{"dims":{"REGION":"South-East Asia","YEAR":"2003","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"36.6"},{"dims":{"REGION":"South-East Asia","YEAR":"2003","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"73.6"},{"dims":{"REGION":"South-East Asia","YEAR":"2002","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"57.0"},{"dims":{"REGION":"South-East Asia","YEAR":"2002","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"37.9"},{"dims":{"REGION":"South-East Asia","YEAR":"2002","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"76.9"},{"dims":{"REGION":"South-East Asia","YEAR":"2001","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"59.2"},{"dims":{"REGION":"South-East Asia","YEAR":"2001","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"39.3"},{"dims":{"REGION":"South-East Asia","YEAR":"2001","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"80.3"},{"dims":{"REGION":"South-East Asia","YEAR":"2000","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"61.5"},{"dims":{"REGION":"South-East Asia","YEAR":"2000","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"40.6"},{"dims":{"REGION":"South-East Asia","YEAR":"2000","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"83.8"},{"dims":{"REGION":"South-East Asia","YEAR":"1999","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"63.7"},{"dims":{"REGION":"South-East Asia","YEAR":"1999","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"41.9"},{"dims":{"REGION":"South-East Asia","YEAR":"1999","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"87.4"},{"dims":{"REGION":"South-East Asia","YEAR":"1998","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"66.0"},{"dims":{"REGION":"South-East Asia","YEAR":"1998","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"43.2"},{"dims":{"REGION":"South-East Asia","YEAR":"1998","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"90.9"},{"dims":{"REGION":"South-East Asia","YEAR":"1997","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"68.3"},{"dims":{"REGION":"South-East Asia","YEAR":"1997","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"44.5"},{"dims":{"REGION":"South-East Asia","YEAR":"1997","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"94.5"},{"dims":{"REGION":"South-East Asia","YEAR":"1996","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"70.5"},{"dims":{"REGION":"South-East Asia","YEAR":"1996","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"45.7"},{"dims":{"REGION":"South-East Asia","YEAR":"1996","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"97.9"},{"dims":{"REGION":"South-East Asia","YEAR":"1995","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"72.7"},{"dims":{"REGION":"South-East Asia","YEAR":"1995","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"46.9"},{"dims":{"REGION":"South-East Asia","YEAR":"1995","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"101.3"},{"dims":{"REGION":"South-East Asia","YEAR":"1994","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"74.8"},{"dims":{"REGION":"South-East Asia","YEAR":"1994","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"48.0"},{"dims":{"REGION":"South-East Asia","YEAR":"1994","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"104.7"},{"dims":{"REGION":"South-East Asia","YEAR":"1993","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"77.0"},{"dims":{"REGION":"South-East Asia","YEAR":"1993","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"49.2"},{"dims":{"REGION":"South-East Asia","YEAR":"1993","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"108.0"},{"dims":{"REGION":"South-East Asia","YEAR":"1992","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"79.1"},{"dims":{"REGION":"South-East Asia","YEAR":"1992","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"50.4"},{"dims":{"REGION":"South-East Asia","YEAR":"1992","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"111.4"},{"dims":{"REGION":"South-East Asia","YEAR":"1991","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"81.3"},{"dims":{"REGION":"South-East Asia","YEAR":"1991","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"51.5"},{"dims":{"REGION":"South-East Asia","YEAR":"1991","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"114.9"},{"dims":{"REGION":"South-East Asia","YEAR":"1990","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"83.6"},{"dims":{"REGION":"South-East Asia","YEAR":"1990","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"52.7"},{"dims":{"REGION":"South-East Asia","YEAR":"1990","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"118.5"},{"dims":{"REGION":"Europe","YEAR":"2016","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"8.3"},{"dims":{"REGION":"Europe","YEAR":"2016","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"5.1"},{"dims":{"REGION":"Europe","YEAR":"2016","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"9.6"},{"dims":{"REGION":"Europe","YEAR":"2015","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"8.7"},{"dims":{"REGION":"Europe","YEAR":"2015","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"5.3"},{"dims":{"REGION":"Europe","YEAR":"2015","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"10.1"},{"dims":{"REGION":"Europe","YEAR":"2014","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"9.1"},{"dims":{"REGION":"Europe","YEAR":"2014","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"5.5"},{"dims":{"REGION":"Europe","YEAR":"2014","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"10.5"},{"dims":{"REGION":"Europe","YEAR":"2013","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"9.5"},{"dims":{"REGION":"Europe","YEAR":"2013","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"5.7"},{"dims":{"REGION":"Europe","YEAR":"2013","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"11.0"},{"dims":{"REGION":"Europe","YEAR":"2012","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"9.9"},{"dims":{"REGION":"Europe","YEAR":"2012","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"5.9"},{"dims":{"REGION":"Europe","YEAR":"2012","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"11.5"},{"dims":{"REGION":"Europe","YEAR":"2011","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"10.4"},{"dims":{"REGION":"Europe","YEAR":"2011","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"6.2"},{"dims":{"REGION":"Europe","YEAR":"2011","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"12.1"},{"dims":{"REGION":"Europe","YEAR":"2010","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"10.9"},{"dims":{"REGION":"Europe","YEAR":"2010","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"6.4"},{"dims":{"REGION":"Europe","YEAR":"2010","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"12.6"},{"dims":{"REGION":"Europe","YEAR":"2009","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"11.4"},{"dims":{"REGION":"Europe","YEAR":"2009","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"6.7"},{"dims":{"REGION":"Europe","YEAR":"2009","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"13.2"},{"dims":{"REGION":"Europe","YEAR":"2008","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"11.9"},{"dims":{"REGION":"Europe","YEAR":"2008","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"7.0"},{"dims":{"REGION":"Europe","YEAR":"2008","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"13.9"},{"dims":{"REGION":"Europe","YEAR":"2007","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"12.4"},{"dims":{"REGION":"Europe","YEAR":"2007","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"7.3"},{"dims":{"REGION":"Europe","YEAR":"2007","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"14.6"},{"dims":{"REGION":"Europe","YEAR":"2006","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"13.1"},{"dims":{"REGION":"Europe","YEAR":"2006","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"7.7"},{"dims":{"REGION":"Europe","YEAR":"2006","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"15.4"},{"dims":{"REGION":"Europe","YEAR":"2005","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"13.7"},{"dims":{"REGION":"Europe","YEAR":"2005","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"8.1"},{"dims":{"REGION":"Europe","YEAR":"2005","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"16.2"},{"dims":{"REGION":"Europe","YEAR":"2004","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"14.5"},{"dims":{"REGION":"Europe","YEAR":"2004","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"8.5"},{"dims":{"REGION":"Europe","YEAR":"2004","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"17.1"},{"dims":{"REGION":"Europe","YEAR":"2003","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"15.3"},{"dims":{"REGION":"Europe","YEAR":"2003","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"8.9"},{"dims":{"REGION":"Europe","YEAR":"2003","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"18.2"},{"dims":{"REGION":"Europe","YEAR":"2002","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"16.1"},{"dims":{"REGION":"Europe","YEAR":"2002","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"9.4"},{"dims":{"REGION":"Europe","YEAR":"2002","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"19.3"},{"dims":{"REGION":"Europe","YEAR":"2001","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"17.0"},{"dims":{"REGION":"Europe","YEAR":"2001","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"9.9"},{"dims":{"REGION":"Europe","YEAR":"2001","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"20.4"},{"dims":{"REGION":"Europe","YEAR":"2000","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"17.9"},{"dims":{"REGION":"Europe","YEAR":"2000","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"10.3"},{"dims":{"REGION":"Europe","YEAR":"2000","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"21.6"},{"dims":{"REGION":"Europe","YEAR":"1999","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"18.9"},{"dims":{"REGION":"Europe","YEAR":"1999","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"10.8"},{"dims":{"REGION":"Europe","YEAR":"1999","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"22.9"},{"dims":{"REGION":"Europe","YEAR":"1998","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"19.8"},{"dims":{"REGION":"Europe","YEAR":"1998","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"11.3"},{"dims":{"REGION":"Europe","YEAR":"1998","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"24.1"},{"dims":{"REGION":"Europe","YEAR":"1997","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"20.7"},{"dims":{"REGION":"Europe","YEAR":"1997","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"11.7"},{"dims":{"REGION":"Europe","YEAR":"1997","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"25.3"},{"dims":{"REGION":"Europe","YEAR":"1996","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"21.6"},{"dims":{"REGION":"Europe","YEAR":"1996","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"12.2"},{"dims":{"REGION":"Europe","YEAR":"1996","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"26.4"},{"dims":{"REGION":"Europe","YEAR":"1995","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"22.4"},{"dims":{"REGION":"Europe","YEAR":"1995","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"12.6"},{"dims":{"REGION":"Europe","YEAR":"1995","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"27.5"},{"dims":{"REGION":"Europe","YEAR":"1994","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"23.1"},{"dims":{"REGION":"Europe","YEAR":"1994","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"13.0"},{"dims":{"REGION":"Europe","YEAR":"1994","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"28.4"},{"dims":{"REGION":"Europe","YEAR":"1993","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"23.6"},{"dims":{"REGION":"Europe","YEAR":"1993","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"13.2"},{"dims":{"REGION":"Europe","YEAR":"1993","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"29.1"},{"dims":{"REGION":"Europe","YEAR":"1992","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"24.1"},{"dims":{"REGION":"Europe","YEAR":"1992","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"13.5"},{"dims":{"REGION":"Europe","YEAR":"1992","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"29.6"},{"dims":{"REGION":"Europe","YEAR":"1991","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"24.4"},{"dims":{"REGION":"Europe","YEAR":"1991","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"13.7"},{"dims":{"REGION":"Europe","YEAR":"1991","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"30.1"},{"dims":{"REGION":"Europe","YEAR":"1990","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"24.9"},{"dims":{"REGION":"Europe","YEAR":"1990","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"13.9"},{"dims":{"REGION":"Europe","YEAR":"1990","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"30.8"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2016","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"40.6"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2016","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"27.7"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2016","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"51.7"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2015","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"41.4"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2015","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"28.2"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2015","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"53.0"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2014","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"42.4"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2014","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"28.8"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2014","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"54.5"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2013","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"43.5"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2013","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"29.4"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2013","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"56.0"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2012","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"44.6"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2012","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"30.1"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2012","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"57.6"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2011","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"45.7"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2011","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"30.7"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2011","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"59.2"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2010","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"46.9"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2010","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"31.4"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2010","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"61.0"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2009","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"48.1"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2009","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"31.9"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2009","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"62.8"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2008","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"49.5"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2008","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"32.5"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2008","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"64.7"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2007","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"50.8"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2007","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"33.1"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2007","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"66.7"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2006","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"52.1"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2006","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"33.8"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2006","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"68.6"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2005","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"53.4"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2005","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"34.5"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2005","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"70.4"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2004","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"54.7"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2004","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"35.3"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2004","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"72.3"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2003","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"56.0"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2003","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"36.1"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2003","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"74.3"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2002","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"57.5"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2002","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"36.9"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2002","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"76.4"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2001","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"59.0"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2001","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"37.8"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2001","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"78.6"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2000","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"60.6"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2000","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"38.6"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"2000","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"80.8"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"1999","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"62.2"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"1999","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"39.5"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"1999","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"83.1"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"1998","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"63.7"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"1998","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"40.3"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"1998","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"85.3"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"1997","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"65.3"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"1997","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"41.1"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"1997","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"87.4"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"1996","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"66.8"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"1996","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"41.7"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"1996","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"89.6"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"1995","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"68.2"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"1995","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"42.3"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"1995","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"91.6"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"1994","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"69.6"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"1994","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"42.8"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"1994","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"93.6"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"1993","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"71.0"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"1993","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"43.1"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"1993","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"95.6"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"1992","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"72.4"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"1992","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"43.2"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"1992","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"97.7"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"1991","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"73.9"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"1991","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"43.3"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"1991","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"100.0"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"1990","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"75.5"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"1990","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"43.4"},{"dims":{"REGION":"Eastern Mediterranean","YEAR":"1990","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"102.4"},{"dims":{"REGION":"Western Pacific","YEAR":"2016","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"10.8"},{"dims":{"REGION":"Western Pacific","YEAR":"2016","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"6.5"},{"dims":{"REGION":"Western Pacific","YEAR":"2016","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"12.9"},{"dims":{"REGION":"Western Pacific","YEAR":"2015","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"11.4"},{"dims":{"REGION":"Western Pacific","YEAR":"2015","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"6.8"},{"dims":{"REGION":"Western Pacific","YEAR":"2015","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"13.7"},{"dims":{"REGION":"Western Pacific","YEAR":"2014","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"11.9"},{"dims":{"REGION":"Western Pacific","YEAR":"2014","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"7.2"},{"dims":{"REGION":"Western Pacific","YEAR":"2014","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"14.3"},{"dims":{"REGION":"Western Pacific","YEAR":"2013","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"12.6"},{"dims":{"REGION":"Western Pacific","YEAR":"2013","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"7.6"},{"dims":{"REGION":"Western Pacific","YEAR":"2013","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"15.2"},{"dims":{"REGION":"Western Pacific","YEAR":"2012","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"13.4"},{"dims":{"REGION":"Western Pacific","YEAR":"2012","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"8.0"},{"dims":{"REGION":"Western Pacific","YEAR":"2012","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"16.1"},{"dims":{"REGION":"Western Pacific","YEAR":"2011","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"14.1"},{"dims":{"REGION":"Western Pacific","YEAR":"2011","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"8.6"},{"dims":{"REGION":"Western Pacific","YEAR":"2011","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"17.0"},{"dims":{"REGION":"Western Pacific","YEAR":"2010","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"15.0"},{"dims":{"REGION":"Western Pacific","YEAR":"2010","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"9.1"},{"dims":{"REGION":"Western Pacific","YEAR":"2010","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"18.0"},{"dims":{"REGION":"Western Pacific","YEAR":"2009","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"15.9"},{"dims":{"REGION":"Western Pacific","YEAR":"2009","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"9.8"},{"dims":{"REGION":"Western Pacific","YEAR":"2009","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"19.1"},{"dims":{"REGION":"Western Pacific","YEAR":"2008","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"16.9"},{"dims":{"REGION":"Western Pacific","YEAR":"2008","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"10.5"},{"dims":{"REGION":"Western Pacific","YEAR":"2008","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"20.3"},{"dims":{"REGION":"Western Pacific","YEAR":"2007","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"17.9"},{"dims":{"REGION":"Western Pacific","YEAR":"2007","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"11.4"},{"dims":{"REGION":"Western Pacific","YEAR":"2007","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"21.6"},{"dims":{"REGION":"Western Pacific","YEAR":"2006","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"19.2"},{"dims":{"REGION":"Western Pacific","YEAR":"2006","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"12.4"},{"dims":{"REGION":"Western Pacific","YEAR":"2006","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"23.2"},{"dims":{"REGION":"Western Pacific","YEAR":"2005","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"20.5"},{"dims":{"REGION":"Western Pacific","YEAR":"2005","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"13.5"},{"dims":{"REGION":"Western Pacific","YEAR":"2005","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"24.9"},{"dims":{"REGION":"Western Pacific","YEAR":"2004","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"22.0"},{"dims":{"REGION":"Western Pacific","YEAR":"2004","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"14.5"},{"dims":{"REGION":"Western Pacific","YEAR":"2004","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"26.8"},{"dims":{"REGION":"Western Pacific","YEAR":"2003","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"23.6"},{"dims":{"REGION":"Western Pacific","YEAR":"2003","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"15.6"},{"dims":{"REGION":"Western Pacific","YEAR":"2003","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"28.8"},{"dims":{"REGION":"Western Pacific","YEAR":"2002","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"25.2"},{"dims":{"REGION":"Western Pacific","YEAR":"2002","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"16.7"},{"dims":{"REGION":"Western Pacific","YEAR":"2002","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"31.0"},{"dims":{"REGION":"Western Pacific","YEAR":"2001","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"26.8"},{"dims":{"REGION":"Western Pacific","YEAR":"2001","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"17.7"},{"dims":{"REGION":"Western Pacific","YEAR":"2001","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"33.2"},{"dims":{"REGION":"Western Pacific","YEAR":"2000","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"28.3"},{"dims":{"REGION":"Western Pacific","YEAR":"2000","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"18.7"},{"dims":{"REGION":"Western Pacific","YEAR":"2000","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"35.3"},{"dims":{"REGION":"Western Pacific","YEAR":"1999","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"29.7"},{"dims":{"REGION":"Western Pacific","YEAR":"1999","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"19.6"},{"dims":{"REGION":"Western Pacific","YEAR":"1999","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"37.3"},{"dims":{"REGION":"Western Pacific","YEAR":"1998","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"31.1"},{"dims":{"REGION":"Western Pacific","YEAR":"1998","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"20.5"},{"dims":{"REGION":"Western Pacific","YEAR":"1998","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"39.2"},{"dims":{"REGION":"Western Pacific","YEAR":"1997","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"32.3"},{"dims":{"REGION":"Western Pacific","YEAR":"1997","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"21.4"},{"dims":{"REGION":"Western Pacific","YEAR":"1997","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"41.0"},{"dims":{"REGION":"Western Pacific","YEAR":"1996","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"33.6"},{"dims":{"REGION":"Western Pacific","YEAR":"1996","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"22.3"},{"dims":{"REGION":"Western Pacific","YEAR":"1996","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"42.7"},{"dims":{"REGION":"Western Pacific","YEAR":"1995","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"34.8"},{"dims":{"REGION":"Western Pacific","YEAR":"1995","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"23.4"},{"dims":{"REGION":"Western Pacific","YEAR":"1995","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"44.6"},{"dims":{"REGION":"Western Pacific","YEAR":"1994","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"36.1"},{"dims":{"REGION":"Western Pacific","YEAR":"1994","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"24.3"},{"dims":{"REGION":"Western Pacific","YEAR":"1994","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"46.3"},{"dims":{"REGION":"Western Pacific","YEAR":"1993","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"37.3"},{"dims":{"REGION":"Western Pacific","YEAR":"1993","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"25.2"},{"dims":{"REGION":"Western Pacific","YEAR":"1993","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"48.0"},{"dims":{"REGION":"Western Pacific","YEAR":"1992","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"38.4"},{"dims":{"REGION":"Western Pacific","YEAR":"1992","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"25.9"},{"dims":{"REGION":"Western Pacific","YEAR":"1992","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"49.6"},{"dims":{"REGION":"Western Pacific","YEAR":"1991","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"39.3"},{"dims":{"REGION":"Western Pacific","YEAR":"1991","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"26.4"},{"dims":{"REGION":"Western Pacific","YEAR":"1991","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"50.9"},{"dims":{"REGION":"Western Pacific","YEAR":"1990","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"40.0"},{"dims":{"REGION":"Western Pacific","YEAR":"1990","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"26.8"},{"dims":{"REGION":"Western Pacific","YEAR":"1990","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"51.9"},{"dims":{"REGION":"Global","YEAR":"2016","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"30.5"},{"dims":{"REGION":"Global","YEAR":"2016","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"18.6"},{"dims":{"REGION":"Global","YEAR":"2016","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"40.8"},{"dims":{"REGION":"Global","YEAR":"2015","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"31.4"},{"dims":{"REGION":"Global","YEAR":"2015","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"19.1"},{"dims":{"REGION":"Global","YEAR":"2015","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"42.2"},{"dims":{"REGION":"Global","YEAR":"2014","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"32.4"},{"dims":{"REGION":"Global","YEAR":"2014","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"19.6"},{"dims":{"REGION":"Global","YEAR":"2014","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"43.7"},{"dims":{"REGION":"Global","YEAR":"2013","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"33.6"},{"dims":{"REGION":"Global","YEAR":"2013","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"20.2"},{"dims":{"REGION":"Global","YEAR":"2013","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"45.5"},{"dims":{"REGION":"Global","YEAR":"2012","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"34.7"},{"dims":{"REGION":"Global","YEAR":"2012","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"20.8"},{"dims":{"REGION":"Global","YEAR":"2012","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"47.3"},{"dims":{"REGION":"Global","YEAR":"2011","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"36.0"},{"dims":{"REGION":"Global","YEAR":"2011","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"21.5"},{"dims":{"REGION":"Global","YEAR":"2011","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"49.3"},{"dims":{"REGION":"Global","YEAR":"2010","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"37.4"},{"dims":{"REGION":"Global","YEAR":"2010","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"22.2"},{"dims":{"REGION":"Global","YEAR":"2010","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"51.7"},{"dims":{"REGION":"Global","YEAR":"2009","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"38.8"},{"dims":{"REGION":"Global","YEAR":"2009","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"22.9"},{"dims":{"REGION":"Global","YEAR":"2009","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"53.7"},{"dims":{"REGION":"Global","YEAR":"2008","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"40.3"},{"dims":{"REGION":"Global","YEAR":"2008","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"23.6"},{"dims":{"REGION":"Global","YEAR":"2008","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"56.2"},{"dims":{"REGION":"Global","YEAR":"2007","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"41.8"},{"dims":{"REGION":"Global","YEAR":"2007","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"24.4"},{"dims":{"REGION":"Global","YEAR":"2007","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"58.5"},{"dims":{"REGION":"Global","YEAR":"2006","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"43.4"},{"dims":{"REGION":"Global","YEAR":"2006","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"25.3"},{"dims":{"REGION":"Global","YEAR":"2006","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"61.1"},{"dims":{"REGION":"Global","YEAR":"2005","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"45.1"},{"dims":{"REGION":"Global","YEAR":"2005","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"26.1"},{"dims":{"REGION":"Global","YEAR":"2005","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"63.7"},{"dims":{"REGION":"Global","YEAR":"2004","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"46.9"},{"dims":{"REGION":"Global","YEAR":"2004","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"27.0"},{"dims":{"REGION":"Global","YEAR":"2004","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"66.7"},{"dims":{"REGION":"Global","YEAR":"2003","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"48.6"},{"dims":{"REGION":"Global","YEAR":"2003","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"28.0"},{"dims":{"REGION":"Global","YEAR":"2003","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"69.2"},{"dims":{"REGION":"Global","YEAR":"2002","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"50.3"},{"dims":{"REGION":"Global","YEAR":"2002","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"28.9"},{"dims":{"REGION":"Global","YEAR":"2002","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"72.0"},{"dims":{"REGION":"Global","YEAR":"2001","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"52.1"},{"dims":{"REGION":"Global","YEAR":"2001","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"29.8"},{"dims":{"REGION":"Global","YEAR":"2001","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"74.8"},{"dims":{"REGION":"Global","YEAR":"2000","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"53.9"},{"dims":{"REGION":"Global","YEAR":"2000","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"30.7"},{"dims":{"REGION":"Global","YEAR":"2000","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"77.5"},{"dims":{"REGION":"Global","YEAR":"1999","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"55.4"},{"dims":{"REGION":"Global","YEAR":"1999","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"31.5"},{"dims":{"REGION":"Global","YEAR":"1999","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"79.9"},{"dims":{"REGION":"Global","YEAR":"1998","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"56.9"},{"dims":{"REGION":"Global","YEAR":"1998","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"32.3"},{"dims":{"REGION":"Global","YEAR":"1998","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"82.1"},{"dims":{"REGION":"Global","YEAR":"1997","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"58.2"},{"dims":{"REGION":"Global","YEAR":"1997","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"33.1"},{"dims":{"REGION":"Global","YEAR":"1997","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"84.0"},{"dims":{"REGION":"Global","YEAR":"1996","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"59.4"},{"dims":{"REGION":"Global","YEAR":"1996","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"33.7"},{"dims":{"REGION":"Global","YEAR":"1996","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"85.6"},{"dims":{"REGION":"Global","YEAR":"1995","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"60.5"},{"dims":{"REGION":"Global","YEAR":"1995","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"34.4"},{"dims":{"REGION":"Global","YEAR":"1995","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"87.3"},{"dims":{"REGION":"Global","YEAR":"1994","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"61.4"},{"dims":{"REGION":"Global","YEAR":"1994","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"34.9"},{"dims":{"REGION":"Global","YEAR":"1994","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"88.7"},{"dims":{"REGION":"Global","YEAR":"1993","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"62.3"},{"dims":{"REGION":"Global","YEAR":"1993","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"35.4"},{"dims":{"REGION":"Global","YEAR":"1993","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"89.7"},{"dims":{"REGION":"Global","YEAR":"1992","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"63.1"},{"dims":{"REGION":"Global","YEAR":"1992","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"35.9"},{"dims":{"REGION":"Global","YEAR":"1992","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"90.9"},{"dims":{"REGION":"Global","YEAR":"1991","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"63.9"},{"dims":{"REGION":"Global","YEAR":"1991","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"36.3"},{"dims":{"REGION":"Global","YEAR":"1991","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"92.1"},{"dims":{"REGION":"Global","YEAR":"1990","GHO":"Infant mortality rate (probability of dying between birth and age 1 per 1000 live births)"},"Value":"64.8"},{"dims":{"REGION":"Global","YEAR":"1990","GHO":"Neonatal mortality rate (per 1000 live births)"},"Value":"36.8"},{"dims":{"REGION":"Global","YEAR":"1990","GHO":"Under-five mortality rate (probability of dying by age 5 per 1000 live births)"},"Value":"93.4"}]}

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_recharts__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WikiQuote_js__ = __webpack_require__(21);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HIVKnowledgeData=__webpack_require__(597);var HIVKnowledge=function(_Component){_inherits(HIVKnowledge,_Component);function HIVKnowledge(props){_classCallCheck(this,HIVKnowledge);var _this=_possibleConstructorReturn(this,(HIVKnowledge.__proto__||Object.getPrototypeOf(HIVKnowledge)).call(this,props));_this.state={data:[],quote:""};return _this;}_createClass(HIVKnowledge,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var quote="",data=[];var success=function success(wikiData){quote='"'+wikiData.quote+'"';};var checkQuoteLength=function checkQuoteLength(){if(quote.length>0){_this2.setState({quote:quote,data:data});}else{setTimeout(checkQuoteLength,100);}};__WEBPACK_IMPORTED_MODULE_3__WikiQuote_js__["a" /* WikiquoteApi */].getRandomQuote("HIV/AIDS",success,__WEBPACK_IMPORTED_MODULE_3__WikiQuote_js__["b" /* error */]);data=Object(__WEBPACK_IMPORTED_MODULE_2__utils_js__["h" /* mapTable */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_js__["f" /* filterTable */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_js__["g" /* initialReformat */])(HIVKnowledgeData)));checkQuoteLength();}},{key:'render',value:function render(){var data=[],finalData=[],i=0;if(this.state.data.length>0){//format data so that data can be utilised by year... [title: {year: [obj_with_data, ...], ...}, ...]
data=Object(__WEBPACK_IMPORTED_MODULE_2__utils_js__["c" /* filterAll */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_js__["b" /* dataFunction */])(this.state.data));//what exact countries do I want to show data for?
data=data['Knowlege about sexual transmission of AIDS'];//set each country as a 'dataKey' with value what is shown on the chart.
for(var year in data){finalData.push({year:year});data[year].forEach(function(obj){//do this in case there is a male and female to average the data between gender
if(parseFloat(finalData[i][obj.country])>0){finalData[i][obj.country]=(finalData[i][obj.country]+ +obj.value)/2;}//otherwise set to value if only male or female, or first instance of either
else finalData[i][obj.country]=+obj.value;});i++;}}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'chart bar HIV'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,this.state.quote),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h6',null,'Knowlege about sexual transmission of AIDS (Average Both Sexes)'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["k" /* ResponsiveContainer */],{width:'100%',height:300},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["e" /* LineChart */],{cx:'50%',cy:'50%',outerRadius:'80%',data:finalData},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["m" /* XAxis */],{dataKey:'year'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["n" /* YAxis */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["c" /* CartesianGrid */],{strokeDasharray:'3 3'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["l" /* Tooltip */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["d" /* Line */],{connectNulls:true,type:'monotone',dataKey:'Zambia',stroke:'black'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["d" /* Line */],{connectNulls:true,type:'monotone',dataKey:'Bangladesh',stroke:'green'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["d" /* Line */],{connectNulls:true,type:'monotone',dataKey:'Bolivia (Plurinational State of)',stroke:'purple'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["d" /* Line */],{connectNulls:true,type:'monotone',dataKey:'Cameroon',stroke:'orange'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["d" /* Line */],{connectNulls:true,type:'monotone',dataKey:'Ghana',stroke:'brown'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["d" /* Line */],{connectNulls:true,type:'monotone',dataKey:'Malawi',stroke:'#C90016'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["d" /* Line */],{connectNulls:true,type:'monotone',dataKey:'Nepal',stroke:'red'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["d" /* Line */],{connectNulls:true,type:'monotone',dataKey:'Zimbabwe',stroke:'maroon'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["d" /* Line */],{connectNulls:true,type:'monotone',dataKey:'United Republic of Tanzania',stroke:'grey'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["d" /* Line */],{connectNulls:true,type:'monotone',dataKey:'Peru',stroke:'#6082B6'}))));}}]);return HIVKnowledge;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (HIVKnowledge);

/***/ }),
/* 597 */
/***/ (function(module, exports) {

module.exports = {"dimension":[{"label":"GHO","display":"Indicator"},{"label":"DATASOURCE","display":"Data Source"},{"label":"PUBLISHSTATE","display":"PUBLISH STATES"},{"label":"YEAR","display":"Year"},{"label":"REGION","display":"WHO region"},{"label":"COUNTRY","display":"Country"},{"label":"SEX","display":"Sex"}],"fact":[{"dims":{"COUNTRY":"Afghanistan","YEAR":"2010","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"8.8"},{"dims":{"COUNTRY":"Albania","YEAR":"2008","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"75.5"},{"dims":{"COUNTRY":"Albania","YEAR":"2008","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"67.1"},{"dims":{"COUNTRY":"Albania","YEAR":"2005","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"64.4"},{"dims":{"COUNTRY":"Argentina","YEAR":"2011","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"78.5"},{"dims":{"COUNTRY":"Armenia","YEAR":"2010","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"80.2"},{"dims":{"COUNTRY":"Armenia","YEAR":"2010","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"68.9"},{"dims":{"COUNTRY":"Armenia","YEAR":"2005","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"78.3"},{"dims":{"COUNTRY":"Armenia","YEAR":"2005","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"67.3"},{"dims":{"COUNTRY":"Armenia","YEAR":"2000","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"81.1"},{"dims":{"COUNTRY":"Armenia","YEAR":"2000","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"65.5"},{"dims":{"COUNTRY":"Azerbaijan","YEAR":"2006","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"50.8"},{"dims":{"COUNTRY":"Azerbaijan","YEAR":"2006","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"25.1"},{"dims":{"COUNTRY":"Bangladesh","YEAR":"2011","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"55.9"},{"dims":{"COUNTRY":"Bangladesh","YEAR":"2011","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"37.4"},{"dims":{"COUNTRY":"Bangladesh","YEAR":"2007","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"51.0"},{"dims":{"COUNTRY":"Bangladesh","YEAR":"2007","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"20.1"},{"dims":{"COUNTRY":"Bangladesh","YEAR":"2006","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"37.3"},{"dims":{"COUNTRY":"Bangladesh","YEAR":"2004","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"1.0"},{"dims":{"COUNTRY":"Bangladesh","YEAR":"2004","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"1.5"},{"dims":{"COUNTRY":"Bangladesh","YEAR":"1999","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"3.0"},{"dims":{"COUNTRY":"Bangladesh","YEAR":"1999","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"0.6"},{"dims":{"COUNTRY":"Bangladesh","YEAR":"1996","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"1.8"},{"dims":{"COUNTRY":"Bangladesh","YEAR":"1996","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"0.2"},{"dims":{"COUNTRY":"Barbados","YEAR":"2012","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"85.0"},{"dims":{"COUNTRY":"Belarus","YEAR":"2012","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"86.5"},{"dims":{"COUNTRY":"Belarus","YEAR":"2012","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"88.2"},{"dims":{"COUNTRY":"Belarus","YEAR":"2005","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"57.4"},{"dims":{"COUNTRY":"Belize","YEAR":"2011","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"64.5"},{"dims":{"COUNTRY":"Belize","YEAR":"2006","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"58.6"},{"dims":{"COUNTRY":"Benin","YEAR":"2011","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"72.3"},{"dims":{"COUNTRY":"Benin","YEAR":"2011","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"64.5"},{"dims":{"COUNTRY":"Benin","YEAR":"2006","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"82.3"},{"dims":{"COUNTRY":"Benin","YEAR":"2006","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"72.7"},{"dims":{"COUNTRY":"Benin","YEAR":"2001","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"53.5"},{"dims":{"COUNTRY":"Benin","YEAR":"2001","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"68.4"},{"dims":{"COUNTRY":"Benin","YEAR":"1996","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"10.4"},{"dims":{"COUNTRY":"Benin","YEAR":"1996","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"7.3"},{"dims":{"COUNTRY":"Bhutan","YEAR":"2010","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"51.0"},{"dims":{"COUNTRY":"Bolivia (Plurinational State of)","YEAR":"2008","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"62.8"},{"dims":{"COUNTRY":"Bolivia (Plurinational State of)","YEAR":"2008","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"49.9"},{"dims":{"COUNTRY":"Bolivia (Plurinational State of)","YEAR":"2003","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"63.1"},{"dims":{"COUNTRY":"Bolivia (Plurinational State of)","YEAR":"2003","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"56.5"},{"dims":{"COUNTRY":"Bolivia (Plurinational State of)","YEAR":"1998","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"24.4"},{"dims":{"COUNTRY":"Bolivia (Plurinational State of)","YEAR":"1998","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"22.5"},{"dims":{"COUNTRY":"Bolivia (Plurinational State of)","YEAR":"1994","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"9.1"},{"dims":{"COUNTRY":"Bosnia and Herzegovina","YEAR":"2011","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"88.3"},{"dims":{"COUNTRY":"Bosnia and Herzegovina","YEAR":"2011","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"82.1"},{"dims":{"COUNTRY":"Bosnia and Herzegovina","YEAR":"2006","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"76.4"},{"dims":{"COUNTRY":"Brazil","YEAR":"1996","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"9.0"},{"dims":{"COUNTRY":"Brazil","YEAR":"1996","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"5.6"},{"dims":{"COUNTRY":"Burkina Faso","YEAR":"2010","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"86.6"},{"dims":{"COUNTRY":"Burkina Faso","YEAR":"2010","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"74.2"},{"dims":{"COUNTRY":"Burkina Faso","YEAR":"2006","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"62.8"},{"dims":{"COUNTRY":"Burkina Faso","YEAR":"2003","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"67.6"},{"dims":{"COUNTRY":"Burkina Faso","YEAR":"2003","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"60.7"},{"dims":{"COUNTRY":"Burkina Faso","YEAR":"1998","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"30.6"},{"dims":{"COUNTRY":"Burkina Faso","YEAR":"1998","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"9.0"},{"dims":{"COUNTRY":"Burkina Faso","YEAR":"1993","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"16.2"},{"dims":{"COUNTRY":"Burundi","YEAR":"2010","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"84.5"},{"dims":{"COUNTRY":"Burundi","YEAR":"2010","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"79.0"},{"dims":{"COUNTRY":"Burundi","YEAR":"2005","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"56.5"},{"dims":{"COUNTRY":"Côte d'Ivoire","YEAR":"2011","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"68.2"},{"dims":{"COUNTRY":"Côte d'Ivoire","YEAR":"2011","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"50.7"},{"dims":{"COUNTRY":"Côte d'Ivoire","YEAR":"1998","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"24.2"},{"dims":{"COUNTRY":"Côte d'Ivoire","YEAR":"1998","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"76.8"},{"dims":{"COUNTRY":"Côte d'Ivoire","YEAR":"1994","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"27.5"},{"dims":{"COUNTRY":"Côte d'Ivoire","YEAR":"1994","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"75.7"},{"dims":{"COUNTRY":"Cambodia","YEAR":"2010","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"80.1"},{"dims":{"COUNTRY":"Cambodia","YEAR":"2010","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"74.5"},{"dims":{"COUNTRY":"Cambodia","YEAR":"2005","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"85.1"},{"dims":{"COUNTRY":"Cambodia","YEAR":"2005","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"80.3"},{"dims":{"COUNTRY":"Cambodia","YEAR":"2000","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"77.5"},{"dims":{"COUNTRY":"Cameroon","YEAR":"2011","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"67.4"},{"dims":{"COUNTRY":"Cameroon","YEAR":"2011","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"60.6"},{"dims":{"COUNTRY":"Cameroon","YEAR":"2006","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"59.3"},{"dims":{"COUNTRY":"Cameroon","YEAR":"2004","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"73.8"},{"dims":{"COUNTRY":"Cameroon","YEAR":"2004","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"62.1"},{"dims":{"COUNTRY":"Cameroon","YEAR":"1998","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"14.0"},{"dims":{"COUNTRY":"Cameroon","YEAR":"1998","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"9.4"},{"dims":{"COUNTRY":"Central African Republic","YEAR":"2010","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"66.5"},{"dims":{"COUNTRY":"Central African Republic","YEAR":"2010","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"57.4"},{"dims":{"COUNTRY":"Central African Republic","YEAR":"2006","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"69.0"},{"dims":{"COUNTRY":"Central African Republic","YEAR":"2006","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"56.2"},{"dims":{"COUNTRY":"Central African Republic","YEAR":"1994","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"19.9"},{"dims":{"COUNTRY":"Central African Republic","YEAR":"1994","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"11.4"},{"dims":{"COUNTRY":"Chad","YEAR":"2010","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"25.4"},{"dims":{"COUNTRY":"Chad","YEAR":"2004","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"54.0"},{"dims":{"COUNTRY":"Chad","YEAR":"2004","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"22.9"},{"dims":{"COUNTRY":"Chad","YEAR":"1996","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"7.4"},{"dims":{"COUNTRY":"Chad","YEAR":"1996","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"3.9"},{"dims":{"COUNTRY":"Colombia","YEAR":"2010","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"67.6"},{"dims":{"COUNTRY":"Colombia","YEAR":"2005","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"13.1"},{"dims":{"COUNTRY":"Colombia","YEAR":"2000","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"9.1"},{"dims":{"COUNTRY":"Colombia","YEAR":"1995","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"37.7"},{"dims":{"COUNTRY":"Comoros","YEAR":"2012","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"79.6"},{"dims":{"COUNTRY":"Comoros","YEAR":"2012","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"60.9"},{"dims":{"COUNTRY":"Comoros","YEAR":"1996","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"25.3"},{"dims":{"COUNTRY":"Comoros","YEAR":"1996","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"17.8"},{"dims":{"COUNTRY":"Congo","YEAR":"2011","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"79.5"},{"dims":{"COUNTRY":"Congo","YEAR":"2011","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"70.8"},{"dims":{"COUNTRY":"Congo","YEAR":"2005","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"77.6"},{"dims":{"COUNTRY":"Congo","YEAR":"2005","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"65.5"},{"dims":{"COUNTRY":"Costa Rica","YEAR":"2011","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"76.2"},{"dims":{"COUNTRY":"Cuba","YEAR":"2010","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"23.1"},{"dims":{"COUNTRY":"Cuba","YEAR":"2006","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"15.9"},{"dims":{"COUNTRY":"Democratic Republic of the Congo","YEAR":"2013","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"67.0"},{"dims":{"COUNTRY":"Democratic Republic of the Congo","YEAR":"2013","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"50.8"},{"dims":{"COUNTRY":"Democratic Republic of the Congo","YEAR":"2010","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"41.4"},{"dims":{"COUNTRY":"Democratic Republic of the Congo","YEAR":"2007","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"57.6"},{"dims":{"COUNTRY":"Democratic Republic of the Congo","YEAR":"2007","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"49.2"},{"dims":{"COUNTRY":"Djibouti","YEAR":"2006","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"40.9"},{"dims":{"COUNTRY":"Dominican Republic","YEAR":"2013","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"79.4"},{"dims":{"COUNTRY":"Dominican Republic","YEAR":"2013","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"80.4"},{"dims":{"COUNTRY":"Dominican Republic","YEAR":"2007","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"82.2"},{"dims":{"COUNTRY":"Dominican Republic","YEAR":"2007","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"76.6"},{"dims":{"COUNTRY":"Dominican Republic","YEAR":"2002","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"82.3"},{"dims":{"COUNTRY":"Dominican Republic","YEAR":"2002","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"83.3"},{"dims":{"COUNTRY":"Dominican Republic","YEAR":"1999","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"21.0"},{"dims":{"COUNTRY":"Dominican Republic","YEAR":"1999","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"24.0"},{"dims":{"COUNTRY":"Dominican Republic","YEAR":"1996","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"85.7"},{"dims":{"COUNTRY":"Dominican Republic","YEAR":"1996","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"78.9"},{"dims":{"COUNTRY":"Egypt","YEAR":"2005","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"23.9"},{"dims":{"COUNTRY":"Ethiopia","YEAR":"2011","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"63.7"},{"dims":{"COUNTRY":"Ethiopia","YEAR":"2011","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"43.3"},{"dims":{"COUNTRY":"Ethiopia","YEAR":"2005","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"55.8"},{"dims":{"COUNTRY":"Ethiopia","YEAR":"2005","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"34.7"},{"dims":{"COUNTRY":"Ethiopia","YEAR":"2000","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"59.9"},{"dims":{"COUNTRY":"Ethiopia","YEAR":"2000","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"36.4"},{"dims":{"COUNTRY":"Gabon","YEAR":"2012","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"80.6"},{"dims":{"COUNTRY":"Gabon","YEAR":"2012","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"74.9"},{"dims":{"COUNTRY":"Gabon","YEAR":"2000","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"14.5"},{"dims":{"COUNTRY":"Gabon","YEAR":"2000","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"17.4"},{"dims":{"COUNTRY":"Gambia","YEAR":"2005","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"78.6"},{"dims":{"COUNTRY":"Georgia","YEAR":"2005","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"46.1"},{"dims":{"COUNTRY":"Ghana","YEAR":"2011","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"78.2"},{"dims":{"COUNTRY":"Ghana","YEAR":"2011","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"71.9"},{"dims":{"COUNTRY":"Ghana","YEAR":"2008","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"77.3"},{"dims":{"COUNTRY":"Ghana","YEAR":"2008","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"68.7"},{"dims":{"COUNTRY":"Ghana","YEAR":"2006","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"70.5"},{"dims":{"COUNTRY":"Ghana","YEAR":"2006","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"64.2"},{"dims":{"COUNTRY":"Ghana","YEAR":"2003","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"78.1"},{"dims":{"COUNTRY":"Ghana","YEAR":"2003","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"69.0"},{"dims":{"COUNTRY":"Ghana","YEAR":"1998","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"21.2"},{"dims":{"COUNTRY":"Ghana","YEAR":"1998","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"11.5"},{"dims":{"COUNTRY":"Ghana","YEAR":"1993","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"0.0"},{"dims":{"COUNTRY":"Guatemala","YEAR":"1995","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"5.7"},{"dims":{"COUNTRY":"Guinea","YEAR":"2012","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"74.0"},{"dims":{"COUNTRY":"Guinea","YEAR":"2012","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"62.8"},{"dims":{"COUNTRY":"Guinea","YEAR":"2005","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"77.0"},{"dims":{"COUNTRY":"Guinea","YEAR":"2005","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"67.7"},{"dims":{"COUNTRY":"Guinea","YEAR":"1999","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"16.5"},{"dims":{"COUNTRY":"Guinea","YEAR":"1999","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"15.1"},{"dims":{"COUNTRY":"Guinea-Bissau","YEAR":"2006","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"46.4"},{"dims":{"COUNTRY":"Guyana","YEAR":"2009","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"77.1"},{"dims":{"COUNTRY":"Guyana","YEAR":"2009","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"73.9"},{"dims":{"COUNTRY":"Guyana","YEAR":"2006","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"68.9"},{"dims":{"COUNTRY":"Haiti","YEAR":"2012","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"85.6"},{"dims":{"COUNTRY":"Haiti","YEAR":"2012","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"81.2"},{"dims":{"COUNTRY":"Haiti","YEAR":"2005","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"88.7"},{"dims":{"COUNTRY":"Haiti","YEAR":"2005","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"80.8"},{"dims":{"COUNTRY":"Haiti","YEAR":"2000","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"78.3"},{"dims":{"COUNTRY":"Haiti","YEAR":"2000","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"69.5"},{"dims":{"COUNTRY":"Haiti","YEAR":"1994","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"0.0"},{"dims":{"COUNTRY":"Honduras","YEAR":"2011","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"77.3"},{"dims":{"COUNTRY":"Honduras","YEAR":"2011","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"67.6"},{"dims":{"COUNTRY":"Honduras","YEAR":"2005","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"65.5"},{"dims":{"COUNTRY":"India","YEAR":"2005","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"64.3"},{"dims":{"COUNTRY":"India","YEAR":"2005","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"32.4"},{"dims":{"COUNTRY":"India","YEAR":"1998","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"4.3"},{"dims":{"COUNTRY":"Indonesia","YEAR":"2012","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"49.5"},{"dims":{"COUNTRY":"Indonesia","YEAR":"2012","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"37.4"},{"dims":{"COUNTRY":"Indonesia","YEAR":"2007","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"41.5"},{"dims":{"COUNTRY":"Indonesia","YEAR":"2007","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"30.0"},{"dims":{"COUNTRY":"Indonesia","YEAR":"2002","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"37.8"},{"dims":{"COUNTRY":"Indonesia","YEAR":"2002","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"25.8"},{"dims":{"COUNTRY":"Indonesia","YEAR":"1997","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"1.0"},{"dims":{"COUNTRY":"Iraq","YEAR":"2011","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"20.1"},{"dims":{"COUNTRY":"Iraq","YEAR":"2006","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"12.9"},{"dims":{"COUNTRY":"Jamaica","YEAR":"2005","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"76.0"},{"dims":{"COUNTRY":"Jordan","YEAR":"2012","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"51.5"},{"dims":{"COUNTRY":"Jordan","YEAR":"2007","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"50.1"},{"dims":{"COUNTRY":"Jordan","YEAR":"2002","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"38.4"},{"dims":{"COUNTRY":"Jordan","YEAR":"1997","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"0.2"},{"dims":{"COUNTRY":"Kazakhstan","YEAR":"2010","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"73.6"},{"dims":{"COUNTRY":"Kazakhstan","YEAR":"2010","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"70.5"},{"dims":{"COUNTRY":"Kazakhstan","YEAR":"2006","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"53.1"},{"dims":{"COUNTRY":"Kazakhstan","YEAR":"1999","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"33.5"},{"dims":{"COUNTRY":"Kazakhstan","YEAR":"1999","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"19.1"},{"dims":{"COUNTRY":"Kenya","YEAR":"2008","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"77.1"},{"dims":{"COUNTRY":"Kenya","YEAR":"2008","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"70.9"},{"dims":{"COUNTRY":"Kenya","YEAR":"2003","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"74.6"},{"dims":{"COUNTRY":"Kenya","YEAR":"2003","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"66.2"},{"dims":{"COUNTRY":"Kenya","YEAR":"1998","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"0.0"},{"dims":{"COUNTRY":"Kenya","YEAR":"1993","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"0.0"},{"dims":{"COUNTRY":"Kyrgyzstan","YEAR":"2012","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"59.6"},{"dims":{"COUNTRY":"Kyrgyzstan","YEAR":"2012","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"57.2"},{"dims":{"COUNTRY":"Kyrgyzstan","YEAR":"2005","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"59.0"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2011","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"81.8"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2011","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"67.5"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2009","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"72.2"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2009","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"80.7"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2004","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"59.7"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2004","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"70.9"},{"dims":{"COUNTRY":"Liberia","YEAR":"2013","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"68.5"},{"dims":{"COUNTRY":"Liberia","YEAR":"2013","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"68.0"},{"dims":{"COUNTRY":"Liberia","YEAR":"2007","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"66.7"},{"dims":{"COUNTRY":"Liberia","YEAR":"2007","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"44.6"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2008","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"68.4"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2008","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"65.1"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2003","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"66.2"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2003","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"57.4"},{"dims":{"COUNTRY":"Madagascar","YEAR":"1997","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"6.8"},{"dims":{"COUNTRY":"Malawi","YEAR":"2010","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"66.2"},{"dims":{"COUNTRY":"Malawi","YEAR":"2010","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"66.6"},{"dims":{"COUNTRY":"Malawi","YEAR":"2006","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"52.6"},{"dims":{"COUNTRY":"Malawi","YEAR":"2006","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"59.4"},{"dims":{"COUNTRY":"Malawi","YEAR":"2004","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"64.1"},{"dims":{"COUNTRY":"Malawi","YEAR":"2004","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"49.0"},{"dims":{"COUNTRY":"Malawi","YEAR":"2000","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"63.9"},{"dims":{"COUNTRY":"Malawi","YEAR":"2000","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"59.4"},{"dims":{"COUNTRY":"Malawi","YEAR":"1992","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"0.0"},{"dims":{"COUNTRY":"Maldives","YEAR":"2009","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"73.5"},{"dims":{"COUNTRY":"Maldives","YEAR":"2009","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"76.2"},{"dims":{"COUNTRY":"Mali","YEAR":"2012","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"65.8"},{"dims":{"COUNTRY":"Mali","YEAR":"2012","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"48.0"},{"dims":{"COUNTRY":"Mali","YEAR":"2006","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"62.4"},{"dims":{"COUNTRY":"Mali","YEAR":"2006","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"53.1"},{"dims":{"COUNTRY":"Mali","YEAR":"2001","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"53.8"},{"dims":{"COUNTRY":"Mali","YEAR":"2001","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"47.7"},{"dims":{"COUNTRY":"Mali","YEAR":"1995","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"3.4"},{"dims":{"COUNTRY":"Mali","YEAR":"1995","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"3.0"},{"dims":{"COUNTRY":"Mauritania","YEAR":"2007","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"40.7"},{"dims":{"COUNTRY":"Mauritania","YEAR":"2007","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"20.2"},{"dims":{"COUNTRY":"Mongolia","YEAR":"2010","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"71.2"},{"dims":{"COUNTRY":"Mongolia","YEAR":"2010","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"72.5"},{"dims":{"COUNTRY":"Mongolia","YEAR":"2005","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"66.1"},{"dims":{"COUNTRY":"Montenegro","YEAR":"2005","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"66.8"},{"dims":{"COUNTRY":"Morocco","YEAR":"2003","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"48.0"},{"dims":{"COUNTRY":"Mozambique","YEAR":"2011","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"73.4"},{"dims":{"COUNTRY":"Mozambique","YEAR":"2011","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"51.7"},{"dims":{"COUNTRY":"Mozambique","YEAR":"2008","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"64.8"},{"dims":{"COUNTRY":"Mozambique","YEAR":"2003","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"75.5"},{"dims":{"COUNTRY":"Mozambique","YEAR":"2003","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"66.5"},{"dims":{"COUNTRY":"Mozambique","YEAR":"1997","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"10.9"},{"dims":{"COUNTRY":"Mozambique","YEAR":"1997","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"8.4"},{"dims":{"COUNTRY":"Namibia","YEAR":"2013","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"85.2"},{"dims":{"COUNTRY":"Namibia","YEAR":"2013","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"84.3"},{"dims":{"COUNTRY":"Namibia","YEAR":"2006","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"82.8"},{"dims":{"COUNTRY":"Namibia","YEAR":"2006","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"80.4"},{"dims":{"COUNTRY":"Namibia","YEAR":"2000","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"84.1"},{"dims":{"COUNTRY":"Namibia","YEAR":"2000","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"72.3"},{"dims":{"COUNTRY":"Nepal","YEAR":"2011","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"84.3"},{"dims":{"COUNTRY":"Nepal","YEAR":"2011","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"71.1"},{"dims":{"COUNTRY":"Nepal","YEAR":"2006","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"74.5"},{"dims":{"COUNTRY":"Nepal","YEAR":"2006","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"55.0"},{"dims":{"COUNTRY":"Nepal","YEAR":"2001","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"61.5"},{"dims":{"COUNTRY":"Nepal","YEAR":"2001","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"35.3"},{"dims":{"COUNTRY":"Nepal","YEAR":"1996","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"4.7"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2001","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"52.1"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"1998","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"11.4"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"1998","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"9.8"},{"dims":{"COUNTRY":"Niger","YEAR":"2012","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"65.9"},{"dims":{"COUNTRY":"Niger","YEAR":"2012","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"48.2"},{"dims":{"COUNTRY":"Niger","YEAR":"2006","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"64.6"},{"dims":{"COUNTRY":"Niger","YEAR":"2006","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"53.3"},{"dims":{"COUNTRY":"Niger","YEAR":"1998","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"5.1"},{"dims":{"COUNTRY":"Niger","YEAR":"1998","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"2.3"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2013","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"70.5"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2013","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"54.7"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2011","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"48.8"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2008","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"67.8"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2008","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"48.3"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2007","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"39.5"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2003","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"66.0"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2003","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"53.2"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2012","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"36.6"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2012","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"19.5"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2006","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"17.0"},{"dims":{"COUNTRY":"Peru","YEAR":"2012","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"68.4"},{"dims":{"COUNTRY":"Peru","YEAR":"2011","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"68.2"},{"dims":{"COUNTRY":"Peru","YEAR":"2010","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"66.4"},{"dims":{"COUNTRY":"Peru","YEAR":"2009","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"68.6"},{"dims":{"COUNTRY":"Peru","YEAR":"2007","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"66.4"},{"dims":{"COUNTRY":"Peru","YEAR":"2004","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"57.2"},{"dims":{"COUNTRY":"Peru","YEAR":"2000","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"10.8"},{"dims":{"COUNTRY":"Peru","YEAR":"1996","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"16.4"},{"dims":{"COUNTRY":"Peru","YEAR":"1996","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"13.0"},{"dims":{"COUNTRY":"Philippines","YEAR":"2013","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"38.9"},{"dims":{"COUNTRY":"Philippines","YEAR":"2008","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"52.9"},{"dims":{"COUNTRY":"Philippines","YEAR":"2003","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"60.3"},{"dims":{"COUNTRY":"Philippines","YEAR":"2003","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"48.1"},{"dims":{"COUNTRY":"Republic of Moldova","YEAR":"2012","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"67.9"},{"dims":{"COUNTRY":"Republic of Moldova","YEAR":"2012","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"75.9"},{"dims":{"COUNTRY":"Republic of Moldova","YEAR":"2005","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"80.2"},{"dims":{"COUNTRY":"Republic of Moldova","YEAR":"2005","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"72.5"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2010","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"74.2"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2010","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"78.8"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2005","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"79.7"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2005","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"72.7"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2000","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"70.1"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2000","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"56.2"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2012","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"82.9"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2008","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"71.0"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2008","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"68.2"},{"dims":{"COUNTRY":"Senegal","YEAR":"2010","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"75.2"},{"dims":{"COUNTRY":"Senegal","YEAR":"2010","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"66.8"},{"dims":{"COUNTRY":"Senegal","YEAR":"2005","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"70.0"},{"dims":{"COUNTRY":"Senegal","YEAR":"2005","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"72.7"},{"dims":{"COUNTRY":"Senegal","YEAR":"1997","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"16.5"},{"dims":{"COUNTRY":"Senegal","YEAR":"1997","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"12.1"},{"dims":{"COUNTRY":"Serbia","YEAR":"2010","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"87.6"},{"dims":{"COUNTRY":"Serbia","YEAR":"2010","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"46.1"},{"dims":{"COUNTRY":"Serbia","YEAR":"2005","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"63.4"},{"dims":{"COUNTRY":"Sierra Leone","YEAR":"2013","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"73.7"},{"dims":{"COUNTRY":"Sierra Leone","YEAR":"2013","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"63.4"},{"dims":{"COUNTRY":"Sierra Leone","YEAR":"2010","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"54.6"},{"dims":{"COUNTRY":"Sierra Leone","YEAR":"2008","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"55.3"},{"dims":{"COUNTRY":"Sierra Leone","YEAR":"2008","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"38.2"},{"dims":{"COUNTRY":"Sierra Leone","YEAR":"2005","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"43.7"},{"dims":{"COUNTRY":"Somalia","YEAR":"2006","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"10.6"},{"dims":{"COUNTRY":"Sudan","YEAR":"2010","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"15.9"},{"dims":{"COUNTRY":"Suriname","YEAR":"2011","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"71.4"},{"dims":{"COUNTRY":"Suriname","YEAR":"2006","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"67.6"},{"dims":{"COUNTRY":"Swaziland","YEAR":"2010","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"89.3"},{"dims":{"COUNTRY":"Swaziland","YEAR":"2010","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"92.4"},{"dims":{"COUNTRY":"Swaziland","YEAR":"2006","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"83.4"},{"dims":{"COUNTRY":"Swaziland","YEAR":"2006","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"86.9"},{"dims":{"COUNTRY":"Syrian Arab Republic","YEAR":"2006","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"32.0"},{"dims":{"COUNTRY":"Tajikistan","YEAR":"2006","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"16.7"},{"dims":{"COUNTRY":"Thailand","YEAR":"2005","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"72.1"},{"dims":{"COUNTRY":"The former Yugoslav republic of Macedonia","YEAR":"2005","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"51.4"},{"dims":{"COUNTRY":"Timor-Leste","YEAR":"2009","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"42.4"},{"dims":{"COUNTRY":"Timor-Leste","YEAR":"2009","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"26.7"},{"dims":{"COUNTRY":"Togo","YEAR":"2010","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"71.1"},{"dims":{"COUNTRY":"Togo","YEAR":"2010","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"64.9"},{"dims":{"COUNTRY":"Togo","YEAR":"2006","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"60.8"},{"dims":{"COUNTRY":"Togo","YEAR":"1998","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"13.9"},{"dims":{"COUNTRY":"Togo","YEAR":"1998","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"8.3"},{"dims":{"COUNTRY":"Trinidad and Tobago","YEAR":"2006","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"78.0"},{"dims":{"COUNTRY":"Tunisia","YEAR":"2010","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"51.6"},{"dims":{"COUNTRY":"Turkey","YEAR":"2003","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"3.9"},{"dims":{"COUNTRY":"Turkey","YEAR":"1998","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"3.4"},{"dims":{"COUNTRY":"Turkey","YEAR":"1998","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"2.4"},{"dims":{"COUNTRY":"Uganda","YEAR":"2011","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"79.0"},{"dims":{"COUNTRY":"Uganda","YEAR":"2011","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"74.2"},{"dims":{"COUNTRY":"Uganda","YEAR":"2006","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"81.7"},{"dims":{"COUNTRY":"Uganda","YEAR":"2006","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"66.5"},{"dims":{"COUNTRY":"Uganda","YEAR":"2000","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"78.2"},{"dims":{"COUNTRY":"Uganda","YEAR":"2000","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"72.1"},{"dims":{"COUNTRY":"Uganda","YEAR":"1995","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"13.7"},{"dims":{"COUNTRY":"Uganda","YEAR":"1995","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"11.0"},{"dims":{"COUNTRY":"Ukraine","YEAR":"2012","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"90.5"},{"dims":{"COUNTRY":"Ukraine","YEAR":"2012","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"91.0"},{"dims":{"COUNTRY":"Ukraine","YEAR":"2007","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"87.3"},{"dims":{"COUNTRY":"Ukraine","YEAR":"2007","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"85.7"},{"dims":{"COUNTRY":"Ukraine","YEAR":"2005","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"68.0"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2010","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"70.3"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2010","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"71.3"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2004","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"72.1"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2004","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"74.7"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"1999","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"38.2"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"1999","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"30.8"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"1996","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"16.7"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"1996","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"14.1"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2006","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"59.5"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2007","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"53.4"},{"dims":{"COUNTRY":"Viet Nam","YEAR":"2010","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"27.4"},{"dims":{"COUNTRY":"Viet Nam","YEAR":"2006","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"19.0"},{"dims":{"COUNTRY":"Viet Nam","YEAR":"2002","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"80.0"},{"dims":{"COUNTRY":"Viet Nam","YEAR":"1997","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"81.8"},{"dims":{"COUNTRY":"Yemen","YEAR":"2006","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"20.8"},{"dims":{"COUNTRY":"Zambia","YEAR":"2007","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"69.2"},{"dims":{"COUNTRY":"Zambia","YEAR":"2007","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"69.1"},{"dims":{"COUNTRY":"Zambia","YEAR":"2001","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"70.6"},{"dims":{"COUNTRY":"Zambia","YEAR":"2001","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"77.2"},{"dims":{"COUNTRY":"Zambia","YEAR":"1996","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"20.8"},{"dims":{"COUNTRY":"Zambia","YEAR":"1996","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"16.6"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"2010","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"78.7"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"2010","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"77.2"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"2009","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"76.3"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"2005","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"71.4"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"2005","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"65.4"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"1999","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"26.0"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"1999","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"9.4"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"1994","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Male"},"Value":"31.0"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"1994","GHO":"Knowlege about sexual transmission of AIDS","SEX":"Female"},"Value":"20.4"}]}

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_recharts__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WikiQuote_js__ = __webpack_require__(21);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PartnerViolenceData=__webpack_require__(599);var IntimatePartnerViolence=function(_Component){_inherits(IntimatePartnerViolence,_Component);function IntimatePartnerViolence(props){_classCallCheck(this,IntimatePartnerViolence);var _this=_possibleConstructorReturn(this,(IntimatePartnerViolence.__proto__||Object.getPrototypeOf(IntimatePartnerViolence)).call(this,props));_this.state={data:[],quote:""};return _this;}_createClass(IntimatePartnerViolence,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var quote="",data=[];var success=function success(wikiData){quote='"'+wikiData.quote+'"';};__WEBPACK_IMPORTED_MODULE_3__WikiQuote_js__["a" /* WikiquoteApi */].getRandomQuote("Violence",success,__WEBPACK_IMPORTED_MODULE_3__WikiQuote_js__["b" /* error */]);data=Object(__WEBPACK_IMPORTED_MODULE_2__utils_js__["h" /* mapTable */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_js__["f" /* filterTable */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_js__["g" /* initialReformat */])(PartnerViolenceData)));var checkQuoteLength=function checkQuoteLength(){if(quote.length>0){_this2.setState({quote:quote,data:data});}else{setTimeout(checkQuoteLength,100);}};checkQuoteLength();}},{key:'render',value:function render(){var data=[],formatData=[];if(this.state.data.length>0){//separates data based upon year.. as so: [some_title: {some_year: [objs_of_data],...},...]
data=Object(__WEBPACK_IMPORTED_MODULE_2__utils_js__["c" /* filterAll */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_js__["b" /* dataFunction */])(this.state.data));data=data['Intimate partner violence prevalence among ever partnered women (%)'][2010];formatData=Object(__WEBPACK_IMPORTED_MODULE_2__utils_js__["d" /* filterByAgeGroup */])(data,'15-69  (total) years');formatData.map(function(row){row.value=parseFloat(row.value);});//averages data from all years based upon region, {region1: data1, ...}
//format data to be read by react bootstrap tables
}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'chart partner-violence'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,this.state.quote),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h6',{className:'title'},'Intimate partner violence prevalence among ever partnered women (%) - 15-69  (total) years averaged'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["k" /* ResponsiveContainer */],{width:'100%',height:300},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["j" /* RadarChart */],{cx:'50%',cy:'50%',outerRadius:'80%',data:formatData},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["g" /* PolarGrid */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["f" /* PolarAngleAxis */],{dataKey:'region'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["h" /* PolarRadiusAxis */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["l" /* Tooltip */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["i" /* Radar */],{name:'Percent',dataKey:'value',stroke:'#8884d8',fill:'#8884d8',fillOpacity:0.6}))));}}]);return IntimatePartnerViolence;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (IntimatePartnerViolence);

/***/ }),
/* 599 */
/***/ (function(module, exports) {

module.exports = {"dimension":[{"label":"GHO","display":"Indicator"},{"label":"PUBLISHSTATE","display":"PUBLISH STATES"},{"label":"YEAR","display":"Year"},{"label":"GBDREGION","display":"GBD Region"},{"label":"WHOINCOMEREGION","display":"WHO Income Region"},{"label":"AGEGROUP","display":"Age Group"},{"label":"SEX","display":"Sex"}],"fact":[{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the African Region","AGEGROUP":"15-19  years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"39.9 [35.8-44.1]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the African Region","AGEGROUP":"20-24 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"43.7 [39.7-47.6]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the African Region","AGEGROUP":"25-29 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"45.9 [41.9-49.9]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the African Region","AGEGROUP":"30-34 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"42.6 [38.7-46.6]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the African Region","AGEGROUP":"35-39 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"28.7 [17.8-39.7]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the African Region","AGEGROUP":"40-44 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"29 [12.1-45.9]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the African Region","AGEGROUP":"45-49 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"38.5 [34.4-42.6]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the African Region","AGEGROUP":"60-64 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"16.1 [0-34.6]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the African Region","AGEGROUP":"15-69  (total) years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"36.6 [32.7-40.5]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the African Region","AGEGROUP":"65-69 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"38.1 [25.4-50.8]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the Americas","AGEGROUP":"15-19  years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"30.6 [27-34.2]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the Americas","AGEGROUP":"20-24 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"32.6 [29-36.1]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the Americas","AGEGROUP":"25-29 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"33.1 [29.6-36.7]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the Americas","AGEGROUP":"30-34 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"33.1 [29.5-36.6]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the Americas","AGEGROUP":"35-39 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"32.1 [26.5-37.8]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the Americas","AGEGROUP":"40-44 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"32.4 [25.8-39]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the Americas","AGEGROUP":"45-49 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"31.9 [28.3-35.5]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the Americas","AGEGROUP":"50-54 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"24.7 [13.4-36.1]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the Americas","AGEGROUP":"55-59 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"23 [11.7-34.3]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the Americas","AGEGROUP":"15-69  (total) years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"29.8 [25.8-33.9]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the Americas","AGEGROUP":"65-69 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"35.8 [21.4-50.3]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the Eastern Mediterranean Region","AGEGROUP":"15-19  years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"24.9 [16.1-33.7]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the Eastern Mediterranean Region","AGEGROUP":"20-24 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"31.9 [23.1-40.7]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the Eastern Mediterranean Region","AGEGROUP":"25-29 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"31 [22.9-39.1]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the Eastern Mediterranean Region","AGEGROUP":"30-34 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"31.1 [23.3-38.9]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the Eastern Mediterranean Region","AGEGROUP":"35-39 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"28.5 [10.8-46.1]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the Eastern Mediterranean Region","AGEGROUP":"40-44 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"36.4 [20-52.9]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the Eastern Mediterranean Region","AGEGROUP":"45-49 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"31.3 [22.1-40.5]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the Eastern Mediterranean Region","AGEGROUP":"50-54 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"34.5 [10.4-58.6]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the Eastern Mediterranean Region","AGEGROUP":"15-69  (total) years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"37 [30.9-43.1]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the Eastern Mediterranean Region","AGEGROUP":"65-69 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"22.9 [0-85.9]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the European Region","AGEGROUP":"15-19  years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"24.6 [19.7-29.4]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the European Region","AGEGROUP":"20-24 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"21 [14.8-27.1]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the European Region","AGEGROUP":"25-29 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"26.1 [21.3-30.8]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the European Region","AGEGROUP":"30-34 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"25.6 [21-30.3]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the European Region","AGEGROUP":"35-39 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"26.2 [18.2-34.3]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the European Region","AGEGROUP":"40-44 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"24.8 [15.4-34.2]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the European Region","AGEGROUP":"45-49 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"25.6 [18.3-32.9]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the European Region","AGEGROUP":"15-69  (total) years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"25.4 [20.9-30]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the South-East Asia Region","AGEGROUP":"15-19  years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"43.1 [36.6-49.6]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the South-East Asia Region","AGEGROUP":"20-24 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"40.7 [34.6-46.8]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the South-East Asia Region","AGEGROUP":"25-29 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"40.5 [34.6-46.5]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the South-East Asia Region","AGEGROUP":"30-34 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"37.5 [31.5-43.4]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the South-East Asia Region","AGEGROUP":"35-39 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"63.2 [40.7-85.7]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the South-East Asia Region","AGEGROUP":"40-44 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"65.2 [42.6-87.9]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the South-East Asia Region","AGEGROUP":"45-49 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"33.7 [27.6-39.8]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the South-East Asia Region","AGEGROUP":"15-69  (total) years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"37.7 [32.8-42.6]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the Western Pacific Region","AGEGROUP":"15-19  years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"19.7 [12.7-26.6]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the Western Pacific Region","AGEGROUP":"20-24 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"24.7 [19.6-29.9]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the Western Pacific Region","AGEGROUP":"25-29 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"25.3 [20-30.7]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the Western Pacific Region","AGEGROUP":"30-34 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"25.5 [20.4-30.5]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the Western Pacific Region","AGEGROUP":"35-39 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"27.1 [20.3-33.9]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the Western Pacific Region","AGEGROUP":"40-44 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"27 [17.8-36.1]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the Western Pacific Region","AGEGROUP":"45-49 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"25.5 [21-30.1]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the Western Pacific Region","AGEGROUP":"50-54 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"27.3 [18.1-36.5]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the Western Pacific Region","AGEGROUP":"15-69  (total) years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"24.6 [20.1-29]"},{"dims":{"WHOINCOMEREGION":"Low- and middle-income countries of the Western Pacific Region","AGEGROUP":"65-69 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"13.4 [0.6-26.2]"},{"dims":{"WHOINCOMEREGION":"High-income countries for all regions","AGEGROUP":"15-19  years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"16.6 [12-21.3]"},{"dims":{"WHOINCOMEREGION":"High-income countries for all regions","AGEGROUP":"20-24 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"20.8 [17-24.5]"},{"dims":{"WHOINCOMEREGION":"High-income countries for all regions","AGEGROUP":"25-29 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"21.2 [17.3-25.1]"},{"dims":{"WHOINCOMEREGION":"High-income countries for all regions","AGEGROUP":"30-34 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"21.5 [17.7-25.4]"},{"dims":{"WHOINCOMEREGION":"High-income countries for all regions","AGEGROUP":"35-39 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"21.6 [17.4-25.9]"},{"dims":{"WHOINCOMEREGION":"High-income countries for all regions","AGEGROUP":"40-44 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"21.8 [10.7-32.8]"},{"dims":{"WHOINCOMEREGION":"High-income countries for all regions","AGEGROUP":"45-49 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"18.7 [14.5-22.8]"},{"dims":{"WHOINCOMEREGION":"High-income countries for all regions","AGEGROUP":"50-54 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"18.2 [2.6-33.7]"},{"dims":{"WHOINCOMEREGION":"High-income countries for all regions","AGEGROUP":"55-59 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"10.4 [0-23]"},{"dims":{"WHOINCOMEREGION":"High-income countries for all regions","AGEGROUP":"60-64 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"22.2 [11.6-32.7]"},{"dims":{"WHOINCOMEREGION":"High-income countries for all regions","AGEGROUP":"15-69  (total) years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"23.2 [20.2-26.2]"},{"dims":{"WHOINCOMEREGION":"High-income countries for all regions","AGEGROUP":"65-69 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"16.2 [11.4-20.9]"},{"dims":{"WHOINCOMEREGION":"World","AGEGROUP":"15-19  years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"29.4 [26.8-32.1]"},{"dims":{"WHOINCOMEREGION":"World","AGEGROUP":"20-24 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"31.6 [29.2-33.9]"},{"dims":{"WHOINCOMEREGION":"World","AGEGROUP":"25-29 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"32.3 [30-34.6]"},{"dims":{"WHOINCOMEREGION":"World","AGEGROUP":"30-34 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"31.1 [28.9-33.4]"},{"dims":{"WHOINCOMEREGION":"World","AGEGROUP":"35-39 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"36.6 [30-43.2]"},{"dims":{"WHOINCOMEREGION":"World","AGEGROUP":"40-44 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"37.8 [30.7-44.9]"},{"dims":{"WHOINCOMEREGION":"World","AGEGROUP":"45-49 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"29.2 [26.9-31.5]"},{"dims":{"WHOINCOMEREGION":"World","AGEGROUP":"50-54 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"25.5 [18.6-32.4]"},{"dims":{"WHOINCOMEREGION":"World","AGEGROUP":"55-59 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"15.1 [6.1-24.1]"},{"dims":{"WHOINCOMEREGION":"World","AGEGROUP":"60-64 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"19.6 [9.6-29.5]"},{"dims":{"WHOINCOMEREGION":"World","AGEGROUP":"15-69  (total) years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"30 [27.8-32.2]"},{"dims":{"WHOINCOMEREGION":"World","AGEGROUP":"65-69 years","GHO":"Intimate partner violence prevalence among ever partnered women (%)","SEX":"Female","YEAR":"2010"},"Value":"22.2 [12.8-31.6]"}]}

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_recharts__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WikiQuote_js__ = __webpack_require__(21);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LifeExpectancyData=__webpack_require__(601);var LifeExpectancy=function(_Component){_inherits(LifeExpectancy,_Component);function LifeExpectancy(props){_classCallCheck(this,LifeExpectancy);var _this=_possibleConstructorReturn(this,(LifeExpectancy.__proto__||Object.getPrototypeOf(LifeExpectancy)).call(this,props));_this.state={data:[],quote:""};return _this;}_createClass(LifeExpectancy,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var quote="",data=[];var success=function success(wikiData){quote='"'+wikiData.quote+'"';};__WEBPACK_IMPORTED_MODULE_3__WikiQuote_js__["a" /* WikiquoteApi */].getRandomQuote("Life",success,__WEBPACK_IMPORTED_MODULE_3__WikiQuote_js__["b" /* error */]);data=Object(__WEBPACK_IMPORTED_MODULE_2__utils_js__["h" /* mapTable */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_js__["f" /* filterTable */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_js__["g" /* initialReformat */])(LifeExpectancyData)));var checkQuoteLength=function checkQuoteLength(){if(quote.length>0){_this2.setState({quote:quote,data:data});}else{setTimeout(checkQuoteLength,100);}};checkQuoteLength();}},{key:'render',value:function render(){var data=[],finalData=[],i=0;if(this.state.data.length>0){//format data so that data can be utilised by year... [title: {year: [obj_with_data, ...], another_year: [...], ...}, ...]
data=Object(__WEBPACK_IMPORTED_MODULE_2__utils_js__["c" /* filterAll */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_js__["b" /* dataFunction */])(this.state.data));data=Object(__WEBPACK_IMPORTED_MODULE_2__utils_js__["e" /* filterBySex */])('Both sexes',data,'Life expectancy at birth (years)',2015);//for a bar the table must be used to compare data based upon a datakey for the x-axis, a specific dataKey for each country works
finalData[i]={};finalData[i].xaxis='';//because I could not put each country as its own x-axis value I had to give them an individual one, so only one object is made with the country/value I want
data.forEach(function(obj){if(obj.country==="Afghanistan"){finalData[i].Afghanistan=+obj.value;}if(obj.country==="Switzerland"){finalData[i].Switzerland=+obj.value;}if(obj.country==="Nigeria"){finalData[i].Nigeria=+obj.value;}if(obj.country==="Libya"){finalData[i].Libya=+obj.value;}if(obj.country==="Lesotho"){finalData[i].Lesotho=+obj.value;}if(obj.country==="Syrian Arab Republic"){finalData[i]['Syrian Arab Republic']=+obj.value;}if(obj.country==="Viet Nam"){finalData[i]['Viet Nam']=+obj.value;}if(obj.country==="Malawi"){finalData[i].Malawi=+obj.value;}if(obj.country==="France"){finalData[i].France=+obj.value;}if(obj.country==="Madagascar"){finalData[i].Madagascar=+obj.value;}if(obj.country==="United States of America"){finalData[i]['United States of America']=+obj.value;}if(obj.country==="Uzbekistan"){finalData[i].Uzbekistan=+obj.value;}if(obj.country==="Saudi Arabia"){finalData[i]['Saudi Arabia']=+obj.value;}});}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'chart bar life-expectancy'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,this.state.quote),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h6',null,'Life expectancy at birth (years) 2015 Data set (Both sexes averaged)'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["k" /* ResponsiveContainer */],{width:'100%',height:300},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["b" /* BarChart */],{cx:'50%',cy:'50%',outerRadius:'80%',data:finalData},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["m" /* XAxis */],{dataKey:'xaxis'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["n" /* YAxis */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["c" /* CartesianGrid */],{strokeDasharray:'3 3'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["l" /* Tooltip */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["a" /* Bar */],{dataKey:'Afghanistan',fill:'black'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["a" /* Bar */],{dataKey:'Switzerland',fill:'green'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["a" /* Bar */],{dataKey:'Nigeria',fill:'purple'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["a" /* Bar */],{dataKey:'Libya',fill:'orange'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["a" /* Bar */],{dataKey:'Lesotho',fill:'brown'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["a" /* Bar */],{dataKey:'Syrian Arab Republic',fill:'#C90016'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["a" /* Bar */],{dataKey:'Viet Nam',fill:'red'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["a" /* Bar */],{dataKey:'Malawi',fill:'pink'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["a" /* Bar */],{dataKey:'United States of America',fill:'grey'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["a" /* Bar */],{dataKey:'France',fill:'blue'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["a" /* Bar */],{dataKey:'Uzbekistan',fill:'gold'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["a" /* Bar */],{dataKey:'Saudi Arabia',fill:'maroon'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["a" /* Bar */],{dataKey:'Madagascar',fill:'lime'}))));}}]);return LifeExpectancy;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (LifeExpectancy);

/***/ }),
/* 601 */
/***/ (function(module, exports) {

module.exports = {"dimension":[{"label":"GHO","display":"Indicator"},{"label":"PUBLISHSTATE","display":"PUBLISH STATES"},{"label":"YEAR","display":"Year"},{"label":"REGION","display":"WHO region"},{"label":"COUNTRY","display":"Country"},{"label":"SEX","display":"Sex"}],"fact":[{"dims":{"COUNTRY":"Afghanistan","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"60.5"},{"dims":{"COUNTRY":"Afghanistan","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"59.3"},{"dims":{"COUNTRY":"Afghanistan","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"61.9"},{"dims":{"COUNTRY":"Afghanistan","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.0"},{"dims":{"COUNTRY":"Afghanistan","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.3"},{"dims":{"COUNTRY":"Afghanistan","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.7"},{"dims":{"COUNTRY":"Afghanistan","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"59.9"},{"dims":{"COUNTRY":"Afghanistan","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"58.6"},{"dims":{"COUNTRY":"Afghanistan","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"61.3"},{"dims":{"COUNTRY":"Afghanistan","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.9"},{"dims":{"COUNTRY":"Afghanistan","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.2"},{"dims":{"COUNTRY":"Afghanistan","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.6"},{"dims":{"COUNTRY":"Afghanistan","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"59.9"},{"dims":{"COUNTRY":"Afghanistan","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"58.7"},{"dims":{"COUNTRY":"Afghanistan","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"61.2"},{"dims":{"COUNTRY":"Afghanistan","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.9"},{"dims":{"COUNTRY":"Afghanistan","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.2"},{"dims":{"COUNTRY":"Afghanistan","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.6"},{"dims":{"COUNTRY":"Afghanistan","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"59.5"},{"dims":{"COUNTRY":"Finland","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"22.8"},{"dims":{"COUNTRY":"Finland","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"20.3"},{"dims":{"COUNTRY":"Finland","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.9"},{"dims":{"COUNTRY":"Finland","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"78.7"},{"dims":{"COUNTRY":"Finland","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"75.2"},{"dims":{"COUNTRY":"Finland","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"82.0"},{"dims":{"COUNTRY":"Finland","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"22.6"},{"dims":{"COUNTRY":"Finland","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"20.1"},{"dims":{"COUNTRY":"Finland","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.7"},{"dims":{"COUNTRY":"Finland","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"78.4"},{"dims":{"COUNTRY":"Finland","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"75.0"},{"dims":{"COUNTRY":"Finland","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"81.7"},{"dims":{"COUNTRY":"Finland","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"22.2"},{"dims":{"COUNTRY":"Finland","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.8"},{"dims":{"COUNTRY":"Finland","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.1"},{"dims":{"COUNTRY":"Finland","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"78.1"},{"dims":{"COUNTRY":"Finland","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"74.7"},{"dims":{"COUNTRY":"Finland","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"81.4"},{"dims":{"COUNTRY":"Finland","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"21.9"},{"dims":{"COUNTRY":"Finland","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.4"},{"dims":{"COUNTRY":"Finland","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"23.9"},{"dims":{"COUNTRY":"Finland","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"78.0"},{"dims":{"COUNTRY":"Finland","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"74.5"},{"dims":{"COUNTRY":"Finland","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"81.4"},{"dims":{"COUNTRY":"Finland","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"21.8"},{"dims":{"COUNTRY":"Finland","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.4"},{"dims":{"COUNTRY":"Finland","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"23.8"},{"dims":{"COUNTRY":"Finland","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"77.5"},{"dims":{"COUNTRY":"Finland","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"74.0"},{"dims":{"COUNTRY":"Finland","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"80.9"},{"dims":{"COUNTRY":"Finland","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"21.5"},{"dims":{"COUNTRY":"Finland","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.1"},{"dims":{"COUNTRY":"Finland","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"23.6"},{"dims":{"COUNTRY":"France","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"82.4"},{"dims":{"COUNTRY":"France","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"79.4"},{"dims":{"COUNTRY":"France","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"85.4"},{"dims":{"COUNTRY":"France","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"25.7"},{"dims":{"COUNTRY":"France","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"23.5"},{"dims":{"COUNTRY":"France","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"27.7"},{"dims":{"COUNTRY":"France","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"82.2"},{"dims":{"COUNTRY":"France","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"79.1"},{"dims":{"COUNTRY":"France","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"85.2"},{"dims":{"COUNTRY":"France","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"25.5"},{"dims":{"COUNTRY":"France","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"23.3"},{"dims":{"COUNTRY":"France","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"27.6"},{"dims":{"COUNTRY":"France","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"82.0"},{"dims":{"COUNTRY":"France","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"78.9"},{"dims":{"COUNTRY":"France","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"85.0"},{"dims":{"COUNTRY":"France","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"25.4"},{"dims":{"COUNTRY":"France","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"23.1"},{"dims":{"COUNTRY":"France","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"27.4"},{"dims":{"COUNTRY":"France","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"81.5"},{"dims":{"COUNTRY":"France","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"78.4"},{"dims":{"COUNTRY":"France","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"84.6"},{"dims":{"COUNTRY":"France","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"24.9"},{"dims":{"COUNTRY":"France","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"22.7"},{"dims":{"COUNTRY":"France","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"27.0"},{"dims":{"COUNTRY":"France","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"81.7"},{"dims":{"COUNTRY":"France","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"78.5"},{"dims":{"COUNTRY":"France","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"84.9"},{"dims":{"COUNTRY":"France","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"25.2"},{"dims":{"COUNTRY":"France","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"22.8"},{"dims":{"COUNTRY":"France","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"27.3"},{"dims":{"COUNTRY":"France","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"81.3"},{"dims":{"COUNTRY":"France","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"78.0"},{"dims":{"COUNTRY":"France","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"84.6"},{"dims":{"COUNTRY":"France","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"24.8"},{"dims":{"COUNTRY":"France","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"22.4"},{"dims":{"COUNTRY":"France","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"27.0"},{"dims":{"COUNTRY":"France","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"81.1"},{"dims":{"COUNTRY":"France","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"77.7"},{"dims":{"COUNTRY":"France","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"84.4"},{"dims":{"COUNTRY":"France","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"24.7"},{"dims":{"COUNTRY":"France","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"22.2"},{"dims":{"COUNTRY":"France","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"26.9"},{"dims":{"COUNTRY":"France","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"80.9"},{"dims":{"COUNTRY":"France","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"77.5"},{"dims":{"COUNTRY":"France","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"84.3"},{"dims":{"COUNTRY":"France","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"24.5"},{"dims":{"COUNTRY":"France","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"22.0"},{"dims":{"COUNTRY":"France","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"26.8"},{"dims":{"COUNTRY":"France","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"80.9"},{"dims":{"COUNTRY":"France","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"77.3"},{"dims":{"COUNTRY":"France","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"84.4"},{"dims":{"COUNTRY":"France","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"24.5"},{"dims":{"COUNTRY":"France","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"21.9"},{"dims":{"COUNTRY":"France","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"26.8"},{"dims":{"COUNTRY":"France","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"80.6"},{"dims":{"COUNTRY":"France","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"77.0"},{"dims":{"COUNTRY":"France","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"84.1"},{"dims":{"COUNTRY":"France","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"24.3"},{"dims":{"COUNTRY":"France","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"21.7"},{"dims":{"COUNTRY":"France","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"26.6"},{"dims":{"COUNTRY":"France","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"80.1"},{"dims":{"COUNTRY":"France","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"76.5"},{"dims":{"COUNTRY":"France","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"83.7"},{"dims":{"COUNTRY":"France","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"23.9"},{"dims":{"COUNTRY":"France","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"21.3"},{"dims":{"COUNTRY":"France","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"26.2"},{"dims":{"COUNTRY":"France","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"80.2"},{"dims":{"COUNTRY":"France","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"76.6"},{"dims":{"COUNTRY":"France","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"83.8"},{"dims":{"COUNTRY":"France","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"24.0"},{"dims":{"COUNTRY":"France","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"21.4"},{"dims":{"COUNTRY":"France","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"26.4"},{"dims":{"COUNTRY":"France","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"79.3"},{"dims":{"COUNTRY":"France","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"75.7"},{"dims":{"COUNTRY":"France","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"82.9"},{"dims":{"COUNTRY":"France","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"23.3"},{"dims":{"COUNTRY":"France","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"20.7"},{"dims":{"COUNTRY":"France","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"25.6"},{"dims":{"COUNTRY":"France","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"79.2"},{"dims":{"COUNTRY":"France","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"75.5"},{"dims":{"COUNTRY":"France","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"82.9"},{"dims":{"COUNTRY":"France","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"23.3"},{"dims":{"COUNTRY":"France","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"20.7"},{"dims":{"COUNTRY":"France","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"25.7"},{"dims":{"COUNTRY":"France","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"79.0"},{"dims":{"COUNTRY":"France","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"75.2"},{"dims":{"COUNTRY":"France","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"82.8"},{"dims":{"COUNTRY":"France","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"23.2"},{"dims":{"COUNTRY":"France","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"20.5"},{"dims":{"COUNTRY":"France","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"25.6"},{"dims":{"COUNTRY":"France","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"78.8"},{"dims":{"COUNTRY":"France","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"75.0"},{"dims":{"COUNTRY":"France","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"82.7"},{"dims":{"COUNTRY":"France","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"23.0"},{"dims":{"COUNTRY":"France","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"20.3"},{"dims":{"COUNTRY":"France","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"25.5"},{"dims":{"COUNTRY":"Gabon","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"66.0"},{"dims":{"COUNTRY":"Gabon","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"64.7"},{"dims":{"COUNTRY":"Gabon","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"67.2"},{"dims":{"COUNTRY":"Gabon","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.2"},{"dims":{"COUNTRY":"Gabon","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.5"},{"dims":{"COUNTRY":"Gabon","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.9"},{"dims":{"COUNTRY":"Gabon","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"65.5"},{"dims":{"COUNTRY":"Gabon","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"64.4"},{"dims":{"COUNTRY":"Gabon","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"66.6"},{"dims":{"COUNTRY":"Gabon","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.2"},{"dims":{"COUNTRY":"Gabon","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.5"},{"dims":{"COUNTRY":"Gabon","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.8"},{"dims":{"COUNTRY":"Gabon","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"64.6"},{"dims":{"COUNTRY":"Gabon","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"63.9"},{"dims":{"COUNTRY":"Gabon","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"65.2"},{"dims":{"COUNTRY":"Gabon","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.1"},{"dims":{"COUNTRY":"Gabon","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.4"},{"dims":{"COUNTRY":"Gabon","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.6"},{"dims":{"COUNTRY":"Gabon","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"63.5"},{"dims":{"COUNTRY":"Gabon","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"63.5"},{"dims":{"COUNTRY":"Gabon","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"63.5"},{"dims":{"COUNTRY":"Gabon","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.0"},{"dims":{"COUNTRY":"Gabon","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.4"},{"dims":{"COUNTRY":"Gabon","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.5"},{"dims":{"COUNTRY":"Gabon","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"62.8"},{"dims":{"COUNTRY":"Gabon","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"62.9"},{"dims":{"COUNTRY":"Gabon","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"62.6"},{"dims":{"COUNTRY":"Gabon","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.9"},{"dims":{"COUNTRY":"Gabon","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.3"},{"dims":{"COUNTRY":"Gabon","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.3"},{"dims":{"COUNTRY":"Gabon","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"62.3"},{"dims":{"COUNTRY":"Gabon","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"62.4"},{"dims":{"COUNTRY":"Gabon","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"62.1"},{"dims":{"COUNTRY":"Gabon","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.8"},{"dims":{"COUNTRY":"Gabon","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.2"},{"dims":{"COUNTRY":"Gabon","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.2"},{"dims":{"COUNTRY":"Gabon","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"61.7"},{"dims":{"COUNTRY":"Gabon","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"62.0"},{"dims":{"COUNTRY":"Gabon","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"61.4"},{"dims":{"COUNTRY":"Gabon","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.7"},{"dims":{"COUNTRY":"Gabon","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.2"},{"dims":{"COUNTRY":"Gabon","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.2"},{"dims":{"COUNTRY":"Gabon","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"61.6"},{"dims":{"COUNTRY":"Gabon","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"61.8"},{"dims":{"COUNTRY":"Gabon","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"61.3"},{"dims":{"COUNTRY":"Gabon","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.6"},{"dims":{"COUNTRY":"Gabon","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.1"},{"dims":{"COUNTRY":"Gabon","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.1"},{"dims":{"COUNTRY":"Gabon","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"61.6"},{"dims":{"COUNTRY":"Gabon","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"61.7"},{"dims":{"COUNTRY":"Gabon","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"61.4"},{"dims":{"COUNTRY":"Gabon","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.6"},{"dims":{"COUNTRY":"Gabon","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.1"},{"dims":{"COUNTRY":"Gabon","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.1"},{"dims":{"COUNTRY":"Gabon","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"61.4"},{"dims":{"COUNTRY":"Gabon","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"61.4"},{"dims":{"COUNTRY":"Gabon","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"61.4"},{"dims":{"COUNTRY":"Gabon","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.5"},{"dims":{"COUNTRY":"Gabon","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.0"},{"dims":{"COUNTRY":"Gabon","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.0"},{"dims":{"COUNTRY":"Gabon","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"60.5"},{"dims":{"COUNTRY":"Gabon","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"60.5"},{"dims":{"COUNTRY":"Gabon","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"60.4"},{"dims":{"COUNTRY":"Gabon","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.4"},{"dims":{"COUNTRY":"Gabon","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.9"},{"dims":{"COUNTRY":"Gabon","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"17.8"},{"dims":{"COUNTRY":"Gabon","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"59.7"},{"dims":{"COUNTRY":"Gabon","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"59.7"},{"dims":{"COUNTRY":"Gabon","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"59.7"},{"dims":{"COUNTRY":"Gabon","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.3"},{"dims":{"COUNTRY":"Gabon","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.8"},{"dims":{"COUNTRY":"Gabon","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"17.7"},{"dims":{"COUNTRY":"Gabon","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"59.7"},{"dims":{"COUNTRY":"Gabon","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"59.5"},{"dims":{"COUNTRY":"Gabon","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"59.7"},{"dims":{"COUNTRY":"Gabon","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.3"},{"dims":{"COUNTRY":"Gabon","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.7"},{"dims":{"COUNTRY":"Gabon","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"17.7"},{"dims":{"COUNTRY":"Gabon","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"59.7"},{"dims":{"COUNTRY":"Gabon","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"59.4"},{"dims":{"COUNTRY":"Gabon","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"59.9"},{"dims":{"COUNTRY":"Gabon","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.2"},{"dims":{"COUNTRY":"Gabon","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.7"},{"dims":{"COUNTRY":"Gabon","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"17.7"},{"dims":{"COUNTRY":"Gabon","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"59.8"},{"dims":{"COUNTRY":"Gabon","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"59.4"},{"dims":{"COUNTRY":"Gabon","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"60.2"},{"dims":{"COUNTRY":"Gabon","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.2"},{"dims":{"COUNTRY":"Gabon","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.7"},{"dims":{"COUNTRY":"Gabon","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"17.7"},{"dims":{"COUNTRY":"Gabon","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"60.1"},{"dims":{"COUNTRY":"Gabon","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"59.5"},{"dims":{"COUNTRY":"Gabon","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"60.7"},{"dims":{"COUNTRY":"Gabon","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.2"},{"dims":{"COUNTRY":"Gabon","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.7"},{"dims":{"COUNTRY":"Gabon","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"17.7"},{"dims":{"COUNTRY":"Gambia","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"61.1"},{"dims":{"COUNTRY":"Gambia","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"59.8"},{"dims":{"COUNTRY":"Gambia","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"62.5"},{"dims":{"COUNTRY":"Gambia","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.3"},{"dims":{"COUNTRY":"Gambia","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.7"},{"dims":{"COUNTRY":"Gambia","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.0"},{"dims":{"COUNTRY":"Gambia","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"60.8"},{"dims":{"COUNTRY":"Gambia","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"59.5"},{"dims":{"COUNTRY":"Gambia","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"62.1"},{"dims":{"COUNTRY":"Gambia","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.3"},{"dims":{"COUNTRY":"Gambia","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.7"},{"dims":{"COUNTRY":"Gambia","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.9"},{"dims":{"COUNTRY":"Gambia","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"60.6"},{"dims":{"COUNTRY":"Gambia","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"59.2"},{"dims":{"COUNTRY":"Gambia","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"62.0"},{"dims":{"COUNTRY":"Gambia","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.2"},{"dims":{"COUNTRY":"Gambia","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.7"},{"dims":{"COUNTRY":"Gambia","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.9"},{"dims":{"COUNTRY":"Gambia","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"60.2"},{"dims":{"COUNTRY":"Gambia","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"58.9"},{"dims":{"COUNTRY":"Gambia","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"61.6"},{"dims":{"COUNTRY":"Gambia","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.2"},{"dims":{"COUNTRY":"Gambia","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.7"},{"dims":{"COUNTRY":"Gambia","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.9"},{"dims":{"COUNTRY":"Gambia","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"59.8"},{"dims":{"COUNTRY":"Gambia","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"58.7"},{"dims":{"COUNTRY":"Gambia","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"61.0"},{"dims":{"COUNTRY":"Gambia","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.2"},{"dims":{"COUNTRY":"Gambia","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.6"},{"dims":{"COUNTRY":"Gambia","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.8"},{"dims":{"COUNTRY":"Gambia","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"59.3"},{"dims":{"COUNTRY":"Gambia","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"58.3"},{"dims":{"COUNTRY":"Gambia","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"60.5"},{"dims":{"COUNTRY":"Gambia","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.1"},{"dims":{"COUNTRY":"Gambia","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.6"},{"dims":{"COUNTRY":"Gambia","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.7"},{"dims":{"COUNTRY":"Gambia","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"59.0"},{"dims":{"COUNTRY":"Gambia","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"58.0"},{"dims":{"COUNTRY":"Gambia","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"60.2"},{"dims":{"COUNTRY":"Gambia","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.0"},{"dims":{"COUNTRY":"Gambia","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.5"},{"dims":{"COUNTRY":"Gambia","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.7"},{"dims":{"COUNTRY":"Gambia","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"58.7"},{"dims":{"COUNTRY":"Gambia","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"57.7"},{"dims":{"COUNTRY":"Gambia","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"59.9"},{"dims":{"COUNTRY":"Gambia","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.0"},{"dims":{"COUNTRY":"Gambia","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.5"},{"dims":{"COUNTRY":"Gambia","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.6"},{"dims":{"COUNTRY":"Gambia","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"58.5"},{"dims":{"COUNTRY":"Gambia","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"57.4"},{"dims":{"COUNTRY":"Gambia","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"59.6"},{"dims":{"COUNTRY":"Gambia","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.0"},{"dims":{"COUNTRY":"Gambia","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.5"},{"dims":{"COUNTRY":"Gambia","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.6"},{"dims":{"COUNTRY":"Gambia","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"58.2"},{"dims":{"COUNTRY":"Gambia","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"57.1"},{"dims":{"COUNTRY":"Gambia","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"59.3"},{"dims":{"COUNTRY":"Gambia","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"14.9"},{"dims":{"COUNTRY":"Gambia","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.4"},{"dims":{"COUNTRY":"Gambia","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.5"},{"dims":{"COUNTRY":"Gambia","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"57.7"},{"dims":{"COUNTRY":"Gambia","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"56.7"},{"dims":{"COUNTRY":"Gambia","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"58.9"},{"dims":{"COUNTRY":"Gambia","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"14.9"},{"dims":{"COUNTRY":"Gambia","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.4"},{"dims":{"COUNTRY":"Gambia","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.4"},{"dims":{"COUNTRY":"Gambia","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"57.3"},{"dims":{"COUNTRY":"Gambia","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"56.4"},{"dims":{"COUNTRY":"Gambia","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"58.5"},{"dims":{"COUNTRY":"Gambia","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"14.8"},{"dims":{"COUNTRY":"Gambia","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.4"},{"dims":{"COUNTRY":"Gambia","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.4"},{"dims":{"COUNTRY":"Gambia","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"57.0"},{"dims":{"COUNTRY":"Gambia","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"56.0"},{"dims":{"COUNTRY":"Gambia","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"58.1"},{"dims":{"COUNTRY":"Gambia","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"14.8"},{"dims":{"COUNTRY":"Gambia","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.3"},{"dims":{"COUNTRY":"Gambia","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.3"},{"dims":{"COUNTRY":"Gambia","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"56.6"},{"dims":{"COUNTRY":"Gambia","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"55.6"},{"dims":{"COUNTRY":"Gambia","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"57.8"},{"dims":{"COUNTRY":"Gambia","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"14.8"},{"dims":{"COUNTRY":"Gambia","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.3"},{"dims":{"COUNTRY":"Gambia","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.3"},{"dims":{"COUNTRY":"Gambia","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"56.3"},{"dims":{"COUNTRY":"Gambia","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"55.2"},{"dims":{"COUNTRY":"Gambia","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"57.5"},{"dims":{"COUNTRY":"Gambia","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"14.7"},{"dims":{"COUNTRY":"Gambia","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.3"},{"dims":{"COUNTRY":"Gambia","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.3"},{"dims":{"COUNTRY":"Gambia","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"55.9"},{"dims":{"COUNTRY":"Gambia","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"54.8"},{"dims":{"COUNTRY":"Gambia","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"57.1"},{"dims":{"COUNTRY":"Gambia","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"14.7"},{"dims":{"COUNTRY":"Gambia","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.2"},{"dims":{"COUNTRY":"Gambia","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.2"},{"dims":{"COUNTRY":"Georgia","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"74.4"},{"dims":{"COUNTRY":"Georgia","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"70.3"},{"dims":{"COUNTRY":"Georgia","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"78.3"},{"dims":{"COUNTRY":"Georgia","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.4"},{"dims":{"COUNTRY":"Georgia","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.9"},{"dims":{"COUNTRY":"Georgia","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"21.5"},{"dims":{"COUNTRY":"Georgia","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"74.5"},{"dims":{"COUNTRY":"Georgia","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"70.5"},{"dims":{"COUNTRY":"Georgia","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"78.4"},{"dims":{"COUNTRY":"Georgia","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.5"},{"dims":{"COUNTRY":"Georgia","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.1"},{"dims":{"COUNTRY":"Georgia","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"21.6"},{"dims":{"COUNTRY":"Georgia","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"74.5"},{"dims":{"COUNTRY":"Georgia","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"70.5"},{"dims":{"COUNTRY":"Georgia","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"78.5"},{"dims":{"COUNTRY":"Georgia","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.7"},{"dims":{"COUNTRY":"Georgia","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.2"},{"dims":{"COUNTRY":"Georgia","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"21.8"},{"dims":{"COUNTRY":"Georgia","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"74.2"},{"dims":{"COUNTRY":"Georgia","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"70.2"},{"dims":{"COUNTRY":"Georgia","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"78.1"},{"dims":{"COUNTRY":"Georgia","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.5"},{"dims":{"COUNTRY":"Georgia","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.1"},{"dims":{"COUNTRY":"Georgia","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"21.6"},{"dims":{"COUNTRY":"Georgia","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.9"},{"dims":{"COUNTRY":"Georgia","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"70.3"},{"dims":{"COUNTRY":"Georgia","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"77.4"},{"dims":{"COUNTRY":"Georgia","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.2"},{"dims":{"COUNTRY":"Georgia","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.0"},{"dims":{"COUNTRY":"Georgia","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"21.0"},{"dims":{"COUNTRY":"Georgia","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.8"},{"dims":{"COUNTRY":"Georgia","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"70.0"},{"dims":{"COUNTRY":"Georgia","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"77.3"},{"dims":{"COUNTRY":"Georgia","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.3"},{"dims":{"COUNTRY":"Georgia","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.2"},{"dims":{"COUNTRY":"Georgia","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"20.9"},{"dims":{"COUNTRY":"Georgia","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.2"},{"dims":{"COUNTRY":"Georgia","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"69.6"},{"dims":{"COUNTRY":"Georgia","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"76.6"},{"dims":{"COUNTRY":"Georgia","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.0"},{"dims":{"COUNTRY":"Georgia","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.0"},{"dims":{"COUNTRY":"Georgia","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"20.6"},{"dims":{"COUNTRY":"Georgia","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.9"},{"dims":{"COUNTRY":"Georgia","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"69.8"},{"dims":{"COUNTRY":"Georgia","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"77.9"},{"dims":{"COUNTRY":"Georgia","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.9"},{"dims":{"COUNTRY":"Georgia","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.5"},{"dims":{"COUNTRY":"Georgia","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"21.8"},{"dims":{"COUNTRY":"Georgia","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"74.4"},{"dims":{"COUNTRY":"Georgia","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"70.5"},{"dims":{"COUNTRY":"Georgia","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"78.1"},{"dims":{"COUNTRY":"Georgia","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"20.1"},{"dims":{"COUNTRY":"Georgia","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.7"},{"dims":{"COUNTRY":"Georgia","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"22.0"},{"dims":{"COUNTRY":"Georgia","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.9"},{"dims":{"COUNTRY":"Georgia","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"69.8"},{"dims":{"COUNTRY":"Georgia","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"77.8"},{"dims":{"COUNTRY":"Georgia","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.8"},{"dims":{"COUNTRY":"Georgia","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.6"},{"dims":{"COUNTRY":"Georgia","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"21.6"},{"dims":{"COUNTRY":"Georgia","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.9"},{"dims":{"COUNTRY":"Georgia","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"70.0"},{"dims":{"COUNTRY":"Georgia","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"77.4"},{"dims":{"COUNTRY":"Georgia","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"20.0"},{"dims":{"COUNTRY":"Georgia","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.8"},{"dims":{"COUNTRY":"Georgia","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"21.8"},{"dims":{"COUNTRY":"Georgia","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"72.3"},{"dims":{"COUNTRY":"Georgia","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"68.4"},{"dims":{"COUNTRY":"Georgia","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"76.0"},{"dims":{"COUNTRY":"Georgia","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.6"},{"dims":{"COUNTRY":"Georgia","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.5"},{"dims":{"COUNTRY":"Georgia","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"20.3"},{"dims":{"COUNTRY":"Georgia","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"72.7"},{"dims":{"COUNTRY":"Georgia","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"69.1"},{"dims":{"COUNTRY":"Georgia","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"76.1"},{"dims":{"COUNTRY":"Georgia","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.0"},{"dims":{"COUNTRY":"Georgia","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.8"},{"dims":{"COUNTRY":"Georgia","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"20.7"},{"dims":{"COUNTRY":"Georgia","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"71.7"},{"dims":{"COUNTRY":"Georgia","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"68.0"},{"dims":{"COUNTRY":"Georgia","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"75.3"},{"dims":{"COUNTRY":"Georgia","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.8"},{"dims":{"COUNTRY":"Georgia","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.0"},{"dims":{"COUNTRY":"Georgia","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"20.2"},{"dims":{"COUNTRY":"Georgia","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.0"},{"dims":{"COUNTRY":"Kyrgyzstan","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.1"},{"dims":{"COUNTRY":"Kyrgyzstan","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"67.1"},{"dims":{"COUNTRY":"Kyrgyzstan","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"63.3"},{"dims":{"COUNTRY":"Kyrgyzstan","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"71.2"},{"dims":{"COUNTRY":"Kyrgyzstan","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.5"},{"dims":{"COUNTRY":"Kyrgyzstan","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.5"},{"dims":{"COUNTRY":"Kyrgyzstan","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.4"},{"dims":{"COUNTRY":"Kyrgyzstan","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"66.6"},{"dims":{"COUNTRY":"Kyrgyzstan","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"62.7"},{"dims":{"COUNTRY":"Kyrgyzstan","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"70.6"},{"dims":{"COUNTRY":"Kyrgyzstan","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.1"},{"dims":{"COUNTRY":"Kyrgyzstan","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.1"},{"dims":{"COUNTRY":"Kyrgyzstan","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"17.9"},{"dims":{"COUNTRY":"Kyrgyzstan","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"66.7"},{"dims":{"COUNTRY":"Kyrgyzstan","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"62.8"},{"dims":{"COUNTRY":"Kyrgyzstan","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"70.8"},{"dims":{"COUNTRY":"Kyrgyzstan","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.5"},{"dims":{"COUNTRY":"Kyrgyzstan","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.4"},{"dims":{"COUNTRY":"Kyrgyzstan","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.2"},{"dims":{"COUNTRY":"Kyrgyzstan","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"67.2"},{"dims":{"COUNTRY":"Kyrgyzstan","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"63.1"},{"dims":{"COUNTRY":"Kyrgyzstan","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"71.5"},{"dims":{"COUNTRY":"Kyrgyzstan","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.4"},{"dims":{"COUNTRY":"Kyrgyzstan","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.2"},{"dims":{"COUNTRY":"Kyrgyzstan","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.1"},{"dims":{"COUNTRY":"Kyrgyzstan","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"66.6"},{"dims":{"COUNTRY":"Kyrgyzstan","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"62.6"},{"dims":{"COUNTRY":"Kyrgyzstan","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"70.7"},{"dims":{"COUNTRY":"Kyrgyzstan","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.0"},{"dims":{"COUNTRY":"Kyrgyzstan","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.9"},{"dims":{"COUNTRY":"Kyrgyzstan","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.6"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"65.7"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"64.1"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"67.2"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.8"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.9"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"17.6"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"65.3"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"63.7"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"66.8"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.7"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.9"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"17.5"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"64.9"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"63.3"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"66.4"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.7"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.8"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"17.4"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"64.4"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"62.9"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"66.0"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.6"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.7"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"17.4"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"64.0"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"62.4"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"65.6"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.5"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.6"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"17.3"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"63.6"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"62.0"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"65.1"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.5"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.6"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"17.2"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"63.1"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"61.5"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"64.7"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.4"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.5"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"17.1"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"62.6"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"61.0"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"64.2"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.3"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.4"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"17.1"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"62.1"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"60.5"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"63.7"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.2"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.4"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"17.0"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"61.5"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"59.9"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"63.1"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.1"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.3"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.9"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"61.0"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"59.4"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"62.6"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.0"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.2"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.8"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"60.4"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"58.8"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"62.0"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.0"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.1"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.7"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"59.8"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"58.2"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"61.4"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.9"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.0"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.6"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"59.3"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"57.7"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"60.9"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.8"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.9"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.5"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"58.7"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"57.1"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"60.3"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.7"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.9"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.4"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"58.1"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"56.5"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"59.7"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.6"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.8"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.3"},{"dims":{"COUNTRY":"Latvia","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"74.6"},{"dims":{"COUNTRY":"Latvia","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"69.6"},{"dims":{"COUNTRY":"Latvia","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"79.2"},{"dims":{"COUNTRY":"Latvia","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"20.1"},{"dims":{"COUNTRY":"Latvia","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.8"},{"dims":{"COUNTRY":"Latvia","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"22.6"},{"dims":{"COUNTRY":"Latvia","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"74.4"},{"dims":{"COUNTRY":"Latvia","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"69.4"},{"dims":{"COUNTRY":"Latvia","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"79.0"},{"dims":{"COUNTRY":"Latvia","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"20.0"},{"dims":{"COUNTRY":"Latvia","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.7"},{"dims":{"COUNTRY":"Latvia","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"22.5"},{"dims":{"COUNTRY":"Latvia","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"74.1"},{"dims":{"COUNTRY":"Latvia","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"69.0"},{"dims":{"COUNTRY":"Latvia","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"78.8"},{"dims":{"COUNTRY":"Latvia","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.9"},{"dims":{"COUNTRY":"Latvia","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.5"},{"dims":{"COUNTRY":"Latvia","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"22.4"},{"dims":{"COUNTRY":"Latvia","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.8"},{"dims":{"COUNTRY":"Latvia","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"68.8"},{"dims":{"COUNTRY":"Latvia","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"78.6"},{"dims":{"COUNTRY":"Latvia","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.7"},{"dims":{"COUNTRY":"Latvia","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.4"},{"dims":{"COUNTRY":"Latvia","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"22.1"},{"dims":{"COUNTRY":"Latvia","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.6"},{"dims":{"COUNTRY":"Latvia","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"68.5"},{"dims":{"COUNTRY":"Latvia","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"78.4"},{"dims":{"COUNTRY":"Latvia","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.7"},{"dims":{"COUNTRY":"Latvia","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.3"},{"dims":{"COUNTRY":"Latvia","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"22.2"},{"dims":{"COUNTRY":"Latvia","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"72.8"},{"dims":{"COUNTRY":"Latvia","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"67.6"},{"dims":{"COUNTRY":"Latvia","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"77.7"},{"dims":{"COUNTRY":"Latvia","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.2"},{"dims":{"COUNTRY":"Latvia","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.8"},{"dims":{"COUNTRY":"Latvia","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"21.7"},{"dims":{"COUNTRY":"Latvia","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"72.6"},{"dims":{"COUNTRY":"Latvia","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"67.3"},{"dims":{"COUNTRY":"Latvia","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"77.6"},{"dims":{"COUNTRY":"Latvia","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.3"},{"dims":{"COUNTRY":"Latvia","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.9"},{"dims":{"COUNTRY":"Latvia","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"21.8"},{"dims":{"COUNTRY":"Latvia","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"71.9"},{"dims":{"COUNTRY":"Latvia","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"66.3"},{"dims":{"COUNTRY":"Latvia","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"77.3"},{"dims":{"COUNTRY":"Latvia","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.1"},{"dims":{"COUNTRY":"Latvia","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.5"},{"dims":{"COUNTRY":"Latvia","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"21.7"},{"dims":{"COUNTRY":"Latvia","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"70.8"},{"dims":{"COUNTRY":"Latvia","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"65.1"},{"dims":{"COUNTRY":"Latvia","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"76.4"},{"dims":{"COUNTRY":"Latvia","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.6"},{"dims":{"COUNTRY":"Latvia","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.2"},{"dims":{"COUNTRY":"Latvia","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"21.1"},{"dims":{"COUNTRY":"Latvia","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"70.5"},{"dims":{"COUNTRY":"Latvia","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"64.8"},{"dims":{"COUNTRY":"Latvia","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"76.2"},{"dims":{"COUNTRY":"Latvia","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.5"},{"dims":{"COUNTRY":"Latvia","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.0"},{"dims":{"COUNTRY":"Latvia","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"21.1"},{"dims":{"COUNTRY":"Latvia","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"70.6"},{"dims":{"COUNTRY":"Latvia","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"64.8"},{"dims":{"COUNTRY":"Latvia","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"76.4"},{"dims":{"COUNTRY":"Latvia","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.4"},{"dims":{"COUNTRY":"Latvia","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.8"},{"dims":{"COUNTRY":"Latvia","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"21.1"},{"dims":{"COUNTRY":"Latvia","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"71.0"},{"dims":{"COUNTRY":"Latvia","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"65.6"},{"dims":{"COUNTRY":"Latvia","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"76.3"},{"dims":{"COUNTRY":"Latvia","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.6"},{"dims":{"COUNTRY":"Latvia","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.2"},{"dims":{"COUNTRY":"Latvia","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"21.1"},{"dims":{"COUNTRY":"Latvia","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"70.8"},{"dims":{"COUNTRY":"Latvia","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"65.5"},{"dims":{"COUNTRY":"Latvia","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"75.9"},{"dims":{"COUNTRY":"Latvia","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.5"},{"dims":{"COUNTRY":"Latvia","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.2"},{"dims":{"COUNTRY":"Latvia","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"20.8"},{"dims":{"COUNTRY":"Latvia","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"70.3"},{"dims":{"COUNTRY":"Latvia","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"64.6"},{"dims":{"COUNTRY":"Latvia","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"76.0"},{"dims":{"COUNTRY":"Latvia","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.5"},{"dims":{"COUNTRY":"Latvia","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.1"},{"dims":{"COUNTRY":"Latvia","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"20.9"},{"dims":{"COUNTRY":"Latvia","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"69.9"},{"dims":{"COUNTRY":"Latvia","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"64.2"},{"dims":{"COUNTRY":"Latvia","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"75.5"},{"dims":{"COUNTRY":"Latvia","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.4"},{"dims":{"COUNTRY":"Latvia","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.0"},{"dims":{"COUNTRY":"Latvia","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"20.7"},{"dims":{"COUNTRY":"Latvia","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"70.1"},{"dims":{"COUNTRY":"Latvia","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"64.4"},{"dims":{"COUNTRY":"Latvia","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"75.7"},{"dims":{"COUNTRY":"Latvia","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.4"},{"dims":{"COUNTRY":"Latvia","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.0"},{"dims":{"COUNTRY":"Latvia","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"20.8"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"74.9"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"73.5"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"76.5"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.9"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.8"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"20.1"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"74.8"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"73.4"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"76.4"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.9"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.8"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"20.1"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"74.9"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"73.5"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"76.4"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.9"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.8"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"20.1"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"75.0"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"73.8"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"76.5"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.9"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.8"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"20.1"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"75.0"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"73.7"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"76.4"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.9"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.8"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"20.1"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"74.9"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"73.6"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"76.3"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.8"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.8"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"20.0"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"74.7"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"73.5"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"76.2"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.8"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.7"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"20.0"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"74.5"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"73.2"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"76.0"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.7"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.6"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.9"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"74.4"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"73.1"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"75.9"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.6"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.6"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.8"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"74.1"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"72.8"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"75.7"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.5"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.5"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.8"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.9"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"72.6"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"75.5"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.4"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.4"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.7"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.7"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"72.3"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"75.3"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.3"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.2"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.6"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.5"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"72.1"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"75.0"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.2"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.1"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.4"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.2"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"71.8"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"74.8"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.2"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.0"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.3"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.0"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"71.5"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"74.5"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.1"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.9"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.2"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"72.7"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"71.2"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"74.3"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.0"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.9"},{"dims":{"COUNTRY":"Lebanon","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.1"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"53.7"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"51.7"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"55.4"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.8"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.6"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.6"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"52.1"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"50.3"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"53.8"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.6"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.4"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.4"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"52.1"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"50.3"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"53.7"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.6"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.4"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.4"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"52.2"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"50.5"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"53.5"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.6"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.5"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.4"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"52.3"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"50.3"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"54.0"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.6"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.5"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.4"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"51.1"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"49.4"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"52.6"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.5"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.4"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.3"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"49.4"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"48.5"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"50.0"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.3"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.3"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.0"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"47.8"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"47.1"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"48.3"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.1"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.2"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.8"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"46.2"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"45.7"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"46.5"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"14.9"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.0"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.6"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"45.3"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"44.6"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"45.7"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"14.7"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"13.8"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.4"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"44.5"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"44.0"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"44.8"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"14.5"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"13.7"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.2"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"44.8"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"44.3"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"45.2"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"14.5"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"13.6"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.3"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"45.5"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"44.8"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"46.0"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"14.6"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"13.6"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.4"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"46.4"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"45.7"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"47.1"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"14.7"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"13.7"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.5"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"47.8"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"46.8"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"48.5"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"14.9"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"13.8"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.6"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"49.3"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"48.2"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"50.3"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.0"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.0"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.8"},{"dims":{"COUNTRY":"Liberia","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"61.4"},{"dims":{"COUNTRY":"Liberia","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"59.8"},{"dims":{"COUNTRY":"Liberia","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"62.9"},{"dims":{"COUNTRY":"Liberia","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.6"},{"dims":{"COUNTRY":"Liberia","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.0"},{"dims":{"COUNTRY":"Liberia","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.2"},{"dims":{"COUNTRY":"Liberia","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"58.1"},{"dims":{"COUNTRY":"Liberia","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"56.5"},{"dims":{"COUNTRY":"Liberia","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"59.8"},{"dims":{"COUNTRY":"Liberia","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.3"},{"dims":{"COUNTRY":"Liberia","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.6"},{"dims":{"COUNTRY":"Liberia","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.9"},{"dims":{"COUNTRY":"Liberia","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"61.1"},{"dims":{"COUNTRY":"Liberia","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"59.8"},{"dims":{"COUNTRY":"Liberia","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"62.4"},{"dims":{"COUNTRY":"Liberia","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.7"},{"dims":{"COUNTRY":"Liberia","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.2"},{"dims":{"COUNTRY":"Liberia","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.2"},{"dims":{"COUNTRY":"Liberia","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"60.7"},{"dims":{"COUNTRY":"Liberia","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"59.4"},{"dims":{"COUNTRY":"Liberia","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"62.0"},{"dims":{"COUNTRY":"Liberia","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.7"},{"dims":{"COUNTRY":"Liberia","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.2"},{"dims":{"COUNTRY":"Liberia","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.1"},{"dims":{"COUNTRY":"Liberia","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"60.2"},{"dims":{"COUNTRY":"Liberia","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"58.9"},{"dims":{"COUNTRY":"Liberia","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"61.6"},{"dims":{"COUNTRY":"Liberia","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.7"},{"dims":{"COUNTRY":"Liberia","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.2"},{"dims":{"COUNTRY":"Liberia","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.1"},{"dims":{"COUNTRY":"Liberia","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"59.7"},{"dims":{"COUNTRY":"Liberia","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"58.4"},{"dims":{"COUNTRY":"Liberia","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"61.0"},{"dims":{"COUNTRY":"Liberia","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.6"},{"dims":{"COUNTRY":"Liberia","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.1"},{"dims":{"COUNTRY":"Liberia","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.1"},{"dims":{"COUNTRY":"Liberia","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"59.2"},{"dims":{"COUNTRY":"Liberia","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"57.9"},{"dims":{"COUNTRY":"Liberia","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"60.5"},{"dims":{"COUNTRY":"Liberia","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.6"},{"dims":{"COUNTRY":"Liberia","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.1"},{"dims":{"COUNTRY":"Liberia","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.0"},{"dims":{"COUNTRY":"Liberia","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"58.6"},{"dims":{"COUNTRY":"Liberia","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"57.3"},{"dims":{"COUNTRY":"Liberia","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"60.0"},{"dims":{"COUNTRY":"Liberia","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.6"},{"dims":{"COUNTRY":"Liberia","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.1"},{"dims":{"COUNTRY":"Liberia","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.0"},{"dims":{"COUNTRY":"Liberia","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"57.9"},{"dims":{"COUNTRY":"Liberia","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"56.6"},{"dims":{"COUNTRY":"Liberia","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"59.3"},{"dims":{"COUNTRY":"Liberia","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.5"},{"dims":{"COUNTRY":"Liberia","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.0"},{"dims":{"COUNTRY":"Liberia","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.9"},{"dims":{"COUNTRY":"Liberia","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"56.7"},{"dims":{"COUNTRY":"Liberia","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"55.5"},{"dims":{"COUNTRY":"Liberia","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"58.0"},{"dims":{"COUNTRY":"Liberia","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.2"},{"dims":{"COUNTRY":"Liberia","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.8"},{"dims":{"COUNTRY":"Liberia","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.6"},{"dims":{"COUNTRY":"Liberia","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"55.3"},{"dims":{"COUNTRY":"Liberia","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"54.3"},{"dims":{"COUNTRY":"Liberia","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"56.4"},{"dims":{"COUNTRY":"Liberia","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"14.9"},{"dims":{"COUNTRY":"Liberia","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.5"},{"dims":{"COUNTRY":"Liberia","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.2"},{"dims":{"COUNTRY":"Liberia","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"54.0"},{"dims":{"COUNTRY":"Liberia","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"53.2"},{"dims":{"COUNTRY":"Liberia","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"54.8"},{"dims":{"COUNTRY":"Liberia","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"14.5"},{"dims":{"COUNTRY":"Liberia","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.2"},{"dims":{"COUNTRY":"Liberia","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"14.9"},{"dims":{"COUNTRY":"Liberia","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"50.0"},{"dims":{"COUNTRY":"Liberia","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"48.1"},{"dims":{"COUNTRY":"Liberia","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"52.0"},{"dims":{"COUNTRY":"Liberia","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"14.2"},{"dims":{"COUNTRY":"Liberia","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"13.8"},{"dims":{"COUNTRY":"Liberia","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"14.5"},{"dims":{"COUNTRY":"Liberia","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"50.6"},{"dims":{"COUNTRY":"Liberia","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"49.2"},{"dims":{"COUNTRY":"Liberia","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"52.1"},{"dims":{"COUNTRY":"Liberia","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"14.2"},{"dims":{"COUNTRY":"Liberia","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"13.9"},{"dims":{"COUNTRY":"Liberia","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"14.6"},{"dims":{"COUNTRY":"Liberia","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"51.5"},{"dims":{"COUNTRY":"Liberia","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"50.7"},{"dims":{"COUNTRY":"Liberia","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"52.4"},{"dims":{"COUNTRY":"Liberia","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"14.6"},{"dims":{"COUNTRY":"Liberia","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.3"},{"dims":{"COUNTRY":"Liberia","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"14.8"},{"dims":{"COUNTRY":"Liberia","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"51.9"},{"dims":{"COUNTRY":"Liberia","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"51.2"},{"dims":{"COUNTRY":"Liberia","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"52.6"},{"dims":{"COUNTRY":"Liberia","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.0"},{"dims":{"COUNTRY":"Liberia","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.7"},{"dims":{"COUNTRY":"Liberia","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.2"},{"dims":{"COUNTRY":"Libya","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"72.7"},{"dims":{"COUNTRY":"Libya","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"70.1"},{"dims":{"COUNTRY":"Libya","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"75.6"},{"dims":{"COUNTRY":"Libya","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.4"},{"dims":{"COUNTRY":"Libya","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.9"},{"dims":{"COUNTRY":"Libya","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.9"},{"dims":{"COUNTRY":"Libya","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"72.4"},{"dims":{"COUNTRY":"Libya","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"69.8"},{"dims":{"COUNTRY":"Libya","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"75.4"},{"dims":{"COUNTRY":"Libya","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.4"},{"dims":{"COUNTRY":"Libya","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.9"},{"dims":{"COUNTRY":"Libya","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.9"},{"dims":{"COUNTRY":"Libya","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"72.9"},{"dims":{"COUNTRY":"Libya","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"70.4"},{"dims":{"COUNTRY":"Libya","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"75.5"},{"dims":{"COUNTRY":"Libya","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.4"},{"dims":{"COUNTRY":"Libya","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.9"},{"dims":{"COUNTRY":"Libya","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.9"},{"dims":{"COUNTRY":"Libya","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"72.9"},{"dims":{"COUNTRY":"Libya","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"70.5"},{"dims":{"COUNTRY":"Libya","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"75.5"},{"dims":{"COUNTRY":"Libya","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.3"},{"dims":{"COUNTRY":"Libya","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.9"},{"dims":{"COUNTRY":"Libya","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.8"},{"dims":{"COUNTRY":"Libya","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"71.3"},{"dims":{"COUNTRY":"Libya","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"68.4"},{"dims":{"COUNTRY":"Libya","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"74.6"},{"dims":{"COUNTRY":"Libya","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.2"},{"dims":{"COUNTRY":"Libya","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.8"},{"dims":{"COUNTRY":"Libya","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.8"},{"dims":{"COUNTRY":"Libya","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"72.8"},{"dims":{"COUNTRY":"Libya","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"70.5"},{"dims":{"COUNTRY":"Libya","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"75.3"},{"dims":{"COUNTRY":"Libya","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.3"},{"dims":{"COUNTRY":"Libya","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.9"},{"dims":{"COUNTRY":"Libya","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.8"},{"dims":{"COUNTRY":"Libya","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"72.7"},{"dims":{"COUNTRY":"Libya","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"70.5"},{"dims":{"COUNTRY":"Libya","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"75.2"},{"dims":{"COUNTRY":"Libya","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.3"},{"dims":{"COUNTRY":"Libya","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.9"},{"dims":{"COUNTRY":"Libya","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.8"},{"dims":{"COUNTRY":"Libya","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"72.6"},{"dims":{"COUNTRY":"Libya","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"70.4"},{"dims":{"COUNTRY":"Libya","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"75.1"},{"dims":{"COUNTRY":"Libya","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.2"},{"dims":{"COUNTRY":"Libya","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.9"},{"dims":{"COUNTRY":"Libya","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.7"},{"dims":{"COUNTRY":"Libya","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"72.5"},{"dims":{"COUNTRY":"Libya","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"70.3"},{"dims":{"COUNTRY":"Libya","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"74.9"},{"dims":{"COUNTRY":"Libya","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.2"},{"dims":{"COUNTRY":"Libya","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.8"},{"dims":{"COUNTRY":"Libya","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.7"},{"dims":{"COUNTRY":"Libya","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"72.2"},{"dims":{"COUNTRY":"Libya","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"70.1"},{"dims":{"COUNTRY":"Libya","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"74.6"},{"dims":{"COUNTRY":"Libya","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.1"},{"dims":{"COUNTRY":"Libya","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.8"},{"dims":{"COUNTRY":"Libya","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.5"},{"dims":{"COUNTRY":"Libya","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"71.9"},{"dims":{"COUNTRY":"Libya","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"69.9"},{"dims":{"COUNTRY":"Libya","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"74.1"},{"dims":{"COUNTRY":"Libya","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.0"},{"dims":{"COUNTRY":"Libya","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.8"},{"dims":{"COUNTRY":"Libya","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.2"},{"dims":{"COUNTRY":"Libya","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"71.5"},{"dims":{"COUNTRY":"Libya","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"69.8"},{"dims":{"COUNTRY":"Libya","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"73.6"},{"dims":{"COUNTRY":"Libya","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.8"},{"dims":{"COUNTRY":"Libya","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.8"},{"dims":{"COUNTRY":"Libya","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.0"},{"dims":{"COUNTRY":"Libya","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"71.3"},{"dims":{"COUNTRY":"Libya","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"69.6"},{"dims":{"COUNTRY":"Libya","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"73.2"},{"dims":{"COUNTRY":"Libya","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.7"},{"dims":{"COUNTRY":"Libya","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.7"},{"dims":{"COUNTRY":"Libya","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.8"},{"dims":{"COUNTRY":"Libya","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"71.1"},{"dims":{"COUNTRY":"Libya","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"69.5"},{"dims":{"COUNTRY":"Libya","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"73.0"},{"dims":{"COUNTRY":"Libya","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.7"},{"dims":{"COUNTRY":"Libya","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.7"},{"dims":{"COUNTRY":"Libya","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.7"},{"dims":{"COUNTRY":"Libya","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"71.0"},{"dims":{"COUNTRY":"Libya","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"69.4"},{"dims":{"COUNTRY":"Libya","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"72.8"},{"dims":{"COUNTRY":"Libya","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.6"},{"dims":{"COUNTRY":"Libya","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.7"},{"dims":{"COUNTRY":"Libya","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.7"},{"dims":{"COUNTRY":"Libya","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"70.8"},{"dims":{"COUNTRY":"Libya","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"69.3"},{"dims":{"COUNTRY":"Libya","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"72.7"},{"dims":{"COUNTRY":"Libya","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.6"},{"dims":{"COUNTRY":"Libya","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.7"},{"dims":{"COUNTRY":"Libya","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.6"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.6"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"68.1"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"79.1"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.4"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.5"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"22.6"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.4"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"67.9"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"79.0"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.3"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.5"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"22.5"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.0"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"67.4"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"78.7"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.2"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.5"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"22.3"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.0"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"67.3"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"78.8"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.2"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.3"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"22.4"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"72.8"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"67.1"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"78.6"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.1"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.3"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"22.3"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"72.4"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"66.7"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"78.3"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.9"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.1"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"22.1"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"72.2"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"66.3"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"78.2"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.0"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.1"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"22.2"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"71.1"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"65.1"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"77.4"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.9"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.2"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"22.0"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"70.2"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"63.8"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"77.1"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.5"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.6"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"21.8"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"70.6"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"64.4"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"77.0"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.5"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.8"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"21.6"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"70.8"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"64.6"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"77.3"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.7"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.9"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"21.7"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"71.6"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"65.7"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"77.7"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.0"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.4"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"21.9"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"71.6"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"65.8"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"77.6"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.0"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.4"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"22.0"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"71.4"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"65.6"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"77.4"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.9"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.3"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"21.7"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"71.2"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"65.3"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"77.3"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.0"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.4"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"21.8"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"71.6"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"65.9"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"77.2"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.0"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.6"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"21.7"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"82.0"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"79.8"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"84.0"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"24.3"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"22.5"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"25.9"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"81.7"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"79.5"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"83.8"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"24.1"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"22.3"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"25.8"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"81.4"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"79.3"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"83.5"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"23.9"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"22.2"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"25.5"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"81.1"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"78.8"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"83.3"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"23.6"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"21.8"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"25.3"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"80.8"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"78.4"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"83.2"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"23.5"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"21.5"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"25.3"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"80.6"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"78.0"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"83.1"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"23.3"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"21.3"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"25.1"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"80.3"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"77.7"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"82.7"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"23.1"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"21.0"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.9"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"80.0"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"77.3"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"82.5"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"23.0"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"20.9"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.8"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"79.7"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"77.0"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"82.2"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"22.8"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"20.7"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.5"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"79.4"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"76.6"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"82.1"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"22.6"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"20.5"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.4"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"78.8"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"75.8"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"81.6"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"22.2"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"20.0"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.0"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"78.7"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"75.6"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"81.7"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"22.2"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"20.0"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.2"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"78.6"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"75.5"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"81.6"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"22.2"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.8"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.1"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"78.3"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"75.1"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"81.4"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"22.0"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.5"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.0"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"78.0"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"74.8"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"81.1"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"21.7"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.2"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"23.7"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"77.8"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"74.5"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"80.9"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"21.6"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.0"},{"dims":{"COUNTRY":"Luxembourg","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"23.7"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"65.5"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"63.9"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"67.0"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.0"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.3"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"17.6"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"65.1"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"63.6"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"66.7"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.9"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.3"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"17.6"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"64.7"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"63.2"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"66.3"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.9"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.2"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"17.5"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"64.3"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"62.8"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"65.8"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.8"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.2"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"17.4"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"63.8"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"62.3"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"65.4"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.8"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.1"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"17.4"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"63.3"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"61.8"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"64.8"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.7"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.1"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"17.3"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"62.8"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"61.3"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"64.3"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.7"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.0"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"17.3"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"62.3"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"60.8"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"63.8"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.6"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.0"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"17.2"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"61.9"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"60.4"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"63.3"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.6"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.9"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"17.2"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"61.4"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"60.0"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"62.8"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.5"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.9"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"17.1"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"60.9"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"59.6"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"62.3"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.4"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.8"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"17.0"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"60.4"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"59.1"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"61.7"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.3"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.8"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.9"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"59.9"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"58.6"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"61.2"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.3"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.7"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.8"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"59.3"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"58.1"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"60.6"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.2"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.7"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.7"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"58.7"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"57.5"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"59.9"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.0"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.5"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.5"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"57.9"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"56.7"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"59.1"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.8"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.3"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.3"},{"dims":{"COUNTRY":"Malawi","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"58.3"},{"dims":{"COUNTRY":"Malawi","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"56.7"},{"dims":{"COUNTRY":"Malawi","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"59.9"},{"dims":{"COUNTRY":"Malawi","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.4"},{"dims":{"COUNTRY":"Malawi","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.5"},{"dims":{"COUNTRY":"Malawi","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.1"},{"dims":{"COUNTRY":"Malawi","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"57.6"},{"dims":{"COUNTRY":"Malawi","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"56.1"},{"dims":{"COUNTRY":"Malawi","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"59.2"},{"dims":{"COUNTRY":"Malawi","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.4"},{"dims":{"COUNTRY":"Malawi","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.5"},{"dims":{"COUNTRY":"Malawi","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.1"},{"dims":{"COUNTRY":"Malawi","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"56.7"},{"dims":{"COUNTRY":"Malawi","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"55.2"},{"dims":{"COUNTRY":"Malawi","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"58.2"},{"dims":{"COUNTRY":"Malawi","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.4"},{"dims":{"COUNTRY":"Malawi","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.5"},{"dims":{"COUNTRY":"Malawi","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.1"},{"dims":{"COUNTRY":"Malawi","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"55.3"},{"dims":{"COUNTRY":"Malawi","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"54.0"},{"dims":{"COUNTRY":"Malawi","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"56.7"},{"dims":{"COUNTRY":"Malawi","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.3"},{"dims":{"COUNTRY":"Malawi","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.4"},{"dims":{"COUNTRY":"Malawi","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.0"},{"dims":{"COUNTRY":"Malawi","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"54.1"},{"dims":{"COUNTRY":"Malawi","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"52.9"},{"dims":{"COUNTRY":"Malawi","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"55.3"},{"dims":{"COUNTRY":"Malawi","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.2"},{"dims":{"COUNTRY":"Malawi","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.4"},{"dims":{"COUNTRY":"Malawi","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.0"},{"dims":{"COUNTRY":"Malawi","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"52.9"},{"dims":{"COUNTRY":"Malawi","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"51.7"},{"dims":{"COUNTRY":"Malawi","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"54.0"},{"dims":{"COUNTRY":"Malawi","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.2"},{"dims":{"COUNTRY":"Malawi","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.3"},{"dims":{"COUNTRY":"Malawi","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.9"},{"dims":{"COUNTRY":"Malawi","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"51.5"},{"dims":{"COUNTRY":"Malawi","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"50.6"},{"dims":{"COUNTRY":"Malawi","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"52.4"},{"dims":{"COUNTRY":"Malawi","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.0"},{"dims":{"COUNTRY":"Malawi","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.2"},{"dims":{"COUNTRY":"Malawi","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.8"},{"dims":{"COUNTRY":"Malawi","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"50.0"},{"dims":{"COUNTRY":"Malawi","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"49.2"},{"dims":{"COUNTRY":"Malawi","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"50.7"},{"dims":{"COUNTRY":"Malawi","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"14.9"},{"dims":{"COUNTRY":"Malawi","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.1"},{"dims":{"COUNTRY":"Malawi","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.6"},{"dims":{"COUNTRY":"Malawi","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"48.5"},{"dims":{"COUNTRY":"Malawi","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"48.0"},{"dims":{"COUNTRY":"Malawi","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"48.9"},{"dims":{"COUNTRY":"Malawi","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"14.7"},{"dims":{"COUNTRY":"Malawi","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"13.9"},{"dims":{"COUNTRY":"Malawi","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.5"},{"dims":{"COUNTRY":"Malawi","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"47.1"},{"dims":{"COUNTRY":"Malawi","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"46.8"},{"dims":{"COUNTRY":"Malawi","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"47.3"},{"dims":{"COUNTRY":"Malawi","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"14.6"},{"dims":{"COUNTRY":"Malawi","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"13.8"},{"dims":{"COUNTRY":"Malawi","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.3"},{"dims":{"COUNTRY":"Malawi","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"46.0"},{"dims":{"COUNTRY":"Malawi","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"45.9"},{"dims":{"COUNTRY":"Malawi","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"46.1"},{"dims":{"COUNTRY":"Malawi","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"14.4"},{"dims":{"COUNTRY":"Malawi","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"13.7"},{"dims":{"COUNTRY":"Malawi","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.1"},{"dims":{"COUNTRY":"Malawi","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"45.1"},{"dims":{"COUNTRY":"Malawi","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"45.1"},{"dims":{"COUNTRY":"Malawi","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"45.2"},{"dims":{"COUNTRY":"Malawi","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"14.3"},{"dims":{"COUNTRY":"Malawi","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"13.6"},{"dims":{"COUNTRY":"Malawi","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.0"},{"dims":{"COUNTRY":"Malawi","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"44.6"},{"dims":{"COUNTRY":"Malawi","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"44.4"},{"dims":{"COUNTRY":"Malawi","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"44.7"},{"dims":{"COUNTRY":"Malawi","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"14.3"},{"dims":{"COUNTRY":"Malawi","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"13.5"},{"dims":{"COUNTRY":"Malawi","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"14.9"},{"dims":{"COUNTRY":"Malawi","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"44.0"},{"dims":{"COUNTRY":"Malawi","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"43.7"},{"dims":{"COUNTRY":"Malawi","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"44.2"},{"dims":{"COUNTRY":"Malawi","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"14.2"},{"dims":{"COUNTRY":"Malawi","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"13.5"},{"dims":{"COUNTRY":"Malawi","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"14.9"},{"dims":{"COUNTRY":"Malawi","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"43.5"},{"dims":{"COUNTRY":"Malawi","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"43.1"},{"dims":{"COUNTRY":"Malawi","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"43.8"},{"dims":{"COUNTRY":"Malawi","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"14.1"},{"dims":{"COUNTRY":"Malawi","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"13.4"},{"dims":{"COUNTRY":"Malawi","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"14.8"},{"dims":{"COUNTRY":"Malawi","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"43.1"},{"dims":{"COUNTRY":"Malawi","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"42.6"},{"dims":{"COUNTRY":"Malawi","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"43.6"},{"dims":{"COUNTRY":"Malawi","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"14.0"},{"dims":{"COUNTRY":"Malawi","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"13.3"},{"dims":{"COUNTRY":"Malawi","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"14.7"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"75.0"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"72.7"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"77.3"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.5"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"18.6"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"20.3"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"74.8"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"72.5"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"77.1"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.4"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"18.5"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"20.3"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"74.6"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"72.3"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"77.0"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.3"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"18.5"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"20.2"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"74.5"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"72.2"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"76.8"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.2"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"18.4"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"20.1"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"74.3"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"72.1"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"76.7"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.1"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"18.3"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"20.0"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"74.1"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"71.9"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"76.5"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.0"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"18.1"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.9"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"74.0"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"71.8"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"76.4"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.8"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"18.0"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.7"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.8"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"71.6"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"76.3"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.7"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.8"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.6"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.7"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"71.5"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"76.1"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.6"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.7"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.5"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.6"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"71.4"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"75.9"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.5"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.6"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.4"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.4"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"71.2"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"75.8"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.3"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.5"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.3"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.2"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"71.1"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"75.6"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.2"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.3"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.2"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.1"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"71.0"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"75.4"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.1"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.3"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.1"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"72.9"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"70.8"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"75.2"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.1"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.2"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.0"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"72.7"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"70.5"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"75.1"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.0"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.2"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.9"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"72.4"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"81.5"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"79.8"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"83.1"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"24.6"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"23.4"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"25.7"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"81.3"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"79.5"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"83.0"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"24.4"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"23.2"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"25.6"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"81.1"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"79.3"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"82.8"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"24.3"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"23.0"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"25.5"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"80.6"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"78.9"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"82.4"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"23.9"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"22.7"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"25.1"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"80.9"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"79.0"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"82.8"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"24.2"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"22.8"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"25.5"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"80.5"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"78.4"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"82.4"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"23.8"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"22.3"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"25.2"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"80.1"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"78.2"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"82.1"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"23.5"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"22.1"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.8"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"80.1"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"77.9"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"82.2"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"23.5"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"22.0"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"25.0"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"79.9"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"77.8"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"81.9"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"23.3"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"21.8"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.7"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"79.9"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"77.7"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"82.1"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"23.4"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"21.8"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.9"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"79.2"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"77.1"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"81.4"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"22.7"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"21.1"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.2"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"79.1"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"76.8"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"81.3"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"22.7"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"21.0"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.3"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"78.7"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"76.4"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"81.0"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"22.4"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"20.6"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.0"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"78.5"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"76.0"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"80.8"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"22.1"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"20.3"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"23.8"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"78.6"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"75.9"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"81.2"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"22.3"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"20.3"},{"dims":{"COUNTRY":"New Zealand","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.2"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"74.8"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"71.5"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"77.9"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"21.9"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"20.3"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"23.3"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"74.5"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"71.3"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"77.7"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"21.7"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"20.2"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"23.1"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.9"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"70.6"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"77.1"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"21.5"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.9"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"22.8"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.9"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"70.5"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"77.3"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"21.6"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.9"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"23.2"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"74.5"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"71.6"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"77.3"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"21.9"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"20.6"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"23.0"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.2"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"70.2"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"76.1"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"20.8"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.4"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"22.1"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.2"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"70.1"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"76.2"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"21.3"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"20.0"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"22.4"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"72.5"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"69.3"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"75.7"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"20.9"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.5"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"22.1"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"72.5"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"69.4"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"75.5"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"21.0"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.8"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"22.1"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.0"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"69.8"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"76.1"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"21.5"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"20.1"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"22.7"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"71.2"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"67.8"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"74.5"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"20.6"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.2"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"21.9"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"71.0"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"67.8"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"74.0"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"20.4"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.1"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"21.6"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"70.6"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"67.6"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"73.7"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"20.3"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.3"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"21.2"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"70.5"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"67.7"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"73.3"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"20.3"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.2"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"21.2"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"70.3"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"67.6"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"73.0"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"20.2"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.2"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"21.1"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"70.3"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"67.3"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"73.3"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"20.3"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.2"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"21.4"},{"dims":{"COUNTRY":"Niger","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"61.8"},{"dims":{"COUNTRY":"Niger","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"60.9"},{"dims":{"COUNTRY":"Niger","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"62.8"},{"dims":{"COUNTRY":"Niger","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.2"},{"dims":{"COUNTRY":"Niger","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.6"},{"dims":{"COUNTRY":"Niger","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.7"},{"dims":{"COUNTRY":"Niger","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"61.4"},{"dims":{"COUNTRY":"Niger","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"60.5"},{"dims":{"COUNTRY":"Niger","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"62.4"},{"dims":{"COUNTRY":"Niger","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.1"},{"dims":{"COUNTRY":"Niger","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.6"},{"dims":{"COUNTRY":"Niger","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.7"},{"dims":{"COUNTRY":"Niger","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"60.9"},{"dims":{"COUNTRY":"Niger","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"60.0"},{"dims":{"COUNTRY":"Niger","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"61.9"},{"dims":{"COUNTRY":"Niger","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.1"},{"dims":{"COUNTRY":"Niger","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.5"},{"dims":{"COUNTRY":"Niger","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.6"},{"dims":{"COUNTRY":"Niger","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"60.3"},{"dims":{"COUNTRY":"Niger","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"59.4"},{"dims":{"COUNTRY":"Niger","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"61.2"},{"dims":{"COUNTRY":"Niger","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.0"},{"dims":{"COUNTRY":"Niger","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.5"},{"dims":{"COUNTRY":"Niger","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.5"},{"dims":{"COUNTRY":"Niger","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"59.4"},{"dims":{"COUNTRY":"Niger","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"58.7"},{"dims":{"COUNTRY":"Niger","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"60.1"},{"dims":{"COUNTRY":"Niger","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.8"},{"dims":{"COUNTRY":"Niger","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.4"},{"dims":{"COUNTRY":"Niger","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.3"},{"dims":{"COUNTRY":"Niger","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"58.2"},{"dims":{"COUNTRY":"Niger","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"57.8"},{"dims":{"COUNTRY":"Niger","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"58.8"},{"dims":{"COUNTRY":"Niger","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.6"},{"dims":{"COUNTRY":"Niger","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.2"},{"dims":{"COUNTRY":"Niger","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.0"},{"dims":{"COUNTRY":"Niger","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"57.1"},{"dims":{"COUNTRY":"Niger","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"56.8"},{"dims":{"COUNTRY":"Niger","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"57.4"},{"dims":{"COUNTRY":"Niger","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.4"},{"dims":{"COUNTRY":"Niger","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.1"},{"dims":{"COUNTRY":"Niger","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.7"},{"dims":{"COUNTRY":"Niger","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"56.0"},{"dims":{"COUNTRY":"Niger","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"55.9"},{"dims":{"COUNTRY":"Niger","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"56.2"},{"dims":{"COUNTRY":"Niger","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.2"},{"dims":{"COUNTRY":"Niger","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.0"},{"dims":{"COUNTRY":"Niger","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.5"},{"dims":{"COUNTRY":"Niger","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"55.2"},{"dims":{"COUNTRY":"Niger","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"55.1"},{"dims":{"COUNTRY":"Niger","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"55.3"},{"dims":{"COUNTRY":"Niger","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.2"},{"dims":{"COUNTRY":"Niger","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.9"},{"dims":{"COUNTRY":"Niger","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.4"},{"dims":{"COUNTRY":"Niger","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"54.5"},{"dims":{"COUNTRY":"Niger","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"54.4"},{"dims":{"COUNTRY":"Niger","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"54.6"},{"dims":{"COUNTRY":"Niger","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.1"},{"dims":{"COUNTRY":"Niger","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.9"},{"dims":{"COUNTRY":"Niger","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.3"},{"dims":{"COUNTRY":"Niger","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"53.7"},{"dims":{"COUNTRY":"Niger","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"53.7"},{"dims":{"COUNTRY":"Niger","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"53.8"},{"dims":{"COUNTRY":"Niger","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.1"},{"dims":{"COUNTRY":"Niger","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.9"},{"dims":{"COUNTRY":"Niger","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.3"},{"dims":{"COUNTRY":"Niger","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"52.9"},{"dims":{"COUNTRY":"Niger","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"52.9"},{"dims":{"COUNTRY":"Niger","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"53.0"},{"dims":{"COUNTRY":"Niger","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.1"},{"dims":{"COUNTRY":"Niger","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.9"},{"dims":{"COUNTRY":"Niger","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.3"},{"dims":{"COUNTRY":"Niger","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"52.1"},{"dims":{"COUNTRY":"Niger","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"52.1"},{"dims":{"COUNTRY":"Niger","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"52.2"},{"dims":{"COUNTRY":"Niger","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.1"},{"dims":{"COUNTRY":"Niger","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.9"},{"dims":{"COUNTRY":"Niger","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.2"},{"dims":{"COUNTRY":"Niger","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"51.4"},{"dims":{"COUNTRY":"Niger","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"51.3"},{"dims":{"COUNTRY":"Niger","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"51.4"},{"dims":{"COUNTRY":"Niger","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.0"},{"dims":{"COUNTRY":"Niger","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.9"},{"dims":{"COUNTRY":"Niger","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.2"},{"dims":{"COUNTRY":"Niger","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"50.6"},{"dims":{"COUNTRY":"Niger","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"50.6"},{"dims":{"COUNTRY":"Niger","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"50.7"},{"dims":{"COUNTRY":"Niger","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.0"},{"dims":{"COUNTRY":"Niger","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.8"},{"dims":{"COUNTRY":"Niger","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.2"},{"dims":{"COUNTRY":"Niger","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"50.0"},{"dims":{"COUNTRY":"Niger","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"49.9"},{"dims":{"COUNTRY":"Niger","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"50.0"},{"dims":{"COUNTRY":"Niger","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.0"},{"dims":{"COUNTRY":"Niger","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.8"},{"dims":{"COUNTRY":"Niger","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.2"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"54.5"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"53.4"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"55.6"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"14.2"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"13.9"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"14.5"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"53.6"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"52.6"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"54.7"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"14.1"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"13.9"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"14.4"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"53.2"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"52.2"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"54.2"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"14.1"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"13.8"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"14.3"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"52.7"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"51.8"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"53.5"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"14.0"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"13.8"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"14.3"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"52.3"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"51.5"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"53.1"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"14.0"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"13.7"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"14.2"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"52.0"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"51.2"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"52.9"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"14.0"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"13.7"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"14.2"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"51.6"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"50.7"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"52.4"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"13.9"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"13.7"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"14.1"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"50.9"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"50.1"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"51.7"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"13.8"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"13.6"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"14.1"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"50.5"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"49.7"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"51.3"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"13.8"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"13.5"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"14.0"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"49.8"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"49.0"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"50.7"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"13.6"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"13.4"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"13.9"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"49.2"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"48.4"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"50.1"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"13.5"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"13.3"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"13.8"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"48.5"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"47.7"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"49.4"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"13.4"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"13.2"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"13.6"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"48.1"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"47.2"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"49.0"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"13.4"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"13.1"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"13.6"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"47.7"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"46.8"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"48.6"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"13.4"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"13.1"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"13.6"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"47.4"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"46.4"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"48.3"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"13.4"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"13.1"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"13.6"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"47.1"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"46.2"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"48.1"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"13.4"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"13.2"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"13.7"},{"dims":{"COUNTRY":"Niue","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19"},{"dims":{"COUNTRY":"Niue","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17"},{"dims":{"COUNTRY":"Niue","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"21"},{"dims":{"COUNTRY":"Norway","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"81.8"},{"dims":{"COUNTRY":"Norway","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"79.8"},{"dims":{"COUNTRY":"Norway","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"83.7"},{"dims":{"COUNTRY":"Norway","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"24.2"},{"dims":{"COUNTRY":"Norway","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"22.6"},{"dims":{"COUNTRY":"Norway","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"25.6"},{"dims":{"COUNTRY":"Norway","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"81.6"},{"dims":{"COUNTRY":"Norway","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"79.6"},{"dims":{"COUNTRY":"Norway","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"83.6"},{"dims":{"COUNTRY":"Norway","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"24.1"},{"dims":{"COUNTRY":"Norway","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"22.5"},{"dims":{"COUNTRY":"Norway","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"25.5"},{"dims":{"COUNTRY":"Norway","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"81.5"},{"dims":{"COUNTRY":"Norway","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"79.4"},{"dims":{"COUNTRY":"Norway","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"83.5"},{"dims":{"COUNTRY":"Norway","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"24.0"},{"dims":{"COUNTRY":"Norway","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"22.4"},{"dims":{"COUNTRY":"Norway","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"25.5"},{"dims":{"COUNTRY":"Norway","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"81.3"},{"dims":{"COUNTRY":"Norway","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"79.2"},{"dims":{"COUNTRY":"Norway","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"83.3"},{"dims":{"COUNTRY":"Norway","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"23.8"},{"dims":{"COUNTRY":"Norway","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"22.2"},{"dims":{"COUNTRY":"Norway","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"25.2"},{"dims":{"COUNTRY":"Norway","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"81.1"},{"dims":{"COUNTRY":"Norway","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"78.9"},{"dims":{"COUNTRY":"Norway","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"83.3"},{"dims":{"COUNTRY":"Norway","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"23.8"},{"dims":{"COUNTRY":"Norway","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"22.1"},{"dims":{"COUNTRY":"Norway","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"25.5"},{"dims":{"COUNTRY":"Norway","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"81.0"},{"dims":{"COUNTRY":"Norway","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"78.8"},{"dims":{"COUNTRY":"Norway","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"83.1"},{"dims":{"COUNTRY":"Norway","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"23.7"},{"dims":{"COUNTRY":"Norway","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"21.9"},{"dims":{"COUNTRY":"Norway","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"25.3"},{"dims":{"COUNTRY":"Norway","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"80.9"},{"dims":{"COUNTRY":"Norway","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"78.6"},{"dims":{"COUNTRY":"Norway","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"83.1"},{"dims":{"COUNTRY":"Norway","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"23.7"},{"dims":{"COUNTRY":"Norway","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"21.9"},{"dims":{"COUNTRY":"Norway","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"25.2"},{"dims":{"COUNTRY":"Norway","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"80.6"},{"dims":{"COUNTRY":"Norway","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"78.3"},{"dims":{"COUNTRY":"Norway","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"82.9"},{"dims":{"COUNTRY":"Norway","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"23.4"},{"dims":{"COUNTRY":"Norway","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"21.5"},{"dims":{"COUNTRY":"Norway","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"25.1"},{"dims":{"COUNTRY":"Norway","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"80.5"},{"dims":{"COUNTRY":"Norway","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"78.2"},{"dims":{"COUNTRY":"Norway","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"82.7"},{"dims":{"COUNTRY":"Norway","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"23.2"},{"dims":{"COUNTRY":"Norway","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"21.3"},{"dims":{"COUNTRY":"Norway","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"25.0"},{"dims":{"COUNTRY":"Norway","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"80.4"},{"dims":{"COUNTRY":"Norway","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"78.0"},{"dims":{"COUNTRY":"Norway","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"82.6"},{"dims":{"COUNTRY":"Norway","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"23.3"},{"dims":{"COUNTRY":"Norway","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"21.4"},{"dims":{"COUNTRY":"Norway","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.9"},{"dims":{"COUNTRY":"Norway","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"80.1"},{"dims":{"COUNTRY":"Norway","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"77.6"},{"dims":{"COUNTRY":"Norway","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"82.5"},{"dims":{"COUNTRY":"Norway","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"23.1"},{"dims":{"COUNTRY":"Norway","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"21.1"},{"dims":{"COUNTRY":"Norway","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.9"},{"dims":{"COUNTRY":"Norway","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"79.8"},{"dims":{"COUNTRY":"Norway","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"77.3"},{"dims":{"COUNTRY":"Norway","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"82.3"},{"dims":{"COUNTRY":"Norway","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"23.0"},{"dims":{"COUNTRY":"Norway","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"21.0"},{"dims":{"COUNTRY":"Norway","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.8"},{"dims":{"COUNTRY":"Norway","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"79.4"},{"dims":{"COUNTRY":"Norway","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"76.9"},{"dims":{"COUNTRY":"Norway","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"81.9"},{"dims":{"COUNTRY":"Norway","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"22.6"},{"dims":{"COUNTRY":"Norway","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"20.6"},{"dims":{"COUNTRY":"Norway","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.4"},{"dims":{"COUNTRY":"Norway","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"78.9"},{"dims":{"COUNTRY":"Norway","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"76.2"},{"dims":{"COUNTRY":"Norway","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"81.5"},{"dims":{"COUNTRY":"Norway","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"22.1"},{"dims":{"COUNTRY":"Norway","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"20.1"},{"dims":{"COUNTRY":"Norway","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.0"},{"dims":{"COUNTRY":"Norway","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"78.8"},{"dims":{"COUNTRY":"Norway","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"76.0"},{"dims":{"COUNTRY":"Norway","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"81.5"},{"dims":{"COUNTRY":"Norway","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"22.1"},{"dims":{"COUNTRY":"Norway","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"20.0"},{"dims":{"COUNTRY":"Norway","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.0"},{"dims":{"COUNTRY":"Norway","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"78.5"},{"dims":{"COUNTRY":"Norway","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"75.7"},{"dims":{"COUNTRY":"Norway","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"81.3"},{"dims":{"COUNTRY":"Norway","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"22.0"},{"dims":{"COUNTRY":"Norway","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.9"},{"dims":{"COUNTRY":"Norway","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"23.9"},{"dims":{"COUNTRY":"Oman","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"76.6"},{"dims":{"COUNTRY":"Oman","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"75.0"},{"dims":{"COUNTRY":"Oman","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"79.2"},{"dims":{"COUNTRY":"Oman","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"20.9"},{"dims":{"COUNTRY":"Oman","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.7"},{"dims":{"COUNTRY":"Oman","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"22.4"},{"dims":{"COUNTRY":"Oman","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"76.4"},{"dims":{"COUNTRY":"Oman","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"74.7"},{"dims":{"COUNTRY":"Oman","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"79.0"},{"dims":{"COUNTRY":"Oman","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"20.8"},{"dims":{"COUNTRY":"Oman","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.6"},{"dims":{"COUNTRY":"Oman","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"22.3"},{"dims":{"COUNTRY":"Oman","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"76.2"},{"dims":{"COUNTRY":"Oman","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"74.5"},{"dims":{"COUNTRY":"Oman","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"78.8"},{"dims":{"COUNTRY":"Oman","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"20.6"},{"dims":{"COUNTRY":"Oman","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.4"},{"dims":{"COUNTRY":"Oman","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"22.1"},{"dims":{"COUNTRY":"Oman","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"76.0"},{"dims":{"COUNTRY":"Oman","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"74.2"},{"dims":{"COUNTRY":"Oman","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"78.6"},{"dims":{"COUNTRY":"Oman","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"20.5"},{"dims":{"COUNTRY":"Oman","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.2"},{"dims":{"COUNTRY":"Oman","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"21.9"},{"dims":{"COUNTRY":"Oman","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"75.8"},{"dims":{"COUNTRY":"Oman","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"74.0"},{"dims":{"COUNTRY":"Oman","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"78.4"},{"dims":{"COUNTRY":"Oman","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"20.3"},{"dims":{"COUNTRY":"Oman","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.0"},{"dims":{"COUNTRY":"Oman","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"21.7"},{"dims":{"COUNTRY":"Oman","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"75.6"},{"dims":{"COUNTRY":"Oman","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"73.7"},{"dims":{"COUNTRY":"Oman","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"78.1"},{"dims":{"COUNTRY":"Oman","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"20.1"},{"dims":{"COUNTRY":"Oman","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"18.9"},{"dims":{"COUNTRY":"Oman","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"21.6"},{"dims":{"COUNTRY":"Oman","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"75.4"},{"dims":{"COUNTRY":"Oman","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"73.5"},{"dims":{"COUNTRY":"Oman","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"77.9"},{"dims":{"COUNTRY":"Oman","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"20.0"},{"dims":{"COUNTRY":"Oman","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"18.7"},{"dims":{"COUNTRY":"Oman","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"21.4"},{"dims":{"COUNTRY":"Oman","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"75.2"},{"dims":{"COUNTRY":"Oman","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"73.3"},{"dims":{"COUNTRY":"Oman","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"77.7"},{"dims":{"COUNTRY":"Oman","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.8"},{"dims":{"COUNTRY":"Oman","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"18.5"},{"dims":{"COUNTRY":"Oman","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"21.2"},{"dims":{"COUNTRY":"Oman","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"74.9"},{"dims":{"COUNTRY":"Oman","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"72.9"},{"dims":{"COUNTRY":"Oman","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"77.3"},{"dims":{"COUNTRY":"Oman","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.6"},{"dims":{"COUNTRY":"Oman","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"18.3"},{"dims":{"COUNTRY":"Oman","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"20.9"},{"dims":{"COUNTRY":"Oman","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"74.7"},{"dims":{"COUNTRY":"Oman","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"72.8"},{"dims":{"COUNTRY":"Oman","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"77.1"},{"dims":{"COUNTRY":"Oman","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.5"},{"dims":{"COUNTRY":"Oman","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"18.2"},{"dims":{"COUNTRY":"Oman","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"20.8"},{"dims":{"COUNTRY":"Oman","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"74.3"},{"dims":{"COUNTRY":"Oman","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"72.4"},{"dims":{"COUNTRY":"Oman","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"76.8"},{"dims":{"COUNTRY":"Oman","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.3"},{"dims":{"COUNTRY":"Oman","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"18.1"},{"dims":{"COUNTRY":"Oman","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"20.6"},{"dims":{"COUNTRY":"Oman","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"74.0"},{"dims":{"COUNTRY":"Oman","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"72.1"},{"dims":{"COUNTRY":"Oman","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"76.4"},{"dims":{"COUNTRY":"Oman","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.1"},{"dims":{"COUNTRY":"Oman","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"18.0"},{"dims":{"COUNTRY":"Oman","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"20.4"},{"dims":{"COUNTRY":"Oman","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.6"},{"dims":{"COUNTRY":"Oman","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"71.7"},{"dims":{"COUNTRY":"Oman","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"76.0"},{"dims":{"COUNTRY":"Oman","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.0"},{"dims":{"COUNTRY":"Oman","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.8"},{"dims":{"COUNTRY":"Oman","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"20.1"},{"dims":{"COUNTRY":"Oman","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.3"},{"dims":{"COUNTRY":"Oman","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"71.4"},{"dims":{"COUNTRY":"Oman","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"75.6"},{"dims":{"COUNTRY":"Oman","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.8"},{"dims":{"COUNTRY":"Oman","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.7"},{"dims":{"COUNTRY":"Oman","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.9"},{"dims":{"COUNTRY":"Oman","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"72.9"},{"dims":{"COUNTRY":"Oman","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"71.1"},{"dims":{"COUNTRY":"Oman","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"75.3"},{"dims":{"COUNTRY":"Oman","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.7"},{"dims":{"COUNTRY":"Oman","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.6"},{"dims":{"COUNTRY":"Oman","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.8"},{"dims":{"COUNTRY":"Oman","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"72.6"},{"dims":{"COUNTRY":"Oman","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"70.7"},{"dims":{"COUNTRY":"Oman","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"74.9"},{"dims":{"COUNTRY":"Oman","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.5"},{"dims":{"COUNTRY":"Oman","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.4"},{"dims":{"COUNTRY":"Oman","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.6"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"66.4"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"65.5"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"67.5"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.8"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.6"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.0"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"66.2"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"65.2"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"67.2"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.8"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.6"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.0"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"66.0"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"65.1"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"67.0"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.8"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.6"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.0"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"65.7"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"64.8"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"66.7"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.8"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.5"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.0"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"65.5"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"64.6"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"66.5"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.7"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.5"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.0"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"65.1"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"64.1"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"66.1"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.7"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.4"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"17.9"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"64.8"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"63.9"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"65.9"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.6"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.4"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"17.9"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"64.6"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"63.7"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"65.7"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.6"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.3"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"17.9"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"64.4"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"63.5"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"65.4"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.5"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.3"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"17.9"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"64.2"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"63.3"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"65.2"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.5"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.2"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"17.8"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"62.9"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"61.9"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"64.0"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.2"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.8"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"17.6"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"63.7"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"62.9"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"64.6"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.4"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.1"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"17.8"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"63.5"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"62.7"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"64.4"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.4"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.0"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"17.8"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"63.2"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"62.4"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"64.1"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.4"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.0"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"17.8"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"63.0"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"62.2"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"63.9"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.4"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.0"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"17.8"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"62.8"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"62.0"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"63.6"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.3"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.0"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"17.7"},{"dims":{"COUNTRY":"Palau","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18"},{"dims":{"COUNTRY":"Palau","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17"},{"dims":{"COUNTRY":"Palau","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"20"},{"dims":{"COUNTRY":"Panama","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"77.8"},{"dims":{"COUNTRY":"Panama","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"74.7"},{"dims":{"COUNTRY":"Panama","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"81.1"},{"dims":{"COUNTRY":"Panama","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"24.1"},{"dims":{"COUNTRY":"Panama","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"22.5"},{"dims":{"COUNTRY":"Panama","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"25.7"},{"dims":{"COUNTRY":"Panama","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"77.6"},{"dims":{"COUNTRY":"Panama","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"74.6"},{"dims":{"COUNTRY":"Panama","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"80.9"},{"dims":{"COUNTRY":"Panama","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"24.0"},{"dims":{"COUNTRY":"Panama","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"22.4"},{"dims":{"COUNTRY":"Panama","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"25.6"},{"dims":{"COUNTRY":"Panama","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"77.5"},{"dims":{"COUNTRY":"Panama","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"74.7"},{"dims":{"COUNTRY":"Panama","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"80.4"},{"dims":{"COUNTRY":"Panama","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"23.8"},{"dims":{"COUNTRY":"Panama","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"22.4"},{"dims":{"COUNTRY":"Panama","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"25.3"},{"dims":{"COUNTRY":"Panama","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"77.2"},{"dims":{"COUNTRY":"Panama","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"74.2"},{"dims":{"COUNTRY":"Panama","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"80.5"},{"dims":{"COUNTRY":"Panama","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"23.7"},{"dims":{"COUNTRY":"Panama","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"22.2"},{"dims":{"COUNTRY":"Panama","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"25.2"},{"dims":{"COUNTRY":"Panama","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"77.3"},{"dims":{"COUNTRY":"Panama","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"74.3"},{"dims":{"COUNTRY":"Panama","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"80.4"},{"dims":{"COUNTRY":"Panama","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"23.8"},{"dims":{"COUNTRY":"Panama","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"22.3"},{"dims":{"COUNTRY":"Panama","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"25.3"},{"dims":{"COUNTRY":"Panama","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"76.5"},{"dims":{"COUNTRY":"Panama","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"73.5"},{"dims":{"COUNTRY":"Panama","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"79.8"},{"dims":{"COUNTRY":"Panama","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"23.1"},{"dims":{"COUNTRY":"Panama","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"21.6"},{"dims":{"COUNTRY":"Panama","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.7"},{"dims":{"COUNTRY":"Panama","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"76.8"},{"dims":{"COUNTRY":"Panama","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"73.7"},{"dims":{"COUNTRY":"Panama","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"80.1"},{"dims":{"COUNTRY":"Panama","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"23.6"},{"dims":{"COUNTRY":"Panama","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"22.2"},{"dims":{"COUNTRY":"Panama","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"25.1"},{"dims":{"COUNTRY":"Panama","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"76.5"},{"dims":{"COUNTRY":"Panama","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"73.6"},{"dims":{"COUNTRY":"Panama","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"79.6"},{"dims":{"COUNTRY":"Panama","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"23.4"},{"dims":{"COUNTRY":"Panama","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"22.0"},{"dims":{"COUNTRY":"Panama","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.7"},{"dims":{"COUNTRY":"Panama","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"76.4"},{"dims":{"COUNTRY":"Panama","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"73.7"},{"dims":{"COUNTRY":"Panama","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"79.4"},{"dims":{"COUNTRY":"Panama","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"23.2"},{"dims":{"COUNTRY":"Panama","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"21.7"},{"dims":{"COUNTRY":"Panama","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.6"},{"dims":{"COUNTRY":"Panama","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"76.2"},{"dims":{"COUNTRY":"Panama","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"73.6"},{"dims":{"COUNTRY":"Panama","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"78.9"},{"dims":{"COUNTRY":"Panama","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"22.9"},{"dims":{"COUNTRY":"Panama","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"21.6"},{"dims":{"COUNTRY":"Panama","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.1"},{"dims":{"COUNTRY":"Panama","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"75.8"},{"dims":{"COUNTRY":"Panama","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"73.4"},{"dims":{"COUNTRY":"Panama","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"78.2"},{"dims":{"COUNTRY":"Panama","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"22.3"},{"dims":{"COUNTRY":"Panama","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"21.4"},{"dims":{"COUNTRY":"Panama","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"23.3"},{"dims":{"COUNTRY":"Panama","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"75.8"},{"dims":{"COUNTRY":"Panama","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"73.4"},{"dims":{"COUNTRY":"Panama","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"78.4"},{"dims":{"COUNTRY":"Panama","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"22.5"},{"dims":{"COUNTRY":"Panama","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"21.3"},{"dims":{"COUNTRY":"Panama","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"23.6"},{"dims":{"COUNTRY":"Panama","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"75.5"},{"dims":{"COUNTRY":"Panama","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"72.9"},{"dims":{"COUNTRY":"Panama","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"78.3"},{"dims":{"COUNTRY":"Panama","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"22.4"},{"dims":{"COUNTRY":"Panama","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"21.1"},{"dims":{"COUNTRY":"Panama","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"23.7"},{"dims":{"COUNTRY":"Panama","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"75.7"},{"dims":{"COUNTRY":"Panama","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"73.3"},{"dims":{"COUNTRY":"Panama","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"78.4"},{"dims":{"COUNTRY":"Panama","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"22.6"},{"dims":{"COUNTRY":"Panama","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"21.5"},{"dims":{"COUNTRY":"Panama","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"23.7"},{"dims":{"COUNTRY":"Panama","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"75.5"},{"dims":{"COUNTRY":"Panama","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"73.0"},{"dims":{"COUNTRY":"Panama","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"78.3"},{"dims":{"COUNTRY":"Panama","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"22.4"},{"dims":{"COUNTRY":"Panama","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"21.2"},{"dims":{"COUNTRY":"Panama","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"23.6"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"70.3"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"64.5"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"76.1"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.5"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.0"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"21.1"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"70.0"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"64.2"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"75.9"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.3"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.9"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"20.9"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"69.6"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"63.7"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"75.6"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.2"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.8"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"20.7"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"69.4"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"63.5"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"75.4"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.2"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.8"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"20.7"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"68.4"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"62.4"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"74.6"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.5"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.1"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"20.0"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"68.2"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"62.2"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"74.5"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.5"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.1"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"20.1"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"67.5"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"61.3"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"74.0"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.3"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.0"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.8"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"67.3"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"61.1"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"73.8"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.4"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.1"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.8"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"66.4"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"60.2"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"73.1"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.0"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"13.9"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.4"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"65.0"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"58.6"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"72.1"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.4"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"13.1"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.9"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"64.9"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"58.6"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"72.0"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.2"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"12.9"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.7"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"64.6"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"58.3"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"71.7"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.8"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"12.5"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.4"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"64.8"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"58.5"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"71.8"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.9"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"12.6"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.4"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"65.1"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"58.8"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"72.0"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.2"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"13.0"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.7"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"65.0"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"58.7"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"72.0"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.3"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"13.1"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.6"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"66.1"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"60.9"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"71.1"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.0"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.0"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.7"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"65.7"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"60.5"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"70.8"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.0"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.0"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.6"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"65.2"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"60.0"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"70.3"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.9"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.9"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.6"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"64.6"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"59.4"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"69.8"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.8"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.8"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.5"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"63.8"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"58.5"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"69.1"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.7"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.7"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.4"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"62.8"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"57.5"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"68.1"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.6"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.6"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.3"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"61.0"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"55.4"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"66.7"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.4"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.3"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.2"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"60.8"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"55.4"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"66.2"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.3"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.3"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.1"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"59.6"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"54.1"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"65.1"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.1"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.1"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.0"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"57.6"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"52.3"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"63.1"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.9"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.9"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.8"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"55.3"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"50.2"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"60.6"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.7"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.6"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.6"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"53.4"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"48.4"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"58.6"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.4"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.4"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.4"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"52.0"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"47.0"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"57.3"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.3"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.2"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.3"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"50.7"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"45.7"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"56.0"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.1"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.0"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.2"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"48.6"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"43.4"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"54.4"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.9"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"13.8"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.1"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"48.3"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"43.3"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"53.8"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.8"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"13.7"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.0"},{"dims":{"COUNTRY":"Saint Kitts and Nevis","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19"},{"dims":{"COUNTRY":"Saint Kitts and Nevis","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17"},{"dims":{"COUNTRY":"Saint Kitts and Nevis","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"21"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"75.2"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"72.6"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"77.9"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"21.3"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.4"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"23.1"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"75.0"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"72.4"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"77.7"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"21.2"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.3"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"23.0"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"74.8"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"72.2"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"77.5"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"21.1"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.2"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"22.9"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"74.7"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"72.2"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"77.4"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"21.0"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.2"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"22.9"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"74.6"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"72.0"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"77.3"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"20.9"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.1"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"22.8"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"74.2"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"71.6"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"76.9"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"20.8"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.0"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"22.7"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"74.3"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"71.7"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"77.0"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"20.8"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.0"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"22.6"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"74.1"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"71.6"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"76.8"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"20.7"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"18.9"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"22.5"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.9"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"71.4"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"76.5"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"20.5"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"18.8"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"22.3"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.5"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"71.1"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"76.0"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"20.3"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"18.6"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"22.0"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.1"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"70.8"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"75.3"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"20.0"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"18.4"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"21.5"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"72.6"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"70.6"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"74.7"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.7"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"18.3"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"21.1"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"72.2"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"70.3"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"74.2"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.5"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"18.1"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"20.8"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"72.0"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"70.1"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"73.9"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.3"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"18.0"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"20.6"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"71.8"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"69.9"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"73.7"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.3"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.9"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"20.5"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"71.6"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"69.6"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"73.5"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.2"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.9"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"20.5"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.2"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"71.3"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"75.2"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"20.1"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.1"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"21.0"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.1"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"71.2"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"75.1"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"20.0"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.0"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"21.0"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"72.7"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"70.8"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"74.7"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.9"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"18.9"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"20.8"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"72.8"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"71.0"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"74.8"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.9"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"18.9"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"20.8"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"72.7"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"70.8"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"74.6"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.8"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"18.9"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"20.7"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"72.5"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"70.7"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"74.4"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.7"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"18.8"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"20.6"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"72.3"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"70.5"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"74.2"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.6"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"18.7"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"20.4"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"72.1"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"70.3"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"74.0"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.5"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"18.6"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"20.3"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"71.9"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"70.1"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"73.9"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.4"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"18.5"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"20.3"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"71.7"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"69.8"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"73.7"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.3"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"18.3"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"20.2"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"71.4"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"69.4"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"73.6"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.2"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"18.1"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"20.2"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"71.2"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"69.1"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"73.5"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.0"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.9"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"20.1"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"71.0"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"68.8"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"73.4"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.0"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.8"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"20.1"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"70.9"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"68.7"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"73.2"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.9"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.7"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"20.0"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"70.9"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"68.8"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"73.2"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.9"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.8"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"20.0"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"70.9"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"68.9"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"73.1"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.9"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.8"},{"dims":{"COUNTRY":"Saint Vincent and the Grenadines","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.9"},{"dims":{"COUNTRY":"Samoa","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"74.0"},{"dims":{"COUNTRY":"Samoa","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"70.9"},{"dims":{"COUNTRY":"Samoa","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"77.5"},{"dims":{"COUNTRY":"Samoa","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.2"},{"dims":{"COUNTRY":"Samoa","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.7"},{"dims":{"COUNTRY":"Samoa","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"21.8"},{"dims":{"COUNTRY":"Samoa","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.8"},{"dims":{"COUNTRY":"Samoa","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"70.7"},{"dims":{"COUNTRY":"Samoa","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"77.3"},{"dims":{"COUNTRY":"Samoa","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.1"},{"dims":{"COUNTRY":"Samoa","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.6"},{"dims":{"COUNTRY":"Samoa","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"21.7"},{"dims":{"COUNTRY":"Samoa","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.6"},{"dims":{"COUNTRY":"Samoa","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"70.5"},{"dims":{"COUNTRY":"Samoa","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"77.1"},{"dims":{"COUNTRY":"Samoa","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"19.0"},{"dims":{"COUNTRY":"Samoa","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.5"},{"dims":{"COUNTRY":"Samoa","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"21.5"},{"dims":{"COUNTRY":"Samoa","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.2"},{"dims":{"COUNTRY":"Samoa","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"70.1"},{"dims":{"COUNTRY":"Samoa","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"76.7"},{"dims":{"COUNTRY":"Samoa","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.8"},{"dims":{"COUNTRY":"Samoa","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.3"},{"dims":{"COUNTRY":"Samoa","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"21.4"},{"dims":{"COUNTRY":"Samoa","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.0"},{"dims":{"COUNTRY":"Samoa","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"69.9"},{"dims":{"COUNTRY":"Samoa","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"76.5"},{"dims":{"COUNTRY":"Samoa","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.6"},{"dims":{"COUNTRY":"Samoa","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.2"},{"dims":{"COUNTRY":"Samoa","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"21.2"},{"dims":{"COUNTRY":"Samoa","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"72.6"},{"dims":{"COUNTRY":"Samoa","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"69.6"},{"dims":{"COUNTRY":"Samoa","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"76.1"},{"dims":{"COUNTRY":"Samoa","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.5"},{"dims":{"COUNTRY":"Samoa","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.1"},{"dims":{"COUNTRY":"Samoa","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"21.0"},{"dims":{"COUNTRY":"Samoa","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"70.6"},{"dims":{"COUNTRY":"Samoa","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"67.5"},{"dims":{"COUNTRY":"Samoa","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"74.2"},{"dims":{"COUNTRY":"Samoa","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.9"},{"dims":{"COUNTRY":"Samoa","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.5"},{"dims":{"COUNTRY":"Samoa","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"20.4"},{"dims":{"COUNTRY":"Samoa","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"72.5"},{"dims":{"COUNTRY":"Samoa","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"69.5"},{"dims":{"COUNTRY":"Samoa","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"75.9"},{"dims":{"COUNTRY":"Samoa","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.2"},{"dims":{"COUNTRY":"Samoa","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.9"},{"dims":{"COUNTRY":"Samoa","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"20.7"},{"dims":{"COUNTRY":"Samoa","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"72.2"},{"dims":{"COUNTRY":"Samoa","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"69.2"},{"dims":{"COUNTRY":"Samoa","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"75.6"},{"dims":{"COUNTRY":"Samoa","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.1"},{"dims":{"COUNTRY":"Samoa","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.8"},{"dims":{"COUNTRY":"Samoa","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"20.5"},{"dims":{"COUNTRY":"Samoa","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"72.0"},{"dims":{"COUNTRY":"Samoa","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"69.0"},{"dims":{"COUNTRY":"Samoa","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"75.4"},{"dims":{"COUNTRY":"Samoa","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.9"},{"dims":{"COUNTRY":"Samoa","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.7"},{"dims":{"COUNTRY":"Samoa","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"20.4"},{"dims":{"COUNTRY":"Samoa","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"71.6"},{"dims":{"COUNTRY":"Samoa","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"68.6"},{"dims":{"COUNTRY":"Samoa","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"75.0"},{"dims":{"COUNTRY":"Samoa","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.8"},{"dims":{"COUNTRY":"Samoa","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.5"},{"dims":{"COUNTRY":"Samoa","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"20.2"},{"dims":{"COUNTRY":"Samoa","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"71.4"},{"dims":{"COUNTRY":"Samoa","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"68.4"},{"dims":{"COUNTRY":"Samoa","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"74.9"},{"dims":{"COUNTRY":"Samoa","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.7"},{"dims":{"COUNTRY":"Samoa","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.4"},{"dims":{"COUNTRY":"Samoa","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"20.1"},{"dims":{"COUNTRY":"Samoa","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"70.9"},{"dims":{"COUNTRY":"Samoa","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"67.9"},{"dims":{"COUNTRY":"Samoa","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"74.4"},{"dims":{"COUNTRY":"Samoa","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.5"},{"dims":{"COUNTRY":"Samoa","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.3"},{"dims":{"COUNTRY":"Samoa","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.9"},{"dims":{"COUNTRY":"Samoa","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"70.6"},{"dims":{"COUNTRY":"Samoa","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"67.6"},{"dims":{"COUNTRY":"Samoa","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"74.1"},{"dims":{"COUNTRY":"Samoa","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.4"},{"dims":{"COUNTRY":"Samoa","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.2"},{"dims":{"COUNTRY":"Samoa","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.8"},{"dims":{"COUNTRY":"Samoa","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"70.5"},{"dims":{"COUNTRY":"Samoa","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"67.5"},{"dims":{"COUNTRY":"Samoa","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"74.0"},{"dims":{"COUNTRY":"Samoa","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.3"},{"dims":{"COUNTRY":"Samoa","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.1"},{"dims":{"COUNTRY":"Samoa","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.7"},{"dims":{"COUNTRY":"Samoa","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"70.2"},{"dims":{"COUNTRY":"Samoa","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"67.2"},{"dims":{"COUNTRY":"Samoa","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"73.7"},{"dims":{"COUNTRY":"Samoa","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.1"},{"dims":{"COUNTRY":"Samoa","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.0"},{"dims":{"COUNTRY":"Samoa","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.5"},{"dims":{"COUNTRY":"San Marino","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"25"},{"dims":{"COUNTRY":"San Marino","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"25"},{"dims":{"COUNTRY":"San Marino","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"26"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"67.5"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"65.6"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"69.4"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.3"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.6"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.9"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"67.3"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"65.5"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"69.2"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.3"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.5"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.9"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"67.1"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"65.3"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"69.0"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.2"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.5"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.8"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"66.9"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"65.1"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"68.7"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.2"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.5"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.8"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"66.6"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"64.7"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"68.4"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.2"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.5"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.8"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"66.2"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"64.3"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"68.1"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.2"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.4"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.8"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"65.8"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"63.8"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"67.8"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.1"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.4"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.7"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"65.4"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"63.4"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"67.4"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.1"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.4"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.7"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"65.1"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"63.1"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"67.1"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.1"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.4"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.7"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"64.7"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"62.7"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"66.7"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.0"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.3"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.6"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"64.3"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"62.3"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"66.2"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.9"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.2"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.5"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"63.8"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"61.9"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"65.7"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.8"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.1"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.4"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"63.4"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"61.6"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"65.3"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.7"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.1"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.3"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"63.1"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"61.2"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"64.9"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.7"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.0"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.3"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"62.8"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"61.0"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"64.7"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.6"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.0"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.2"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"62.6"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"60.8"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"64.4"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.6"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.0"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.2"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"74.5"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"73.2"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"76.0"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.7"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.6"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.9"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"74.4"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"73.1"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"75.9"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.6"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.6"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.8"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"74.3"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"72.9"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"75.7"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.6"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.5"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.7"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"74.1"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"72.8"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"75.5"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.5"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.4"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.6"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.9"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"72.6"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"75.3"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.4"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.3"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.5"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.7"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"72.4"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"75.1"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.3"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.2"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.4"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.4"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"72.1"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"74.8"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.2"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.1"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.3"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.3"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"72.0"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"74.7"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.1"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.1"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.3"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.2"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"71.9"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"74.6"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.1"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.1"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.3"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.2"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"71.8"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"74.6"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.1"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.1"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.3"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.1"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"71.8"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"74.6"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.1"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.1"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.3"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.1"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"71.7"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"74.6"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.1"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.1"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.4"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.0"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"71.6"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"74.6"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.2"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.1"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.4"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"72.9"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"71.5"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"74.6"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.2"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.1"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.4"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"72.8"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"71.3"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"74.5"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.1"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.0"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.4"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"72.6"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"71.0"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"74.4"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.1"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.9"},{"dims":{"COUNTRY":"Saudi Arabia","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.4"},{"dims":{"COUNTRY":"Senegal","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"66.7"},{"dims":{"COUNTRY":"Senegal","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"64.6"},{"dims":{"COUNTRY":"Senegal","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"68.6"},{"dims":{"COUNTRY":"Senegal","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.8"},{"dims":{"COUNTRY":"Senegal","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.8"},{"dims":{"COUNTRY":"Senegal","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"17.6"},{"dims":{"COUNTRY":"Senegal","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"66.4"},{"dims":{"COUNTRY":"Senegal","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"64.3"},{"dims":{"COUNTRY":"Senegal","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"68.3"},{"dims":{"COUNTRY":"Senegal","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.7"},{"dims":{"COUNTRY":"Senegal","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.8"},{"dims":{"COUNTRY":"Senegal","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"17.6"},{"dims":{"COUNTRY":"Senegal","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"66.0"},{"dims":{"COUNTRY":"Senegal","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"64.0"},{"dims":{"COUNTRY":"Senegal","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"67.9"},{"dims":{"COUNTRY":"Senegal","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.7"},{"dims":{"COUNTRY":"Senegal","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.7"},{"dims":{"COUNTRY":"Senegal","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"17.5"},{"dims":{"COUNTRY":"Senegal","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"65.6"},{"dims":{"COUNTRY":"Senegal","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"63.6"},{"dims":{"COUNTRY":"Senegal","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"67.4"},{"dims":{"COUNTRY":"Senegal","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.6"},{"dims":{"COUNTRY":"Senegal","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.7"},{"dims":{"COUNTRY":"Senegal","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"17.4"},{"dims":{"COUNTRY":"Senegal","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"64.9"},{"dims":{"COUNTRY":"Senegal","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"63.1"},{"dims":{"COUNTRY":"Senegal","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"66.7"},{"dims":{"COUNTRY":"Senegal","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.5"},{"dims":{"COUNTRY":"Senegal","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.6"},{"dims":{"COUNTRY":"Senegal","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"17.3"},{"dims":{"COUNTRY":"Senegal","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"64.3"},{"dims":{"COUNTRY":"Senegal","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"62.6"},{"dims":{"COUNTRY":"Senegal","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"65.8"},{"dims":{"COUNTRY":"Senegal","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.4"},{"dims":{"COUNTRY":"Senegal","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.6"},{"dims":{"COUNTRY":"Senegal","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"17.1"},{"dims":{"COUNTRY":"Senegal","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"63.5"},{"dims":{"COUNTRY":"Senegal","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"62.0"},{"dims":{"COUNTRY":"Senegal","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"64.9"},{"dims":{"COUNTRY":"Senegal","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.2"},{"dims":{"COUNTRY":"Senegal","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.5"},{"dims":{"COUNTRY":"Senegal","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.9"},{"dims":{"COUNTRY":"Senegal","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"62.8"},{"dims":{"COUNTRY":"Senegal","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"61.4"},{"dims":{"COUNTRY":"Senegal","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"64.0"},{"dims":{"COUNTRY":"Senegal","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.1"},{"dims":{"COUNTRY":"Senegal","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.4"},{"dims":{"COUNTRY":"Senegal","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.7"},{"dims":{"COUNTRY":"Senegal","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"62.1"},{"dims":{"COUNTRY":"Senegal","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"60.7"},{"dims":{"COUNTRY":"Senegal","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"63.3"},{"dims":{"COUNTRY":"Senegal","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.0"},{"dims":{"COUNTRY":"Senegal","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.3"},{"dims":{"COUNTRY":"Senegal","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.6"},{"dims":{"COUNTRY":"Senegal","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"61.3"},{"dims":{"COUNTRY":"Senegal","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"59.9"},{"dims":{"COUNTRY":"Swaziland","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"50.0"},{"dims":{"COUNTRY":"Swaziland","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"48.7"},{"dims":{"COUNTRY":"Swaziland","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"51.2"},{"dims":{"COUNTRY":"Swaziland","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.3"},{"dims":{"COUNTRY":"Swaziland","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.3"},{"dims":{"COUNTRY":"Swaziland","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.2"},{"dims":{"COUNTRY":"Swaziland","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"47.8"},{"dims":{"COUNTRY":"Swaziland","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"46.9"},{"dims":{"COUNTRY":"Swaziland","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"48.6"},{"dims":{"COUNTRY":"Swaziland","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.0"},{"dims":{"COUNTRY":"Swaziland","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.0"},{"dims":{"COUNTRY":"Swaziland","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.9"},{"dims":{"COUNTRY":"Swaziland","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"46.0"},{"dims":{"COUNTRY":"Swaziland","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"45.2"},{"dims":{"COUNTRY":"Swaziland","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"46.7"},{"dims":{"COUNTRY":"Swaziland","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"14.8"},{"dims":{"COUNTRY":"Swaziland","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"13.8"},{"dims":{"COUNTRY":"Swaziland","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.7"},{"dims":{"COUNTRY":"Swaziland","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"45.6"},{"dims":{"COUNTRY":"Swaziland","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"44.8"},{"dims":{"COUNTRY":"Swaziland","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"46.4"},{"dims":{"COUNTRY":"Swaziland","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"14.7"},{"dims":{"COUNTRY":"Swaziland","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"13.7"},{"dims":{"COUNTRY":"Swaziland","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.6"},{"dims":{"COUNTRY":"Swaziland","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"45.9"},{"dims":{"COUNTRY":"Swaziland","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"44.9"},{"dims":{"COUNTRY":"Swaziland","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"46.8"},{"dims":{"COUNTRY":"Swaziland","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"14.7"},{"dims":{"COUNTRY":"Swaziland","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"13.7"},{"dims":{"COUNTRY":"Swaziland","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.6"},{"dims":{"COUNTRY":"Swaziland","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"46.4"},{"dims":{"COUNTRY":"Swaziland","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"45.3"},{"dims":{"COUNTRY":"Swaziland","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"47.5"},{"dims":{"COUNTRY":"Swaziland","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"14.7"},{"dims":{"COUNTRY":"Swaziland","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"13.8"},{"dims":{"COUNTRY":"Swaziland","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.6"},{"dims":{"COUNTRY":"Swaziland","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"47.1"},{"dims":{"COUNTRY":"Swaziland","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"45.9"},{"dims":{"COUNTRY":"Swaziland","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"48.4"},{"dims":{"COUNTRY":"Swaziland","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"14.8"},{"dims":{"COUNTRY":"Swaziland","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"13.8"},{"dims":{"COUNTRY":"Swaziland","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.7"},{"dims":{"COUNTRY":"Swaziland","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"48.4"},{"dims":{"COUNTRY":"Swaziland","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"47.0"},{"dims":{"COUNTRY":"Swaziland","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"49.8"},{"dims":{"COUNTRY":"Swaziland","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"14.9"},{"dims":{"COUNTRY":"Swaziland","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"13.9"},{"dims":{"COUNTRY":"Swaziland","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.8"},{"dims":{"COUNTRY":"Sweden","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"82.4"},{"dims":{"COUNTRY":"Sweden","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"80.7"},{"dims":{"COUNTRY":"Sweden","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"84.0"},{"dims":{"COUNTRY":"Sweden","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"24.6"},{"dims":{"COUNTRY":"Sweden","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"23.3"},{"dims":{"COUNTRY":"Sweden","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"25.8"},{"dims":{"COUNTRY":"Sweden","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"82.3"},{"dims":{"COUNTRY":"Sweden","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"80.6"},{"dims":{"COUNTRY":"Sweden","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"84.1"},{"dims":{"COUNTRY":"Sweden","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"24.6"},{"dims":{"COUNTRY":"Sweden","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"23.2"},{"dims":{"COUNTRY":"Sweden","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"25.9"},{"dims":{"COUNTRY":"Sweden","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"81.9"},{"dims":{"COUNTRY":"Sweden","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"80.2"},{"dims":{"COUNTRY":"Sweden","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"83.7"},{"dims":{"COUNTRY":"Sweden","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"24.3"},{"dims":{"COUNTRY":"Sweden","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"22.9"},{"dims":{"COUNTRY":"Sweden","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"25.5"},{"dims":{"COUNTRY":"Sweden","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"81.7"},{"dims":{"COUNTRY":"Sweden","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"80.0"},{"dims":{"COUNTRY":"Sweden","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"83.5"},{"dims":{"COUNTRY":"Sweden","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"24.1"},{"dims":{"COUNTRY":"Sweden","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"22.7"},{"dims":{"COUNTRY":"Sweden","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"25.4"},{"dims":{"COUNTRY":"Sweden","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"81.7"},{"dims":{"COUNTRY":"Sweden","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"79.8"},{"dims":{"COUNTRY":"Sweden","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"83.6"},{"dims":{"COUNTRY":"Sweden","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"24.1"},{"dims":{"COUNTRY":"Sweden","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"22.6"},{"dims":{"COUNTRY":"Sweden","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"25.5"},{"dims":{"COUNTRY":"Sweden","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"81.5"},{"dims":{"COUNTRY":"Sweden","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"79.5"},{"dims":{"COUNTRY":"Sweden","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"83.5"},{"dims":{"COUNTRY":"Sweden","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"23.9"},{"dims":{"COUNTRY":"Sweden","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"22.3"},{"dims":{"COUNTRY":"Sweden","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"25.3"},{"dims":{"COUNTRY":"Sweden","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"81.4"},{"dims":{"COUNTRY":"Sweden","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"79.3"},{"dims":{"COUNTRY":"Sweden","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"83.4"},{"dims":{"COUNTRY":"Sweden","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"23.9"},{"dims":{"COUNTRY":"Sweden","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"22.3"},{"dims":{"COUNTRY":"Sweden","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"25.4"},{"dims":{"COUNTRY":"Sweden","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"81.1"},{"dims":{"COUNTRY":"Sweden","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"79.0"},{"dims":{"COUNTRY":"Sweden","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"83.2"},{"dims":{"COUNTRY":"Sweden","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"23.7"},{"dims":{"COUNTRY":"Sweden","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"22.0"},{"dims":{"COUNTRY":"Sweden","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"25.2"},{"dims":{"COUNTRY":"Sweden","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"80.9"},{"dims":{"COUNTRY":"Sweden","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"78.9"},{"dims":{"COUNTRY":"Sweden","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"83.0"},{"dims":{"COUNTRY":"Sweden","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"23.5"},{"dims":{"COUNTRY":"Sweden","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"21.9"},{"dims":{"COUNTRY":"Sweden","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"25.0"},{"dims":{"COUNTRY":"Sweden","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"80.8"},{"dims":{"COUNTRY":"Sweden","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"78.6"},{"dims":{"COUNTRY":"Sweden","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"82.9"},{"dims":{"COUNTRY":"Sweden","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"23.4"},{"dims":{"COUNTRY":"Sweden","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"21.6"},{"dims":{"COUNTRY":"Sweden","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"25.0"},{"dims":{"COUNTRY":"Sweden","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"80.5"},{"dims":{"COUNTRY":"Sweden","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"78.3"},{"dims":{"COUNTRY":"Sweden","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"82.7"},{"dims":{"COUNTRY":"Sweden","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"23.2"},{"dims":{"COUNTRY":"Sweden","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"21.4"},{"dims":{"COUNTRY":"Sweden","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.8"},{"dims":{"COUNTRY":"Sweden","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"80.3"},{"dims":{"COUNTRY":"Sweden","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"78.1"},{"dims":{"COUNTRY":"Sweden","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"82.5"},{"dims":{"COUNTRY":"Sweden","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"23.2"},{"dims":{"COUNTRY":"Sweden","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"21.4"},{"dims":{"COUNTRY":"Sweden","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.8"},{"dims":{"COUNTRY":"Sweden","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"80.2"},{"dims":{"COUNTRY":"Sweden","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"77.9"},{"dims":{"COUNTRY":"Sweden","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"82.4"},{"dims":{"COUNTRY":"Sweden","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"22.9"},{"dims":{"COUNTRY":"Sweden","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"21.1"},{"dims":{"COUNTRY":"Sweden","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.6"},{"dims":{"COUNTRY":"Sweden","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"79.9"},{"dims":{"COUNTRY":"Sweden","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"77.7"},{"dims":{"COUNTRY":"Sweden","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"82.1"},{"dims":{"COUNTRY":"Sweden","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"22.7"},{"dims":{"COUNTRY":"Sweden","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"20.9"},{"dims":{"COUNTRY":"Sweden","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.3"},{"dims":{"COUNTRY":"Sweden","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"79.8"},{"dims":{"COUNTRY":"Sweden","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"77.5"},{"dims":{"COUNTRY":"Sweden","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"82.1"},{"dims":{"COUNTRY":"Sweden","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"22.7"},{"dims":{"COUNTRY":"Sweden","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"20.8"},{"dims":{"COUNTRY":"Sweden","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.4"},{"dims":{"COUNTRY":"Sweden","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"79.6"},{"dims":{"COUNTRY":"Sweden","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"77.3"},{"dims":{"COUNTRY":"Sweden","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"81.9"},{"dims":{"COUNTRY":"Sweden","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"22.5"},{"dims":{"COUNTRY":"Sweden","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"20.6"},{"dims":{"COUNTRY":"Sweden","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.3"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"83.4"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"81.3"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"85.3"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"25.5"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"23.9"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"27.0"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"83.2"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"81.1"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"85.1"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"25.4"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"23.7"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"26.9"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"83.0"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"80.8"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"85.0"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"25.3"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"23.5"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"26.8"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"82.7"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"80.5"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"84.7"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"25.0"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"23.3"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"26.5"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"82.6"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"80.3"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"84.8"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"25.1"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"23.2"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"26.7"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"82.3"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"80.0"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"84.5"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"24.8"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"22.9"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"26.5"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"82.1"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"79.6"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"84.3"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"24.7"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"22.8"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"26.3"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"82.0"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"79.5"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"84.3"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"24.6"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"22.7"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"26.3"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"81.7"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"79.2"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"84.0"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"24.4"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"22.4"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"26.2"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"81.5"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"78.9"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"83.9"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"24.3"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"22.3"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"26.1"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"81.1"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"78.5"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"83.6"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"24.0"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"21.9"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"25.8"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"81.0"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"78.4"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"83.5"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"24.0"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"21.9"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"25.8"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"80.5"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"77.8"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"83.0"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"23.5"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"21.4"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"25.3"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"80.4"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"77.6"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"82.9"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"23.5"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"21.4"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"25.4"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"80.2"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"77.3"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"82.9"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"23.4"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"21.1"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"25.3"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"79.7"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"76.8"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"82.5"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"23.1"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"20.8"},{"dims":{"COUNTRY":"Switzerland","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"25.0"},{"dims":{"COUNTRY":"Syrian Arab Republic","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"64.5"},{"dims":{"COUNTRY":"Syrian Arab Republic","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"59.9"},{"dims":{"COUNTRY":"Syrian Arab Republic","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"69.9"},{"dims":{"COUNTRY":"Syrian Arab Republic","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.1"},{"dims":{"COUNTRY":"Syrian Arab Republic","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.7"},{"dims":{"COUNTRY":"Syrian Arab Republic","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.5"},{"dims":{"COUNTRY":"Syrian Arab Republic","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"64.4"},{"dims":{"COUNTRY":"Syrian Arab Republic","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"59.9"},{"dims":{"COUNTRY":"Syrian Arab Republic","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"69.7"},{"dims":{"COUNTRY":"Syrian Arab Republic","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.1"},{"dims":{"COUNTRY":"Syrian Arab Republic","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.9"},{"dims":{"COUNTRY":"Syrian Arab Republic","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.5"},{"dims":{"COUNTRY":"Syrian Arab Republic","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"63.6"},{"dims":{"COUNTRY":"Syrian Arab Republic","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"59.0"},{"dims":{"COUNTRY":"Syrian Arab Republic","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"69.1"},{"dims":{"COUNTRY":"Syrian Arab Republic","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.1"},{"dims":{"COUNTRY":"Syrian Arab Republic","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.0"},{"dims":{"COUNTRY":"Syrian Arab Republic","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.4"},{"dims":{"COUNTRY":"Syrian Arab Republic","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"62.8"},{"dims":{"COUNTRY":"Syrian Arab Republic","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"58.0"},{"dims":{"COUNTRY":"Syrian Arab Republic","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"68.4"},{"dims":{"COUNTRY":"Syrian Arab Republic","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.1"},{"dims":{"COUNTRY":"Syrian Arab Republic","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.0"},{"dims":{"COUNTRY":"Syrian Arab Republic","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.3"},{"dims":{"COUNTRY":"Syrian Arab Republic","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"71.7"},{"dims":{"COUNTRY":"Syrian Arab Republic","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"69.3"},{"dims":{"COUNTRY":"Syrian Arab Republic","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"74.4"},{"dims":{"COUNTRY":"Syrian Arab Republic","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.8"},{"dims":{"COUNTRY":"Syrian Arab Republic","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.9"},{"dims":{"COUNTRY":"Syrian Arab Republic","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.8"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"55.8"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"57.9"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.8"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.2"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.5"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"56.2"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"55.2"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"57.2"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.7"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.1"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.4"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"54.5"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"53.7"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"55.3"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.5"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.9"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.2"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"53.1"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"52.4"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"53.8"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.4"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.8"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.0"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"52.2"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"51.6"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"52.9"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.3"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.7"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.9"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"51.5"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"50.8"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"52.2"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.2"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.6"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.8"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"50.8"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"50.1"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"51.5"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.1"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.5"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.6"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"50.2"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"49.5"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"50.9"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"15.0"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.4"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.6"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"49.6"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"48.9"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"50.4"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"14.9"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.3"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.5"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"49.2"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"48.4"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"50.0"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"14.9"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"14.2"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"15.4"},{"dims":{"COUNTRY":"United States of America","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"79.3"},{"dims":{"COUNTRY":"United States of America","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"76.9"},{"dims":{"COUNTRY":"United States of America","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"81.6"},{"dims":{"COUNTRY":"United States of America","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"23.6"},{"dims":{"COUNTRY":"United States of America","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"22.1"},{"dims":{"COUNTRY":"United States of America","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"25.0"},{"dims":{"COUNTRY":"United States of America","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"79.1"},{"dims":{"COUNTRY":"United States of America","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"76.8"},{"dims":{"COUNTRY":"United States of America","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"81.5"},{"dims":{"COUNTRY":"United States of America","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"23.5"},{"dims":{"COUNTRY":"United States of America","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"22.0"},{"dims":{"COUNTRY":"United States of America","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.9"},{"dims":{"COUNTRY":"United States of America","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"78.9"},{"dims":{"COUNTRY":"United States of America","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"76.5"},{"dims":{"COUNTRY":"United States of America","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"81.2"},{"dims":{"COUNTRY":"United States of America","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"23.3"},{"dims":{"COUNTRY":"United States of America","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"21.7"},{"dims":{"COUNTRY":"United States of America","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.7"},{"dims":{"COUNTRY":"United States of America","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"78.8"},{"dims":{"COUNTRY":"United States of America","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"76.4"},{"dims":{"COUNTRY":"United States of America","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"81.2"},{"dims":{"COUNTRY":"United States of America","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"23.3"},{"dims":{"COUNTRY":"United States of America","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"21.7"},{"dims":{"COUNTRY":"United States of America","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.7"},{"dims":{"COUNTRY":"United States of America","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"78.7"},{"dims":{"COUNTRY":"United States of America","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"76.3"},{"dims":{"COUNTRY":"United States of America","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"81.1"},{"dims":{"COUNTRY":"United States of America","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"23.2"},{"dims":{"COUNTRY":"United States of America","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"21.6"},{"dims":{"COUNTRY":"United States of America","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.6"},{"dims":{"COUNTRY":"United States of America","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"78.7"},{"dims":{"COUNTRY":"United States of America","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"76.2"},{"dims":{"COUNTRY":"United States of America","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"81.1"},{"dims":{"COUNTRY":"United States of America","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"23.1"},{"dims":{"COUNTRY":"United States of America","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"21.5"},{"dims":{"COUNTRY":"United States of America","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.5"},{"dims":{"COUNTRY":"United States of America","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"78.5"},{"dims":{"COUNTRY":"United States of America","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"76.0"},{"dims":{"COUNTRY":"United States of America","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"80.9"},{"dims":{"COUNTRY":"United States of America","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"23.1"},{"dims":{"COUNTRY":"United States of America","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"21.4"},{"dims":{"COUNTRY":"United States of America","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.5"},{"dims":{"COUNTRY":"United States of America","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"78.2"},{"dims":{"COUNTRY":"United States of America","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"75.7"},{"dims":{"COUNTRY":"United States of America","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"80.6"},{"dims":{"COUNTRY":"United States of America","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"22.7"},{"dims":{"COUNTRY":"United States of America","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"21.2"},{"dims":{"COUNTRY":"United States of America","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.1"},{"dims":{"COUNTRY":"United States of America","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"78.1"},{"dims":{"COUNTRY":"United States of America","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"75.5"},{"dims":{"COUNTRY":"United States of America","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"80.6"},{"dims":{"COUNTRY":"United States of America","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"22.7"},{"dims":{"COUNTRY":"United States of America","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"21.1"},{"dims":{"COUNTRY":"United States of America","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.2"},{"dims":{"COUNTRY":"United States of America","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"77.8"},{"dims":{"COUNTRY":"United States of America","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"75.2"},{"dims":{"COUNTRY":"United States of America","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"80.3"},{"dims":{"COUNTRY":"United States of America","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"22.5"},{"dims":{"COUNTRY":"United States of America","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"20.9"},{"dims":{"COUNTRY":"United States of America","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.0"},{"dims":{"COUNTRY":"United States of America","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"77.5"},{"dims":{"COUNTRY":"United States of America","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"74.9"},{"dims":{"COUNTRY":"United States of America","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"80.0"},{"dims":{"COUNTRY":"United States of America","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"22.2"},{"dims":{"COUNTRY":"United States of America","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"20.5"},{"dims":{"COUNTRY":"United States of America","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"23.6"},{"dims":{"COUNTRY":"United States of America","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"77.5"},{"dims":{"COUNTRY":"United States of America","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"74.9"},{"dims":{"COUNTRY":"United States of America","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"80.1"},{"dims":{"COUNTRY":"United States of America","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"22.2"},{"dims":{"COUNTRY":"United States of America","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"20.5"},{"dims":{"COUNTRY":"United States of America","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"23.6"},{"dims":{"COUNTRY":"United States of America","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"77.2"},{"dims":{"COUNTRY":"United States of America","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"74.5"},{"dims":{"COUNTRY":"United States of America","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"79.7"},{"dims":{"COUNTRY":"United States of America","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"21.9"},{"dims":{"COUNTRY":"United States of America","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"20.2"},{"dims":{"COUNTRY":"United States of America","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"23.3"},{"dims":{"COUNTRY":"United States of America","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"77.0"},{"dims":{"COUNTRY":"United States of America","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"74.4"},{"dims":{"COUNTRY":"United States of America","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"79.6"},{"dims":{"COUNTRY":"United States of America","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"21.7"},{"dims":{"COUNTRY":"United States of America","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"20.0"},{"dims":{"COUNTRY":"United States of America","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"23.2"},{"dims":{"COUNTRY":"United States of America","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"76.9"},{"dims":{"COUNTRY":"United States of America","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"74.2"},{"dims":{"COUNTRY":"United States of America","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"79.5"},{"dims":{"COUNTRY":"United States of America","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"21.6"},{"dims":{"COUNTRY":"United States of America","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.9"},{"dims":{"COUNTRY":"United States of America","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"23.2"},{"dims":{"COUNTRY":"United States of America","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"76.8"},{"dims":{"COUNTRY":"United States of America","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"74.0"},{"dims":{"COUNTRY":"United States of America","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"79.5"},{"dims":{"COUNTRY":"United States of America","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"21.5"},{"dims":{"COUNTRY":"United States of America","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.6"},{"dims":{"COUNTRY":"United States of America","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"23.1"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"77.0"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"73.3"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"80.4"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"22.0"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.1"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.5"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"76.8"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"73.2"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"80.3"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"21.9"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.0"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.4"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"76.8"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"73.1"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"80.2"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"21.9"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.0"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.3"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"76.5"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"72.8"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"80.0"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"21.6"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"18.7"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.1"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"77.0"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"73.3"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"80.5"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"21.8"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"18.9"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.4"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"76.3"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"72.7"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"79.7"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"21.4"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"18.5"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.0"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"76.6"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"72.9"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"80.1"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"21.8"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"18.8"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.4"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"76.4"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"72.9"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"79.6"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"21.6"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"18.8"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.0"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"75.4"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"71.9"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"78.8"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"20.7"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.8"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"23.2"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"76.2"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"72.6"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"79.7"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"21.4"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"18.4"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"23.9"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"75.7"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"72.2"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"79.1"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"20.9"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"18.2"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"23.4"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"75.4"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"71.8"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"79.0"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"20.7"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.9"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"23.3"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"75.4"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"71.7"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"79.0"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"20.6"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.8"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"23.2"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"75.4"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"71.7"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"79.1"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"20.9"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"18.1"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"23.4"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"75.2"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"71.5"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"78.8"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"20.7"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.9"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"23.1"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"75.1"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"71.2"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"78.9"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"20.8"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"18.0"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"23.3"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"69.4"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"66.1"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"72.7"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.4"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.6"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.9"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"69.2"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"65.9"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"72.6"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.3"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.6"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.9"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"69.1"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"65.8"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"72.4"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.2"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.5"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.8"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"68.8"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"65.5"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"72.1"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.0"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.2"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.6"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"68.5"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"65.3"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"71.8"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.7"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.9"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.4"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"68.3"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"65.0"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"71.6"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.4"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.6"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.1"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"68.0"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"64.8"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"71.3"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.2"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.3"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.0"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"67.9"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"64.6"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"71.2"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.2"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.4"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.9"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"67.8"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"64.5"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"71.1"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.3"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.4"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.9"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"67.6"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"64.4"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"70.9"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.3"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.5"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.0"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"67.3"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"64.0"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"70.7"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.3"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.4"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.9"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"67.8"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"64.5"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"71.1"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.8"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.9"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.4"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"67.2"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"64.1"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"70.4"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.3"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.5"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.8"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"67.1"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"63.8"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"70.3"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.5"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.7"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.0"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"67.4"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"64.1"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"70.7"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.1"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.4"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.5"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"67.1"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"63.8"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"70.4"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.9"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.2"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.3"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"72.0"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"70.1"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"74.0"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.2"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.0"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.5"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"71.7"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"69.8"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"73.7"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.1"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"17.0"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.4"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"71.6"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"69.8"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"73.6"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"18.0"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.9"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.3"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"71.4"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"69.6"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"73.4"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.9"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.9"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.2"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"71.2"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"69.5"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"73.2"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.8"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.8"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"19.0"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"71.0"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"69.3"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"72.9"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.7"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.7"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.9"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"70.8"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"69.1"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"72.7"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.6"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.6"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.8"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"70.5"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"68.9"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"72.5"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.5"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.6"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.6"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"70.3"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"68.7"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"72.2"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.4"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.5"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.5"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"70.1"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"68.5"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"72.0"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.3"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.4"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.4"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"69.9"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"68.3"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"71.7"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.2"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.4"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.3"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"69.6"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"68.1"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"71.5"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.1"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.3"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.2"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"69.4"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"67.9"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"71.3"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.1"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.2"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.1"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"69.3"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"67.8"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"71.1"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"17.0"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.2"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.0"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"69.1"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"67.6"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"70.9"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.9"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.1"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"18.0"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"69.0"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"67.6"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"70.7"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.9"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"16.1"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"17.9"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"74.1"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"70.0"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"78.5"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"21.4"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.4"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"23.4"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.9"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"69.8"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"78.3"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"21.3"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.3"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"23.3"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.8"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"69.7"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"78.2"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"21.3"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.2"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"23.3"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.7"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"69.5"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"78.3"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"21.3"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.2"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"23.4"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.8"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"69.9"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"77.9"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"21.1"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.1"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"23.0"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.7"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"69.8"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"77.8"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"21.1"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.1"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"22.9"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.6"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"69.4"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2009","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"78.1"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"21.4"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.4"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2009","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"23.3"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.2"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"69.0"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2008","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"77.7"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"21.0"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.0"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2008","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"23.0"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.4"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"69.3"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"77.8"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"21.1"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.2"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"23.0"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.6"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"69.6"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"77.8"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"21.2"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.2"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"23.1"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.6"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"69.8"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"77.7"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"21.0"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.1"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"23.0"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.3"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"69.4"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"77.6"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"20.9"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.0"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"22.9"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"72.4"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"68.3"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"76.9"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"20.5"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"18.5"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"22.4"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"73.1"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"69.3"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"77.3"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"21.1"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.2"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"22.9"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"72.5"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"68.5"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"76.9"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"20.4"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"18.5"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"22.3"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"72.5"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"68.4"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"77.1"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"20.5"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"18.4"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"22.5"},{"dims":{"COUNTRY":"Viet Nam","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"76.0"},{"dims":{"COUNTRY":"Viet Nam","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"71.3"},{"dims":{"COUNTRY":"Viet Nam","YEAR":"2015","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"80.7"},{"dims":{"COUNTRY":"Viet Nam","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"22.5"},{"dims":{"COUNTRY":"Viet Nam","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.5"},{"dims":{"COUNTRY":"Viet Nam","YEAR":"2015","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.9"},{"dims":{"COUNTRY":"Viet Nam","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"75.9"},{"dims":{"COUNTRY":"Viet Nam","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"71.1"},{"dims":{"COUNTRY":"Viet Nam","YEAR":"2014","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"80.5"},{"dims":{"COUNTRY":"Viet Nam","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"22.5"},{"dims":{"COUNTRY":"Viet Nam","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.4"},{"dims":{"COUNTRY":"Viet Nam","YEAR":"2014","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.8"},{"dims":{"COUNTRY":"Viet Nam","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"75.7"},{"dims":{"COUNTRY":"Viet Nam","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"70.9"},{"dims":{"COUNTRY":"Viet Nam","YEAR":"2013","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"80.4"},{"dims":{"COUNTRY":"Viet Nam","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"22.4"},{"dims":{"COUNTRY":"Viet Nam","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.3"},{"dims":{"COUNTRY":"Viet Nam","YEAR":"2013","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.8"},{"dims":{"COUNTRY":"Viet Nam","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"75.6"},{"dims":{"COUNTRY":"Viet Nam","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"70.7"},{"dims":{"COUNTRY":"Viet Nam","YEAR":"2012","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"80.3"},{"dims":{"COUNTRY":"Viet Nam","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"22.3"},{"dims":{"COUNTRY":"Viet Nam","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.3"},{"dims":{"COUNTRY":"Viet Nam","YEAR":"2012","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.7"},{"dims":{"COUNTRY":"Viet Nam","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"75.4"},{"dims":{"COUNTRY":"Viet Nam","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"70.5"},{"dims":{"COUNTRY":"Viet Nam","YEAR":"2011","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"80.2"},{"dims":{"COUNTRY":"Viet Nam","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"22.2"},{"dims":{"COUNTRY":"Viet Nam","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"19.1"},{"dims":{"COUNTRY":"Viet Nam","YEAR":"2011","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"24.7"},{"dims":{"COUNTRY":"Viet Nam","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"75.2"},{"dims":{"COUNTRY":"Viet Nam","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"70.3"},{"dims":{"COUNTRY":"Viet Nam","YEAR":"2010","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"80.1"},{"dims":{"COUNTRY":"Viet Nam","YEAR":"2010","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"22.1"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"47.1"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"2007","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"46.2"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.3"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.7"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"2007","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.8"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"45.4"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"45.9"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"2006","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"44.9"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.1"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.5"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"2006","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.6"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"44.6"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"45.1"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"2005","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"44.1"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.0"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.5"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"2005","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.5"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"44.3"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"44.8"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"2004","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"43.8"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.0"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.4"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"2004","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.5"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"44.5"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"44.9"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"2003","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"44.1"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.0"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.5"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"2003","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.6"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"44.8"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"45.1"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"2002","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"44.5"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.1"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.5"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"2002","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.6"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"45.3"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"45.5"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"2001","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"45.2"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.1"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.5"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"2001","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.7"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Both sexes"},"Value":"46.0"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Male"},"Value":"46.0"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"2000","GHO":"Life expectancy at birth (years)","SEX":"Female"},"Value":"46.0"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Both sexes"},"Value":"16.2"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Male"},"Value":"15.6"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"2000","GHO":"Life expectancy at age 60 (years)","SEX":"Female"},"Value":"16.8"}]}

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_recharts__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WikiQuote_js__ = __webpack_require__(21);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var OpenDefData=__webpack_require__(603);var OpenDefChart=function(_Component){_inherits(OpenDefChart,_Component);function OpenDefChart(props){_classCallCheck(this,OpenDefChart);var _this=_possibleConstructorReturn(this,(OpenDefChart.__proto__||Object.getPrototypeOf(OpenDefChart)).call(this,props));_this.state={data:[],quote:""};return _this;}_createClass(OpenDefChart,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var quote="",data=[];var success=function success(wikiData){quote='"'+wikiData.quote+'"';};__WEBPACK_IMPORTED_MODULE_3__WikiQuote_js__["a" /* WikiquoteApi */].getRandomQuote("Suffering",success,__WEBPACK_IMPORTED_MODULE_3__WikiQuote_js__["b" /* error */]);data=Object(__WEBPACK_IMPORTED_MODULE_2__utils_js__["h" /* mapTable */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_js__["f" /* filterTable */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_js__["g" /* initialReformat */])(OpenDefData)));var checkQuoteLength=function checkQuoteLength(){if(quote.length>0){_this2.setState({quote:quote,data:data});}else{setTimeout(checkQuoteLength,100);}};checkQuoteLength();}},{key:'render',value:function render(){var data=[],finalData=[],i=0;if(this.state.data.length>0){//format data so that data can be utilised by year... [title: {year: [obj_with_data, ...], ...}, ...]
data=Object(__WEBPACK_IMPORTED_MODULE_2__utils_js__["c" /* filterAll */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_js__["b" /* dataFunction */])(this.state.data));data=data['Population not using any sanitation facility (open defecation) (%)'];for(var key in data){finalData.push({year:key});data[key].forEach(function(obj){finalData[i][obj.country]=+obj.value;});i++;}}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'chart bar open-def'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,this.state.quote),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h6',{className:'title'},this.state.data.length>0&&data['1990'][0].title),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["k" /* ResponsiveContainer */],{width:'100%',height:300},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["e" /* LineChart */],{cx:'50%',cy:'50%',outerRadius:'80%',data:finalData},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["m" /* XAxis */],{dataKey:'year'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["n" /* YAxis */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["c" /* CartesianGrid */],{strokeDasharray:'3 3'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["l" /* Tooltip */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["d" /* Line */],{connectNulls:true,type:'monotone',dataKey:'Colombia',stroke:'black'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["d" /* Line */],{connectNulls:true,type:'monotone',dataKey:'Zimbabwe',stroke:'green'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["d" /* Line */],{connectNulls:true,type:'monotone',dataKey:'Zambia',stroke:'purple'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["d" /* Line */],{connectNulls:true,type:'monotone',dataKey:'Viet Nam',stroke:'orange'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["d" /* Line */],{connectNulls:true,type:'monotone',dataKey:'United Republic of Tanzania',stroke:'black'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["d" /* Line */],{connectNulls:true,type:'monotone',dataKey:'Uganda',stroke:'brown'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["d" /* Line */],{connectNulls:true,type:'monotone',dataKey:'Togo',stroke:'#C90016'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["d" /* Line */],{connectNulls:true,type:'monotone',dataKey:'Sierra Leone',stroke:'red'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["d" /* Line */],{connectNulls:true,type:'monotone',dataKey:'Senegal',stroke:'maroon'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["d" /* Line */],{connectNulls:true,type:'monotone',dataKey:'Philippines',stroke:'grey'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["d" /* Line */],{connectNulls:true,type:'monotone',dataKey:'Peru',stroke:'#6082B6'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["d" /* Line */],{connectNulls:true,type:'monotone',dataKey:'Nepal',stroke:'#D4AF37'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["d" /* Line */],{connectNulls:true,type:'monotone',dataKey:'Ghana',stroke:'#00FF00'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["d" /* Line */],{connectNulls:true,type:'monotone',dataKey:'Cameroon',stroke:'#5218FA'}))));}}]);return OpenDefChart;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (OpenDefChart);

/***/ }),
/* 603 */
/***/ (function(module, exports) {

module.exports = {"dimension":[{"label":"GHO","display":"Indicator"},{"label":"DATASOURCE","display":"Data Source"},{"label":"PUBLISHSTATE","display":"PUBLISH STATES"},{"label":"YEAR","display":"Year"},{"label":"REGION","display":"WHO region"},{"label":"COUNTRY","display":"Country"}],"fact":[{"dims":{"COUNTRY":"Afghanistan","DATASOURCE":"MICS","YEAR":"2010","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"17.7"},{"dims":{"COUNTRY":"Albania","DATASOURCE":"DHS","YEAR":"2008","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"0.0"},{"dims":{"COUNTRY":"Albania","DATASOURCE":"MICS","YEAR":"2005","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"0.0"},{"dims":{"COUNTRY":"Argentina","DATASOURCE":"MICS","YEAR":"2011","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"2.8"},{"dims":{"COUNTRY":"Armenia","DATASOURCE":"DHS","YEAR":"2010","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"0.0"},{"dims":{"COUNTRY":"Armenia","DATASOURCE":"DHS","YEAR":"2005","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"0.1"},{"dims":{"COUNTRY":"Armenia","DATASOURCE":"DHS","YEAR":"2000","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"0.1"},{"dims":{"COUNTRY":"Azerbaijan","DATASOURCE":"DHS","YEAR":"2006","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"0.3"},{"dims":{"COUNTRY":"Bangladesh","DATASOURCE":"DHS","YEAR":"2011","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"4.0"},{"dims":{"COUNTRY":"Bangladesh","DATASOURCE":"DHS","YEAR":"2007","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"7.3"},{"dims":{"COUNTRY":"Bangladesh","DATASOURCE":"DHS","YEAR":"2004","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"12.0"},{"dims":{"COUNTRY":"Bangladesh","DATASOURCE":"DHS","YEAR":"1999","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"17.2"},{"dims":{"COUNTRY":"Bangladesh","DATASOURCE":"DHS","YEAR":"1996","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"23.0"},{"dims":{"COUNTRY":"Bangladesh","DATASOURCE":"DHS","YEAR":"1993","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"26.6"},{"dims":{"COUNTRY":"Bangladesh","DATASOURCE":"MICS","YEAR":"2006","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"7.5"},{"dims":{"COUNTRY":"Barbados","DATASOURCE":"MICS","YEAR":"2012","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"0.3"},{"dims":{"COUNTRY":"Belarus","DATASOURCE":"MICS","YEAR":"2012","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"0.0"},{"dims":{"COUNTRY":"Belarus","DATASOURCE":"MICS","YEAR":"2005","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"0.0"},{"dims":{"COUNTRY":"Belize","DATASOURCE":"MICS","YEAR":"2011","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"1.6"},{"dims":{"COUNTRY":"Belize","DATASOURCE":"MICS","YEAR":"2006","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"2.1"},{"dims":{"COUNTRY":"Benin","DATASOURCE":"DHS","YEAR":"2011","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"57.4"},{"dims":{"COUNTRY":"Benin","DATASOURCE":"DHS","YEAR":"2006","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"64.9"},{"dims":{"COUNTRY":"Benin","DATASOURCE":"DHS","YEAR":"2001","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"67.4"},{"dims":{"COUNTRY":"Benin","DATASOURCE":"DHS","YEAR":"1996","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"73.7"},{"dims":{"COUNTRY":"Bhutan","DATASOURCE":"MICS","YEAR":"2010","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"3.4"},{"dims":{"COUNTRY":"Bolivia (Plurinational State of)","DATASOURCE":"DHS","YEAR":"2003","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"34.1"},{"dims":{"COUNTRY":"Bolivia (Plurinational State of)","DATASOURCE":"DHS","YEAR":"1994","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"41.2"},{"dims":{"COUNTRY":"Bosnia and Herzegovina","DATASOURCE":"MICS","YEAR":"2011","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"0.0"},{"dims":{"COUNTRY":"Bosnia and Herzegovina","DATASOURCE":"MICS","YEAR":"2006","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"0.1"},{"dims":{"COUNTRY":"Brazil","DATASOURCE":"DHS","YEAR":"1996","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"11.8"},{"dims":{"COUNTRY":"Burkina Faso","DATASOURCE":"DHS","YEAR":"2010","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"63.7"},{"dims":{"COUNTRY":"Burkina Faso","DATASOURCE":"DHS","YEAR":"2003","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"69.6"},{"dims":{"COUNTRY":"Burkina Faso","DATASOURCE":"DHS","YEAR":"1998","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"76.7"},{"dims":{"COUNTRY":"Burkina Faso","DATASOURCE":"DHS","YEAR":"1993","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"71.8"},{"dims":{"COUNTRY":"Burkina Faso","DATASOURCE":"MICS","YEAR":"2006","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"62.8"},{"dims":{"COUNTRY":"Burundi","DATASOURCE":"DHS","YEAR":"2010","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"2.9"},{"dims":{"COUNTRY":"Burundi","DATASOURCE":"MICS","YEAR":"2005","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"3.1"},{"dims":{"COUNTRY":"Côte d'Ivoire","DATASOURCE":"DHS","YEAR":"2011","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"33.8"},{"dims":{"COUNTRY":"Côte d'Ivoire","DATASOURCE":"DHS","YEAR":"1998","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"35.5"},{"dims":{"COUNTRY":"Côte d'Ivoire","DATASOURCE":"DHS","YEAR":"1994","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"42.2"},{"dims":{"COUNTRY":"Côte d'Ivoire","DATASOURCE":"MICS","YEAR":"2006","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"34.1"},{"dims":{"COUNTRY":"Cambodia","DATASOURCE":"DHS","YEAR":"2010","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"55.3"},{"dims":{"COUNTRY":"Cambodia","DATASOURCE":"DHS","YEAR":"2005","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"69.9"},{"dims":{"COUNTRY":"Cambodia","DATASOURCE":"DHS","YEAR":"2000","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"78.2"},{"dims":{"COUNTRY":"Cameroon","DATASOURCE":"DHS","YEAR":"2011","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"7.1"},{"dims":{"COUNTRY":"Cameroon","DATASOURCE":"DHS","YEAR":"2004","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"7.0"},{"dims":{"COUNTRY":"Cameroon","DATASOURCE":"DHS","YEAR":"1998","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"9.7"},{"dims":{"COUNTRY":"Cameroon","DATASOURCE":"DHS","YEAR":"1991","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"12.7"},{"dims":{"COUNTRY":"Cameroon","DATASOURCE":"MICS","YEAR":"2006","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"7.5"},{"dims":{"COUNTRY":"Central African Republic","DATASOURCE":"DHS","YEAR":"1994","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"25.6"},{"dims":{"COUNTRY":"Central African Republic","DATASOURCE":"MICS","YEAR":"2010","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"26.6"},{"dims":{"COUNTRY":"Central African Republic","DATASOURCE":"MICS","YEAR":"2006","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"22.3"},{"dims":{"COUNTRY":"Chad","DATASOURCE":"DHS","YEAR":"2004","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"71.6"},{"dims":{"COUNTRY":"Chad","DATASOURCE":"DHS","YEAR":"1996","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"71.4"},{"dims":{"COUNTRY":"Chad","DATASOURCE":"MICS","YEAR":"2010","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"65.9"},{"dims":{"COUNTRY":"Colombia","DATASOURCE":"DHS","YEAR":"2010","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"5.3"},{"dims":{"COUNTRY":"Colombia","DATASOURCE":"DHS","YEAR":"2005","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"7.4"},{"dims":{"COUNTRY":"Colombia","DATASOURCE":"DHS","YEAR":"2000","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"9.2"},{"dims":{"COUNTRY":"Colombia","DATASOURCE":"DHS","YEAR":"1995","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"15.8"},{"dims":{"COUNTRY":"Colombia","DATASOURCE":"DHS","YEAR":"1990","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"14.9"},{"dims":{"COUNTRY":"Comoros","DATASOURCE":"DHS","YEAR":"2012","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"0.5"},{"dims":{"COUNTRY":"Comoros","DATASOURCE":"DHS","YEAR":"1996","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"0.3"},{"dims":{"COUNTRY":"Congo","DATASOURCE":"DHS","YEAR":"2011","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"8.1"},{"dims":{"COUNTRY":"Congo","DATASOURCE":"DHS","YEAR":"2005","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"9.4"},{"dims":{"COUNTRY":"Costa Rica","DATASOURCE":"MICS","YEAR":"2011","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"0.0"},{"dims":{"COUNTRY":"Cuba","DATASOURCE":"MICS","YEAR":"2010","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"1.0"},{"dims":{"COUNTRY":"Cuba","DATASOURCE":"MICS","YEAR":"2006","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"1.1"},{"dims":{"COUNTRY":"Democratic Republic of the Congo","DATASOURCE":"DHS","YEAR":"2013","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"13.0"},{"dims":{"COUNTRY":"Democratic Republic of the Congo","DATASOURCE":"DHS","YEAR":"2007","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"9.9"},{"dims":{"COUNTRY":"Democratic Republic of the Congo","DATASOURCE":"MICS","YEAR":"2010","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"14.5"},{"dims":{"COUNTRY":"Djibouti","DATASOURCE":"MICS","YEAR":"2006","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"3.9"},{"dims":{"COUNTRY":"Dominican Republic","DATASOURCE":"DHS","YEAR":"2013","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"2.8"},{"dims":{"COUNTRY":"Dominican Republic","DATASOURCE":"DHS","YEAR":"2007","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"3.6"},{"dims":{"COUNTRY":"Dominican Republic","DATASOURCE":"DHS","YEAR":"2002","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"4.9"},{"dims":{"COUNTRY":"Dominican Republic","DATASOURCE":"DHS","YEAR":"1999","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"8.7"},{"dims":{"COUNTRY":"Dominican Republic","DATASOURCE":"DHS","YEAR":"1996","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"9.3"},{"dims":{"COUNTRY":"Egypt","DATASOURCE":"DHS","YEAR":"2008","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"0.4"},{"dims":{"COUNTRY":"Egypt","DATASOURCE":"DHS","YEAR":"2005","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"1.1"},{"dims":{"COUNTRY":"Egypt","DATASOURCE":"DHS","YEAR":"2003","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"1.4"},{"dims":{"COUNTRY":"Egypt","DATASOURCE":"DHS","YEAR":"2000","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"2.8"},{"dims":{"COUNTRY":"Egypt","DATASOURCE":"DHS","YEAR":"1995","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"5.3"},{"dims":{"COUNTRY":"Ethiopia","DATASOURCE":"DHS","YEAR":"2011","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"38.2"},{"dims":{"COUNTRY":"Ethiopia","DATASOURCE":"DHS","YEAR":"2005","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"62.2"},{"dims":{"COUNTRY":"Ethiopia","DATASOURCE":"DHS","YEAR":"2000","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"82.3"},{"dims":{"COUNTRY":"Gabon","DATASOURCE":"DHS","YEAR":"2012","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"2.3"},{"dims":{"COUNTRY":"Gabon","DATASOURCE":"DHS","YEAR":"2000","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"2.1"},{"dims":{"COUNTRY":"Gambia","DATASOURCE":"MICS","YEAR":"2005","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"4.4"},{"dims":{"COUNTRY":"Georgia","DATASOURCE":"MICS","YEAR":"2005","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"0.0"},{"dims":{"COUNTRY":"Ghana","DATASOURCE":"DHS","YEAR":"2008","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"23.0"},{"dims":{"COUNTRY":"Ghana","DATASOURCE":"DHS","YEAR":"2003","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"24.5"},{"dims":{"COUNTRY":"Ghana","DATASOURCE":"DHS","YEAR":"1998","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"24.0"},{"dims":{"COUNTRY":"Ghana","DATASOURCE":"DHS","YEAR":"1993","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"26.5"},{"dims":{"COUNTRY":"Ghana","DATASOURCE":"MICS","YEAR":"2011","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"22.9"},{"dims":{"COUNTRY":"Ghana","DATASOURCE":"MICS","YEAR":"2006","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"24.4"},{"dims":{"COUNTRY":"Guatemala","DATASOURCE":"DHS","YEAR":"1998","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"14.1"},{"dims":{"COUNTRY":"Guatemala","DATASOURCE":"DHS","YEAR":"1995","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"16.7"},{"dims":{"COUNTRY":"Guinea","DATASOURCE":"DHS","YEAR":"2012","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"17.2"},{"dims":{"COUNTRY":"Guinea","DATASOURCE":"DHS","YEAR":"2005","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"27.6"},{"dims":{"COUNTRY":"Guinea","DATASOURCE":"DHS","YEAR":"1999","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"34.9"},{"dims":{"COUNTRY":"Guinea-Bissau","DATASOURCE":"MICS","YEAR":"2006","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"31.2"},{"dims":{"COUNTRY":"Guyana","DATASOURCE":"DHS","YEAR":"2009","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"1.0"},{"dims":{"COUNTRY":"Guyana","DATASOURCE":"MICS","YEAR":"2006","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"1.5"},{"dims":{"COUNTRY":"Haiti","DATASOURCE":"DHS","YEAR":"2012","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"25.4"},{"dims":{"COUNTRY":"Haiti","DATASOURCE":"DHS","YEAR":"2005","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"35.0"},{"dims":{"COUNTRY":"Haiti","DATASOURCE":"DHS","YEAR":"2000","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"39.1"},{"dims":{"COUNTRY":"Haiti","DATASOURCE":"DHS","YEAR":"1994","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"42.4"},{"dims":{"COUNTRY":"Honduras","DATASOURCE":"DHS","YEAR":"2011","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"10.3"},{"dims":{"COUNTRY":"Honduras","DATASOURCE":"DHS","YEAR":"2005","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"16.6"},{"dims":{"COUNTRY":"India","DATASOURCE":"DHS","YEAR":"2005","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"56.3"},{"dims":{"COUNTRY":"India","DATASOURCE":"DHS","YEAR":"1998","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"64.0"},{"dims":{"COUNTRY":"India","DATASOURCE":"DHS","YEAR":"1992","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"70.1"},{"dims":{"COUNTRY":"Indonesia","DATASOURCE":"DHS","YEAR":"2012","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"15.0"},{"dims":{"COUNTRY":"Indonesia","DATASOURCE":"DHS","YEAR":"2007","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"22.9"},{"dims":{"COUNTRY":"Indonesia","DATASOURCE":"DHS","YEAR":"2002","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"23.0"},{"dims":{"COUNTRY":"Iraq","DATASOURCE":"MICS","YEAR":"2011","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"0.8"},{"dims":{"COUNTRY":"Iraq","DATASOURCE":"MICS","YEAR":"2006","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"2.5"},{"dims":{"COUNTRY":"Jamaica","DATASOURCE":"MICS","YEAR":"2011","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"0.3"},{"dims":{"COUNTRY":"Jamaica","DATASOURCE":"MICS","YEAR":"2005","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"0.6"},{"dims":{"COUNTRY":"Jordan","DATASOURCE":"DHS","YEAR":"2012","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"0.0"},{"dims":{"COUNTRY":"Jordan","DATASOURCE":"DHS","YEAR":"2009","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"0.0"},{"dims":{"COUNTRY":"Jordan","DATASOURCE":"DHS","YEAR":"2007","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"0.1"},{"dims":{"COUNTRY":"Jordan","DATASOURCE":"DHS","YEAR":"2002","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"0.1"},{"dims":{"COUNTRY":"Jordan","DATASOURCE":"DHS","YEAR":"1997","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"0.4"},{"dims":{"COUNTRY":"Kazakhstan","DATASOURCE":"DHS","YEAR":"1999","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"0.5"},{"dims":{"COUNTRY":"Kazakhstan","DATASOURCE":"DHS","YEAR":"1995","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"0.5"},{"dims":{"COUNTRY":"Kazakhstan","DATASOURCE":"MICS","YEAR":"2010","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"0.0"},{"dims":{"COUNTRY":"Kazakhstan","DATASOURCE":"MICS","YEAR":"2006","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"0.0"},{"dims":{"COUNTRY":"Kenya","DATASOURCE":"DHS","YEAR":"2008","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"14.4"},{"dims":{"COUNTRY":"Kenya","DATASOURCE":"DHS","YEAR":"2003","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"18.2"},{"dims":{"COUNTRY":"Kenya","DATASOURCE":"DHS","YEAR":"1998","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"15.8"},{"dims":{"COUNTRY":"Kenya","DATASOURCE":"DHS","YEAR":"1993","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"17.9"},{"dims":{"COUNTRY":"Kyrgyzstan","DATASOURCE":"DHS","YEAR":"2012","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"0.0"},{"dims":{"COUNTRY":"Kyrgyzstan","DATASOURCE":"DHS","YEAR":"1997","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"0.1"},{"dims":{"COUNTRY":"Kyrgyzstan","DATASOURCE":"MICS","YEAR":"2005","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"0.1"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","DATASOURCE":"MICS","YEAR":"2011","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"37.9"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","DATASOURCE":"MICS","YEAR":"2006","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"50.1"},{"dims":{"COUNTRY":"Lesotho","DATASOURCE":"DHS","YEAR":"2009","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"35.6"},{"dims":{"COUNTRY":"Lesotho","DATASOURCE":"DHS","YEAR":"2004","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"44.1"},{"dims":{"COUNTRY":"Liberia","DATASOURCE":"DHS","YEAR":"2013","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"45.0"},{"dims":{"COUNTRY":"Liberia","DATASOURCE":"DHS","YEAR":"2007","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"54.7"},{"dims":{"COUNTRY":"Madagascar","DATASOURCE":"DHS","YEAR":"2008","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"43.6"},{"dims":{"COUNTRY":"Madagascar","DATASOURCE":"DHS","YEAR":"2003","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"46.4"},{"dims":{"COUNTRY":"Madagascar","DATASOURCE":"DHS","YEAR":"1997","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"60.4"},{"dims":{"COUNTRY":"Malawi","DATASOURCE":"DHS","YEAR":"2010","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"9.8"},{"dims":{"COUNTRY":"Malawi","DATASOURCE":"DHS","YEAR":"2004","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"14.5"},{"dims":{"COUNTRY":"Malawi","DATASOURCE":"DHS","YEAR":"2000","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"16.4"},{"dims":{"COUNTRY":"Malawi","DATASOURCE":"DHS","YEAR":"1992","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"24.8"},{"dims":{"COUNTRY":"Malawi","DATASOURCE":"MICS","YEAR":"2006","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"12.1"},{"dims":{"COUNTRY":"Maldives","DATASOURCE":"DHS","YEAR":"2009","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"1.0"},{"dims":{"COUNTRY":"Mali","DATASOURCE":"DHS","YEAR":"2012","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"10.9"},{"dims":{"COUNTRY":"Mali","DATASOURCE":"DHS","YEAR":"2006","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"19.6"},{"dims":{"COUNTRY":"Mali","DATASOURCE":"DHS","YEAR":"2001","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"20.9"},{"dims":{"COUNTRY":"Mali","DATASOURCE":"DHS","YEAR":"1995","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"26.6"},{"dims":{"COUNTRY":"Mauritania","DATASOURCE":"MICS","YEAR":"2007","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"45.6"},{"dims":{"COUNTRY":"Mongolia","DATASOURCE":"MICS","YEAR":"2010","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"13.0"},{"dims":{"COUNTRY":"Mongolia","DATASOURCE":"MICS","YEAR":"2005","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"13.4"},{"dims":{"COUNTRY":"Montenegro","DATASOURCE":"MICS","YEAR":"2005","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"0.3"},{"dims":{"COUNTRY":"Morocco","DATASOURCE":"DHS","YEAR":"2003","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"17.1"},{"dims":{"COUNTRY":"Morocco","DATASOURCE":"DHS","YEAR":"1992","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"39.1"},{"dims":{"COUNTRY":"Mozambique","DATASOURCE":"DHS","YEAR":"2011","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"39.3"},{"dims":{"COUNTRY":"Mozambique","DATASOURCE":"DHS","YEAR":"2003","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"46.7"},{"dims":{"COUNTRY":"Mozambique","DATASOURCE":"DHS","YEAR":"1997","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"60.5"},{"dims":{"COUNTRY":"Mozambique","DATASOURCE":"MICS","YEAR":"2008","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"42.3"},{"dims":{"COUNTRY":"Namibia","DATASOURCE":"DHS","YEAR":"2013","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"49.8"},{"dims":{"COUNTRY":"Namibia","DATASOURCE":"DHS","YEAR":"2006","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"52.9"},{"dims":{"COUNTRY":"Namibia","DATASOURCE":"DHS","YEAR":"2000","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"56.6"},{"dims":{"COUNTRY":"Namibia","DATASOURCE":"DHS","YEAR":"1992","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"62.7"},{"dims":{"COUNTRY":"Nepal","DATASOURCE":"DHS","YEAR":"2011","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"38.2"},{"dims":{"COUNTRY":"Nepal","DATASOURCE":"DHS","YEAR":"2006","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"51.9"},{"dims":{"COUNTRY":"Nepal","DATASOURCE":"DHS","YEAR":"2001","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"70.0"},{"dims":{"COUNTRY":"Nepal","DATASOURCE":"DHS","YEAR":"1996","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"83.7"},{"dims":{"COUNTRY":"Nicaragua","DATASOURCE":"DHS","YEAR":"2001","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"14.9"},{"dims":{"COUNTRY":"Nicaragua","DATASOURCE":"DHS","YEAR":"1998","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"14.6"},{"dims":{"COUNTRY":"Niger","DATASOURCE":"DHS","YEAR":"2012","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"71.9"},{"dims":{"COUNTRY":"Niger","DATASOURCE":"DHS","YEAR":"2006","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"79.4"},{"dims":{"COUNTRY":"Niger","DATASOURCE":"DHS","YEAR":"1998","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"79.3"},{"dims":{"COUNTRY":"Nigeria","DATASOURCE":"DHS","YEAR":"2013","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"28.8"},{"dims":{"COUNTRY":"Nigeria","DATASOURCE":"DHS","YEAR":"2008","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"30.9"},{"dims":{"COUNTRY":"Nigeria","DATASOURCE":"DHS","YEAR":"2003","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"24.5"},{"dims":{"COUNTRY":"Nigeria","DATASOURCE":"MICS","YEAR":"2011","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"28.5"},{"dims":{"COUNTRY":"Nigeria","DATASOURCE":"MICS","YEAR":"2007","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"27.7"},{"dims":{"COUNTRY":"Pakistan","DATASOURCE":"DHS","YEAR":"2012","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"21.2"},{"dims":{"COUNTRY":"Pakistan","DATASOURCE":"DHS","YEAR":"2006","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"28.1"},{"dims":{"COUNTRY":"Pakistan","DATASOURCE":"DHS","YEAR":"1990","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"50.9"},{"dims":{"COUNTRY":"Peru","DATASOURCE":"DHS","YEAR":"2012","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"10.2"},{"dims":{"COUNTRY":"Peru","DATASOURCE":"DHS","YEAR":"2011","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"10.8"},{"dims":{"COUNTRY":"Peru","DATASOURCE":"DHS","YEAR":"2010","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"12.9"},{"dims":{"COUNTRY":"Peru","DATASOURCE":"DHS","YEAR":"2009","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"14.1"},{"dims":{"COUNTRY":"Peru","DATASOURCE":"DHS","YEAR":"2007","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"14.4"},{"dims":{"COUNTRY":"Peru","DATASOURCE":"DHS","YEAR":"2004","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"14.4"},{"dims":{"COUNTRY":"Peru","DATASOURCE":"DHS","YEAR":"2000","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"23.0"},{"dims":{"COUNTRY":"Peru","DATASOURCE":"DHS","YEAR":"1996","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"25.8"},{"dims":{"COUNTRY":"Peru","DATASOURCE":"DHS","YEAR":"1991","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"23.9"},{"dims":{"COUNTRY":"Philippines","DATASOURCE":"DHS","YEAR":"2013","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"6.3"},{"dims":{"COUNTRY":"Philippines","DATASOURCE":"DHS","YEAR":"2008","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"9.6"},{"dims":{"COUNTRY":"Philippines","DATASOURCE":"DHS","YEAR":"2003","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"9.4"},{"dims":{"COUNTRY":"Philippines","DATASOURCE":"DHS","YEAR":"1998","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"10.5"},{"dims":{"COUNTRY":"Philippines","DATASOURCE":"DHS","YEAR":"1993","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"12.6"},{"dims":{"COUNTRY":"Republic of Moldova","DATASOURCE":"DHS","YEAR":"2005","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"0.0"},{"dims":{"COUNTRY":"Republic of Moldova","DATASOURCE":"MICS","YEAR":"2012","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"0.1"},{"dims":{"COUNTRY":"Rwanda","DATASOURCE":"DHS","YEAR":"2010","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"1.1"},{"dims":{"COUNTRY":"Rwanda","DATASOURCE":"DHS","YEAR":"2007","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"2.2"},{"dims":{"COUNTRY":"Rwanda","DATASOURCE":"DHS","YEAR":"2005","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"3.3"},{"dims":{"COUNTRY":"Rwanda","DATASOURCE":"DHS","YEAR":"2000","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"2.9"},{"dims":{"COUNTRY":"Rwanda","DATASOURCE":"DHS","YEAR":"1992","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"5.9"},{"dims":{"COUNTRY":"Saint Lucia","DATASOURCE":"MICS","YEAR":"2012","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"1.8"},{"dims":{"COUNTRY":"Sao Tome and Principe","DATASOURCE":"DHS","YEAR":"2008","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"57.7"},{"dims":{"COUNTRY":"Senegal","DATASOURCE":"DHS","YEAR":"2012","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"21.0"},{"dims":{"COUNTRY":"Senegal","DATASOURCE":"DHS","YEAR":"2010","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"16.5"},{"dims":{"COUNTRY":"Senegal","DATASOURCE":"DHS","YEAR":"2005","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"22.0"},{"dims":{"COUNTRY":"Senegal","DATASOURCE":"DHS","YEAR":"1997","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"32.5"},{"dims":{"COUNTRY":"Serbia","DATASOURCE":"MICS","YEAR":"2010","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"0.0"},{"dims":{"COUNTRY":"Serbia","DATASOURCE":"MICS","YEAR":"2005","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"0.1"},{"dims":{"COUNTRY":"Sierra Leone","DATASOURCE":"DHS","YEAR":"2013","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"20.2"},{"dims":{"COUNTRY":"Sierra Leone","DATASOURCE":"DHS","YEAR":"2008","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"21.8"},{"dims":{"COUNTRY":"Sierra Leone","DATASOURCE":"MICS","YEAR":"2010","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"29.0"},{"dims":{"COUNTRY":"Sierra Leone","DATASOURCE":"MICS","YEAR":"2005","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"31.9"},{"dims":{"COUNTRY":"Somalia","DATASOURCE":"MICS","YEAR":"2006","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"53.9"},{"dims":{"COUNTRY":"South Africa","DATASOURCE":"DHS","YEAR":"1998","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"12.8"},{"dims":{"COUNTRY":"Sudan","DATASOURCE":"MICS","YEAR":"2010","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"31.4"},{"dims":{"COUNTRY":"Suriname","DATASOURCE":"MICS","YEAR":"2011","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"5.6"},{"dims":{"COUNTRY":"Suriname","DATASOURCE":"MICS","YEAR":"2006","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"6.4"},{"dims":{"COUNTRY":"Swaziland","DATASOURCE":"DHS","YEAR":"2006","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"19.8"},{"dims":{"COUNTRY":"Swaziland","DATASOURCE":"MICS","YEAR":"2010","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"15.4"},{"dims":{"COUNTRY":"Syrian Arab Republic","DATASOURCE":"MICS","YEAR":"2006","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"1.1"},{"dims":{"COUNTRY":"Tajikistan","DATASOURCE":"MICS","YEAR":"2006","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"0.4"},{"dims":{"COUNTRY":"Thailand","DATASOURCE":"MICS","YEAR":"2005","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"0.7"},{"dims":{"COUNTRY":"The former Yugoslav republic of Macedonia","DATASOURCE":"MICS","YEAR":"2011","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"0.6"},{"dims":{"COUNTRY":"The former Yugoslav republic of Macedonia","DATASOURCE":"MICS","YEAR":"2005","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"0.2"},{"dims":{"COUNTRY":"Timor-Leste","DATASOURCE":"DHS","YEAR":"2009","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"35.9"},{"dims":{"COUNTRY":"Togo","DATASOURCE":"DHS","YEAR":"1998","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"64.3"},{"dims":{"COUNTRY":"Togo","DATASOURCE":"MICS","YEAR":"2010","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"55.7"},{"dims":{"COUNTRY":"Togo","DATASOURCE":"MICS","YEAR":"2006","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"55.0"},{"dims":{"COUNTRY":"Trinidad and Tobago","DATASOURCE":"MICS","YEAR":"2006","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"0.1"},{"dims":{"COUNTRY":"Tunisia","DATASOURCE":"MICS","YEAR":"2010","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"2.3"},{"dims":{"COUNTRY":"Turkey","DATASOURCE":"DHS","YEAR":"2003","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"0.6"},{"dims":{"COUNTRY":"Turkey","DATASOURCE":"DHS","YEAR":"1998","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"2.2"},{"dims":{"COUNTRY":"Turkey","DATASOURCE":"DHS","YEAR":"1993","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"1.9"},{"dims":{"COUNTRY":"Uganda","DATASOURCE":"DHS","YEAR":"2011","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"9.6"},{"dims":{"COUNTRY":"Uganda","DATASOURCE":"DHS","YEAR":"2006","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"11.7"},{"dims":{"COUNTRY":"Uganda","DATASOURCE":"DHS","YEAR":"2000","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"14.8"},{"dims":{"COUNTRY":"Uganda","DATASOURCE":"DHS","YEAR":"1995","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"17.4"},{"dims":{"COUNTRY":"Ukraine","DATASOURCE":"DHS","YEAR":"2007","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"0.0"},{"dims":{"COUNTRY":"Ukraine","DATASOURCE":"MICS","YEAR":"2012","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"0.0"},{"dims":{"COUNTRY":"Ukraine","DATASOURCE":"MICS","YEAR":"2005","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"0.0"},{"dims":{"COUNTRY":"United Republic of Tanzania","DATASOURCE":"DHS","YEAR":"2010","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"15.7"},{"dims":{"COUNTRY":"United Republic of Tanzania","DATASOURCE":"DHS","YEAR":"2004","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"14.2"},{"dims":{"COUNTRY":"United Republic of Tanzania","DATASOURCE":"DHS","YEAR":"1999","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"12.3"},{"dims":{"COUNTRY":"United Republic of Tanzania","DATASOURCE":"DHS","YEAR":"1996","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"13.0"},{"dims":{"COUNTRY":"Uzbekistan","DATASOURCE":"DHS","YEAR":"1996","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"0.0"},{"dims":{"COUNTRY":"Uzbekistan","DATASOURCE":"MICS","YEAR":"2006","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"0.0"},{"dims":{"COUNTRY":"Vanuatu","DATASOURCE":"MICS","YEAR":"2007","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"3.2"},{"dims":{"COUNTRY":"Viet Nam","DATASOURCE":"DHS","YEAR":"2002","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"18.2"},{"dims":{"COUNTRY":"Viet Nam","DATASOURCE":"DHS","YEAR":"1997","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"23.8"},{"dims":{"COUNTRY":"Viet Nam","DATASOURCE":"MICS","YEAR":"2010","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"6.4"},{"dims":{"COUNTRY":"Viet Nam","DATASOURCE":"MICS","YEAR":"2006","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"12.3"},{"dims":{"COUNTRY":"Yemen","DATASOURCE":"MICS","YEAR":"2006","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"21.4"},{"dims":{"COUNTRY":"Zambia","DATASOURCE":"DHS","YEAR":"2007","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"23.3"},{"dims":{"COUNTRY":"Zambia","DATASOURCE":"DHS","YEAR":"2001","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"26.9"},{"dims":{"COUNTRY":"Zambia","DATASOURCE":"DHS","YEAR":"1996","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"26.7"},{"dims":{"COUNTRY":"Zimbabwe","DATASOURCE":"DHS","YEAR":"2010","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"28.1"},{"dims":{"COUNTRY":"Zimbabwe","DATASOURCE":"DHS","YEAR":"2005","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"31.8"},{"dims":{"COUNTRY":"Zimbabwe","DATASOURCE":"DHS","YEAR":"1999","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"28.2"},{"dims":{"COUNTRY":"Zimbabwe","DATASOURCE":"DHS","YEAR":"1994","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"38.4"},{"dims":{"COUNTRY":"Zimbabwe","DATASOURCE":"MICS","YEAR":"2009","GHO":"Population not using any sanitation facility (open defecation) (%)"},"Value":"32.9"}]}

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_recharts__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WikiQuote_js__ = __webpack_require__(21);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PopulationBelowPovLineData=__webpack_require__(605);var PopulationBelowPovertyLine=function(_Component){_inherits(PopulationBelowPovertyLine,_Component);function PopulationBelowPovertyLine(props){_classCallCheck(this,PopulationBelowPovertyLine);var _this=_possibleConstructorReturn(this,(PopulationBelowPovertyLine.__proto__||Object.getPrototypeOf(PopulationBelowPovertyLine)).call(this,props));_this.state={data:[],quote:""};return _this;}_createClass(PopulationBelowPovertyLine,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var quote="",data=[];var success=function success(wikiData){quote='"'+wikiData.quote+'"';};__WEBPACK_IMPORTED_MODULE_3__WikiQuote_js__["a" /* WikiquoteApi */].getRandomQuote("Poverty",success,__WEBPACK_IMPORTED_MODULE_3__WikiQuote_js__["b" /* error */]);data=Object(__WEBPACK_IMPORTED_MODULE_2__utils_js__["h" /* mapTable */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_js__["f" /* filterTable */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_js__["g" /* initialReformat */])(PopulationBelowPovLineData)));var checkQuoteLength=function checkQuoteLength(){if(quote.length>0){_this2.setState({quote:quote,data:data});}else{setTimeout(checkQuoteLength,100);}};checkQuoteLength();}},{key:'render',value:function render(){var data=[],finalData=[],i=0;if(this.state.data.length>0){//format data so that data can be utilised by year... [title: {year: [obj_with_data, ...], ...}, ...]
data=Object(__WEBPACK_IMPORTED_MODULE_2__utils_js__["c" /* filterAll */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_js__["b" /* dataFunction */])(this.state.data));data=data['Proportion of population below the international poverty line of US$1.90 per day (%)'];for(var key in data){finalData.push({year:key});data[key].forEach(function(obj){finalData[i][obj.country]=+obj.value;});i++;}}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'chart bar below-poverty-line'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,this.state.quote),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h6',null,'Proportion of population below the international poverty line of US$1.90 per day (%)'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["k" /* ResponsiveContainer */],{width:'100%',height:300},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["e" /* LineChart */],{cx:'50%',cy:'50%',outerRadius:'80%',data:finalData},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["m" /* XAxis */],{dataKey:'year'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["n" /* YAxis */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["c" /* CartesianGrid */],{strokeDasharray:'3 3'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["l" /* Tooltip */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["d" /* Line */],{connectNulls:true,type:'monotone',dataKey:'Guinea',stroke:'black'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["d" /* Line */],{connectNulls:true,type:'monotone',dataKey:'Ecuador',stroke:'green'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["d" /* Line */],{connectNulls:true,type:'monotone',dataKey:'Russian Federation',stroke:'purple'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["d" /* Line */],{connectNulls:true,type:'monotone',dataKey:'C\xF4te d\'Ivoire',stroke:'orange'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["d" /* Line */],{connectNulls:true,type:'monotone',dataKey:'Venezuela',stroke:'black'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["d" /* Line */],{connectNulls:true,type:'monotone',dataKey:'Zambia',stroke:'brown'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["d" /* Line */],{connectNulls:true,type:'monotone',dataKey:'Armenia',stroke:'#C90016'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["d" /* Line */],{connectNulls:true,type:'monotone',dataKey:'China',stroke:'red'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["d" /* Line */],{connectNulls:true,type:'monotone',dataKey:'Bangladesh',stroke:'maroon'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["d" /* Line */],{connectNulls:true,type:'monotone',dataKey:'Brazil',stroke:'grey'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["d" /* Line */],{connectNulls:true,type:'monotone',dataKey:'Bulgaria',stroke:'#6082B6'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["d" /* Line */],{connectNulls:true,type:'monotone',dataKey:'Columbia',stroke:'#D4AF37'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["d" /* Line */],{connectNulls:true,type:'monotone',dataKey:'Nigeria',stroke:'#00FF00'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["d" /* Line */],{connectNulls:true,type:'monotone',dataKey:'Panama',stroke:'#5218FA'}))));}}]);return PopulationBelowPovertyLine;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PopulationBelowPovertyLine);

/***/ }),
/* 605 */
/***/ (function(module, exports) {

module.exports = {"dimension":[{"label":"GHO","display":"Indicator"},{"label":"PUBLISHSTATE","display":"PUBLISH STATES"},{"label":"YEAR","display":"Year"},{"label":"REGION","display":"WHO region"},{"label":"COUNTRY","display":"Country"},{"label":"AGEGROUP","display":"Age Group"},{"label":"SEX","display":"Sex"}],"fact":[{"dims":{"COUNTRY":"Albania","YEAR":"2012","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"1.1"},{"dims":{"COUNTRY":"Albania","YEAR":"2008","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.4"},{"dims":{"COUNTRY":"Albania","YEAR":"2005","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"1.1"},{"dims":{"COUNTRY":"Albania","YEAR":"2002","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"2.2"},{"dims":{"COUNTRY":"Albania","YEAR":"1996","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"1.1"},{"dims":{"COUNTRY":"Angola","YEAR":"2008","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"30.1"},{"dims":{"COUNTRY":"Angola","YEAR":"2000","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based. Urban only.","Value":"32.3"},{"dims":{"COUNTRY":"Argentina","YEAR":"2013","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based. Urban only.","Value":"1.8"},{"dims":{"COUNTRY":"Argentina","YEAR":"2012","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based. Urban only.","Value":"1.6"},{"dims":{"COUNTRY":"Argentina","YEAR":"2011","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based. Urban only.","Value":"1.5"},{"dims":{"COUNTRY":"Argentina","YEAR":"2010","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based. Urban only.","Value":"2.1"},{"dims":{"COUNTRY":"Argentina","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based. Urban only.","Value":"3.1"},{"dims":{"COUNTRY":"Argentina","YEAR":"2008","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based. Urban only.","Value":"3.0"},{"dims":{"COUNTRY":"Argentina","YEAR":"2007","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based. Urban only.","Value":"3.5"},{"dims":{"COUNTRY":"Argentina","YEAR":"2006","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based. Urban only.","Value":"4.1"},{"dims":{"COUNTRY":"Argentina","YEAR":"2005","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based. Urban only.","Value":"5.4"},{"dims":{"COUNTRY":"Argentina","YEAR":"2004","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based. Urban only.","Value":"7.1"},{"dims":{"COUNTRY":"Argentina","YEAR":"2003","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based. Urban only.","Value":"9.8"},{"dims":{"COUNTRY":"Argentina","YEAR":"2002","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based. Urban only.","Value":"14.0"},{"dims":{"COUNTRY":"Argentina","YEAR":"2001","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based. Urban only.","Value":"9.4"},{"dims":{"COUNTRY":"Argentina","YEAR":"2000","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based. Urban only.","Value":"5.7"},{"dims":{"COUNTRY":"Argentina","YEAR":"1999","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based. Urban only.","Value":"4.8"},{"dims":{"COUNTRY":"Argentina","YEAR":"1998","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based. Urban only.","Value":"4.6"},{"dims":{"COUNTRY":"Argentina","YEAR":"1997","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based. Urban only.","Value":"4.1"},{"dims":{"COUNTRY":"Argentina","YEAR":"1996","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based. Urban only.","Value":"4.6"},{"dims":{"COUNTRY":"Argentina","YEAR":"1995","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based. Urban only.","Value":"4.1"},{"dims":{"COUNTRY":"Argentina","YEAR":"1994","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based. Urban only.","Value":"2.3"},{"dims":{"COUNTRY":"Argentina","YEAR":"1993","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based. Urban only.","Value":"2.4"},{"dims":{"COUNTRY":"Argentina","YEAR":"1992","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based. Urban only.","Value":"2.1"},{"dims":{"COUNTRY":"Argentina","YEAR":"1991","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based. Urban only.","Value":"1.1"},{"dims":{"COUNTRY":"Armenia","YEAR":"2013","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"2.4"},{"dims":{"COUNTRY":"Armenia","YEAR":"2012","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"1.7"},{"dims":{"COUNTRY":"Armenia","YEAR":"2011","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"2.7"},{"dims":{"COUNTRY":"Armenia","YEAR":"2010","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"2.5"},{"dims":{"COUNTRY":"Armenia","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"1.6"},{"dims":{"COUNTRY":"Armenia","YEAR":"2008","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"1.5"},{"dims":{"COUNTRY":"Armenia","YEAR":"2007","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"3.6"},{"dims":{"COUNTRY":"Armenia","YEAR":"2006","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"3.3"},{"dims":{"COUNTRY":"Armenia","YEAR":"2005","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"4.5"},{"dims":{"COUNTRY":"Armenia","YEAR":"2004","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"7.9"},{"dims":{"COUNTRY":"Armenia","YEAR":"2003","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"11.4"},{"dims":{"COUNTRY":"Armenia","YEAR":"2002","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"15.1"},{"dims":{"COUNTRY":"Armenia","YEAR":"2001","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"19.3"},{"dims":{"COUNTRY":"Armenia","YEAR":"1999","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"16.9"},{"dims":{"COUNTRY":"Armenia","YEAR":"1996","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"17.9"},{"dims":{"COUNTRY":"Azerbaijan","YEAR":"2005","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Azerbaijan","YEAR":"2004","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Azerbaijan","YEAR":"2003","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Azerbaijan","YEAR":"2002","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Azerbaijan","YEAR":"2001","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"2.7"},{"dims":{"COUNTRY":"Azerbaijan","YEAR":"1995","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"7.3"},{"dims":{"COUNTRY":"Bangladesh","YEAR":"2010","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"43.7"},{"dims":{"COUNTRY":"Bangladesh","YEAR":"2005","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"51.6"},{"dims":{"COUNTRY":"Bangladesh","YEAR":"2000","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"60.0"},{"dims":{"COUNTRY":"Bangladesh","YEAR":"1995","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"63.5"},{"dims":{"COUNTRY":"Bangladesh","YEAR":"1991","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"72.2"},{"dims":{"COUNTRY":"Belarus","YEAR":"2012","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Belarus","YEAR":"2011","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Belarus","YEAR":"2010","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Belarus","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Belarus","YEAR":"2008","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Belarus","YEAR":"2007","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Belarus","YEAR":"2006","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.1"},{"dims":{"COUNTRY":"Belarus","YEAR":"2005","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.4"},{"dims":{"COUNTRY":"Belarus","YEAR":"2004","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.3"},{"dims":{"COUNTRY":"Belarus","YEAR":"2003","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"1.5"},{"dims":{"COUNTRY":"Belarus","YEAR":"2002","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"2.0"},{"dims":{"COUNTRY":"Belarus","YEAR":"2001","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"1.1"},{"dims":{"COUNTRY":"Belarus","YEAR":"2000","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"2.0"},{"dims":{"COUNTRY":"Belarus","YEAR":"1999","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"2.7"},{"dims":{"COUNTRY":"Belarus","YEAR":"1998","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"3.2"},{"dims":{"COUNTRY":"Belarus","YEAR":"1995","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.7"},{"dims":{"COUNTRY":"Belarus","YEAR":"1993","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.1"},{"dims":{"COUNTRY":"Belize","YEAR":"1999","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"13.9"},{"dims":{"COUNTRY":"Belize","YEAR":"1998","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"14.4"},{"dims":{"COUNTRY":"Belize","YEAR":"1997","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"16.5"},{"dims":{"COUNTRY":"Belize","YEAR":"1996","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"13.3"},{"dims":{"COUNTRY":"Belize","YEAR":"1995","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"12.3"},{"dims":{"COUNTRY":"Belize","YEAR":"1994","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"9.9"},{"dims":{"COUNTRY":"Belize","YEAR":"1993","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"10.1"},{"dims":{"COUNTRY":"Benin","YEAR":"2011","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"53.1"},{"dims":{"COUNTRY":"Benin","YEAR":"2003","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"48.9"},{"dims":{"COUNTRY":"Bhutan","YEAR":"2012","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"2.2"},{"dims":{"COUNTRY":"Bhutan","YEAR":"2007","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"8.0"},{"dims":{"COUNTRY":"Bhutan","YEAR":"2003","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"24.9"},{"dims":{"COUNTRY":"Bolivia (Plurinational State of)","YEAR":"2013","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"7.7"},{"dims":{"COUNTRY":"Bolivia (Plurinational State of)","YEAR":"2012","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"9.1"},{"dims":{"COUNTRY":"Bolivia (Plurinational State of)","YEAR":"2011","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"8.0"},{"dims":{"COUNTRY":"Bolivia (Plurinational State of)","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"11.9"},{"dims":{"COUNTRY":"Bolivia (Plurinational State of)","YEAR":"2008","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"11.9"},{"dims":{"COUNTRY":"Bolivia (Plurinational State of)","YEAR":"2007","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"13.9"},{"dims":{"COUNTRY":"Bolivia (Plurinational State of)","YEAR":"2006","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"17.9"},{"dims":{"COUNTRY":"Bolivia (Plurinational State of)","YEAR":"2005","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"20.4"},{"dims":{"COUNTRY":"Bolivia (Plurinational State of)","YEAR":"2004","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"13.7"},{"dims":{"COUNTRY":"Bolivia (Plurinational State of)","YEAR":"2002","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"24.9"},{"dims":{"COUNTRY":"Bolivia (Plurinational State of)","YEAR":"2001","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"23.7"},{"dims":{"COUNTRY":"Bolivia (Plurinational State of)","YEAR":"2000","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"29.7"},{"dims":{"COUNTRY":"Bolivia (Plurinational State of)","YEAR":"1999","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"25.3"},{"dims":{"COUNTRY":"Bolivia (Plurinational State of)","YEAR":"1997","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"19.3"},{"dims":{"COUNTRY":"Bolivia (Plurinational State of)","YEAR":"1993","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"18.1"},{"dims":{"COUNTRY":"Bolivia (Plurinational State of)","YEAR":"1990","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"8.2"},{"dims":{"COUNTRY":"Bosnia and Herzegovina","YEAR":"2007","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.1"},{"dims":{"COUNTRY":"Bosnia and Herzegovina","YEAR":"2004","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.2"},{"dims":{"COUNTRY":"Bosnia and Herzegovina","YEAR":"2001","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.3"},{"dims":{"COUNTRY":"Botswana","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"18.2"},{"dims":{"COUNTRY":"Botswana","YEAR":"2002","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"29.8"},{"dims":{"COUNTRY":"Botswana","YEAR":"1993","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"34.8"},{"dims":{"COUNTRY":"Brazil","YEAR":"2013","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"4.9"},{"dims":{"COUNTRY":"Brazil","YEAR":"2012","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"4.6"},{"dims":{"COUNTRY":"Brazil","YEAR":"2011","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"5.5"},{"dims":{"COUNTRY":"Brazil","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"6.2"},{"dims":{"COUNTRY":"Brazil","YEAR":"2008","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"6.3"},{"dims":{"COUNTRY":"Brazil","YEAR":"2007","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"7.6"},{"dims":{"COUNTRY":"Brazil","YEAR":"2006","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"7.9"},{"dims":{"COUNTRY":"Brazil","YEAR":"2005","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"9.6"},{"dims":{"COUNTRY":"Brazil","YEAR":"2004","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"11.0"},{"dims":{"COUNTRY":"Brazil","YEAR":"2003","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"12.7"},{"dims":{"COUNTRY":"Brazil","YEAR":"2002","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"12.3"},{"dims":{"COUNTRY":"Brazil","YEAR":"2001","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"13.6"},{"dims":{"COUNTRY":"Brazil","YEAR":"1999","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"13.4"},{"dims":{"COUNTRY":"Brazil","YEAR":"1998","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"12.7"},{"dims":{"COUNTRY":"Brazil","YEAR":"1997","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"14.0"},{"dims":{"COUNTRY":"Brazil","YEAR":"1996","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"14.2"},{"dims":{"COUNTRY":"Brazil","YEAR":"1995","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"13.0"},{"dims":{"COUNTRY":"Brazil","YEAR":"1993","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"19.9"},{"dims":{"COUNTRY":"Brazil","YEAR":"1992","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"20.8"},{"dims":{"COUNTRY":"Brazil","YEAR":"1990","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"20.6"},{"dims":{"COUNTRY":"Bulgaria","YEAR":"2012","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"2.0"},{"dims":{"COUNTRY":"Bulgaria","YEAR":"2011","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"2.2"},{"dims":{"COUNTRY":"Bulgaria","YEAR":"2010","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"1.9"},{"dims":{"COUNTRY":"Bulgaria","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"1.2"},{"dims":{"COUNTRY":"Bulgaria","YEAR":"2008","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"1.2"},{"dims":{"COUNTRY":"Bulgaria","YEAR":"2007","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.4"},{"dims":{"COUNTRY":"Bulgaria","YEAR":"2006","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"5.4"},{"dims":{"COUNTRY":"Bulgaria","YEAR":"2003","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.9"},{"dims":{"COUNTRY":"Bulgaria","YEAR":"2001","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"2.0"},{"dims":{"COUNTRY":"Bulgaria","YEAR":"1997","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.5"},{"dims":{"COUNTRY":"Bulgaria","YEAR":"1995","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"1.2"},{"dims":{"COUNTRY":"Bulgaria","YEAR":"1994","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.2"},{"dims":{"COUNTRY":"Bulgaria","YEAR":"1992","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.0"},{"dims":{"COUNTRY":"Burkina Faso","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"55.3"},{"dims":{"COUNTRY":"Burkina Faso","YEAR":"2003","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"57.3"},{"dims":{"COUNTRY":"Burkina Faso","YEAR":"1998","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"81.6"},{"dims":{"COUNTRY":"Burkina Faso","YEAR":"1994","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"83.1"},{"dims":{"COUNTRY":"Burundi","YEAR":"2006","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"77.7"},{"dims":{"COUNTRY":"Burundi","YEAR":"1998","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"84.1"},{"dims":{"COUNTRY":"Burundi","YEAR":"1992","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"81.1"},{"dims":{"COUNTRY":"Côte d'Ivoire","YEAR":"2008","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"29.0"},{"dims":{"COUNTRY":"Côte d'Ivoire","YEAR":"2002","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"23.0"},{"dims":{"COUNTRY":"Côte d'Ivoire","YEAR":"1998","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"25.7"},{"dims":{"COUNTRY":"Côte d'Ivoire","YEAR":"1995","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"19.1"},{"dims":{"COUNTRY":"Côte d'Ivoire","YEAR":"1993","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"19.2"},{"dims":{"COUNTRY":"Côte d'Ivoire","YEAR":"1992","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"21.6"},{"dims":{"COUNTRY":"Cabo Verde","YEAR":"2007","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"17.6"},{"dims":{"COUNTRY":"Cabo Verde","YEAR":"2001","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"28.2"},{"dims":{"COUNTRY":"Cambodia","YEAR":"2012","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"6.2"},{"dims":{"COUNTRY":"Cambodia","YEAR":"2011","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"8.9"},{"dims":{"COUNTRY":"Cambodia","YEAR":"2010","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"10.0"},{"dims":{"COUNTRY":"Cambodia","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"11.7"},{"dims":{"COUNTRY":"Cambodia","YEAR":"2008","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"19.5"},{"dims":{"COUNTRY":"Cambodia","YEAR":"2007","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"29.4"},{"dims":{"COUNTRY":"Cambodia","YEAR":"2004","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"32.0"},{"dims":{"COUNTRY":"Cambodia","YEAR":"1994","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"47.1"},{"dims":{"COUNTRY":"Cameroon","YEAR":"2007","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"29.3"},{"dims":{"COUNTRY":"Cameroon","YEAR":"2001","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"23.1"},{"dims":{"COUNTRY":"Cameroon","YEAR":"1996","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"48.1"},{"dims":{"COUNTRY":"Central African Republic","YEAR":"2008","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"66.3"},{"dims":{"COUNTRY":"Central African Republic","YEAR":"2003","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"64.8"},{"dims":{"COUNTRY":"Central African Republic","YEAR":"1992","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"84.3"},{"dims":{"COUNTRY":"Chad","YEAR":"2011","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"38.4"},{"dims":{"COUNTRY":"Chad","YEAR":"2003","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"62.9"},{"dims":{"COUNTRY":"Chile","YEAR":"2013","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.9"},{"dims":{"COUNTRY":"Chile","YEAR":"2011","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"1.3"},{"dims":{"COUNTRY":"Chile","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"1.7"},{"dims":{"COUNTRY":"Chile","YEAR":"2006","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"1.7"},{"dims":{"COUNTRY":"Chile","YEAR":"2003","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"2.6"},{"dims":{"COUNTRY":"Chile","YEAR":"2000","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"3.1"},{"dims":{"COUNTRY":"Chile","YEAR":"1998","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"3.5"},{"dims":{"COUNTRY":"Chile","YEAR":"1996","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"3.4"},{"dims":{"COUNTRY":"Chile","YEAR":"1994","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"4.9"},{"dims":{"COUNTRY":"Chile","YEAR":"1992","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"4.6"},{"dims":{"COUNTRY":"Chile","YEAR":"1990","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"7.9"},{"dims":{"COUNTRY":"China","YEAR":"2010","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based. Weighted average of rural and urban estimates.","Value":"11.2"},{"dims":{"COUNTRY":"China","YEAR":"2008","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based. Weighted average of rural and urban estimates.","Value":"14.7"},{"dims":{"COUNTRY":"China","YEAR":"2005","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based. Weighted average of rural and urban estimates.","Value":"18.8"},{"dims":{"COUNTRY":"China","YEAR":"2002","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based. Weighted average of rural and urban estimates.","Value":"32.0"},{"dims":{"COUNTRY":"China","YEAR":"1999","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based. Weighted average of rural and urban estimates.","Value":"40.5"},{"dims":{"COUNTRY":"China","YEAR":"1996","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based. Weighted average of rural and urban estimates.","Value":"42.1"},{"dims":{"COUNTRY":"China","YEAR":"1993","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based. Weighted average of rural and urban estimates.","Value":"57.0"},{"dims":{"COUNTRY":"China","YEAR":"1990","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based. Weighted average of rural and urban estimates.","Value":"66.6"},{"dims":{"COUNTRY":"Colombia","YEAR":"2013","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"6.1"},{"dims":{"COUNTRY":"Colombia","YEAR":"2012","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"7.1"},{"dims":{"COUNTRY":"Colombia","YEAR":"2011","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"6.6"},{"dims":{"COUNTRY":"Colombia","YEAR":"2010","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"8.1"},{"dims":{"COUNTRY":"Colombia","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"9.3"},{"dims":{"COUNTRY":"Colombia","YEAR":"2008","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"10.7"},{"dims":{"COUNTRY":"Colombia","YEAR":"2007","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"17.4"},{"dims":{"COUNTRY":"Colombia","YEAR":"2006","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"20.7"},{"dims":{"COUNTRY":"Colombia","YEAR":"2005","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"10.4"},{"dims":{"COUNTRY":"Colombia","YEAR":"2004","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"11.8"},{"dims":{"COUNTRY":"Colombia","YEAR":"2003","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"12.8"},{"dims":{"COUNTRY":"Colombia","YEAR":"2002","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"14.7"},{"dims":{"COUNTRY":"Colombia","YEAR":"2001","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"20.8"},{"dims":{"COUNTRY":"Colombia","YEAR":"2000","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"15.9"},{"dims":{"COUNTRY":"Colombia","YEAR":"1999","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"19.2"},{"dims":{"COUNTRY":"Colombia","YEAR":"1996","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"15.2"},{"dims":{"COUNTRY":"Colombia","YEAR":"1992","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"8.1"},{"dims":{"COUNTRY":"Colombia","YEAR":"1991","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based. Urban only.","Value":"10.4"},{"dims":{"COUNTRY":"Comoros","YEAR":"2004","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"13.5"},{"dims":{"COUNTRY":"Congo","YEAR":"2011","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"28.7"},{"dims":{"COUNTRY":"Congo","YEAR":"2005","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"50.2"},{"dims":{"COUNTRY":"Costa Rica","YEAR":"2013","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"1.7"},{"dims":{"COUNTRY":"Costa Rica","YEAR":"2012","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"1.7"},{"dims":{"COUNTRY":"Costa Rica","YEAR":"2011","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"1.8"},{"dims":{"COUNTRY":"Costa Rica","YEAR":"2010","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"1.6"},{"dims":{"COUNTRY":"Costa Rica","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"3.3"},{"dims":{"COUNTRY":"Costa Rica","YEAR":"2008","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"2.7"},{"dims":{"COUNTRY":"Costa Rica","YEAR":"2007","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"2.4"},{"dims":{"COUNTRY":"Costa Rica","YEAR":"2006","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"4.4"},{"dims":{"COUNTRY":"Costa Rica","YEAR":"2005","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"4.4"},{"dims":{"COUNTRY":"Costa Rica","YEAR":"2004","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"5.6"},{"dims":{"COUNTRY":"Costa Rica","YEAR":"2003","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"6.1"},{"dims":{"COUNTRY":"Costa Rica","YEAR":"2002","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"6.3"},{"dims":{"COUNTRY":"Costa Rica","YEAR":"2001","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"6.5"},{"dims":{"COUNTRY":"Costa Rica","YEAR":"2000","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"6.5"},{"dims":{"COUNTRY":"Costa Rica","YEAR":"1999","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"6.4"},{"dims":{"COUNTRY":"Costa Rica","YEAR":"1998","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"5.1"},{"dims":{"COUNTRY":"Costa Rica","YEAR":"1997","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"6.5"},{"dims":{"COUNTRY":"Costa Rica","YEAR":"1996","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"8.0"},{"dims":{"COUNTRY":"Costa Rica","YEAR":"1995","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"6.9"},{"dims":{"COUNTRY":"Costa Rica","YEAR":"1994","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"6.7"},{"dims":{"COUNTRY":"Costa Rica","YEAR":"1993","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"8.0"},{"dims":{"COUNTRY":"Costa Rica","YEAR":"1992","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"9.6"},{"dims":{"COUNTRY":"Costa Rica","YEAR":"1991","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"11.7"},{"dims":{"COUNTRY":"Costa Rica","YEAR":"1990","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"9.9"},{"dims":{"COUNTRY":"Croatia","YEAR":"2011","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.9"},{"dims":{"COUNTRY":"Croatia","YEAR":"2010","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Croatia","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Croatia","YEAR":"2008","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Croatia","YEAR":"2004","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Croatia","YEAR":"2001","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.1"},{"dims":{"COUNTRY":"Croatia","YEAR":"2000","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.1"},{"dims":{"COUNTRY":"Croatia","YEAR":"1999","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.2"},{"dims":{"COUNTRY":"Croatia","YEAR":"1998","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Czechia","YEAR":"2012","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.1"},{"dims":{"COUNTRY":"Czechia","YEAR":"2011","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.1"},{"dims":{"COUNTRY":"Czechia","YEAR":"2010","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.0"},{"dims":{"COUNTRY":"Czechia","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.1"},{"dims":{"COUNTRY":"Czechia","YEAR":"2008","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.0"},{"dims":{"COUNTRY":"Czechia","YEAR":"2007","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.1"},{"dims":{"COUNTRY":"Czechia","YEAR":"2006","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.1"},{"dims":{"COUNTRY":"Czechia","YEAR":"2005","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.0"},{"dims":{"COUNTRY":"Czechia","YEAR":"2004","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.0"},{"dims":{"COUNTRY":"Czechia","YEAR":"1996","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.2"},{"dims":{"COUNTRY":"Czechia","YEAR":"1993","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.0"},{"dims":{"COUNTRY":"Democratic Republic of the Congo","YEAR":"2012","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"77.2"},{"dims":{"COUNTRY":"Democratic Republic of the Congo","YEAR":"2004","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"91.2"},{"dims":{"COUNTRY":"Djibouti","YEAR":"2012","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"18.3"},{"dims":{"COUNTRY":"Djibouti","YEAR":"2002","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"20.6"},{"dims":{"COUNTRY":"Dominican Republic","YEAR":"2013","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"2.3"},{"dims":{"COUNTRY":"Dominican Republic","YEAR":"2012","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"2.6"},{"dims":{"COUNTRY":"Dominican Republic","YEAR":"2011","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"2.9"},{"dims":{"COUNTRY":"Dominican Republic","YEAR":"2010","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"2.6"},{"dims":{"COUNTRY":"Dominican Republic","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"3.3"},{"dims":{"COUNTRY":"Dominican Republic","YEAR":"2008","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"3.8"},{"dims":{"COUNTRY":"Dominican Republic","YEAR":"2007","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"4.3"},{"dims":{"COUNTRY":"Dominican Republic","YEAR":"2006","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"4.6"},{"dims":{"COUNTRY":"Dominican Republic","YEAR":"2005","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"5.8"},{"dims":{"COUNTRY":"Dominican Republic","YEAR":"2004","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"8.6"},{"dims":{"COUNTRY":"Dominican Republic","YEAR":"2003","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"6.8"},{"dims":{"COUNTRY":"Dominican Republic","YEAR":"2002","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"5.8"},{"dims":{"COUNTRY":"Dominican Republic","YEAR":"2001","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"4.2"},{"dims":{"COUNTRY":"Dominican Republic","YEAR":"2000","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"5.5"},{"dims":{"COUNTRY":"Dominican Republic","YEAR":"1997","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"5.2"},{"dims":{"COUNTRY":"Dominican Republic","YEAR":"1996","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"4.9"},{"dims":{"COUNTRY":"Dominican Republic","YEAR":"1992","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"5.0"},{"dims":{"COUNTRY":"Ecuador","YEAR":"2013","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"4.4"},{"dims":{"COUNTRY":"Ecuador","YEAR":"2012","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"5.9"},{"dims":{"COUNTRY":"Ecuador","YEAR":"2011","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"5.9"},{"dims":{"COUNTRY":"Ecuador","YEAR":"2010","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"7.1"},{"dims":{"COUNTRY":"Ecuador","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"8.9"},{"dims":{"COUNTRY":"Ecuador","YEAR":"2008","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"9.0"},{"dims":{"COUNTRY":"Ecuador","YEAR":"2007","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"10.1"},{"dims":{"COUNTRY":"Ecuador","YEAR":"2006","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"9.3"},{"dims":{"COUNTRY":"Ecuador","YEAR":"2005","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"13.6"},{"dims":{"COUNTRY":"Ecuador","YEAR":"2004","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"15.2"},{"dims":{"COUNTRY":"Ecuador","YEAR":"2003","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"16.9"},{"dims":{"COUNTRY":"Ecuador","YEAR":"2000","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"28.2"},{"dims":{"COUNTRY":"Ecuador","YEAR":"1999","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"21.8"},{"dims":{"COUNTRY":"Ecuador","YEAR":"1998","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"15.7"},{"dims":{"COUNTRY":"Ecuador","YEAR":"1995","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based. Urban only.","Value":"19.5"},{"dims":{"COUNTRY":"Ecuador","YEAR":"1994","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"17.1"},{"dims":{"COUNTRY":"El Salvador","YEAR":"2013","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"3.3"},{"dims":{"COUNTRY":"El Salvador","YEAR":"2012","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"4.2"},{"dims":{"COUNTRY":"El Salvador","YEAR":"2011","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"4.5"},{"dims":{"COUNTRY":"El Salvador","YEAR":"2010","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"7.2"},{"dims":{"COUNTRY":"El Salvador","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"6.4"},{"dims":{"COUNTRY":"El Salvador","YEAR":"2008","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"6.9"},{"dims":{"COUNTRY":"El Salvador","YEAR":"2007","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"4.5"},{"dims":{"COUNTRY":"El Salvador","YEAR":"2006","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"6.4"},{"dims":{"COUNTRY":"El Salvador","YEAR":"2005","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"9.6"},{"dims":{"COUNTRY":"El Salvador","YEAR":"2004","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"10.0"},{"dims":{"COUNTRY":"El Salvador","YEAR":"2003","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"15.8"},{"dims":{"COUNTRY":"El Salvador","YEAR":"2002","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"13.1"},{"dims":{"COUNTRY":"El Salvador","YEAR":"2001","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"12.7"},{"dims":{"COUNTRY":"El Salvador","YEAR":"2000","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"11.8"},{"dims":{"COUNTRY":"El Salvador","YEAR":"1999","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"16.3"},{"dims":{"COUNTRY":"El Salvador","YEAR":"1998","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"20.0"},{"dims":{"COUNTRY":"El Salvador","YEAR":"1996","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"22.0"},{"dims":{"COUNTRY":"El Salvador","YEAR":"1995","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"19.9"},{"dims":{"COUNTRY":"El Salvador","YEAR":"1991","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"20.7"},{"dims":{"COUNTRY":"Estonia","YEAR":"2012","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"1.0"},{"dims":{"COUNTRY":"Estonia","YEAR":"2011","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"1.2"},{"dims":{"COUNTRY":"Estonia","YEAR":"2010","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.9"},{"dims":{"COUNTRY":"Estonia","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.7"},{"dims":{"COUNTRY":"Estonia","YEAR":"2008","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.5"},{"dims":{"COUNTRY":"Estonia","YEAR":"2007","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.5"},{"dims":{"COUNTRY":"Estonia","YEAR":"2006","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.9"},{"dims":{"COUNTRY":"Estonia","YEAR":"2005","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"1.0"},{"dims":{"COUNTRY":"Estonia","YEAR":"2004","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.5"},{"dims":{"COUNTRY":"Estonia","YEAR":"2003","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"1.1"},{"dims":{"COUNTRY":"Estonia","YEAR":"2002","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"1.3"},{"dims":{"COUNTRY":"Estonia","YEAR":"2001","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"1.2"},{"dims":{"COUNTRY":"Estonia","YEAR":"2000","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"1.4"},{"dims":{"COUNTRY":"Estonia","YEAR":"1998","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.2"},{"dims":{"COUNTRY":"Estonia","YEAR":"1995","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.6"},{"dims":{"COUNTRY":"Estonia","YEAR":"1993","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"1.3"},{"dims":{"COUNTRY":"Ethiopia","YEAR":"2010","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"33.5"},{"dims":{"COUNTRY":"Ethiopia","YEAR":"2004","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"36.3"},{"dims":{"COUNTRY":"Ethiopia","YEAR":"1999","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"55.3"},{"dims":{"COUNTRY":"Ethiopia","YEAR":"1995","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"67.9"},{"dims":{"COUNTRY":"Fiji","YEAR":"2008","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"3.6"},{"dims":{"COUNTRY":"Fiji","YEAR":"2002","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"5.1"},{"dims":{"COUNTRY":"Gabon","YEAR":"2005","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"8.0"},{"dims":{"COUNTRY":"Gambia","YEAR":"2003","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"45.3"},{"dims":{"COUNTRY":"Gambia","YEAR":"1998","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"73.8"},{"dims":{"COUNTRY":"Georgia","YEAR":"2013","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"11.5"},{"dims":{"COUNTRY":"Georgia","YEAR":"2012","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"15.5"},{"dims":{"COUNTRY":"Georgia","YEAR":"2011","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"17.8"},{"dims":{"COUNTRY":"Georgia","YEAR":"2010","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"19.6"},{"dims":{"COUNTRY":"Georgia","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"15.4"},{"dims":{"COUNTRY":"Georgia","YEAR":"2008","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"15.5"},{"dims":{"COUNTRY":"Georgia","YEAR":"2007","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"16.3"},{"dims":{"COUNTRY":"Georgia","YEAR":"2006","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"15.3"},{"dims":{"COUNTRY":"Georgia","YEAR":"2005","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"16.2"},{"dims":{"COUNTRY":"Georgia","YEAR":"2004","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"16.8"},{"dims":{"COUNTRY":"Georgia","YEAR":"2003","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"17.4"},{"dims":{"COUNTRY":"Georgia","YEAR":"2002","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"15.6"},{"dims":{"COUNTRY":"Georgia","YEAR":"2001","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"19.4"},{"dims":{"COUNTRY":"Georgia","YEAR":"2000","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"19.4"},{"dims":{"COUNTRY":"Georgia","YEAR":"1999","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"18.7"},{"dims":{"COUNTRY":"Georgia","YEAR":"1998","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"14.6"},{"dims":{"COUNTRY":"Georgia","YEAR":"1997","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"16.4"},{"dims":{"COUNTRY":"Georgia","YEAR":"1996","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"5.5"},{"dims":{"COUNTRY":"Ghana","YEAR":"2005","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"25.2"},{"dims":{"COUNTRY":"Ghana","YEAR":"1998","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"33.9"},{"dims":{"COUNTRY":"Ghana","YEAR":"1991","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"47.4"},{"dims":{"COUNTRY":"Guatemala","YEAR":"2011","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"11.5"},{"dims":{"COUNTRY":"Guatemala","YEAR":"2006","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"11.5"},{"dims":{"COUNTRY":"Guatemala","YEAR":"2004","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"14.5"},{"dims":{"COUNTRY":"Guatemala","YEAR":"2003","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"16.5"},{"dims":{"COUNTRY":"Guatemala","YEAR":"2002","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"18.4"},{"dims":{"COUNTRY":"Guatemala","YEAR":"2000","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"10.1"},{"dims":{"COUNTRY":"Guatemala","YEAR":"1998","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"13.2"},{"dims":{"COUNTRY":"Guinea","YEAR":"2012","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"35.3"},{"dims":{"COUNTRY":"Guinea","YEAR":"2007","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"59.7"},{"dims":{"COUNTRY":"Guinea","YEAR":"2002","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"61.6"},{"dims":{"COUNTRY":"Guinea","YEAR":"1994","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"48.5"},{"dims":{"COUNTRY":"Guinea","YEAR":"1991","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"92.3"},{"dims":{"COUNTRY":"Guinea-Bissau","YEAR":"2010","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"67.1"},{"dims":{"COUNTRY":"Guinea-Bissau","YEAR":"2002","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"53.9"},{"dims":{"COUNTRY":"Guinea-Bissau","YEAR":"1993","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"64.0"},{"dims":{"COUNTRY":"Guinea-Bissau","YEAR":"1991","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"43.0"},{"dims":{"COUNTRY":"Guyana","YEAR":"1998","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"14.0"},{"dims":{"COUNTRY":"Guyana","YEAR":"1992","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"33.2"},{"dims":{"COUNTRY":"Haiti","YEAR":"2012","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"53.9"},{"dims":{"COUNTRY":"Haiti","YEAR":"2001","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"55.6"},{"dims":{"COUNTRY":"Honduras","YEAR":"2013","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"18.9"},{"dims":{"COUNTRY":"Honduras","YEAR":"2012","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"21.4"},{"dims":{"COUNTRY":"Honduras","YEAR":"2011","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"18.8"},{"dims":{"COUNTRY":"Honduras","YEAR":"2010","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"15.5"},{"dims":{"COUNTRY":"Honduras","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"14.1"},{"dims":{"COUNTRY":"Honduras","YEAR":"2008","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"16.1"},{"dims":{"COUNTRY":"Honduras","YEAR":"2007","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"17.4"},{"dims":{"COUNTRY":"Honduras","YEAR":"2006","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"23.8"},{"dims":{"COUNTRY":"Honduras","YEAR":"2005","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"27.8"},{"dims":{"COUNTRY":"Honduras","YEAR":"2004","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"26.3"},{"dims":{"COUNTRY":"Honduras","YEAR":"2003","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"27.5"},{"dims":{"COUNTRY":"Honduras","YEAR":"2002","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"29.1"},{"dims":{"COUNTRY":"Honduras","YEAR":"2001","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"18.3"},{"dims":{"COUNTRY":"Honduras","YEAR":"1999","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"26.5"},{"dims":{"COUNTRY":"Honduras","YEAR":"1998","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"25.9"},{"dims":{"COUNTRY":"Honduras","YEAR":"1997","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"21.2"},{"dims":{"COUNTRY":"Honduras","YEAR":"1996","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"30.4"},{"dims":{"COUNTRY":"Honduras","YEAR":"1995","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"27.7"},{"dims":{"COUNTRY":"Honduras","YEAR":"1994","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"26.7"},{"dims":{"COUNTRY":"Honduras","YEAR":"1993","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"23.6"},{"dims":{"COUNTRY":"Honduras","YEAR":"1992","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"28.7"},{"dims":{"COUNTRY":"Honduras","YEAR":"1991","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"33.4"},{"dims":{"COUNTRY":"Honduras","YEAR":"1990","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"44.3"},{"dims":{"COUNTRY":"Hungary","YEAR":"2012","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.3"},{"dims":{"COUNTRY":"Hungary","YEAR":"2011","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.1"},{"dims":{"COUNTRY":"Hungary","YEAR":"2010","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.1"},{"dims":{"COUNTRY":"Hungary","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.1"},{"dims":{"COUNTRY":"Hungary","YEAR":"2008","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.0"},{"dims":{"COUNTRY":"Hungary","YEAR":"2007","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Hungary","YEAR":"2006","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.1"},{"dims":{"COUNTRY":"Hungary","YEAR":"2005","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Hungary","YEAR":"2004","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Hungary","YEAR":"2003","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Hungary","YEAR":"2002","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Hungary","YEAR":"2001","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Hungary","YEAR":"2000","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Hungary","YEAR":"1999","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Hungary","YEAR":"1998","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Hungary","YEAR":"1993","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.2"},{"dims":{"COUNTRY":"India","YEAR":"2011","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based. Weighted average of rural and urban estimates.","Value":"21.3"},{"dims":{"COUNTRY":"India","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based. Weighted average of rural and urban estimates.","Value":"31.4"},{"dims":{"COUNTRY":"India","YEAR":"2004","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based. Weighted average of rural and urban estimates.","Value":"38.4"},{"dims":{"COUNTRY":"India","YEAR":"1993","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based. Weighted average of rural and urban estimates.","Value":"46.1"},{"dims":{"COUNTRY":"Indonesia","YEAR":"2010","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based. Weighted average of rural and urban estimates.","Value":"15.9"},{"dims":{"COUNTRY":"Indonesia","YEAR":"2008","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based. Weighted average of rural and urban estimates.","Value":"21.3"},{"dims":{"COUNTRY":"Indonesia","YEAR":"2005","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based. Weighted average of rural and urban estimates.","Value":"21.6"},{"dims":{"COUNTRY":"Indonesia","YEAR":"2002","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based. Weighted average of rural and urban estimates.","Value":"23.4"},{"dims":{"COUNTRY":"Indonesia","YEAR":"1999","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based. Weighted average of rural and urban estimates.","Value":"40.0"},{"dims":{"COUNTRY":"Indonesia","YEAR":"1996","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based. Weighted average of rural and urban estimates.","Value":"45.9"},{"dims":{"COUNTRY":"Indonesia","YEAR":"1993","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based. Weighted average of rural and urban estimates.","Value":"57.1"},{"dims":{"COUNTRY":"Indonesia","YEAR":"1990","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based. Weighted average of rural and urban estimates.","Value":"57.3"},{"dims":{"COUNTRY":"Iran (Islamic Republic of)","YEAR":"2013","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.1"},{"dims":{"COUNTRY":"Iran (Islamic Republic of)","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.3"},{"dims":{"COUNTRY":"Iran (Islamic Republic of)","YEAR":"2005","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"2.6"},{"dims":{"COUNTRY":"Iran (Islamic Republic of)","YEAR":"1998","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"2.2"},{"dims":{"COUNTRY":"Iran (Islamic Republic of)","YEAR":"1994","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"2.3"},{"dims":{"COUNTRY":"Iran (Islamic Republic of)","YEAR":"1990","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"5.3"},{"dims":{"COUNTRY":"Jamaica","YEAR":"2004","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"1.7"},{"dims":{"COUNTRY":"Jamaica","YEAR":"2002","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"2.8"},{"dims":{"COUNTRY":"Jamaica","YEAR":"1999","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"2.6"},{"dims":{"COUNTRY":"Jamaica","YEAR":"1996","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"3.4"},{"dims":{"COUNTRY":"Jamaica","YEAR":"1993","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"9.8"},{"dims":{"COUNTRY":"Jamaica","YEAR":"1990","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"4.6"},{"dims":{"COUNTRY":"Jordan","YEAR":"2010","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.1"},{"dims":{"COUNTRY":"Jordan","YEAR":"2008","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.1"},{"dims":{"COUNTRY":"Jordan","YEAR":"2006","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.3"},{"dims":{"COUNTRY":"Jordan","YEAR":"2002","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"1.0"},{"dims":{"COUNTRY":"Jordan","YEAR":"1997","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"1.5"},{"dims":{"COUNTRY":"Jordan","YEAR":"1992","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"4.1"},{"dims":{"COUNTRY":"Kazakhstan","YEAR":"2013","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Kazakhstan","YEAR":"2012","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.1"},{"dims":{"COUNTRY":"Kazakhstan","YEAR":"2011","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Kazakhstan","YEAR":"2010","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.1"},{"dims":{"COUNTRY":"Kazakhstan","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.2"},{"dims":{"COUNTRY":"Kazakhstan","YEAR":"2008","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.1"},{"dims":{"COUNTRY":"Kazakhstan","YEAR":"2007","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.5"},{"dims":{"COUNTRY":"Kazakhstan","YEAR":"2006","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.6"},{"dims":{"COUNTRY":"Kazakhstan","YEAR":"2005","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.2"},{"dims":{"COUNTRY":"Kazakhstan","YEAR":"2004","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"2.9"},{"dims":{"COUNTRY":"Kazakhstan","YEAR":"2003","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"4.1"},{"dims":{"COUNTRY":"Kazakhstan","YEAR":"2002","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"6.5"},{"dims":{"COUNTRY":"Kazakhstan","YEAR":"2001","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"10.1"},{"dims":{"COUNTRY":"Kazakhstan","YEAR":"1996","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"6.3"},{"dims":{"COUNTRY":"Kazakhstan","YEAR":"1993","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"6.5"},{"dims":{"COUNTRY":"Kenya","YEAR":"2005","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"33.6"},{"dims":{"COUNTRY":"Kenya","YEAR":"1997","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"21.5"},{"dims":{"COUNTRY":"Kenya","YEAR":"1994","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"18.8"},{"dims":{"COUNTRY":"Kenya","YEAR":"1992","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"23.1"},{"dims":{"COUNTRY":"Kiribati","YEAR":"2006","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"14.1"},{"dims":{"COUNTRY":"Kyrgyzstan","YEAR":"2012","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"2.9"},{"dims":{"COUNTRY":"Kyrgyzstan","YEAR":"2011","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"1.8"},{"dims":{"COUNTRY":"Kyrgyzstan","YEAR":"2010","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"4.0"},{"dims":{"COUNTRY":"Kyrgyzstan","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"3.3"},{"dims":{"COUNTRY":"Kyrgyzstan","YEAR":"2008","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"3.5"},{"dims":{"COUNTRY":"Kyrgyzstan","YEAR":"2007","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"3.9"},{"dims":{"COUNTRY":"Kyrgyzstan","YEAR":"2006","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"15.7"},{"dims":{"COUNTRY":"Kyrgyzstan","YEAR":"2005","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"22.0"},{"dims":{"COUNTRY":"Kyrgyzstan","YEAR":"2004","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"13.6"},{"dims":{"COUNTRY":"Kyrgyzstan","YEAR":"2003","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"28.1"},{"dims":{"COUNTRY":"Kyrgyzstan","YEAR":"2002","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"34.4"},{"dims":{"COUNTRY":"Kyrgyzstan","YEAR":"2001","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"36.4"},{"dims":{"COUNTRY":"Kyrgyzstan","YEAR":"2000","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"42.2"},{"dims":{"COUNTRY":"Kyrgyzstan","YEAR":"1998","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"30.6"},{"dims":{"COUNTRY":"Kyrgyzstan","YEAR":"1993","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"44.3"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2012","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"30.0"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2007","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"36.3"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2002","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"42.7"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"1997","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"46.8"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"1992","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"42.6"},{"dims":{"COUNTRY":"Latvia","YEAR":"2012","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"1.4"},{"dims":{"COUNTRY":"Latvia","YEAR":"2011","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"1.3"},{"dims":{"COUNTRY":"Latvia","YEAR":"2010","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"1.9"},{"dims":{"COUNTRY":"Latvia","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.3"},{"dims":{"COUNTRY":"Latvia","YEAR":"2008","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Latvia","YEAR":"2007","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Latvia","YEAR":"2006","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"1.3"},{"dims":{"COUNTRY":"Latvia","YEAR":"2005","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"2.7"},{"dims":{"COUNTRY":"Latvia","YEAR":"2004","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.3"},{"dims":{"COUNTRY":"Latvia","YEAR":"2003","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.6"},{"dims":{"COUNTRY":"Latvia","YEAR":"2002","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.7"},{"dims":{"COUNTRY":"Latvia","YEAR":"1998","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"10.1"},{"dims":{"COUNTRY":"Latvia","YEAR":"1997","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"9.7"},{"dims":{"COUNTRY":"Latvia","YEAR":"1996","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"1.6"},{"dims":{"COUNTRY":"Latvia","YEAR":"1995","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.0"},{"dims":{"COUNTRY":"Latvia","YEAR":"1993","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.0"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2010","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"59.7"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2002","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"61.3"},{"dims":{"COUNTRY":"Lesotho","YEAR":"1994","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"69.6"},{"dims":{"COUNTRY":"Liberia","YEAR":"2007","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"68.6"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2012","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"1.0"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2011","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.9"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2010","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"1.7"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"2.3"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2008","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.2"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2007","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"1.2"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2006","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"1.6"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2005","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"1.8"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2004","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.1"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2003","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.2"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2002","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.5"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2001","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.6"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2000","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.3"},{"dims":{"COUNTRY":"Lithuania","YEAR":"1999","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.4"},{"dims":{"COUNTRY":"Lithuania","YEAR":"1998","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.3"},{"dims":{"COUNTRY":"Lithuania","YEAR":"1996","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Lithuania","YEAR":"1993","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"7.0"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2010","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"81.8"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2005","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"74.1"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2001","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"68.7"},{"dims":{"COUNTRY":"Madagascar","YEAR":"1999","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"64.1"},{"dims":{"COUNTRY":"Madagascar","YEAR":"1997","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"65.9"},{"dims":{"COUNTRY":"Madagascar","YEAR":"1993","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"69.4"},{"dims":{"COUNTRY":"Malawi","YEAR":"2010","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"70.9"},{"dims":{"COUNTRY":"Malawi","YEAR":"2004","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"73.6"},{"dims":{"COUNTRY":"Malawi","YEAR":"1997","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"63.6"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.3"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2007","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.0"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2004","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"4.4"},{"dims":{"COUNTRY":"Malaysia","YEAR":"1997","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.4"},{"dims":{"COUNTRY":"Malaysia","YEAR":"1995","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"1.8"},{"dims":{"COUNTRY":"Malaysia","YEAR":"1992","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"1.3"},{"dims":{"COUNTRY":"Maldives","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"5.6"},{"dims":{"COUNTRY":"Maldives","YEAR":"2004","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"2.4"},{"dims":{"COUNTRY":"Maldives","YEAR":"1998","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"24.1"},{"dims":{"COUNTRY":"Mali","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"49.3"},{"dims":{"COUNTRY":"Mali","YEAR":"2006","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"50.6"},{"dims":{"COUNTRY":"Mali","YEAR":"2001","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"57.9"},{"dims":{"COUNTRY":"Mali","YEAR":"1994","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"84.9"},{"dims":{"COUNTRY":"Mauritania","YEAR":"2008","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"10.9"},{"dims":{"COUNTRY":"Mauritania","YEAR":"2004","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"14.4"},{"dims":{"COUNTRY":"Mauritania","YEAR":"2000","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"19.6"},{"dims":{"COUNTRY":"Mauritania","YEAR":"1995","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"20.6"},{"dims":{"COUNTRY":"Mauritania","YEAR":"1993","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"41.2"},{"dims":{"COUNTRY":"Mauritius","YEAR":"2012","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.5"},{"dims":{"COUNTRY":"Mauritius","YEAR":"2006","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.4"},{"dims":{"COUNTRY":"Mexico","YEAR":"2012","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"2.7"},{"dims":{"COUNTRY":"Mexico","YEAR":"2010","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"3.8"},{"dims":{"COUNTRY":"Mexico","YEAR":"2008","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"3.8"},{"dims":{"COUNTRY":"Mexico","YEAR":"2006","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"3.3"},{"dims":{"COUNTRY":"Mexico","YEAR":"2005","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"8.7"},{"dims":{"COUNTRY":"Mexico","YEAR":"2004","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"4.8"},{"dims":{"COUNTRY":"Mexico","YEAR":"2002","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"8.8"},{"dims":{"COUNTRY":"Mexico","YEAR":"2000","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"11.0"},{"dims":{"COUNTRY":"Mexico","YEAR":"1998","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"14.3"},{"dims":{"COUNTRY":"Mexico","YEAR":"1996","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"14.1"},{"dims":{"COUNTRY":"Mexico","YEAR":"1994","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"8.6"},{"dims":{"COUNTRY":"Mexico","YEAR":"1992","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"9.7"},{"dims":{"COUNTRY":"Micronesia (Federated States of)","YEAR":"2000","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based. Urban only.","Value":"50.4"},{"dims":{"COUNTRY":"Mongolia","YEAR":"2012","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.4"},{"dims":{"COUNTRY":"Mongolia","YEAR":"2011","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.6"},{"dims":{"COUNTRY":"Mongolia","YEAR":"2010","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.8"},{"dims":{"COUNTRY":"Mongolia","YEAR":"2007","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"1.3"},{"dims":{"COUNTRY":"Mongolia","YEAR":"2002","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"10.6"},{"dims":{"COUNTRY":"Mongolia","YEAR":"1998","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"26.9"},{"dims":{"COUNTRY":"Mongolia","YEAR":"1995","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"13.9"},{"dims":{"COUNTRY":"Montenegro","YEAR":"2013","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"1.7"},{"dims":{"COUNTRY":"Montenegro","YEAR":"2012","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"1.3"},{"dims":{"COUNTRY":"Montenegro","YEAR":"2011","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.2"},{"dims":{"COUNTRY":"Montenegro","YEAR":"2010","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Montenegro","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Montenegro","YEAR":"2008","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.1"},{"dims":{"COUNTRY":"Montenegro","YEAR":"2007","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.4"},{"dims":{"COUNTRY":"Montenegro","YEAR":"2006","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.1"},{"dims":{"COUNTRY":"Montenegro","YEAR":"2005","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.3"},{"dims":{"COUNTRY":"Morocco","YEAR":"2007","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"3.1"},{"dims":{"COUNTRY":"Morocco","YEAR":"2000","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"6.2"},{"dims":{"COUNTRY":"Morocco","YEAR":"1998","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"7.4"},{"dims":{"COUNTRY":"Morocco","YEAR":"1990","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"2.8"},{"dims":{"COUNTRY":"Mozambique","YEAR":"2008","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"68.7"},{"dims":{"COUNTRY":"Mozambique","YEAR":"2002","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"80.4"},{"dims":{"COUNTRY":"Mozambique","YEAR":"1996","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"85.4"},{"dims":{"COUNTRY":"Namibia","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"22.6"},{"dims":{"COUNTRY":"Namibia","YEAR":"2003","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"31.5"},{"dims":{"COUNTRY":"Namibia","YEAR":"1993","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"52.9"},{"dims":{"COUNTRY":"Nepal","YEAR":"2010","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"15.0"},{"dims":{"COUNTRY":"Nepal","YEAR":"2003","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"47.1"},{"dims":{"COUNTRY":"Nepal","YEAR":"1995","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"61.7"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"10.8"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2005","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"15.6"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2001","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"17.6"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"1998","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"15.7"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"1993","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"22.1"},{"dims":{"COUNTRY":"Niger","YEAR":"2011","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"50.3"},{"dims":{"COUNTRY":"Niger","YEAR":"2007","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"72.0"},{"dims":{"COUNTRY":"Niger","YEAR":"2005","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"74.9"},{"dims":{"COUNTRY":"Niger","YEAR":"1994","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"81.4"},{"dims":{"COUNTRY":"Niger","YEAR":"1992","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"78.2"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"53.5"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2003","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"53.5"},{"dims":{"COUNTRY":"Nigeria","YEAR":"1996","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"63.5"},{"dims":{"COUNTRY":"Nigeria","YEAR":"1992","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"57.1"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2010","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"8.3"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2007","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"13.3"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2005","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"16.5"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2004","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"18.1"},{"dims":{"COUNTRY":"Pakistan","YEAR":"2001","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"28.5"},{"dims":{"COUNTRY":"Pakistan","YEAR":"1998","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"23.4"},{"dims":{"COUNTRY":"Pakistan","YEAR":"1996","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"15.9"},{"dims":{"COUNTRY":"Pakistan","YEAR":"1990","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"59.0"},{"dims":{"COUNTRY":"Panama","YEAR":"2013","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"2.9"},{"dims":{"COUNTRY":"Panama","YEAR":"2012","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"4.4"},{"dims":{"COUNTRY":"Panama","YEAR":"2011","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"4.0"},{"dims":{"COUNTRY":"Panama","YEAR":"2010","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"4.6"},{"dims":{"COUNTRY":"Panama","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"3.4"},{"dims":{"COUNTRY":"Panama","YEAR":"2008","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"5.5"},{"dims":{"COUNTRY":"Panama","YEAR":"2007","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"8.1"},{"dims":{"COUNTRY":"Panama","YEAR":"2006","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"11.0"},{"dims":{"COUNTRY":"Panama","YEAR":"2005","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"10.3"},{"dims":{"COUNTRY":"Panama","YEAR":"2004","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"10.8"},{"dims":{"COUNTRY":"Panama","YEAR":"2003","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"11.6"},{"dims":{"COUNTRY":"Panama","YEAR":"2002","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"11.9"},{"dims":{"COUNTRY":"Panama","YEAR":"2001","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"16.4"},{"dims":{"COUNTRY":"Panama","YEAR":"2000","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"14.7"},{"dims":{"COUNTRY":"Panama","YEAR":"1999","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"13.4"},{"dims":{"COUNTRY":"Panama","YEAR":"1998","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"15.2"},{"dims":{"COUNTRY":"Panama","YEAR":"1997","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"15.0"},{"dims":{"COUNTRY":"Panama","YEAR":"1995","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"16.3"},{"dims":{"COUNTRY":"Panama","YEAR":"1991","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"21.9"},{"dims":{"COUNTRY":"Papua New Guinea","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"39.3"},{"dims":{"COUNTRY":"Papua New Guinea","YEAR":"1996","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"53.2"},{"dims":{"COUNTRY":"Paraguay","YEAR":"2013","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"2.2"},{"dims":{"COUNTRY":"Paraguay","YEAR":"2012","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"3.7"},{"dims":{"COUNTRY":"Paraguay","YEAR":"2011","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"5.5"},{"dims":{"COUNTRY":"Paraguay","YEAR":"2010","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"6.1"},{"dims":{"COUNTRY":"Paraguay","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"6.4"},{"dims":{"COUNTRY":"Paraguay","YEAR":"2008","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"5.0"},{"dims":{"COUNTRY":"Paraguay","YEAR":"2007","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"8.5"},{"dims":{"COUNTRY":"Paraguay","YEAR":"2006","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"10.1"},{"dims":{"COUNTRY":"Paraguay","YEAR":"2005","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"7.0"},{"dims":{"COUNTRY":"Paraguay","YEAR":"2004","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"6.6"},{"dims":{"COUNTRY":"Paraguay","YEAR":"2003","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"9.0"},{"dims":{"COUNTRY":"Paraguay","YEAR":"2002","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"13.3"},{"dims":{"COUNTRY":"Paraguay","YEAR":"2001","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"9.1"},{"dims":{"COUNTRY":"Paraguay","YEAR":"1999","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"10.2"},{"dims":{"COUNTRY":"Paraguay","YEAR":"1997","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"10.6"},{"dims":{"COUNTRY":"Paraguay","YEAR":"1995","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"12.4"},{"dims":{"COUNTRY":"Paraguay","YEAR":"1990","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"1.2"},{"dims":{"COUNTRY":"Peru","YEAR":"2013","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"3.7"},{"dims":{"COUNTRY":"Peru","YEAR":"2012","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"4.1"},{"dims":{"COUNTRY":"Peru","YEAR":"2011","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"4.4"},{"dims":{"COUNTRY":"Peru","YEAR":"2010","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"4.7"},{"dims":{"COUNTRY":"Peru","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"6.3"},{"dims":{"COUNTRY":"Peru","YEAR":"2008","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"7.9"},{"dims":{"COUNTRY":"Peru","YEAR":"2007","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"10.0"},{"dims":{"COUNTRY":"Peru","YEAR":"2006","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"12.4"},{"dims":{"COUNTRY":"Peru","YEAR":"2005","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"14.2"},{"dims":{"COUNTRY":"Peru","YEAR":"2004","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"12.2"},{"dims":{"COUNTRY":"Peru","YEAR":"2003","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"12.2"},{"dims":{"COUNTRY":"Peru","YEAR":"2002","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"15.1"},{"dims":{"COUNTRY":"Peru","YEAR":"2001","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"17.8"},{"dims":{"COUNTRY":"Peru","YEAR":"2000","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"16.5"},{"dims":{"COUNTRY":"Peru","YEAR":"1999","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"17.4"},{"dims":{"COUNTRY":"Peru","YEAR":"1998","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"16.4"},{"dims":{"COUNTRY":"Peru","YEAR":"1997","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"17.5"},{"dims":{"COUNTRY":"Peru","YEAR":"1994","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"14.5"},{"dims":{"COUNTRY":"Philippines","YEAR":"2012","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"13.1"},{"dims":{"COUNTRY":"Philippines","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"12.0"},{"dims":{"COUNTRY":"Philippines","YEAR":"2006","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"16.5"},{"dims":{"COUNTRY":"Philippines","YEAR":"2003","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"16.8"},{"dims":{"COUNTRY":"Philippines","YEAR":"2000","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"18.4"},{"dims":{"COUNTRY":"Philippines","YEAR":"1997","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"17.7"},{"dims":{"COUNTRY":"Philippines","YEAR":"1994","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"25.0"},{"dims":{"COUNTRY":"Philippines","YEAR":"1991","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"27.5"},{"dims":{"COUNTRY":"Poland","YEAR":"2012","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Poland","YEAR":"2011","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Poland","YEAR":"2010","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Poland","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Poland","YEAR":"2008","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Poland","YEAR":"2007","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Poland","YEAR":"2006","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Poland","YEAR":"2005","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"1.0"},{"dims":{"COUNTRY":"Poland","YEAR":"2004","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.1"},{"dims":{"COUNTRY":"Poland","YEAR":"2003","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.1"},{"dims":{"COUNTRY":"Poland","YEAR":"2002","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.1"},{"dims":{"COUNTRY":"Poland","YEAR":"2001","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.1"},{"dims":{"COUNTRY":"Poland","YEAR":"2000","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.1"},{"dims":{"COUNTRY":"Poland","YEAR":"1999","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.1"},{"dims":{"COUNTRY":"Poland","YEAR":"1998","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Poland","YEAR":"1996","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"2.6"},{"dims":{"COUNTRY":"Poland","YEAR":"1992","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Republic of Moldova","YEAR":"2013","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.1"},{"dims":{"COUNTRY":"Republic of Moldova","YEAR":"2012","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.3"},{"dims":{"COUNTRY":"Republic of Moldova","YEAR":"2011","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.3"},{"dims":{"COUNTRY":"Republic of Moldova","YEAR":"2010","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.5"},{"dims":{"COUNTRY":"Republic of Moldova","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"1.0"},{"dims":{"COUNTRY":"Republic of Moldova","YEAR":"2008","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"1.3"},{"dims":{"COUNTRY":"Republic of Moldova","YEAR":"2007","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"1.1"},{"dims":{"COUNTRY":"Republic of Moldova","YEAR":"2006","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"2.4"},{"dims":{"COUNTRY":"Republic of Moldova","YEAR":"2005","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"14.0"},{"dims":{"COUNTRY":"Republic of Moldova","YEAR":"2004","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"8.3"},{"dims":{"COUNTRY":"Republic of Moldova","YEAR":"2003","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"7.8"},{"dims":{"COUNTRY":"Republic of Moldova","YEAR":"2002","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"16.4"},{"dims":{"COUNTRY":"Republic of Moldova","YEAR":"2001","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"27.6"},{"dims":{"COUNTRY":"Republic of Moldova","YEAR":"2000","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"35.9"},{"dims":{"COUNTRY":"Republic of Moldova","YEAR":"1999","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"39.1"},{"dims":{"COUNTRY":"Republic of Moldova","YEAR":"1998","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"27.6"},{"dims":{"COUNTRY":"Republic of Moldova","YEAR":"1997","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"16.1"},{"dims":{"COUNTRY":"Republic of Moldova","YEAR":"1992","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"13.4"},{"dims":{"COUNTRY":"Romania","YEAR":"2012","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Romania","YEAR":"2011","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Romania","YEAR":"2010","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Romania","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Romania","YEAR":"2008","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Romania","YEAR":"2007","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"5.8"},{"dims":{"COUNTRY":"Romania","YEAR":"2006","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"7.3"},{"dims":{"COUNTRY":"Romania","YEAR":"2005","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"2.2"},{"dims":{"COUNTRY":"Romania","YEAR":"2004","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"2.8"},{"dims":{"COUNTRY":"Romania","YEAR":"2003","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"3.9"},{"dims":{"COUNTRY":"Romania","YEAR":"2002","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"5.4"},{"dims":{"COUNTRY":"Romania","YEAR":"2001","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"5.5"},{"dims":{"COUNTRY":"Romania","YEAR":"2000","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"7.5"},{"dims":{"COUNTRY":"Romania","YEAR":"1999","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"6.5"},{"dims":{"COUNTRY":"Romania","YEAR":"1998","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Romania","YEAR":"1994","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"10.7"},{"dims":{"COUNTRY":"Romania","YEAR":"1992","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.6"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2012","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2011","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.1"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2010","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.2"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2008","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.1"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2007","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.2"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2006","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.5"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2005","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.7"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2004","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.9"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2003","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"1.0"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2002","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.7"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2001","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"1.2"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"2000","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"2.3"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"1999","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"3.4"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"1998","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"1.7"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"1997","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"1.1"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"1996","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"3.6"},{"dims":{"COUNTRY":"Russian Federation","YEAR":"1993","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"2.4"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2010","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"60.3"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2005","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"68.0"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2000","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"77.0"},{"dims":{"COUNTRY":"Saint Lucia","YEAR":"1995","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"35.8"},{"dims":{"COUNTRY":"Samoa","YEAR":"2008","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.8"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2010","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"33.9"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2000","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"29.5"},{"dims":{"COUNTRY":"Senegal","YEAR":"2011","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"38.0"},{"dims":{"COUNTRY":"Senegal","YEAR":"2005","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"37.6"},{"dims":{"COUNTRY":"Senegal","YEAR":"2001","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"48.6"},{"dims":{"COUNTRY":"Senegal","YEAR":"1994","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"56.8"},{"dims":{"COUNTRY":"Senegal","YEAR":"1991","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"68.0"},{"dims":{"COUNTRY":"Serbia","YEAR":"2010","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.1"},{"dims":{"COUNTRY":"Serbia","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.1"},{"dims":{"COUNTRY":"Serbia","YEAR":"2008","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.1"},{"dims":{"COUNTRY":"Serbia","YEAR":"2007","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.4"},{"dims":{"COUNTRY":"Serbia","YEAR":"2006","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.5"},{"dims":{"COUNTRY":"Serbia","YEAR":"2005","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"1.1"},{"dims":{"COUNTRY":"Serbia","YEAR":"2004","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.9"},{"dims":{"COUNTRY":"Serbia","YEAR":"2003","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.5"},{"dims":{"COUNTRY":"Serbia","YEAR":"2002","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.3"},{"dims":{"COUNTRY":"Seychelles","YEAR":"2006","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.4"},{"dims":{"COUNTRY":"Seychelles","YEAR":"1999","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.6"},{"dims":{"COUNTRY":"Sierra Leone","YEAR":"2011","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"52.3"},{"dims":{"COUNTRY":"Sierra Leone","YEAR":"2003","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"58.6"},{"dims":{"COUNTRY":"Slovakia","YEAR":"2012","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.2"},{"dims":{"COUNTRY":"Slovakia","YEAR":"2011","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.4"},{"dims":{"COUNTRY":"Slovakia","YEAR":"2010","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.4"},{"dims":{"COUNTRY":"Slovakia","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Slovakia","YEAR":"2008","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Slovakia","YEAR":"2007","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Slovakia","YEAR":"2006","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Slovakia","YEAR":"2005","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.1"},{"dims":{"COUNTRY":"Slovakia","YEAR":"2004","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.2"},{"dims":{"COUNTRY":"Slovakia","YEAR":"1996","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.5"},{"dims":{"COUNTRY":"Slovakia","YEAR":"1992","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.0"},{"dims":{"COUNTRY":"Slovenia","YEAR":"2012","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.0"},{"dims":{"COUNTRY":"Slovenia","YEAR":"2011","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.0"},{"dims":{"COUNTRY":"Slovenia","YEAR":"2010","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.0"},{"dims":{"COUNTRY":"Slovenia","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.0"},{"dims":{"COUNTRY":"Slovenia","YEAR":"2008","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.0"},{"dims":{"COUNTRY":"Slovenia","YEAR":"2007","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.0"},{"dims":{"COUNTRY":"Slovenia","YEAR":"2006","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.1"},{"dims":{"COUNTRY":"Slovenia","YEAR":"2005","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.1"},{"dims":{"COUNTRY":"Slovenia","YEAR":"2004","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Slovenia","YEAR":"2003","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Slovenia","YEAR":"2002","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Slovenia","YEAR":"1998","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Slovenia","YEAR":"1993","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.1"},{"dims":{"COUNTRY":"Solomon Islands","YEAR":"2005","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"45.6"},{"dims":{"COUNTRY":"South Africa","YEAR":"2011","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"16.6"},{"dims":{"COUNTRY":"South Africa","YEAR":"2008","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"15.1"},{"dims":{"COUNTRY":"South Africa","YEAR":"2006","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"23.1"},{"dims":{"COUNTRY":"South Africa","YEAR":"2000","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"35.2"},{"dims":{"COUNTRY":"South Africa","YEAR":"1995","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"34.9"},{"dims":{"COUNTRY":"South Africa","YEAR":"1993","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"31.9"},{"dims":{"COUNTRY":"Sri Lanka","YEAR":"2012","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"1.7"},{"dims":{"COUNTRY":"Sri Lanka","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"2.4"},{"dims":{"COUNTRY":"Sri Lanka","YEAR":"2006","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"3.8"},{"dims":{"COUNTRY":"Sri Lanka","YEAR":"2002","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"8.3"},{"dims":{"COUNTRY":"Sri Lanka","YEAR":"1995","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"8.9"},{"dims":{"COUNTRY":"Sri Lanka","YEAR":"1990","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"8.7"},{"dims":{"COUNTRY":"Sudan","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"14.9"},{"dims":{"COUNTRY":"Suriname","YEAR":"1999","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"23.4"},{"dims":{"COUNTRY":"Swaziland","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"42.0"},{"dims":{"COUNTRY":"Swaziland","YEAR":"2000","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"48.4"},{"dims":{"COUNTRY":"Swaziland","YEAR":"1994","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"81.7"},{"dims":{"COUNTRY":"Tajikistan","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"4.7"},{"dims":{"COUNTRY":"Tajikistan","YEAR":"2007","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"10.4"},{"dims":{"COUNTRY":"Tajikistan","YEAR":"2004","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"15.4"},{"dims":{"COUNTRY":"Tajikistan","YEAR":"2003","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"30.9"},{"dims":{"COUNTRY":"Tajikistan","YEAR":"1999","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"54.3"},{"dims":{"COUNTRY":"Thailand","YEAR":"2012","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.1"},{"dims":{"COUNTRY":"Thailand","YEAR":"2011","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Thailand","YEAR":"2010","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.1"},{"dims":{"COUNTRY":"Thailand","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.2"},{"dims":{"COUNTRY":"Thailand","YEAR":"2008","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.2"},{"dims":{"COUNTRY":"Thailand","YEAR":"2007","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.3"},{"dims":{"COUNTRY":"Thailand","YEAR":"2006","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.7"},{"dims":{"COUNTRY":"Thailand","YEAR":"2004","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.8"},{"dims":{"COUNTRY":"Thailand","YEAR":"2002","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"1.1"},{"dims":{"COUNTRY":"Thailand","YEAR":"2000","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"2.6"},{"dims":{"COUNTRY":"Thailand","YEAR":"1999","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"2.5"},{"dims":{"COUNTRY":"Thailand","YEAR":"1998","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"1.5"},{"dims":{"COUNTRY":"Thailand","YEAR":"1996","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"2.3"},{"dims":{"COUNTRY":"Thailand","YEAR":"1994","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"3.2"},{"dims":{"COUNTRY":"Thailand","YEAR":"1992","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"6.7"},{"dims":{"COUNTRY":"Thailand","YEAR":"1990","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"9.4"},{"dims":{"COUNTRY":"The former Yugoslav republic of Macedonia","YEAR":"2008","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"1.3"},{"dims":{"COUNTRY":"The former Yugoslav republic of Macedonia","YEAR":"2006","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"2.7"},{"dims":{"COUNTRY":"The former Yugoslav republic of Macedonia","YEAR":"2005","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"1.4"},{"dims":{"COUNTRY":"The former Yugoslav republic of Macedonia","YEAR":"2004","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"1.4"},{"dims":{"COUNTRY":"The former Yugoslav republic of Macedonia","YEAR":"2003","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"1.2"},{"dims":{"COUNTRY":"The former Yugoslav republic of Macedonia","YEAR":"2002","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"1.3"},{"dims":{"COUNTRY":"The former Yugoslav republic of Macedonia","YEAR":"2000","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"5.2"},{"dims":{"COUNTRY":"The former Yugoslav republic of Macedonia","YEAR":"1998","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.8"},{"dims":{"COUNTRY":"Timor-Leste","YEAR":"2007","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"46.8"},{"dims":{"COUNTRY":"Timor-Leste","YEAR":"2001","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"44.2"},{"dims":{"COUNTRY":"Togo","YEAR":"2011","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"54.2"},{"dims":{"COUNTRY":"Togo","YEAR":"2006","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"55.6"},{"dims":{"COUNTRY":"Tonga","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"1.1"},{"dims":{"COUNTRY":"Trinidad and Tobago","YEAR":"1992","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"3.4"},{"dims":{"COUNTRY":"Tunisia","YEAR":"2010","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"2.0"},{"dims":{"COUNTRY":"Tunisia","YEAR":"2005","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"3.1"},{"dims":{"COUNTRY":"Tunisia","YEAR":"2000","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"5.3"},{"dims":{"COUNTRY":"Tunisia","YEAR":"1995","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"10.9"},{"dims":{"COUNTRY":"Tunisia","YEAR":"1990","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"9.8"},{"dims":{"COUNTRY":"Turkey","YEAR":"2012","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.3"},{"dims":{"COUNTRY":"Turkey","YEAR":"2011","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.3"},{"dims":{"COUNTRY":"Turkey","YEAR":"2010","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.8"},{"dims":{"COUNTRY":"Turkey","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.9"},{"dims":{"COUNTRY":"Turkey","YEAR":"2008","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.4"},{"dims":{"COUNTRY":"Turkey","YEAR":"2007","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"1.4"},{"dims":{"COUNTRY":"Turkey","YEAR":"2006","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"1.9"},{"dims":{"COUNTRY":"Turkey","YEAR":"2005","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"2.5"},{"dims":{"COUNTRY":"Turkey","YEAR":"2004","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"2.1"},{"dims":{"COUNTRY":"Turkey","YEAR":"2003","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"3.7"},{"dims":{"COUNTRY":"Turkey","YEAR":"2002","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"1.7"},{"dims":{"COUNTRY":"Turkey","YEAR":"1994","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"2.6"},{"dims":{"COUNTRY":"Turkmenistan","YEAR":"1998","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"42.3"},{"dims":{"COUNTRY":"Turkmenistan","YEAR":"1993","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"80.9"},{"dims":{"COUNTRY":"Uganda","YEAR":"2012","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"33.2"},{"dims":{"COUNTRY":"Uganda","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"41.5"},{"dims":{"COUNTRY":"Uganda","YEAR":"2005","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"53.2"},{"dims":{"COUNTRY":"Uganda","YEAR":"2002","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"62.2"},{"dims":{"COUNTRY":"Uganda","YEAR":"1999","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"52.1"},{"dims":{"COUNTRY":"Uganda","YEAR":"1996","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"59.6"},{"dims":{"COUNTRY":"Uganda","YEAR":"1992","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"68.1"},{"dims":{"COUNTRY":"Ukraine","YEAR":"2013","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Ukraine","YEAR":"2012","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Ukraine","YEAR":"2011","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Ukraine","YEAR":"2010","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Ukraine","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.1"},{"dims":{"COUNTRY":"Ukraine","YEAR":"2008","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Ukraine","YEAR":"2007","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.0"},{"dims":{"COUNTRY":"Ukraine","YEAR":"2006","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.1"},{"dims":{"COUNTRY":"Ukraine","YEAR":"2005","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.3"},{"dims":{"COUNTRY":"Ukraine","YEAR":"2004","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.6"},{"dims":{"COUNTRY":"Ukraine","YEAR":"2003","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"0.6"},{"dims":{"COUNTRY":"Ukraine","YEAR":"2002","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"1.7"},{"dims":{"COUNTRY":"Ukraine","YEAR":"1999","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"8.3"},{"dims":{"COUNTRY":"Ukraine","YEAR":"1996","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"5.4"},{"dims":{"COUNTRY":"Ukraine","YEAR":"1995","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"5.4"},{"dims":{"COUNTRY":"Ukraine","YEAR":"1992","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"1.6"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2011","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"46.6"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2007","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"52.7"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2000","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"84.7"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"1991","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"70.4"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2013","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.3"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2012","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.4"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2011","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.3"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2010","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.2"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2009","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.3"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2008","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.3"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2007","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.6"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2006","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"0.9"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2005","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based. Urban only.","Value":"1.5"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2004","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based. Urban only.","Value":"1.5"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2003","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based. Urban only.","Value":"1.3"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2002","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based. Urban only.","Value":"1.1"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2001","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based. Urban only.","Value":"0.8"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2000","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based. Urban only.","Value":"0.6"},{"dims":{"COUNTRY":"Uruguay","YEAR":"1998","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based. Urban only.","Value":"0.9"},{"dims":{"COUNTRY":"Uruguay","YEAR":"1997","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based. Urban only.","Value":"0.7"},{"dims":{"COUNTRY":"Uruguay","YEAR":"1996","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based. Urban only.","Value":"0.8"},{"dims":{"COUNTRY":"Uruguay","YEAR":"1995","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based. Urban only.","Value":"0.7"},{"dims":{"COUNTRY":"Uruguay","YEAR":"1992","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based. Urban only.","Value":"0.5"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2003","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"66.8"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2002","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"65.6"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2000","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"68.1"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"1998","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"45.5"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2010","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"15.4"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2006","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"9.2"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2005","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"17.0"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2004","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"17.5"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2003","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"20.0"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2002","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"16.0"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"2001","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"9.6"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"1999","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"10.2"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"1998","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"11.4"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"1995","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"8.6"},{"dims":{"COUNTRY":"Venezuela (Bolivarian Republic of)","YEAR":"1992","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankIncome based.","Value":"4.3"},{"dims":{"COUNTRY":"Viet Nam","YEAR":"2012","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"3.2"},{"dims":{"COUNTRY":"Viet Nam","YEAR":"2010","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"4.8"},{"dims":{"COUNTRY":"Viet Nam","YEAR":"2008","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"16.2"},{"dims":{"COUNTRY":"Viet Nam","YEAR":"2006","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"22.0"},{"dims":{"COUNTRY":"Viet Nam","YEAR":"2004","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"27.1"},{"dims":{"COUNTRY":"Viet Nam","YEAR":"2002","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"38.8"},{"dims":{"COUNTRY":"Viet Nam","YEAR":"1998","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"34.8"},{"dims":{"COUNTRY":"Viet Nam","YEAR":"1992","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"49.2"},{"dims":{"COUNTRY":"Zambia","YEAR":"2010","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"64.4"},{"dims":{"COUNTRY":"Zambia","YEAR":"2006","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"60.5"},{"dims":{"COUNTRY":"Zambia","YEAR":"2004","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"56.7"},{"dims":{"COUNTRY":"Zambia","YEAR":"2002","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"49.4"},{"dims":{"COUNTRY":"Zambia","YEAR":"1998","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"42.1"},{"dims":{"COUNTRY":"Zambia","YEAR":"1996","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"41.8"},{"dims":{"COUNTRY":"Zambia","YEAR":"1993","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"54.5"},{"dims":{"COUNTRY":"Zambia","YEAR":"1991","GHO":"Proportion of population below the international poverty line of US$1.90 per day (%)"},"Comments":"Global monitoring data.World BankConsumption based.","Value":"54.1"}]}

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_recharts__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WikiQuote_js__ = __webpack_require__(21);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SexViolenceData=__webpack_require__(607);var SexualViolence=function(_Component){_inherits(SexualViolence,_Component);function SexualViolence(props){_classCallCheck(this,SexualViolence);var _this=_possibleConstructorReturn(this,(SexualViolence.__proto__||Object.getPrototypeOf(SexualViolence)).call(this,props));_this.state={data:[],quote:""};return _this;}_createClass(SexualViolence,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var quote="",data=[];var success=function success(wikiData){quote='"'+wikiData.quote+'"';};__WEBPACK_IMPORTED_MODULE_3__WikiQuote_js__["a" /* WikiquoteApi */].getRandomQuote("Pedophilia",success,__WEBPACK_IMPORTED_MODULE_3__WikiQuote_js__["b" /* error */]);data=Object(__WEBPACK_IMPORTED_MODULE_2__utils_js__["h" /* mapTable */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_js__["f" /* filterTable */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_js__["g" /* initialReformat */])(SexViolenceData)));var checkQuoteLength=function checkQuoteLength(){if(quote.length>0){_this2.setState({quote:quote,data:data});}else{setTimeout(checkQuoteLength,100);}};checkQuoteLength();}},{key:'render',value:function render(){var data=[],finalData=[],i=0;if(this.state.data.length>0){//format data so that data can be utilised by year... [title: {year: [obj_with_data, ...], ...}, ...]
data=Object(__WEBPACK_IMPORTED_MODULE_2__utils_js__["c" /* filterAll */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_js__["b" /* dataFunction */])(this.state.data));data=data['Proportion of young women and men aged 18-29 years who experienced sexual violence by age 18 (%)'];//for a bar the table must be used to compare data based upon a datakey for the x-axis, a specific dataKey for each country works
finalData[i]={};finalData[i].xaxis='';//because I could not put each country as its own x-axis value I had to give them an individual one, so only one object is made with the country/value I want
for(var key in data){//basically grab the last year that data was available for the country
data[key].forEach(function(obj){finalData[i][obj.country]=parseFloat(obj.value);});}}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'chart bar sexual-violence'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,this.state.quote),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h6',null,'Proportion of young women and men aged 18-29 years who experienced sexual violence by age 18 (%) - Most recent data'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["k" /* ResponsiveContainer */],{width:'100%',height:300},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["b" /* BarChart */],{cx:'50%',cy:'50%',outerRadius:'80%',data:finalData},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["m" /* XAxis */],{dataKey:'xaxis'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["n" /* YAxis */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["c" /* CartesianGrid */],{strokeDasharray:'3 3'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["l" /* Tooltip */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["a" /* Bar */],{dataKey:'Cameroon',fill:'black'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["a" /* Bar */],{dataKey:'Colombia',fill:'green'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["a" /* Bar */],{dataKey:'Democratic Republic of the Congo',fill:'purple'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["a" /* Bar */],{dataKey:'Gambia',fill:'orange'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["a" /* Bar */],{dataKey:'Honduras',fill:'brown'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["a" /* Bar */],{dataKey:'India',fill:'#C90016'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["a" /* Bar */],{dataKey:'Mozambique',fill:'red'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["a" /* Bar */],{dataKey:'Nepal',fill:'pink'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["a" /* Bar */],{dataKey:'Philippines',fill:'grey'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["a" /* Bar */],{dataKey:'Tajikistan',fill:'blue'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["a" /* Bar */],{dataKey:'Rwanda',fill:'gold'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["a" /* Bar */],{dataKey:'Ukraine',fill:'maroon'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["a" /* Bar */],{dataKey:'Zimbabwe',fill:'lime'}))));}}]);return SexualViolence;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SexualViolence);

/***/ }),
/* 607 */
/***/ (function(module, exports) {

module.exports = {"dimension":[{"label":"GHO","display":"Indicator"},{"label":"PUBLISHSTATE","display":"PUBLISH STATES"},{"label":"YEAR","display":"Year"},{"label":"REGION","display":"WHO region"},{"label":"COUNTRY","display":"Country"},{"label":"AGEGROUP","display":"Age Group"},{"label":"SEX","display":"Sex"}],"fact":[{"dims":{"COUNTRY":"Azerbaijan","YEAR":"2006","GHO":"Proportion of young women and men aged 18-29 years who experienced sexual violence by age 18 (%)","AGEGROUP":"18-29 years","SEX":"Female"},"Comments":"DHS 2006","Value":"0.09"},{"dims":{"COUNTRY":"Cambodia","YEAR":"2014","GHO":"Proportion of young women and men aged 18-29 years who experienced sexual violence by age 18 (%)","AGEGROUP":"18-29 years","SEX":"Female"},"Comments":"DHS 2014","Value":"1.70"},{"dims":{"COUNTRY":"Cameroon","YEAR":"2011","GHO":"Proportion of young women and men aged 18-29 years who experienced sexual violence by age 18 (%)","AGEGROUP":"18-29 years","SEX":"Male"},"Comments":"DHS 2011","Value":"4.13"},{"dims":{"COUNTRY":"Cameroon","YEAR":"2011","GHO":"Proportion of young women and men aged 18-29 years who experienced sexual violence by age 18 (%)","AGEGROUP":"18-29 years","SEX":"Female"},"Comments":"DHS 2011","Value":"15.99"},{"dims":{"COUNTRY":"Colombia","YEAR":"2010","GHO":"Proportion of young women and men aged 18-29 years who experienced sexual violence by age 18 (%)","AGEGROUP":"18-29 years","SEX":"Female"},"Comments":"DHS 2010","Value":"2.86"},{"dims":{"COUNTRY":"Comoros","YEAR":"2012","GHO":"Proportion of young women and men aged 18-29 years who experienced sexual violence by age 18 (%)","AGEGROUP":"18-29 years","SEX":"Female"},"Comments":"DHS 2012","Value":"3.14"},{"dims":{"COUNTRY":"Democratic Republic of the Congo","YEAR":"2014","GHO":"Proportion of young women and men aged 18-29 years who experienced sexual violence by age 18 (%)","AGEGROUP":"18-29 years","SEX":"Female"},"Comments":"DHS 2013-14","Value":"13.37"},{"dims":{"COUNTRY":"Dominican Republic","YEAR":"2013","GHO":"Proportion of young women and men aged 18-29 years who experienced sexual violence by age 18 (%)","AGEGROUP":"18-29 years","SEX":"Female"},"Comments":"DHS 2013","Value":"1.31"},{"dims":{"COUNTRY":"Gabon","YEAR":"2012","GHO":"Proportion of young women and men aged 18-29 years who experienced sexual violence by age 18 (%)","AGEGROUP":"18-29 years","SEX":"Female"},"Comments":"DHS 2012","Value":"9.28"},{"dims":{"COUNTRY":"Gambia","YEAR":"2013","GHO":"Proportion of young women and men aged 18-29 years who experienced sexual violence by age 18 (%)","AGEGROUP":"18-29 years","SEX":"Female"},"Comments":"DHS 2013","Value":"0.36"},{"dims":{"COUNTRY":"Ghana","YEAR":"2008","GHO":"Proportion of young women and men aged 18-29 years who experienced sexual violence by age 18 (%)","AGEGROUP":"18-29 years","SEX":"Female"},"Comments":"DHS 2008","Value":"10.31"},{"dims":{"COUNTRY":"Haiti","YEAR":"2012","GHO":"Proportion of young women and men aged 18-29 years who experienced sexual violence by age 18 (%)","AGEGROUP":"18-29 years","SEX":"Female"},"Comments":"DHS 2012","Value":"4.20"},{"dims":{"COUNTRY":"Honduras","YEAR":"2012","GHO":"Proportion of young women and men aged 18-29 years who experienced sexual violence by age 18 (%)","AGEGROUP":"18-29 years","SEX":"Female"},"Comments":"DHS 2011-12","Value":"5.14"},{"dims":{"COUNTRY":"India","YEAR":"2006","GHO":"Proportion of young women and men aged 18-29 years who experienced sexual violence by age 18 (%)","AGEGROUP":"18-29 years","SEX":"Female"},"Comments":"DHS 2005-06","Value":"1.34"},{"dims":{"COUNTRY":"Kenya","YEAR":"2014","GHO":"Proportion of young women and men aged 18-29 years who experienced sexual violence by age 18 (%)","AGEGROUP":"18-29 years","SEX":"Male"},"Comments":"DHS 2014","Value":"1.77"},{"dims":{"COUNTRY":"Kenya","YEAR":"2014","GHO":"Proportion of young women and men aged 18-29 years who experienced sexual violence by age 18 (%)","AGEGROUP":"18-29 years","SEX":"Female"},"Comments":"DHS 2014","Value":"4.40"},{"dims":{"COUNTRY":"Kyrgyzstan","YEAR":"2012","GHO":"Proportion of young women and men aged 18-29 years who experienced sexual violence by age 18 (%)","AGEGROUP":"18-29 years","SEX":"Female"},"Comments":"DHS 2012","Value":"0.00"},{"dims":{"COUNTRY":"Liberia","YEAR":"2007","GHO":"Proportion of young women and men aged 18-29 years who experienced sexual violence by age 18 (%)","AGEGROUP":"18-29 years","SEX":"Female"},"Comments":"DHS 2007","Value":"4.21"},{"dims":{"COUNTRY":"Malawi","YEAR":"2010","GHO":"Proportion of young women and men aged 18-29 years who experienced sexual violence by age 18 (%)","AGEGROUP":"18-29 years","SEX":"Female"},"Comments":"DHS 2010","Value":"6.40"},{"dims":{"COUNTRY":"Mozambique","YEAR":"2011","GHO":"Proportion of young women and men aged 18-29 years who experienced sexual violence by age 18 (%)","AGEGROUP":"18-29 years","SEX":"Male"},"Comments":"DHS 2011","Value":"1.12"},{"dims":{"COUNTRY":"Mozambique","YEAR":"2011","GHO":"Proportion of young women and men aged 18-29 years who experienced sexual violence by age 18 (%)","AGEGROUP":"18-29 years","SEX":"Female"},"Comments":"DHS 2011","Value":"7.67"},{"dims":{"COUNTRY":"Namibia","YEAR":"2013","GHO":"Proportion of young women and men aged 18-29 years who experienced sexual violence by age 18 (%)","AGEGROUP":"18-29 years","SEX":"Female"},"Comments":"DHS 2013","Value":"0.55"},{"dims":{"COUNTRY":"Nepal","YEAR":"2011","GHO":"Proportion of young women and men aged 18-29 years who experienced sexual violence by age 18 (%)","AGEGROUP":"18-29 years","SEX":"Female"},"Comments":"DHS 2011","Value":"1.15"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2013","GHO":"Proportion of young women and men aged 18-29 years who experienced sexual violence by age 18 (%)","AGEGROUP":"18-29 years","SEX":"Female"},"Comments":"DHS 2013","Value":"3.86"},{"dims":{"COUNTRY":"Philippines","YEAR":"2008","GHO":"Proportion of young women and men aged 18-29 years who experienced sexual violence by age 18 (%)","AGEGROUP":"18-29 years","SEX":"Female"},"Comments":"DHS 2008","Value":"2.80"},{"dims":{"COUNTRY":"Republic of Moldova","YEAR":"2005","GHO":"Proportion of young women and men aged 18-29 years who experienced sexual violence by age 18 (%)","AGEGROUP":"18-29 years","SEX":"Female"},"Comments":"DHS 2005","Value":"5.23"},{"dims":{"COUNTRY":"Rwanda","YEAR":"2010","GHO":"Proportion of young women and men aged 18-29 years who experienced sexual violence by age 18 (%)","AGEGROUP":"18-29 years","SEX":"Female"},"Comments":"DHS 2010","Value":"10.36"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2009","GHO":"Proportion of young women and men aged 18-29 years who experienced sexual violence by age 18 (%)","AGEGROUP":"18-29 years","SEX":"Female"},"Comments":"DHS 2008-09","Value":"3.38"},{"dims":{"COUNTRY":"Sierra Leone","YEAR":"2013","GHO":"Proportion of young women and men aged 18-29 years who experienced sexual violence by age 18 (%)","AGEGROUP":"18-29 years","SEX":"Male"},"Comments":"DHS 2013","Value":"0.39"},{"dims":{"COUNTRY":"Sierra Leone","YEAR":"2013","GHO":"Proportion of young women and men aged 18-29 years who experienced sexual violence by age 18 (%)","AGEGROUP":"18-29 years","SEX":"Female"},"Comments":"DHS 2013","Value":"1.84"},{"dims":{"COUNTRY":"Tajikistan","YEAR":"2012","GHO":"Proportion of young women and men aged 18-29 years who experienced sexual violence by age 18 (%)","AGEGROUP":"18-29 years","SEX":"Female"},"Comments":"DHS 2012","Value":"0.29"},{"dims":{"COUNTRY":"Timor-Leste","YEAR":"2010","GHO":"Proportion of young women and men aged 18-29 years who experienced sexual violence by age 18 (%)","AGEGROUP":"18-29 years","SEX":"Female"},"Comments":"DHS 2009-10","Value":"0.95"},{"dims":{"COUNTRY":"Togo","YEAR":"2014","GHO":"Proportion of young women and men aged 18-29 years who experienced sexual violence by age 18 (%)","AGEGROUP":"18-29 years","SEX":"Female"},"Comments":"DHS 2013-14","Value":"3.78"},{"dims":{"COUNTRY":"Uganda","YEAR":"2011","GHO":"Proportion of young women and men aged 18-29 years who experienced sexual violence by age 18 (%)","AGEGROUP":"18-29 years","SEX":"Male"},"Comments":"DHS 2011","Value":"2.34"},{"dims":{"COUNTRY":"Uganda","YEAR":"2011","GHO":"Proportion of young women and men aged 18-29 years who experienced sexual violence by age 18 (%)","AGEGROUP":"18-29 years","SEX":"Female"},"Comments":"DHS 2011","Value":"8.21"},{"dims":{"COUNTRY":"Ukraine","YEAR":"2007","GHO":"Proportion of young women and men aged 18-29 years who experienced sexual violence by age 18 (%)","AGEGROUP":"18-29 years","SEX":"Female"},"Comments":"DHS 2007","Value":"1.84"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2010","GHO":"Proportion of young women and men aged 18-29 years who experienced sexual violence by age 18 (%)","AGEGROUP":"18-29 years","SEX":"Female"},"Comments":"DHS 2010","Value":"6.33"},{"dims":{"COUNTRY":"Zambia","YEAR":"2014","GHO":"Proportion of young women and men aged 18-29 years who experienced sexual violence by age 18 (%)","AGEGROUP":"18-29 years","SEX":"Female"},"Comments":"DHS 2013-14","Value":"5.47"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"2011","GHO":"Proportion of young women and men aged 18-29 years who experienced sexual violence by age 18 (%)","AGEGROUP":"18-29 years","SEX":"Female"},"Comments":"DHS 2010-11","Value":"12.76"}]}

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_recharts__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WikiQuote_js__ = __webpack_require__(21);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SexWorkersSyphilisData=__webpack_require__(609);var SexWorkersSyphilis=function(_Component){_inherits(SexWorkersSyphilis,_Component);function SexWorkersSyphilis(props){_classCallCheck(this,SexWorkersSyphilis);var _this=_possibleConstructorReturn(this,(SexWorkersSyphilis.__proto__||Object.getPrototypeOf(SexWorkersSyphilis)).call(this,props));_this.state={data:[],quote:""};return _this;}_createClass(SexWorkersSyphilis,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var quote="",data=[];var success=function success(wikiData){quote='"'+wikiData.quote+'"';};__WEBPACK_IMPORTED_MODULE_3__WikiQuote_js__["a" /* WikiquoteApi */].getRandomQuote("Disease",success,__WEBPACK_IMPORTED_MODULE_3__WikiQuote_js__["b" /* error */]);data=Object(__WEBPACK_IMPORTED_MODULE_2__utils_js__["h" /* mapTable */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_js__["f" /* filterTable */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_js__["g" /* initialReformat */])(SexWorkersSyphilisData)));var checkQuoteLength=function checkQuoteLength(){if(quote.length>0){_this2.setState({quote:quote,data:data});}else{setTimeout(checkQuoteLength,100);}};checkQuoteLength();}},{key:'render',value:function render(){var data=[],finalData=[],i=0;if(this.state.data.length>0){//format data so that data can be utilised by year... [title: {year: [obj_with_data, ...], ...}, ...]
data=Object(__WEBPACK_IMPORTED_MODULE_2__utils_js__["c" /* filterAll */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_js__["b" /* dataFunction */])(this.state.data));data=data['Sex workers with active syphilis (%)'];//for a bar the table must be used to compare data based upon a datakey for the x-axis, a specific dataKey for each country works
finalData[i]={};finalData[i].xaxis='';//because I could not put each country as its own x-axis value I had to give them an individual one, so only one object is made with the country/value I want
//basically grab the last year that data was available for the country
for(var key in data){data[key].forEach(function(obj){if(key>2011){finalData[i][obj.country]=parseFloat(obj.value);}});}}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'chart bar syphilis'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,this.state.quote),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h6',null,'Sex workers with active syphilis (%) - Most Recent Year Data'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["k" /* ResponsiveContainer */],{width:'100%',height:300},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["b" /* BarChart */],{cx:'50%',cy:'50%',outerRadius:'80%',data:finalData},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["m" /* XAxis */],{dataKey:'xaxis'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["n" /* YAxis */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["c" /* CartesianGrid */],{strokeDasharray:'3 3'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["l" /* Tooltip */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["a" /* Bar */],{dataKey:'Brazil',fill:'black'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["a" /* Bar */],{dataKey:'Paraguay',fill:'green'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["a" /* Bar */],{dataKey:'Chile',fill:'purple'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["a" /* Bar */],{dataKey:'China',fill:'orange'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["a" /* Bar */],{dataKey:'Bulgaria',fill:'brown'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["a" /* Bar */],{dataKey:'Dominican Republic',fill:'#C90016'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["a" /* Bar */],{dataKey:'Indonesia',fill:'red'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["a" /* Bar */],{dataKey:'Myanmar',fill:'pink'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["a" /* Bar */],{dataKey:'Zimbabwe',fill:'grey'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["a" /* Bar */],{dataKey:'Senegal',fill:'blue'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["a" /* Bar */],{dataKey:'Algeria',fill:'gold'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["a" /* Bar */],{dataKey:'Mongolia',fill:'maroon'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_recharts__["a" /* Bar */],{dataKey:'Ghana',fill:'lime'}))));}}]);return SexWorkersSyphilis;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SexWorkersSyphilis);

/***/ }),
/* 609 */
/***/ (function(module, exports) {

module.exports = {"dimension":[{"label":"GHO","display":"Indicator"},{"label":"PUBLISHSTATE","display":"PUBLISH STATES"},{"label":"YEAR","display":"Year"},{"label":"REGION","display":"WHO region"},{"label":"COUNTRY","display":"Country"}],"fact":[{"dims":{"COUNTRY":"Afghanistan","YEAR":"2012","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data collection period: 01/06/2012 to 30/09/2012.  Data source: Integrated Behavioral Biological Surveillance (IBBS), 2012.  Data are not representative.  Data are consistent with the definition of active syphilis for GARPR (both treponemal and non-treponemal test positive)(Serological test (Rapid test kit) was used).  Comments: the data collected from three sites (Kabul, Mazar-i-Sharif and Hirat). The data is collected from three sites (three cities). ","Value":"1.0"},{"dims":{"COUNTRY":"Afghanistan","YEAR":"2010","GHO":"Sex workers with active syphilis (%)"},"Value":"8.7"},{"dims":{"COUNTRY":"Algeria","YEAR":"2013","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data collection period: 01/06/2013 to 31/12/2013.  Data source: Project report: \"Improving access to prevention, treatment and support for HIV among Sex Workers in Oran,\" December 2013. NGOs: AIDS Algeria. (Original: Rapport du projet: \"Renforcer l�acc�s � la pr�vention, traitement et appui li�s au VIH aupr�s des Travailleurs du sexe � Oran\", D�cembre 2013 . ONG: AIDS Alg�rie.  ) Data are not representative.  Data are consistent with the definition of active syphilis for GARPR (both treponemal and non-treponemal test positive).  Comments: Outreach program at Oran (western Algeria). (Origina: Programme de proximit� au niveau de la wilaya d'Oran (Ouest Alg�rien). )","Value":"7.4"},{"dims":{"COUNTRY":"Algeria","YEAR":"2008","GHO":"Sex workers with active syphilis (%)"},"Value":"18.4"},{"dims":{"COUNTRY":"Angola","YEAR":"2010","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data refers to 2010 Feb 15 to 2011 May 16. These data are from the behavioral surveillance and serology study of HIV and syphilis in young women from 15-24 years involved in transactional sex on the border between Angola and Namibia (Cunene Province), conducted by INLS/CDC in 2010.  This study is not representative of all female sex workers because it was done in a border area in one province.","Value":"3.7"},{"dims":{"COUNTRY":"Argentina","YEAR":"2008","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data source: Pando MA, et al. Incidence of HIV-1 infection, antiretroviral drug resistance and molecular characterization in newly diagnosed individuals in Argentina. A Global Fund Project. AIDS Research and Human Retroviruses, 2011;27(1):17-23. ISSN: 0889-2229","Value":"22.4"},{"dims":{"COUNTRY":"Armenia","YEAR":"2014","GHO":"Sex workers with active syphilis (%)"},"Comments":"Source: Integrated Biological and Behavioral Survaillance Survey. Comments: Respondent-driven sampling (RDS) was used to conduct surveillance among SWs. Data are representative.","Value":"0.8"},{"dims":{"COUNTRY":"Armenia","YEAR":"2012","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data source: Integrated BioBehavioral Surveillance (IBBS) Survey.","Value":"4"},{"dims":{"COUNTRY":"Armenia","YEAR":"2010","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data refers to September 1 to October 31 of reference year.","Value":"3.1"},{"dims":{"COUNTRY":"Bahamas","YEAR":"2013","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data are not representative.  Data are consistent with the definition of active syphilis for GARPR (both treponemal and non-treponemal test positive).  Comments: SMALL SELECT SUBSET ATTENDING COMPREHENSIVE STI CLINIC. ","Value":"0.0"},{"dims":{"COUNTRY":"Bahamas","YEAR":"2010","GHO":"Sex workers with active syphilis (%)"},"Value":"0.0"},{"dims":{"COUNTRY":"Bangladesh","YEAR":"2014","GHO":"Sex workers with active syphilis (%)"},"Value":"3.5"},{"dims":{"COUNTRY":"Bangladesh","YEAR":"2013","GHO":"Sex workers with active syphilis (%)"},"Value":"3.6"},{"dims":{"COUNTRY":"Bangladesh","YEAR":"2011","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data refers to 2010 December 1 to 2011 June 30. Govt. of Bangladesh, 2011. National HIV Serological Surveillance, 9th Round Technical Report, 2011 Bangladesh. National AIDS/STD Program, Directorate General of Health Services, Ministry of Health and Family Welfare, Govt. of Bangladesh.","Value":"3.8"},{"dims":{"COUNTRY":"Bangladesh","YEAR":"2010","GHO":"Sex workers with active syphilis (%)"},"Comments":"Presented data is from HSS Round 8 which has not yet been officially published but has been widely used and accepted by national stakeholders.","Value":"4.2"},{"dims":{"COUNTRY":"Bangladesh","YEAR":"2007","GHO":"Sex workers with active syphilis (%)"},"Comments":"HSS-8 (2007) data is unpublished data. Brothel based sex female workers was not included in 8th round HSS.","Value":"4.5"},{"dims":{"COUNTRY":"Belarus","YEAR":"2013","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data collection period: 01/08/2013 to 30/11/2013.  Data source: The results of behavioral and biomedical research among IDUs, MSM, FSW in the Republic of Belarus for 2013. (Original: ?????????? ?????????????? ? ??????????????? ???????????? ????? ???, ???, ??? ? ?????????? ???????? ?? 2013 ???. ) Data are representative.  Data are consistent with the definition of active syphilis for GARPR (both treponemal and non-treponemal test positive).  ","Value":"1.6"},{"dims":{"COUNTRY":"Belarus","YEAR":"2011","GHO":"Sex workers with active syphilis (%)"},"Value":"0.6"},{"dims":{"COUNTRY":"Belgium","YEAR":"2013","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data collection period: 01/01/2013 to 01/01/2013.  Data source: Date of routine programme from 2 psycho-socio-medical organizations dedicated to sex workers: Ghapro: organization covering provinces of Antwere and part of Flemish Brabant, Flanders. They had contacts with 1345 SW in 2013 (121 male; 1224 female; 320 <25 years; 1025 >=25 years) Espace. P: organization covering Wallonia and Brussels. They had contacts with 865 SW (12 male; 853 female; <25 years: 212; >=25 years: 618).  Data are not representative.  Data are not consistent with the definition of active syphilis for GARPR.  Comments: Data provided are merged from the 2 sources: Ghapro (Flanders) and Espace.P (Wallonia & Brussels). The disaggregated data are: Ghapro: 6 syphillis on 1136 SW = 0.5% Espace. P : 6 syphillis on 710 SW = 0.8%. Data from routine programme but not from a survey with a representative sampling. ","Value":"0.7"},{"dims":{"COUNTRY":"Belgium","YEAR":"2011","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data from Flemish community (routine data from Ghapro in 2011, a medico-social centre for SW in Antwerp), not representative of all SW.","Value":"1.0"},{"dims":{"COUNTRY":"Belgium","YEAR":"2010","GHO":"Sex workers with active syphilis (%)"},"Value":"0.2"},{"dims":{"COUNTRY":"Belize","YEAR":"2012","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data source: BSS.","Value":"0.5"},{"dims":{"COUNTRY":"Bolivia (Plurinational State of)","YEAR":"2014","GHO":"Sex workers with active syphilis (%)"},"Comments":"Source: Data from routine monitoring by the Departmental Monitoring and Reference Centers of STI / AIDS (Original: Corresponde a las vigilancia regular de los CDVIR/CRVIR). Comments: Data are representative.","Value":"3"},{"dims":{"COUNTRY":"Bolivia (Plurinational State of)","YEAR":"2013","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data are representative.  Data are consistent with the definition of active syphilis for GARPR (both treponemal and non-treponemal test positive).  Comments: The data correspond to sex workers attending prevention programs, ie attending Monitoring, Information and Referral Centers (CDVIR). (Original: Los datos corresponden a trabajadoras sexuales usuarias de los programas de prevenci�n, es decir que acuden a los Centros de Vigilancia Informaci�n y Referencia (CDVIR). )","Value":"3.1"},{"dims":{"COUNTRY":"Bolivia (Plurinational State of)","YEAR":"2011","GHO":"Sex workers with active syphilis (%)"},"Comments":"The data come from existing records in the departmental centers (Regional) Information, Monitoring and Reference CDVIR / CRVIR. Coverage is limited only to sex workers attending the program, no information of clandestine workers.","Value":"5.2"},{"dims":{"COUNTRY":"Bolivia (Plurinational State of)","YEAR":"2010","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data collection period: 2010 September 06 to 2010 October 12. Data source: Study of Second Generation Surveilance. Coverage is estimated on sex workers working locally or in the street but does not capture those working by telephone, online or independently (a group that is increasing in number). The data correspond to three cities with high population density and are considered nationally representative.","Value":"8"},{"dims":{"COUNTRY":"Bosnia and Herzegovina","YEAR":"2011","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data refers to 2010 November 1 to 2011 February 28. The research was conducted as a study of a cross-section of the population of female sex workers (SW) and men who have sex with men (MSM) in major cities in BiH: Sarajevo, Tuzla, Banja Luka, Bijeljina, Prijedor. All the places were selected on the basis of estimated presence of high-risk groups, availability of outreach workers, involvement of NGOs and availability of reliable information. Both samples were selected applying the “Snowball” sampling method.","Value":"4.0"},{"dims":{"COUNTRY":"Bosnia and Herzegovina","YEAR":"2008","GHO":"Sex workers with active syphilis (%)"},"Value":"7.2"},{"dims":{"COUNTRY":"Botswana","YEAR":"2012","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data collection period: 01/07/2012 to 31/10/2012.  Data source: Mapping, Size Estimation, and Biological and Behavorial Surveillance Study of HIV and Sexually Transmitted Infections Among Selected High Risk Sub-Populations in Botswana (2012).  Data are not representative.  Data are consistent with the definition of active syphilis for GARPR (both treponemal and non-treponemal test positive).  Comments: This data represents female sex workers only.","Value":"3.5"},{"dims":{"COUNTRY":"Brazil","YEAR":"2013","GHO":"Sex workers with active syphilis (%)"},"Value":"2.5"},{"dims":{"COUNTRY":"Brazil","YEAR":"2009","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data collection period: 01/01/2009 to 31/12/2009.  Data source: RDS among female sex workers in ten municipalities in Brazil (age 18+).  Data are not representative.  Data are consistent with the definition of active syphilis for GARPR (both treponemal and non-treponemal test positive).  ","Value":"2.5"},{"dims":{"COUNTRY":"Bulgaria","YEAR":"2012","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data collection period: 01/09/2012 to 30/11/2012.  Data are not representative.  Data are not consistent with the definition of active syphilis for GARPR.  Comments: Integrated biological and behavioral surveillance (IBBS) among sex workers in Bulgaria has been conducted yearly since 2004. Surveillance is based on repeated cross-sectional surveys of eligible population, recruitment primarily carried out from selected venues. Information on demographics, substance use, injecting and sexual behaviours, were collected through an FHI-structured and adapted questionnaire during face-to-face interviews. A blood sample was collected for testing for HIV/ HCV/ HCB and syphilis.  It is important to note that ELISA Syphilis tests were performed and reported data on the number of sex workers who tested positive account for reactive test results rather than active syphilis. ","Value":"15.3"},{"dims":{"COUNTRY":"Bulgaria","YEAR":"2011","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data refers to Oct 1 to Nov 30 of reference year. Integrated biological and behavioral surveillance (IBBS) among sex workers in Bulgaria has been conducted yearly since 2004. Surveillance is based on repeated cross-sectional surveys of eligible population, recruitment primarily carried out from selected venues. It is important to note that ELISA Syphilis tests were performed and reported data on the number of sex workers who tested positive account for reactive test results rather than active syphilis.","Value":"9.6"},{"dims":{"COUNTRY":"Burkina Faso","YEAR":"2014","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data collection period: 07/01/2013 to 30/06/2014.         Source: Behavioral and serosurveillance study of HIV and syphilis among men who have sex with men (MSM) and sex workers (SW), Burkina Faso (Original: Etude comportementale et de serosurveillance du VIH et de la syphilis aupr�s des hommes ayant des rapports sexuels avec des hommes (HSH) et les travailleuses de sexe (TS), au Burkina Faso).                     Comments: The survey of SW took place from January to August 2013 and two cities from March to June 2014 three other cities. Totaling five (05) cities covered by the survey. (Original: L'�tude aupr�s des TS s'est d�roul� de janvier � ao�t 2013 dans deux villes puis de mars � juin 2014 dans trois autres villes. Soit au total cinq (05) villes couvertes par l'enqu�te.)","Value":"1.4"},{"dims":{"COUNTRY":"Burundi","YEAR":"2008","GHO":"Sex workers with active syphilis (%)"},"Value":"28.1"},{"dims":{"COUNTRY":"Côte d'Ivoire","YEAR":"2014","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data collection period: 18/03/2014 to 28/06/2015. Source: Special studies - Bio Behavioral Survey.              Comments: The investigation was carried out only in the Abidjan District (Original: l'Enqu�te s'est deroulement uniquement dans le District d'Abidjan). Data are not representative. Data are not consistent with the definition of active syphilis for GARPR (both treponemal and non-treponemal test positive).","Value":"0.9"},{"dims":{"COUNTRY":"Cabo Verde","YEAR":"2013","GHO":"Sex workers with active syphilis (%)"},"Comments":"Source:  Report from the NGO 'Verdefam', which works in health centres and mobile outposts for the screening of STIs in sex workers (Original: Rapport de l'ONG Verdefam qui travaille dans les centres de sant� et dans les postes mobiles pour le depistage des IST au sein des  travailleurs de sexe).        Comments: The data are only representative of the intervention sites (Original: Les donn�s represent seulement les sites d'intervention ( Praia , Santa Catarina, Tarrafal, Santa Cruz, et  Mindelo))","Value":"0.9"},{"dims":{"COUNTRY":"Cabo Verde","YEAR":"2012","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data source: Progress reports from mobile STI clinics.","Value":"1.8"},{"dims":{"COUNTRY":"Cabo Verde","YEAR":"2011","GHO":"Sex workers with active syphilis (%)"},"Value":"8.2"},{"dims":{"COUNTRY":"Cambodia","YEAR":"2014","GHO":"Sex workers with active syphilis (%)"},"Comments":"Source: Link Response monitoring report 2014","Value":"0.1"},{"dims":{"COUNTRY":"Cambodia","YEAR":"2012","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data source: NCHADS and RHAC. Entertainment Workers (EWs) visiting the STI clinic for the first time were tested for syphilis. Test type: RPR used in screening and  TPPA/TPHA confirmed.The denominator is the number of EWs who visited the STI clinic at first time only who were tested for syphilis with RPR test(first test), and the numerator is the number of EWs who have a positive syphilis serology with TPPA/TPHA test (confirmed test). All positive cases were treated. ","Value":"0.9"},{"dims":{"COUNTRY":"Cambodia","YEAR":"2011","GHO":"Sex workers with active syphilis (%)"},"Comments":"The syphilis screening test performed only for Entertainment Workers (EWs) who visited the STI clinic for the first time. We processed  the RPR test as the first test for screening syphilis and used TPPA/TPHA as the confirmed test. The denominator is the number of EWs who visited the STI clinic at first time only who were tested for syphilis with RPR test (first test), and the numerator is the number of EWs who have a positive syphilis serology with TPPA/TPHA test (confirmatory test).","Value":"2.1"},{"dims":{"COUNTRY":"Cambodia","YEAR":"2005","GHO":"Sex workers with active syphilis (%)"},"Comments":"STI sentinel surveillance: Female commercial sex workers.","Value":"2.3"},{"dims":{"COUNTRY":"Cameroon","YEAR":"2010","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data collection period: 01/01/2010 to 31/03/2010.  Data source: Epidemiological and behavioral survey of HIV and syphilis among sex workers in Cameroon. (Original: Enqu�te �pid�miologique et comportementale du VIH et de la syphilis chez les travailleurs de sexe au Cameroun.  ) Data are representative.  Data are consistent with the definition of active syphilis for GARPR (both treponemal and non-treponemal test positive).  ","Value":"17.5"},{"dims":{"COUNTRY":"Central African Republic","YEAR":"2013","GHO":"Sex workers with active syphilis (%)"},"Comments":"Source: Special studies. Comments: Small sample. Data are not representative.","Value":"5"},{"dims":{"COUNTRY":"Chile","YEAR":"2014","GHO":"Sex workers with active syphilis (%)"},"Value":"11.1"},{"dims":{"COUNTRY":"Chile","YEAR":"2013","GHO":"Sex workers with active syphilis (%)"},"Value":"7.0"},{"dims":{"COUNTRY":"Chile","YEAR":"2011","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data source: Monthly Statistical Records (REM) of the Public Health System. The numerator refers to screening tests (RPR and VDRL) that were reactive for syphilis for sex workers attending sexual health centers of the Public Health System. The denominator indicates the total number of screening tests for syphilis (RPR and VDRL) processed in sex workers attending sexual health centers Public Health System.","Value":"10.3"},{"dims":{"COUNTRY":"Chile","YEAR":"2010","GHO":"Sex workers with active syphilis (%)"},"Value":"6.3"},{"dims":{"COUNTRY":"Chile","YEAR":"2008","GHO":"Sex workers with active syphilis (%)"},"Value":"0.2"},{"dims":{"COUNTRY":"China","YEAR":"2014","GHO":"Sex workers with active syphilis (%)"},"Comments":"Source:  National HIV sentinel surveillance, 2014. Data are representative.","Value":"2.3"},{"dims":{"COUNTRY":"China","YEAR":"2013","GHO":"Sex workers with active syphilis (%)"},"Value":"2.6"},{"dims":{"COUNTRY":"China","YEAR":"2012","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data collection period: 2012 April 01 to 2012 June 30. Data source: 2012 National HIV sentinel surveillance.","Value":"2.6"},{"dims":{"COUNTRY":"China","YEAR":"2011","GHO":"Sex workers with active syphilis (%)"},"Value":"2.8"},{"dims":{"COUNTRY":"China","YEAR":"2010","GHO":"Sex workers with active syphilis (%)"},"Value":"2.9"},{"dims":{"COUNTRY":"China","YEAR":"2008","GHO":"Sex workers with active syphilis (%)"},"Value":"2.7"},{"dims":{"COUNTRY":"Colombia","YEAR":"2008","GHO":"Sex workers with active syphilis (%)"},"Comments":"Based upon a random sample of establishments where sex workers worked in Medellín, Barranquilla, Bucaramanga, and Cali.","Value":"18.0"},{"dims":{"COUNTRY":"Comoros","YEAR":"2014","GHO":"Sex workers with active syphilis (%)"},"Comments":"Source: National programme data (Routine data). Data are not representative.","Value":"0.8"},{"dims":{"COUNTRY":"Comoros","YEAR":"2010","GHO":"Sex workers with active syphilis (%)"},"Comments":"These Sex Workers were followed through the sentinel surveillance system.","Value":"0.5"},{"dims":{"COUNTRY":"Comoros","YEAR":"2008","GHO":"Sex workers with active syphilis (%)"},"Value":"7.1"},{"dims":{"COUNTRY":"Costa Rica","YEAR":"2013","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data collection period: 01/01/2013 to 15/10/2013.  Data are not representative.  Data are consistent with the definition of active syphilis for GARPR (both treponemal and non-treponemal test positive).  Comments: This information corresponds to a single sentinel site for VICITS, located in the greater metropolitan area of the country. The information corresponds to sex workers. (Original: Esta informaci�n corresponde a un solo sitio centinela VICITS, ubicado en el Gran Area Metropolitana del pa�s, la informaci�n corresponde a Trabajadoras del sexo. )","Value":"4.5"},{"dims":{"COUNTRY":"Costa Rica","YEAR":"2010","GHO":"Sex workers with active syphilis (%)"},"Value":"12.9"},{"dims":{"COUNTRY":"Czechia","YEAR":"2010","GHO":"Sex workers with active syphilis (%)"},"Comments":"Cross-sectional study and prevalence assessment among sex workers of STI and HIV was conducted by NGO Bliss without Risk.","Value":"2.1"},{"dims":{"COUNTRY":"Djibouti","YEAR":"2014","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data collection period: 01/03/2014 to 31/03/2014. Source: Integrated bio-behavioral survey on HIV-AIDS among female sex and long-distance truck drivers. Djibouti, 2014. (Original: Enqu�te int�gr�e bio-comportementale sur le VIH-SIDA chez les professionnelles de sexe et les conducteurs de camion sur longue distance. Djibouti, 2014)     Comments: The study was conducted in four urban sites: Q2, Q4, and Arhiba PK12. (L'�tude a �t� men�e sur 4 sites urbains:  Q2, Q4, ARHIBA et PK12.) Data are not representative. ","Value":"5"},{"dims":{"COUNTRY":"Dominican Republic","YEAR":"2012","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data collection period: 01/07/2012 to 31/08/2012.  Data source: Behavior Surveillance Survey with serological data, 2012 (Original: Encuesta de Vigilancia de Comportamiento con vinculacion serologica, 2012. ) Data are not representative.  Data are not consistent with the definition of active syphilis for GARPR.  Comments:  The survey was conducted in 5 provinces. (Original: La encuesta se realizo en 5 provincias.)","Value":"9.5"},{"dims":{"COUNTRY":"Dominican Republic","YEAR":"2008","GHO":"Sex workers with active syphilis (%)"},"Value":"9.0"},{"dims":{"COUNTRY":"Dominican Republic","YEAR":"2007","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data refers to February 28 to August 31 of reference year. Source: 1st Behavior Surveillance Survey by Serological Linking Vulnerable Populations: GTH, TRSX, UD, 2008.","Value":"7.0"},{"dims":{"COUNTRY":"El Salvador","YEAR":"2014","GHO":"Sex workers with active syphilis (%)"},"Comments":"Source: Sentinel surveillance. Data are representative.","Value":"1"},{"dims":{"COUNTRY":"El Salvador","YEAR":"2012","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data collection period: 01/07/2012 to 31/12/2012.  Data are representative.  Data are consistent with the definition of active syphilis for GARPR (both treponemal and non-treponemal test positive).  ","Value":"1.4"},{"dims":{"COUNTRY":"El Salvador","YEAR":"2010","GHO":"Sex workers with active syphilis (%)"},"Comments":"The data for sex workers is for the City of San Salvador which is the capital of El Salvador, and is taken from the Central Monitoring Survey Sexual Behavior and HIV Prevalence / STIs in Vulnerable Populations (ECVC) 2010.","Value":"17.5"},{"dims":{"COUNTRY":"El Salvador","YEAR":"2008","GHO":"Sex workers with active syphilis (%)"},"Comments":"Taken from the Central Survey of Sexual Behavior Surveillance and Prevalence of HIV / STIs in Vulnerable Populations, 2008; inlcudes only female sex workers, data for the Department of San Salvador.","Value":"2.7"},{"dims":{"COUNTRY":"Eritrea","YEAR":"2008","GHO":"Sex workers with active syphilis (%)"},"Value":"1.3"},{"dims":{"COUNTRY":"Estonia","YEAR":"2011","GHO":"Sex workers with active syphilis (%)"},"Comments":"Study on FEMALE CSWs in Tallinn (capital city) in summer 2011. The study was part of the international BORDERNETWork Project coordinated by the SPI Forschung GmbH in Germany. Sampling method: Respondent Driven Sampling. Rapid testing for syphilis. Sample size was 210, and out of these, two (0.9%) were tested positive for syphilis.","Value":"0.9"},{"dims":{"COUNTRY":"Fiji","YEAR":"2012","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data collection period: 07/06/2012 to 25/08/2012.  Data source: IBBS Survey for SW.  Data are not representative.  Data are not consistent with the definition of active syphilis for GARPR.  ","Value":"28.0"},{"dims":{"COUNTRY":"Gabon","YEAR":"2010","GHO":"Sex workers with active syphilis (%)"},"Comments":"KAP and seroprevalence study in the PS in Libreville and Owendo.","Value":"2.1"},{"dims":{"COUNTRY":"Gabon","YEAR":"2008","GHO":"Sex workers with active syphilis (%)"},"Value":"6.0"},{"dims":{"COUNTRY":"Georgia","YEAR":"2006","GHO":"Sex workers with active syphilis (%)"},"Comments":"BSS study , conducted by: Save The Children, Tanadgoma, Bemoni, National AIDS Center (IDACIRC) , 2006.","Value":"23.8"},{"dims":{"COUNTRY":"Germany","YEAR":"2010","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data collection period: 01/01/2010 to 30/04/2011.  Data are not representative.  Data are consistent with the definition of active syphilis for GARPR (both treponemal and non-treponemal test positive).  Comments: The data provided stem from the cross-sectional study KABP-Surv STI, performed between January 2010 and April 2011 in 24 local public health departments across Germany. The study population consists of female and transgender sex workers, recruited while attending a low-threshold HIV/STI consultation. A diagnosis-questionnaire, filled out by the physician, was available for 1225 participants. ","Value":"0.8"},{"dims":{"COUNTRY":"Ghana","YEAR":"2013","GHO":"Sex workers with active syphilis (%)"},"Value":"6.8"},{"dims":{"COUNTRY":"Ghana","YEAR":"2011","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data collection period: 2011 August 01 to 2011 October 31. Data source: Integrated BioBehavioral Surveillance (IBBS) Survey.","Value":"6.3"},{"dims":{"COUNTRY":"Guatemala","YEAR":"2014","GHO":"Sex workers with active syphilis (%)"},"Comments":"Source: Special studies and Sentinel Surveillance of key populations (Original: Estudios especiales y Vigilancia Centinela).             Comments: The primary source for this indicator is clinical data from 11 specialized clinics across the country. It is not possible to calculate a single percentage from data from the ECVC.    Sex workers (MTS). EVC data collected from 6% in active syphilis in Escuintla; Sex workers (MTS). ECVC 0.8 data collected from active syphilis in Guatemala City; Sex workers (MTS). ECVC data collected from 0% in active syphilis in Malacat�n. (Original: Profesionales del sexo ( MTS). Datos recolectado de ECVC  6% en sifilis activa en Escuintla; Profesionales del sexo ( MTS). datos recolectado de ECVC 0.8 sifilis activa en Ciudad de Guatemala; Profesionales del sexo ( MTS). datos recolectado de ECVC 0% en sifilis activa en Malacatan)        Data are representative.","Value":"0.5"},{"dims":{"COUNTRY":"Guatemala","YEAR":"2013","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data are not representative.  Data are consistent with the definition of active syphilis for GARPR (both treponemal and non-treponemal test positive).  Comments: Information obtained from 5 VICITS sites: Xela Health Center, Health Center of Zone 3, Puerto Barrios Health Center, Coatepeque Hospital, Marco Antonio Foundation. (Original: Informaci�n obtenida de 5 sitios VICITS, Centro de Salud de Xela, Centro de Salud de la Zona 3, Cetro de Salud de Puerto Barrios, Hospital de Coatepeque, Fundaci�n Marco Antonio. )","Value":"0.7"},{"dims":{"COUNTRY":"Guatemala","YEAR":"2012","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data source: Sentinel Surveillance of sexually transmitted infections (VICITS). Including 4 sentinel sites including Health Care No.2 ITS, Marco Antonio Foundation in Guatemala City Health Center of Puerto Barrios Izabal and Quetzaltenango Health Center.","Value":"0.3"},{"dims":{"COUNTRY":"Guatemala","YEAR":"2011","GHO":"Sex workers with active syphilis (%)"},"Value":"1.4"},{"dims":{"COUNTRY":"Guatemala","YEAR":"2010","GHO":"Sex workers with active syphilis (%)"},"Value":"4.8"},{"dims":{"COUNTRY":"Guatemala","YEAR":"2008","GHO":"Sex workers with active syphilis (%)"},"Value":"6.0"},{"dims":{"COUNTRY":"Guinea-Bissau","YEAR":"2010","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data obtained from the study of STIs among FSWs.","Value":"19.6"},{"dims":{"COUNTRY":"Guyana","YEAR":"2014","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data collection period: 01/11/2013 to 31/10/2014.   Source: Bio-behavioural Surveillance survey.     Comments: A total of 530 sex workers were interviewed (male, female and transwomen). The survey methodology was different from the 2009 study. In 2014, the PLACE methodology was utilized- the same was much larger as well as the scope of the study which gathered data from 9 out of 10 administrative regions in the country. persons did not have to self-identify to be recruited into the survey as was the case in the 2009 survey. The study was not population based. It was carried out in 9 out of 10 administartive regions in the country. A Rapid Plasma Reagin Test was used. Data are not representative.","Value":"1.6"},{"dims":{"COUNTRY":"Guyana","YEAR":"2005","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data collection period: 01/01/2004 to 31/12/2005.  Data source: BBSS 2004/2005.  Data are not representative.  Data are not consistent with the definition of active syphilis for GARPR testing was done using the rapid plasma reagin (RPR) test and all samples with a titre of 1.8 and above were considered as having active syphilis).  Comments: Data was collected in the BBSS 2008/9 and 8.5% of sex workers self reported having sores or boils on their vagina or anus in the 12 months preceding the survey (n=199). Data was collected from 6 out of 10 regions. Data collected from 3 out of 10 administrative regions: Regions 4, 6 and 10. ","Value":"15.4"},{"dims":{"COUNTRY":"Honduras","YEAR":"2014","GHO":"Sex workers with active syphilis (%)"},"Comments":"Source: Sentinel Surveillance. Comments: These data are collected from the VICITS strategy. The data do not represent the whole country. Currently it has been implemented in five regions: Atlantida, Cortes, Tegucigalpa Metropolitan, Metropolitan Region of San Pedro Sula and Choluteca. This is a strategy that is being implemented progressively. (Original: Esto corresponde a la estrategia VICITS. Los datos no representan a todo el pa�s. Actualmente se ha implementado en 5 regiones: Atl�ntida, Cort�s, Metropolitana de Tegucigalpa, Regi�n Metropolitana de San Pedro Sula y Choluteca. Esta es una estrategia que se esta implementando progresivamente.)    Data are not representative. ","Value":"2.3"},{"dims":{"COUNTRY":"Honduras","YEAR":"2013","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data are consistent with the definition of active syphilis for GARPR (both treponemal and non-treponemal test positive).  Comments: This corresponds to the VICITS strategy. The data do not represent the whole country. It has now been implemented in five regions: Atlantis, Cortez, Tegucigalpa Metropolitan, metropolitan area of ??San Pedro Sula and Choluteca. There is a plan to extend this coverage to more regions in the country. (Original: Esto corresponde a la estrategia VICITS. Los datos no representan a todo el pa�s. Actualmente se ha implementado en 5 regiones: Atl�ntida, Cort�z, Metropolitana de Tegucigalpa, Regi�n Metropolitana de San Pedro Sula y Choluteca. Existe la visi�n de ampliar esta cobertura a mas regiones en el pa�s.)","Value":"2.6"},{"dims":{"COUNTRY":"Honduras","YEAR":"2012","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data source: Data Strategy Sentinel Surveillance of Sexually Transmitted Infections (VICITS) in sex workers and UMIETS, Ministry of Health. ","Value":"2"},{"dims":{"COUNTRY":"Honduras","YEAR":"2010","GHO":"Sex workers with active syphilis (%)"},"Value":"1.5"},{"dims":{"COUNTRY":"Honduras","YEAR":"2008","GHO":"Sex workers with active syphilis (%)"},"Value":"6.4"},{"dims":{"COUNTRY":"India","YEAR":"2014","GHO":"Sex workers with active syphilis (%)"},"Comments":"Source: National programme data. Comments: Data are not representative.","Value":"0.3"},{"dims":{"COUNTRY":"India","YEAR":"2012","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data source: Programme Data from Designated STI Clinics through NACO Computerized Management Information System. The data reported is through designated STI clinics located within health facilities at district level and above only. It does not include ANC visits at sub-district health facilities (Primary Health Centres, Community Health Centres, Block PHCs etc.).","Value":"0.8"},{"dims":{"COUNTRY":"India","YEAR":"2008","GHO":"Sex workers with active syphilis (%)"},"Value":"3.1"},{"dims":{"COUNTRY":"Indonesia","YEAR":"2014","GHO":"Sex workers with active syphilis (%)"},"Comments":"Source: Monthly STI report, MOH. Comments: Data are representative.","Value":"4.1"},{"dims":{"COUNTRY":"Indonesia","YEAR":"2013","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data are representative.  Data are consistent with the definition of active syphilis for GARPR (both treponemal and non-treponemal test positive).  Comments: Data measurement source is monthly STI report, MoH. ","Value":"6.8"},{"dims":{"COUNTRY":"Indonesia","YEAR":"2012","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data source: Monthly STI Report, Sub Directorate AIDS & STD, MoH","Value":"7.9"},{"dims":{"COUNTRY":"Indonesia","YEAR":"2011","GHO":"Sex workers with active syphilis (%)"},"Comments":"Monthly report of STI services, AIDS & STD Sub Directorate - MoH 2011.","Value":"8.6"},{"dims":{"COUNTRY":"Indonesia","YEAR":"2010","GHO":"Sex workers with active syphilis (%)"},"Comments":"Syphilis prevalence among direct FSW was 7%, indirect FSW was 3%, waria was 13%.","Value":"6.1"},{"dims":{"COUNTRY":"Indonesia","YEAR":"2008","GHO":"Sex workers with active syphilis (%)"},"Value":"15.0"},{"dims":{"COUNTRY":"Iran (Islamic Republic of)","YEAR":"2010","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data collection period: 01/09/2010 to 01/03/2011.  Data source: RDS among FSW in Shiraz district using both behavioral questionnaire and blood samples for HIV and syphilis, and vaginal swab for other STIs.  Data are not representative.  Data are consistent with the definition of active syphilis for GARPR (both treponemal and non-treponemal test positive).  Comments: Although the design of the survey is for only Shiraz, other older studies among female high risk population did not reveal higher syphilis prevalence. ","Value":"0.0"},{"dims":{"COUNTRY":"Iran (Islamic Republic of)","YEAR":"2008","GHO":"Sex workers with active syphilis (%)"},"Value":"1.6"},{"dims":{"COUNTRY":"Jamaica","YEAR":"2010","GHO":"Sex workers with active syphilis (%)"},"Value":"1.2"},{"dims":{"COUNTRY":"Jamaica","YEAR":"2008","GHO":"Sex workers with active syphilis (%)"},"Value":"6.2"},{"dims":{"COUNTRY":"Jordan","YEAR":"2008","GHO":"Sex workers with active syphilis (%)"},"Value":"6.7"},{"dims":{"COUNTRY":"Kazakhstan","YEAR":"2008","GHO":"Sex workers with active syphilis (%)"},"Value":"17.7"},{"dims":{"COUNTRY":"Kenya","YEAR":"2011","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data refers to 2010 Nov 1 to 2011 Jan 31. Data is from Integrated biological survey conducted in Nairobi.","Value":"0.9"},{"dims":{"COUNTRY":"Kenya","YEAR":"2010","GHO":"Sex workers with active syphilis (%)"},"Comments":"Nairobi area IBBSS.","Value":"0.8"},{"dims":{"COUNTRY":"Kiribati","YEAR":"2013","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data source: National laboratory Services.  Data are not representative.  Data are consistent with the definition of active syphilis for GARPR (both treponemal and non-treponemal test positive).  Comments: HIV and STI tests were conducted on 30 sex workers from Betio area as part of KFHA campaign targeting this high risk group, and none were positive. ","Value":"0.0"},{"dims":{"COUNTRY":"Kyrgyzstan","YEAR":"2010","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data refers to August 1 to September 30 of reference year.","Value":"10.4"},{"dims":{"COUNTRY":"Kyrgyzstan","YEAR":"2008","GHO":"Sex workers with active syphilis (%)"},"Value":"32.4"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2011","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data collection period: 2011 December 14 to 2011 December 29. Data source: Integrated BioBehaviour Surveillance (IBBS) Survey.","Value":"0.5"},{"dims":{"COUNTRY":"Lao People's Democratic Republic","YEAR":"2008","GHO":"Sex workers with active syphilis (%)"},"Comments":"Results of 3rd round sentinel surveillance.","Value":"0.6"},{"dims":{"COUNTRY":"Lesotho","YEAR":"2014","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data collection period: 01/12/2013 to 31/08/2014. Source: IBBS. Comments: Data collected only on two main sites. Data are not representative.","Value":"27.2"},{"dims":{"COUNTRY":"Liberia","YEAR":"2013","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data source: IBBSS.  Data are representative.  Data are consistent with the definition of active syphilis for GARPR (both treponemal and non-treponemal test positive).  ","Value":"4.3"},{"dims":{"COUNTRY":"Lithuania","YEAR":"2008","GHO":"Sex workers with active syphilis (%)"},"Value":"5.7"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2013","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data are not representative.  Data are consistent with the definition of active syphilis for GARPR (both treponemal and non-treponemal test positive).  Comments: 10 sites were included in the study, with the RDS method. (Original: 10 sites ont �t� concern�s par l'�tude, avec la m�thode RDS. )","Value":"16.7"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2010","GHO":"Sex workers with active syphilis (%)"},"Value":"15.6"},{"dims":{"COUNTRY":"Madagascar","YEAR":"2008","GHO":"Sex workers with active syphilis (%)"},"Value":"12.1"},{"dims":{"COUNTRY":"Malawi","YEAR":"2014","GHO":"Sex workers with active syphilis (%)"},"Comments":"Source: 2013 Malawi Biological and Behaviouraural Surveillance Study (Preliminary Results). Comments: Data as collected refers to SWs with a positive rapid syphillis test but not disaggregated into asymptomatic and active syphillis. Data are representative.","Value":"20"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2012","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data source: Survey. Data is from selected clinics.","Value":"0.7"},{"dims":{"COUNTRY":"Malaysia","YEAR":"2011","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data from survey at selected health facilities (government & private) and NGO sites.","Value":"0.6"},{"dims":{"COUNTRY":"Maldives","YEAR":"2008","GHO":"Sex workers with active syphilis (%)"},"Value":"0.0"},{"dims":{"COUNTRY":"Mali","YEAR":"2010","GHO":"Sex workers with active syphilis (%)"},"Value":"0.0"},{"dims":{"COUNTRY":"Mauritania","YEAR":"2014","GHO":"Sex workers with active syphilis (%)"},"Comments":"Source: Behavioral and Biological Surveillance Surveys (Original: ENQUETE SEROCOMPORTEMENTALE COMBINEE 2014). Data are not representative.","Value":"2.5"},{"dims":{"COUNTRY":"Mauritius","YEAR":"2010","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data refers to August 2 to 17 of reference year. Data from IBBS - FSW (only).","Value":"4.4"},{"dims":{"COUNTRY":"Mexico","YEAR":"2014","GHO":"Sex workers with active syphilis (%)"},"Value":"1.8"},{"dims":{"COUNTRY":"Mexico","YEAR":"2013","GHO":"Sex workers with active syphilis (%)"},"Value":"2.2"},{"dims":{"COUNTRY":"Mexico","YEAR":"2012","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data source: Health Information System (SIS) and DGIS. The numerator is the number of male and female sex workers who tested ??positive for syphilis. The denominator is the total number of male and female sex workers who were tested for syphilis. The Mexican Ministry of Health serves about 55% of the population. Test Type: RPR/VDRL and rapid tests.","Value":"3.5"},{"dims":{"COUNTRY":"Mexico","YEAR":"2011","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data source: SS / DGIS. Health Information System. Data reported by the SAES and CAPASITS at December 31, 2010 and 2011. It includes information from Ministry of Health, for their specialized services for people with HIV / AIDS and STIs. The numerator includes total detection of syphilis conducted in sex workers and the denominator includes positive detections of syphilis in this population. Aggregate information is used for two years (2010-2011).","Value":"2.1"},{"dims":{"COUNTRY":"Mongolia","YEAR":"2014","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data collection period: 17/03/2014 to 09/05/2014. Source: HIV/STI Surveillance Survey Report, 2014. Data are representative.","Value":"29.6"},{"dims":{"COUNTRY":"Mongolia","YEAR":"2012","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data collection period: 02/01/2012 to 29/03/2012.  Data source: HIV, STI Second Generation Sentinel Surveillance Survey.  Data are not representative.  Data are consistent with the definition of active syphilis for GARPR (both treponemal and non-treponemal test positive); person was considered syphilis positive if both RPR and TPHA tests are reactive with RPR titer of 1:2 above.  Comments: Data were collected from Ulaanbaatar city and 4 provinces. ","Value":"27.5"},{"dims":{"COUNTRY":"Mongolia","YEAR":"2009","GHO":"Sex workers with active syphilis (%)"},"Comments":"SGS 2009. In 2009 the sampling of sex workers was done from 5 sites. In previous years' report, data from 2 sites were reported. ","Value":"18.3"},{"dims":{"COUNTRY":"Mongolia","YEAR":"2008","GHO":"Sex workers with active syphilis (%)"},"Value":"20.8"},{"dims":{"COUNTRY":"Morocco","YEAR":"2011","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data collection period: 2011 December 01 to 2012 May 30. Data source: Integrated BioBehavioral Surveillance (IBBS) Survey using Respondent Driven sampling RDS). ","Value":"17.7"},{"dims":{"COUNTRY":"Morocco","YEAR":"2010","GHO":"Sex workers with active syphilis (%)"},"Comments":"Integrated bio-behavioral survey (IBBS) using RDS (Respondent Driven sampling) in 4 cities: Agadir, Rabat, Fès, Tanger.  ","Value":"17.7"},{"dims":{"COUNTRY":"Morocco","YEAR":"2008","GHO":"Sex workers with active syphilis (%)"},"Value":"16.9"},{"dims":{"COUNTRY":"Myanmar","YEAR":"2014","GHO":"Sex workers with active syphilis (%)"},"Comments":"Source: National programme data. Comments: Data from partners are not available. Data are not representative.","Value":"8.7"},{"dims":{"COUNTRY":"Myanmar","YEAR":"2013","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data are not representative.  Data are consistent with the definition of active syphilis for GARPR (both treponemal and non-treponemal test positive).  Comments: Data from partners are not available. ","Value":"11.5"},{"dims":{"COUNTRY":"Myanmar","YEAR":"2012","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data collection period: 2012 March 01 to 2012 May 31.Data source: HIV sero-sentinel surveillance, 2012.","Value":"3.8"},{"dims":{"COUNTRY":"Myanmar","YEAR":"2011","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data refers to March 1 to May 31 of reference year. Data from annul HIV Sero-sentinel surveillance survey 2011, where syphilis testing is included.","Value":"3.9"},{"dims":{"COUNTRY":"Myanmar","YEAR":"2008","GHO":"Sex workers with active syphilis (%)"},"Value":"5.5"},{"dims":{"COUNTRY":"Nepal","YEAR":"2011","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data collection period: 16/01/2011 to 06/03/2011.  Data source: Integrated Biological and behavior Surveillance Surveys.  Data are not representative.  Data are consistent with the definition of active syphilis for GARPR (both treponemal and non-treponemal test positive).  Comments: We have two separate studies for male sex workers and female sex workers. Since only one field is available for data entry, we have entered data for female sex workers as 0.67% (Source: IBBS among FSWs in Kathmandu valley, 2011) for now. However, percentage of MSW with active syphilis is 2.2% (Source: IBBS among MSM/TG in Kathmandu valley, 2012). IBBS Surveys in Nepal are conducted in regular intervals in different survey areas. ","Value":"0.7"},{"dims":{"COUNTRY":"Nepal","YEAR":"2010","GHO":"Sex workers with active syphilis (%)"},"Comments":"Capital city IBBS data. Only FSW included. ","Value":"1.0"},{"dims":{"COUNTRY":"Nepal","YEAR":"2008","GHO":"Sex workers with active syphilis (%)"},"Value":"1.0"},{"dims":{"COUNTRY":"Netherlands","YEAR":"2010","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data from female sex workers attending STI clinics in the Netherlands in 2010.","Value":"0.2"},{"dims":{"COUNTRY":"Netherlands","YEAR":"2008","GHO":"Sex workers with active syphilis (%)"},"Value":"0.2"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2014","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data collection period:  01/12/2013 to 31/03/2014.               Source: Surveillance study of sexual behavior and HIV and syphilis prevalence in vulnerable populations at increased risk to HIV: men who have sex with men, transgender women, sex workers, injecting drug users and people with HIV in Nicaragua, 2013. Study sampled from 5 cities. (Original: Estudio de vigilancia de comportamiento sexual y prevalencias de VIH y S�filis en poblaciones vulnerables y en mayor riesgo al VIH: Hombres que tienen sexo con hombres, Transg�nero femeninas, Trabajadoras sexuales, Usuarios de drogas inyectables y Personas con VIH en Nicaragua, 2013. Estudio cuyo dise�o muestral es no probabil�stico (bola de nieve), de 5 ciudades del pa�s.)          Data are not representative.","Value":"2.3"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2010","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data collection period: 01/01/2009 to 31/12/2010.  Data source: Behavior Surveillance Survey of prevalence of HIV and STIs. Weighting based on special tabulation provided by the UVG (Chinandega 0 of 213/23 617 Managua). (Original: Fuente Encuesta de Vigilancia del Comportamiento y prevalencia de VIH e ITS. Ponderaci�n en base a tabulaci�n especial brindada por la UVG (Chinandega 0 de 213 / Managua 23 de 617). ) Data are representative.  Data are consistent with the definition of active syphilis for GARPR (both treponemal and non-treponemal test positive).  ","Value":"2.0"},{"dims":{"COUNTRY":"Nicaragua","YEAR":"2009","GHO":"Sex workers with active syphilis (%)"},"Comments":"Behavior Surveillance Survey and prevalence of HIV and STIs. Weighting based on special tabulation provided by the UVG.","Value":"2.1"},{"dims":{"COUNTRY":"Niger","YEAR":"2009","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data collection period: 15/04/2009 to 15/07/2009.  Data source: Report on sentinel surveillance STI / HIV in pregnant women and sex workers in Niger in 2009.  The 2012 sentinel surveillance did not take into account the sex workers. (Original: Rapport de la surveillance sentinelle IST/VIH chez les femmes enceintes et les professionnelles de sexe (PS) au Niger en 2009. La surveillance sentinelle 2012 n'as pas pris en compte les PS.  ) Data are representative.  Data are consistent with the definition of active syphilis for GARPR (both treponemal and non-treponemal test positive).  ","Value":"4"},{"dims":{"COUNTRY":"Nigeria","YEAR":"2008","GHO":"Sex workers with active syphilis (%)"},"Value":"1.4"},{"dims":{"COUNTRY":"Panama","YEAR":"2014","GHO":"Sex workers with active syphilis (%)"},"Comments":"Source: Data for 2013 are from the registration of the six 'Friendly Clinics' which carry out the Sentinel Surveillance of STIs in PEMAR population, located in the following Metropolitan Health Regions (santa Ana), Colon, Chiriqui, San Miguelito and Bocas Del Toro (Original: Fuentes de la Notificaci�n: Los datos para el a�o 2013 provienen de los registro de las seis Cl�nicas Amigables (CLAM) donde se llevan a cabo las Vigilancia Centinela de las ITS (VICITS) en poblaci�n PEMAR, ubicadas en las siguientes Regiones de Salud Metropolitana (Santa Ana), Col�n , Chiriqu�, San Miguelito y Bocas Del Toro).   Data are representative. Data are not consistent with the definition of active syphilis for GARPR (both treponemal and non-treponemal test positive).","Value":"53"},{"dims":{"COUNTRY":"Panama","YEAR":"2012","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data source: Sentinel Surveillance data. A total of 92 sex workers (82 female 89.1% and 10 transexual (10.9%).","Value":"6.5"},{"dims":{"COUNTRY":"Papua New Guinea","YEAR":"2010","GHO":"Sex workers with active syphilis (%)"},"Comments":"3 transgender were not included in the numerator.  12 transgender were not included in the denominator.  ","Value":"21.1"},{"dims":{"COUNTRY":"Paraguay","YEAR":"2014","GHO":"Sex workers with active syphilis (%)"},"Value":"8.8"},{"dims":{"COUNTRY":"Paraguay","YEAR":"2013","GHO":"Sex workers with active syphilis (%)"},"Value":"2.5"},{"dims":{"COUNTRY":"Paraguay","YEAR":"2012","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data source: Data source: PRONASIDA (voluntary counseling and testing) and CTV data (Mobile clinic data). Six health regions are represented. CTV PRONASIDA (voluntary counseling and testing) and CTV data (Mobile clinic data). ","Value":"7.9"},{"dims":{"COUNTRY":"Paraguay","YEAR":"2011","GHO":"Sex workers with active syphilis (%)"},"Comments":"We achieved access to sex workers for syphilis testing through the promotion of VCT services through the work of peer promoters and from mid-2011, routes were established with the mobile VCT.","Value":"16.5"},{"dims":{"COUNTRY":"Paraguay","YEAR":"2010","GHO":"Sex workers with active syphilis (%)"},"Comments":"Includes male and female sex workers. Active syphilis infection is defined as a patient with a reactive rapid test plus a reactive VDRL at 1:1 or higher in a patient with a previous non-reactive test or without a previous test.","Value":"14.6"},{"dims":{"COUNTRY":"Peru","YEAR":"2014","GHO":"Sex workers with active syphilis (%)"},"Value":"6.1"},{"dims":{"COUNTRY":"Philippines","YEAR":"2009","GHO":"Sex workers with active syphilis (%)"},"Comments":"IHBSS, 2009.","Value":"1.3"},{"dims":{"COUNTRY":"Republic of Moldova","YEAR":"2013","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data collection period: 15/02/2013 to 05/06/2013.  Data are not representative.  Data are consistent with the definition of active syphilis for GARPR (both treponemal and non-treponemal test positive).  Comments: Respondent Driven Sampling was applied. The sampling was conducted independently in two established study areas (municipality of Chisinau and municipality of Balti). In each location 5 persons  (\"seeds�) were selected to represent different strata of sex workers. In each site, recruitment occurred up to the 9th wave. The planned sample size has been estimated by on-line sample size calculator using the estimated number of commercial sex workers in each site of study implementation.  Collected data are representative only for study area. Entered data are for Chisinau, capital city. ","Value":"10.1"},{"dims":{"COUNTRY":"Republic of Moldova","YEAR":"2010","GHO":"Sex workers with active syphilis (%)"},"Comments":"RDS has been applied in the 2009 - 2010 BSS.","Value":"8.9"},{"dims":{"COUNTRY":"Republic of Moldova","YEAR":"2008","GHO":"Sex workers with active syphilis (%)"},"Comments":"The target group of the research are exclusively  beneficiaries of the Harm Reduction Programmes and cannot be extrapolated to represent the entire population of FSWs.","Value":"13.3"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2012","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data collection period: 2012 August 01 to 2012 December 31. Data source: Sentinel Site.","Value":"4.7"},{"dims":{"COUNTRY":"Sao Tome and Principe","YEAR":"2008","GHO":"Sex workers with active syphilis (%)"},"Value":"5.6"},{"dims":{"COUNTRY":"Senegal","YEAR":"2014","GHO":"Sex workers with active syphilis (%)"},"Comments":"Source: National Programme data. Comments: The data are not complete for the regions of Tambacounda, Kolda, Kaolack and Fatick (Original:  Les donn�es ne sont pas exhaustives dans les r�gions de Tamba, Kolda, Kaolack et Fatick)","Value":"19.6"},{"dims":{"COUNTRY":"Senegal","YEAR":"2013","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data are representative.  Data are consistent with the definition of active syphilis for GARPR (both treponemal and non-treponemal test positive).  Comments: These are sex workers followed in STI clinics, in whom syphilis is suspected, at the level of the entire country. (Original: Il s'agit des professionnelles du sexe suivies dans les centres IST chez qui une syphilis est suspect�es au niveau de tout le pays. )","Value":"6.7"},{"dims":{"COUNTRY":"Senegal","YEAR":"2010","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data collection period: 2010 June 07 to 2010 August 20. Data source: ENSC Report, 2010.","Value":"3.4"},{"dims":{"COUNTRY":"Senegal","YEAR":"2008","GHO":"Sex workers with active syphilis (%)"},"Comments":"This is considered representative as the combined monitoring survey was conducted at the population level and not within the cohort of female sex workers followed.","Value":"11.3"},{"dims":{"COUNTRY":"Seychelles","YEAR":"2013","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data are representative.  Data are consistent with the definition of active syphilis for GARPR (both treponemal and non-treponemal test positive).  ","Value":"6.9"},{"dims":{"COUNTRY":"Singapore","YEAR":"2014","GHO":"Sex workers with active syphilis (%)"},"Comments":"Source: National programme data. Comments: There were no cases of active / infectious syphilis in female sex workers. There were only 19 cases of non infectious / latent syphilis. Data are representative.","Value":"0"},{"dims":{"COUNTRY":"Singapore","YEAR":"2013","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data are representative.  Data are consistent with the definition of active syphilis for GARPR (both treponemal and non-treponemal test positive).  ","Value":"0.0"},{"dims":{"COUNTRY":"Singapore","YEAR":"2010","GHO":"Sex workers with active syphilis (%)"},"Comments":"Approximate total number of tests done during Jan - Dec 2010 (Source : Table 10 - DSC Annual Report 2010).","Value":"0.7"},{"dims":{"COUNTRY":"Singapore","YEAR":"2008","GHO":"Sex workers with active syphilis (%)"},"Value":"0.6"},{"dims":{"COUNTRY":"Solomon Islands","YEAR":"2014","GHO":"Sex workers with active syphilis (%)"},"Value":"10.0"},{"dims":{"COUNTRY":"Somalia","YEAR":"2008","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data refers to August 15 to October 31 of reference year. IBBS conducted among female sex workers in 2008. There is no specific program targeting sex workers testing and treatment in the country.","Value":"3.4"},{"dims":{"COUNTRY":"Sri Lanka","YEAR":"2014","GHO":"Sex workers with active syphilis (%)"},"Comments":"Source: IBBS survery 2014. Comments: The surveys considered selective areas. Data are not representative.","Value":"0.6"},{"dims":{"COUNTRY":"Sri Lanka","YEAR":"2011","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data refers to August 15 to Nov 15 of reference year. No data available regarding VDRL titre. Numerator includes VDRL status reported as reactive.","Value":"2.4"},{"dims":{"COUNTRY":"Sri Lanka","YEAR":"2010","GHO":"Sex workers with active syphilis (%)"},"Value":"3.0"},{"dims":{"COUNTRY":"Sudan","YEAR":"2011","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data collection period: 01/10/2010 to 01/08/2011.  Data source: Integrated bio behavioral surveillance survey (IBBS) using RDS.  Data are representative.  Data are consistent with the definition of active syphilis for GARPR (both treponemal and non-treponemal test positive).  Comments: Value for this indicator is the unadjusted sample proportion for female sex workers only disaggregation by site is shown in the attached IBBS report under the sex workers indicator. ","Value":"4.4"},{"dims":{"COUNTRY":"Tajikistan","YEAR":"2010","GHO":"Sex workers with active syphilis (%)"},"Comments":"Sentinel surveillance among sex workers with analysis using IFA1 (screening) and IFA2 (expert). ","Value":"9.6"},{"dims":{"COUNTRY":"Tajikistan","YEAR":"2008","GHO":"Sex workers with active syphilis (%)"},"Value":"12.6"},{"dims":{"COUNTRY":"Thailand","YEAR":"2013","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data collection period: 01/05/2013 to 30/06/2013.  Data are representative.  Data are not consistent with the definition of active syphilis for GARPR.  Comments: Thai National data regarding active syphilis among sex workers are actually available from two health information systems including HSS (HIV sentinel surveillance system) and routine STIs montoring system (STI mini record). In this report, data from HSS were chosen due to its presumably better reliability. For more complete documentation, it should be noted that, based on findings from STI mini records, the percentage of active syphillis among sex workers was 2.67 (57 positive from 2,064 tested). ","Value":"0.7"},{"dims":{"COUNTRY":"Thailand","YEAR":"2011","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data refers to May 1 to June 30 of reference year. The data source for this indicator is the HSS among direct and indirect FSW. Direct FSW prevalence = 1.04% (37/3559) and Indirect FSW = 0.4%(35/8650).  The same weights for HIV were used for this indicator which where direct FSW x 0.1 and indirect FSW x 0.9. No numerator and denominator were included in the template because the methodology used included separate weights for each population (i.e. direct and indirect FSW).","Value":"0.5"},{"dims":{"COUNTRY":"Thailand","YEAR":"2010","GHO":"Sex workers with active syphilis (%)"},"Comments":"Result from HIV serosurveillance among FSW. Data was not available among MSW.","Value":"0.6"},{"dims":{"COUNTRY":"Thailand","YEAR":"2008","GHO":"Sex workers with active syphilis (%)"},"Value":"8.9"},{"dims":{"COUNTRY":"The former Yugoslav republic of Macedonia","YEAR":"2011","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data refers to 2010 Oct 1 to 2011 Feb 17. RDS survey among SW; data presented refers to sample proportions. Population estimates (weighted analysis) are different.","Value":"1.1"},{"dims":{"COUNTRY":"Timor-Leste","YEAR":"2011","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data refers to August 1 to Dec 31 of reference year. 2011 IBBS.","Value":"9.8"},{"dims":{"COUNTRY":"Timor-Leste","YEAR":"2010","GHO":"Sex workers with active syphilis (%)"},"Comments":"The 2010 Integrated Behavioural and Biological Survey report has not yet been finalized. Results taken from the draft analysis.","Value":"8.8"},{"dims":{"COUNTRY":"Trinidad and Tobago","YEAR":"2011","GHO":"Sex workers with active syphilis (%)"},"Comments":"Cellma Electronic Management Patient Registers at STI Clinics.","Value":"10.8"},{"dims":{"COUNTRY":"Trinidad and Tobago","YEAR":"2010","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data represent the 2 main public health STI clinics in the north & south respectively, however data may be an underestimate.","Value":"31.8"},{"dims":{"COUNTRY":"Turkey","YEAR":"2010","GHO":"Sex workers with active syphilis (%)"},"Value":"2.9"},{"dims":{"COUNTRY":"Uganda","YEAR":"2008","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data collected from the CRANE Study that is in progress.","Value":"20.4"},{"dims":{"COUNTRY":"Ukraine","YEAR":"2009","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data was obtained through sentinel suveilance study among FSW in 2009. Sample size is 2278 people. ","Value":"4.4"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2014","GHO":"Sex workers with active syphilis (%)"},"Comments":"Source: Special studies. Comments: Data are representative. ","Value":"7.8"},{"dims":{"COUNTRY":"United Republic of Tanzania","YEAR":"2010","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data collection period: 02/08/2010 to 30/10/2010.  Data are not representative.  Data are not consistent with the definition of active syphilis for GARPR.  Comments: The study was conducted in Dar-es-salaam hence not representative of the whole country. ","Value":"2.0"},{"dims":{"COUNTRY":"Uruguay","YEAR":"2013","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data source: Registro de atenci�n en policl�nicas de control de trabajo sexual.  Data are representative.  Data are consistent with the definition of active syphilis for GARPR (both treponemal and non-treponemal test positive).  Comments: Corresponds to reports from 41 polyclinics throughout the country (80% of clinics reported these data). These data represent only female sex workers who are controlled.  (Original: Corresponde al reporte de 41 policl�nicas en todo el pa�s (80% de las policl�nicas reportan estos datos). Por lo que este dato representa solo a trabajadores sexuales mujeres que se controlan.)","Value":"0.7"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2011","GHO":"Sex workers with active syphilis (%)"},"Value":"5.4"},{"dims":{"COUNTRY":"Uzbekistan","YEAR":"2008","GHO":"Sex workers with active syphilis (%)"},"Comments":"Cluster sampling.","Value":"13.2"},{"dims":{"COUNTRY":"Vanuatu","YEAR":"2011","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data collection period: 01/01/2011 to 31/12/2011.  Data source: Vanuatu Integrated Bio?Behavioural Survey and Population Size Estimation with Female Sex Workers in Port Vila, Vanuatu, 2011.  Data are not representative.  Data are not consistent with the definition of active syphilis for GARPR.  ","Value":"3.7"},{"dims":{"COUNTRY":"Viet Nam","YEAR":"2014","GHO":"Sex workers with active syphilis (%)"},"Comments":"Source: STI sentinel surveillance integrated with HIV sentinel surveillance.     Comments: Data are representative.","Value":"1.3"},{"dims":{"COUNTRY":"Viet Nam","YEAR":"2013","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data collection period: 01/06/2013 to 31/10/2013.  Data source: Guideline based Decision 09/2012/TT-BYT on HIV/STI surveillance.  Data are not representative.  Data are consistent with the definition of active syphilis for GARPR (both treponemal and non-treponemal test positive).  Comments: Implemented only 10/63 provinces, these provinces are high HIV/AIDS epidemic. ","Value":"0.7"},{"dims":{"COUNTRY":"Viet Nam","YEAR":"2012","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data collection period: 2012 June 01 to 2012 September 30. Data source: STI sentinel surveillance.","Value":"0.7"},{"dims":{"COUNTRY":"Viet Nam","YEAR":"2011","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data refers to June 1 to Sept 9 of reference year. Numerator and denominator were collected from  the “Integrating short behaviour survey in to the routine HIV Sentinel surveillance” (HSS plus) in 2011.","Value":"0.9"},{"dims":{"COUNTRY":"Viet Nam","YEAR":"2010","GHO":"Sex workers with active syphilis (%)"},"Comments":"This data is not representative of national FSWs population because it was collectted only from hot-spots of FSWs in proviinces/cities with high HIV prevalance. Data on male SWs is not available.","Value":"1.6"},{"dims":{"COUNTRY":"Viet Nam","YEAR":"2008","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data reported from 8 of 10 STI sentinel surveillance provinces: Hanoi, Hochiminh city, Haiphong, Quangninh, Angiang, Nghean, Cantho, and Khanhhoa.","Value":"2.5"},{"dims":{"COUNTRY":"Yemen","YEAR":"2008","GHO":"Sex workers with active syphilis (%)"},"Value":"4.9"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"2012","GHO":"Sex workers with active syphilis (%)"},"Comments":"Data source: CESHHAR project routine data. May not be representative of the population.","Value":"12.3"},{"dims":{"COUNTRY":"Zimbabwe","YEAR":"2011","GHO":"Sex workers with active syphilis (%)"},"Value":"12.2"}]}

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Buttons=function(_Component){_inherits(Buttons,_Component);function Buttons(props){_classCallCheck(this,Buttons);var _this=_possibleConstructorReturn(this,(Buttons.__proto__||Object.getPrototypeOf(Buttons)).call(this,props));_this.state={leftButtonDisable:true,rightButtonDisable:false};_this.handleChange=_this.handleChange.bind(_this);return _this;}//this allows one to access the props that are coming from a parent component, and do work with it prior to rendering the page
_createClass(Buttons,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var currentPage=nextProps.currentPage;if(currentPage===0){this.setState({leftButtonDisable:true});}else if(currentPage===9){this.setState({rightButtonDisable:true});}else{this.setState({leftButtonDisable:false,rightButtonDisable:false});}}//when button is clicked set value sent to parent component to either -1 to decrement or +1 to increment
},{key:"handleChange",value:function handleChange(e){var value=0;if(e.target.value==="left"){value--;this.props.onPageChange(value);}else{value++;this.props.onPageChange(value);}}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"buttons"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"btn",value:"left",disabled:this.state.leftButtonDisable,onClick:this.handleChange},"\u25C0"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"btn",value:"right",disabled:this.state.rightButtonDisable,onClick:this.handleChange},"\u25B6"));}}]);return Buttons;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Buttons);

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("/quote_and_a_chart",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl="/quote_and_a_chart"+'/service-worker.js';if(isLocalhost){// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);}else{// Is not local host. Just register service worker
registerValidSW(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.09604046.js